/**
 * Created by Bruce on 2016/11/18.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.language', []);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var systemConstant = {
    "ONLINE_USER_NO": "線上人數",
    "MANAGER_CENTER": "管理中心"
  };
  angular
    .module('eHRD.modules.language')
    .constant('systemConstantZhTW',systemConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var statusConstant = {
    "PASSED": "通過",
    "COMPLETED": "完成",
    "INCOMPLETED": "未完成",
    "INCOMPLETE": "未完成",
    "FAILED": "未通過",
    "NOT AVAILABLE": "待修中",
    "NOT ATTEMPTED": "未曾觀看",
    "NOT_ENROLLED": "尚未報名",
    "UNENROLLED": "尚未報名",
    "UNENROLL": "取消報名",
    "EXEMPTION":"免修",
    "UNPUBLISHED ASSIGNED": "等待發佈中",
    "ENROLLMENT APPROVAL PENDING": "等待簽核中",
    "INCOMPLETED_STATUS":"未完成",
    "SCO_NON_ATTEMPT":"未曾觀看",
    "ENROLLMENT_APPROVAL_PENDING": "等待簽核中",
    "STATUS_NOT_AVAILABLE":"待修中",
    "COMPLETED_STATUS":"完成",
    "UNPUBLISHED_WAITLISTED": "候補中",
    "ENROLLMENT_WAITLISTED":"候補中",
    "LEAVE_APPROVAL_PENDING": "請假申請等待簽核中",
    "UNPUBLISHED_ASSIGNED":"等待發佈中",
    "WAITING_FOR_PROGRAM_PUBLISH": "等待來源學習活動發佈中",
    "WAITING FOR PROGRAM PUBLISH": "等待來源學習活動發佈中",
    "SELFENROLLED": "自行報名",
    "ASSIGNED": "指定報名",
    "EXECUTED": "已生效",
    "NOT_EXECUTED": "尚未生效",
    "UNKNOW_STATUS":"未知狀態",
    "CANCEL": "取消",
    "APPROVED": "已批准",
    "PUBLIC_STATUS_REJECT": "拒絕",
    "PUBLISH_STATUS_REJECT": "拒絕",
    "WAITING_APPROVAL": "簽核中",
    "NO_APPROVAL": "無須簽核",
    "APPROVALED": "已核准",
    "NOT_YET_APPROVAL": "尚未核准",
    "APPROVAL_REJECT": "簽核拒絕",
    "EXEMPTION_SUBMIT": "免繳",
    "NOT_SUBMIT": "未繳",
    "SUBMITTED": "已繳",
    "NOT_PUBLISHED": "不公布",
    "ENROLLED": "已報名",
    "NOT_ENROLLMENT": "尚未開始報名",
    "ENROLLMENT_DEADLINE": "報名截止",
    "ATTENDANCE": "出席",
    "ABSENCE": "缺席",
    "ABSENT": "缺席",
    "REJECTED": "已被拒絕",
    "LEAVE": "請假",
    "LEARNER_ASK_LEAVE": "學員自行請假",
    "ADMINISTRATOR_REGISTER": "管理員登錄",
    "PUBLISHED": "發佈中",
    "HAVE NOT EXECUTED ENROLLED ASSIGNMENT": "尚未生效",
    "NO_RATING_REQUIRED": "無須評分",
    "FAIL_CHECK_SESSIONQUOTAFULL": "名額已滿",
    "FAIL_CHECK_PRIVILEGE": "無權限報名",
    "FAIL_CHECK_OUT_OF_QUOTA": "已額滿",
    "WAITLISTED": "候補中",
    "BLOCKED": "擋修中",
    "NEW": "最新",
    "HOT": "熱門",
    "FEATURED": "精選"
  };
  angular
    .module('eHRD.modules.language')
    .constant('statusConstantZhTW',statusConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var messageConstant = {
    "YOU_HAVE_BEEN_LOGGED_OUT":"您已經成功登出",
    "YOU_HAVE_SUCCESSFULLY_SIGNED_IN":"您已經成功登入!",
    "MSG_TAKES_TIME_ACTION": "這個動作需要花上一些時間，我們將在背景作業中處理。變更或許不會在頁面即時呈現。",
    "MSG_IS_SURE_ENROLL": "確定報名嗎？",
    "MSG_IS_SURE_UN_ENROLL": "確定取消報名嗎？",
    "MSG_IS_SURE_TO_PAY": "您確定要繳交？",
    "MSG_NOT_YET_COMPLETED_WHETHER_TO_SEND_OUT": "尚未完成的題目：{{value}}，是否確定送出？",
    "MSG_THERE_ARE_OPTIONS_NOT_FILLED_OUT": "尚有選項未填寫！",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_STUDENT": "請至少選擇一個學員",
    "MSG_ERROR_NOT_PUBLISH": "此活動尚未發佈或已被刪除",
    "MSG_ERROR_MESSAGE_CAN_NOT_ENROLL_CAUSE_PASS_RESULT": "您已通過此課程，依照課程設定無法再自行報名其他班次，班次資訊如下:<br>格式:學習活動班次名稱(上課日期)<br>",
    "MSG_ERROR_MESSAGE_CAN_ENROLL_WAITLSTED_RESULT": "候補中",
    "MSG_IS_CONTINUE": "確定繼續?",
    "MSG_YOU_HAVE_REQUIRED_SUBJECT_NOT_YET_ANSWERED": "您尚有必填題目：{{value}}，尚未作答！！",
    "MSG_QUESTION_OPTION_EXCEEDS_WORD_LIMIT": "題目：{{value}}，選項超出字數限制！！",
    "MSG_UNABLE_SEND_REFRESH": "如果您無法發送，系統會自動重新整理，請等待一下。",
    "MSG_PLEASE_RETURN_TO_FILL_IN": "請返回填寫",
    "MSG_QUESTION_FILL_THIS_TO_THE_END": "填答到此結束，感謝您的回饋填答到此結束，對此問卷請給予回饋",
    "MSG_ERROR_PLAY_BLOCKING": "請先完成前一資料夾的課程內容或測驗問卷才能繼續",
    "MSG_YOU_HAVE_COMPLETED_THIS_QUESTIONNAIRE": "你已完成此問卷",
    "MSG_YOU_HAVE_COMPLETED_THIS_TEST": "你已完成此測驗",
    "MSG_CURRENTLY_NON_VIEWING_TIME": "目前非觀看時間",
    "MSG_NEXT_TEST_DATETIME": "下次測驗日期為",
    "MSG_CAN_NOT_TAKE_LESSONS": "無法進行課程",
    "MSG_CAN_NOT_TAKE_TEST_QUESTIONNAIRE": "無法進行測驗問卷",
    "MSG_ARE_YOU_SURE_WANT_TO_REPLACE_YOUR_AVATAR": "確定要將更換個人頭像嗎?",
    "MSG_ARE_YOU_SURE_WANT_TO_CHANGE_YOUR_PASSWORD": "確定要變更密碼嗎?",
    "MSG_CAN_NOT_FIND_THE_LATEST_INFORMATION": "無法查到最新資料",
    "MSG_DO_YOU_WANT_TO_ADD_MY_FAVORITE": "確定要將{{value}}加入我的最愛嗎?",
    "MSG_DO_YOU_WANT_TO_CANCEL_MY_FAVORITE": "確定要將{{value}}取消我的最愛嗎?",
    "MSG_PLEASE_ENTER_START_DATE": "請輸入開始日期",
    "MSG_PLEASE_ENTER_END_DATE": "請輸入結束日期",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_COURSE": "請至少選擇一個課程",
    "MSG_THE_START_DATE_CAN_NOT_BE_GREATER_THAN_THE_END_DATE": "開始日期不能大於結束日期",
    "MSG_PLEASE_SELECT_DEPARTMENT_MEMBER": "請選擇部門成員",
    "MSG_THE_FORM_HAS_NOT_BEEN_COMPLETED_YET_PLEASE_CONFIRM": "表單尚未完成，請確認!",
    "MSG_UPDATE_PASSWORD_SUCCESS": "變更密碼成功",
    "MSG_ENROLLMENT_APPROVAL_PENDING": "等待簽核中",
    "MSG_THIS_ACTION_WILL_RELEVANT_STUDY_REPORT": "這個動作會取消所有相關的學習報告",
    "MSG_ARE_YOU_SURE_WANT_TO_DELETE_DEPUTY_RECORD": "確定要刪除代理人紀錄?",
    "MSG_DEPUTY_EFFECTIVE_DATE_CNA_NOT_EMPTY": "代理生效日不得為空!",
    "MSG_DEPUTY_END_DATE_CNA_NOT_EMPTY": "代理結束日不得為空!",
    "MSG_DEPUTY_END_DATE_CNA_NOT_BE_EARLIER_THAN_DEPUTY_EFFECTIVE_DATE": "代理結束日不能早於代理生效日",
    "MSG_PLEASE_SETTING_DEPUTY": "請設定代理人",
    "MSG_SETTING_DEPUTY_SUCCESSFUL": "設定代理人成功",
    "MSG_EDIT_DEPUTY_RECORD_SUCCESSFUL": "修改代理人紀錄成功",
    "MSG_NOT_ALLOW_TO_DELETE_OTHER_SETTING": "不允許移除其他人的設定",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_TIME_PERIOD": "請至少選擇一個時段",
    "MSG_PLEASE_FILE_IN_THE_REASON_FOR_REJECT": "請填入不核准的原因",
    "MSG_ERROR_NEED_FINISH_PREREQUISITE_ITEMS": "請先完成下列先修項目再報名",
    "MSG_SELECT_COURSE_OR_OTHER_NEED": "請選擇課程或其他需求",
    "MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_SELF_REQUIRED_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT": "僅能刪除自我要求且尚未報名的建議學習項目",
    "MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_YOU_HAVE_ENROLLED_IN": "您已報名的課程，無法直接刪除",
    "MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_MANAGER_SUGGEST_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT": "僅能刪除主管建議且尚未報名的建議學習項目",
    "MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_EMPLOYEES_HAVE_ENROLLED_IN": "同仁已報名的課程，無法直接刪除",
    "MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES_AND_MANAGER_SUGGESTION": "僅能針對\"自我要求/主管建議\"課程調整預定完成日期",
    "MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES": "僅能針對\"自我要求\"課程調整預定完成日期",
    "MSG_PLEASE_FILL_IN_THE_REASON": "請填寫理由",
    "MSG_THE_SETTING_TIME_DOES_NOT_EXIST_PLEASE_RE_ENTER": "設定時間不存在,請重新輸入",
    "MSG_TIME_PERIOD_N_PARTIALLY_OVERLAPS_PLEASE_RESET": "與時段 {{value}} 設定時間部份重疊，請重新設定",
    "MSG_SUCCESSFUL_OPERATION": "操作成功",
    "MSG_FAILED_OPERATION": "操作失敗",
    "MSG_EXTERNAL_TRAINING_APPLY_SUMMIT_CHECK": "送出前請再次確認填入資料是否全部正確!!  確定要送出請按\"確定\"鈕. 重新編輯請按\"取消\"鈕.",
    "MSG_THE_START_DATE_NEED_TO_EARLIER_THAN_THE_END_DATE": "開始時間必須早於結束時間",
    "MSG_YOUR_ATTENDANCE_RATE_IS_TOO_LOW_TO_FILL_OUT": "您出席率不足，無法進行填寫",
    "MSG_ENROLLMENT_WAITING_APPROVAL": "報名等待簽核中",
    "MSG_CLASS_TIME_CONFLICT": "此課程與其他已經報名之課程:<br> {{value}} 的上課時間重疊,因此不能報名!",
    "MSG_CLASS_TIME_CONFLICT_NO_BLOCK": "此課程與其他已經報名之課程:<br> {{value}} 的上課時間重疊",
    "MSG_TIME_IS_OUT": "時間已到!",
    "MSG_ASSIGN_EXCEED_MAX": "你已經選擇了{{value1}}個學員。但是只有{{value2}}個學員能夠加入此課程/學程，因指定人數超過上限，請重新選擇。",
    "MSG_CURRENTLY_ON_THE_TEMPORARY_LEARNING_RESOURCES": "目前暫無線上學習資源",
    "MSG_ERROR_MESSAGE_ENROLL_CAUSE_PASS_RESULT": "您已通過此課程，是否繼續再自行報名其他班次，班次資訊如下:<br>格式:學習活動班次名稱(上課日期)<br>",
    "MSG_INNERCERT_CANNOT_ENROLL_EXTENDED_SESSION": "您無取得過該內部證照, 無法報名展期班次",
    "MSG_RESTORE_LAST_TIME_UNFINISHED_FORM": "恢復前次未完成填寫表單!!",
    "MSG_COURSE_DATA_FILE_NEED_RE_CHOOSE": "課程資料檔案需要重新選取!!",
    "MSG_THE_TIME_RANGE_IS_ERROR": "時間範圍錯誤",
    "MSG_CONFIRM_TO_DELETE": "確定刪除?",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_ITEM": "請至少選擇一個項目",
    "MSG_BEFORE_YOU_REGISTER_YOU_MUST_FILL_OUT_THE_REGISTRATION_QUESTIONNAIRE_ARE_YOU_SURE_YOU_WANT_TO_CONTINUE": "報名課程前必須先填寫報名問卷。確定要繼續?",
    "MSG_YOU_DO_NOT_HAVE_PERMISSION_TO_VIEW_THIS_LEARNING_ACTIVITY": "您沒有權限觀看本學習活動",
    "MSG_PLEASE_SELECT_ONE_COURSE": "請選擇一個課程",
    "MSG_PLEASE_SELECT_ONE_COURSE_SESSION": "請選擇一個班次",
    "MSG_THE_APPLICATION_FORM_WAS_UPDATED_SUCCESSFULLY": "申請表單修改成功",
    "MSG_YOU_HAVE_SUCCESSFULLY_ADDED_EXTERNAL_VENDOR": "您已成功新增外訓廠商",
    "MSG_INPUT_ANSWER_EXCEED_LIMIT": "答案不可超過限制長度。",
    "ADDED_EXTERNAL_VENDOR": "新增外訓廠商",
    "PICTURE_OVER_MB_PLEASE_RELOAD": "圖片檔案超過{{value}}mb，請重新上傳"
  };
  angular
    .module('eHRD.modules.language')
    .constant('messageConstantZhTW',messageConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var httpErrorCodeConstant = {
    "102_TITLE": "ERR CONNECTION REFUSED",
    "102_CONTENT": "未知的錯誤。",

    "400_TITLE": "Bad Request",
    "400_CONTENT": "由於包含語法錯誤，當前請求無法被伺服器理解。除非進行修改，否則用戶端不應該重複提交這個請求。",

    "401_TITLE": "Unauthorized",
    "401_CONTENT": "當前請求需要使用者驗證。該響應必須包含一個適用於被請求資源的WWW-Authenticate資訊頭用以詢問使用者資訊。用戶端可以重複提交一個包含恰當的Authorization頭資訊的請求。如果當前請求已經包含了Authorization憑證，那麼401響應代表著伺服器驗證已經拒絕了那些憑證。如果401響應包含了與前一個響應相同的身分驗證詢問，且瀏覽器已經至少嘗試了一次驗證，那麼瀏覽器應當向使用者展示響應中包含的實體資訊，因為這個實體資訊中可能包含了相關診斷資訊。",

    "402_TITLE": "Payment Required",
    "402_CONTENT": "該狀態碼是為了將來可能的需求而預留的。",

    "403_TITLE": "Forbidden",
    "403_CONTENT": "伺服器已經理解請求，但是拒絕執行它。與401響應不同的是，身分驗證並不能提供任何幫助，而且這個請求也不應該被重複提交。如果這不是一個HEAD請求，而且伺服器希望能夠講清楚為何請求不能被執行，那麼就應該在實體內描述拒絕的原因。當然伺服器也可以返回一個404響應，假如它不希望讓用戶端獲得任何資訊。",

    "404_TITLE": "Not Found",
    "404_CONTENT": "請求失敗，請求所希望得到的資源未被在伺服器上發現。沒有資訊能夠告訴使用者這個狀況到底是暫時的還是永久的。假如伺服器知道情況的話，應當使用410狀態碼來告知舊資源因為某些內部的配置機制問題，已經永久的不可用，而且沒有任何可以跳轉的位址。404這個狀態碼被廣泛應用於當伺服器不想揭示到底為何請求被拒絕或者沒有其他適合的響應可用的情況下。",

    "405_TITLE": "Method Not Allowed",
    "405_CONTENT": "請求行中指定的請求方法不能被用於請求相應的資源。該響應必須返回一個Allow頭資訊用以表示出當前資源能夠接受的請求方法的列表。鑒於PUT，DELETE方法會對伺服器上的資源進行寫操作，因而絕大部分的網頁伺服器都不支援或者在預設配置下不允許上述請求方法，對於此類請求均會返回405錯誤。",

    "406_TITLE": "Not Acceptable",
    "406_CONTENT": "請求的資源的內容特性無法滿足請求頭中的條件，因而無法生成響應實體。除非這是一個HEAD請求，否則該響應就應當返回一個包含可以讓使用者或者瀏覽器從中選擇最合適的實體特性以及位址列表的實體。實體的格式由Content-Type頭中定義的媒體類型決定。瀏覽器可以根據格式及自身能力自行作出最佳選擇。但是，規範中並沒有定義任何作出此類自動選擇的標準。",

    "407_TITLE": "Proxy Authentication Required",
    "407_CONTENT": "與401響應類似，只不過用戶端必須在代理伺服器上進行身分驗證。代理伺服器必須返回一個Proxy-Authenticate用以進行身分詢問。用戶端可以返回一個Proxy-Authorization資訊頭用以驗證。",

    "408_TITLE": "Request Timeout",
    "408_CONTENT": "請求超時。用戶端沒有在伺服器預備等待的時間內完成一個請求的傳送。用戶端可以隨時再次提交這一請求而無需進行任何更改。",

    "409_TITLE": "Conflict",
    "409_CONTENT": "由於和被請求的資源的當前狀態之間存在衝突，請求無法完成。這個代碼只允許用在這樣的情況下才能被使用：使用者被認為能夠解決衝突，並且會重新提交新的請求。該響應應當包含足夠的資訊以便使用者發現衝突的源頭。衝突通常發生於對PUT請求的處理中。例如，在採用版本檢查的環境下，某次PUT提交的對特定資源的修改請求所附帶的版本資訊與之前的某個（第三方）請求向衝突，那麼此時伺服器就應該返回一個409錯誤，告知使用者請求無法完成。此時，響應實體中很可能會包含兩個衝突版本之間的差異比較，以便使用者重新提交歸併以後的新版本。",

    "410_TITLE": "Gone",
    "410_CONTENT":"被請求的資源在伺服器上已經不再可用，而且沒有任何已知的轉發位址。這樣的狀況應當被認為是永久性的。如果可能，擁有連結編輯功能的用戶端應當在獲得使用者許可後刪除所有指向這個位址的參照。如果伺服器不知道或者無法確定這個狀況是否是永久的，那麼就應該使用404狀態碼。除非額外說明，否則這個響應是可快取的。",

    "411_TITLE": "Length Required",
    "411_CONTENT":"伺服器拒絕在沒有定義Content-Length頭的情況下接受請求。在添加了表明請求訊息體長度的有效Content-Length頭之後，用戶端可以再次提交該請求。",

    "412_TITLE": "Precondition Failed",
    "412_CONTENT":"伺服器在驗證在請求的頭欄位中給出先決條件時，沒能滿足其中的一個或多個。這個狀態碼允許用戶端在取得資源時在請求的元資訊（請求頭欄位資料）中設定先決條件，以此避免該請求方法被應用到其希望的內容以外的資源上。",

    "413_TITLE": "Request Entity Too Large",
    "413_CONTENT":"伺服器拒絕處理當前請求，因為該請求提交的實體資料大小超過了伺服器願意或者能夠處理的範圍。此種情況下，伺服器可以關閉連線以免用戶端繼續傳送此請求。如果這個狀況是臨時的，伺服器應當返回一個Retry-After的響應頭，以告知用戶端可以在多少時間以後重新嘗試。",

    "414_TITLE": "Request-URI Too Long",
    "414_CONTENT":"請求的URI長度超過了伺服器能夠解釋的長度，因此伺服器拒絕對該請求提供服務",

    "415_TITLE": "Unsupported Media Type",
    "415_CONTENT":"對於當前請求的方法和所請求的資源，請求中提交的實體並不是伺服器中所支援的格式，因此請求被拒絕。",

    "416_TITLE": "Requested Range Not Satisfiable",
    "416_CONTENT":"如果請求中包含了Range請求頭，並且Range中指定的任何資料範圍都與當前資源的可用範圍不重合，同時請求中又沒有定義If-Range請求頭，那麼伺服器就應當返回416狀態碼。假如Range使用的是位元組範圍，那麼這種情況就是指請求指定的所有資料範圍的首位元組位置都超過了當前資源的長度。伺服器也應當在返回416狀態碼的同時，包含一個Content-Range實體頭，用以指明當前資源的長度。這個響應也被禁止使用multipart/byteranges作為其Content-Type。",

    "417_TITLE": "Expectation Failed",
    "417_CONTENT":"在請求頭Expect中指定的預期內容無法被伺服器滿足，或者這個伺服器是一個代理伺服器，它有明顯的證據證明在當前路由的下一個節點上，Expect的內容無法被滿足。",

    "418_TITLE": "I'm a teapot",
    "418_CONTENT":"本操作碼是在1998年作為IETF的傳統愚人節笑話, 在RFC 2324 超文字咖啡壺控制協定中定義的，並不需要在真實的HTTP伺服器中定義。當一個控制茶壺的HTCPCP收到BREW或POST指令要求其煮咖啡時應當回傳此錯誤。",

    "421_TITLE": "There are too many connections from your internet address",
    "421_CONTENT":"從當前用戶端所在的IP位址到伺服器的連線數超過了伺服器許可的最大範圍。通常，這裡的IP位址指的是從伺服器上看到的用戶端位址（比如使用者的閘道器或者代理伺服器位址）。在這種情況下，連線數的計算可能涉及到不止一個終端使用者。",

    "422_TITLE": "Unprocessable Entity",
    "422_CONTENT":"請求格式正確，但是由於含有語意錯誤，無法響應。",

    "423_TITLE": "Locked",
    "423_CONTENT":"當前資源被鎖定。",

    "424_TITLE": "Failed Dependency",
    "424_CONTENT":"由於之前的某個請求發生的錯誤，導致當前請求失敗，例如PROPPATCH。",

    "425_TITLE": "Unordered Collection",
    "425_CONTENT":"在WebDav Advanced Collections草案中定義，但是未出現在《WebDAV順序集協定》中。",

    "426_TITLE": "Upgrade Required",
    "426_CONTENT":"用戶端應當切換到TLS/1.0。",

    "449_TITLE": "Retry With",
    "449_CONTENT":"由微軟擴充功能，代表請求應當在執行完適當的操作後進行重試。",

    "451_TITLE": "Unavailable For Legal Reasons",
    "451_CONTENT":"由IETF核准，代表該存取因法律的要求而被拒絕。",


    "500_TITLE": "Internal Server Error",
    "500_CONTENT":"伺服器遇到了一個未曾預料的狀況，導致了它無法完成對請求的處理。一般來說，這個問題都會在伺服器的程式碼出錯時出現。",

    "501_TITLE": "Not Implemented",
    "501_CONTENT":"伺服器不支援當前請求所需要的某個功能。當伺服器無法識別請求的方法，並且無法支援其對任何資源的請求。",

    "502_TITLE": "Bad Gateway",
    "502_CONTENT":"作為閘道器或者代理工作的伺服器嘗試執行請求時，從上游伺服器接收到無效的響應。",

    "503_TITLE": "Service Unavailable",
    "503_CONTENT":"由於臨時的伺服器維護或者過載，伺服器當前無法處理請求。這個狀況是臨時的，並且將在一段時間以後取消復原。如果能夠預計延遲時間，那麼響應中可以包含一個Retry-After頭用以標明這個延遲時間。如果沒有給出這個Retry-After資訊，那麼用戶端應當以處理500響應的方式處理它。",

    "504_TITLE": "Gateway Timeout",
    "504_CONTENT":"作為閘道器或者代理工作的伺服器嘗試執行請求時，未能及時從上游伺服器（URI標識出的伺服器，例如HTTP、FTP、LDAP）或者輔助伺服器（例如DNS）收到響應。注意：某些代理伺服器在DNS查詢超時時會返回400或者500錯誤。",

    "505_TITLE": "HTTP Version Not Supported",
    "505_CONTENT":"伺服器不支援，或者拒絕支援在請求中使用的HTTP版本。這暗示著伺服器不能或不願使用與用戶端相同的版本。響應中應當包含一個描述了為何版本不被支援以及伺服器支援哪些協定的實體。",

    "506_TITLE": "Variant Also Negotiates",
    "506_CONTENT":"由《透明內容協商協定》擴充功能，代表伺服器存在內部配置錯誤：被請求的協商變元資源被配置為在透明內容協商中使用自己，因此在一個協商處理中不是一個合適的重點。",

    "507_TITLE": "Insufficient Storage",
    "507_CONTENT":"伺服器無法儲存完成請求所必須的內容。這個狀況被認為是臨時的。",

    "509_TITLE": "Bandwidth Limit Exceeded",
    "509_CONTENT":"伺服器達到頻寬限制。這不是一個官方的狀態碼，但是仍被廣泛使用。",

    "510_TITLE": "Not Extended",
    "510_CONTENT":"取得資源所需要的策略並沒有被滿足。"

  };
  angular
    .module('eHRD.modules.language')
    .constant('httpErrorCodeConstantZhTW',httpErrorCodeConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var formValidationConstant = {
    "THIS_IS_REQUIRED": "必填!",
    "PLEASE_RE_CHECK_NEW_PASSWORD": "請重新確認新密碼",
    "PLEASE_RE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD": "請重新輸入您的帳號及密碼",
    "PLEASE_SELECT_AT_LEAST_ONE_ITEM": "請至少選擇一項",
    "PLEASE_SELECT_AT_LEAST_ONE_MEMBER": "請至少選擇一個成員",
    "PLEASE_SET_AT_LEAST_ONE_TIME_ZONE": "請至少設定一個時間區段",
    "NUMBEROFREPORTS_ERROR_SETTING": "學習報告份數必須介於1~100之間",
    "THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM": "尚有表單未填寫完成，請重新確認",
    "PLEASE_ENTER_A_VALID_URL": "請輸入有效網址. ex: http://example.com",
    "PLEASE_ENTER_A_VALID_DATE": "請輸入有效日期",
    "SET_THE_TIME_PART_OF_OVERLAP_PLEASE_RESET": "設定時間部份重疊，請重新設定",
    "PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY": "請輸入有效金額",
    "PLEASE_ENTER_A_VALID_EMAIL": "請輸入有效電子信箱"
  };
  angular
      .module('eHRD.modules.language')
      .constant('formValidationConstantZhTW',formValidationConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var actionsConstant = {
    "FINISH": "完成",
    "CLOSE": "關閉",
    "SUBMIT": "提交",
    "ENTER": "確定",
    "APPLY": "套用",
    "CANCEL": "取消",
    "DELETE": "刪除",
    "SEARCH": "搜尋",
    "FILTERS": "篩選",
    "SORT": "排序",
    "SORT_METHOD": "排序方式",
    "LOGIN": "登入",
    "LOGOUT":"登出",
    "NEXT_STEP": "下一步",
    "PREVIOUS_STEP": "上一步",
    "NEXT": "下一個",
    "PREV": "上一個",
    "UN_ENROLL": "取消報名",
    "EXEMPTION": "免修",
    "LEAVE": "請假",
    "RETURN": "返回",
    "FILL_IN": "填寫",
    "ENROLL": "報名",
    "START_LEARNING": "開始學習",
    "START_SURVEY": "問卷開始",
    "START_TEST": "測驗開始",
    "SELECT_ALL": "全選",
    "SELECT_FILES": "選擇檔案",
    "REPLACE_FILES": "取代檔案",
    "UPLOAD_ALL": "全部上傳",
    "DELETE_ALL": "全部刪除",
    "DOWNLOAD_FILE": "下載檔案",
    "SELECT_QUESTION_NUMBER": "選擇題號",
    "RE_TEST_ONCE": "再測驗一次",
    "OPEN_LINK": "開啟連結",
    "ALL_ANNOUNCEMENTS": "全部公告",
    "PLAY_COURSE": "播放課程",
    "FILL_IN_TEST_SURVEY": "受測/填寫問卷",
    "CHANGE_LOGIN_PASSWORD": "變更登入密碼",
    "REPLACE": "取代",
    "READ": "閱讀",
    "RATING": "評分",
    "DOWNLOAD": "下載",
    "SHOW_AVERAGE_RATING": "顯示平均評分",
    "HIDDEN_AVERAGE_RATING": "隱藏平均評分",
    "SUBMIT_RATING": "確定評分",
    "FORM_VIEW": "表單檢視",
    "VIEW_REPORT": "檢視報告",
    "APPROVAL": "核准",
    "NO_APPROVAL": "不核准",
    "APPLY_INFORMATION":"申請須知",
    "APPLY_ENROLLMENT": "申請報名",
    "LOGIN_AGAIN": "重新登入",
    "SELECT": "選擇",
    "REJECT": "不核准",
    "RESEND": "重送",
    "EXPAND_PROFILE_DETAIL": "展開個人資訊",
    "COLLAPSE_PROFILE_DETAIL": "收合個人資訊",
    "EDIT": "編輯",
    "VIEW": "檢視",
    "ADD_PERSONAL_ELECTIVE_ITEM": "加入個人選修項目",
    "ADD_MANAGER_SUGGEST_ITEM": "加入主管建議項目",
    "UPDATE_ESTIMATED_COMPLETION_DATE": "更新預定完成日",
    "UPDATE": "更新",
    "ADD_A_TIME_ZONE": "新增時間區段",
    "EDIT_A_TIME_ZONE": "編輯時間區段",
    "DELETE_A_TIME_ZONE": "刪除時間區段",
    "ADD_FILE": "新增檔案",
    "DELETE_FILE": "刪除檔案",
    "EXPAND_MORE": "展開更多",
    "COLLAPSE_MORE": "收合更多",
    "SELECT_DEPARTMENT": "選擇部門",
    "FORM_EDIT": "表單編輯",
    "APPLY_APPROVAL": "申請簽核",
    "CONTINUE_ENROLL": "繼續報名",
    "NEXT_PAGE": "下一頁",
    "PREVIOUS_PAGE": "上一頁",
    "PRINT": "列印",
    "SEND_APPLY": "送出申請",
    "ADD_A_TIME": "新增時間",
    "DELETE_A_TIME": "刪除時間",
    "EXCERT_APPLY_BONUS": "申請外部證照合格獎勵",
    "EXCERT_APPLY_COMPENSATION": "申請外部證照考試補助",
    "ADD": "新增",
    "REMOVE": "移除",
    "SELECT_CLASS": "選擇班次",
    "SELECT_COURSE": "選擇課程",
    "ADD_NEW_CLASS": "建立新班次",
    "EDIT_CLASS": "修改班次",
    "SET_REPORT_SCORE": "設定報告分數",
    "ADD_APPLY_MEMBER": "加入申請學員",    
    "GO_BACK": "返回上一層"
  };
  angular
    .module('eHRD.modules.language')
    .constant('actionsConstantZhTW',actionsConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var systemConstant = {
    "ONLINE_USER_NO": "线上人数",
    "MANAGER_CENTER": "管理中心"
  };
  angular
    .module('eHRD.modules.language')
    .constant('systemConstantZhCN',systemConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var statusConstant = {
    "PASSED": "通过",
    "COMPLETED": "完成",
    "INCOMPLETED": "未完成",
    "INCOMPLETE": "未完成",
    "FAILED": "未通过",
    "NOT AVAILABLE": "待修中",
    "NOT ATTEMPTED": "未曾观看",
    "NOT_ENROLLED": "尚未报名",
    "UNENROLLED": "尚未报名",
    "UNENROLL": "取消报名",
    "EXEMPTION":"免修",
    "UNPUBLISHED ASSIGNED": "等待发佈中",
    "ENROLLMENT APPROVAL PENDING": "等待簽核中",
    "INCOMPLETED_STATUS":"未完成",
    "SCO_NON_ATTEMPT":"未曾观看",
    "ENROLLMENT_APPROVAL_PENDING": "等待簽核中",
    "STATUS_NOT_AVAILABLE":"待修中",
    "COMPLETED_STATUS":"完成",
    "UNPUBLISHED_WAITLISTED": "候补中",
    "ENROLLMENT_WAITLISTED":"候补中",
    "LEAVE_APPROVAL_PENDING": "请假申请等待簽核中",
    "UNPUBLISHED_ASSIGNED":"等待发佈中",
    "WAITING_FOR_PROGRAM_PUBLISH": "等待来源学习活动发佈中",
    "WAITING FOR PROGRAM PUBLISH": "等待来源学习活动发佈中",
    "SELFENROLLED": "自行报名",
    "ASSIGNED": "指定报名",
    "EXECUTED": "已生效",
    "NOT_EXECUTED": "尚未生效",
    "UNKNOW_STATUS":"未知状态",
    "CANCEL": "取消",
    "APPROVED": "已批准",
    "PUBLIC_STATUS_REJECT": "拒绝",
    "PUBLISH_STATUS_REJECT": "拒绝",
    "WAITING_APPROVAL": "簽核中",
    "NO_APPROVAL": "无须簽核",
    "APPROVALED": "已核准",
    "NOT_YET_APPROVAL": "尚未核准",
    "APPROVAL_REJECT": "簽核拒绝",
    "EXEMPTION_SUBMIT": "免缴",
    "NOT_SUBMIT": "未缴",
    "SUBMITTED": "已缴",
    "NOT_PUBLISHED": "不公布",
    "ENROLLED": "已报名",
    "NOT_ENROLLMENT": "尚未开始报名",
    "ENROLLMENT_DEADLINE": "报名截止",
    "ATTENDANCE": "出席",
    "ABSENCE": "缺席",
    "ABSENT": "缺席",
    "REJECTED": "已被拒绝",
    "LEAVE": "请假",
    "LEARNER_ASK_LEAVE": "学员自行请假",
    "ADMINISTRATOR_REGISTER": "管理员登录",
    "PUBLISHED": "发佈中",
    "HAVE NOT EXECUTED ENROLLED ASSIGNMENT": "尚未生效",
    "NO_RATING_REQUIRED": "无须评分",
    "FAIL_CHECK_SESSIONQUOTAFULL": "名额已满",
    "FAIL_CHECK_PRIVILEGE": "无权限报名",
    "FAIL_CHECK_OUT_OF_QUOTA": "已额满",
    "WAITLISTED": "候补中",
    "BLOCKED": "挡修中",
    "NEW": "最新",
    "HOT": "热门",
    "FEATURED": "精选"
  };
  angular
    .module('eHRD.modules.language')
    .constant('statusConstantZhCN',statusConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var messageConstant = {
    "YOU_HAVE_BEEN_LOGGED_OUT":"您已经成功登出",
    "YOU_HAVE_SUCCESSFULLY_SIGNED_IN":"您已经成功登入!",
    "MSG_TAKES_TIME_ACTION": "这个动作需要花上一些时间，我们将在背景作业中处理。变更或许不会在页面即时呈现。",
    "MSG_IS_SURE_ENROLL": "确定报名吗？",
    "MSG_IS_SURE_UN_ENROLL": "确定取消报名吗？",
    "MSG_IS_SURE_TO_PAY": "您确定要缴交？",
    "MSG_NOT_YET_COMPLETED_WHETHER_TO_SEND_OUT": "尚未完成的題目：{{value}}，是否確定送出？",
    "MSG_THERE_ARE_OPTIONS_NOT_FILLED_OUT": "尚有选项未填写！",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_STUDENT": "请至少选择一个学员",
    "MSG_ERROR_NOT_PUBLISH": "此活动尚未发佈或已被删除",
    "MSG_ERROR_MESSAGE_CAN_NOT_ENROLL_CAUSE_PASS_RESULT": "您已通过此课程，依照课程设定无法再自行报名其他班次，班次资讯如下:<br>格式:学习活动班次名称(上课日期)<br>",
    "MSG_ERROR_MESSAGE_CAN_ENROLL_WAITLSTED_RESULT": "候补中",
    "MSG_IS_CONTINUE": "确定继续?",
    "MSG_YOU_HAVE_REQUIRED_SUBJECT_NOT_YET_ANSWERED": "您尚有必填题目：{{value}}，尚未作答！！",
    "MSG_QUESTION_OPTION_EXCEEDS_WORD_LIMIT": "题目：{{value}}，选项超出字数限制！！",
    "MSG_UNABLE_SEND_REFRESH": "如果您无法发送，系统会自动重新整理，请等待一下",
    "MSG_PLEASE_RETURN_TO_FILL_IN": "请返回填写",
    "MSG_QUESTION_FILL_THIS_TO_THE_END": "填答到此结束，感谢您的回馈填答到此结束，对此问卷请给予回馈",
    "MSG_ERROR_PLAY_BLOCKING": "请先完成前一资料夹的课程内容或测验问卷才能继续",
    "MSG_YOU_HAVE_COMPLETED_THIS_QUESTIONNAIRE": "你已完成此问卷",
    "MSG_YOU_HAVE_COMPLETED_THIS_TEST": "你已完成此测验",
    "MSG_CURRENTLY_NON_VIEWING_TIME": "目前非观看时间",
    "MSG_NEXT_TEST_DATETIME": "下次测验日期为",
    "MSG_CAN_NOT_TAKE_LESSONS": "无法进行课程",
    "MSG_CAN_NOT_TAKE_TEST_QUESTIONNAIRE": "无法进行测验问卷",
    "MSG_ARE_YOU_SURE_WANT_TO_REPLACE_YOUR_AVATAR": "确定要将更换个人头像吗?",
    "MSG_ARE_YOU_SURE_WANT_TO_CHANGE_YOUR_PASSWORD": "确定要变更密码吗?",
    "MSG_CAN_NOT_FIND_THE_LATEST_INFORMATION": "无法查到最新资料",
    "MSG_DO_YOU_WANT_TO_ADD_MY_FAVORITE": "确定要将{{value}}加入我的最爱吗?",
    "MSG_DO_YOU_WANT_TO_CANCEL_MY_FAVORITE": "确定要将{{value}}取消我的最爱吗?",
    "MSG_PLEASE_ENTER_START_DATE": "请输入开始日期",
    "MSG_PLEASE_ENTER_END_DATE": "请输入结束日期",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_COURSE": "请至少选择一个课程",
    "MSG_THE_START_DATE_CAN_NOT_BE_GREATER_THAN_THE_END_DATE": "开始日期不能大于结束日期",
    "MSG_PLEASE_SELECT_DEPARTMENT_MEMBER": "请选择部门成员",
    "MSG_THE_FORM_HAS_NOT_BEEN_COMPLETED_YET_PLEASE_CONFIRM": "表单尚未完成，请确认!",
    "MSG_UPDATE_PASSWORD_SUCCESS": "变更密码成功",
    "MSG_ENROLLMENT_APPROVAL_PENDING": "等待簽核中",
    "MSG_THIS_ACTION_WILL_RELEVANT_STUDY_REPORT": "这个动作会取消所有相关的学习报告",
    "MSG_ARE_YOU_SURE_WANT_TO_DELETE_DEPUTY_RECORD": "确定要删除代理人纪录?",
    "MSG_DEPUTY_EFFECTIVE_DATE_CNA_NOT_EMPTY": "代理生效日不得为空!",
    "MSG_DEPUTY_END_DATE_CNA_NOT_EMPTY": "代理结束日不得为空!",
    "MSG_DEPUTY_END_DATE_CNA_NOT_BE_EARLIER_THAN_DEPUTY_EFFECTIVE_DATE": "代理结束日不能早於代理生效日",
    "MSG_PLEASE_SETTING_DEPUTY": "请设定代理人",
    "MSG_SETTING_DEPUTY_SUCCESSFUL": "设定代理人成功",
    "MSG_EDIT_DEPUTY_RECORD_SUCCESSFUL": "修改代理人纪录成功",
    "MSG_NOT_ALLOW_TO_DELETE_OTHER_SETTING": "不允许移除其他人的设定",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_TIME_PERIOD": "请至少选择一个时段",
    "MSG_PLEASE_FILE_IN_THE_REASON_FOR_REJECT": "请填入不核准的原因",
    "MSG_ERROR_NEED_FINISH_PREREQUISITE_ITEMS": "请先完成下列先修项目再报名",
    "MSG_SELECT_COURSE_OR_OTHER_NEED": "请选择课程或其他需求",
    "MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_SELF_REQUIRED_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT": "仅能删除自我要求且尚未报名的建议学习项目",
    "MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_YOU_HAVE_ENROLLED_IN": "您已报名的课程，无法直接删除",
    "MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_MANAGER_SUGGEST_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT": "仅能删除主管建议且尚未报名的建议学习项目",
    "MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_EMPLOYEES_HAVE_ENROLLED_IN": "同仁已报名的课程，无法直接删除",
    "MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES_AND_MANAGER_SUGGESTION": "仅能针对\"自我要求/主管建议\"课程调整预定完成日期",
    "MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES": "仅能针对\"自我要求\"课程调整预定完成日期",
    "MSG_PLEASE_FILL_IN_THE_REASON": "请填写理由",
    "MSG_THE_SETTING_TIME_DOES_NOT_EXIST_PLEASE_RE_ENTER": "设定时间不存在,请重新输入",
    "MSG_TIME_PERIOD_N_PARTIALLY_OVERLAPS_PLEASE_RESET": "与时段 {{value}} 设定时间部份重叠，请重新设定",
    "MSG_SUCCESSFUL_OPERATION": "操作成功",
    "MSG_FAILED_OPERATION": "操作失败",
    "MSG_EXTERNAL_TRAINING_APPLY_SUMMIT_CHECK": "送出前请再次确认填入资料是否全部正确!!  确定要送出请按\"确定\"钮. 重新编辑请按\"取消\"钮.",
    "MSG_THE_START_DATE_NEED_TO_EARLIER_THAN_THE_END_DATE": "开始时间必须早於结束时间",
    "MSG_YOUR_ATTENDANCE_RATE_IS_TOO_LOW_TO_FILL_OUT": "您出席率不足，无法进行填写",
    "MSG_ENROLLMENT_WAITING_APPROVAL": "报名等待簽核中",
    "MSG_CLASS_TIME_CONFLICT": "此课程与其他已经报名之课程:<br> {{value}} 的上课时间重叠,因此不能报名!",
    "MSG_CLASS_TIME_CONFLICT_NO_BLOCK": "此课程与其他已经报名之课程:<br> {{value}} 的上课时间重叠",
    "MSG_TIME_IS_OUT": "时间已到!",
    "MSG_ASSIGN_EXCEED_MAX": "你已经选择了{{value1}}个学员。但是只有{{value2}}个学员能够加入此课程/学程，因指定人数超过上限，请重新选择。",
    "MSG_CURRENTLY_ON_THE_TEMPORARY_LEARNING_RESOURCES": "目前暂无线上学习资源",
    "MSG_ERROR_MESSAGE_ENROLL_CAUSE_PASS_RESULT": "您已通过此课程，是否继续再自行报名其他班次，班次资讯如下:<br>格式:学习活动班次名称(上课日期)<br>",
    "MSG_INNERCERT_CANNOT_ENROLL_EXTENDED_SESSION": "您无取得过该内部证照, 无法报名展期班次",
    "MSG_RESTORE_LAST_TIME_UNFINISHED_FORM": "恢复前次未完成填写表单!!",
    "MSG_COURSE_DATA_FILE_NEED_RE_CHOOSE": "课程资料档案需要重新选取!!",
    "MSG_THE_TIME_RANGE_IS_ERROR": "时间范围错误",
    "MSG_CONFIRM_TO_DELETE": "确定删除?",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_ITEM": "请至少选择一个项目",
    "MSG_BEFORE_YOU_REGISTER_YOU_MUST_FILL_OUT_THE_REGISTRATION_QUESTIONNAIRE_ARE_YOU_SURE_YOU_WANT_TO_CONTINUE": "报名课程前必须先填写报名问卷。确定要继续?",
    "MSG_YOU_DO_NOT_HAVE_PERMISSION_TO_VIEW_THIS_LEARNING_ACTIVITY": "您没有权限观看本学习活动",
    "MSG_PLEASE_SELECT_ONE_COURSE": "请选择一个课程",
    "MSG_PLEASE_SELECT_ONE_COURSE_SESSION": "请选择一个班次",
    "MSG_THE_APPLICATION_FORM_WAS_UPDATED_SUCCESSFULLY": "申请表单修改成功",
    "MSG_YOU_HAVE_SUCCESSFULLY_ADDED_EXTERNAL_VENDOR": "您已成功新增外训厂商",
    "MSG_INPUT_ANSWER_EXCEED_LIMIT": "答案不可超过限制长度。",
    "ADDED_EXTERNAL_VENDOR": "新增外训厂商",
    "PICTURE_OVER_MB_PLEASE_RELOAD": "图片档案超过{{value}}mb，请重新上传"
  };
  angular
    .module('eHRD.modules.language')
    .constant('messageConstantZhCN',messageConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var httpErrorCodeConstant = {
    "102_TITLE": "ERR CONNECTION REFUSED",
    "102_CONTENT": "未知的错误。",

    "400_TITLE": "Bad Request",
    "400_CONTENT": "由于包含语法错误，当前请求无法被伺服器理解。除非进行修改，否则用户端不应该重複提交这个请求。",

    "401_TITLE": "Unauthorized",
    "401_CONTENT": "当前请求需要使用者验证。该响应必须包含一个适用于被请求资源的WWW-Authenticate资讯头用以询问使用者资讯。用户端可以重複提交一个包含恰当的Authorization头资讯的请求。如果当前请求已经包含了Authorization凭证，那麽401响应代表着伺服器验证已经拒绝了那些凭证。如果401响应包含了与前一个响应相同的身分验证询问，且浏览器已经至少尝试了一次验证，那麽浏览器应当向使用者展示响应中包含的实体资讯，因为这个实体资讯中可能包含了相关诊断资讯。",

    "402_TITLE": "Payment Required",
    "402_CONTENT": "该状态码是为了将来可能的需求而预留的。",

    "403_TITLE": "Forbidden",
    "403_CONTENT": "伺服器已经理解请求，但是拒绝执行它。与401响应不同的是，身分验证并不能提供任何帮助，而且这个请求也不应该被重複提交。如果这不是一个HEAD请求，而且伺服器希望能够讲清楚为何请求不能被执行，那麽就应该在实体内描述拒绝的原因。当然伺服器也可以返回一个404响应，假如它不希望让用户端获得任何资讯。",

    "404_TITLE": "Not Found",
    "404_CONTENT": "请求失败，请求所希望得到的资源未被在伺服器上发现。没有资讯能够告诉使用者这个状况到底是暂时的还是永久的。假如伺服器知道情况的话，应当使用410状态码来告知旧资源因为某些内部的配置机制问题，已经永久的不可用，而且没有任何可以跳转的位址。404这个状态码被广泛应用于当伺服器不想揭示到底为何请求被拒绝或者没有其他适合的响应可用的情况下。",

    "405_TITLE": "Method Not Allowed",
    "405_CONTENT": "请求行中指定的请求方法不能被用于请求相应的资源。该响应必须返回一个Allow头资讯用以表示出当前资源能够接受的请求方法的列表。鉴于PUT，DELETE方法会对伺服器上的资源进行写操作，因而绝大部分的网页伺服器都不支援或者在预设配置下不允许上述请求方法，对于此类请求均会返回405错误。",

    "406_TITLE": "Not Acceptable",
    "406_CONTENT": "请求的资源的内容特性无法满足请求头中的条件，因而无法生成响应实体。除非这是一个HEAD请求，否则该响应就应当返回一个包含可以让使用者或者浏览器从中选择最合适的实体特性以及位址列表的实体。实体的格式由Content-Type头中定义的媒体类型决定。浏览器可以根据格式及自身能力自行作出最佳选择。但是，规范中并没有定义任何作出此类自动选择的标准。",

    "407_TITLE": "Proxy Authentication Required",
    "407_CONTENT": "与401响应类似，只不过用户端必须在代理伺服器上进行身分验证。代理伺服器必须返回一个Proxy-Authenticate用以进行身分询问。用户端可以返回一个Proxy-Authorization资讯头用以验证。",

    "408_TITLE": "Request Timeout",
    "408_CONTENT": "请求超时。用户端没有在伺服器预备等待的时间内完成一个请求的传送。用户端可以随时再次提交这一请求而无需进行任何更改。",

    "409_TITLE": "Conflict",
    "409_CONTENT": "由于和被请求的资源的当前状态之间存在冲突，请求无法完成。这个代码只允许用在这样的情况下才能被使用：使用者被认为能够解决冲突，并且会重新提交新的请求。该响应应当包含足够的资讯以便使用者发现冲突的源头。冲突通常发生于对PUT请求的处理中。例如，在採用版本检查的环境下，某次PUT提交的对特定资源的修改请求所附带的版本资讯与之前的某个（第三方）请求向冲突，那麽此时伺服器就应该返回一个409错误，告知使用者请求无法完成。此时，响应实体中很可能会包含两个冲突版本之间的差异比较，以便使用者重新提交归併以后的新版本。",

    "410_TITLE": "Gone",
    "410_CONTENT":"被请求的资源在伺服器上已经不再可用，而且没有任何已知的转发位址。这样的状况应当被认为是永久性的。如果可能，拥有连结编辑功能的用户端应当在获得使用者许可后删除所有指向这个位址的参照。如果伺服器不知道或者无法确定这个状况是否是永久的，那麽就应该使用404状态码。除非额外说明，否则这个响应是可快取的。",

    "411_TITLE": "Length Required",
    "411_CONTENT":"伺服器拒绝在没有定义Content-Length头的情况下接受请求。在添加了表明请求讯息体长度的有效Content-Length头之后，用户端可以再次提交该请求。",

    "412_TITLE": "Precondition Failed",
    "412_CONTENT":"伺服器在验证在请求的头栏位中给出先决条件时，没能满足其中的一个或多个。这个状态码允许用户端在取得资源时在请求的元资讯（请求头栏位资料）中设定先决条件，以此避免该请求方法被应用到其希望的内容以外的资源上。",

    "413_TITLE": "Request Entity Too Large",
    "413_CONTENT":"伺服器拒绝处理当前请求，因为该请求提交的实体资料大小超过了伺服器愿意或者能够处理的范围。此种情况下，伺服器可以关闭连线以免用户端继续传送此请求。如果这个状况是临时的，伺服器应当返回一个Retry-After的响应头，以告知用户端可以在多少时间以后重新尝试。",

    "414_TITLE": "Request-URI Too Long",
    "414_CONTENT":"请求的URI长度超过了伺服器能够解释的长度，因此伺服器拒绝对该请求提供服务",

    "415_TITLE": "Unsupported Media Type",
    "415_CONTENT":"对于当前请求的方法和所请求的资源，请求中提交的实体并不是伺服器中所支援的格式，因此请求被拒绝。",

    "416_TITLE": "Requested Range Not Satisfiable",
    "416_CONTENT":"如果请求中包含了Range请求头，并且Range中指定的任何资料范围都与当前资源的可用范围不重合，同时请求中又没有定义If-Range请求头，那麽伺服器就应当返回416状态码。假如Range使用的是位元组范围，那麽这种情况就是指请求指定的所有资料范围的首位元组位置都超过了当前资源的长度。伺服器也应当在返回416状态码的同时，包含一个Content-Range实体头，用以指明当前资源的长度。这个响应也被禁止使用multipart/byteranges作为其Content-Type。",

    "417_TITLE": "Expectation Failed",
    "417_CONTENT":"在请求头Expect中指定的预期内容无法被伺服器满足，或者这个伺服器是一个代理伺服器，它有明显的证据证明在当前路由的下一个节点上，Expect的内容无法被满足。",

    "418_TITLE": "I'm a teapot",
    "418_CONTENT":"本操作码是在1998年作为IETF的传统愚人节笑话, 在RFC 2324 超文字咖啡壶控制协定中定义的，并不需要在真实的HTTP伺服器中定义。当一个控制茶壶的HTCPCP收到BREW或POST指令要求其煮咖啡时应当回传此错误。",

    "421_TITLE": "There are too many connections from your internet address",
    "421_CONTENT":"从当前用户端所在的IP位址到伺服器的连线数超过了伺服器许可的最大范围。通常，这裡的IP位址指的是从伺服器上看到的用户端位址（比如使用者的闸道器或者代理伺服器位址）。在这种情况下，连线数的计算可能涉及到不止一个终端使用者。",

    "422_TITLE": "Unprocessable Entity",
    "422_CONTENT":"请求格式正确，但是由于含有语意错误，无法响应。",

    "423_TITLE": "Locked",
    "423_CONTENT":"当前资源被锁定。",

    "424_TITLE": "Failed Dependency",
    "424_CONTENT":"由于之前的某个请求发生的错误，导致当前请求失败，例如PROPPATCH。",

    "425_TITLE": "Unordered Collection",
    "425_CONTENT":"在WebDav Advanced Collections草案中定义，但是未出现在《WebDAV顺序集协定》中。",

    "426_TITLE": "Upgrade Required",
    "426_CONTENT":"用户端应当切换到TLS/1.0。",

    "449_TITLE": "Retry With",
    "449_CONTENT":"由微软扩充功能，代表请求应当在执行完适当的操作后进行重试。",

    "451_TITLE": "Unavailable For Legal Reasons",
    "451_CONTENT":"由IETF核准，代表该存取因法律的要求而被拒绝。",


    "500_TITLE": "Internal Server Error",
    "500_CONTENT":"伺服器遇到了一个未曾预料的状况，导致了它无法完成对请求的处理。一般来说，这个问题都会在伺服器的程式码出错时出现。",

    "501_TITLE": "Not Implemented",
    "501_CONTENT":"伺服器不支援当前请求所需要的某个功能。当伺服器无法识别请求的方法，并且无法支援其对任何资源的请求。",

    "502_TITLE": "Bad Gateway",
    "502_CONTENT":"作为闸道器或者代理工作的伺服器尝试执行请求时，从上游伺服器接收到无效的响应。",

    "503_TITLE": "Service Unavailable",
    "503_CONTENT":"由于临时的伺服器维护或者过载，伺服器当前无法处理请求。这个状况是临时的，并且将在一段时间以后取消復原。如果能够预计延迟时间，那麽响应中可以包含一个Retry-After头用以标明这个延迟时间。如果没有给出这个Retry-After资讯，那麽用户端应当以处理500响应的方式处理它。",

    "504_TITLE": "Gateway Timeout",
    "504_CONTENT":"作为闸道器或者代理工作的伺服器尝试执行请求时，未能及时从上游伺服器（URI标识出的伺服器，例如HTTP、FTP、LDAP）或者辅助伺服器（例如DNS）收到响应。注意：某些代理伺服器在DNS查询超时时会返回400或者500错误。",

    "505_TITLE": "HTTP Version Not Supported",
    "505_CONTENT":"伺服器不支援，或者拒绝支援在请求中使用的HTTP版本。这暗示着伺服器不能或不愿使用与用户端相同的版本。响应中应当包含一个描述了为何版本不被支援以及伺服器支援哪些协定的实体。",

    "506_TITLE": "Variant Also Negotiates",
    "506_CONTENT":"由《透明内容协商协定》扩充功能，代表伺服器存在内部配置错误：被请求的协商变元资源被配置为在透明内容协商中使用自己，因此在一个协商处理中不是一个合适的重点。",

    "507_TITLE": "Insufficient Storage",
    "507_CONTENT":"伺服器无法储存完成请求所必须的内容。这个状况被认为是临时的。",

    "509_TITLE": "Bandwidth Limit Exceeded",
    "509_CONTENT":"伺服器达到频宽限制。这不是一个官方的状态码，但是仍被广泛使用。",

    "510_TITLE": "Not Extended",
    "510_CONTENT":"取得资源所需要的策略并没有被满足。"

  };
  angular
    .module('eHRD.modules.language')
    .constant('httpErrorCodeConstantZhCN',httpErrorCodeConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var formValidationConstant = {
    "THIS_IS_REQUIRED": "必填!",
    "PLEASE_RE_CHECK_NEW_PASSWORD": "请重新确认新密码",
    "PLEASE_RE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD": "请重新输入您的帐号及密码",
    "PLEASE_SELECT_AT_LEAST_ONE_ITEM": "请至少选择一项",
    "PLEASE_SELECT_AT_LEAST_ONE_MEMBER": "请至少选择一个成员",
    "PLEASE_SET_AT_LEAST_ONE_TIME_ZONE": "请至少设定一个时间区段",
    "NUMBEROFREPORTS_ERROR_SETTING": "学习报告份数必须介于1~100之间",
    "THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM": "尚有表单未填写完成，请重新确认",
    "PLEASE_ENTER_A_VALID_URL": "请输入有效网址. ex: http://example.com",
    "PLEASE_ENTER_A_VALID_DATE": "请输入有效日期",
    "SET_THE_TIME_PART_OF_OVERLAP_PLEASE_RESET": "设定时间部份重叠，请重新设定",
    "PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY": "请输入有效金额",
    "PLEASE_ENTER_A_VALID_EMAIL": "请输入有效电子信箱"
  };
  angular
    .module('eHRD.modules.language')
    .constant('formValidationConstantZhCN',formValidationConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var actionsConstant = {
    "FINISH": "完成",
    "CLOSE": "关闭",
    "SUBMIT": "提交",
    "ENTER": "确定",
    "APPLY": "套用",
    "CANCEL": "取消",
    "DELETE": "删除",
    "SEARCH": "搜寻",
    "FILTERS": "筛选",
    "SORT": "排序",
    "SORT_METHOD": "排序方式",
    "LOGIN": "登入",
    "LOGOUT":"登出",
    "NEXT_STEP": "下一步",
    "PREVIOUS_STEP": "上一步",
    "NEXT": "下一个",
    "PREV": "上一个",
    "UN_ENROLL": "取消报名",
    "EXEMPTION": "免修",
    "LEAVE": "请假",
    "RETURN": "返回",
    "FILL_IN": "填写",
    "ENROLL": "报名",
    "START_LEARNING": "开始学习",
    "START_SURVEY": "问卷开始",
    "START_TEST": "测验开始",
    "SELECT_ALL": "全选",
    "SELECT_FILES": "选择档案",
    "REPLACE_FILES": "取代档案",
    "UPLOAD_ALL": "全部上传",
    "DELETE_ALL": "全部删除",
    "DOWNLOAD_FILE": "下载档案",
    "SELECT_QUESTION_NUMBER": "选择题号",
    "RE_TEST_ONCE": "再测验一次",
    "OPEN_LINK": "开启链接",
    "ALL_ANNOUNCEMENTS": "全部公告",
    "PLAY_COURSE": "播放课程",
    "FILL_IN_TEST_SURVEY": "受测/填写问卷",
    "CHANGE_LOGIN_PASSWORD": "变更登入密码",
    "REPLACE": "取代",
    "READ": "阅读",
    "RATING": "评分",
    "DOWNLOAD": "下载",
    "SHOW_AVERAGE_RATING": "显示平均评分",
    "HIDDEN_AVERAGE_RATING": "隐藏平均评分",
    "SUBMIT_RATING": "确定评分",
    "FORM_VIEW": "表单检视",
    "VIEW_REPORT": "检视报告",
    "APPROVAL": "核准",
    "NO_APPROVAL": "不核准",
    "APPLY_INFORMATION":"申请须知",
    "APPLY_ENROLLMENT": "申请报名",
    "LOGIN_AGAIN": "重新登入",
    "SELECT": "选择",
    "REJECT": "不核准",
    "RESEND": "重送",
    "EXPAND_PROFILE_DETAIL": "展开个人资讯",
    "COLLAPSE_PROFILE_DETAIL": "收合个人资讯",
    "EDIT": "编辑",
    "VIEW": "检视",
    "ADD_PERSONAL_ELECTIVE_ITEM": "加入个人选修项目",
    "ADD_MANAGER_SUGGEST_ITEM": "加入主管建议项目",
    "UPDATE_ESTIMATED_COMPLETION_DATE": "更新预定完成日",
    "UPDATE": "更新",
    "ADD_A_TIME_ZONE": "新增时间区段",
    "EDIT_A_TIME_ZONE": "编辑时间区段",
    "DELETE_A_TIME_ZONE": "删除时间区段",
    "ADD_FILE": "新增档案",
    "DELETE_FILE": "删除档案",
    "EXPAND_MORE": "展开更多",
    "COLLAPSE_MORE": "收合更多",
    "SELECT_DEPARTMENT": "选择部门",
    "FORM_EDIT": "表单编辑",
    "APPLY_APPROVAL": "申请簽核",
    "CONTINUE_ENROLL": "继续报名",
    "NEXT_PAGE": "下一页",
    "PREVIOUS_PAGE": "上一页",
    "PRINT": "列印",
    "SEND_APPLY": "送出申请",
    "ADD_A_TIME": "新增时间",
    "DELETE_A_TIME": "删除时间",
    "EXCERT_APPLY_BONUS": "申请外部证照合格奖励",
    "EXCERT_APPLY_COMPENSATION": "申请外部证照考试补助",
    "ADD": "新增",
    "REMOVE": "移除",
    "SELECT_CLASS": "选择班次",
    "SELECT_COURSE": "选择课程",
    "ADD_NEW_CLASS": "建立新班次",
    "EDIT_CLASS": "修改班次",
    "SET_REPORT_SCORE": "设定报告分数",
    "ADD_APPLY_MEMBER": "加入申请学员",    
    "GO_BACK": "返回上一层"
  };
  angular
    .module('eHRD.modules.language')
    .constant('actionsConstantZhCN',actionsConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var systemConstant = {
    "ONLINE_USER_NO": "Online user",
    "MANAGER_CENTER": "Management center"
  };
  angular
    .module('eHRD.modules.language')
    .constant('systemConstantEnUS',systemConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var statusConstant = {
    "PASSED": "Pass",
    "COMPLETED": "Complete",
    "INCOMPLETED": "Incomplete",
    "INCOMPLETE": "Incomplete",
    "FAILED": "Fail",
    "NOT AVAILABLE": "Incomplete",
    "NOT ATTEMPTED": "Not yet viewed",
    "NOT_ENROLLED": "Not enrolled",
    "UNENROLLED": "Not enrolled",
    "UNENROLL": "Cancel the enrollment",
    "EXEMPTION":"Exemption",
    "UNPUBLISHED ASSIGNED": "Waiting to publish",
    "ENROLLMENT APPROVAL PENDING": "Waiting	for approval",
    "INCOMPLETED_STATUS":"Incomplete",
    "SCO_NON_ATTEMPT":"Not yet viewed",
    "ENROLLMENT_APPROVAL_PENDING": "Waiting for approval",
    "STATUS_NOT_AVAILABLE":"Incomplete",
    "COMPLETED_STATUS":"Complete",
    "UNPUBLISHED_WAITLISTED": "On the waiting list",
    "ENROLLMENT_WAITLISTED":"On the waiting list",
    "LEAVE_APPROVAL_PENDING": "The application of ask for leave is waiting for approval.",
    "UNPUBLISHED_ASSIGNED":"Waiting to publish",
    "WAITING_FOR_PROGRAM_PUBLISH": "Waiting for the program to be published.",
    "WAITING FOR PROGRAM PUBLISH": "Waiting for the program to be published.",
    "SELFENROLLED": "Self-registered",
    "ASSIGNED": "Assigned",
    "EXECUTED": "Effective",
    "NOT_EXECUTED": "Not effective",
    "UNKNOW_STATUS":"Unknown status",
    "CANCEL": "Cancel",
    "APPROVED": "Approved",
    "PUBLIC_STATUS_REJECT": "Reject",
    "PUBLISH_STATUS_REJECT": "Reject",
    "WAITING_APPROVAL": "Waiting for approval",
    "NO_APPROVAL": "No need to approve",
    "APPROVALED": "Approved",
    "NOT_YET_APPROVAL": "Not yet approval",
    "APPROVAL_REJECT": "Reject",
    "EXEMPTION_SUBMIT": "Exempt from report",
    "NOT_SUBMIT": "Not submit",
    "SUBMITTED": "Submitted",
    "NOT_PUBLISHED": "Not publish",
    "ENROLLED": "Enrolled",
    "NOT_ENROLLMENT": "Not the application time",
    "ENROLLMENT_DEADLINE": "Over the application deadline",
    "ATTENDANCE": "Attendance",
    "ABSENCE": "Absence",
    "ABSENT": "Absent",
    "REJECTED": "Rejected",
    "LEAVE": "Leave",
    "LEARNER_ASK_LEAVE": "Learner leave on their own",
    "ADMINISTRATOR_REGISTER": "Administrator register",
    "PUBLISHED": "published",
    "HAVE NOT EXECUTED ENROLLED ASSIGNMENT": "Not effective",
    "NO_RATING_REQUIRED": "No rating required",
    "FAIL_CHECK_SESSIONQUOTAFULL": "Session is Full",
    "FAIL_CHECK_PRIVILEGE": "You don't have privilege to enroll",
    "FAIL_CHECK_OUT_OF_QUOTA": "Full",
    "WAITLISTED": "Wait list",
    "BLOCKED": "Blocked",
    "NEW": "New",
    "HOT": "Hot",
    "FEATURED": "Featured"
  };
  angular
    .module('eHRD.modules.language')
    .constant('statusConstantEnUS',statusConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var messageConstant = {
    "YOU_HAVE_BEEN_LOGGED_OUT":"Logout successfully.",
    "YOU_HAVE_SUCCESSFULLY_SIGNED_IN":"Login successfully.",
    "MSG_TAKES_TIME_ACTION": "Since the system will process the requirement in the background, the adjustment may not display immediately.",
    "MSG_IS_SURE_ENROLL": "Continue to enroll?",
    "MSG_IS_SURE_UN_ENROLL": "Are your sure to cancel the enrollment?",
    "MSG_IS_SURE_TO_PAY": "Submit?",
    "MSG_NOT_YET_COMPLETED_WHETHER_TO_SEND_OUT": "Not yet completed：{{value}}, whether to send out？",
    "MSG_THERE_ARE_OPTIONS_NOT_FILLED_OUT": "Some items are not filled in!",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_STUDENT": "Please select at least one learner.",
    "MSG_ERROR_NOT_PUBLISH": "The activity is not published or is be deleted.",
    "MSG_ERROR_MESSAGE_CAN_NOT_ENROLL_CAUSE_PASS_RESULT": "According to the rules, you cannot enroll any other classes because you have passed the course.",
	  "MSG_ERROR_MESSAGE_CAN_ENROLL_WAITLSTED_RESULT": "Waitlisted",
    "MSG_IS_CONTINUE": "Continue?",
    "MSG_YOU_HAVE_REQUIRED_SUBJECT_NOT_YET_ANSWERED": "Required items：{{value}}，are not filled.",
    "MSG_QUESTION_OPTION_EXCEEDS_WORD_LIMIT": "Item：{{value}}，exceeds the character count limit.",
    "MSG_UNABLE_SEND_REFRESH": "If you can't send it, it will be refreshed automatically, please wait.",
    "MSG_PLEASE_RETURN_TO_FILL_IN": "Return.",
    "MSG_QUESTION_FILL_THIS_TO_THE_END": "Thanks for the feedback.",
    "MSG_ERROR_PLAY_BLOCKING": "Please finish the previous content, test, or questionnaire.",
    "MSG_YOU_HAVE_COMPLETED_THIS_QUESTIONNAIRE": "Finish the questionnaire.",
    "MSG_YOU_HAVE_COMPLETED_THIS_TEST": "Finish the test.",
    "MSG_CURRENTLY_NON_VIEWING_TIME": "Not the allowed viewing time.",
    "MSG_NEXT_TEST_DATETIME": "The date & time of the next test",
    "MSG_CAN_NOT_TAKE_LESSONS": "Can't view the content.",
    "MSG_CAN_NOT_TAKE_TEST_QUESTIONNAIRE": "Can't take the test or questionnaire.",
    "MSG_ARE_YOU_SURE_WANT_TO_REPLACE_YOUR_AVATAR": "Change the photo?",
    "MSG_ARE_YOU_SURE_WANT_TO_CHANGE_YOUR_PASSWORD": "Are you sure to change the password?",
    "MSG_CAN_NOT_FIND_THE_LATEST_INFORMATION": "Can't find out the latest information.",
    "MSG_DO_YOU_WANT_TO_ADD_MY_FAVORITE": "Put{{value}}in My Favourites?",
    "MSG_DO_YOU_WANT_TO_CANCEL_MY_FAVORITE": "Remove{{value}}from My Favourites?",
    "MSG_PLEASE_ENTER_START_DATE": "Input the start date.",
    "MSG_PLEASE_ENTER_END_DATE": "Input the end date.",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_COURSE": "Please select at least one course.",
    "MSG_THE_START_DATE_CAN_NOT_BE_GREATER_THAN_THE_END_DATE": "The end date can not earlier than start date.",
    "MSG_PLEASE_SELECT_DEPARTMENT_MEMBER": "Please select the department member.",
    "MSG_THE_FORM_HAS_NOT_BEEN_COMPLETED_YET_PLEASE_CONFIRM": "Please fill in the form.",
    "MSG_UPDATE_PASSWORD_SUCCESS": "Change the password successfully.",
    "MSG_ENROLLMENT_APPROVAL_PENDING": "Waiting for approval.",
    "MSG_THIS_ACTION_WILL_RELEVANT_STUDY_REPORT": "This action will relevant study report",
    "MSG_ARE_YOU_SURE_WANT_TO_DELETE_DEPUTY_RECORD": "Are you sure want to delete deputy record?",
    "MSG_DEPUTY_EFFECTIVE_DATE_CNA_NOT_EMPTY": "Deputy effective date can not empty!",
    "MSG_DEPUTY_END_DATE_CNA_NOT_EMPTY": "Deputy end date can not empty!",
    "MSG_DEPUTY_END_DATE_CNA_NOT_BE_EARLIER_THAN_DEPUTY_EFFECTIVE_DATE": "Deputy end date can not be earlier than deputy effective date",
    "MSG_PLEASE_SETTING_DEPUTY": "Please setting deputy",
    "MSG_SETTING_DEPUTY_SUCCESSFUL": "Setting deputy successful",
    "MSG_EDIT_DEPUTY_RECORD_SUCCESSFUL": "Edit deputy record successful",
    "MSG_NOT_ALLOW_TO_DELETE_OTHER_SETTING": "Can't allow to delete other setting",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_TIME_PERIOD": "Please select at least the time period",
    "MSG_PLEASE_FILE_IN_THE_REASON_FOR_REJECT": "Please fill in the reason for reject",
    "MSG_ERROR_NEED_FINISH_PREREQUISITE_ITEMS": "Please complete the following prerequisites before applying",
    "MSG_SELECT_COURSE_OR_OTHER_NEED": "Select course or other requirement",
    "MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_SELF_REQUIRED_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT": "Sorry,you can only delete courses from Self-Required which are still open for enrollment.",
    "MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_YOU_HAVE_ENROLLED_IN": "Sorry,you cannot delete courses which you have enrolled in.",
    "MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_MANAGER_SUGGEST_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT": "Sorry,you can only delete courses from Manager's suggestions which are still open for enrollment.",
    "MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_EMPLOYEES_HAVE_ENROLLED_IN": "Sorry,you cannot delete courses which employees have enrolled in.",
    "MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES_AND_MANAGER_SUGGESTION": "Sorry,you can only update planned completion date(s) of courses from Self Requires and Manager's suggestion",
    "MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES": "Sorry,you can only update planned completion date(s) of courses from Self Requires",
    "MSG_PLEASE_FILL_IN_THE_REASON": "Please fill in the reason",
    "MSG_THE_SETTING_TIME_DOES_NOT_EXIST_PLEASE_RE_ENTER": "The setting time does not exist, please re-enter",
    "MSG_TIME_PERIOD_N_PARTIALLY_OVERLAPS_PLEASE_RESET": "Time period {{value}} partially overlaps, please reset",
    "MSG_SUCCESSFUL_OPERATION": "Operation succeeded",
    "MSG_FAILED_OPERATION": "Operation failed",
    "MSG_EXTERNAL_TRAINING_APPLY_SUMMIT_CHECK": "Re-confirm data before sending!! To confirm sending please press Ok, and Cancel to edit.",
    "MSG_THE_START_DATE_NEED_TO_EARLIER_THAN_THE_END_DATE": "The end date can not earlier than start date.",
    "MSG_YOUR_ATTENDANCE_RATE_IS_TOO_LOW_TO_FILL_OUT": "Your attendance rate is too low to fill out.",
    "MSG_ENROLLMENT_WAITING_APPROVAL": "Enrollment pending approval",
    "MSG_CLASS_TIME_CONFLICT": "This class time conflicts with other enrolled courses:<br> {{value}} and hence can not enroll in this class!",
    "MSG_CLASS_TIME_CONFLICT_NO_BLOCK": "This class time conflicts with other enrolled courses:<br> {{value}} ",
    "MSG_TIME_IS_OUT": "Time is out!",
    "MSG_ASSIGN_EXCEED_MAX": "You have selected{{value1}}learners. But only {{value2}} learners can join in the course/curriculum. Since there is no enough quota. Please re-select.",
    "MSG_CURRENTLY_ON_THE_TEMPORARY_LEARNING_RESOURCES": "Currently on the temporary learning resources",
    "MSG_ERROR_MESSAGE_ENROLL_CAUSE_PASS_RESULT": "You have passed this course. Do you want to enroll in other classes? The classes are:<br> Format: Class name(class time)<br>",
    "MSG_INNERCERT_CANNOT_ENROLL_EXTENDED_SESSION": "Cannot enroll in this extended session because you have not yet got this internal certificate.",
    "MSG_RESTORE_LAST_TIME_UNFINISHED_FORM": "Restore last time unfinished form!!",
    "MSG_COURSE_DATA_FILE_NEED_RE_CHOOSE": "Course data file need re choose!!",
    "MSG_THE_TIME_RANGE_IS_ERROR": "The time range is error",
    "MSG_CONFIRM_TO_DELETE": "Confirm to delete?",
    "MSG_PLEASE_SELECT_AT_LEAST_ONE_ITEM": "Please select at least one item.",
    "MSG_BEFORE_YOU_REGISTER_YOU_MUST_FILL_OUT_THE_REGISTRATION_QUESTIONNAIRE_ARE_YOU_SURE_YOU_WANT_TO_CONTINUE": "Before you register, you must fill out the registration questionnaire. Are you sure you want to continue?",
    "MSG_YOU_DO_NOT_HAVE_PERMISSION_TO_VIEW_THIS_LEARNING_ACTIVITY": "You don't have permission to view this learning activity",
    "MSG_PLEASE_SELECT_ONE_COURSE": "Please select one course.",
    "MSG_PLEASE_SELECT_ONE_COURSE_SESSION": "Please select one session",
    "MSG_THE_APPLICATION_FORM_WAS_UPDATED_SUCCESSFULLY": "The application form was updated successfully",
    "MSG_YOU_HAVE_SUCCESSFULLY_ADDED_EXTERNAL_VENDOR": "You have successfully added external vendor",
    "MSG_INPUT_ANSWER_EXCEED_LIMIT": "The answer should not be more than limit length characters.",
    "ADDED_EXTERNAL_VENDOR": "Added External vendor",
    "PICTURE_OVER_MB_PLEASE_RELOAD": "Picture over {{value}}mb, please reload."
  };
  angular
    .module('eHRD.modules.language')
    .constant('messageConstantEnUS',messageConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var httpErrorCodeConstant = {
    "102_TITLE": "ERR CONNECTION REFUSED",
    "102_CONTENT": "未知的錯誤。",

    "400_TITLE": "Bad Request",
    "400_CONTENT": "由於包含語法錯誤，當前請求無法被伺服器理解。除非進行修改，否則用戶端不應該重複提交這個請求。",

    "401_TITLE": "Unauthorized",
    "401_CONTENT": "當前請求需要使用者驗證。該響應必須包含一個適用於被請求資源的WWW-Authenticate資訊頭用以詢問使用者資訊。用戶端可以重複提交一個包含恰當的Authorization頭資訊的請求。如果當前請求已經包含了Authorization憑證，那麼401響應代表著伺服器驗證已經拒絕了那些憑證。如果401響應包含了與前一個響應相同的身分驗證詢問，且瀏覽器已經至少嘗試了一次驗證，那麼瀏覽器應當向使用者展示響應中包含的實體資訊，因為這個實體資訊中可能包含了相關診斷資訊。",

    "402_TITLE": "Payment Required",
    "402_CONTENT": "該狀態碼是為了將來可能的需求而預留的。",

    "403_TITLE": "Forbidden",
    "403_CONTENT": "伺服器已經理解請求，但是拒絕執行它。與401響應不同的是，身分驗證並不能提供任何幫助，而且這個請求也不應該被重複提交。如果這不是一個HEAD請求，而且伺服器希望能夠講清楚為何請求不能被執行，那麼就應該在實體內描述拒絕的原因。當然伺服器也可以返回一個404響應，假如它不希望讓用戶端獲得任何資訊。",

    "404_TITLE": "Not Found",
    "404_CONTENT": "請求失敗，請求所希望得到的資源未被在伺服器上發現。沒有資訊能夠告訴使用者這個狀況到底是暫時的還是永久的。假如伺服器知道情況的話，應當使用410狀態碼來告知舊資源因為某些內部的配置機制問題，已經永久的不可用，而且沒有任何可以跳轉的位址。404這個狀態碼被廣泛應用於當伺服器不想揭示到底為何請求被拒絕或者沒有其他適合的響應可用的情況下。",

    "405_TITLE": "Method Not Allowed",
    "405_CONTENT": "請求行中指定的請求方法不能被用於請求相應的資源。該響應必須返回一個Allow頭資訊用以表示出當前資源能夠接受的請求方法的列表。鑒於PUT，DELETE方法會對伺服器上的資源進行寫操作，因而絕大部分的網頁伺服器都不支援或者在預設配置下不允許上述請求方法，對於此類請求均會返回405錯誤。",

    "406_TITLE": "Not Acceptable",
    "406_CONTENT": "請求的資源的內容特性無法滿足請求頭中的條件，因而無法生成響應實體。除非這是一個HEAD請求，否則該響應就應當返回一個包含可以讓使用者或者瀏覽器從中選擇最合適的實體特性以及位址列表的實體。實體的格式由Content-Type頭中定義的媒體類型決定。瀏覽器可以根據格式及自身能力自行作出最佳選擇。但是，規範中並沒有定義任何作出此類自動選擇的標準。",

    "407_TITLE": "Proxy Authentication Required",
    "407_CONTENT": "與401響應類似，只不過用戶端必須在代理伺服器上進行身分驗證。代理伺服器必須返回一個Proxy-Authenticate用以進行身分詢問。用戶端可以返回一個Proxy-Authorization資訊頭用以驗證。",

    "408_TITLE": "Request Timeout",
    "408_CONTENT": "請求超時。用戶端沒有在伺服器預備等待的時間內完成一個請求的傳送。用戶端可以隨時再次提交這一請求而無需進行任何更改。",

    "409_TITLE": "Conflict",
    "409_CONTENT": "由於和被請求的資源的當前狀態之間存在衝突，請求無法完成。這個代碼只允許用在這樣的情況下才能被使用：使用者被認為能夠解決衝突，並且會重新提交新的請求。該響應應當包含足夠的資訊以便使用者發現衝突的源頭。衝突通常發生於對PUT請求的處理中。例如，在採用版本檢查的環境下，某次PUT提交的對特定資源的修改請求所附帶的版本資訊與之前的某個（第三方）請求向衝突，那麼此時伺服器就應該返回一個409錯誤，告知使用者請求無法完成。此時，響應實體中很可能會包含兩個衝突版本之間的差異比較，以便使用者重新提交歸併以後的新版本。",

    "410_TITLE": "Gone",
    "410_CONTENT":"被請求的資源在伺服器上已經不再可用，而且沒有任何已知的轉發位址。這樣的狀況應當被認為是永久性的。如果可能，擁有連結編輯功能的用戶端應當在獲得使用者許可後刪除所有指向這個位址的參照。如果伺服器不知道或者無法確定這個狀況是否是永久的，那麼就應該使用404狀態碼。除非額外說明，否則這個響應是可快取的。",

    "411_TITLE": "Length Required",
    "411_CONTENT":"伺服器拒絕在沒有定義Content-Length頭的情況下接受請求。在添加了表明請求訊息體長度的有效Content-Length頭之後，用戶端可以再次提交該請求。",

    "412_TITLE": "Precondition Failed",
    "412_CONTENT":"伺服器在驗證在請求的頭欄位中給出先決條件時，沒能滿足其中的一個或多個。這個狀態碼允許用戶端在取得資源時在請求的元資訊（請求頭欄位資料）中設定先決條件，以此避免該請求方法被應用到其希望的內容以外的資源上。",

    "413_TITLE": "Request Entity Too Large",
    "413_CONTENT":"伺服器拒絕處理當前請求，因為該請求提交的實體資料大小超過了伺服器願意或者能夠處理的範圍。此種情況下，伺服器可以關閉連線以免用戶端繼續傳送此請求。如果這個狀況是臨時的，伺服器應當返回一個Retry-After的響應頭，以告知用戶端可以在多少時間以後重新嘗試。",

    "414_TITLE": "Request-URI Too Long",
    "414_CONTENT":"請求的URI長度超過了伺服器能夠解釋的長度，因此伺服器拒絕對該請求提供服務",

    "415_TITLE": "Unsupported Media Type",
    "415_CONTENT":"對於當前請求的方法和所請求的資源，請求中提交的實體並不是伺服器中所支援的格式，因此請求被拒絕。",

    "416_TITLE": "Requested Range Not Satisfiable",
    "416_CONTENT":"如果請求中包含了Range請求頭，並且Range中指定的任何資料範圍都與當前資源的可用範圍不重合，同時請求中又沒有定義If-Range請求頭，那麼伺服器就應當返回416狀態碼。假如Range使用的是位元組範圍，那麼這種情況就是指請求指定的所有資料範圍的首位元組位置都超過了當前資源的長度。伺服器也應當在返回416狀態碼的同時，包含一個Content-Range實體頭，用以指明當前資源的長度。這個響應也被禁止使用multipart/byteranges作為其Content-Type。",

    "417_TITLE": "Expectation Failed",
    "417_CONTENT":"在請求頭Expect中指定的預期內容無法被伺服器滿足，或者這個伺服器是一個代理伺服器，它有明顯的證據證明在當前路由的下一個節點上，Expect的內容無法被滿足。",

    "418_TITLE": "I'm a teapot",
    "418_CONTENT":"本操作碼是在1998年作為IETF的傳統愚人節笑話, 在RFC 2324 超文字咖啡壺控制協定中定義的，並不需要在真實的HTTP伺服器中定義。當一個控制茶壺的HTCPCP收到BREW或POST指令要求其煮咖啡時應當回傳此錯誤。",

    "421_TITLE": "There are too many connections from your internet address",
    "421_CONTENT":"從當前用戶端所在的IP位址到伺服器的連線數超過了伺服器許可的最大範圍。通常，這裡的IP位址指的是從伺服器上看到的用戶端位址（比如使用者的閘道器或者代理伺服器位址）。在這種情況下，連線數的計算可能涉及到不止一個終端使用者。",

    "422_TITLE": "Unprocessable Entity",
    "422_CONTENT":"請求格式正確，但是由於含有語意錯誤，無法響應。",

    "423_TITLE": "Locked",
    "423_CONTENT":"當前資源被鎖定。",

    "424_TITLE": "Failed Dependency",
    "424_CONTENT":"由於之前的某個請求發生的錯誤，導致當前請求失敗，例如PROPPATCH。",

    "425_TITLE": "Unordered Collection",
    "425_CONTENT":"在WebDav Advanced Collections草案中定義，但是未出現在《WebDAV順序集協定》中。",

    "426_TITLE": "Upgrade Required",
    "426_CONTENT":"用戶端應當切換到TLS/1.0。",

    "449_TITLE": "Retry With",
    "449_CONTENT":"由微軟擴充功能，代表請求應當在執行完適當的操作後進行重試。",

    "451_TITLE": "Unavailable For Legal Reasons",
    "451_CONTENT":"由IETF核准，代表該存取因法律的要求而被拒絕。",


    "500_TITLE": "Internal Server Error",
    "500_CONTENT":"伺服器遇到了一個未曾預料的狀況，導致了它無法完成對請求的處理。一般來說，這個問題都會在伺服器的程式碼出錯時出現。",

    "501_TITLE": "Not Implemented",
    "501_CONTENT":"伺服器不支援當前請求所需要的某個功能。當伺服器無法識別請求的方法，並且無法支援其對任何資源的請求。",

    "502_TITLE": "Bad Gateway",
    "502_CONTENT":"作為閘道器或者代理工作的伺服器嘗試執行請求時，從上游伺服器接收到無效的響應。",

    "503_TITLE": "Service Unavailable",
    "503_CONTENT":"由於臨時的伺服器維護或者過載，伺服器當前無法處理請求。這個狀況是臨時的，並且將在一段時間以後取消復原。如果能夠預計延遲時間，那麼響應中可以包含一個Retry-After頭用以標明這個延遲時間。如果沒有給出這個Retry-After資訊，那麼用戶端應當以處理500響應的方式處理它。",

    "504_TITLE": "Gateway Timeout",
    "504_CONTENT":"作為閘道器或者代理工作的伺服器嘗試執行請求時，未能及時從上游伺服器（URI標識出的伺服器，例如HTTP、FTP、LDAP）或者輔助伺服器（例如DNS）收到響應。注意：某些代理伺服器在DNS查詢超時時會返回400或者500錯誤。",

    "505_TITLE": "HTTP Version Not Supported",
    "505_CONTENT":"伺服器不支援，或者拒絕支援在請求中使用的HTTP版本。這暗示著伺服器不能或不願使用與用戶端相同的版本。響應中應當包含一個描述了為何版本不被支援以及伺服器支援哪些協定的實體。",

    "506_TITLE": "Variant Also Negotiates",
    "506_CONTENT":"由《透明內容協商協定》擴充功能，代表伺服器存在內部配置錯誤：被請求的協商變元資源被配置為在透明內容協商中使用自己，因此在一個協商處理中不是一個合適的重點。",

    "507_TITLE": "Insufficient Storage",
    "507_CONTENT":"伺服器無法儲存完成請求所必須的內容。這個狀況被認為是臨時的。",

    "509_TITLE": "Bandwidth Limit Exceeded",
    "509_CONTENT":"伺服器達到頻寬限制。這不是一個官方的狀態碼，但是仍被廣泛使用。",

    "510_TITLE": "Not Extended",
    "510_CONTENT":"取得資源所需要的策略並沒有被滿足。"

  };
  angular
    .module('eHRD.modules.language')
    .constant('httpErrorCodeConstantEnUS',httpErrorCodeConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var formValidationConstant = {
    "THIS_IS_REQUIRED": "Required",
    "PLEASE_RE_CHECK_NEW_PASSWORD": "Please confirm the new password.",
    "PLEASE_RE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD": "Please re-enter the account and password.",
    "PLEASE_SELECT_AT_LEAST_ONE_ITEM": "Please select at least one item",
    "PLEASE_SELECT_AT_LEAST_ONE_MEMBER": "Please select at least one member",
    "PLEASE_SET_AT_LEAST_ONE_TIME_ZONE": "Please set at least one time span",
    "NUMBEROFREPORTS_ERROR_SETTING": "Number of learning reports must be between 1~100",
    "THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM": "There is no form completed, please re-confirm",
    "PLEASE_ENTER_A_VALID_URL": "Please Enter a valid url. ex：http：//example.com",
    "PLEASE_ENTER_A_VALID_DATE": "Please enter a valid date",
    "SET_THE_TIME_PART_OF_OVERLAP_PLEASE_RESET": "The setting-time part of overlap, Please Reset",
    "PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY": "Please enter a valid amount of money",
    "PLEASE_ENTER_A_VALID_EMAIL": "Please enter a valid email"

  };
  angular
    .module('eHRD.modules.language')
    .constant('formValidationConstantEnUS',formValidationConstant);

})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var actionsConstant = {
    "FINISH": "Finish",
    "CLOSE": "Close",
    "SUBMIT": "Submit",
    "ENTER": "Enter",
    "APPLY": "Apply",
    "CANCEL": "Cancel",
    "DELETE": "Delete",
    "SEARCH": "Search",
    "FILTERS": "Filter",
    "SORT": "Sort",
    "SORT_METHOD": "Sort method",
    "LOGIN": "Login",
    "LOGOUT":"Logout",
    "NEXT_STEP": "Next",
    "PREVIOUS_STEP": "Back",
    "NEXT": "Next",
    "PREV": "Back",
    "UN_ENROLL": "Cancel the enrollment",
    "EXEMPTION": "Exemption",
    "LEAVE": "Ask for leave",
    "RETURN": "Return",
    "FILL_IN": "Fill in",
    "ENROLL": "Enroll",
    "START_LEARNING": "Start to learn",
    "START_SURVEY": "Start",
    "START_TEST": "Start",
    "SELECT_ALL": "All",
    "SELECT_FILES": "Select files",
    "REPLACE_FILES": "Replace files",
    "UPLOAD_ALL": "Upload",
    "DELETE_ALL": "Delete",
    "DOWNLOAD_FILE": "Download",
    "SELECT_QUESTION_NUMBER": "Select item",
    "RE_TEST_ONCE": "Retest",
    "OPEN_LINK": "Open link",
    "ALL_ANNOUNCEMENTS": "Announce",
    "PLAY_COURSE": "Play",
    "FILL_IN_TEST_SURVEY": "Test/Fill in the survey",
    "CHANGE_LOGIN_PASSWORD": "Change the password",
    "REPLACE": "Replace",
    "READ": "Read",
    "RATING": "Rate",
    "DOWNLOAD": "Download",
    "SHOW_AVERAGE_RATING": "Display the average score",
    "HIDDEN_AVERAGE_RATING": "Hide the average score",
    "SUBMIT_RATING": "Submit",
    "FORM_VIEW": "Check",
    "VIEW_REPORT": "Check the report",
    "APPROVAL": "Approve",
    "NO_APPROVAL": "Reject",
    "APPLY_INFORMATION":"Application guidelines",
    "APPLY_ENROLLMENT": "Apply for enrollment",
    "LOGIN_AGAIN": "Login again",
    "SELECT": "Select",
    "REJECT": "Reject",
    "RESEND": "Resend",
    "EXPAND_PROFILE_DETAIL": "Expand profile detail",
    "COLLAPSE_PROFILE_DETAIL": "Collapse profile detail",
    "EDIT": "Edit",
    "VIEW": "View",
    "ADD_PERSONAL_ELECTIVE_ITEM": "Add personal elective item",
    "ADD_MANAGER_SUGGEST_ITEM": "Add manger suggest item",
    "UPDATE_ESTIMATED_COMPLETION_DATE": "Update estimated completion date",
    "UPDATE": "Update",
    "ADD_A_TIME_ZONE": "Add Time Span",
    "EDIT_A_TIME_ZONE": "Edit Time Span",
    "DELETE_A_TIME_ZONE": "Delete Time Span",
    "ADD_FILE": "Add File",
    "DELETE_FILE": "Delete File",
    "EXPAND_MORE": "Expand more",
    "COLLAPSE_MORE": "Collapse more",
    "SELECT_DEPARTMENT": "Select Dept.",
    "FORM_EDIT": "Form Edit",
    "APPLY_APPROVAL": "Apply approval",
    "CONTINUE_ENROLL": "Continue to enroll",
    "NEXT_PAGE": "Next Page",
    "PREVIOUS_PAGE": "Previous Page",
    "PRINT": "Print",
    "SEND_APPLY": "Send apply",
    "ADD_A_TIME": "Add Time",
    "DELETE_A_TIME": "Delete Time",
    "EXCERT_APPLY_BONUS": "Apply for external certification reward",
    "EXCERT_APPLY_COMPENSATION": "Apply for external certificate subsidy",
    "ADD": "Add",
    "REMOVE": "Remove",
    "SELECT_CLASS": "Select Class",
    "SELECT_COURSE": "Select Course",
    "ADD_NEW_CLASS": "Add New Class",
    "EDIT_CLASS": "Edit Class",
    "SET_REPORT_SCORE": "Set report score",
    "ADD_APPLY_MEMBER": "Add apply member",
    "GO_BACK": "go back"
  };
  angular
    .module('eHRD.modules.language')
    .constant('actionsConstantEnUS',actionsConstant);

})();

/**
 * Created by Bruce on 2016/7/1.
 */

(function () {
  'use strict';
  angular.module('eHRD.kernel.uiElements.wizard',[]);
})();

/**
 * Created by Bruce on 2016/7/13.
 */
(function () {
  'use strict';

  function wizardHandler() {
    var service = {};

    var wizards = {};

    service.defaultName = "defaultWizard";

    service.addWizard = function(name, wizard) {
      wizards[name] = wizard;
    };

    service.removeWizard = function(name) {
      delete wizards[name];
    };

    service.wizard = function(name) {
      var nameToUse = name;
      if (!name) {
        nameToUse = service.defaultName;
      }

      return wizards[nameToUse];
    };

    return service;
  }

  angular.module('eHRD.kernel.uiElements.wizard')
    .factory('WizardHandler', wizardHandler);

})();

/**
 * Created by Bruce on 2016/7/1.
 */

(function () {
  'use strict';

  function wizard() {
    var directive = {
      restrict: 'EA',
      replace: true,
      transclude: true,
      scope: {
        currentStep: '=',
        onFinish: '&',
        hideIndicators: '=',
        editMode: '=',
        name: '@'
      },
      templateUrl: function(element, attributes) {
        return attributes.template || "app/kernel/ui-elements/wizard/views/wizard.html";
      },

      //controller for wizard directive, treat this just like an angular controller
      controller: ['$scope', '$element', '$log', 'WizardHandler', '$q', function($scope, $element, $log, WizardHandler, $q) {
        //this variable allows directive to load without having to pass any step validation
        var firstRun = true;
        //creating instance of wizard, passing this as second argument allows access to functions attached to this via Service
        WizardHandler.addWizard($scope.name || WizardHandler.defaultName, this);

        $scope.$on('$destroy', function() {
          WizardHandler.removeWizard($scope.name || WizardHandler.defaultName);
        });

        //steps array where all the scopes of each step are added
        $scope.steps = [];

        var stepIdx = function(step) {
          var idx = 0;
          var res = -1;
          angular.forEach($scope.getEnabledSteps(), function(currStep) {
            if (currStep === step) {
              res = idx;
            }
            idx++;
          });
          return res;
        };

        var stepByTitle = function(titleToFind) {
          var foundStep = null;
          angular.forEach($scope.getEnabledSteps(), function(step) {
            if (step.wzTitle === titleToFind) {
              foundStep = step;
            }
          });
          return foundStep;
        };

        //access to context object for step validation
        $scope.context = {};

        //watching changes to currentStep
        $scope.$watch('currentStep', function(step) {
          //checking to make sure currentStep is truthy value
          if (!step) return;
          //setting stepTitle equal to current step title or default title
          var stepTitle = $scope.selectedStep.wzTitle;
          if ($scope.selectedStep && stepTitle !== $scope.currentStep) {
            //invoking goTo() with step title as argument
            $scope.goTo(stepByTitle($scope.currentStep));
          }

        });

        //watching steps array length and editMode value, if edit module is undefined or null the nothing is done
        //if edit mode is truthy, then all steps are marked as completed
        $scope.$watch('[editMode, steps.length]', function() {
          var editMode = $scope.editMode;
          if (angular.isUndefined(editMode) || (editMode === null)) return;

          if (editMode) {
            angular.forEach($scope.getEnabledSteps(), function(step) {
              step.completed = true;
            });
          } else {
            var completedStepsIndex = $scope.currentStepNumber() - 1;
            angular.forEach($scope.getEnabledSteps(), function(step, stepIndex) {
              if(stepIndex >= completedStepsIndex) {
                step.completed = false;
              }
            });
          }
        }, true);

        //called each time step directive is loaded
        this.addStep = function(step) {
          //pushing the scope of directive onto step array
          $scope.steps.push(step);
          //if this is first step being pushed then goTo that first step
          if ($scope.getEnabledSteps().length === 1) {
            //goTo first step
            $scope.goTo($scope.getEnabledSteps()[0]);
          }
        };

        this.context = $scope.context;

        $scope.getStepNumber = function(step) {
          return stepIdx(step) + 1;
        };

        $scope.goTo = function(step) {
          //if this is the first time the wizard is loading it bi-passes step validation
          if(firstRun){
            //deselect all steps so you can set fresh below
            unselectAll();
            $scope.selectedStep = step;
            //making sure current step is not undefined
            if (angular.isDefined($scope.currentStep)) {
              $scope.currentStep = step.wzTitle;
            }
            //setting selected step to argument passed into goTo()
            step.selected = true;
            //emit event upwards with data on goTo() invoktion
            $scope.$emit('wizard:stepChanged', {step: step, index: stepIdx(step)});
            //setting variable to false so all other step changes must pass validation
            firstRun = false;
          } else {
            //createing variables to capture current state that goTo() was invoked from and allow booleans
            var thisStep;
            //getting data for step you are transitioning out of
            if($scope.currentStepNumber() > 0){
              thisStep = $scope.currentStepNumber() - 1;
            } else if ($scope.currentStepNumber() === 0){
              thisStep = 0;
            }
            // $log.log('steps[thisStep] Data: ', $scope.getEnabledSteps()[thisStep].canexit);
            $q.all([canExitStep($scope.getEnabledSteps()[thisStep], step), canEnterStep(step)]).then(function(data) {
              if(data[0] && data[1]){
                //deselect all steps so you can set fresh below
                unselectAll();

                //$log.log('value for canExit argument: ', $scope.currentStep.canexit);
                $scope.selectedStep = step;
                //making sure current step is not undefined
                if(angular.isDefined($scope.currentStep)){
                  $scope.currentStep = step.wzTitle;
                }
                //setting selected step to argument passed into goTo()
                step.selected = true;
                //emit event upwards with data on goTo() invoktion
                $scope.$emit('wizard:stepChanged', {step: step, index: stepIdx(step)});
                //$log.log('current step number: ', $scope.currentStepNumber());
              }
            });
          }
        };

        function canEnterStep(step) {
          var defer,
            canEnter;
          //If no validation function is provided, allow the user to enter the step
          if(angular.isUndefined(step.canenter) ){
            return true;
          }
          //If canenter is a boolean value instead of a function, return the value
          if(typeof step.canenter === 'boolean'){
            return step.canenter;
          }
          //Check to see if the canenter function is a promise which needs to be returned
          canEnter = step.canenter($scope.context);
          if(angular.isFunction(canEnter.then)){
            defer = $q.defer();
            canEnter.then(function(response){
              defer.resolve(response);
            });
            return defer.promise;
          } else {
            return canEnter === true;
          }
        }

        function canExitStep(step, stepTo) {
          var defer,
            canExit;
          //Exiting the step should be allowed if no validation function was provided or if the user is moving backwards
          if(angular.isUndefined((step.canexit))  || $scope.getStepNumber(stepTo) < $scope.currentStepNumber()){
            return true;
          }
          //If canexit is a boolean value instead of a function, return the value
          if(typeof step.canexit === 'boolean'){
            return step.canexit;
          }
          //Check to see if the canexit function is a promise which needs to be returned
          canExit = step.canexit($scope.context);
          if(angular.isFunction(canExit.then)){
            defer = $q.defer();
            canExit.then(function(response){
              defer.resolve(response);
            });
            return defer.promise;
          } else {
            return canExit === true;
          }
        }

        $scope.currentStepNumber = function() {
          //retreive current step number
          return stepIdx($scope.selectedStep) + 1;
        };

        $scope.getEnabledSteps = function() {
          return $scope.steps.filter(function(step){
            return step.disabled !== 'true';
          });
        };

        //unSelect All Steps
        function unselectAll() {
          //traverse steps array and set each "selected" property to false
          angular.forEach($scope.getEnabledSteps(), function (step) {
            step.selected = false;
          });
          //set selectedStep variable to null
          $scope.selectedStep = null;
        }

        //ALL METHODS ATTACHED TO this ARE ACCESSIBLE VIA WizardHandler.wizard().methodName()

        this.currentStepTitle = function(){
          return $scope.selectedStep.wzTitle;
        };

        this.currentStepDescription = function(){
          return $scope.selectedStep.description;
        };

        this.currentStep = function(){
          return $scope.selectedStep;
        };

        this.totalStepCount = function() {
          return $scope.getEnabledSteps().length;
        }

        //Access to enabled steps from outside
        this.getEnabledSteps = function(){
          return $scope.getEnabledSteps();
        };

        //Access to current step number from outside
        this.currentStepNumber = function(){
          return $scope.currentStepNumber();
        };
        //method used for next button within step
        this.next = function(callback) {
          var enabledSteps = $scope.getEnabledSteps();
          //setting variable equal to step  you were on when next() was invoked
          var index = stepIdx($scope.selectedStep);
          //checking to see if callback is a function
          if(angular.isFunction(callback)){
            if(callback()){
              if (index === enabledSteps.length - 1) {
                this.finish();
              } else {
                //invoking goTo() with step number next in line
                $scope.goTo(enabledSteps[index + 1]);
              }
            } else {
              return;
            }
          }
          if (!callback) {
            //completed property set on scope which is used to add class/remove class from progress bar
            $scope.selectedStep.completed = true;
          }
          //checking to see if this is the last step.  If it is next behaves the same as finish()
          if (index === enabledSteps.length - 1) {
            this.finish();
          } else {
            //invoking goTo() with step number next in line
            $scope.goTo(enabledSteps[index + 1]);
          }

        };

        //used to traverse to any step, step number placed as argument
        this.goTo = function(step) {
          var enabledSteps = $scope.getEnabledSteps();
          var stepTo;
          //checking that step is a Number
          if (angular.isNumber(step)) {
            stepTo = enabledSteps[step];
          } else {
            //finding the step associated with the title entered as goTo argument
            stepTo = stepByTitle(step);
          }
          //going to step
          $scope.goTo(stepTo);
        };

        //calls finish() which calls onFinish() which is declared on an attribute and linked to controller via wizard directive.
        this.finish = function() {
          if ($scope.onFinish) {
            $scope.onFinish();
          }
        };

        this.previous = function() {
          //getting index of current step
          var index = stepIdx($scope.selectedStep);
          //ensuring you aren't trying to go back from the first step
          if (index === 0) {
            throw new Error("Can't go back. It's already in step 0");
          } else {
            //go back one step from current step
            $scope.goTo($scope.getEnabledSteps()[index - 1]);
          }
        };

        //cancel is alias for previous.
        this.cancel = function() {
          //getting index of current step
          var index = stepIdx($scope.selectedStep);
          //ensuring you aren't trying to go back from the first step
          if (index === 0) {
            throw new Error("Can't go back. It's already in step 0");
          } else {
            //go back one step from current step
            $scope.goTo($scope.getEnabledSteps()[0]);
          }
        };

        //reset
        this.reset = function(){
          //traverse steps array and set each "completed" property to false
          angular.forEach($scope.getEnabledSteps(), function (step) {
            step.completed = false;
          });
          //go to first step
          this.goTo(0);
        };
      }]
    };
    return directive;
  }


  angular.module('eHRD.kernel.uiElements.wizard')
    .directive('wizard', wizard)
  ;
})();

/**
 * Created by Bruce on 2016/7/1.
 */

(function () {
  'use strict';
  function stepFormWizard($timeout) {

    function link(scope, element){
      $timeout(function(){
        element.stepFormWizard({
          theme: element.data('style') ? element.data('style') : "circle",
          showNav: element.data('nav') ? element.data('nav') : "top",
          height: "auto",
          rtl:  false

        });
      },500);
    }
    var directive = {
      restrict: 'EA',
      link :link
    };

    return directive;
  }


  function wzStep() {
    var directive = {
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {
        wzTitle: '@',
        canenter : '=',
        canexit : '=',
        disabled: '@?wzDisabled',
        description: '@',
        wzData: '='
      },
      require: '^wizard',

      templateUrl: function(element, attributes) {
        return attributes.template || "app/kernel/ui-elements/wizard/views/step.html";
      },

      link: function($scope, $element, $attrs, wizard) {
        $scope.title = $scope.wzTitle;
          wizard.addStep($scope);
      }
    }
    return directive;
  }


  angular.module('eHRD.kernel.uiElements.wizard')
    .directive('stepFormWizard', stepFormWizard)
    .directive('wzStep', wzStep)
  ;
})();

/**
 * Created by Bruce on 2016/7/1.
 */

(function () {
  'use strict';



  function wizardButtonDirective(action) {
    angular.module('eHRD.kernel.uiElements.wizard')
      .directive(action, function() {
        return {
          restrict: 'A',
          replace: false,
          require: '^wizard',
          link: function($scope, $element, $attrs, wizard) {

            $element.on("click", function(e) {
              e.preventDefault();
              $scope.$apply(function() {
                $scope.$eval($attrs[action]);
                wizard[action.replace("wz", "").toLowerCase()]();
              });
            });
          }
        };
      });
  }
  
  wizardButtonDirective('wzNext');
  wizardButtonDirective('wzPrevious');
  wizardButtonDirective('wzFinish');
  wizardButtonDirective('wzCancel');
  wizardButtonDirective('wzReset');
})();

/**
 * Created by Bruce on 2016/6/4.
 */
(function () {
  'use strict';

  angular.isUndefinedOrNull = isUndefinedOrNull;

  angular.isDefined = isDefined;

  function isUndefinedOrNull(val) {
    return angular.isUndefined(val) || val === null;
  }

  function isDefined(val) {
    return !(angular.isUndefined(val) || val === null);
  }

  angular.module('eHRD.kernel.uiElements',[
    'eHRD.kernel.uiElements.breadcrumbs',
    'eHRD.kernel.uiElements.tree',
    'eHRD.kernel.uiElements.treeTable',
    'eHRD.kernel.uiElements.uiTable',
    'eHRD.kernel.uiElements.pagination',
    'eHRD.kernel.uiElements.timer',
    'eHRD.kernel.uiElements.angular-clock',
    'eHRD.kernel.uiElements.uiDatePicker',
    'eHRD.kernel.uiElements.uiCalendar',
    'eHRD.kernel.uiElements.media',
    'eHRD.kernel.uiElements.wizard',
    'eHRD.kernel.uiElements.cusRateIt'
  ]);

})();

/**
 * Created by Bruce on 2016/8/17.
 */

(function () {
  'use strict';

  SweetAlert.$inject = ['$rootScope', '$window', '$filter'];
  function SweetAlert($rootScope, $window, $filter) {

    var swal = $window.swal;
    var setDefaults = function () {
      swal.setDefaults({
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: $filter('translate')('ACTIONS.ENTER'),
        cancelButtonText: $filter('translate')('ACTIONS.CANCEL'),
        closeOnCancel: false,
        reverseButtons: true
      });
    };


    //public methods
    var self = {
      swal: function ( arg1, arg2, arg3 ) {
        setDefaults();
        $rootScope.$evalAsync(function(){
          if( angular.isFunction(arg2)) {
            swal( arg1 ).then(arg2, arg3);
            // swal( arg1 )
            //   .then(function(isConfirm){
            //     $rootScope.$evalAsync( function(){
            //       arg2(isConfirm);
            //     });
            //   }, arg3 );
          } else {
            swal( arg1, arg2, arg3);
          }
        });
      },
      check: function (title, text, type, successCallBack, errorCallBack, cusConfirmButtonText, cusCancelButtonText) {
        setDefaults();
        var _successCallBack = successCallBack || new function () {};
        var _errorCallBack = errorCallBack || new function () {};
        cusConfirmButtonText = cusConfirmButtonText || undefined;
        cusCancelButtonText = cusCancelButtonText || undefined;
        $rootScope.$evalAsync(function(){
          var option = {
            title: title,
            text: text,
            type: type,
            showCancelButton: true
          };
          if(angular.isDefined(cusConfirmButtonText)) option['confirmButtonText'] = cusConfirmButtonText;
          if(angular.isDefined(cusCancelButtonText)) option['cancelButtonText'] = cusCancelButtonText;
          swal(option).then(_successCallBack, _errorCallBack);
        });
      },
      timeoutAlert: function (successCallBack, errorCallBack) {
        setDefaults();
        var _successCallBack = successCallBack || new function () {};
        var _errorCallBack = errorCallBack || new function () {};
        $rootScope.$evalAsync(function(){
          var option = {
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            html: '<i class="material-icons animated tada" style="font-size: 220px; color: red;"> alarm</i>' +
            '<p>'+ $filter('translate')('MESSAGE.MSG_TIME_IS_OUT') +'</p>'
          };
          swal(option).then(_successCallBack, _errorCallBack);
        });
      },
      success: function(title, message) {
        setDefaults();
        $rootScope.$evalAsync(function(){
          swal( title, message, 'success' );
        });
      },
	 error: function(title, message) {
        setDefaults();
        $rootScope.$evalAsync(function(){
          swal( title, message, 'error' );
        });
      },
      errorRetutn: function(title, message,successCallBack) {
        setDefaults();
		var _successCallBack = successCallBack ||new function () {};
        var _errorCallBack = new function () {};
		 
		 $rootScope.$evalAsync(function(){
          var option = {
            title: title,
            text: message,
            showCancelButton: false
          };
          swal(option).then(_successCallBack, _errorCallBack);
        });
      },
      warning: function(title, message) {
        setDefaults();
        $rootScope.$evalAsync(function(){
          swal( title, message, 'warning' );
        });
      },
      info: function(title, message) {
        setDefaults();
        $rootScope.$evalAsync(function(){
          swal( title, message, 'info' );
        });
      },

      submitCheck: function (title, message, preConfirmFn, successCallBack, errorCallBack) {
        var _successCallBack = successCallBack || new function () {};
        var _errorCallBack = errorCallBack || new function () {};
        swal.queue([{
          title: title,
          type: 'info',
          text: message,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: $filter('translate')('ACTIONS.ENTER'),
          cancelButtonText: $filter('translate')('ACTIONS.CANCEL'),
          closeOnCancel: true,
          showCancelButton: true,
          reverseButtons: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
          showLoaderOnConfirm: true,
          preConfirm: preConfirmFn
        }]).then(_successCallBack, _errorCallBack);
      },

      insertErrorQueueStep: function (title, message, isHtmlMsg) {
        isHtmlMsg = isHtmlMsg || false;
        var insertQueueStep = {
          title: title,
          type: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: $filter('translate')('ACTIONS.ENTER'),
          allowEscapeKey: false,
          allowOutsideClick: false,
          text: isHtmlMsg ? '' : message,
          html: isHtmlMsg ? message : ''
        };

        swal.insertQueueStep(insertQueueStep);
      },
      insertSuccessQueueStep: function (title, message, isHtmlMsg, closeFn) {
        isHtmlMsg = isHtmlMsg || false;
        closeFn = closeFn || undefined;
        var insertQueueStep = {
          title: title,
          type: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: $filter('translate')('ACTIONS.ENTER'),
          allowEscapeKey: false,
          allowOutsideClick: false,
          text: isHtmlMsg ? '' : message,
          html: isHtmlMsg ? message : '',
          onClose: function () {
            if(angular.isFunction(closeFn)){
              closeFn();
            }
          }
        };
        swal.insertQueueStep(insertQueueStep);
      },
      submitCheckQueueStep: function (title, message, isHtmlMsg, confirmFn) {
        isHtmlMsg = isHtmlMsg || false;
        confirmFn = confirmFn || undefined;
        var insertQueueStep = {
          title: title,
          type: 'info',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: $filter('translate')('ACTIONS.ENTER'),
          cancelButtonText: $filter('translate')('ACTIONS.CANCEL'),
          closeOnCancel: true,
          showCancelButton: true,
          reverseButtons: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
          text: isHtmlMsg ? '' : message,
          html: isHtmlMsg ? message : '',
          clickConfirm: function (event) {
            if(angular.isFunction(confirmFn)){
              confirmFn(event);
            }
          }
        };
        swal.insertQueueStep(insertQueueStep);
      },

      confirmCallback: function (type, title, message, successCallBack) {
        setDefaults();
        var _successCallBack = successCallBack || new function () {};
        $rootScope.$evalAsync(function(){
          var option = {
            title: title,
            type: type,
            text: message,
            confirmButtonColor: '#3085d6',
            confirmButtonText: $filter('translate')('ACTIONS.ENTER'),
            allowOutsideClick: false
          };
          swal(option).then(_successCallBack);
        });
      }
    };

    return self;
  }
  angular.module('eHRD.kernel.uiElements')
    .factory('SweetAlert', SweetAlert);
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  trustAsResourceUrl.$inject = ['$sce'];
  function trustAsResourceUrl($sce) {
    return function(val) {
      return $sce.trustAsResourceUrl(val);
    };
  }
  angular.module('eHRD.kernel.uiElements')
    .filter('trustAsResourceUrl', trustAsResourceUrl);

})();

/**
 * Created by Bruce on 2016/11/11.
 */

(function () {
  'use strict';

  ngTargetBlank.$inject = [];
  function ngTargetBlank() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        if(attrs.ngTargetBlank === "true") {
          element.attr("target", "_blank");
        }
      }
    };
  }

  angular.module('eHRD.kernel.uiElements')
    .directive('ngTargetBlank',ngTargetBlank);

})();

/**
 * Created by Bruce on 2016/7/28.
 */

(function () {
  'use strict';

  function ngMetis($timeout){

    var directive ={
      restrict: 'A',

      link: function(scope, el/*, atts*/) {
        if(scope.$last){
          $timeout(function () {
            angular.element('.metismenu').metisMenu({
              toggle: false,
              doubleTapToGo: false,
              preventDefault: false
            });
          });
        } else{
          el.metisMenu();
        }
      }
    };
    return directive;
  }

  angular.module('eHRD.kernel.uiElements')
    .directive('ngMetis',ngMetis);

})();

/**
 * Created by Bruce on 2016/11/7.
 */
(function () {
  'use strict';


  mdPersonChips.$inject = ['$mdTheming', '$mdUtil'];
  function mdPersonChips($mdTheming, $mdUtil) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/kernel/ui-elements/widgets/views/md-person-chips-template.html',
      controller: 'MdPersonChipsController',
      controllerAs: '$mdPersonChipsCtrl',
      bindToController: true,
      compile: compile,
      scope: {
        personQuery: '&mdPersons',
        placeholder: '@',
        secondaryPlaceholder: '@',
        personName: '@mdPersonName',
        personImage: '@mdPersonImage',
        personEmail: '@mdPersonEmail',
        personGroup: '@mdPersonGroup',
        personIsGray: '@mdPersonIsGray',
        persons: '=ngModel',
        requireMatch: '=?mdRequireMatch',
        highlightFlags: '@?mdHighlightFlags',
        selectedPersons:'=selectedPersons'
      }
    };

    return directive;

    function compile(element, attr) {
      return function postLink(scope, element/*, attrs, controllers*/) {

        $mdUtil.initOptionalProperties(scope, attr);
        $mdTheming(element);

        element.attr('tabindex', '-1');
      };
    }
  }

  angular.module('eHRD.kernel.uiElements')
    .directive('mdPersonChips',mdPersonChips);

})();

/**
 * Created by Bruce on 2016/11/10.
 */
(function () {
  'use strict';

  mdCompareTo.$inject = ["$animate", "$mdUtil"];
  function mdCompareTo($animate, $mdUtil) {
    return {
      restrict: 'A',
      require: ['ngModel', '^mdInputContainer'],
      link: postLink
    };

    function postLink(scope, element, attr, ctrls) {
      var compareTo;
      var ngModelCtrl = ctrls[0];
      var containerCtrl = ctrls[1];
      var charCountEl, errorsSpacer;
// console.log(ngModelCtrl, containerCtrl, attr)
      // Wait until the next tick tos ensure that the input has setup the errors spacer where we will
      // append our counter
      $mdUtil.nextTick(function() {
        errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
        charCountEl = angular.element('<div class="md-char-counter">');

        // Append our character counter inside the errors spacer
        errorsSpacer.append(charCountEl);

        // Stop model from trimming. This makes it so whitespace
        // over the maxlength still counts as invalid.
        attr.$set('ngTrim', 'false');

        scope.$watch(attr.mdCompareTo, function(value) {
          compareTo = value;
          if (angular.equals(ngModelCtrl.$$rawModelValue,value)) {
            if (!charCountEl.parent().length) {
              $animate.enter(charCountEl, errorsSpacer);
            }
          } else {
            $animate.leave(charCountEl);
          }
        });

        ngModelCtrl.$validators['md-compare-to'] = function(modelValue) {
          return (angular.equals(modelValue, compareTo));
        };
      });
    }
  }
  angular.module('eHRD.kernel.uiElements')
    .directive('mdCompareTo',mdCompareTo);
})();

/**
 * Created by Bruce on 2016/6/4.
 */
(function () {
  'use strict';

  function themeInfoBox() {
    function link(scope, element, attrs){

      attrs.$observe('type', function(val) {
        scope.type = val;
      });

      attrs.$observe('title', function(val) {
        scope.title = val;
      });

      attrs.$observe('count', function(val) {
        scope.count = val;
      });

      attrs.$observe('iconcolor', function(val) {
        scope.iconColor = val;
      });

      attrs.$observe('icon', function(val) {
        scope.icon = val;
      });

    }

    var directive = {
      restrict: 'E',
      templateUrl: 'app/kernel/uiElements/widgets/views/infobox.html',
      link :link
    };

    return directive;
  }

  angular.module('eHRD.kernel.uiElements')
    .directive('themeInfoBox',themeInfoBox);

})();

/**
 * Created by Bruce on 2016/7/27.
 */

(function () {
  'use strict';

  function doughnutGauge() {

    function link($scope, $element, $attrs){
      $attrs.$observe('gaugeValue', function(value) {
        if (value) {
          $scope.gaugeData=[value,100-value];
        }
      });
      $scope.gaugeLabels=["Score",''];
    }
    var directive = {
      restrict: "E",
      scope:
      {
        gaugeSize: '@', //size in px
        gaugeOptions: '=',
        gaugeColors: '=',
        gaugeValue: '@', //value displayed 0-100
        valueSuffix: '@', //optional suffix, e.g. '%'
        gaugeTitle: '@', //large title under gauge
        subTitle: '@'  //smaller text under title
      },
      link: link,
      templateUrl:'app/kernel/ui-elements/widgets/views/doughnut-gauge.html'

    };

    return directive;
  }

  angular.module('eHRD.kernel.uiElements')
    .directive('doughnutGauge',doughnutGauge);

})();

/**
 * Created by Bruce on 2016/11/7.
 */
(function () {
  'use strict';

  MdPersonChipsController.$inject = ['$filter'];
  function MdPersonChipsController($filter) {
    var vm = this;
    /** @type {Object} */
    vm.selectedItem = null;

    /** @type {string} */
    vm.searchText = '';

    vm.addChipToSelectedPersons = function (chip) {
      if(!$filter('getArrayObjectByKey')(vm.selectedPersons,'userId', chip.userId)) vm.selectedPersons.push(chip);
      // if(!$filter('contains')(vm.selectedPersons, chip))vm.selectedPersons.push(chip);
    };
    vm.removeChipToSelectedPersons = function (chip) {
      var index = $filter('arrayObjectIndexOf')(vm.selectedPersons, $filter('getArrayObjectByKey')(vm.selectedPersons, 'userId', chip.userId));
      if($filter('getArrayObjectByKey')(vm.selectedPersons,'userId', chip.userId) && index > -1){
      //   var index = vm.selectedPersons.indexOf(chip);
        vm.selectedPersons.splice(index, 1);
      }
    };
  }

  MdPersonChipsController.prototype.queryPerson = function(searchText) {
    var results = this.personQuery({'$query': searchText});
    return this.filterSelected ?
      results.filter(angular.bind(this, this.filterSelectedPersons)) : results;
  };

  MdPersonChipsController.prototype.itemName = function(item) {
    return item[this.personName];
  };


  MdPersonChipsController.prototype.filterSelectedPersons = function(person) {
    return this.persons.indexOf(person) == -1;
  };


  angular.module('eHRD.kernel.uiElements')
    .controller('MdPersonChipsController',MdPersonChipsController);

})();

/**
 * Created by Bruce on 2016/11/30.
 */
(function () {
  'use strict';

  var selectDate = {
    bindings: {
      type:'@?',
      ngModel: '=ngModel',
      min: '=?min',
      max: '=?max',
      defaultValue: '=?defaultValue'
    },
    templateUrl: 'app/kernel/ui-elements/widgets/views/select-date.html',
    controller: ['$scope', function($scope){
      var vm = this;
      vm.type = angular.isUndefined(this.type) ? null : this.type;
      vm.ngModel = angular.isUndefined(this.ngModel) ? null : this.ngModel;
      vm.min = angular.isUndefined(this.min) ? null : this.min;
      vm.max = angular.isUndefined(this.max) ? null : this.max;
      vm.defaultValue = angular.isUndefined(this.defaultValue) ? null : this.defaultValue;
      $scope.$watch(function(){
        return vm.defaultValue;
      },function (newVal) {
        vm.ngModel = newVal.toString();
      });
      vm.hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      vm.minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
    }]
  };

  angular.module('eHRD.kernel.uiElements')
    .component('selectDate', selectDate);
})();

/**
 * Created by Bruce on 2016/12/16.
 */
(function () {
  'use strict';

  var mdCompanyChips = {
    bindings: {
      personQuery: '&mdPersons',
      placeholder: '@',
      secondaryPlaceholder: '@',
      personName: '@mdPersonName',
      personImage: '@mdPersonImage',
      personEmail: '@mdPersonEmail',
      personGroup: '@mdPersonGroup',
      personIsGray: '@mdPersonIsGray',
      persons: '=ngModel',
      requireMatch: '=?mdRequireMatch',
      highlightFlags: '@?mdHighlightFlags',
      selectedPersons:'=selectedPersons'
    },
    templateUrl: 'app/kernel/ui-elements/widgets/views/md-company-chips-template.html',
    controller: MdCompanyChipsController,
    controllerAs: '$mdPersonChipsCtrl'

  };

  MdCompanyChipsController.$inject = [ '$scope', '$element', '$attrs', '$log', '$filter', '$mdTheming', '$mdUtil'];
  function MdCompanyChipsController( $scope, $element, $attrs, $log, $filter, $mdTheming, $mdUtil) {
    var vm = this;

    vm.autoCompleteSelected = {};

    /** @type {Object} */
    vm.selectedItem = null;

    /** @type {string} */
    vm.searchText = '';

    vm.addChipToSelectedPersons = function (chip) {
      if(!$filter('getArrayObjectByKey')(vm.selectedPersons,'userId', chip.userId)) vm.selectedPersons.push(chip);
      vm.selectedItemChange(chip);
    };
    vm.removeChipToSelectedPersons = function (chip) {
      if($filter('getArrayObjectByKey')(vm.selectedPersons,'userId', chip.userId)){
        var index = vm.selectedPersons.indexOf(chip);
        vm.selectedPersons.splice(index, 1);
      }
      vm.autoCompleteSelected[chip.userId].checked = false;
    };

    vm.selectedItemChange = function (item) {
      if(angular.isDefined(item)){
        var chipIndex = arrayObjectIndexOf(this.persons, item);
        if(vm.autoCompleteSelected[item.userId].checked){
          if(  chipIndex === -1) {
            this.persons.push(item);
            vm.autoCompleteSelected[item.userId].checked = true;
          }
        }else{
          if(  chipIndex != -1) {
            this.persons.splice(arrayObjectIndexOf(this.persons, item), 1);
          }
        }
      }
    };

    function arrayObjectIndexOf(arr, obj){
      for(var i = 0; i < arr.length; i++){
        if(angular.equals(arr[i], obj)){
          return i;
        }
      }
      return -1;
    }

    this.$postLink = function() {
      $mdUtil.initOptionalProperties($scope, $attrs);
      $mdTheming($element);

      $element.attr('tabindex', '-1');
    };
  }


  MdCompanyChipsController.prototype.queryPerson = function(searchText) {
    var results = this.personQuery({'$query': searchText});
    return this.filterSelected ?
      results.filter(angular.bind(this, this.filterSelectedPersons)) : results;
  };

  MdCompanyChipsController.prototype.itemName = function(item) {
    return item[this.personName];
  };

  MdCompanyChipsController.prototype.filterSelectedPersons = function(person) {
    return this.persons.indexOf(person) == -1;
  };


  angular.module('eHRD.kernel.uiElements')
    .component('mdCompanyChips',mdCompanyChips);

})();

/**
 * Created by Bruce on 2016/12/2.
 * Hack By angular datePicker
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.uiDatePicker',[]);

})();

/**
 * Created by Bruce on 2016/12/2.
 */
(function () {
  'use strict';

  mFormat.$inject=[];
  function mFormat() {
    return function (m, format, tz) {
      if (!(moment.isMoment(m))) {
        return moment(m).format(format);
      }
      return tz ? moment.tz(m, tz).format(format) : m.format(format);
    };
  }
  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .filter('mFormat', mFormat);

})();

/**
 * Created by Bruce on 2016/12/2.
 * Hack By angular datePicker
 */

(function () {
  'use strict';

  datePickerUtils.$inject = [];
  function datePickerUtils() {
    var tz, firstDay;
    var createNewDate = function (year, month, day, hour, minute) {
      var utc = Date.UTC(year | 0, month | 0, day | 0, hour | 0, minute | 0);
      return tz ? moment.tz(utc, tz) : moment(utc);
    };

    return {
      getVisibleMinutes: function (m, step) {
        var year = m.year(),
          month = m.month(),
          day = m.date(),
          hour = m.hours(), pushedDate,
          offset = m.utcOffset() / 60,
          minutes = [], minute;

        for (minute = 0; minute < 60; minute += step) {
          pushedDate = createNewDate(year, month, day, hour - offset, minute);
          minutes.push(pushedDate);
        }
        return minutes;
      },
      getVisibleWeeks: function (m) {
        m = moment(m);
        var startYear = m.year(),
          startMonth = m.month();

        //Set date to the first day of the month
        m.date(1);

        //Grab day of the week
        var day = m.day();

        //Go back the required number of days to arrive at the previous week start
        m.date(firstDay - (day + (firstDay >= day ? 6 : -1)));

        var weeks = [];

        while (weeks.length < 6) {
          if ((m.year() === startYear && m.month() > startMonth) || (m.year() !== startYear && m.month() === 1)) {
            break;
          }
          if(m.month() === startMonth || moment(m).add(6, 'd').month() === startMonth)
            weeks.push(this.getDaysOfWeek(m));
          m.add(7, 'd');
        }
        return weeks;
      },
      getVisibleYears: function (d) {
        var m = moment(d),
          year = m.year();

        m.year(year - (year % 10));
        year = m.year();

        var offset = m.utcOffset() / 60,
          years = [],
          pushedDate,
          actualOffset;

        for (var i = 0; i < 12; i++) {
          pushedDate = createNewDate(year, 0, 1, 0 - offset);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, 0, 1, 0 - actualOffset);
            offset = actualOffset;
          }
          years.push(pushedDate);
          year++;
        }
        return years;
      },
      getDaysOfWeek: function (m) {
        m = m ? m : (tz ? moment.tz(tz).day(firstDay) : moment().day(firstDay));

        var year = m.year(),
          month = m.month(),
          day = m.date(),
          days = [],
          pushedDate,
          offset = m.utcOffset() / 60,
          actualOffset;

        for (var i = 0; i < 7; i++) {
          pushedDate = createNewDate(year, month, day, 0 - offset, 0, false);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, month, day, 0 - actualOffset, 0, false);
          }
          days.push(pushedDate);
          day++;
        }
        return days;
      },
      getVisibleMonths: function (m) {
        var year = m.year(),
          offset = m.utcOffset() / 60,
          months = [],
          pushedDate,
          actualOffset;

        for (var month = 0; month < 12; month++) {
          pushedDate = createNewDate(year, month, 1, 0 - offset, 0, false);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, month, 1, 0 - actualOffset, 0, false);
          }
          months.push(pushedDate);
        }
        return months;
      },
      getVisibleHours: function (m) {
        var year = m.year(),
          month = m.month(),
          day = m.date(),
          hours = [],
          hour, pushedDate, actualOffset,
          offset = m.utcOffset() / 60;

        for (hour = 0; hour < 24; hour++) {
          pushedDate = createNewDate(year, month, day, hour - offset, 0, false);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, month, day, hour - actualOffset, 0, false);
          }
          hours.push(pushedDate);
        }

        return hours;
      },
      isAfter: function (model, date) {
        return model && model.unix() >= date.unix();
      },
      isBefore: function (model, date) {
        return model.unix() <= date.unix();
      },
      isSameYear: function (model, date) {
        return model && model.year() === date.year();
      },
      isSameMonth: function (model, date) {
        return this.isSameYear(model, date) && model.month() === date.month();
      },
      isSameDay: function (model, date) {
        return this.isSameMonth(model, date) && model.date() === date.date();
      },
      isSameHour: function (model, date) {
        return this.isSameDay(model, date) && model.hours() === date.hours();
      },
      isSameMinutes: function (model, date) {
        return this.isSameHour(model, date) && model.minutes() === date.minutes();
      },
      isHasDayEvent: function (dateEvent, date) {
        return this.isSameMonth(dateEvent, date) && dateEvent.date() === date.date();
      },
      setParams: function (zone, fd) {
        tz = zone;
        firstDay = fd;
      },
      scopeSearch: function (scope, name, comparisonFn) {
        var parentScope = scope,
          nameArray = name.split('.'),
          target, i, j = nameArray.length;

        do {
          target = parentScope = parentScope.$parent;

          //Loop through provided names.
          for (i = 0; i < j; i++) {
            target = target[nameArray[i]];
            if (!target) {
              continue;
            }
          }

          //If we reached the end of the list for this scope,
          //and something was found, trigger the comparison
          //function. If the comparison function is happy, return
          //found result. Otherwise, continue to the next parent scope
          if (target && comparisonFn(target)) {
            return target;
          }

        } while (parentScope.$parent);

        return false;
      },
      findFunction: function (scope, name) {
        //Search scope ancestors for a matching function.
        return this.scopeSearch(scope, name, function (target) {
          //Property must also be a function
          return angular.isFunction(target);
        });
      },
      findParam: function (scope, name) {
        //Search scope ancestors for a matching parameter.
        return this.scopeSearch(scope, name, function () {
          //As long as the property exists, we're good
          return true;
        });
      },
      createMoment: function (m) {
        if(moment.isMoment(m)){
          if (tz) {
            return moment.tz(new Date(m._i), tz);
          } else {
            //If input is a moment, and we have no TZ info, we need to remove TZ
            //info from the moment, otherwise the newly created moment will take
            //the timezone of the input moment. The easiest way to do that is to
            //take the unix timestamp, and use that to create a new moment.
            //The new moment will use the local timezone of the user machine.
            return moment.unix(m.unix());
          }
        }else{
          return moment(m);
        }

      },
      getDate: function (scope, attrs, name) {
        var result = false;
        if (attrs[name]) {
          result = this.createMoment(attrs[name]);
          if (!result.isValid()) {
            result = this.findParam(scope, attrs[name]);
            if (result) {
              result = this.createMoment(result);
            }
          }
        }

        return result;
      },
      //Checks if an event targeted at a specific picker, via either a string name, or an array of strings.
      eventIsForPicker: function (targetIDs, pickerID) {
        function matches(id) {
          if (id instanceof RegExp) {
            return id.test(pickerID);
          }
          return id === pickerID;
        }

        if (angular.isArray(targetIDs)) {
          return targetIDs.some(matches);
        }
        return matches(targetIDs);
      }
    };
  }
  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .factory('datePickerUtils', datePickerUtils);

})();

/**
 * Created by Bruce on 2016/12/5.
 */
(function () {
  'use strict';

  uiDateRange.$inject = ['$compile', 'datePickerUtils', 'dateTimeConfig'];
  function uiDateRange($compile, datePickerUtils, dateTimeConfig) {
    function getTemplate(attrs, id, model, min, max) {
      return dateTimeConfig.template(angular.extend(attrs, {
        ngModel: model,
        minDate: min && moment.isMoment(min) ? min.format() : false,
        maxDate: max && moment.isMoment(max) ? max.format() : false
      }), id);
    }

    function randomName() {
      return 'picker' + Math.random().toString().substr(2);
    }

    return {
      scope: {
        start: '=',
        end: '='
      },
      link: function (scope, element, attrs) {
        var dateChange = null,
          pickerRangeID = element[0].id,
          pickerIDs = [randomName(), randomName()],
          createMoment = datePickerUtils.createMoment,
          eventIsForPicker = datePickerUtils.eventIsForPicker;

        scope.dateChange = function (modelName, newDate) {
          //Notify user if callback exists.
          if (dateChange) {
            dateChange(modelName, newDate);
          }
        };

        function setMax(date) {
          scope.$broadcast('pickerUpdate', pickerIDs[0], {
            maxDate: date
          });
        }

        function setMin(date) {
          scope.$broadcast('pickerUpdate', pickerIDs[1], {
            minDate: date
          });
        }

        if (pickerRangeID) {
          scope.$on('pickerUpdate', function (event, targetIDs, data) {
            if (eventIsForPicker(targetIDs, pickerRangeID)) {
              //If we received an update event, dispatch it to the inner pickers using their IDs.
              scope.$broadcast('pickerUpdate', pickerIDs, data);
            }
          });
        }

        datePickerUtils.setParams(attrs.timezone);

        scope.start = createMoment(scope.start);
        scope.end = createMoment(scope.end);

        scope.$watchGroup(['start', 'end'], function (dates) {
          //Scope data changed, update picker min/max
          setMin(dates[0]);
          setMax(dates[1]);
        });

        if (angular.isDefined(attrs.dateChange)) {
          dateChange = datePickerUtils.findFunction(scope, attrs.dateChange);
        }

        attrs.onSetDate = 'dateChange';

        var template = '<div><table class="date-range"><tr><td valign="top">' +
          getTemplate(attrs, pickerIDs[0], 'start', false, scope.end) +
          '</td><td valign="top">' +
          getTemplate(attrs, pickerIDs[1], 'end', scope.start, false) +
          '</td></tr></table></div>';

        var picker = $compile(template)(scope);
        element.append(picker);
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .directive('uiDatePicker', uiDateRange);

})();

/**
 * Created by Bruce on 2016/12/2.
 */
(function () {
  'use strict';

  uiDatePicker.$inject= ['datePickerConfig', 'datePickerUtils'];
  function uiDatePicker(datePickerConfig, datePickerUtils) {
    //noinspection JSUnusedLocalSymbols
    return {
      require: '?ngModel',
      template: '<div ng-include="template"></div>',
      scope: {
        model: '=datePicker',
        after: '=?',
        before: '=?',
        dateEvents: '=?',
        showEventLightbox: '=?showEventLightbox'
      },
      link: function (scope, element, attrs, ngModel) {

        function prepareViews() {
          scope.views = datePickerConfig.views.concat();
          scope.view = attrs.view || datePickerConfig.view;

          scope.views = scope.views.slice(
            scope.views.indexOf(attrs.maxView || 'year'),
            scope.views.indexOf(attrs.minView || 'minutes') + 1
          );

          if (scope.views.length === 1 || scope.views.indexOf(scope.view) === -1) {
            scope.view = scope.views[0];
          }
        }

        function getDate(name) {
          return datePickerUtils.getDate(scope, attrs, name);
        }

        var arrowClick = false,
            tz = scope.tz = attrs.timezone,
            createMoment = datePickerUtils.createMoment,
            eventIsForPicker = datePickerUtils.eventIsForPicker,
            step = parseInt(attrs.step || datePickerConfig.step, 10),
            partial = !!attrs.partial,
            minDate = getDate('minDate'),
            maxDate = getDate('maxDate'),
            pickerID = element[0].id,
            now = scope.now = createMoment(),
            selected = scope.date = createMoment(scope.model || now),
            autoclose = attrs.autoClose === 'true',
            // Either gets the 1st day from the attributes, or asks moment.js to give it to us as it is localized.
            firstDay = attrs.firstDay && attrs.firstDay >= 0 && attrs.firstDay <= 6 ? parseInt(attrs.firstDay, 10) : moment().weekday(0).day(),
            setDate,
            prepareViewData,
            isSame,
            clipDate,
            isNow,
            inValidRange;

        datePickerUtils.setParams(tz, firstDay);

        if (!scope.model) {
          selected.minute(Math.ceil(selected.minute() / step) * step).second(0);
        }

        scope.template = attrs.template || datePickerConfig.template;

        scope.watchDirectChanges = angular.isDefined(attrs.watchDirectChanges);
        scope.callbackOnSetDate = attrs.dateChange ? datePickerUtils.findFunction(scope, attrs.dateChange) : undefined;
        // scope.showEventLightbox = angular.isDefined(attrs.showEventLightbox) ? attrs.showEventLightbox : undefined;

        scope.showEventLightbox = angular.isDefined(scope.showEventLightbox) ? scope.showEventLightbox : false;
        prepareViews();

        scope.$watch(function () {
          return scope.dateEvents;
        },function (newVal) {
          if(angular.isDefined(newVal) && angular.isDefined(scope.weeks) && scope.weeks.length > 0){

            if(angular.isArray(scope.dateEvents) && scope.dateEvents.length > 0 ){
              prepareViewData();
            }else if(angular.isObject(scope.dateEvents) && Object.keys(scope.dateEvents).length > 0){
              prepareViewData();
            }
          }
        },true);


        scope.setView = function (nextView) {
          if (scope.views.indexOf(nextView) !== -1) {
            scope.view = nextView;
          }
        };

        scope.closeLightBox = function () {
          scope.showEvents = false;
        };

        scope.selectDate = function (date, isOnlyDay) {
          isOnlyDay = isOnlyDay || false;
          if (attrs.disabled) {
            return false;
          }
          if (isSame(scope.date, date)) {
            date = scope.date;
          }
          date = clipDate(date);
          if (!date) {
            return false;
          }
          scope.date = date;

          var nextView = scope.views[scope.views.indexOf(scope.view) + 1];
          if ((!nextView || partial) || scope.model) {
            setDate(date, isOnlyDay);
          }
          if(isOnlyDay && angular.isDefined(scope.dateEvents[date.format('YYYY-MM-DD')])){
            scope.lightBoxEvents = scope.dateEvents[date.format('YYYY-MM-DD')];
            scope.showEvents = true;
          }

          if (nextView) {
            scope.setView(nextView);
          } else if (autoclose) {
            element.addClass('hidden');
            scope.$emit('hidePicker');
          } else {
            prepareViewData();
          }
        };

        setDate = function (date, isOnlyDay) {
          isOnlyDay = isOnlyDay || false;
          if (date) {
            scope.model = date;
            if (ngModel) {
              ngModel.$setViewValue(date);
            }
          }
          scope.$emit('setDate', scope.model, scope.view);

          //This is duplicated in the new functionality.
          if (scope.callbackOnSetDate) {
            // scope.callbackOnSetDate(attrs.datePicker, scope.date, isOnlyDay);
            scope.callbackOnSetDate(scope.date, isOnlyDay);
          }
        };

        function update() {
          var view = scope.view;
          datePickerUtils.setParams(tz, firstDay);

          if (scope.model && !arrowClick) {
            scope.date = createMoment(scope.model);
            arrowClick = false;
          }

          var date = scope.date;
          switch (view) {
            case 'year':
              scope.years = datePickerUtils.getVisibleYears(date);
              break;
            case 'month':
              scope.months = datePickerUtils.getVisibleMonths(date);
              break;
            case 'date':
              scope.weekdays = scope.weekdays || datePickerUtils.getDaysOfWeek();
              scope.weeks = datePickerUtils.getVisibleWeeks(date);
              break;
            case 'hours':
              scope.hours = datePickerUtils.getVisibleHours(date);
              break;
            case 'minutes':
              scope.minutes = datePickerUtils.getVisibleMinutes(date, step);
              break;
          }

          prepareViewData();
        }

        function watch() {
          if (scope.view !== 'date') {
            return scope.view;
          }
          return scope.date ? scope.date.month() : null;
        }

        scope.$watch(watch, update);

        if (scope.watchDirectChanges) {
          scope.$watch('model', function () {
            arrowClick = false;
            update();
          });
        }

        prepareViewData = function () {
          var view = scope.view,
              date = scope.date,
              classes = [], classList = '',
              i, j;
          datePickerUtils.setParams(tz, firstDay);
          if (view === 'date') {
            var weeks = scope.weeks, week;
            for (i = 0; i < weeks.length; i++) {
              week = weeks[i];
              classes.push([]);
              for (j = 0; j < week.length; j++) {
                classList = '';
                if(week[j].isoWeekday() === 6 || week[j].isoWeekday() === 7){
                  classList += ' pt-mark';
                }

                angular.forEach(scope.dateEvents, function (dateEvent, key) {
                  if(datePickerUtils.isHasDayEvent(createMoment(angular.isArray(scope.dateEvents) ? dateEvent : key), week[j])){
                    classList += ' day-withEvent';
                  }
                });

                if (datePickerUtils.isSameDay(date, week[j])) {
                  classList += ' active';
                }
                if (isNow(week[j], view)) {
                  classList += ' now';
                }

                //if (week[j].month() !== date.month()) classList += ' disabled';
                if (week[j].month() !== date.month() || !inValidRange(week[j])) {
                  classList += ' disable';
                }
                classes[i].push(classList);
              }
            }
          } else {
            var params = datePickerConfig.viewConfig[view],
              dates = scope[params[0]],
              compareFunc = params[1];

            for (i = 0; i < dates.length; i++) {
              classList = '';
              if (datePickerUtils[compareFunc](date, dates[i])) {
                classList += 'active';
              }
              if (isNow(dates[i], view)) {
                classList += ' now';
              }
              if (!inValidRange(dates[i])) {
                classList += ' disable';
              }
              classes.push(classList);
            }
          }
          scope.classes = classes;
        };

        scope.next = function (delta) {
          var date = moment(scope.date);
          delta = delta || 1;
          switch (scope.view) {
            case 'year':
            /*falls through*/
            case 'month':
              date.year(date.year() + delta);
              break;
            case 'date':
              date.month(date.month() + delta);
              break;
            case 'hours':
            /*falls through*/
            case 'minutes':
              date.hours(date.hours() + delta);
              break;
          }
          date = clipDate(date);
          if (date) {
            scope.date = date;
            arrowClick = true;
            update();
            setDate(date);
          }
        };

        inValidRange = function (date) {
          var valid = true;
          if (minDate && minDate.isAfter(date)) {
            valid = isSame(minDate, date);
          }
          if (maxDate && maxDate.isBefore(date)) {
            valid &= isSame(maxDate, date);
          }
          return valid;
        };

        isSame = function (date1, date2) {
          return date1.isSame(date2, datePickerConfig.momentNames[scope.view]) ? true : false;
        };

        clipDate = function (date) {
          if (minDate && minDate.isAfter(date)) {
            return minDate;
          } else if (maxDate && maxDate.isBefore(date)) {
            return maxDate;
          } else {
            return date;
          }
        };

        isNow = function (date, view) {
          var is = true;

          switch (view) {
            case 'minutes':
              is &= ~~(now.minutes() / step) === ~~(date.minutes() / step);
            /* falls through */
            case 'hours':
              is &= now.hours() === date.hours();
            /* falls through */
            case 'date':
              is &= now.date() === date.date();
            /* falls through */
            case 'month':
              is &= now.month() === date.month();
            /* falls through */
            case 'year':
              is &= now.year() === date.year();
          }
          return is;
        };

        scope.prev = function (delta) {
          return scope.next(-delta || -1);
        };

        if (pickerID) {
          scope.$on('pickerUpdate', function (event, pickerIDs, data) {
            if (eventIsForPicker(pickerIDs, pickerID)) {
              var updateViews = false, updateViewData = false;

              if (angular.isDefined(data.minDate)) {
                minDate = data.minDate ? data.minDate : false;
                updateViewData = true;
              }
              if (angular.isDefined(data.maxDate)) {
                maxDate = data.maxDate ? data.maxDate : false;
                updateViewData = true;
              }

              if (angular.isDefined(data.minView)) {
                attrs.minView = data.minView;
                updateViews = true;
              }
              if (angular.isDefined(data.maxView)) {
                attrs.maxView = data.maxView;
                updateViews = true;
              }
              attrs.view = data.view || attrs.view;

              if (updateViews) {
                prepareViews();
              }

              if (updateViewData) {
                update();
              }
            }
          });
        }
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .directive('datePicker', uiDatePicker);

})();

/**
 * Created by Bruce on 2016/12/5.
 */
(function () {
  'use strict';

  uiDateTime.$inject = ['$compile', '$document', '$filter', 'dateTimeConfig', '$parse', 'datePickerUtils'];
  function uiDateTime($compile, $document, $filter, dateTimeConfig, $parse, datePickerUtils) {
    var PRISTINE_CLASS = 'ng-pristine',
        DIRTY_CLASS = 'ng-dirty';
    var body = $document.find('body');
    var dateFilter = $filter('mFormat');
    return {
      require: 'ngModel',
      scope: true,
      link: function (scope, element, attrs, ngModel) {
        var format = attrs.format || dateTimeConfig.format,
          parentForm = element.inheritedData('$formController'),
          views = $parse(attrs.views)(scope) || dateTimeConfig.views.concat(),
          view = attrs.view || views[0],
          index = views.indexOf(view),
          dismiss = attrs.autoClose ? $parse(attrs.autoClose)(scope) : dateTimeConfig.autoClose,
          picker = null,
          pickerID = element[0].id,
          position = attrs.position || dateTimeConfig.position,
          container = null,
          minDate = null,
          minValid = null,
          maxDate = null,
          maxValid = null,
          timezone = attrs.timezone || false,
          eventIsForPicker = datePickerUtils.eventIsForPicker,
          dateChange = null,
          shownOnce = false,
          template;

        if (index === -1) {
          views.splice(index, 1);
        }

        views.unshift(view);

        function formatter(value) {
          if (value) {
            return dateFilter(value, format, timezone);
          }
        }

        function parser(viewValue) {
          if (!viewValue) {
            return '';
          }
          var parsed = moment(viewValue, format);
          if (parsed.isValid()) {
            return parsed;
          }
        }

        function setMin(date) {
          minDate = date;
          attrs.minDate = date ? date.format() : date;
          minValid = moment.isMoment(date);
        }

        function setMax(date) {
          maxDate = date;
          attrs.maxDate = date ? date.format() : date;
          maxValid = moment.isMoment(date);
        }

        ngModel.$formatters.push(formatter);
        ngModel.$parsers.unshift(parser);

        if (angular.isDefined(attrs.minDate)) {
          setMin(datePickerUtils.findParam(scope, attrs.minDate));

          ngModel.$validators.min = function (value) {
            //If we don't have a min / max value, then any value is valid.
            return minValid ? moment.isMoment(value) && (minDate.isSame(value) || minDate.isBefore(value)) : true;
          };
        }

        if (angular.isDefined(attrs.maxDate)) {
          setMax(datePickerUtils.findParam(scope, attrs.maxDate));

          ngModel.$validators.max = function (value) {
            return maxValid ? moment.isMoment(value) && (maxDate.isSame(value) || maxDate.isAfter(value)) : true;
          };
        }

        if (angular.isDefined(attrs.dateChange)) {
          dateChange = datePickerUtils.findFunction(scope, attrs.dateChange);
        }

        function getTemplate() {
          template = dateTimeConfig.template(attrs);
        }


        function updateInput(event) {
          event.stopPropagation();
          if (ngModel.$pristine) {
            ngModel.$dirty = true;
            ngModel.$pristine = false;
            element.removeClass(PRISTINE_CLASS).addClass(DIRTY_CLASS);
            if (parentForm) {
              parentForm.$setDirty();
            }
            ngModel.$render();
          }
        }

        function clear() {
          if (picker) {
            picker.remove();
            picker = null;
          }
          if (container) {
            container.remove();
            container = null;
          }
        }

        if (pickerID) {
          scope.$on('pickerUpdate', function (event, pickerIDs, data) {
            if (eventIsForPicker(pickerIDs, pickerID)) {
              if (picker) {
                //Need to handle situation where the data changed but the picker is currently open.
                //To handle this, we can create the inner picker with a random ID, then forward
                //any events received to it.
              } else {
                var validateRequired = false;
                if (angular.isDefined(data.minDate)) {
                  setMin(data.minDate);
                  validateRequired = true;
                }
                if (angular.isDefined(data.maxDate)) {
                  setMax(data.maxDate);
                  validateRequired = true;
                }

                if (angular.isDefined(data.minView)) {
                  attrs.minView = data.minView;
                }
                if (angular.isDefined(data.maxView)) {
                  attrs.maxView = data.maxView;
                }
                attrs.view = data.view || attrs.view;

                if (validateRequired) {
                  ngModel.$validate();
                }
                if (angular.isDefined(data.format)) {
                  format = attrs.format = data.format || dateTimeConfig.format;
                  ngModel.$modelValue = -1; //Triggers formatters. This value will be discarded.
                }
                getTemplate();
              }
            }
          });
        }

        function showPicker() {
          if (picker) {
            return;
          }
          // create picker element
          picker = $compile(template)(scope);
          scope.$digest();

          //If the picker has already been shown before then we shouldn't be binding to events, as these events are already bound to in this scope.
          if (!shownOnce) {
            scope.$on('setDate', function (event, date, view) {
              updateInput(event);
              if (dateChange) {
                dateChange(attrs.ngModel, date);
              }
              if (dismiss && views[views.length - 1] === view) {
                clear();
              }
            });

            scope.$on('hidePicker', function () {
              element[0].blur();
            });

            scope.$on('$destroy', clear);

            shownOnce = true;
          }


          // move picker below input element

          if (position === 'absolute') {
            var pos = element[0].getBoundingClientRect();
            // Support IE8
            var height = pos.height || element[0].offsetHeight;
            picker.css({top: (pos.top + height) + 'px', left: pos.left + 'px', display: 'block', position: position});
            body.append(picker);
          } else {
            // relative
            container = angular.element('<div date-picker-wrapper></div>');
            element[0].parentElement.insertBefore(container[0], element[0]);
            container.append(picker);
            //          this approach doesn't work
            //          element.before(picker);
            picker.css({top: element[0].offsetHeight + 'px', display: 'block'});
          }
          picker.bind('mousedown', function (evt) {
            evt.preventDefault();
          });
        }

        element.bind('focus', showPicker);
        element.bind('blur', clear);
        getTemplate();
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .directive('uiDateTime', uiDateTime);

})();

/**
 * Created by Bruce on 2016/12/5.
 */
(function () {
  'use strict';

  uiDateTimeAppend.$inject = [];
  function uiDateTimeAppend() {
    return {
      link: function (scope, element) {
        element.bind('click', function () {
          element.find('input')[0].focus();
        });
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .directive('uiDateTimeAppend', uiDateTimeAppend);

})();

/**
 * Created by Bruce on 2016/12/2.
 * Hack By angular datePicker
 */

(function () {
  'use strict';

  var datePickerConfig = {
    template: 'app/kernel/ui-elements/ui-datepicker/views/datepicker.html',
    view: 'month',
    views: ['year', 'month', 'date', 'hours', 'minutes'],
    momentNames: {
      year: 'year',
      month: 'month',
      date: 'day',
      hours: 'hours',
      minutes: 'minutes'
    },
    viewConfig: {
      year: ['years', 'isSameYear'],
      month: ['months', 'isSameMonth'],
      hours: ['hours', 'isSameHour'],
      minutes: ['minutes', 'isSameMinutes']
    },
    step: 5
  };

  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .constant('datePickerConfig', datePickerConfig);
})();

/**
 * Created by Bruce on 2016/12/2.
 * Hack By angular datePicker
 */

(function () {
  'use strict';

  var dateTimeConfig = {
    template: function (attrs, id) {
      return '' +
        '<div ' +
        (id ? 'id="' + id + '" ' : '') +
        'date-picker="' + attrs.ngModel + '" ' +
        (attrs.view ? 'view="' + attrs.view + '" ' : '') +
        (attrs.maxView ? 'max-view="' + attrs.maxView + '" ' : '') +
        (attrs.maxDate ? 'max-date="' + attrs.maxDate + '" ' : '') +
        (attrs.autoClose ? 'auto-close="' + attrs.autoClose + '" ' : '') +
        (attrs.template ? 'template="' + attrs.template + '" ' : '') +
        (attrs.minView ? 'min-view="' + attrs.minView + '" ' : '') +
        (attrs.minDate ? 'min-date="' + attrs.minDate + '" ' : '') +
        (attrs.partial ? 'partial="' + attrs.partial + '" ' : '') +
        (attrs.step ? 'step="' + attrs.step + '" ' : '') +
        (attrs.onSetDate ? 'date-change="' + attrs.onSetDate + '" ' : '') +
        (attrs.ngModel ? 'ng-model="' + attrs.ngModel + '" ' : '') +
        (attrs.firstDay ? 'first-day="' + attrs.firstDay + '" ' : '') +
        (attrs.timezone ? 'timezone="' + attrs.timezone + '" ' : '') +
        'class="date-picker-date-time"></div>';
    },
    format: 'YYYY-MM-DD HH:mm',
    views: ['date', 'year', 'month', 'hours', 'minutes'],
    autoClose: false,
    position: 'relative'
  };

  angular.module('eHRD.kernel.uiElements.uiDatePicker')
    .constant('dateTimeConfig', dateTimeConfig);
})();

/**
 * Created by Bruce on 2016/12/6.
 * Hack By angular bootstrap calendar
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.uiCalendar',[]);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  dateFns.$inject = [];
  function dateFns() {
    var MILLISECONDS_IN_HOUR = 3600000;
    var MILLISECONDS_IN_MINUTE = 60000;
    var DEFAULT_ADDITIONAL_DIGITS = 2;
    var parseTokenDateTimeDelimeter = /[T ]/;
    var parseTokenPlainTime = /:/;
    var parseTokenYY = /^(\d{2})$/;
    var parseTokensYYY = [
      /^([+-]\d{2})$/,
      /^([+-]\d{3})$/,
      /^([+-]\d{4})$/
    ];
    var parseTokenYYYY = /^(\d{4})/;
    var parseTokensYYYYY = [
      /^([+-]\d{4})/,
      /^([+-]\d{5})/,
      /^([+-]\d{6})/
    ];
    var parseTokenMM = /^-(\d{2})$/;
    var parseTokenDDD = /^-?(\d{3})$/;
    var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
    var parseTokenWww = /^-?W(\d{2})$/;
    var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;
    var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
    var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
    var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;
    var parseTokenTimezone = /([Z+-].*)$/;
    var parseTokenTimezoneZ = /^(Z)$/;
    var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
    var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;

    var enLocale = function () {
      distanceInWords= buildDistanceInWordsLocale;
      format= buildFormatLocale;
    };

    function buildDistanceInWordsLocale() {
      var distanceInWordsLocale = {
        lessThanXSeconds: {
          one: 'less than a second',
          other: 'less than {{count}} seconds'
        },
        xSeconds: {
          one: '1 second',
          other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
          one: 'less than a minute',
          other: 'less than {{count}} minutes'
        },
        xMinutes: {
          one: '1 minute',
          other: '{{count}} minutes'
        },
        aboutXHours: {
          one: 'about 1 hour',
          other: 'about {{count}} hours'
        },
        xHours: {
          one: '1 hour',
          other: '{{count}} hours'
        },
        xDays: {
          one: '1 day',
          other: '{{count}} days'
        },
        aboutXMonths: {
          one: 'about 1 month',
          other: 'about {{count}} months'
        },
        xMonths: {
          one: '1 month',
          other: '{{count}} months'
        },
        aboutXYears: {
          one: 'about 1 year',
          other: 'about {{count}} years'
        },
        xYears: {
          one: '1 year',
          other: '{{count}} years'
        },
        overXYears: {
          one: 'over 1 year',
          other: 'over {{count}} years'
        },
        almostXYears: {
          one: 'almost 1 year',
          other: 'almost {{count}} years'
        }
      };
      function localize(token, count, options) {
        options = options || {};
        var result;
        if (angular.isString(distanceInWordsLocale[token])) {
          result = distanceInWordsLocale[token];
        } else if (count === 1) {
          result = distanceInWordsLocale[token].one;
        } else {
          result = distanceInWordsLocale[token].other.replace('{{count}}', count);
        }
        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'in ' + result;
          } else {
            return result + ' ago';
          }
        }
        return result;
      }
      return { localize: localize };
    }
    function buildFormatLocale() {
      var months3char = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ];
      var monthsFull = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
      var weekdays2char = [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
      ];
      var weekdays3char = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
      ];
      var weekdaysFull = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ];
      var meridiemUppercase = [
        'AM',
        'PM'
      ];
      var meridiemLowercase = [
        'am',
        'pm'
      ];
      var meridiemFull = [
        'a.m.',
        'p.m.'
      ];
      var formatters = {
        'MMM': function (date) {
          return months3char[date.getMonth()];
        },
        'MMMM': function (date) {
          return monthsFull[date.getMonth()];
        },
        'dd': function (date) {
          return weekdays2char[date.getDay()];
        },
        'ddd': function (date) {
          return weekdays3char[date.getDay()];
        },
        'dddd': function (date) {
          return weekdaysFull[date.getDay()];
        },
        'A': function (date) {
          return date.getHours() / 12 >= 1 ? meridiemUppercase[1] : meridiemUppercase[0];
        },
        'a': function (date) {
          return date.getHours() / 12 >= 1 ? meridiemLowercase[1] : meridiemLowercase[0];
        },
        'aa': function (date) {
          return date.getHours() / 12 >= 1 ? meridiemFull[1] : meridiemFull[0];
        }
      };
      var ordinalFormatters = [
        'M',
        'D',
        'DDD',
        'd',
        'Q',
        'W'
      ];
      ordinalFormatters.forEach(function (formatterToken) {
        formatters[formatterToken + 'o'] = function (date, formatters) {
          return ordinal(formatters[formatterToken](date));
        };
      });
      return {
        formatters: formatters,
        formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
      };
    }
    function ordinal(number) {
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + 'st';
          case 2:
            return number + 'nd';
          case 3:
            return number + 'rd';
        }
      }
      return number + 'th';
    }

    function buildFormattingTokensRegExp(formatters) {
      var commonFormatterKeys = [
        'M',
        'MM',
        'Q',
        'D',
        'DD',
        'DDD',
        'DDDD',
        'd',
        'E',
        'W',
        'WW',
        'YY',
        'YYYY',
        'GG',
        'GGGG',
        'H',
        'HH',
        'h',
        'hh',
        'm',
        'mm',
        's',
        'ss',
        'S',
        'SS',
        'SSS',
        'Z',
        'ZZ',
        'X',
        'x'
      ];
      var formattingTokens = commonFormatterKeys.concat(Object.keys(formatters)).sort().reverse();
      var formattingTokensRegExp = new RegExp('(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g');
      return formattingTokensRegExp;
    }

    function parse(dateString, options) {
      if (isDate(dateString)) {
        return new Date(dateString.getTime());
      } else if (!angular.isString(dateString)) {
        return new Date(dateString);
      }
      options = options || {};
      var additionalDigits = options.additionalDigits;
      if (additionalDigits == null) {
        additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
      }
      var dateStrings = splitDateString(dateString);
      var parseYearResult = parseYear(dateStrings.date, additionalDigits);
      var year = parseYearResult.year;
      var restDateString = parseYearResult.restDateString;
      var date = parseDate(restDateString, year);
      if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
          time = parseTime(dateStrings.time);
        }
        if (dateStrings.timezone) {
          offset = parseTimezone(dateStrings.timezone);
        } else {
          offset = new Date(timestamp + time).getTimezoneOffset();
          offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
        }
        return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE);
      } else {
        return new Date(dateString);
      }
    }
    function splitDateString(dateString) {
      var dateStrings = {};
      var array = dateString.split(parseTokenDateTimeDelimeter);
      var timeString;
      if (parseTokenPlainTime.test(array[0])) {
        dateStrings.date = null;
        timeString = array[0];
      } else {
        dateStrings.date = array[0];
        timeString = array[1];
      }
      if (timeString) {
        var token = parseTokenTimezone.exec(timeString);
        if (token) {
          dateStrings.time = timeString.replace(token[1], '');
          dateStrings.timezone = token[1];
        } else {
          dateStrings.time = timeString;
        }
      }
      return dateStrings;
    }
    function parseYear(dateString, additionalDigits) {
      var parseTokenYYY = parseTokensYYY[additionalDigits];
      var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];
      var token;
      token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
      if (token) {
        var yearString = token[1];
        return {
          year: parseInt(yearString, 10),
          restDateString: dateString.slice(yearString.length)
        };
      }
      token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
      if (token) {
        var centuryString = token[1];
        return {
          year: parseInt(centuryString, 10) * 100,
          restDateString: dateString.slice(centuryString.length)
        };
      }
      return { year: null };
    }
    function parseDate(dateString, year) {
      if (year === null) {
        return null;
      }
      var token;
      var date;
      var month;
      var week;
      if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
      }
      token = parseTokenMM.exec(dateString);
      if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        date.setUTCFullYear(year, month);
        return date;
      }
      token = parseTokenDDD.exec(dateString);
      if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
      }
      token = parseTokenMMDD.exec(dateString);
      if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        date.setUTCFullYear(year, month, day);
        return date;
      }
      token = parseTokenWww.exec(dateString);
      if (token) {
        week = parseInt(token[1], 10) - 1;
        return dayOfISOYear(year, week);
      }
      token = parseTokenWwwD.exec(dateString);
      if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        return dayOfISOYear(year, week, dayOfWeek);
      }
      return null;
    }
    function parseTime(timeString) {
      var token;
      var hours;
      var minutes;
      token = parseTokenHH.exec(timeString);
      if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        return hours % 24 * MILLISECONDS_IN_HOUR;
      }
      token = parseTokenHHMM.exec(timeString);
      if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
      }
      token = parseTokenHHMMSS.exec(timeString);
      if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
      }
      return null;
    }
    function parseTimezone(timezoneString) {
      var token;
      var absoluteOffset;
      token = parseTokenTimezoneZ.exec(timezoneString);
      if (token) {
        return 0;
      }
      token = parseTokenTimezoneHH.exec(timezoneString);
      if (token) {
        absoluteOffset = parseInt(token[2], 10) * 60;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
      }
      token = parseTokenTimezoneHHMM.exec(timezoneString);
      if (token) {
        absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
      }
      return 0;
    }
    function dayOfISOYear(isoYear, week, day) {
      week = week || 0;
      day = day || 0;
      var date = new Date(0);
      date.setUTCFullYear(isoYear, 0, 4);
      var fourthOfJanuaryDay = date.getUTCDay() || 7;
      var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
      date.setUTCDate(date.getUTCDate() + diff);
      return date;
    }

    function endOfWeek(dirtyDate, options) {
      var weekStartsOn = options ? options.weekStartsOn || 0 : 0;
      var date = parse(dirtyDate);
      var day = date.getDay();
      var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
      date.setDate(date.getDate() + diff);
      date.setHours(23, 59, 59, 999);
      return date;
    }

    function endOfMonth(dirtyDate) {
      var date = parse(dirtyDate);
      var month = date.getMonth();
      date.setFullYear(date.getFullYear(), month + 1, 0);
      date.setHours(23, 59, 59, 999);
      return date;
    }

    function differenceInDays(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      var sign = compareAsc(dateLeft, dateRight);
      var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
      dateLeft.setDate(dateLeft.getDate() - sign * difference);
      var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign;
      return sign * (difference - isLastDayNotFull);
    }

    function addDays(dirtyDate, amount) {
      var date = parse(dirtyDate);
      date.setDate(date.getDate() + amount);
      return date;
    }

    function addHours(dirtyDate, amount) {
      var date = parse(dirtyDate);
      date.setHours(date.getHours() + amount);
      return date;
    }

    function addISOYears(dirtyDate, amount) {
      return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount);
    }

    function addMilliseconds(dirtyDate, amount) {
      var date = parse(dirtyDate);
      date.setMilliseconds(date.getMilliseconds() + amount);
      return date;
    }

    function addMinutes(dirtyDate, amount) {
      var date = parse(dirtyDate);
      date.setMinutes(date.getMinutes() + amount);
      return date;
    }

    function addMonths(dirtyDate, amount) {
      var date = parse(dirtyDate);
      var desiredMonth = date.getMonth() + amount;
      var dateWithDesiredMonth = new Date(0);
      dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
      dateWithDesiredMonth.setHours(0, 0, 0, 0);
      var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
      date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
      return date;
    }

    function addQuarters(dirtyDate, amount) {
      var months = amount * 3;
      return addMonths(dirtyDate, months);
    }

    function addSeconds(dirtyDate, amount) {
      var date = parse(dirtyDate);
      date.setSeconds(date.getSeconds() + amount);
      return date;
    }

    function addWeeks(dirtyDate, amount) {
      var days = amount * 7;
      return addDays(dirtyDate, days);
    }

    function addYears(dirtyDate, amount) {
      return addMonths(dirtyDate, amount * 12);
    }

    function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
      if (!(dirtyDatesArray instanceof Array)) {
        throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array');
      }
      var dateToCompare = parse(dirtyDateToCompare);
      var timeToCompare = dateToCompare.getTime();
      var result;
      var minDistance;
      dirtyDatesArray.forEach(function (dirtyDate, index) {
        var currentDate = parse(dirtyDate);
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (angular.isUndefined(result) || distance < minDistance) {
          result = index;
          minDistance = distance;
        }
      });
      return result;
    }

    function closestTo(dirtyDateToCompare, dirtyDatesArray) {
      if (!(dirtyDatesArray instanceof Array)) {
        throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array');
      }
      var dateToCompare = parse(dirtyDateToCompare);
      var timeToCompare = dateToCompare.getTime();
      var result;
      var minDistance;
      dirtyDatesArray.forEach(function (dirtyDate) {
        var currentDate = parse(dirtyDate);
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (angular.isUndefined(result) || distance < minDistance) {
          result = currentDate;
          minDistance = distance;
        }
      });
      return result;
    }

    function compareAsc(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var timeLeft = dateLeft.getTime();
      var dateRight = parse(dirtyDateRight);
      var timeRight = dateRight.getTime();
      if (timeLeft < timeRight) {
        return -1;
      } else if (timeLeft > timeRight) {
        return 1;
      } else {
        return 0;
      }
    }

    function compareDesc(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var timeLeft = dateLeft.getTime();
      var dateRight = parse(dirtyDateRight);
      var timeRight = dateRight.getTime();
      if (timeLeft > timeRight) {
        return -1;
      } else if (timeLeft < timeRight) {
        return 1;
      } else {
        return 0;
      }
    }


    function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
      var MILLISECONDS_IN_MINUTE = 60000;
      var MILLISECONDS_IN_DAY = 86400000;
      var startOfDayLeft = startOfDay(dirtyDateLeft);
      var startOfDayRight = startOfDay(dirtyDateRight);
      var timestampLeft = startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
      var timestampRight = startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
      return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
    }

    function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
      var MILLISECONDS_IN_MINUTE = 60000;
      var MILLISECONDS_IN_WEEK = 604800000;
      var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft);
      var startOfISOWeekRight = startOfISOWeek(dirtyDateRight);
      var timestampLeft = startOfISOWeekLeft.getTime() - startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
      var timestampRight = startOfISOWeekRight.getTime() - startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
      return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
    }

    function differenceInCalendarISOYears(dirtyDateLeft, dirtyDateRight) {
      return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight);
    }

    function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
      var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
      return yearDiff * 12 + monthDiff;
    }

    function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
      var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight);
      return yearDiff * 4 + quarterDiff;
    }

    function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
      var MILLISECONDS_IN_MINUTE = 60000;
      var MILLISECONDS_IN_WEEK = 604800000;
      var startOfWeekLeft = startOfWeek(dirtyDateLeft, options);
      var startOfWeekRight = startOfWeek(dirtyDateRight, options);
      var timestampLeft = startOfWeekLeft.getTime() - startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
      var timestampRight = startOfWeekRight.getTime() - startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
      return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
    }

    function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      return dateLeft.getFullYear() - dateRight.getFullYear();
    }

    function differenceInHours(dirtyDateLeft, dirtyDateRight) {
      var MILLISECONDS_IN_HOUR = 3600000;
      var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
      return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
    }

    function differenceInISOYears(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      var sign = compareAsc(dateLeft, dateRight);
      var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight));
      dateLeft = subISOYears(dateLeft, sign * difference);
      var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
      return sign * (difference - isLastISOYearNotFull);
    }

    function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      return dateLeft.getTime() - dateRight.getTime();
    }

    function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
      var MILLISECONDS_IN_MINUTE = 60000;
      var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE;
      return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
    }

    function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      var sign = compareAsc(dateLeft, dateRight);
      var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
      dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
      var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;
      return sign * (difference - isLastMonthNotFull);
    }

    function differenceInQuarters(dirtyDateLeft, dirtyDateRight) {
      var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3;
      return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
    }

    function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
      var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000;
      return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
    }

    function differenceInWeeks(dirtyDateLeft, dirtyDateRight) {
      var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7;
      return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
    }

    function differenceInYears(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      var sign = compareAsc(dateLeft, dateRight);
      var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
      dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference);
      var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
      return sign * (difference - isLastYearNotFull);
    }

    var distanceInWords = function (dirtyDateToCompare, dirtyDate, options) {
      var MINUTES_IN_DAY = 1440;
      var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
      var MINUTES_IN_MONTH = 43200;
      var MINUTES_IN_TWO_MONTHS = 86400;
      options = options || {};
      var comparison = compareDesc(dirtyDateToCompare, dirtyDate);
      var locale = options.locale || enLocale;
      var localize = locale.distanceInWords.localize;
      var localizeOptions = {
        addSuffix: options.addSuffix,
        comparison: comparison
      };
      var dateLeft, dateRight;
      if (comparison > 0) {
        dateLeft = parse(dirtyDateToCompare);
        dateRight = parse(dirtyDate);
      } else {
        dateLeft = parse(dirtyDate);
        dateRight = parse(dirtyDateToCompare);
      }
      var seconds = differenceInSeconds(dateRight, dateLeft);
      var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset();
      var minutes = Math.round(seconds / 60) - offset;
      var months;
      if (minutes < 2) {
        if (options.includeSeconds) {
          if (seconds < 5) {
            return localize('lessThanXSeconds', 5, localizeOptions);
          } else if (seconds < 10) {
            return localize('lessThanXSeconds', 10, localizeOptions);
          } else if (seconds < 20) {
            return localize('lessThanXSeconds', 20, localizeOptions);
          } else if (seconds < 40) {
            return localize('halfAMinute', null, localizeOptions);
          } else if (seconds < 60) {
            return localize('lessThanXMinutes', 1, localizeOptions);
          } else {
            return localize('xMinutes', 1, localizeOptions);
          }
        } else {
          if (minutes === 0) {
            return localize('lessThanXMinutes', 1, localizeOptions);
          } else {
            return localize('xMinutes', minutes, localizeOptions);
          }
        }
      } else if (minutes < 45) {
        return localize('xMinutes', minutes, localizeOptions);
      } else if (minutes < 90) {
        return localize('aboutXHours', 1, localizeOptions);
      } else if (minutes < MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return localize('aboutXHours', hours, localizeOptions);
      } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
        return localize('xDays', 1, localizeOptions);
      } else if (minutes < MINUTES_IN_MONTH) {
        var days = Math.round(minutes / MINUTES_IN_DAY);
        return localize('xDays', days, localizeOptions);
      } else if (minutes < MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / MINUTES_IN_MONTH);
        return localize('aboutXMonths', months, localizeOptions);
      }
      months = differenceInMonths(dateRight, dateLeft);
      if (months < 12) {
        var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
        return localize('xMonths', nearestMonth, localizeOptions);
      } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        if (monthsSinceStartOfYear < 3) {
          return localize('aboutXYears', years, localizeOptions);
        } else if (monthsSinceStartOfYear < 9) {
          return localize('overXYears', years, localizeOptions);
        } else {
          return localize('almostXYears', years + 1, localizeOptions);
        }
      }
    };

    function distanceInWordsStrict(dirtyDateToCompare, dirtyDate, options) {
      var MINUTES_IN_DAY = 1440;
      var MINUTES_IN_MONTH = 43200;
      var MINUTES_IN_YEAR = 525600;
      options = options || {};
      var comparison = compareDesc(dirtyDateToCompare, dirtyDate);
      var locale = options.locale || enLocale;
      var localize = locale.distanceInWords.localize;
      var localizeOptions = {
        addSuffix: options.addSuffix,
        comparison: comparison
      };
      var dateLeft, dateRight;
      if (comparison > 0) {
        dateLeft = parse(dirtyDateToCompare);
        dateRight = parse(dirtyDate);
      } else {
        dateLeft = parse(dirtyDate);
        dateRight = parse(dirtyDateToCompare);
      }
      var unit = options.unit;
      var mathPartial = Math[options.partialMethod || 'floor'];
      var seconds = differenceInSeconds(dateRight, dateLeft);
      var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset();
      var minutes = mathPartial(seconds / 60) - offset;
      var hours, days, months, years;
      if (!unit) {
        if (minutes < 1) {
          unit = 's';
        } else if (minutes < 60) {
          unit = 'm';
        } else if (minutes < MINUTES_IN_DAY) {
          unit = 'h';
        } else if (minutes < MINUTES_IN_MONTH) {
          unit = 'd';
        } else if (minutes < MINUTES_IN_YEAR) {
          unit = 'M';
        } else {
          unit = 'Y';
        }
      }
      if (unit === 's') {
        return localize('xSeconds', seconds, localizeOptions);
      } else if (unit === 'm') {
        return localize('xMinutes', minutes, localizeOptions);
      } else if (unit === 'h') {
        hours = mathPartial(minutes / 60);
        return localize('xHours', hours, localizeOptions);
      } else if (unit === 'd') {
        days = mathPartial(minutes / MINUTES_IN_DAY);
        return localize('xDays', days, localizeOptions);
      } else if (unit === 'M') {
        months = mathPartial(minutes / MINUTES_IN_MONTH);
        return localize('xMonths', months, localizeOptions);
      } else if (unit === 'Y') {
        years = mathPartial(minutes / MINUTES_IN_YEAR);
        return localize('xYears', years, localizeOptions);
      }
      throw new Error('Unknown unit: ' + unit);
    }

    function distanceInWordsToNow(dirtyDate, options) {
      return distanceInWords(Date.now(), dirtyDate, options);
    }

    function eachDay(dirtyStartDate, dirtyEndDate) {
      var startDate = parse(dirtyStartDate);
      var endDate = parse(dirtyEndDate);
      var endTime = endDate.getTime();
      if (startDate.getTime() > endTime) {
        throw new Error('The first date cannot be after the second date');
      }
      var dates = [];
      var currentDate = startDate;
      currentDate.setHours(0, 0, 0, 0);
      while (currentDate.getTime() <= endTime) {
        dates.push(parse(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return dates;
    }

    function endOfDay(dirtyDate) {
      var date = parse(dirtyDate);
      date.setHours(23, 59, 59, 999);
      return date;
    }

    function endOfHour(dirtyDate) {
      var date = parse(dirtyDate);
      date.setMinutes(59, 59, 999);
      return date;
    }

    function endOfISOWeek(dirtyDate) {
      return endOfWeek(dirtyDate, { weekStartsOn: 1 });
    }

    function endOfISOYear(dirtyDate) {
      var year = getISOYear(dirtyDate);
      var fourthOfJanuaryOfNextYear = new Date(0);
      fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
      fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
      var date = startOfISOWeek(fourthOfJanuaryOfNextYear);
      date.setMilliseconds(date.getMilliseconds() - 1);
      return date;
    }

    function endOfMinute(dirtyDate) {
      var date = parse(dirtyDate);
      date.setSeconds(59, 999);
      return date;
    }

    function endOfQuarter(dirtyDate) {
      var date = parse(dirtyDate);
      var currentMonth = date.getMonth();
      var month = currentMonth - currentMonth % 3 + 3;
      date.setMonth(month, 0);
      date.setHours(23, 59, 59, 999);
      return date;
    }

    function endOfSecond(dirtyDate) {
      var date = parse(dirtyDate);
      date.setMilliseconds(999);
      return date;
    }

    function endOfToday() {
      return endOfDay(new Date());
    }

    function endOfTomorrow() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var day = now.getDate();
      var date = new Date(0);
      date.setFullYear(year, month, day + 1);
      date.setHours(23, 59, 59, 999);
      return date;
    }

    function endOfYear(dirtyDate) {
      var date = parse(dirtyDate);
      var year = date.getFullYear();
      date.setFullYear(year + 1, 0, 0);
      date.setHours(23, 59, 59, 999);
      return date;
    }

    function endOfYesterday() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var day = now.getDate();
      var date = new Date(0);
      date.setFullYear(year, month, day - 1);
      date.setHours(23, 59, 59, 999);
      return date;
    }

    var format = function(dirtyDate, formatStr, options) {
      formatStr = formatStr || 'YYYY-MM-DDTHH:mm:ss.SSSZ';
      options = options || {};
      var locale = options.locale || enLocale;
      var formatLocale = locale.format;
      var date = parse(dirtyDate);
      var formatFn = buildFormatFn(formatStr, formatLocale);
      return formatFn(date);
    };

    var formatters = {
      'M': function (date) {
        return date.getMonth() + 1;
      },
      'MM': function (date) {
        return addLeadingZeros(date.getMonth() + 1, 2);
      },
      'Q': function (date) {
        return Math.ceil((date.getMonth() + 1) / 3);
      },
      'D': function (date) {
        return date.getDate();
      },
      'DD': function (date) {
        return addLeadingZeros(date.getDate(), 2);
      },
      'DDD': function (date) {
        return getDayOfYear(date);
      },
      'DDDD': function (date) {
        return addLeadingZeros(getDayOfYear(date), 3);
      },
      'd': function (date) {
        return date.getDay();
      },
      'E': function (date) {
        return date.getDay() || 7;
      },
      'W': function (date) {
        return getISOWeek(date);
      },
      'WW': function (date) {
        return addLeadingZeros(getISOWeek(date), 2);
      },
      'YY': function (date) {
        return addLeadingZeros(date.getFullYear(), 4).substr(2);
      },
      'YYYY': function (date) {
        return addLeadingZeros(date.getFullYear(), 4);
      },
      'GG': function (date) {
        return String(getISOYear(date)).substr(2);
      },
      'GGGG': function (date) {
        return getISOYear(date);
      },
      'H': function (date) {
        return date.getHours();
      },
      'HH': function (date) {
        return addLeadingZeros(date.getHours(), 2);
      },
      'h': function (date) {
        var hours = date.getHours();
        if (hours === 0) {
          return 12;
        } else if (hours > 12) {
          return hours % 12;
        } else {
          return hours;
        }
      },
      'hh': function (date) {
        return addLeadingZeros(formatters['h'](date), 2);
      },
      'm': function (date) {
        return date.getMinutes();
      },
      'mm': function (date) {
        return addLeadingZeros(date.getMinutes(), 2);
      },
      's': function (date) {
        return date.getSeconds();
      },
      'ss': function (date) {
        return addLeadingZeros(date.getSeconds(), 2);
      },
      'S': function (date) {
        return Math.floor(date.getMilliseconds() / 100);
      },
      'SS': function (date) {
        return Math.floor(date.getMilliseconds() / 10);
      },
      'SSS': function (date) {
        return date.getMilliseconds();
      },
      'Z': function (date) {
        return formatTimezone(date.getTimezoneOffset(), ':');
      },
      'ZZ': function (date) {
        return formatTimezone(date.getTimezoneOffset());
      },
      'X': function (date) {
        return Math.floor(date.getTime() / 1000);
      },
      'x': function (date) {
        return date.getTime();
      }
    };
    function buildFormatFn(formatStr, formatLocale) {
      var array = formatStr.match(formatLocale.formattingTokensRegExp);
      var length = array.length;
      var i;
      var formatter;
      for (i = 0; i < length; i++) {
        formatter = formatLocale.formatters[array[i]] || formatters[array[i]];
        if (formatter) {
          array[i] = formatter;
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (date) {
        var output = '';
        for (var i = 0; i < length; i++) {
          if (array[i] instanceof Function) {
            output += array[i](date, formatters);
          } else {
            output += array[i];
          }
        }
        return output;
      };
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function formatTimezone(offset, delimeter) {
      delimeter = delimeter || '';
      var sign = offset > 0 ? '-' : '+';
      var absOffset = Math.abs(offset);
      var hours = Math.floor(absOffset / 60);
      var minutes = absOffset % 60;
      return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2);
    }
    function addLeadingZeros(number, targetLength) {
      var output = Math.abs(number).toString();
      while (output.length < targetLength) {
        output = '0' + output;
      }
      return output;
    }

    function getDate(dirtyDate) {
      var date = parse(dirtyDate);
      var dayOfMonth = date.getDate();
      return dayOfMonth;
    }

    function getDay(dirtyDate) {
      var date = parse(dirtyDate);
      var day = date.getDay();
      return day;
    }

    function getDaysInYear(dirtyDate) {
      return isLeapYear(dirtyDate) ? 366 : 365;
    }

    function getDayOfYear(dirtyDate) {
      var date = parse(dirtyDate);
      var diff = differenceInCalendarDays(date, startOfYear(date));
      var dayOfYear = diff + 1;
      return dayOfYear;
    }

    function getDaysInMonth(dirtyDate) {
      var date = parse(dirtyDate);
      var year = date.getFullYear();
      var monthIndex = date.getMonth();
      var lastDayOfMonth = new Date(0);
      lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
      lastDayOfMonth.setHours(0, 0, 0, 0);
      return lastDayOfMonth.getDate();
    }

    function getHours(dirtyDate) {
      var date = parse(dirtyDate);
      var hours = date.getHours();
      return hours;
    }

    function getISODay(dirtyDate) {
      var date = parse(dirtyDate);
      var day = date.getDay();
      if (day === 0) {
        day = 7;
      }
      return day;
    }

    function getISOWeek(dirtyDate) {
      var MILLISECONDS_IN_WEEK = 604800000;
      var date = parse(dirtyDate);
      var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime();
      return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
    }

    function getISOWeeksInYear(dirtyDate) {
      var MILLISECONDS_IN_WEEK = 604800000;
      var thisYear = startOfISOYear(dirtyDate);
      var nextYear = startOfISOYear(addWeeks(thisYear, 60));
      var diff = nextYear.valueOf() - thisYear.valueOf();
      return Math.round(diff / MILLISECONDS_IN_WEEK);
    }

    function getISOYear(dirtyDate) {
      var date = parse(dirtyDate);
      var year = date.getFullYear();
      var fourthOfJanuaryOfNextYear = new Date(0);
      fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
      fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
      var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
      var fourthOfJanuaryOfThisYear = new Date(0);
      fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
      fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
      var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }

    function getMilliseconds(dirtyDate) {
      var date = parse(dirtyDate);
      var milliseconds = date.getMilliseconds();
      return milliseconds;
    }

    function getMinutes(dirtyDate) {
      var date = parse(dirtyDate);
      var minutes = date.getMinutes();
      return minutes;
    }

    function getMonth(dirtyDate) {
      var date = parse(dirtyDate);
      var month = date.getMonth();
      return month;
    }

    function getQuarter(dirtyDate) {
      var date = parse(dirtyDate);
      var quarter = Math.floor(date.getMonth() / 3) + 1;
      return quarter;
    }

    function getSeconds(dirtyDate) {
      var date = parse(dirtyDate);
      var seconds = date.getSeconds();
      return seconds;
    }

    function getYear(dirtyDate) {
      var date = parse(dirtyDate);
      var year = date.getFullYear();
      return year;
    }

    function isAfter(dirtyDateToCompare, dirtyDate) {
      var dateToCompare = parse(dirtyDateToCompare);
      var date = parse(dirtyDate);
      return dateToCompare.getTime() > date.getTime();
    }

    function isBefore(dirtyDateToCompare, dirtyDate) {
      var dateToCompare = parse(dirtyDateToCompare);
      var date = parse(dirtyDate);
      return dateToCompare.getTime() < date.getTime();
    }

    function isDate(argument) {
      return argument instanceof Date;
    }

    function isEqual(dirtyLeftDate, dirtyRightDate) {
      var dateLeft = parse(dirtyLeftDate);
      var dateRight = parse(dirtyRightDate);
      return dateLeft.getTime() === dateRight.getTime();
    }

    function isFirstDayOfMonth(dirtyDate) {
      return parse(dirtyDate).getDate() === 1;
    }

    function isFriday(dirtyDate) {
      return parse(dirtyDate).getDay() === 5;
    }

    function isFuture(dirtyDate) {
      return parse(dirtyDate).getTime() > new Date().getTime();
    }

    function isLastDayOfMonth(dirtyDate) {
      var date = parse(dirtyDate);
      return endOfDay(date).getTime() === endOfMonth(date).getTime();
    }

    function isLeapYear(dirtyDate) {
      var date = parse(dirtyDate);
      var year = date.getFullYear();
      return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }

    function isMonday(dirtyDate) {
      return parse(dirtyDate).getDay() === 1;
    }

    function isPast(dirtyDate) {
      return parse(dirtyDate).getTime() < new Date().getTime();
    }

    function isSameDay(dirtyDateLeft, dirtyDateRight) {
      var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
      var dateRightStartOfDay = startOfDay(dirtyDateRight);
      return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
    }

    function isSameHour(dirtyDateLeft, dirtyDateRight) {
      var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
      var dateRightStartOfHour = startOfHour(dirtyDateRight);
      return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
    }

    function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
      return isSameWeek(dirtyDateLeft, dirtyDateRight, { weekStartsOn: 1 });
    }

    function isSameISOYear(dirtyDateLeft, dirtyDateRight) {
      var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft);
      var dateRightStartOfYear = startOfISOYear(dirtyDateRight);
      return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
    }

    function isSameMinute(dirtyDateLeft, dirtyDateRight) {
      var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft);
      var dateRightStartOfMinute = startOfMinute(dirtyDateRight);
      return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
    }

    function isSameMonth(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
    }

    function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
      var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
      var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
      return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
    }

    function isSameSecond(dirtyDateLeft, dirtyDateRight) {
      var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
      var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
      return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
    }

    function isSameWeek(dirtyDateLeft, dirtyDateRight, options) {
      var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, options);
      var dateRightStartOfWeek = startOfWeek(dirtyDateRight, options);
      return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
    }

    function isSameYear(dirtyDateLeft, dirtyDateRight) {
      var dateLeft = parse(dirtyDateLeft);
      var dateRight = parse(dirtyDateRight);
      return dateLeft.getFullYear() === dateRight.getFullYear();
    }

    function isSaturday(dirtyDate) {
      return parse(dirtyDate).getDay() === 6;
    }

    function isSunday(dirtyDate) {
      return parse(dirtyDate).getDay() === 0;
    }

    function isThisHour(dirtyDate) {
      return isSameHour(new Date(), dirtyDate);
    }

    function isThisISOWeek(dirtyDate) {
      return isSameISOWeek(new Date(), dirtyDate);
    }

    function isThisISOYear(dirtyDate) {
      return isSameISOYear(new Date(), dirtyDate);
    }

    function isThisMinute(dirtyDate) {
      return isSameMinute(new Date(), dirtyDate);
    }

    function isThisMonth(dirtyDate) {
      return isSameMonth(new Date(), dirtyDate);
    }

    function isThisQuarter(dirtyDate) {
      return isSameQuarter(new Date(), dirtyDate);
    }

    function isThisSecond(dirtyDate) {
      return isSameSecond(new Date(), dirtyDate);
    }

    function isThisWeek(dirtyDate, options) {
      return isSameWeek(new Date(), dirtyDate, options);
    }

    function isThisYear(dirtyDate) {
      return isSameYear(new Date(), dirtyDate);
    }

    function isThursday(dirtyDate) {
      return parse(dirtyDate).getDay() === 4;
    }

    function isToday(dirtyDate) {
      return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime();
    }

    function isTomorrow(dirtyDate) {
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime();
    }

    function isTuesday(dirtyDate) {
      return parse(dirtyDate).getDay() === 2;
    }

    function isValid(date) {
      if (isDate(date)) {
        return !isNaN(date);
      } else {
        throw new TypeError(toString.call(date) + ' is not an instance of Date');
      }
    }

    function isWednesday(dirtyDate) {
      return parse(dirtyDate).getDay() === 3;
    }

    function isWeekend(dirtyDate) {
      var date = parse(dirtyDate);
      var day = date.getDay();
      return day === 0 || day === 6;
    }

    function isWithinRange(dirtyDate, dirtyStartDate, dirtyEndDate) {
      var time = parse(dirtyDate).getTime();
      var startTime = parse(dirtyStartDate).getTime();
      var endTime = parse(dirtyEndDate).getTime();
      if (startTime > endTime) {
        throw new Error('The start of the range cannot be after the end of the range');
      }
      return time >= startTime && time <= endTime;
    }

    function isYesterday(dirtyDate) {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime();
    }

    function lastDayOfISOWeek(dirtyDate) {
      return lastDayOfWeek(dirtyDate, { weekStartsOn: 1 });
    }

    function lastDayOfISOYear(dirtyDate) {
      var year = getISOYear(dirtyDate);
      var fourthOfJanuary = new Date(0);
      fourthOfJanuary.setFullYear(year + 1, 0, 4);
      fourthOfJanuary.setHours(0, 0, 0, 0);
      var date = startOfISOWeek(fourthOfJanuary);
      date.setDate(date.getDate() - 1);
      return date;
    }

    function lastDayOfMonth(dirtyDate) {
      var date = parse(dirtyDate);
      var month = date.getMonth();
      date.setFullYear(date.getFullYear(), month + 1, 0);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function lastDayOfQuarter(dirtyDate) {
      var date = parse(dirtyDate);
      var currentMonth = date.getMonth();
      var month = currentMonth - currentMonth % 3 + 3;
      date.setMonth(month, 0);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function lastDayOfWeek(dirtyDate, options) {
      var weekStartsOn = options ? options.weekStartsOn || 0 : 0;
      var date = parse(dirtyDate);
      var day = date.getDay();
      var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
      date.setHours(0, 0, 0, 0);
      date.setDate(date.getDate() + diff);
      return date;
    }

    function lastDayOfYear(dirtyDate) {
      var date = parse(dirtyDate);
      var year = date.getFullYear();
      date.setFullYear(year + 1, 0, 0);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function max() {
      var dirtyDates = Array.prototype.slice.call(arguments);
      var dates = dirtyDates.map(function (dirtyDate) {
        return parse(dirtyDate);
      });
      var latestTimestamp = Math.max.apply(null, dates);
      return new Date(latestTimestamp);
    }

    function min() {
      var dirtyDates = Array.prototype.slice.call(arguments);
      var dates = dirtyDates.map(function (dirtyDate) {
        return parse(dirtyDate);
      });
      var earliestTimestamp = Math.min.apply(null, dates);
      return new Date(earliestTimestamp);
    }

    function setDate(dirtyDate, dayOfMonth) {
      var date = parse(dirtyDate);
      date.setDate(dayOfMonth);
      return date;
    }

    function setDay(dirtyDate, day, options) {
      var weekStartsOn = options ? options.weekStartsOn || 0 : 0;
      var date = parse(dirtyDate);
      var currentDay = date.getDay();
      var remainder = day % 7;
      var dayIndex = (remainder + 7) % 7;
      var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
      return addDays(date, diff);
    }

    function setDayOfYear(dirtyDate, dayOfYear) {
      var date = parse(dirtyDate);
      date.setMonth(0);
      date.setDate(dayOfYear);
      return date;
    }

    function setHours(dirtyDate, hours) {
      var date = parse(dirtyDate);
      date.setHours(hours);
      return date;
    }

    function setISODay(dirtyDate, day) {
      var date = parse(dirtyDate);
      var currentDay = getISODay(date);
      var diff = day - currentDay;
      return addDays(date, diff);
    }

    function setISOWeek(dirtyDate, isoWeek) {
      var date = parse(dirtyDate);
      var diff = getISOWeek(date) - isoWeek;
      date.setDate(date.getDate() - diff * 7);
      return date;
    }

    function setISOYear(dirtyDate, isoYear) {
      var date = parse(dirtyDate);
      var diff = differenceInCalendarDays(date, startOfISOYear(date));
      var fourthOfJanuary = new Date(0);
      fourthOfJanuary.setFullYear(isoYear, 0, 4);
      fourthOfJanuary.setHours(0, 0, 0, 0);
      date = startOfISOYear(fourthOfJanuary);
      date.setDate(date.getDate() + diff);
      return date;
    }

    function setMilliseconds(dirtyDate, milliseconds) {
      var date = parse(dirtyDate);
      date.setMilliseconds(milliseconds);
      return date;
    }

    function setMinutes(dirtyDate, minutes) {
      var date = parse(dirtyDate);
      date.setMinutes(minutes);
      return date;
    }

    function setMonth(dirtyDate, month) {
      var date = parse(dirtyDate);
      var year = date.getFullYear();
      var day = date.getDate();
      var dateWithDesiredMonth = new Date(0);
      dateWithDesiredMonth.setFullYear(year, month, 15);
      dateWithDesiredMonth.setHours(0, 0, 0, 0);
      var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
      date.setMonth(month, Math.min(day, daysInMonth));
      return date;
    }

    function setQuarter(dirtyDate, quarter) {
      var date = parse(dirtyDate);
      var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
      var diff = quarter - oldQuarter;
      return setMonth(date, date.getMonth() + diff * 3);
    }

    function setSeconds(dirtyDate, seconds) {
      var date = parse(dirtyDate);
      date.setSeconds(seconds);
      return date;
    }

    function setYear(dirtyDate, year) {
      var date = parse(dirtyDate);
      date.setFullYear(year);
      return date;
    }

    function startOfDay(dirtyDate) {
      var date = parse(dirtyDate);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function startOfHour(dirtyDate) {
      var date = parse(dirtyDate);
      date.setMinutes(0, 0, 0);
      return date;
    }

    function startOfISOWeek(dirtyDate) {
      return startOfWeek(dirtyDate, { weekStartsOn: 1 });
    }

    function startOfISOYear(dirtyDate) {
      var year = getISOYear(dirtyDate);
      var fourthOfJanuary = new Date(0);
      fourthOfJanuary.setFullYear(year, 0, 4);
      fourthOfJanuary.setHours(0, 0, 0, 0);
      var date = startOfISOWeek(fourthOfJanuary);
      return date;
    }

    function startOfMinute(dirtyDate) {
      var date = parse(dirtyDate);
      date.setSeconds(0, 0);
      return date;
    }

    function startOfMonth(dirtyDate) {
      var date = parse(dirtyDate);
      date.setDate(1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function startOfQuarter(dirtyDate) {
      var date = parse(dirtyDate);
      var currentMonth = date.getMonth();
      var month = currentMonth - currentMonth % 3;
      date.setMonth(month, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function startOfSecond(dirtyDate) {
      var date = parse(dirtyDate);
      date.setMilliseconds(0);
      return date;
    }

    function startOfToday() {
      return startOfDay(new Date());
    }

    function startOfTomorrow() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var day = now.getDate();
      var date = new Date(0);
      date.setFullYear(year, month, day + 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function startOfWeek(dirtyDate, options) {
      var weekStartsOn = options ? options.weekStartsOn || 0 : 0;
      var date = parse(dirtyDate);
      var day = date.getDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setDate(date.getDate() - diff);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function startOfYear(dirtyDate) {
      var cleanDate = parse(dirtyDate);
      var date = new Date(0);
      date.setFullYear(cleanDate.getFullYear(), 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function startOfYesterday() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var day = now.getDate();
      var date = new Date(0);
      date.setFullYear(year, month, day - 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function subDays(dirtyDate, amount) {
      return addDays(dirtyDate, -amount);
    }

    function subHours(dirtyDate, amount) {
      return addHours(dirtyDate, -amount);
    }

    function subISOYears(dirtyDate, amount) {
      return addISOYears(dirtyDate, -amount);
    }

    function subMilliseconds(dirtyDate, amount) {
      return addMilliseconds(dirtyDate, -amount);
    }

    function subMinutes(dirtyDate, amount) {
      return addMinutes(dirtyDate, -amount);
    }

    function subMonths(dirtyDate, amount) {
      return addMonths(dirtyDate, -amount);
    }

    function subQuarters(dirtyDate, amount) {
      return addQuarters(dirtyDate, -amount);
    }

    function subSeconds(dirtyDate, amount) {
      return addSeconds(dirtyDate, -amount);
    }

    function subWeeks(dirtyDate, amount) {
      return addWeeks(dirtyDate, -amount);
    }

    function subYears(dirtyDate, amount) {
      return addYears(dirtyDate, -amount);
    }

    return{
      addDays: addDays,
      addHours: addHours,
      addISOYears: addISOYears,
      addMilliseconds: addMilliseconds,
      addMinutes: addMinutes,
      addMonths: addMonths,
      addQuarters: addQuarters,
      addSeconds: addSeconds,
      addWeeks: addWeeks,
      addYears: addYears,
      closestIndexTo: closestIndexTo,
      closestTo: closestTo,
      compareAsc: compareAsc,
      compareDesc: compareDesc,
      differenceInCalendarDays: differenceInCalendarDays,
      differenceInCalendarISOWeeks: differenceInCalendarISOWeeks,
      differenceInCalendarISOYears: differenceInCalendarISOYears,
      differenceInCalendarMonths: differenceInCalendarMonths,
      differenceInCalendarQuarters: differenceInCalendarQuarters,
      differenceInCalendarWeeks: differenceInCalendarWeeks,
      differenceInCalendarYears: differenceInCalendarYears,
      differenceInDays: differenceInDays,
      differenceInHours: differenceInHours,
      differenceInISOYears: differenceInISOYears,
      differenceInMilliseconds: differenceInMilliseconds,
      differenceInMinutes: differenceInMinutes,
      differenceInMonths: differenceInMonths,
      differenceInQuarters: differenceInQuarters,
      differenceInSeconds: differenceInSeconds,
      differenceInWeeks: differenceInWeeks,
      differenceInYears: differenceInYears,
      distanceInWords: distanceInWords,
      distanceInWordsStrict: distanceInWordsStrict,
      distanceInWordsToNow: distanceInWordsToNow,
      eachDay: eachDay,
      endOfDay: endOfDay,
      endOfHour: endOfHour,
      endOfISOWeek: endOfISOWeek,
      endOfISOYear: endOfISOYear,
      endOfMinute: endOfMinute,
      endOfMonth: endOfMonth,
      endOfQuarter: endOfQuarter,
      endOfSecond: endOfSecond,
      endOfToday: endOfToday,
      endOfTomorrow: endOfTomorrow,
      endOfWeek: endOfWeek,
      endOfYear: endOfYear,
      endOfYesterday: endOfYesterday,
      format: format,
      getDate: getDate,
      getDay: getDay,
      getDayOfYear: getDayOfYear,
      getDaysInMonth: getDaysInMonth,
      getDaysInYear: getDaysInYear,
      getHours: getHours,
      getISODay: getISODay,
      getISOWeek: getISOWeek,
      getISOWeeksInYear: getISOWeeksInYear,
      getISOYear: getISOYear,
      getMilliseconds: getMilliseconds,
      getMinutes: getMinutes,
      getMonth: getMonth,
      getQuarter: getQuarter,
      getSeconds: getSeconds,
      getYear: getYear,
      isAfter: isAfter,
      isBefore: isBefore,
      isDate: isDate,
      isEqual: isEqual,
      isFirstDayOfMonth: isFirstDayOfMonth,
      isFriday: isFriday,
      isFuture: isFuture,
      isLastDayOfMonth: isLastDayOfMonth,
      isLeapYear: isLeapYear,
      isMonday: isMonday,
      isPast: isPast,
      isSameDay: isSameDay,
      isSameHour: isSameHour,
      isSameISOWeek: isSameISOWeek,
      isSameISOYear: isSameISOYear,
      isSameMinute: isSameMinute,
      isSameMonth: isSameMonth,
      isSameQuarter: isSameQuarter,
      isSameSecond: isSameSecond,
      isSameWeek: isSameWeek,
      isSameYear: isSameYear,
      isSaturday: isSaturday,
      isSunday: isSunday,
      isThisHour: isThisHour,
      isThisISOWeek: isThisISOWeek,
      isThisISOYear: isThisISOYear,
      isThisMinute: isThisMinute,
      isThisMonth: isThisMonth,
      isThisQuarter: isThisQuarter,
      isThisSecond: isThisSecond,
      isThisWeek: isThisWeek,
      isThisYear: isThisYear,
      isThursday: isThursday,
      isToday: isToday,
      isTomorrow: isTomorrow,
      isTuesday: isTuesday,
      isValid: isValid,
      isWednesday: isWednesday,
      isWeekend: isWeekend,
      isWithinRange: isWithinRange,
      isYesterday: isYesterday,
      lastDayOfISOWeek: lastDayOfISOWeek,
      lastDayOfISOYear: lastDayOfISOYear,
      lastDayOfMonth: lastDayOfMonth,
      lastDayOfQuarter: lastDayOfQuarter,
      lastDayOfWeek: lastDayOfWeek,
      lastDayOfYear: lastDayOfYear,
      max: max,
      min: min,
      parse: parse,
      setDate: setDate,
      setDay: setDay,
      setDayOfYear: setDayOfYear,
      setHours: setHours,
      setISODay: setISODay,
      setISOWeek: setISOWeek,
      setISOYear: setISOYear,
      setMilliseconds: setMilliseconds,
      setMinutes: setMinutes,
      setMonth: setMonth,
      setQuarter: setQuarter,
      setSeconds: setSeconds,
      setYear: setYear,
      startOfDay: startOfDay,
      startOfHour: startOfHour,
      startOfISOWeek: startOfISOWeek,
      startOfISOYear: startOfISOYear,
      startOfMinute: startOfMinute,
      startOfMonth: startOfMonth,
      startOfQuarter: startOfQuarter,
      startOfSecond: startOfSecond,
      startOfToday: startOfToday,
      startOfTomorrow: startOfTomorrow,
      startOfWeek: startOfWeek,
      startOfYear: startOfYear,
      startOfYesterday: startOfYesterday,
      subDays: subDays,
      subHours: subHours,
      subISOYears: subISOYears,
      subMilliseconds: subMilliseconds,
      subMinutes: subMinutes,
      subMonths: subMonths,
      subQuarters: subQuarters,
      subSeconds: subSeconds,
      subWeeks: subWeeks,
      subYears: subYears
    };
  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .factory('dateFns', dateFns);

})();

/**
 * Created by Bruce on 2016/12/7.
 */

(function () {
  'use strict';

  calendarUtils.$inject = ['dateFns'];
  function calendarUtils(dateFns) {
    var WEEKEND_DAY_NUMBERS = [0, 6];
    var DAYS_IN_WEEK = 7;
    var HOURS_IN_DAY = 24;
    var MINUTES_IN_HOUR = 60;
    var endOfDay = dateFns.endOfDay;
    var addMinutes = dateFns.addMinutes;
    var differenceInDays = dateFns.differenceInDays;
    var startOfDay = dateFns.startOfDay;
    var isSameDay = dateFns.isSameDay;
    var getDay = dateFns.getDay;
    var startOfWeek = dateFns.startOfWeek;
    var addDays = dateFns.addDays;
    var endOfWeek = dateFns.endOfWeek;
    var differenceInSeconds = dateFns.differenceInSeconds;
    var startOfMonth = dateFns.startOfMonth;
    var endOfMonth = dateFns.endOfMonth;
    var isSameMonth = dateFns.isSameMonth;
    var isSameSecond = dateFns.isSameSecond;
    var setHours = dateFns.setHours;
    var setMinutes = dateFns.setMinutes;
    var startOfMinute = dateFns.startOfMinute;
    var differenceInMinutes = dateFns.differenceInMinutes;
    var addHours = dateFns.addHours;

    var getWeekViewEventSpan = function (event, offset, startOfWeek) {
      var span = 1;
      if (event.end) {
        var begin = event.start < startOfWeek ? startOfWeek : event.start;
        span = differenceInDays(addMinutes(endOfDay(event.end), 1), startOfDay(begin));
        if (span > DAYS_IN_WEEK) {
          span = DAYS_IN_WEEK;
        }
      }
      var totalLength = offset + span;
      if (totalLength > DAYS_IN_WEEK) {
        span -= (totalLength - DAYS_IN_WEEK);
      }
      return span;
    };
    var getWeekViewEventOffset = function (event, startOfWeek) {
      var offset = 0;
      if (startOfDay(event.start) > startOfWeek) {
        offset = differenceInDays(startOfDay(event.start), startOfWeek);
      }
      return offset;
    };
    var isEventIsPeriod = function (_a) {
      var event = _a.event, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
      var eventStart = event.start;
      var eventEnd = event.end || event.start;
      if (eventStart > periodStart && eventStart < periodEnd) {
        return true;
      }
      if (eventEnd > periodStart && eventEnd < periodEnd) {
        return true;
      }
      if (eventStart < periodStart && eventEnd > periodEnd) {
        return true;
      }
      if (isSameSecond(eventStart, periodStart) || isSameSecond(eventStart, periodEnd)) {
        return true;
      }
      if (isSameSecond(eventEnd, periodStart) || isSameSecond(eventEnd, periodEnd)) {
        return true;
      }
      return false;
    };
    var getEventsInPeriod = function (_a) {
      var events = _a.events, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
      return events.filter(function (event) { return isEventIsPeriod({ event: event, periodStart: periodStart, periodEnd: periodEnd }); });
    };
    var getWeekDay = function (_a) {
      var date = _a.date;
      var today = startOfDay(new Date());
      return {
        date: date,
        isPast: date < today,
        isToday: isSameDay(date, today),
        isFuture: date > today,
        isWeekend: WEEKEND_DAY_NUMBERS.indexOf(getDay(date)) > -1
      };
    };
    var getWeekViewHeader = function (_a) {
      var viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn;
      var start = startOfWeek(viewDate, { weekStartsOn: weekStartsOn });
      var days = [];
      for (var i = 0; i < DAYS_IN_WEEK; i++) {
        var date = addDays(start, i);
        days.push(getWeekDay({ date: date }));
      }
      return days;
    };
    var getWeekView = function (_a, isSort) {
      isSort = isSort || false;
      var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn;
      var startOfViewWeek = startOfWeek(viewDate, { weekStartsOn: weekStartsOn });
      var endOfViewWeek = endOfWeek(viewDate, { weekStartsOn: weekStartsOn });
      var eventsMapped = getEventsInPeriod({ events: events, periodStart: startOfViewWeek, periodEnd: endOfViewWeek }).map(function (event) {
        var offset = getWeekViewEventOffset(event, startOfViewWeek);
        var span = getWeekViewEventSpan(event, offset, startOfViewWeek);
        return {
          event: event,
          offset: offset,
          span: span,
          startsBeforeWeek: event.start < startOfViewWeek,
          endsAfterWeek: (event.end || event.start) > endOfViewWeek
        };
      });

      if(isSort){
        eventsMapped.sort(function (itemA, itemB) {
          var startSecondsDiff = differenceInSeconds(itemA.event.start, itemB.event.start);
          if (startSecondsDiff === 0) {
            return differenceInSeconds(itemB.event.end || itemB.event.start, itemA.event.end || itemA.event.start);
          }
          return startSecondsDiff;
        })
      }

      var eventRows = [];
      var allocatedEvents = [];
      eventsMapped.forEach(function (event, index) {
        if (allocatedEvents.indexOf(event) === -1) {
          allocatedEvents.push(event);
          var rowSpan_1 = event.span + event.offset;
          var otherRowEvents = eventsMapped.slice(index + 1).filter(function (nextEvent) {
            if (nextEvent.offset >= rowSpan_1 &&
              rowSpan_1 + nextEvent.span <= DAYS_IN_WEEK &&
              allocatedEvents.indexOf(nextEvent) === -1) {
              nextEvent.offset -= rowSpan_1;
              rowSpan_1 += nextEvent.span + nextEvent.offset;
              allocatedEvents.push(nextEvent);
              return true;
            }
          });
          eventRows.push({
            row: [
              event
            ].concat(otherRowEvents)
          });
        }
      });
      return eventRows;
    };
    var getMonthView = function (_a) {
      var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn;
      var start = startOfWeek(startOfMonth(viewDate), { weekStartsOn: weekStartsOn });
      var end = endOfWeek(endOfMonth(viewDate), { weekStartsOn: weekStartsOn });
      var eventsInMonth = getEventsInPeriod({
        events: events,
        periodStart: start,
        periodEnd: end
      });
      var days = [];
      var i;
      for (i = 0; i < differenceInDays(end, start) + 1; i++) {
        var date = addDays(start, i);
        var day = getWeekDay({ date: date });
        var events_1 = getEventsInPeriod({
          events: eventsInMonth,
          periodStart: startOfDay(date),
          periodEnd: endOfDay(date)
        });
        day.inMonth = isSameMonth(date, viewDate);
        day.events = events_1;
        day.badgeTotal = events_1.length;
        days.push(day);
      }
      var rows = Math.floor(days.length / 7);
      var rowOffsets = [];
      for (i = 0; i < rows; i++) {
        rowOffsets.push(i * 7);
      }
      return {
        rowOffsets: rowOffsets,
        days: days
      };
    };
    var getDayView = function (_a) {
      var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd, eventWidth = _a.eventWidth, segmentHeight = _a.segmentHeight;
      var startOfView = setMinutes(setHours(startOfDay(viewDate), dayStart.hour), dayStart.minute);
      var endOfView = setMinutes(setHours(startOfMinute(endOfDay(viewDate)), dayEnd.hour), dayEnd.minute);
      var previousDayEvents = [];
      var dayViewEvents = getEventsInPeriod({
        events: events.filter(function (event) { return !event.allDay; }),
        periodStart: startOfView,
        periodEnd: endOfView
      }).sort(function (eventA, eventB) {
        return eventA.start.valueOf() - eventB.start.valueOf();
      }).map(function (event) {
        var eventStart = event.start;
        var eventEnd = event.end || eventStart;
        var startsBeforeDay = eventStart < startOfView;
        var endsAfterDay = eventEnd > endOfView;
        var hourHeightModifier = (hourSegments * segmentHeight) / MINUTES_IN_HOUR;
        var top = 0;
        if (eventStart > startOfView) {
          top += differenceInMinutes(eventStart, startOfView);
        }
        top *= hourHeightModifier;
        var startDate = startsBeforeDay ? startOfView : eventStart;
        var endDate = endsAfterDay ? endOfView : eventEnd;
        var height = differenceInMinutes(endDate, startDate);
        if (!event.end) {
          height = segmentHeight;
        }
        else {
          height *= hourHeightModifier;
        }
        var bottom = top + height;
        var overlappingPreviousEvents = previousDayEvents.filter(function (previousEvent) {
          var previousEventTop = previousEvent.top;
          var previousEventBottom = previousEvent.top + previousEvent.height;
          if (top < previousEventBottom && previousEventBottom < bottom) {
            return true;
          }
          else if (previousEventTop <= top && bottom <= previousEventBottom) {
            return true;
          }
          return false;
        });
        var left = 0;
        while (overlappingPreviousEvents.some(function (previousEvent) { return previousEvent.left === left; })) {
          left += eventWidth;
        }
        var dayEvent = {
          event: event,
          height: height,
          width: eventWidth,
          top: top,
          left: left,
          startsBeforeDay: startsBeforeDay,
          endsAfterDay: endsAfterDay
        };
        if (height > 0) {
          previousDayEvents.push(dayEvent);
        }
        return dayEvent;
      }).filter(function (dayEvent) { return dayEvent.height > 0; });
      var width = Math.max.apply(Math, dayViewEvents.map(function (event) { return event.left + event.width; }));
      var allDayEvents = getEventsInPeriod({
        events: events.filter(function (event) { return event.allDay; }),
        periodStart: startOfDay(startOfView),
        periodEnd: endOfDay(endOfView)
      });
      return {
        events: dayViewEvents,
        width: width,
        allDayEvents: allDayEvents
      };
    };
    var getDayViewHourGrid = function (_a) {
      var viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd;
      var hours = [];
      var startOfView = setMinutes(setHours(startOfDay(viewDate), dayStart.hour), dayStart.minute);
      var endOfView = setMinutes(setHours(startOfMinute(endOfDay(viewDate)), dayEnd.hour), dayEnd.minute);
      var segmentDuration = MINUTES_IN_HOUR / hourSegments;
      var startOfViewDay = startOfDay(viewDate);
      for (var i = 0; i < HOURS_IN_DAY; i++) {
        var segments = [];
        for (var j = 0; j < hourSegments; j++) {
          var date = addMinutes(addHours(startOfViewDay, i), j * segmentDuration);
          if (date >= startOfView && date < endOfView) {
            segments.push({
              date: date,
              isStart: j === 0
            });
          }
        }
        if (segments.length > 0) {
          hours.push({ segments: segments });
        }
      }
      return hours;
    };

    return{
      getMonthView: getMonthView,
      getWeekView: getWeekView,
      getDayView: getDayView,
      getWeekViewEventOffset: getWeekViewEventOffset,
      getWeekViewHeader: getWeekViewHeader,
      getDayViewHourGrid: getDayViewHourGrid
    };
  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .factory('calendarUtils', calendarUtils);

})();

/**
 * Created by Bruce on 2016/12/7.
 */

(function () {
  'use strict';

  calendarTitle.$inject = ['calendarConfig', 'calendarHelper', '$filter'];
  function calendarTitle(calendarConfig, calendarHelper, $filter) {
    function day(viewDate) {
      return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.day);
    }


    function week(viewDate) {
      return $filter('translate')('FIELD.' + calendarConfig.titleFormats.week, {
        week: moment(viewDate).isoWeek(),
        year: moment(viewDate).startOf('week').format('YYYY')
      });
      // return calendarConfig.titleFormats.week
      //   .replace('{week}', moment(viewDate).isoWeek())
      //   .replace('{year}', moment(viewDate).startOf('week').format('YYYY'))
      //   ;
    }

    function month(viewDate) {
      return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.month);
    }

    function year(viewDate) {
      return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.year);
    }

    return {
      day: day,
      week: week,
      month: month,
      year: year
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .factory('calendarTitle', calendarTitle);

})();

/**
 * Created by Bruce on 2016/12/7.
 */

(function () {
  'use strict';

  calendarHelper.$inject = ['$http', '$q', '$templateRequest', '$templateCache', '$interpolate', 'dateFilter', 'calendarConfig', 'calendarUtils'];
  function calendarHelper($http, $q, $templateRequest, $templateCache, $interpolate, dateFilter, calendarConfig, calendarUtils) {

    function formatDate(date, format) {
      if (calendarConfig.dateFormatter === 'angular') {
        return dateFilter(moment(date).toDate(), format);
      } else if (calendarConfig.dateFormatter === 'moment') {
        return moment(date).format(format);
      } else {
        throw new Error('Unknown date formatter: ' + calendarConfig.dateFormatter);
      }
    }

    function adjustEndDateFromStartDiff(oldStart, newStart, oldEnd) {
      if (!oldEnd) {
        return oldEnd;
      }
      var diffInSeconds = moment(newStart).diff(moment(oldStart));
      return moment(oldEnd).add(diffInSeconds);
    }

    function getRecurringEventPeriod(eventPeriod, recursOn, containerPeriodStart) {

      var eventStart = moment(eventPeriod.start);
      var eventEnd = moment(eventPeriod.end);
      var periodStart = moment(containerPeriodStart);

      if (recursOn) {

        switch (recursOn) {
          case 'year':
            eventStart.set({
              year: periodStart.year()
            });
            break;

          case 'month':
            eventStart.set({
              year: periodStart.year(),
              month: periodStart.month()
            });
            break;

          default:
            throw new Error('Invalid value (' + recursOn + ') given for recurs on. Can only be year or month.');
        }

        eventEnd = adjustEndDateFromStartDiff(eventPeriod.start, eventStart, eventEnd);

      }

      return {start: eventStart, end: eventEnd};

    }

    function eventIsInPeriod(event, periodStart, periodEnd) {

      periodStart = moment(periodStart);
      periodEnd = moment(periodEnd);

      var eventPeriod = getRecurringEventPeriod({start: event.startsAt, end: event.endsAt || event.startsAt}, event.recursOn, periodStart);
      var eventStart = eventPeriod.start;
      var eventEnd = eventPeriod.end;

      return (eventStart.isAfter(periodStart) && eventStart.isBefore(periodEnd)) ||
        (eventEnd.isAfter(periodStart) && eventEnd.isBefore(periodEnd)) ||
        (eventStart.isBefore(periodStart) && eventEnd.isAfter(periodEnd)) ||
        eventStart.isSame(periodStart) ||
        eventEnd.isSame(periodEnd);

    }

    function filterEventsInPeriod(events, startPeriod, endPeriod) {
      return events.filter(function(event) {
        return eventIsInPeriod(event, startPeriod, endPeriod);
      });
    }

    function getEventsInPeriod(calendarDate, period, allEvents) {
      var startPeriod = moment(calendarDate).startOf(period);
      var endPeriod = moment(calendarDate).endOf(period);
      return filterEventsInPeriod(allEvents, startPeriod, endPeriod);
    }

    function getBadgeTotal(events) {
      return events.filter(function(event) {
        return event.incrementsBadgeTotal !== false;
      }).length;
    }

    function getWeekDayNames() {
      var weekdays = [];
      var count = 0;
      while (count < 7) {
        weekdays.push(formatDate(moment().weekday(count++), calendarConfig.dateFormats.weekDay));
      }
      return weekdays;
    }

    function getYearView(events, viewDate, cellModifier) {

      var view = [];
      var eventsInPeriod = getEventsInPeriod(viewDate, 'year', events);
      var month = moment(viewDate).startOf('year');
      var count = 0;
      while (count < 12) {
        var startPeriod = month.clone();
        var endPeriod = startPeriod.clone().endOf('month');
        var periodEvents = filterEventsInPeriod(eventsInPeriod, startPeriod, endPeriod);
        var cell = {
          label: formatDate(startPeriod, calendarConfig.dateFormats.month),
          isToday: startPeriod.isSame(moment().startOf('month')),
          events: periodEvents,
          date: startPeriod,
          badgeTotal: getBadgeTotal(periodEvents)
        };

        cellModifier({calendarCell: cell});
        view.push(cell);
        month.add(1, 'month');
        count++;
      }

      return view;

    }

    function getMonthView(events, viewDate, cellModifier) {

      // hack required to work with the calendar-utils api
      events.forEach(function(event) {
        event.start = event.startsAt;
        event.end = event.endsAt;
      });

      var view = calendarUtils.getMonthView({
        events: events,
        viewDate: viewDate,
        weekStartsOn: moment().startOf('week').day()
      });

      view.days = view.days.map(function(day) {
        day.date = moment(day.date);
        day.label = day.date.date();
        day.badgeTotal = getBadgeTotal(day.events);
        if (!calendarConfig.displayAllMonthEvents && !day.inMonth) {
          day.events = [];
        }
        cellModifier({calendarCell: day});
        return day;
      });

      // remove hack
      events.forEach(function(event) {
        delete event.start;
        delete event.end;
      });

      return view;

    }

    function getWeekView(events, viewDate, isSort) {
      isSort = isSort || false;
      var days = calendarUtils.getWeekViewHeader({
        viewDate: viewDate,
        weekStartsOn: moment().startOf('week').day()
      }).map(function(day) {
        day.date = moment(day.date);
        day.weekDayLabel = formatDate(day.date, calendarConfig.dateFormats.weekDay);
        day.dayLabel = formatDate(day.date, calendarConfig.dateFormats.day);
        return day;
      });

      var startOfWeek = moment(viewDate).startOf('week');
      var endOfWeek = moment(viewDate).endOf('week');

      var eventRows = calendarUtils.getWeekView({
        viewDate: viewDate,
        weekStartsOn: moment().startOf('week').day(),
        events: filterEventsInPeriod(events, startOfWeek, endOfWeek).map(function(event) {

          var weekViewStart = moment(startOfWeek).startOf('day');

          var eventPeriod = getRecurringEventPeriod({
            start: moment(event.startsAt),
            end: moment(event.endsAt || event.startsAt)
          }, event.recursOn, weekViewStart);

          eventPeriod.originalEvent = event;

          return eventPeriod;

        })
      }, isSort).map(function(eventRow) {
        eventRow.row = eventRow.row.map(function(rowEvent) {
          rowEvent.event = rowEvent.event.originalEvent;
          return rowEvent;
        });

        return eventRow;

      });

      return {days: days, eventRows: eventRows};

    }

    function getDayView(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit, dayViewEventWidth) {

      var dayStart = (dayViewStart || '00:00').split(':');
      var dayEnd = (dayViewEnd || '23:59').split(':');

      var view = calendarUtils.getDayView({
        events: events.map(function(event) { // hack required to work with event API
          event.start = event.startsAt;
          event.end = event.endsAt;
          return event;
        }),
        viewDate: viewDate,
        hourSegments: 60 / dayViewSplit,
        dayStart: {
          hour: dayStart[0],
          minute: dayStart[1]
        },
        dayEnd: {
          hour: dayEnd[0],
          minute: dayEnd[1]
        },
        eventWidth: dayViewEventWidth ? +dayViewEventWidth : 150,
        segmentHeight: 30
      });

      // remove hack to work with new event API
      events.forEach(function(event) {
        delete event.start;
        delete event.end;
      });

      return view;

    }

    function getWeekViewWithTimes(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit) {
      var weekView = getWeekView(events, viewDate);
      var newEvents = [];
      var flattenedEvents = [];
      weekView.eventRows.forEach(function(row) {
        row.row.forEach(function(eventRow) {
          flattenedEvents.push(eventRow.event);
        });
      });
      weekView.days.forEach(function(day) {
        var dayEvents = flattenedEvents.filter(function(event) {
          return moment(event.startsAt).startOf('day').isSame(moment(day.date).startOf('day'));
        });
        var newDayEvents = getDayView(
          dayEvents,
          day.date,
          dayViewStart,
          dayViewEnd,
          dayViewSplit
        ).events;
        newEvents = newEvents.concat(newDayEvents);
      });
      weekView.eventRows = [{
        row: newEvents.map(function(dayEvent) {
          var event = dayEvent.event;
          return {
            event: event,
            top: dayEvent.top,
            offset: calendarUtils.getWeekViewEventOffset(
              {start: event.startsAt, end: event.endsAt},
              moment(viewDate).startOf('week')
            )
          };
        })
      }];
      return weekView;
    }

    function getDayViewHeight(dayViewStart, dayViewEnd, dayViewSplit) {
      var dayViewStartM = moment(dayViewStart || '00:00', 'HH:mm');
      var dayViewEndM = moment(dayViewEnd || '23:59', 'HH:mm');
      var hourHeight = (60 / dayViewSplit) * 30;
      return ((dayViewEndM.diff(dayViewStartM, 'minutes') / 60) * hourHeight) + 3;
    }

    function loadTemplates() {
      var promises = [];
      Object.keys(calendarConfig.templates).map(function(key) {
        var templateUrl = calendarConfig.templates[key];
        if(angular.isUndefined($templateCache.get(templateUrl))){
          var deferred = $q.defer();
          $http.get(templateUrl).success(function(data) {
            var templateContents = data
                  .replace('{{', $interpolate.startSymbol())
                  .replace('}}', $interpolate.endSymbol());
              $templateCache.put(templateUrl, templateContents);
              deferred.resolve({
                templateContents: templateContents,
                templateUrl: templateUrl
              });
            }).error(function() {
              deferred.reject();
          });
          promises.push(deferred.promise);
        }else{
          promises.push($templateRequest(templateUrl));
        }
      });

      return $q.all(promises);
    }

    return {
      getWeekDayNames: getWeekDayNames,
      getYearView: getYearView,
      getMonthView: getMonthView,
      getWeekView: getWeekView,
      getDayView: getDayView,
      getWeekViewWithTimes: getWeekViewWithTimes,
      getDayViewHeight: getDayViewHeight,
      adjustEndDateFromStartDiff: adjustEndDateFromStartDiff,
      formatDate: formatDate,
      loadTemplates: loadTemplates,
      eventIsInPeriod: eventIsInPeriod //expose for testing only
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .factory('calendarHelper', calendarHelper);

})();

/**
 * Created by Bruce on 2016/12/7.
 */

(function () {
  'use strict';

  calendarEventTitle.$inject = ['calendarDateFilter', 'calendarTruncateEventTitleFilter'];
  function calendarEventTitle(calendarDateFilter, calendarTruncateEventTitleFilter) {
    function yearView(event) {
      return event.title + ' (' + calendarDateFilter(event.startsAt, 'datetime', true) + ')';
    }

    function monthView(event) {
      return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + calendarDateFilter(event.endsAt, 'time', true) + ' ' + event.title;
      // return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
    }

    function monthViewTooltip(event) {
      return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;
    }

    function weekView(event) {
      return event.title;
    }

    function weekViewTooltip(event) {
      return event.title;
    }

    function dayView(event) {
      return event.allDay ? event.title : calendarTruncateEventTitleFilter(event.title, 20, event.height);
    }

    function dayViewTooltip(event) {
      return event.title;
    }

    return {
      yearView: yearView,
      monthView: monthView,
      monthViewTooltip: monthViewTooltip,
      weekView: weekView,
      weekViewTooltip: weekViewTooltip,
      dayView: dayView,
      dayViewTooltip: dayViewTooltip
    };

  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .factory('calendarEventTitle', calendarEventTitle);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  calendarTrustAsHtml.$inject = ['$sce'];
  function calendarTrustAsHtml($sce) {
    return function(text) {
      return $sce.trustAsHtml(text);
    };
  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .filter('calendarTrustAsHtml', calendarTrustAsHtml);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  calendarTruncateEventTitle.$inject = [];
  function calendarTruncateEventTitle() {
    return function(string, length, boxHeight) {
      if (!string) {
        return '';
      }

      //Only truncate if if actually needs truncating
      if (string.length >= length && string.length / 20 > boxHeight / 30) {
        return string.substr(0, length) + '...';
      } else {
        return string;
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .filter('calendarTruncateEventTitle', calendarTruncateEventTitle);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  calendarLimitTo.$inject = ['limitToFilter'];
  function calendarLimitTo(limitToFilter) {
    if (angular.version.minor >= 4) { //1.4+ supports the begin attribute
      return limitToFilter;
    }

    //Copied from the angular source. Only 1.4 has the begin functionality.
    return function(input, limit, begin) {
      if (Math.abs(Number(limit)) === Infinity) {
        limit = Number(limit);
      } else {
        limit = parseInt(limit);
      }
      if (isNaN(limit)) {
        return input;
      }

      if (angular.isNumber(input)) {
        input = input.toString();
      }
      if (!angular.isArray(input) && !angular.isString(input)) {
        return input;
      }

      begin = (!begin || isNaN(begin)) ? 0 : parseInt(begin);
      begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;

      if (limit >= 0) {
        return input.slice(begin, begin + limit);
      } else if (begin === 0) {
        return input.slice(limit, input.length);
      } else {
        return input.slice(Math.max(0, begin + limit), begin);
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .filter('calendarLimitTo', calendarLimitTo);
})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  calendarDate.$inject = ['calendarHelper', 'calendarConfig'];
  function calendarDate(calendarHelper, calendarConfig) {
    function calendarDate(date, format, getFromConfig) {

      if (getFromConfig === true) {
        format = calendarConfig.dateFormats[format];
      }

      return calendarHelper.formatDate(date, format);

    }

    // This is stateful because the locale can change as well
    // as calendarConfig.dateFormats which would change the value outside of this filter
    calendarDate.$stateful = true;

    return calendarDate;
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .filter('calendarDate', calendarDate);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlResizable.$inject = [];
  function mwlResizable() {
    return {
      restrict: 'A',
      controller: ['$element', '$scope', '$parse', '$attrs', '$timeout', function ($element, $scope, $parse, $attrs, $timeout) {
        if (!interact) {
          return;
        }

        var snap, snapGridDimensions;
        if ($attrs.snapGrid) {
          snapGridDimensions = $parse($attrs.snapGrid)($scope);
          snap = {
            targets: [
              interact.createSnapGrid(snapGridDimensions)
            ]
          };
        }

        var originalDimensions = {};
        var originalDimensionsStyle = {};
        var resizeEdge;

        function getUnitsResized(edge, elm) {
          var unitsResized = {};
          unitsResized.edge = edge;
          if (edge === 'start') {
            unitsResized.x = elm.data('x');
            unitsResized.y = elm.data('y');
          } else if (edge === 'end') {
            unitsResized.x = parseFloat(elm.css('width').replace('px', '')) - originalDimensions.width;
            unitsResized.y = parseFloat(elm.css('height').replace('px', '')) - originalDimensions.height;
          }
          return unitsResized;
        }

        interact($element[0]).resizable({
          edges: $parse($attrs.resizeEdges)($scope),
          snap: snap,
          onstart: function(event) {

            resizeEdge = 'end';
            var elm = angular.element(event.target);
            originalDimensions.height = elm[0].offsetHeight;
            originalDimensions.width = elm[0].offsetWidth;
            originalDimensionsStyle.height = elm.css('height');
            originalDimensionsStyle.width = elm.css('width');

          },
          onmove: function(event) {

            if (event.rect.width > 0 && event.rect.height > 0) {
              var elm = angular.element(event.target);
              var x = parseFloat(elm.data('x') || 0);
              var y = parseFloat(elm.data('y') || 0);

              elm.css({
                width: event.rect.width + 'px',
                height: event.rect.height + 'px'
              });

              // translate when resizing from top or left edges
              x += event.deltaRect.left;
              y += event.deltaRect.top;

              elm.css('transform', 'translate(' + x + 'px,' + y + 'px)');

              elm.data('x', x);
              elm.data('y', y);

              if (event.deltaRect.left !== 0 || event.deltaRect.top !== 0) {
                resizeEdge = 'start';
              }

              if ($attrs.onResize) {
                $parse($attrs.onResize)($scope, getUnitsResized(resizeEdge, elm));
                $scope.$apply();
              }

            }

          },
          onend: function(event) {

            var elm = angular.element(event.target);
            var unitsResized = getUnitsResized(resizeEdge, elm);

            $timeout(function() {
              elm
                .data('x', null)
                .data('y', null)
                .css({
                  transform: '',
                  width: originalDimensionsStyle.width,
                  height: originalDimensionsStyle.height
                });
            });

            if ($attrs.onResizeEnd) {
              $parse($attrs.onResizeEnd)($scope, unitsResized);
              $scope.$apply();
            }

          }
        });

        $scope.$watch($attrs.mwlResizable, function(enabled) {
          interact($element[0]).resizable({
            enabled: enabled
          });
        });

        $scope.$on('$destroy', function() {
          interact($element[0]).unset();
        });
      }]
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlResizable', mwlResizable);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlElementDimensions.$inject = [];
  function mwlElementDimensions() {
    return {
      restrict: 'A',
      controller: ['$element', '$scope', '$parse', '$attrs', '$window', function ($element, $scope, $parse, $attrs, $window) {
        function setDimensions() {
          $parse($attrs.mwlElementDimensions).assign($scope, {
            width: $element[0].offsetWidth - 1,
            height: $element[0].offsetHeight
          });
          $scope.$applyAsync();
        }

        var win = angular.element($window);

        win.bind('resize', setDimensions);

        setDimensions();

        $scope.$on('$destroy', function() {
          win.unbind('resize', setDimensions);
        });
      }]
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlElementDimensions', mwlElementDimensions);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlDynamicDirectiveTemplate.$inject = [];
  function mwlDynamicDirectiveTemplate() {
    return {
      restrict: 'A',
      controller: ['$http', '$compile', '$scope', '$attrs', '$element', '$templateCache', '$interpolate', '$log', 'calendarConfig', 'calendarHelper',
        function ($http, $compile, $scope, $attrs, $element, $templateCache, $interpolate, $log, calendarConfig, calendarHelper) {
        $scope.$watch($attrs.overrides, function(overrides) {

          var templateName = calendarConfig.templates[$attrs.name];

          if ( overrides && angular.isObject(overrides) && overrides[$attrs.name] ) {
            if ($templateCache.get(overrides[$attrs.name])) {
              templateName = overrides[$attrs.name];
            } else {
              $log.warn('Bootstrap Calendar', 'The custom template for ' + overrides[$attrs.name] +
                ' was not found in the template cache. Please ensure it is pre-loaded via a script tag ' +
                '<script type="text/ng-template" id="' + overrides[$attrs.name] + '">Custom template content</script> or ' +
                'via a tool such as https://www.npmjs.com/package/gulp-angular-templatecache');
            }
          }

          calendarHelper.loadTemplates().then(function () {
            var template = $templateCache.get(templateName);
            $element.html(template);
            $compile($element.contents())($scope);
          });

        });
      }]
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlDynamicDirectiveTemplate', mwlDynamicDirectiveTemplate);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlDroppable.$inject = [];
  function mwlDroppable() {

    return {
      restrict: 'A',
      controller: ['$element', '$scope', '$parse', '$attrs', function ($element, $scope, $parse, $attrs) {
        if (!interact) {
          return;
        }

        var DROP_ACTIVE_CLASS = $attrs.dropActiveClass || 'drop-active';

        interact($element[0]).dropzone({
          ondragenter: function(event) {
            angular.element(event.target).addClass(DROP_ACTIVE_CLASS);
          },
          ondragleave: function(event) {
            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
          },
          ondropdeactivate: function(event) {
            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
          },
          ondrop: function(event) {
            if (event.relatedTarget.dropData) {
              $parse($attrs.onDrop)($scope, {dropData: event.relatedTarget.dropData});
              $scope.$apply();
            }
          }
        });

        $scope.$on('$destroy', function() {
          interact($element[0]).unset();
        });
      }]
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlDroppable', mwlDroppable);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlDraggable.$inject = [];
  function mwlDraggable() {
    return {
      restrict: 'A',
      controller: ['$element', '$scope', '$window', '$parse', '$attrs', '$timeout', function ($element, $scope, $window, $parse, $attrs, $timeout) {

        if (!interact) {
          return;
        }

        var snap, snapGridDimensions;
        if ($attrs.snapGrid) {
          snapGridDimensions = $parse($attrs.snapGrid)($scope);
          snap = {
            targets: [
              interact.createSnapGrid(snapGridDimensions)
            ]
          };
        }

        function translateElement(elm, transformValue) {
          return elm
            .css('-ms-transform', transformValue)
            .css('-webkit-transform', transformValue)
            .css('transform', transformValue);
        }

        interact($element[0]).draggable({
          snap: snap,
          onstart: function(event) {
            angular.element(event.target).addClass('dragging-active');
            event.target.dropData = $parse($attrs.dropData)($scope);
            event.target.style.pointerEvents = 'none';
            if ($attrs.onDragStart) {
              $parse($attrs.onDragStart)($scope);
              $scope.$apply();
            }
          },
          onmove: function(event) {

            var elm = angular.element(event.target);
            var x = (parseFloat(elm.attr('data-x')) || 0) + (event.dx || 0);
            var y = (parseFloat(elm.attr('data-y')) || 0) + (event.dy || 0);

            switch ($parse($attrs.axis)($scope)) {
              case 'x':
                y = 0;
                break;

              case 'y':
                x = 0;
                break;

              default:
            }

            if ($window.getComputedStyle(elm[0]).position === 'static') {
              elm.css('position', 'relative');
            }

            translateElement(elm, 'translate(' + x + 'px, ' + y + 'px)')
              .css('z-index', 50)
              .attr('data-x', x)
              .attr('data-y', y);

            if ($attrs.onDrag) {
              $parse($attrs.onDrag)($scope, {x: x, y: y});
              $scope.$apply();
            }

          },
          onend: function(event) {

            var elm = angular.element(event.target);
            var x = elm.attr('data-x');
            var y = elm.attr('data-y');

            event.target.style.pointerEvents = 'auto';
            if ($attrs.onDragEnd) {
              $parse($attrs.onDragEnd)($scope, {x: x, y: y});
              $scope.$apply();
            }

            $timeout(function() {
              translateElement(elm, '')
                .css('z-index', 'auto')
                .removeAttr('data-x')
                .removeAttr('data-y')
                .removeClass('dragging-active');
            });

          }
        });

        $scope.$watch($attrs.mwlDraggable, function(enabled) {
          interact($element[0]).draggable({
            enabled: enabled
          });
        });

        $scope.$on('$destroy', function() {
          interact($element[0]).unset();
        });
      }]
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlDraggable', mwlDraggable);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlDragSelect.$inject = [];
  function mwlDragSelect() {
    return {
      restrict: 'A',
      controller: ['$scope', '$element', '$parse', '$attrs', function ($scope, $element, $parse, $attrs) {
        function handleMouseEvent(callbackName) {
          return function(event) {
            if (callbackName) {
              $parse(callbackName)($scope);
              $scope.$apply();
            }
            event.preventDefault();
          };
        }

        var onMouseDown = handleMouseEvent($attrs.onDragSelectStart);
        var onMouseMove = handleMouseEvent($attrs.onDragSelectMove);
        var onMouseUp = handleMouseEvent($attrs.onDragSelectEnd);

        function enableMouseListeners() {
          $element.on('mousedown', onMouseDown);
          $element.on('mousemove', onMouseMove);
          $element.on('mouseup', onMouseUp);
        }

        function disableMouseListeners() {
          $element.off('mousedown', onMouseDown);
          $element.off('mousemove', onMouseMove);
          $element.off('mouseup', onMouseUp);
        }

        $scope.$watch($attrs.mwlDragSelect, function(isEnabled) {
          if (isEnabled) {
            enableMouseListeners();
          } else {
            disableMouseListeners();
          }
        });

        $scope.$on('$destroy', function() {
          disableMouseListeners();
        });
      }]
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlDragSelect', mwlDragSelect);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlDateModifier.$inject = [];
  function mwlDateModifier() {
    return {
      restrict: 'A',
      controller: ['$element', '$attrs', '$scope', 'datePickerUtils', function ($element, $attrs, $scope, datePickerUtils) {
        var vm = this;
        vm.callbackOnSetDate = $attrs.dateChange ? datePickerUtils.findFunction($scope, $attrs.dateChange) : undefined;

        function onClick() {
          if (angular.isDefined($attrs.setToToday)) {
            vm.date = new Date();
          } else if (angular.isDefined($attrs.increment)) {
            vm.date = moment(vm.date).add(1, vm.increment).toDate();
          } else if (angular.isDefined($attrs.decrement)) {
            vm.date = moment(vm.date).subtract(1, vm.decrement).toDate();
          }
          $scope.$apply();

          //This is duplicated in the new functionality.
          if (vm.callbackOnSetDate) {
            // scope.callbackOnSetDate(attrs.datePicker, scope.date, isOnlyDay);
            vm.callbackOnSetDate(vm.date, false);
          }
        }

        $element.bind('click', onClick);

        $scope.$on('$destroy', function() {
          $element.unbind('click', onClick);
        });
      }],
      controllerAs: '$ctrl',
      scope: {
        date: '=',
        increment: '=',
        decrement: '='
      },
      bindToController: true
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlDateModifier', mwlDateModifier);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  mwlCollapseFallback.$inject = ['$injector'];
  function mwlCollapseFallback($injector) {
    if ($injector.has('uibCollapseDirective')) {
      return {};
    }

    return {
      restrict: 'A',
      controller: ['$scope', '$attrs', '$element', function ($scope, $attrs, $element) {
        $scope.$watch($attrs.mwlCollapseFallback, function(shouldCollapse) {
          if (shouldCollapse) {
            $element.addClass('ng-hide');
          } else {
            $element.removeClass('ng-hide');
          }
        });
      }]
    };

  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .directive('mwlCollapseFallback', mwlCollapseFallback);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  var calendarConfig = {
    allDateFormats: {
      angular: {
        date: {
          hour: 'ha',
          day: 'd MMM',
          month: 'MMMM',
          weekDay: 'EEEE',
          time: 'HH:mm',
          datetime: 'MMM d, h:mm a'
        },
        title: {
          day: 'EEEE d MMMM, yyyy',
          week: 'WEEK_OF_YEAR', // RC, {week}{year}
          month: 'MMMM yyyy',
          year: 'yyyy'
        }
      },
      moment: {
        date: {
          hour: 'ha',
          day: 'MMMM Do',
          month: 'MMMM',
          weekDay: 'dddd',
          time: 'HH:mm',
          datetime: 'MMM D, h:mm a'
        },
        title: {
          day: 'dddd D MMMM, YYYY',
          week: 'WEEK_OF_YEAR', // RC ,{week}{year}
          // week: 'Week {week} of {year}',
          month: 'MMMM YYYY',
          year: 'YYYY'
        }
      }
    },
    get dateFormats() {
      return this.allDateFormats[this.dateFormatter].date;
    },
    get titleFormats() {
      return this.allDateFormats[this.dateFormatter].title;
    },
    dateFormatter: 'moment', // default angular
    showTimesOnWeekView: false,
    isSortEventOnWeekView: false, // sort week view event
    displayAllMonthEvents: true,
    i18nStrings: {
      weekNumber: 'Week {week}'
    },
    templates: {
      calendar: 'app/kernel/ui-elements/ui-calendar/views/calendar.html',
      calendarDayView: 'app/kernel/ui-elements/ui-calendar/views/calendarDayView.html',
      calendarHourList: 'app/kernel/ui-elements/ui-calendar/views/calendarHourList.html',
      calendarMonthCell: 'app/kernel/ui-elements/ui-calendar/views/calendarMonthCell.html',
      calendarMonthCellEvents: 'app/kernel/ui-elements/ui-calendar/views/calendarMonthCellEvents.html',
      calendarMonthView : 'app/kernel/ui-elements/ui-calendar/views/calendarMonthView.html',
      calendarSlideBox:'app/kernel/ui-elements/ui-calendar/views/calendarSlideBox.html',
      calendarWeekView: 'app/kernel/ui-elements/ui-calendar/views/calendarWeekView.html',
      calendarYearView: 'app/kernel/ui-elements/ui-calendar/views/calendarYearView.html'
    },
    colorTypes: {
      info: {
        primary: '#1e90ff',
        secondary: '#d1e8ff'
      },
      important: {
        primary: '#ad2121',
        secondary: '#fae3e3'
      },
      warning: {
        primary: '#e3bc08',
        secondary: '#fdf1ba'
      },
      inverse: {
        primary: '#1b1b1b',
        secondary: '#c1c1c1'
      },
      special: {
        primary: '#800080',
        secondary: '#ffe6ff'
      },
      success: {
        primary: '#006400',
        secondary: '#caffca'
      },

      room: {
        primary: '#4DAEA5',
        secondary: 'rgba(77, 174, 165, 0.55)'
      },
      train: {
        primary: '#E98BAB',
        secondary: 'rgba(233, 139, 171, 0.55)'
      },
      test: {
        primary: '#4ca64f',
        secondary: 'rgba(76, 166, 79, 0.55)'
      }
    }
  };
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .constant('calendarConfig', calendarConfig);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';
  var LOG_PREFIX = 'Bootstrap calendar:';
  var mwlCalendar = {
    template: '<div mwl-dynamic-directive-template name="calendar" overrides="$ctrl.customTemplateUrls"></div>',
    bindings: {
      events: '=',
      view: '=',
      viewTitle: '=?',
      viewDate: '=',
      cellIsOpen: '=?',
      cellAutoOpenDisabled: '=?',
      slideBoxDisabled: '=?',
      customTemplateUrls: '=?',
      onEventClick: '&',
      onEventTimesChanged: '&',
      onTimespanClick: '&',
      onDateRangeSelect: '&?',
      onViewChangeClick: '&',
      cellModifier: '&',
      dayViewStart: '@',
      dayViewEnd: '@',
      dayViewSplit: '@',
      dayViewEventChunkSize: '@',
      dayViewEventWidth: '@',
      templateScope: '=?',
      weekNumberLabelDisabled: '=?'
    },
    controller: MwlCalendarCtrl
  };

  MwlCalendarCtrl.$inject = ['$scope', '$log', '$timeout', '$attrs', '$locale', 'calendarTitle', 'calendarHelper'];
  function MwlCalendarCtrl($scope, $log, $timeout, $attrs, $locale, calendarTitle, calendarHelper) {
    var vm = this;
    if (vm.slideBoxDisabled) {
      $log.warn(LOG_PREFIX, 'The `slide-box-disabled` option is deprecated and will be removed in the next release. ' +
        'Instead set `cell-auto-open-disabled` to true');
    }

    vm.events = vm.events || [];

    vm.changeView = function(view, newDay) {
      vm.view = view;
      vm.viewDate = newDay;
    };

    vm.dateClicked = function(date) {
      var rawDate = moment(date).toDate();

      var nextView = {
        year: 'month',
        month: 'day',
        week: 'day'
      };

      if (vm.onViewChangeClick({calendarDate: rawDate, calendarNextView: nextView[vm.view]}) !== false) {
        vm.changeView(nextView[vm.view], rawDate);
      }

    };

    var previousDate = moment(vm.viewDate);
    var previousView = vm.view;

    function checkEventIsValid(event) {
      if (!event.startsAt) {
        $log.warn(LOG_PREFIX, 'Event is missing the startsAt field', event);
      } else if (!angular.isDate(event.startsAt)) {
        $log.warn(LOG_PREFIX, 'Event startsAt should be a javascript date object. Do `new Date(event.startsAt)` to fix it.', event);
      }

      if (event.endsAt) {
        if (!angular.isDate(event.endsAt)) {
          $log.warn(LOG_PREFIX, 'Event endsAt should be a javascript date object. Do `new Date(event.endsAt)` to fix it.', event);
        }
        if (moment(event.startsAt).isAfter(moment(event.endsAt))) {
          $log.warn(LOG_PREFIX, 'Event cannot start after it finishes', event);
        }
      }
    }

    function refreshCalendar() {

      if (calendarTitle[vm.view] && angular.isDefined($attrs.viewTitle)) {
        vm.viewTitle = calendarTitle[vm.view](vm.viewDate);
      }

      vm.events.forEach(function(event, index) {
        checkEventIsValid(event);
        event.calendarEventId = index;
      });

      //if on-timespan-click="calendarDay = calendarDate" is set then don't update the view as nothing needs to change
      var currentDate = moment(vm.viewDate);
      var shouldUpdate = true;
      if (
        previousDate.clone().startOf(vm.view).isSame(currentDate.clone().startOf(vm.view)) &&
        !previousDate.isSame(currentDate) &&
        vm.view === previousView
      ) {
        shouldUpdate = false;
      }
      previousDate = currentDate;
      previousView = vm.view;

      if (shouldUpdate) {
        // a $timeout is required as $broadcast is synchronous so if a new events array is set the calendar won't update
        $timeout(function() {
          $scope.$broadcast('calendar.refreshView');
        });
      }
    }

    calendarHelper.loadTemplates().then(function() {
      vm.templatesLoaded = true;
      var eventsWatched = false;
      //Refresh the calendar when any of these variables change.
      $scope.$watchGroup([
        '$ctrl.viewDate',
        '$ctrl.view',
        '$ctrl.cellIsOpen',
        function() {
          return moment.locale() + $locale.id; //Auto update the calendar when the locale changes
        }
      ], function() {
        if (!eventsWatched) {
          eventsWatched = true;
          //need to deep watch events hence why it isn't included in the watch group
          $scope.$watch('$ctrl.events', refreshCalendar, true); //this will call refreshCalendar when the watcher starts (i.e. now)
        } else {
          refreshCalendar();
        }
      });

    }).catch(function(err) {
      $log.error('Could not load all calendar templates', err);
    });
  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .component('mwlCalendar', mwlCalendar);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  var mwlCalendarYear = {
    template: '<div mwl-dynamic-directive-template name="calendarYearView" overrides="$ctrl.customTemplateUrls"></div>',
    require: {
      calendarCtrl: '^mwlCalendar'
    },
    bindings: {
      events: '=',
      viewDate: '=',
      onEventClick: '=',
      onEventTimesChanged: '=',
      cellIsOpen: '=',
      cellAutoOpenDisabled: '=',
      onTimespanClick: '=',
      cellModifier: '=',
      slideBoxDisabled: '=',
      customTemplateUrls: '=?',
      templateScope: '='
    },
    controller: MwlCalendarYearCtrl
  };

  MwlCalendarYearCtrl.$inject = ['$scope', 'calendarHelper'];
  function MwlCalendarYearCtrl($scope, calendarHelper) {
    var vm = this;
    vm.openMonthIndex = null;

    function toggleCell() {
      vm.openRowIndex = null;
      vm.openMonthIndex = null;

      if (vm.cellIsOpen && vm.view) {
        vm.view.forEach(function(month, monthIndex) {
          if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
            vm.openMonthIndex = monthIndex;
            vm.openRowIndex = Math.floor(monthIndex / 4);
          }
        });
      }
    }

    $scope.$on('calendar.refreshView', function() {
      vm.view = calendarHelper.getYearView(vm.events, vm.viewDate, vm.cellModifier);

      if (vm.cellAutoOpenDisabled) {
        toggleCell();
      } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openMonthIndex === null) {
        //Auto open the calendar to the current day if set
        vm.openMonthIndex = null;
        vm.view.forEach(function(month) {
          if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
            vm.monthClicked(month, true);
          }
        });
      }

    });

    if (vm.cellAutoOpenDisabled) {
      $scope.$watchGroup([
        '$ctrl.cellIsOpen',
        '$ctrl.viewDate'
      ], toggleCell);
    }

    vm.monthClicked = function(month, monthClickedFirstRun, $event) {

      if (!monthClickedFirstRun) {
        vm.onTimespanClick({
          calendarDate: month.date.toDate(),
          calendarCell: month,
          $event: $event
        });
        if ($event && $event.defaultPrevented) {
          return;
        }
      }

      if (!vm.cellAutoOpenDisabled) {
        vm.openRowIndex = null;
        var monthIndex = vm.view.indexOf(month);
        if (monthIndex === vm.openMonthIndex) { //the month has been clicked and is already open
          vm.openMonthIndex = null; //close the open month
          vm.cellIsOpen = false;
        } else {
          vm.openMonthIndex = monthIndex;
          vm.openRowIndex = Math.floor(monthIndex / 4);
          vm.cellIsOpen = true;
        }
      }

    };

    vm.handleEventDrop = function(event, newMonthDate) {
      var newStart = moment(event.startsAt)
        .month(moment(newMonthDate).month())
        .year(moment(newMonthDate).year());
      var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

      vm.onEventTimesChanged({
        calendarEvent: event,
        calendarDate: newMonthDate,
        calendarNewEventStart: newStart.toDate(),
        calendarNewEventEnd: newEnd ? newEnd.toDate() : null
      });
    };

    this.$postLink = function() {
      $scope.$ctrl.calendarCtrl = this.calendarCtrl;
    };

  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .component('mwlCalendarYear', mwlCalendarYear);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  var mwlCalendarWeek = {
    template: '<div mwl-dynamic-directive-template name="calendarWeekView" overrides="$ctrl.customTemplateUrls"></div>',
    require: {
      calendarCtrl: '^mwlCalendar'
    },
    bindings: {
      events: '=',
      viewDate: '=',
      onEventClick: '=',
      onEventTimesChanged: '=',
      dayViewStart: '=',
      dayViewEnd: '=',
      dayViewSplit: '=',
      dayViewEventChunkSize: '=',
      onTimespanClick: '=',
      onDateRangeSelect: '=',
      customTemplateUrls: '=?',
      cellModifier: '=',
      templateScope: '='
    },
    controller: MwlCalendarWeekCtrl
  };

  MwlCalendarWeekCtrl.$inject = ['$scope', 'calendarHelper', 'calendarConfig', 'calendarEventTitle'];
  function MwlCalendarWeekCtrl($scope, calendarHelper, calendarConfig, calendarEventTitle) {
    var vm = this;

    vm.showTimes = calendarConfig.showTimesOnWeekView;
    vm.calendarEventTitle = calendarEventTitle;

    $scope.$on('calendar.refreshView', function() {
      vm.dayViewSplit = vm.dayViewSplit || 30;
      vm.dayViewHeight = calendarHelper.getDayViewHeight(
        vm.dayViewStart,
        vm.dayViewEnd,
        vm.dayViewSplit
      );
      if (vm.showTimes) {
        vm.view = calendarHelper.getWeekViewWithTimes(
          vm.events,
          vm.viewDate,
          vm.dayViewStart,
          vm.dayViewEnd,
          vm.dayViewSplit
        );
      } else {
        vm.view = calendarHelper.getWeekView(vm.events, vm.viewDate, calendarConfig.isSortEventOnWeekView);
      }
    });

    vm.weekDragged = function(event, daysDiff, minuteChunksMoved) {

      var newStart = moment(event.startsAt).add(daysDiff, 'days');
      var newEnd = moment(event.endsAt).add(daysDiff, 'days');

      if (minuteChunksMoved) {
        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
        newStart = newStart.add(minutesDiff, 'minutes');
        newEnd = newEnd.add(minutesDiff, 'minutes');
      }

      delete event.tempStartsAt;

      vm.onEventTimesChanged({
        calendarEvent: event,
        calendarNewEventStart: newStart.toDate(),
        calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
      });
    };

    vm.eventDropped = function(event, date) {
      var daysDiff = moment(date).diff(moment(event.startsAt), 'days');
      vm.weekDragged(event, daysDiff);
    };

    vm.weekResized = function(event, edge, daysDiff) {

      var start = moment(event.startsAt);
      var end = moment(event.endsAt);
      if (edge === 'start') {
        start.add(daysDiff, 'days');
      } else {
        end.add(daysDiff, 'days');
      }

      vm.onEventTimesChanged({
        calendarEvent: event,
        calendarNewEventStart: start.toDate(),
        calendarNewEventEnd: end.toDate()
      });

    };

    vm.tempTimeChanged = function(event, minuteChunksMoved) {
      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
      event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
    };

    this.$postLink = function() {
      $scope.$ctrl.calendarCtrl = this.calendarCtrl;
    };

  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .component('mwlCalendarWeek', mwlCalendarWeek);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  var mwlCalendarSlideBox = {
    template: '<div mwl-dynamic-directive-template name="calendarSlideBox" overrides="$ctrl.customTemplateUrls"></div>',
    require: {
      mwlCalendarMonth: '^?mwlCalendarMonth',
      mwlCalendarYear: '^?mwlCalendarYear'
    },
    bindings: {
      isOpen: '=',
      events: '=',
      onEventClick: '=',
      cell: '=',
      customTemplateUrls: '=?',
      templateScope: '='
    },
    controller: MwlCalendarSlideBoxCtrl
  };

  MwlCalendarSlideBoxCtrl.$inject = ['$scope', '$timeout', 'calendarConfig', 'calendarEventTitle'];
  function MwlCalendarSlideBoxCtrl($scope, $timeout, calendarConfig, calendarEventTitle) {
    var vm = this;
    vm.calendarConfig = calendarConfig;
    vm.calendarEventTitle = calendarEventTitle;

    vm.isCollapsed = true;
    $scope.$watch('$ctrl.isOpen', function(isOpen) {
      //events must be populated first to set the element height before animation will work
      $timeout(function() {
        vm.isCollapsed = !isOpen;
      });
    });

    this.$postLink = function() {
      $scope.isMonthView = !!this.mwlCalendarMonth;
      $scope.isYearView = !!this.mwlCalendarYear;
    };

  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .component('mwlCalendarSlideBox', mwlCalendarSlideBox);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  var mwlCalendarMonth = {
    template: '<div mwl-dynamic-directive-template name="calendarMonthView" overrides="$ctrl.customTemplateUrls"></div>',
    require: {
      calendarCtrl: '^mwlCalendar'
    },
    bindings: {
      events: '=',
      viewDate: '=',
      onEventClick: '=',
      onEventTimesChanged: '=',
      onDateRangeSelect: '=',
      cellIsOpen: '=',
      cellAutoOpenDisabled: '=',
      onTimespanClick: '=',
      cellModifier: '=',
      slideBoxDisabled: '=',
      customTemplateUrls: '=?',
      templateScope: '=',
      weekNumberLabelDisabled: '=?'
    },
    controller: MwlCalendarMonthCtrl
  };

  MwlCalendarMonthCtrl.$inject = ['$scope', 'calendarHelper', 'calendarConfig', 'calendarEventTitle'];
  function MwlCalendarMonthCtrl($scope, calendarHelper, calendarConfig, calendarEventTitle) {
    var vm = this;
    vm.calendarConfig = calendarConfig;
    vm.calendarEventTitle = calendarEventTitle;
    vm.openRowIndex = null;

    function toggleCell() {
      vm.openRowIndex = null;
      vm.openDayIndex = null;

      if (vm.cellIsOpen && vm.view) {
        vm.view.forEach(function(day, dayIndex) {
          if (moment(vm.viewDate).startOf('day').isSame(day.date)) {
            vm.openDayIndex = dayIndex;
            vm.openRowIndex = Math.floor(dayIndex / 7);
          }
        });
      }
    }

    $scope.$on('calendar.refreshView', function() {

      vm.weekDays = calendarHelper.getWeekDayNames();

      var monthView = calendarHelper.getMonthView(vm.events, vm.viewDate, vm.cellModifier);
      vm.view = monthView.days;
      vm.monthOffsets = monthView.rowOffsets;

      if (vm.cellAutoOpenDisabled) {
        toggleCell();
      } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openRowIndex === null) {
        //Auto open the calendar to the current day if set
        vm.openDayIndex = null;
        vm.view.forEach(function(day) {
          if (day.inMonth && moment(vm.viewDate).startOf('day').isSame(day.date)) {
            vm.dayClicked(day, true);
          }
        });
      }

    });

    if (vm.cellAutoOpenDisabled) {
      $scope.$watchGroup([
        '$ctrl.cellIsOpen',
        '$ctrl.viewDate'
      ], toggleCell);
    }

    vm.dayClicked = function(day, dayClickedFirstRun, $event) {

      if (!dayClickedFirstRun) {
        vm.onTimespanClick({
          calendarDate: day.date.toDate(),
          calendarCell: day,
          $event: $event
        });
        if ($event && $event.defaultPrevented) {
          return;
        }
      }

      if (!vm.cellAutoOpenDisabled) {
        vm.openRowIndex = null;
        var dayIndex = vm.view.indexOf(day);
        if (dayIndex === vm.openDayIndex) { //the day has been clicked and is already open
          vm.openDayIndex = null; //close the open day
          vm.cellIsOpen = false;
        } else {
          vm.openDayIndex = dayIndex;
          vm.openRowIndex = Math.floor(dayIndex / 7);
          vm.cellIsOpen = true;
        }
      }

    };

    vm.highlightEvent = function(event, shouldAddClass) {

      vm.view.forEach(function(day) {
        delete day.highlightClass;
        delete day.backgroundColor;
        if (shouldAddClass) {
          var dayContainsEvent = day.events.indexOf(event) > -1;
          if (dayContainsEvent) {
            day.backgroundColor = event.color ? event.color.secondary : '';
          }
        }
      });

    };

    vm.handleEventDrop = function(event, newDayDate, draggedFromDate) {

      var newStart = moment(event.startsAt)
        .date(moment(newDayDate).date())
        .month(moment(newDayDate).month())
        .year(moment(newDayDate).year());

      var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

      vm.onEventTimesChanged({
        calendarEvent: event,
        calendarDate: newDayDate,
        calendarNewEventStart: newStart.toDate(),
        calendarNewEventEnd: newEnd ? newEnd.toDate() : null,
        calendarDraggedFromDate: draggedFromDate
      });
    };

    vm.getWeekNumberLabel = function(day) {
      var weekNumber = day.date.clone().add(1, 'day').isoWeek();
      if (angular.isFunction(calendarConfig.i18nStrings.weekNumber)) {
        return calendarConfig.i18nStrings.weekNumber({weekNumber: weekNumber});
      } else {
        return calendarConfig.i18nStrings.weekNumber.replace('{week}', weekNumber);
      }
    };

    vm.onDragSelectStart = function(day) {
      if (!vm.dateRangeSelect) {
        vm.dateRangeSelect = {
          startDate: day.date,
          endDate: day.date
        };
      }
    };

    vm.onDragSelectMove = function(day) {
      if (vm.dateRangeSelect) {
        vm.dateRangeSelect.endDate = day.date;
      }
    };

    vm.onDragSelectEnd = function(day) {
      vm.dateRangeSelect.endDate = day.date;
      if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
        vm.onDateRangeSelect({
          calendarRangeStartDate: vm.dateRangeSelect.startDate.clone().startOf('day').toDate(),
          calendarRangeEndDate: vm.dateRangeSelect.endDate.clone().endOf('day').toDate()
        });
      }
      delete vm.dateRangeSelect;
    };

    this.$postLink = function() {
      $scope.$ctrl.calendarCtrl = this.calendarCtrl;
    };

  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .component('mwlCalendarMonth', mwlCalendarMonth);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  var mwlCalendarHourList = {
    template: '<div mwl-dynamic-directive-template name="calendarHourList" overrides="$ctrl.customTemplateUrls"></div>',
    bindings: {
      viewDate: '=',
      dayViewStart: '=',
      dayViewEnd: '=',
      dayViewSplit: '=',
      dayWidth: '=?',
      onTimespanClick: '=',
      onDateRangeSelect: '=',
      onEventTimesChanged: '=',
      customTemplateUrls: '=?',
      cellModifier: '=',
      templateScope: '='
    },
    controller: MwlCalendarHourListCtrl
  };

  MwlCalendarHourListCtrl.$inject = ['$scope', 'calendarHelper', 'calendarConfig', 'calendarUtils'];
  function MwlCalendarHourListCtrl($scope, calendarHelper, calendarConfig, calendarUtils) {
    var vm = this;

    function updateDays() {

      vm.dayViewSplit = parseInt(vm.dayViewSplit);
      var dayStart = (vm.dayViewStart || '00:00').split(':');
      var dayEnd = (vm.dayViewEnd || '23:59').split(':');
      vm.hourGrid = calendarUtils.getDayViewHourGrid({
        viewDate: calendarConfig.showTimesOnWeekView ? moment(vm.viewDate).startOf('week').toDate() : moment(vm.viewDate).toDate(),
        hourSegments: 60 / vm.dayViewSplit,
        dayStart: {
          hour: dayStart[0],
          minute: dayStart[1]
        },
        dayEnd: {
          hour: dayEnd[0],
          minute: dayEnd[1]
        }
      });

      vm.hourGrid.forEach(function(hour) {
        hour.segments.forEach(function(segment) {

          segment.date = moment(segment.date);
          segment.nextSegmentDate = segment.date.clone().add(vm.dayViewSplit, 'minutes');

          if (calendarConfig.showTimesOnWeekView) {

            segment.days = [];

            for (var i = 0; i < 7; i++) {
              var day = {
                date: moment(segment.date).add(i, 'days')
              };
              day.nextSegmentDate = day.date.clone().add(vm.dayViewSplit, 'minutes');
              vm.cellModifier({calendarCell: day});
              segment.days.push(day);
            }

          } else {
            vm.cellModifier({calendarCell: segment});
          }

        });
      });

    }

    var originalLocale = moment.locale();

    $scope.$on('calendar.refreshView', function() {

      if (originalLocale !== moment.locale()) {
        originalLocale = moment.locale();
        updateDays();
      }

    });

    $scope.$watchGroup([
      '$ctrl.dayViewStart',
      '$ctrl.dayViewEnd',
      '$ctrl.dayViewSplit',
      '$ctrl.viewDate'
    ], function() {
      updateDays();
    });

    vm.eventDropped = function(event, date) {
      var newStart = moment(date);
      var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

      vm.onEventTimesChanged({
        calendarEvent: event,
        calendarDate: date,
        calendarNewEventStart: newStart.toDate(),
        calendarNewEventEnd: newEnd ? newEnd.toDate() : null
      });
    };

    vm.onDragSelectStart = function(date, dayIndex) {
      if (!vm.dateRangeSelect) {
        vm.dateRangeSelect = {
          active: true,
          startDate: date,
          endDate: date,
          dayIndex: dayIndex
        };
      }
    };

    vm.onDragSelectMove = function(date) {
      if (vm.dateRangeSelect) {
        vm.dateRangeSelect.endDate = date;
      }
    };

    vm.onDragSelectEnd = function(date) {
      if (vm.dateRangeSelect) {
        vm.dateRangeSelect.endDate = date;
        if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
          vm.onDateRangeSelect({calendarRangeStartDate: vm.dateRangeSelect.startDate, calendarRangeEndDate: vm.dateRangeSelect.endDate});
        }
        delete vm.dateRangeSelect;
      }
    };
  }
  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .component('mwlCalendarHourList', mwlCalendarHourList);

})();

/**
 * Created by Bruce on 2016/12/7.
 */
(function () {
  'use strict';

  var mwlCalendarDay = {
    template: '<div mwl-dynamic-directive-template name="calendarDayView" overrides="$ctrl.customTemplateUrls"></div>',
    require: '^mwlCalendar',
    bindings:{
      events: '=',
      viewDate: '=',
      onEventClick: '=',
      onEventTimesChanged: '=',
      onTimespanClick: '=',
      onDateRangeSelect: '=',
      dayViewStart: '=',
      dayViewEnd: '=',
      dayViewSplit: '=',
      dayViewEventChunkSize: '=',
      dayViewEventWidth: '=',
      customTemplateUrls: '=?',
      cellModifier: '=',
      templateScope: '='
    },
    controller: MwlCalendarDayCtrl
  };

  MwlCalendarDayCtrl.$inject = ['$scope', 'calendarHelper', 'calendarEventTitle'];
  function MwlCalendarDayCtrl($scope, calendarHelper, calendarEventTitle) {
    var vm = this;

    vm.calendarEventTitle = calendarEventTitle;

    function refreshView() {
      vm.dayViewSplit = vm.dayViewSplit || 30;
      vm.dayViewHeight = calendarHelper.getDayViewHeight(
        vm.dayViewStart,
        vm.dayViewEnd,
        vm.dayViewSplit
      );

      var view = calendarHelper.getDayView(
        vm.events,
        vm.viewDate,
        vm.dayViewStart,
        vm.dayViewEnd,
        vm.dayViewSplit,
        vm.dayViewEventWidth
      );

      vm.allDayEvents = view.allDayEvents;
      vm.nonAllDayEvents = view.events;
      vm.viewWidth = view.width + 62;

    }

    $scope.$on('calendar.refreshView', refreshView);

    $scope.$watchGroup([
      '$ctrl.dayViewStart',
      '$ctrl.dayViewEnd',
      '$ctrl.dayViewSplit'
    ], refreshView);

    vm.eventDragComplete = function(event, minuteChunksMoved) {
      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
      var newStart = moment(event.startsAt).add(minutesDiff, 'minutes');
      var newEnd = moment(event.endsAt).add(minutesDiff, 'minutes');
      delete event.tempStartsAt;

      vm.onEventTimesChanged({
        calendarEvent: event,
        calendarNewEventStart: newStart.toDate(),
        calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
      });
    };

    vm.eventDragged = function(event, minuteChunksMoved) {
      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
      event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
    };

    vm.eventResizeComplete = function(event, edge, minuteChunksMoved) {
      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
      var start = moment(event.startsAt);
      var end = moment(event.endsAt);
      if (edge === 'start') {
        start.add(minutesDiff, 'minutes');
      } else {
        end.add(minutesDiff, 'minutes');
      }
      delete event.tempStartsAt;

      vm.onEventTimesChanged({
        calendarEvent: event,
        calendarNewEventStart: start.toDate(),
        calendarNewEventEnd: end.toDate()
      });
    };

    vm.eventResized = function(event, edge, minuteChunksMoved) {
      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
      if (edge === 'start') {
        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiCalendar')
    .component('mwlCalendarDay', mwlCalendarDay);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.treeTable',[]);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTableOrderBy.$inject = ['$filter'];
  function TreeTableOrderBy($filter) {
    var _fnOrderBy = $filter('orderBy'),
      for_all_descendants = function for_all_descendants(options, node, name, fnOrderBy) {
        var _i, _len, _nodes;

        if (angular.isDefined(node[name])) {
          _nodes = node[name];
          _len = _nodes.length;
          // OrderBy children
          for (_i = 0; _i < _len; _i++) {
            _nodes[_i] = for_all_descendants(options, _nodes[_i], name, fnOrderBy);
          }

          node[name] = fnOrderBy(node[name], options);
        }
        return node;
      },
      _fnOrder = function _fnOrder(list, orderBy) {
        return _fnOrderBy(list, orderBy);
      },
      _fnMain = function _fnMain(treeData, orderBy) {
        if (!angular.isArray(treeData)
          || treeData.length === 0
          || !(angular.isArray(orderBy) || angular.isObject(orderBy) || angular.isString(orderBy) || angular.isFunction(orderBy))
          || orderBy.length === 0 && !angular.isFunction(orderBy)) {
          return treeData;
        }

        var _i, _len;

        for (_i = 0, _len = treeData.length; _i < _len; _i++) {
          treeData[_i] = for_all_descendants(
            orderBy,
            treeData[_i],
            '__children__',
            _fnOrder
          );
        }

        return _fnOrder(treeData, orderBy);
      };

    return _fnMain;
  }

angular.module('eHRD.kernel.uiElements.treeTable')
  .factory('$TreeTableOrderBy', TreeTableOrderBy);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function() {
  'use strict';

  TreeTableFilter.$inject = ['$filter'];
  function TreeTableFilter($filter) {
    return fnInitFilter;

    function for_all_descendants(options, node, fieldChild, fnBefore, fnAfter, parentPassed) {
      if (!angular.isFunction(fnBefore)) {
        return null;
      }

      var _i, _len, _nodes,
        _nodePassed = fnBefore(options, node),
        _childPassed = false,
        _filter_index = options.filter_index;

      if (angular.isDefined(node[fieldChild])) {
        _nodes = node[fieldChild];
        _len = _nodes.length;
        options.filter_index = 0;
        for (_i = 0; _i < _len; _i++) {
          _childPassed = for_all_descendants(
              options,
              _nodes[_i],
              fieldChild,
              fnBefore,
              fnAfter,
              _nodePassed || parentPassed
            ) || _childPassed;
        }

        // restore filter_index of node
        options.filter_index = _filter_index;
      }

      if (angular.isFunction(fnAfter)) {
        fnAfter(options, node, _nodePassed === true, _childPassed === true, parentPassed === true);
      }

      return _nodePassed || _childPassed;
    }

    /**
     * Check data with callback
     * @param {string|object|function|regex} callback
     * @param {*} data
     * @returns {null|boolean}
     * @private
     */
    function _fnCheck(callback, data) {
      if (angular.isUndefinedOrNull(data) || angular.isArray(data)) {
        return null;
      }

      if (angular.isFunction(callback)) {
        return callback(data, $filter);
      } else {
        if (typeof callback === 'boolean') {
          data = !!data;
          return data === callback;
        } else if (angular.isDefined(callback)) {
          try {
            var _regex = new RegExp(callback);
            return _regex.test(data);
          } catch (err) {
            if (angular.isString(data)) {
              return data.indexOf(callback) > -1;
            } else {
              return null;
            }
          }
        } else {
          return null;
        }
      }
    }

    /**
     * `fnProcess` to call `_fnCheck`. If `condition` is `array` then call `for_each_filter`
     * else will call `_fnCheck`. Specical `condition.field` is `_$` then apply `condition.callback` for all field, if have `field` invaild then `return true`.
     *
     * @param node
     * @param condition
     * @param isAnd
     * @returns {null|boolean}
     * @private
     */
    function _fnProccess(node, condition, isAnd) {
      if (angular.isArray(condition)) {
        return for_each_filter(node, condition, isAnd);
      } else {
        var _key = condition.field,
          _callback = condition.callback,
          _iO, _keysO, _lenO;

        if (_key === '_$') {
          _keysO = Object.keys(node);
          _lenO = _keysO.length;
          for (_iO = 0; _iO < _lenO; _iO++) {
            if (_fnCheck(_callback, node[_keysO[_iO]])) {
              return true;
            }
          }
        } else if (angular.isDefined(node[_key])) {
          return _fnCheck(_callback, node[_key]);
        }
      }
      return null;
    }

    /**
     *
     * @param {object} node
     * @param {array} conditions Array `conditions`
     * @param {boolean} isAnd check with condition `And`, if `And` then `return false` when all `false`
     * @returns {null|boolean}
     */
    function for_each_filter(node, conditions, isAnd) {
      var i, len = conditions.length || 0,
        passed = false;
      if (len === 0) {
        return null;
      }

      for (i = 0; i < len; i++) {
        if (_fnProccess(node, conditions[i], !isAnd)) {
          passed = true;
          // if condition `or` then return;
          if (!isAnd) {
            return true;
          }
        } else {

          // if condition `and` and result in fnProccess = false then return;
          if (isAnd) {
            return false;
          }
        }
      }

      return passed;
    }

    /**
     * Will call _fnAfter to clear data no need
     * @param {object} options
     * @param {object} node
     * @param {boolean} isNodePassed
     * @param {boolean} isChildPassed
     * @param {boolean} isParentPassed
     * @private
     */
    function _fnAfter(options, node, isNodePassed, isChildPassed, isParentPassed) {
      if (isNodePassed === true) {
        node.__filtered__ = true;
        node.__filtered_visible__ = true;
        node.__filtered_index__ = options.filter_index++;
        return; //jmp
      } else if (isChildPassed === true && options.showParent === true ||
        isParentPassed === true && options.showChild === true) {
        node.__filtered__ = false;
        node.__filtered_visible__ = true;
        node.__filtered_index__ = options.filter_index++;
        return; //jmp
      }

      // remove attr __filtered__
      delete node.__filtered__;
      delete node.__filtered_visible__;
      delete node.__filtered_index__;
    }

    /**
     * `fnBefore` will called when `for_all_descendants` of `node` checking.
     * If `filter` empty then return `true` else result of function `_fnProccess` {@see _fnProccess}
     *
     * @param {object} options
     * @param {object} node
     * @returns {null|boolean}
     * @private
     */
    function _fnBefore(options, node) {
      if (options.filter.length === 0) {
        return true;
      } else {
        return _fnProccess(node, options.filter, options.beginAnd || false);
      }
    }

    /**
     * `fnBeforeClear` will called when `for_all_descendants` of `node` checking.
     * Alway false to Clear Filter empty
     *
     * @param {object} options
     * @param {object} node
     * @returns {null|boolean}
     * @private
     */
    function _fnBeforeClear( /*options, node*/ ) {
      return false;
    }

    /**
     * `_fnConvert` to convert `filter` `object` to `array` invaild.
     *
     * @param {object|array} filters
     * @returns {array} Instead of `filter` or new array invaild *(converted from filter)*
     * @private
     */
    function _fnConvert(filters) {
      var _iF, _lenF, _keysF,
        _filter,
        _state;
      // convert filter object to array filter
      if (angular.isObject(filters) && !angular.isArray(filters)) {
        _keysF = Object.keys(filters);
        _lenF = _keysF.length;
        _filter = [];

        if (_lenF > 0) {
          for (_iF = 0; _iF < _lenF; _iF++) {

            if (angular.isString(filters[_keysF[_iF]]) && filters[_keysF[_iF]].length === 0) {
              continue;
            } else if (angular.isArray(filters[_keysF[_iF]])) {
              _state = filters[_keysF[_iF]];
            } else if (angular.isObject(filters[_keysF[_iF]])) {
              _state = _fnConvert(filters[_keysF[_iF]]);
            } else {
              _state = {
                field: _keysF[_iF],
                callback: filters[_keysF[_iF]]
              };
            }
            _filter.push(_state);
          }
        }
        _state = null;
        return _filter;
      } else {
        return filters;
      }
    }

    /**
     * `fnInitFilter` function is constructor of service `$TreeTableFilter`.
     * @constructor
     * @param {object|array} treeData
     * @param {object|array} filters
     * @param {object} options
     * @param {string} keyChild
     * @returns {array} Return `treeData` or `treeData` with `filter`
     * @private
     */
    function fnInitFilter(treeData, filters, options, keyChild) {
      if (!angular.isArray(treeData) ||
        treeData.length === 0) {
        return treeData;
      }

      var _i, _len,
        _filter;

      _filter = _fnConvert(filters);
      if (!(angular.isArray(_filter) || angular.isObject(_filter)) ||
        _filter.length === 0) {
        for (_i = 0, _len = treeData.length; _i < _len; _i++) {
          for_all_descendants(
            options,
            treeData[_i],
            keyChild || '__children__',
            _fnBeforeClear, _fnAfter
          );
        }
        return treeData;
      }

      options.filter = _filter;
      options.filter_index = 0;
      for (_i = 0, _len = treeData.length; _i < _len; _i++) {
        for_all_descendants(
          options,
          treeData[_i],
          keyChild || '__children__',
          _fnBefore, _fnAfter
        );
      }

      return treeData;
    }

  }
  angular.module('eHRD.kernel.uiElements.treeTable')
    .factory('$TreeTableFilter', TreeTableFilter);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function() {
  'use strict';

  fnInitTreeTableViewport.$inject = ['$window', '$document', '$timeout'/*, '$q', '$compile'*/];

  function fnInitTreeTableViewport($window, $document, $timeout/*, $q, $compile*/) {

    var viewport = null,
        isUpdating = false,
        isRender = false,
        updateAgain = false,
        // viewportRect,
        items = [],
        // nodeTemplate,
        updateTimeout,
        renderTime,
        eWindow = angular.element($window);

    eWindow.on('load resize scroll', updateDelayed);

    return {

      setViewport: function (element) {
        /**
         * @name setViewport
         * @desciption Set the viewport element
         * @param element
         */
        viewport = element;
      },

      getViewport: function () {
        /**
         * Return the current viewport
         * @returns {*}
         */
        return viewport;
      },

      add: function (scope, element) {
        /**
         * Add listener for event
         * @param element
         * @param callback
         */
        updateDelayed();
        items.push({
          element: element,
          scope: scope
        });
      },

      setTemplate: function (/*scope, template*/) {
        // nodeTemplate = template;
      },

      getItems: function () {
        /**
               * Get list of items
               * @returns {Array}
               */
        return items;
      },

      updateDelayed: updateDelayed,

      pointIsInsideBounds: function (x, y, bounds) {
        /**
                 * Check if a point is inside specified bounds
                 * @param x
                 * @param y
                 * @param bounds
                 * @returns {boolean}
                 */
        return x >= bounds.left &&
          y >= bounds.top &&
          x <= bounds.left + bounds.width &&
          y <= bounds.top + bounds.height;
      }
    };

    /**
     * trigger an update
     */
    function updateDelayed() {
      $timeout.cancel(updateTimeout);
      updateTimeout = $timeout(function() {
        update();
      }, 0);
    }

    function update() {
      // viewportRect = {
      //   width: eWindow.prop('offsetWidth') || $document[0].documentElement.clientWidth,
      //   height: eWindow.prop('offsetHeight') || $document[0].documentElement.clientHeight,
      //   top: $document[0].body.scrollTop || $document[0].documentElement.scrollTop,
      //   left: $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft
      // };

      if (isUpdating || isRender) {
        updateAgain = true;
        return;
      }
      isUpdating = true;

      recursivePromise();
    }

    function recursivePromise() {
      if (isRender) {
        return;
      }

      var number = number > 0 ? number : items.length;
      // var item;

      if (number > 0) {
        // item = items[0];

        isRender = true;
        renderTime = $timeout(function() {
          items.splice(0, 1);
          isRender = false;
          number--;
          $timeout.cancel(renderTime);
          recursivePromise();
        }, 0);

      } else {
        isUpdating = false;
        if (updateAgain) {
          updateAgain = false;
          update();
        }
      }

    }
  }

  angular.module('eHRD.kernel.uiElements.treeTable')
    .factory('$TreeTableViewport', fnInitTreeTableViewport);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTableControl.$inject = [];
  function TreeTableControl() {
    var _target, _parent,
      i, len;

    function fnSetCollapse(node) {
      node.__expanded__ = false;
    }

    function fnSetExpand(node) {
      node.__expanded__ = true;
    }

    function _$init(scope) {
      var n, tree = {
        selected_node:       null,
        for_all_descendants: scope.for_all_descendants,
        select_node:         function (node) {
          if (!node) {
            if (tree.selected_node) {
              delete tree.selected_node.__selected__;
            }
            tree.selected_node = null;
            return null;
          }

          if (node !== tree.selected_node) {
            if (tree.selected_node) {
              delete tree.selected_node.__selected__;
            }
            node.__selected__  = true;
            tree.selected_node = node;
            tree.expand_all_parents(node);
            if (angular.isFunction(tree.on_select)) {
              tree.on_select(node);
            }
          }
          return node;
        },
        deselect_node:       function () {
          _target = null;
          if (tree.selected_node) {
            delete tree.selected_node.__selected__;
            _target            = tree.selected_node;
            tree.selected_node = null;
          }
          return _target;
        },
        get_parent:          function (node) {
          if (node && node.__parent_real__ !== null) {
            return scope.tree_nodes[node.__parent_real__];
          }
          return null;
        },
        for_all_ancestors:   function (child, fn) {
          _parent = tree.get_parent(child);
          if (_parent) {
            if (fn(_parent)) {
              return false;
            }

            return tree.for_all_ancestors(_parent, fn);
          }
          return true;
        },
        expand_all_parents:  function (child) {
          child = child || tree.selected_node;
          if (angular.isObject(child)) {
            tree.for_all_ancestors(
              child, fnSetExpand
            )
          }
        },
        collapse_all_parents:               function (child) {
          child = child || tree.selected_node;
          if (angular.isObject(child)) {
            tree.for_all_ancestors(
              child, fnSetCollapse
            )
          }
        },

        reload_data:                       function () {
          return scope.reload_data();
        },
        add_node:                          function (parent, new_node, index) {
          if (angular.isNumber(index)) {
            if (parent) {
              parent.__children__.push(new_node);
              parent.__expanded__ = true;
            } else {
              scope.treeData.push(new_node);
            }
          } else {
            if (parent) {
              parent.__children__.splice(index, 0, new_node);
              parent.__expanded__ = true;
            } else {
              scope.treeData.splice(index, 0, new_node);
            }
          }
          return new_node;
        },
        add_node_root:                     function (new_node) {
          tree.add_node(null, new_node);
          return new_node;
        },
        expand_all:                        function () {
          len = scope.treeData.length;
          for (i = 0; i < len; i++) {
            tree.for_all_descendants(
              scope.treeData[i], fnSetExpand
            );
          }
        },
        collapse_all:                      function () {
          len = scope.treeData.length;
          for (i = 0; i < len; i++) {
            tree.for_all_descendants(
              scope.treeData[i], fnSetCollapse
            );
          }
        },
        remove_node:                       function (node) {
          node = node || tree.selected_node;
          if (angular.isObject(node) ) {
            if (node.__parent_real__ !== null) {
              _parent = tree.get_parent(node).__children__;
            } else {
              _parent = scope.treeData;
            }

            _parent.splice(node.__index__, 1);

            tree.reload_data();

            if (tree.selected_node === node) {
              tree.selected_node = null;
            }
          }
        },
        expand_node:                       function (node) {
          node = node || tree.selected_node;
          if (angular.isObject(node) && node.__expanded__) {
            node.__expanded__ = true;
            return node;
          }
        },
        collapse_node:                     function (node) {
          node = node || tree.selected_node;
          if (angular.isObject(node)) {
            node.__expanded__ = false;
            return node;
          }
        },
        get_selected_node:                 function () {
          return tree.selected_node;
        },
        get_first_node:                    function () {
          len = scope.treeData.length;
          if (len > 0) {
            return scope.treeData[0];
          }
          return null;
        },
        get_children:                      function (node) {
          return node.__children__;
        },
        get_siblings:                      function (node) {
          node = node || tree.selected_node;
          if (angular.isObject(node) ) {
            _parent = tree.get_parent(node);
            if (_parent) {
              _target = _parent.__children__;
            } else {
              _target = scope.treeData;
            }
            return _target;
          }
        },
        get_next_sibling:                  function (node) {
          node = node || tree.selected_node;
          if (angular.isObject(node)) {
            _target = tree.get_siblings(node);
            n       = _target.length;
            if (node.__index__ < n) {
              return _target[node.__index__ + 1];
            }
          }
        },
        get_prev_sibling:                  function (node) {
          node    = node || tree.selected_node;
          _target = tree.get_siblings(node);
          if (node.__index__ > 0) {
            return _target[node.__index__ - 1];
          }
        },
        get_first_child:                   function (node) {
          node = node || tree.selected_node;
          if (angular.isObject(node)) {
            _target = node.__children__;
            if (_target && _target.length > 0) {
              return node.__children__[0];
            }
          }
          return null;
        },
        get_closest_ancestor_next_sibling: function (node) {
          node    = node || tree.selected_node;
          _target = tree.get_next_sibling(node);
          if (_target) {
            return _target;
          }

          _parent = tree.get_parent(node);
          if(_parent)
          {
            return tree.get_closest_ancestor_next_sibling(_parent);
          }

          return null;
        },
        get_next_node:                     function (node) {
          node = node || tree.selected_node;

          if (angular.isObject(node) ) {
            _target = tree.get_first_child(node);
            if (_target) {
              return _target;
            } else {
              return tree.get_closest_ancestor_next_sibling(node);
            }
          }
        },
        get_prev_node:                     function (node) {
          node = node || tree.selected_node;

          if (angular.isObject(node)) {
            _target = tree.get_prev_sibling(node);
            if (_target) {
              return tree.get_last_descendant(_target);
            }

            _parent = tree.get_parent(node);
            return _parent;
          }
        },
        get_last_descendant:               scope.getLastDescendant,
        select_parent_node:                function (node) {
          node = node || tree.selected_node;

          if (angular.isObject(node)) {
            _parent = tree.get_parent(node);
            if (_parent) {
              return tree.select_node(_parent);
            }
          }
        },
        select_first_node:                 function () {
          var firstNode = tree.get_first_node();
          return tree.select_node(firstNode);
        },
        select_next_sibling:               function (node) {
          node = node || tree.selected_node;

          if (angular.isObject(node)) {
            _target = tree.get_next_sibling(node);
            if (_target) {
              return tree.select_node(_target);
            }
          }
        },
        select_prev_sibling:               function (node) {
          node = node || tree.selected_node;

          if (angular.isObject(node)) {
            _target = tree.get_prev_sibling(node);
            if (_target) {
              return tree.select_node(_target);
            }
          }
        },
        select_next_node:                  function (node) {
          node = node || tree.selected_node;

          if (angular.isObject(node)) {
            _target = tree.get_next_node(node);
            if (_target) {
              return tree.select_node(_target);
            }
          }
        },
        select_prev_node:                  function (node) {
          node = node || tree.selected_node;

          if (angular.isObject(node)) {
            _target = tree.get_prev_node(node);
            if (_target) {
              return tree.select_node(_target);
            }
          }
        }
      };
      angular.extend(scope.tree, tree);
      return scope.tree;
    }

    return _$init;
  }
  angular.module('eHRD.kernel.uiElements.treeTable')
    .factory('$TreeTableControl', TreeTableControl);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTableTemplate.$inject = ['$templateCache'];
  function TreeTableTemplate($templateCache) {
    var templatePath = 'template/TreeTable/TreeTable.html',
      copyPath     = 'template/TreeTable/TreeTableStatusCopy.html',
      movePath     = 'template/TreeTable/TreeTableStatusMove.html',
      scopes       = {},
      temp,
      _$init       = {
        setMove: function (path, scope) {
          if (!scopes[scope.$id]) {
            scopes[scope.$id] = {};
          }
          scopes[scope.$id].movePath = path;
        },
        setCopy: function (path, scope) {
          if (!scopes[scope.$id]) {
            scopes[scope.$id] = {};
          }
          scopes[scope.$id].copyPath = path;
        },
        getPath: function () {
          return templatePath;
        },
        getCopy: function (scope) {
          if (scopes[scope.$id] && scopes[scope.$id].copyPath) {
            temp = $templateCache.get(scopes[scope.$id].copyPath);
            if (temp) {
              return temp;
            }
          }
          return $templateCache.get(copyPath);
        },
        getMove: function (scope) {
          if (scopes[scope.$id] && scopes[scope.$id].movePath) {
            temp = $templateCache.get(scopes[scope.$id].movePath);
            if (temp) {
              return temp;
            }
          }
          return $templateCache.get(movePath);
        }
      };

    return _$init;
  }
  angular.module('eHRD.kernel.uiElements.treeTable')
    .factory('$TreeTableTemplate', TreeTableTemplate);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTablePlugin.$inject = ['$injector'];
  function TreeTablePlugin($injector) {
    var _fnget = function (name) {
      if (angular.isDefined($injector) && $injector.has(name)) {
        return $injector.get(name);
      }
      return null;
    };
    return _fnget;
  }

  angular.module('eHRD.kernel.uiElements.treeTable')
    .factory('$TreeTablePlugin', TreeTablePlugin);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTableHelper.$inject = ['$document', '$window'];
  function TreeTableHelper($document, $window) {
    var _$helper = {
      nodrag:          function (targetElm) {
        return angular.isDefined(targetElm.attr('data-nodrag'));
      },
      eventObj:        function (e) {
        var obj = e;
        if (angular.isDefined(e.targetTouches) ) {
          obj = e.targetTouches.item(0);
        } else if (angular.isDefined(e.originalEvent) && angular.isDefined(e.originalEvent.targetTouches)) {
          obj = e.originalEvent.targetTouches.item(0);
        }
        return obj;
      },
      dragInfo:        function (scope) {
        var _node   = scope.getData(),
          _tree   = scope.getScopeTree(),
          _parent = scope.getNode(_node.__parent_real__);
        return {
          node:    _node,
          parent:  _parent,
          move:    {
            parent: _parent,
            pos:    _node.__index__
          },
          scope:   scope,
          target:  _tree,
          drag:    _tree,
          drop:    scope.getPrevSibling(_node),
          changed: false
        };
      },
      height:          function (element) {
        return element.prop('scrollHeight');
      },
      width:           function (element) {
        return element.prop('scrollWidth');
      },
      offset:          function (element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width:  element.prop('offsetWidth'),
          height: element.prop('offsetHeight'),
          top:    boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
          left:   boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
        };
      },
      positionStarted: function (e, target) {
        var pos     = {};
        pos.offsetX = e.pageX - this.offset(target).left;
        pos.offsetY = e.pageY - this.offset(target).top;
        pos.startX  = pos.lastX = e.pageX;
        pos.startY = pos.lastY = e.pageY;
        pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
        pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
        return pos;
      },
      positionMoved:   function (e, pos, firstMoving) {
        // mouse position last events
        pos.lastX    = pos.nowX;
        pos.lastY    = pos.nowY;
        // mouse position this events
        pos.nowX     = e.pageX;
        pos.nowY     = e.pageY;
        // distance mouse moved between events
        pos.distX    = pos.nowX - pos.lastX;
        pos.distY    = pos.nowY - pos.lastY;
        // direction mouse was moving
        pos.lastDirX = pos.dirX;
        pos.lastDirY = pos.dirY;
        // direction mouse is now moving (on both axis)
        pos.dirX     = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
        pos.dirY     = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;
        // axis mouse is now moving on
        var newAx    = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;
        // do nothing on first move
        if (firstMoving) {
          pos.dirAx  = newAx;
          pos.moving = true;
          return;
        }
        // calc distance moved on this axis (and direction)
        if (pos.dirAx !== newAx) {
          pos.distAxX = 0;
          pos.distAxY = 0;
        } else {
          pos.distAxX += Math.abs(pos.distX);
          if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
            pos.distAxX = 0;
          }
          pos.distAxY += Math.abs(pos.distY);
          if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
            pos.distAxY = 0;
          }
        }
        pos.dirAx = newAx;
      },
      replaceIndent:   function (scope, element, indent, attr) {
        attr = attr || 'left';
        angular.element(element.children()[0]).css(attr, scope.$callbacks.calsIndent(indent));
      }
    };
    return _$helper;
  }

  angular.module('eHRD.kernel.uiElements.treeTable')
    .factory('$TreeTableHelper', TreeTableHelper);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTableConvert.$inject = [];
  function TreeTableConvert() {
    var _$initConvert = {
      line2tree: function (data, primaryKey, parentKey, callback) {
        callback = angular.isFunction(callback) ? callback : function () {
        };
        if (!data || data.length === 0 || !primaryKey || !parentKey) {
          return [];
        }
        var tree     = [],
          rootIds  = [],
          item     = data[0],
          _primary = item[primaryKey],
          treeObjs = {},
          parentId, parent,
          len      = data.length,
          i        = 0;
        while (i < len) {
          item = data[i++];
          callback(item);
          _primary           = item[primaryKey];
          treeObjs[_primary] = item;
        }
        i = 0;
        while (i < len) {
          item = data[i++];
          callback(item);
          _primary           = item[primaryKey];
          treeObjs[_primary] = item;
          parentId           = item[parentKey];
          if (parentId) {
            parent = treeObjs[parentId];
            if (parent) {
              if (parent.__children__) {
                parent.__children__.push(item);
              } else {
                parent.__children__ = [item];
              }
            }
          } else {
            rootIds.push(_primary);
          }
        }
        len = rootIds.length;
        for (i = 0; i < len; i++) {
          tree.push(treeObjs[rootIds[i]]);
        }
        return tree;
      },
      tree2tree: function access_child(data, containKey, callback) {
        callback  = angular.isFunction(callback) ? callback : function () {
        };
        var _tree = [],
          _i,
          _len  = data ? data.length : 0,
          _copy, _child;
        for (_i = 0; _i < _len; _i++) {
          _copy = angular.copy(data[_i]);
          callback(_copy);
          if (angular.isArray(_copy[containKey]) && _copy[containKey].length > 0) {
            _child = access_child(_copy[containKey], containKey, callback);
            delete _copy[containKey];
            _copy.__children__ = _child;
          }
          _tree.push(_copy);
        }
        return _tree;
      },
      arrayTree2tableTree: function access_child(data, containKey, callback) {
        callback  = angular.isFunction(callback) ? callback : function () {
        };
        var _tree = [],
          _i,
          _len  = data ? data.length : 0;
        for (_i = 0; _i < _len; _i++) {
          if(angular.isArray(data[_i]) && data[_i].length >0)
            _tree.push(data[_i][0]);
        }
        return _$initConvert.tree2tree(_tree, containKey, callback);
      }
    };

    return _$initConvert;
  }
  angular.module('eHRD.kernel.uiElements.treeTable')
    .factory('$TreeTableConvert', TreeTableConvert);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function() {
  'use strict';

  fnInitTreeTable.$inject = ['$timeout', '$http', '$compile', '$parse', '$window', '$document', '$templateCache',
    '$TreeTableTemplate', '$TreeTableClass', '$TreeTableHelper', '$TreeTablePlugin', '$TreeTableViewport'
  ];

  function fnInitTreeTable($timeout, $http, $compile, $parse, $window, $document, $templateCache,
                           $TreeTableTemplate, $TreeTableClass, $TreeTableHelper, $TreeTablePlugin, $TreeTableViewport) {


    fnController.$inject = ['$scope', '$element', '$attrs'];

    function fnController($scope, $element, $attrs) {
      $scope.indent = 20;
      $scope.indent_plus = 15;
      $scope.indent_unit = 'px';
      $scope.$tree_class = 'table';
      $scope.primary_key = '__uid__';

      $scope.$type = 'TreeTable';
      // $scope.enabledFilter = null;
      $scope.colDefinitions = [];
      $scope.$globals = {};
      $scope.$class = {};

      $scope.treeData = [];
      $scope.tree_nodes = [];

      $scope.$class = angular.copy($TreeTableClass);
      angular.extend(
        $scope.$class.icon, {
          '1': $attrs.iconExpand || 'glyphicon glyphicon-minus',
          '0': $attrs.iconCollapse || 'glyphicon glyphicon-plus',
          '-1': $attrs.iconLeaf || 'glyphicon glyphicon-file'
        }
      );

      $scope.for_all_descendants = function(node, fn, parent, checkSibling) {
        if (angular.isFunction(fn)) {
          var _i, _len, _nodes;

          if (fn(node, parent)) {
            // have error or need ignore children
            return false;
          }
          _nodes = node.__children__;
          _len = _nodes ? _nodes.length : 0;
          for (_i = 0; _i < _len; _i++) {
            if (!$scope.for_all_descendants(_nodes[_i], fn, node) && !checkSibling) {
              // skip sibling of node checking
              return false;
            }
          }
        }
        // succeed then continue
        return true;
      };

      $scope.getLastDescendant = function(node) {
        var last_child, n;
        if (!node) {
          node = $scope.tree ? $scope.tree.selected_node : false;
        }
        if (node === false) {
          return false;
        }
        n = node.__children__.length;
        if (n === 0) {
          return node;
        } else {
          last_child = node.__children__[n - 1];
          return $scope.getLastDescendant(last_child);
        }
      };

      $scope.getElementChilds = function() {
        return angular.element($element[0].querySelector('[tree-table-nodes]'));
      };

      $scope.onClick = function(node) {
        if (angular.isDefined($scope.tree) && angular.isFunction($scope.tree.on_click)) {
          // We want to detach from Angular's digest cycle so we can
          // independently measure the time for one cycle.
          $timeout(function() {
            $scope.tree.on_click(node);
          }, 0);
        }
      };

      $scope.onSelect = function(node) {
        if (angular.isDefined($scope.tree)) {
          if (node !== $scope.tree.selected_node) {
            $scope.tree.select_node(node);
          }

          if (angular.isFunction($scope.tree.on_select)) {
            $timeout(function() {
              $scope.tree.on_select(node);
            }, 0);
          }
        }
      };

      var passedExpand, _clone;
      $scope.toggleExpand = function(node, fnCallback) {
        passedExpand = true;
        if (angular.isFunction(fnCallback) && !fnCallback(node)) {
          passedExpand = false;
        } else if (angular.isFunction($scope.$callbacks.expand) && !$scope.$callbacks.expand(node)) {
          passedExpand = false;
        }

        if (passedExpand) {
          if (node.__children__.length >= 0 && (node.isFolderType===1 || node.ivqType==1)) {
            node.__expanded__ = !node.__expanded__;
          }
        }
      };


      var _fnGetHash = function(node) {
          return '#' + node.__parent__ + '#' + node[$scope.primary_key];
        },
        _fnSetHash = function(node) {
          var _hashKey = _fnGetHash(node);
          if (angular.isUndefinedOrNull(node.__hashKey__) || node.__hashKey__ !== _hashKey) {
            node.__hashKey__ = _hashKey;
          }
          return node;
        };
      $scope.getHash = _fnGetHash;
      $scope.$callbacks = {
        getHash: _fnGetHash,
        setHash: _fnSetHash,
        for_all_descendants: $scope.for_all_descendants,
        /*expand:              function (node) {
         return true;
         },*/
        accept: function( /*dragInfo, moveTo, isChanged*/ ) {
          return $scope.dropEnabled === true;
        },
        calsIndent: function(level, skipUnit, skipEdge) {
          var unit = 0,
            edge = skipEdge ? 0 : $scope.indent_plus;
          if (!skipUnit) {
            unit = $scope.indent_unit ? $scope.indent_unit : 'px';
          }

          if (level - 1 < 1) {
            return edge + unit;
          } else {
            return $scope.indent * (level - 1) + edge + unit;
          }
        },
        droppable: function() {
          return $scope.dropEnabled === true;
        },
        draggable: function() {
          return $scope.dragEnabled === true;
        },
        beforeDrop: function( /*event*/ ) {
          return true;
        },
        changeKey: function(node) {
          var _key = node.__uid__;
          node.__uid__ = Math.random();
          if (node.__selected__) {
            delete node.__selected__;
          }

          if ($scope.primary_key !== '__uid__') {
            _key = '' + node[$scope.primary_key];
            _key = _key.replace(/_#.+$/g, '') + '_#' + node.__uid__;

            node[$scope.primary_key] = _key;
          }
          // delete(node.__hashKey__);
        },
        clone: function(node /*, _this*/ ) {
          _clone = angular.copy(node);
          this.for_all_descendants(_clone, this.changeKey);
          return _clone;
        },
        remove: function(node, parent, _this, delayReload) {
          var temp = parent.splice(node.__index__, 1)[0];
          if (!delayReload) {
            $scope.reload_data();
          }
          return temp;
        },
        clearInfo: function(node) {
          delete node.__inited__;
          delete node.__visible__;

          // always changed after call reload_data
          //delete node.__hashKey__;
        },
        add: function(node, pos, parent /*, _this*/ ) {
          // clearInfo
          this.for_all_descendants(node, this.clearInfo);
          if (parent) {
            if (parent.length > -1) {
              if (pos > -1) {
                parent.splice(pos, 0, node);
              } else {
                // todo If children need load crazy
                parent.push(node);
              }
            } else {
              parent.push(node);
            }
          }
        }
      };

      $scope.deleteScope = function(scope, node) {
        var _hash = node.__hashKey__;
        if ($scope.$globals[_hash] && $scope.$globals[_hash] === scope) {
          delete $scope.$globals[_hash];
        }
      };

      $scope.setScope = function(scope, node) {
        var _hash = node.__hashKey__;
        if ($scope.$globals[_hash] !== scope) {
          $scope.$globals[_hash] = scope;
        }
      };

      $scope.getScope = function(node) {
        if (node) {
          var _hash = node.__hashKey__;
          //var _hash = typeof node === 'string' ? node : node.__hashKey__;
          return $scope.$globals[_hash];
        }
        return $scope;
      };

      if ($attrs.enableDrag || $attrs.enableDrop) {
        $scope.placeElm = null;
        //                            $scope.dragBorder = 30;
        $scope.dragEnabled = null;
        $scope.dropEnabled = null;
        $scope.horizontal = null;

        if ($attrs.enableDrag) {

          $scope.dragDelay = 0;
          $scope.enabledMove = true;
          $scope.statusMove = true;
          $scope.enabledHotkey = false;
          $scope.enabledCollapse = null;
          $scope.statusElm = null;
          $scope.dragging = null;

          angular.extend(
            $scope.$callbacks, {
              beforeDrag: function( /*scopeDrag*/ ) {
                return true;
              },
              dragStop: function(info, passed) {
                if (!info || !info.changed && info.drag.enabledMove || !passed) {
                  return null;
                }

                info.target.reload_data();

                if (info.target !== info.drag && info.drag.enabledMove) {
                  info.drag.reload_data();
                }
              },
              dropped: function(info /*, pass*/ ) {
                if (!info) {
                  return null;
                }

                var _node = info.node,
                  _nodeAdd = null,
                  _move = info.move,
                  _parent = null,
                  _parentRemove = info.parent || info.drag.treeData,
                  _parentAdd = _move.parent || info.target.treeData,
                  isMove = info.drag.enabledMove;

                if (!info.changed && isMove) {
                  return false;
                }

                if (info.target.$callbacks.accept(info, info.move, info.changed)) {
                  if (isMove) {
                    _parent = _parentRemove;
                    if (angular.isDefined(_parent.__children__)) {
                      _parent = _parent.__children__;
                    }

                    _nodeAdd = info.drag.$callbacks.remove(
                      _node,
                      _parent,
                      info.drag.$callbacks,
                      true // delay reload
                    );
                  } else {
                    _nodeAdd = info.drag.$callbacks.clone(_node, info.drag.$callbacks);
                  }

                  // if node dragging change index in sample node parent
                  // and index node decrement
                  if (isMove &&
                    info.drag === info.target &&
                    _parentRemove === _parentAdd &&
                    _move.pos >= info.node.__index__) {
                    _move.pos--;
                  }

                  _parent = _parentAdd;
                  if (_parent.__children__) {
                    _parent = _parent.__children__;
                  }

                  info.target.$callbacks.add(
                    _nodeAdd,
                    _move.pos,
                    _parent,
                    info.drag.$callbacks
                  );

                  return true;
                }

                return false;
              },
              dragStart: function( /*event*/ ) {},
              dragMove: function( /*event*/ ) {}
            }
          );

          $scope.setDragging = function(dragInfo) {
            $scope.dragging = dragInfo;
          };

          $scope.enableMove = function(val) {
            if (typeof val === 'boolean') {
              $scope.enabledMove = val;
            } else {
              $scope.enabledMove = true;
            }
          };

          if ($attrs.enableStatus) {
            $scope.enabledStatus = false;

            $scope.hideStatus = function() {
              if ($scope.statusElm) {
                $scope.statusElm.addClass($scope.$class.hidden);
              }
            };

            $scope.refreshStatus = function() {
              if (!$scope.dragging) {
                return;
              }

              if ($scope.enabledStatus) {
                var statusElmOld = $scope.statusElm;
                if ($scope.enabledMove) {
                  $scope.statusElm = angular.element($TreeTableTemplate.getMove($scope));
                } else {
                  $scope.statusElm = angular.element($TreeTableTemplate.getCopy($scope));
                }

                if (statusElmOld !== $scope.statusElm) {
                  if (statusElmOld) {
                    $scope.statusElm.attr('class', statusElmOld.attr('class'));
                    $scope.statusElm.attr('style', statusElmOld.attr('style'));
                    statusElmOld.remove();
                  }
                  $document.find('body').append($scope.statusElm);

                }

                $scope.statusElm.removeClass($scope.$class.hidden);
              }
            };

            $scope.setPositionStatus = function(e) {
              if ($scope.statusElm) {
                $scope.statusElm.css({
                  'left': e.pageX + 10 + 'px',
                  'top': e.pageY + 15 + 'px',
                  'z-index': 9999
                });
                $scope.statusElm.addClass($scope.$class.status);
              }
            };
          }
        }

        $scope.targeting = false;

        $scope.getPrevSibling = function(node) {
          if (node && node.__index__ > 0) {
            var _parent, _index = node.__index__ - 1;

            if (angular.isDefined(node.__parent_real__)) {
              _parent = $scope.tree_nodes[node.__parent_real__];
              return _parent.__children__[_index];
            }
            return $scope.treeData[_index];

          }
          return null;
        };

        $scope.getNode = function(index) {
          if (angular.isUndefinedOrNull(index)) {
            return null;
          }
          return $scope.tree_nodes[index];
        };

        $scope.initPlace = function(element, dragElm) {

          if (!$scope.placeElm) {
            if ($scope.isTable) {
              $scope.placeElm = angular.element($window.document.createElement('tr'));
              var _len_down = $scope.colDefinitions.length;
              $scope.placeElm.append(
                angular.element($window.document.createElement('td'))
                  .addClass($scope.$class.empty)
                  .addClass('indented')
                  .addClass($scope.$class.place)
              );
              while (_len_down-- > 0) {
                $scope.placeElm.append(
                  angular.element($window.document.createElement('td'))
                    .addClass($scope.$class.empty)
                    .addClass($scope.$class.place)
                );
              }
            } else {
              $scope.placeElm = angular.element($window.document.createElement('li'))
                .addClass($scope.$class.empty)
                .addClass($scope.$class.place);
            }

          }

          if (dragElm) {
            $scope.placeElm.css('height', $TreeTableHelper.height(dragElm) + 'px');
          }

          if (element) {
            element[0].parentNode.insertBefore($scope.placeElm[0], element[0]);
          } else {
            $scope.getElementChilds().append($scope.placeElm);
          }

          return $scope.placeElm;
        };

        $scope.hidePlace = function() {
          if ($scope.placeElm) {
            $scope.placeElm.addClass($scope.$class.hidden);
          }
        };

        $scope.showPlace = function() {
          if ($scope.placeElm) {
            $scope.placeElm.removeClass($scope.$class.hidden);
          }
        };

        $scope.getScopeTree = function() {
          return $scope;
        };

      }

      $scope.$safeApply = $safeApply;


      $scope.hiddenChild = function fnHiddenChild(node, parent) {
        var nodeScope = $scope.getScope(node);
        if (nodeScope) {
          if (parent && parent.__expanded__ && parent.__visible__) {
            nodeScope.$element.removeClass($scope.$class.hidden);
            node.__visible__ = true;
          } else {
            nodeScope.$element.addClass($scope.$class.hidden);
            node.__visible__ = false;
          }
        } else {
          // show node & init scope
          if (parent && parent.__expanded__ && parent.__visible__) {
            node.__visible__ = true;
          } else {
            node.__visible__ = false;
          }
        }

        // skip all child hiding... if not expaned
        return node.__expanded__ === false;
      };
      var _fnInitFilter,
        _fnInitOrderBy,
        _fnGetControl,
        _defaultFilterOption = {
          showParent: true,
          showChild: false,
          beginAnd: true
        },
        tree,
        _watches = [
          [
            'enableDrag', [
            ['boolean', 'enableStatus', null, 'enabledStatus'],
            ['boolean', 'enableMove', null, 'enabledMove'],
            ['number', 'dragDelay', 0, null, 0],
            ['boolean', 'enableCollapse', null, 'enabledCollapse'],
            [
              'boolean', 'enableHotkey', null, 'enabledHotkey', null,
              function(isHotkey) {
                if (isHotkey) {
                  $scope.enabledMove = false;
                } else {
                  $scope.enabledMove = $scope.statusMove;
                }
              }
            ]
          ]
          ],
          [
            ['enableDrag', 'enableStatus'],
            [
              [
                'string', 'templateCopy', $attrs.templateCopy, 'templateCopy', null,
                function(_url) {
                  if (_url && $templateCache.get(_url)) {
                    $TreeTableTemplate.setCopy(_url, $scope);
                  }
                }
              ],
              [
                'string', 'templateMove', $attrs.templateMove, 'templateMove', null,
                function(_url) {
                  if (_url && $templateCache.get(_url)) {
                    $TreeTableTemplate.setMove(_url, $scope);
                  }
                }
              ]
            ]
          ],
          [
            [
              ['enableDrag', 'enableDrop']
            ],
            [
              ['number', 'dragBorder', 30, 'dragBorder', 30]
            ]
          ],
          [
            '*', [
            ['boolean', 'treeTable', true, 'treeTable', null],
            ['boolean', 'horizontal'],
            [
              'callback', 'treeClass',
              function(val) {
                switch (typeof val) {
                  case 'string':
                    $scope.$tree_class = val;
                    break;
                  case 'object':
                    angular.extend($scope.$class, val);
                    $scope.$tree_class = $scope.$class.tree;
                    break;
                  default:
                    $scope.$tree_class = $attrs.treeClass;
                    break;
                }
              }, 'treeClass',
              function() {
                $scope.$tree_class = $scope.$class.tree + ' table';
              },
              null,
              function() {
                if (/^(\s+[\w\-]+){2,}$/g.test(' ' + $attrs.treeClass)) {
                  $scope.$tree_class = $attrs.treeClass.trim();
                  return true;
                }
              }
            ],
            [
              ['object', 'string'], 'expandOn', getExpandOn, 'expandingProperty', getExpandOn,
              function(expandOn) {
                if (angular.isUndefinedOrNull(expandOn)) {
                  $scope.expandingProperty = $attrs.expandOn;
                }
              }
            ],
            [
              'object', 'treeControl', angular.isDefined($scope.tree) ? $scope.tree : {},
              'tree', null,
              function($tree) {

                if (!angular.isFunction(_fnGetControl)) {
                  _fnGetControl = $TreeTablePlugin('$TreeTableControl');
                }

                if (angular.isFunction(_fnGetControl)) {
                  tree = angular.extend(
                    $tree,
                    _fnGetControl($scope)
                  );
                }
              }
            ],
            [
              ['array', 'object'], 'columnDefs', getColDefs, 'colDefinitions', getColDefs,
              function(colDefs) {
                if (angular.isUndefinedOrNull(colDefs) || !angular.isArray(colDefs)) {
                  $scope.colDefinitions = getColDefs();
                }
              }
            ],
            [
              ['object', 'string', 'array', 'function'], 'orderBy', $attrs.orderBy
            ],
            [
              ['object', 'array'], 'filter', null, 'filter', null,
              function(filters) {
                var _passed = false;
                if (angular.isDefined(filters) && !angular.isArray(filters)) {
                  var _keysF = Object.keys(filters),
                    _lenF = _keysF.length,
                    _iF;

                  if (_lenF > 0) {
                    for (_iF = 0; _iF < _lenF; _iF++) {

                      if (angular.isString(filters[_keysF[_iF]]) &&
                        filters[_keysF[_iF]].length === 0) {
                        continue;
                      }
                      _passed = true;
                      break;
                    }
                  }
                }

                $scope.enabledFilter = _passed;
                reload_data();
              }
            ],
            [
              'object', 'filterOptions', _defaultFilterOption, 'filterOptions',
              _defaultFilterOption,
              function(option) {
                if (angular.isObject(option)) {
                  $scope.filterOptions = angular.extend(_defaultFilterOption, option);
                }
              }
            ],
            ['string', 'primaryKey', $attrs.primaryKey, 'primary_key', '__uid__'],
            ['string', 'indentUnit', $attrs.indentUnit, 'indent_unit'],
            ['number', 'indent', 30, null, 30],
            ['number', 'indentPlus', 20, null, 20],
            [
              'null', 'callbacks',
              function(optCallbacks) {
                angular.forEach(
                  optCallbacks,
                  function(value, key) {
                    if (angular.isFunction(value)) {
                      if ($scope.$callbacks[key]) {
                        $scope.$callbacks[key] = value;
                      }
                    }
                  }
                );
                return $scope.$callbacks;
              },
              '$callbacks'
            ],
            [
              'number', 'expandLevel', 9999, 'expandLevel', 9999,
              function() {
                reload_data();
              }
            ],
            ['number', 'treeLimit', 100, '$TreeLimit', 100],
            ['boolean', 'enableDrag', null, 'dragEnabled'],
            ['boolean', 'enableDrop', null, 'dropEnabled']
          ]
          ]
        ],
        w, lenW = _watches.length,
        i, len,
        _curW,
        _typeW, _nameW, _defaultW, _scopeW, _NotW, _AfterW, _BeforeW,

        // debounce reload_Data;
        timeReloadData, tmpTreeData;

      for (w = 0; w < lenW; w++) {
        // skip if not exist
        if (!check_exist_attr($attrs, _watches[w][0], true)) {
          continue;
        }
        _curW = _watches[w][1];
        for (i = 0, len = _curW.length; i < len; i++) {
          _typeW = _curW[i][0];
          _nameW = _curW[i][1];
          _defaultW = _curW[i][2];
          _scopeW = _curW[i][3];
          _NotW = _curW[i][4];
          _AfterW = _curW[i][5];
          _BeforeW = _curW[i][6];
          generateWatch(_typeW, _nameW, _defaultW, _scopeW, _NotW, _AfterW, _BeforeW);
        }
      }

      if ($attrs.treeData) {
        $scope.$watch(
          $attrs.treeData,
          function(val) {
            if (angular.equals(val, $scope.treeData)) {
              return;
            }

            tmpTreeData = val;
            if (angular.isUndefinedOrNull(timeReloadData)) {
              timeReloadData = $timeout(timeLoadData, 350);
            }
          }, true
        );
      }

      function timeLoadData() {
        $scope.treeData = tmpTreeData;
        reload_data();
        timeReloadData = null;
      }

      $scope.updateLimit = function updateLimit() {
        //console.log('Call fn UpdateLimit');
        $scope.$TreeLimit += 50;
      };

      $scope.reload_data = reload_data;

      function check_exist_attr(attrs, existAttr, isAnd) {
        if (angular.isUndefinedOrNull(existAttr)) {
          return false;
        }

        if (existAttr === '*' || angular.isDefined(attrs[existAttr])) {
          return true;
        }

        if (angular.isArray(existAttr)) {
          return for_each_attrs(attrs, existAttr, isAnd);
        }
      }

      function for_each_attrs(attrs, exist, isAnd) {
        var i, len = exist.length,
          passed = false;

        if (len === 0) {
          return null;
        }
        for (i = 0; i < len; i++) {
          if (check_exist_attr(attrs, exist[i], !isAnd)) {
            passed = true;
            if (!isAnd) {
              return true;
            }
          } else {
            if (isAnd) {
              return false;
            }
          }
        }

        return passed;
      }

      function generateWatch(type, nameAttr, valDefault, nameScope, fnNotExist, fnAfter,
                             fnBefore
      ) {
        nameScope = nameScope || nameAttr;
        if (angular.isString(type) || angular.isArray(type)) {
          if (angular.isFunction(fnBefore) && fnBefore()) {
            return; //jmp
          }
          if (angular.isString($attrs[nameAttr])) {
            $scope.$watch(
              $attrs[nameAttr],
              function(val) {
                if (angular.isString(type) && typeof val === type ||
                  angular.isArray(type) && type.indexOf(typeof val) > -1
                ) {
                  $scope[nameScope] = val;
                } else {
                  if (angular.isFunction(valDefault)) {
                    $scope[nameScope] = valDefault(val);
                  } else {
                    $scope[nameScope] = valDefault;
                  }
                }

                if (angular.isFunction(fnAfter)) {
                  fnAfter($scope[nameScope], $scope);
                }
              }, true
            );
          } else {

            if (angular.isFunction(fnNotExist)) {
              $scope[nameScope] = fnNotExist();
            } else if (angular.isDefined(fnNotExist)) {
              $scope[nameScope] = fnNotExist;
            }
          }
        }
      }

      function $safeApply(fn) {
        var phase = this.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
          if (fn && angular.isFunction(fn)) {
            fn();
          }
        } else {
          this.$apply(fn);
        }
      }

      function getExpandOn() {
        if ($scope.treeData && $scope.treeData.length) {
          var _firstNode = $scope.treeData[0],
            _keys = Object.keys(_firstNode),
            _regex = new RegExp('^__([a-zA-Z0-9_\-]*)__$'),
            _len,
            i;
          // Auto get first field with type is string;
          for (i = 0, _len = _keys.length; i < _len; i++) {
            if (angular.isString(_firstNode[_keys[i]]) && !_regex.test(_keys[i])) {
              $scope.expandingProperty = _keys[i];
              return;
            }
          }

          // Auto get first
          if (angular.isUndefinedOrNull($scope.expandingProperty)) {
            $scope.expandingProperty = _keys[0];
          }

        }
      }

      function getColDefs() {
        // Auto get Defs except attribute __level__ ....
        if ($scope.treeData.length) {
          var _col_defs = [],
            _firstNode = $scope.treeData[0],
            _regex = new RegExp('(^__([a-zA-Z0-9_\-]*)__$|^' + $scope.expandingProperty + '$)'),
            _keys = Object.keys(_firstNode),
            i, _len;
          // Auto get first field with type is string;
          for (i = 0, _len = _keys.length; i < _len; i++) {
            if (angular.isString(_firstNode[_keys[i]]) && !_regex.test(_keys[i])) {
              _col_defs.push({
                field: _keys[i]
              });
            }
          }
          $scope.colDefinitions = _col_defs;
        }
      }

      function do_f(root, node, parent, parent_real, level, visible, index) {

        if (!angular.isObject(node)) {
          return 0;
        }

        var _i, _len, _icon, _index_real, _dept, _hashKey;
        if (!angular.isArray(node.__children__)) {
          node.__children__ = [];
        }

        node.__parent_real__ = parent_real;
        node.__parent__ = parent;
        _len = node.__children__.length;

        if (angular.isUndefinedOrNull(node.__expanded__) && node.isFolderType===1) { //angular.isUndefinedOrNull(node.__expanded__) && _len > 0
          node.__expanded__ = level < $scope.expandLevel;
        }

        if ((_len === 0 && node.isFolderType===0) || node.itemType === 'doc.quicktime') {
          _icon = -1;
        } else {
          if (node.__expanded__) {
            _icon = 1;
          } else {
            _icon = 0;
          }
        }

        // Insert item vertically
        _index_real = root.length;
        node.__index__ = index;
        node.__index_real__ = _index_real;
        node.__level__ = level;
        node.__icon__ = _icon;
        node.__icon_class__ = $scope.$class.icon[_icon];
        node.__visible__ = !!visible;

        if (angular.isUndefinedOrNull(node.__uid__)) {
          node.__uid__ = '' + Math.random();
        }

        _hashKey = $scope.getHash(node);

        if (angular.isUndefinedOrNull(node.__hashKey__) || node.__hashKey__ !== _hashKey) {
          node.__hashKey__ = _hashKey;
        }

        root.push(node);

        // Check node children
        _dept = 1;
        if (_len > 0) {
          for (_i = 0; _i < _len; _i++) {
            _dept += do_f(
              root,
              node.__children__[_i],
              node[$scope.primary_key],
              _index_real,
              level + 1,
              visible && node.__expanded__,
              _i
            );
          }
        }

        node.__dept__ = _dept;

        return _dept;
      }

      function init_data(data) {

        // clear memory
        if (angular.isDefined($scope.tree_nodes)) {
          delete $scope.tree_nodes;
        }
        $scope.tree_nodes = data;
        return data;
      }

      function reload_data(oData) {
        //removeIf(nodebug)
        // console.time('Reload_Data');
        //endRemoveIf(nodebug)

        var _data,
          _len,
          _tree_nodes = [];
        if (angular.isDefined(oData)) {
          if (!angular.isArray(oData) || oData.length === 0) {
            return init_data([]);
          } else {
            _data = oData;
          }
        } else if (!angular.isArray($scope.treeData) || $scope.treeData.length === 0) {
          return init_data([]);
        } else {
          _data = $scope.treeData;
        }

        if (!$attrs.expandOn) {
          getExpandOn();
        }

        if (!$attrs.columnDefs) {
          getColDefs();
        }

        if (angular.isDefined($scope.orderBy)) {
          if (!angular.isFunction(_fnInitOrderBy)) {
            _fnInitOrderBy = $TreeTablePlugin('$TreeTableOrderBy');
          }

          if (angular.isFunction(_fnInitOrderBy)) {
            _data = _fnInitOrderBy(_data, $scope.orderBy);
          }
        }

        if (angular.isDefined($scope.filter)) {
          if (!angular.isFunction(_fnInitFilter)) {
            _fnInitFilter = $TreeTablePlugin('$TreeTableFilter');
          }

          if (angular.isFunction(_fnInitFilter)) {
            _data = _fnInitFilter(_data, $scope.filter, $scope.filterOptions);
          }
        }

        _len = _data.length;
        if (_len > 0) {
          var _i,
            _deptTotal = 0;

          for (_i = 0; _i < _len; _i++) {
            _deptTotal += do_f(_tree_nodes, _data[_i], null, null, 1, true, _i);
          }
          _deptTotal;
        }

        init_data(_tree_nodes);

        //removeIf(nodebug)
        // console.timeEnd('Reload_Data');
        //endRemoveIf(nodebug)
        return _tree_nodes;
      }
    }

    function fnCompile(tElement) {

      var $_Template = '',
        _element = tElement.html().trim();

      if (_element.length > 0) {
        $_Template = _element;
        tElement.html('');
      }

      return function fnPost(scope, element, attrs) {

        // if (attrs.enableDrag) {
        //
        // }

        // kick out $digest
        element.ready(function() {
          // apply Template
          function checkTreeTable(template, scope) {
            var elemNode = template[0].querySelector('[tree-table-node]'),
              attrInclude;

            scope.isTable = null;
            if (elemNode) {
              elemNode = angular.element(elemNode);
              attrInclude = elemNode.attr('ng-include');
            } else {
              return;
            }

            if (attrInclude) {
              var treeInclude = $parse(attrInclude)(scope) || attrInclude;
              if (angular.isString(treeInclude)) {
                return $http.get(
                  treeInclude, {
                    cache: $templateCache
                  }
                ).success(
                  function(data) {
                    data = data.trim();
                    //scope.templateNode = data;
                    var tempDiv = $document[0].createElement('div');
                    tempDiv.innerHTML = data;
                    tempDiv = angular.element(tempDiv);
                    scope.isTable = !tempDiv[0].querySelector('[tree-table-nodes]');
                  }
                );
              }
            } else {
              scope.isTable = !elemNode[0].querySelector('[tree-table-nodes]');
              //scope.templateNode = elemNode.html();
            }
            $TreeTableViewport.setTemplate(scope, scope.templateNode);
            //elemNode.html('');
          }

          var promiseCheck;
          if ($_Template.length > 0) {
            promiseCheck = checkTreeTable(angular.element($_Template.trim()), scope);
            if (angular.isObject(promiseCheck)) {
              promiseCheck.then(function() {
                element.append($compile($_Template)(scope));
              });
            } else {
              element.append($compile($_Template)(scope));
            }
          } else {
            $http.get(
              attrs.templateUrl || $TreeTableTemplate.getPath(), {
                cache: $templateCache
              }
            ).success(
              function(data) {
                data = angular.element(data.trim());
                promiseCheck = checkTreeTable(data, scope);
                if (angular.isObject(promiseCheck)) {
                  promiseCheck.then(function() {
                    element.append($compile(data)(scope));
                  });
                } else {
                  element.append($compile(data)(scope));
                }
              }
            );
          }
        })
      };
    }
    return {
      restrict: 'E',
      scope: true,
      replace: true,
      controller: fnController,
      compile: fnCompile
    };
  }
  angular.module('eHRD.kernel.uiElements.treeTable')
    .directive('treeTable', fnInitTreeTable);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTableNodes.$inject = [];
  function TreeTableNodes() {
    return {
      restrict: 'A',
      replace:  true,
      link:     function (scope, element/*, attrs*/) {
        scope.$type = 'TreeTableNodes';

        if (scope.$class.nodes) {
          element.addClass(scope.$class.nodes);
          scope.$nodes_class = scope.$class.nodes;
        } else {
          scope.$nodes_class = '';
        }
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.treeTable')
    .directive('treeTableNodes', TreeTableNodes);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  TreeTableNode.$inject = ['$TreeTableViewport'/*, '$timeout'*/];
  function TreeTableNode($TreeTableViewport/*, $timeout*/) {
    return {
      restrict: 'A',
      replace:  true,
      link:     fnLink
    };
    function fnLink(scope, element, attrs) {

      scope.$node_class = '';

      if (scope.$class.node) {
        element.addClass(scope.$class.node);
        scope.$node_class = scope.$class.node;
      }
      var enabledDnD = typeof scope.dragEnabled === 'boolean' || typeof scope.dropEnabled === 'boolean',
        keyNode    = attrs.treeTableNode,
        first      = true,
        childsElem;
      //removeIf(nodebug)
      // console.log('Created Node');
      //endRemoveIf(nodebug)
      $TreeTableViewport.add(scope, element);

      if (enabledDnD) {
        scope.$type = 'TreeTableNode';

        scope.getData = function () {
          return scope[keyNode];
        };
      }

      scope.$element            = element;
      scope[keyNode].__inited__ = true;

      scope.getElementChilds = function () {
        return angular.element(element[0].querySelector('[tree-table-nodes]'));
      };

      scope.setScope(scope, scope[keyNode]);

      scope.getScopeNode = function () {
        return scope;
      };

      var objprops = [],
        objexpr,
        i, keyO  = Object.keys(scope[keyNode]),
        lenO     = keyO.length,
        hashKey  = scope[keyNode].__hashKey__,
        skipAttr = [
          '__visible__',
          '__children__',
          '__level__',
          '__index__',
          '__index_real__',

          '__parent__',
          '__parent_real__',
          '__dept__',
          '__icon__',
          '__icon_class__'
        ],
        keepAttr = [
          '__expanded__'
        ],
        lenKeep  = keepAttr.length;

      // skip __visible__
      for (i = 0; i < lenO + lenKeep; i++) {
        if (i < lenO) {
          if (skipAttr.indexOf(keyO[i]) === -1) {
            objprops.push(keyNode + '.' + keyO[i]);
          }
        } else {
          if (keyO.indexOf(keepAttr[i - lenO]) === -1) {
            objprops.push(keyNode + '.' + keepAttr[i - lenO]);
          }
        }
      }

      objexpr = '[' + objprops.join(',') + ']';

      scope.$watch(objexpr, fnWatchNode, true);

      scope.$on('$destroy', function () {
        scope.deleteScope(scope, scope[keyNode]);
      });

      function fnWatchNode(newVal, oldVal, scope) {

        //removeIf(nodebug)
        // console.time('Node_Changed');
        //endRemoveIf(nodebug)
        var nodeOf = scope[keyNode],
          _icon;

        if (first) {
          _icon                 = nodeOf.__icon__;
          nodeOf.__icon_class__ = scope.$class.icon[_icon];
        } else {

          var parentReal = nodeOf.__parent_real__,
            parentNode = scope.tree_nodes[parentReal] || null,
            _childs    = nodeOf.__children__,
            _len       = _childs.length,
            _i;

          if (!nodeOf.__inited__) {
            nodeOf.__inited__ = true;
          }

          if (nodeOf.__hashKey__ !== hashKey) {
            // clear scope in $globals
            scope.deleteScope(scope, nodeOf);

            // add new scope into $globals
            scope.setScope(scope, nodeOf);
            hashKey = nodeOf.__hashKey__;
          }

          if (parentNode && (!parentNode.__expanded__ || !parentNode.__visible__)) {
            element.addClass(scope.$class.hidden);
            nodeOf.__visible__ = false;
          } else {
            element.removeClass(scope.$class.hidden);
            nodeOf.__visible__ = true;
          }

          if (_len === 0 && nodeOf.isFolderType===0) { //_len === 0
            _icon = -1;
          } else {
            if (nodeOf.__expanded__) {
              _icon = 1;
            } else {
              _icon = 0;
            }
          }

          nodeOf.__icon__       = _icon;
          nodeOf.__icon_class__ = scope.$class.icon[_icon];

          if (scope.isTable) {
            for (_i = 0; _i < _len; _i++) {
              scope.for_all_descendants(_childs[_i], scope.hiddenChild, nodeOf, true);
            }
          } else {
            if (!childsElem) {
              childsElem = scope.getElementChilds();
            }

            if (nodeOf.__expanded__) {
              childsElem.removeClass(scope.$class.hidden);
            } else {
              childsElem.addClass(scope.$class.hidden);
            }
          }

        }

        //removeIf(nodebug)
        // console.timeEnd('Node_Changed');
        //endRemoveIf(nodebug)
        first      = false;

      }
    }
  }
  angular.module('eHRD.kernel.uiElements.treeTable')
    .directive('treeTableNode', TreeTableNode);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  function TreeTableNodeHandle() {
    return {
      restrict: 'A',
      scope:    true,
      link:     function (scope, element/*, attrs*/) {
        scope.$type = 'TreeTableNodeHandle';
        if (scope.$class.handle) {
          element.addClass(scope.$class.handle);
        }
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.treeTable')
    .directive('treeTableNodeHandle', TreeTableNodeHandle);
})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  compile.$inject = ['$compile'];
  function compile($compile) {
    return {
      restrict: 'A',
      link:     function (scope, element, attrs) {
        scope.$watch(
          attrs.compile, function (new_val) {
            if (new_val) {
              if (angular.isFunction(element.empty)) {
                element.empty();
              } else {
                element.html('');
              }

              element.append($compile(new_val)(scope));
            }
          }
        );
      }
    };
  }

  compileReplace.$inject = ['$compile'];
  function compileReplace($compile) {
    return {
      restrict: 'A',
      link:     function (scope, element, attrs) {
        scope.$watch(
          attrs.compileReplace, function (new_val) {
            if (new_val) {
              element.replaceWith($compile(new_val)(scope));
            }
          }
        );
      }
    };
  }


  angular.module('eHRD.kernel.uiElements.treeTable')
    .directive('compile', compile)
    .directive('compileReplace', compileReplace);


})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.tree',[]);

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  UiTreeHelper.$inject = [/*'$document', '$window', 'treeConfig'*/];
  function UiTreeHelper(/*$document, $window, treeConfig*/) {
    return {
      /**
       * A hashtable used to storage data of nodes
       * @type {Object}
       */
      nodesData: {},

      setNodeAttribute: function (scope, attrName, val) {
        if (!scope.$modelValue) {
          return null;
        }
        var data = this.nodesData[scope.$modelValue.hashKey];
        if (!data) {
          data = {};
          this.nodesData[scope.$modelValue.hashKey] = data;
        }
        data[attrName] = val;
      },

      getNodeAttribute: function (scope, attrName) {
        if (!scope.$modelValue) {
          return null;
        }
        var data = this.nodesData[scope.$modelValue.hashKey];
        if (data) {
          return data[attrName];
        }
        return null;
      }
    };
  }


  angular.module('eHRD.kernel.uiElements.tree')
    .factory('uiTreeHelper',UiTreeHelper);

})();

/**
 * Created by Bruce on 2017/5/5.
 */
(function () {
  'use strict';

  treeFactory.$inject = [];
  function treeFactory() {
    /**
     * Sort an array using the merge sort algorithm.
     *
     * @param {function} comparatorFn The comparator function.
     * @param {array} arr The array to sort.
     * @returns {array} The sorted array.
     */
    function mergeSort(comparatorFn, arr) {
      var len = arr.length, firstHalf, secondHalf;
      if (len >= 2) {
        firstHalf = arr.slice(0, len / 2);
        secondHalf = arr.slice(len / 2, len);
        return merge(comparatorFn, mergeSort(comparatorFn, firstHalf), mergeSort(comparatorFn, secondHalf));
      } else {
        return arr.slice();
      }
    }

    /**
     * The merge part of the merge sort algorithm.
     *
     * @param {function} comparatorFn The comparator function.
     * @param {array} arr1 The first sorted array.
     * @param {array} arr2 The second sorted array.
     * @returns {array} The merged and sorted array.
     */
    function merge(comparatorFn, arr1, arr2) {
      var result = [], left1 = arr1.length, left2 = arr2.length;
      while (left1 > 0 && left2 > 0) {
        if (comparatorFn(arr1[0], arr2[0]) <= 0) {
          result.push(arr1.shift());
          left1--;
        } else {
          result.push(arr2.shift());
          left2--;
        }
      }
      if (left1 > 0) {
        result.push.apply(result, arr1);
      } else {
        result.push.apply(result, arr2);
      }
      return result;
    }

    /**
     * Find the index to insert an element in array keeping the sort order.
     *
     * @param {function} comparatorFn The comparator function which sorted the array.
     * @param {array} arr The sorted array.
     * @param {object} el The element to insert.
     */
    function findInsertIndex(comparatorFn, arr, el) {
      var i, len;
      for (i = 0, len = arr.length; i < len; i++) {
        if (comparatorFn(arr[i], el) > 0) {
          break;
        }
      }
      return i;
    }





    var walkStrategies;

    walkStrategies = {};

    function k(result) {
      return function () {
        return result;
      };
    }

    function TreeModel(config) {
      config = config || {};
      this.config = config;
      this.config.childrenPropertyName = config.childrenPropertyName || 'children';
      this.config.modelComparatorFn = config.modelComparatorFn;
    }

    function addChildToNode(node, child) {
      child.parent = node;
      node.children.push(child);
      return child;
    }

    function Node(config, model) {
      this.config = config;
      this.model = model;
      this.children = [];
    }

    TreeModel.prototype.parse = function (model) {
      var i, childCount, node;

      if (!(model instanceof Object)) {
        throw new TypeError('Model must be of type object.');
      }

      node = new Node(this.config, model);
      if (model[this.config.childrenPropertyName] instanceof Array) {
        if (this.config.modelComparatorFn) {
          model[this.config.childrenPropertyName] = mergeSort(
            this.config.modelComparatorFn,
            model[this.config.childrenPropertyName]);
        }
        for (i = 0, childCount = model[this.config.childrenPropertyName].length; i < childCount; i++) {
          addChildToNode(node, this.parse(model[this.config.childrenPropertyName][i]));
        }
      }
      return node;
    };

    function hasComparatorFunction(node) {
      return angular.isFunction(node.config.modelComparatorFn);
    }

    Node.prototype.isRoot = function () {
      return angular.isUndefined(this.parent);
    };

    Node.prototype.hasChildren = function () {
      return this.children.length > 0;
    };

    function addChild(self, child, insertIndex) {
      var index;

      if (!(child instanceof Node)) {
        throw new TypeError('Child must be of type Node.');
      }

      child.parent = self;
      if (!(self.model[self.config.childrenPropertyName] instanceof Array)) {
        self.model[self.config.childrenPropertyName] = [];
      }

      if (hasComparatorFunction(self)) {
        // Find the index to insert the child
        index = findInsertIndex(
          self.config.modelComparatorFn,
          self.model[self.config.childrenPropertyName],
          child.model);

        // Add to the model children
        self.model[self.config.childrenPropertyName].splice(index, 0, child.model);

        // Add to the node children
        self.children.splice(index, 0, child);
      } else {
        if (angular.isUndefined(insertIndex)) {
          self.model[self.config.childrenPropertyName].push(child.model);
          self.children.push(child);
        } else {
          if (insertIndex < 0 || insertIndex > self.children.length) {
            throw new Error('Invalid index.');
          }
          self.model[self.config.childrenPropertyName].splice(insertIndex, 0, child.model);
          self.children.splice(insertIndex, 0, child);
        }
      }
      return child;
    }

    Node.prototype.addChild = function (child) {
      return addChild(this, child);
    };

    Node.prototype.addChildAtIndex = function (child, index) {
      if (hasComparatorFunction(this)) {
        throw new Error('Cannot add child at index when using a comparator function.');
      }

      return addChild(this, child, index);
    };

    Node.prototype.setIndex = function (index) {
      if (hasComparatorFunction(this)) {
        throw new Error('Cannot set node index when using a comparator function.');
      }

      if (this.isRoot()) {
        if (index === 0) {
          return this;
        }
        throw new Error('Invalid index.');
      }

      if (index < 0 || index >= this.parent.children.length) {
        throw new Error('Invalid index.');
      }

      var oldIndex = this.parent.children.indexOf(this);

      this.parent.children.splice(index, 0, this.parent.children.splice(oldIndex, 1)[0]);

      this.parent.model[this.parent.config.childrenPropertyName]
        .splice(index, 0, this.parent.model[this.parent.config.childrenPropertyName].splice(oldIndex, 1)[0]);

      return this;
    };

    Node.prototype.getPath = function () {
      var path = [];
      (function addToPath(node) {
        path.unshift(node);
        if (!node.isRoot()) {
          addToPath(node.parent);
        }
      })(this);
      return path;
    };

    Node.prototype.getIndex = function () {
      if (this.isRoot()) {
        return 0;
      }
      return this.parent.children.indexOf(this);
    };

    /**
     * Parse the arguments of traversal functions. These functions can take one optional
     * first argument which is an options object. If present, this object will be stored
     * in args.options. The only mandatory argument is the callback function which can
     * appear in the first or second position (if an options object is given). This
     * function will be saved to args.fn. The last optional argument is the context on
     * which the callback function will be called. It will be available in args.ctx.
     *
     * @returns Parsed arguments.
     */
    function parseArgs() {
      var args = {};
      if (arguments.length === 1) {
        if (angular.isFunction(arguments[0])) {
          args.fn = arguments[0];
        } else {
          args.options = arguments[0];
        }
      } else if (arguments.length === 2) {
        if (angular.isFunction(arguments[0])) {
          args.fn = arguments[0];
          args.ctx = arguments[1];
        } else {
          args.options = arguments[0];
          args.fn = arguments[1];
        }
      } else {
        args.options = arguments[0];
        args.fn = arguments[1];
        args.ctx = arguments[2];
      }
      args.options = args.options || {};
      if (!args.options.strategy) {
        args.options.strategy = 'pre';
      }
      if (!walkStrategies[args.options.strategy]) {
        throw new Error('Unknown tree walk strategy. Valid strategies are \'pre\' [default], \'post\' and \'breadth\'.');
      }
      return args;
    }

    Node.prototype.walk = function () {
      var args;
      args = parseArgs.apply(this, arguments);
      walkStrategies[args.options.strategy].call(this, args.fn, args.ctx);
    };

    walkStrategies.pre = function depthFirstPreOrder(callback, context) {
      var i, childCount, keepGoing;
      keepGoing = callback.call(context, this);
      for (i = 0, childCount = this.children.length; i < childCount; i++) {
        if (keepGoing === false) {
          return false;
        }
        keepGoing = depthFirstPreOrder.call(this.children[i], callback, context);
      }
      return keepGoing;
    };

    walkStrategies.post = function depthFirstPostOrder(callback, context) {
      var i, childCount, keepGoing;
      for (i = 0, childCount = this.children.length; i < childCount; i++) {
        keepGoing = depthFirstPostOrder.call(this.children[i], callback, context);
        if (keepGoing === false) {
          return false;
        }
      }
      keepGoing = callback.call(context, this);
      return keepGoing;
    };

    walkStrategies.breadth = function breadthFirst(callback, context) {
      var queue = [this];
      (function processQueue() {
        var i, childCount, node;
        if (queue.length === 0) {
          return;
        }
        node = queue.shift();
        for (i = 0, childCount = node.children.length; i < childCount; i++) {
          queue.push(node.children[i]);
        }
        if (callback.call(context, node) !== false) {
          processQueue();
        }
      })();
    };

    Node.prototype.all = function () {
      var args, all = [];
      args = parseArgs.apply(this, arguments);
      args.fn = args.fn || k(true);
      walkStrategies[args.options.strategy].call(this, function (node) {
        if (args.fn.call(args.ctx, node)) {
          all.push(node);
        }
      }, args.ctx);
      return all;
    };

    Node.prototype.first = function () {
      var args, first;
      args = parseArgs.apply(this, arguments);
      args.fn = args.fn || k(true);
      walkStrategies[args.options.strategy].call(this, function (node) {
        if (args.fn.call(args.ctx, node)) {
          first = node;
          return false;
        }
      }, args.ctx);
      return first;
    };

    Node.prototype.drop = function () {
      var indexOfChild;
      if (!this.isRoot()) {
        indexOfChild = this.parent.children.indexOf(this);
        this.parent.children.splice(indexOfChild, 1);
        this.parent.model[this.config.childrenPropertyName].splice(indexOfChild, 1);
        this.parent = undefined;
        delete this.parent;
      }
      return this;
    };

    return {

      mergeSort: mergeSort,
      findInsertIndex: findInsertIndex,
      TreeModel: TreeModel

    };
  }


  angular.module('eHRD.kernel.uiElements.tree')
    .factory('treeFactory',treeFactory);

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  uiTree.$inject = ['treeConfig', '$window'];
  function uiTree(treeConfig, $window) {

    function link(scope, element, attrs, ctrl) {
      var callbacks = {

        },
        config = {},
        tdElm,
        $trElm,
        emptyElmColspan;

      angular.extend(config, treeConfig);
      if (config.treeClass) {
        element.addClass(config.treeClass);
      }

      if (element.prop('tagName').toLowerCase() === 'table') {
        scope.$emptyElm = angular.element($window.document.createElement('tr'));
        $trElm = element.find('tr');
        // If we can find a tr, then we can use its td children as the empty element colspan.
        if ($trElm.length > 0) {
          emptyElmColspan = angular.element($trElm).children().length;
        } else {
          // If not, by setting a huge colspan we make sure it takes full width.
          emptyElmColspan = 1000000;
        }
        tdElm = angular.element($window.document.createElement('td'))
          .attr('colspan', emptyElmColspan);
        scope.$emptyElm.append(tdElm);
      } else {
        scope.$emptyElm = angular.element($window.document.createElement('div'));
      }

      if (config.emptyTreeClass) {
        scope.$emptyElm.addClass(config.emptyTreeClass);
      }

      scope.$watch('$nodesScope.$modelValue.length', function (val) {
        if (!angular.isNumber(val)) {
          return;
        }

        ctrl.resetEmptyElement();
      }, true);

      scope.$watch(attrs.maxDepth, function (val) {
        if ((typeof val) == 'number') {
          scope.maxDepth = val;
        }
      });

      /**
       * Callback is fired when a user toggles node (but after processing the toggle action)
       * @param sourceNodeScope
       * @param collapsed
       */
      callbacks.toggle = function (/*collapsed, sourceNodeScope*/) {

      };

      scope.$watch(attrs.uiTree, function (newVal/*, oldVal*/) {
        angular.forEach(newVal, function (value, key) {
          if (callbacks[key]) {
            if (angular.isFunction(typeof value)) {
              callbacks[key] = value;
            }
          }
        });
        scope.$callbacks = callbacks;
      }, true);
    }
    var directive = {
      restrict: 'A',
      scope: true,
      controller: 'uiTreeController',
      controllerAs:'treeRoot',
      link:link
    };

    return directive;
  }


  angular.module('eHRD.kernel.uiElements.tree')
    .directive('uiTree',uiTree)
    ;

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  uiTreeNodes.$inject = ['treeConfig'/*, '$window'*/];
  function uiTreeNodes(treeConfig/*, $window*/) {

    function link(scope, element, attrs, controllersArr) {
      var config = {},
        ngModel = controllersArr[0],
        treeNodeCtrl = controllersArr[1],
        treeCtrl = controllersArr[2];

      angular.extend(config, treeConfig);
      if (config.nodesClass) {
        element.addClass(config.nodesClass);
      }

      if (treeNodeCtrl) {
        treeNodeCtrl.scope.$childNodesScope = scope;
        scope.$nodeScope = treeNodeCtrl.scope;
      } else {
        // find the root nodes if there is no parent node and have a parent ui-tree
        treeCtrl.scope.$nodesScope = scope;
      }
      scope.$treeScope = treeCtrl.scope;

      if (ngModel) {
        ngModel.$render = function () {
          scope.$modelValue = ngModel.$modelValue;
        };
      }

      scope.$watch(function () {
        return attrs.maxDepth;
      }, function (val) {
        if ((typeof val) == 'number') {
          scope.maxDepth = val;
        }
      });

    }

    var directive = {
      require: ['ngModel', '?^uiTreeNode', '^uiTree'],
      restrict: 'A',
      scope: true,
      controller: 'uiTreeNodesController',
      controllerAs: 'treeNodes',
      link:link
    };

    return directive;
  }


  angular.module('eHRD.kernel.uiElements.tree')
    .directive('uiTreeNodes',uiTreeNodes)
  ;

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  uiTreeNode.$inject = ['treeConfig', 'uiTreeHelper', '$window'/*, '$document', '$timeout', '$q'*/];
  function uiTreeNode(treeConfig, uiTreeHelper, $window/*, $document, $timeout, $q*/) {

    function link(scope, element, attrs, controllersArr) {
      // todo startPos is unused
      var config = {},
        keydownHandler;

      angular.extend(config, treeConfig);
      if (config.nodeClass) {
        element.addClass(config.nodeClass);
      }
      scope.treeNode.init(controllersArr);

      scope.collapsed = !!uiTreeHelper.getNodeAttribute(scope, 'collapsed') || treeConfig.defaultCollapsed;
      // scope.sourceOnly = scope.nodropEnabled || scope.$treeScope.nodropEnabled;

      scope.$watch(attrs.collapsed, function (val) {
        if ((typeof val) == 'boolean') {
          scope.collapsed = val;
        }
      });

      scope.$watch('collapsed', function (val) {
        uiTreeHelper.setNodeAttribute(scope, 'collapsed', val);
        attrs.$set('collapsed', val);
      });

      scope.$on('angular-ui-tree:collapse-all', function () {
        scope.collapsed = true;
      });

      scope.$on('angular-ui-tree:expand-all', function () {
        scope.collapsed = false;
      });

      keydownHandler = function (e) {
        if (e.keyCode == 27) {
          // scope.$$allowNodeDrop = false;
          // dragEnd(e);
        }
      };

      angular.element($window.document).bind('keydown', keydownHandler);

      //unbind handler that retains scope
      scope.$on('$destroy', function () {
        angular.element($window.document).unbind('keydown', keydownHandler);
      });
    }
    var directive = {
      require: ['^uiTreeNodes', '^uiTree'],
      restrict: 'A',
      controller: 'uiTreeNodeController',
      controllerAs: 'treeNode',
      link:link
    };

    return directive;
  }


  angular.module('eHRD.kernel.uiElements.tree')
    .directive('uiTreeNode',uiTreeNode)
  ;

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';


  uiTreeHandle.$inject = ['treeConfig'];
  function uiTreeHandle(treeConfig) {
    function link(scope, element, attrs, treeNodeCtrl) {
      var config = {};
      angular.extend(config, treeConfig);
      if (config.handleClass) {
        element.addClass(config.handleClass);
      }
      // connect with the tree node.
      if (scope != treeNodeCtrl.scope) {
        scope.$nodeScope = treeNodeCtrl.scope;
        treeNodeCtrl.scope.$handleScope = scope;
      }
    }
    var directive = {
      require: '^uiTreeNode',
      restrict: 'A',
      scope: true,
      controller: 'TreeHandleController',
      link:link
    };
    return directive;
  }

  angular.module('eHRD.kernel.uiElements.tree')
    .directive('uiTreeHandle', uiTreeHandle);

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  uiTreeController.$inject = ['$scope','$element'];

  function uiTreeController($scope, $element) {
    var vm = this;
    vm.scope = $scope;
    vm.scope.$element = $element;
    vm.scope.$nodesScope = null; // root nodes
    vm.scope.$type = 'uiTree';
    vm.scope.$emptyElm = null;
    vm.scope.$callbacks = null;

    vm.scope.maxDepth = 0;

    // Check if it's a empty tree
    vm.isEmpty = function () {
      return (vm.scope.$nodesScope && vm.scope.$nodesScope.$modelValue
      && vm.scope.$nodesScope.$modelValue.length === 0);
    }; 


    vm.resetEmptyElement = function () {
      if ((!vm.scope.$nodesScope.$modelValue || vm.scope.$nodesScope.$modelValue.length === 0) /*&&
        $scope.emptyPlaceholderEnabled*/) {
        $element.append(vm.scope.$emptyElm);
      } else {
        vm.scope.$emptyElm.remove();
      }
    };

  }

  angular.module('eHRD.kernel.uiElements.tree')
    .controller('uiTreeController', uiTreeController)
   ;

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  uiTreeNodesController.$inject =['$scope', '$element'];
  function uiTreeNodesController($scope, $element) {
    var vm = this;
    vm.scope = $scope;

    vm.scope.$element = $element;
    vm.scope.$modelValue = null;
    vm.scope.$nodeScope = null; // the scope of node which the nodes belongs to
    vm.scope.$treeScope = null;
    vm.scope.$type = 'uiTreeNodes';
    vm.scope.$nodesMap = {};

    vm.scope.maxDepth = 0;

    vm.initSubNode = function (subNode) {
      if (!subNode.$modelValue) {
        return null;
      }
      vm.scope.$nodesMap[subNode.$modelValue.hashKey] = subNode;
    };

    vm.destroySubNode = function (subNode) {
      if (!subNode.$modelValue) {
        return null;
      }
      vm.scope.$nodesMap[subNode.$modelValue.hashKey] = null;
    };

    vm.accept = function (sourceNode, destIndex) {
      return vm.scope.$treeScope.$callbacks.accept(sourceNode, $scope, destIndex);
    };

    vm.isParent = function (node) {
      return node.$parentNodesScope == $scope;
    };

    vm.hasChild = function () {
      return vm.scope.$modelValue.length > 0;
    };



    vm.childNodes = function () {
      var i, nodes = [];
      if (vm.scope.$modelValue) {
        for (i = 0; i < vm.scope.$modelValue.length; i++) {
          nodes.push(vm.scope.$nodesMap[vm.scope.$modelValue[i].hashKey]);
        }
      }
      return nodes;
    };

    vm.depth = function () {
      if (vm.scope.$nodeScope) {
        return vm.scope.$nodeScope.depth();
      }
      return 0; // if it has no $nodeScope, it's root
    };

    // check if depth limit has reached
    vm.outOfDepth = function (sourceNode) {
      var maxDepth = vm.scope.maxDepth || vm.scope.$treeScope.maxDepth;
      if (maxDepth > 0) {
        return vm.depth() + sourceNode.maxSubDepth() + 1 > maxDepth;
      }
      return false;
    };

  }

  angular.module('eHRD.kernel.uiElements.tree')
    .controller('uiTreeNodesController', uiTreeNodesController)
   ;

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  uiTreeNodeController.$inject = ['$scope', '$element', '$stateParams'];
  function uiTreeNodeController($scope, $element, $stateParams){
    var vm = this;
    vm.scope = $scope;

    vm.scope.$element = $element;
    vm.scope.$modelValue = null; // Model value for node;
    vm.scope.$parentNodeScope = null; // uiTreeNode Scope of parent node;
    vm.scope.$childNodesScope = null; // uiTreeNodes Scope of child nodes.
    vm.scope.$parentNodesScope = null; // uiTreeNodes Scope of parent nodes.
    vm.scope.$treeScope = null; // uiTree scope
    vm.scope.$handleScope = null; // it's handle scope
    vm.scope.$type = 'uiTreeNode';
    vm.scope.collapsed = false;

    vm.init = function (controllersArr) {
      var treeNodesCtrl = controllersArr[0];
      vm.scope.$treeScope = controllersArr[1] ? controllersArr[1].scope : null;
      // find the scope of it's parent node
      vm.scope.$parentNodeScope = treeNodesCtrl.scope.$nodeScope;
      // modelValue for current node
      vm.scope.$modelValue = treeNodesCtrl.scope.$modelValue[$scope.$index];
      vm.scope.$parentNodesScope = treeNodesCtrl.scope;
      treeNodesCtrl.initSubNode($scope); // init sub nodes

      if($stateParams.id === vm.scope.$modelValue.id  && $stateParams.id!== ''){
        vm.scope.$element.addClass('active');
        var parentNode = vm.scope.$parentNodeScope;
        while(parentNode!==null){
          parentNode.$element.addClass('active');
          parentNode = parentNode.$parentNodeScope;
        }
      }

      $element.on('$destroy', function () {
        treeNodesCtrl.destroySubNode($scope); // destroy sub nodes
      });
    };

    vm.index = function () {
      return vm.scope.$parentNodesScope.$modelValue.indexOf(vm.scope.$modelValue);
    };



    vm.isSibling = function (targetNode) {
      return vm.scope.$parentNodesScope == targetNode.$parentNodesScope;
    };

    vm.isChild = function (targetNode) {
      var nodes = $scope.childNodes();
      return nodes && nodes.indexOf(targetNode) > -1;
    };

    vm.prev = function () {
      var index = vm.index();
      if (index > 0) {
        return vm.siblings()[index - 1];
      }
      return null;
    };

    vm.siblings = function () {
      return vm.scope.$parentNodesScope.childNodes();
    };

    vm.childNodesCount = function () {
      return vm.childNodes() ? vm.childNodes().length : 0;
    };

    vm.hasChild = function () {
      return vm.childNodesCount() > 0;
    };

    vm.childNodes = function () {
      return vm.scope.$childNodesScope && vm.scope.$childNodesScope.$modelValue ?
        vm.scope.$childNodesScope.childNodes() :
        null;
    };





    vm.toggle = function () {
      vm.scope.collapsed = !vm.scope.collapsed;
      vm.scope.$treeScope.$callbacks.toggle(vm.scope.collapsed, vm.scope);
    };

    vm.collapse = function () {
      vm.scope.collapsed = true;
    };

    vm.expand = function () {
      vm.scope.collapsed = false;
    };

    vm.depth = function () {
      var parentNode = vm.scope.$parentNodeScope;
      if (parentNode) {
        return parentNode.depth() + 1;
      }
      return 1;
    };

    /**
     * Returns the depth of the deepest subtree under this node
     * @param scope a TreeNodesController scope object
     * @returns Depth of all nodes *beneath* this node. If scope belongs to a leaf node, the
     *   result is 0 (it has no subtree).
     */
    function countSubTreeDepth(scope) {
      var thisLevelDepth = 0,
        childNodes = scope.childNodes(),
        childNode,
        childDepth,
        i;
      if (!childNodes || childNodes.length === 0) {
        return 0;
      }
      for (i = childNodes.length - 1; i >= 0 ; i--) {
        childNode = childNodes[i],
          childDepth = 1 + countSubTreeDepth(childNode);
        thisLevelDepth = Math.max(thisLevelDepth, childDepth);
      }
      return thisLevelDepth;
    }

    vm.maxSubDepth = function () {
      return vm.scope.$childNodesScope ? countSubTreeDepth(vm.scope.$childNodesScope) : 0;
    };

  }

  angular.module('eHRD.kernel.uiElements.tree')
    .controller('uiTreeNodeController', uiTreeNodeController)
   ;

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  uiTreeHandleController.$inject = ['$scope', '$element'];

  function uiTreeHandleController($scope, $element){
    var vm = this;

    vm.scope = $scope;

    vm.scope.$element = $element;
    vm.scope.$nodeScope = null;
    vm.scope.$type = 'uiTreeHandle';

  }

  angular.module('eHRD.kernel.uiElements.tree')
    .controller('uiTreeHandleController', uiTreeHandleController)
   ;

})();

/**
 * Created by Bruce on 2016/9/4.
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.timer',[]);
})();

/**
 * Created by Bruce on 2016/9/5.
 */
(function () {
  'use strict';

  function progressBarService() {
    var ProgressBarService = function() {};

    /**
     * calculate the remaining time in a progress bar in percentage
     * @param {momentjs} startValue in seconds
     * @param {integer} currentCountdown, where are we in the countdown
     * @param {integer} remainingTime, remaining milliseconds
     * @param {integer} endTime, end time, can be undefined
     * @param {integer} coutdown, original coutdown value, can be undefined
     *
     * joke : https://www.youtube.com/watch?v=gENVB6tjq_M
     * @return {float} 0 --> 100
     */
    ProgressBarService.prototype.calculateProgressBar = function calculateProgressBar(startValue, remainingTime, endTimeAttr, coutdown) {
      var displayProgressBar = 0,
        endTimeValue,
        initialCountdown;

      remainingTime = remainingTime / 1000; //seconds


      if(endTimeAttr !== null){
        endTimeValue = moment(endTimeAttr);
        initialCountdown = endTimeValue.diff(startValue, 'seconds');
        displayProgressBar = remainingTime * 100 / initialCountdown;
      }
      else {
        displayProgressBar = remainingTime * 100 / coutdown;
      }

      displayProgressBar = 100 - displayProgressBar; //To have 0 to 100 and not 100 to 0
      displayProgressBar = Math.round(displayProgressBar * 10) / 10; //learn more why : http://stackoverflow.com/questions/588004/is-floating-point-math-broken

      if(displayProgressBar > 100){ //security
        displayProgressBar = 100;
      }

      return displayProgressBar;
    };

    return new ProgressBarService();
  }
  angular.module('eHRD.kernel.uiElements.timer')
    .factory('progressBarService', progressBarService);
})();

/**
 * Created by Bruce on 2016/9/5.
 */
(function () {
  'use strict';

  function I18nService() {
    var I18nService = function() {};

    I18nService.prototype.language = 'en';
    I18nService.prototype.fallback = 'en';
    I18nService.prototype.timeHumanizer = {};

    I18nService.prototype.init = function init(lang, fallback) {
      var supported_languages = humanizeDuration.getSupportedLanguages();

      this.fallback = (angular.isDefined(fallback)) ? fallback : 'en';
      if (supported_languages.indexOf(fallback) === -1) {
        this.fallback = 'en';
      }

      this.language = lang;
      if (supported_languages.indexOf(lang) === -1) {
        this.language = this.fallback;
      }

      //moment init
      moment.locale(this.language); //@TODO maybe to remove, it should be handle by the user's application itself, and not inside the directive

      //human duration init, using it because momentjs does not allow accurate time (
      // momentJS: a few moment ago, human duration : 4 seconds ago
      this.timeHumanizer = humanizeDuration.humanizer({
        language: this.language,
        halfUnit:false
      });
    };

    /**
     * get time with units from momentJS i18n
     * @param {int} millis
     * @returns {{millis: string, seconds: string, minutes: string, hours: string, days: string, months: string, years: string}}
     */
    I18nService.prototype.getTimeUnits = function getTimeUnits(millis) {
      var diffFromAlarm = Math.round(millis/1000) * 1000; //time in milliseconds, get rid of the last 3 ms value to avoid 2.12 seconds display

      var time = {};

      if (angular.isDefined(this.timeHumanizer)){
        time = {
          'millis' : this.timeHumanizer(diffFromAlarm, { units: ["milliseconds"] }),
          'seconds' : this.timeHumanizer(diffFromAlarm, { units: ["seconds"] }),
          'minutes' : this.timeHumanizer(diffFromAlarm, { units: ["minutes", "seconds"] }) ,
          'hours' : this.timeHumanizer(diffFromAlarm, { units: ["hours", "minutes", "seconds"] }) ,
          'days' : this.timeHumanizer(diffFromAlarm, { units: ["days", "hours", "minutes", "seconds"] }) ,
          'months' : this.timeHumanizer(diffFromAlarm, { units: ["months", "days", "hours", "minutes", "seconds"] }) ,
          'years' : this.timeHumanizer(diffFromAlarm, { units: ["years", "months", "days", "hours", "minutes", "seconds"] })
        };
      }
      else {
        // console.error('i18nService has not been initialized. You must call i18nService.init("en") for example');
      }

      return time;
    };

    return I18nService;
  }
  angular.module('eHRD.kernel.uiElements.timer')
    .factory('I18nService', I18nService);
})();

/**
 * Created by Bruce on 2016/9/13.
 * Hack By Ng-Table
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.uiTable',[]);

})();

/**
 * Created by Bruce on 2016/9/13.
 */
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */
(function () {
  'use strict';

  ngTableParams.$inject = ['$q', '$log', '$filter', 'ngTableDefaults', 'ngTableDefaultGetData', 'ngTableEventsChannel'];
  function ngTableParams($q, $log, $filter, ngTableDefaults, ngTableDefaultGetData, ngTableEventsChannel) {
    var isNumber = function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    };
    var NgTableParams = function(baseParameters, baseSettings) {

      // the ngTableController "needs" to create a dummy/null instance and it's important to know whether an instance
      // is one of these
      if (typeof baseParameters === "boolean"){
        this.isNullInstance = true;
      }

      var self = this,
        prevParamsMemento,
        errParamsMemento,
        isCommittedDataset = false,
        initialEvents = [],
        log = function() {
          if (settings.debugMode && $log.debug) {
            $log.debug.apply($log, arguments);
          }
        },
        defaultFilterOptions = {
          filterComparator: undefined, // look for a substring match in case insensitive way
          filterDelay: 500,
          filterDelayThreshold: 10000, // size of dataset array that will trigger the filterDelay being applied
          filterFilterName: undefined, // when defined overrides ngTableDefaultGetDataProvider.filterFilterName
          filterFn: undefined, // when defined overrides the filter function that ngTableDefaultGetData uses
          filterLayout: 'stack' // alternative: 'horizontal'
        },
        defaultGroupOptions = {
          defaultSort: 'asc', // set to 'asc' or 'desc' to apply sorting to groups
          isExpanded: true
        },
        defaultSettingsFns = getDefaultSettingFns();

      this.data = [];

      /**
       * @ngdoc method
       * @name NgTableParams#parameters
       * @description Set new parameters or get current parameters
       *
       * @param {string} newParameters      New parameters
       * @param {string} parseParamsFromUrl Flag if parse parameters like in url
       * @returns {Object} Current parameters or `this`
       */
      this.parameters = function(newParameters, parseParamsFromUrl) {
        parseParamsFromUrl = parseParamsFromUrl || false;
        if (angular.isDefined(newParameters)) {
          for (var key in newParameters) {
            var value = newParameters[key];
            if (parseParamsFromUrl && key.indexOf('[') >= 0) {
              var keys = key.split(/\[(.*)\]/).reverse()
              var lastKey = '';
              for (var i = 0, len = keys.length; i < len; i++) {
                var name = keys[i];
                if (name !== '') {
                  var v = value;
                  value = {};
                  value[lastKey = name] = (isNumber(v) ? parseFloat(v) : v);
                }
              }
              if (lastKey === 'sorting') {
                params[lastKey] = {};
              }
              params[lastKey] = angular.extend(params[lastKey] || {}, value[lastKey]);
            } else {
              if (key === 'group'){
                params[key] = parseGroup(newParameters[key]);
              } else {
                params[key] = (isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key]);
              }
            }
          }
          log('ngTable: set parameters', params);
          return this;
        }
        return params;
      };

      function parseGroup(group){
        var defaultSort = settings.groupOptions && settings.groupOptions.defaultSort;
        if (angular.isFunction(group)) {
          if (group.sortDirection == null){
            group.sortDirection = defaultSort;
          }
          return group;
        } else if (angular.isString(group)) {
          var grp = {};
          grp[group] = defaultSort;
          return grp;
        } else if (angular.isObject(group)) {
          for (var key in group) {
            if (group[key] == null){
              group[key] = defaultSort;
            }
          }
          return group;
        } else {
          return group;
        }
      }

      /**
       * @ngdoc method
       * @name NgTableParams#settings
       * @description Set new settings for table
       *
       * @param {string} newSettings New settings or undefined
       * @returns {Object} Current settings or `this`
       */
      this.settings = function(newSettings) {
        if (angular.isDefined(newSettings)) {

          // todo: don't modify newSettings object: this introduces unexpected side effects;
          // instead take a copy of newSettings

          if (newSettings.filterOptions){
            newSettings.filterOptions = angular.extend({}, settings.filterOptions, newSettings.filterOptions);
          }
          if (newSettings.groupOptions){
            newSettings.groupOptions = angular.extend({}, settings.groupOptions, newSettings.groupOptions);
          }

          if (angular.isArray(newSettings.dataset)) {
            //auto-set the total from passed in dataset
            newSettings.total = newSettings.dataset.length;
          }

          var originalDataset = settings.dataset;
          settings = angular.extend(settings, newSettings);

          if (angular.isArray(newSettings.dataset)) {
            optimizeFilterDelay();
          }

          // note: using != as want null and undefined to be treated the same
          var hasDatasetChanged = newSettings.hasOwnProperty('dataset') && (newSettings.dataset != originalDataset);
          if (hasDatasetChanged) {
            if (isCommittedDataset){
              this.page(1); // reset page as a new dataset has been supplied
            }
            isCommittedDataset = false;

            var fireEvent = function () {
              ngTableEventsChannel.publishDatasetChanged(self, newSettings.dataset, originalDataset);
            };

            if (initialEvents){
              initialEvents.push(fireEvent);
            } else {
              fireEvent();
            }
          }
          log('ngTable: set settings', settings);
          return this;
        }
        return settings;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#page
       * @description If parameter page not set return current page else set current page
       *
       * @param {string} page Page number
       * @returns {Object|Number} Current page or `this`
       */
      this.page = function(page) {
        return angular.isDefined(page) ? this.parameters({
          'page': page
        }) : params.page;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#total
       * @description If parameter total not set return current quantity else set quantity
       *
       * @param {string} total Total quantity of items
       * @returns {Object|Number} Current page or `this`
       */
      this.total = function(total) {
        return angular.isDefined(total) ? this.settings({
          'total': total
        }) : settings.total;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#count
       * @description If parameter count not set return current count per page else set count per page
       *
       * @param {string} count Count per number
       * @returns {Object|Number} Count per page or `this`
       */
      this.count = function(count) {
        // reset to first page because can be blank page
        return angular.isDefined(count) ? this.parameters({
          'count': count,
          'page': 1
        }) : params.count;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#filter
       * @description If 'filter' parameter not set return current filter else set current filter
       *
       * Note: when assigning a new filter, {@link NgTableParams#page page} will be set to 1
       *
       * @param {Object|Boolean} filter 'object': new filter to assign or
       * 'true': to return the current filter minus any insignificant values (null,  undefined and empty string); or
       * 'falsey': to return the current filter "as is"
       * @returns {Object} Current filter or `this`
       */
      this.filter = function(filter) {
        if (angular.isDefined(filter) && angular.isObject(filter)) {
          return this.parameters({
            'filter': filter,
            'page': 1
          });
        } else if (filter === true){
          var keys = Object.keys(params.filter);
          var significantFilter = {};
          for (var i=0; i < keys.length; i++){
            var filterValue = params.filter[keys[i]];
            if (filterValue != null && filterValue !== '') {
              significantFilter[keys[i]] = filterValue;
            }
          }
          return significantFilter;
        } else {
          return params.filter;
        }
      };

      /**
       * @ngdoc method
       * @name NgTableParams#group
       * @description If 'group' parameter is not set, return current grouping. Otherwise set current group.
       *
       * @param {string|Function|Object} group New group field
       * @param {string} sortDirection Optional direction that the list of groups should be sorted
       * @returns {Object} Current grouping or `this`
       */
      this.group = function(group, sortDirection) {
        if (angular.isUndefined(group)){
          return params.group;
        }

        var newParameters = {
          page: 1
        };
        if (angular.isFunction(group) && angular.isDefined(sortDirection)){
          group.sortDirection = sortDirection;
          newParameters.group = group;
        } else if (angular.isDefined(group) && angular.isDefined(sortDirection)) {
          var groupArray = {};
          groupArray[group] = sortDirection;
          newParameters.group = groupArray;
        } else {
          newParameters.group = group;
        }
        this.parameters(newParameters);
        return this;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#sorting
       * @description If 'sorting' parameter is not set, return current sorting. Otherwise set current sorting.
       *
       * @param {string} sorting New sorting
       * @returns {Object} Current sorting or `this`
       */
      this.sorting = function(sorting) {
        if (arguments.length == 2) {
          var sortArray = {};
          sortArray[sorting] = arguments[1];
          this.parameters({
            'sorting': sortArray
          });
          return this;
        }
        return angular.isDefined(sorting) ? this.parameters({
          'sorting': sorting
        }) : params.sorting;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#isSortBy
       * @description Checks sort field
       *
       * @param {string} field     Field name
       * @param {string} direction Optional direction of sorting ('asc' or 'desc')
       * @returns {Array} Return true if field sorted by direction
       */
      this.isSortBy = function(field, direction) {
        if(angular.isDefined(direction)) {
          return angular.isDefined(params.sorting[field]) && params.sorting[field] == direction;
        } else {
          return angular.isDefined(params.sorting[field]);
        }
      };

      /**
       * @ngdoc method
       * @name NgTableParams#orderBy
       * @description Return object of sorting parameters for angular filter
       *
       * @returns {Array} Array like: [ '-name', '+age' ]
       */
      this.orderBy = function() {
        return convertSortToOrderBy(params.sorting);
      };

      function convertSortToOrderBy(sorting){
        var result = [];
        for (var column in sorting) {
          result.push((sorting[column] === "asc" ? "+" : "-") + column);
        }
        return result;
      }

      /**
       * @ngdoc method
       * @name NgTableParams#generatePagesArray
       * @description Generate array of pages
       *
       * When no arguments supplied, the current parameter state of this `NgTableParams` instance will be used
       *
       * @param {boolean} currentPage which page must be active
       * @param {boolean} totalItems  Total quantity of items
       * @param {boolean} pageSize    Quantity of items on page
       * @param {number} maxBlocks    Quantity of blocks for pagination
       * @returns {Array} Array of pages
       */
      this.generatePagesArray = function(currentPage, totalItems, pageSize/*, maxBlocks*/) {
        if (!arguments.length){
          currentPage = this.page();
          totalItems = this.total();
          pageSize = this.count();
        }

        var maxPage, maxPivotPages, minPage, numPages, pages;
        // maxBlocks = maxBlocks && maxBlocks < 6 ? 6 : maxBlocks;

        pages = [];
        numPages = Math.ceil(totalItems / pageSize);
        if (numPages > 1) {
          pages.push({
            type: 'prev',
            number: Math.max(1, currentPage - 1),
            active: currentPage > 1
          });
          pages.push({
            type: 'first',
            number: 1,
            active: currentPage > 1,
            current: currentPage === 1
          });
          maxPivotPages = Math.round((settings.paginationMaxBlocks - settings.paginationMinBlocks) / 2);
          minPage = Math.max(2, currentPage - maxPivotPages);
          maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
          minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
          var i = minPage;
          while (i <= maxPage) {
            if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
              pages.push({
                type: 'more',
                active: false
              });
            } else {
              pages.push({
                type: 'page',
                number: i,
                active: currentPage !== i,
                current: currentPage === i
              });
            }
            i++;
          }
          pages.push({
            type: 'last',
            number: numPages,
            active: currentPage !== numPages,
            current: currentPage === numPages
          });
          pages.push({
            type: 'next',
            number: Math.min(numPages, currentPage + 1),
            active: currentPage < numPages
          });
        }
        return pages;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#isDataReloadRequired
       * @description Return true when a change to this `NgTableParams` instance should require the reload method
       * to be run so as to ensure the data presented to the user reflects the `NgTableParams`
       *
       * Note that this method will return false when the reload method has run but fails. In this case
       * `hasErrorState` will return true.
       */
      this.isDataReloadRequired = function(){
        // note: using != as want to treat null and undefined the same
        return !isCommittedDataset || !angular.equals(createComparableParams(), prevParamsMemento)
          || hasGlobalSearchFieldChanges();
      };

      function createComparableParams(){
        var result = {params: params};
        if (angular.isFunction(params.group)){
          result.groupSortDirection = params.group.sortDirection;
        }
        return result
      }
      /**
       * @ngdoc method
       * @name NgTableParams#hasFilter
       * @description Determines if NgTableParams#filter has significant filter value(s)
       * (any value except null, undefined, or empty string)
       * @returns {Boolean} true when NgTableParams#filter has at least one significant field value
       */
      this.hasFilter = function(){
        return Object.keys(this.filter(true)).length > 0;
      };

      /**
       * @ngdoc method
       * @name NgTableParams#hasGroup
       * @description Determines if at least one group has been set
       * @returns {Boolean}
       */
      this.hasGroup = function(group, sortDirection){
        if (group == null) {
          return angular.isFunction(params.group) || Object.keys(params.group).length > 0
        }

        if (angular.isFunction(group)) {
          if (sortDirection == null) {
            return params.group === group;
          } else {
            return params.group === group && group.sortDirection === sortDirection;
          }
        } else {
          if (sortDirection == null) {
            return Object.keys(params.group).indexOf(group) !== -1;
          } else {
            return params.group[group] === sortDirection;
          }
        }
      };

      /**
       * @ngdoc method
       * @name NgTableParams#hasFilterChanges
       * @description Return true when a change to `NgTableParams.filters`require the reload method
       * to be run so as to ensure the data presented to the user reflects these filters
       */
      this.hasFilterChanges = function(){
        var previousFilter = (prevParamsMemento && prevParamsMemento.params.filter);
        return !angular.equals((params.filter), previousFilter) || hasGlobalSearchFieldChanges();
      };

      function hasGlobalSearchFieldChanges(){
        var currentVal = (params.filter && params.filter.$);
        var previousVal =
          (prevParamsMemento && prevParamsMemento.params.filter && prevParamsMemento.params.filter.$);
        return !angular.equals(currentVal, previousVal);
      }

      /**
       * @ngdoc method
       * @name NgTableParams#url
       * @description Return groups for table grouping
       *
       * @param {boolean} asString flag indicates return array of string or object
       * @returns {Array} If asString = true will be return array of url string parameters else key-value object
       */
      this.url = function(asString) {
        asString = asString || false;
        var pairs = (asString ? [] : {});
        for (var key in params) {
          if (params.hasOwnProperty(key)) {
            var item = params[key],
              name = encodeURIComponent(key);
            if (angular.isObject(item)) {
              for (var subkey in item) {
                if (isSignificantValue(item[subkey], key)) {
                  var pname = name + "[" + encodeURIComponent(subkey) + "]";
                  collectValue(item[subkey], pname);
                }
              }
            } else if (!angular.isFunction(item) && isSignificantValue(item, key)) {
              collectValue(item, name);
            }
          }
        }
        return pairs;

        function collectValue(value, key){
          if (asString) {
            pairs.push(key + "=" + encodeURIComponent(value));
          } else {
            pairs[key] = encodeURIComponent(value);
          }
        }

        function isSignificantValue(value, key){
          return key === "group" ? true : angular.isDefined(value) && value !== "";
        }
      };

      /**
       * @ngdoc method
       * @name NgTableParams#reload
       * @description Reload table data
       */
      this.reload = function() {
        var self = this,
          pData = null;

        settings.$loading = true;

        prevParamsMemento = angular.copy(createComparableParams());
        isCommittedDataset = true;

        if (self.hasGroup()) {
          pData = runInterceptorPipeline($q.when(settings.getGroups(self)));
        } else {
          pData = runInterceptorPipeline($q.when(settings.getData(self)));
        }

        log('ngTable: reload data');

        var oldData = self.data;
        return pData.then(function(data) {
          settings.$loading = false;
          errParamsMemento = null;

          self.data = data;
          // note: I think it makes sense to publish this event even when data === oldData
          // subscribers can always set a filter to only receive the event when data !== oldData
          ngTableEventsChannel.publishAfterReloadData(self, data, oldData);
          self.reloadPages();

          return data;
        }).catch(function(reason){
          errParamsMemento = prevParamsMemento;
          // "rethrow"
          return $q.reject(reason);
        });
      };

      /**
       * @ngdoc method
       * @name NgTableParams#hasErrorState
       * @description Return true when an attempt to `reload` the current `parameter` values have resulted in
       * a failure
       *
       * This method will continue to return true until the reload is successfully called or when the
       * `parameter` values have changed
       */
      this.hasErrorState = function(){
        return !!(errParamsMemento && angular.equals(errParamsMemento, createComparableParams()));
      };

      function optimizeFilterDelay(){
        // don't debounce by default filter input when working with small synchronous datasets
        if (settings.filterOptions.filterDelay === defaultFilterOptions.filterDelay &&
          settings.total <= settings.filterOptions.filterDelayThreshold &&
          settings.getData === defaultSettingsFns.getData){
          settings.filterOptions.filterDelay = 0;
        }
      }

      this.reloadPages = (function() {
        var currentPages;
        return function(){
          var oldPages = currentPages;
          var newPages = self.generatePagesArray(self.page(), self.total(), self.count());
          if (!angular.equals(oldPages, newPages)){
            currentPages = newPages;
            ngTableEventsChannel.publishPagesChanged(this, newPages, oldPages);
          }
        }
      })();

      function runInterceptorPipeline(fetchedData){
        var interceptors = settings.interceptors || [];

        return interceptors.reduce(function(result, interceptor){
          var thenFn = (interceptor.response && interceptor.response.bind(interceptor)) || $q.when;
          var rejectFn = (interceptor.responseError && interceptor.responseError.bind(interceptor)) || $q.reject;
          return result.then(function(data){
            return thenFn(data, self);
          }, function(reason){
            return rejectFn(reason, self);
          });
        }, fetchedData);
      }

      function getDefaultSettingFns(){

        return {
          getData: getData,
          getGroups: getGroups
        };

        /**
         * @ngdoc method
         * @name settings#getData
         * @description Returns the data to display in the table
         *
         * Called by `NgTableParams` whenever it considers new data is to be loaded
         *
         * @param {Object} params the `NgTableParams` requesting data
         */
        function getData(params) {
          return ngTableDefaultGetData(params.settings().dataset, params);
        }

        /**
         * @ngdoc method
         * @name settings#getGroups
         * @description Return groups of data to display in the table
         *
         * Called by `NgTableParams` whenever it considers new data is to be loaded
         * and when a `group` value has been assigned
         *
         * @param {Object} params the `NgTableParams` requesting data
         */
        function getGroups(params) {

          var group = params.group();
          var groupFn;
          var sortDirection = undefined;
          if (angular.isFunction(group)) {
            groupFn = group;
            sortDirection = group.sortDirection;
          } else {
            // currently support for only one group implemented
            var groupField = Object.keys(group)[0];
            sortDirection = group[groupField];
            groupFn = function(item){
              return getPath(item, groupField);
            };
          }

          var settings = params.settings();
          var originalDataOptions = settings.dataOptions;
          settings.dataOptions = { applyPaging: false };
          var gotData = $q.when(settings.getData(params));
          return gotData.then(function(data) {
            var groups = {};
            angular.forEach(data, function(item) {
              var groupName = groupFn(item);
              groups[groupName] = groups[groupName] || {
                  data: [],
                  $hideRows: !settings.groupOptions.isExpanded,
                  value: groupName
                };
              groups[groupName].data.push(item);
            });
            var result = [];
            for (var i in groups) {
              result.push(groups[i]);
            }
            if (sortDirection) {
              var orderByFn = ngTableDefaultGetData.getOrderByFn();
              var orderBy = convertSortToOrderBy({
                value: sortDirection
              });
              result = orderByFn(result, orderBy);
            }

            return ngTableDefaultGetData.applyPaging(result, params);
          }).finally(function(){
            // restore the real options
            settings.dataOptions = originalDataOptions;
          });
        }

        function getPath (obj, ks) {
          // origianl source https://github.com/documentcloud/underscore-contrib

          if (typeof ks == "string") ks = ks.split(".");

          // If we have reached an undefined property
          // then stop executing and return undefined
          if (angular.isUndefined(obj)) return void 0;

          // If the path array has no more elements, we've reached
          // the intended property and return its value
          if (ks.length === 0) return obj;

          // If we still have elements in the path array and the current
          // value is null, stop executing and return undefined
          if (obj === null) return void 0;

          return getPath(obj[ks[0]], ks.slice(1));
        }
      }

      var params = {
        page: 1,
        count: 10,
        filter: {},
        sorting: {},
        group: {}
      };
      angular.extend(params, ngTableDefaults.params);

      /**
       * @ngdoc object
       * @name settings
       * @module ngTable
       * @description configuration settings for `NgTableParams`
       */
      var settings = {
        $loading: false,
        dataset: null, //allows data to be set when table is initialized
        total: 0,
        defaultSort: 'desc',
        filterOptions: angular.copy(defaultFilterOptions),
        groupOptions: angular.copy(defaultGroupOptions),
        counts: ngTableDefaults.counts,
        interceptors: [],
        paginationMaxBlocks: 11,
        paginationMinBlocks: 5,
        sortingIndicator: 'span'
      };

      this.settings(defaultSettingsFns);
      this.settings(ngTableDefaults.settings);
      this.settings(baseSettings);
      this.parameters(baseParameters, true);

      ngTableEventsChannel.publishAfterCreated(this);
      // run events during construction after the initial create event. That way a consumer
      // can subscribe to all events for a table without "dropping" an event
      angular.forEach(initialEvents, function(event){
        event();
      });
      initialEvents = null;

      return this;
    };
    return NgTableParams;
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .factory('NgTableParams', ngTableParams);
})();


/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name ngTableEventsChannel
   * @description strongly typed pub/sub for `NgTableParams`
   *
   * Supported events:
   *
   * * afterCreated - raised when a new instance of `NgTableParams` has finished being constructed
   * * afterReloadData - raised when the `reload` event has finished loading new data
   * * datasetChanged - raised when `settings` receives a new data array
   * * pagesChanged - raised when a new pages array has been generated
   */
  ngTableEventsChannel.$inject = ['$rootScope'];
  function ngTableEventsChannel($rootScope){
    var events = {};
    events = addChangeEvent('afterCreated', events);
    events = addChangeEvent('afterReloadData', events);
    events = addChangeEvent('datasetChanged', events);
    events = addChangeEvent('pagesChanged', events);
    return events;

    //////////

    function addChangeEvent(eventName, target){
      var fnName = eventName.charAt(0).toUpperCase() + eventName.substring(1);
      var event = {};
      event['on' + fnName] = createEventSubscriptionFn(eventName);
      event['publish' + fnName] = createPublishEventFn(eventName);
      return angular.extend(target, event);
    }

    function createEventSubscriptionFn(eventName){

      return function subscription(handler/*[, eventSelector or $scope][, eventSelector]*/){
        var eventSelector = angular.identity;
        var scope = $rootScope;

        if (arguments.length === 2){
          if (angular.isFunction(arguments[1].$new)) {
            scope = arguments[1];
          } else {
            eventSelector = arguments[1]
          }
        } else if (arguments.length > 2){
          scope = arguments[1];
          eventSelector = arguments[2];
        }

        // shorthand for subscriber to only receive events from a specific publisher instance
        if (angular.isObject(eventSelector)) {
          var requiredPublisher = eventSelector;
          eventSelector = function(publisher){
            return publisher === requiredPublisher;
          }
        }

        return scope.$on('ngTable:' + eventName, function(event, params/*, ...args*/){
          // don't send events published by the internal NgTableParams created by ngTableController
          if (params.isNullInstance) return;

          var eventArgs = rest(arguments, 2);
          var fnArgs = [params].concat(eventArgs);
          if (eventSelector.apply(this, fnArgs)){
            handler.apply(this, fnArgs);
          }
        });
      }
    }

    function createPublishEventFn(eventName){
      return function publish(/*args*/){
        var fnArgs = ['ngTable:' + eventName].concat(Array.prototype.slice.call(arguments));
        $rootScope.$broadcast.apply($rootScope, fnArgs);
      }
    }

    function rest(array, n) {
      return Array.prototype.slice.call(array, n == null ? 1 : n);
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .factory('ngTableEventsChannel', ngTableEventsChannel);

})();

/**
 * Created by Bruce on 2016/9/13.
 */
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

(function () {
  'use strict';

  ngTableColumn.$inject = [];
  function ngTableColumn() {
    return {
      buildColumn: buildColumn
    };

    //////////////

    /**
     * @ngdoc method
     * @name ngTableColumn#buildColumn
     * @description Creates a $column for use within a header template
     *
     * @param {Object} column an existing $column or simple column data object
     * @param {Scope} defaultScope the $scope to supply to the $column getter methods when not supplied by caller
     * @param {Array} columns a reference to the columns array to make available on the context supplied to the
     * $column getter methods
     * @returns {Object} a $column object
     */
    function buildColumn(column, defaultScope, columns){
      // note: we're not modifying the original column object. This helps to avoid unintended side affects
      var extendedCol = Object.create(column);
      var defaults = createDefaults();
      for (var prop in defaults) {
        if (angular.isUndefined(extendedCol[prop])) {
          extendedCol[prop] = defaults[prop];
        }
        if(!angular.isFunction(extendedCol[prop])){
          // wrap raw field values with "getter" functions
          // - this is to ensure consistency with how ngTable.compile builds columns
          // - note that the original column object is being "proxied"; this is important
          //   as it ensure that any changes to the original object will be returned by the "getter"
          (function(prop1){
            var getterSetter = function getterSetter(/*[value] || [$scope, locals]*/) {
              if (arguments.length === 1 && !isScopeLike(arguments[0])) {
                getterSetter.assign(null, arguments[0]);
              } else {
                return column[prop1];
              }
            };
            getterSetter.assign = function($scope, value){
              column[prop1] = value;
            };
            extendedCol[prop1] = getterSetter;
          })(prop);
        }
        (function(prop1){
          // satisfy the arguments expected by the function returned by parsedAttribute in the ngTable directive
          var getterFn = extendedCol[prop1];
          extendedCol[prop1] = function () {
            if (arguments.length === 1 && !isScopeLike(arguments[0])){
              getterFn.assign(null, arguments[0]);
            } else {
              var scope = arguments[0] || defaultScope;
              var context = Object.create(scope);
              angular.extend(context, {
                $column: extendedCol,
                $columns: columns
              });
              return getterFn.call(column, context);
            }
          };
          if (getterFn.assign){
            extendedCol[prop1].assign = getterFn.assign;
          }
        })(prop);
      }
      return extendedCol;
    }

    function createDefaults(){
      return {
        'class': createGetterSetter(''),
        filter: createGetterSetter(false),
        groupable: createGetterSetter(false),
        filterData: angular.noop,
        headerTemplateURL: createGetterSetter(false),
        headerTitle: createGetterSetter(''),
        sortable: createGetterSetter(false),
        show: createGetterSetter(true),
        title: createGetterSetter(''),
        titleAlt: createGetterSetter(''),
        columnType: createGetterSetter('string'), // int or string or action, default: String
        width: createGetterSetter(undefined),
        minWidth: createGetterSetter(''),
        canHideColumn: createGetterSetter(true), // all column default can hide
        hideColumn: createGetterSetter(false), // all column default can hide
        priority: createGetterSetter(9999) // default: 1, 2, 3,... 9999
      };
    }

    function createGetterSetter(initialValue){
      var value = initialValue;
      var getterSetter = function getterSetter(/*[value] || [$scope, locals]*/){
        if (arguments.length === 1 && !isScopeLike(arguments[0])) {
          getterSetter.assign(null, arguments[0]);
        } else {
          return value;
        }
      };
      getterSetter.assign = function($scope, newValue){
        value = newValue;
      };
      return getterSetter;
    }

    function isScopeLike(object){
      return object != null && angular.isFunction(object.$new);
    }

  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .factory('ngTableColumn', ngTableColumn);
})();



/**
 * Created by Bruce on 2016/9/13.
 */

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */
(function(){
  'use strict';

  ngTableFilterConfigProvider.$inject = [];
  function ngTableFilterConfigProvider() {
    var config;
    var defaultConfig = {
      defaultBaseUrl: 'app/kernel/ui-elements/table/filters/',
      defaultExt: '.html',
      aliasUrls: {}
    };

    this.$get = ngTableFilterConfig;
    this.resetConfigs = resetConfigs;
    this.setConfig = setConfig;

    init();

    /////////

    function init(){
      resetConfigs();
    }

    function resetConfigs(){
      config = defaultConfig;
    }

    function setConfig(customConfig){
      var mergeConfig = angular.extend({}, config, customConfig);
      mergeConfig.aliasUrls = angular.extend({}, config.aliasUrls, customConfig.aliasUrls);
      config = mergeConfig;
    }

    /////////

    ngTableFilterConfig.$inject = [];

    function ngTableFilterConfig(){

      var publicConfig;

      var service = {
        config: publicConfig,
        getTemplateUrl: getTemplateUrl,
        getUrlForAlias: getUrlForAlias
      };
      Object.defineProperty(service, "config", {
        get: function(){
          return publicConfig = publicConfig || angular.copy(config);
        },
        enumerable: true
      });

      return service;

      /////////

      function getTemplateUrl(filterDef, filterKey){
        if (angular.isObject(filterDef)){
          filterDef = filterDef.id;
        }
        if (filterDef.indexOf('/') !== -1){
          return filterDef;
        }

        return service.getUrlForAlias(filterDef, filterKey);
      }

      function getUrlForAlias(aliasName/*, filterKey*/){
        return config.aliasUrls[aliasName] || config.defaultBaseUrl + aliasName + config.defaultExt;
      }
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .provider('ngTableFilterConfig', ngTableFilterConfigProvider);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */
(function () {
  'use strict';

  ngTableDefaultGetDataProvider.$inject = [];
  function ngTableDefaultGetDataProvider() {
    var provider = this;
    provider.$get = ngTableDefaultGetData;
    provider.filterFilterName = 'filter';
    provider.sortingFilterName = 'orderBy';

    ///////////

    ngTableDefaultGetData.$inject = ['$filter'];

    /**
     * @ngdoc service
     * @name ngTableDefaultGetData
     * @description A default implementation of the getData function that will apply the `filter`, `orderBy` and
     * paging values from the `NgTableParams` instance supplied to the data array supplied.
     *
     * The outcome will be to return the resulting array and to assign the total item count after filtering
     * to the `total` of the `NgTableParams` instance supplied
     */
    function ngTableDefaultGetData($filter) {

      var defaultDataOptions = {applyFilter: true, applySort: true, applyPaging: true};

      getData.applyPaging = applyPaging;
      getData.getFilterFn = getFilterFn;
      getData.getOrderByFn = getOrderByFn;

      return getData;

      function getFilterFn(params) {
        var filterOptions = params.settings().filterOptions;
        if (angular.isFunction(filterOptions.filterFn)){
          return filterOptions.filterFn;
        } else {
          return $filter(filterOptions.filterFilterName || provider.filterFilterName);
        }
      }

      function getOrderByFn (/*params*/){
        return $filter(provider.sortingFilterName);
      }

      function applyFilter(data, params) {
        if (!params.hasFilter()) {
          return data;
        }

        var filter = params.filter(true);
        var filterKeys = Object.keys(filter);
        var parsedFilter = filterKeys.reduce(function(result, key){
          result = setPath(result, filter[key], key);
          return result;
        }, {});
        var filterFn = getFilterFn(params);
        return filterFn.call(params, data, parsedFilter, params.settings().filterOptions.filterComparator);
      }

      function applyPaging(data, params) {
        var pagedData = data.slice((params.page() - 1) * params.count(), params.page() * params.count());
        params.total(data.length); // set total for recalc pagination
        return pagedData;
      }

      function applySort(data, params) {
        var orderBy = params.orderBy();
        var orderByFn = getOrderByFn(params);
        return orderBy.length ? orderByFn(data, orderBy) : data;
      }

      function getData(data, params) {
        if (data == null){
          return [];
        }

        var options = angular.extend({}, defaultDataOptions, params.settings().dataOptions);

        var fData = options.applyFilter ? applyFilter(data, params) : data;
        var orderedData = options.applySort ? applySort(fData, params) : fData;
        return options.applyPaging ? applyPaging(orderedData, params) : orderedData;
      }

      // Sets the value at any depth in a nested object based on the path
      // note: adapted from: underscore-contrib#setPath
      function setPath(obj, value, path) {
        var keys     = path.split('.');
        var ret      = obj;
        var lastKey  = keys[keys.length -1];
        var target   = ret;

        var parentPathKeys = keys.slice(0, keys.length -1);
        parentPathKeys.forEach(function(key) {
          if (!target.hasOwnProperty(key)) {
            target[key] = {};
          }
          target = target[key];
        });

        target[lastKey] = value;
        return ret;
      }
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .provider('ngTableDefaultGetData', ngTableDefaultGetDataProvider);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTable.$inject = ['$q', '$parse'];
  function ngTable($q, $parse) {
    return {
      restrict: 'A',
      priority: 1001,
      scope: true,
      controller: 'NgTableController',
      controllerAs:'TC',
      compile: function(element) {
        var columns = [],
          i = 0,
          dataRow,
          groupRow,
          rows = [];

        angular.forEach(element.find('tr'), function(tr) {
          rows.push(angular.element(tr))
        });
        dataRow = rows.filter(function(tr){
          return !tr.hasClass('ng-table-group');
        })[0];
        groupRow = rows.filter(function(tr){
          return tr.hasClass('ng-table-group');
        })[0];

        if (!dataRow) {
          return;
        }
        angular.forEach(dataRow.find('td'), function(item) {
          var el = angular.element(item);
          if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
            return;
          }

          var getAttrValue = function(attr){
            return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
          };
          var setAttrValue = function(attr, value){
            if (el.attr('x-data-' + attr)){
              el.attr('x-data-' + attr, value)
            } else if (el.attr('data' + attr)){
              el.attr('data' + attr, value)
            } else {
              el.attr(attr, value)
            }
          };

          var parsedAttribute = function(attr) {
            var expr = getAttrValue(attr);
            if (!expr){
              return undefined;
            }

            var localValue;
            var getter = function (context) {
              if (angular.isDefined(localValue)){
                return localValue;
              }
              return $parse(expr)(context);
            };
            getter.assign = function($scope, value){
              var parsedExpr = $parse(expr);
              if (parsedExpr.assign) {
                // we should be writing back to the parent scope as this is where the expression
                // came from
                parsedExpr.assign($scope.$parent, value);
              } else {
                localValue = value;
              }
            };
            return getter;
          };
          var titleExpr = getAttrValue('title-alt') || getAttrValue('title');
          if (titleExpr){
            el.attr('data-title-text', '{{' + titleExpr + '}}'); // this used in responsive table
          }
          // NOTE TO MAINTAINERS: if you add extra fields to a $column be sure to extend ngTableColumn with
          // a corresponding "safe" default
          columns.push({
            id: i++,
            title: parsedAttribute('title'),
            titleAlt: parsedAttribute('title-alt'),
            headerTitle: parsedAttribute('header-title'),
            sortable: parsedAttribute('sortable'),
            'class': parsedAttribute('header-class'),
            filter: parsedAttribute('filter'),
            groupable: parsedAttribute('groupable'),
            headerTemplateURL: parsedAttribute('header'),
            filterData: parsedAttribute('filter-data'),
            show: el.attr("ng-if") ? parsedAttribute('ng-if') : undefined
          });

          if (groupRow || el.attr("ng-if")){
            // change ng-if to bind to our column definition which we know will be writable
            // because this will potentially increase the $watch count, only do so if we already have an
            // ng-if or when we definitely need to change visibility of the columns.
            // currently only ngTableGroupRow directive needs to change visibility
            setAttrValue('ng-if', '$columns[' + (columns.length - 1) + '].show(this)');
          }
        });
        return function(scope, element, attrs, controller) {
          scope.$columns = columns = controller.buildColumns(columns);

          controller.setupBindingsToInternalScope(attrs.ngTable);
          controller.loadFilterData(columns);
          controller.compileDirectiveTemplates();
        };
      }
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTable', ngTable);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTableSorterRow.$inject = [];
  function ngTableSorterRow() {
    var directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/kernel/ui-elements/table/views/sorterRow.html',
      scope: true,
      controller: 'NgTableSorterRowController',
      controllerAs:'tsrc'
    };
    return directive;
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTableSorterRow', ngTableSorterRow);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTableSelectFilterDs.$inject = [];
  function ngTableSelectFilterDs() {
    var directive = {
      restrict: 'A',
      controller: ngTableSelectFilterDsController
    };
    return directive;
  }
  ngTableSelectFilterDsController.$inject = ['$scope', '$parse', '$attrs', '$q'];
  function ngTableSelectFilterDsController($scope, $parse, $attrs, $q){

    var $column = {};
    init();

    function init(){
      $column = $parse($attrs.ngTableSelectFilterDs)($scope);
      $scope.$watch(function(){
        return $column.data;
      }, bindDataSource);
    }

    function bindDataSource(){
      getSelectListData($column).then(function(data){
        if (data && !hasEmptyOption(data)){
          data.unshift({ id: '', title: ''});
        }
        data = data || [];
        $scope.$selectData = data;
      });
    }

    function hasEmptyOption(data) {
      var isMatch;
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        if (item && item.id === '') {
          isMatch = true;
          break;
        }
      }
      return isMatch;
    }

    function getSelectListData($column) {
      var data = angular.isFunction($column.data) ? $column.data() : $column.data;
      return $q.when(data);
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTableSelectFilterDs', ngTableSelectFilterDs);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTablePagination.$inject = ['$compile', 'ngTableEventsChannel','$document'];
  function ngTablePagination($compile, ngTableEventsChannel, $document) {
    return {
      restrict: 'A',
      scope: {
        'params': '=ngTablePagination',
        'templateUrl': '='
      },
      replace: false,
      link: function(scope, element/*, attrs*/) {

        ngTableEventsChannel.onAfterReloadData(function(pubParams) {
          scope.pages = pubParams.generatePagesArray();
        }, scope, function(pubParams){
          return pubParams === scope.params;
        });

        scope.$watch('templateUrl', function(templateUrl) {
          if (angular.isUndefined(templateUrl)) {
            return;
          }
          var template = angular.element($document[0].createElement('div'));
          template.attr({
            'ng-include': 'templateUrl'
          });
          element.append(template);
          $compile(template)(scope);
        });
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTablePagination', ngTablePagination);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTableGroupRow.$inject = [];
  function ngTableGroupRow() {
    var directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/kernel/ui-elements/table/views/groupRow.html',
      scope: true,
      controller: 'NgTableGroupRowController',
      controllerAs: 'dctrl'
    };
    return directive;
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTableGroupRow', ngTableGroupRow);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTableFilterRow.$inject = [];
  function ngTableFilterRow() {
    var directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/kernel/ui-elements/table/views/filterRow.html',
      scope: true,
      controller: 'NgTableFilterRowController'
    };
    return directive;
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTableFilterRow', ngTableFilterRow);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTableDynamic.$inject = ['$window', '$filter'];
  function ngTableDynamic($window, $filter) {
    return {
      restrict: 'A',
      priority: 1001,
      scope: true,
      controller: 'NgTableResponsiveController',
      compile: function(tElement) {
        var row;
        // IE 8 fix :not(.ng-table-group) selector
        angular.forEach(tElement.find('tr'), function(tr) {
          tr = angular.element(tr);
          if (!tr.hasClass('ng-table-group') && !row) {
            row = tr;
          }
        });
        if (!row) {
          return;
        }

        angular.forEach(row.find('td'), function(item) {
          var el = angular.element(item);
          var getAttrValue = function(attr){
            return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
          };

          // this used in responsive table
          var titleExpr = getAttrValue('title');
          if (!titleExpr){
            el.attr('data-title-text', '{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}');
          }
          var showExpr = el.attr('ng-if');
          if (!showExpr){
            el.attr('ng-if', '$columns[$index].show(this)');
          }
        });
        return function (scope, element, attrs, controller) {
          var expr = controller.parseNgTableDynamicExpr(attrs.ngTableDynamic);
          controller.setupBindingsToInternalScope(expr.tableParams);
          controller.compileDirectiveTemplates();

          scope.$watchCollection(expr.columns, function (newCols/*, oldCols*/) {
            controller.exprColumns = $filter('orderBy')(newCols, 'priority');
            if($filter('where')(newCols, {'classes' : 'control'}).length === 0){
              newCols.push(controller.controlColumn);
            }
            scope.$columns = controller.buildColumns(newCols);
            // set columns sort
            // scope.$columns = $filter('orderBy')(scope.$columns, 'priority()');
            controller.loadFilterData(scope.$columns);
          });

          angular.element($window).on('resize', function () {
            controller.resize();
          });
        };
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTableDynamic', ngTableDynamic);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  ngTableColumnsBinding.$inject = ['$parse'];
  function ngTableColumnsBinding($parse) {
    var directive = {
      restrict: 'A',
      require: 'ngTable',
      link: linkFn
    };
    return directive;

    function linkFn($scope, $element, $attrs){
      var setter = $parse($attrs.ngTableColumnsBinding).assign;
      if (setter){
        $scope.$watch('$columns', function(newColumns){
          var shallowClone = (newColumns || []).slice(0);
          setter($scope, shallowClone);
        });
      }
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .directive('ngTableColumnsBinding', ngTableColumnsBinding);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  NgTableController.$inject = ['$window', '$scope', 'NgTableParams', '$timeout', '$parse', '$compile', '$attrs', '$element',
    'ngTableColumn', 'ngTableEventsChannel', '$document', '$templateRequest'];
  function NgTableController($window, $scope, NgTableParams, $timeout, $parse, $compile, $attrs, $element, ngTableColumn, ngTableEventsChannel, $document, $templateRequest) {
    var vm = this;
    vm.scope = $scope;
    // var isFirstTimeLoad = true;
    vm.scope.$filterRow = {};
    vm.scope.$loading = false;

    // until such times as the directive uses an isolated scope, we need to ensure that the check for
    // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
    // field on a $scope higher up in the prototype chain
    if (!$scope.hasOwnProperty("params")) {
      vm.scope.params = new NgTableParams(true);
    }
    vm.scope.params.settings().$scope = $scope;

    var delayFilter = (function() {
      var timer = 0;
      return function(callback, ms) {
        $timeout.cancel(timer);
        timer = $timeout(callback, ms);
      };
    })();

    function onDataReloadStatusChange (newStatus/*, oldStatus*/) {
      if (!newStatus || vm.scope.params.hasErrorState()) {
        return;
      }

      vm.scope.params.settings().$scope = $scope;

      var currentParams = vm.scope.params;
      var filterOptions = currentParams.settings().filterOptions;

      if (currentParams.hasFilterChanges()) {
        var applyFilter = function () {
          currentParams.page(1);
          currentParams.reload();
        };
        if (filterOptions.filterDelay) {
          delayFilter(applyFilter, filterOptions.filterDelay);
        } else {
          applyFilter();
        }
      } else {
        currentParams.reload();
      }
    }

    // watch for when a new NgTableParams is bound to the scope
    // CRITICAL: the watch must be for reference and NOT value equality; this is because NgTableParams maintains
    // the current data page as a field. Checking this for value equality would be terrible for performance
    // and potentially cause an error if the items in that array has circular references
    $scope.$watch('params', function(newParams, oldParams){
      if (newParams === oldParams || !newParams) {
        return;
      }

      newParams.reload();
    }, false);

    $scope.$watch('params.isDataReloadRequired()', onDataReloadStatusChange);

    vm.compileDirectiveTemplates = function () {
      if (!$element.hasClass('ng-table')) {
        vm.scope.templates = {
          header: ($attrs.templateHeader ? $attrs.templateHeader : 'app/kernel/ui-elements/table/views/header.html'),
          pagination: ($attrs.templatePagination ? $attrs.templatePagination : 'app/kernel/ui-elements/table/views/pager.html'),
          responsiveRow: ($attrs.templateResponsiveRow ? $attrs.templateResponsiveRow : 'app/kernel/ui-elements/table/views/responsive-row.html')
        };
        $element.addClass('ng-table');
        var headerTemplate = null;

        // $element.find('> thead').length === 0 doesn't work on jqlite
        var theadFound = false;
        angular.forEach($element.children(), function(e) {
          if (e.tagName === 'THEAD') {
            theadFound = true;
          }
        });
        if (!theadFound) {
          headerTemplate = angular.element($document[0].createElement('thead')).attr('ng-include', 'templates.header');
          $element.prepend(headerTemplate);
        }
        var paginationTemplate = angular.element($document[0].createElement('div')).attr({
          'ng-table-pagination': 'params',
          'template-url': 'templates.pagination'
        });
        $element.after(paginationTemplate);
        if (headerTemplate) {
          $compile(headerTemplate)($scope);
        }
        $compile(paginationTemplate)($scope);
      }
    };

    vm.loadFilterData = function ($columns) {
      angular.forEach($columns, function ($column) {
        var result;
        result = $column.filterData($scope);
        if (!result) {
          delete $column.filterData;
          return;
        }

        // if we're working with a deferred object or a promise, let's wait for the promise
        /* WARNING: support for returning a $defer is depreciated */
        if ((angular.isObject(result) && (angular.isObject(result.promise) || angular.isFunction(result.then)))) {
          var pData = angular.isFunction(result.then) ? result : result.promise;
          delete $column.filterData;
          return pData.then(function(data) {
            // our deferred can eventually return arrays, functions and objects
            if (!angular.isArray(data) && !angular.isFunction(data) && !angular.isObject(data)) {
              // if none of the above was found - we just want an empty array
              data = [];
            }
            $column.data = data;
          });
        }
        // otherwise, we just return what the user gave us. It could be a function, array, object, whatever
        else {
          return $column.data = result;
        }
      });
    };

    vm.buildControlColumns = function (columns) {
      var responsiveCol = {
        classes: 'control',
        canHideColumn: false,
        minWidth: '50',
        clickFn: function ( row, $event ) {
          if(angular.element($event.target.parentNode).next('tr').attr("id") === 'responsive-child'){
            angular.element($event.target.parentNode).removeClass('parent');
            var rowChild = angular.element(angular.element($event.target.parentNode).next('tr'));
            if(rowChild.length > 0){
              rowChild.removeClass('fadeIn').addClass('fadeOut').hide('slow', function () {
                var current = $event.target.parentNode;
                // this.remove(); //IE 11 not support
                // reference: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
                // this.parentNode.removeChild(this);
                current.parentNode.removeChild(rowChild[0]);
              });
            }
          }else{
            angular.element($event.target.parentNode).addClass('parent');
            $templateRequest(vm.scope.templates.responsiveRow).then(function(html){
              var responsiveTR = angular.element(html).addClass('animated fadeIn');
              angular.element($event.target.parentNode).after(responsiveTR);
              if (responsiveTR) {
                vm.scope.responsiveTrRow = row;
                $compile(responsiveTR)($scope);
              }
            });
          }
        }
      };
      columns.push(ngTableColumn.buildColumn(responsiveCol, $scope, columns));
      return columns
    };

    vm.buildColumns = function (columns) {
      var result = [];
      (columns || []).forEach(function(col){
        result.push(ngTableColumn.buildColumn(col, $scope, result));
      });
      return result
    };

    vm.parseNgTableDynamicExpr = function (attr) {
      if (!attr || attr.indexOf(" with ") > -1) {
        var parts = attr.split(/\s+with\s+/);
        return {
          tableParams: parts[0],
          columns: parts[1]
        };
      } else {
        throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
      }
    };

    vm.setupBindingsToInternalScope = function(tableParamsExpr){

      // note: this we're setting up watches to simulate angular's isolated scope bindings

      // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
      // $watch for value equivalence. This is because ngTableParams references the current page of data as
      // a field and it's important not to watch this
      var tableParamsGetter = $parse(tableParamsExpr);
      $scope.$watch(tableParamsGetter, (function (params) {
        if (angular.isUndefined(params)) {
          return;
        }
        vm.scope.paramsModel = tableParamsGetter;
        vm.scope.params = params;
      }), false);

      setupFilterRowBindingsToInternalScope();
      setupGroupRowBindingsToInternalScope();
    };

    function setupFilterRowBindingsToInternalScope(){
      if ($attrs.showFilter) {
        $scope.$parent.$watch($attrs.showFilter, function(value) {
          vm.scope.show_filter = value;
        });
      } else {
        $scope.$watch(hasVisibleFilterColumn, function(value){
          vm.scope.show_filter = value;
        })
      }

      if ($attrs.disableFilter) {
        $scope.$parent.$watch($attrs.disableFilter, function(value) {
          vm.scope.$filterRow.disabled = value;
        });
      }
    }

    function setupGroupRowBindingsToInternalScope(){
      vm.scope.$groupRow = {};
      if ($attrs.showGroup) {
        var showGroupGetter = $parse($attrs.showGroup);
        $scope.$parent.$watch(showGroupGetter, function(value) {
          vm.scope.$groupRow.show = value;
        });
        if (showGroupGetter.assign){
          // setup two-way databinding thus allowing ngTableGrowRow to assign to the showGroup expression
          $scope.$watch('$groupRow.show', function(value) {
            showGroupGetter.assign($scope.$parent, value);
          });
        }
      } else{
        $scope.$watch('params.hasGroup()', function(newValue) {
          vm.scope.$groupRow.show = newValue;
        });
      }
    }

    function getVisibleColumns(){
      return ($scope.$columns || []).filter(function(c){
        return c.show($scope);
      });
    }

    function hasVisibleFilterColumn(){
      if (!$scope.$columns) return false;

      return some($scope.$columns, function($column){
        return $column.show($scope) && $column.filter($scope);
      });
    }

    function some(array, predicate){
      var found = false;
      for (var i = 0; i < array.length; i++) {
        var obj = array[i];
        if (predicate(obj)){
          found = true;
          break;
        }
      }
      return found;
    }

    function commonInit(){
      ngTableEventsChannel.onAfterReloadData(bindDataToScope, $scope, isMyPublisher);
      ngTableEventsChannel.onPagesChanged(bindPagesToScope, $scope, isMyPublisher);

      function bindDataToScope(params, newDatapage){
        var visibleColumns = getVisibleColumns();
        if (params.hasGroup()) {
          vm.scope.$groups = newDatapage || [];
          vm.scope.$groups.visibleColumnCount = visibleColumns.length;
        } else {
          vm.scope.$data = newDatapage || [];
          vm.scope.$data.visibleColumnCount = visibleColumns.length;
        }
      }


      function bindPagesToScope(params, newPages){
        vm.scope.pages = newPages
      }

      function isMyPublisher(publisher){
        return vm.scope.params === publisher;
      }
    }

    commonInit();
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .controller('NgTableController', NgTableController);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  NgTableSorterRowController.$inject = ['$scope'];
  function NgTableSorterRowController($scope) {
    var vm = this;
    vm.sortBy = sortBy;

    ///////////

    function sortBy($column, event) {
      var parsedSortable = $column.sortable && $column.sortable();
      if (!parsedSortable) {
        return;
      }
      var defaultSort = $scope.params.settings().defaultSort;
      var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
      var sorting = $scope.params.sorting() && $scope.params.sorting()[parsedSortable] && ($scope.params.sorting()[parsedSortable] === defaultSort);
      var sortingParams = (event.ctrlKey || event.metaKey) ? $scope.params.sorting() : {};
      sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
      $scope.params.parameters({
        sorting: sortingParams
      });
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .controller('NgTableSorterRowController', NgTableSorterRowController);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  NgTableResponsiveController.$inject = ['$window', '$scope', 'NgTableParams', '$timeout', '$parse', '$compile', '$attrs', '$element',
    'ngTableColumn', 'ngTableEventsChannel', '$document', '$templateRequest', '$filter'];
  function NgTableResponsiveController($window, $scope, NgTableParams, $timeout, $parse, $compile, $attrs, $element, ngTableColumn, ngTableEventsChannel, $document, $templateRequest, $filter) {
    var vm = this;
    vm.scope = $scope;
    // var isFirstTimeLoad = true;
    vm.scope.$filterRow = {};
    vm.scope.$loading = false;

    var breakpoints = [
      { name: 'desktop',  width: Infinity },
      { name: 'tablet-l', width: 1024 },
      { name: 'tablet-p', width: 720 }/*,
      { name: 'mobile-l', width: 480 },
      { name: 'mobile-p', width: 320 }*/
    ];

    // until such times as the directive uses an isolated scope, we need to ensure that the check for
    // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
    // field on a $scope higher up in the prototype chain
    if (!$scope.hasOwnProperty("params")) {
      vm.scope.params = new NgTableParams(true);
    }
    vm.scope.params.settings().$scope = $scope;

    var delayFilter = (function() {
      var timer = 0;
      return function(callback, ms) {
        $timeout.cancel(timer);
        timer = $timeout(callback, ms);
      };
    })();

    function onDataReloadStatusChange (newStatus/*, oldStatus*/) {
      if (!newStatus || vm.scope.params.hasErrorState()) {
        return;
      }

      vm.scope.params.settings().$scope = $scope;

      var currentParams = vm.scope.params;
      var filterOptions = currentParams.settings().filterOptions;

      if (currentParams.hasFilterChanges()) {
        var applyFilter = function () {
          currentParams.page(1);
          currentParams.reload();
        };
        if (filterOptions.filterDelay) {
          delayFilter(applyFilter, filterOptions.filterDelay);
        } else {
          applyFilter();
        }
      } else {
        currentParams.reload();
      }
    }

    // watch for when a new NgTableParams is bound to the scope
    // CRITICAL: the watch must be for reference and NOT value equality; this is because NgTableParams maintains
    // the current data page as a field. Checking this for value equality would be terrible for performance
    // and potentially cause an error if the items in that array has circular references
    $scope.$watch('params', function(newParams, oldParams){
      if (newParams === oldParams || !newParams) {
        return;
      }

      newParams.reload();
    }, false);

    $scope.$watch('params.isDataReloadRequired()', onDataReloadStatusChange);

    vm.compileDirectiveTemplates = function () {
      if (!$element.hasClass('ng-table')) {
        vm.scope.templates = {
          header: ($attrs.templateHeader ? $attrs.templateHeader : 'app/kernel/ui-elements/table/views/header.html'),
          pagination: ($attrs.templatePagination ? $attrs.templatePagination : 'app/kernel/ui-elements/table/views/pager.html'),
          responsiveRow: ($attrs.templateResponsiveRow ? $attrs.templateResponsiveRow : 'app/kernel/ui-elements/table/views/responsive-row.html')
        };
        $element.addClass('ng-table');
        var headerTemplate = null;

        // $element.find('> thead').length === 0 doesn't work on jqlite
        var theadFound = false;
        angular.forEach($element.children(), function(e) {
          if (e.tagName === 'THEAD') {
            theadFound = true;
          }
        });
        if (!theadFound) {
          headerTemplate = angular.element($document[0].createElement('thead')).attr('ng-include', 'templates.header');
          $element.prepend(headerTemplate);
        }
        var paginationTemplate = angular.element($document[0].createElement('div')).attr({
          'ng-table-pagination': 'params',
          'template-url': 'templates.pagination'
        });
        $element.after(paginationTemplate);
        if (headerTemplate) {
          $compile(headerTemplate)($scope);
        }
        $compile(paginationTemplate)($scope);
      }
    };

    vm.loadFilterData = function ($columns) {
      angular.forEach($columns, function ($column) {
        var result;
        result = $column.filterData($scope);
        if (!result) {
          delete $column.filterData;
          return;
        }

        // if we're working with a deferred object or a promise, let's wait for the promise
        /* WARNING: support for returning a $defer is depreciated */
        if ((angular.isObject(result) && (angular.isObject(result.promise) || angular.isFunction(result.then)))) {
          var pData = angular.isFunction(result.then) ? result : result.promise;
          delete $column.filterData;
          return pData.then(function(data) {
            // our deferred can eventually return arrays, functions and objects
            if (!angular.isArray(data) && !angular.isFunction(data) && !angular.isObject(data)) {
              // if none of the above was found - we just want an empty array
              data = [];
            }
            $column.data = data;
          });
        }
        // otherwise, we just return what the user gave us. It could be a function, array, object, whatever
        else {
          return $column.data = result;
        }
      });
    };

    vm.controlColumn = {
      classes: 'control',
      canHideColumn: false,
      minWidth: '50',
      clickFn: function ( row, $event ) {
        if(angular.element($event.target.parentNode).next('tr').attr("id") === 'responsive-child'){
          angular.element($event.target.parentNode).removeClass('parent');
          var rowChild = angular.element(angular.element($event.target.parentNode).next('tr'));
          if(rowChild.length > 0){
            rowChild.removeClass('fadeIn').addClass('fadeOut').hide('slow', function () {
              var current = $event.target.parentNode;
              // this.remove(); //IE 11 not support
              // reference: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
              // this.parentNode.removeChild(this);
              current.parentNode.removeChild(rowChild[0]);
            });
          }
        }else{
          angular.element($event.target.parentNode).addClass('parent');
          $templateRequest(vm.scope.templates.responsiveRow).then(function(html){
            var responsiveTR = angular.element(html).addClass('animated fadeIn');
            angular.element($event.target.parentNode).after(responsiveTR);
            if (responsiveTR) {
              vm.scope.row = row;
              $compile(responsiveTR)($scope);
            }
          });
        }
      }
    };

    vm.buildControlColumns = function (columns) {
      var responsiveCol = {
        classes: 'control',
        canHideColumn: false,
        minWidth: '50',
        clickFn: function ( row, $event ) {
          if(angular.element($event.target.parentNode).next('tr').attr("id") === 'responsive-child'){
            angular.element($event.target.parentNode).removeClass('parent');
            var rowChild = angular.element(angular.element($event.target.parentNode).next('tr'));
            if(rowChild.length > 0){
              rowChild.removeClass('fadeIn').addClass('fadeOut').hide('slow', function () {
                var current = $event.target.parentNode;
                // this.remove(); //IE 11 not support
                // reference: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
                // this.parentNode.removeChild(this);
                current.parentNode.removeChild(rowChild[0]);
              });
            }
          }else{
            angular.element($event.target.parentNode).addClass('parent');
            $templateRequest(vm.scope.templates.responsiveRow).then(function(html){
              var responsiveTR = angular.element(html).addClass('animated fadeIn');
              angular.element($event.target.parentNode).after(responsiveTR);
              if (responsiveTR) {
                vm.scope.row = row;
                $compile(responsiveTR)($scope);
              }
            });
          }
        }
      };
      columns.push(ngTableColumn.buildColumn(responsiveCol, $scope, columns));
      return columns
    };

    vm.buildColumns = function (columns) {
      var result = [];
      (columns || []).forEach(function(col){
        result.push(ngTableColumn.buildColumn(col, $scope, result));
      });
      return result
    };

    vm.parseNgTableDynamicExpr = function (attr) {
      if (!attr || attr.indexOf(" with ") > -1) {
        var parts = attr.split(/\s+with\s+/);
        return {
          tableParams: parts[0],
          columns: parts[1]
        };
      } else {
        throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
      }
    };

    vm.setupBindingsToInternalScope = function(tableParamsExpr){

      // note: this we're setting up watches to simulate angular's isolated scope bindings

      // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
      // $watch for value equivalence. This is because ngTableParams references the current page of data as
      // a field and it's important not to watch this
      var tableParamsGetter = $parse(tableParamsExpr);
      $scope.$watch(tableParamsGetter, (function (params) {
        if (angular.isUndefined(params)) {
          return;
        }
        vm.scope.paramsModel = tableParamsGetter;
        vm.scope.params = params;
      }), false);

      setupFilterRowBindingsToInternalScope();
      setupGroupRowBindingsToInternalScope();
    };

    function setupFilterRowBindingsToInternalScope(){
      if ($attrs.showFilter) {
        $scope.$parent.$watch($attrs.showFilter, function(value) {
          vm.scope.show_filter = value;
        });
      } else {
        $scope.$watch(hasVisibleFilterColumn, function(value){
          vm.scope.show_filter = value;
        })
      }

      if ($attrs.disableFilter) {
        $scope.$parent.$watch($attrs.disableFilter, function(value) {
          vm.scope.$filterRow.disabled = value;
        });
      }
    }

    function setupGroupRowBindingsToInternalScope(){
      vm.scope.$groupRow = {};
      if ($attrs.showGroup) {
        var showGroupGetter = $parse($attrs.showGroup);
        $scope.$parent.$watch(showGroupGetter, function(value) {
          vm.scope.$groupRow.show = value;
        });
        if (showGroupGetter.assign){
          // setup two-way databinding thus allowing ngTableGrowRow to assign to the showGroup expression
          $scope.$watch('$groupRow.show', function(value) {
            showGroupGetter.assign($scope.$parent, value);
          });
        }
      } else{
        $scope.$watch('params.hasGroup()', function(newValue) {
          vm.scope.$groupRow.show = newValue;
        });
      }
    }

    function getVisibleColumns(){
      return ($scope.$columns || []).filter(function(c){
        return c.show($scope);
      });
    }

    function hasVisibleFilterColumn(){
      if (!$scope.$columns) return false;

      return some($scope.$columns, function($column){
        return $column.show($scope) && $column.filter($scope);
      });
    }

    function some(array, predicate){
      var found = false;
      for (var i = 0; i < array.length; i++) {
        var obj = array[i];
        if (predicate(obj)){
          found = true;
          break;
        }
      }
      return found;
    }

    function commonInit(){
      ngTableEventsChannel.onAfterReloadData(bindDataToScope, $scope, isMyPublisher);
      ngTableEventsChannel.onPagesChanged(bindPagesToScope, $scope, isMyPublisher);

      function bindDataToScope(params, newDatapage){
        var visibleColumns = getVisibleColumns();
        if (params.hasGroup()) {
          vm.scope.$groups = newDatapage || [];
          vm.scope.$groups.visibleColumnCount = visibleColumns.length;
        } else {
          vm.scope.$data = newDatapage || [];
          vm.scope.$data.visibleColumnCount = visibleColumns.length;
        }
        vm.resize();
      }

      vm.resizeAuto = function () {
        vm.breakpoint = ''; vm.n_breakpoint = '';
        vm.eleWidth = $element.width();
        var _breakpoints = breakpoints.slice().reverse();
        angular.forEach(_breakpoints, function (breakpoint, index) {
          if ( vm.eleWidth <= breakpoint.width && vm.breakpoint.length === 0) {
            vm.breakpoint = breakpoint.name;
            vm.n_breakpoint = angular.isDefined(_breakpoints[index - 1]) ?
              _breakpoints[index - 1].name : undefined;
          }
        });
      };

      vm.resizeColumns = function () {
        vm.minColumns = 0;
        vm._minColumns = 0;
        vm.useTableWidth = 0;
        // set visibleColumns sort
        // vm.visibleColumns = $filter('orderBy')(getVisibleColumns(), 'priority()');
        vm.visibleColumns = getVisibleColumns();
        switch (vm.breakpoint){
          case 'desktop': // > 1024px
            angular.forEach(vm.visibleColumns, function (column) {
              if(column.columnType() === 'action'){
                column.priority(3);
              }
              if(column.priority() <= 3 ){
                column.canHideColumn(false);
                vm.minColumns += 1;
                if(column.width()){
                  vm.useTableWidth += column.width();
                }
              } else if(column.classes === 'control'){
                column.width(50);
                column.canHideColumn(false);
              } else {
                column.canHideColumn( true );
              }
            });
            break;
          case 'tablet-l': // <= 1024px
            angular.forEach(vm.visibleColumns, function (column) {
              if(column.columnType() === 'action'){
                column.priority(2);
              }
              if(column.priority() <= 2 ){
                column.canHideColumn(false);
                vm.minColumns += 1;
                if(column.width()){
                  vm.useTableWidth += column.width();
                  vm._minColumns += 1;
                }
              } else if(column.classes === 'control'){
                column.width(50);
                column.canHideColumn(false);
              } else {
                column.canHideColumn( true );
              }
            });
            break;
          case 'tablet-p': // 720px
            angular.forEach(vm.visibleColumns, function (column) {
              if(column.columnType() === 'action'){
                column.priority(1);
              }
              if(column.priority() <= 1 ){
                column.canHideColumn(false);
                vm.minColumns += 1;
              } else if(column.classes === 'control'){
                column.width(50);
                column.canHideColumn(false);
              } else {
                column.canHideColumn( true );
              }
            });
            break;
        }

        var columnWidth = 0;
        var breakpointWidth = 0;
        var p_breakpointWidth = 0;
        vm.useTableWidth += 50;
        if(angular.isDefined($filter('where')(breakpoints, {name:vm.breakpoint})[0])){
          breakpointWidth = $filter('where')(breakpoints, {name:vm.breakpoint})[0].width;
          var n_breakpoint = $filter('where')(breakpoints, {name:vm.n_breakpoint});
          if(vm.eleWidth <= breakpointWidth && n_breakpoint.length > 0){
            p_breakpointWidth = n_breakpoint[0].width;
            columnWidth = Math.floor((n_breakpoint[0].width - vm.useTableWidth)/(vm.minColumns - vm._minColumns));
          }
        }

        var _useTableWidth = 0;
        angular.forEach(vm.visibleColumns, function (column) {
          if(!column.canHideColumn() && column.classes !== 'control'){
            column.minWidth((columnWidth > 0) ? columnWidth : '');
            if( column.width()){
              column.minWidth(column.width());
              _useTableWidth += column.width();
            } else{
              _useTableWidth += (column.minWidth() !== '') ? parseInt(column.minWidth()) : 0;
            }
          }else if(column.classes === 'control'){
            if( column.width()){
              column.minWidth(column.width());
              _useTableWidth += column.width();
            }
          }

          if((angular.element($window)[0].innerWidth - 10) <= $filter('where')(breakpoints, {name:'tablet-p'})[0].width) {
            column.minWidth('');
          }
        });

        var hideColumnCount = 0;
        if(vm.eleWidth > p_breakpointWidth && p_breakpointWidth > 0){
          angular.forEach(vm.visibleColumns, function (column) {
              if(column.canHideColumn() && (_useTableWidth < vm.eleWidth) &&
                ((_useTableWidth + columnWidth) < vm.eleWidth) &&
                (angular.element($window)[0].innerWidth - 10) > $filter('where')(breakpoints, {name:'tablet-p'})[0].width){
                column.canHideColumn(false);
                column.minWidth(columnWidth);
                _useTableWidth += columnWidth;
              }
              if(column.canHideColumn()){
                hideColumnCount += 1;
              }
          });
        }else {
          angular.forEach(vm.visibleColumns, function (column) {
            if(column.canHideColumn()){
              hideColumnCount += 1;
            }
          });
        }

        angular.forEach(vm.visibleColumns, function (column) {
          if(column.classes === 'control'){
            if(hideColumnCount === 0){
              column.canHideColumn( true );
              vm.scope.canHideControlColumn = true;
            }else {
              column.canHideColumn( false );
              vm.scope.canHideControlColumn = false;
            }
          }
          column.hideColumn(column.canHideColumn());
        });
      };

      vm.resize = function (){
        vm.resizeAuto();
        vm.resizeColumns();
      };

      // vm.scope.$finishColumnRender = function () {
        // vm.resize();
      // };

      function bindPagesToScope(params, newPages){
        vm.scope.pages = newPages
      }

      function isMyPublisher(publisher){
        return vm.scope.params === publisher;
      }
    }

    commonInit();
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .controller('NgTableResponsiveController', NgTableResponsiveController);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  NgTableGroupRowController.$inject = ['$scope'];
  function NgTableGroupRowController($scope) {
    var vm = this;
    vm.scope = $scope;
    var groupFns = [];

    init();

    function init(){
      vm.scope.getGroupables = getGroupables;
      vm.scope.getGroupTitle = getGroupTitle;
      vm.scope.getVisibleColumns = getVisibleColumns;
      vm.scope.groupBy = groupBy;
      vm.scope.isSelectedGroup = isSelectedGroup;
      vm.scope.toggleDetail = toggleDetail;

      $scope.$watch('params.group()', setGroup, true);
    }

    function changeSortDirection(){
      var newDirection;
      if ($scope.params.hasGroup($scope.$selGroup, 'asc')) {
        newDirection = 'desc';
      } else if ($scope.params.hasGroup($scope.$selGroup, 'desc')){
        newDirection = '';
      } else {
        newDirection = 'asc';
      }
      $scope.params.group($scope.$selGroup, newDirection);
    }

    function findGroupColumn(groupKey) {
      return $scope.$columns.filter(function ($column) {
        return $column.groupable($scope) === groupKey;
      })[0];
    }

    function getGroupTitle(group){
      return angular.isFunction(group) ? group.title : group.title($scope);
    }

    function getGroupables(){
      var groupableCols = $scope.$columns.filter(function ($column) {
        return $column.groupable($scope);
      });
      return groupFns.concat(groupableCols);
    }

    function getVisibleColumns(){
      return $scope.$columns.filter(function($column){
        return $column.show($scope);
      })
    }

    function groupBy(group){
      if (isSelectedGroup(group)){
        changeSortDirection();
      } else {
        if (group.groupable){
          $scope.params.group(group.groupable($scope));
        } else{
          $scope.params.group(group);
        }
      }
    }

    function isSelectedGroup(group){
      if (group.groupable){
        return group.groupable($scope) === $scope.$selGroup;
      } else {
        return group === $scope.$selGroup;
      }
    }

    function setGroup(group){
      var existingGroupCol = findGroupColumn($scope.$selGroup);
      if (existingGroupCol && existingGroupCol.show.assign){
        existingGroupCol.show.assign($scope, true);
      }
      if (angular.isFunction(group)) {
        groupFns = [group];
        vm.scope.$selGroup = group;
        vm.scope.$selGroupTitle = group.title;
      } else {
        // note: currently only one group is implemented
        var groupKey = Object.keys(group || {})[0];
        var groupedColumn = findGroupColumn(groupKey);
        if (groupedColumn) {
          vm.scope.$selGroupTitle = groupedColumn.title($scope);
          vm.scope.$selGroup = groupKey;
          if (groupedColumn.show.assign) {
            groupedColumn.show.assign($scope, false);
          }
        }
      }
    }

    function toggleDetail(){
      $scope.params.settings().groupOptions.isExpanded = !$scope.params.settings().groupOptions.isExpanded;
      return $scope.params.reload();
    }
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .controller('NgTableGroupRowController', NgTableGroupRowController);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  NgTableFilterRowController.$inject = ['$scope', 'ngTableFilterConfig'];
  function NgTableFilterRowController($scope, ngTableFilterConfig) {
    var vm = this;
    vm.scope = $scope;
    vm.scope.config = ngTableFilterConfig;

    vm.scope.getFilterCellCss = function (filter, layout){
      if (layout !== 'horizontal') {
        return 's12';
      }

      var size = Object.keys(filter).length;
      var width = parseInt(12 / size, 10);
      return 's' + width;
    };

    vm.scope.getFilterPlaceholderValue = function(filterValue/*, filterName*/){
      if (angular.isObject(filterValue)) {
        return filterValue.placeholder;
      } else {
        return '';
      }
    };
  }

  angular.module('eHRD.kernel.uiElements.uiTable')
    .controller('NgTableFilterRowController', NgTableFilterRowController);
})();

/**
 * Created by Bruce on 2016/6/27.
 */

(function () {
  'use strict';
  angular.module('eHRD.kernel.uiElements.pagination',[]); 
})();

/**
 * Created by Bruce on 2016/6/27.
 */

(function () {
  'use strict';

  function uiPaginationService(){
    var instances = {};
    var lastRegisteredInstance;

    return {
      registerInstance : function (instanceId) {
        if (angular.isUndefined(instances[instanceId])) {
          instances[instanceId] = {
            asyncMode: false
          };
          lastRegisteredInstance = instanceId;
        }
      },

      deregisterInstance : function(instanceId) {
        delete instances[instanceId];
      },

      isRegistered : function(instanceId) {
        return (angular.isDefined(instances[instanceId]));
      },

      getLastInstanceId : function() {
        return lastRegisteredInstance;
      },

      setCurrentPageParser : function(instanceId, val, scope) {
        instances[instanceId].currentPageParser = val;
        instances[instanceId].context = scope;
      },

      setFilterOptionParser : function(instanceId, val, scope) {
        instances[instanceId].filterOptionParser = val;
        instances[instanceId].context = scope;
      },

      setSortOption : function (instanceId, key, method) {
        instances[instanceId].sortOption = {};
        instances[instanceId].sortOption.key = key;
        instances[instanceId].sortOption.method = method;
      },
      getSortOption : function (instanceId) {
        return instances[instanceId].sortOption;
      },

      setFilterOption : function (instanceId, filterKey, filterValue) {
        instances[instanceId].filterOption = {};
        instances[instanceId].filterOption.filterKey = filterKey;
        instances[instanceId].filterOption.filterValue = filterValue;
      },
      getFilterOption : function (instanceId) {
        return instances[instanceId].filterOption;
      },

      setSearchOption : function(instanceId, val) {
        instances[instanceId].searchOption = val;
      },

      getSearchOption : function(instanceId) {
        return instances[instanceId].searchOption;
      },

      setContentLayoutTemplate : function(instanceId, val) {
        instances[instanceId].contentLayoutTemplate = val;
      },

      getContentLayoutTemplate : function(instanceId) {
        return instances[instanceId].contentLayoutTemplate;
      },

      setPaginationsObj : function(instanceId, val) {
        instances[instanceId].paginationsObj = val;
      },

      getPaginationsObj : function(instanceId) {
        return instances[instanceId].paginationsObj;
      },

      setCurrentPage : function(instanceId, val) {
        instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
      },

      getCurrentPage : function(instanceId) {
        var parser = instances[instanceId].currentPageParser;
        return parser ? parser(instances[instanceId].context) : 1;
      },

      setItemsPerPage : function(instanceId, val) {
        instances[instanceId].itemsPerPage = val;
      },

      getItemsPerPage : function(instanceId) {
        return instances[instanceId].itemsPerPage;
      },

      setCollectionLength : function(instanceId, val) {
        instances[instanceId].collectionLength = val;
      },

      getCollectionLength : function(instanceId) {
        return instances[instanceId].collectionLength;
      },

      setAsyncModeTrue : function(instanceId) {
        instances[instanceId].asyncMode = true;
      },

      setAsyncModeFalse : function(instanceId) {
        instances[instanceId].asyncMode = false;
      },

      isAsyncMode : function(instanceId) {
        return instances[instanceId].asyncMode;
      }
    };

  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .factory('uiPaginationService', uiPaginationService);
})();

/**
 * Created by Bruce on 2016/6/27.
 */

(function () {
  'use strict';

  function paginationTemplateProvider() {
    var templatePath = 'default.pagination.template';
    var headerTemplatePath = 'default.pagination.template';
    var templateString;
    var headerTemplateString;

    /**
     * Set a templateUrl to be used by all instances of <dir-pagination-controls>
     * @param {String} path
     */
    this.setPath = function(path) {
      templatePath = path;
    };

    this.setHeaderPath = function(path) {
      headerTemplatePath = path;
    };

    /**
     * Set a string of HTML to be used as a template by all instances
     * of <dir-pagination-controls>. If both a path *and* a string have been set,
     * the string takes precedence.
     * @param {String} str
     */
    this.setString = function(str) {
      templateString = str;
    };
    this.setHeaderString = function(str) {
      headerTemplateString = str;
    };

    this.$get = function() {
      return {
        getPath: function() {
          return templatePath;
        },
        getString: function() {
          return templateString;
        },

        getHeaderPath: function() {
          return headerTemplatePath;
        },
        getHeaderString: function() {
          return headerTemplateString;
        }
      };
    };
  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .provider('paginationTemplate', paginationTemplateProvider);
})();

/**
 * Created by Bruce on 2016/6/27.
 */
(function() {
  'use strict';

  itemsPerPageFilter.$inject = ['uiPaginationService', 'uiPaginationConfig'];

  function itemsPerPageFilter(uiPaginationService, uiPaginationConfig) {
    var DEFAULT_ID = uiPaginationConfig.DEFAULT_ID;

    return function(collection, itemsPerPage, paginationId) {
      if (angular.isUndefined(paginationId)) {
        paginationId = DEFAULT_ID;
      }
      if (!uiPaginationService.isRegistered(paginationId)) {
        throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
      }
      var end;
      var start;
      if (angular.isObject(collection)) {
        itemsPerPage = parseInt(itemsPerPage) || 999999999;
        if (uiPaginationService.isAsyncMode(paginationId)) {
          start = 0;
        } else {
          start = (uiPaginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
        }
        end = start + itemsPerPage;
        uiPaginationService.setItemsPerPage(paginationId, itemsPerPage);

        if (collection instanceof Array) {
          // the array just needs to be sliced
          return collection.slice(start, end);
        } else {
          // in the case of an object, we need to get an array of keys, slice that, then map back to
          // the original object.
          var slicedObject = {};
          angular.forEach(keys(collection).slice(start, end), function(key) {
            slicedObject[key] = collection[key];
          });
          return slicedObject;
        }
      } else {
        return collection;
      }
    };
  }

  /**
   * Shim for the Object.keys() method which does not exist in IE < 9
   * @param obj
   * @returns {Array}
   */
  function keys(obj) {
    if (!Object.keys) {
      var objKeys = [];
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          objKeys.push(i);
        }
      }
      return objKeys;
    } else {
      return Object.keys(obj);
    }
  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .filter('itemsPerPage', itemsPerPageFilter);
})();

/**
 * Created by Bruce on 2016/6/27.
 */
(function() {
  'use strict';
  uiPaginationHeaderControls.$inject = ['uiPaginationService', 'paginationTemplate', 'uiPaginationConfig', '$filter'];

  function uiPaginationHeaderControls( uiPaginationService, paginationTemplate, uiPaginationConfig, $filter) {
    var DEFAULT_ID = uiPaginationConfig.DEFAULT_ID;
    var DDO = {
      restrict: 'AE',
      scope: {
        onSortChange: '&?',
        reloadPaginationData: '&?',
        paginationId: '=?',
        paginationSort: '=?',
        paginationFilter:'=?',
        sorts: '=?',
        filters:'=?',
        hasSearchBox: '=?',
        hasChangeTemplate: '=?',
        templateType:'@?',
        placeholder:'@?'
      },
      link: uiPaginationControlsLinkFn
    };

    // We need to check the paginationTemplate service to see whether a template path or
    // string has been specified, and add the `template` or `templateUrl` property to
    // the DDO as appropriate. The order of priority to decide which template to use is
    // (highest priority first):
    // 1. paginationTemplate.getHeaderString()
    // 2. attrs.templateUrl
    // 3. paginationTemplate.getPath()
    var templateString = paginationTemplate.getHeaderString();
    if (angular.isDefined(templateString)) {
      DDO.template = templateString;
    } else {
      DDO.templateUrl = function(elem, attrs) {
        return attrs.templateUrl || paginationTemplate.getHeaderPath();
      };
    }
    return DDO;


    function uiPaginationControlsLinkFn(scope, element, attrs) {

      // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding ui-paginate directive has
      // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
      // no corresponding ui-paginate directive and wrongly throwing an exception.
      // var rawId = attrs.paginationId || DEFAULT_ID;
      var paginationId = scope.paginationId || attrs.paginationId || DEFAULT_ID;

      // if (!uiPaginationService.isRegistered(paginationId) && !uiPaginationService.isRegistered(rawId)) {
      //
      // }

      scope.autoHide = angular.isUndefined(scope.autoHide) ? true : scope.autoHide;
      scope.paginationSort = angular.isUndefined(scope.paginationSort) ? null : scope.paginationSort;
      scope.sorts = angular.isUndefined(scope.sorts) ? null : scope.sorts;
      scope.placeholder = angular.isUndefined(scope.placeholder) ? $filter('translate')('FIELD.SEARCH_THIS_AND_SUB_CATEGORIES') : scope.placeholder;

      scope.$watch('paginationSort', function(sortOption, oldVal) {
        if(!angular.equals(sortOption, oldVal)){
          uiPaginationService.setSortOption(paginationId, sortOption.sortKey, sortOption.sortMethod);
        }
      });

      scope.paginationFilter = angular.isUndefined(scope.paginationFilter) ? null : scope.paginationFilter;
      scope.filters = angular.isUndefined(scope.filters) ? null : scope.filters;

      scope.$watch('paginationFilter', function(filterOption, oldVal) {
        if(!angular.equals(filterOption, oldVal)){
          uiPaginationService.setFilterOption(paginationId, filterOption.filterKey, filterOption.filterValue);
        }
      });

      scope.hasSearchBox = angular.isUndefined(scope.hasSearchBox) ? false : scope.hasSearchBox;
      scope.hasChangeTemplate = angular.isUndefined(scope.hasChangeTemplate) ? false : scope.hasChangeTemplate;
      scope.templateType = angular.isUndefined(scope.templateType) ? 'list' : scope.templateType;

      scope.query = angular.isUndefined(scope.query) ? null : scope.query;

      var templateInit = function(type){
        if(element.parent().parent()[0].tagName === 'SECTION' && element.parent().parent()[0].id==='timeline' && element.parent().parent().hasClass('th-contentList')){
          switch(type){
            case 'card':
              element.parent().parent().addClass('th-card');
              break;
            default:
              element.parent().parent().removeClass('th-card');
              break;
          }
        }
      };
      // template Init
      templateInit(scope.templateType);

      /*
      *
      * */
      scope.templateChange = function (type) {
        scope.templateType = type;
        templateInit(type);
      };

      scope.search = function () {
        uiPaginationService.setSearchOption(paginationId, scope.query);
        var params = {
          keyword: (uiPaginationService.getSearchOption(paginationId) === null ? '': uiPaginationService.getSearchOption(paginationId).keywords),
          list_size: uiPaginationService.getItemsPerPage(paginationId)
        };
        if (scope.reloadPaginationData) {
          scope.reloadPaginationData({
            params: params
          });
        }
      };

      scope.setSort = function (val, order) {
        if (uiPaginationService.isRegistered(paginationId)) {
          if(angular.isUndefinedOrNull(order))
            order='ASC';
          var sortMethod = ((angular.equals(val, scope.paginationSort.sortKey) ? ((scope.paginationSort.sortMethod === 'DESC') ? 'ASC' : 'DESC') : order));
          uiPaginationService.setSortOption(paginationId, val, sortMethod);
          var params = {
            keyword: (uiPaginationService.getSearchOption(paginationId) === null ? '': uiPaginationService.getSearchOption(paginationId).keywords),
            current_page: uiPaginationService.getCurrentPage(paginationId),
            list_size: uiPaginationService.getItemsPerPage(paginationId)
          };

          if(angular.isDefined(uiPaginationService.getSortOption(paginationId)) ){
            params.sort = uiPaginationService.getSortOption(paginationId).key;
            params.order = uiPaginationService.getSortOption(paginationId).method;
          }
          if(angular.isDefined(uiPaginationService.getFilterOption(paginationId)) ){
            params.filter_key = uiPaginationService.getFilterOption(paginationId).filterKey;
            params.filter_value = uiPaginationService.getFilterOption(paginationId).filterValue;
          }

          if (scope.reloadPaginationData) {
            scope.reloadPaginationData({
              params: params
            });
          }
        }
      };

      scope.setFilter = function(key, value){
        if (uiPaginationService.isRegistered(paginationId)) {
          uiPaginationService.setFilterOption(paginationId, key, value);
          var params = {
            keyword: (uiPaginationService.getSearchOption(paginationId) === null ? '': uiPaginationService.getSearchOption(paginationId).keywords),
            filter_key: key,
            filter_value: value,
            list_size: uiPaginationService.getItemsPerPage(paginationId)
          };

          if (scope.reloadPaginationData) {
            scope.reloadPaginationData({
              params: params
            });
          }
        }
      };

    }
  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .directive('uiPaginationHeaderControls', uiPaginationHeaderControls);
})();

/**
 * Created by Bruce on 2016/6/27.
 */
(function() {
  'use strict';
  uiPaginationControls.$inject = ['uiPaginationService', 'paginationTemplate', 'uiPaginationConfig'];

  function uiPaginationControls(uiPaginationService, paginationTemplate, uiPaginationConfig) {
    var DEFAULT_ID = uiPaginationConfig.DEFAULT_ID;
    var numberRegex = /^\d+$/;

    var DDO = {
      restrict: 'AE',
      scope: {
        maxSize: '=?',
        onPageChange: '&?',
        paginationId: '=?',
        autoHide: '=?',
        canSelectOption: '=?',
        btnFinishFn: '&?btnFinishFn',
		buttonSubmmitDisabled:'=?'
      },
      link: uiPaginationControlsLinkFn
    };

    // We need to check the paginationTemplate service to see whether a template path or
    // string has been specified, and add the `template` or `templateUrl` property to
    // the DDO as appropriate. The order of priority to decide which template to use is
    // (highest priority first):
    // 1. paginationTemplate.getString()
    // 2. attrs.templateUrl
    // 3. paginationTemplate.getPath()
    var templateString = paginationTemplate.getString();
    if (angular.isDefined(templateString)) {
      DDO.template = templateString;
    } else {
      DDO.templateUrl = function(elem, attrs) {
        return attrs.templateUrl || paginationTemplate.getPath();
      };
    }
    return DDO;


    function uiPaginationControlsLinkFn(scope, element, attrs) {

      // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding ui-paginate directive has
      // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
      // no corresponding ui-paginate directive and wrongly throwing an exception.
      var rawId = attrs.paginationId || DEFAULT_ID;
      var paginationId = scope.paginationId || attrs.paginationId || DEFAULT_ID;

      if (!uiPaginationService.isRegistered(paginationId) && !uiPaginationService.isRegistered(rawId)) {
        // var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
        // if (window.console) {
        //   console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
        // }
      }
      if (!scope.maxSize) {
        scope.maxSize = 9;
      }
      scope.autoHide = angular.isUndefined(scope.autoHide) ? true : scope.autoHide;
      scope.canSelectOption = angular.isUndefined(scope.canSelectOption) ? true : scope.canSelectOption;
      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

      var paginationRange = Math.max(scope.maxSize, 5);

      scope.pages = [];
      scope.units= [
        {'id': 1, 'label': '1'},
        {'id': 5, 'label': '5'},
        {'id': 10, 'label': '10'},
        {'id': 15, 'label': '15'},
        {'id': 20, 'label': '20'},
        {'id': 30, 'label': '30'}
      ];
      scope.pagination = {
        last: 1,
        current: 1,
        perPage:String(scope.units[0].id)
      };
      scope.range = {
        lower: 1,
        upper: 1,
        total: 1
      };

      scope.$watch('maxSize', function(val) {
        if (val) {
          paginationRange = Math.max(scope.maxSize, 5);
          generatePagination();
        }
      });

      scope.$watch(function() {
        if (uiPaginationService.isRegistered(paginationId)) {
          return (uiPaginationService.getCollectionLength(paginationId) + 1) * uiPaginationService.getItemsPerPage(paginationId);
        }
      }, function(length) {
        if (0 < length) {
          generatePagination();
        }
      });

      scope.$watch(function() {
        if (uiPaginationService.isRegistered(paginationId)) {
          return (uiPaginationService.getItemsPerPage(paginationId));
        }
      }, function(current, previous) {
        if (current != previous && angular.isDefined(previous)) {
          goToPage(scope.pagination.current);
        }
      });

      scope.$watch(function() {
        if (uiPaginationService.isRegistered(paginationId)) {
          return uiPaginationService.getCurrentPage(paginationId);
        }
      }, function(currentPage, previousPage) {
        if (currentPage != previousPage && angular.isDefined(previousPage)) {
          goToPage(currentPage);
        }
      });

      scope.setCurrent = function(num) {
        if (uiPaginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
          num = parseInt(num, 10);
          uiPaginationService.setCurrentPage(paginationId, num);
        }
      };

      scope.setItemsPerPage = function (val) {
        if (uiPaginationService.isRegistered(paginationId)) {
          uiPaginationService.setItemsPerPage(paginationId, val);
          var currentPage = uiPaginationService.getCurrentPage(paginationId);
          var maxPage = (scope.pagination.total%val === 0)?scope.pagination.total/val:(scope.pagination.total/val + 1);
          var params = {
            keyword:(uiPaginationService.getSearchOption(paginationId) === null ? '': uiPaginationService.getSearchOption(paginationId).keywords),
            current_page:( maxPage >= currentPage)?currentPage:1,
            list_size:val
          };

          if(angular.isDefined(uiPaginationService.getSortOption(paginationId)) ){
            params.sort = uiPaginationService.getSortOption(paginationId).key;
            params.order = uiPaginationService.getSortOption(paginationId).method;
          }
          if(angular.isDefined(uiPaginationService.getFilterOption(paginationId)) ){
            params.filter_key = uiPaginationService.getFilterOption(paginationId).filterKey;
            params.filter_value = uiPaginationService.getFilterOption(paginationId).filterValue;
          }
          if (scope.onPageChange) {
            scope.onPageChange({
              params: params
            });
          }
        }
      };



      /**
       * Custom "track by" function which allows for duplicate "..." entries on long lists,
       * yet fixes the problem of wrongly-highlighted links which happens when using
       * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
       * @param id
       * @param index
       * @returns {string}
       */
      scope.tracker = function(id, index) {
        return id + '_' + index;
      };

      function goToPage(num) {
        if (uiPaginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
          // var oldPageNumber = scope.pagination.current;

          scope.pages = generatePagesArray(num, uiPaginationService.getCollectionLength(paginationId), uiPaginationService.getItemsPerPage(paginationId), paginationRange);
          scope.pagination.current = num;

          updateRangeValues();
          // if a callback has been set, then call it with the page number as the first argument
          // and the previous page number as a second argument
          var params = {
            keyword:(uiPaginationService.getSearchOption(paginationId) === null ? '': uiPaginationService.getSearchOption(paginationId).keywords),
            current_page: num,
            list_size: uiPaginationService.getItemsPerPage(paginationId)
          };

          if(angular.isDefined(uiPaginationService.getSortOption(paginationId)) ){
            params.sort = uiPaginationService.getSortOption(paginationId).key;
            params.order = uiPaginationService.getSortOption(paginationId).method;
          }
          if(angular.isDefined(uiPaginationService.getFilterOption(paginationId)) ){
            params.filter_key = uiPaginationService.getFilterOption(paginationId).filterKey;
            params.filter_value = uiPaginationService.getFilterOption(paginationId).filterValue;
          }

          // console.log(params)
          if (scope.onPageChange) {
            scope.onPageChange({
              params: params
            });
          }
        }
      }

      function generatePagination() {
        if (uiPaginationService.isRegistered(paginationId)) {
          var page = parseInt(uiPaginationService.getCurrentPage(paginationId)) || 1;
          scope.pages = generatePagesArray(page, uiPaginationService.getCollectionLength(paginationId), uiPaginationService.getItemsPerPage(paginationId), paginationRange);
          scope.pagination.current = page;
          scope.pagination.last = scope.pages[scope.pages.length - 1];
          scope.pagination.total = uiPaginationService.getCollectionLength(paginationId);

          // Set Defaulat pagination perPage Value
          if(angular.isDefined(uiPaginationService.getItemsPerPage(paginationId))){
            scope.pagination.perPage = String(uiPaginationService.getItemsPerPage(paginationId));
          }

          if(angular.isDefined(uiPaginationService.getFilterOption(paginationId))){
            scope.pagination.filters = uiPaginationService.getFilterOption(paginationId);
          }

          if (scope.pagination.last < scope.pagination.current) {
            scope.setCurrent(scope.pagination.last);
          } else {
            updateRangeValues();
          }
        }
      }

      /**
       * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
       * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
       */
      function updateRangeValues() {
        if (uiPaginationService.isRegistered(paginationId)) {
          var currentPage = uiPaginationService.getCurrentPage(paginationId),
            itemsPerPage = uiPaginationService.getItemsPerPage(paginationId),
            totalItems = uiPaginationService.getCollectionLength(paginationId);

          scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
          scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
          scope.range.total = totalItems;
        }
      }

      function isValidPageNumber(num) {
        return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
      }
    }

    /**
     * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
     * links used in pagination
     *
     * @param currentPage
     * @param rowsPerPage
     * @param paginationRange
     * @param collectionLength
     * @returns {Array}
     */
    function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
      var pages = [];
      var totalPages = Math.ceil(collectionLength / rowsPerPage);
      var halfWay = Math.ceil(paginationRange / 2);
      var position;

      if (currentPage <= halfWay) {
        position = 'start';
      } else if (totalPages - halfWay < currentPage) {
        position = 'end';
      } else {
        position = 'middle';
      }

      var ellipsesNeeded = paginationRange < totalPages;
      var i = 1;
      while (i <= totalPages && i <= paginationRange) {
        var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

        var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
        var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          pages.push('...');
        } else {
          pages.push(pageNumber);
        }
        i++;
      }
      return pages;
    }

    /**
     * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
     *
     * @param i
     * @param currentPage
     * @param paginationRange
     * @param totalPages
     * @returns {*}
     */
    function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
      var halfWay = Math.ceil(paginationRange / 2);
      if (i === paginationRange) {
        return totalPages;
      } else if (i === 1) {
        return i;
      } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return totalPages - paginationRange + i;
        } else if (halfWay < currentPage) {
          return currentPage - halfWay + i;
        } else {
          return i;
        }
      } else {
        return i;
      }
    }

  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .directive('uiPaginationControls', uiPaginationControls);
})();

/**
 * Created by Bruce on 2016/6/27.
 */
(function() {
  'use strict';

  uiPaginate.$inject = ['$compile', '$parse', 'uiPaginationService', 'uiPaginationConfig'];


  function uiPaginate($compile, $parse, uiPaginationService, uiPaginationConfig) {
    var DEFAULT_ID = uiPaginationConfig.DEFAULT_ID;
    return {
      terminal: true,
      multiElement: true,
      priority: 100,
      compile: uiPaginationCompileFn
    };

    function uiPaginationCompileFn(tElement, tAttrs) {
      // tElement.addClass('card');
      var expression = tAttrs.uiPaginate;
      // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
      if (match[2].match(filterPattern) === null) {
        throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
      }
      var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
      var collectionGetter = $parse(itemsPerPageFilterRemoved);

      addNoCompileAttributes(tElement);

      // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
      // ui-pagination-controls directives that may be looking for this ID.
      var rawId = tAttrs.paginationId || DEFAULT_ID;
      uiPaginationService.registerInstance(rawId);

      return uiPaginationLinkFn;


      function uiPaginationLinkFn(scope, element, attrs) {
        // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
        // potentially register a new ID if it evaluates to a different value than the rawId.
        var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;

        // (TODO: this seems sound, but I'm reverting as many bug reports followed it's introduction in 0.11.0.
        // Needs more investigation.)
        // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
        // before registering using paginationId
        // uiPaginationService.deregisterInstance(rawId);
        uiPaginationService.registerInstance(paginationId);
        uiPaginationService.setSearchOption(paginationId, null);
        var repeatExpression = getRepeatExpression(expression, paginationId);
        addNgRepeatToElement(element, attrs, repeatExpression);

        removeTemporaryAttributes(element)

        var compiled = $compile(element);

        var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
        var filterOptionGetter = makeFilterOptionGetterFn(scope, attrs, paginationId);

        uiPaginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);
        uiPaginationService.setFilterOptionParser(paginationId, filterOptionGetter, scope);

        if (angular.isDefined(attrs.totalItems)) {
          uiPaginationService.setAsyncModeTrue(paginationId);
          scope.$watch(function() {
            return $parse(attrs.totalItems)(scope);
          }, function(result) {
            if (0 <= result) {
              uiPaginationService.setCollectionLength(paginationId, result);
            }
          });
        } else {
          uiPaginationService.setAsyncModeFalse(paginationId);
          scope.$watchCollection(function() {
            return collectionGetter(scope);
          }, function(collection) {
            if (collection) {
              var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
              uiPaginationService.setCollectionLength(paginationId, collectionLength);
            }
          });
        }

        // Delegate to the link function returned by the new compilation of the ng-repeat
        compiled(scope);

        // (TODO: Reverting this due to many bug reports in v 0.11.0. Needs investigation as the
        // principle is sound)
        // When the scope is destroyed, we make sure to remove the reference to it in uiPaginationService
        // so that it can be properly garbage collected
        // scope.$on('$destroy', function destroyDirPagination() {
        //     uiPaginationService.deregisterInstance(paginationId);
        // });
      }

    }



    /**
     * If a pagination id has been specified, we need to check that it is present as the second argument passed to
     * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
     *
     * @param expression
     * @param paginationId
     * @returns {*}
     */
    function getRepeatExpression(expression, paginationId) {
      var repeatExpression,
        idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

      if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
        repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
      } else {
        repeatExpression = expression;
      }

      return repeatExpression;
    }

    /**
     * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
     * appropriate multi-element ng-repeat to the first and last element in the range.
     * @param element
     * @param attrs
     * @param repeatExpression
     */
    function addNgRepeatToElement(element, attrs, repeatExpression) {
      if (element[0].hasAttribute('ui-paginate-start') || element[0].hasAttribute('data-ui-paginate-start')) {
        // using multiElement mode (ui-paginate-start, ui-paginate-end)
        attrs.$set('ngRepeatStart', repeatExpression);
        element.eq(element.length - 1).attr('ng-repeat-end', true);
      } else {
        attrs.$set('ngRepeat', repeatExpression);
      }
    }

    /**
     * Adds the ui-paginate-no-compile directive to each element in the tElement range.
     * @param tElement
     */
    function addNoCompileAttributes(tElement) {
      angular.forEach(tElement, function(el) {
        if (el.nodeType === 1) {
          angular.element(el).attr('ui-paginate-no-compile', true);
        }
      });
    }

    /**
     * Removes the variations on ui-paginate (data-, -start, -end) and the ui-paginate-no-compile directives.
     * @param element
     */
    function removeTemporaryAttributes(element) {
      angular.forEach(element, function(el) {
        if (el.nodeType === 1) {
          angular.element(el).removeAttr('ui-paginate-no-compile');
        }
      });
      element.eq(0).removeAttr('ui-paginate-start').removeAttr('ui-paginate').removeAttr('data-ui-paginate-start').removeAttr('data-ui-paginate');
      element.eq(element.length - 1).removeAttr('ui-paginate-end').removeAttr('data-ui-paginate-end');
    }

    /**
     * Creates a getter function for the current-page attribute, using the expression provided or a default value if
     * no current-page expression was specified.
     *
     * @param scope
     * @param attrs
     * @param paginationId
     * @returns {*}
     */
    function makeCurrentPageGetterFn(scope, attrs, paginationId) {
      var currentPageGetter;
      if (attrs.currentPage) {
        currentPageGetter = $parse(attrs.currentPage);
      } else {
        // If the current-page attribute was not set, we'll make our own.
        // Replace any non-alphanumeric characters which might confuse
        // the $parse service and give unexpected results.
        // See https://github.com/michaelbromley/angularUtils/issues/233
        var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
        scope[defaultCurrentPage] = 1;
        currentPageGetter = $parse(defaultCurrentPage);
      }
      return currentPageGetter;
    }

    function makeFilterOptionGetterFn(scope, attrs, paginationId) {
      var filterOptionGetter;
      if (attrs.filterOption) {
        filterOptionGetter = $parse(attrs.filterOption);
      } else {
        var defaultFilterOption = (paginationId + '__filterOption').replace(/\W/g, '_');
        scope[defaultFilterOption] = {};
        filterOptionGetter = $parse(defaultFilterOption);
      }
      return filterOptionGetter;

    }

  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .directive('uiPaginate', uiPaginate);
})();

/**
 * Created by Bruce on 2016/6/27.
 */

(function () {
  'use strict';
  function uiPaginateNoCompile() {
    return {
      priority: 5000,
      terminal: true
    };
  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .directive('uiPaginateNoCompile', uiPaginateNoCompile);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  "use strict";

  angular.module("mdPickers", [
    "ngMaterial",
    "ngAnimate",
    "ngAria"
  ]);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  function mdpTimePickerProvider() {
    var LABEL_OK = "OK",
      LABEL_CANCEL = "Cancel";

    this.setOKButtonLabel = function(label) {
      LABEL_OK = label;
    };

    this.setCancelButtonLabel = function(label) {
      LABEL_CANCEL = label;
    };

    mdpTimePicker.$inject = ['$mdDialog'];

    function mdpTimePicker($mdDialog) {
      var timePicker = function(time, options) {
        if (!angular.isDate(time)) time = Date.now();
        if (!angular.isObject(options)) options = {};

        return $mdDialog.show({
          controller: 'TimePickerController',
          controllerAs: 'timepicker',
          clickOutsideToClose: true,
          template: '<md-dialog aria-label="" class="mdp-timepicker" ng-class="{ \'portrait\': !timepicker.$mdMedia(\'gt-xs\') }">' +
          '<md-dialog-content layout-gt-xs="row" layout-wrap>' +
          '<md-toolbar layout-gt-xs="column" layout-xs="row" layout-align="center center" flex class="mdp-timepicker-time md-hue-1 md-primary">' +
          '<div class="mdp-timepicker-selected-time">' +
          '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_HOURS }" ng-click="timepicker.currentView = timepicker.VIEW_HOURS">{{ timepicker.time.format("h") }}</span>:' +
          '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_MINUTES }" ng-click="timepicker.currentView = timepicker.VIEW_MINUTES">{{ timepicker.time.format("mm") }}</span>' +
          '</div>' +
          '<div layout="column" class="mdp-timepicker-selected-ampm">' +
          '<span ng-click="timepicker.setAM()" ng-class="{ \'active\': timepicker.time.hours() < 12 }">AM</span>' +
          '<span ng-click="timepicker.setPM()" ng-class="{ \'active\': timepicker.time.hours() >= 12 }">PM</span>' +
          '</div>' +
          '</md-toolbar>' +
          '<div>' +
          '<div class="mdp-clock-switch-container" ng-switch="timepicker.currentView" layout layout-align="center center">' +
          '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="hours" ng-switch-when="1"></mdp-clock>' +
          '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="minutes" ng-switch-when="2"></mdp-clock>' +
          '</div>' +

          '<md-dialog-actions layout="row">' +
          '<span flex></span>' +
          '<md-button ng-click="timepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
          '<md-button ng-click="timepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
          '</md-dialog-actions>' +
          '</div>' +
          '</md-dialog-content>' +
          '</md-dialog>',
          targetEvent: options.targetEvent,
          locals: {
            time: time,
            autoSwitch: options.autoSwitch
          },
          multiple: true
        });
      };

      return timePicker;
    }

    this.$get = mdpTimePicker;
  }
  angular.module('mdPickers')
    .provider('$mdpTimePicker', mdpTimePickerProvider);

})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  function mdpDatePickerProvider() {
    var LABEL_OK = "OK",
      LABEL_CANCEL = "Cancel",
      DISPLAY_FORMAT = "ddd, MMM DD";

    this.setDisplayFormat = function(format) {
      DISPLAY_FORMAT = format;
    };

    this.setOKButtonLabel = function(label) {
      LABEL_OK = label;
    };

    this.setCancelButtonLabel = function(label) {
      LABEL_CANCEL = label;
    };


    mdpDatePicker.$inject = ['$mdDialog'];

    function mdpDatePicker($mdDialog) {
      var datePicker = function(currentDate, options) {
        if (!angular.isDate(currentDate)) currentDate = Date.now();
        if (!angular.isObject(options)) options = {};

        options.displayFormat = DISPLAY_FORMAT;

        return $mdDialog.show({
          controller: 'DatePickerController',
          controllerAs: 'datepicker',
          clickOutsideToClose: true,
          template: '<md-dialog aria-label="" class="mdp-datepicker" ng-class="{ \'portrait\': !datepicker.$mdMedia(\'gt-xs\') }">' +
          '<md-dialog-content layout="row" layout-wrap>' +
          '<div layout="column" layout-align="start center">' +
          '<md-toolbar layout-align="start start" flex class="mdp-datepicker-date-wrapper md-hue-1 md-primary" layout="column">' +
          '<span class="mdp-datepicker-year" ng-click="datepicker.showYear()" ng-class="{ \'active\': datepicker.selectingYear }">{{ datepicker.date.format(\'YYYY\') }}</span>' +
          '<span class="mdp-datepicker-date" ng-click="datepicker.showCalendar()" ng-class="{ \'active\': !datepicker.selectingYear }">{{ datepicker.date.format(datepicker.displayFormat) }}</span> ' +
          '</md-toolbar>' +
          '</div>' +
          '<div>' +
          '<div class="mdp-datepicker-select-year mdp-animation-zoom" layout="column" layout-align="center start" ng-if="datepicker.selectingYear">' +
          '<md-virtual-repeat-container md-auto-shrink md-top-index="datepicker.yearTopIndex">' +
          '<div flex md-virtual-repeat="item in datepicker.yearItems" md-on-demand class="repeated-year">' +
          '<span class="md-button" ng-click="datepicker.selectYear(item)" md-ink-ripple ng-class="{ \'md-primary current\': item == datepicker.year }">{{ item }}</span>' +
          '</div>' +
          '</md-virtual-repeat-container>' +
          '</div>' +
          '<mdp-calendar ng-if="!datepicker.selectingYear" class="mdp-animation-zoom" date="datepicker.date" min-date="datepicker.minDate" date-filter="datepicker.dateFilter" max-date="datepicker.maxDate"></mdp-calendar>' +
          '<md-dialog-actions layout="row">' +
          '<span flex></span>' +
          '<md-button ng-click="datepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
          '<md-button ng-click="datepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
          '</md-dialog-actions>' +
          '</div>' +
          '</md-dialog-content>' +
          '</md-dialog>',
          targetEvent: options.targetEvent,
          locals: {
            currentDate: currentDate,
            options: options
          },
          multiple: true
        });
      };

      return datePicker;
    }

    this.$get = mdpDatePicker;
  }
  angular.module('mdPickers')
    .provider('$mdpDatePicker', mdpDatePickerProvider);

})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  ngMessage.$inject = ['$mdUtil'];

  function ngMessage($mdUtil) {
    var directive = {
      restrict: "EA",
      priority: 101,
      compile: function(element) {
        var inputContainer = $mdUtil.getClosest(element, "mdp-time-picker", true) ||
          $mdUtil.getClosest(element, "mdp-date-picker", true);

        // If we are not a child of an input container, don't do anything
        if (!inputContainer) return;

        // Add our animation class
        element.toggleClass('md-input-message-animation', true);

        return {};
      }
    };

    return directive;
  }
  angular.module('mdPickers')
    .directive('ngMessage', ngMessage);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  mdpTimePicker1.$inject = ["$mdpTimePicker" /*, "$timeout"*/ ];

  function mdpTimePicker1($mdpTimePicker /*, $timeout*/ ) {
    function link(scope, element, attrs, ngModel, $transclude) {
      var inputElement = angular.element(element[0].querySelector('input')),
        inputContainer = angular.element(element[0].querySelector('md-input-container')),
        inputContainerCtrl = inputContainer.controller("mdInputContainer");

      $transclude(function(clone) {
        inputContainer.append(clone);
      });

      var messages = angular.element(inputContainer[0].querySelector("[ng-messages]"));

      scope.type = scope.timeFormat ? "text" : "time"
      scope.timeFormat = scope.timeFormat || "HH:mm";
      scope.autoSwitch = scope.autoSwitch || false;

      scope.$watch(function() {
        return ngModel.$error
      }, function( /*newValue, oldValue*/ ) {
        inputContainerCtrl.setInvalid(!ngModel.$pristine && !!Object.keys(ngModel.$error).length);
      }, true);

      // update input element if model has changed
      ngModel.$formatters.unshift(function(value) {
        var time = angular.isDate(value) && moment(value);
        if (time && time.isValid())
          updateInputElement(time.format(scope.timeFormat));
        else
          updateInputElement(null);
      });

      ngModel.$validators.format = function(modelValue, viewValue) {
        return !viewValue || angular.isDate(viewValue) || moment(viewValue, scope.timeFormat, true).isValid();
      };

      ngModel.$validators.required = function(modelValue, viewValue) {
        return angular.isUndefined(attrs.required) || !ngModel.$isEmpty(modelValue) || !ngModel.$isEmpty(viewValue);
      };

      ngModel.$parsers.unshift(function(value) {
        var parsed = moment(value, scope.timeFormat, true);
        if (parsed.isValid()) {
          if (angular.isDate(ngModel.$modelValue)) {
            var originalModel = moment(ngModel.$modelValue);
            originalModel.minutes(parsed.minutes());
            originalModel.hours(parsed.hours());
            originalModel.seconds(parsed.seconds());

            parsed = originalModel;
          }
          return parsed.toDate();
        } else
          return null;
      });

      // update input element value
      function updateInputElement(value) {
        inputElement[0].value = value;
        inputContainerCtrl.setHasValue(!ngModel.$isEmpty(value));
      }

      function updateTime(time) {
        var value = moment(time, angular.isDate(time) ? null : scope.timeFormat, true),
          strValue = value.format(scope.timeFormat);

        if (value.isValid()) {
          updateInputElement(strValue);
          ngModel.$setViewValue(strValue);
        } else {
          updateInputElement(time);
          ngModel.$setViewValue(time);
        }

        if (!ngModel.$pristine &&
          messages.hasClass("md-auto-hide") &&
          inputContainer.hasClass("md-input-invalid")) messages.removeClass("md-auto-hide");

        ngModel.$render();
      }

      scope.showPicker = function(ev) {
        $mdpTimePicker(ngModel.$modelValue, {
          targetEvent: ev,
          autoSwitch: scope.autoSwitch
        }).then(function(time) {
          updateTime(time, true);
        });
      };

      function onInputElementEvents(event) {
        if (event.target.value !== ngModel.$viewVaue)
          updateTime(event.target.value);
      }

      inputElement.on("reset input blur", onInputElementEvents);

      scope.$on("$destroy", function() {
        inputElement.off("reset input blur", onInputElementEvents);
      })
    }
    var directive = {
      restrict: 'E',
      require: 'ngModel',
      transclude: true,
      template: function(element, attrs) {
        var noFloat = angular.isDefined(attrs.mdpNoFloat),
          placeholder = angular.isDefined(attrs.mdpPlaceholder) ? attrs.mdpPlaceholder : "",
          openOnClick = angular.isDefined(attrs.mdpOpenOnClick) ? true : false;

        return '<div layout layout-align="start start">' +
          '<md-button class="md-icon-button" ng-click="showPicker($event)"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + '>' +
          '<md-icon md-svg-icon="mdp-access-time"></md-icon>' +
          '</md-button>' +
          '<md-input-container' + (noFloat ? ' md-no-float' : '') + ' md-is-error="isError()">' +
          '<input type="{{ ::type }}"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' aria-label="' + placeholder + '" placeholder="' + placeholder + '"' + (openOnClick ? ' ng-click="showPicker($event)" ' : '') + ' />' +
          '</md-input-container>' +
          '</div>';
      },
      scope: {
        "timeFormat": "@mdpFormat",
        "placeholder": "@mdpPlaceholder",
        "autoSwitch": "=?mdpAutoSwitch",
        "disabled": "=?mdpDisabled"
      },
      link: link
    };
    return directive;
  }


  mdpTimePicker2.$inject = ["$mdpTimePicker" /*, "$timeout"*/ ];

  function mdpTimePicker2($mdpTimePicker /*, $timeout*/ ) {
    function link(scope, element, attrs, ngModel /*, $transclude*/ ) {
      scope.format = scope.format || "HH:mm";

      function showPicker(ev) {
        $mdpTimePicker(ngModel.$modelValue, {
          targetEvent: ev,
          autoSwitch: scope.autoSwitch
        }).then(function(time) {
          ngModel.$setViewValue(moment(time).format(scope.format));
          ngModel.$render();
        });
      }

      element.on("click", showPicker);

      scope.$on("$destroy", function() {
        element.off("click", showPicker);
      });
    }
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        "timeFormat": "@mdpFormat",
        "autoSwitch": "=?mdpAutoSwitch"
      },
      link: link
    };
    return directive;
  }

  angular.module('mdPickers')
    .directive('mdpTimePicker', mdpTimePicker1)
    .directive('mdpTimePicker', mdpTimePicker2);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  function formatValidator(value, format) {
    return !value || angular.isDate(value) || moment(value, format, true).isValid();
  }

  function minDateValidator(value, format, _minDate) {
    var minDate = moment(_minDate, "YYYY-MM-DD", true);
    var date = angular.isDate(value) ? moment(value) : moment(value, format, true);

    return !value ||
      angular.isDate(value) ||
      !minDate.isValid() ||
      date.isSameOrAfter(minDate);
  }

  function maxDateValidator(value, format, _maxDate) {
    var maxDate = moment(_maxDate, "YYYY-MM-DD", true);
    var date = angular.isDate(value) ? moment(value) : moment(value, format, true);

    return !value ||
      angular.isDate(value) ||
      !maxDate.isValid() ||
      date.isSameOrBefore(maxDate);
  }

  function filterValidator(value, format, filter) {
    var date = angular.isDate(value) ? moment(value) : moment(value, format, true);

    return !value ||
      angular.isDate(value) ||
      !angular.isFunction(filter) ||
      !filter(date);
  }

  // function requiredValidator(value, ngModel) {
  //   return value
  // }

  mdpDatePicker1.$inject = ["$mdpDatePicker" /*, "$timeout"*/ ];

  function mdpDatePicker1($mdpDatePicker /*, $timeout*/ ) {

    var directive = {
      restrict: 'E',
      require: 'ngModel',
      transclude: true,
      template: function(element, attrs) {
        var noFloat = angular.isDefined(attrs.mdpNoFloat),
          placeholder = angular.isDefined(attrs.mdpPlaceholder) ? attrs.mdpPlaceholder : "",
          openOnClick = angular.isDefined(attrs.mdpOpenOnClick) ? true : false;

        return '<div layout layout-align="start start">' +
          '<md-button' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' class="md-icon-button" ng-click="showPicker($event)">' +
          '<md-icon md-svg-icon="mdp-event"></md-icon>' +
          '</md-button>' +
          '<md-input-container' + (noFloat ? ' md-no-float' : '') + ' md-is-error="isError()">' +
          '<input type="{{ ::type }}"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' aria-label="' + placeholder + '" placeholder="' + placeholder + '"' + (openOnClick ? ' ng-click="showPicker($event)" ' : '') + ' />' +
          '</md-input-container>' +
          '</div>';
      },
      scope: {
        "minDate": "=mdpMinDate",
        "maxDate": "=mdpMaxDate",
        "dateFilter": "=mdpDateFilter",
        "dateFormat": "@mdpFormat",
        "placeholder": "@mdpPlaceholder",
        "noFloat": "=mdpNoFloat",
        "openOnClick": "=mdpOpenOnClick",
        "disabled": "=?mdpDisabled"
      },
      link: {
        pre: function( /*scope, element, attrs, ngModel, $transclude*/ ) {

        },
        post: function(scope, element, attrs, ngModel, $transclude) {
          var inputElement = angular.element(element[0].querySelector('input')),
            inputContainer = angular.element(element[0].querySelector('md-input-container')),
            inputContainerCtrl = inputContainer.controller("mdInputContainer");

          $transclude(function(clone) {
            inputContainer.append(clone);
          });

          var messages = angular.element(inputContainer[0].querySelector("[ng-messages]"));

          scope.type = scope.dateFormat ? "text" : "date"
          scope.dateFormat = scope.dateFormat || "YYYY-MM-DD";
          scope.model = ngModel;

          scope.isError = function() {
            return !ngModel.$pristine && !!ngModel.$invalid;
          };

          // update input element if model has changed
          ngModel.$formatters.unshift(function(value) {
            var date = angular.isDate(value) && moment(value);
            if (date && date.isValid())
              updateInputElement(date.format(scope.dateFormat));
            else
              updateInputElement(null);
          });

          ngModel.$validators.format = function(modelValue, viewValue) {
            return formatValidator(viewValue, scope.dateFormat);
          };

          ngModel.$validators.minDate = function(modelValue, viewValue) {
            return minDateValidator(viewValue, scope.dateFormat, scope.minDate);
          };

          ngModel.$validators.maxDate = function(modelValue, viewValue) {
            return maxDateValidator(viewValue, scope.dateFormat, scope.maxDate);
          };

          ngModel.$validators.filter = function(modelValue, viewValue) {
            return filterValidator(viewValue, scope.dateFormat, scope.dateFilter);
          };

          ngModel.$validators.required = function(modelValue, viewValue) {
            return angular.isUndefined(attrs.required) || !ngModel.$isEmpty(modelValue) || !ngModel.$isEmpty(viewValue);
          };

          ngModel.$parsers.unshift(function(value) {
            var parsed = moment(value, scope.dateFormat, true);
            if (parsed.isValid()) {
              if (angular.isDate(ngModel.$modelValue)) {
                var originalModel = moment(ngModel.$modelValue);
                originalModel.year(parsed.year());
                originalModel.month(parsed.month());
                originalModel.date(parsed.date());

                parsed = originalModel;
              }
              return parsed.toDate();
            } else
              return null;
          });

          // update input element value
          function updateInputElement(value) {
            inputElement[0].value = value;
            inputContainerCtrl.setHasValue(!ngModel.$isEmpty(value));
          }

          function updateDate(date) {
            var value = moment(date, angular.isDate(date) ? null : scope.dateFormat, true),
              strValue = value.format(scope.dateFormat);

            if (value.isValid()) {
              updateInputElement(strValue);
              ngModel.$setViewValue(strValue);
            } else {
              updateInputElement(date);
              ngModel.$setViewValue(date);
            }

            if (!ngModel.$pristine &&
              messages.hasClass("md-auto-hide") &&
              inputContainer.hasClass("md-input-invalid")) messages.removeClass("md-auto-hide");

            ngModel.$render();
          }

          scope.showPicker = function(ev) {
            $mdpDatePicker(ngModel.$modelValue, {
              minDate: scope.minDate,
              maxDate: scope.maxDate,
              dateFilter: scope.dateFilter,
              targetEvent: ev
            }).then(updateDate);
          };

          function onInputElementEvents(event) {
            if (event.target.value !== ngModel.$viewVaue)
              updateDate(event.target.value);
          }

          inputElement.on("reset input blur", onInputElementEvents);

          scope.$on("$destroy", function() {
            inputElement.off("reset input blur", onInputElementEvents);
          });
        }
      }
    };

    return directive;
  }

  mdpDatePicker2.$inject = ["$mdpDatePicker" /*, "$timeout"*/ ];

  function mdpDatePicker2($mdpDatePicker /*, $timeout*/ ) {
    function link(scope, element, attrs, ngModel /*, $transclude*/ ) {
      scope.dateFormat = scope.dateFormat || "YYYY-MM-DD";

      ngModel.$validators.format = function(modelValue, viewValue) {
        return formatValidator(viewValue, scope.format);
      };

      ngModel.$validators.minDate = function(modelValue, viewValue) {
        return minDateValidator(viewValue, scope.format, scope.minDate);
      };

      ngModel.$validators.maxDate = function(modelValue, viewValue) {
        return maxDateValidator(viewValue, scope.format, scope.maxDate);
      };

      ngModel.$validators.filter = function(modelValue, viewValue) {
        return filterValidator(viewValue, scope.format, scope.dateFilter);
      };

      function showPicker(ev) {
        $mdpDatePicker(ngModel.$modelValue, {
          minDate: scope.minDate,
          maxDate: scope.maxDate,
          dateFilter: scope.dateFilter,
          targetEvent: ev
        }).then(function(time) {
          ngModel.$setViewValue(moment(time).format(scope.format));
          ngModel.$render();
        });
      }

      element.on("click", showPicker);

      scope.$on("$destroy", function() {
        element.off("click", showPicker);
      });
    }

    var directive = {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        "minDate": "@min",
        "maxDate": "@max",
        "dateFilter": "=mdpDateFilter",
        "dateFormat": "@mdpFormat"
      },
      link: link
    };
    return directive;
  }
  angular.module('mdPickers')
    .directive('mdpDatePicker', mdpDatePicker1)
    .directive('mdpDatePicker', mdpDatePicker2);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  mdpClock.$inject = ["$animate", "$timeout"];

  function mdpClock($animate, $timeout) {

    function link(scope, element/*, attrs, ctrl*/) {
      // var pointer = angular.element(element[0].querySelector(".mdp-pointer"));
      // var timepickerCtrl = scope.$parent.timepicker;

      var onEvent = function(/*event*/) {
        // var containerCoords = event.currentTarget.getClientRects()[0];
        // var x = ((event.currentTarget.offsetWidth / 2) - (event.pageX - containerCoords.left)),
        //   y = ((event.pageY - containerCoords.top) - (event.currentTarget.offsetHeight / 2));

        // var deg = Math.round((Math.atan2(x, y) * (180 / Math.PI)));
        $timeout(function() {
          // ctrl.setTimeByDeg(deg + 180);
          // if (ctrl.autoSwitch && ["mouseup", "click"].indexOf(event.type) !== -1 && timepickerCtrl) timepickerCtrl.switchView();
        });
      };

      element.on("mousedown", function() {
        element.on("mousemove", onEvent);
      });

      element.on("mouseup", function( /*e*/ ) {
        element.off("mousemove");
      });

      element.on("click", onEvent);
      scope.$on("$destroy", function() {
        element.off("click", onEvent);
        element.off("mousemove", onEvent);
      });
    }
    var directive = {
      restrict: 'E',
      bindToController: {
        'type': '@?',
        'time': '=',
        'autoSwitch': '=?'
      },
      replace: true,
      template: '<div class="mdp-clock">' +
      '<div class="mdp-clock-container">' +
      '<md-toolbar class="mdp-clock-center md-primary"></md-toolbar>' +
      '<md-toolbar ng-style="clock.getPointerStyle()" class="mdp-pointer md-primary">' +
      '<span class="mdp-clock-selected md-button md-raised md-primary"></span>' +
      '</md-toolbar>' +
      '<md-button ng-class="{ \'md-primary\': clock.selected == step }" class="md-icon-button md-raised mdp-clock-deg{{ ::(clock.STEP_DEG * ($index + 1)) }}" ng-repeat="step in clock.steps" ng-click="clock.setTime(step)">{{ step }}</md-button>' +
      '</div>' +
      '</div>',
      controller: 'ClockController',
      controllerAs: "clock",
      link: link
    };

    return directive;
  }
  angular.module('mdPickers')
    .directive('mdpClock', mdpClock);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  mdpCalendar.$inject = ['$animate'];

  function mdpCalendar($animate) {
    function link(scope, element, attrs, ctrl) {
      var animElements = [
        element[0].querySelector(".mdp-calendar-week-days"),
        element[0].querySelector('.mdp-calendar-days'),
        element[0].querySelector('.mdp-calendar-monthyear')
      ].map(function(a) {
        return angular.element(a);
      });

      scope.$watch(function() {
        return ctrl.date.format("YYYYMM")
      }, function(newValue, oldValue) {
        var direction = null;

        if (newValue > oldValue)
          direction = "mdp-animate-next";
        else if (newValue < oldValue)
          direction = "mdp-animate-prev";

        if (direction) {
          for (var i in animElements) {
            animElements[i].addClass(direction);
            $animate.removeClass(animElements[i], direction);
          }
        }
      });
    }

    var directive = {
      restrict: 'E',
      bindToController: {
        "date": "=",
        "minDate": "=",
        "maxDate": "=",
        "dateFilter": "="
      },
      template: '<div class="mdp-calendar">' +
      '<div layout="row" layout-align="space-between center">' +
      '<md-button aria-label="previous month" class="md-icon-button" ng-click="calendar.prevMonth()"><md-icon md-svg-icon="mdp-chevron-left"></md-icon></md-button>' +
      '<div class="mdp-calendar-monthyear" ng-show="!calendar.animating">{{ calendar.date.format("MMMM YYYY") }}</div>' +
      '<md-button aria-label="next month" class="md-icon-button" ng-click="calendar.nextMonth()"><md-icon md-svg-icon="mdp-chevron-right"></md-icon></md-button>' +
      '</div>' +
      '<div layout="row" layout-align="space-around center" class="mdp-calendar-week-days" ng-show="!calendar.animating">' +
      '<div layout layout-align="center center" ng-repeat="d in calendar.weekDays track by $index">{{ d }}</div>' +
      '</div>' +
      '<div layout="row" layout-align="start center" layout-wrap class="mdp-calendar-days" ng-class="{ \'mdp-animate-next\': calendar.animating }" ng-show="!calendar.animating" md-swipe-left="calendar.nextMonth()" md-swipe-right="calendar.prevMonth()">' +
      '<div layout layout-align="center center" ng-repeat-start="day in calendar.daysInMonth track by $index" ng-class="{ \'mdp-day-placeholder\': !day }">' +
      '<md-button class="md-icon-button md-raised" aria-label="Select day" ng-if="day" ng-class="{ \'md-accent\': calendar.date.date() == day.value }" ng-click="calendar.selectDate(day.value)" ng-disabled="!day.enabled">{{ day.value }}</md-button>' +
      '</div>' +
      '<div flex="100" ng-if="($index + 1) % 7 == 0" ng-repeat-end></div>' +
      '</div>' +
      '</div>',
      controller: 'CalendarController',
      controllerAs: "calendar",
      link: link

    };

    return directive;
  }
  angular.module('mdPickers')
    .directive('mdpCalendar', mdpCalendar);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  TimePickerController.$inject = ['$scope', '$mdDialog', 'time', 'autoSwitch', '$mdMedia'];

  function TimePickerController($scope, $mdDialog, time, autoSwitch, $mdMedia) {
    var vm = this;
    vm.VIEW_HOURS = 1;
    vm.VIEW_MINUTES = 2;
    vm.currentView = vm.VIEW_HOURS;
    vm.time = moment(time);
    vm.autoSwitch = !!autoSwitch;

    vm.clockHours = parseInt(vm.time.format("h"));
    vm.clockMinutes = parseInt(vm.time.minutes());

    vm.$mdMedia = $mdMedia;

    vm.switchView = function() {
      vm.currentView = vm.currentView == vm.VIEW_HOURS ? vm.VIEW_MINUTES : vm.VIEW_HOURS;
    };

    vm.setAM = function() {
      if (vm.time.hours() >= 12)
        vm.time.hour(vm.time.hour() - 12);
    };

    vm.setPM = function() {
      if (vm.time.hours() < 12)
        vm.time.hour(vm.time.hour() + 12);
    };

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.confirm = function() {
      $mdDialog.hide(vm.time.toDate());
    };
  }
  angular.module('mdPickers')
    .controller('TimePickerController', TimePickerController);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  DatePickerController.$inject = ['$scope', '$mdDialog', '$mdMedia', '$timeout', 'currentDate', 'options'];

  function DatePickerController($scope, $mdDialog, $mdMedia, $timeout, currentDate, options) {
    var vm = this;

    vm.date = moment(currentDate);
    vm.minDate = options.minDate && moment(options.minDate).isValid() ? moment(options.minDate) : null;
    vm.maxDate = options.maxDate && moment(options.maxDate).isValid() ? moment(options.maxDate) : null;
    vm.displayFormat = options.displayFormat || "ddd, MMM DD";
    vm.dateFilter = angular.isFunction(options.dateFilter) ? options.dateFilter : null;
    vm.selectingYear = false;

    // validate min and max date
    if (vm.minDate && vm.maxDate) {
      if (vm.maxDate.isBefore(vm.minDate)) {
        vm.maxDate = moment(vm.minDate).add(1, 'days');
      }
    }

    if (vm.date) {
      // check min date
      if (vm.minDate && vm.date.isBefore(vm.minDate)) {
        vm.date = moment(vm.minDate);
      }

      // check max date
      if (vm.maxDate && vm.date.isAfter(vm.maxDate)) {
        vm.date = moment(vm.maxDate);
      }
    }
    vm.yearItems = {
      currentIndex_: 0,
      PAGE_SIZE: 5,
      START: (vm.minDate ? vm.minDate.year() : 1900),
      END: (vm.maxDate ? vm.maxDate.year() : 0),
      getItemAtIndex: function(index) {
        if (vm.yearItems.currentIndex_ < index)
          vm.yearItems.currentIndex_ = index;

        return vm.yearItems.START + index;
      },
      getLength: function() {
        return Math.min(
          vm.yearItems.currentIndex_ + Math.floor(vm.yearItems.PAGE_SIZE / 2),
          Math.abs(vm.yearItems.START - vm.yearItems.END) + 1
        );
      }
    };

    vm.$mdMedia = $mdMedia;
    vm.year = vm.date.year();

    vm.selectYear = function(year) {
      vm.date.year(year);
      vm.year = year;
      vm.selectingYear = false;
      vm.animate();
    };

    vm.showYear = function() {
      vm.yearTopIndex = (vm.date.year() - vm.yearItems.START) + Math.floor(vm.yearItems.PAGE_SIZE / 2);
      vm.yearItems.currentIndex_ = (vm.date.year() - vm.yearItems.START) + 1;
      vm.selectingYear = true;
    };

    vm.showCalendar = function() {
      vm.selectingYear = false;
    };

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.confirm = function() {
      var date = vm.date;

      if (vm.minDate && vm.date.isBefore(vm.minDate)) {
        date = moment(vm.minDate);
      }

      if (vm.maxDate && vm.date.isAfter(vm.maxDate)) {
        date = moment(vm.maxDate);
      }

      $mdDialog.hide(date.toDate());
    };

    vm.animate = function() {
      vm.animating = true;
      $timeout(angular.noop).then(function() {
        vm.animating = false;
      })
    };
  }

  angular.module('mdPickers')
    .controller('DatePickerController', DatePickerController);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  ClockController.$inject = [ /*'$scope'*/ ];

  function ClockController( /*$scope*/ ) {
    var TYPE_HOURS = "hours";
    var TYPE_MINUTES = "minutes";
    var vm = this;

    vm.STEP_DEG = 360 / 12;
    vm.steps = [];

    vm.CLOCK_TYPES = {
      "hours": {
        range: 12
      },
      "minutes": {
        range: 60
      }
    }

    vm.getPointerStyle = function() {
      var divider = 1;
      switch (vm.type) {
        case TYPE_HOURS:
          divider = 12;
          break;
        case TYPE_MINUTES:
          divider = 60;
          break;
      }
      var degrees = Math.round(vm.selected * (360 / divider)) - 180;
      return {
        "-webkit-transform": "rotate(" + degrees + "deg)",
        "-ms-transform": "rotate(" + degrees + "deg)",
        "transform": "rotate(" + degrees + "deg)"
      }
    };

    vm.setTimeByDeg = function(deg) {
      deg = deg >= 360 ? 0 : deg;
      var divider = 0;
      switch (vm.type) {
        case TYPE_HOURS:
          divider = 12;
          break;
        case TYPE_MINUTES:
          divider = 60;
          break;
      }
      vm.setTime(
        Math.round(divider / 360 * deg)
      );
    };

    vm.setTime = function(time /*, type*/ ) {
      vm.selected = time;
      switch (vm.type) {
        case TYPE_HOURS:
          if (vm.time.format("A") == "PM") time += 12;
          vm.time.hours(time);
          break;
        case TYPE_MINUTES:
          if (time > 59) time -= 60;
          vm.time.minutes(time);
          break;
      }

    };

    vm.init = function() {
      vm.type = vm.type || "hours";
      var i;
      switch (vm.type) {
        case TYPE_HOURS:
          for (i = 1; i <= 12; i++)
            vm.steps.push(i);
          vm.selected = vm.time.hours() || 0;
          if (vm.selected > 12) vm.selected -= 12;

          break;
        case TYPE_MINUTES:
          for (i = 5; i <= 55; i += 5)
            vm.steps.push(i);

          vm.steps.push(0);
          vm.selected = vm.time.minutes() || 0;
          break;
      }
    };

    vm.init();
  }
  angular.module('mdPickers')
    .controller('ClockController', ClockController);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  CalendarController.$inject = ['$scope'];

  function CalendarController($scope) {
    var vm = this;
    vm.dow = moment.localeData().firstDayOfWeek();

    vm.weekDays = [].concat(
      moment.weekdaysMin().slice(
        vm.dow
      ),
      moment.weekdaysMin().slice(
        0,
        vm.dow
      )
    );

    vm.daysInMonth = [];

    vm.getDaysInMonth = function() {
      var days = vm.date.daysInMonth(),
        firstDay = moment(vm.date).date(1).day() - vm.dow;

      if (firstDay < 0) firstDay = vm.weekDays.length - 1;


      var arr = [];
      for (var i = 1; i <= (firstDay + days); i++) {
        var day = null;
        if (i > firstDay) {
          day = {
            value: (i - firstDay),
            enabled: vm.isDayEnabled(moment(vm.date).date(i - firstDay).toDate())
          };
        }
        arr.push(day);
      }

      return arr;
    };

    vm.isDayEnabled = function(day) {
      return (!vm.minDate || vm.minDate <= day) &&
        (!vm.maxDate || vm.maxDate >= day) &&
        (!vm.dateFilter || !vm.dateFilter(day));
    };

    vm.selectDate = function(dom) {
      vm.date.date(dom);
    };

    vm.nextMonth = function() {
      vm.date.add(1, 'months');
    };

    vm.prevMonth = function() {
      vm.date.subtract(1, 'months');
    };

    vm.updateDaysInMonth = function() {
      vm.daysInMonth = vm.getDaysInMonth();
    };

    $scope.$watch(function() {
      return vm.date.unix()
    }, function(newValue, oldValue) {
      if (newValue && newValue !== oldValue)
        vm.updateDaysInMonth();
    })

    vm.updateDaysInMonth();
  }
  angular.module('mdPickers')
    .controller('CalendarController', CalendarController);
})();

/**
 * Created by Bruce on 2016/12/6.
 * Hack By angular bootstrap calendar
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.cusRateIt',[]);

})();

/**
 * Created by Alan on 2017/11/27
 */
(function () {
  'use strict';

  var cusRateIt = {
    bindings: {
      number: '@?',
      step: '@?',
      width: '@?',
      height: '@?',
      value:  '='
    },
    templateUrl: 'app/kernel/ui-elements/cus-rate-it/views/cus-rate-it.html',
    controller: [function(){
      var vm = this;

      vm.number = this.number || 5;
      vm.step = this.step || 1;
      vm.width = this.width || 16;
      vm.height = this.height || 16;
      vm.value = this.value;

      var rates = vm.number / vm.step;
      vm.ratesArray = new Array(rates);

      vm.getStarOffset = function (index) {
        var ratio = 1/vm.step;
        return   -( vm.width / ratio ) * ( index % ratio );
      };

      vm.isSelected = function (index) {
        var value = (index+1) / rates * vm.number;
        return value <= vm.value;
      };

    }]
  };

  angular.module('eHRD.kernel.uiElements.cusRateIt')
    .component('cusRateIt', cusRateIt);
})();

// /**
//  * Created by Bruce on 2017/2/16.
//  */
// /*!
//  * Angular Material Design
//  * https://github.com/angular/material
//  * @license MIT
//  * v1.1.3-master-0619e30
//  */
// (function(  ){
//   "use strict";
//
//   /**
//    * @ngdoc module
//    * @name material.components.virtualRepeat
//    */
//   VirtualRepeatContainerController['$inject'] = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs", "$document"];
//   VirtualRepeatController['$inject'] = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
//   VirtualRepeatDirective['$inject'] = ["$parse"];
//   angular.module('material.components.virtualRepeat', [
//     'material.core',
//     'material.components.showHide'
//   ])
//     .directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
//     .directive('mdVirtualRepeat', VirtualRepeatDirective);
//
//
//   /**
//    * @ngdoc directive
//    * @name mdVirtualRepeatContainer
//    * @module material.components.virtualRepeat
//    * @restrict E
//    * @description
//    * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
//    *
//    * VirtualRepeat is a limited substitute for ng-repeat that renders only
//    * enough DOM nodes to fill the container and recycling them as the user scrolls.
//    *
//    * Once an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for
//    * another visible item by replacing the previous dataset with the new one.
//    *
//    * ### Common Issues
//    *
//    * - When having one-time bindings inside of the view template, the VirtualRepeat will not properly
//    *   update the bindings for new items, since the view will be recycled.
//    *
//    * - Directives inside of a VirtualRepeat will be only compiled (linked) once, because those
//    *   are will be recycled items and used for other items.
//    *   The VirtualRepeat just updates the scope bindings.
//    *
//    *
//    * ### Notes
//    *
//    * > The VirtualRepeat is a similar implementation to the Android
//    * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html)
//    *
//    * <!-- This comment forces a break between blockquotes //-->
//    *
//    * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">VirtualRepeat</a>
//    * documentation for more information.
//    *
//    *
//    * @usage
//    * <hljs lang="html">
//    *
//    * <md-virtual-repeat-container md-top-index="topIndex">
//    *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
//    * </md-virtual-repeat-container>
//    * </hljs>
//    *
//    * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
//    *     container to $scope. It can both read and set the scroll position.
//    * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
//    *     (defaults to orientation and scrolling vertically).
//    * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
//    *     the number of items when that number is less than its original size.
//    * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
//    *     will shrink to (default: 0).
//    */
//   function VirtualRepeatContainerDirective() {
//     return {
//       controller: VirtualRepeatContainerController,
//       template: virtualRepeatContainerTemplate,
//       compile: function virtualRepeatContainerCompile($element, $attrs) {
//         $element
//           .addClass('md-virtual-repeat-container')
//           .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
//             ? 'md-orient-horizontal'
//             : 'md-orient-vertical');
//       }
//     };
//   }
//
//
//   function virtualRepeatContainerTemplate($element) {
//     return '<div class="md-virtual-repeat-scroller">' +
//       '<div class="md-virtual-repeat-sizer"></div>' +
//       '<div class="md-virtual-repeat-offsetter">' +
//       $element[0].innerHTML +
//       '</div></div>';
//   }
//
//   /**
//    * Number of additional elements to render above and below the visible area inside
//    * of the virtual repeat container. A higher number results in less flicker when scrolling
//    * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
//    * @const {number}
//    */
//   var NUM_EXTRA = 3;
//
//   /** ngInject */
//   function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window, $scope,
//                                             $element, $attrs, $document) {
//     this.$rootScope = $rootScope;
//     this.$scope = $scope;
//     this.$element = $element;
//     this.$attrs = $attrs;
//     this.$document = $document;
//
//     /** @type {number} The width or height of the container */
//     this.size = 0;
//     /** @type {number} The scroll width or height of the scroller */
//     this.scrollSize = 0;
//     /** @type {number} The scrollLeft or scrollTop of the scroller */
//     this.scrollOffset = 0;
//     /** @type {boolean} Whether the scroller is oriented horizontally */
//     this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
//     /** @type {!VirtualRepeatController} The repeater inside of this container */
//     this.repeater = null;
//     /** @type {boolean} Whether auto-shrink is enabled */
//     this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
//     /** @type {number} Minimum number of items to auto-shrink to */
//     this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
//     /** @type {?number} Original container size when shrank */
//     this.originalSize = null;
//     /** @type {number} Amount to offset the total scroll size by. */
//     this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
//     /** @type {?string} height or width element style on the container prior to auto-shrinking. */
//     this.oldElementSize = null;
//     /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
//     this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;
//
//     if (this.$attrs.mdTopIndex) {
//       /** @type {function(angular.Scope): number} Binds to topIndex on Angular scope */
//       this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
//       /** @type {number} The index of the item that is at the top of the scroll container */
//       this.topIndex = this.bindTopIndex(this.$scope);
//
//       if (angular.isUndefined(this.topIndex)) {
//         this.topIndex = 0;
//         this.bindTopIndex.assign(this.$scope, 0);
//       }
//
//       this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
//         if (newIndex !== this.topIndex) {
//           this.scrollToIndex(newIndex);
//         }
//       }));
//     } else {
//       this.topIndex = 0;
//     }
//
//     this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
//     this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
//     this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');
//
//     // After the dom stablizes, measure the initial size of the container and
//     // make a best effort at re-measuring as it changes.
//     var boundUpdateSize = angular.bind(this, this.updateSize);
//
//     $$rAF(angular.bind(this, function() {
//       boundUpdateSize();
//
//       var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
//       var jWindow = angular.element($window);
//
//       // Make one more attempt to get the size if it is 0.
//       // This is not by any means a perfect approach, but there's really no
//       // silver bullet here.
//       if (!this.size) {
//         debouncedUpdateSize();
//       }
//
//       jWindow.on('resize', debouncedUpdateSize);
//       $scope.$on('$destroy', function() {
//         jWindow.off('resize', debouncedUpdateSize);
//       });
//
//       $scope.$emit('$md-resize-enable');
//       $scope.$on('$md-resize', boundUpdateSize);
//     }));
//   }
//
//
//   /** Called by the md-virtual-repeat inside of the container at startup. */
//   VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
//     this.repeater = repeaterCtrl;
//
//     angular.element(this.scroller)
//       .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
//   };
//
//
//   /** @return {boolean} Whether the container is configured for horizontal scrolling. */
//   VirtualRepeatContainerController.prototype.isHorizontal = function() {
//     return this.horizontal;
//   };
//
//
//   /** @return {number} The size (width or height) of the container. */
//   VirtualRepeatContainerController.prototype.getSize = function() {
//     return this.size;
//   };
//
//
//   /**
//    * Resizes the container.
//    * @private
//    * @param {number} size The new size to set.
//    */
//   VirtualRepeatContainerController.prototype.setSize_ = function(size) {
//     var dimension = this.getDimensionName_();
//
//     this.size = size;
//     this.$element[0].style[dimension] = size + 'px';
//   };
//
//
//   VirtualRepeatContainerController.prototype.unsetSize_ = function() {
//     this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
//     this.oldElementSize = null;
//   };
//
//
//   /** Instructs the container to re-measure its size. */
//   VirtualRepeatContainerController.prototype.updateSize = function() {
//     // If the original size is already determined, we can skip the update.
//     if (this.originalSize) return;
//
//     this.size = this.isHorizontal()
//       ? this.$element[0].clientWidth
//       : this.$element[0].clientHeight;
//
//     // Recheck the scroll position after updating the size. This resolves
//     // problems that can result if the scroll position was measured while the
//     // element was display: none or detached from the document.
//     this.handleScroll_();
//
//     this.repeater && this.repeater.containerUpdated();
//   };
//
//
//   /** @return {number} The container's scrollHeight or scrollWidth. */
//   VirtualRepeatContainerController.prototype.getScrollSize = function() {
//     return this.scrollSize;
//   };
//
//
//   VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
//     return this.isHorizontal() ? 'width' : 'height';
//   };
//
//
//   /**
//    * Sets the scroller element to the specified size.
//    * @private
//    * @param {number} size The new size.
//    */
//   VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
//     var dimension =  this.getDimensionName_();
//     var crossDimension = this.isHorizontal() ? 'height' : 'width';
//
//     // Clear any existing dimensions.
//     this.sizer.innerHTML = '';
//
//     // If the size falls within the browser's maximum explicit size for a single element, we can
//     // set the size and be done. Otherwise, we have to create children that add up the the desired
//     // size.
//     if (size < this.maxElementPixels) {
//       this.sizer.style[dimension] = size + 'px';
//     } else {
//       this.sizer.style[dimension] = 'auto';
//       this.sizer.style[crossDimension] = 'auto';
//
//       // Divide the total size we have to render into N max-size pieces.
//       var numChildren = Math.floor(size / this.maxElementPixels);
//
//       // Element template to clone for each max-size piece.
//       var sizerChild = this.$document[0].createElement('div');
//       sizerChild.style[dimension] = this.maxElementPixels + 'px';
//       sizerChild.style[crossDimension] = '1px';
//
//       for (var i = 0; i < numChildren; i++) {
//         this.sizer.appendChild(sizerChild.cloneNode(false));
//       }
//
//       // Re-use the element template for the remainder.
//       sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
//       this.sizer.appendChild(sizerChild);
//     }
//   };
//
//
//   /**
//    * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
//    * @private
//    * @param {number} size The new size.
//    */
//   VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
//     var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
//
//     if (this.autoShrink && shrinkSize !== this.size) {
//       if (this.oldElementSize === null) {
//         this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
//       }
//
//       var currentSize = this.originalSize || this.size;
//
//       if (!currentSize || shrinkSize < currentSize) {
//         if (!this.originalSize) {
//           this.originalSize = this.size;
//         }
//
//         // Now we update the containers size, because shrinking is enabled.
//         this.setSize_(shrinkSize);
//       } else if (this.originalSize !== null) {
//         // Set the size back to our initial size.
//         this.unsetSize_();
//
//         var _originalSize = this.originalSize;
//         this.originalSize = null;
//
//         // We determine the repeaters size again, if the original size was zero.
//         // The originalSize needs to be null, to be able to determine the size.
//         if (!_originalSize) this.updateSize();
//
//         // Apply the original size or the determined size back to the container, because
//         // it has been overwritten before, in the shrink block.
//         this.setSize_(_originalSize || this.size);
//       }
//
//       this.repeater.containerUpdated();
//     }
//   };
//
//
//   /**
//    * Sets the scrollHeight or scrollWidth. Called by the repeater based on
//    * its item count and item size.
//    * @param {number} itemsSize The total size of the items.
//    */
//   VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
//     var size = itemsSize + this.offsetSize;
//     if (this.scrollSize === size) return;
//
//     this.sizeScroller_(size);
//     this.autoShrink_(size);
//     this.scrollSize = size;
//   };
//
//
//   /** @return {number} The container's current scroll offset. */
//   VirtualRepeatContainerController.prototype.getScrollOffset = function() {
//     return this.scrollOffset;
//   };
//
//   /**
//    * Scrolls to a given scrollTop position.
//    * @param {number} position
//    */
//   VirtualRepeatContainerController.prototype.scrollTo = function(position) {
//     this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
//     this.handleScroll_();
//   };
//
//   /**
//    * Scrolls the item with the given index to the top of the scroll container.
//    * @param {number} index
//    */
//   VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
//     var itemSize = this.repeater.getItemSize();
//     var itemsLength = this.repeater.itemsLength;
//     if(index > itemsLength) {
//       index = itemsLength - 1;
//     }
//     this.scrollTo(itemSize * index);
//   };
//
//   VirtualRepeatContainerController.prototype.resetScroll = function() {
//     this.scrollTo(0);
//   };
//
//
//   VirtualRepeatContainerController.prototype.handleScroll_ = function() {
//     var ltr = this.$document[0].dir != 'rtl' && this.$document[0].body.dir != 'rtl';
//     if(!ltr && !this.maxSize) {
//       this.scroller.scrollLeft = this.scrollSize;
//       this.maxSize = this.scroller.scrollLeft;
//     }
//     var offset = this.isHorizontal() ?
//       (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
//       : this.scroller.scrollTop;
//     if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;
//
//     var itemSize = this.repeater.getItemSize();
//     if (!itemSize) return;
//
//     var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
//
//     var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
//       (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
//
//     this.scrollOffset = offset;
//     this.offsetter.style.webkitTransform = transform;
//     this.offsetter.style.transform = transform;
//
//     if (this.bindTopIndex) {
//       var topIndex = Math.floor(offset / itemSize);
//       if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
//         this.topIndex = topIndex;
//         this.bindTopIndex.assign(this.$scope, topIndex);
//         if (!this.$rootScope.$$phase) this.$scope.$digest();
//       }
//     }
//
//     this.repeater.containerUpdated();
//   };
//
//
//   /**
//    * @ngdoc directive
//    * @name mdVirtualRepeat
//    * @module material.components.virtualRepeat
//    * @restrict A
//    * @priority 1000
//    * @description
//    * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
//    *
//    * Virtual repeat is a limited substitute for ng-repeat that renders only
//    * enough DOM nodes to fill the container and recycling them as the user scrolls.
//    *
//    * Arrays, but not objects are supported for iteration.
//    * Track by, as alias, and (key, value) syntax are not supported.
//    *
//    * ### On-Demand Async Item Loading
//    *
//    * When using the `md-on-demand` attribute and loading some asynchronous data, the `getItemAtIndex` function will
//    * mostly return nothing.
//    *
//    * <hljs lang="js">
//    *   DynamicItems.prototype.getItemAtIndex = function(index) {
//  *     if (this.pages[index]) {
//  *       return this.pages[index];
//  *     } else {
//  *       // This is an asynchronous action and does not return any value.
//  *       this.loadPage(index);
//  *     }
//  *   };
//    * </hljs>
//    *
//    * This means that the VirtualRepeat will not have any value for the given index.<br/>
//    * After the data loading completed, the user expects the VirtualRepeat to recognize the change.
//    *
//    * To make sure that the VirtualRepeat properly detects any change, you need to run the operation
//    * in another digest.
//    *
//    * <hljs lang="js">
//    *   DynamicItems.prototype.loadPage = function(index) {
//  *     var self = this;
//  *
//  *     // Trigger a new digest by using $timeout
//  *     $timeout(function() {
//  *       self.pages[index] = Data;
//  *     });
//  *   };
//    * </hljs>
//    *
//    * > <b>Note:</b> Please also review the
//    *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
//    *   for more information.
//    *
//    * @usage
//    * <hljs lang="html">
//    * <md-virtual-repeat-container>
//    *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
//    * </md-virtual-repeat-container>
//    *
//    * <md-virtual-repeat-container md-orient-horizontal>
//    *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
//    * </md-virtual-repeat-container>
//    * </hljs>
//    *
//    * @param {number=} md-item-size The height or width of the repeated elements (which must be
//    *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
//    *   but still assumes that all repeated nodes have same height or width.
//    * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
//    *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
//    * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
//    *   that can fetch rows rather than an array.
//    *
//    *   **NOTE:** This object must implement the following interface with two (2) methods:
//    *
//    *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
//    *     loaded (it should start downloading the item in that case).
//    *   - `getLength: function() [number]` The data length to which the repeater container
//    *     should be sized. Ideally, when the count is known, this method should return it.
//    *     Otherwise, return a higher number than the currently loaded items to produce an
//    *     infinite-scroll behavior.
//    */
//   function VirtualRepeatDirective($parse) {
//     return {
//       controller: VirtualRepeatController,
//       priority: 1000,
//       require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
//       restrict: 'A',
//       terminal: true,
//       transclude: 'element',
//       compile: function VirtualRepeatCompile($element, $attrs) {
//         var expression = $attrs.mdVirtualRepeat;
//         var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
//         var repeatName = match[1];
//         var repeatListExpression = $parse(match[2]);
//         var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);
//
//         return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
//           ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
//         };
//       }
//     };
//   }
//
//
//   /** ngInject */
//   function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
//                                    $$rAF, $mdUtil) {
//     this.$scope = $scope;
//     this.$element = $element;
//     this.$attrs = $attrs;
//     this.$browser = $browser;
//     this.$document = $document;
//     this.$rootScope = $rootScope;
//     this.$$rAF = $$rAF;
//
//     /** @type {boolean} Whether we are in on-demand mode. */
//     this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
//     /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
//     this.browserCheckUrlChange = $browser.$$checkUrlChange;
//     /** @type {number} Most recent starting repeat index (based on scroll offset) */
//     this.newStartIndex = 0;
//     /** @type {number} Most recent ending repeat index (based on scroll offset) */
//     this.newEndIndex = 0;
//     /** @type {number} Most recent end visible index (based on scroll offset) */
//     this.newVisibleEnd = 0;
//     /** @type {number} Previous starting repeat index (based on scroll offset) */
//     this.startIndex = 0;
//     /** @type {number} Previous ending repeat index (based on scroll offset) */
//     this.endIndex = 0;
//     // TODO: measure width/height of first element from dom if not provided.
//     // getComputedStyle?
//     /** @type {?number} Height/width of repeated elements. */
//     this.itemSize = $scope.$eval($attrs.mdItemSize) || null;
//
//     /** @type {boolean} Whether this is the first time that items are rendered. */
//     this.isFirstRender = true;
//
//     /**
//      * @private {boolean} Whether the items in the list are already being updated. Used to prevent
//      *     nested calls to virtualRepeatUpdate_.
//      */
//     this.isVirtualRepeatUpdating_ = false;
//
//     /** @type {number} Most recently seen length of items. */
//     this.itemsLength = 0;
//
//     /**
//      * @type {!Function} Unwatch callback for item size (when md-items-size is
//      *     not specified), or angular.noop otherwise.
//      */
//     this.unwatchItemSize_ = angular.noop;
//
//     /**
//      * Presently rendered blocks by repeat index.
//      * @type {Object<number, !VirtualRepeatController.Block}
//      */
//     this.blocks = {};
//     /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
//     this.pooledBlocks = [];
//
//     $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
//   }
//
//
//   /**
//    * An object representing a repeated item.
//    * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
//    */
//   VirtualRepeatController.Block;
//
//
//   /**
//    * Called at startup by the md-virtual-repeat postLink function.
//    * @param {!VirtualRepeatContainerController} container The container's controller.
//    * @param {!Function} transclude The repeated element's bound transclude function.
//    * @param {string} repeatName The left hand side of the repeat expression, indicating
//    *     the name for each item in the array.
//    * @param {!Function} repeatListExpression A compiled expression based on the right hand side
//    *     of the repeat expression. Points to the array to repeat over.
//    * @param {string|undefined} extraName The optional extra repeatName.
//    */
//   VirtualRepeatController.prototype.link_ =
//     function(container, transclude, repeatName, repeatListExpression, extraName) {
//       this.container = container;
//       this.transclude = transclude;
//       this.repeatName = repeatName;
//       this.rawRepeatListExpression = repeatListExpression;
//       this.extraName = extraName;
//       this.sized = false;
//
//       this.repeatListExpression = angular.bind(this, this.repeatListExpression_);
//
//       this.container.register(this);
//     };
//
//
//   /** @private Cleans up unused blocks. */
//   VirtualRepeatController.prototype.cleanupBlocks_ = function() {
//     angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
//       block.element.remove();
//     });
//   };
//
//
//   /** @private Attempts to set itemSize by measuring a repeated element in the dom */
//   VirtualRepeatController.prototype.readItemSize_ = function() {
//     if (this.itemSize) {
//       // itemSize was successfully read in a different asynchronous call.
//       return;
//     }
//
//     this.items = this.repeatListExpression(this.$scope);
//     this.parentNode = this.$element[0].parentNode;
//     var block = this.getBlock_(0);
//     if (!block.element[0].parentNode) {
//       this.parentNode.appendChild(block.element[0]);
//     }
//
//     this.itemSize = block.element[0][
//         this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;
//
//     this.blocks[0] = block;
//     this.poolBlock_(0);
//
//     if (this.itemSize) {
//       this.containerUpdated();
//     }
//   };
//
//
//   /**
//    * Returns the user-specified repeat list, transforming it into an array-like
//    * object in the case of infinite scroll/dynamic load mode.
//    * @param {!angular.Scope} The scope.
//    * @return {!Array|!Object} An array or array-like object for iteration.
//    */
//   VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
//     var repeatList = this.rawRepeatListExpression(scope);
//
//     if (this.onDemand && repeatList) {
//       var virtualList = new VirtualRepeatModelArrayLike(repeatList);
//       virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
//       return virtualList;
//     } else {
//       return repeatList;
//     }
//   };
//
//
//   /**
//    * Called by the container. Informs us that the containers scroll or size has
//    * changed.
//    */
//   VirtualRepeatController.prototype.containerUpdated = function() {
//     // If itemSize is unknown, attempt to measure it.
//     if (!this.itemSize) {
//       // Make sure to clean up watchers if we can (see #8178)
//       if(this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
//         this.unwatchItemSize_();
//       }
//       this.unwatchItemSize_ = this.$scope.$watchCollection(
//         this.repeatListExpression,
//         angular.bind(this, function(items) {
//           if (items && items.length) {
//             this.readItemSize_();
//           }
//         }));
//       if (!this.$rootScope.$$phase) this.$scope.$digest();
//
//       return;
//     } else if (!this.sized) {
//       this.items = this.repeatListExpression(this.$scope);
//     }
//
//     if (!this.sized) {
//       this.unwatchItemSize_();
//       this.sized = true;
//       this.$scope.$watchCollection(this.repeatListExpression,
//         angular.bind(this, function(items, oldItems) {
//           if (!this.isVirtualRepeatUpdating_) {
//             this.virtualRepeatUpdate_(items, oldItems);
//           }
//         }));
//     }
//
//     this.updateIndexes_();
//
//     if (this.newStartIndex !== this.startIndex ||
//       this.newEndIndex !== this.endIndex ||
//       this.container.getScrollOffset() > this.container.getScrollSize()) {
//       if (this.items instanceof VirtualRepeatModelArrayLike) {
//         this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
//       }
//       this.virtualRepeatUpdate_(this.items, this.items);
//     }
//   };
//
//
//   /**
//    * Called by the container. Returns the size of a single repeated item.
//    * @return {?number} Size of a repeated item.
//    */
//   VirtualRepeatController.prototype.getItemSize = function() {
//     return this.itemSize;
//   };
//
//
//   /**
//    * Called by the container. Returns the size of a single repeated item.
//    * @return {?number} Size of a repeated item.
//    */
//   VirtualRepeatController.prototype.getItemCount = function() {
//     return this.itemsLength;
//   };
//
//
//   /**
//    * Updates the order and visible offset of repeated blocks in response to scrolling
//    * or items updates.
//    * @private
//    */
//   VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
//     this.isVirtualRepeatUpdating_ = true;
//
//     var itemsLength = items && items.length || 0;
//     var lengthChanged = false;
//
//     // If the number of items shrank, keep the scroll position.
//     if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
//       this.items = items;
//       var previousScrollOffset = this.container.getScrollOffset();
//       this.container.resetScroll();
//       this.container.scrollTo(previousScrollOffset);
//     }
//
//     if (itemsLength !== this.itemsLength) {
//       lengthChanged = true;
//       this.itemsLength = itemsLength;
//     }
//
//     this.items = items;
//     if (items !== oldItems || lengthChanged) {
//       this.updateIndexes_();
//     }
//
//     this.parentNode = this.$element[0].parentNode;
//
//     if (lengthChanged) {
//       this.container.setScrollSize(itemsLength * this.itemSize);
//     }
//
//     var cleanUpFirstRender = false, firstRenderStartIndex;
//     if (this.isFirstRender) {
//       cleanUpFirstRender = true;
//       this.isFirstRender = false;
//       // var startIndex = this.$attrs.mdStartIndex ?
//       firstRenderStartIndex = this.$attrs.mdStartIndex ?
//         this.$scope.$eval(this.$attrs.mdStartIndex) :
//         this.container.topIndex;
//       // this.container.scrollToIndex(startIndex);
//       this.container.scrollToIndex(firstRenderStartIndex);
//     }
//
//     // Detach and pool any blocks that are no longer in the viewport.
//     Object.keys(this.blocks).forEach(function(blockIndex) {
//       var index = parseInt(blockIndex, 10);
//       if (index < this.newStartIndex || index >= this.newEndIndex) {
//         this.poolBlock_(index);
//       }
//     }, this);
//
//     // Add needed blocks.
//     // For performance reasons, temporarily block browser url checks as we digest
//     // the restored block scopes ($$checkUrlChange reads window.location to
//     // check for changes and trigger route change, etc, which we don't need when
//     // trying to scroll at 60fps).
//     this.$browser.$$checkUrlChange = angular.noop;
//
//     var i, block,
//       newStartBlocks = [],
//       newEndBlocks = [];
//
//     // Collect blocks at the top.
//     for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
//       block = this.getBlock_(i);
//       this.updateBlock_(block, i);
//       newStartBlocks.push(block);
//     }
//
//     // Update blocks that are already rendered.
//     for (; this.blocks[i] != null; i++) {
//       this.updateBlock_(this.blocks[i], i);
//     }
//     var maxIndex = i - 1;
//
//     // Collect blocks at the end.
//     for (; i < this.newEndIndex; i++) {
//       block = this.getBlock_(i);
//       this.updateBlock_(block, i);
//       newEndBlocks.push(block);
//     }
//
//     // Attach collected blocks to the document.
//     if (newStartBlocks.length) {
//       this.parentNode.insertBefore(
//         this.domFragmentFromBlocks_(newStartBlocks),
//         this.$element[0].nextSibling);
//     }
//     if (newEndBlocks.length) {
//       this.parentNode.insertBefore(
//         this.domFragmentFromBlocks_(newEndBlocks),
//         this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
//     }
//
//     // DOM manipulation may have altered scroll, so scroll again
//     if (cleanUpFirstRender) {
//       this.container.scrollToIndex(firstRenderStartIndex);
//     }
//
//     // Restore $$checkUrlChange.
//     this.$browser.$$checkUrlChange = this.browserCheckUrlChange;
//
//     this.startIndex = this.newStartIndex;
//     this.endIndex = this.newEndIndex;
//
//     this.isVirtualRepeatUpdating_ = false;
//   };
//
//
//   /**
//    * @param {number} index Where the block is to be in the repeated list.
//    * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
//    * @private
//    */
//   VirtualRepeatController.prototype.getBlock_ = function(index) {
//     if (this.pooledBlocks.length) {
//       return this.pooledBlocks.pop();
//     }
//
//     var block;
//     this.transclude(angular.bind(this, function(clone, scope) {
//       block = {
//         element: clone,
//         new: true,
//         scope: scope
//       };
//
//       this.updateScope_(scope, index);
//       this.parentNode.appendChild(clone[0]);
//     }));
//
//     return block;
//   };
//
//
//   /**
//    * Updates and if not in a digest cycle, digests the specified block's scope to the data
//    * at the specified index.
//    * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
//    * @param {number} index The index to set.
//    * @private
//    */
//   VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
//     this.blocks[index] = block;
//
//     if (!block.new &&
//       (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
//       return;
//     }
//     block.new = false;
//
//     // Update and digest the block's scope.
//     this.updateScope_(block.scope, index);
//
//     // Perform digest before reattaching the block.
//     // Any resulting synchronous dom mutations should be much faster as a result.
//     // This might break some directives, but I'm going to try it for now.
//     if (!this.$rootScope.$$phase) {
//       block.scope.$digest();
//     }
//   };
//
//
//   /**
//    * Updates scope to the data at the specified index.
//    * @param {!angular.Scope} scope The scope which should be updated.
//    * @param {number} index The index to set.
//    * @private
//    */
//   VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
//     scope.$index = index;
//     scope[this.repeatName] = this.items && this.items[index];
//     if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
//   };
//
//
//   /**
//    * Pools the block at the specified index (Pulls its element out of the dom and stores it).
//    * @param {number} index The index at which the block to pool is stored.
//    * @private
//    */
//   VirtualRepeatController.prototype.poolBlock_ = function(index) {
//     this.pooledBlocks.push(this.blocks[index]);
//     this.parentNode.removeChild(this.blocks[index].element[0]);
//     delete this.blocks[index];
//   };
//
//
//   /**
//    * Produces a dom fragment containing the elements from the list of blocks.
//    * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
//    *     should be added to the document fragment.
//    * @return {DocumentFragment}
//    * @private
//    */
//   VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
//     var fragment = this.$document[0].createDocumentFragment();
//     blocks.forEach(function(block) {
//       fragment.appendChild(block.element[0]);
//     });
//     return fragment;
//   };
//
//
//   /**
//    * Updates start and end indexes based on length of repeated items and container size.
//    * @private
//    */
//   VirtualRepeatController.prototype.updateIndexes_ = function() {
//     var itemsLength = this.items ? this.items.length : 0;
//     var containerLength = Math.ceil(this.container.getSize() / this.itemSize);
//
//     this.newStartIndex = Math.max(0, Math.min(
//       itemsLength - containerLength,
//       Math.floor(this.container.getScrollOffset() / this.itemSize)));
//     this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
//     this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
//     this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
//   };
//
//   /**
//    * This VirtualRepeatModelArrayLike class enforces the interface requirements
//    * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
//    * interface must implement the following interface with two (2) methods:
//    *
//    * getItemAtIndex: function(index) -> item at that index or null if it is not yet
//    *     loaded (It should start downloading the item in that case).
//    *
//    * getLength: function() -> number The data legnth to which the repeater container
//    *     should be sized. Ideally, when the count is known, this method should return it.
//    *     Otherwise, return a higher number than the currently loaded items to produce an
//    *     infinite-scroll behavior.
//    *
//    * @usage
//    * <hljs lang="html">
//    *  <md-virtual-repeat-container md-orient-horizontal>
//    *    <div md-virtual-repeat="i in items" md-on-demand>
//    *      Hello {{i}}!
//    *    </div>
//    *  </md-virtual-repeat-container>
//    * </hljs>
//    *
//    */
//   function VirtualRepeatModelArrayLike(model) {
//     if (!angular.isFunction(model.getItemAtIndex) ||
//       !angular.isFunction(model.getLength)) {
//       throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
//         'functions getItemAtIndex() and getLength() ');
//     }
//
//     this.model = model;
//   }
//
//
//   VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
//     for (var i = start; i < end; i++) {
//       if (!this.hasOwnProperty(i)) {
//         this[i] = this.model.getItemAtIndex(i);
//       }
//     }
//     this.length = this.model.getLength();
//   };
//
// })();

/**
 * Created by Bruce on 2017/3/1.
 */
(function() {
  'use strict';

  // POST RELEASE
  // TODO(jelbourn): Demo that uses moment.js
  // TODO(jelbourn): make sure this plays well with validation and ngMessages.
  // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
  // TODO(jelbourn): input behavior (masking? auto-complete?)


  angular.module('material.components.datepicker')
    .directive('cusMdDatepicker', datePickerDirective);

  /**
   * @ngdoc directive
   * @name mdDatepicker
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a value that can be parsed into one (e.g. a ISO 8601 string).
   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being updated. Also allows
   * for a timezone to be specified. <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the ngModelOptions docs.</a>
   * @param {expression=} ng-change Expression evaluated when the model value changes.
   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar is opened.
   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the calendar is closed.
   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
   * @param {boolean=} ng-required Whether a value is required for the datepicker.
   * @param {Date=} md-min-date Expression representing a min date (inclusive).
   * @param {Date=} md-max-date Expression representing a max date (inclusive).
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
   * @param {String=} md-placeholder The date input placeholder value.
   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input is focused.
   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar on-demand.
   * @param {String=} md-current-view Default open view of the calendar pane. Can be either "month" or "year".
   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that this may cause the
   * datepicker to not align properly with other components. **Use at your own risk.** Possible values are:
   * * `"all"` - Hides all icons.
   * * `"calendar"` - Only hides the calendar icon.
   * * `"triangle"` - Only hides the triangle icon.
   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
   * ovewritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
   *
   * @description
   * `<md-datepicker>` is a component used to select a single date.
   * For information on how to configure internationalization for the date picker,
   * see `$mdDateLocaleProvider`.
   *
   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
   * Supported attributes are:
   * * `required`: whether a required date is not set.
   * * `mindate`: whether the selected date is before the minimum allowed date.
   * * `maxdate`: whether the selected date is after the maximum allowed date.
   * * `debounceInterval`: ms to delay input processing (since last debounce reset); default value 500ms
   *
   * @usage
   * <hljs lang="html">
   *   <md-datepicker ng-model="birthday"></md-datepicker>
   * </hljs>
   *
   */

  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
    return {
      template: function(tElement, tAttrs) {
        // Buttons are not in the tab order because users can open the calendar via keyboard
        // interaction on the text input, and multiple tab stops for one component (picker)
        // may be confusing.
        var hiddenIcons = tAttrs.mdHideIcons;
        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;

        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
          'tabindex="-1" aria-hidden="true" ' +
          'ng-click="ctrl.openCalendarPane($event)">' +
          '<md-icon class="md-datepicker-calendar-icon" aria-label="cus-md-calendar" ' +
          'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
          '</md-button>';

        var triangleButton = '';

        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
          triangleButton = '' +
            '<md-button type="button" md-no-ink ' +
            'class="md-datepicker-triangle-button md-icon-button" ' +
            'ng-click="ctrl.openCalendarPane($event)" ' +
            'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
            '<div class="md-datepicker-expand-triangle"></div>' +
            '</md-button>';

          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
        }

        return calendarButton +
          '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
          '<input ' +
          (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
          'class="md-datepicker-input" ' +
          'aria-haspopup="true" ' +
          'aria-expanded="{{ctrl.isCalendarOpen}}" ' +
          'ng-focus="ctrl.setFocused(true)" ' +
          'ng-blur="ctrl.setFocused(false)"> ' +
          triangleButton +
          '</div>' +

          // This pane will be detached from here and re-attached to the document body.
          '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
          '<div class="md-datepicker-input-mask">' +
          '<div class="md-datepicker-input-mask-opaque"></div>' +
          '</div>' +
          '<div class="md-datepicker-calendar">' +
          '<cus-md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
          'md-current-view="{{::ctrl.currentView}}"' +
          'md-min-date="ctrl.minDate"' +
          'md-max-date="ctrl.maxDate"' +
          'md-date-filter="ctrl.dateFilter"' +
          'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
          '</cus-md-calendar>' +
          '</div>' +
          '</div>';
      },
      require: ['ngModel', 'cusMdDatepicker', '?^mdInputContainer', '?^form'],
      scope: {
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        placeholder: '@mdPlaceholder',
        currentView: '@mdCurrentView',
        dateFilter: '=mdDateFilter',
        isOpen: '=?mdIsOpen',
        debounceInterval: '=mdDebounceInterval',
        dateLocale: '=mdDateLocale'
      },
      controller: DatePickerCtrl,
      controllerAs: 'ctrl',
      bindToController: true,
      link: function(scope, element, attr, controllers) {
        var ngModelCtrl = controllers[0];
        var mdDatePickerCtrl = controllers[1];
        var mdInputContainer = controllers[2];
        var parentForm = controllers[3];
        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);

        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);

        if (mdInputContainer) {
          // We need to move the spacer after the datepicker itself,
          // because md-input-container adds it after the
          // md-datepicker-input by default. The spacer gets wrapped in a
          // div, because it floats and gets aligned next to the datepicker.
          // There are easier ways of working around this with CSS (making the
          // datepicker 100% wide, change the `display` etc.), however they
          // break the alignment with any other form controls.
          var spacer = element[0].querySelector('.md-errors-spacer');

          if (spacer) {
            element.after(angular.element('<div>').append(spacer));
          }

          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
          mdInputContainer.input = element;
          mdInputContainer.element
            .addClass(INPUT_CONTAINER_CLASS)
            .toggleClass(HAS_CALENDAR_ICON_CLASS, attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');

          if (!mdInputContainer.label) {
            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
          } else if(!mdNoAsterisk) {
            attr.$observe('required', function(value) {
              mdInputContainer.label.toggleClass('md-required', !!value);
            });
          }

          scope.$watch(mdInputContainer.isErrorGetter || function() {
              return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
            }, mdInputContainer.setInvalid);
        } else if (parentForm) {
          // If invalid, highlights the input when the parent form is submitted.
          var parentSubmittedWatcher = scope.$watch(function() {
            return parentForm.$submitted;
          }, function(isSubmitted) {
            if (isSubmitted) {
              mdDatePickerCtrl.updateErrorState();
              parentSubmittedWatcher();
            }
          });
        }
      }
    };
  }

  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
  var EXTRA_INPUT_SIZE = 3;

  /** Class applied to the container if the date is invalid. */
  var INVALID_CLASS = 'md-datepicker-invalid';

  /** Class applied to the datepicker when it's open. */
  var OPEN_CLASS = 'md-datepicker-open';

  /** Class applied to the md-input-container, if a datepicker is placed inside it */
  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';

  /** Class to be applied when the calendar icon is enabled. */
  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';

  /** Class to be applied when the triangle icon is enabled. */
  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';

  /** Default time in ms to debounce input event by. */
  var DEFAULT_DEBOUNCE_INTERVAL = 500;

  /**
   * Height of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_HEIGHT = 368;

  /**
   * Width of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_WIDTH = 360;

  /** Used for checking whether the current user agent is on iOS or Android. */
  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;

  /**
   * Controller for md-datepicker.
   *
   * @ngInject @constructor
   */
  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant",
    "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter", "$document"];
  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant,
                          $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF, $filter, $document) {

    /** @final */
    this.$window = $window;

    /** @final */
    this.$document = $document;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdConstant = $mdConstant;

    /* @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.$$rAF = $$rAF;

    /** @final */
    this.$mdDateLocale = $mdDateLocale;

    /**
     * The root document element. This is used for attaching a top-level click handler to
     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
     * instead of body because, when scrolling is disabled, some browsers consider the body element
     * to be completely off the screen and propagate events directly to the html element.
     * @type {!angular.JQLite}
     */
    this.documentElement = angular.element(this.$document[0].documentElement);

    /** @type {!angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {HTMLInputElement} */
    this.inputElement = $element[0].querySelector('input');

    /** @final {!angular.JQLite} */
    this.ngInputElement = angular.element(this.inputElement);

    /** @type {HTMLElement} */
    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');

    /** @type {HTMLElement} Floating calendar pane. */
    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');

    /** @type {HTMLElement} Calendar icon button. */
    this.calendarButton = $element[0].querySelector('.md-datepicker-button');

    /**
     * Element covering everything but the input in the top of the floating calendar pane.
     * @type {!angular.JQLite}
     */
    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Attributes} */
    this.$attrs = $attrs;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @type {Date} */
    this.date = null;

    /** @type {boolean} */
    this.isFocused = false;

    /** @type {boolean} */
    this.isDisabled;
    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));

    /** @type {boolean} Whether the date-picker's calendar pane is open. */
    this.isCalendarOpen = false;

    /** @type {boolean} Whether the calendar should open when the input is focused. */
    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');

    /** @final */
    this.mdInputContainer = null;

    /**
     * Element from which the calendar pane was opened. Keep track of this so that we can return
     * focus to it when the pane is closed.
     * @type {HTMLElement}
     */
    this.calendarPaneOpenedFrom = null;

    /** @type {String} Unique id for the calendar pane. */
    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();

    /** Pre-bound click handler is saved so that the event listener can be removed. */
    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

    /**
     * Name of the event that will trigger a close. Necessary to sniff the browser, because
     * the resize event doesn't make sense on mobile and can have a negative impact since it
     * triggers whenever the browser zooms in on a focused input.
     */
    this.windowEventName = IS_MOBILE_REGEX.test(
      navigator.userAgent || navigator.vendor || this.$window.opera
    ) ? 'orientationchange' : 'resize';

    /** Pre-bound close handler so that the event listener can be removed. */
    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);

    /** The built-in Angular date filter. */
    this.ngDateFilter = $filter('date');

    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
    this.leftMargin = 20;

    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
    this.topMargin = null;

    // Unless the user specifies so, the datepicker should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if ($attrs.tabindex) {
      this.ngInputElement.attr('tabindex', $attrs.tabindex);
      $attrs.$set('tabindex', null);
    } else {
      $attrs.$set('tabindex', '-1');
    }

    $attrs.$set('aria-owns', this.calendarPaneId);

    $mdTheming($element);
    $mdTheming(angular.element(this.calendarPane));

    var self = this;

    $scope.$on('$destroy', function() {
      self.detachCalendarPane();
    });

    if ($attrs.mdIsOpen) {
      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
        if (shouldBeOpen) {
          self.openCalendarPane({
            target: self.inputElement
          });
        } else {
          self.closeCalendarPane();
        }
      });
    }

    // For Angular 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }

  }

  /**
   * Angular Lifecycle hook for newer Angular versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
   */
  DatePickerCtrl.prototype.$onInit = function() {

    /**
     * Holds locale-specific formatters, parsers, labels etc. Allows
     * the user to override specific ones from the $mdDateLocale provider.
     * @type {!Object}
     */
    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale) : this.$mdDateLocale;

    this.installPropertyInterceptors();
    this.attachChangeListeners();
    this.attachInteractionListeners();
  };

  /**
   * Sets up the controller's reference to ngModelController and
   * applies Angular's `input[type="date"]` directive.
   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
   * @param {Object} inputDirective Config for Angular's `input` directive.
   */
  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
    this.ngModelCtrl = ngModelCtrl;
    this.mdInputContainer = mdInputContainer;

    // The input needs to be [type="date"] in order to be picked up by Angular.
    this.$attrs.$set('type', 'date');

    // Invoke the `input` directive link function, adding a stub for the element.
    // This allows us to re-use Angular's logic for setting the timezone via ng-model-options.
    // It works by calling the link function directly which then adds the proper `$parsers` and
    // `$formatters` to the ngModel controller.
    inputDirective[0].link.pre(this.$scope, {
      on: angular.noop,
      val: angular.noop,
      0: {}
    }, this.$attrs, [ngModelCtrl]);

    var self = this;

    // Responds to external changes to the model value.
    self.ngModelCtrl.$formatters.push(function(value) {
      var parsedValue = angular.isDefined(value) ? Date.parse(value) : null;

      // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
      if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
        value = new Date(parsedValue);
      }

      if (value && !(value instanceof Date)) {
        throw Error(
          'The ng-model for md-datepicker must be a Date instance or a value ' +
          'that can be parsed into a date. Currently the model is of type: ' + typeof value
        );
      }

      self.onExternalChange(value);

      return value;
    });

    // Responds to external error state changes (e.g. ng-required based on another input).
    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));

    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
    // working for events that don't bubble (e.g. 'blur') since Angular binds the handlers to
    // the `<md-datepicker>`.
    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');

    if (updateOn) {
      this.ngInputElement.on(
        updateOn,
        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
      );
    }
  };

  /**
   * Attach event listeners for both the text input and the md-calendar.
   * Events are used instead of ng-model so that updates don't infinitely update the other
   * on a change. This should also be more performant than using a $watch.
   */
  DatePickerCtrl.prototype.attachChangeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-change', function(event, date) {
      self.setModelValue(date);
      self.onExternalChange(date);
      self.closeCalendarPane();
    });

    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));

    var debounceInterval = angular.isDefined(this.debounceInterval) ?
      this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
      debounceInterval, self));
  };

  /** Attach event listeners for user interaction. */
  DatePickerCtrl.prototype.attachInteractionListeners = function() {
    var self = this;
    var $scope = this.$scope;
    var keyCodes = this.$mdConstant.KEY_CODE;

    // Add event listener through angular so that we can triggerHandler in unit tests.
    self.ngInputElement.on('keydown', function(event) {
      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
        self.openCalendarPane(event);
        $scope.$digest();
      }
    });

    if (self.openOnFocus) {
      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
      angular.element(self.$window).on('blur', self.windowBlurHandler);

      $scope.$on('$destroy', function() {
        angular.element(self.$window).off('blur', self.windowBlurHandler);
      });
    }

    $scope.$on('md-calendar-close', function() {
      self.closeCalendarPane();
    });
  };

  /**
   * Capture properties set to the date-picker and imperitively handle internal changes.
   * This is done to avoid setting up additional $watches.
   */
  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
    var self = this;

    if (this.$attrs.ngDisabled) {
      // The expression is to be evaluated against the directive element's scope and not
      // the directive's isolate scope.
      var scope = this.$scope.$parent;

      if (scope) {
        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
          self.setDisabled(isDisabled);
        });
      }
    }

    Object.defineProperty(this, 'placeholder', {
      get: function() { return self.inputElement.placeholder; },
      set: function(value) { self.inputElement.placeholder = value || ''; }
    });
  };

  /**
   * Sets whether the date-picker is disabled.
   * @param {boolean} isDisabled
   */
  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
    this.isDisabled = isDisabled;
    this.inputElement.disabled = isDisabled;

    if (this.calendarButton) {
      this.calendarButton.disabled = isDisabled;
    }
  };

  /**
   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
   *   - mindate: whether the selected date is before the minimum date.
   *   - maxdate: whether the selected flag is after the maximum date.
   *   - filtered: whether the selected date is allowed by the custom filtering function.
   *   - valid: whether the entered text input is a valid date
   *
   * The 'required' flag is handled automatically by ngModel.
   *
   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
   */
  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
    var date = opt_date || this.date;

    // Clear any existing errors to get rid of anything that's no longer relevant.
    this.clearErrorState();

    if (this.dateUtil.isValidDate(date)) {
      // Force all dates to midnight in order to ignore the time portion.
      date = this.dateUtil.createDateAtMidnight(date);

      if (this.dateUtil.isValidDate(this.minDate)) {
        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
      }

      if (this.dateUtil.isValidDate(this.maxDate)) {
        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
      }

      if (angular.isFunction(this.dateFilter)) {
        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
      }
    } else {
      // The date is seen as "not a valid date" if there is *something* set
      // (i.e.., not null or undefined), but that something isn't a valid date.
      this.ngModelCtrl.$setValidity('valid', date == null);
    }

    angular.element(this.inputContainer).toggleClass(INVALID_CLASS, !this.ngModelCtrl.$valid);
  };

  /** Clears any error flags set by `updateErrorState`. */
  DatePickerCtrl.prototype.clearErrorState = function() {
    this.inputContainer.classList.remove(INVALID_CLASS);
    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
      this.ngModelCtrl.$setValidity(field, true);
    }, this);
  };

  /** Resizes the input element based on the size of its content. */
  DatePickerCtrl.prototype.resizeInputElement = function() {
    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
  };

  /**
   * Sets the model value if the user input is a valid date.
   * Adds an invalid class to the input element if not.
   */
  DatePickerCtrl.prototype.handleInputEvent = function() {
    var inputString = this.inputElement.value;
    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
    this.dateUtil.setDateTimeToMidnight(parsedDate);

    // An input string is valid if it is either empty (representing no date)
    // or if it parses to a valid date that the user is allowed to select.
    var isValidInput = inputString == '' || (
        this.dateUtil.isValidDate(parsedDate) &&
        this.locale.isDateComplete(inputString) &&
        this.isDateEnabled(parsedDate)
      );

    // The datepicker's model is only updated when there is a valid input.
    if (isValidInput) {
      this.setModelValue(parsedDate);
      this.date = parsedDate;
    }

    this.updateErrorState(parsedDate);
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
      (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
  };

  /** Position and attach the floating calendar to the document. */
  DatePickerCtrl.prototype.attachCalendarPane = function() {
    var calendarPane = this.calendarPane;
    var body = this.$document[0].body;

    calendarPane.style.transform = '';
    this.$element.addClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
    angular.element(body).addClass('md-datepicker-is-showing');

    var elementRect = this.inputContainer.getBoundingClientRect();
    var bodyRect = body.getBoundingClientRect();

    if (!this.topMargin || this.topMargin < 0) {
      this.topMargin = (this.inputMask.parent().prop('clientHeight') - this.ngInputElement.prop('clientHeight')) / 2;
    }

    // Check to see if the calendar pane would go off the screen. If so, adjust position
    // accordingly to keep it within the viewport.
    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;

    // If ng-material has disabled body scrolling (for example, if a dialog is open),
    // then it's possible that the already-scrolled body has a negative top/left. In this case,
    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
    // though, the top of the viewport should just be the body's scroll position.
    var viewportTop = (bodyRect.top < 0 && this.$document[0].body.scrollTop == 0) ?
      -bodyRect.top :
      this.$document[0].body.scrollTop;

    var viewportLeft = (bodyRect.left < 0 && this.$document[0].body.scrollLeft == 0) ?
      -bodyRect.left :
      this.$document[0].body.scrollLeft;

    var viewportBottom = viewportTop + this.$window.innerHeight;
    var viewportRight = viewportLeft + this.$window.innerWidth;

    // Creates an overlay with a hole the same size as element. We remove a pixel or two
    // on each end to make it overlap slightly. The overlay's background is added in
    // the theme in the form of a box-shadow with a huge spread.
    this.inputMask.css({
      position: 'absolute',
      left: this.leftMargin + 'px',
      top: this.topMargin + 'px',
      width: (elementRect.width - 1) + 'px',
      height: (elementRect.height - 2) + 'px'
    });

    // If the right edge of the pane would be off the screen and shifting it left by the
    // difference would not go past the left edge of the screen. If the calendar pane is too
    // big to fit on the screen at all, move it to the left of the screen and scale the entire
    // element down to fit.
    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
      } else {
        paneLeft = viewportLeft;
        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
        calendarPane.style.transform = 'scale(' + scale + ')';
      }

      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    // If the bottom edge of the pane would be off the screen and shifting it up by the
    // difference would not go past the top edge of the screen.
    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
      viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    calendarPane.style.left = paneLeft + 'px';
    calendarPane.style.top = paneTop + 'px';
    this.$document[0].body.appendChild(calendarPane);

    // Add CSS class after one frame to trigger open animation.
    this.$$rAF(function() {
      calendarPane.classList.add('md-pane-open');
    });
  };

  /** Detach the floating calendar pane from the document. */
  DatePickerCtrl.prototype.detachCalendarPane = function() {
    this.$element.removeClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
    angular.element(this.$document[0].body).removeClass('md-datepicker-is-showing');
    this.calendarPane.classList.remove('md-pane-open');
    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

    if (this.isCalendarOpen) {
      this.$mdUtil.enableScrolling();
    }

    if (this.calendarPane.parentNode) {
      // Use native DOM removal because we do not want any of the
      // angular state of this element to be disposed.
      this.calendarPane.parentNode.removeChild(this.calendarPane);
    }
  };

  /**
   * Open the floating calendar pane.
   * @param {Event} event
   */
  DatePickerCtrl.prototype.openCalendarPane = function(event) {
    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
      this.isCalendarOpen = this.isOpen = true;
      this.calendarPaneOpenedFrom = event.target;

      // Because the calendar pane is attached directly to the body, it is possible that the
      // rest of the component (input, etc) is in a different scrolling container, such as
      // an md-content. This means that, if the container is scrolled, the pane would remain
      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
      // also matches the native behavior for things like `<select>` on Mac and Windows.
      this.$mdUtil.disableScrollAround(this.calendarPane);

      this.attachCalendarPane();
      this.focusCalendar();
      this.evalAttr('ngFocus');

      // Attach click listener inside of a timeout because, if this open call was triggered by a
      // click, we don't want it to be immediately propogated up to the body and handled.
      var self = this;
      this.$mdUtil.nextTick(function() {
        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
        // events aren't propogated under most circumstances.
        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        self.documentElement.on('click touchstart', self.bodyClickHandler);
      }, false);

      this.$window.addEventListener(this.windowEventName, this.windowEventHandler);
    }
  };

  /** Close the floating calendar pane. */
  DatePickerCtrl.prototype.closeCalendarPane = function() {
    if (this.isCalendarOpen) {
      var self = this;

      self.detachCalendarPane();
      self.ngModelCtrl.$setTouched();
      self.evalAttr('ngBlur');

      self.documentElement.off('click touchstart', self.bodyClickHandler);
      this.$window.removeEventListener(self.windowEventName, self.windowEventHandler);

      self.calendarPaneOpenedFrom.focus();
      self.calendarPaneOpenedFrom = null;

      if (self.openOnFocus) {
        // Ensures that all focus events have fired before resetting
        // the calendar. Prevents the calendar from reopening immediately
        // in IE when md-open-on-focus is set. Also it needs to trigger
        // a digest, in order to prevent issues where the calendar wasn't
        // showing up on the next open.
        self.$mdUtil.nextTick(reset);
      } else {
        reset();
      }
    }

    function reset(){
      self.isCalendarOpen = self.isOpen = false;
    }
  };

  /** Gets the controller instance for the calendar in the floating pane. */
  DatePickerCtrl.prototype.getCalendarCtrl = function() {
    return angular.element(this.calendarPane.querySelector('cus-md-calendar')).controller('cusMdCalendar');
  };

  /** Focus the calendar in the floating pane. */
  DatePickerCtrl.prototype.focusCalendar = function() {
    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
    var self = this;
    this.$mdUtil.nextTick(function() {
      self.getCalendarCtrl().focus();
    }, false);
  };

  /**
   * Sets whether the input is currently focused.
   * @param {boolean} isFocused
   */
  DatePickerCtrl.prototype.setFocused = function(isFocused) {
    if (!isFocused) {
      this.ngModelCtrl.$setTouched();
    }

    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
    // because they also get called when the calendar is opened/closed.
    if (!this.openOnFocus) {
      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
    }

    this.isFocused = isFocused;
  };

  /**
   * Handles a click on the document body when the floating calendar pane is open.
   * Closes the floating calendar pane if the click is not inside of it.
   * @param {MouseEvent} event
   */
  DatePickerCtrl.prototype.handleBodyClick = function(event) {
    if (this.isCalendarOpen) {
      var isInCalendar = this.$mdUtil.getClosest(event.target, 'cus-md-calendar');

      if (!isInCalendar) {
        this.closeCalendarPane();
      }

      this.$scope.$digest();
    }
  };

  /**
   * Handles the event when the user navigates away from the current tab. Keeps track of
   * whether the input was focused when the event happened, in order to prevent the calendar
   * from re-opening.
   */
  DatePickerCtrl.prototype.handleWindowBlur = function() {
    this.inputFocusedOnWindowBlur = this.$document[0].activeElement === this.inputElement;
  };

  /**
   * Evaluates an attribute expression against the parent scope.
   * @param {String} attr Name of the attribute to be evaluated.
   */
  DatePickerCtrl.prototype.evalAttr = function(attr) {
    if (this.$attrs[attr]) {
      this.$scope.$parent.$eval(this.$attrs[attr]);
    }
  };

  /**
   * Sets the ng-model value by first converting the date object into a strng. Converting it
   * is necessary, in order to pass Angular's `input[type="date"]` validations. Angular turns
   * the value into a Date object afterwards, before setting it on the model.
   * @param {Date=} value Date to be set as the model value.
   */
  DatePickerCtrl.prototype.setModelValue = function(value) {
    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone));
  };

  /**
   * Updates the datepicker when a model change occurred externally.
   * @param {Date=} value Value that was set to the model.
   */
  DatePickerCtrl.prototype.onExternalChange = function(value) {
    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');

    this.date = value;
    this.inputElement.value = this.locale.formatDate(value, timezone);
    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
    this.resizeInputElement();
    this.updateErrorState();
  };
})();

/**
 * Created by Bruce on 2016/12/19.
 */

(function () {
  'use strict';
  angular.module('eHRD.kernel.uiElements.cusMaterial',[]);
})();

/**
 * Created by Bruce on 2016/12/19.
 */
(function () {
  'use strict';
  var MD_CHIPS_TEMPLATE = '\
      <md-chips-wrap\
          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
          class="md-chips">\
        <cus-md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
            index="{{$index}}"\
            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
          <div class="md-chip-content"\
              tabindex="-1"\
              aria-hidden="true"\
              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
          <div ng-if="$mdChipsCtrl.isRemovable()"\
               class="md-chip-remove-container"\
               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
        </cus-md-chip>\
        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
        </div>\
      </md-chips-wrap>';

  var CHIP_INPUT_TEMPLATE = '\
        <input\
            class="md-input"\
            tabindex="0"\
            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
            aria-label="{{$mdChipsCtrl.getPlaceholder()}}"\
            ng-model="$mdChipsCtrl.chipBuffer"\
            ng-focus="$mdChipsCtrl.onInputFocus()"\
            ng-blur="$mdChipsCtrl.onInputBlur()"\
            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';

  var CHIP_DEFAULT_TEMPLATE = '\
      <span>{{$chip}}</span>';

  var CHIP_REMOVE_TEMPLATE = '\
      <button\
          class="md-chip-remove"\
          ng-if="$mdChipsCtrl.isRemovable()"\
          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)"\
          type="button"\
          aria-hidden="true"\
          tabindex="-1">\
        <md-icon md-svg-src="{{ $mdChipsCtrl.mdCloseIcon }}"></md-icon>\
        <span class="md-visually-hidden">\
          {{$mdChipsCtrl.deleteButtonLabel}}\
        </span>\
      </button>';

  /**
   * MDChips Directive Definition
   */
  cusMdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];
  function cusMdChips($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
// Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
    var templates = getTemplates();

    return {
      template: function(element, attrs) {
        // Clone the element into an attribute. By prepending the attribute
        // name with '$', Angular won't write it into the DOM. The cloned
        // element propagates to the link function via the attrs argument,
        // where various contained-elements can be consumed.
        attrs['$mdUserTemplate'] = element.clone();
        return templates.chips;
      },
      require: ['cusMdChips'],
      restrict: 'E',
      controller: MdChipsCtrl,
      controllerAs: '$mdChipsCtrl',
      bindToController: true,
      compile: compile,
      scope: {
        readonly: '=readonly',
        removable: '=mdRemovable',
        placeholder: '@',
        secondaryPlaceholder: '@',
        maxChips: '@mdMaxChips',
        transformChip: '&mdTransformChip',
        onAppend: '&mdOnAppend',
        onAdd: '&mdOnAdd',
        onRemove: '&mdOnRemove',
        onSelect: '&mdOnSelect',
        deleteHint: '@',
        deleteButtonLabel: '@',
        separatorKeys: '=?mdSeparatorKeys',
        requireMatch: '=?mdRequireMatch'
      }
    };

    /**
     * Builds the final template for `md-chips` and returns the postLink function.
     *
     * Building the template involves 3 key components:
     * static chips
     * chip template
     * input control
     *
     * If no `ng-model` is provided, only the static chip work needs to be done.
     *
     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
     * template is appended to the chip content element.
     *
     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
     *
     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
     * If no user input is provided, a default one is appended to the input container node in the
     * template.
     *
     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
     * transclusion in the `postLink` function.
     *
     *
     * @param element
     * @param attr
     * @returns {Function}
     */
    function compile(element, attr) {
      // Grab the user template from attr and reset the attribute to null.
      var userTemplate = attr['$mdUserTemplate'];
      attr['$mdUserTemplate'] = null;

      var chipTemplate = getTemplateByQuery('cus-md-chips>md-chip-template');

      var chipRemoveSelector = $mdUtil
        .prefixer()
        .buildList('md-chip-remove')
        .map(function(attr) {
          return 'cus-md-chips>*[' + attr + ']';
        })
        .join(',');

      // Set the chip remove, chip contents and chip input templates. The link function will put
      // them on the scope for transclusion later.
      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
        chipContentsTemplate = chipTemplate || templates.default,
        chipInputTemplate    = getTemplateByQuery('cus-md-chips>cus-md-autocomplete')
          || getTemplateByQuery('cus-md-chips>input')
          || templates.input,
        staticChips = userTemplate.find('cus-md-chip');

      // Warn of malformed template. See #2545
      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
      }

      function getTemplateByQuery (query) {
        if (!attr.ngModel) return;
        var element = userTemplate[0].querySelector(query);
        return element && element.outerHTML;
      }

      /**
       * Configures controller and transcludes.
       */
      return function postLink(scope, element, attrs, controllers) {
        $mdUtil.initOptionalProperties(scope, attr);

        $mdTheming(element);
        var mdChipsCtrl = controllers[0];
        if(chipTemplate) {
          // Chip editing functionality assumes we are using the default chip template.
          mdChipsCtrl.enableChipEdit = false;
        }

        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;

        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdClose;

        element.attr({ 'aria-hidden': true, tabindex: -1 })
          .on('focus', function () {
            mdChipsCtrl.onFocus();
          });

        if (attr.ngModel) {
          mdChipsCtrl.configureNgModel(element.controller('ngModel'));
          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
          // before appending chips.
          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();

          // If an `md-on-append` attribute was set, tell the controller to use the expression
          // when appending chips.
          //
          // DEPRECATED: Will remove in official 1.0 release
          if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();

          // If an `md-on-add` attribute was set, tell the controller to use the expression
          // when adding chips.
          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();

          // If an `md-on-remove` attribute was set, tell the controller to use the expression
          // when removing chips.
          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();

          // If an `md-on-select` attribute was set, tell the controller to use the expression
          // when selecting chips.
          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();

          // The md-autocomplete and input elements won't be compiled until after this directive
          // is complete (due to their nested nature). Wait a tick before looking for them to
          // configure the controller.
          if (chipInputTemplate != templates.input) {
            // The autocomplete will not appear until the readonly attribute is not true (i.e.
            // false or undefined), so we have to watch the readonly and then on the next tick
            // after the chip transclusion has run, we can configure the autocomplete and user
            // input.
            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
              if (!readonly) {

                $mdUtil.nextTick(function(){

                  if (chipInputTemplate.indexOf('<cus-md-autocomplete') === 0) {
                    var autocompleteEl = element.find('cus-md-autocomplete');
                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('cusMdAutocomplete'));
                  }

                  mdChipsCtrl.configureUserInput(element.find('input'));
                });
              }
            });
          }

          // At the next tick, if we find an input, make sure it has the md-input class
          $mdUtil.nextTick(function() {
            var input = element.find('input');

            input && input.toggleClass('md-input', true);
          });
        }

        // Compile with the parent's scope and prepend any static chips to the wrapper.
        if (staticChips.length > 0) {
          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
        }
      };
    }

    function getTemplates() {
      return {
        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
      };
    }
  }

  /**
   * Controller for the MdChips component. Responsible for adding to and
   * removing from the list of chips, marking chips as selected, and binding to
   * the models of various input components.
   *
   * @param $scope
   * @param $attrs
   * @param $mdConstant
   * @param $log
   * @param $element
   * @param $timeout
   * @param $mdUtil
   * @constructor
   */
  MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil"];
  function MdChipsCtrl($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil) {
    /** @type {$timeout} **/
    this.$timeout = $timeout;

    /** @type {Object} */
    this.$mdConstant = $mdConstant;

    /** @type {angular.$scope} */
    this.$scope = $scope;

    /** @type {angular.$scope} */
    this.parent = $scope.$parent;

    /** @type {$mdUtil} */
    this.$mdUtil = $mdUtil;

    /** @type {$log} */
    this.$log = $log;

    /** @type {$element} */
    this.$element = $element;

    /** @type {angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {angular.NgModelController} */
    this.userInputNgModelCtrl = null;

    /** @type {MdAutocompleteCtrl} */
    this.autocompleteCtrl = null;

    /** @type {Element} */
    this.userInputElement = null;

    /** @type {Array.<Object>} */
    this.items = [];

    /** @type {number} */
    this.selectedChip = -1;

    /** @type {string} */
    this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);

    /** @type {string} */
    this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);

    /**
     * Hidden hint text for how to delete a chip. Used to give context to screen readers.
     * @type {string}
     */
    this.deleteHint = 'Press delete to remove this chip.';

    /**
     * Hidden label for the delete button. Used to give context to screen readers.
     * @type {string}
     */
    this.deleteButtonLabel = 'Remove';

    /**
     * Model used by the input element.
     * @type {string}
     */
    this.chipBuffer = '';

    /**
     * Whether to use the transformChip expression to transform the chip buffer
     * before appending it to the list.
     * @type {boolean}
     */
    this.useTransformChip = false;

    /**
     * Whether to use the onAdd expression to notify of chip additions.
     * @type {boolean}
     */
    this.useOnAdd = false;

    /**
     * Whether to use the onRemove expression to notify of chip removals.
     * @type {boolean}
     */
    this.useOnRemove = false;

    /**
     * Whether to use the onSelect expression to notify the component's user
     * after selecting a chip from the list.
     * @type {boolean}
     */
  }


  /**
   * Handles the keydown event on the input element: by default <enter> appends
   * the buffer to the chip list, while backspace removes the last chip in the
   * list if the current buffer is empty.
   * @param event
   */
  MdChipsCtrl.prototype.inputKeydown = function(event) {
    var chipBuffer = this.getChipBuffer();

    // If we have an autocomplete, and it handled the event, we have nothing to do
    if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
      return;
    }

    if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
      // Only select and focus the previous chip, if the current caret position of the
      // input element is at the beginning.
      if (this.getCursorPosition(event.target) !== 0) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (this.items.length) {
        this.selectAndFocusChipSafe(this.items.length - 1);
      }

      return;
    }

    // By default <enter> appends the buffer to the chip list.
    if (!this.separatorKeys || this.separatorKeys.length < 1) {
      this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
    }

    // Support additional separator key codes in an array of `md-separator-keys`.
    if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
      if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
      event.preventDefault();

      // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
      if (this.hasMaxChipsReached()) return;

      this.appendChip(chipBuffer.trim());
      this.resetChipBuffer();
    }
  };

  /**
   * Returns the cursor position of the specified input element.
   * @param element HTMLInputElement
   * @returns {Number} Cursor Position of the input.
   */
  MdChipsCtrl.prototype.getCursorPosition = function(element) {
    /*
     * Figure out whether the current input for the chips buffer is valid for using
     * the selectionStart / end property to retrieve the cursor position.
     * Some browsers do not allow the use of those attributes, on different input types.
     */
    try {
      if (element.selectionStart === element.selectionEnd) {
        return element.selectionStart;
      }
    } catch (e) {
      if (!element.value) {
        return 0;
      }
    }
  };


  /**
   * Updates the content of the chip at given index
   * @param chipIndex
   * @param chipContents
   */
  MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents){
    if(chipIndex >= 0 && chipIndex < this.items.length) {
      this.items[chipIndex] = chipContents;
      this.ngModelCtrl.$setDirty();
    }
  };


  /**
   * Returns true if a chip is currently being edited. False otherwise.
   * @return {boolean}
   */
  MdChipsCtrl.prototype.isEditingChip = function() {
    return !!this.$element[0].querySelector('._md-chip-editing');
  };


  MdChipsCtrl.prototype.isRemovable = function() {
    // Return false if we have static chips
    if (!this.ngModelCtrl) {
      return false;
    }

    return this.readonly ? this.removable :
      angular.isDefined(this.removable) ? this.removable : true;
  };

  /**
   * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
   * keys switch which chips is active
   * @param event
   */
  MdChipsCtrl.prototype.chipKeydown = function (event) {
    if (this.getChipBuffer()) return;
    if (this.isEditingChip()) return;

    switch (event.keyCode) {
      case this.$mdConstant.KEY_CODE.BACKSPACE:
      case this.$mdConstant.KEY_CODE.DELETE:
        if (this.selectedChip < 0) return;
        event.preventDefault();
        // Cancel the delete action only after the event cancel. Otherwise the page will go back.
        if (!this.isRemovable()) return;
        this.removeAndSelectAdjacentChip(this.selectedChip);
        break;
      case this.$mdConstant.KEY_CODE.LEFT_ARROW:
        event.preventDefault();
        if (this.selectedChip < 0) this.selectedChip = this.items.length;
        if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
        break;
      case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
        event.preventDefault();
        this.selectAndFocusChipSafe(this.selectedChip + 1);
        break;
      case this.$mdConstant.KEY_CODE.ESCAPE:
      case this.$mdConstant.KEY_CODE.TAB:
        if (this.selectedChip < 0) return;
        event.preventDefault();
        this.onFocus();
        break;
    }
  };

  /**
   * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
   * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
   * always.
   */
  MdChipsCtrl.prototype.getPlaceholder = function() {
    // Allow `secondary-placeholder` to be blank.
    var useSecondary = (this.items && this.items.length &&
    (this.secondaryPlaceholder == '' || this.secondaryPlaceholder));
    return useSecondary ? this.secondaryPlaceholder : this.placeholder;
  };

  /**
   * Removes chip at {@code index} and selects the adjacent chip.
   * @param index
   */
  MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index) {
    var selIndex = this.getAdjacentChipIndex(index);
    this.removeChip(index);
    this.$timeout(angular.bind(this, function () {
      this.selectAndFocusChipSafe(selIndex);
    }));
  };

  /**
   * Sets the selected chip index to -1.
   */
  MdChipsCtrl.prototype.resetSelectedChip = function() {
    this.selectedChip = -1;
  };

  /**
   * Gets the index of an adjacent chip to select after deletion. Adjacency is
   * determined as the next chip in the list, unless the target chip is the
   * last in the list, then it is the chip immediately preceding the target. If
   * there is only one item in the list, -1 is returned (select none).
   * The number returned is the index to select AFTER the target has been
   * removed.
   * If the current chip is not selected, then -1 is returned to select none.
   */
  MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
    var len = this.items.length - 1;
    return (len == 0) ? -1 :
      (index == len) ? index -1 : index;
  };

  /**
   * Append the contents of the buffer to the chip list. This method will first
   * call out to the md-transform-chip method, if provided.
   *
   * @param newChip
   */
  MdChipsCtrl.prototype.appendChip = function(newChip) {
    if (this.useTransformChip && this.transformChip) {
      var transformedChip = this.transformChip({'$chip': newChip});

      // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
      // they want the string version.
      if (angular.isDefined(transformedChip)) {
        newChip = transformedChip;
      }
    }

    // If items contains an identical object to newChip, do not append
    if (angular.isObject(newChip)){
      var identical = this.items.some(function(item){
        return angular.equals(newChip, item);
      });
      if (identical) return;
    }

    // Check for a null (but not undefined), or existing chip and cancel appending
    if (newChip == null || this.items.indexOf(newChip) + 1) return;

    // Append the new chip onto our list
    var index = this.items.push(newChip);

    // Update model validation
    this.ngModelCtrl.$setDirty();
    this.validateModel();

    // If they provide the md-on-add attribute, notify them of the chip addition
    if (this.useOnAdd && this.onAdd) {
      this.onAdd({ '$chip': newChip, '$index': index });
    }
  };

  /**
   * Sets whether to use the md-transform-chip expression. This expression is
   * bound to scope and controller in {@code MdChipsDirective} as
   * {@code transformChip}. Due to the nature of directive scope bindings, the
   * controller cannot know on its own/from the scope whether an expression was
   * actually provided.
   */
  MdChipsCtrl.prototype.useTransformChipExpression = function() {
    this.useTransformChip = true;
  };

  /**
   * Sets whether to use the md-on-add expression. This expression is
   * bound to scope and controller in {@code MdChipsDirective} as
   * {@code onAdd}. Due to the nature of directive scope bindings, the
   * controller cannot know on its own/from the scope whether an expression was
   * actually provided.
   */
  MdChipsCtrl.prototype.useOnAddExpression = function() {
    this.useOnAdd = true;
  };

  /**
   * Sets whether to use the md-on-remove expression. This expression is
   * bound to scope and controller in {@code MdChipsDirective} as
   * {@code onRemove}. Due to the nature of directive scope bindings, the
   * controller cannot know on its own/from the scope whether an expression was
   * actually provided.
   */
  MdChipsCtrl.prototype.useOnRemoveExpression = function() {
    this.useOnRemove = true;
  };

  /*
   * Sets whether to use the md-on-select expression. This expression is
   * bound to scope and controller in {@code MdChipsDirective} as
   * {@code onSelect}. Due to the nature of directive scope bindings, the
   * controller cannot know on its own/from the scope whether an expression was
   * actually provided.
   */
  MdChipsCtrl.prototype.useOnSelectExpression = function() {
    this.useOnSelect = true;
  };

  /**
   * Gets the input buffer. The input buffer can be the model bound to the
   * default input item {@code this.chipBuffer}, the {@code selectedItem}
   * model of an {@code md-autocomplete}, or, through some magic, the model
   * bound to any inpput or text area element found within a
   * {@code md-input-container} element.
   * @return {string}
   */
  MdChipsCtrl.prototype.getChipBuffer = function() {
    var chipBuffer =  !this.userInputElement ? this.chipBuffer :
      this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
        this.userInputElement[0].value;

    // Ensure that the chip buffer is always a string. For example, the input element buffer might be falsy.
    return angular.isString(chipBuffer) ? chipBuffer : '';
  };

  /**
   * Resets the input buffer for either the internal input or user provided input element.
   */
  MdChipsCtrl.prototype.resetChipBuffer = function() {
    if (this.userInputElement) {
      if (this.userInputNgModelCtrl) {
        this.userInputNgModelCtrl.$setViewValue('');
        this.userInputNgModelCtrl.$render();
      } else {
        this.userInputElement[0].value = '';
      }
    } else {
      this.chipBuffer = '';
    }
  };

  MdChipsCtrl.prototype.hasMaxChipsReached = function() {
    if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;

    return this.maxChips > 0 && this.items.length >= this.maxChips;
  };

  /**
   * Updates the validity properties for the ngModel.
   */
  MdChipsCtrl.prototype.validateModel = function() {
    this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
  };

  /**
   * Removes the chip at the given index.
   * @param index
   */
  MdChipsCtrl.prototype.removeChip = function(index) {
    var removed = this.items.splice(index, 1);

    // Update model validation
    this.ngModelCtrl.$setDirty();
    this.validateModel();

    if (removed && removed.length && this.useOnRemove && this.onRemove) {
      this.onRemove({ '$chip': removed[0], '$index': index });
    }
  };

  MdChipsCtrl.prototype.removeChipAndFocusInput = function (index) {
    this.removeChip(index);

    if (this.autocompleteCtrl) {
      // Always hide the autocomplete dropdown before focusing the autocomplete input.
      // Wait for the input to move horizontally, because the chip was removed.
      // This can lead to an incorrect dropdown position.
      this.autocompleteCtrl.hidden = true;
      this.$mdUtil.nextTick(this.onFocus.bind(this));
    } else {
      this.onFocus();
    }

  };
  /**
   * Selects the chip at `index`,
   * @param index
   */
  MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
    if (!this.items.length) {
      this.selectChip(-1);
      this.onFocus();
      return;
    }
    if (index === this.items.length) return this.onFocus();
    index = Math.max(index, 0);
    index = Math.min(index, this.items.length - 1);
    this.selectChip(index);
    this.focusChip(index);
  };

  /**
   * Marks the chip at the given index as selected.
   * @param index
   */
  MdChipsCtrl.prototype.selectChip = function(index) {
    if (index >= -1 && index <= this.items.length) {
      this.selectedChip = index;

      // Fire the onSelect if provided
      if (this.useOnSelect && this.onSelect) {
        this.onSelect({'$chip': this.items[this.selectedChip] });
      }
    } else {
      this.$log.warn('Selected Chip index out of bounds; ignoring.');
    }
  };

  /**
   * Selects the chip at `index` and gives it focus.
   * @param index
   */
  MdChipsCtrl.prototype.selectAndFocusChip = function(index) {
    this.selectChip(index);
    if (index != -1) {
      this.focusChip(index);
    }
  };

  /**
   * Call `focus()` on the chip at `index`
   */
  MdChipsCtrl.prototype.focusChip = function(index) {
    this.$element[0].querySelector('md-chip[index="' + index + '"] .md-chip-content').focus();
  };

  /**
   * Configures the required interactions with the ngModel Controller.
   * Specifically, set {@code this.items} to the {@code NgModelCtrl#$viewVale}.
   * @param ngModelCtrl
   */
  MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
    this.ngModelCtrl = ngModelCtrl;

    var self = this;
    ngModelCtrl.$render = function() {
      // model is updated. do something.
      self.items = self.ngModelCtrl.$viewValue;
    };
  };

  MdChipsCtrl.prototype.onFocus = function () {
    var input = this.$element[0].querySelector('input');
    input && input.focus();
    this.resetSelectedChip();
  };

  MdChipsCtrl.prototype.onInputFocus = function () {
    this.inputHasFocus = true;
    this.resetSelectedChip();
  };

  MdChipsCtrl.prototype.onInputBlur = function () {
    this.inputHasFocus = false;

    var chipBuffer = this.getChipBuffer().trim();

    // Update the custom chip validators.
    this.validateModel();

    var isModelValid = this.ngModelCtrl.$valid;

    if (this.userInputNgModelCtrl) {
      isModelValid &= this.userInputNgModelCtrl.$valid;
    }

    // Only append the chip and reset the chip buffer if the chips and input ngModel is valid.
    if (this.addOnBlur && chipBuffer && isModelValid) {
      this.appendChip(chipBuffer);
      this.resetChipBuffer();
    }
  };

  /**
   * Configure event bindings on a user-provided input element.
   * @param inputElement
   */
  MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
    this.userInputElement = inputElement;

    // Find the NgModelCtrl for the input element
    var ngModelCtrl = inputElement.controller('ngModel');
    // `.controller` will look in the parent as well.
    if (ngModelCtrl != this.ngModelCtrl) {
      this.userInputNgModelCtrl = ngModelCtrl;
    }

    var scope = this.$scope;
    var ctrl = this;

    // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
    var scopeApplyFn = function(event, fn) {
      scope.$evalAsync(angular.bind(ctrl, fn, event));
    };

    // Bind to keydown and focus events of input
    inputElement
      .attr({ tabindex: 0 })
      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown) })
      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus) })
      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur) })
  };

  MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
    if (ctrl) {
      this.autocompleteCtrl = ctrl;

      ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
        if (item) {
          // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
          if (this.hasMaxChipsReached()) return;

          this.appendChip(item);
          this.resetChipBuffer();
        }
      }));

      this.$element.find('input')
        .on('focus',angular.bind(this, this.onInputFocus) )
        .on('blur', angular.bind(this, this.onInputBlur) );
    }
  };

  MdChipsCtrl.prototype.hasFocus = function () {
    return this.inputHasFocus || this.selectedChip >= 0;
  };


  angular.module('eHRD.kernel.uiElements.cusMaterial')
    .directive('cusMdChips', cusMdChips);
})();

// /**
//  * Created by Bruce on 2016/12/19.
//  */
// (function () {
//   'use strict';
//   // This hint text is hidden within a chip but used by screen readers to
//   // inform the user how they can interact with a chip.
//   var DELETE_HINT_TEMPLATE = '\
//     <span ng-if="!$mdChipsCtrl.readonly" class="md-visually-hidden">\
//       {{$mdChipsCtrl.deleteHint}}\
//     </span>';
//
//   cusMdChip.$inject = ["$mdTheming", "$mdUtil"];
//   function cusMdChip($mdTheming, $mdUtil) {
//     var hintTemplate = $mdUtil.processTemplate(DELETE_HINT_TEMPLATE);
//
//     return {
//       restrict: 'E',
//       require: ['^?cusMdChips', 'cusMdChip'],
//       compile:  compile,
//       controller: 'MdChipCtrl'
//     };
//
//     function compile(element/*, attr*/) {
//       // Append the delete template
//       element.append($mdUtil.processTemplate(hintTemplate));
//
//       return function postLink(scope, element, attr, ctrls) {
//         var chipsController = ctrls.shift();
//         var chipController  = ctrls.shift();
//         $mdTheming(element);
//
//         if (chipsController) {
//           chipController.init(chipsController);
//
//           angular
//             .element(element[0]
//               .querySelector('.md-chip-content'))
//             .on('blur', function () {
//               chipsController.resetSelectedChip();
//               chipsController.$scope.$applyAsync();
//             });
//         }
//       };
//     }
//   }
//
//   MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];
//   function MdChipCtrl($scope, $element, $mdConstant, $timeout, $mdUtil) {
//     /**
//      * @type {$scope}
//      */
//     this.$scope = $scope;
//
//     /**
//      * @type {$element}
//      */
//     this.$element = $element;
//
//     /**
//      * @type {$mdConstant}
//      */
//     this.$mdConstant = $mdConstant;
//
//     /**
//      * @type {$timeout}
//      */
//     this.$timeout = $timeout;
//
//     /**
//      * @type {$mdUtil}
//      */
//     this.$mdUtil = $mdUtil;
//
//     /**
//      * @type {boolean}
//      */
//     this.isEditting = false;
//
//     /**
//      * @type {MdChipsCtrl}
//      */
//     this.parentController = undefined;
//
//     /**
//      * @type {boolean}
//      */
//     this.enableChipEdit = false;
//   }
//
//
//
//
//   /**
//    * @param {MdChipsCtrl} controller
//    */
//   MdChipCtrl.prototype.init = function(controller) {
//     this.parentController = controller;
//     this.enableChipEdit = this.parentController.enableChipEdit;
//
//     if (this.enableChipEdit) {
//       this.$element.on('keydown', this.chipKeyDown.bind(this));
//       this.$element.on('mousedown', this.chipMouseDown.bind(this));
//       this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
//     }
//   };
//
//
//   /**
//    * @return {Object}
//    */
//   MdChipCtrl.prototype.getChipContent = function() {
//     var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
//     return angular.element(chipContents[0]);
//   };
//
//
//   /**
//    * @return {Object}
//    */
//   MdChipCtrl.prototype.getContentElement = function() {
//     return angular.element(this.getChipContent().children()[0]);
//   };
//
//
//   /**
//    * @return {number}
//    */
//   MdChipCtrl.prototype.getChipIndex = function() {
//     return parseInt(this.$element.attr('index'));
//   };
//
//
//   /**
//    * Presents an input element to edit the contents of the chip.
//    */
//   MdChipCtrl.prototype.goOutOfEditMode = function() {
//     if (!this.isEditting) return;
//
//     this.isEditting = false;
//     this.$element.removeClass('_md-chip-editing');
//     this.getChipContent()[0].contentEditable = 'false';
//     var chipIndex = this.getChipIndex();
//
//     var content = this.getContentElement().text();
//     if (content) {
//       this.parentController.updateChipContents(
//         chipIndex,
//         this.getContentElement().text()
//       );
//
//       this.$mdUtil.nextTick(function() {
//         if (this.parentController.selectedChip === chipIndex) {
//           this.parentController.focusChip(chipIndex);
//         }
//       }.bind(this));
//     } else {
//       this.parentController.removeChipAndFocusInput(chipIndex);
//     }
//   };
//
//
//   /**
//    * Given an HTML element. Selects contents of it.
//    * @param node
//    */
//   MdChipCtrl.prototype.selectNodeContents = function(node) {
//     var range, selection;
//     if (document.body.createTextRange) {
//       range = document.body.createTextRange();
//       range.moveToElementText(node);
//       range.select();
//     } else if (window.getSelection) {
//       selection = window.getSelection();
//       range = document.createRange();
//       range.selectNodeContents(node);
//       selection.removeAllRanges();
//       selection.addRange(range);
//     }
//   };
//
//
//   /**
//    * Presents an input element to edit the contents of the chip.
//    */
//   MdChipCtrl.prototype.goInEditMode = function() {
//     this.isEditting = true;
//     this.$element.addClass('_md-chip-editing');
//     this.getChipContent()[0].contentEditable = 'true';
//     this.getChipContent().on('blur', function() {
//       this.goOutOfEditMode();
//     }.bind(this));
//
//     this.selectNodeContents(this.getChipContent()[0]);
//   };
//
//
//   /**
//    * Handles the keydown event on the chip element. If enable-chip-edit attribute is
//    * set to true, space or enter keys can trigger going into edit mode. Enter can also
//    * trigger submitting if the chip is already being edited.
//    * @param event
//    */
//   MdChipCtrl.prototype.chipKeyDown = function(event) {
//     if (!this.isEditting &&
//       (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
//       event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
//       event.preventDefault();
//       this.goInEditMode();
//     } else if (this.isEditting &&
//       event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
//       event.preventDefault();
//       this.goOutOfEditMode();
//     }
//   };
//
//
//   /**
//    * Handles the double click event
//    */
//   MdChipCtrl.prototype.chipMouseDown = function() {
//     if(this.getChipIndex() == this.parentController.selectedChip &&
//       this.enableChipEdit &&
//       !this.isEditting) {
//       this.goInEditMode();
//     }
//   };
//
//   angular.module('eHRD.kernel.uiElements.cusMaterial')
//     .directive('cusMdChip', cusMdChip);
// })();

/**
 * Created by Bruce on 2017/3/1.
 */
(function() {
  'use strict';
  /*!
   * Angular Material Design
   * https://github.com/angular/material
   * @license MIT
   * v1.1.3-master-0619e30
   */
  /**
   * @ngdoc directive
   * @name mdCalendar
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Should be a Date object.
   * @param {Date=} md-min-date Expression representing the minimum date.
   * @param {Date=} md-max-date Expression representing the maximum date.
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
   *
   * @description
   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
   * It is a part of the `<md-datepicker` pane, however it can also be used on it's own.
   *
   * @usage
   *
   * <hljs lang="html">
   *   <md-calendar ng-model="birthday"></md-calendar>
   * </hljs>
   */
  angular.module('material.components.datepicker')
    .directive('cusMdCalendar', calendarDirective);

  // POST RELEASE
  // TODO(jelbourn): Mac Cmd + left / right == Home / End
  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
  // TODO(jelbourn): Scroll snapping (virtual repeat)
  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
  // TODO(jelbourn): Month headers stick to top when scrolling.
  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
  //     announcement and key handling).
  // Read-only calendar (not just date-picker).

  function calendarDirective() {
    return {
      template: function(tElement, tAttr) {
        // TODO(crisbeto): This is a workaround that allows the calendar to work, without
        // a datepicker, until issue #8585 gets resolved. It can safely be removed
        // afterwards. This ensures that the virtual repeater scrolls to the proper place on load by
        // deferring the execution until the next digest. It's necessary only if the calendar is used
        // without a datepicker, otherwise it's already wrapped in an ngIf.
        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
        var template = '' +
          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
          '<cus-md-calendar-year ng-switch-when="year"></cus-md-calendar-year>' +
          '<cus-md-calendar-month ng-switch-default></cus-md-calendar-month>' +
          '</div>';

        return template;
      },
      scope: {
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        dateFilter: '=mdDateFilter',
        _currentView: '@mdCurrentView'
      },
      require: ['ngModel', 'cusMdCalendar'],
      controller: CalendarCtrl,
      controllerAs: 'calendarCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var mdCalendarCtrl = controllers[1];
        mdCalendarCtrl.configureNgModel(ngModelCtrl);
      }
    };
  }

  /**
   * Occasionally the hideVerticalScrollbar method might read an element's
   * width as 0, because it hasn't been laid out yet. This value will be used
   * as a fallback, in order to prevent scenarios where the element's width
   * would otherwise have been set to 0. This value is the "usual" width of a
   * calendar within a floating calendar pane.
   */
  var FALLBACK_WIDTH = 340;

  /** Next identifier for calendar instance. */
  var nextUniqueId = 0;

  /**
   * Controller for the mdCalendar component.
   * @ngInject @constructor
   */
  CalendarCtrl.$inject = ["$document", "$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale"];
  function CalendarCtrl($document, $element, $scope, $$mdDateUtil, $mdUtil,
                        $mdConstant, $mdTheming, $$rAF, $attrs, $mdDateLocale) {

    $mdTheming($element);

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.JQLite} */
    this.$document = $document;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.keyCode = $mdConstant.KEY_CODE;

    /** @final */
    this.$$rAF = $$rAF;

    /** @final */
    this.$mdDateLocale = $mdDateLocale;

    /** @final {Date} */
    this.today = this.dateUtil.createDateAtMidnight();

    /** @type {!angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {String} Class applied to the selected date cell. */
    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';

    /** @type {String} Class applied to the cell for today. */
    this.TODAY_CLASS = 'md-calendar-date-today';

    /** @type {String} Class applied to the focused cell. */
    this.FOCUSED_DATE_CLASS = 'md-focus';

    /** @final {number} Unique ID for this calendar instance. */
    this.id = nextUniqueId++;

    /**
     * The date that is currently focused or showing in the calendar. This will initially be set
     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
     * to other months. The cell corresponding to the displayDate does not necesarily always have
     * focus in the document (such as for cases when the user is scrolling the calendar).
     * @type {Date}
     */
    this.displayDate = null;

    /**
     * The selected date. Keep track of this separately from the ng-model value so that we
     * can know, when the ng-model value changes, what the previous value was before it's updated
     * in the component's UI.
     *
     * @type {Date}
     */
    this.selectedDate = null;

    /**
     * The first date that can be rendered by the calendar. The default is taken
     * from the mdDateLocale provider and is limited by the mdMinDate.
     * @type {Date}
     */
    this.firstRenderableDate = null;

    /**
     * The last date that can be rendered by the calendar. The default comes
     * from the mdDateLocale provider and is limited by the maxDate.
     * @type {Date}
     */
    this.lastRenderableDate = null;

    /**
     * Used to toggle initialize the root element in the next digest.
     * @type {Boolean}
     */
    this.isInitialized = false;

    /**
     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
     * and to avoid extra reflows when switching between views.
     * @type {Number}
     */
    this.width = 0;

    /**
     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
     * @type {Number}
     */
    this.scrollbarWidth = 0;

    // Unless the user specifies so, the calendar should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if (!$attrs.tabindex) {
      $element.attr('tabindex', '-1');
    }

    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);



    // If use the md-calendar directly in the body without datepicker,
    // handleKeyEvent will disable other inputs on the page.
    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
    // otherwise apply on the calendar element only.

    var handleKeyElement;
    if ($element.parent().hasClass('md-datepicker-calendar')) {
      handleKeyElement = angular.element(this.$document[0].body);
    } else {
      handleKeyElement = $element;
    }

    // Bind the keydown handler to the body, in order to handle cases where the focused
    // element gets removed from the DOM and stops propagating click events.
    handleKeyElement.on('keydown', boundKeyHandler);

    $scope.$on('$destroy', function() {
      handleKeyElement.off('keydown', boundKeyHandler);
    });

    // For Angular 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }

  }

  /**
   * Angular Lifecycle hook for newer Angular versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
   */
  CalendarCtrl.prototype.$onInit = function() {

    /**
     * The currently visible calendar view. Note the prefix on the scope value,
     * which is necessary, because the datepicker seems to reset the real one value if the
     * calendar is open, but the value on the datepicker's scope is empty.
     * @type {String}
     */
    this.currentView = this._currentView || 'month';

    var dateLocale = this.$mdDateLocale;

    if (this.minDate && this.minDate > dateLocale.firstRenderableDate) {
      this.firstRenderableDate = new Date(moment(this.minDate).year(), moment(this.minDate).month(), 0);
    } else {
      this.firstRenderableDate = dateLocale.firstRenderableDate;
    }

    if (this.maxDate && this.maxDate < dateLocale.lastRenderableDate) {
      this.lastRenderableDate = this.maxDate;
    } else {
      this.lastRenderableDate = dateLocale.lastRenderableDate;
    }
  };

  /**
   * Sets up the controller's reference to ngModelController.
   * @param {!angular.NgModelController} ngModelCtrl
   */
  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl) {
    var self = this;

    self.ngModelCtrl = ngModelCtrl;

    self.$mdUtil.nextTick(function() {
      self.isInitialized = true;
    });

    ngModelCtrl.$render = function() {
      var value = this.$viewValue;

      // Notify the child scopes of any changes.
      self.$scope.$broadcast('md-calendar-parent-changed', value);

      // Set up the selectedDate if it hasn't been already.
      if (!self.selectedDate) {
        self.selectedDate = value;
      }

      // Also set up the displayDate.
      if (!self.displayDate) {
        self.displayDate = self.selectedDate || self.today;
      }
    };
  };

  /**
   * Sets the ng-model value for the calendar and emits a change event.
   * @param {Date} date
   */
  CalendarCtrl.prototype.setNgModelValue = function(date) {
    var value = this.dateUtil.createDateAtMidnight(date);
    this.focus(value);
    this.$scope.$emit('md-calendar-change', value);
    this.ngModelCtrl.$setViewValue(value);
    this.ngModelCtrl.$render();
    return value;
  };

  /**
   * Sets the current view that should be visible in the calendar
   * @param {string} newView View name to be set.
   * @param {number|Date} time Date object or a timestamp for the new display date.
   */
  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
    var self = this;

    self.$mdUtil.nextTick(function() {
      self.currentView = newView;

      if (time) {
        self.displayDate = angular.isDate(time) ? time : new Date(time);
      }
    });
  };

  /**
   * Focus the cell corresponding to the given date.
   * @param {Date} date The date to be focused.
   */
  CalendarCtrl.prototype.focus = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var previousFocus = this.$element[0].querySelector('.md-focus');
      if (previousFocus) {
        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
      }

      var cellId = this.getDateId(date, this.currentView);
      var cell = this.$document[0].getElementById(cellId);
      if (cell) {
        cell.classList.add(this.FOCUSED_DATE_CLASS);
        cell.focus();
        this.displayDate = date;
      }
    } else {
      var rootElement = this.$element[0].querySelector('[ng-switch]');

      if (rootElement) {
        rootElement.focus();
      }
    }
  };

  /**
   * Normalizes the key event into an action name. The action will be broadcast
   * to the child controllers.
   * @param {KeyboardEvent} event
   * @returns {String} The action that should be taken, or null if the key
   * does not match a calendar shortcut.
   */
  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
    var keyCode = this.keyCode;

    switch (event.which) {
      case keyCode.ENTER: return 'select';

      case keyCode.RIGHT_ARROW: return 'move-right';
      case keyCode.LEFT_ARROW: return 'move-left';

      // TODO(crisbeto): Might want to reconsider using metaKey, because it maps
      // to the "Windows" key on PC, which opens the start menu or resizes the browser.
      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';

      case keyCode.PAGE_DOWN: return 'move-page-down';
      case keyCode.PAGE_UP: return 'move-page-up';

      case keyCode.HOME: return 'start';
      case keyCode.END: return 'end';

      default: return null;
    }
  };

  /**
   * Handles a key event in the calendar with the appropriate action. The action will either
   * be to select the focused date or to navigate to focus a new date.
   * @param {KeyboardEvent} event
   */
  CalendarCtrl.prototype.handleKeyEvent = function(event) {
    var self = this;

    this.$scope.$apply(function() {
      // Capture escape and emit back up so that a wrapping component
      // (such as a date-picker) can decide to close.
      if (event.which == self.keyCode.ESCAPE || event.which == self.keyCode.TAB) {
        self.$scope.$emit('md-calendar-close');

        if (event.which == self.keyCode.TAB) {
          event.preventDefault();
        }

        return;
      }

      // Broadcast the action that any child controllers should take.
      var action = self.getActionFromKeyEvent(event);
      if (action) {
        event.preventDefault();
        event.stopPropagation();
        self.$scope.$broadcast('md-calendar-parent-action', action);
      }
    });
  };

  /**
   * Hides the vertical scrollbar on the calendar scroller of a child controller by
   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
   * around the scroller, and then setting a padding-right on the scroller equal
   * to the width of the browser's scrollbar.
   *
   * This will cause a reflow.
   *
   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
   */
  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
    var self = this;
    var element = childCtrl.$element[0];
    var scrollMask = element.querySelector('.md-calendar-scroll-mask');

    if (self.width > 0) {
      setWidth();
    } else {
      self.$$rAF(function() {
        var scroller = childCtrl.calendarScroller;

        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
        self.width = element.querySelector('table').offsetWidth;
        setWidth();
      });
    }

    function setWidth() {
      var width = self.width || FALLBACK_WIDTH;
      var scrollbarWidth = self.scrollbarWidth;
      var scroller = childCtrl.calendarScroller;

      scrollMask.style.width = width + 'px';
      scroller.style.width = (width + scrollbarWidth) + 'px';
      scroller.style.paddingRight = scrollbarWidth + 'px';
    }
  };

  /**
   * Gets an identifier for a date unique to the calendar instance for internal
   * purposes. Not to be displayed.
   * @param {Date} date The date for which the id is being generated
   * @param {string} namespace Namespace for the id. (month, year etc.)
   * @returns {string}
   */
  CalendarCtrl.prototype.getDateId = function(date, namespace) {
    if (!namespace) {
      throw new Error('A namespace for the date id has to be specified.');
    }

    return [
      'md',
      this.id,
      namespace,
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    ].join('-');
  };

  /**
   * Util to trigger an extra digest on a parent scope, in order to to ensure that
   * any child virtual repeaters have updated. This is necessary, because the virtual
   * repeater doesn't update the $index the first time around since the content isn't
   * in place yet. The case, in which this is an issue, is when the repeater has less
   * than a page of content (e.g. a month or year view has a min or max date).
   */
  CalendarCtrl.prototype.updateVirtualRepeat = function() {
    var scope = this.$scope;
    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
      if (!scope.$$phase) {
        scope.$apply();
      }

      virtualRepeatResizeListener();
    });
  };
})();

/**
 * Created by Bruce on 2017/3/1.
 */
(function() {
  'use strict';

  angular.module('material.components.datepicker')
    .directive('cusMdCalendarYear', calendarDirective);

  /**
   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
   * subsequently used for scrolling to specific years.
   */
  var TBODY_HEIGHT = 88;

  /** Private component, representing a list of years in the calendar. */
  function calendarDirective() {
    return {
      template:
      '<div class="md-calendar-scroll-mask">' +
      '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
      '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
      '<tbody ' +
      'cus-md-calendar-year-body ' +
      'role="rowgroup" ' +
      'md-virtual-repeat="i in yearCtrl.items" ' +
      'md-year-offset="$index" class="md-calendar-year" ' +
      'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
      'md-item-size="' + TBODY_HEIGHT + '">' +
      // The <tr> ensures that the <tbody> will have the proper
      // height, even though it may be empty.
      '<tr aria-hidden="true" style="height:' + TBODY_HEIGHT + 'px;"></tr>' +
      '</tbody>' +
      '</table>' +
      '</md-virtual-repeat-container>' +
      '</div>',
      require: ['^^cusMdCalendar', 'cusMdCalendarYear'],
      controller: CalendarYearCtrl,
      controllerAs: 'yearCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var yearCtrl = controllers[1];
        yearCtrl.initialize(calendarCtrl);
      }
    };
  }

  /**
   * Controller for the mdCalendar component.
   * @ngInject @constructor
   */
  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil"];
  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil) {

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final {!angular.$animate} */
    this.$animate = $animate;

    /** @final {!angular.$q} */
    this.$q = $q;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final {HTMLElement} */
    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');

    /** @type {boolean} */
    this.isInitialized = false;

    /** @type {boolean} */
    this.isMonthTransitionInProgress = false;

    var self = this;

    /**
     * Handles a click event on a date cell.
     * Created here so that every cell can use the same function instance.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.cellClickHandler = function() {
      self.calendarCtrl.setCurrentView('month', $$mdDateUtil.getTimestampFromNode(this));
    };
  }

  /**
   * Initialize the controller by saving a reference to the calendar and
   * setting up the object that will be iterated by the virtual repeater.
   */
  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
    /**
     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
     * number of years that can be viewed. We add 1 extra in order to include the current year.
     */
    this.items = {
      length: this.dateUtil.getYearDistance(
        calendarCtrl.firstRenderableDate,
        calendarCtrl.lastRenderableDate
      ) + 1
    };

    this.calendarCtrl = calendarCtrl;
    this.attachScopeListeners();
    calendarCtrl.updateVirtualRepeat();

    // Fire the initial render, since we might have missed it the first time it fired.
    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
  };

  /**
   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
   * @returns {number}
   */
  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
    var calendarCtrl = this.calendarCtrl;

    return this.dateUtil.getYearDistance(
      calendarCtrl.firstRenderableDate,
      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
    );
  };

  /**
   * Change the date that is highlighted in the calendar.
   * @param {Date} date
   */
  CalendarYearCtrl.prototype.changeDate = function(date) {
    // Initialization is deferred until this function is called because we want to reflect
    // the starting value of ngModel.
    if (!this.isInitialized) {
      this.calendarCtrl.hideVerticalScrollbar(this);
      this.isInitialized = true;
      return this.$q.when();
    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
      var self = this;
      var animationPromise = this.animateDateChange(date);

      self.isMonthTransitionInProgress = true;
      self.calendarCtrl.displayDate = date;

      return animationPromise.then(function() {
        self.isMonthTransitionInProgress = false;
      });
    }
  };

  /**
   * Animates the transition from the calendar's current month to the given month.
   * @param {Date} date
   * @returns {angular.$q.Promise} The animation promise.
   */
  CalendarYearCtrl.prototype.animateDateChange = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
    }

    return this.$q.when();
  };

  /**
   * Handles the year-view-specific keyboard interactions.
   * @param {Object} event Scope event object passed by the calendar.
   * @param {String} action Action, corresponding to the key that was pressed.
   */
  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
    var calendarCtrl = this.calendarCtrl;
    var displayDate = calendarCtrl.displayDate;

    if (action === 'select') {
      this.changeDate(displayDate).then(function() {
        calendarCtrl.setCurrentView('month', displayDate);
        calendarCtrl.focus(displayDate);
      });
    } else {
      var date = null;
      var dateUtil = this.dateUtil;

      switch (action) {
        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;

        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
      }

      if (date) {
        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
        date = dateUtil.getFirstDateOfMonth(this.dateUtil.clampDate(date, min, max));

        this.changeDate(date).then(function() {
          calendarCtrl.focus(date);
        });
      }
    }
  };

  /**
   * Attaches listeners for the scope events that are broadcast by the calendar.
   */
  CalendarYearCtrl.prototype.attachScopeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
      self.changeDate(value);
    });

    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
  };
})();

/**
 * Created by Bruce on 2017/3/1.
 */
(function() {
  'use strict';

  angular.module('material.components.datepicker')
    .directive('cusMdCalendarYearBody', mdCalendarYearDirective);

  /**
   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
   * and allows for the year view to use md-virtual-repeat.
   */
  function mdCalendarYearDirective() {
    return {
      require: ['^^cusMdCalendar', '^^cusMdCalendarYear', 'cusMdCalendarYearBody'],
      scope: { offset: '=mdYearOffset' },
      controller: CalendarYearBodyCtrl,
      controllerAs: 'mdYearBodyCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var yearCtrl = controllers[1];
        var yearBodyCtrl = controllers[2];

        yearBodyCtrl.calendarCtrl = calendarCtrl;
        yearBodyCtrl.yearCtrl = yearCtrl;

        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
          if (angular.isNumber(offset)) {
            yearBodyCtrl.generateContent();
          }
        });
      }
    };
  }

  /**
   * Controller for a single year.
   * @ngInject @constructor
   */
  CalendarYearBodyCtrl.$inject = ["$document", "$element", "$$mdDateUtil", "$mdDateLocale"];
  function CalendarYearBodyCtrl($document, $element, $$mdDateUtil, $mdDateLocale) {
    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.JQLite} */
    this.$document = $document;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @type {Object} Reference to the calendar. */
    this.calendarCtrl = null;

    /** @type {Object} Reference to the year view. */
    this.yearCtrl = null;

    /**
     * Number of months from the start of the month "items" that the currently rendered month
     * occurs. Set via angular data binding.
     * @type {number}
     */
    this.offset = null;

    /**
     * Date cell to focus after appending the month to the document.
     * @type {HTMLElement}
     */
    this.focusAfterAppend = null;
  }

  /** Generate and append the content for this year to the directive element. */
  CalendarYearBodyCtrl.prototype.generateContent = function() {
    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);

    this.$element
      .empty()
      .append(this.buildCalendarForYear(date));

    if (this.focusAfterAppend) {
      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
      this.focusAfterAppend.focus();
      this.focusAfterAppend = null;
    }
  };

  /**
   * Creates a single cell to contain a year in the calendar.
   * @param {number} opt_year Four-digit year.
   * @param {number} opt_month Zero-indexed month.
   * @returns {HTMLElement}
   */
  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
    var calendarCtrl = this.calendarCtrl;
    var yearCtrl = this.yearCtrl;
    var cell = this.buildBlankCell();

    // Represent this month/year as a date.
    var firstOfMonth = new Date(year, month, 1);
    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');

    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
    cell.setAttribute('data-timestamp', firstOfMonth.getTime());

    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
      cell.classList.add(calendarCtrl.TODAY_CLASS);
    }

    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
      this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
      cell.setAttribute('aria-selected', 'true');
    }

    var cellText = this.dateLocale.shortMonths[month];

    if (this.dateUtil.isMonthWithinRange(firstOfMonth,
        calendarCtrl.minDate, calendarCtrl.maxDate)) {
      var selectionIndicator = this.$document[0].createElement('span');
      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
      selectionIndicator.textContent = cellText;
      cell.appendChild(selectionIndicator);
      cell.addEventListener('click', yearCtrl.cellClickHandler);

      if (calendarCtrl.displayDate && this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
        this.focusAfterAppend = cell;
      }
    } else {
      cell.classList.add('md-calendar-date-disabled');
      cell.textContent = cellText;
    }

    return cell;
  };

  /**
   * Builds a blank cell.
   * @return {HTMLTableCellElement}
   */
  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
    var cell = this.$document[0].createElement('td');
    cell.tabIndex = -1;
    cell.classList.add('md-calendar-date');
    cell.setAttribute('role', 'gridcell');

    cell.setAttribute('tabindex', '-1');
    return cell;
  };

  /**
   * Builds the <tbody> content for the given year.
   * @param {Date} date Date for which the content should be built.
   * @returns {DocumentFragment} A document fragment containing the months within the year.
   */
  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
    // Store rows for the month in a document fragment so that we can append them all at once.
    var year = date.getFullYear();
    var yearBody = this.$document[0].createDocumentFragment();

    var /*monthCell,*/ i;
    // First row contains label and Jan-Jun.
    var firstRow = this.$document[0].createElement('tr');
    var labelCell = this.$document[0].createElement('td');
    labelCell.className = 'md-calendar-month-label';
    labelCell.textContent = year;
    firstRow.appendChild(labelCell);

    for (i = 0; i < 6; i++) {
      firstRow.appendChild(this.buildMonthCell(year, i));
    }
    yearBody.appendChild(firstRow);

    // Second row contains a blank cell and Jul-Dec.
    var secondRow = this.$document[0].createElement('tr');
    secondRow.appendChild(this.buildBlankCell());
    for (i = 6; i < 12; i++) {
      secondRow.appendChild(this.buildMonthCell(year, i));
    }
    yearBody.appendChild(secondRow);

    return yearBody;
  };
})();

/**
 * Created by Bruce on 2017/3/1.
 */
(function() {
  'use strict';

  angular.module('material.components.datepicker')
    .directive('cusMdCalendarMonth', calendarDirective);

  /**
   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
   * subsequently used for scrolling to specific months.
   */
  var TBODY_HEIGHT = 265;

  /**
   * Height of a calendar month with a single row. This is needed to calculate the offset for
   * rendering an extra month in virtual-repeat that only contains one row.
   */
  var TBODY_SINGLE_ROW_HEIGHT = 45;

  /** Private directive that represents a list of months inside the calendar. */
  function calendarDirective() {
    return {
      template:
      '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
      '<div class="md-calendar-scroll-mask">' +
      '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
      'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
      '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
      '<tbody ' +
      'cus-md-calendar-month-body ' +
      'role="rowgroup" ' +
      'md-virtual-repeat="i in monthCtrl.items" ' +
      'md-month-offset="$index" ' +
      'class="md-calendar-month" ' +
      'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
      'md-item-size="' + TBODY_HEIGHT + '">' +

      // The <tr> ensures that the <tbody> will always have the
      // proper height, even if it's empty. If it's content is
      // compiled, the <tr> will be overwritten.
      '<tr aria-hidden="true" style="height:' + TBODY_HEIGHT + 'px;"></tr>' +
      '</tbody>' +
      '</table>' +
      '</md-virtual-repeat-container>' +
      '</div>',
      require: ['^^cusMdCalendar', 'cusMdCalendarMonth'],
      controller: CalendarMonthCtrl,
      controllerAs: 'monthCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var monthCtrl = controllers[1];
        monthCtrl.initialize(calendarCtrl);
      }
    };
  }

  /**
   * Controller for the calendar month component.
   * @ngInject @constructor
   */
  CalendarMonthCtrl.$inject = ["$document", "$element", "$scope", "$animate", "$q",
    "$$mdDateUtil", "$mdDateLocale"];
  function CalendarMonthCtrl($document, $element, $scope, $animate, $q,
                             $$mdDateUtil, $mdDateLocale) {

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.JQLite} */
    this.$document = $document;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final {!angular.$animate} */
    this.$animate = $animate;

    /** @final {!angular.$q} */
    this.$q = $q;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @final {HTMLElement} */
    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');

    /** @type {boolean} */
    this.isInitialized = false;

    /** @type {boolean} */
    this.isMonthTransitionInProgress = false;

    var self = this;

    /**
     * Handles a click event on a date cell.
     * Created here so that every cell can use the same function instance.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.cellClickHandler = function() {
      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
      self.$scope.$apply(function() {
        self.calendarCtrl.setNgModelValue(timestamp);
      });
    };

    /**
     * Handles click events on the month headers. Switches
     * the calendar to the year view.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.headerClickHandler = function() {
      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
    };
  }

  /*** Initialization ***/

  /**
   * Initialize the controller by saving a reference to the calendar and
   * setting up the object that will be iterated by the virtual repeater.
   */
  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
    /**
     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
     * number of months that can be viewed. We add 2 months: one to include the current month
     * and one for the last dummy month.
     *
     * This is shorter than ideal because of a (potential) Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
     */

    this.items = {
      length: this.dateUtil.getMonthDistance(
        calendarCtrl.firstRenderableDate,
        calendarCtrl.lastRenderableDate
      ) + 2
    };

    this.calendarCtrl = calendarCtrl;
    this.attachScopeListeners();
    calendarCtrl.updateVirtualRepeat();

    // Fire the initial render, since we might have missed it the first time it fired.
    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
  };

  /**
   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
   * @returns {number}
   */
  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
    var calendarCtrl = this.calendarCtrl;

    return this.dateUtil.getMonthDistance(
      calendarCtrl.firstRenderableDate,
      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
    );
  };

  /**
   * Change the selected date in the calendar (ngModel value has already been changed).
   * @param {Date} date
   */
  CalendarMonthCtrl.prototype.changeSelectedDate = function(date) {
    var self = this;
    var calendarCtrl = self.calendarCtrl;
    var previousSelectedDate = calendarCtrl.selectedDate;
    calendarCtrl.selectedDate = date;

    this.changeDisplayDate(date).then(function() {
      var selectedDateClass = calendarCtrl.SELECTED_DATE_CLASS;
      var namespace = 'month';

      // Remove the selected class from the previously selected date, if any.
      if (previousSelectedDate) {
        var prevDateCell = self.$document[0].getElementById(calendarCtrl.getDateId(previousSelectedDate, namespace));
        if (prevDateCell) {
          prevDateCell.classList.remove(selectedDateClass);
          prevDateCell.setAttribute('aria-selected', 'false');
        }
      }

      // Apply the select class to the new selected date if it is set.
      if (date) {
        var dateCell = self.$document[0].getElementById(calendarCtrl.getDateId(date, namespace));
        if (dateCell) {
          dateCell.classList.add(selectedDateClass);
          dateCell.setAttribute('aria-selected', 'true');
        }
      }
    });
  };

  /**
   * Change the date that is being shown in the calendar. If the given date is in a different
   * month, the displayed month will be transitioned.
   * @param {Date} date
   */
  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
    // Initialization is deferred until this function is called because we want to reflect
    // the starting value of ngModel.
    if (!this.isInitialized) {
      this.buildWeekHeader();
      this.calendarCtrl.hideVerticalScrollbar(this);
      this.isInitialized = true;
      return this.$q.when();
    }

    // If trying to show an invalid date or a transition is in progress, do nothing.
    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
      return this.$q.when();
    }

    this.isMonthTransitionInProgress = true;
    var animationPromise = this.animateDateChange(date);

    this.calendarCtrl.displayDate = date;

    var self = this;
    animationPromise.then(function() {
      self.isMonthTransitionInProgress = false;
    });

    return animationPromise;
  };

  /**
   * Animates the transition from the calendar's current month to the given month.
   * @param {Date} date
   * @returns {angular.$q.Promise} The animation promise.
   */
  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
    }

    return this.$q.when();
  };

  /**
   * Builds and appends a day-of-the-week header to the calendar.
   * This should only need to be called once during initialization.
   */
  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
    var shortDays = this.dateLocale.shortDays;

    var row = this.$document[0].createElement('tr');
    for (var i = 0; i < 7; i++) {
      var th = this.$document[0].createElement('th');
      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
      row.appendChild(th);
    }

    this.$element.find('thead').append(row);
  };

  /**
   * Attaches listeners for the scope events that are broadcast by the calendar.
   */
  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
      self.changeSelectedDate(value);
    });

    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
  };

  /**
   * Handles the month-specific keyboard interactions.
   * @param {Object} event Scope event object passed by the calendar.
   * @param {String} action Action, corresponding to the key that was pressed.
   */
  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
    var calendarCtrl = this.calendarCtrl;
    var displayDate = calendarCtrl.displayDate;

    if (action === 'select') {
      calendarCtrl.setNgModelValue(displayDate);
    } else {
      var date = null;
      var dateUtil = this.dateUtil;

      switch (action) {
        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;

        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;

        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;

        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
      }

      if (date) {
        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);

        this.changeDisplayDate(date).then(function() {
          calendarCtrl.focus(date);
        });
      }
    }
  };
})();

/**
 * Created by Bruce on 2017/3/1.
 */
(function() {
  'use strict';

  angular.module('material.components.datepicker')
    .directive('cusMdCalendarMonthBody', mdCalendarMonthBodyDirective);

  /**
   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
   * the rest of the calendar controller logic.
   * @ngInject
   */
  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];

    return {
      require: ['^^cusMdCalendar', '^^cusMdCalendarMonth', 'cusMdCalendarMonthBody'],
      scope: { offset: '=mdMonthOffset' },
      controller: CalendarMonthBodyCtrl,
      controllerAs: 'mdMonthBodyCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var monthCtrl = controllers[1];
        var monthBodyCtrl = controllers[2];

        monthBodyCtrl.calendarCtrl = calendarCtrl;
        monthBodyCtrl.monthCtrl = monthCtrl;
        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);

        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
        // of repeated items that are linked, and then those elements have their bindings updated.
        // Since the months are not generated by bindings, we simply regenerate the entire thing
        // when the binding (offset) changes.
        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
          if (angular.isNumber(offset)) {
            monthBodyCtrl.generateContent();
          }
        });
      }
    };
  }

  /**
   * Controller for a single calendar month.
   * @ngInject @constructor
   */
  CalendarMonthBodyCtrl.$inject = ["$document", "$element", "$$mdDateUtil", "$mdDateLocale"];
  function CalendarMonthBodyCtrl($document, $element, $$mdDateUtil, $mdDateLocale) {
    /** @final {!angular.JQLite} */
    this.$document = $document;
    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @type {Object} Reference to the month view. */
    this.monthCtrl = null;

    /** @type {Object} Reference to the calendar. */
    this.calendarCtrl = null;

    /**
     * Number of months from the start of the month "items" that the currently rendered month
     * occurs. Set via angular data binding.
     * @type {number}
     */
    this.offset = null;

    /**
     * Date cell to focus after appending the month to the document.
     * @type {HTMLElement}
     */
    this.focusAfterAppend = null;
  }

  /** Generate and append the content for this month to the directive element. */
  CalendarMonthBodyCtrl.prototype.generateContent = function() {
    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);

    this.$element
      .empty()
      .append(this.buildCalendarForMonth(date));

    if (this.focusAfterAppend) {
      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
      this.focusAfterAppend.focus();
      this.focusAfterAppend = null;
    }
  };

  /**
   * Creates a single cell to contain a date in the calendar with all appropriate
   * attributes and classes added. If a date is given, the cell content will be set
   * based on the date.
   * @param {Date=} opt_date
   * @returns {HTMLElement}
   */
  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
    var monthCtrl = this.monthCtrl;
    var calendarCtrl = this.calendarCtrl;

    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
    var cell = this.$document[0].createElement('td');
    cell.tabIndex = -1;
    cell.classList.add('md-calendar-date');
    cell.setAttribute('role', 'gridcell');

    if (opt_date) {
      cell.setAttribute('tabindex', '-1');
      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
      cell.id = calendarCtrl.getDateId(opt_date, 'month');

      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
      cell.setAttribute('data-timestamp', opt_date.getTime());

      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
      // It may be better to finish the construction and then query the node and add the class.
      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
        cell.classList.add(calendarCtrl.TODAY_CLASS);
      }

      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
        this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
        cell.setAttribute('aria-selected', 'true');
      }

      var cellText = this.dateLocale.dates[opt_date.getDate()];

      if (this.isDateEnabled(opt_date)) {
        // Add a indicator for select, hover, and focus states.
        var selectionIndicator = this.$document[0].createElement('span');
        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
        selectionIndicator.textContent = cellText;
        cell.appendChild(selectionIndicator);
        cell.addEventListener('click', monthCtrl.cellClickHandler);

        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
          this.focusAfterAppend = cell;
        }
      } else {
        cell.classList.add('md-calendar-date-disabled');
        cell.textContent = cellText;
      }
    }

    return cell;
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date,
        this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
      (!angular.isFunction(this.calendarCtrl.dateFilter)
      || this.calendarCtrl.dateFilter(opt_date));
  };

  /**
   * Builds a `tr` element for the calendar grid.
   * @param rowNumber The week number within the month.
   * @returns {HTMLElement}
   */
  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
    var row = this.$document[0].createElement('tr');
    row.setAttribute('role', 'row');

    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
    // to prevent the entire row being read aloud when the user moves between rows.
    // See http://community.nvda-project.org/ticket/4643.
    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));

    return row;
  };

  /**
   * Builds the <tbody> content for the given date's month.
   * @param {Date=} opt_dateInMonth
   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
   */
  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();

    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);

    // Store rows for the month in a document fragment so that we can append them all at once.
    var monthBody = this.$document[0].createDocumentFragment();

    var rowNumber = 1;
    var row = this.buildDateRow(rowNumber);
    monthBody.appendChild(row);

    // If this is the final month in the list of items, only the first week should render,
    // so we should return immediately after the first row is complete and has been
    // attached to the body.
    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;

    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
    // goes on a row above the first of the month. Otherwise, the month label takes up the first
    // two cells of the first row.
    var blankCellOffset = 0;
    var monthLabelCell = this.$document[0].createElement('td');
    var monthLabelCellContent = this.$document[0].createElement('span');

    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
    monthLabelCell.appendChild(monthLabelCellContent);
    monthLabelCell.classList.add('md-calendar-month-label');
    // If the entire month is after the max date, render the label as a disabled state.
    if (this.calendarCtrl.maxDate && firstDayOfMonth > this.calendarCtrl.maxDate) {
      monthLabelCell.classList.add('md-calendar-month-label-disabled');
    } else {
      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
    }

    if (firstDayOfTheWeek <= 2) {
      monthLabelCell.setAttribute('colspan', '7');

      var monthLabelRow = this.buildDateRow();
      monthLabelRow.appendChild(monthLabelCell);
      monthBody.insertBefore(monthLabelRow, row);

      if (isFinalMonth) {
        return monthBody;
      }
    } else {
      blankCellOffset = 3;
      monthLabelCell.setAttribute('colspan', '3');
      row.appendChild(monthLabelCell);
    }

    // Add a blank cell for each day of the week that occurs before the first of the month.
    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
      row.appendChild(this.buildDateCell());
    }

    // Add a cell for each day of the month, keeping track of the day of the week so that
    // we know when to start a new row.
    var dayOfWeek = firstDayOfTheWeek;
    var iterationDate = firstDayOfMonth;
    for (var d = 1; d <= numberOfDaysInMonth; d++) {
      // If we've reached the end of the week, start a new row.
      if (dayOfWeek === 7) {
        // We've finished the first row, so we're done if this is the final month.
        if (isFinalMonth) {
          return monthBody;
        }
        dayOfWeek = 0;
        rowNumber++;
        row = this.buildDateRow(rowNumber);
        monthBody.appendChild(row);
      }

      iterationDate.setDate(d);
      var cell = this.buildDateCell(iterationDate);
      row.appendChild(cell);

      dayOfWeek++;
    }

    // Ensure that the last row of the month has 7 cells.
    while (row.childNodes.length < 7) {
      row.appendChild(this.buildDateCell());
    }

    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
    // requires that all items have exactly the same height.
    while (monthBody.childNodes.length < 6) {
      var whitespaceRow = this.buildDateRow();
      for (var j = 0; j < 7; j++) {
        whitespaceRow.appendChild(this.buildDateCell());
      }
      monthBody.appendChild(whitespaceRow);
    }

    return monthBody;
  };

  /**
   * Gets the day-of-the-week index for a date for the current locale.
   * @private
   * @param {Date} date
   * @returns {number} The column index of the date in the calendar.
   */
  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
  };
})();

/**
 * Created by Bruce on 2016/12/20.
 */
(function () {
  'use strict';

  cusMdAutocomplete.$inject = ['$$mdSvgRegistry'];
  function cusMdAutocomplete($$mdSvgRegistry) {
    return {
      controller:   MdAutocompleteCtrl,
      controllerAs: '$mdAutocompleteCtrl',
      scope:        {
        inputName:        '@mdInputName',
        inputMinlength:   '@mdInputMinlength',
        inputMaxlength:   '@mdInputMaxlength',
        searchText:       '=?mdSearchText',
        selectedItem:     '=?mdSelectedItem',
        itemsExpr:        '@mdItems',
        itemText:         '&mdItemText',
        placeholder:      '@placeholder',
        noCache:          '=?mdNoCache',
        requireMatch:     '=?mdRequireMatch',
        selectOnMatch:    '=?mdSelectOnMatch',
        matchInsensitive: '=?mdMatchCaseInsensitive',
        itemChange:       '&?mdSelectedItemChange',
        textChange:       '&?mdSearchTextChange',
        minLength:        '=?mdMinLength',
        delay:            '=?mdDelay',
        autofocus:        '=?mdAutofocus',
        floatingLabel:    '@?mdFloatingLabel',
        autoselect:       '=?mdAutoselect',
        menuClass:        '@?mdMenuClass',
        inputId:          '@?mdInputId',
        escapeOptions:    '@?mdEscapeOptions',
        dropdownItems:    '=?mdDropdownItems',
        dropdownPosition: '@?mdDropdownPosition',
        clearButton:      '=?mdClearButton'
      },
      compile: function(tElement, tAttrs) {
        var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
        var input = tElement.find('input');

        attributes.forEach(function(attribute) {
          var attrValue = tAttrs[tAttrs.$normalize(attribute)];

          if (attrValue !== null) {
            input.attr(attribute, attrValue);
          }
        });

        return function(scope, element, attrs, ctrl) {
          // Retrieve the state of using a md-not-found template by using our attribute, which will
          // be added to the element in the template function.
          ctrl.hasNotFound = !!element.attr('md-has-not-found');

          // By default the inset autocomplete should show the clear button when not explicitly overwritten.
          if (angular.isUndefined(attrs.mdClearButton) && !scope.floatingLabel) {
            scope.clearButton = true;
          }
        }
      },
      template:     function (element, attr) {
        var noItemsTemplate = getNoItemsTemplate(),
          itemTemplate    = getItemTemplate(),
          leftover        = element.html(),
          tabindex        = attr.tabindex;

        // Set our attribute for the link function above which runs later.
        // We will set an attribute, because otherwise the stored variables will be trashed when
        // removing the element is hidden while retrieving the template. For example when using ngIf.
        if (noItemsTemplate) element.attr('md-has-not-found', true);

        // Always set our tabindex of the autocomplete directive to -1, because our input
        // will hold the actual tabindex.
        element.attr('tabindex', '-1');

        return '\
        <md-autocomplete-wrap\
            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
                        \'md-show-clear-button\': !!clearButton }">\
          ' + getInputElement() + '\
          ' + getClearButton() + '\
          <md-progress-linear\
              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
              md-mode="indeterminate"></md-progress-linear>\
          <md-virtual-repeat-container\
              md-auto-shrink\
              md-auto-shrink-min="1"\
              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
              ng-hide="$mdAutocompleteCtrl.hidden"\
              class="md-autocomplete-suggestions-container md-whiteframe-z1"\
              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
              role="presentation">\
            <ul class="md-autocomplete-suggestions"\
                ng-class="::menuClass"\
                id="ul-{{$mdAutocompleteCtrl.id}}">\
              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
                  ng-click="$mdAutocompleteCtrl.select($index)"\
                  md-extra-name="$mdAutocompleteCtrl.itemName">\
                  ' + itemTemplate + '\
                  </li>' + noItemsTemplate + '\
            </ul>\
          </md-virtual-repeat-container>\
        </md-autocomplete-wrap>';

        function getItemTemplate() {
          var templateTag = element.find('md-item-template').detach(),
            html = templateTag.length ? templateTag.html() : element.html();
          if (!templateTag.length) element.empty();
          return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html + '</md-autocomplete-parent-scope>';
        }

        function getNoItemsTemplate() {
          var templateTag = element.find('md-not-found').detach(),
            template = templateTag.length ? templateTag.html() : '';
          return template
            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
                         md-autocomplete-parent-scope>' + template + '</li>'
            : '';

        }

        function getInputElement () {
          if (attr.mdFloatingLabel) {
            return '\
            <md-input-container ng-if="floatingLabel">\
              <label>{{floatingLabel}}</label>\
              <input type="search"\
                  ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
                  name="{{inputName}}"\
                  autocomplete="off"\
                  ng-required="$mdAutocompleteCtrl.isRequired"\
                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
                  ng-minlength="inputMinlength"\
                  ng-maxlength="inputMaxlength"\
                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
                  ng-model-options="{ allowInvalid: true }"\
                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
                  ng-blur="$mdAutocompleteCtrl.blur($event)"\
                  ng-focus="$mdAutocompleteCtrl.focus($event)"\
                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
                  aria-label="{{floatingLabel}}"\
                  aria-autocomplete="list"\
                  role="combobox"\
                  aria-haspopup="true"\
                  aria-activedescendant=""\
                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
            </md-input-container>';
          } else {
            return '\
            <input type="search"\
                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
                name="{{inputName}}"\
                ng-if="!floatingLabel"\
                autocomplete="off"\
                ng-required="$mdAutocompleteCtrl.isRequired"\
                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
                ng-model="$mdAutocompleteCtrl.scope.searchText"\
                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
                ng-blur="$mdAutocompleteCtrl.blur($event)"\
                ng-focus="$mdAutocompleteCtrl.focus($event)"\
                placeholder="{{placeholder}}"\
                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
                aria-label="{{placeholder}}"\
                aria-autocomplete="list"\
                role="combobox"\
                aria-haspopup="true"\
                aria-activedescendant=""\
                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>';
          }
        }

        function getClearButton() {
          return '' +
            '<button ' +
            'type="button" ' +
            'aria-label="Clear Input" ' +
            'tabindex="-1" ' +
            'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText && !$mdAutocompleteCtrl.isDisabled" ' +
            'ng-click="$mdAutocompleteCtrl.clear($event)">' +
            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
            '</button>';
        }
      }
    };
  }

  var ITEM_HEIGHT   = 48,
    MAX_ITEMS     = 5,
    MENU_PADDING  = 8,
    INPUT_PADDING = 2; // Padding provided by `md-input-container`

  MdAutocompleteCtrl.inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer", "$document"];
  function MdAutocompleteCtrl($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
                              $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer, $document) {
// Internal Variables.
    var ctrl                 = this,
      itemParts            = $scope.itemsExpr.split(/ in /i),
      itemExpr             = itemParts[ 1 ],
      elements             = null,
      cache                = {},
      noBlur               = false,
      selectedItemWatchers = [],
      hasFocus             = false,
      fetchesInProgress    = 0,
      enableWrapScroll     = null,
      inputModelCtrl       = null,
      debouncedOnResize    = $mdUtil.debounce(onWindowResize);

    // Public Exported Variables with handlers
    defineProperty('hidden', handleHiddenChange, true);

    // Public Exported Variables
    ctrl.scope      = $scope;
    ctrl.parent     = $scope.$parent;
    ctrl.itemName   = itemParts[ 0 ];
    ctrl.matches    = [];
    ctrl.loading    = false;
    ctrl.hidden     = true;
    ctrl.index      = null;
    ctrl.id         = $mdUtil.nextUid();
    ctrl.isDisabled = null;
    ctrl.isRequired = null;
    ctrl.isReadonly = null;
    ctrl.hasNotFound = false;

    // Public Exported Methods
    ctrl.keydown                       = keydown;
    ctrl.blur                          = blur;
    ctrl.focus                         = focus;
    ctrl.clear                         = clearValue;
    ctrl.select                        = select;
    ctrl.listEnter                     = onListEnter;
    ctrl.listLeave                     = onListLeave;
    ctrl.mouseUp                       = onMouseup;
    ctrl.getCurrentDisplayValue        = getCurrentDisplayValue;
    ctrl.registerSelectedItemWatcher   = registerSelectedItemWatcher;
    ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
    ctrl.notFoundVisible               = notFoundVisible;
    ctrl.loadingIsVisible              = loadingIsVisible;
    ctrl.positionDropdown              = positionDropdown;

    /**
     * Report types to be used for the $mdLiveAnnouncer
     * @enum {number} Unique flag id.
     */
    var ReportType = {
      Count: 1,
      Selected: 2
    };

    return init();

    //-- initialization methods

    /**
     * Initialize the controller, setup watchers, gather elements
     */
    function init () {

      $mdUtil.initOptionalProperties($scope, $attrs, {
        searchText: '',
        selectedItem: null,
        clearButton: false
      });

      $mdTheming($element);
      configureWatchers();
      $mdUtil.nextTick(function () {

        gatherElements();
        moveDropdown();

        // Forward all focus events to the input element when autofocus is enabled
        if ($scope.autofocus) {
          $element.on('focus', focusInputElement);
        }
      });
    }

    function updateModelValidators() {
      if (!$scope.requireMatch || !inputModelCtrl) return;

      inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
    }

    /**
     * Calculates the dropdown's position and applies the new styles to the menu element
     * @returns {*}
     */
    function positionDropdown () {
      if (!elements) {
        return $mdUtil.nextTick(positionDropdown, false, $scope);
      }

      var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;

      var hrect  = elements.wrap.getBoundingClientRect(),
        vrect  = elements.snap.getBoundingClientRect(),
        root   = elements.root.getBoundingClientRect(),
        top    = vrect.bottom - root.top,
        bot    = root.bottom - vrect.top,
        left   = hrect.left - root.left,
        width  = hrect.width,
        offset = getVerticalOffset(),
        position = $scope.dropdownPosition,
        styles;

      // Automatically determine dropdown placement based on available space in viewport.
      if (!position) {
        position = (top > bot && root.height - hrect.bottom - MENU_PADDING < dropdownHeight) ? 'top' : 'bottom';
      }
      // Adjust the width to account for the padding provided by `md-input-container`
      if ($attrs.mdFloatingLabel) {
        left += INPUT_PADDING;
        width -= INPUT_PADDING * 2;
      }
      styles = {
        left:     left + 'px',
        minWidth: width + 'px',
        maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
      };

      if (position === 'top') {
        styles.top       = 'auto';
        styles.bottom    = bot + 'px';
        styles.maxHeight = Math.min(dropdownHeight, hrect.top - root.top - MENU_PADDING) + 'px';
      } else {
        var bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();

        styles.top       = (top - offset) + 'px';
        styles.bottom    = 'auto';
        styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
      }

      elements.$.scrollContainer.css(styles);
      $mdUtil.nextTick(correctHorizontalAlignment, false);

      /**
       * Calculates the vertical offset for floating label examples to account for ngMessages
       * @returns {number}
       */
      function getVerticalOffset () {
        var offset = 0;
        var inputContainer = $element.find('md-input-container');
        if (inputContainer.length) {
          var input = inputContainer.find('input');
          offset = inputContainer.prop('offsetHeight');
          offset -= input.prop('offsetTop');
          offset -= input.prop('offsetHeight');
          // add in the height left up top for the floating label text
          offset += inputContainer.prop('offsetTop');
        }
        return offset;
      }

      /**
       * Makes sure that the menu doesn't go off of the screen on either side.
       */
      function correctHorizontalAlignment () {
        var dropdown = elements.scrollContainer.getBoundingClientRect(),
          styles   = {};
        if (dropdown.right > root.right - MENU_PADDING) {
          styles.left = (hrect.right - dropdown.width) + 'px';
        }
        elements.$.scrollContainer.css(styles);
      }
    }

    /**
     * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
     */
    function moveDropdown () {
      if (!elements.$.root.length) return;
      $mdTheming(elements.$.scrollContainer);
      elements.$.scrollContainer.detach();
      elements.$.root.append(elements.$.scrollContainer);
      if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
    }

    /**
     * Sends focus to the input element.
     */
    function focusInputElement () {
      elements.input.focus();
    }

    /**
     * Sets up any watchers used by autocomplete
     */
    function configureWatchers () {
      var wait = parseInt($scope.delay, 10) || 0;

      $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
      $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
      $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });

      $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
      $scope.$watch('selectedItem', selectedItemChange);

      angular.element($window).on('resize', debouncedOnResize);

      $scope.$on('$destroy', cleanup);
    }

    /**
     * Removes any events or leftover elements created by this controller
     */
    function cleanup () {
      if (!ctrl.hidden) {
        $mdUtil.enableScrolling();
      }

      angular.element($window).off('resize', debouncedOnResize);

      if ( elements ){
        var items = ['ul', 'scroller', 'scrollContainer', 'input'];
        angular.forEach(items, function(key){
          elements.$[key].remove();
        });
      }
    }

    /**
     * Event handler to be called whenever the window resizes.
     */
    function onWindowResize() {
      if (!ctrl.hidden) {
        positionDropdown();
      }
    }

    /**
     * Gathers all of the elements needed for this controller
     */
    function gatherElements () {
      elements = {
        main:  $element[0],
        scrollContainer: $element[0].querySelector('.md-virtual-repeat-container'),
        scroller: $element[0].querySelector('.md-virtual-repeat-scroller'),
        ul:    $element.find('ul')[0],
        input: $element.find('input')[0],
        wrap:  getWrapTarget(),
        root:  $document[0].body
      };

      elements.li   = elements.ul.getElementsByTagName('li');
      elements.snap = getSnapTarget();
      elements.$    = getAngularElements(elements);

      inputModelCtrl = elements.$.input.controller('ngModel');
    }

    /**
     * Finds the correct element that will determine the width
     * @returns {*}
     */
    function getWrapTarget() {
      for (var element = $element; element.length; element = element.parent()) {
        if (angular.isDefined(element.attr('md-autocomplete-wrap-override'))) return element[ 0 ];
      }
      return $element.find('md-autocomplete-wrap')[0];
    }

    /**
     * Finds the element that the menu will base its position on
     * @returns {*}
     */
    function getSnapTarget () {
      for (var element = $element; element.length; element = element.parent()) {
        if (angular.isDefined(element.attr('md-autocomplete-snap'))) return element[ 0 ];
      }
      return elements.wrap;
    }

    /**
     * Gathers angular-wrapped versions of each element
     * @param elements
     * @returns {{}}
     */
    function getAngularElements (elements) {
      var obj = {};
      for (var key in elements) {
        if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
      }
      return obj;
    }

    //-- event/change handlers

    /**
     * Handles changes to the `hidden` property.
     * @param hidden
     * @param oldHidden
     */
    function handleHiddenChange (hidden, oldHidden) {
      if (!hidden && oldHidden) {
        positionDropdown();

        // Report in polite mode, because the screenreader should finish the default description of
        // the input. element.
        reportMessages(true, ReportType.Count | ReportType.Selected);

        if (elements) {
          $mdUtil.disableScrollAround(elements.ul);
          enableWrapScroll = disableElementScrollEvents(angular.element(elements.wrap));
        }
      } else if (hidden && !oldHidden) {
        $mdUtil.enableScrolling();

        if (enableWrapScroll) {
          enableWrapScroll();
          enableWrapScroll = null;
        }
      }
    }

    /**
     * Disables scrolling for a specific element
     */
    function disableElementScrollEvents(element) {

      function preventDefault(e) {
        e.preventDefault();
      }

      element.on('wheel', preventDefault);
      element.on('touchmove', preventDefault);

      return function() {
        element.off('wheel', preventDefault);
        element.off('touchmove', preventDefault);
      };
    }

    /**
     * When the user mouses over the dropdown menu, ignore blur events.
     */
    function onListEnter () {
      noBlur = true;
    }

    /**
     * When the user's mouse leaves the menu, blur events may hide the menu again.
     */
    function onListLeave () {
      if (!hasFocus && !ctrl.hidden) elements.input.focus();
      noBlur = false;
      ctrl.hidden = shouldHide();
    }

    /**
     * When the mouse button is released, send focus back to the input field.
     */
    function onMouseup () {
      elements.input.focus();
    }

    /**
     * Handles changes to the selected item.
     * @param selectedItem
     * @param previousSelectedItem
     */
    function selectedItemChange (selectedItem, previousSelectedItem) {

      updateModelValidators();

      if (selectedItem) {
        getDisplayValue(selectedItem).then(function (val) {
          $scope.searchText = val;
          handleSelectedItemChange(selectedItem, previousSelectedItem);
        });
      } else if (previousSelectedItem && $scope.searchText) {
        getDisplayValue(previousSelectedItem).then(function(displayValue) {
          // Clear the searchText, when the selectedItem is set to null.
          // Do not clear the searchText, when the searchText isn't matching with the previous
          // selected item.
          if (displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
            $scope.searchText = '';
          }
        });
      }

      if (selectedItem !== previousSelectedItem) announceItemChange();
    }

    /**
     * Use the user-defined expression to announce changes each time a new item is selected
     */
    function announceItemChange () {
      angular.isFunction($scope.itemChange) && $scope.itemChange(getItemAsNameVal($scope.selectedItem));
    }

    /**
     * Use the user-defined expression to announce changes each time the search text is changed
     */
    function announceTextChange () {
      angular.isFunction($scope.textChange) && $scope.textChange();
    }

    /**
     * Calls any external watchers listening for the selected item.  Used in conjunction with
     * `registerSelectedItemWatcher`.
     * @param selectedItem
     * @param previousSelectedItem
     */
    function handleSelectedItemChange (selectedItem, previousSelectedItem) {
      selectedItemWatchers.forEach(function (watcher) { watcher(selectedItem, previousSelectedItem); });
    }

    /**
     * Register a function to be called when the selected item changes.
     * @param cb
     */
    function registerSelectedItemWatcher (cb) {
      if (selectedItemWatchers.indexOf(cb) == -1) {
        selectedItemWatchers.push(cb);
      }
    }

    /**
     * Unregister a function previously registered for selected item changes.
     * @param cb
     */
    function unregisterSelectedItemWatcher (cb) {
      var i = selectedItemWatchers.indexOf(cb);
      if (i != -1) {
        selectedItemWatchers.splice(i, 1);
      }
    }

    /**
     * Handles changes to the searchText property.
     * @param searchText
     * @param previousSearchText
     */
    function handleSearchText (searchText, previousSearchText) {
      ctrl.index = getDefaultIndex();

      // do nothing on init
      if (searchText === previousSearchText) return;

      updateModelValidators();

      getDisplayValue($scope.selectedItem).then(function (val) {
        // clear selected item if search text no longer matches it
        if (searchText !== val) {
          $scope.selectedItem = null;


          // trigger change event if available
          if (searchText !== previousSearchText) announceTextChange();

          // cancel results if search text is not long enough
          if (!isMinLengthMet()) {
            ctrl.matches = [];

            setLoading(false);
            reportMessages(false, ReportType.Count);

          } else {
            handleQuery();
          }
        }
      });

    }

    /**
     * Handles input blur event, determines if the dropdown should hide.
     */
    function blur($event) {
      hasFocus = false;

      if (!noBlur) {
        ctrl.hidden = shouldHide();
        evalAttr('ngBlur', { $event: $event });
      }
    }

    /**
     * Force blur on input element
     * @param forceBlur
     */
    function doBlur(forceBlur) {
      if (forceBlur) {
        noBlur = false;
        hasFocus = false;
      }
      elements.input.blur();
    }

    /**
     * Handles input focus event, determines if the dropdown should show.
     */
    function focus($event) {
      hasFocus = true;

      if (isSearchable() && isMinLengthMet()) {
        handleQuery();
      }

      ctrl.hidden = shouldHide();

      evalAttr('ngFocus', { $event: $event });
    }

    /**
     * Handles keyboard input.
     * @param event
     */
    function keydown (event) {
      switch (event.keyCode) {
        case $mdConstant.KEY_CODE.DOWN_ARROW:
          if (ctrl.loading) return;
          event.stopPropagation();
          event.preventDefault();
          ctrl.index   = Math.min(ctrl.index + 1, ctrl.matches.length - 1);
          updateScroll();
          reportMessages(false, ReportType.Selected);
          break;
        case $mdConstant.KEY_CODE.UP_ARROW:
          if (ctrl.loading) return;
          event.stopPropagation();
          event.preventDefault();
          ctrl.index   = ctrl.index < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
          updateScroll();
          reportMessages(false, ReportType.Selected);
          break;
        case $mdConstant.KEY_CODE.TAB:
          // If we hit tab, assume that we've left the list so it will close
          onListLeave();

          if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
          select(ctrl.index);
          break;
        case $mdConstant.KEY_CODE.ENTER:
          if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
          if (hasSelection()) return;
          event.stopPropagation();
          event.preventDefault();
          select(ctrl.index);
          break;
        case $mdConstant.KEY_CODE.ESCAPE:
          event.preventDefault(); // Prevent browser from always clearing input
          if (!shouldProcessEscape()) return;
          event.stopPropagation();

          clearSelectedItem();
          if ($scope.searchText && hasEscapeOption('clear')) {
            clearSearchText();
          }

          // Manually hide (needed for mdNotFound support)
          ctrl.hidden = true;

          if (hasEscapeOption('blur')) {
            // Force the component to blur if they hit escape
            doBlur(true);
          }

          break;
        default:
      }
    }

    //-- getters

    /**
     * Returns the minimum length needed to display the dropdown.
     * @returns {*}
     */
    function getMinLength () {
      return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
    }

    /**
     * Returns the display value for an item.
     * @param item
     * @returns {*}
     */
    function getDisplayValue (item) {
      return $q.when(getItemText(item) || item).then(function(itemText) {
        if (itemText && !angular.isString(itemText)) {
          $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
            'Please check the `md-item-text` attribute.');
        }

        return itemText;
      });

      /**
       * Getter function to invoke user-defined expression (in the directive)
       * to convert your object to a single string.
       */
      function getItemText (item) {
        return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
      }
    }

    /**
     * Returns the locals object for compiling item templates.
     * @param item
     * @returns {{}}
     */
    function getItemAsNameVal (item) {
      if (!item) return undefined;

      var locals = {};
      if (ctrl.itemName) locals[ ctrl.itemName ] = item;

      return locals;
    }

    /**
     * Returns the default index based on whether or not autoselect is enabled.
     * @returns {number}
     */
    function getDefaultIndex () {
      return $scope.autoselect ? 0 : -1;
    }

    /**
     * Sets the loading parameter and updates the hidden state.
     * @param value {boolean} Whether or not the component is currently loading.
     */
    function setLoading(value) {
      if (ctrl.loading != value) {
        ctrl.loading = value;
      }

      // Always refresh the hidden variable as something else might have changed
      ctrl.hidden = shouldHide();
    }

    /**
     * Determines if the menu should be hidden.
     * @returns {boolean}
     */
    function shouldHide () {
      if (!isSearchable()) return true;    // Hide when not able to query
      else return !shouldShow();            // Hide when the dropdown is not able to show.
    }

    /**
     * Determines whether the autocomplete is able to query within the current state.
     * @returns {boolean}
     */
    function isSearchable() {
      if (ctrl.loading && !hasMatches()) return false; // No query when query is in progress.
      else if (hasSelection()) return false;           // No query if there is already a selection
      else if (!hasFocus) return false;                // No query if the input does not have focus
      return true;
    }

    /**
     * Determines if the escape keydown should be processed
     * @returns {boolean}
     */
    function shouldProcessEscape() {
      return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
    }

    /**
     * Determines if an escape option is set
     * @returns {boolean}
     */
    function hasEscapeOption(option) {
      return !$scope.escapeOptions || $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
    }

    /**
     * Determines if the menu should be shown.
     * @returns {boolean}
     */
    function shouldShow() {
      return (isMinLengthMet() && hasMatches()) || notFoundVisible();
    }

    /**
     * Returns true if the search text has matches.
     * @returns {boolean}
     */
    function hasMatches() {
      return ctrl.matches.length ? true : false;
    }

    /**
     * Returns true if the autocomplete has a valid selection.
     * @returns {boolean}
     */
    function hasSelection() {
      return ctrl.scope.selectedItem ? true : false;
    }

    /**
     * Returns true if the loading indicator is, or should be, visible.
     * @returns {boolean}
     */
    function loadingIsVisible() {
      return ctrl.loading && !hasSelection();
    }

    /**
     * Returns the display value of the current item.
     * @returns {*}
     */
    function getCurrentDisplayValue () {
      return getDisplayValue(ctrl.matches[ ctrl.index ]);
    }

    /**
     * Determines if the minimum length is met by the search text.
     * @returns {*}
     */
    function isMinLengthMet () {
      return ($scope.searchText || '').length >= getMinLength();
    }

    //-- actions

    /**
     * Defines a public property with a handler and a default value.
     * @param key
     * @param handler
     * @param value
     */
    function defineProperty (key, handler, value) {
      Object.defineProperty(ctrl, key, {
        get: function () { return value; },
        set: function (newValue) {
          var oldValue = value;
          value        = newValue;
          handler(newValue, oldValue);
        }
      });
    }

    /**
     * Selects the item at the given index.
     * @param index
     */
    function select (index) {
      //-- force form to update state for validation
      $mdUtil.nextTick(function () {
        getDisplayValue(ctrl.matches[ index ]).then(function (val) {
          var ngModel = elements.$.input.controller('ngModel');
          ngModel.$setViewValue(val);
          ngModel.$render();
        }).finally(function () {
          $scope.selectedItem = ctrl.matches[ index ];
          setLoading(false);
        });
      }, false);
    }

    /**
     * Clears the searchText value and selected item.
     */
    function clearValue () {
      clearSelectedItem();
      clearSearchText();
    }

    /**
     * Clears the selected item
     */
    function clearSelectedItem () {
      // Reset our variables
      ctrl.index = 0;
      ctrl.matches = [];
    }

    /**
     * Clears the searchText value
     */
    function clearSearchText () {
      // Set the loading to true so we don't see flashes of content.
      // The flashing will only occur when an async request is running.
      // So the loading process will stop when the results had been retrieved.
      setLoading(true);

      $scope.searchText = '';

      // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
      // But some browsers are not detecting it properly, which means that we have to trigger the event.
      // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
      // The `change` event is a good alternative and is supported by all supported browsers.
      var eventObj = $document[0].createEvent('CustomEvent');
      eventObj.initCustomEvent('change', true, true, { value: '' });
      elements.input.dispatchEvent(eventObj);

      // For some reason, firing the above event resets the value of $scope.searchText if
      // $scope.searchText has a space character at the end, so we blank it one more time and then
      // focus.
      elements.input.blur();
      $scope.searchText = '';
      elements.input.focus();
    }

    /**
     * Fetches the results for the provided search text.
     * @param searchText
     */
    function fetchResults (searchText) {
      var items = $scope.$parent.$eval(itemExpr),
        term  = searchText.toLowerCase(),
        isList = angular.isArray(items),
        isPromise = !!items.then; // Every promise should contain a `then` property

      if (isList) onResultsRetrieved(items);
      else if (isPromise) handleAsyncResults(items);

      function handleAsyncResults(items) {
        if ( !items ) return;

        items = $q.when(items);
        fetchesInProgress++;
        setLoading(true);

        $mdUtil.nextTick(function () {
          items
            .then(onResultsRetrieved)
            .finally(function(){
              if (--fetchesInProgress === 0) {
                setLoading(false);
              }
            });
        },true, $scope);
      }

      function onResultsRetrieved(matches) {
        cache[term] = matches;

        // Just cache the results if the request is now outdated.
        // The request becomes outdated, when the new searchText has changed during the result fetching.
        if ((searchText || '') !== ($scope.searchText || '')) {
          return;
        }

        handleResults(matches);
      }
    }


    /**
     * Reports given message types to supported screenreaders.
     * @param {boolean} isPolite Whether the announcement should be polite.
     * @param {!number} types Message flags to be reported to the screenreader.
     */
    function reportMessages(isPolite, types) {

      var politeness = isPolite ? 'polite' : 'assertive';
      var messages = [];

      if (types & ReportType.Selected && ctrl.index !== -1) {
        messages.push(getCurrentDisplayValue());
      }

      if (types & ReportType.Count) {
        messages.push($q.resolve(getCountMessage()));
      }

      $q.all(messages).then(function(data) {
        $mdLiveAnnouncer.announce(data.join(' '), politeness);
      });

    }

    /**
     * Returns the ARIA message for how many results match the current query.
     * @returns {*}
     */
    function getCountMessage () {
      switch (ctrl.matches.length) {
        case 0:
          return 'There are no matches available.';
        case 1:
          return 'There is 1 match available.';
        default:
          return 'There are ' + ctrl.matches.length + ' matches available.';
      }
    }

    /**
     * Makes sure that the focused element is within view.
     */
    function updateScroll () {
      if (!elements.li[0]) return;
      var height = elements.li[0].offsetHeight,
        top = height * ctrl.index,
        bot = top + height,
        hgt = elements.scroller.clientHeight,
        scrollTop = elements.scroller.scrollTop;
      if (top < scrollTop) {
        scrollTo(top);
      } else if (bot > scrollTop + hgt) {
        scrollTo(bot - hgt);
      }
    }

    function isPromiseFetching() {
      return fetchesInProgress !== 0;
    }

    function scrollTo (offset) {
      elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
    }

    function notFoundVisible () {
      var textLength = (ctrl.scope.searchText || '').length;

      return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
    }

    /**
     * Starts the query to gather the results for the current searchText.  Attempts to return cached
     * results first, then forwards the process to `fetchResults` if necessary.
     */
    function handleQuery () {
      var searchText = $scope.searchText || '';
      var term = searchText.toLowerCase();

      // If caching is enabled and the current searchText is stored in the cache
      if (!$scope.noCache && cache[term]) {
        // The results should be handled as same as a normal un-cached request does.
        handleResults(cache[term]);
      } else {
        fetchResults(searchText);
      }

      ctrl.hidden = shouldHide();
    }

    /**
     * Handles the retrieved results by showing them in the autocompletes dropdown.
     * @param results Retrieved results
     */
    function handleResults(results) {
      ctrl.matches = results;
      ctrl.hidden  = shouldHide();

      // If loading is in progress, then we'll end the progress. This is needed for example,
      // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
      if (ctrl.loading) setLoading(false);

      if ($scope.selectOnMatch) selectItemOnMatch();

      positionDropdown();
      reportMessages(true, ReportType.Count);
    }

    /**
     * If there is only one matching item and the search text matches its display value exactly,
     * automatically select that item.  Note: This function is only called if the user uses the
     * `md-select-on-match` flag.
     */
    function selectItemOnMatch () {
      var searchText = $scope.searchText,
        matches    = ctrl.matches,
        item       = matches[ 0 ];
      if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
        var isMatching = searchText == displayValue;
        if ($scope.matchInsensitive && !isMatching) {
          isMatching = searchText.toLowerCase() == displayValue.toLowerCase();
        }

        if (isMatching) select(0);
      });
    }

    /**
     * Evaluates an attribute expression against the parent scope.
     * @param {String} attr Name of the attribute to be evaluated.
     * @param {Object?} locals Properties to be injected into the evaluation context.
     */
    function evalAttr(attr, locals) {
      if ($attrs[attr]) {
        $scope.$parent.$eval($attrs[attr], locals || {});
      }
    }
  }

  angular.module('eHRD.kernel.uiElements.cusMaterial')
    .directive('cusMdAutocomplete', cusMdAutocomplete);
})();

/**
 * Created by Bruce on 2016/12/19.
 */

(function () {
  'use strict';
  var $MD_THEME_CSS = "md-autocomplete.md-THEME_NAME-theme{background:'{{background-A100}}'}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:'{{background-100}}'}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:'{{background-600}}'}md-autocomplete.md-THEME_NAME-theme button:after{background:'{{background-600-0.3}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:'{{background-A100}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:'{{background-900}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight{color:'{{background-600}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover{background:'{{background-200}}'}cus-md-autocomplete.md-THEME_NAME-theme{background:'{{background-A100}}'}cus-md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:'{{background-100}}'}cus-md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:'{{background-600}}'}cus-md-autocomplete.md-THEME_NAME-theme button:after{background:'{{background-600-0.3}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:'{{background-A100}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:'{{background-900}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight{color:'{{background-600}}'}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected{background:'{{background-200}}'}md-backdrop{background-color:'{{background-900-0.0}}'}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:'{{background-900-1.0}}'}md-bottom-sheet.md-THEME_NAME-theme{background-color:'{{background-50}}';border-top-color:'{{background-300}}'}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:'{{foreground-1}}'}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:'{{background-50}}';color:'{{foreground-1}}'}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:'{{background-500-0.2}}'}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:'{{accent-contrast}}'}.md-button.md-THEME_NAME-theme.md-primary{color:'{{primary-color}}'}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:'{{primary-contrast}}';background-color:'{{primary-color}}'}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:'{{primary-contrast}}'}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:'{{primary-600}}'}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:'{{primary-color}}'}.md-button.md-THEME_NAME-theme.md-fab{background-color:'{{accent-color}}';color:'{{accent-contrast}}'}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:'{{accent-contrast}}'}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:'{{accent-A700}}'}.md-button.md-THEME_NAME-theme.md-raised{color:'{{background-900}}';background-color:'{{background-50}}'}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:'{{background-900}}'}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:'{{background-50}}'}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:'{{background-200}}'}.md-button.md-THEME_NAME-theme.md-warn{color:'{{warn-color}}'}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:'{{warn-contrast}}';background-color:'{{warn-color}}'}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:'{{warn-contrast}}'}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:'{{warn-600}}'}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:'{{warn-color}}'}.md-button.md-THEME_NAME-theme.md-accent{color:'{{accent-color}}'}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:'{{accent-contrast}}';background-color:'{{accent-color}}'}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:'{{accent-contrast}}'}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:'{{accent-A700}}'}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:'{{accent-color}}'}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:'{{foreground-3}}';cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:'{{foreground-3}}'}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:'{{foreground-4}}'}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:'{{primary-color}}'}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:'{{primary-700}}'}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:'{{accent-700}}'}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:'{{accent-color}}'}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:'{{accent-A700}}'}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:'{{warn-color}}'}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:'{{warn-700}}'}md-card.md-THEME_NAME-theme{color:'{{foreground-1}}';background-color:'{{background-hue-1}}';border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:'{{background-color}}';background-color:'{{foreground-3}}'}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:'{{foreground-2}}'}md-checkbox.md-THEME_NAME-theme .md-ripple{color:'{{accent-A700}}'}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:'{{background-600}}'}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:'{{accent-color-0.26}}'}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:'{{foreground-2}}'}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:'{{accent-color-0.87}}'}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:'{{foreground-2}}'}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:'{{accent-color-0.87}}'}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:'{{accent-contrast-0.87}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:'{{primary-600}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:'{{background-600}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:'{{foreground-2}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:'{{primary-color-0.87}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:'{{foreground-2}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:'{{primary-color-0.87}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:'{{primary-color-0.26}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:'{{primary-contrast-0.87}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:'{{foreground-3}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:'{{warn-600}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:'{{foreground-2}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:'{{warn-color-0.87}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:'{{foreground-2}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:'{{warn-color-0.87}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:'{{warn-color-0.26}}'}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:'{{background-200}}'}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:'{{foreground-3}}'}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:'{{foreground-3}}'}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:'{{background-200}}'}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:'{{foreground-3}}'}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:'{{foreground-3}}'}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px '{{foreground-4}}'}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px '{{primary-color}}'}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:'{{foreground-1}}'}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:'{{foreground-3}}'}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:'{{foreground-3}}'}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:'{{foreground-3}}'}md-chips.md-THEME_NAME-theme md-chip{background:'{{background-300}}';color:'{{background-800}}'}md-chips.md-THEME_NAME-theme md-chip md-icon{color:'{{background-700}}'}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:'{{primary-color}}';color:'{{primary-contrast}}'}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:'{{primary-contrast}}'}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:'{{background-800}}'}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:'{{background-500}}'}.md-contact-suggestion span.md-contact-email{color:'{{background-400}}'}cus-md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px '{{foreground-4}}'}cus-md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px '{{primary-color}}'}cus-md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:'{{foreground-1}}'}cus-md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:'{{foreground-3}}'}cus-md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder{color:'{{foreground-3}}'}cus-md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:'{{foreground-3}}'}cus-md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:'{{foreground-3}}'}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:'{{foreground-3}}'}cus-md-chips.md-THEME_NAME-theme cus-md-chip{background:'{{background-300}}';color:'{{background-800}}'}cus-md-chips.md-THEME_NAME-theme cus-md-chip md-icon{color:'{{background-700}}'}cus-md-chips.md-THEME_NAME-theme cus-md-chip.md-focused{background:'{{primary-color}}';color:'{{primary-contrast}}'}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:'{{primary-contrast}}'}cus-md-chips.md-THEME_NAME-theme cus-md-chip._md-chip-editing{background:transparent;color:'{{background-800}}'}cus-md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:'{{background-500}}'}.md-contact-suggestion span.md-contact-email{color:'{{background-400}}'}md-content.md-THEME_NAME-theme{color:'{{foreground-1}}';background-color:'{{background-default}}'}.md-calendar.md-THEME_NAME-theme{background:'{{background-A100}}';color:'{{background-A200-0.87}}'}.md-calendar.md-THEME_NAME-theme tr:last-child td{border-bottom-color:'{{background-200}}'}.md-THEME_NAME-theme .md-calendar-day-header{background:'{{background-300}}';color:'{{background-A200-0.87}}'}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid '{{primary-500}}'}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:'{{primary-500-0.6}}'}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:'{{background-300}}'}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:'{{primary-500}}';color:'{{primary-500-contrast}}';border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:'{{background-A200-0.435}}'}.md-THEME_NAME-theme .md-datepicker-input{color:'{{foreground-1}}'}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:'{{foreground-3}}'}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:'{{foreground-3}}'}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:'{{foreground-3}}'}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:'{{foreground-4}}'}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:'{{primary-color}}'}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:'{{accent-color}}'}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:'{{warn-A700}}'}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:'{{background-hue-1}}'}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:'{{foreground-3}}'}.md-THEME_NAME-theme .md-datepicker-triangle-button:hover .md-datepicker-expand-triangle{border-top-color:'{{foreground-2}}'}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:'{{primary-color}}'}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:'{{accent-color}}'}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:'{{warn-A700}}'}.md-THEME_NAME-theme .md-datepicker-calendar{background:'{{background-A100}}'}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:'{{background-hue-1}}';color:'{{foreground-1}}'}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:'{{foreground-4}}'}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:'{{foreground-4}}'}md-icon.md-THEME_NAME-theme{color:'{{foreground-2}}'}md-icon.md-THEME_NAME-theme.md-primary{color:'{{primary-color}}'}md-icon.md-THEME_NAME-theme.md-accent{color:'{{accent-color}}'}md-icon.md-THEME_NAME-theme.md-warn{color:'{{warn-color}}'}md-input-container.md-THEME_NAME-theme .md-input{color:'{{foreground-1}}';border-color:'{{foreground-4}}'}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:'{{foreground-3}}'}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:'{{foreground-3}}'}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:'{{foreground-3}}'}md-input-container.md-THEME_NAME-theme>md-icon{color:'{{foreground-1}}'}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:'{{foreground-3}}'}md-input-container.md-THEME_NAME-theme label.md-required:after{color:'{{warn-A700}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:'{{foreground-2}}'}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:'{{warn-A700}}'}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:'{{foreground-1}}'}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:'{{foreground-2}}'}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:'{{foreground-2}}'}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:'{{foreground-2}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:'{{foreground-2}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:'{{primary-color}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:'{{primary-color}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:'{{accent-color}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:'{{accent-color}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:'{{warn-A700}}'}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:'{{warn-A700}}'}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:'{{warn-A700}}'}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:'{{warn-A700}}'}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:'{{foreground-3}}';background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:'{{foreground-1}}'}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:'{{foreground-2}}'}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:'{{background-100}}'}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:'{{foreground-3}}';color:'{{background-color}}'}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:'{{foreground-2}}'}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:'{{primary-color}}'}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:'{{accent-color}}'}md-menu-content.md-THEME_NAME-theme{background-color:'{{background-A100}}'}md-menu-content.md-THEME_NAME-theme md-menu-item{color:'{{background-A200-0.87}}'}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:'{{background-A200-0.54}}'}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:'{{background-A200-0.25}}'}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:'{{background-A200-0.11}}'}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:'{{foreground-2}}';border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background:'{{background-200}}'}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:'{{ background-500-0.2}}'}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:'{{background-A200-0.54}}'}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:'{{ background-500-0.2}}'}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:'{{background-A100}}';color:'{{background-A200}}'}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:'{{primary-color}}';color:'{{background-A100-0.87}}'}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:'{{background-A100-0.87}}'}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:'{{foreground-4}}'}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:'{{foreground-2}}'}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:'{{accent-color}}';background:'{{accent-color}}'}.md-panel{background-color:'{{background-900-0.0}}'}.md-panel._md-panel-backdrop.md-THEME_NAME-theme{background-color:'{{background-900-1.0}}'}md-progress-circular.md-THEME_NAME-theme path{stroke:'{{primary-color}}'}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:'{{warn-color}}'}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:'{{accent-color}}'}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:'{{primary-100}}'}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:'{{primary-color}}'}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:'{{warn-100}}'}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:'{{warn-color}}'}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:'{{accent-100}}'}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:'{{accent-color}}'}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:'{{warn-100}}'}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:'{{accent-100}}'}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:'{{foreground-2}}'}md-radio-button.md-THEME_NAME-theme .md-on{background-color:'{{accent-color-0.87}}'}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:'{{accent-color-0.87}}'}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:'{{accent-color-0.87}}'}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:'{{accent-A700}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:'{{primary-color-0.87}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:'{{primary-color-0.87}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:'{{primary-color-0.87}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:'{{primary-600}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:'{{warn-color-0.87}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:'{{warn-color-0.87}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:'{{warn-color-0.87}}'}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:'{{warn-600}}'}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:'{{foreground-3}}'}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:'{{foreground-3}}'}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:'{{accent-color-0.26}}'}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:'{{primary-color-0.26}}'}md-radio-group.md-THEME_NAME-theme .md-checked.md-primary .md-ink-ripple{color:'{{warn-color-0.26}}'}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:'{{accent-color-0.26}}'}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:'{{primary-color-0.26}}'}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:'{{warn-color-0.26}}'}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:'{{warn-A700}}'}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:'{{foreground-3}}'}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:'{{primary-color}}'}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:'{{warn-A700}}'!important;border-bottom-color:'{{warn-A700}}'!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:'{{foreground-4}}'}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:'{{foreground-3}}'}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:'{{warn-A700}}'}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:'{{warn-A700}}'!important;border-bottom-color:'{{warn-A700}}'!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:'{{primary-color}}';color:'{{ foreground-1 }}'}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:'{{ foreground-1 }}'}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:'{{accent-color}}'}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:'{{warn-color}}'}md-select.md-THEME_NAME-theme .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:'{{foreground-3}}'}md-select.md-THEME_NAME-theme .md-select-icon:hover{color:'{{foreground-2}}'}md-select-menu.md-THEME_NAME-theme md-content{background:'{{background-A100}}'}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:'{{background-600-0.87}}'}md-select-menu.md-THEME_NAME-theme md-content md-option{color:'{{background-900-0.87}}'}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:'{{background-400-0.87}}'}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background:'{{background-200}}'}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:'{{primary-500}}'}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:'{{primary-600}}'}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:'{{accent-color}}'}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:'{{accent-A700}}'}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:'{{primary-600}}'}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:'{{background-600}}'}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:'{{foreground-2}}'}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:'{{primary-color-0.87}}'}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:'{{foreground-2}}'}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:'{{primary-color-0.87}}'}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:'{{primary-color-0.26}}'}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:'{{primary-contrast-0.87}}'}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:'{{foreground-3}}'}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:'{{background-900-0.87}}'}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:'{{background-hue-1}}'}md-slider.md-THEME_NAME-theme .md-track{background-color:'{{foreground-3}}'}md-slider.md-THEME_NAME-theme .md-track-ticks{color:'{{background-contrast}}'}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:'{{accent-A200-0.2}}'}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:'{{background-color}}';background-color:'{{background-color}}'}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:'{{background-color}}';border-color:'{{foreground-3}}'}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:'{{foreground-3-0.38}}'}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:'{{background-contrast}}';border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:'{{background-400}}'}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:'{{background-400}}'}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:'{{background-400}}'}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:'{{accent-color}}'}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:'{{accent-color}}';background-color:'{{accent-color}}'}md-slider.md-THEME_NAME-theme .md-sign{background-color:'{{accent-color}}'}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:'{{accent-color}}'}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:'{{accent-color}}'}md-slider.md-THEME_NAME-theme .md-thumb-text{color:'{{accent-contrast}}'}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:'{{warn-200-0.38}}'}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:'{{warn-color}}'}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:'{{warn-color}}';background-color:'{{warn-color}}'}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:'{{warn-color}}'}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:'{{warn-color}}'}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:'{{warn-color}}'}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:'{{warn-contrast}}'}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:'{{primary-200-0.38}}'}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:'{{primary-color}}'}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:'{{primary-color}}';background-color:'{{primary-color}}'}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:'{{primary-color}}'}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:'{{primary-color}}'}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:'{{primary-color}}'}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:'{{primary-contrast}}'}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:'{{foreground-3}}';border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:'{{background-400}}'}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:'{{background-400}}'}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:'{{background-400}}'}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:'{{foreground-3}}'}.md-subheader.md-THEME_NAME-theme{color:'{{ foreground-2-0.23 }}';background-color:'{{background-default}}'}.md-subheader.md-THEME_NAME-theme.md-primary{color:'{{primary-color}}'}.md-subheader.md-THEME_NAME-theme.md-accent{color:'{{accent-color}}'}.md-subheader.md-THEME_NAME-theme.md-warn{color:'{{warn-color}}'}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:'{{background-500}}'}md-switch.md-THEME_NAME-theme .md-thumb{background-color:'{{background-50}}'}md-switch.md-THEME_NAME-theme .md-bar{background-color:'{{background-500}}'}md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:'{{accent-color}}'}md-switch.md-THEME_NAME-theme.md-checked .md-thumb{background-color:'{{accent-color}}'}md-switch.md-THEME_NAME-theme.md-checked .md-bar{background-color:'{{accent-color-0.5}}'}md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before{background-color:'{{accent-color-0.26}}'}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple{color:'{{primary-color}}'}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb{background-color:'{{primary-color}}'}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar{background-color:'{{primary-color-0.5}}'}md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before{background-color:'{{primary-color-0.26}}'}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple{color:'{{warn-color}}'}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb{background-color:'{{warn-color}}'}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar{background-color:'{{warn-color-0.5}}'}md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before{background-color:'{{warn-color-0.26}}'}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:'{{background-400}}'}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:'{{foreground-4}}'}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:'{{foreground-4}}'}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:'{{primary-color}}'}md-tabs.md-THEME_NAME-theme md-ink-bar{color:'{{accent-color}}';background:'{{accent-color}}'}md-tabs.md-THEME_NAME-theme .md-tab{color:'{{foreground-2}}'}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:'{{foreground-3}}'}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:'{{primary-color}}'}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:'{{primary-color-0.1}}'}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:'{{accent-A100}}'}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:'{{accent-color}}'}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:'{{accent-A100}}'}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:'{{accent-contrast}}'}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:'{{accent-contrast-0.1}}'}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:'{{primary-600-1}}';background:'{{primary-600-1}}'}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:'{{primary-color}}'}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:'{{primary-100}}'}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:'{{primary-contrast}}'}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:'{{primary-contrast-0.1}}'}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:'{{warn-color}}'}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:'{{warn-100}}'}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:'{{warn-contrast}}'}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:'{{warn-contrast-0.1}}'}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:'{{primary-color}}'}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:'{{primary-100}}'}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:'{{primary-contrast}}'}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:'{{primary-contrast-0.1}}'}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:'{{accent-color}}'}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:'{{accent-A100}}'}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:'{{accent-contrast}}'}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:'{{accent-contrast-0.1}}'}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:'{{primary-600-1}}';background:'{{primary-600-1}}'}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:'{{warn-color}}'}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:'{{warn-100}}'}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:'{{warn-contrast}}'}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:'{{warn-contrast-0.1}}'}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:'{{background-50}}'}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:'{{background-50}}'}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:'{{accent-color}}'}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:'{{primary-color}}'}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:'{{warn-color}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:'{{primary-color}}';color:'{{primary-contrast}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:'{{primary-contrast}}';fill:'{{primary-contrast}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:'{{primary-contrast-0.26}}';fill:'{{primary-contrast-0.26}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:'{{accent-color}}';color:'{{accent-contrast}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:'{{accent-contrast}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:'{{accent-contrast}}';fill:'{{accent-contrast}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:'{{accent-contrast-0.26}}';fill:'{{accent-contrast-0.26}}'}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:'{{warn-color}}';color:'{{warn-contrast}}'}.md-tooltip.md-THEME_NAME-theme{color:'{{background-700-contrast}}'}.md-tooltip.md-THEME_NAME-theme.md-panel{background-color:'{{background-700}}'}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:'{{foreground-1}}';background-color:'{{background-color}}'}";

  angular.module('eHRD.kernel.uiElements.cusMaterial')
    .constant('$MD_THEME_CSS', $MD_THEME_CSS);
})();

/**
 * Created by Bruce on 2017/5/4.
 */
(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.breadcrumbs',[]);

})();

/**
 * Created by Bruce on 2017/5/4.
 */

(function () {
  'use strict';

  function breadcrumbsService() {
    var $registeredListeners = {};

    function registerListenerOnce(tag, $rootScope, event, fn) {
      var deregisterListenerFn = $registeredListeners[tag];
      if ( angular.isDefined(deregisterListenerFn) ) {
        deregisterListenerFn();
      }
      deregisterListenerFn = $rootScope.$on(event, fn);
      $registeredListeners[tag] = deregisterListenerFn;
    }
    function isAOlderThanB(scopeA, scopeB) {
      if(angular.equals(scopeA.length, scopeB.length)) {
        return scopeA > scopeB;
      } else {
        return scopeA.length > scopeB.length;
      }
    }

    function parseStateRef(ref) {
      var parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
      if (!parsed || parsed.length !== 4) { throw new Error("Invalid state ref '" + ref + "'"); }
      return { state: parsed[1], paramExpr: parsed[3] || null };
    }

    var getExpression = function(interpolationFunction) {
      if(interpolationFunction.expressions) {
        return interpolationFunction.expressions;
      } else {
        // Workaround for Angular 1.2.x
        var expressions = [];
        angular.forEach(interpolationFunction.parts, function(part) {
          if(angular.isFunction(part)) {
            expressions.push(part.exp);
          }
        });
        return expressions;
      }
    };

    var deregisterWatchers = function(labelWatcherArray) {
      angular.forEach(labelWatcherArray, function(deregisterWatch) {
        deregisterWatch();
      });
    };

    var registerWatchers = function(labelWatcherArray, interpolationFunction, viewScope, step) {
      angular.forEach(getExpression(interpolationFunction), function(expression) {
        var watcher = viewScope.$watch(expression, function() {
          step.ncyBreadcrumbLabel = interpolationFunction(viewScope);
        });
        labelWatcherArray.push(watcher);
      });
    };

    return{
      registerListenerOnce: registerListenerOnce,
      isAOlderThanB: isAOlderThanB,
      parseStateRef: parseStateRef,
      getExpression: getExpression,
      deregisterWatchers: deregisterWatchers,
      registerWatchers: registerWatchers
    };
  }

  angular.module('eHRD.kernel.uiElements.breadcrumbs')
    .factory('breadcrumbsService',breadcrumbsService)
  ;

})();

/**
 * Created by Bruce on 2017/5/4.
 */
(function () {
  'use strict';


  function $Breadcrumb() {

    var $$options = {
      prefixStateName: null,
      template: 'bootstrap3',
      templateUrl: null,
      templateLast: 'default',
      templateLastUrl: null,
      includeAbstract : false
    };

    this.setOptions = function(options) {
      angular.extend($$options, options);
    };

    BreadCrumb.$inject = ['$state', '$stateParams', '$rootScope', 'breadcrumbsService', 'treeFactory', 'sitemapService'];
    function BreadCrumb($state, $stateParams, $rootScope, breadcrumbsService, treeFactory, sitemapService) {
      var $lastViewScope = $rootScope;
      // Early catch of $viewContentLoaded event
      breadcrumbsService.registerListenerOnce('$Breadcrumb.$viewContentLoaded', $rootScope, '$viewContentLoaded', function (event) {
        // With nested views, the event occur several times, in "wrong" order
        if(!event.targetScope.ncyBreadcrumbIgnore &&
          breadcrumbsService.isAOlderThanB(event.targetScope.$id, $lastViewScope.$id)) {
          $lastViewScope = event.targetScope;
        }
      });

      // Get the parent state
      var $$parentMenu = function (state) {
        var menuChain = [];

        if( sitemapService.getSiteMapNodes() ) {
          sitemapService.getSiteMapNodes().walk(function (node) {
            if( node.model.type === 'STATIC'){
              if(angular.equals(node.model.stateParams['mid'], $state.params['mid']) ){
                menuChain = node.getPath();
              }
            }else{
              if (node.model.state === state.name){
                if(angular.isDefined(node.model.stateParams) && (angular.isDefined(node.model.stateParams['cid']) || angular.isDefined(node.model.stateParams['courseId']) || angular.isDefined(node.model.stateParams['mid']) ) ) {
                  if( (angular.isDefined(node.model.stateParams['cid']) && angular.equals(node.model.stateParams['cid'], $state.params['cid']) ||
                      ($state.params['cid'] === "0" && node.model.stateParams['cid'] === null) )) {
                    menuChain = node.getPath();
                  }
                  if(angular.isDefined(node.model.stateParams['courseId']) && angular.equals(node.model.stateParams['courseId'], $state.params['courseId'])) menuChain = node.getPath();
                  if(angular.equals(node.model.stateParams['mid'], $state.params['mid'])) menuChain = node.getPath();
                }else {
                  menuChain = node.getPath();
                }
              }
            }
          });
        }
        return menuChain;
      };

      // Add the state in the chain if not already in and if not abstract
      var $$addStateInChain = function(chain, stateRef, nodeModel) {
        var conf,
          parentParams,
          ref = breadcrumbsService.parseStateRef(stateRef),
          force = false,
          skip = false;
        var isCopy = false;

        for(var i=0, l=chain.length; i<l; i+=1) {
          if( !(nodeModel && nodeModel.type === 'STATIC') ){
            if (chain[i].name === ref.state) {
              isCopy = true;
              return;
            }
          }else {
            isCopy = true;
          }
        }
        conf = isCopy ? angular.copy($state.get(ref.state)) : $state.get(ref.state);


        if(nodeModel.type === 'STATIC' && angular.isDefined(nodeModel.stateParams['url']) && nodeModel.stateParams['url'].length === 0){
          conf.abstract = true;
        }

        // conf = angular.copy($state.get(ref.state));
        // Get breadcrumb options
        if(conf.ncyBreadcrumb) {
          if(conf.ncyBreadcrumb.force){ force = true; }
          if(conf.ncyBreadcrumb.skip){ skip = true; }
        }
        if((!conf.abstract || $$options.includeAbstract || force) && !skip) {
          if(ref.paramExpr) {
            parentParams = $lastViewScope.$eval(ref.paramExpr);
          }

          if(nodeModel) {
            parentParams = nodeModel.stateParams;
            conf._ncyBreadcrumbLabel = nodeModel.title;
          }
          conf.ncyBreadcrumbLink = $state.href(ref.state, parentParams || $stateParams || {});
          conf.ncyBreadcrumbStateRef = stateRef;
          chain.unshift(conf);
        }
      };

      var $$breadcrumbParentMenu= function(stateRef) {
        var ref = breadcrumbsService.parseStateRef(stateRef),
            conf = $state.get(ref.state);
        return $$parentMenu(conf);
      };


      return {

        getTemplate: function(templates) {
          if($$options.templateUrl) {
            // templateUrl takes precedence over template
            return null;
          } else if(templates[$$options.template]) {
            // Predefined templates (bootstrap, ...)
            return templates[$$options.template];
          } else {
            return $$options.template;
          }
        },

        getTemplateUrl: function() {
          return $$options.templateUrl;
        },

        getTemplateLast: function(templates) {
          if($$options.templateLastUrl) {
            // templateUrl takes precedence over template
            return null;
          } else if(templates[$$options.templateLast]) {
            // Predefined templates (default)
            return templates[$$options.templateLast];
          } else {
            return $$options.templateLast;
          }
        },

        getTemplateLastUrl: function() {
          return $$options.templateLastUrl;
        },

        getStatesChain: function(/*exitOnFirst*/) { // Deliberately undocumented param, see getLastStep
          var chain = [];
          var _chain = $$breadcrumbParentMenu($state.$current.self.name).reverse();
          var isShowBreadCrumb = angular.isUndefinedOrNull($stateParams['ncyBreadcrumb'] && $stateParams['ncyBreadcrumb'].isShowBreadCrumb) ? true : $stateParams['ncyBreadcrumb'].isShowBreadCrumb;
          angular.forEach(_chain, function (node) {
            if (isShowBreadCrumb && node.model.state) {
              $$addStateInChain(chain, node.model.state, node.model);
            } else if (node.model.state === $state.$current.self.name) {
              $$addStateInChain(chain, node.model.state, node.model);
            }

          });

          // Prefix state treatment
          if($$options.prefixStateName) {
            if( sitemapService.getSiteMapNodes() ) {
              sitemapService.getSiteMapNodes().walk(function (node) {
                if(node.model.state === 'index' && isShowBreadCrumb){
                  $$addStateInChain(chain, node.model.state, node.model);
                }
              });
            }
            // $$addStateInChain(chain, $$options.prefixStateName);
          }

          return chain;
        },

        getLastStep: function() {
          var chain = this.getStatesChain(true);
          return chain.length ? chain[0] : undefined;
        },

        $getLastViewScope: function() {
          return $lastViewScope;
        }
      };
    }

    this.$get = BreadCrumb;
  }

  angular.module('eHRD.kernel.uiElements.breadcrumbs')
    .provider('$breadcrumbs', $Breadcrumb)

})();

/**
 * Created by Bruce on 2017/5/4.
 */
(function () {
  'use strict';

  BreadcrumbDirective.$inject = ['$state', '$interpolate', '$breadcrumbs', '$rootScope', 'breadcrumbsService', 'sitemapService'];
  function BreadcrumbDirective($state, $interpolate, $breadcrumb, $rootScope, breadcrumbsService, sitemapService) {

    var $$templates = {
      bootstrap2: '<ul class="breadcrumb">' +
      '<li ng-repeat="step in steps" ng-switch="$last || !!step.abstract" ng-class="{active: $last}">' +
      '<a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a>' +
      '<span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span>' +
      '<span class="divider" ng-hide="$last">/</span>' +
      '</li>' +
      '</ul>',
      bootstrap3: '<ol class="breadcrumb">' +
      '<li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract">' +
      '<a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a>' +
      '<span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span>' +
      '</li>' +
      '</ol>'
    };

    return {
      restrict: 'AE',
      replace: true,
      scope: {},
      template: $breadcrumb.getTemplate($$templates),
      templateUrl: $breadcrumb.getTemplateUrl(),
      link: {
        post: function postLink(scope) {
          var labelWatchers = [];

          var renderBreadcrumb = function() {
            breadcrumbsService.deregisterWatchers(labelWatchers);
            labelWatchers = [];
            var viewScope = $breadcrumb.$getLastViewScope();
            scope.steps = $breadcrumb.getStatesChain();

            angular.forEach(scope.steps, function (step) {
              if (step.ncyBreadcrumb && step.ncyBreadcrumb.label) {
                var parseLabel = $interpolate(step.ncyBreadcrumb.label);
                step.ncyBreadcrumbLabel = parseLabel(viewScope);
                // Watcher for further viewScope updates
                breadcrumbsService.registerWatchers(labelWatchers, parseLabel, viewScope, step);
              } else {
                step.ncyBreadcrumbLabel = step.name;
              }
            });
          };
          if(sitemapService.getMenu().length === 0 || $state.current.name === 'mySetting') {
            sitemapService.getProjectSideMenu().then(function (menuItems) {
              sitemapService.setMenu(menuItems);
              breadcrumbsService.registerListenerOnce('BreadcrumbDirective.$viewContentLoaded', $rootScope, '$viewContentLoaded', function (event) {
                if(!event.targetScope.ncyBreadcrumbIgnore) {
                  renderBreadcrumb();
                }
              });
              // View(s) may be already loaded while the directive's linking
              renderBreadcrumb();
            });
          } else {
            breadcrumbsService.registerListenerOnce('BreadcrumbDirective.$viewContentLoaded', $rootScope, '$viewContentLoaded', function (event) {
              if(!event.targetScope.ncyBreadcrumbIgnore) {
                renderBreadcrumb();
              }
            });

            // View(s) may be already loaded while the directive's linking
            renderBreadcrumb();
          }
        }
      }
    };
  }


  angular.module('eHRD.kernel.uiElements.breadcrumbs')
    .directive('breadcrumb', BreadcrumbDirective);

})();

/**
 * Created by Bruce on 2017/5/4.
 */
(function () {
  'use strict';

  BreadcrumbTextDirective.$inject = ['$interpolate', '$breadcrumbs', '$rootScope', 'breadcrumbsService'];
  function BreadcrumbTextDirective($interpolate, $breadcrumb, $rootScope, breadcrumbsService) {

    return {
      restrict: 'A',
      scope: {},
      template: '{{ncyBreadcrumbChain}}',

      compile: function(cElement, cAttrs) {
        // Override the default template if ncyBreadcrumbText has a value
        var template = cElement.attr(cAttrs.$attr.ncyBreadcrumbText);
        if(template) {
          cElement.html(template);
        }

        var separator = cElement.attr(cAttrs.$attr.ncyBreadcrumbTextSeparator) || ' / ';

        return {
          post: function postLink(scope) {
            var labelWatchers = [];

            var registerWatchersText = function(labelWatcherArray, interpolationFunction, viewScope) {
              angular.forEach(breadcrumbsService.getExpression(interpolationFunction), function(expression) {
                var watcher = viewScope.$watch(expression, function(newValue, oldValue) {
                  if (newValue !== oldValue) {
                    renderLabel();
                  }
                });
                labelWatcherArray.push(watcher);
              });
            };

            var renderLabel = function() {
              breadcrumbsService.deregisterWatchers(labelWatchers);
              labelWatchers = [];

              var viewScope = $breadcrumb.$getLastViewScope();
              var steps = $breadcrumb.getStatesChain();
              var combinedLabels = [];
              angular.forEach(steps, function (step) {
                if (step.ncyBreadcrumb && step.ncyBreadcrumb.label) {
                  var parseLabel = $interpolate(step.ncyBreadcrumb.label);
                  combinedLabels.push(parseLabel(viewScope));
                  // Watcher for further viewScope updates
                  registerWatchersText(labelWatchers, parseLabel, viewScope);
                } else {
                  combinedLabels.push(step.name);
                }
              });

              scope.ncyBreadcrumbChain = combinedLabels.join(separator);
            };

            breadcrumbsService.registerListenerOnce('BreadcrumbTextDirective.$viewContentLoaded', $rootScope, '$viewContentLoaded', function (event) {
              if(!event.targetScope.ncyBreadcrumbIgnore) {
                renderLabel();
              }
            });

            // View(s) may be already loaded while the directive's linking
            renderLabel();
          }
        };

      }
    };
  }


  angular.module('eHRD.kernel.uiElements.breadcrumbs')
    .directive('breadcrumbText', BreadcrumbTextDirective);
})();

/**
 * Created by Bruce on 2017/5/4.
 */
(function () {
  'use strict';

  BreadcrumbLastDirective.$inject = ['$interpolate', '$breadcrumbs', '$rootScope', 'breadcrumbsService'];
  function BreadcrumbLastDirective($interpolate, $breadcrumb, $rootScope, breadcrumbsService) {
    var $$templates = {
      'default': '{{ncyBreadcrumbLabel}}'
    };

    return {
      restrict: 'A',
      scope: {},
      template: $breadcrumb.getTemplateLast($$templates),
      templateUrl: $breadcrumb.getTemplateLastUrl(),
      compile: function(cElement, cAttrs) {

        // Override the default template if ncyBreadcrumbLast has a value
        // This should likely be removed in a future version since global
        // templating is now available for ncyBreadcrumbLast
        var template = cElement.attr(cAttrs.$attr.ncyBreadcrumbLast);
        if(template) {
          cElement.html(template);
        }

        return {
          post: function postLink(scope) {
            var labelWatchers = [];

            var renderLabel = function() {
              breadcrumbsService.deregisterWatchers(labelWatchers);
              labelWatchers = [];

              var viewScope = $breadcrumb.$getLastViewScope();
              var lastStep = $breadcrumb.getLastStep();
              if(lastStep) {
                scope.ncyBreadcrumbLink = lastStep.ncyBreadcrumbLink;
                if (lastStep.ncyBreadcrumb && lastStep.ncyBreadcrumb.label) {
                  var parseLabel = $interpolate(lastStep.ncyBreadcrumb.label);
                  scope.ncyBreadcrumbLabel = parseLabel(viewScope);
                  // Watcher for further viewScope updates
                  // Tricky last arg: the last step is the entire scope of the directive !
                  breadcrumbsService.registerWatchers(labelWatchers, parseLabel, viewScope, scope);
                } else {
                  scope.ncyBreadcrumbLabel = lastStep.name;
                }
              }
            };

            breadcrumbsService.registerListenerOnce('BreadcrumbLastDirective.$viewContentLoaded', $rootScope, '$viewContentLoaded', function (event) {
              if(!event.targetScope.ncyBreadcrumbIgnore) {
                renderLabel();
              }
            });

            // View(s) may be already loaded while the directive's linking
            renderLabel();
          }
        };

      }
    };
  }




  angular.module('eHRD.kernel.uiElements.breadcrumbs')
    .directive('breadcrumbLast', BreadcrumbLastDirective);
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';
  angular.module('eHRD.kernel.uiElements.media',[]);
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  YoutubePlayerEmbed.$inject = [];
  function YoutubePlayerEmbed() {
    return {
      scope: {
        autoplay: "=",
        start: "=",
        end: "=",
        params: "@",
        v: "@"
      },
      restrict: 'E',
      replace: true,
      template: '<iframe ng-src="http://www.youtube.com/embed/{{v}}{{querys}}" frameborder="0" allowfullscreen></iframe>',
      compile: function(/*elem, attrs, transcludeFn*/) {
        return function link (scope, element, attrs) {
          var
            paramsObject = {},
            paramsString = '';

          attrs.$observe('v', function(v) {
            scope.v = v;
          });

          // If <youtube params=""> already setup, then passing variable directly.
          if (attrs.params) {
            scope.querys = attrs.params;
            return;
          }

          // Else make querys.
          if (scope.autoplay) {
            paramsObject.autoplay = 1;
          }

          if (scope.start) {
            paramsObject.start = scope.start;
          }

          if (scope.end) {
            paramsObject.end = scope.end;
          }

          angular.forEach(paramsObject, function(value, key) {
            paramsString = paramsString + key + '=' + value + '&';
          });

          if ('' !== paramsString) {
            scope.querys = '?' + paramsString;
          }
        };
      }
    };
  }
  angular.module('eHRD.kernel.uiElements.media')
    .value('YoutubePlayerEmbed', YoutubePlayerEmbed)
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  MediaJustinLiveStreamPlayer.$inject = ['configure'];
  function MediaJustinLiveStreamPlayer(configure) {
    configure = configure || {
        type: 'justin'
      };

    return {
      restrict: 'E',
      scope: {
        channel: '@'
      },
      template:
      '<object type="application/x-shockwave-flash" '+
      'id="live_embed_player_flash" '+
      'data="http://www.' + configure.type + '.tv/widgets/live_embed_player.swf?channel={{channel}}">'+
      '<param name="allowFullScreen" value="true" />'+
      '<param name="allowScriptAccess" value="always" />'+
      '<param name="allowNetworking" value="all" />'+
      '<param name="auto_play" value="always">'+
      '<param name="wmode" value="transparent">'+
      '<param name="flashvars" value="auto_play=true&amp;channel={{channel}}&amp;start_volume=50" />'+
      '</object>',
      replace: true,
      compile: function(/*elem, attrs, transcludeFn*/) {
        return function link (scope, element/*, attrs*/) {
          // Prevent error when the Justin player connect source before scope.channel unready. (e.g. When ng-view)
          scope.$watch('channel', function(/*channel*/) {
            element.append('<param name="movie" value="http://www.' + configure.type + '.tv/widgets/live_embed_player.swf" />');
          });
        };
      }
    };
  }
  angular.module('eHRD.kernel.uiElements.media')
    .value('MediaJustinLiveStreamPlayer', MediaJustinLiveStreamPlayer)
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  MediaJustinLiveStreamChatroom.$inject = ['configure'];
  function MediaJustinLiveStreamChatroom(configure) {
    configure = configure || {
        type: 'justin'
      };

    return {
      restrict: 'A',
      compile: function(/*elem, attrs, transcludeFn*/) {
        return function link (scope, element, attrs) {
          var channel = attrs.channel ? attrs.channel : attrs.twitchChatChannel;
          element.attr('frameborder', '0');
          element.attr('scrolling', 'no');
          element.attr('src', 'http://' + configure.type + '.tv/chat/embed?channel=' + channel + '&amp;popout_chat=true');
        };
      }
    };
  }
  angular.module('eHRD.kernel.uiElements.media')
    .value('MediaJustinLiveStreamChatroom', MediaJustinLiveStreamChatroom)
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  function MediaFlashPlayerEmbed($window) {
    var isIEversion = detectIE($window);
    var template = function () {
      var html='';
      if(isIEversion){
        html =
          '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"  width="{{width}}"' +
          'codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=8,0,0,0" >'+
          '<param name="movie" value="{{src | trustAsResourceUrl}}" />'+
          '<param name="quality" value="high" />'+
          '<param name="bgcolor" value="#ffffff" />'+
          '<PARAM NAME="SCALE" VALUE="default">'+
          '<embed src="{{src | trustAsResourceUrl}}"  quality="high" type="application/x-shockwave-flash"  width="{{width}}" height="{{height}}" SCALE="default" bgcolor="#ffffff" pluginspage="http://www.macromedia.com/go/getflashplayer"></embed>'+
          '</object>'
      }else{
        html =
          '<object data="{{src}}" type="application/x-shockwave-flash">'+
          '<param name="allowscriptaccess" value="always" />'+
          '<param name="allowfullscreen" value="true" />'+
          '<param name="wmode" value="transparent" />'+
          '</object>'
      }
      return html;
    };

    return {
      scope: {
        src: "@",
        vars: "@",
        width:"@?",
        height:'@?'
      },
      restrict: 'E',
      replace: true,
      template: template,

      compile: function(/*elem, attrs, transcludeFn*/) {
        return function link (scope, element/*, attrs*/) {
          // Prevent error when the flash player connect source before scope.channel unready. (e.g. When ng-view)
          scope.$watch('src', function(src) {
            element.append('<param name="movie" value="' + src + '" />');
          });
          scope.$watch('vars', function(vars) {
            element.append('<param name="flashvars" value="' + vars + '" />');
          });
        };
      }
    };
  }

  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  function detectIE($window) {
    var ua = $window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  angular.module('eHRD.kernel.uiElements.media')
    .value('MediaFlashPlayerEmbed', MediaFlashPlayerEmbed)
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  factory.$inject = ['YoutubePlayerEmbed'];
  function factory(YoutubePlayerEmbed) {
    return YoutubePlayerEmbed();
  }

  angular.module('eHRD.kernel.uiElements.media')
    .directive('mediaYoutube', factory)
  ;
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  factory.$inject = ['MediaJustinLiveStreamPlayer'];
  function factory(MediaJustinLiveStreamPlayer) {
    return MediaJustinLiveStreamPlayer({
      type: 'twitch'
    });
  }

  angular.module('eHRD.kernel.uiElements.media')
    .directive('mediaTwitch', factory)
  ;
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  factory.$inject = ['MediaJustinLiveStreamChatroom'];
  function factory(MediaJustinLiveStreamChatroom) {
    return MediaJustinLiveStreamChatroom({
      type: 'twitch'
    });
  }

  angular.module('eHRD.kernel.uiElements.media')
    .directive('mediaTwitchChat', factory)
  ;
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  factory.$inject = ['MediaJustinLiveStreamChatroom'];
  function factory(MediaJustinLiveStreamChatroom) {
    return MediaJustinLiveStreamChatroom({
      type: 'twitch'
    });
  }

  angular.module('eHRD.kernel.uiElements.media')
    .directive('mediaTwitchChatChannel', factory)
  ;
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  factory.$inject = ['MediaJustinLiveStreamChatroom'];
  function factory(MediaJustinLiveStreamChatroom) {
    return MediaJustinLiveStreamChatroom({
      type: 'justin'
    });
  }

  angular.module('eHRD.kernel.uiElements.media')
    .directive('mediaJustinChat', factory)
  ;
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  factory.$inject = ['MediaJustinLiveStreamChatroom'];
  function factory(MediaJustinLiveStreamChatroom) {
    return MediaJustinLiveStreamChatroom({
      type: 'justin'
    });
  }

  angular.module('eHRD.kernel.uiElements.media')
    .directive('mediaJustinChatChannel', factory)
  ;
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  factory.$inject = ['MediaFlashPlayerEmbed','$window'];
  function factory(MediaFlashPlayerEmbed, $window) {
    return MediaFlashPlayerEmbed($window);
  }

  angular.module('eHRD.kernel.uiElements.media')
    .directive('mediaFlash', factory)
  ;
})();

/**
 * Created by Bruce on 2016/9/29.
 */
(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.angular-clock',[]);
})();

/**
 * Created by Bruce on 2016/9/30.
 */
(function() {
  'use strict';

  /**
   * Usage pattern
   * <ds-widget-clock data-gmt-offset="0"></ds-widget-clock>
   */
  // var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  // var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  dsWidgetClock.$inject = ['$interval', '$filter'];

  function dsWidgetClock($interval, $filter) {
    return clock($interval, $filter);
  }

  function clock($interval, $filter) {
    return {
      restrict: 'EA',
      scope: {
        gmtOffset: '=gmtOffset',
        digitalFormat: '=digitalFormat',
        showDigital: '=showDigital',
        showAnalog: '=showAnalog',
        startTime: '=startTime',
        theme: '=theme',
        majorsTotal: '=majorsTotal',
        onlyText: '=?'
      },
      templateUrl: 'app/kernel/ui-elements/angular-clock/views/clock-template.html',
      link: function(scope, element, attrs) {
        // var format; // date format
        var stopTime; // so that we can cancel the time updates
        var o = {};
        var gmtOffset = scope.gmtOffset;
        var digitalFormat = scope.digitalFormat ? scope.digitalFormat : 'HH:mm:ss';
        o.showDigital = scope.showDigital != null ? scope.showDigital : angular.isDefined(attrs.showDigital) ? true : false;
        o.showAnalog = scope.showAnalog != null ? scope.showAnalog : angular.isDefined(attrs.showAnalog) ? true : false;
        o.showGmtInfo = angular.isDefined(attrs.showGmtInfo) ? true : false;
        o.startTime = parseInt(scope.startTime, 10); // ms
        scope.themeClass = scope.theme ? scope.theme : attrs.theme ? attrs.theme : 'light';
        scope.onlyText = (angular.isUndefined(scope.onlyText) ? false : scope.onlyText);

        if (!o.showDigital && !o.showAnalog) {
          o.showAnalog = true;
          o.showDigital = true;
        }
        scope.gmtInfo = false;

        scope.date = getDate(o);

        scope.digital = o.showDigital ? 'Loading..' : false;
        scope.analog = o.showAnalog;
        scope.majors = attrs.majorsTotal ? new Array(parseInt(attrs.majorsTotal)) : new Array(12);
        scope.minors = new Array(60);
        var date = null;
        var tick = function() {
          if (!isNaN(o.startTime)) {
            o.startTime = o.startTime + 1000;
          }
          date = getDate(o);
          scope.date = date;
          if (o.showDigital) {
            scope.digital = timeText(date, digitalFormat, gmtOffset, $filter);
          }
        };

        stopTime = $interval(tick, 1000);
        // watch the expression, and update the UI on change.
        scope.$watch('gmtOffset', function(value/*, old*/) {

          gmtOffset = value;
          o.gmtOffset = (gmtOffset != null) ? getGMTbase100(gmtOffset) : false;
          if (o.showGmtInfo && o.gmtOffset !== false) {
            scope.gmtInfo = getGMTText(o.gmtOffset);
          }

          tick();
        });
        scope.$watch('digitalFormat', function(value, old) {
          if (value != old) {
            digitalFormat = value;
          }
        });
        scope.$watch('showDigital', function(value, old) {
          if (value != old) {
            o.showDigital = value;
            scope.digital = o.showDigital ? 'Loading..' : false;
          }
        });
        scope.$watch('showAnalog', function(value, old) {
          if (value != old) {
            o.showAnalog = value;
            scope.analog = value;
          }
        });
        scope.$watch('theme', function(value, old) {
          if (value != old) {
            scope.themeClass = value ? value : attrs.theme ? attrs.theme : 'light';
          }
        });
        // listen on DOM destroy (removal) event, and cancel the next UI update
        // to prevent updating time after the DOM element was removed.
        element.on('$destroy', function() {
          $interval.cancel(stopTime);
          stopTime = null;
        });

      }
    };
  }

  function getGMTbase100(offset) {
    offset = parseFloat(offset);
    var f = offset > 0 ? Math.floor(offset) : Math.ceil(offset),
      s = (offset % 1) / 0.6;

    return f + s;

  }

  // function getGMTbase60(offset) {
  //   var f = offset > 0 ? Math.floor(offset) : Math.ceil(offset),
  //     s = ((offset > 0 ? offset : offset * -1) % 1) * 60;
  //   return f + s;
  // }

  function getGMTText(offset) {

    var f = offset > 0 ? Math.floor(offset) : Math.ceil(offset),
      s = Math.round(((offset > 0 ? offset : offset * -1) % 1) * 60);

    return 'GMT' + (offset === 0 ? '' : ((offset > 0 ? ' +' : ' ') + lpad(f) + '.' + rpad(s).substring(0, 2)));

  }

  function lpad(num) {
    if (num < 0) {
      return (num > -10 ? '-0' : '-') + (num * -1);
    } else {
      return (num < 10 ? '0' : '') + num;
    }

  }

  function rpad(num) {
    return num + (num < 10 ? '0' : '');
  }
  // Checkfor offset and get correct time
  function getDate(o) {
    var now = (!isNaN(o.startTime)) ? new Date(o.startTime) : new Date();
    if (o.gmtOffset !== null && o.gmtOffset !== false) {
      /*Use GMT + gmtOffset
       convert to msec
       add local time zone offset
       get UTC time in msec*/
      var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      // create new Date object for different city
      // using supplied offset
      var offsetNow = new Date(utc + (3600000 * o.gmtOffset));
      return {
        hrs: offsetNow.getHours(),
        mins: offsetNow.getMinutes(),
        secs: offsetNow.getSeconds(),
        date: offsetNow
      };
    } else {
      // Use local time
      return {
        hrs: now.getHours(),
        mins: now.getMinutes(),
        secs: now.getSeconds(),
        date: now
      };
    }
  }

  function timeText(d, format, timezone, $filter) {
    return $filter('date')(d.date, format, timezone);
  }
  angular.module('eHRD.kernel.uiElements.angular-clock')
    .directive('dsWidgetClock', dsWidgetClock);
})();

(function () {
  'use strict';

  /**
   * @namespace permission.ui
   */

  /**
   * @param $stateProvider {Object}
   */
  function config($stateProvider) {
    'ngInject';

    $stateProvider.decorator('$state', function (state) {
      /**
       * Property containing full state object definition
       *
       * This decorator is required to access full state object instead of just it's configuration
       * Can be removed when implemented https://github.com/angular-ui/ui-router/issues/13.
       *
       * @returns {Object}
       */
      state.self.$$permissionState = function () {
        return state;
      };

      return state;
    });
  }

  /**
   * @param $rootScope {Object}
   * @param $state {Object}
   * @param PermTransitionProperties {permission.PermTransitionProperties}
   * @param PermTransitionEvents {permission.ui.PermTransitionEvents}
   * @param PermStateAuthorization {permission.ui.PermStateAuthorization}
   * @param PermStatePermissionMap {permission.ui.PermStatePermissionMap}
   */
  function run($rootScope, $state, PermTransitionProperties, PermTransitionEvents, PermStateAuthorization, PermStatePermissionMap) {
    'ngInject';

    /**
     * State transition interceptor
     */
    var $stateTransitionInterceptor = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {

      if (!isAuthorizationFinished()) {
        setStateAuthorizationStatus(true);
        setTransitionProperties();

        if (!PermTransitionEvents.areEventsDefaultPrevented()) {
          PermTransitionEvents.broadcastPermissionStartEvent();

          $state.transition = {};
          event.preventDefault();
          var statePermissionMap = new PermStatePermissionMap(PermTransitionProperties.toState);

          PermStateAuthorization
            .authorizeByPermissionMap(statePermissionMap)
            .then(function () {
              handleAuthorizedState();
            })
            .catch(function (rejectedPermission) {
              handleUnauthorizedState(rejectedPermission, statePermissionMap);
            })
            .finally(function () {
              setStateAuthorizationStatus(false);
            });
        } else {
          setStateAuthorizationStatus(false);
        }
      }

      /**
       * Updates values of `PermTransitionProperties` holder object
       * @method
       * @private
       */
      function setTransitionProperties() {
        PermTransitionProperties.toState = toState;
        PermTransitionProperties.toParams = toParams;
        PermTransitionProperties.fromState = fromState;
        PermTransitionProperties.fromParams = fromParams;
        PermTransitionProperties.options = options;
      }

      /**
       * Sets internal state `$$finishedAuthorization` variable to prevent looping
       * @method
       * @private
       *
       * @param status {boolean} When true authorization has been already preceded
       */
      function setStateAuthorizationStatus(status) {
        angular.extend(toState, {'$$isAuthorizationFinished': status});
      }

      /**
       * Checks if state has been already checked for authorization
       * @method
       * @private
       *
       * @returns {boolean}
       */
      function isAuthorizationFinished() {
        return toState.$$isAuthorizationFinished;
      }

      /**
       * Handles redirection for authorized access
       * @method
       * @private
       */
      function handleAuthorizedState() {
        PermTransitionEvents.broadcastPermissionAcceptedEvent();

        // Overwrite notify option to broadcast it later
        var transitionOptions = angular.extend({}, PermTransitionProperties.options, {notify: false, location: true});

        $state
          .go(PermTransitionProperties.toState.name, PermTransitionProperties.toParams, transitionOptions)
          .then(function () {
            PermTransitionEvents.broadcastStateChangeSuccessEvent();
          });
      }

      /**
       * Handles redirection for unauthorized access
       * @method
       * @private
       *
       * @param rejectedPermission {String} Rejected access right
       * @param statePermissionMap {permission.ui.PermPermissionMap} State permission map
       */
      function handleUnauthorizedState(rejectedPermission, statePermissionMap) {
        PermTransitionEvents.broadcastPermissionDeniedEvent();

        statePermissionMap
          .resolveRedirectState(rejectedPermission)
          .then(function (redirect) {
            $state.go(redirect.state, redirect.params, redirect.options);
          });
      }
    });

    $rootScope.$on('$destroy', $stateTransitionInterceptor);

  }

  angular
    .module('permission.ui', ['permission', 'ui.router'])
    .config(config)
    .run(run);
})();

(function () {
  'use strict';

  /**
   * Service responsible for managing and emitting events
   * @name permission.ui.PermTransitionEvents
   *
   * @extends permission.PermTransitionEvents
   *
   * @param $delegate {Object} Parent instance being extended
   * @param $rootScope {Object} Top-level angular scope
   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing transition parameters
   * @param PermTransitionEventNames {permission.ui.PermTransitionEventNames} Constant storing event names
   */
  function PermTransitionEvents($delegate, $rootScope, PermTransitionProperties, PermTransitionEventNames) {
    'ngInject';

    $delegate.areEventsDefaultPrevented = areEventsDefaultPrevented;
    $delegate.broadcastStateChangeSuccessEvent = broadcastStateChangeSuccessEvent;
    $delegate.broadcastPermissionStartEvent = broadcastPermissionStartEvent;
    $delegate.broadcastPermissionAcceptedEvent = broadcastPermissionAcceptedEvent;
    $delegate.broadcastPermissionDeniedEvent = broadcastPermissionDeniedEvent;

    /**
     * Checks if state events are not prevented by default
     * @methodOf permission.ui.PermTransitionEvents
     *
     * @returns {boolean}
     */
    function areEventsDefaultPrevented() {
      return isStateChangePermissionStartDefaultPrevented();
    }

    /**
     * Broadcasts "$stateChangePermissionStart" event from $rootScope
     * @methodOf permission.ui.PermTransitionEvents
     */
    function broadcastPermissionStartEvent() {
      $rootScope.$broadcast(PermTransitionEventNames.permissionStart,
        PermTransitionProperties.toState, PermTransitionProperties.toParams,
        PermTransitionProperties.options);
    }

    /**
     * Broadcasts "$stateChangePermissionAccepted" event from $rootScope
     * @methodOf permission.ui.PermTransitionEvents
     */
    function broadcastPermissionAcceptedEvent() {
      $rootScope.$broadcast(PermTransitionEventNames.permissionAccepted,
        PermTransitionProperties.toState, PermTransitionProperties.toParams,
        PermTransitionProperties.options);
    }

    /**
     * Broadcasts "$tateChangePermissionDenied" event from $rootScope
     * @methodOf permission.ui.PermTransitionEvents
     */
    function broadcastPermissionDeniedEvent() {
      $rootScope.$broadcast(PermTransitionEventNames.permissionDenies,
        PermTransitionProperties.toState, PermTransitionProperties.toParams,
        PermTransitionProperties.options);
    }

    /**
     * Broadcasts "$stateChangeSuccess" event from $rootScope
     * @methodOf permission.ui.PermTransitionEvents
     */
    function broadcastStateChangeSuccessEvent() {
      $rootScope.$broadcast('$stateChangeSuccess',
        PermTransitionProperties.toState, PermTransitionProperties.toParams,
        PermTransitionProperties.fromState, PermTransitionProperties.fromParams);
    }

    /**
     * Checks if event $stateChangePermissionStart hasn't been disabled by default
     * @methodOf permission.ui.PermTransitionEvents
     * @private
     *
     * @returns {boolean}
     */
    function isStateChangePermissionStartDefaultPrevented() {
      return $rootScope.$broadcast(PermTransitionEventNames.permissionStart,
        PermTransitionProperties.toState, PermTransitionProperties.toParams,
        PermTransitionProperties.options).defaultPrevented;
    }

    return $delegate;
  }

  angular
    .module('permission.ui')
    .decorator('PermTransitionEvents', PermTransitionEvents);
})();

(function () {
  'use strict';

  /**
   * Constant storing event names for ng-route
   * @name permission.ui.PermTransitionEventNames
   *
   * @type {Object.<String,Object>}
   *
   * @property permissionStart {String} Event name called when started checking for permissions
   * @property permissionAccepted {String} Event name called when authorized
   * @property permissionDenies {String} Event name called when unauthorized
   */
  var PermTransitionEventNames = {
    permissionStart: '$stateChangePermissionStart',
    permissionAccepted: '$stateChangePermissionAccepted',
    permissionDenies: '$stateChangePermissionDenied'
  };

  angular
    .module('permission.ui')
    .value('PermTransitionEventNames', PermTransitionEventNames);

})();

(function () {
  'use strict';

  /**
   * State Access rights map factory
   * @function
   *
   * @param PermPermissionMap {permission.PermPermissionMap|Function}
   *
   * @return {permission.ui.StatePermissionMap}
   */
  function PermStatePermissionMap(PermPermissionMap) {
    'ngInject';

    StatePermissionMap.prototype = new PermPermissionMap();

    /**
     * Constructs map instructing authorization service how to handle authorizing
     * @constructor permission.ui.StatePermissionMap
     * @extends permission.PermPermissionMap
     */
    function StatePermissionMap(state) {
      var toStateObject = state.$$permissionState();
      var toStatePath = toStateObject.path;

      angular.forEach(toStatePath, function (state) {
        if (areSetStatePermissions(state)) {
          var permissionMap = new PermPermissionMap(state.data.permissions);
          this.extendPermissionMap(permissionMap);
        }
      }, this);
    }

    /**
     * Extends permission map by pushing to it state's permissions
     * @methodOf permission.ui.StatePermissionMap
     *
     * @param permissionMap {permission.PermPermissionMap} Compensated permission map
     */
    StatePermissionMap.prototype.extendPermissionMap = function (permissionMap) {
      if (permissionMap.only.length) {
        this.only = this.only.concat([permissionMap.only]);
      }
      if (permissionMap.except.length) {
        this.except = this.except.concat([permissionMap.except]);
      }
      if (permissionMap.all.length) {
        this.all = this.all.concat([permissionMap.all]);
      }
      this.redirectTo = permissionMap.redirectTo;
    };


    /**
     * Checks if state has set permissions
     * We check for hasOwnProperty, because ui-router lets the `data` property inherit from its parent
     * @methodOf permission.ui.StatePermissionMap
     * @private
     *
     * @returns {boolean}
     */
    function areSetStatePermissions(state) {
      try {
        return Object.prototype.hasOwnProperty.call(state.data, 'permissions');
      } catch (e) {
        return false;
      }
    }

    return StatePermissionMap;
  }

  angular
    .module('permission.ui')
    .factory('PermStatePermissionMap', PermStatePermissionMap);
})();


(function () {
  'use strict';


  /**
   * @namespace permission
   */

  angular.module('permission', []);

})();

(function () {
  'use strict';

  /**
   * Service responsible for handling inheritance-enabled state-based authorization in ui-router
   * @extends permission.PermPermissionMap
   * @name permission.ui.PermStateAuthorization
   *
   * @param $q {Object} Angular promise implementation
   * @param $state {Object} State object
   * @param PermStatePermissionMap {permission.ui.PermStatePermissionMap|Function} Angular promise implementation
   */
  function PermStateAuthorization($q, $state, PermStatePermissionMap) {
    'ngInject';

    /**
     * Handles authorization based on provided state permission map
     * @methodOf permission.ui.PermStateAuthorization
     *
     * @param statePermissionMap
     *
     * @return {promise}
     */
    function authorizeByPermissionMap(statePermissionMap) {
      return authorizeStatePermissionMap(statePermissionMap);
    }

    /**
     * Authorizes uses by provided state name
     * @methodOf permission.ui.PermStateAuthorization
     *
     * @param stateName {String}
     * @returns {promise}
     */
    function authorizeByStateName(stateName) {
      var srefState = $state.get(stateName);
      var permissionMap = new PermStatePermissionMap(srefState);

      return authorizeByPermissionMap(permissionMap);
    }

    /**
     * Checks authorization for complex state inheritance
     * @methodOf permission.ui.PermStateAuthorization
     * @private
     *
     * @param map {permission.ui.StatePermissionMap} State access rights map
     *
     * @returns {promise} $q.promise object
     */
    function authorizeStatePermissionMap(map) {
      var deferred = $q.defer();

      resolveExceptStatePermissionMap(deferred, map);

      return deferred.promise;
    }

    /**
     * Resolves compensated set of "except" privileges
     * @methodOf permission.ui.PermStateAuthorization
     * @private
     *
     * @param deferred {Object} Promise defer
     * @param map {permission.ui.StatePermissionMap} State access rights map
     */
    function resolveExceptStatePermissionMap(deferred, map) {
      var exceptPromises = resolveStatePermissionMap(map.except, map);

      $q.all(exceptPromises)
        .then(function (rejectedPermissions) {
          deferred.reject(rejectedPermissions[0]);
        })
        .catch(function () {
          resolveOnlyStatePermissionMap(deferred, map);
        });
    }

    /**
     * Resolves compensated set of "only" privileges
     * @methodOf permission.ui.PermStateAuthorization
     * @private
     *
     * @param deferred {Object} Promise defer
     * @param map {permission.ui.StatePermissionMap} State access rights map
     */
    function resolveOnlyStatePermissionMap(deferred, map) {
      if (!map.only.length) {
        deferred.resolve();
        return;
      }
      var onlyPromises = resolveStatePermissionMap(map.only, map);

      $q.all(onlyPromises)
        .then(function (resolvedPermissions) {
          deferred.resolve(resolvedPermissions);
        })
        .catch(function (rejectedPermission) {
          deferred.reject(rejectedPermission);
        });
    }

    /**
     * Performs iteration over list of privileges looking for matches
     * @methodOf permission.ui.PermStateAuthorization
     * @private
     *
     * @param privilegesNames {Array} Array of sets of access rights
     * @param map {permission.ui.StatePermissionMap} State access rights map
     *
     * @returns {Array<Promise>} Promise collection
     */
    function resolveStatePermissionMap(privilegesNames, map) {
      if (!privilegesNames.length) {
        return [$q.reject()];
      }

      return privilegesNames.map(function (statePrivileges) {
        var resolvedStatePrivileges = map.resolvePropertyValidity(statePrivileges);
        return $q.any(resolvedStatePrivileges)
          .then(function (resolvedPermissions) {
            if (angular.isArray(resolvedPermissions)) {
              return resolvedPermissions[0];
            }
            return resolvedPermissions;
          });
      });
    }

    return{
      authorizeByPermissionMap: authorizeByPermissionMap,
      authorizeByStateName: authorizeByStateName
    };
  }

  angular
    .module('permission')
    .factory('PermStateAuthorization', PermStateAuthorization);
})();

(function () {
  'use strict';

  /**
   * Helper object used for storing ui-router/ng-route transition parameters
   * @name permission.PermTransitionProperties
   *
   * @type {Object.<String,Object>}
   *
   * Transition properties for ui-router:
   * @property toState {Object} Target state object [ui-router]
   * @property toParams {Object} Target state params [ui-router]
   * @property fromState {Object} Source state object [ui-router]
   * @property fromParams {Object} Source state params [ui-router]
   * @property options {Object} Transition options [ui-router]
   *
   * Transition properties for ng-route:
   * @property current {Object} Current state properties [ng-route]
   * @property next {Object} Next state properties [ng-route]
   */
  var PermTransitionProperties = {};

  angular
    .module('permission')
    .value('PermTransitionProperties', PermTransitionProperties);
})();

(function () {
  'use strict';

  /**
   * Interface responsible for managing and emitting events dependent on router implementation
   * @name permission.PermTransitionEvents
   */
  function PermTransitionEvents() {
    'ngInject';

    return{
      broadcastPermissionStartEvent: function () {
        throw new Error('Method broadcastPermissionStartEvent in PermTransitionEvents interface must be implemented');
      },
      broadcastPermissionAcceptedEvent: function () {
        throw new Error('Method broadcastPermissionAcceptedEvent in PermTransitionEvents interface must be implemented');
      },
      broadcastPermissionDeniedEvent: function () {
        throw new Error('Method broadcastPermissionDeniedEvent in PermTransitionEvents interface must be implemented');
      }
    };
  }

  angular
    .module('permission')
    .factory('PermTransitionEvents', PermTransitionEvents);

})();

(function () {
  'use strict';

  /**
   * Pre-defined available configurable behaviours of directive `permission`
   * @name permission.PermPermissionStrategies
   * @readonly
   *
   * @example
   * <div permission
   *      permission-except="'MANAGER'"
   *      permission-on-authorized="PermPermissionStrategies.renderContent"
   *      permission-on-unauthorized="PermPermissionStrategies.removeContent">
   * </div>
   *
   * @property enableElement {Function}
   * @property disableElement {Function}
   * @property showElement {Function}
   * @property hideElement {Function}
   */
  var PermPermissionStrategies = {
    enableElement: function ($element) {
      $element.removeAttr('disabled');
    },
    disableElement: function ($element) {
      $element.attr('disabled', 'disabled');
    },
    showElement: function ($element) {
      $element.removeClass('ng-hide');
    },
    hideElement: function ($element) {
      $element.addClass('ng-hide');
    }
  };

  angular
    .module('permission')
    .value('PermPermissionStrategies', PermPermissionStrategies)
    .value('PermissionStrategies', PermPermissionStrategies);
})();

(function () {
  'use strict';

  /**
   * Role definition storage
   * @name permission.PermRoleStore
   *
   * @param PermRole {permission.PermRole} Role definition constructor
   */
  function PermRoleStore(PermRole) {
    'ngInject';

    var roleStore = {};

    /**
     * Allows to add single role definition to the store by providing it's name and validation function
     * @methodOf permission.PermRoleStore
     *
     * @param roleName {String} Name of defined role
     * @param [validationFunction] {Function|Array<String>} Function used to validate if role is valid or set of
     *   permission names that has to be owned to have a role
     */
    function defineRole(roleName, validationFunction) {
      roleStore[roleName] = new PermRole(roleName, validationFunction);
    }

    /**
     * Allows to define set of roleNames with shared validation function
     * @methodOf permission.PermPermissionStore
     * @throws {TypeError}
     *
     * @param roleMap {String, Function|Array<String>} Map of roles with matching validators
     */
    function defineManyRoles(roleMap) {
      if (!angular.isObject(roleMap)) {
        throw new TypeError('Parameter "roleNames" name must be object');
      }

      angular.forEach(roleMap, function (validationFunction, roleName) {
        defineRole(roleName, validationFunction);
      });
    }

    /**
     * Deletes role from store
     * @method permission.PermRoleStore
     *
     * @param roleName {String} Name of defined permission
     */
    function removeRoleDefinition(roleName) {
      delete roleStore[roleName];
    }

    /**
     * Checks if role is defined in store
     * @method permission.PermRoleStore
     *
     * @param roleName {String} Name of role
     * @returns {Boolean}
     */
    function hasRoleDefinition(roleName) {
      return angular.isDefined(roleStore[roleName]);
    }

    /**
     * Returns role definition object by it's name
     * @method permission.PermRoleStore
     *
     * @returns {permission.PermRole} PermRole definition object
     */
    function getRoleDefinition(roleName) {
      return roleStore[roleName];
    }

    /**
     * Returns all role definitions
     * @method permission.PermRoleStore
     *
     * @returns {Object} Defined roles collection
     */
    function getStore() {
      return roleStore;
    }

    /**
     * Removes all role definitions
     * @method permission.PermRoleStore
     */
    function clearStore() {
      roleStore = {};
    }

    return{
      defineRole: defineRole,
      defineManyRoles: defineManyRoles,
      getRoleDefinition: getRoleDefinition,
      hasRoleDefinition: hasRoleDefinition,
      removeRoleDefinition: removeRoleDefinition,
      getStore: getStore,
      clearStore: clearStore
    }
  }

  angular
    .module('permission')
    .factory('PermRoleStore', PermRoleStore);
})();

(function () {
  'use strict';

  /**
   * Permission definition storage
   * @name permission.PermPermissionStore
   *
   * @param PermPermission {permission.PermPermission|Function}
   */
  function PermPermissionStore(PermPermission) {
    'ngInject';

    /**
     * @property permissionStore
     *
     * @type {Object}
     */
    var permissionStore = {};

    /**
     * Allows to define permission on application configuration
     * @methodOf permission.PermPermissionStore
     *
     * @param permissionName {String} Name of defined permission
     * @param validationFunction {Function} Function used to validate if permission is valid
     */
    function definePermission(permissionName, validationFunction) {
      permissionStore[permissionName] = new PermPermission(permissionName, validationFunction);
    }

    /**
     * Allows to define set of permissionNames with shared validation function on application configuration
     * @methodOf permission.PermPermissionStore
     * @throws {TypeError}
     *
     * @param permissionNames {Array<Number>} Set of permission names
     * @param validationFunction {Function} Function used to validate if permission is valid
     */
    function defineManyPermissions(permissionNames, validationFunction) {
      if (!angular.isArray(permissionNames)) {
        throw new TypeError('Parameter "permissionNames" name must be Array');
      }

      angular.forEach(permissionNames, function (permissionName) {
        definePermission(permissionName, validationFunction);
      });
    }

    /**
     * Deletes permission
     * @methodOf permission.PermPermissionStore
     *
     * @param permissionName {String} Name of defined permission
     */
    function removePermissionDefinition(permissionName) {
      delete permissionStore[permissionName];
    }

    /**
     * Checks if permission exists
     * @methodOf permission.PermPermissionStore
     *
     * @param permissionName {String} Name of defined permission
     * @returns {Boolean}
     */
    function hasPermissionDefinition(permissionName) {
      return angular.isDefined(permissionStore[permissionName]);
    }

    /**
     * Returns permission by it's name
     * @methodOf permission.PermPermissionStore
     *
     * @returns {permission.Permission} Permissions definition object
     */
    function getPermissionDefinition(permissionName) {
      return permissionStore[permissionName];
    }

    /**
     * Returns all permissions
     * @methodOf permission.PermPermissionStore
     *
     * @returns {Object} Permissions collection
     */
    function getStore() {
      return permissionStore;
    }

    /**
     * Removes all permissions
     * @methodOf permission.PermPermissionStore
     */
    function clearStore() {
      permissionStore = {};
    }

    return {
      definePermission: definePermission,
      defineManyPermissions: defineManyPermissions,
      removePermissionDefinition: removePermissionDefinition,
      hasPermissionDefinition: hasPermissionDefinition,
      getPermissionDefinition: getPermissionDefinition,
      getStore: getStore,
      clearStore: clearStore
    };
  }

  angular
    .module('permission')
    .factory('PermPermissionStore', PermPermissionStore);
})();

(function () {
  'use strict';

  /**
   * Role definition factory
   * @function
   *
   * @param $q {Object} Angular promise implementation
   * @param $injector {Object} Dependency injection instance
   * @param PermPermissionStore {permission.PermPermissionStore} Permission definition storage
   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
   *
   * @return {Role}
   */
  function PermRole($q, $injector, PermPermissionStore, PermTransitionProperties) {
    'ngInject';

    /**
     * Role definition constructor
     * @constructor Role
     *
     * @param roleName {String} Name representing role
     * @param validationFunction {Function|Array<String>} Optional function used to validate if permissions are still
     *   valid or list of permission names representing role
     */
    function Role(roleName, validationFunction) {
      validateConstructor(roleName, validationFunction);

      this.roleName = roleName;
      this.validationFunction = annotateValidationFunction(validationFunction);
    }

    /**
     * Checks if role is still valid
     * @methodOf permission.Role
     *
     * @returns {Promise} $q.promise object
     */
    Role.prototype.validateRole = function () {
      var validationLocals = {
        roleName: this.roleName,
        transitionProperties: PermTransitionProperties
      };
      var validationResult = $injector.invoke(this.validationFunction, null, validationLocals);

      if (!angular.isFunction(validationResult.then)) {
        validationResult = wrapInPromise(validationResult, this.roleName);
      }

      return validationResult;
    };

    /**
     * Converts a value into a promise, if the value is truthy it resolves it, otherwise it rejects it
     * @methodOf permission.Role
     * @private
     *
     * @param result {Boolean} Function to be wrapped into promise
     * @param [roleName] {String} Returned value in promise
     *
     * @return {Promise}
     */
    function wrapInPromise(result, roleName) {
      if (result) {
        return $q.resolve(roleName);
      }

      return $q.reject(roleName);
    }

    /**
     * Checks if provided permission has accepted parameter types
     * @methodOf permission.Role
     * @private
     *
     * @throws {TypeError}
     *
     * @param roleName {String} Name representing role
     * @param validationFunction {Function|Array<String>} Optional function used to validate if permissions are still
     *   valid or list of permission names representing role
     */
    function validateConstructor(roleName, validationFunction) {
      if (!angular.isString(roleName)) {
        throw new TypeError('Parameter "roleName" name must be String');
      }

      if (!angular.isArray(validationFunction) && !angular.isFunction(validationFunction)) {
        throw new TypeError('Parameter "validationFunction" must be array or function');
      }
    }


    /**
     * Ensures the validation is injectable using explicit annotation.
     * Wraps a non-injectable function for backwards compatibility
     * @methodOf permission.Role
     * @private
     *
     * @param validationFunction {Function|Array} Function to wrap with injectable if needed
     *
     * @return {Function} Explicitly injectable function
     */
    function annotateValidationFunction(validationFunction) {
      // Test if the validation function is just an array of permission names
      if (angular.isArray(validationFunction) && !angular.isFunction(validationFunction[validationFunction.length - 1])) {
        validationFunction = preparePermissionEvaluation(validationFunction);
      } else if (!angular.isArray(validationFunction.$inject || validationFunction)) {
        // The function is not explicitly annotated, so assume using old-style parameters
        // and manually prepare for injection using our known old API parameters
        validationFunction = ['roleName', 'transitionProperties', validationFunction];
      }

      return validationFunction;
    }

    /**
     * Creates an injectable function that evaluates a set of permissions in place of a role validation function
     * @methodOf permission.Role
     * @private
     *
     * @param permissions {Array<String>} List of permissions to evaluate
     *
     * @return {Function}
     */
    function preparePermissionEvaluation(permissions) {
      return function () {
        var promises = permissions.map(function (permissionName) {
          if (PermPermissionStore.hasPermissionDefinition(permissionName)) {
            var permission = PermPermissionStore.getPermissionDefinition(permissionName);

            return permission.validatePermission();
          }

          return $q.reject(permissionName);
        });

        return $q.all(promises);
      };
    }

    return Role;
  }

  angular
    .module('permission')
    .factory('PermRole', PermRole);

})();

(function () {
  'use strict';

  /**
   * PermPermission definition factory
   * @function
   *
   * @param $q {Object} Angular promise implementation
   * @param $injector {Object} Dependency injection instance
   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
   *
   * @return {Permission}
   */
  function PermPermission($q, $injector, PermTransitionProperties) {
    'ngInject';

    /**
     * PermPermission definition object constructor
     * @constructor Permission
     *
     * @param permissionName {String} Name repressing permission
     * @param validationFunction {Function} Function used to check if permission is valid
     */
    function Permission(permissionName, validationFunction) {
      validateConstructor(permissionName, validationFunction);

      this.permissionName = permissionName;
      this.validationFunction = annotateValidationFunction(validationFunction);
    }

    /**
     * Checks if permission is still valid
     * @methodOf permission.Permission
     *
     * @returns {Promise}
     */
    Permission.prototype.validatePermission = function () {
      var validationLocals = {
        permissionName: this.permissionName,
        transitionProperties: PermTransitionProperties
      };
      var validationResult = $injector.invoke(this.validationFunction, null, validationLocals);

      if (!angular.isFunction(validationResult.then)) {
        validationResult = wrapInPromise(validationResult, this.permissionName);
      }

      return validationResult;
    };

    /**
     * Converts a value into a promise, if the value is truthy it resolves it, otherwise it rejects it
     * @methodOf permission.Permission
     * @private
     *
     * @param result {Boolean} Function to be wrapped into promise
     * @param permissionName {String} Returned value in promise
     *
     * @return {Promise}
     */
    function wrapInPromise(result, permissionName) {
      if (result) {
        return $q.resolve(permissionName);
      }

      return $q.reject(permissionName);
    }

    /**
     * Checks if provided permission has accepted parameter types
     * @methodOf permission.Permission
     * @private
     *
     * @throws {TypeError}
     *
     * @param permissionName {String} Name repressing permission
     * @param validationFunction {Function} Function used to check if permission is valid
     */
    function validateConstructor(permissionName, validationFunction) {
      if (!angular.isString(permissionName)) {
        throw new TypeError('Parameter "permissionName" name must be String');
      }
      if (!angular.isFunction(validationFunction) && !angular.isArray(validationFunction)) {
        throw new TypeError('Parameter "validationFunction" must be Function or an injectable Function using explicit annotation');
      }
    }

    /**
     * Ensures the validation is injectable using explicit annotation.
     * Wraps a non-injectable function for backwards compatibility
     * @methodOf permission.Permission
     * @private
     *
     * @param validationFunction {Function} Function to wrap with injectable if needed
     *
     * @return {Function} Explicitly injectable function
     */
    function annotateValidationFunction(validationFunction) {
      if (!angular.isArray(validationFunction.$inject || validationFunction)) {
        // The function is not explicitly annotated, so assume using old-style parameters
        // and manually prepare for injection using our known old API parameters
        validationFunction = ['permissionName', 'transitionProperties', validationFunction];
      }

      return validationFunction;
    }

    return Permission;
  }

  angular
    .module('permission')
    .factory('PermPermission', PermPermission);
})();

(function () {
  'use strict';

  /**
   * Handles authorization based on provided permissions/roles.
   * @name permission.permissionDirective
   *
   * Directive accepts single or combined attributes `permission-only` and `permission-except` that checks on
   * DOM rendering if permissions/roles are met. Attributes can be passed either as String, Array or variable from
   * parent scope. Directive also will watch for changes if applied and automatically update the view.
   *
   * @example
   * <div permission
   *      permission-only="'USER'">
   * </div>
   * <div permission
   *      permission-only="['USER','ADMIN']"
   *      permission-except="'MANAGER'">
   * </div>
   * <div permission permission-sref="app.login"></div>
   *
   * By default directive will show/hide elements if provided permissions matches.
   * You can override this behaviour by passing `permission-on-authorized` and `permission-on-unauthorized`
   *   attributes that will pass to your function `$element` as argument that you can freely manipulate your DOM
   *   behaviour.
   *
   * Important! Function should be as references - `vm.disableElement` not `vm.disableElement()` to be able to
   *   accept passed $element reference from inside of permissionDirective
   *
   * @example
   * <div permission
   *      permission-only="['USER','ADMIN']"
   *      permission-on-authorized="PermPermissionStrategies.disableElement"
   *      permission-on-unauthorized="PermPermissionStrategies.enableElement">
   * </div>
   *
   * @param $log {Object} Logging service
   * @param $injector {Object} Injector instance object
   * @param PermPermissionMap {permission.permPermissionMap|Function} Map of state access rights
   * @param PermPermissionStrategies {permission.permPermissionStrategies} Set of pre-defined directive behaviours
   *
   * @returns {{
 *   restrict: string,
 *   bindToController: {
 *     sref: string
 *     only: string,
 *     except: string,
 *     onAuthorized: function,
 *     onUnauthorized: function
 *   },
 *   controllerAs: string,
 *   controller: controller
 * }} Directive instance
   */
  function PermissionDirective($log, $injector, PermPermissionMap, PermPermissionStrategies) {
    'ngInject';

    return {
      restrict: 'A',
      bindToController: {
        sref: '=?permissionSref',
        only: '=?permissionOnly',
        except: '=?permissionExcept',
        all: '=?permissionAll',
        onAuthorized: '&?permissionOnAuthorized',
        onUnauthorized: '&?permissionOnUnauthorized'
      },
      controllerAs: 'permission',
      controller: function ($scope, $element) {
        var permission = this;

        $scope.$watchGroup(['permission.only', 'permission.except', 'permission.all', 'sref'],
          function () {
            try {
              if (isSrefStateDefined()) {
                var PermStateAuthorization = $injector.get('PermStateAuthorization');

                PermStateAuthorization
                  .authorizeByStateName(permission.sref)
                  .then(function () {
                    onAuthorizedAccess();
                  })
                  .catch(function () {
                    onUnauthorizedAccess();
                  });
              } else {
                var PermAuthorization = $injector.get('PermAuthorization');
                var permissionMap = new PermPermissionMap({
                  only: permission.only,
                  except: permission.except,
                  all: permission.all
                });

                PermAuthorization
                  .authorizeByPermissionMap(permissionMap)
                  .then(function () {
                    onAuthorizedAccess();
                  })
                  .catch(function () {
                    onUnauthorizedAccess();
                  });
              }
            } catch (e) {
              onUnauthorizedAccess();
              $log.error(e.message);
            }
          });

        /**
         * Returns true when permissions should be checked based on state name
         * @private
         *
         * @returns {boolean}
         */
        function isSrefStateDefined() {
          return $injector.has('$state') && permission.sref;
        }

        /**
         * Calls `onAuthorized` function if provided or show element
         * @private
         */
        function onAuthorizedAccess() {
          if (angular.isFunction(permission.onAuthorized)) {
            permission.onAuthorized()($element);
          } else {
            PermPermissionStrategies.showElement($element);
          }
        }

        /**
         * Calls `onUnauthorized` function if provided or hide element
         * @private
         */
        function onUnauthorizedAccess() {
          if (angular.isFunction(permission.onUnauthorized)) {
            permission.onUnauthorized()($element);
          } else {
            PermPermissionStrategies.hideElement($element);
          }
        }
      }
    };
  }

  angular
    .module('permission')
    .directive('permission', PermissionDirective);
})();

(function () {
  'use strict';

  /**
   * Extends $q implementation by A+ *any* method
   * @name permission.$q
   *
   * @extends {angular.$q}
   *
   * @param $delegate {Object} Parent instance being extended
   */
  function $q($delegate) {
    'ngInject';

    $delegate.any = any;

    /**
     * Implementation of missing $q `any` method that wits for first resolution of provided promise set
     * @methodOf permission.$q
     *
     * @param promises {Array|promise} Single or set of promises
     *
     * @returns {Promise} Returns a single promise that will be rejected with an array/hash of values,
     *  each value corresponding to the promise at the same index/key in the `promises` array/hash.
     *  If any of the promises is resolved, this resulting promise will be returned
     *  with the same resolution value.
     */
    function any(promises) {
      var deferred = $delegate.defer(),
        counter = 0,
        results = angular.isArray(promises) ? [] : {};

      angular.forEach(promises, function (promise, key) {
        counter++;
        $delegate
          .when(promise)
          .then(function (value) {
            deferred.resolve(value);
          })
          .catch(function (reason) {
            results[key] = reason;
            if (!(--counter)) {
              deferred.reject(reason);
            }
          });
      });

      if (counter === 0) {
        deferred.reject(results);
      }

      return deferred.promise;
    }

    return $delegate;
  }

  angular
    .module('permission')
    .decorator('$q', $q);
})();

(function () {
  'use strict';

  /**
   * Access rights map factory
   * @name permission.PermPermissionMap
   *
   * @param $q {Object} Angular promise implementation
   * @param $log {Object} Angular logging utility
   * @param $injector {Object} Dependency injection instance
   * @param PermTransitionProperties {permission.PermTransitionProperties} Helper storing ui-router transition parameters
   * @param PermRoleStore {permission.PermRoleStore} Role definition storage
   * @param PermPermissionStore {permission.PermPermissionStore} Permission definition storage
   *
   * @return {permission.PermissionMap}
   */
  function PermPermissionMap($q, $log, $injector, PermTransitionProperties, PermRoleStore, PermPermissionStore) {
    'ngInject';

    /**
     * Constructs map object instructing authorization service how to handle authorizing
     * @constructor permission.PermissionMap
     *
     * @param [permissionMap] {Object} Map of permissions provided to authorization service
     * @param [permissionMap.only] {String|Array|Function} List of exclusive access right names allowed for
     *   authorization
     * @param [permissionMap.except] {String|Array|Function} List of exclusive access right names denied for
     *   authorization
     * @param [permissionMap.redirectTo] {String|Function|Object|promise} Handling redirection when rejected
     *   authorization
     */
    function PermissionMap(permissionMap) {
      // Suppress not defined object errors
      permissionMap = permissionMap || {};

      this.only = normalizeMapProperty(permissionMap.only);
      this.except = normalizeMapProperty(permissionMap.except);
      this.all = normalizeMapProperty(permissionMap.all);
      this.redirectTo = permissionMap.redirectTo;
    }

    /**
     * Redirects to fallback states when permissions fail
     * @methodOf permission.PermissionMap
     *
     * @param [rejectedPermissionName] {String} Permission name
     *
     * @return {Promise}
     */
    PermissionMap.prototype.resolveRedirectState = function (rejectedPermissionName) {
      if (angular.isFunction(this.redirectTo) || angular.isArray(this.redirectTo)) {
        return resolveFunctionRedirect(this.redirectTo, rejectedPermissionName);
      }

      if (angular.isObject(this.redirectTo)) {
        return resolveObjectRedirect(this.redirectTo, rejectedPermissionName);
      }

      if (angular.isString(this.redirectTo)) {
        return $q.resolve({
          state: this.redirectTo
        });
      }

      // If redirectTo state is not defined stay where you are
      return $q.reject();
    };

    /**
     * Resolves weather permissions set for "only" or "except" property are valid
     * @methodOf permission.PermissionMap
     *
     * @param property {Array} "only" or "except" map property
     *
     * @return {Array<Promise>}
     */
    PermissionMap.prototype.resolvePropertyValidity = function (property) {

      return property.map(function (privilegeName) {
        if (PermRoleStore.hasRoleDefinition(privilegeName)) {
          var role = PermRoleStore.getRoleDefinition(privilegeName);
          return role.validateRole();
        }

        if (PermPermissionStore.hasPermissionDefinition(privilegeName)) {
          var permission = PermPermissionStore.getPermissionDefinition(privilegeName);
          return permission.validatePermission();
        }

        $log.warn('Permission or role ' + privilegeName + ' was not defined.');
        return $q.reject(privilegeName);
      });
    };

    /**
     * Handles function based redirection for rejected permissions
     * @methodOf permission.PermissionMap
     *
     * @throws {TypeError}
     *
     * @param redirectFunction {Function} Redirection function
     * @param rejectedPermissionName {String} Rejected permission
     *
     * @return {Promise}
     */
    function resolveFunctionRedirect(redirectFunction, rejectedPermissionName) {
      if (!angular.isArray(redirectFunction.$inject || redirectFunction)) {
        redirectFunction = ['rejectedPermission', 'transitionProperties', redirectFunction];
      }

      return $q
        .when($injector.invoke(redirectFunction, null, {
          rejectedPermission: rejectedPermissionName,
          transitionProperties: PermTransitionProperties
        }))
        .then(function (redirectState) {
          if (angular.isString(redirectState)) {
            return {
              state: redirectState
            };
          }

          if (angular.isObject(redirectState)) {
            return redirectState;
          }

          return $q.reject();
        });
    }

    /**
     * Handles object based redirection for rejected permissions
     * @methodOf permission.PermissionMap
     *
     * @throws {ReferenceError}
     *
     * @param redirectObject {Object} Redirection function
     * @param permission {String} Rejected permission
     *
     * @return {Promise}
     */
    function resolveObjectRedirect(redirectObject, permission) {
      if (angular.isUndefined(redirectObject['default'])) {
        throw new ReferenceError('When used "redirectTo" as object, property "default" must be defined');
      }

      var redirectState = redirectObject[permission];

      if (angular.isUndefined(redirectState)) {
        redirectState = redirectObject['default'];
      }

      if (angular.isFunction(redirectState) || angular.isArray(redirectState)) {
        return resolveFunctionRedirect(redirectState, permission);
      }

      if (angular.isObject(redirectState)) {
        return $q.resolve(redirectState);
      }

      if (angular.isString(redirectState)) {
        return $q.resolve({
          state: redirectState
        });
      }
    }

    /**
     * Handles extraction of permission map "only" and "except" properties and converts them into array objects
     * @methodOf permission.PermissionMap
     * @private
     *
     * @param property {String|Array|Function} PermPermission map property "only" or "except"
     *
     * @returns {Array<String>} Array of permission "only" or "except" names
     */
    function normalizeMapProperty(property) {
      if (angular.isString(property)) {
        return [property];
      }

      if (angular.isArray(property)) {
        return property;
      }

      if (angular.isFunction(property)) {
        return property.call(null, PermTransitionProperties);
      }

      return [];
    }

    return PermissionMap;
  }

  angular
    .module('permission')
    .factory('PermPermissionMap', PermPermissionMap);
})();

(function () {
  'use strict';

  /**
   * Service responsible for handling view based authorization
   * @name permission.PermAuthorization
   *
   * @param $q {Object} Angular promise implementation
   */
  function PermAuthorization($q) {
    'ngInject';

    /**
     * Handles authorization based on provided permissions map
     * @methodOf permission.PermAuthorization
     *
     * @param map {permission.PermissionMap} Map of permission names
     *
     * @returns {promise} $q.promise object
     */
    function authorizeByPermissionMap(map) {
      return authorizePermissionMap(map);
    }

    /**
     * Checks authorization for simple view based access
     * @methodOf permission.PermAuthorization
     * @private
     *
     * @param map {permission.PermissionMap} Access rights map
     *
     * @returns {promise} $q.promise object
     */
    function authorizePermissionMap(map) {
      var deferred = $q.defer();
      resolveExceptPrivilegeMap(deferred, map);
      return deferred.promise;
    }

    /**
     * Resolves flat set of "except" privileges
     * @methodOf permission.PermAuthorization
     * @private
     *
     * @param deferred {Object} Promise defer
     * @param map {permission.PermissionMap} Access rights map
     *
     * @returns {Promise} $q.promise object
     */
    function resolveExceptPrivilegeMap(deferred, map) {
      var exceptPromises = map.resolvePropertyValidity(map.except);

      $q.any(exceptPromises)
        .then(function (rejectedPermissions) {
          deferred.reject(rejectedPermissions);
        })
        .catch(function () {
          // if(map.all.length > 0){
          //   resolveAllPermissionMap(deferred, map);
          // }else {
          //   resolveOnlyPermissionMap(deferred, map);
          // }
          resolveOnlyPermissionMap(deferred, map);
        });
    }

    /**
     * Resolves flat set of "only" privileges
     * @methodOf permission.PermAuthorization
     * @private
     *
     * @param deferred {Object} Promise defer
     * @param map {permission.PermissionMap} Access rights map
     */
    function resolveOnlyPermissionMap(deferred, map) {
      if (!map.only.length) {
        // deferred.resolve();
        resolveAllPermissionMap(deferred, map);
        return;
      }

      var onlyPromises = map.resolvePropertyValidity(map.only);
      $q.any(onlyPromises)
        .then(function (/*resolvedPermissions*/) {
          resolveAllPermissionMap(deferred, map);
          // deferred.resolve(resolvedPermissions);
        })
        .catch(function (rejectedPermission) {
          deferred.reject(rejectedPermission);
        });
    }

    /**
     * Resolves flat set of "all" privileges
     * @methodOf permission.PermAuthorization
     * @private
     *
     * @param deferred {Object} Promise defer
     * @param map {permission.PermissionMap} Access rights map
     */
    function resolveAllPermissionMap(deferred, map) {
      if (!map.all.length) {
        deferred.resolve();
        return;
      }

      var allPromises = map.resolvePropertyValidity(map.all);
      $q.all(allPromises)
        .then(function (resolvedPermissions) {
          deferred.resolve(resolvedPermissions);
        })
        .catch(function (rejectedPermission) {
          deferred.reject(rejectedPermission);
        });
    }



    return{
      authorizeByPermissionMap: authorizeByPermissionMap
    };
  }

  angular
    .module('permission')
    .factory('PermAuthorization', PermAuthorization);
})();

/**
 * Created by Bruce on 2016/7/21.
 */
(function () {
  'use strict';

  angular.module('eHRD.shared',[
    'eHRD.shared.server'
    // 'eHRD.kernel.translate'
  ]);
})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

  angular.module('eHRD.shared')
      .filter('sunnetPicture', sunnetPicture);

  /** @ngInject */
  function sunnetPicture(layoutPaths) {

    return function(input, ext) {
      ext = ext || 'jpg';
      return layoutPaths.images.sunnet + input + '.' + ext;
    };
  }

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

  angular.module('eHRD.shared')
      .filter('serverResource', serverResource);

  /** @ngInject */
  function serverResource(serverSetting) {

    return function(url, isNeedContextPath) {
      isNeedContextPath = isNeedContextPath || false;
      var baseURL = "";
      if(serverSetting.SSLType === 1){
        baseURL = [['https', serverSetting.serverDomain].join('://'), serverSetting.SSLPort].join((serverSetting.SSLPort.length > 0) ? ':' : '');
        if(isNeedContextPath){
          baseURL = [baseURL, serverSetting.contextPath].join('/');
          return baseURL + url;
        }else {
          return baseURL + url;
        }
      } else {
        if(isNeedContextPath){
          return serverSetting.baseConfig.baseURL + url;
        }else {
          return serverSetting.baseConfig.serverAddress + url;
        }
      }
    };
  }

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

  angular.module('eHRD.shared')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {

    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

  angular.module('eHRD.shared')
      .filter('makePicture', makePicture);

  /** @ngInject */
  function makePicture(layoutPaths) {

    return function(input, ext) {
      ext = ext || 'jpg';
      return layoutPaths.images.make + input + '.' + ext;
    };
  }

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

  angular.module('eHRD.shared')
      .filter('coursePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {

    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.course + input + '.' + ext;
    };
  }

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.user', []);

})();

/**
 * Created by Bruce on 2016/9/22.
 */
(function () {
  'use strict';

  userService.$inject = ['Restangular', 'serverSetting', 'fileProcess', '$auth'];
  function userService(Restangular, serverSetting, fileProcess, $auth) {
    var _UserService = Restangular.all('personal');
    var userProfileAvatarSize = $auth.getUserData().userProfileAvatarSize;
    return {

      getKernelUser: function () {
        return $auth.getUserData();
      },

      getUserProfile: function () {
        /*
        * api/personal/info
        * */
        return _UserService
              .customGET('info');
      },

      getUserProfileDetail: function () {
        /*
         * api/personal/info
         * */
        return _UserService
          .customGET('info-detail');
      },

      getUserProfileDetailById: function (userId) {
        /*
         * api/personal/info
         * */
        return _UserService
          .one(userId.toString())
          .customGET('info-detail');
      },

      getUserProfileById: function (userId) {
        /*
         * api/personal/{UserId}/info
         * */
        return _UserService
              .one(userId.toString())
              .customGET('info');
      },

      uploadUserAvatar: function (userId) {
        /*
         *  api/personal/{userId}/avatar
         *  File name uploadAvatar
         * */
        var url = serverSetting.baseConfig.baseApiPath + '/personal/' + userId + '/avatar';
        return new fileProcess.fileUpload(url, [], 'uploadAvatar', 'PUT', false, userProfileAvatarSize);
      },

      changePassword: function (formData, params) {
        /*
         * api/personal/{userId}/change-password
         * formData.oriPassword & formData.newPassword
         * */
        return _UserService
          .customPUT(formData, 'change-password', params);
      },

      updatePreferLang: function (userId, formData, params) {
        /*
         * api/personal/{userId}/preferlang
         * formData.rcId
         * */
        return _UserService
          .one(userId.toString())
          .customPUT(formData, 'preferlang', params);
      }



    };

  }

  angular.module('eHRD.modules.user')
    .factory('userService', userService);
})();

/**
 * Created by Bruce on 2016/9/22.
 */
(function () {
  'use strict';

  testQuestionnaireCenterService.$inject = ['Restangular'];
  function testQuestionnaireCenterService(Restangular){

    var _TestQuestionnaireCenterService = Restangular.all('my-learning-record');

    return {
      /*
       * Get list of incompleteCourses
       */
      list: function(params) {
        /*
         * api/my-learning-record/test-survey-courses/courselist
         * ?course_type:{ courseType }&program_type:{ programType } &sort:{ sort }&order:{ order }&current_page:{ currentPage }&list_size:{ listSize }
         */
        return _TestQuestionnaireCenterService
              // .one('incomplete', null)
              .customGETLIST('test-survey-courses', params);
      }
    };

  }


  angular.module('eHRD.modules.user')
    .factory('testQuestionnaireCenterService', testQuestionnaireCenterService);
})();

/**
 * Created by Bruce on 2016/10/20.
 */

(function () {
  'use strict';

  myLearningRecordsService.$inject = ['Restangular', '$httpParamSerializer'];
  function myLearningRecordsService(Restangular, $httpParamSerializer){

    var _MyLearningRecordsService = Restangular.all('my-learning-record');

    return {
      getMyTrainingRecords: function (params) {
        /*
         * api/my-learning-record/my-finished-enrollment
         * */
        return _MyLearningRecordsService
          .customGETLIST('my-finished-enrollment', params);
      },

      getSuggestLearningList: function (params) {
        /*
         * api/my-learning-record/recommen-learning-map
         * */
        return _MyLearningRecordsService
            .customGETLIST('recommen-learning-map', params);
      },

      updateSuggestLearningList: function (formData, params) {
        /*
         * api/my-learning-record/recommen-learning-map/update
         * */
        return _MyLearningRecordsService
            .one('recommen-learning-map')
            .customPUT($httpParamSerializer(formData), 'update', params, {"content-type": "application/x-www-form-urlencoded"});
      },

      deleteSuggestLearningList: function (formData, params) {
        /*
         * api/my-learning-record/recommen-learning-map/delete
         * */
        return _MyLearningRecordsService
            .one('recommen-learning-map')
            .customOperation('remove', 'delete', params, {"content-type": "application/x-www-form-urlencoded"},$httpParamSerializer(formData));
      },

      addSuggestLearningList: function (formData, params) {
        /*
         * api/my-learning-record/recommen-learning-map/add-view-item
         * */
        return _MyLearningRecordsService
            .one('recommen-learning-map')
            .customPOST({"addViewItems": formData}, 'add-view-item', params, {'Content-Type': 'application/json'});
      },

      deleteSuggestLearningTemp: function (params) {
        /*
         * api/my-learning-record/recommen-learning-map/delete-temp
         * */
        return _MyLearningRecordsService
            .one('recommen-learning-map')
            .customDELETE('delete-temp', params);
      },

      getSuggestLearningTemp: function (formData, params) {
        /*
         * api/my-learning-record/recommen-learning-map/view-temp-items
         * */
        return _MyLearningRecordsService
            .one('recommen-learning-map')
            .customPOST({"viewItems": formData}, 'view-temp-items', params, {'Content-Type': 'application/json'});
      }

    };

  }


  angular.module('eHRD.modules.user')
    .factory('myLearningRecordsService', myLearningRecordsService);
})();

/**
 * Created by Bruce on 2016/5/24.
 */
(function () {
  'use strict';

  incompleteCoursesService.$inject = ['Restangular'];
  function incompleteCoursesService(Restangular){

    var _IncompleteCoursesService = Restangular.all('my-learning-record');

    return {
      /*
       * Get list of incompleteCourses
       */
      list: function(params) {
        /*
         * api/my-learning-record/incomplete/courselist
         * ?course_type:{ courseType }&program_type:{ programType } &sort:{ sort }&order:{ order }&current_page:{ currentPage }&list_size:{ listSize }
         */
        return _IncompleteCoursesService
              // .one('incomplete', null)
              .customGETLIST('incompletecourses', params);
      },

      /*
       * Show specific incompleteCourses by Id
       */
      show: function(id) {
        // GET /api/incompleteCourses/:id
        return _IncompleteCoursesService.get(id);
      }
    };

  }


  angular.module('eHRD.modules.user')
    .factory('incompleteCoursesService', incompleteCoursesService);
})();

/**
 * Created by Alan on 2016/11/30.
 */
(function () {
    'use strict';

    deputyService.$inject = ['Restangular'];
    function deputyService(Restangular) {
      /*
       * Build collection api/deputy
       */
      var _DeputyService = Restangular.all('deputy');

      return {

        getDeputyRecords: function (params) {
            /*
             * api/deputy/records
             * */
            return _DeputyService
                .customGETLIST('records', params);
        },

        deleteDeputyRecords: function (params) {
          /*
           * api/deputy/records?idList={idList}
           * */
          return _DeputyService
              .one('records')
              .remove(params);
        },

        getAgents: function (params) {
          /*
           * api/deputy/agents?keyword={keyword}&current_page={current_page}&list_size={list_size}
           * */
          return _DeputyService
              .customGETLIST('agents',params);
        },

        insertAgent: function (formData, params) {
          /*
           * api/deputy/record?groupId={groupId}&deputyFrom={deputyFrom}&deputyTo={deputyTo}&agentId={agentId}
           * */
          return _DeputyService
              .customPOST(formData, 'record', params);
        },

        updateAgent: function (agentWorkId, params) {
          /*
           * api/deputy/record/{agentWorkId}?groupId={groupId}&deputyFrom={deputyFrom}&deputyTo={deputyTo}&agentId={agentId}
           * */
          return _DeputyService
              .one('record', agentWorkId)
              .put(params);
        },

        getMyManagedGroups: function () {
          /*
           * GET api/deputy/my-managed-groups
           * */
          return _DeputyService
            .customGET('my-managed-groups');
        }

      };

    }

    angular.module('eHRD.modules.user')
        .factory('deputyService', deputyService);
})();

/**
 * Created by Alan on 2016/1/10.
 */

(function () {
  'use strict';

  userDetail.$inject = ['$mdDialog'];
  function userDetail($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        userId: '=',
        isCertificate: '@?' // 0 or 1
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/user/views/user-detail.html',
            controller: ['userService', '$mdDialog', 'userId', 'isCertificate',
              function (userService, $mdDialog, userId, isCertificate) {
                var vm = this;
                vm.isCertificate = angular.isUndefined(isCertificate)?'0':isCertificate;
                userService.getUserProfileDetailById(userId).then(function(userProfile){
                  vm.userProfile = userProfile;
                });

                vm.close = function() {
                  $mdDialog.cancel();
                };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals:{
              userId: scope.userId,
              isCertificate: scope.isCertificate
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.user')
    .directive('userDetail', userDetail);

})();

/**
 * Created by Alan on 2016/12/7.
 */

(function () {
  'use strict';

  updateEstimatedCompletionDate.$inject = ['$mdDialog', '$filter', 'SweetAlert'];
  function updateEstimatedCompletionDate($mdDialog, $filter, SweetAlert) {
    var directive = {
      restrict: 'A',
      scope: {
          table: '=?',
          enrollmentIdList: '=?',
          permissionType: '@?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          var ceIds ="";
          var itemTypes ="";
          var canUpdate=true;
          angular.forEach(scope.enrollmentIdList, function(enrollmentId, key) {
            if(enrollmentId.value) {
              if(enrollmentId.canUpdate===1) {
                ceIds     += (ceIds==='')? key: "," + key;
                itemTypes += (itemTypes==='')? enrollmentId.itemType: "," + enrollmentId.itemType;
              }
              else {
                canUpdate = false;
              }
            }
          });
          if($filter('filter')(scope.enrollmentIdList, {value: true}).length === 0){
            SweetAlert.error('', $filter('translate')('MESSAGE.MSG_PLEASE_SELECT_AT_LEAST_ONE_ITEM'));
          }
          else if(canUpdate){
            $mdDialog.show({
              templateUrl: 'app/modules/user/views/update-estimated-completion-date.html',
              controller: ['myLearningRecordsService', 'managerService', '$mdDialog', 'table', 'permissionType',
                function (myLearningRecordsService, managerService, $mdDialog, table, permissionType) {
                  var vm = this;
                  vm.form ={
                    predictDate: new Date()
                  };

                  vm.submit = function (form) {
                    if(ceIds!=='') {
                      var formData ={
                        ceIds:       ceIds,
                        itemTypes:   itemTypes,
                        predictDate: moment(form.predictDate).format("YYYY/MM/DD")
                      };
                      if(permissionType==='manager'){
                        managerService.updateMemberSuggestLearningList(formData, {}).then(function () {
                          table.reload();
                        });
                      }
                      else{
                        myLearningRecordsService.updateSuggestLearningList(formData, {}).then(function () {
                          table.reload();
                        });
                      }

                    }
                    $mdDialog.cancel();
                  };

                  vm.close = function () {
                    $mdDialog.cancel();
                  };
                }],
              controllerAs: '$ctrl',
              targetEvent: ev,
              clickOutsideToClose: true,
              locals: {
                table: scope.table,
                permissionType: scope.permissionType
              },
              fullscreen: true // Only for -xs, -sm breakpoints.
            });
          }
          else
          {
            if(scope.permissionType==='manager'){
              SweetAlert.error('', $filter('translate')('MESSAGE.MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES_AND_MANAGER_SUGGESTION'));
            }
            else{
              SweetAlert.error('', $filter('translate')('MESSAGE.MSG_SORRY_YOU_CAN_ONLY_UPDATE_PLANNED_COMPLETION_DATE_OF_COURSE_FROM_SELF_REQUIRES'));
            }

          }

        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.user')
    .directive('updateEstimatedCompletionDate', updateEstimatedCompletionDate);

})();

/**
 * Created by Alan on 2016/12/6.
 */

(function () {
  'use strict';

  suggestLearningSearchDialog.$inject = ['$mdDialog'];
  function suggestLearningSearchDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
          table: '=?',
          permissionType: '@?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/user/views/suggest-learning-search-dialog.html',
            controller: ['PermPermissionStore', '$scope', 'NgTableParams', 'ctlService', '$mdDialog', 'filters', 'permissionType', 'SweetAlert', '$filter',
              function (PermPermissionStore, $scope, NgTableParams, ctlService, $mdDialog, filters, permissionType, SweetAlert, $filter) {
                var vm = this;
                var permission = null;
                permission = PermPermissionStore.getPermissionDefinition('Modules.training_plan');
                vm.hasTrainingPlanPermission = angular.isDefined(permission);
                permission = PermPermissionStore.getPermissionDefinition('Modules.training_roadmap');
                vm.hasTrainingRoadMapPermission = angular.isDefined(permission);
                permission = PermPermissionStore.getPermissionDefinition('Modules.competence');
                vm.hasCompetencePermission = angular.isDefined(permission);
                permission = PermPermissionStore.getPermissionDefinition('Modules.ksa');
                vm.hasKnowLedgePermission = angular.isDefined(permission);
                permission = PermPermissionStore.getPermissionDefinition('Modules.idp_for_cpas61');
                vm.hasIdpForCpasPermission = angular.isDefined(permission);
                permission = PermPermissionStore.getPermissionDefinition('Modules.idp_for_cpas61');
                vm.hasIdpForCpasPermission = angular.isDefined(permission);
                permission = PermPermissionStore.getPermissionDefinition('Modules.approval');
                vm.hasApprovalPermission = angular.isDefined(permission);
                vm.year = [];
                vm.month = [];
                var yearCount;
                var monthCount;
                for (yearCount = new Date().getFullYear()-10; yearCount <= new Date().getFullYear()+10; yearCount++) {
                  vm.year.push(yearCount);
                }
                for (monthCount = 0; monthCount <= 11; monthCount++) {
                  vm.month.push(monthCount);
                }
                vm.permissionType = permissionType;

                if(vm.permissionType==='manager') {
                  ctlService.getManagerGroups({}).then(function (managerGroups) {
                    vm.managerGroups = managerGroups;
                    vm.filters.groupId = (angular.isDefined(filters.groupId))?filters.groupId:vm.managerGroups[0].value;
                  });

                  $scope.$watch('$ctrl.filters.groupId', function(newValue, oldValue) {
                    var params = {
                      groupId: vm.filters.groupId
                    };
                    ctlService.getManagerMembers(params).then(function (managerMembers) {
                      vm.managerMembers = managerMembers;
                      if(angular.isDefined(vm.managerMembers[0])){
                        if(angular.isUndefined(oldValue)){
                          vm.filters.memberId = (angular.isDefined(filters.memberId))?filters.memberId:vm.managerMembers[0].value;
                        }else {
                          vm.filters.memberId = vm.managerMembers[0].value;
                        }
                      }
                    });
                  });
                }

                vm.filters = {
                  lmYearBegin:  (angular.isDefined(filters.lmYearBegin))?filters.lmYearBegin:new Date().getFullYear(),
                  lmMonthBegin: (angular.isDefined(filters.lmMonthBegin))?filters.lmMonthBegin:0,
                  lmYearEnd:    (angular.isDefined(filters.lmYearEnd))?filters.lmYearEnd:new Date().getFullYear(),
                  lmMonthEnd:   (angular.isDefined(filters.lmMonthEnd))?filters.lmMonthEnd:11,
                  sourceType:   (angular.isDefined(filters.sourceType))?filters.sourceType:-101,
                  searchStatus: (angular.isDefined(filters.searchStatus))?filters.searchStatus:'All'
                };

                vm.submit = function(filters) {
                  if( (filters.lmYearBegin > filters.lmYearEnd) || (filters.lmYearBegin === filters.lmYearEnd && filters.lmMonthBegin > filters.lmMonthEnd)) {
                    SweetAlert.error('',$filter('translate')('MESSAGE.MSG_THE_START_DATE_NEED_TO_EARLIER_THAN_THE_END_DATE'));
                  }
                  else {
                    $mdDialog.hide(filters);
                  }

                };
                vm.close = function() {
                  $mdDialog.cancel();
                };
            }],
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
                filters : scope.table.filter(),
                permissionType: scope.permissionType
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function(filters) {
                  scope.table.filter(filters);
                  scope.table.reload();
              }, function() { }
          );
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.user')
    .directive('suggestLearningSearchDialog', suggestLearningSearchDialog);

})();

/**
 * Created by Alan on 2016/12/1.
 */

(function () {
  'use strict';

  deputyRecordDialog.$inject = ['$mdDialog'];
  function deputyRecordDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
          table: '=?',
          data: '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/user/views/deputy-record-dialog.html',
            controller: ['$scope', 'NgTableParams', 'deputyService', '$mdDialog', '$filter', 'SweetAlert', 'table', 'data',
              function ($scope, NgTableParams, deputyService, $mdDialog, $filter, SweetAlert, table, data) {
                var vm = this;
                var formTime;
                var toTime;
                vm.keyword ='';

                if(angular.isDefined(data)){
                  vm.agentFullName = data.agentName;
                  formTime = data.deputyFrom.split(" ")[1].split(":");
                  toTime = data.deputyTo.split(" ")[1].split(":");
                  vm.deputyFromHH = parseInt(formTime[0]);
                  vm.deputyFromMM = parseInt(formTime[1]);
                  vm.deputyToHH = parseInt(toTime[0]);
                  vm.deputyToMM = parseInt(toTime[1]);
                }
                else {
                    vm.deputyFromHH = 0;
                    vm.deputyFromMM = 0;
                    vm.deputyToHH = 0;
                    vm.deputyToMM = 0;
                }
                vm.form = {
                    groupId:    (angular.isDefined(data))?data.deputyGroupId:-1,
                    deputyFrom: (angular.isDefined(data))?new Date(data.deputyFrom):new Date(),
                    deputyTo:   (angular.isDefined(data))?new Date(data.deputyTo):new Date(),
                    agentId:    (angular.isDefined(data))?data.agentId:""
                };

                vm.agentTable = new NgTableParams({}, {
                  counts: [1,5,10,15],
                  getData: function(tableParams) {
                      var params = {};
                      params.keyword = vm.keyword;
                      params.current_page = tableParams.url().page;
                      params.list_size = tableParams.url().count;
                      return deputyService.getAgents(params).then(function (agents) {
                          tableParams.total(agents.metadata.pagination.total);
                          return agents;
                      });
                  }
                });
                $scope.$watch('$ctrl.keyword', function(keyword) {
                    vm.keyword = keyword;
                    vm.agentTable.reload();
                });

                deputyService.getMyManagedGroups().then(function (managedGroups) {
                  vm.managedGroups = managedGroups;
                });
                vm.getAgentFullName = function(agentFullName){
                  vm.agentFullName =agentFullName;
                };
                vm.submit = function(form) {
                    var check = 1;
                    var deputyFrom = new Date($filter('dateTimeFormat')(form.deputyFrom, vm.deputyFromHH, vm.deputyFromMM, '/'));
                    var deputyTo = new Date($filter('dateTimeFormat')(form.deputyTo, vm.deputyToHH, vm.deputyToMM, '/'));
                    if(form.deputyFrom===''){
                        SweetAlert.error('',$filter('translate')('MESSAGE.MSG_DEPUTY_EFFECTIVE_DATE_CNA_NOT_EMPTY'));
                        check = 0;
                    }
                    else if(form.deputyTo===''){
                        SweetAlert.error('',$filter('translate')('MESSAGE.MSG_DEPUTY_END_DATE_CNA_NOT_EMPTY'));
                        check = 0;
                    }
                    else if(deputyFrom >= deputyTo){
                        SweetAlert.error('',$filter('translate')('MESSAGE.MSG_DEPUTY_END_DATE_CNA_NOT_BE_EARLIER_THAN_DEPUTY_EFFECTIVE_DATE'));
                        check = 0;
                    }
                    else if(form.agentId===''){
                        SweetAlert.error('',$filter('translate')('MESSAGE.MSG_PLEASE_SETTING_DEPUTY'));
                        check = 0;
                    }
                    var params ={
                        groupId: form.groupId,
                        deputyFrom: $filter('dateTimeFormat')(form.deputyFrom, vm.deputyFromHH, vm.deputyFromMM, '/'),
                        deputyTo: $filter('dateTimeFormat')(form.deputyTo, vm.deputyToHH, vm.deputyToMM, '/'),
                        agentId: form.agentId
                    };
                    if(check === 1){
                      if(angular.isDefined(data)){
                        deputyService.updateAgent(data.agentWorkId, params).then(function (result) {
                          if(result.status === 0){
                              SweetAlert.success('', $filter('translate')('MESSAGE.MSG_EDIT_DEPUTY_RECORD_SUCCESSFUL'));
                              table.reload();
                              $mdDialog.cancel();
                          }else {
                              SweetAlert.error('', $filter('translate')( 'ERROR.' + result.message));
                          }
                        });
                      }
                      else{
                        deputyService.insertAgent("", params).then(function (result) {
                          if(result.status === 0){
                              SweetAlert.success('', $filter('translate')('MESSAGE.MSG_SETTING_DEPUTY_SUCCESSFUL'));
                              table.reload();
                              $mdDialog.cancel();
                          }else {
                              SweetAlert.error('', $filter('translate')( 'ERROR.' + result.message));
                          }
                        });
                      }
                    }
                };
                vm.close = function() {
                  $mdDialog.cancel();
                };
            }],
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              table: scope.table,
              data:   scope.data
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.user')
    .directive('deputyRecordDialog', deputyRecordDialog);

})();

/**
 * Created by Alan on 2017/2/24.
 */

(function () {
  'use strict';

  deleteSuggestLearningList.$inject = ['myLearningRecordsService', 'managerService', '$filter', 'SweetAlert'];
  function deleteSuggestLearningList(myLearningRecordsService, managerService, $filter, SweetAlert) {
    var directive = {
      restrict: 'A',
      scope: {
        table: '=?',
        enrollmentIdList: '=?',
        permissionType: '@?'
      },
      link: function (scope, element) {
        element.bind('click', function() {
          var ceIds ="";
          var itemTypes ="";
          var canDeletefromType = true;
          var canDeleteUnenroll = true;
          var canDeletefromTypeMessage = "";
          var canDeleteUnenrollMessage = "";
          angular.forEach(scope.enrollmentIdList, function(enrollmentId, key) {
            if(enrollmentId.value) {
              if(enrollmentId.canDelete===1) {
                ceIds     += (ceIds==='')? key: "," + key;
                itemTypes += (itemTypes==='')? enrollmentId.itemType: "," + enrollmentId.itemType;
              }
              else {
                if(enrollmentId.sourceInfos[0].fromType!=='Self' && scope.permissionType !== 'manager') {
                  canDeletefromType = false;
                  canDeletefromTypeMessage = $filter('translate')('MESSAGE.MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_SELF_REQUIRED_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT');
                }
                else if(enrollmentId.sourceInfos[0].fromType!=='Manager' && scope.permissionType === 'manager') {
                  canDeletefromType = false;
                  canDeletefromTypeMessage = $filter('translate')('MESSAGE.MSG_SORRY_YOU_ONLY_DELETE_COURSES_FORM_MANAGER_SUGGEST_WHICH_ARE_STILL_OPEN_FOR_ENROLLMENT');
                }

                if(enrollmentId.sourceInfos[0].fromType==='Self' && enrollmentId.status!=='Unenroll'){
                  canDeleteUnenroll = false;
                  canDeleteUnenrollMessage = $filter('translate')('MESSAGE.MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_YOU_HAVE_ENROLLED_IN');
                }
                else if(enrollmentId.sourceInfos[0].fromType==='Manager' && enrollmentId.status!=='Unenroll'){
                  canDeleteUnenroll = false;
                  canDeleteUnenrollMessage = $filter('translate')('MESSAGE.MSG_SORRY_YOU_CANNOT_DELETE_COURSES_WHICH_EMPLOYEES_HAVE_ENROLLED_IN');
                }
              }
            }
          });

          if($filter('filter')(scope.enrollmentIdList, {value: true}).length === 0) {
            SweetAlert.error('', $filter('translate')('MESSAGE.MSG_PLEASE_SELECT_AT_LEAST_ONE_ITEM'));
          }
          else if(canDeletefromType!==false && canDeleteUnenroll === false) {
            SweetAlert.error('', canDeletefromTypeMessage +'<br>' + canDeleteUnenrollMessage );
          }
          else if(canDeletefromType === false) {
            SweetAlert.error('', canDeletefromTypeMessage);
          }
          else if(canDeleteUnenroll===false) {
            SweetAlert.error('', canDeleteUnenrollMessage);
          }
          else
          {
            SweetAlert.check($filter('translate')('MESSAGE.MSG_CONFIRM_TO_DELETE'), '', 'warning', function() {
              var formData ={
                ceIds: ceIds,
                itemTypes: itemTypes
              };

              if(scope.permissionType === 'manager') {
                managerService.deleteMemberSuggestLearningList(formData, {}).then(function () {
                  scope.table.reload();
                });
              }
              else {
                myLearningRecordsService.deleteSuggestLearningList(formData, {}).then(function () {
                  scope.table.reload();
                });
              }
            });

          }

        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.user')
    .directive('deleteSuggestLearningList', deleteSuggestLearningList);

})();

/**
 * Created by Alan on 2016/12/8.
 */

(function () {
  'use strict';

  addSuggestLearningList.$inject = ['$mdDialog'];
  function addSuggestLearningList($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
          table: '=?',
          permissionType: '@?',
          userId: '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/user/views/add-suggest-learning-list.html',
            controller: ['$scope', 'NgTableParams', 'ctlService', 'managerService', 'myLearningRecordsService', '$mdDialog', 'table', 'permissionType', 'userId', 'WizardHandler', '$filter', 'SweetAlert', '$window',
              function ($scope, NgTableParams, ctlService, managerService, myLearningRecordsService, $mdDialog, table, permissionType, userId, WizardHandler, $filter, SweetAlert, $window) {
                var vm = this;
                var chooseFormData = [];
                vm.permissionType = permissionType;
                vm.temp = [];
                vm.chooseList = [];
                vm.chooseList.other = [];
                vm.other = {
                  itemName: '',
                  otherDescription: '',
                  update: 0
                };
                vm.selectAll = false;
                vm.courseSelectAll = false;
                vm.tempItemsTable = new NgTableParams({}, {
                  counts: [],
                  getData: function() {
                    var params = {
                      userId: userId
                    };
                    vm.suggestLearningList = [];
                    if(vm.permissionType==='manager'){
                      managerService.getMemberSuggestLearningTemp(chooseFormData, params).then(function (suggestLearningList) {
                        angular.forEach(suggestLearningList, function(value, key) {
                          var itemName =(value.itemType===99)?vm.chooseList.other[key].itemName:value.itemName;
                          var otherDescription =(value.itemType===99)?vm.chooseList.other[key].otherDescription:'';
                          vm.suggestLearningList.push({
                            itemType: value.itemType,
                            itemId: value.itemId,
                            itemTypeName: value.itemTypeName,
                            itemName: itemName,
                            otherDescription: otherDescription,
                            status: value.status,
                            disabled: value.disabled
                          });
                          if(value.disabled===1) {
                            vm.temp[value.itemType + "_" + value.itemId].checkValue = false;
                          }
                        });
                      });
                    }
                    else{
                      myLearningRecordsService.getSuggestLearningTemp(chooseFormData).then(function (suggestLearningList) {
                        angular.forEach(suggestLearningList, function(value, key) {
                          var itemName =(value.itemType===99)?vm.chooseList.other[key].itemName:value.itemName;
                          var otherDescription =(value.itemType===99)?vm.chooseList.other[key].otherDescription:'';
                          vm.suggestLearningList.push({
                            itemType: value.itemType,
                            itemId: value.itemId,
                            itemTypeName: value.itemTypeName,
                            itemName: itemName,
                            otherDescription: otherDescription,
                            status: value.status,
                            disabled: value.disabled
                          });
                          if(value.disabled===1) {
                            vm.temp[value.itemType + "_" + value.itemId].checkValue = false;
                          }
                        });
                      });
                    }


                    return vm.suggestLearningList ;
                  }
                });

                vm.deleteTemp = function () {
                      var params = {
                          userId: userId
                      };
                      if(vm.permissionType==='manager') {
                          managerService.deleteMemberSuggestLearningTemp(params).then(function () {});
                      }
                      else
                          myLearningRecordsService.deleteSuggestLearningTemp().then(function () {});
                  };

                vm.chooseItemPage = function () {
                  vm.wzBtn ={
                      next:true,
                      previous: false,
                      finish: false
                  };
                  return true;
                };

                vm.chooseItemPage();
                vm.deleteTemp();

                vm.addSuggestLearning = function () {
                    var formData = [];
                    var params = {
                        userId: userId
                    };
                    angular.forEach(vm.suggestLearningList, function(value, key) {
                      var predictDueDate =(value.itemType===99)?vm.chooseList.other[key].predictDueDate:vm.temp[value.itemType + "_" + value.itemId].predictDueDate;
                      var checkValue =(value.itemType===99)?vm.chooseList.other[key].checkValue:vm.temp[value.itemType + "_" + value.itemId].checkValue;
                      if(checkValue===true){
                        formData.push({
                          itemType: value.itemType,
                          itemId: value.itemId,
                          otherName: value.itemName,
                          otherDescription: value.otherDescription,
                          predictDueDate: (angular.isDate(predictDueDate))?moment(predictDueDate).format("YYYY/MM/DD"):""
                        });
                      }
                    });
                    if(formData.length > 0){
                      if(vm.permissionType==='manager'){
                        managerService.addMemberSuggestLearningList(formData, params).then(function () {
                          table.reload();
                          $mdDialog.cancel();
                        });
                      }
                      else
                        myLearningRecordsService.addSuggestLearningList(formData).then(function () {
                          table.reload();
                          $mdDialog.cancel();
                        });
                    }
                };

                // watch for check all checkbox
                $scope.$watch(function() {
                  return vm.selectAll;
                }, function(value) {
                  angular.forEach(vm.suggestLearningList, function(suggestLearningList, key) {
                    if(suggestLearningList.disabled===0){
                      if(suggestLearningList.itemType===99)
                        vm.chooseList.other[key].checkValue = value;
                      else
                        vm.temp[suggestLearningList.itemType + "_" + suggestLearningList.itemId].checkValue = value;
                    }
                  });
                });

                $scope.$watch(function(){
                  return $window.innerWidth;
                },function(){
                  if ($window.innerWidth <= 1024) {
                    vm.dialogFullScreen = {
                      'max-width': '100%',
                      'max-height': '100%',
                      'width': '100%',
                      'height': '100%',
                      'border-radius': 0
                    };
                  } else {
                    vm.dialogFullScreen = {};
                  }
                });

                vm.addOther = function (other) {
                  if(angular.isUndefined(vm.other.updateIndex)) {
                    vm.chooseList.other.push({
                      itemType: 99,
                      itemId: 0,
                      itemTypeName: '',
                      itemName: other.itemName,
                      otherDescription: other.otherDescription,
                      status: '',
                      predictDueDate: null,
                      checkValue: true
                    });
                  }
                  else {
                    vm.chooseList.other[vm.other.updateIndex].itemName = other.itemName;
                    vm.chooseList.other[vm.other.updateIndex].otherDescription = other.otherDescription;
                  }
                  vm.clearOther();
                };

                vm.removeOther = function (index) {
                  vm.chooseList.other.splice(index, 1);
                  if(vm.other.update===1)
                    vm.clearOther();
                };

                vm.getOther = function (index) {
                  vm.other = {
                    itemName: vm.chooseList.other[index].itemName,
                    otherDescription: vm.chooseList.other[index].otherDescription,
                    update: 1,
                    updateIndex: index
                  };
                };

                vm.clearOther = function () {
                  vm.other = {
                    itemName: '',
                    otherDescription: '',
                    update: 0
                  };
                };

                vm.addItemPage = function () {
                  vm.wzBtn ={
                    next:false,
                    previous: true,
                    finish: true
                  };
                  return true;
                };

                vm.nextStep = function () {
                    chooseFormData = [];

                  angular.forEach(vm.chooseList.other, function(value) {
                    chooseFormData.push({
                      itemType: value.itemType,
                      itemId: value.itemId
                    });
                  });

                  angular.forEach(vm.chooseList, function(value) {
                    chooseFormData.push({
                        itemType: value.itemType,
                        itemId: value.itemId
                    });
                    if(angular.isUndefinedOrNull(vm.temp[value.itemType + "_" + value.itemId])) {
                      vm.temp[value.itemType + "_" + value.itemId] = {
                        checkValue: true,
                        predictDueDate: null
                      }
                    }
                  });

                  if(chooseFormData.length > 0){
                    vm.tempItemsTable.reload();
                    WizardHandler.wizard('suggestLearning').next();
                  }
                  else {
                    SweetAlert.error('',$filter('translate')('MESSAGE.MSG_SELECT_COURSE_OR_OTHER_NEED'));
                  }
                };

                vm.previousStep = function () {
                  WizardHandler.wizard('suggestLearning').previous();
                };

                vm.finishStep = function () {
                  WizardHandler.wizard('suggestLearning').finish();
                };

                vm.close = function() {
                  $mdDialog.cancel();
                };

            }],
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            disableParentScroll: true,
            locals : {
                table : scope.table,
                permissionType: scope.permissionType,
                userId: scope.userId
            }

          }).then(function(filters) {
                  scope.table.filter(filters);
                  scope.table.reload();
              }, function() { }
          );
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.user')
    .directive('addSuggestLearningList', addSuggestLearningList);

})();

/**
 * Created by Bruce on 2016/9/22.
 */
(function() {
  'use strict';

  UserController.$inject = ['$scope', '$state', 'userService', 'userDashboardService', 'sitemapService'];

  function UserController($scope, $state, userService, userDashboardService, sitemapService) {
    var vm = this;
    $scope.$on('$stateChangeSuccess',function () {
      if(!($state.includes('login')) && !($state.includes('logout'))
          && !($state.includes('error')) ){
        userService.getUserProfile().then(function (userData) {
          vm.userProfiles = userData;
        });
        userDashboardService.getUserToDo().then(function(userToDoData) {
          vm.userToDo = userToDoData;
        });
        sitemapService.getOnlineUserNumber().then(function(result){
          vm.number = result.number;
        });
      }
    vm.copyright = sitemapService.getProject('copyright');
    });
  }

  angular.module('eHRD.modules.user')
    .controller('UserController', UserController);
})();

/**
 * Created by Bruce on 2016/10/21.
 */
(function() {
  'use strict';

  TrainingRecordsSearchDialogController.$inject = ['$mdDialog','filters', 'PermPermissionStore'];

  function TrainingRecordsSearchDialogController($mdDialog, filters, PermPermissionStore) {
    var vm = this;
    var permission = null;
    permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
    vm.hasCurriculumPermission = angular.isDefined(permission);
    permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
    vm.hasCertificationInnerPermission = angular.isDefined(permission);

    vm.filters = {
      keyword: angular.isDefined(filters.keyword) ? filters.keyword : '',
      cpType: angular.isDefined(filters.cpType) ? filters.cpType : 1,
      passResult: angular.isDefined(filters.passResult) ? filters.passResult : -1,
      learnerType: angular.isDefined(filters.learnerType) ? filters.learnerType : -1
    };

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.close = function() {
      $mdDialog.cancel();
    };

    vm.submit = function(filters) {
      $mdDialog.hide(filters);
    };
  }

  angular.module('eHRD.modules.user')
    .controller('TrainingRecordsSearchDialogController', TrainingRecordsSearchDialogController);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function() {
  'use strict';

  var userTrainingRecords = {
    bindings: {},
    templateUrl: 'app/modules/user/views/training-records.html',
    controller: ['$scope', '$filter', '$interpolate', 'PermPermissionStore', 'ngTableColumnValueService', 'NgTableParams', '$mdDialog', '$document', 'myLearningRecordsService', 'userService', '$window',
      function($scope, $filter, $interpolate, PermPermissionStore, ngTableColumnValueService, NgTableParams, $mdDialog, $document, myLearningRecordsService, userService, $window) {
        var vm = this;
        var permission = null;
        permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
        vm.hasCurriculumPermission = angular.isDefined(permission);
        permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
        vm.hasCertificationInnerPermission = angular.isDefined(permission);
        vm.cpType = 1;
        vm.filter = {};

        function prepareTable() {
          vm.tableCols = prepareTableCols();

          vm.myTrainingRecordsTable = new NgTableParams({
            filter: vm.filter,
            sorting: {}
          }, {
            getData: function(tableParams) {
              var params = {};
              angular.forEach(tableParams.sorting(), function(value, key) {
                params.sort = key;
                params.order = ((value === 'desc') ? 0 : 1);
              });

              angular.forEach(tableParams.filter(), function(value, key) {
                params[key] = value;
              });

              params.currentPage = tableParams.url().page;
              params.perPage = tableParams.url().count;
              if (angular.isUndefinedOrNull(params.cpType)) params.cpType = 1;
              if (angular.isDefined(params.cpType) && params.cpType === 1) vm.isProgram = false;
              if (angular.isDefined(params.cpType) && params.cpType === 2) vm.isProgram = true;

              return myLearningRecordsService.getMyTrainingRecords(params).then(function(records) {
                vm.summary = records.metadata.summary;
                vm.configuration = records.metadata.configuration;
                if(vm.configuration.isShowCredit === 1 && angular.isDefined($filter('where')(vm.tableCols, {field: 'credits'}).length > 0)){
                    var credits_index = vm.tableCols.indexOf($filter('where')(vm.tableCols, {field: 'credits'})[0]);
                    vm.tableCols[credits_index].show = true;
                }
                tableParams.total(records.metadata.pagination.total);
                return records;
              });
            }
          });

          vm.setFilter = function(filters, isClear) {
            if (isClear) {
              filters = {};
            }
            vm.cpType = filters.cpType;
            vm.filter = filters;
            vm.myTrainingRecordsTable.filter(filters);
            vm.myTrainingRecordsTable.sorting({});
            vm.myTrainingRecordsTable.reload();
          };
        }

        function prepareTableCols() {
          var cols = [];
          switch (vm.cpType) {
            case 1:
              cols = [{
                field: 'courseName',
                title: $filter('translate')('FIELD.APPELLATION'),
                getValue: ngTableColumnValueService.htmlTextValue,
                sortable: '110',
                priority: 1
              }, {
                field: 'sessionName',
                title: $filter('translate')('FIELD.SESSION'),
                getValue: ngTableColumnValueService.htmlTextValue,
                priority: 3
              },{
                field: 'credits',
                title: $filter('translate')('FIELD.CREDITS'),
                sortable: '151',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class='text' ng-if='row.credits > 0'>{{row.credits}}</div>"),
                width: 50,
                show: false,
                priority: 2
              }, {
                field: 'courseType',
                title: $filter('translate')('FIELD.TYPE'),
                sortable: '49',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlCourseType()),
                priority: 3
              }, {
                field: 'history_course_time',
                title: $filter('translate')('FIELD.ENROLLMENT_TIME'),
                sortable: 'history_course_time',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlHistoryCourseTime()),
                width: 100,
                priority: 2
              }, {
                field: 'HOURS',
                title: $filter('translate')('FIELD.HOURS'),
                sortable: '59',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlHours()),
                width: 50,
                priority: 3
              }, {
                field: 'PersonalCost',
                title: $filter('translate')('FIELD.COST'),
                sortable: '56',
                getValue: ngTableColumnValueService.htmlTextValue,
                priority: 3
              }, {
                field: 'PROPERTIES',
                title: $filter('translate')('FIELD.PROPERTIES'),
                sortable: '140',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlProperties()),
                width: 50,
                priority: 2
              }, {
                field: 'enrollmentHours',
                title: $filter('translate')('FIELD.ENROLLMENT_HOURS'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"time\" ng-if=\"row.courseType === 1 || row.courseType === 4 || row.courseType === 6 || $ctrl.cpType === 2\">{{row.totalTime}}</div>"),
                priority: 2
              }, {
                field: 'TEST_FRACTION',
                title: $filter('translate')('FIELD.TEST_FRACTION'),
                sortable: '64',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"text\" ng-if=\"row.isFinalScoreViewable\">{{row.score}}</div><div class=\"text\" ng-if=\"!(row.isFinalScoreViewable)\">{{ 'STATUS.NOT_PUBLISHED' | translate}}</div>"),
                width: 50,
                priority: 3
              }, {
                field: 'ENROLLMENT_STATUS',
                title: $filter('translate')('FIELD.ENROLLMENT_STATUS'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlEnrollmentStatus()),
                width: 100,
                priority: 1
              }, {
                field: 'PASS_STATUS',
                title: $filter('translate')('FIELD.PASS_STATUS'),
                sortable: '46',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlPassStatus()),
                priority: 1
              }, {
                field: 'COMMUNITY',
                title: $filter('translate')('FIELD.COMMUNITY'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"text\" ng-if=\"row.forumUrl!==''\" ng-click=\"$ctrl.iframeWindow(row.forumUrl )\"><i class=\"fa fa-comments\" aria-hidden=\"true\"></i></div>"),
                priority: 1
              }];

              break;
            case 2:
              cols = [{
                field: 'programName',
                title: $filter('translate')('FIELD.APPELLATION'),
                getValue: ngTableColumnValueService.htmlTextValue,
                sortable: '111',
                priority: 1
              }, {
                field: 'sessionName',
                title: $filter('translate')('FIELD.SESSION'),
                getValue: ngTableColumnValueService.htmlTextValue,
                priority: 3
              }, {
                field: 'credits',
                title: $filter('translate')('FIELD.CREDITS'),
                sortable: '151',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class='text' ng-if='row.credits > 0'>{{row.credits}}</div>"),
                width: 50,
                show: false,
                priority: 2
              }, {
                field: 'programAccessTime',
                title: $filter('translate')('FIELD.CLASS_TIME'),
                sortable: 'Dynamic_ProgramAccessDate',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class='time'><span ng-bind-html='row.programAccessTime'></span></div>"),
                priority: 1
              }, {
                field: 'includeCourse',
                title: $filter('translate')('COURSE_CONTAIN'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class='text'><span ng-bind-html=\"row.includeCourse |replaceAll:',':',<br>'\"></span></div>"),
                priority: 3
              }, {
                field: 'enrollmentHours',
                title: $filter('translate')('FIELD.LEARN_TOTAL_TIME'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"time\" ng-if=\"row.courseType === 1 || row.courseType === 4 || row.courseType === 6 || $ctrl.cpType === 2\">{{row.totalTime}}</div>"),
                priority: 1
              }, {
                field: 'passCount',
                title: $filter('translate')('FIELD.PASS_NUMBER'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"text\">{{row.passCount}}</div>"),
                priority: 2
              }, {
                field: 'failedCount',
                title: $filter('translate')('FIELD.FAILED_NUMBER'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"text\">{{row.failedCount}}</div>"),
                priority: 3
              }, {
                field: 'exemptionCount',
                title: $filter('translate')('FIELD.EXEMPTION_NUMBER'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"text\">{{row.exemptionCount}}</div>"),
                priority: 3
              }, {
                field: 'ENROLLMENT_STATUS',
                title: $filter('translate')('FIELD.ENROLLMENT_STATUS'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlEnrollmentStatus()),
                width: 100,
                priority: 1
              }, {
                field: 'PASS_STATUS',
                title: $filter('translate')('FIELD.PASS_STATUS'),
                sortable: '46',
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate(htmlPassStatus()),
                priority: 1
              }, {
                field: 'SCORE',
                title: $filter('translate')('FIELD.SCORE'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"text\">{{row.score}}</div>"),
                priority: 3
              }, {
                field: 'COMMUNITY',
                title: $filter('translate')('FIELD.COMMUNITY'),
                getValue: ngTableColumnValueService.interpolatedValue,
                interpolateExpr: $interpolate("<div class=\"text\" ng-if=\"row.forumUrl!==''\" ng-click=\"$ctrl.iframeWindow(row.forumUrl )\"><i class=\"fa fa-comments\" aria-hidden=\"true\"></i></div>"),
                priority: 1
              }];
              break;
          }
          return cols;
        }

        function htmlCourseType() {
          var html = '<div class="text" ng-switch="row.courseType">';
          html += '<span ng-switch-when="1">{{ "FIELD.ONLINE_COURSE" | translate}}</span>';
          html += '<span ng-switch-when="2">{{ "FIELD.CLASS_ROOM_COURSE" | translate}}</span>';
          html += '<span ng-switch-when="3">{{ "FIELD.EXTERNAL_TRAINING" | translate}}</span>';
          html += '<span ng-switch-when="4">{{ "FIELD.ONLINE_TEST" | translate}}</span>';
          html += '<span ng-switch-when="5">{{ "FIELD.CLASS_ROOM_TEST" | translate}}</span>';
          html += '<span ng-switch-when="6">{{ "FIELD.QUESTIONNAIRE" | translate}}</span>';
          html += '<span ng-switch-default>{{row.courseType}}</span>';
          html += '</div>';
          return html;
        }

        function htmlHistoryCourseTime() {
          var html = '<div class="time" ng-if="row.courseType===1||row.courseType===4||row.courseType===6" ng-bind-html="row.lastAcessDate"></div>'
                   + '<div class="time" ng-if="row.courseType===2||row.courseType===3||row.courseType===5" ng-bind-html="row.timespandesc"></div>';
          return html;
        }

        function htmlHours() {
          var html = '<div class="text">';
          html += '<span ng-if="row.studyMin === 0">{{(row.studyHour === 0) ? "" : row.studyHour}}</span>';
          html += '<span ng-if="!(row.studyMin === 0)">';
          html += '{{(row.studyHour + (row.studyMin/60)) | number:2}}';
          html += '</span>';
          html += '</div>';
          return html;
        }

        function htmlProperties() {
          var html = '<div class="text" ng-if="row.learnerType === \'0\'">{{ "FIELD.COURSE_ELECTIVE" | translate}}</div>';
          html += '<div class="text" ng-if="row.learnerType === \'1\'">{{ "FIELD.COURSE_REQUIRED" | translate}}</div>';
          return html;
        }

        function htmlEnrollmentStatus() {
          var html = '<div class="text" ng-if="row.result!==1">';
          html += '<div class="progress th-line">';
          html += '<div class="progress-bar" ng-style="{\'width\': row.progress + \'%\'}">';
          html += '<div class="progress-value">';
          html += '<a ui-sref="learningPassport.trainingRecords.courseSessionInfo({enrollmentId:row.enrollmentId})" ng-if="row.result!==1 && !$ctrl.isProgram">';
          html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
          html += '<span class="pt-value">{{row.statusProgress}}</span>';
          html += '</a>';
          html += '<a ui-sref="learningPassport.trainingRecords.programSessionInfo({enrollmentId:row.enrollmentId})" ng-if="row.result!==1 && $ctrl.isProgram">';
          html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
          html += '<span class="pt-value">{{row.statusProgress}}</span>';
          html += '</a>';
          html += '</div>';
          html += '</div>';
          html += '</div>';
          html += '</div>';
          html += '<a ng-if="row.result===1 && $ctrl.cpType===1" href="javascript:void(0);" learning-history enrollment-id="row.enrollmentId" session-id="row.sessionId">{{ \'STATUS.\' + row.status | uppercase | translate}}</a>';
          html += '<a ng-if="row.result===1 && $ctrl.cpType===2" href="javascript:void(0);" program-detail-lessons-results-dialog enrollment-id="row.enrollmentId">{{ \'STATUS.\' + row.status | uppercase | translate}}</a>';
          return html;
        }

        function htmlPassStatus() {
          var html = '<div class="text" ng-switch="row.result">';
          html += '<span ng-switch-when="0">N/A</span>';
          html += '<span ng-switch-when="1">{{ \'STATUS.EXEMPTION\' | translate }}</span>';
          html += '<span ng-switch-when="2">{{ \'STATUS.PASSED\' | translate }}</span>';
          html += '<span ng-switch-when="3">{{ \'STATUS.FAILED\' | translate }}</span>';
          html += '</div>';
          return html;
        }

        $scope.$watch(function() {
          return vm.cpType;
        }, function() {
          prepareTable();
        });

        userService.getUserProfile().then(function(userData) {
          vm.userProfiles = userData;
        });

        vm.iframeWindow = function(formDetailUrl) {
          $window.open(formDetailUrl, 'player', 'width=' + $window.innerWidth / 2 + ',height=' + $window.innerHeight / 2 + ',location=no, scrollbars=yes, resizable=yes');
        };

        vm.showPrompt = function(ev) {
          // Appending dialog to document.body to cover sidenav in docs app
          $mdDialog.show({
            controller: 'TrainingRecordsSearchDialogController',
            controllerAs: 'TRSDC',
            templateUrl: 'app/modules/user/views/training-records-search-dialog.html',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              filters: vm.myTrainingRecordsTable.filter()
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function(filters) {
            vm.setFilter(filters, false);
          }, function() {});
        };
      }
    ]
  };

  angular.module('eHRD.modules.user')
    .component('userTrainingRecords', userTrainingRecords);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var mySetting = {
    bindings: {},
    templateUrl: 'app/modules/user/views/my-setting.html',
    controller: ['sitemapService', '$state', '$scope', 'NgTableParams', 'userService', 'deputyService', 'SweetAlert', '$translate', '$filter', 'amMoment',
      function( sitemapService, $state, $scope, NgTableParams, userService, deputyService, SweetAlert, $translate, $filter, amMoment ){

      var vm = this;
      vm.expandProfileDetail = false;
      vm.personal = {};
      vm.agentWorkId = {
        selectAll: false,
        selected: []
      };

      userService.getUserProfile().then(function (userInfo) {
        vm.userInfoIsExternal = userInfo.isExternal;
      });

      vm.getData = function () {
        vm.kernelUser = userService.getKernelUser();
        userService.getUserProfileDetail().then(function (userDetailData) {
          vm.userProfilesDetail = userDetailData;
          vm.personal.rc = userDetailData.lang;
          var uploader = $scope.uploader = userService.uploadUserAvatar(userDetailData.userId);
          uploader.onAfterAddingFile = function (item) {
            SweetAlert.check('', $filter('translate')('MESSAGE.MSG_ARE_YOU_SURE_WANT_TO_REPLACE_YOUR_AVATAR'), 'warning', function () {
              item.upload();
            },function () {
              uploader.clearQueue();
            });
          };
          uploader.onErrorItem = function(/*fileItem, response, status, headers*/) { };
          uploader.onCompleteAll = function () {
            vm.getData();
            $state.reload();
          };
        });
      };

      vm.deputyRecordsTable = new NgTableParams({}, {
        counts: [],
        getData: function(tableParams) {
            var params = {};
            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;
            return deputyService.getDeputyRecords(params).then(function (records) {
                vm.records = records;
                tableParams.total(records.metadata.pagination.total);
                return records;
            });
        }
      });

      vm.deleteDeputyRecords = function(){
        var idList="";
        angular.forEach(vm.agentWorkId.selected, function(agentWorkId,key) {
          if(agentWorkId.value) {
            idList += (idList==='')?key:","+key;
          }
        });
        if(idList!==''){
          var params = {
              idList:idList
          };
          SweetAlert.check('', $filter('translate')('MESSAGE.MSG_ARE_YOU_SURE_WANT_TO_DELETE_DEPUTY_RECORD'), 'warning', function () {
              deputyService.deleteDeputyRecords(params).then(function (res) {
              if(res.status === 0){
                vm.deputyRecordsTable.reload();
              }else if(res.status === -2){
                SweetAlert.error('', $filter('translate')( 'ERROR.MSG_NOT_ALLOW_TO_DELETE_OTHER_SETTING'));
              }
            });
          });
        }

      };

      // watch for check all checkbox
      $scope.$watch(function() {
        return vm.agentWorkId.selectAll;
      }, function(value) {
        angular.forEach(vm.records, function(records) {
          vm.agentWorkId.selected[records.agentWorkId] = {
            value:value
          };
        });
      });

      vm.checkboxSelect = function(agentWorkId,value){
          vm.agentWorkId.selected[agentWorkId] = {
              value:value
          };
      };

      vm.changePassword = function (passwords) {
        SweetAlert.check('', $filter('translate')('MESSAGE.MSG_ARE_YOU_SURE_WANT_TO_CHANGE_YOUR_PASSWORD'), 'warning', function () {
          userService.changePassword({'oriPassword': passwords.oldPwd,'newPassword': passwords.newPwd}, {}).then(function (res) {
            if(res.status === 1){
              SweetAlert.success('', $filter('translate')('MESSAGE.MSG_UPDATE_PASSWORD_SUCCESS'));
            }else {
              SweetAlert.error('', $filter('translate')( 'ERROR.' + res.message));
            }
          });
        });
      };

      vm.updatePreferLang = function (formData) {

        userService.updatePreferLang(vm.userProfilesDetail.userId, formData, {}).then(function (res) {
          if(res.status === 1){
            //vm.getData();
            var _rc = '';
            switch (formData){
              case 1:
                _rc = 'en_us';
                break;
              case 2:
                _rc = 'zh_tw';
                break;
              case 3:
                _rc = 'zh_cn';
                break;
            }
            $translate.use(_rc);
            amMoment.changeLocale($translate.use());

            $state.go('mySetting', {}, {reload: true});
          }
        });
      };

      vm.getData();
    }]
  };

  angular.module('eHRD.modules.user')
    .component('mySetting', mySetting);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var myCurriculum = {
    bindings: {},
    templateUrl: 'app/modules/user/views/my-curriculum.html',
    controller: ['PermPermissionStore', 'NgTableParams', 'myLearningRecordsService', '$scope', '$filter', 'ngTableColumnValueService', '$interpolate',
      function( PermPermissionStore, NgTableParams, myLearningRecordsService, $scope, $filter, ngTableColumnValueService, $interpolate){
        var vm = this;
        var permission = null;
        permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
        vm.hasCurriculumPermission = angular.isDefined(permission);
        permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
        vm.hasCertificationInnerPermission = angular.isDefined(permission);
        var defaultFilters = {
          sourceType: -101,
          searchStatus: 'All',
          lmYearBegin: new Date().getFullYear(),
          lmMonthBegin: 0,
          lmYearEnd: new Date().getFullYear(),
          lmMonthEnd: 11
        };
        vm.enrollmentId = {
          selectAll: false,
          selected: []
        };


        vm.tableCols = prepareTableCols();
        vm.suggestLearningTable = new NgTableParams({ sorting: { 'PredictDueDate': "desc" } }, {
          counts: [1,5,10,15],
          getData: function(tableParams) {
            var params = {};
            //clear checkbox
            vm.enrollmentId = {
              selectAll: false,
              selected: []
            };

            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = ((value === 'desc') ? "ASC" : "DESC");
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;
            return myLearningRecordsService.getSuggestLearningList(params).then(function (suggestLearningList) {
              vm.suggestLearningList = suggestLearningList;
              vm.userInfo = suggestLearningList.metadata.userInfo;
              tableParams.total(suggestLearningList.metadata.pagination.total);
              return suggestLearningList;
            });
          }
        });

        vm.suggestLearningTable.filter(defaultFilters);


        function prepareTableCols() {
          var cols = [
            {
              field: 'checkbox',
              title: '',
              headerTemplateURL: 'headerCheckbox.html',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<md-checkbox flex class='md-primary checkbox'" +
                "ng-model='$ctrl.enrollmentId.selected[row.enrollmentId].value'" +
                "ng-click='$ctrl.checkboxSelect(row, $ctrl.enrollmentId.selected[row.enrollmentId].value)'> </md-checkbox>"
              ),
              priority: 1,
              width: 5
            },
            {
              field: 'predictDueDate',
              title: $filter('translate')('FIELD.ESTIMATED_COMPLETION_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              sortable: 'PredictDueDate',
              priority: 2,
              width: 110
            },
            {
              field: 'finishDate',
              title: $filter('translate')('FIELD.FINISH_TIME'),
              getValue: ngTableColumnValueService.htmlTextValue,
              sortable: 'ResultModifiedDate',
              priority: 1,
              width: 80
            },
            {
              field: 'activityName',
              title: $filter('translate')('FIELD.LEARNING_ACTIVITY'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlActivityName()),
              sortable: 'ActivityName',
              priority: 1
            },
            {
              field: 'sessionName',
              title: $filter('translate')('FIELD.SESSION'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 3
            },
            {
              field: 'itemName',
              title: $filter('translate')('FIELD.TYPE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              sortable: 'ItemType',
              priority: 3,
              width: 50
            },
            {
              field: 'sourceName',
              title: $filter('translate')('FIELD.SOURCE'),
              getValue: htmlSourceInfos,
              sortable: 'Source',
              priority: 2
            },
            {
              field: 'properties',
              title: $filter('translate')('FIELD.PROPERTIES'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("" +
                "<div class='text' ng-if='row.itemType===99 || row.itemType===256'>N/A</div>" +
                "<div class='text' ng-if='row.learnerType===0 && row.itemType!==99 && row.itemType!==256'>{{ 'FIELD.COURSE_ELECTIVE' |translate }}</div>" +
                "<div class='text' ng-if='row.learnerType===1 && row.itemType!==99 && row.itemType!==256'>{{ 'FIELD.COURSE_REQUIRED' |translate }}</div>"
              ),
              sortable: 'LearnerType',
              priority: 2
            },
            {
              field: 'enrollName',
              title: $filter('translate')('FIELD.ENROLL_TYPE') +'(' + $filter('translate')('FIELD.SPECIFY_APPLICANT') + ')',
              headerTemplateURL: 'enrollTypeHeader.html',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate('<div>{{row.enrollName}}<br>' +
               '<span ng-if=\' row.assignerFullName!=="" \'>(<a href=\'javascript:void(0)\' user-detail user-id=\'row.assignerId\'>{{row.assignerFullName}}</a>)</span> </div>'
              ),
              sortable: 'EnrollType',
              priority: 3
            },
            {
              field: 'enrollmentStatus',
              title: $filter('translate')('FIELD.ENROLLMENT_STATUS'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlEnrollmentStatus()),
              priority: 1,
              width: 100
            },
            {
              field: 'leanerStatusName',
              title: $filter('translate')('FIELD.LEARNING_STATUS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1
            }
          ];


          return cols;
        }


        // watch for check all checkbox
        $scope.$watch(function() {
          return vm.enrollmentId.selectAll;
        }, function(value) {
          angular.forEach(vm.suggestLearningList, function(suggestLearningList) {
            vm.checkboxSelect(suggestLearningList, value);
          });
        });

        //checkbox select
        vm.checkboxSelect = function(suggestLearningList, value){
          vm.enrollmentId.selected[suggestLearningList.enrollmentId] = {
            value: value,
            itemType: suggestLearningList.itemType,
            canDelete: suggestLearningList.canDelete,
            canUpdate: suggestLearningList.canUpdate,
            activityName: suggestLearningList.activityName,
            sourceInfos: suggestLearningList.sourceInfos,
            status: suggestLearningList.status
          };
        };


        function htmlSourceInfos() {
          return '<div class=\'text\' ng-repeat=\'sourceInfo in row.sourceInfos track by $index\' >{{sourceInfo.sourceName}}</div>';
        }

        function htmlEnrollmentStatus() {
          var html = '<div class=\'progress th-line\' ng-if=\'row.status!=="Have not Executed Enrolled Assignment" && row.status!=="Enrollment Approval Pending" && row.status!=="Unenroll" && row.status!=="Exemption" && row.status!=="" \' style=\'width: 100px;\'>';
              html += '<div class=\'progress-bar\' ng-style=\'{width: row.progress}\'>';
                html += '<div class=\'progress-value\'>';
                  html += '<a  ng-if=\'row.itemType!==64 && row.itemType!==128\' ui-sref=\'learningPassport.myCurriculum.courseSessionInfo({enrollmentId:row.enrollmentId})\' href=\'javascript:void(0);\'  >';
                    html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                    html += '<span class="pt-value">{{row.statusProgress}}</span>';
                  html += '</a>';
                  html += '<a  ng-if=\'row.itemType===64 || row.itemType===128\' ui-sref=\'learningPassport.myCurriculum.programSessionInfo({enrollmentId:row.enrollmentId})\' href=\'javascript:void(0);\'>';
                    html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                    html += '<span class="pt-value">{{row.statusProgress}}</span>';
                  html += '</a>';
                html += '</div>';
              html += '</div>';
            html += '</div>';
          html += '<span ng-if=\'row.status==="Have not Executed Enrolled Assignment" || row.status==="Enrollment Approval Pending" || row.status==="Unenroll" || row.status==="Exemption" \'> {{row.statusName}}</span>';
          html += '<span ng-if=\'row.status==="" && row.itemType!==256\'> N/A </span>';
          html += '<span ng-if=\'row.status==="" && row.itemType===256\'> {{row.leanerStatusName}} </span>';
          return html;
        }

        function htmlActivityName() {
          var html = "<div ng-switch='row.itemType'>";
          html += "<a href='javascript:void(0)' ng-if='row.itemType!==64 && row.itemType!==128 && row.itemType!==256 && row.itemType!==99' course-detail-info-dialog course-id='row.itemId' is-published='row.isPublished' can-view='row.canViewByUser'>{{row.activityName}}</a>";
          html += "<a href='javascript:void(0)' ng-if='row.itemType===64 || row.itemType===128' program-detail-info-dialog program-id='row.itemId' is-published='row.isPublished' can-view='row.canViewByUser'>{{row.activityName}}</a>";
          html += "<a href='javascript:void(0)' ng-if='row.itemType===256' external-cert-detail-info-dialog subject-id='row.itemId' is-published='row.isPublished' can-view='row.canViewByUser'>{{row.activityName}}</a>";
          html += "<span ng-if='row.itemType===99'>{{row.activityName}}</span>";
          html += "</div>";
          return html;
        }
    }]
  };

  angular.module('eHRD.modules.user')
    .component('myCurriculum', myCurriculum);
})();

/**
 * Created by Bruce on 2016/12/1.
 */
(function () {
  'use strict';

  var myCalendar = {
    bindings: {},
    templateUrl: 'app/modules/user/views/my-calendar.html',
    controller: [ '$state', '$q', '$scope', 'dateFns', 'calendarConfig', 'calendarService', '$mdDialog', 'courseResourceService', function( $state, $q, $scope, dateFns, calendarConfig, calendarService, $mdDialog, courseResourceService){
      var vm = this;
      vm.calendarView = 'month';
      vm.minDateEvents = [];
      vm.bigCalendarEvents = [];
      vm.viewDate = moment(new Date());
      vm.cellIsOpen = true;
      var tomorrowDate = moment(new Date()).add(1, 'days');

      $scope.$watch(function () {
        return vm.viewDate;
      }, function (newVal) {
        if(moment.isMoment(newVal)){
          vm.isCanShowTomorrowEvents = dateFns.isSameDay(vm.viewDate, moment(new Date()));
        }else {
          vm.viewDate = moment(newVal);
        }
      }, true);

      vm.updateViewDate = function (calendarDate) {
        vm.viewDate = moment(new Date(calendarDate));
        vm.getCalendarEvents(vm.viewDate, false);
      };

      vm.getCalendarEvents = function (date, isOnlyDay) {
        isOnlyDay = isOnlyDay || false;
        if(!isOnlyDay){
          getCalendarWithOneBeforeAndAfter(date);
        }
        calendarService.getCalendarEvents(date, true).then(function (data) {
          angular.forEach(data, function (event, index) {
            var eventDate = moment(new Date(event.dateStr)).set({
              'hour' : event.endTime.split(':')[0],
              'minute'  : event.endTime.split(':')[1],
              'second' : "0"
            });
            if(eventDate.isBefore(moment(new Date()))){
              data[index].isExpired = true;
            }
          });
          vm.dateEvents = data;
        });
      };

      var getCalendarWithOneBeforeAndAfter = function (baseDate) {
        if(!moment.isMoment(baseDate)) baseDate = moment(baseDate);
        vm.bigCalendarEvents = []; vm.minDateEvents = [];
        calendarService.getCalendarWithOneBeforeAndAfter(baseDate).then(function (data) {
          vm.bigCalendarEvents = vm.bigCalendarEvents.concat(bigCalendarProcess(data));
          vm.minDateEvents = calendarService.minCalendarProcess(data);
        });
      };

      function bigCalendarProcess(calendars) {
        var bigCalendars = [];
        var actions = [{
          label: '<i class="icon-map"></i>',
          onClick: function(args, $event) {
            vm.openPlaceMap(args.calendarEvent.placeMap, $event);
          }
        }];
        angular.forEach(calendars, function (calendar) {
          bigCalendars.push({
            title: calendar.eventName + '&nbsp;&nbsp;<i class="fa fa-map-marker"></i>&nbsp;' + calendar.place,
            color: {2: calendarConfig.colorTypes.room, 3: calendarConfig.colorTypes.train, 5: calendarConfig.colorTypes.test}[calendar.courseType],
            startsAt: moment(new Date(calendar.dateStr)).set({
              'hour' : calendar.startTime.split(':')[0],
              'minute'  : calendar.startTime.split(':')[1],
              'second' : "0"
            }).toDate() ,
            endsAt: moment(new Date(calendar.dateStr)).set({
              'hour' : calendar.endTime.split(':')[0],
              'minute'  : calendar.endTime.split(':')[1],
              'second' : "0"
            }).toDate() ,
            draggable: false,
            resizable: false,
            placeMap: calendar.placeMap,
            actions: (calendar.placeMap !== null) ? actions : [],
            courseId: calendar.courseId,
            sessionId: calendar.sessionId,
            courseType: calendar.courseType
          });
        });
        return bigCalendars;
      }

      vm.linkToCourseSessionPage = function (event) {
        event = event || undefined;
        if(angular.isDefined(event) && angular.isDefined(event.sessionId)){
          courseResourceService.getEnrollment(event.sessionId, false).then(function (enrollment) {
            $state.go('learningPassport.incompleteCourses.courseInfo', {'enrollmentId': enrollment.enrollmentId});
          });
        }
      };

      vm.openPlaceMap = function (placeMapUrl, ev) {
        $mdDialog.show({
          template: '<md-dialog flex="60"><md-dialog-content>' +
          '<div layout="row" layout-align="center center" >' +
          '<img ng-src="{{$ctrl.placeMapUrl | trustAsResourceUrl}}" style="max-width: 100%">' +
          '</div></md-dialog-content></md-dialog>',
          clickOutsideToClose: true,
          escapeToClose: true,
          controller: ['placeMapUrl', function (placeMapUrl) {
            var vm = this;
            vm.placeMapUrl = placeMapUrl;
          }],
          controllerAs: '$ctrl',
          bindToController: true,
          fullscreen: true,
          targetEvent: ev,
          locals: {
            placeMapUrl: placeMapUrl
          }
        });
      };

      vm.getCalendarEvents(vm.viewDate, true);
      getCalendarWithOneBeforeAndAfter(vm.viewDate);
      calendarService.getCalendarEvents(tomorrowDate, true).then(function (data) {
        vm.tomorrowEvents = data;
        angular.forEach(calendarService.minCalendarProcess(data), function (eventDate) {
          if(vm.minDateEvents.indexOf(eventDate) < 0){
            vm.minDateEvents.push(eventDate)
          }
        });
      });
    }]
  };

  angular.module('eHRD.modules.user')
    .component('myCalendar', myCalendar);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var incompleteTestSurveys = {
    bindings: {},
    templateUrl: 'app/modules/user/views/incomplete-test-surveys.html',
    controller: ['PermPermissionStore', 'testQuestionnaireCenterService', function( PermPermissionStore, testQuestionnaireCenterService ){

      var vm = this;
      var permission = null;
      var defaultCourseType =[];
      var defaultSort = 'ExpireEnd';
      var defaultOrder = 'ASC';
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.onlinetest');
      vm.hasCourseOnlinetestPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.classroomtest');
      vm.hasCourseClassroomtestPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.survey');
      vm.hasCourseSurveyPermission = angular.isDefined(permission);

      if(vm.hasCourseOnlinetestPermission) defaultCourseType.push(4);
      if(vm.hasCourseClassroomtestPermission) defaultCourseType.push(5);
      if(vm.hasCourseSurveyPermission) defaultCourseType.push(6);
      defaultCourseType.push(9);
      var params = {};
      vm.defaultFilterType = 'courseType';
      vm.defaultFilterValue = defaultCourseType.toString();
      params.filter_key = vm.defaultFilterType;
      params.filter_value = vm.defaultFilterValue;
      params.sort = defaultSort;
      params.order = defaultOrder;
      vm.dataFilter = function(filterType, filterValue) {
        params = {};
        if (angular.isDefined(filterType) && angular.isDefined(filterValue)) {
          switch (filterType) {
            case 'courseType':
              params.filter_key = filterType;
              params.filter_value = filterValue;
              break;
          }
        }else{
          params.filter_key = vm.defaultFilterType;
          params.filter_value = vm.defaultFilterValue;
        }
        params.sort = defaultSort;
        params.order = defaultOrder;
        params.list_size = vm.pagination.perPage;
        vm.getData(params);
      };

      vm.getData = function(params) {
        vm.params = params;
        testQuestionnaireCenterService.list(params).then(function(data) {
          vm.incompleteCoursesDatas = data;
          vm.courseCount = vm.incompleteCoursesDatas.metadata.courseCount;
          vm.pagination = vm.incompleteCoursesDatas.metadata.pagination;
          angular.element("html, body").animate({
            scrollTop: 0
          }, 10);
        });
      };
      vm.params = params;
      vm.getData(params);
    }]
  };

  angular.module('eHRD.modules.user')
    .component('incompleteTestSurveys', incompleteTestSurveys);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var incompleteCourses = {
    bindings: {},
    templateUrl: 'app/modules/user/views/incomplete-courses.html',
    controller: ['PermPermissionStore', 'incompleteCoursesService', function( PermPermissionStore, incompleteCoursesService ){

      var vm = this;
      var permission = null;
      var defaultCourseType =[];var defaultProgramType=[];
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.online');
      vm.hasCourseOnlinePermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.classroom');
      vm.hasCourseClassroomPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.external');
      vm.hasCourseExternalPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
      vm.hasCurriculumPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
      vm.hasCertificationInnerPermission = angular.isDefined(permission);

      if(vm.hasCourseOnlinePermission) defaultCourseType.push(1);
      if(vm.hasCourseClassroomPermission) defaultCourseType.push(2);
      if(vm.hasCourseExternalPermission) defaultCourseType.push(3);

      if(vm.hasCurriculumPermission) defaultProgramType.push(0);
      if(vm.hasCertificationInnerPermission) defaultProgramType.push(1);

      var params = {};
      if(defaultCourseType.length > 0 && defaultProgramType.length > 0) {
        vm.defaultFilterType = 'courseType;programType';
        vm.defaultFilterValue = defaultCourseType.toString() + ';' + defaultProgramType.toString();
      }else if(defaultCourseType.length > 0 && defaultProgramType.length === 0){
        vm.defaultFilterType = 'courseType';
        vm.defaultFilterValue = defaultCourseType.toString();
      }else if(defaultCourseType.length === 0 && defaultProgramType.length > 0){
        vm.defaultFilterType = 'programType';
        vm.defaultFilterValue = defaultProgramType.toString();
      }

      var defaultSort = 'ExpireEnd';
      var defaultOrder = 'ASC';
      params.filter_key = vm.defaultFilterType;
      params.filter_value = vm.defaultFilterValue;
      if(vm.hasCourseOnlinePermission && (!vm.hasCourseClassroomPermission &&
        !vm.hasCourseExternalPermission && !vm.hasCurriculumPermission && !vm.hasCertificationInnerPermission)){
        params.sort = 'ExpireEnd';
      }else {
        params.sort = defaultSort;
      }
      params.order = defaultOrder;

      vm.dataFilter = function(filterType, filterValue) {
        params = {};
        if (angular.isDefined(filterType) && angular.isDefined(filterValue)) {
          switch (filterType) {
            case 'courseType':
              params.filter_key = filterType;
              params.filter_value = filterValue;
              params.sort = defaultSort;
              break;
            case 'programType':
              params.filter_key = filterType;
              params.filter_value = filterValue;
              params.sort = defaultSort;
              break;
          }
        }else{
          params.filter_key = vm.defaultFilterType;
          params.filter_value = vm.defaultFilterValue;
          params.sort = defaultSort;
        }
        params.order = defaultOrder;
        params.list_size = vm.pagination.perPage;
        vm.getData(params);
      };

      vm.getData = function(params) {
        vm.params = params;
        incompleteCoursesService.list(params).then(function(data) {
          vm.incompleteCoursesDatas = data;
          vm.courseCount = vm.incompleteCoursesDatas.metadata.courseCount;
          vm.pagination = vm.incompleteCoursesDatas.metadata.pagination;
          angular.element("html, body").animate({
            scrollTop: 0
          }, 10);
        });
      };
      vm.params = params;
      vm.getData(params);
    }]
  };

  angular.module('eHRD.modules.user')
    .component('incompleteCourses', incompleteCourses);
})();

/**
 * Created by Bruce on 2016/12/20.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.utils', []);

})();

/**
 * Created by Bruce on 2017/2/9.
 */
(function () {
  'use strict';

  utilsService.$inject = ['Restangular'];
  function utilsService(Restangular){

    /*
     * Build collection api/util
     */
    var _utilsService = Restangular.all('util');

    return {
      findMyGroupMembers: function (params) {
        params = params || {};
        /*
         * /api/util/find-my-descendent-members
         * */
        return _utilsService
          .customGETLIST('find-my-group-members', params);
      },
      findMyDescendentMembers: function (params) {
        params = params || {};
        /*
         * /api/util/find-my-descendent-members
         * */
        return _utilsService
          .customGETLIST('find-my-descendent-members', params);
      },
      getMembersByFilter: function (params) {
        params = params || {};
        /*
        * /api/util/select-users?keywords={keywords}
        * */
        return _utilsService
          .customGETLIST('select-users', params);
      },
      getTipInfo: function (typeId, params) {
        /*
         * /api/util/tip-info/{typeId}?{params}
         * typeId = 5, params = {exid}
         * */
        return _utilsService
          .one('tip-info', typeId)
          .customGETLIST(null, params);
      },
      getExternalCourses: function (params) {
        /*
         * /api/util/ext-list-courses?courseCode={courseCode}&courseName={courseName}&keywords={keywords}
         * */
        return _utilsService
          .customGETLIST('ext-list-courses', params);
      },
      getExternalCourseSessions: function (courseId, params) {
        /*
         * /api/util/ext-list-courses/{courseId}/sessions?externalId={externalId}&applicantId={applicantId}
         * */
        return _utilsService
          .one('ext-list-courses', courseId)
          .customGETLIST('sessions', params);
      }
    };

  }

  angular.module('eHRD.modules.utils')
    .factory('utilsService', utilsService);

})();

/**
 * Created by Bruce on 2017/3/21.
 */
(function () {
  'use strict';

  ngTableColumnValueService.$inject = [];
  function ngTableColumnValueService(){

    /*
    * This Method Need Use bindCompiledHtml Directive
    * */
    function htmlReferences($scope, row) {
      var values = row[this.field];
      var html = "";
      angular.forEach(values, function (value, index) {
        html += "<a href='javascript:void(0)' " +
          "view-ctms-reference package-id='row[col.field]["+index+"].packageId' " +
          "item-section='row[col.field]["+index+"].itemSection'" +
          "file-name='row[col.field]["+index+"].systemFileName' >" +
          "<i class='material-icons'>assignment</i>" +
          "</a>";
      });
      return html;
    }

    function htmlCertReferences($scope, row) {
      var values = row[this.field];
      var html = "";
      angular.forEach(values, function (value, index) {
        html += "<a href='javascript:void(0)' " +
          "view-ctms-reference package-id='row[col.field]["+index+"].CTMSReferencesRootId' " +
          "file-name='row[col.field]["+index+"].systemFileName' >" +
          "<i class='material-icons'>assignment</i>" +
          "</a>";
      });
      return html;
    }

    function htmlExtCertReferences($scope, row) {
      var values = row[this.field];
      var html = "";
      angular.forEach(values, function (value, index) {
        html += "<a href='javascript:void(0)' " +
          "view-ctms-reference package-id='row[col.field]["+index+"].tableRefId' " +
          "item-section=\"'ExtCertApplyFormRef'\"" +
          "file-name='row[col.field]["+index+"].systemFileName' >" +
          "<i class='material-icons'>assignment</i>" +
          "</a>";
      });
      return html;
    }


    function htmlTextValue($scope, row) {
      var value = row[this.field];
      var columnType = this.columnType();
      var html = "<div class='" + columnType + "'>" + value + "</div>";
      return (html);
    }

    /*
    * EX: cols ==>
    * interpolateExpr: $interpolate("<em class='text-danger'>{{ row.age | number:1}}</em>")
    * */
    function interpolatedValue($scope, row) {
      return this.interpolateExpr({
        row: row,
        $ctrl: $scope
      });
    }

    return {

      htmlReferences: htmlReferences,
      htmlCertReferences: htmlCertReferences,
      htmlExtCertReferences: htmlExtCertReferences,
      htmlTextValue: htmlTextValue,
      interpolatedValue: interpolatedValue


    };
  }

  angular.module('eHRD.modules.utils')
    .factory('ngTableColumnValueService', ngTableColumnValueService);

})();

/**
 * Created by Bruce on 2016/12/22.
 */
(function () {
  'use strict';

  momentUtils.$inject = [];
  function momentUtils() {

    var INTERVALS = {
      year:   true,
      month:  true,
      week:   true,
      day:    true,
      hour:   true,
      minute: true,
      second: true
    };

    function DateRange(start, end) {
      var parts;
      var s = start;
      var e = end;

      if (arguments.length === 1 || angular.isUndefined(end)) {
        if (angular.isObject(start) && start.length === 2) {
          s = start[0];
          e = start[1];
        }
        else if (angular.isString(start)) {
          parts = start.split('/');
          s = parts[0];
          e = parts[1];
        }
      }

      this.start = (s === null) ? moment(-8640000000000000) : moment(s);
      this.end   = (e === null) ? moment(8640000000000000) : moment(e);
    }


    /**
     * Constructor for prototype.
     *
     * @type {DateRange}
     */
    DateRange.prototype.constructor = DateRange;

    /**
     * Deep clone range.
     *
     * @return {!DateRange}
     */
    DateRange.prototype.clone = function() {
      return range(this.start, this.end);
    };

    /**
     * Determine if the current interval contains a given moment/date/range.
     *
     * @param {(Moment|Date|DateRange)} other Date to check
     * @param {!boolean} exclusive True if the to value is exclusive
     *
     * @return {!boolean}
     */
    DateRange.prototype.contains = function(other, exclusive) {
      var start = this.start;
      var end   = this.end;

      if (other instanceof DateRange) {
        return start <= other.start && (end > other.end || (end.isSame(other.end) && !exclusive));
      }
      else {
        return start <= other && (end > other || (end.isSame(other) && !exclusive));
      }
    };

    /**
     * Determine if the current date range overlaps a given date range.
     *
     * @param {!DateRange} range Date range to check
     *
     * @return {!boolean}
     */
    DateRange.prototype.overlaps = function(range) {
      return this.intersect(range) !== null;
    };

    /**
     * Determine the intersecting periods from one or more date ranges.
     *
     * @param {!DateRange} other A date range to intersect with this one
     *
     * @return {DateRange} Returns the intersecting date or `null` if the ranges do
     *                     not intersect
     */
    DateRange.prototype.intersect = function(other) {
      var start = this.start;
      var end   = this.end;

      if ((start <= other.start) && (other.start < end) && (end < other.end)) {
        return new DateRange(other.start, end);
      }
      else if ((other.start < start) && (start < other.end) && (other.end <= end)) {
        return new DateRange(start, other.end);
      }
      else if ((other.start < start) && (start <= end) && (end < other.end)) {
        return this;
      }
      else if ((start <= other.start) && (other.start <= other.end) && (other.end <= end)) {
        return other;
      }

      return null;
    };

    /**
     * Merge date ranges if they intersect.
     *
     * @param {!DateRange} other A date range to add to this one
     *
     * @return {DateRange} Returns the new `DateRange` or `null` if they do not
     *                     overlap
     */
    DateRange.prototype.add = function(other) {
      if (this.overlaps(other)) {
        return new DateRange(moment.min(this.start, other.start), moment.max(this.end, other.end));
      }

      return null;
    };

    /**
     * Subtract one range from another.
     *
     * @param {!DateRange} other A date range to substract from this one
     *
     * @return {!Array<DateRange>}
     */
    DateRange.prototype.subtract = function(other) {
      var start = this.start;
      var end   = this.end;

      if (this.intersect(other) === null) {
        return [this];
      }
      else if ((other.start <= start) && (start < end) && (end <= other.end)) {
        return [];
      }
      else if ((other.start <= start) && (start < other.end) && (other.end < end)) {
        return [new DateRange(other.end, end)];
      }
      else if ((start < other.start) && (other.start < end) && (end <= other.end)) {
        return [new DateRange(start, other.start)];
      }
      else if ((start < other.start) && (other.start < other.end) && (other.end < end)) {
        return [new DateRange(start, other.start), new DateRange(other.end, end)];
      }
      else if ((start < other.start) && (other.start < end) && (other.end < end)) {
        return [new DateRange(start, other.start), new DateRange(other.start, end)];
      }
    };

    /**
     * Build a n array of dates.
     *
     * @param {(!DateRange|String)} range Date range to be used for iteration or
     *                                    shorthand string (shorthands:
     *                                    http://momentjs.com/docs/#/manipulating/add/)
     * @param {!boolean} exclusive Indicate that the end of the range should not
     *                             be included in the iter.
     *
     * @return {!Array}
     */
    DateRange.prototype.toArray = function(by, exclusive) {
      var acc = [];
      this.by(by, function(unit) {
        acc.push(unit);
      }, exclusive);
      return acc;
    };

    /**
     * Iterate over the date range by a given date range, executing a function
     * for each sub-range.
     *
     * @param {(!DateRange|String)} range Date range to be used for iteration or
     *                                    shorthand string (shorthands:
     *                                    http://momentjs.com/docs/#/manipulating/add/)
     * @param {!DateRange~by} hollaback Callback
     * @param {!boolean} exclusive Indicate that the end of the range should not
     *                             be included in the iter.
     *
     * @return {DateRange} `this`
     */
    DateRange.prototype.by = function(range, hollaback, exclusive) {
      if (angular.isString(range)) {
        _byString.call(this, range, hollaback, exclusive);
      }
      else {
        _byRange.call(this, range, hollaback, exclusive);
      }
      return this;
    };


    /**
     * Callback executed for each sub-range.
     *
     * @callback DateRange~by
     *
     * @param {!Moment} current Current moment object for iteration
     */

    /**
     * @private
     */
    function _byString(interval, hollaback, exclusive) {
      var current = moment(this.start);

      while (this.contains(current, exclusive)) {
        hollaback.call(this, current.clone());
        current.add(1, interval);
      }
    }

    /**
     * @private
     */
    function _byRange(interval, hollaback, exclusive) {
      var div = this / interval;
      var l = Math.floor(div);

      if (l === Infinity) { return; }
      if (l === div && exclusive) {
        l--;
      }

      for (var i = 0; i <= l; i++) {
        hollaback.call(this, moment(this.start.valueOf() + interval.valueOf() * i));
      }
    }

    /**
     * Date range formatted as an [ISO8601 Time
     * Interval](http://en.wikipedia.org/wiki/ISO_8601#Time_intervals).
     *
     * @return {!String}
     */
    DateRange.prototype.toString = function() {
      return this.start.format() + '/' + this.end.format();
    };

    /**
     * Date range in milliseconds. Allows basic coercion math of date ranges.
     *
     * @return {!number}
     */
    DateRange.prototype.valueOf = function() {
      return this.end - this.start;
    };

    /**
     * Center date of the range.
     *
     * @return {!Moment}
     */
    DateRange.prototype.center = function() {
      var center = this.start + this.diff() / 2;
      return moment(center);
    };

    /**
     * Date range toDate
     *
     * @return {!Array<Date>}
     */
    DateRange.prototype.toDate = function() {
      return [this.start.toDate(), this.end.toDate()];
    };

    /**
     * Determine if this date range is the same as another.
     *
     * @param {!DateRange} other Another date range to compare to
     *
     * @return {!boolean}
     */
    DateRange.prototype.isSame = function(other) {
      return this.start.isSame(other.start) && this.end.isSame(other.end);
    };

    /**
     * The difference of the end vs start.
     *
     * @param {number} unit Unit of difference, if no unit is passed in
     *                      milliseconds are returned. E.g.: `"days"`, `"months"`,
     *                      etc...
     *
     * @return {!number}
     */
    DateRange.prototype.diff = function(unit) {
      return this.end.diff(this.start, unit);
    };


    function range(start, end) {
      if (start in INTERVALS) {
        return new DateRange(moment(this).startOf(start), moment(this).endOf(start));
      }
      else {
        return new DateRange(start, end);
      }
    }

    range.constructor = DateRange;

    return {
      range: range
    };
  }

  angular
    .module('eHRD.modules.utils')
    .factory('momentUtils', momentUtils);

})();

/**
 * Created by Bruce on 2016/12/6.
 */

(function () {
  'use strict';

  ctlService.$inject = ['Restangular'];
  function ctlService(Restangular){

    var _CtlService = Restangular.all('ctl');

    return {

      getManagerGroups: function (params) {
        /*
         * api/manager/member-finished-enrollment
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('manage-groups', params);
      },

      getManagerMembers: function (params) {
        /*
         * api/ctl/selection-dropdown/manage-members?showAllOption={showAllOption}&selectedValue={selectedValue}&groupId={groupId}&filterSelf={filterSelf}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('manage-members', params);
      },

      getCatalogCourseSearch: function (params) {
        /*
         * api/ctl/catalog-course-search/Search={Search}&itemType={itemType}&searchScope={searchScope}&isbindtype={isbindtype}&roleID={roleID}&
         isbindtype={isbindtype}&showHistorialCourse={showHistorialCourse}&showUnpublished={showUnpublished}&courseFilterType={courseFilterType}&
         keyword={keyword}&current_page={current_page}&list_size={list_size}
         * */
        return _CtlService
          .customGETLIST('catalog-course-search', params);
      },

      getCompanys: function (params) {
        /*
         * api/ctl/selection-dropdown/companys?showAllOption={showAllOption}&selectedValue={selectedValue}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('companys', params);
      },

      getCompanySubjects: function (params) {
        /*
         * api/ctl/selection-dropdown/subjects?companyId=4&showAllOption=false&selectedValue=80
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('subjects', params);
      },

      getAllCurrency: function (params) {
        /*
         * api/ctl/selection-dropdown/all-currency?showAllOption={showAllOption}&selectedValue={selectedValue}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('all-currency', params);
      },

      getInnercertClasses: function (params) {
        /*
         * api/ctl/selection-dropdown/innercert-classes?showAllOption={showAllOption}&selectedValue={selectedValue}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('innercert-classes', params);
      },

      getInnercerts: function (params) {
        /*
        * api/ctl/selection-dropdown/innercerts?showAllOption={showAllOption}&selectedValue={selectedValue}
        * &classificationId={classificationId}
        * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('innercerts', params);
      },

      getExtcertApplyClasses: function (params) {
        /*
         * api/ctl/selection-dropdown/extcert-apply-classes?showAllOption={showAllOption}&selectedValue={selectedValue}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('extcert-apply-classes', params);
      },

      getCompensationTestItem: function (params) {
        /*
         * api/ctl/selection-dropdown/compensation-test-item?showAllOption={showAllOption}&selectedValue={selectedValue}
         * &testApplyFormId={testApplyFormId}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('compensation-test-item', params);
      },

      getManageGroups: function (params) {
        /*
         * api/ctl/selection-dropdown/manage-groups?showAllOption={showAllOption}&selectedValue={selectedValue}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('manage-groups', params);
      },

      getManageMembers: function (params) {
        /*
         * api/ctl/selection-dropdown/manage-members?showAllOption={showAllOption}&selectedValue={selectedValue}
         * &groupId={groupId}&filterSelf={filterSelf}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('manage-members', params);
      },

      getClassifications: function (params) {
        /*
         * api/ctl/selection-dropdown/classifications?type={type}&showAllOption={showAllOption}&amp&selectedValue={selectedValue}
         * */
        return _CtlService
          .one('selection-dropdown')
          .customGETLIST('classifications', params);
      }


    };

  }


  angular.module('eHRD.modules.utils')
    .factory('ctlService', ctlService);
})();

/**
 * Created by Bruce on 2016/12/29.
 */
(function () {
  'use strict';

  classTimeUtils.$inject = ['momentUtils'];
  function classTimeUtils(momentUtils) {

    function getRepeatRanges(startDateTime, endDateTime, classTime) {
      var dateRanges = [];
      var _dateRanges = [];
      switch (classTime.repeatIntervalUnit){
        case 'week':
          _dateRanges = [];
          dateRanges = [];
          _dateRanges = buildRepeatRanges(momentUtils.range(startDateTime, endDateTime).toArray('weeks'), classTime);
          angular.forEach(_dateRanges, function (_dateRange) {
            var sd = _dateRange.toDate();
            var ed = moment(sd).add(1, 'weeks').add(-1, 'days');
            if(ed > endDateTime) ed = moment(endDateTime);
            dateRanges = dateRanges.concat(momentUtils.range(sd, ed.toDate()).toArray('days'));
          });
          break;
        case 'month':
          _dateRanges = [];
          dateRanges = [];
          _dateRanges = buildRepeatRanges(momentUtils.range(startDateTime, endDateTime).toArray('months'), classTime);
          angular.forEach(_dateRanges, function (_dateRange) {
            var sd = _dateRange.toDate();
            var ed = moment(sd).add(1, 'months').add(-1, 'days');
            if(ed > endDateTime) ed = moment(endDateTime);
            dateRanges = dateRanges.concat(moment.range(sd, ed.toDate()).toArray('days'));
          });
          break;
        case 'year':
          _dateRanges = [];
          dateRanges = [];
          _dateRanges = buildRepeatRanges(momentUtils.range(startDateTime, endDateTime).toArray('years'), classTime);
          angular.forEach(_dateRanges, function (_dateRange) {
            var sd = _dateRange.toDate();
            var ed = moment(sd).add(1, 'years').add(-1, 'days');
            if(ed > endDateTime) ed = moment(endDateTime);
            dateRanges = dateRanges.concat(momentUtils.range(sd, ed.toDate()).toArray('days'));
          });
          break;
      }

      return dateRanges;
    }
    function buildRepeatRanges(dateRanges, classTime){
      var nextIndex = 0, repeatRanges = [];
      angular.forEach(dateRanges, function (dateRange, index) {
        if(angular.equals(nextIndex, index))  {
          repeatRanges.push(dateRange);
          nextIndex += (parseInt(classTime.repeatIntervalNumber));
        }
      });
      return repeatRanges;
    }


    function getDateTimeRangesByClassTime(classTime) {
      // courseTimeDesc format ===> 2016/12/31 每1週 00:00-23:00 休息時間12:00-13:00
      // classTime Format ==> 2016/12/31_0:0-12:0,2016/12/31_13:0-23:0
      /*
       * SPEC
       * 1. 未設定休息時間，日期起迄為 (上課開始日期 + 上課開始時間) 到 (上課結束日期 + 上課結束時間)
       * 2. 有設定休息時間，上課時間會變為，a. 上課開始時間 到 休息開始時間; b. 休息結束時間 到 上課結束時間，
       *    日期起迄為
       *    (1). (上課開始日期 + 上課開始時間) 到 (上課結束日期 + 休息開始時間)
       *    (2). (上課開始日期 + 休息結束時間) 到 (上課結束日期 + 上課結束時間)
       * 3. 承1.或2.，計算出日期時間區段，排除未包含的工作日(包含日，預設星期日到星期六)
       * 4. 如有開啟循環模式 承(1.或2.) 和3.，
       * */
      var dateTimeRanges = [];
      var startDateTime = moment(classTime.startDate).set({
        'hour' : classTime.startH,
        'minute'  : classTime.startM,
        'second' : "0"
      }).toDate();
      var endDateTime = moment(classTime.endDate).set({
        'hour' : classTime.endH,
        'minute'  : classTime.endM,
        'second' : "0"
      }).toDate();

      var dateRanges = momentUtils.range(startDateTime, endDateTime).toArray('days');
      if(classTime.isEnableRepeat){
        dateRanges = getRepeatRanges(startDateTime, endDateTime, classTime);
      }

      angular.forEach(dateRanges, function (dateRange) {
        if(classTime.includeDays.indexOf(dateRange.day()) > -1) {
          dateTimeRanges.push(dateRange);
        }
      });

      return dateTimeRanges;
    }

    function getClassTimesFormatted(classTime) {
      var _classTime = [];
      var startDateTime = moment(classTime.startDate).set({
        'hour' : classTime.startH,
        'minute'  : classTime.startM,
        'second' : "0"
      }).toDate();
      var endDateTime = moment(classTime.endDate).set({
        'hour' : classTime.endH,
        'minute'  : classTime.endM,
        'second' : "0"
      }).toDate();
      var dateRanges = momentUtils.range(startDateTime, endDateTime).toArray('days');
      if(classTime.isEnableRepeat){
        dateRanges = getRepeatRanges(startDateTime, endDateTime, classTime);
      }

      angular.forEach(dateRanges, function (dateRange) {
        if(classTime.includeDays.indexOf(dateRange.day()) > -1) {
          var sd = dateRange.format("YYYY/MM/DD");
          if(classTime.isEnableRestTime){
            var rdt1 = sd + '_' + classTime.startH + ':' + classTime.startM + '-' + + classTime.rest_startH + ':' + classTime.rest_startM;
            _classTime.push(rdt1);
            var rdt2 = sd + '_' + classTime.rest_endH + ':' + classTime.rest_endM + '-' + + classTime.endH + ':' + classTime.endM;
            _classTime.push(rdt2);
          }else {
            var dt = sd + '_' + classTime.startH + ':' + classTime.startM + '-' + + classTime.endH + ':' + classTime.endM;
            _classTime.push(dt);
          }
        }
      });
      return _classTime;
    }

    function mergeClassTimes(classTimePools) {
      var classTimeFormatted = [];
      angular.forEach(classTimePools, function (_classTime) {
        var currentClassTimes = getClassTimesFormatted(_classTime);
        angular.forEach(currentClassTimes, function (currentClassTime) {
          if(classTimeFormatted.indexOf(currentClassTime) === -1){
            classTimeFormatted.push(currentClassTime);
          }
        })
      });
      return classTimeFormatted;
    }
    return{
      getDateTimeRangesByClassTime: getDateTimeRangesByClassTime,

      getClassTimesFormatted: getClassTimesFormatted,

      mergeClassTimes: mergeClassTimes
    };
  }

  angular
    .module('eHRD.modules.utils')
    .factory('classTimeUtils', classTimeUtils);
})();

/**
 * Created by Bruce on 2017/3/1.
 */
(function () {
  'use strict';

  urlIncludesServerPath.$inject = ['$sce', 'serverSetting'];
  function urlIncludesServerPath($sce, serverSetting) {
    return function(url) {
      url = url || '';
      return $sce.trustAsHtml((url.contains('http') ? url : (serverSetting.baseConfig.serverAddress + url)));
    };
  }

  angular.module('eHRD.modules.utils')
    .filter('urlIncludesServerPath', urlIncludesServerPath);

})();

/**
 * Created by Bruce on 2017/2/20.
 */

(function () {
  'use strict';

  trustAsHtml.$inject = ['$sce'];
  function trustAsHtml($sce) {
    return function(text) {
      return $sce.trustAsHtml(text);
    };
  }

  angular.module('eHRD.modules.utils')
    .filter('trustAsHtml', trustAsHtml);

})();

/**
 * Created by Bruce on 2017/3/24.
 * Set suffixes after val
 *   (1)$filter('suffixes')(100, '%')
 *      => 100 %
 *   (2) {{ 100 | suffixes: '%'}}
 *      => 100 %
 * @param val (String, int)
 * @param suffixes (String)
 */
(function () {
  'use strict';

  suffixes.$inject = [];
  function suffixes() {
    return function(val, symbol) {
      symbol = symbol || '';
      return val + ' ' + symbol;
    };
  }

  angular.module('eHRD.modules.utils')
    .filter('suffixes', suffixes);

})();

/**
 * Created by Bruce on 2017/2/20.
 */
(function () {
  'use strict';

  stringToNumber.$inject = [];
  function stringToNumber() {
    return function(val) {
      return parseInt(val);
    };
  }

  angular.module('eHRD.modules.utils')
    .filter('stringToNumber', stringToNumber);

})();

/**
 * Created by Bruce on 2017/2/20.
 */
(function () {
  'use strict';

  stringSplitToValue.$inject = [];
  function stringSplitToValue() {
    return function(str, split, index) {
      str = str || '';
      return angular.isDefined(str.split(split)[index]) ? str.split(split)[index] : null;
    };
  }

  angular.module('eHRD.modules.utils')
    .filter('stringSplitToValue', stringSplitToValue);

})();

/**
 * Created by Alan on 2017/1/12.
 * String replace using a regex expression
 *   (1)'Hello Word' |replaceAll:'Word':'Alan'  => Hello Alan
 *   (2)'123' |replaceAll:'(.{2})':'$1.'  => 12.3
 * @param string
 * @param oldValue Replaced by old value
 * @param newValue Replace the new value
 */
(function () {
  'use strict';

  replaceAll.inject = [];
  function replaceAll() {
    return function (string, oldValue, newValue) {
      var regExp= new RegExp(oldValue, "g");
      return (angular.isDefined(string))?string.replace(regExp, newValue):string;
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('replaceAll', replaceAll)
})();

/**
 * Created by Bruce on 2016/9/22.
 */
(function () {
  'use strict';

  numberToMonth.inject = [];
  function numberToMonth() {
    return function (monthNumber) {
      var monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December' ];
      return monthNames[monthNumber - 1];
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('numberToMonth', numberToMonth)
})();

/**
 * Created by Alan on 2017/2/8.
 * Number format conversion
 *    (1)16.4   |nameRegular:'floor' => 16
 *    (2)16.4   |nameRegular:'round' => 16
 *    (3)16.4   |nameRegular:'ceil'  => 17
 * @param number
 * @param method Conversion method
 */
(function () {
  'use strict';

  numberFormat.inject = [];
  function numberFormat() {
    return function (number, method) {
      var newNumber;
      switch(method) {
        case 'floor':
          newNumber = Math.floor(number);
          break;
        case 'round':
          newNumber = Math.round(number);
          break;
        case 'ceil':
          newNumber = Math.ceil(number);
          break;
        case 'abs':
          newNumber = Math.abs(number);
          break;
      }
      return newNumber;
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('numberFormat', numberFormat)
})();

/**
 * Created by Alan on 2017/1/19.
 * Avatar English and Chinese name judgment
 *   (1)'大寶'   |nameRegular => 大寶
 *   (2)'Alan'   |nameRegular => A
 * @param name
 */
(function () {
  'use strict';

  nameRegular.inject = ['$filter'];
  function nameRegular($filter) {
    return function (name) {
      var regExp = /^[\d|\u4e00-\u9fa5]$/;
      if (!regExp.test(name[0]))
        return $filter('uppercase')(name[0]);
      else
        return name.trim().slice(-2);
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('nameRegular', nameRegular)
})();

/**
 * Created by Alan on 2016/11/3.
 * Insert a mark between strings and use foreach or ng-repeat
 *   (1)<span ng-repeat="instructor in $ctrl.sessionData.instructorList">
 *          <a>{{instructor.instructorName | markSplit:$index:'&nbsp;/&nbsp;'}}</a>
 *     </span>
 *     => 小寶 / 中寶 / 大寶
 * @param data   Array or Object
 * @param index  Data index
 * @param mark   String between the mark
 */
(function () {
  'use strict';

  markSplit.inject = [];
  function markSplit() {
    return function (data,index,mark) {
        data=(index===0)?data:mark+data;
      return data;
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('markSplit', markSplit)
})();

/**
 * Created by Bruce on 2017/3/28.
 * Html Escaped Decode
 *    String = &lt;&#160;&#160;&gt;
 *   (1)$filter('html-escaped-decode')(String)
 *      => <  >
 *   (2) {{ String | htmlEscapedDecode}}
 *      => <  >
 * @param val (String)
 */
(function () {
  'use strict';

  htmlEscapedDecode.$inject = [];
  function htmlEscapedDecode() {
    return function(input) {
      var entities = [
        ['amp', '&'],
        ['apos', '\''],
        ['#x27', '\''],
        ['#x2F', '/'],
        ['#39', '\''],
        ['#47', '/'],
        ['lt', '<'],
        ['gt', '>'],
        ['nbsp', ' '],
        ['quot', '"'],
        ['#160', ' ']
      ];

      if(angular.isString(input)){
        angular.forEach(entities, function (entitie) {
          input = input.replace(new RegExp('&'+entitie[0]+';', 'g'), entitie[1]);
        })
      }
      return input;
    };
  }

  angular.module('eHRD.modules.utils')
    .filter('htmlEscapedDecode', htmlEscapedDecode);

})();

/**
 * Created by Alan on 2017/6/20.
 */
(function () {
  'use strict';

  hexConvertRgba.$inject = [];
  function hexConvertRgba() {
    return function (colors, opacity) {
      var newColors;
      opacity = angular.isUndefinedOrNull(opacity)?1:opacity;
      if(angular.isArray(colors)) {
        newColors = [];
        angular.forEach(colors, function(color){
          newColors.push(getRgba(color));
        });
      }else {
        newColors = getRgba(colors);
      }

      function getRgba(color) {
        var hex = color.replace('#','');
        var r = parseInt(hex.substring(0,2), 16);
        var g = parseInt(hex.substring(2,4), 16);
        var b = parseInt(hex.substring(4,6), 16);
        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
      }

      return newColors;
    };

  }

  angular
    .module('eHRD.modules.utils')
    .filter('hexConvertRgba', hexConvertRgba);
})();

/**
 * Created by Bruce on 2016/9/11.
 */

(function () {
  'use strict';

  function getArrayObjectByKey() {
    return function(data, key, value) {
      var i=0, len=data.length;
      for (; i<len; i++) {
        if (+data[i][key] == +value) {
          return data[i];
        }
      }
      return null;
    }
  }
  angular.module('eHRD.modules.utils')
      .filter('getArrayObjectByKey', getArrayObjectByKey);

})();

/**
 * Created by Alan on 2017/1/19.
 * Minute conversion to any time format
 *   (1)'181'   |durationFormat:'HH:mm:ss' => 03:01:00
 * @param duration Minute
 * @param format Time format
 */
(function () {
  'use strict';

  durationFormat.inject = [];
  function durationFormat() {
    return function (duration, format) {
      return moment.utc(moment.duration(duration*60000).asMilliseconds()).format(format);
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('durationFormat', durationFormat)
})();

/**
 * Created by Alan on 2016/12/1.
 * Custom date and time format
 *   (1)$filter('dateTimeFormat')(new Date('2017/3/9'), 2, 55, '/')  => 2017/03/09 2:55
 *   (2)$filter('dateTimeFormat')(new Date('2017/3/9'), 20, 55, '-') => 2017-03-09 20:55
 * @param data     Any Date Format
 * @param hour     Hour
 * @param minute   Minute
 * @param dateMark Date between the mark
 */
(function () {
    'use strict';

    dateTimeFormat.inject = [];
    function dateTimeFormat() {
        return function (data, hour, minute, dateMark) {

            var year = "" + data.getFullYear();
            var month = "" + (data.getMonth() + 1);
            var day = "" + data.getDate();

            if (month.length == 1) {
                month = "0" + month;
            }
            if (day.length == 1){
                day = "0" + day;
            }
            if (hour.length == 1){
                hour = "0" + hour;
            }
            if (minute.length == 1){
                minute = "0" + minute;
            }
            return year + dateMark + month + dateMark + day + " " + hour + ":" + minute ;
        }
    }

    angular.module('eHRD.modules.utils')
        .filter('dateTimeFormat', dateTimeFormat)
})();

/**
 * Created by Alan on 2017/2/10.
 * Number conversion to thousands format
 *   (1)'1234'   |costFormat => 1234
 *   (2)'12345'  |costFormat => 12.3<span>K</span>
 *   (3)'123456' |costFormat => 123<span>K</span>
 * @param cost To convert the formatted number
 */
(function () {
  'use strict';

  costFormat.inject = ['$filter'];
  function costFormat($filter) {
    return function (cost) {
      cost = (angular.isUndefined(cost))?'0':cost.toString();
      if(cost.length === 5) {
        cost = $filter('replaceAll')(cost.slice(0,-2), '(.{2})', '$1.') + '<span>K</span>';
      }
      else if(cost.length > 5) {
        cost = $filter('number')(cost.slice(0, -3)) + '<span>K</span>';
      }
      return cost;
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('costFormat', costFormat)
})();

/**
 * Created by Alan on 2016/11/3.
 * Array is converted and the mark are inserted between the arrays
 *   (1)$filter('arrayToString')(['apple', 'banana', 'cookie'], ' and ', 'array')
 *      => ['apple and', 'banana and', 'cookie']
 *   (2)$filter('arrayToString')(['apple', 'banana', 'cookie'], ' and ')
 *      => apple and banana and cookie
 * @param array
 * @param mark Array and array between the mark
 * @param dataType Return data format
 */
(function () {
  'use strict';

  arrayToString.inject = [];
  function arrayToString() {
    return function (array, mark, dataType) {
      var data="";
      angular.forEach(array, function(value, key) {
        array[key] = (array.length-1!==key) ?value + mark :value;
      });
      switch(dataType) {
        case 'array':
          data = array;
          break;
        default:
          data = array.join('');
          break;
      }

      return data;
    }
  }

  angular.module('eHRD.modules.utils')
  .filter('arrayToString', arrayToString)
})();

/**
 * Created by Bruce on 2016/12/29.
 */
(function () {
  'use strict';

  arrayObjectIndexOf.$inject = [];
  function arrayObjectIndexOf() {
    return function (arr, obj) {
      for(var i = 0; i < arr.length; i++){
        if(angular.equals(arr[i], obj)){
          return i;
        }
      }
      return -1;
    };
  }

  angular
    .module('eHRD.modules.utils')
    .filter('arrayObjectIndexOf', arrayObjectIndexOf);
})();

/**
 * Created by Bruce on 2017/2/17.
 */
(function () {
  'use strict';

  viewCtmsReference.$inject = ['$window', 'serverSetting'];
  function viewCtmsReference($window, serverSetting) {
    var directive = {
      restrict: 'A',
      scope: {
        packageId: '=?packageId',
        itemSection: '=?itemSection',
        fileName: '=?fileName'
      },
      link: function (scope, element) {
        scope.packageId = angular.isDefined(scope.packageId) ? scope.packageId : undefined;
        scope.itemSection = angular.isDefined(scope.itemSection) ? scope.itemSection : 'CTMSReference';
        scope.fileName = angular.isDefined(scope.fileName) ? scope.fileName : undefined;

        element.bind('click', function() {
          var url = serverSetting.baseConfig.baseURL;
          if(angular.isDefined(scope.packageId) && angular.isDefined(scope.fileName) && angular.isDefined(scope.itemSection)){
            url += ('/servlet/openFile?mode=Download&packageId=' + scope.packageId + '&itemSection='+ scope.itemSection +'&fileName=' + scope.fileName);
            $window.open(url, '_blank')
          }
        });
      }
    };
    return directive;
  }

  angular
    .module('eHRD.modules.utils')
    .directive('viewCtmsReference', viewCtmsReference);
})();

/**
 * Created by Bruce on 2017/2/9.
 */
(function () {
  'use strict';

  tipInfo.$inject = ['$mdDialog'];
  function tipInfo($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        tipType: '@?tipType',
        params: '=?params'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/utils/views/tip-info-dialog.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            escapeToClose: true,
            controller: ['$scope', 'utilsService', 'tipType', 'params', function ($scope, utilsService, tipType, params) {
              var vm = this;
              vm.tipType = tipType;
              utilsService.getTipInfo(tipType, params).then(function (data) {
                vm.displayName = data.metadata.displayName;
                vm.tipInfos = data;
              });

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            controllerAs: '$ctrl',
            bindToController: true,
            fullscreen: true,
            multiple: true,
            locals: {
              tipType: scope.tipType,
              params: scope.params
            }
          }).then(function() {}, function() {});
        });
      }
    };
    return directive;
  }

  angular
    .module('eHRD.modules.utils')
    .directive('tipInfo', tipInfo);
})();

/**
 * Created by Bruce on 2017/3/7.
 */
(function () {
  'use strict';

  onFinishNgRepeat.$inject = ['$timeout'];
  function onFinishNgRepeat($timeout) {
    var directive = {
      restrict: 'A',
      link: function (scope, element, attr) {
        if (scope.$last === true) {
          $timeout(function () {
            scope.$evalAsync(attr.onFinishNgRepeat);
          });
        }
      }
    };
    return directive;
  }

  angular
    .module('eHRD.modules.utils')
    .directive('onFinishNgRepeat', onFinishNgRepeat);
})();

/**
 * Created by Bruce on 2017/2/20.
 */
(function () {
  'use strict';

  externalReferenceServlet.$inject = ['$window', 'serverSetting'];
  function externalReferenceServlet($window, serverSetting) {
    var directive = {
      restrict: 'A',
      scope: {
        externalId: '=?externalId',
        num: '=?num'
      },
      link: function (scope, element) {
        scope.externalId = angular.isDefined(scope.externalId) ? scope.externalId : undefined;
        scope.num = angular.isDefined(scope.num) ? scope.num : undefined;

        element.bind('click', function() {
          var url = serverSetting.baseConfig.baseURL;
          if(angular.isDefined(scope.externalId) && angular.isDefined(scope.num)){
            url += ('/servlet/ExternalRefServlet?externalId=' + scope.externalId + '&num='+ scope.num);
            $window.open(url, '_blank')
          }
        });
      }
    };
    return directive;
  }

  angular
    .module('eHRD.modules.utils')
    .directive('externalReferenceServlet', externalReferenceServlet);
})();

/**
 * Created by Alan on 2017/5/17.
 */
(function () {
  'use strict';

  emptyIframe.$inject = ['$window'];
  function emptyIframe($window) {
    var directive = {
      restrict: 'EA',
      scope: {
        content: '='
      },
      template:'<iframe frameborder="0" scrolling="no" width="100%"></iframe>',
      link:  function (scope, element) {
        var iframe = element.find('iframe');
        iframe.ready(function(){
          iframe.contents().find('body').append(scope.content);
          iframe.contents().find('body').css('font-family', '"Microsoft JhengHei", RobotoDraft, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif');
          iframe.contents().find('body').css('font-weight', 'normal');
          iframeResize();
        });
        angular.element($window).on('resize', function () {
          iframeResize();
        });

        function iframeResize() {
          iframe.css('height', '100%');
          iframe.css('height', iframe.contents().find("html").height() + 'px');
        }
      }
    };
    return directive;
  }

  angular
    .module('eHRD.modules.utils')
    .directive('emptyIframe', emptyIframe);
})();

/**
 * Created by Bruce on 2016/12/27.
 */
(function () {
  'use strict';

  classTimeHandle.$inject = ['$mdDialog', 'momentUtils'];
  function classTimeHandle($mdDialog, momentUtils) {
    var directive = {
      restrict: 'A',
      scope: {
        classTimePools: '=',
        editorId: '=?'
      },
      link: function (scope, element, attr) {
        element.bind('click', function(ev) {
          if(attr.classTimeHandle !== 'delete'){
            $mdDialog.show({
              templateUrl: 'app/modules/utils/views/class-time-dialog.html',
              targetEvent: ev,
              clickOutsideToClose: true,
              escapeToClose: true,
              controller: ['$scope', '$filter', 'SweetAlert', 'momentUtils', 'classTimeUtils',
                           'classTimePools', 'editorId',
                            function ($scope, $filter, SweetAlert, momentUtils, classTimeUtils,
                                      classTimePools, editorId) {

                var vm = this;
                var currentDateTimePull = [];
                var localeDate = moment.localeData();
                vm.classTimePools = classTimePools;
                vm.weekDays = localeDate._weekdays;
                vm.repeatIntervalNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                vm.repeatIntervalUnits = ['week', 'month', 'year'];

                if( editorId > -1){
                  vm.classTime = angular.copy(vm.classTimePools[editorId], vm.classTime);
                }else{
                  vm.classTime = {
                    startDate: new Date(),
                    endDate: new Date(),
                    startH: 9,
                    startM: 0,
                    endH: 18,
                    endM: 0, // eq 55 min
                    isEnableRestTime: false,
                    rest_startH: 12,
                    rest_startM: 0,
                    rest_endH: 13,
                    rest_endM: 0,
                    isEnableRepeat: false,
                    repeatIntervalNumber: 1,
                    repeatIntervalUnit: 'week',
                    includeDays: []
                  };
                  angular.forEach(vm.weekDays, function (weekDay, index) {
                    vm.classTime.includeDays.push(index);
                  });
                }

                vm.includeDaysToggle = function(item) {
                  var idx = vm.classTime.includeDays.indexOf(item);
                  if (idx > -1) {
                    vm.classTime.includeDays.splice(idx, 1);
                  }else {
                    vm.classTime.includeDays.push(item);
                  }
                };

                function checkCurrentClassTime() {
                  currentDateTimePull = classTimeUtils.getDateTimeRangesByClassTime(vm.classTime);
                  return (currentDateTimePull.length > 0);
                }
                function checkClassTime() {
                  var vaildObj = {
                    classTime: true
                  };
                  var dateTime = [];

                  angular.forEach(vm.classTimePools, function (classTime, index) {
                    if(vaildObj.classTime && (editorId!==index)){
                      dateTime = dateTime.concat(classTimeUtils.getDateTimeRangesByClassTime(classTime));
                      angular.forEach(dateTime, function (_dateTime) {
                        if(vaildObj.classTime){
                          if(classTime.includeDays.indexOf(_dateTime.day()) > -1) {
                            var _startDateTime = _dateTime.set({
                              'hour' : classTime.startH,
                              'minute'  : classTime.startM,
                              'second' : "0"
                            }).toDate();
                            _startDateTime = new Date(_startDateTime);
                            var _endDateTime = _dateTime.set({
                              'hour' : classTime.endH,
                              'minute'  : classTime.endM,
                              'second' : "0"
                            }).toDate();
                            _endDateTime = new Date(_endDateTime);

                            var range  = momentUtils.range(_startDateTime, _endDateTime);
                            angular.forEach(currentDateTimePull, function (currentDateTime) {
                              if(vaildObj.classTime){
                                var _checkStartDate = currentDateTime.set({
                                  'hour' : vm.classTime.startH,
                                  'minute'  : vm.classTime.startM,
                                  'second' : "0"
                                }).toDate();
                                _checkStartDate =  new Date(_checkStartDate);
                                var _checkEndDate = currentDateTime.set({
                                  'hour' : vm.classTime.endH,
                                  'minute'  : vm.classTime.endM,
                                  'second' : "0"
                                }).toDate();
                                _checkEndDate =  new Date(_checkEndDate);
                                if(momentUtils.range(_checkStartDate, _checkEndDate).overlaps(range)) {
                                  vaildObj.classTime = false;
                                  vaildObj.conflict = (parseInt(index) + 1);
                                }
                              }
                            });
                          }
                        }
                      });
                    }
                  });
                  return vaildObj;
                }

                vm.submit = function () {
                  // 檢查當前時間是否符合規則
                  if(checkCurrentClassTime()){
                    // 比對已設定時間，是否有衝突
                    var _checkClassTime = checkClassTime();
                    if(_checkClassTime.classTime){
                      if(editorId > -1){
                        vm.classTimePools[editorId] = vm.classTime;
                      }else {
                        vm.classTimePools.push(vm.classTime);
                        // mergeClassTime();
                      }
                      $mdDialog.hide(vm.classTimePools);
                    }else {
                      SweetAlert.error($filter('translate')('MESSAGE.MSG_TIME_PERIOD_N_PARTIALLY_OVERLAPS_PLEASE_RESET', {value: _checkClassTime.conflict}), '');
                    }
                  }else{
                    SweetAlert.warning($filter('translate')('MESSAGE.MSG_THE_SETTING_TIME_DOES_NOT_EXIST_PLEASE_RE_ENTER'), '');
                  }
                };

                vm.updateEndDateModel = function () {
                  var beginningTime = moment(vm.classTime.startDate);
                  var endTime = moment(vm.classTime.endDate);
                  if(!beginningTime.isBefore(endTime)){
                    vm.classTime.endDate = vm.classTime.startDate;
                  }
                };

                vm.close = function() {
                  $mdDialog.cancel();
                };
              }],
              controllerAs: '$ctrl',
              bindToController: true,
              fullscreen: true,
              locals: {
                classTimePools: angular.isDefined(scope.classTimePools) ? scope.classTimePools : [],
                editorId: angular.isDefined(scope.editorId) ? scope.editorId : -1
              }
            }).then(function() {}, function() {});
          }
        });
      }
    };
    return directive;
  }

  angular
    .module('eHRD.modules.utils')
    .directive('classTimeHandle', classTimeHandle);
})();

/**
 * Created by Bruce on 2017/3/21.
 */
(function () {
  'use strict';

  bindCompiledHtml.$inject = [];
  function bindCompiledHtml() {
    var directive = {
      restrict: 'A',
      controller: bindCompiledHtmlController
    };
    return directive;
  }

  bindCompiledHtmlController.$inject = ["$scope", "$element", "$attrs", "$compile"];
  function bindCompiledHtmlController($scope, $element, $attrs, $compile){
    $scope.$watch($attrs.bindCompiledHtml, compileHtml);

    function compileHtml(html){
      // debugger;
      var compiledElements = $compile(html)($scope);
      $element.append(compiledElements);
    }
  }

  angular
    .module('eHRD.modules.utils')
    .directive('bindCompiledHtml', bindCompiledHtml);
})();

/**
 * Created by Alan on 2017/4/12.
 */
(function () {
  'use strict';

  avatar.$inject = [];
  function avatar() {
    var directive = {
      restrict: 'AE',
      scope: {
        avatarUrl: '=',
        firstName: '=',
        lineHeight:'@?',
        fontSize:  '@?'
      },
      replace: true,
      templateUrl: 'app/modules/utils/views/avatar.html',
      controller: ['$scope', function ($scope) {
        $scope.getRandom = function () {
          var colors = ['#9bba42', '#ef562d', '#936cae', '#a97b50', '#fb8c00', '#5587a2', '#d13076'];
          return colors[Math.floor((Math.random() * 7))];
        };
      }]
    };
    return directive;
  }

  angular
    .module('eHRD.modules.utils')
    .directive('avatar', avatar);
})();

/**
 * Created by Bruce on 2017/03/24.
 */
(function () {
  'use strict';

  var uploadRefs = {
    bindings: {
      ngModel: '=ngModel',
      refs: '=?refs',
      maxCount: '@?maxCount',
      isMultiple: '=?isMultiple',
      ngDisabled: '=?ngDisabled'
    },
    templateUrl: 'app/modules/utils/views/upload-refs.html',
    controller: ['$scope', function ($scope) {
      var vm = this;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : {};
      vm.maxCount = angular.isDefined(this.maxCount) ? this.maxCount: -1;
      vm.isMultiple = angular.isDefined(this.isMultiple) ? this.isMultiple: false;
      vm.refs = angular.isDefined(this.refs) ? this.refs : [];

      $scope.$watch(function () {
        return vm.refs;
      },function (newVal) {
        var fileLength = 0;
        vm.refsObject = {};
        if(angular.isDefined(newVal) && vm.refs.length > 0){
          angular.forEach(vm.refs, function (ref) {
            if(ref.packageId > 0){
              vm.refsObject[(parseInt(ref.index) - 1)] = ref;
              fileLength = ref.index;
            }
          });
        }

        vm.files = [];
        vm._files = {};
        if(fileLength === 0){
          vm.files = [0];
          vm.ngModel[0] = undefined;
        }else{
          var fileIndex = 0;
          while(fileLength > 0){
            vm.files.push(fileIndex);
            vm._files[fileIndex] = undefined;
            fileIndex ++;
            fileLength --;
          }
        }
      }, true);

      vm.replaceFile = function (index, files) {
        if(files.length === 0){
          vm._files[index] = undefined;
        }else {
          vm._files[index] = files[0];
        }
        vm.ngModel = vm._files;
      };

      vm.selectFile = function (index, files) {
        if(files.length === 0){
          vm._files[index] = undefined;
        }else {
          vm._files[index] = files[0];
        }
        vm.ngModel = vm._files;
      };

      vm.addFileSelect = function (index) {
        vm.files.push(vm.files.length);
        vm.ngModel[(index+1)] = '';
      };

      vm.removeFileSelect = function (index) {
        vm.files.splice(index, 1);
        vm.refsObject[index] = null;
        vm.ngModel[index] = '';
      };
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('uploadRefs', uploadRefs);

})();

/**
 * Created by Bruce on 2016/12/29.
 */
(function () {
  'use strict';

  var uploadCourseDataFiles = {
    bindings: {
      ngModel: '=ngModel',
      refs: '=?refs',
      externalId: '=?externalId',
      maxCount: '@?maxCount',
      isMultiple: '=?isMultiple',
      ngDisabled: '=?ngDisabled',
      externalTrainingVendors: '=?'
    },
    templateUrl: 'app/modules/utils/views/upload-course-data-files.html',
    controller: ['$scope', function ($scope) {
      var vm = this;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : {};
      vm.maxCount = angular.isDefined(this.maxCount) ? this.maxCount: -1;
      vm.isMultiple = angular.isDefined(this.isMultiple) ? this.isMultiple: false;
      vm.refs = angular.isDefined(this.refs) ? this.refs : [];
      vm.refs = angular.isDefined(this.externalTrainingVendors) ? this.externalTrainingVendors : false;

      $scope.$watch(function () {
        return vm.refs;
      },function (newVal) {
        var fileLength = 0;
        vm.refsObject = {};
        if(angular.isDefined(newVal) && vm.refs.length > 0){
          angular.forEach(vm.refs, function (ref, idx, array) {
            vm.refsObject[(parseInt(ref.num) - 1)] = ref;
            if(angular.equals(idx, (array.length-1))){
              fileLength = ref.num;
            }
          });
        }

        vm.files = [];
        vm._files = {};
        if(fileLength === 0){
          vm.files = [0];
          vm.ngModel[0] = undefined;
        }else{
          var fileIndex = 0;
          while(fileLength > 0){
            vm.files.push(fileIndex);
            vm._files[fileIndex] = undefined;
            fileIndex ++;
            fileLength --;
          }
        }
      }, true);

      vm.replaceFile = function (index, files) {
        if(files.length === 0){
          vm._files[index] = undefined;
        }else {
          vm._files[index] = files[0];
        }
        vm.ngModel = vm._files;
      };

      vm.selectFile = function (index, files) {
        if(files.length === 0){
          vm._files[index] = undefined;
        }else {
          vm._files[index] = files[0];
        }
        vm.ngModel = vm._files;
      };

      vm.addFileSelect = function (index) {
        vm.files.push(vm.files.length);
        vm.ngModel[(index+1)] = undefined;
      };

      vm.removeFileSelect = function (index) {
        if(vm.refs) {
          vm.refs.splice(index, 1);
        }
        vm.files.splice(index, 1);
        delete vm.ngModel[index];
      };
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('uploadCourseDataFiles', uploadCourseDataFiles);

})();

/**
 * Created by Alan on 2017/6/30.
 */
(function () {
  'use strict';

  var squareText = {
    bindings: {
      width: '@?',
      height: '@?',
      color: '@?',
      fontSize: '@?',
      text: '@?'
    },
    templateUrl: 'app/modules/utils/views/square-text.html',
    controller: [function () {
      var vm = this;
      vm.width = angular.isUndefinedOrNull(vm.width)?38:this.width;
      vm.height = angular.isUndefinedOrNull(vm.height)?38:this.height;
      vm.color = angular.isUndefinedOrNull(vm.color)?'#F08917':this.color;
      vm.fontSize = angular.isUndefinedOrNull(vm.fontSize)?20:this.fontSize;
      vm.text = angular.isUndefinedOrNull(vm.text)?'':this.text;
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('squareText', squareText);

})();

/**
 * Created by Bruce on 2017/4/7.
 */
(function () {
  'use strict';

  var showCourseSessionName = {
    bindings: {
      courseId: '=?courseId',
      sessionId: '=?sessionId'
    },
    template: '<span ng-if="$ctrl.course">{{$ctrl.course.courseName}}</span><span ng-if="$ctrl.session">&nbsp;/&nbsp;{{$ctrl.session.sessionName}}</span>',
    controller: ['$filter', '$scope', 'courseResourceService', function ( $filter, $scope, courseResourceService) {
      var vm = this;
      vm.courseId = angular.isUndefined(this.courseId) ? undefined : this.courseId;
      vm.sessionId = angular.isUndefined(this.sessionId) ? undefined : this.sessionId;

      $scope.$watch(function () {
        return vm.courseId;
      }, function (newVal) {
        if(angular.isDefined(newVal)){
          courseResourceService.getCourse(vm.courseId, {}).then(function (course) {
            vm.course = course;
          });
        }
      });

      $scope.$watch(function () {
        return vm.sessionId;
      }, function (newVal) {
        if(angular.isDefined(newVal)){
          if(vm.sessionId != '-1'){
            courseResourceService.getCourseSession(vm.sessionId, {}).then(function (session) {
              vm.session = session;
            });
          }else{
            vm.session = {};
            vm.session['sessionName'] = $filter('translate')('ACTIONS.ADD_NEW_CLASS');
          }
        }
      });

    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('showCourseSessionName', showCourseSessionName);

})();

/**
 * Created by Bruce on 2016/12/29.
 */
(function () {
  'use strict';

  var selectExternalTrainingVendors = {
    bindings: {
      ngModel: '=ngModel',
      name: '@?name',
      required: '=?ngRequired',
      ngDisabled: '=?ngDisabled',
      onlyText: '=?onlyText',
      isReload: '=?',
      inputDisabled: '=?'
    },
    templateUrl: 'app/modules/utils/views/select-external-training-vendors.html',
    controller: ['$scope', '$element', 'externalTrainingService', function ($scope, $element, externalTrainingService) {
      var vm = this;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : [];
      vm.isReload = false;
      vm.vendorType = 2;
      vm.selectedVendor = null;
      vm.inputDisabled = angular.isDefined(this.inputDisabled) ? this.inputDisabled : false;

      var params = {
        keyword: '',
        list_size: 50,
        current_page: 1
      };
      getVendors(params);

      $scope.$watch(function () {
        return vm.searchTerm;
      },function (newVal) {
        params.keyword = newVal;
        getVendors(params);
      });


      $scope.$watch(function () {
        return vm.inputDisabled;
      },function (newVal) {
        vm.inputDisabled = newVal;
      });

      //reload
      $scope.$watch(function () {
        return vm.isReload;
      },function (newVal) {
        if(newVal) {
          getVendors(params);
          vm.isReload = false;
        }
      });

      vm.clearSearchTerm = function() {
        vm.searchTerm = '';
      };

      vm.queryVendors = function (vendorName) {
        params.keyword = vendorName;
        return externalTrainingService.getVendors(params).then(function(data) {
          return data;
        });
      };    

      vm.removeDuplicatedVendor = function(chip) {
        vm.ngModel = vm.ngModel
          .filter(function(vendor, pos, vendors) {
            return vendors.map(function(v) {
              return v.vendorId;
            }).indexOf(vendor.vendorId) == pos;
          });
      }; 

      function getVendors(params) {
        externalTrainingService.getVendors(params).then(function (vendors) {
          vm.vendors = vendors;
        });
      }

    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('selectExternalTrainingVendors', selectExternalTrainingVendors);

})();

/**
 * Created by Bruce on 2017/4/6.
 */
(function () {
  'use strict';

  var selectExternalClass = {
    bindings: {
      ngModel: '=?ngModel',
      externalId: '=?externalId',
      applicantId: '=?applicantId',
      ngDisabled: '=?ngDisabled'
    },
    template: '<md-button class="md-raised md-primary md-btn" ng-click="$ctrl.selectClass($event)" ng-disabled="$ctrl.ngDisabled">{{ ( $ctrl.ngModel ? "ACTIONS.EDIT_CLASS" : "ACTIONS.SELECT_CLASS")  | translate }}</md-button>',
    controller: ['$filter', '$scope', '$document', '$mdDialog', 'WizardHandler', 'SweetAlert', function ($filter, $scope, $document, $mdDialog, WizardHandler, SweetAlert) {
      var vm = this;
      vm.ngModel = angular.isUndefined(this.ngModel) ? undefined : this.ngModel;
      vm.externalId = angular.isUndefined(this.externalId) ? undefined : this.externalId;
      vm.applicantId = angular.isUndefined(this.applicantId) ? undefined : this.applicantId;
      vm.ngDisabled = angular.isUndefined(this.ngDisabled) ? false : this.ngDisabled;

      this.$onInit = function () {
        vm.selectClass = function (ev) {
          $mdDialog.show({
            controller: [ '$scope', 'externalId', 'applicantId', 'ngModel', function ($scope, externalId, applicantId, ngModel) {
              var vm = this;
              vm.externalId = externalId;
              vm.applicantId = applicantId;
              vm.ngModel = ngModel;
              vm.choiceCourseId = undefined;
              vm.currentStep = 1; vm.totalStep = 2;

              $scope.$watch(function () {
                return vm.ngModel;
              },function (newVal) {
                if(angular.isDefined(newVal)){
                  vm.choiceCourseId = angular.isDefined(vm.ngModel['courseId']) ? vm.ngModel['courseId'] : undefined;
                  vm.choiceSessionId = angular.isDefined(vm.ngModel['sessionId']) ? vm.ngModel['sessionId'] : undefined;
                }
              });

              vm.canExitStep1 = function () {
                var isCanNext = false;
                isCanNext = (angular.isDefined(vm.choiceCourseId) && vm.choiceCourseId > 0);
                if(!isCanNext) SweetAlert.error("", $filter('translate')('MESSAGE.MSG_PLEASE_SELECT_ONE_COURSE'));
                return isCanNext;
              };

              vm.canExitStep2 = function () {
                var isCanNext = false;
                isCanNext = (angular.isDefined(vm.choiceSessionId));
                if(!isCanNext) SweetAlert.error("", $filter('translate')('MESSAGE.MSG_PLEASE_SELECT_ONE_COURSE_SESSION'));
                return isCanNext;
              };

              vm.nextStep = function () {
                WizardHandler.wizard('selectExternalClass').next();
                vm.updateCurrentStep('next');
              };

              vm.previousStep = function() {
                WizardHandler.wizard('selectExternalClass').previous();
                vm.updateCurrentStep('previous');
              };

              vm.finishStep = function () {
                if(vm.canExitStep2()){
                  WizardHandler.wizard('selectExternalClass').finish();
                }
              };

              vm.updateModel = function () {
                $mdDialog.hide({courseId: vm.choiceCourseId, sessionId: vm.choiceSessionId});
              };

              vm.updateCurrentStep = function(type) {
                  switch (type) {
                    case 'next':
                      if (vm.canExitStep1()) {
                        vm.currentStep = WizardHandler.wizard('selectExternalClass').currentStepNumber() + 1;
                      }
                      break;
                    case 'previous':
                      vm.currentStep = WizardHandler.wizard('selectExternalClass').currentStepNumber() - 1;
                      break;
                }
              };

              vm.cancel = function() {
                $mdDialog.cancel();
              };
              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/utils/views/select-external-class.html',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              externalId: vm.externalId,
              applicantId: vm.applicantId,
              ngModel: vm.ngModel
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function(data) {
            vm.ngModel = data;
          });
        };
      };
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('selectExternalClass', selectExternalClass);

})();

/**
 * Created by Bruce on 2017/1/10.
 */
(function () {
  'use strict';

  var selectCurrency = {
    bindings: {
      ngModel: '=ngModel',
      currencys: '=currencys',
      ngDisabled: '=?ngDisabled',
      ngChange: '&?ngChange'
    },
    templateUrl: 'app/modules/utils/views/select-currency.html',
    controller: ['$scope', function ($scope) {
      var vm = this;
      vm.selectCurrency = -1;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : undefined;
      vm.currencys  = angular.isDefined(this.currencys) ? this.currencys : [];
      vm.ngChange = angular.isDefined(this.ngChange) ? this.ngChange : undefined;
      // currency.isBasic
      $scope.$watch(function () {
        return vm.ngModel;
      }, function () {
        if(angular.isDefined(vm.ngChange) && angular.isFunction(vm.ngChange)){
          vm.ngChange();
        }
      });

    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('selectCurrency', selectCurrency);

})();

/**
 * Created by Bruce on 2017/3/21.
 */

/*
* Basic Params:
* params = {
*   showAllOption: false
*   selectedValue: ''
* }
* */
(function () {
  'use strict';

  var selectCtl = {
    bindings: {
      ctlData: '=?ctlData',
      ngModel: '=?ngModel',
      ngChange: '&?ngChange',
      type: '@?type',
      params: '=?params',
      ngDisabled: '=?ngDisabled',
      onlyText: '=?onlyText',
      defaultSelectFirst: '=?defaultSelectFirst'
    },
    templateUrl: 'app/modules/utils/views/select-ctl.html',
    controller: [ '$q', '$filter', '$scope', 'ctlService', function ($q, $filter, $scope, ctlService) {
      var vm = this;
      var params;
      vm.ctlData = angular.isDefined(this.ctlData) ? this.ctlData : undefined;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : '';
      vm.ngChange = angular.isDefined(this.ngChange) ? this.ngChange : undefined;
      vm.type = angular.isDefined(this.type) ? this.type : undefined;
      vm.params = angular.isDefined(this.params) ? this.params : {};
      vm.isStatic = false;
      vm.defaultSelectFirst = angular.isDefined(this.defaultSelectFirst) ? this.defaultSelectFirst : false;

      $scope.$watch(function () {
        return vm.params;
      }, function (newVal) {
        if(angular.isDefined(newVal)){
          params = angular.copy(newVal);
          getCtlData();
        }
      });

      function getCtlData() {
        if(angular.isDefined(vm.type)){
          var defer = $q.defer();
          var ctlData;
          switch (vm.type){
            /*
            * select dropdowns component, base on server side data
            * */
            case 'innercert-classes':
              ctlData = ctlService.getInnercertClasses(params);
              break;
            case 'innercerts':
              ctlData = ctlService.getInnercerts(params);
              break;
            case 'companys':
              ctlData = ctlService.getCompanys(params);
              break;
            case 'subjects':
              ctlData = ctlService.getCompanySubjects(params);
              break;
            case 'extcert-apply-classes':
              ctlData = ctlService.getExtcertApplyClasses(params);
              break;
            case 'compensation-test-item':
              ctlData = ctlService.getCompensationTestItem(params);
              break;
            case 'all-currency':
              ctlData = ctlService.getAllCurrency(params);
              break;
            case 'manage-groups':
              ctlData = ctlService.getManageGroups(params);
              break;
            case 'manage-members':
              ctlData = ctlService.getManageMembers(params);
              break;
            case 'classifications':
              ctlData = ctlService.getClassifications(params);
              break;

            /*
            * static select dropdowns component
            * */
            case 'static-approve-status':
              vm.isStatic = true;
              ctlData = defer.promise;
              var data = [{
                value: "",
                name: $filter('translate')('FIELD.ALL'),
                selected: 0
              },{
                value: "1",
                name: $filter('translate')('STATUS.APPROVALED'),
                selected: 0
              },{
                value: "2",
                name: $filter('translate')('STATUS.WAITING_APPROVAL'),
                selected: 0
              },{
                value: "3",
                name: $filter('translate')('STATUS.REJECTED'),
                selected: 0
              },{
                value: "4",
                name: $filter('translate')('STATUS.CANCEL'),
                selected: 0
              }];
              defer.resolve(data);
              break;
          }

          ctlData.then(function (datas) {
            vm.datas = vm.ctlData = datas;
            if(vm.isStatic){
              angular.forEach(vm.datas, function (data) {
                if(angular.equals(data.value, params['selectedValue'])){
                  data.selected = 1;
                }
              });
            }

            // if((!vm.isStatic) && ((params['selectedValue'] !== '') && $filter('where')(datas, { 'value': params['selectedValue']}).length === 0 )){
            //   params['selectedValue'] = '';
            //   getCtlData();
            // }

            if(vm.defaultSelectFirst && $filter('where')(datas, { 'value': params['selectedValue']}).length === 0){
              angular.forEach(vm.datas, function (data) {
                if(data.selected === 1) data.selected = 0;
              });
              if(vm.datas.length > 0) vm.datas[0].selected = 1;
            }
          });
        }
      }

      $scope.$watch(function () {
        return vm.ngModel;
      }, function () {
        if(angular.isDefined(vm.ngChange) && angular.isFunction(vm.ngChange)){
          vm.ngChange();
        }
      });
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('selectCtl', selectCtl);

})();

/**
 * Created by Bruce on 2017/1/15.
 */
(function () {
  'use strict';

  var selectClassification = {
    bindings: {
      ngModel: '=?ngModel',
      type: '@?type',
      ngDisabled: '=?ngDisabled',
      onlyText: '=?onlyText'
    },
    templateUrl: 'app/modules/utils/views/select-classification.html',
    controller: [ '$scope', 'courseResourceService', function ($scope, courseResourceService) {
      var vm = this;
      vm.type = angular.isDefined(this.type) ? this.type : undefined;
      $scope.$watch(function () {
        return vm.type;
      },function (newVal) {
        if(angular.isDefined(newVal)){
          courseResourceService.getClassifications(vm.type).then(function (classifications) {
            vm.classifications = classifications;
          });
        }
      });
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('selectClassification', selectClassification);

})();

/**
 * Created by Bruce on 2017/3/28.
 *
 *  * Multi date picker control Component
 *   (1) <multi-date-picker-ctrl ng-model="ngModel"></multi-date-picker-ctrl>
 * @param ngModel => bind Model, the model is array date string, ex: ['1990/01/01', ....]
 *        this watch will hacker new Model to moment array, ex: [moment('1990/01/01').toDate(), ...]
 * @param ngChange
 * @param maxCount
 * @param ngRequired
 */
(function () {
  'use strict';

  var multiDatePickerCtrl = {
    bindings: {
      ngModel: '=?ngModel',
      ngChange: '&?ngChange',
      maxCount: '@?maxCount',
      ngRequired: '=?ngRequired'
    },
    templateUrl: 'app/modules/utils/views/multi-date-picker-ctrl.html',
    controller: [ '$q', '$filter', '$scope', function ($q, $filter, $scope) {
      var vm = this;

      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : undefined;
      vm.ngChange = angular.isDefined(this.ngChange) ? this.ngChange : undefined;
      vm.maxCount = angular.isDefined(this.maxCount) ? this.maxCount: -1;
      vm.ngRequired = angular.isDefined(this.ngRequired) ? this.ngRequired : false;

      vm.add = function () {
        vm.ngModel.push(undefined);
      };

      vm.remove = function (index) {
        vm.ngModel.splice(index, 1);
      };

      function prepareDateModel() {
        angular.forEach(vm.ngModel, function (date, index) {
          vm.ngModel[index] = moment(new Date(date)).toDate();
        })
      }

      $scope.$watch(function () {
        return vm.ngModel;
      }, function (newVal) {
        if(angular.isDefined(newVal)){
          prepareDateModel();
        }
      });

    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('multiDatePickerCtrl', multiDatePickerCtrl);

})();

/**
 * Created by Bruce on 2017/1/12.
 */
(function () {
  'use strict';

  var multiCheckbox = {
    bindings: {
      ngModel: '=ngModel',
      datas: '=datas',
      titleKey: '@titleKey',
      valueKey: '@valueKey',
      ngDisabled: '=?ngDisabled'
    },
    templateUrl: 'app/modules/utils/views/multi-checkbox.html',
    controller: [ function () {
      var vm = this;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : [];
      vm.toggle = function(item) {
        var idx = vm.ngModel.indexOf(item);
        if (idx > -1) {
          vm.ngModel.splice(idx, 1);
        }else {
          vm.ngModel.push(item);
        }
      };
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('multiCheckbox', multiCheckbox);
})();

/**
 * Created by Bruce on 2017/6/1.
 */
(function () {
  'use strict';

  var memberSelection = {
    bindings: {
      ngModel: '=?ngModel', // [{ "userId": 1, "fullName": "Administrator Chen" }]
      ngDisabled: '=?ngDisabled',
      display: '=?display',
      displayIcon: '@?displayIcon',
      buttonType: '@?buttonType', // FAB, Flat, Raised,
      isMini: '=?isMini',
      ignoreSelf: '=?ignoreSelf',
      ngOnChanges: '&?ngOnChanges'
    },
    template: '<md-button class="md-primary" ng-click="$ctrl.openMemberSelection($event)"' +
                ' ng-class="{ \'md-mini\': $ctrl.isMini, \'md-fab\': $ctrl.buttonType === \'FAB\' }">' +
              '<md-icon ng-if="$ctrl.displayIcon">{{$ctrl.displayIcon}}</md-icon>' +
              '<span ng-if="!$ctrl.displayIcon">{{$ctrl.display}}</span>' +
              '</md-button>',
    controller: [ '$scope', '$mdDialog', '$document', function ($scope, $mdDialog, $document) {
      var vm = this;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : [];
      vm.ignoreSelf = angular.isDefined(this.ignoreSelf) ? this.ignoreSelf : false;

      vm.openMemberSelection = function (ev) {
        $mdDialog.show({
          parent: angular.element($document[0].body),
          templateUrl: 'app/modules/utils/views/member-selection-dialog.html',
          controller: [ 'SweetAlert', '$q', '$timeout', '$filter', '$auth', 'ngModel', 'ignoreSelf', 'utilsService', function (SweetAlert, $q, $timeout, $filter, $auth, ngModel, ignoreSelf, utilsService) {
            var vm = this;

            vm.items = [];
            for (var i = 0; i < 1000; i++) {
              vm.items.push({
                'title': 'repeat item - ' + (i+1),
                'selected': false,
                'index': i
              });
            }



            vm.ngModel = ngModel;
            vm.selectMembers = [];
            vm.isDirectMembers = false;
            vm.filters = {};
            vm.filters.learningType = false;
            vm.filters.selectedPersons = [];
            vm.ignoreSelf = ignoreSelf;

            /*
             *  Start: search model-1 for select person
             * */
            var cachedQuery, lastSearch;
            var pendingSearch, cancelSearch = angular.noop;
            vm.selectPersonModel1 = [];

            if(vm.ngModel.length > 0 ){
              vm.selectPersonModel1 = angular.copy(vm.ngModel);
              vm.selectMembers = angular.copy(vm.ngModel);
            }

            vm.querySearch = function(criteria) {
              cachedQuery = cachedQuery || criteria;
              return utilsService.getMembersByFilter({'keywords': cachedQuery}).then(function (members) {
                if( vm.ignoreSelf ){
                  // vm.selectMembers.push($filter('getArrayObjectByKey')(members, 'userId', $auth.getUserData().id))
                }
                angular.forEach(vm.selectMembers, function(data) {
                  if($filter('getArrayObjectByKey')(members, 'userId', data.userId)){
                    var index = $filter('arrayObjectIndexOf')(members, $filter('getArrayObjectByKey')(members, 'userId', data.userId));
                    if(index > -1) members.splice(index, 1);
                  }
                });
                return members;
              });
            };

            vm.delayedQuerySearch = function(criteria) {
              cachedQuery = criteria;
              if (!pendingSearch || !debounceSearch()) {
                cancelSearch();
                return pendingSearch = $q(function(resolve, reject) {
                  cancelSearch = reject;
                  $timeout(function() {
                    resolve(vm.querySearch());
                    refreshDebounce();
                  }, Math.random() * 10, true)
                });
              }
              return pendingSearch;
            };

            function refreshDebounce() {
              lastSearch = 0;
              pendingSearch = null;
              cancelSearch = angular.noop;
            }

            // Debounce if querying faster than 300ms
            function debounceSearch() {
              var now = new Date().getMilliseconds();
              lastSearch = lastSearch || now;
              return ((now - lastSearch) < 300);
            }
            /*
             *  End: search model-1 for select person
             * */

            /*
             *  Start: search model-2 for select person
             * */
            vm.optionsToggle = function(member) {
              if (!$filter('getArrayObjectByKey')(vm.selectMembers, 'userId', member.userId)) {
                vm.selectMembers.push(member);
                vm.selectPersonModel1.push(member);
              } else {
                // Bind selectMembers Model
                angular.forEach(vm.selectMembers, function(data, idx) {
                  if (angular.equals(data.userId, member.userId)) vm.selectMembers.splice(idx, 1);
                });
                // Bind selectPersonModel1 Model
                angular.forEach(vm.selectPersonModel1, function(data, idx) {
                  if (angular.equals(data.userId, member.userId)) vm.selectPersonModel1.splice(idx, 1);
                });
              }
            };

            vm.memberIsChecked = function (member) {
              return ($filter('getArrayObjectByKey')(vm.selectMembers, 'userId', member.userId)) ? true : false;
            };

            $scope.$watch(function() {
              return vm.isDirectMembers;
            }, function(newVal) {
              if (newVal) {
                getDirectMembers()
              }
            }, true);

            $scope.$watch(function() {
              return vm.selectMembers;
            }, function(newVal, oldVal) {
              if (!angular.equals(newVal, oldVal)) {
                getDirectMembers()
              }
            }, true);

            function getDirectMembers() {
              utilsService.findMyGroupMembers().then(function(members) {
                vm.members = members;
                vm.filters.showMembers = {};
                angular.forEach(members, function(member) {
                  if ($filter('getArrayObjectByKey')(vm.selectMembers, 'userId', member.userId)) vm.filters.showMembers[member.userId] = true;
                  if (!$filter('getArrayObjectByKey')(vm.selectMembers, 'userId', member.userId)) vm.filters.showMembers[member.userId] = false;
                //   // if (member.isGray) vm.filters.showMembers[member.userId] = member.isGray;
                });
              });
            }
            /*
             *  End: search model-2 for select person
             * */

            vm.submit = function () {
              if(vm.selectMembers.length > 0){
                $mdDialog.hide(vm.selectMembers);
              } else {
                SweetAlert.error('', $filter('translate')('FORM_VALIDATION.PLEASE_SELECT_AT_LEAST_ONE_MEMBER'));
              }

            };
            vm.close = function() {
              $mdDialog.cancel();
            };
          }],
          multiple: true,
          controllerAs: '$ctrl',
          targetEvent: ev,
          locals: {
            ngModel: vm.ngModel,
            ignoreSelf: vm.ignoreSelf
          },
          clickOutsideToClose:true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        }).then(function (selectMembers) {
          vm.ngModel = selectMembers;
          if(angular.isFunction(vm.ngOnChanges)) vm.ngOnChanges();
        }, function() {});
      }
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('memberSelection', memberSelection);

})();

/**
 * Created by Bruce on 2016/12/22.
 */
(function () {
  'use strict';

  var mdSelectTime = {
    bindings: {
      type:'@?',
      ngModel: '=ngModel',
      formTime: '@?formTime',
      toTime: '@?toTime',
      isArrayIndex: '@?isArrayIndex'
    },
    templateUrl: 'app/modules/utils/views/md-time-select.html',
    controller: ['$scope', function($scope){
      var vm = this;
      vm.type = angular.isUndefined(this.type) ? null : this.type;
      vm.ngModel = angular.isUndefined(this.ngModel) ? null : this.ngModel;
      vm.formTime = angular.isUndefined(this.formTime) ? null : this.formTime;
      vm.toTime = angular.isUndefined(this.toTime) ? null : this.toTime;
      vm.isArrayIndex = angular.isUndefined(this.isArrayIndex) ? false : this.isArrayIndex;

      vm.hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      vm.minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

      switch (vm.type){
        case 'minute':
          if(!vm.isArrayIndex){
            vm.ngModel = vm.minutes.indexOf(vm.ngModel);
          }
          break;
        case 'hours':
          vm.ngModel = vm.hours.indexOf(vm.ngModel);
          break;
      }

      vm.min = 0;

      $scope.$watch(function(){
        return vm.formTime;
      },function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)) {
          resetSelect();
        }
      });
      $scope.$watch(function(){
        return vm.toTime;
      },function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)) {
          resetSelect();
        }
      });

      function resetSelect() {
        var beginningTime = moment(vm.formTime, 'h:mm');
        var endTime = moment(vm.toTime, 'h:mm');
        switch (vm.type){
          case 'hours':
            var h_exists = false;
            angular.forEach(vm.hours, function (hour, index) {
              endTime.set({
                'hour' : (vm.isArrayIndex) ? index : hour
              });
              if(!h_exists){
                if(checkTime(beginningTime, endTime)) {
                  h_exists = true;
                  vm.min = hour;
                }
              }
            });
            break;
          case 'minute':
            var m_exists = false;
            angular.forEach(vm.minutes, function (minute, index) {
              if(!m_exists){
                endTime.set({
                  'minute' : (vm.isArrayIndex) ? index : minute
                });
                if(checkTime(beginningTime, endTime)) {
                  m_exists = true;
                  vm.min = minute;
                  if(vm.isArrayIndex){
                    if(vm.ngModel < index) vm.ngModel = index;
                  }else {
                    if(vm.ngModel < minute) vm.ngModel = minute;
                  }
                }
              }
            });
            break;
        }
      }

      function checkTime(beginningTime, endTime) {
        return beginningTime.isBefore(endTime);
      }
    }]
  };

  angular.module('eHRD.modules.utils')
    .component('mdSelectTime', mdSelectTime);
})();

/**
 * Created by Bruce on 2017/1/12.
 */
(function () {
  'use strict';

  var learningReportSetting = {
    bindings: {
      ngModel: '=?ngModel',
      settingRule: '=?settingRule',
      classTimeObjects: '=?classTimeObjects',
      ngDisabled: '=?ngDisabled',
      isCreateForm: '=?isCreateForm'
    },
    templateUrl: 'app/modules/utils/views/learning-report-setting.html',
    controller: [ '$scope', function ($scope) {
      var vm = this;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : {};
      vm.settingRule = angular.isDefined(this.settingRule) ? this.settingRule : undefined;
      vm.classTimeObjects = angular.isDefined(this.classTimeObjects) ? this.classTimeObjects : undefined;
      vm.isCreateForm = angular.isDefined(this.isCreateForm) ? this.isCreateForm : false;


      vm.isCanEditSetting = false;
      $scope.$watch(function () {
        return vm.settingRule;
      },function (newVal) {
        if(angular.isDefined(newVal)){
          vm.isCanEditSetting = (vm.settingRule.isCanEditSetting && vm.settingRule.isFormOwner) ||
                                (vm.settingRule.isManagerCanEditSetting && vm.settingRule.isManager && (!vm.settingRule.isFormOwner)) ||
                                (vm.settingRule.isLearningAdmin && !vm.isCreateForm) ;
          ngModelDataInit();
        }
      },true);

      var watchClassTimeObjects = $scope.$watch(function () {
        return vm.classTimeObjects;
      }, updateReportSettingDeadLine, true);

      function updateReportSettingDeadLine(newVal) {
        if(angular.isDefined(newVal) && vm.classTimeObjects.length > 0){
          if(vm.settingRule.isHasDefaultSetting && vm.settingRule.isNeedReport){
            if(!vm.settingRule.isCanEditSetting){
              var minStartDate = undefined;
              var maxEndDate = undefined;
              angular.forEach(vm.classTimeObjects, function (classTimeObject, index) {
                if(index === 0){
                  minStartDate = classTimeObject.startDate;
                  maxEndDate = classTimeObject.endDate;
                }else{
                  if(classTimeObject.startDate < minStartDate){
                    minStartDate = classTimeObject.startDate;
                  }
                  if(classTimeObject.endDate > maxEndDate){
                    maxEndDate = classTimeObject.endDate;
                  }
                }
              });

              if(angular.isDefined(maxEndDate) && angular.isDefined(maxEndDate)){
                var docReportDeadLine = moment(maxEndDate)
                  .add(vm.settingRule.defaultSetting.docReportMonth, 'months')
                  .add(vm.settingRule.defaultSetting.docReportDay, 'days');
                var oralReportDeadLine = moment(maxEndDate)
                  .add(vm.settingRule.defaultSetting.oralReportMonth, 'months')
                  .add(vm.settingRule.defaultSetting.oralReportDay, 'days');
                var teachingDeadLine = moment(maxEndDate)
                  .add(vm.settingRule.defaultSetting.teachingMonth, 'months')
                  .add(vm.settingRule.defaultSetting.teachingDay, 'days');

                vm.ngModel['docReportDeadLine'] = docReportDeadLine.toDate();
                vm.ngModel['oralReportDeadLine'] = oralReportDeadLine.toDate();
                vm.ngModel['teachingDeadLine'] = teachingDeadLine.toDate();

              }

            }
          }
          watchClassTimeObjects(); // clear $watch classTimeObjects function
        }
      }

      function ngModelDataInit() {
        if(angular.isDefined(vm.settingRule.data) && Object.keys(vm.settingRule.data).length > 0){
          // Edit
          vm.ngModel = {
            isNeedReport: vm.settingRule.data.isNeedReport,
            isNeedDocReport: vm.settingRule.data.isNeedDocReport,
            numOfDocReport: vm.settingRule.data.numOfDocReport,
            docReportDeadLine: moment(vm.settingRule.data.docReportDeadLine).isValid()?new Date(vm.settingRule.data.docReportDeadLine):null ,
            isNeedOralReport: vm.settingRule.data.isNeedOralReport,
            oralReportDeadLine: moment(vm.settingRule.data.oralReportDeadLine).isValid()?new Date(vm.settingRule.data.oralReportDeadLine):null ,
            isOralReportNeedGrade: vm.settingRule.data.isOralReportNeedGrade,
            isNeedTeaching: vm.settingRule.data.isNeedTeaching,
            teachingDeadLine: moment(vm.settingRule.data.teachingDeadLine).isValid()?new Date(vm.settingRule.data.teachingDeadLine):null ,
            isTeachingNeedGrade: vm.settingRule.data.isTeachingNeedGrade,
            isNeedOther: vm.settingRule.data.isNeedOther,
            otherReportWay: vm.settingRule.data.otherReportWay
          };

        }else {
          // Add
          vm.ngModel['isNeedReport'] = (vm.settingRule.isHasDefaultSetting && vm.settingRule.isNeedReport);
          vm.ngModel['isNeedDocReport'] = vm.settingRule.defaultSetting.isNeedDocReport;
          vm.ngModel['numOfDocReport'] = vm.settingRule.defaultSetting.numOfDocReport;
          vm.ngModel['isNeedOralReport'] = vm.settingRule.defaultSetting.isNeedOralReport;
          vm.ngModel['isOralReportNeedGrade'] = vm.settingRule.defaultSetting.isOralReportNeedGrade;
          vm.ngModel['isNeedTeaching'] = vm.settingRule.defaultSetting.isNeedTeaching;
          vm.ngModel['isTeachingNeedGrade'] = vm.settingRule.defaultSetting.isTeachingNeedGrade;
          vm.ngModel['isNeedOther'] = vm.settingRule.defaultSetting.isNeedOther;
          vm.ngModel['otherReportWay'] = vm.settingRule.defaultSetting.otherReportWay;
          vm.ngModel['docReportDeadLine'] = angular.isDefined(vm.ngModel['docReportDeadLine']) ? vm.ngModel['docReportDeadLine'] : undefined;
          vm.ngModel['oralReportDeadLine'] = angular.isDefined(vm.ngModel['oralReportDeadLine']) ? vm.ngModel['oralReportDeadLine'] : undefined;
          vm.ngModel['teachingDeadLine'] = angular.isDefined(vm.ngModel['teachingDeadLine']) ? vm.ngModel['teachingDeadLine'] : undefined;
        }
      }
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('learningReportSetting', learningReportSetting);

})();

/**
 * Created by Bruce on 2016/12/30.
 */
(function () {
  'use strict';

  var enrollCosts = {
    bindings: {
      ngModel: '=?ngModel',
      form: '=?',
      ngDisabled: '=?ngDisabled',
      defaultDisableField: '=?defaultDisableField'
    },
    templateUrl: 'app/modules/utils/views/enroll-costs.html',
    controller: [ '$scope', '$filter', 'externalTrainingService', function ($scope, $filter, externalTrainingService) {
      var vm = this;
      vm.isCanRenderHtml = false;
      vm.ngModel = angular.isDefined(this.ngModel) ? this.ngModel : {};
      vm.form = angular.isUndefinedOrNull(this.form)?null:this.form;
      vm.defaultCostCurrency = -1;


      externalTrainingService.getCurrencys().then(function (currencys) {
        vm.currencys = currencys;
        angular.forEach(currencys, function (currency) {
          if(currency.isBasic){
            vm.defaultCostCurrency = currency.currencyId;
          }
        });

        $scope.$watch(function () {
          return vm.ngModel;
        },function (newVal) {
          if(angular.isDefined(newVal)){
            renderCost();
          }
        },true);
      });

      function renderCost() {
        angular.forEach(vm.ngModel, function (_ngModel, key) {
          if(Object.keys(_ngModel.costObject).length === 0){
            vm.ngModel[key].costObject = {
              course_cost_currency: (vm.defaultCostCurrency > -1) ? vm.defaultCostCurrency : '',
              course_cost_amount: 0,
              course_converting_amount: '',
              subsidyType: '1',
              subsidyPercentage: '',
              voucherType: '1',
              apply_type: '0',
              payee: '',
              remit_title: '',
              remit_branch: '',
              remit_account: '',
              check_title: '',
              check_expired_date: undefined,
              check_format1: false,
              check_format2: false,
            };
            //#edit by w3c, #87981  start
            vm.ngModel[key].costObject.remit_title_error = {};
            vm.ngModel[key].costObject.remit_branch_error = {};
            vm.ngModel[key].costObject.remit_account_error = {};
            vm.ngModel[key].costObject.check_title_error = {};
            vm.ngModel[key].costObject.check_expired_date_error = {};
            //#edit by w3c, #87981  end
          }else {
            if(angular.isDefined(_ngModel.costObject['apply_type']) && _ngModel.costObject['apply_type'].length === 0){
              _ngModel.costObject['apply_type'] = '0';
            }
            if(angular.isUndefined(_ngModel.costObject['check_expired_date'])){
              vm.ngModel[key].costObject['check_expired_date'] = undefined;
            }else{
              var check_expired_date = moment(_ngModel.costObject['check_expired_date']);
              vm.ngModel[key].costObject['check_expired_date'] = check_expired_date.isValid() ? check_expired_date.toDate() : undefined;
            }
          }

          if(angular.isDefined(_ngModel.costObject.course_cost_currency) && _ngModel.costObject.course_cost_currency !== ''){
            var exchangeRate = angular.isDefined($filter('filterBy')(vm.currencys, ['currencyId'], _ngModel.costObject.course_cost_currency)) ? $filter('filterBy')(vm.currencys, ['currencyId'], _ngModel.costObject.course_cost_currency)[0].exchangeRate: 1;
            vm.ngModel[key].costObject.course_converting_amount = $filter('number')(_ngModel.costObject.course_cost_amount * exchangeRate, 2);
          }
        });
        vm.isCanRenderHtml = true;
      }
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('enrollCosts', enrollCosts);

})();

/**
 * Created by Bruce on 2016/12/20.
 */
(function () {
  'use strict';

  var classTime = {
    bindings: {
      classTime: '=?ngModel', // Array ex.2017/10/01 0:0-23:11,2017/10/02 0:0-23:11,2017/10/03 0:0-23:11,2017/10/05 0:0-1:0
      classTimeDesc: '=?',    // String ex. 2017/10/01 ~ 2017/10/03 Per 2 Month 00:00-23:55 2017/10/05 00:00-01:00
      classTimeObjects: '=?',  // Array Object ex. [{}]
      name: '@?name',
      required: '=?ngRequired',
      ngDisabled: '=?ngDisabled'
    },
    templateUrl: 'app/modules/utils/views/class-time.html',
    controller: ['$scope', 'classTimeUtils', function ($scope, classTimeUtils) {
      var vm = this;
      this.$onInit = function () {
        vm.classTime = angular.isDefined(this.classTime) ? this.classTime : [];
        vm.classTimeStr = '';
        vm.classTimeDesc = angular.isDefined(this.classTimeDesc) ? this.classTimeDesc : '';
        vm.classTimeObjects = angular.isDefined(this.classTimeObjects) ? this.classTimeObjects : [];
        var localeDate = moment.localeData();
        vm.weekDays = localeDate._weekdays;

        $scope.$watch(function () {
          return vm.classTimeObjects;
        },function (newVal) {
          vm.classTime = classTimeUtils.mergeClassTimes(newVal);
        }, true);

        $scope.$watch(function () {
          return vm.classTime;
        },function (newVal) {
          if(angular.isDefined(newVal) && angular.isArray(newVal)){
            vm.classTimeStr = (vm.classTime.length > 0 ? vm.classTime.toString() : '');
          }
        }, true);
      };
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('classTime', classTime);

})();

/**
 * Created by Bruce on 2017/04/06.
 */
(function () {
  'use strict';

  var choiceExternalCourses = {
    bindings: {
      ngModel: '=?ngModel',
      params: '@?params',
      displayType: '@?displayType'
    },
    templateUrl: 'app/modules/utils/views/choice-external-courses.html',
    controller: ['$interpolate', '$filter', '$scope', 'utilsService', 'NgTableParams', 'ngTableColumnValueService', function ($interpolate, $filter, $scope, utilsService, NgTableParams, ngTableColumnValueService) {
      var vm = this;
      vm.ngModel = angular.isUndefined(this.ngModel) ? undefined : this.ngModel;
      vm.params = angular.isUndefined(this.params) ? {} : this.params;
      vm.displayType = angular.isUndefined(this.displayType) ? 'table' : this.displayType;


      this.$onInit = function () {
        switch (vm.displayType){
          case 'table':
            prepareTable();
            break;
          case 'list':
            utilsService.getExternalCourses(vm.params).then(function (datas) {
              vm.datas = datas;
            });
            break;
        }
      };

      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.table = new NgTableParams({
          sorting: {},
          filter: {}
        },{
          counts: [],
          getData: function (tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = value;
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;

            return utilsService.getExternalCourses({}).then(function (data) {
              return data;
            });
          }
        });
      }

      function prepareTableCols() {
        var cols = [{
          field: 'choice',
          title: '',
          getValue: htmlChoiceValue,
          priority: 1,
          width: 5
        }, {
          field: 'courseName',
          title: $filter('translate')('FIELD.COURSE_NAME'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        }];

        return cols;
      }

      function htmlChoiceValue() {
        return '<input type="radio" ng-model="data.group1" name="choice" ng-value="row.courseId"/>';
      }
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('choiceExternalCourses', choiceExternalCourses);

})();

/**
 * Created by Bruce on 2017/04/06.
 */
(function () {
  'use strict';

  var choiceExternalCourseSessions = {
    bindings: {
      courseId: '=?courseId',
      ngModel: '=?ngModel',
      params: '=?params',
      displayType: '@?displayType'
    },
    templateUrl: 'app/modules/utils/views/choice-external-course-sessions.html',
    controller: ['$interpolate', '$filter', '$scope', 'utilsService', 'NgTableParams', 'ngTableColumnValueService', function ($interpolate, $filter, $scope, utilsService, NgTableParams, ngTableColumnValueService) {
      var vm = this;
      vm.courseId = angular.isUndefined(this.courseId) ? undefined : this.courseId;
      vm.ngModel = angular.isUndefined(this.ngModel) ? undefined : this.ngModel;
      vm.params = angular.isUndefined(this.params) ? {} : this.params;
      vm.displayType = angular.isUndefined(this.displayType) ? 'table' : this.displayType;

      $scope.$watch(function () {
        return vm.courseId;
      }, function (newVal) {
        if(angular.isDefined(newVal)){
          switch (vm.displayType){
            case 'table':
              prepareTable();
              break;
            case 'list':
              utilsService.getExternalCourseSessions(vm.courseId, vm.params).then(function (datas) {
                vm.datas = datas;
              });
              break;
          }
        }
      });

      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.table = new NgTableParams({
          sorting: {},
          filter: {}
        },{
          counts: [],
          getData: function (tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = value;
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;

            return utilsService.getExternalCourseSessions(vm.courseId, vm.params).then(function (data) {
              return data;
            });
          }
        });
      }

      function prepareTableCols() {
        var cols = [{
          field: 'choice',
          title: '',
          getValue: htmlChoiceValue,
          priority: 1,
          width: 5
        }, {
          field: 'sessionName',
          title: $filter('translate')('FIELD.SESSION_NAME'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        }];

        return cols;
      }

      function htmlChoiceValue() {
        return '<input type="radio" ng-model="data.group1" name="choice" ng-value="row.courseId"/>';
      }
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('choiceExternalCourseSessions', choiceExternalCourseSessions);

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.manager', []);

})();

/**
 * Created by Alan on 2016/12/19.
 */

(function () {
  'use strict';

  trainingRoadMapService.$inject = ['Restangular'];
  function trainingRoadMapService(Restangular){

    var _TrainingRoadMapService = Restangular.all('trainingroadmap');

    return {
      getTrainingRoadMapList: function () {
        /*
         * api/trainingroadmap/visible
         * */
        return _TrainingRoadMapService
          .customGETLIST('visible');
      },

      getTrainingRoadMapInfo: function (trId, params) {
        /*
         * api/trainingroadmap/{trId}
         * */
        return _TrainingRoadMapService
          .customGET(trId, params);
      }

    };

  }


  angular.module('eHRD.modules.manager')
    .factory('trainingRoadMapService', trainingRoadMapService);
})();

/**
 * Created by Bruce on 2016/12/15.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.trainingRoadMap', []);

})();

/**
 * Created by Bruce on 2016/12/15.
 */
(function () {
  'use strict';

  var trainingRoadMap = {
    bindings: {},
    templateUrl: 'app/modules/training-road-map/views/training-road-map.html',
    controller: [ '$state', 'trainingRoadMapService', '$scope', '$location', '$anchorScroll',
      function($state, trainingRoadMapService, $scope, $location, $anchorScroll){
      var vm = this;
      trainingRoadMapService.getTrainingRoadMapList().then(function (trainingRoadMapList) {
        vm.trainingRoadMapList = trainingRoadMapList;
        vm.trainingRoadMapId = vm.trainingRoadMapList[0].trainingRoadmapId;

        $scope.$watch('$ctrl.trainingRoadMapId', function(trainingRoadMapId) {
          var params = {
            withUserStatus: true
          };
          trainingRoadMapService.getTrainingRoadMapInfo(trainingRoadMapId, params).then(function (data) {
            vm.trainingRoadMapInfo = data.trainingRoadmapInfo;
            vm.userCurrentCondition = data.userCurrentCondition;
            vm.titleGroups = data.activitiesNestList.titleGroups;
          });
        });
      });

      vm.clickZone = function(zone) {
        vm.selectZone = zone;
        $location.hash(zone);
        $anchorScroll();
      };

      vm.goToCourse = function(activity) {
        if (activity.activityType!==64 && activity.activityType!==128) {
          $state.go('courseResourceCatalog.CourseInfo', {
              cid: 0,
              courseId: activity.activityId
            });
        }else {
          $state.go('courseResourceCatalog.ProgramInfo', {
              cid: 0,
              programId: activity.activityId
            });
        }
      }

    }]
  };

  angular.module('eHRD.modules.trainingRoadMap')
    .component('trainingRoadMap', trainingRoadMap);
})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  angular
    .module('eHRD.modules.training',[]);

})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  var trainingPlan = {
    bindings: {},
    templateUrl: 'app/modules/training/views/training-plan.html',
    controller: ['serverSetting', function (serverSetting) {
      var vm = this;
      vm.url = serverSetting.baseConfig.baseURL + '/training-plan-overview.do';
    }]
  };

  angular
    .module('eHRD.modules.training')
    .component('trainingPlan' , trainingPlan);

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.system', []);

})();

/**
 * Created by Bruce on 2016/9/22.
 */
(function() {
  'use strict';

  SystemController.$inject = ['serverSetting'];

  function SystemController(serverSetting) {
    var vm = this;
    vm.defaultMgrUrl = serverSetting.getServerPath();
  }

  angular.module('eHRD.modules.system')
    .controller('SystemController', SystemController);
})();

/**
 * Created by Bruce on 2017/5/18.
 */
(function () {
  'use strict';

  var systemInfo = {
    bindings: {},
    templateUrl: 'app/modules/system/views/system-info.html',
    controller: [ 'localStorageService', function (localStorageService) {
      var vm = this;
      vm.systemInfos = {};
      var lsKeys = localStorageService.keys().reverse();
      angular.forEach(lsKeys, function (key) {
        vm.systemInfos[key] = angular.isUndefinedOrNull(localStorageService.get(key)) ? "Null" : localStorageService.get(key);
      });
    }]
  };

  angular
    .module('eHRD.modules.system')
    .component('systemInfo', systemInfo);

})();

/**
 * Created by Bruce on 2017/5/4.
 */
(function () {
  'use strict';

  angular
    .module('eHRD.modules.staticPage', []);

})();

/**
 * Created by Bruce on 2017/5/4.
 */
(function() {
  'use strict';

  var staticPage = {
    bindings: {},
    templateUrl: 'app/modules/static-page/views/static-page.html',
    controller: [ '$stateParams', '$mdDialog', function($stateParams, $mdDialog) {
        var vm = this;
        vm.url = decodeURIComponent($stateParams['url']);
        
        // VIP: 82040
        
        if (!angular.isUndefinedOrNull(vm.url) || vm.url !== '') {
          if (vm.url.indexOf('cmcs-compettence-map-frame.do') != -1) {
            window.openCourseInfoDialog = openCourseInfoDialog($mdDialog)
            window.openProgramInfoDialog = openProgramInfoDialog($mdDialog)
          }
        }
      }
    ]
  };

  var openCourseInfoDialog = function($mdDialog) {
    return function(courseId) {
      $mdDialog.show({
        templateUrl: 'app/modules/course-resource/views/course-detail-info-dialog.html',
        controller: ['courseResourceService', '$mdDialog',
          function (courseResourceService, $mdDialog) {
            var vm = this;

            courseResourceService.getCourse(courseId, null).then(function (courseData) {
              vm.courseData = courseData;
            });

            courseResourceService.getCourseReference(courseId, {}).then(function (referenceData) {
              vm.referenceData = referenceData;
            });

            vm.close = function() {
              $mdDialog.cancel();
            };
          }],
        controllerAs: '$ctrl',
        clickOutsideToClose:true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }
  }

  var openProgramInfoDialog = function($mdDialog) {
    return function(programId) {
      $mdDialog.show({
        templateUrl: 'app/modules/course-resource/views/program-detail-info-dialog.html',
        controller: ['courseResourceService', '$mdDialog',
          function (courseResourceService, $mdDialog) {
            var vm = this;
            courseResourceService.getProgram(programId, null).then(function (programData) {
              vm.programData = programData;
              vm.programData.courseName = vm.programData.programName;
            });

            vm.close = function () {
              $mdDialog.cancel();
            };

          }],
        controllerAs: '$ctrl',
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }
  }

  angular.module('eHRD.modules.staticPage')
    .component('staticPage', staticPage);
})();

/**
 * Created by Bruce on 2017/5/8.
 */
(function () {
  'use strict';

  angular
    .module('eHRD.modules.sitemap', []);

})();

/**
 * Created by Bruce on 2017/5/8.
 */
(function () {
  'use strict';

  sitemapService.$inject = ['treeFactory', 'Restangular', 'AuthStorage', '$q', 'serverSetting', '$ocLazyLoad'];
  function sitemapService(treeFactory, Restangular, AuthStorage, $q, serverSetting, $ocLazyLoad){
    /*
     * Build collection api/approval
     */
    var _sitemapService = Restangular.all('sitemap');
    var _SitemapLoginService = Restangular.all('sitemap-login');


    var treeModel = new treeFactory.TreeModel();
    var menuItems = [];

    var currentPanelType = '';

    function menuProcess(_menuItems) {
      angular.forEach(_menuItems, function (_menuItem, index) {
        parseMenuPermission(_menuItems, _menuItem, index);
        if(_menuItem.children.length > 0){
          _menuItems[index]._children = _menuItem.children.filter(function(item) {
            return item.isMenu;
          });
          menuProcess(_menuItems[index]._children);
        }
      });
    }

    function parseMenuPermission(_menuItems, _menuItem, index) {
      _menuItems[index].permissionsAll = [];
      _menuItems[index].permissions = [];

      // Server API is ready menu module parse
      // angular.forEach(_menuItem.moduleOption.modules, function (module) {
      //   if(_menuItem.moduleOption.enabledValidateAll){
      //     _menuItems[index].permissionsAll.push('Modules.' + module);
      //   }else{
      //     _menuItems[index].permissions.push('Modules.' + module);
      //   }
      // });
      angular.forEach(_menuItem.permissionOption.permissions, function (permission) {
        if(_menuItem.permissionOption.enabledValidateAll){
          _menuItems[index].permissionsAll.push(permission);
        }else{
          _menuItems[index].permissions.push(permission);
        }
      });
    }

    function siteMapNodesMapToMenu() {
      var _menuItems = angular.copy(menuItems).filter(function(item) {
        return item.isMenu ;
      });
      menuProcess(_menuItems);
      return _menuItems;
    }

    function getSiteMapNodes() {
      if( menuItems.length > 0) {
        return treeModel.parse({
          children: menuItems
        });
      } else {
        return null;
      }

    }

    function getProjectSideMenu(projectId) {
      var _projectId = projectId || this.getProject('projectId');
      return _sitemapService
        .one("project-info")
        .customGET('side_menu',{projectId: _projectId});
    }

    return {

      setMenu: function (menuItem) {
        menuItems = menuItem;
      },

      getMenu: function () {
        return siteMapNodesMapToMenu();
      },

      getNodeTree: function (node) {
        return treeModel.parse(node);
      },

      getProjectSideMenu: getProjectSideMenu,

      siteMapNodesMapToMenu: siteMapNodesMapToMenu,

      getSiteMapNodes: getSiteMapNodes,

      getProjectId: function (pid) {
        /*
         * api/sitemap//project-info
         * */
        if(angular.isUndefinedOrNull(pid) || pid==='')
          return _sitemapService.customGET('project-info');
        else
          return _sitemapService.one("project-info").customGET('review',{projectId:pid});
      },

      getProject: function (name) {
        return angular.fromJson(AuthStorage.get("projectData"))[name];
      },

      loginSitemapRequired: function(params) {
        /*
         * api/sitemap-login/info?companyName={companyName}
         * */
        var deferred = $q.defer();
        _SitemapLoginService.customGET('info', params).then(function(data){
          deferred.resolve(data);
        });

        return deferred.promise;
      },

      loginSitemapPreviewRequired: function(params) {
        /*
         * api/sitemap-login/info/review?projectId={projectId}
         * */
        var deferred = $q.defer();
        _SitemapLoginService.one('info').customGET('review', params).then(function(data){
          deferred.resolve(data);
        });

        return deferred.promise;
      },

      getOnlineUserNumber: function (params) {
        /*
         * api/ctl/online-user-number
         * */
        return _SitemapLoginService
          .customGET('online-user-number', params);
      },

      setSitemapColor: function (projectId, panelType) {
        // angular.element('body').removeClass("cl-sunnet");
        // angular.element('body').removeClass("cus-color");
        // angular.element('body').addClass((panelType===0) ? "cl-sunnet" : "cus-color");
        if(angular.element("link#color").length===0) {
          angular.element('<link rel="stylesheet" id="color" type="text/css" href="'+ serverSetting.baseConfig.baseURL + '/theme_v86/theme_' + projectId +'/cus-colors.css?panelType=' + panelType + '">')
            .appendTo(angular.element("head"));
        }
        else {
          angular.element("link#color").attr("href", serverSetting.baseConfig.baseURL + "/theme_v86/theme_" + projectId + "/cus-colors.css?panelType=" + panelType);
        }
      },

      setMaterialColor: function (panelType) {
        if (currentPanelType !== panelType) {
          if (currentPanelType) {
            angular.element('link[href*="'+ this.getSiteMapColor(currentPanelType) +'.css"]').remove();
          }
          $ocLazyLoad.load([this.getSiteMapColor(panelType)], {cache: false});
          currentPanelType = panelType;
        }
      },

      getSiteMapColor: function (panelType) {

        var color = "redTheme";
        switch (panelType){
          case 0:
            color = "default";
            break;
          case 1:
            color = "redTheme";
            break;
          case 2:
            color = "pinkTheme";
            break;
          case 3:
            color = "blueTheme";
            break;
          case 4:
            color = "tealTheme";
            break;
          case 5:
            color = "greenTheme";
            break;
          case 6:
            color = "orangeTheme";
            break;
          case 7:
            color = "blackTheme";
            break;
          case 8:
            color = "purpleTheme";
            break;
        }
        return color;
      },

      setSiteMap: function(siteMapData) {
        var project= {
          projectId: siteMapData.projectId,
          logoUrl: siteMapData.logoUrl,
          copyright: siteMapData.copyright,
          broswerTitle: siteMapData.broswerTitle,
          bannerRotateSpeed: siteMapData.bannerRotateSpeed,
          Context: siteMapData.Context,
          primaryColor: siteMapData.primaryColor,
          accentColor: siteMapData.accentColor,
          dangerColor: siteMapData.dangerColor,
          panelType: siteMapData.panelType
        };
        this.setSitemapColor(siteMapData.projectId, siteMapData.panelType);
        this.setMaterialColor(siteMapData.panelType);
        AuthStorage.set("projectData", angular.toJson(project));
      }
    };

  }


  angular.module('eHRD.modules.sitemap')
    .factory('sitemapService', sitemapService);
})();

/**
 * Created by Herry on 2019/01/15.
 */
(function () {
  'use strict';

  loadImageResize.$inject = [] ;
  function loadImageResize() {
    var directive = {
      restrict: 'A',
      scope: {
        setWidth: '=?',
        setHeight: '=?'
      },
      link: function (scope, element) {
        scope.setWidth = angular.isUndefined(scope.setWidth) ? null : scope.setWidth;
        scope.setHeight = angular.isUndefined(scope.setHeight) ? null : scope.setHeight;

       element.css('display', 'none');

        element.bind('load', function(){

          var width = this.width;
          var height = this.height;

          if (scope.setWidth) {
            if (width >= scope.setWidth) {
              element.css('width', scope.setWidth);
            } else {
              element.css('width', width);
            }
          } else {
            element.css('width', width);
          }
          if (scope.setHeight) {
            if (height >= scope.setHeight) {
              element.css('height', scope.setHeight);
            } else {
              element.css('height', height);
            }
          } else {
            element.css('height', height);
          }
          element.css('display', '');

        });

      }
    };
    return directive;
  }

  angular.module('eHRD.modules.sitemap')
    .directive('loadImageResize', loadImageResize);

})();

/**
 * Created by Bruce on 2017/5/8.
 */
(function () {
  'use strict';

  var sidebar = {
    bindings: {},
    templateUrl: 'app/modules/sitemap/views/sidebar.html',
    controller: ['$state', '$stateParams', 'navigationService', 'sitemapService', function ($state, $stateParams, navigationService, sitemapService) {
      var vm = this;
      vm.$state = $state;
      vm.$stateParams = $stateParams;
      vm.isMenuPrepared = true;
      sitemapService.getProjectSideMenu().then(function (_menuItems) {
        vm.isMenuPrepared = true;
        sitemapService.setMenu(_menuItems);
        vm.menuItems = sitemapService.getMenu();
      });

      vm.scrollBarConfig = navigationService.scrollBarConfig;
      vm.updateScrollbar = navigationService.updateScrollbar;

      vm.checkMenu = function (item) {
        var isActive = false;
        if(vm.isMenuPrepared){
          sitemapService.getNodeTree(item).walk(function (node) {
            if( node.model.state === $state.current.name){
              if( node.model.type === 'STATIC'){
                if(angular.equals(node.model.stateParams['mid'], $stateParams['mid'])) isActive = true;
              } else {
                if(angular.isDefined(node.model.stateParams) && (angular.isDefined(node.model.stateParams['id']) || angular.isDefined(node.model.stateParams['courseId']) || angular.isDefined(node.model.stateParams['mid']) )) {
                  if(angular.isDefined(node.model.stateParams['mid']) && angular.equals(node.model.stateParams['mid'], $stateParams['mid'])) isActive = true;
                  if(angular.isDefined(node.model.stateParams['id']) && angular.equals(node.model.stateParams['id'], $stateParams['id'])) isActive = true;
                  if(angular.isDefined(node.model.stateParams['courseId']) && angular.equals(node.model.stateParams['courseId'], $stateParams['courseId'])) isActive = true;
                }else {
                  isActive = true;
                }

              }
            }
          });
        }

        return isActive;
      };

      vm.logoUrl = sitemapService.getProject('logoUrl');

    }]
  };

  angular
    .module('eHRD.modules.sitemap')
    .component('sidebar', sidebar);

})();

/**
 * Created by Bruce on 2016/11/25.
 */

(function () {
  'use strict';

  routerHelper.$inject = ['$rootScope', '$location', '$log', '$auth', 'serverSetting', 'routerHelper', 'modulesRouteConfig', 'mailLinkRouteConfig'];
  function routerHelper($rootScope, $location, $log, $auth, serverSetting, routerHelper, modulesRouteConfig, mailLinkRouteConfig) {
    routerHelper.configureStates(modulesRouteConfig);
    routerHelper.configureStates(mailLinkRouteConfig);

    $log.info($location.absUrl().replace($location.protocol() + '://' + $location.host() + ':' + $location.port(), '').replace($location.url(),'').replace('/', '').replace('#', ''))
    var ssoParams = routerHelper.defaultQueryParams();
    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (ev, to, toParams){
      $auth._redirct = $location.path();
      if(serverSetting.authConfig.enabledSSOQueryParams){
        var isNeedReValidation = false;
        angular.forEach(serverSetting.authConfig.SSOQueryParamsKey, function (param) {
          if(angular.isDefined(toParams[param]) && !angular.equals(toParams[param], ssoParams[param])) isNeedReValidation = true;
          if(angular.isDefined(toParams[param]) && toParams[param].length > 0) {
            ssoParams[param] = toParams[param];
          }else{
            ssoParams[param] = undefined;
          }
        });

        if(isNeedReValidation){
          // $auth.logout().then(function () {
          //   $auth.skipIfLoggedIn();
          // });
        }
        angular.extend(toParams, ssoParams);
      }
    });
    $rootScope.$on('$destroy', stateChangeStart);
  }

  angular
    .module('eHRD.modules.routing',[])
    .run(routerHelper);

})();

/**
 * Created by Bruce on 2016/8/15.
 */

(function () {
  'use strict';

  stateHelperProvider.$inject = ['$stateProvider'];
  /* @ngInject */
  function stateHelperProvider($stateProvider) {
    var self = this;

    /**
     * Recursively sets the states using $stateProvider.state.
     * Child states are defined via a `children` property.
     *
     * 1. Recursively calls itself for all descendant states, by traversing the `children` properties.
     * 2. Converts all the state names to dot notation, of the form `grandfather.father.state`.
     * 3. Sets `parent` property of the descendant states.
     *
     * @param {Object} state - A regular ui.router state object.
     * @param {Array} [state.children] - An optional array of child states.
     * @deprecated {Boolean} keepOriginalNames - An optional flag that prevents conversion
     *     of names to dot notation if true. (use options.keepOriginalNames instead)
     * @param {Object} [options] - An optional options object.
     * @param {Boolean} [options.keepOriginalNames=false] An optional flag that
     *     prevents conversion of names to dot notation if true.
     * @param {Boolean} [options.siblingTraversal=false] An optional flag that
     *     adds `nextSibling` and `previousSibling` properties when enabled
     */
    this.state = function(state){
      var args = Array.prototype.slice.apply(arguments);
      var options = {
        keepOriginalNames: false,
        siblingTraversal: false
      };

      if (typeof args[1] === 'boolean') {
        options.keepOriginalNames = args[1];
      }
      else if (angular.isObject(args[1])) {
        angular.extend(options, args[1]);
      }

      if (!options.keepOriginalNames) {
        fixStateName(state);
      }

      $stateProvider.state(state);

      if(state.children && state.children.length){
        state.children.forEach(function(childState){
          childState.parent = state;
          self.state(childState, options);
        });

        if (options.siblingTraversal) {
          addSiblings(state);
        }
      }

      return self;
    };

    this.setNestedState = this.state;

    self.$get = angular.noop;

    /**
     * Converts the name of a state to dot notation, of the form `grandfather.father.state`.
     * @param state
     */
    function fixStateName(state){
      if(state.parent){
        state.name = (angular.isObject(state.parent) ? state.parent.name : state.parent) + '.' + state.name;
      }
    }

    function addSiblings(state) {
      state.children.forEach(function (childState, idx, array) {
        if (array[idx + 1]) {
          childState.nextSibling = array[idx + 1].name;
        }
        if (array[idx - 1]) {
          childState.previousSibling = array[idx - 1].name;
        }
      });
    }
  }

  angular.module('eHRD.modules.routing')
    .provider('stateHelper', stateHelperProvider);

})();

/**
 * Created by Bruce on 2016/8/15.
 */

(function () {
  'use strict';

  routerHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];
  /* @ngInject */
  function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {

    this.$get = RouterHelper;

    // $locationProvider.html5Mode(true);

    RouterHelper.$inject = ['serverSetting', '$state'];
    function RouterHelper( serverSetting, $state) {
      var hasOtherwise = false;
      var queryParams = '';
      var stateQueryParams = {};
      angular.forEach(serverSetting.authConfig.SSOQueryParamsKey, function (param, index) {
        stateQueryParams[param] = {
          value: null, squash: true
        };
        queryParams+=param;
        if((index+1) !== serverSetting.authConfig.SSOQueryParamsKey.length) queryParams+='&';
      });

      return {
        configureStates: configureStates,
        getStates: getStates,
        defaultQueryParams: defaultQueryParams
      };

      function configureStates(states, otherwisePath) {

        if(serverSetting.authConfig.enabledSSOQueryParams){
          states.forEach(function(state) {
            if(!state.config.abstract && angular.isDefined(state.config.url)){
              state.config.url = state.config.url.concat('?' + queryParams.toString());
              if(angular.isUndefined(state.config.params)) state.config.params = stateQueryParams;
            }
            $stateProvider.state(state.state, state.config);
          });
        }else{
          states.forEach(function(state) {
            $stateProvider.state(state.state, state.config);
          });
        }

        if (otherwisePath && !hasOtherwise) {
          hasOtherwise = true;
          $urlRouterProvider.otherwise(otherwisePath);
        }
      }

      function getStates() {
        return $state.get();
      }

      function defaultQueryParams() {
        if(serverSetting.authConfig.enabledSSOQueryParams){
          var ssoParams = {};
          angular.forEach(serverSetting.authConfig.SSOQueryParamsKey, function (param) {
            ssoParams[param] = undefined;
          });
          return ssoParams;
        }else{
          return null;
        }
      }
    }
  }

  angular.module('eHRD.modules.routing')
    .provider('routerHelper', routerHelperProvider);

})();

/**
 * Created by Bruce on 2016/12/14.
 */

(function () {
  'use strict';
  var processMenu = function (state) {
    return {
      processMenuId: ['$q', 'sitemapService', '$stateParams', 'loginRequired', function ($q, sitemapService, $stateParams, loginRequired) {
        var deferred = $q.defer();

        var process = function () {
          switch (state){
            case 'courseResourceCatalog': case 'courseResourceCatalog.CourseInfo': case 'courseResourceCatalog.CourseInfo.SessionInfo':
            case 'courseResourceCatalog.CourseInfo.applyFormCreateByCourseSession':
            case 'courseResourceCatalog.ProgramInfo': case 'courseResourceCatalog.ProgramInfo.SessionInfo':
              sitemapService.getSiteMapNodes().walk(function (node) {
                if(node.model.state === 'courseResourceCatalog' && angular.isUndefinedOrNull($stateParams['mid'])){
                  if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === "0") {
                    $stateParams['mid'] = node.model.stateParams['mid'];
                  }
                }
              });
              break;
            default:
              sitemapService.getSiteMapNodes().walk(function (node) {
                if( node.model.type !== 'STATIC'){
                  if(node.model.state === state){
                    $stateParams['mid'] = node.model.stateParams['mid'];
                  }
                }
              });
              break;
          }
          deferred.resolve();
        };
        if(sitemapService.getMenu().length > 0) {
          process();
        }else {
          sitemapService.getProjectSideMenu().then(function (menuItems) {
            sitemapService.setMenu(menuItems);
            deferred.resolve();
          });
        }
        return deferred.promise;
      }]
    };
  };

      // $auth.changePasswordRequired = function() {
      //   var deferred = $q.defer();
      //   var changePassword = $auth.getUserData().changePassword;
      //   if(angular.isDefined(changePassword) && changePassword) {
      //     $mdDialog.show({
      //       templateUrl: 'app/shared/views/login-change-password.html',
      //       controller: [
      //         function () {
      //           var dialog = this;
      //           dialog.oldPassword;
      //           dialog.newPassword;
      //           dialog.newPassword2;
      //           dialog.message;
      //           dialog.status;
      //           dialog.auth = function() {
      //             dialog.status = vm.newPasswordAuth(dialog)
      //             if (dialog.status) {
      //               var newPasswordInfo = {
      //                 oldPassword : dialog.oldPassword,
      //                 newPassword :dialog.newPassword,
      //                 currentUserId : $auth.getUserData().id
      //               }

      //               loginService.checkNewPasswordAuth(newPasswordInfo)
      //               .then(function(result){
      //                 if (result.status) {
      //                   defaultRedirct();
      //                   $mdDialog.cancel();
      //                   deferred.resolve();
      //                 } else {
      //                   dialog.status = result.status;
      //                   dialog.message = result.message;
      //                 }
      //               });
      //             }
      //           }
      //         }
      //       ],
      //       controllerAs: '$ctrl',
      //       targetEvent: ev
      //     });
      //   }
      // };

  var agreePdpRequired = ['loginRequired', 'pdpService', '$q', '$mdDialog', '$auth', '$state', function(loginRequired, pdpService, $q, $mdDialog, $auth, $state) {
    if (!$auth.getUserData().pdpAgreementRequired) {
      return true;
    }else {
      var deferred = $q.defer();
      $mdDialog.show({
        templateUrl: 'app/shared/views/pdp-agreement.html',
        controller: [
          function() {
            var pdpAgreeCtrl = this;
            pdpAgreeCtrl.termsOfService = 'Terms of Service';
            pdpAgreeCtrl.stage = 'declare';

            pdpAgreeCtrl.showTerms = function() {
              pdpService.getPdpTermsOfService().then(function(terms) {
                pdpAgreeCtrl.stage = 'confirm';
                pdpAgreeCtrl.termsOfService = terms;
              })
            };

            pdpAgreeCtrl.agree = function() {
              setPdpAgreement(true);
            };

            pdpAgreeCtrl.disagree = function() {
              setPdpAgreement(false);
            };

            pdpAgreeCtrl.relogin = function() {
              $mdDialog.cancel();
              $state.go('logout');
            };

            var setPdpAgreement = function(agree) {
              pdpService.setPdpAuthorizeAgree(agree).then(function() {
                if (agree) {
                  //$scope.user.agreePdp = 1;
                  $mdDialog.cancel();
                  deferred.resolve();
                }else {
                  pdpAgreeCtrl.msg = 'disagree';
                  pdpAgreeCtrl.stage = 'disagree';
                }
              });
            };
          }
        ],
        controllerAs: '$ctrl'
      });
      return deferred.promise;
    }
  }];

  var modulesRouteConfig = [
    {
      state: 'modules',
      config: {
        abstract: true,
        url:'?:pid&:mid',
        params:{
          pid:null,
          mid: null
        },
        templateUrl: "app/shared/views/content.html",
        controller: 'UserController',
        controllerAs:'UC',
        resolve: {
          agreePdpRequired: agreePdpRequired,
          loginRequired: ['$auth', '$stateParams', function ($auth, $stateParams) {
            return $auth.loginRequired($stateParams.pid);
          }],
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'theme-plugins'
            ]);
          }]
        }
      }
    },

    {
      state: 'modules.error',
      config: {
        url: '/error/page/:type',
        templateUrl: "app/shared/views/error-page.html"
      }
    },

    {
      state: 'page',
      config: {
        url: "/static-page?:url",
        parent: "modules",
        template: '<static-page></static-page>',
        resolve: Object.assign({}, processMenu('page'))
        // params: {
        //   url: null
        // }
      }
    },

    // new solution for Site Map

    {
      state: 'learningActivity',
      config: {
        parent: "modules",
        url: '/learningActivity/:activityType/:activityId',
        template: '<course-info ng-if="$resolve.activityType === \'COURSE\'" course-id="$resolve.activityId" ></course-info>' +
        '<program-info ng-if="$resolve.activityType === \'PROGRAM\'" program-id="$resolve.activityId" ></program-info>',
        resolve: {
          activityType: [ '$stateParams', function ($stateParams) {
            return $stateParams.activityType;
          }],
          activityId: [ '$stateParams', function ($stateParams) {
            return $stateParams.activityId;
          }]
        }
      }
    },
    {
      state: 'knowledgeDocumentCatalog',
      config: {
        parent: "modules",
        url: '/knowledgeDocumentCatalog/:cid?:nid',
        template: '<knowledge-document catalog-id="$resolve.catalogId" node-id="$resolve.nodeId"></knowledge-document>',
        params: {
          cid: '0'
        },
        resolve: {
          catalogId: [ '$stateParams', function ($stateParams) {
            return $stateParams.cid;
          }],
          nodeId: [ '$stateParams', function ($stateParams) {
            return $stateParams.nid;
          }]
        }
      }
    },

    // new solution for Site Map
    {
      state: 'courseResourceCatalog',
      config: {
        parent: "modules",
        url: '/courseResourceCatalog/:cid?:nid',
        template: '<course-resource-catalog-list tab-select="$resolve.tabSelect" catalog-id="$resolve.catalogId" node-id="$resolve.nodeId"></course-resource-catalog-list>',
        params: {
          tabSelect: null,
          cid: '0',
          params : null
        },
        resolve: Object.assign({
          catalogId: [ '$stateParams', function ($stateParams) {
            return (angular.isDefined($stateParams.cid) && $stateParams.cid.length > 0)? $stateParams.cid : 0;
          }],
          nodeId: [ '$stateParams', function ($stateParams) {
            return $stateParams.nid;
          }],
          tabSelect: ['$stateParams', function ($stateParams) {
            return $stateParams.tabSelect;
          }]
        }, processMenu('courseResourceCatalog'))
      }
    },
    {
      state: 'courseResourceCatalog.CourseInfo',
      config: {
        parent: "modules",
        url: "/courseResourceCatalog/:cid/course-info/:courseId?:nid",
        template: '<ui-view><course-info ng-if="$resolve.state.includes(\'courseResourceCatalog.CourseInfo\')" catalog-id="$resolve.catalogId" course-id="$resolve.courseId" node-id="$resolve.nodeId"></course-info></ui-view>',
        params: {
          backState: 'courseResourceCatalog',
          params: null
        },
        resolve: Object.assign({
          state: ['$state', function ($state) {
            return $state;
          }],
          catalogId: [ '$stateParams', function ($stateParams) {
            return $stateParams.cid;
          }],
          nodeId: [ '$stateParams', function ($stateParams) {
            return $stateParams.nid;
          }],
          courseId: [ '$stateParams', function ($stateParams) {
            return $stateParams.courseId;
          }]
        }, processMenu('courseResourceCatalog.CourseInfo'))
      }
    },
    {
      state: 'courseResourceCatalog.CourseInfo.applyFormCreateByCourseSession',
      config: {
        url: "/session/:sessionId/create-external-training-form",
        template: '<external-training-apply type="createByCourseSession" course-id="$resolve.courseId" session-id="$resolve.sessionId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          _backState: 'courseResourceCatalog.CourseInfo',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams._backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          courseId: ['$stateParams', function ($stateParams) {
            return $stateParams.courseId;
          }],
          sessionId: ['$stateParams', function ($stateParams) {
            return $stateParams.sessionId;
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('courseResourceCatalog.CourseInfo.applyFormCreateByCourseSession'))
      }
    },
    {
      state: 'courseResourceCatalog.CourseInfo.SessionInfo',
      config: {
        parent: "modules",
        url: "/courseResourceCatalog/:cid/course-info/:courseId/session-info/:enrollmentId?:nid",
        template: '<course-session-info enrollment-id="$resolve.enrollmentId" catalog-id="$resolve.catalogId" course-id="$resolve.courseId" node-id="$resolve.nodeId" back-state="$resolve.backState"></course-session-info>',
        params: {
          backState: 'courseResourceCatalog.CourseInfo'
        },
        resolve: Object.assign({
          catalogId: ['$stateParams', function( $stateParams ){
            return $stateParams.cid;
          }],
          courseId: ['$stateParams', function( $stateParams ){
            return $stateParams.courseId;
          }],
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }],
          nodeId: [ '$stateParams', function ($stateParams) {
            return $stateParams.nid;
          }],
          backState: ['$stateParams', function( $stateParams ){
            return $stateParams.backState;
          }]
        }, processMenu('courseResourceCatalog.CourseInfo.SessionInfo'))
      }
    },

    {
      state: 'courseResourceCatalog.ProgramInfo',
      config: {
        parent: "modules",
        url: "/courseResourceCatalog/:cid/program-info/:programId?:nid",
        template: '<program-info catalog-id="$resolve.catalogId" program-id="$resolve.programId" node-id="$resolve.nodeId"></program-info>',
        params: {
          backState: 'courseResourceCatalog',
          params: null
        },
        resolve: Object.assign({
          catalogId: [ '$stateParams', function ($stateParams) {
            return $stateParams.cid;
          }],
          nodeId: [ '$stateParams', function ($stateParams) {
            return $stateParams.nid;
          }],
          programId: [ '$stateParams', function ($stateParams) {
            return $stateParams.programId;
          }]
        }, processMenu('courseResourceCatalog.ProgramInfo'))
      }
    },

    {
      state: 'courseResourceCatalog.ProgramInfo.SessionInfo',
      config: {
        parent: "modules",
        url: "/courseResourceCatalog/:cid/program-info/:programId/session-info/:enrollmentId?:nid",
        template: '<program-session-info enrollment-id="$resolve.enrollmentId" catalog-id="$resolve.catalogId" program-id="$resolve.programId" node-id="$resolve.nodeId" back-state="$resolve.backState"></program-session-info>',
        params: {
          backState: 'courseResourceCatalog.ProgramInfo'
        },
        resolve: Object.assign({
          catalogId: ['$stateParams', function( $stateParams ){
            return $stateParams.cid;
          }],
          programId: ['$stateParams', function( $stateParams ){
            return $stateParams.programId;
          }],
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }],
          nodeId: [ '$stateParams', function ($stateParams) {
            return $stateParams.nid;
          }],
          backState: ['$stateParams', function( $stateParams ){
            return $stateParams.backState;
          }]
        }, processMenu('courseResourceCatalog.ProgramInfo.SessionInfo'))
      }
    },



    {
      state: 'supervisorZone',
      config: {
        abstract: true,
        url: "/supervisor-zone",
        parent: "modules",
        template : '<ui-view />',
        resolve: Object.assign({}, processMenu('supervisorZone')),
        data: {
          permissions: {
            only: ['Manager_Privilege', 'Deputy_Privilege', 'Approval_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.departmentDashboard',
      config: {
        url: "/department-dashboard",
        template: '<department-dashboard></department-dashboard>',
        resolve: Object.assign({}, processMenu('supervisorZone.departmentDashboard')),
        data: {
          permissions: {
            only: ['Manager_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.approve',
      config: {
        url: "/approve",
        template: '<manager-approve default-params="$resolve.defaultParams"></manager-approve>',
        params: {
          defaultParams: null
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('supervisorZone.approve')),
        data: {
          permissions: {
            only:['Manager_Privilege', 'Approval_Privilege'],
            all: ['Modules.approval'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.approveExternalTrainingApplyRecordsFormEdit',
      config: {
        url: "/approve/external-training-apply/edit/:externalId",
        template: '<external-training-apply type="edit" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'supervisorZone.approve',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('supervisorZone.approveExternalTrainingApplyRecordsFormEdit'))
      }
    },
    {
      state: 'supervisorZone.approveExternalTrainingApplyRecordsFormView',
      config: {
        url: "/approve/external-training-apply/view/:externalId",
        template: '<external-training-apply type="view" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'supervisorZone.approve',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('supervisorZone.approveExternalTrainingApplyRecordsFormView'))
      }
    },


    {
      state: 'supervisorZone.approveRecords',
      config: {
        url: "/approve-records",
        template: '<manager-approve-records default-params="$resolve.defaultParams"></manager-approve-records>',
        params: {
          defaultParams: null
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('supervisorZone.approveRecords')),
        data: {
          permissions: {
            only:['Manager_Privilege', 'Approval_Privilege'],
            all: ['Modules.approval'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.approveRejectedRecords',
      config: {
        url: "/approve-reject-records",
        template: '<manager-approve-records default-params="$resolve.defaultParams"></manager-approve-records>',
        params: {
          defaultParams: {
            status : 3
          }
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('supervisorZone.approveRecords')),
        data: {
          permissions: {
            only:['Manager_Privilege', 'Approval_Privilege'],
            all: ['Modules.approval'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.approveRecordsExternalTrainingApplyRecordsFormEdit',
      config: {
        url: "/approve-records/external-training-apply/edit/:externalId",
        template: '<external-training-apply type="edit" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'supervisorZone.approveRecords',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('supervisorZone.approveRecordsExternalTrainingApplyRecordsFormEdit'))
      }
    },
    {
      state: 'supervisorZone.approveRecordsExternalTrainingApplyRecordsFormView',
      config: {
        url: "/approve-records/external-training-apply/view/:externalId",
        template: '<external-training-apply type="view" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'supervisorZone.approveRecords',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('supervisorZone.approveRecordsExternalTrainingApplyRecordsFormView'))
      }
    },

    {
      state: 'supervisorZone.trainingPlan',
      config: {
        url: "/training-plan",
        template: '<manager-training-plan></manager-training-plan>',
        resolve: Object.assign({}, processMenu('supervisorZone.trainingPlan')),
        data: {
          permissions: {
            only: ['Deputy_Privilege', 'Manager_Privilege'],
            all: ['Modules.training_plan'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.memberCurriculum',
      config: {
        url: "/member-curriculum",
        template: '<member-curriculum></member-curriculum>',
        resolve: Object.assign({}, processMenu('supervisorZone.memberCurriculum')),
        data: {
          permissions: {
            all: ['Modules.course', 'Manager_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.trainingRecords',
      config: {
        url: "/member-training-records",
        template: '<manager-training-records></manager-training-records>',
        resolve: Object.assign({}, processMenu('supervisorZone.trainingRecords')),
        data: {
          permissions: {
            all: ['Modules.course', 'Manager_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.trainingRecords.courseSessionInfo',
      config: {
        parent:'supervisorZone',
        url: "/member-training-records/course-session-info/:enrollmentId",
        template: '<course-session-info enrollment-id="$resolve.enrollmentId"></course-session-info>',
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('supervisorZone.trainingRecords.courseSessionInfo'))
      }
    },
    {
      state: 'supervisorZone.trainingRecords.programSessionInfo',
      config: {
        parent: "supervisorZone",
        url: "/member-training-records/program-session-info/:enrollmentId",
        template: '<program-session-info enrollment-id="$resolve.enrollmentId"></program-session-info>',
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('supervisorZone.trainingRecords.programSessionInfo'))
      }
    },
    {
      state: 'supervisorZone.memberSuggestLearningList',
      config: {
        url: "/member-suggest-learning-list",
        template: '<member-suggest-learning-list></member-suggest-learning-list>',
        resolve: Object.assign({}, processMenu('supervisorZone.memberSuggestLearningList')),
        data: {
          permissions: {
            only: ['Manager_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.memberFinancialCertRecordSearch',
      config: {
        url: "/member-financial-cert-record-search",
        template: '<member-financial-cert-record-search></member-financial-cert-record-search>',
        resolve: Object.assign({}, processMenu('supervisorZone.memberFinancialCertRecordSearch')),
        data: {
          permissions: {
            all: ['Modules.certification', 'Modules.certification.financial', 'Manager_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.memberCertRecordsSearch',
      config: {
        url: "/member-cert-records-search",
        template: '<member-cert-records-search></member-cert-records-search>',
        resolve: Object.assign({}, processMenu('supervisorZone.memberCertRecordsSearch')),
        data: {
          permissions: {
            all: ['Modules.certification', 'Manager_Privilege'],
            only: ['Modules.certification.inner', 'Modules.certification.ext'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.embaCalendar',
      config: {
        url: "/emba-calendar",
        template: '<emba-calendar></emba-calendar>',
        resolve: Object.assign({}, processMenu('supervisorZone.embaCalendar')),
        data: {
          permissions: {
            all: ['Modules.EMBA', 'Manager_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'supervisorZone.embaMustRead',
      config: {
        url: "/emba-must-read",
        template: '<emba-must-read></emba-must-read>',
        resolve: Object.assign({}, processMenu('supervisorZone.embaMustRead')),
        data: {
          permissions: {
            all: ['Modules.EMBA', 'Manager_Privilege'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'learningPassport',
      config: {
        abstract: true,
        url: "/learning-passport",
        parent: "modules",
        template : '<ui-view />',
        resolve: Object.assign({}, processMenu('learningPassport')),
        data: {
          permissions: {
            only: ['Modules.core'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'learningPassport.learningDashboard',
      config: {
        url: "/learning-dashboard",
        parent: "learningPassport",
        template: '<learning-dashboard></learning-dashboard>',
        resolve: Object.assign({}, processMenu('learningPassport.learningDashboard'))
      }
    },
    {
      state: 'learningPassport.incompleteCourses',
      config: {
        url: "/incomplete-courses",
        template: '<incomplete-courses></incomplete-courses>',
        resolve: Object.assign({}, processMenu('learningPassport.incompleteCourses')),
        data: {
          permissions: {
            only: ['Modules.course.online','Modules.course.classroom','Modules.course.external'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'learningPassport.incompleteCourses.courseInfo',
      config: {
        parent: "learningPassport",
        url: "/incomplete-courses/course-info/:enrollmentId",
        template: '<course-session-info enrollment-id="$resolve.enrollmentId" tab-select="$resolve.tabSelect"></course-session-info>',
        params: {
          tabSelect: 'learningCenter'
        },
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }],
          tabSelect: ['$stateParams', function( $stateParams ){
            return $stateParams.tabSelect;
          }]
        }, processMenu('learningPassport.incompleteCourses.courseInfo'))
      }
    },
    {
      state: 'learningPassport.incompleteCourses.programInfo',
      config: {
        parent: "learningPassport",
        url: "/incomplete-courses/program-info/:enrollmentId",
        template: '<program-session-info enrollment-id="$resolve.enrollmentId" tab-select="$resolve.tabSelect"></program-session-info>',
        params: {
          tabSelect: 'courseList'
        },
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }],
          tabSelect: ['$stateParams', function( $stateParams ){
            return $stateParams.tabSelect;
          }]
        }, processMenu('learningPassport.incompleteCourses.programInfo'))
      }
    },
    {
      state: 'learningPassport.incompleteCourses.certificationInfo',
      config: {
        parent: "learningPassport",
        url: "/incomplete-courses/certification-info/:enrollmentId",
        template: '<program-session-info enrollment-id="$resolve.enrollmentId" tab-select="$resolve.tabSelect"></program-session-info>',
        params: {
          tabSelect: 'learningCenter'
        },
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }],
          tabSelect: ['$stateParams', function( $stateParams ){
            return $stateParams.tabSelect;
          }]
        }, processMenu('learningPassport.incompleteCourses.certificationInfo'))
      }
    },
    {
      state: 'learningPassport.incompleteCourses.programInfo.courseInfo',
      config: {
        parent: "learningPassport",
        url: "/incomplete-courses/program/:programEnrollmentId/course-info/:enrollmentId",
        template: '<course-session-info back-state="$resolve.backState" program-enrollment-id="$resolve.programEnrollmentId" enrollment-id="$resolve.enrollmentId" tab-select="$resolve.tabSelect"></course-session-info>',
        params: {
          tabSelect:null,
          backState: 'learningPassport.incompleteCourses.programInfo',
          ncyBreadcrumb: {
            isShowBreadCrumb: false
          }
        },
        resolve: Object.assign({
          backState: ['$stateParams', function( $stateParams ){
            return $stateParams.backState;
          }],
          programEnrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.programEnrollmentId;
          }],
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }],
          tabSelect: ['$stateParams', function( $stateParams ){
            return $stateParams.tabSelect;
          }]
        }, processMenu('learningPassport.incompleteCourses.programInfo.courseInfo'))
      }
    },
    {
      state: 'learningPassport.testQuestionnaireCenter',
      config: {
        url: "/test-questionnaire-center",
        template: '<incomplete-test-surveys></incomplete-test-surveys>',
        resolve: Object.assign({}, processMenu('learningPassport.testQuestionnaireCenter')),
        data: {
          permissions: {
            only: ['Modules.course.onlinetest','Modules.course.classroomtest','Modules.course.survey'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'learningPassport.testQuestionnaireCenter.courseInfo',
      config: {
        parent: "learningPassport",
        url: "/incomplete-test-questionnaire/course-info/:enrollmentId",
        template: '<course-session-info enrollment-id="$resolve.enrollmentId"></course-session-info>',
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('learningPassport.testQuestionnaireCenter.courseInfo'))
      }
    },
    {
      state: 'learningPassport.myCurriculum',
      config: {
        url: "/my-curriculum",
        template: '<my-curriculum></my-curriculum>',
        resolve: Object.assign({}, processMenu('learningPassport.myCurriculum'))
      }
    },
    {
      state: 'learningPassport.myCurriculum.courseSessionInfo',
      config: {
        parent: "learningPassport",
        url: "/course-learning-resource/course-session-info/:enrollmentId",
        template: '<course-session-info enrollment-id="$resolve.enrollmentId"></course-session-info>',
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('learningPassport.myCurriculum.courseSessionInfo'))
      }
    },
    {
      state: 'learningPassport.myCurriculum.programSessionInfo',
      config: {
        parent: "learningPassport",
        url: "/course-learning-resource/program-session-info/:enrollmentId",
        template: '<program-session-info enrollment-id="$resolve.enrollmentId"></program-session-info>',
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('learningPassport.myCurriculum.programSessionInfo'))
      }
    },
    {
      state: 'learningPassport.approveRecords',
      config: {
        url: "/approve-records",
        template: '<user-approve-records default-params="$resolve.defaultParams"></user-approve-records>',
        params: {
          defaultParams: null
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('learningPassport.approveRecords')),
        data: {
          permissions: {
            only: ['Modules.approval'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'learningPassport.approveRejectRecords',
      config: {
        url: "/approve-reject-records",
        template: '<user-approve-records default-params="$resolve.defaultParams"></user-approve-records>',
        params: {
          defaultParams: {
            status : 3
          }
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('learningPassport.approveRecords')),
        data: {
          permissions: {
            only: ['Modules.approval'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'learningPassport.approveRecordsExternalTrainingApplyRecordsFormEdit',
      config: {
        url: "/approve-records/external-training-apply/edit/:externalId",
        template: '<external-training-apply type="edit" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'learningPassport.approveRecords',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('learningPassport.approveRecordsExternalTrainingApplyRecordsFormEdit'))
      }
    },
    {
      state: 'learningPassport.approveRecordsExternalTrainingApplyRecordsFormReSubmit',
      config: {
        url: "/approve-records/external-training-apply/re-submit/:externalId",
        template: '<external-training-apply type="reSubmit" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'learningPassport.approveRecords',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('learningPassport.approveRecordsExternalTrainingApplyRecordsFormReSubmit'))
      }
    },
    {
      state: 'learningPassport.approveRecordsExternalTrainingApplyRecordsFormView',
      config: {
        url: "/approve-records/external-training-apply/view/:externalId",
        template: '<external-training-apply type="view" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'learningPassport.approveRecords',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('learningPassport.approveRecordsExternalTrainingApplyRecordsFormView'))
      }
    },


    {
      state: 'learningPassport.trainingRecords',
      config: {
        url: "/training-records",
        template: '<user-training-records></user-training-records>',
        resolve: Object.assign({}, processMenu('learningPassport.trainingRecords'))
      }
    },
    {
      state: 'learningPassport.trainingRecords.courseSessionInfo',
      config: {
        parent: "learningPassport",
        url: "/course-learning-resource/course-session-info/:enrollmentId",
        template: '<course-session-info enrollment-id="$resolve.enrollmentId"></course-session-info>',
        params: {
          backState: 'learningPassport.trainingRecords'
        },
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('learningPassport.trainingRecords.courseSessionInfo'))
      }
    },
    {
      state: 'learningPassport.trainingRecords.programSessionInfo',
      config: {
        parent: "learningPassport",
        url: "/course-learning-resource/program-session-info/:enrollmentId",
        template: '<program-session-info enrollment-id="$resolve.enrollmentId"></program-session-info>',
        resolve: Object.assign({
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('learningPassport.trainingRecords.programSessionInfo')),
        params: {
          backState: 'learningPassport.trainingRecords'
        }
      }
    },
    {
      state: 'learningPassport.trainingRoadMap',
      config: {
        url: '/training-road-map',
        template: '<training-road-map></training-road-map>',
        resolve: Object.assign({}, processMenu('learningPassport.trainingRoadMap')),
        data: {
          permissions: {
            only: ['Modules.training_roadmap'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'learningPassport.trainingPlan',
      config: {
        url: "/training-plan",
        parent: "learningPassport",
        template: '<training-plan></training-plan>',
        resolve: Object.assign({}, processMenu('learningPassport.trainingPlan')),
        data: {
          permissions: {
            only: ['Modules.training_plan'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },

    {
      state: 'myCalendar',
      config: {
        url: "/my-calendar",
        parent: "modules",
        template : '<my-calendar></my-calendar>'
        // resolve: Object.assign({}, processMenu('myCalendar'))
      }
    },
    {
      state: 'mySetting',
      config: {
        url: "/my-setting",
        parent: "modules",
        template : '<my-setting></my-setting>'
        // resolve: Object.assign({}, processMenu('mySetting'))
      }
    },

    {
      state: 'reportsZone',
      config: {
        parent: "modules",
        url: "/reports",
        template: '<learning-reports></learning-reports>',
        resolve: Object.assign({}, processMenu('reportsZone')),
        params: {
          id:'',
          url: ''
        },
        data: {
          permissions: {
            only: ['Modules.report'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'communityDiscussionZone',
      config: {
        abstract: true,
        url: "/community-discussion-zone",
        parent: "modules",
        template : '<ui-view></ui-view>',
        resolve: Object.assign({}, processMenu('communityDiscussionZone'))
      }
    },
    {
      state: 'communityDiscussionZone.publicDiscussionZone',
      config: {
        url: "/public-discussion-zone",
        template: '<forum></forum>',
        resolve: Object.assign({}, processMenu('communityDiscussionZone.publicDiscussionZone')),
        params: {
          url: 'mvnforum/index'
        }
      }
    },
    {
      state: 'communityDiscussionZone.publicDiscussionZoneThread',
      config: {
        url: "/public-discussion-zone/thread/:threadId",
        template: '<forum></forum>',
        resolve: Object.assign({}, processMenu('communityDiscussionZone.publicDiscussionZone')),
        params: {
          url: 'mvnforum/viewthread?thread='
        }
      }
    },
    {
      state: 'communityDiscussionZone.classesDiscussionZone',
      config: {
        url: "/classes-discussion-zone",
        template: '<forum></forum>',
        resolve: Object.assign({}, processMenu('communityDiscussionZone.classesDiscussionZone')),
        params: {
          url: 'mvnforum/listcourseforums'
        }
      }
    },

    {
      state: 'externalTrainingZone',
      config: {
        abstract: true,
        url: "/external-training-zone",
        parent: "modules",
        template : '<ui-view></ui-view>',
        resolve: Object.assign({}, processMenu('externalTrainingZone')),
        data: {
          permissions: {
            only: ['Modules.course.external'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },

    {
      state: 'externalTrainingZone.externalTrainingApplyFormCreate',
      config: {
        url: "/external-training-form/create",
        template: '<external-training-apply type="create"></external-training-apply>',
        resolve: Object.assign({
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('externalTrainingZone.externalTrainingApplyFormCreate'))
      }
    },

    {
      state: 'externalTrainingZone.externalTrainingBulletin',
      config: {
        url: "/external-training-bulletin",
        template: '<external-training-bulletin default-params="$resolve.defaultParams"></external-training-bulletin>',
        params: {
          defaultParams: null
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('externalTrainingZone.externalTrainingBulletin'))
      }
    },
    {
      state: 'externalTrainingZone.externalTrainingBulletinApplyFormCreateByBulletin',
      config: {
        url: "/external-training-bulletin/:bulletinId/create-external-training-form",
        template: '<external-training-apply type="createByBulletin" bulletin-id="$resolve.bulletinId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'externalTrainingZone.externalTrainingBulletin',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          bulletinId: ['$stateParams', function ($stateParams) {
            return $stateParams.bulletinId;
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('externalTrainingZone.externalTrainingBulletinApplyFormCreateByBulletin'))
      }
    },
    {
      state: 'externalTrainingZone.externalTrainingBulletinApplyFormCreateByCourseSession',
      config: {
        url: "/external-training-bulletin/course/:courseId/session/:sessionId/create-external-training-form",
        template: '<external-training-apply type="createByCourseSession" course-id="$resolve.courseId" session-id="$resolve.sessionId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'externalTrainingZone.externalTrainingBulletin',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          courseId: ['$stateParams', function ($stateParams) {
            return $stateParams.courseId;
          }],
          sessionId: ['$stateParams', function ($stateParams) {
            return $stateParams.sessionId;
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('externalTrainingZone.externalTrainingBulletinApplyFormCreateByCourseSession'))
      }
    },


    {
      state: 'externalTrainingZone.externalTrainingApplyRecords',
      config: {
        url: "/external-training-apply-records",
        template: '<external-training-records default-params="$resolve.defaultParams"></external-training-records>',
        params: {
          defaultParams: null
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('externalTrainingZone.externalTrainingApplyRecords'))
      }
    },

    {
      state: 'externalTrainingZone.externalTrainingApplyRecordsFormEdit',
      config: {
        url: "/external-training-apply-records/edit/:externalId",
        template: '<external-training-apply type="edit" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'externalTrainingZone.externalTrainingApplyRecords',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('externalTrainingZone.externalTrainingApplyRecordsFormEdit'))
      }
    },
    {
      state: 'externalTrainingZone.externalTrainingApplyRecordsFormView',
      config: {
        url: "/external-training-apply-records/view/:externalId",
        template: '<external-training-apply type="view" external-id="$resolve.externalId" back-state-object="$resolve.backStateObject"></external-training-apply>',
        params: {
          backState: 'externalTrainingZone.externalTrainingApplyRecords',
          backStateParams: null
        },
        resolve: Object.assign({
          backStateObject: ['$stateParams', function ($stateParams) {
            return {
              state: $stateParams.backState,
              params: {
                defaultParams: $stateParams.backStateParams
              }
            };
          }],
          formType: [ '$stateParams', function ($stateParams) {
            return $stateParams.formType
          }],
          externalId: [ '$stateParams', function ($stateParams) {
            return $stateParams.externalId
          }],
          loadPlugin: ['$ocLazyLoad', function( $ocLazyLoad ){
            return $ocLazyLoad.load(['stepFormWizard']);
          }]
        }, processMenu('externalTrainingZone.externalTrainingApplyRecordsFormView'))
      }
    },

    {
      state: 'certZone',
      config: {
        abstract: true,
        url: "/cert-zone",
        parent: "modules",
        template : '<ui-view></ui-view>',
        resolve: Object.assign({}, processMenu('certZone')),
        data: {
          permissions: {
            only: ['Modules.certification', 'Modules.certification.ext', 'Modules.certification.inner'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.externalCertRegister',
      config: {
        url: "/external-cert-register",
        template: '<external-cert-register></external-cert-register>',
        resolve: Object.assign({}, processMenu('certZone.externalCertRegister')),
        data: {
          permissions: {
            only: ['Modules.certification.ext'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.externalCertExamApplication',
      config: {
        url: "/external-cert-exam-application",
        template: '<external-cert-exam-application></external-cert-exam-application>',
        resolve: Object.assign({}, processMenu('certZone.externalCertExamApplication')),
        data: {
          permissions: {
            only: ['Modules.certification.ext'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.externalCertExamAllowanceApplication',
      config: {
        url: "/external-cert-exam-allowance-application",
        template: '<external-cert-exam-allowance-application></external-cert-exam-allowance-application>',
        resolve: Object.assign({}, processMenu('certZone.externalCertExamAllowanceApplication')),
        data: {
          permissions: {
            only: ['Modules.certification.ext'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.externalCertQualifyRewardApplication',
      config: {
        url: "/external-cert-qualify-reward-application",
        template: '<external-cert-qualify-reward-application></external-cert-qualify-reward-application>',
        resolve: Object.assign({}, processMenu('certZone.externalCertQualifyRewardApplication')),
        data: {
          permissions: {
            only: ['Modules.certification.ext'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.externalCertApplicationRecordsSearch',
      config: {
        url: "/external-cert-application-records-search",
        template: '<external-cert-application-records-search></external-cert-application-records-search>',
        resolve: Object.assign({}, processMenu('certZone.externalCertApplicationRecordsSearch')),
        data: {
          permissions: {
            only: ['Modules.certification.ext'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.certRecordsSearch',
      config: {
        url: "/cert-records-search",
        template: '<cert-records-search></cert-records-search>',
        resolve: Object.assign({}, processMenu('certZone.certRecordsSearch')),
        data: {
          permissions: {
            only: ['Modules.certification.ext', 'Modules.certification.inner'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.certInnerRecordsSearch',
      config: {
        url: "/cert-inner-records-search",
        template: '<cert-records-search default-params="$resolve.defaultParams"></cert-records-search>',
        params: {
          defaultParams : {
            defaultCertType : 'inner'
          }
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('certZone.certRecordsSearch')),
        data: {
          permissions: {
            only: ['Modules.certification.ext', 'Modules.certification.inner'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.certExtRecordsSearch',
      config: {
        url: "/cert-ext-records-search",
        template: '<cert-records-search default-params="$resolve.defaultParams"></cert-records-search>',
        params: {
          defaultParams : {
            defaultCertType : 'ext'
          }
        },
        resolve: Object.assign({
          defaultParams: ['$stateParams', function ($stateParams) {
            return $stateParams.defaultParams;
          }]
        }, processMenu('certZone.certRecordsSearch')),
        data: {
          permissions: {
            only: ['Modules.certification.ext', 'Modules.certification.inner'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.financialCertRecordApplication',
      config: {
        url: "/financial-cert-record-application",
        template: '<financial-cert-record-application></financial-cert-record-application>',
        resolve: Object.assign({}, processMenu('certZone.financialCertRecordApplication')),
        data: {
          permissions: {
            only: ['Modules.certification.financial'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },
    {
      state: 'certZone.financialCertRecordSearch',
      config: {
        url: "/financial-cert-record-search",
        template: '<financial-cert-record-search></financial-cert-record-search>',
        resolve: Object.assign({}, processMenu('certZone.financialCertRecordSearch')),
        data: {
          permissions: {
            only: ['Modules.certification.financial'],
            redirectTo: {
              default: function(/*rejectedPermission, transitionProperties*/){
                return {
                  state: 'modules.error',
                  params: {
                    type: ''
                  }
                };
              }
            }
          }
        }
      }
    },

    {
      state: 'error',
      config: {
        url: '/error/:id',
        templateUrl: "app/shared/views/error.html",
        controller: 'ErrorController',
        controllerAs: 'vm'
      }
    },
    {
      state: 'login',
      config: {
        url: '/login?:pid&:siteMapContext',
        templateUrl: "app/shared/views/login.html",
        controller: 'LoginController',
        controllerAs: 'vm',
        resolve: {
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'theme-plugins'
            ]);
          }],
          skipIfLoggedIn: ['$auth', '$stateParams', function ($auth, $stateParams) {
            if(angular.isUndefinedOrNull($stateParams.pid) || $stateParams.pid==='')
              return $auth.skipIfLoggedIn();
          }],
          loginSitemapRequired:['sitemapService', '$cookies', '$stateParams', function(sitemapService, $cookies, $stateParams){
            if(angular.isUndefinedOrNull($stateParams.pid) || $stateParams.pid==='') {
              var companyName = (angular.isUndefinedOrNull($cookies.get('Company')) || $cookies.get('Company')==='')?$stateParams.siteMapContext:$cookies.get('Company');
              return sitemapService.loginSitemapRequired({ companyName: companyName});
            }
            else
              return sitemapService.loginSitemapPreviewRequired({projectId: $stateParams.pid});
          }]
        }
      }
    },
    {
      state: 'logout',
      config: {
        url: '/logout',
        template: null,
        // resolve: Object.assign({}, processMenu('logout')),
        controller: 'LogoutController',
        controllerAs: 'vm'
      }
    },
    {
      state: 'index',
      config: {
        url: "/",
        parent: "modules",
        template : '<index></index>',
        resolve: Object.assign({}, processMenu('index')),
        data: {
          permissions: {
            only: ['Modules.core'],
            redirectTo: function(/*rejectedPermission, transitionProperties*/){
              return {
                state: 'modules.error',
                params: {
                  type: 'one'
                }
              };
            }
          }
        }
      }
    },

    {
      state: 'testQuestionnaire',
      config: {
        url: "/test-questionnaire/item-id/:itemId/session-id/:sessionId",
        template: '<test-questionnaire item-id="$resolve.itemId" session-id="$resolve.sessionId"></test-questionnaire>',
        resolve: Object.assign({
          loginRequired: ['$auth', function ($auth) {
            return $auth.loginRequired();
          }],
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'theme-plugins'
            ]);
          }],
          itemId: ['$stateParams', function ($stateParams) {
            return $stateParams.itemId;
          }],
          sessionId: ['$stateParams', function ($stateParams) {
            return $stateParams.sessionId;
          }]
        }, processMenu('testQuestionnaire'))
      }
    },

    {
      state: 'evaluationSurvey',
      config: {
        url: "/evaluation-survey/relation-id/:relationId/survey-id/:surveyId",
        template: '<evaluation-survey relation-id="$resolve.relationId" survey-id="$resolve.surveyId"></evaluation-survey>',
        resolve: Object.assign({
          loginRequired: ['$auth', function ($auth) {
            return $auth.loginRequired();
          }],
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'theme-plugins'
            ]);
          }],
          relationId: ['$stateParams', function ($stateParams) {
            return $stateParams.relationId;
          }],
          surveyId: ['$stateParams', function ($stateParams) {
            return $stateParams.surveyId;
          }]
        }, processMenu('evaluationSurvey'))
      }
    },

    {
      state: 'courseInfo',
      config: {
        url: "/incomplete-courses/course-info/:enrollmentId",
        template: '<course-session-info enrollment-id="$resolve.enrollmentId" tab-select="$resolve.tabSelect" is-user="false"></course-session-info>',
        params: {
          tabSelect:null
        },
        resolve: Object.assign({
          loginRequired: ['$auth', function ($auth) {
            return $auth.loginRequired();
          }],
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'theme-plugins'
            ]);
          }],
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }],
          tabSelect: ['$stateParams', function( $stateParams ){
            return $stateParams.tabSelect;
          }]
        }, processMenu('courseInfo'))
      }
    },
    {
      state: 'programInfo',
      config: {
        url: "/incomplete-courses/program-info/:enrollmentId",
        template: '<program-session-info enrollment-id="$resolve.enrollmentId" is-user="false"></program-session-info>',
        resolve: Object.assign({
          loginRequired: ['$auth', function ($auth) {
            return $auth.loginRequired();
          }],
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'theme-plugins'
            ]);
          }],
          enrollmentId: ['$stateParams', function( $stateParams ){
            return $stateParams.enrollmentId;
          }]
        }, processMenu('programInfo'))
      }
    },
    {
      state: 'learningDashboardDialog',
      config: {
        url: "/learning-passport/learning-dashboard/dialog?:pid",
        template: '<learning-dashboard-blocks is-manager="true"></learning-dashboard-blocks>',
        resolve: Object.assign({
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([
              'theme-plugins'
            ]);
          }]
        }, processMenu('learningDashboardDialog'))
      }
    },
    {
      state: 'systemInfo',
      config: {
        url: '/system-info',
        template: '<system-info></system-info>'
        // resolve: Object.assign({}, processMenu('systemInfo'))
      }
    },
    {
      state: 'fullTextSearchList',
      config: {
        parent: "modules",
        url: '/full-text-search-list',
        template: '<full-text-search-list></full-text-search-list>',
        params: {
          params : null,
          tabSelect : null
        }
      }
    }
  ];

  angular.module('eHRD.modules.routing')
    .constant('modulesRouteConfig', modulesRouteConfig);

})();


/**
 * Created by Bruce on 2016/12/14.
 */

(function () {
  'use strict';

  var mailLinkRouteConfig = [
    {
      state: 'mailLink',
      config: {
        url: "/mail-link/link-type/:linkType",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK',
        resolve: {
          loginRequired: ['$auth', '$stateParams', function ($auth, $stateParams) {
            return $auth.loginRequired($stateParams.pid);
          }]
        }
      }
    },
    {
      state: 'mailLink.forum',
      config: {
        url: "/forum",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.forum.discussionZone',
      config: {
        url: "/discussion-zone/:forumType",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.forum.thread',
      config: {
        url: "/thread/:threadId",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.course',
      config: {
        url: "/course/:courseId",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.course.session',
      config: {
        abstract: true,
        url: "/session/:sessionId",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.course.session.tabSelect',
      config: {
        url: "?:tabSelect"
      }
    },
    {
      state: 'mailLink.course.session.user',
      config: {
        url: "/user/:userId?tabSelect",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.program',
      config: {
        url: "/program/:programId",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.program.session',
      config: {
        abstract: true,
        url: "/session/:sessionId",
        template: '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    },
    {
      state: 'mailLink.program.session.tabSelect',
      config: {
        url: "?:tabSelect"
      }
    },
    {
      state: 'mailLink.program.session.user',
      config: {
        url: "/user/:userId?tabSelect",
        template : '<mail-link-process></mail-link-process>',
        title: 'MAIL_LINK'
      }
    }
  ];

  angular.module('eHRD.modules.routing')
    .constant('mailLinkRouteConfig', mailLinkRouteConfig);

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.reports', []);

})();

/**
 * Created by Bruce on 2016/5/18.
 */

(function () {
  'use strict';

  reportsService.$inject = ['Restangular'];
  function reportsService( Restangular) {

    /*
     * Build collection
     *api/learning-resource/folder/{ folderId }/userlist
     * ? keyword={ keyword }&sort={ sort }&order={ order }&current_page={ currentPage }&list_size={ listSize }
     */
    var _reportsService = Restangular.all('report');

    return{

      menuNodes: function () {
        // GET /api/report/nodes
        return _reportsService
          .customGETLIST('nodes');
      }
    };

  }

  angular.module('eHRD.modules.reports')
    .factory('reportsService',reportsService)
    ;

})();

/**
 * Created by Bruce on 2016/6/22.
 */
(function () {
  'use strict';

  ReportsMenuController.$inject = ['reportsService'];
  function ReportsMenuController(reportsService) {
    var vm = this;
    reportsService.menuNodes().then(function (data) {
      vm.menu = data;
    });


  }

  angular
    .module('eHRD.modules.reports')
    .controller('ReportsMenuController', ReportsMenuController)
    ;

})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var learningReports = {
    bindings: {},
    templateUrl: 'app/modules/reports/views/learning-reports.html',
    controller: ['$stateParams', 'serverSetting', function( $stateParams, serverSetting ){
      var vm = this;
      if($stateParams.url.length > 0){
        if ( ($stateParams.url.lastIndexOf('http://', 0) === 0) || ($stateParams.url.lastIndexOf('https://', 0) === 0) )
          vm.url = $stateParams.url;
        else
          vm.url = serverSetting.baseConfig.baseURL + '/' + $stateParams.url;
      }
    }]
  };

  angular.module('eHRD.modules.reports')
    .component('learningReports', learningReports);
})();

/**
 * Created by Bruce on 2017/7/31.
 */

(function() {
  'use strict';

  var learningReportsMenu = {
    bindings: {
      catalogId: '=?catalogId',
      nodeId: '=?nodeId'
    },
    templateUrl: 'app/modules/reports/views/learning-reports-menu.html',
    controller: [ 'reportsService', '$state', '$filter', 'serverSetting', 'sitemapService', function( reportsService, $state, $filter, serverSetting, sitemapService) {
      var vm = this;
      vm.previousMenu = undefined;
      vm.mainMenu = undefined;

      vm.process = function() {
        sitemapService.getSiteMapNodes().walk(function (node) {
          if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
            vm.mainMenu = node.model;
            if ((node.getPath().length -2) > 0) {
              vm.previousMenu = node.getPath()[(node.getPath().length -2)];
            }
          }
        });

        if(!vm.previousMenu) {
          sitemapService.getSiteMapNodes().walk(function (node) {
            if(node.model.state === 'index') {
              vm.previousMenu = node;
            }
          });
        }
      };

      if(sitemapService.getMenu().length > 0) {
        vm.process();
      } else {
        sitemapService.getProjectSideMenu().then(function (menuItems) {
          sitemapService.setMenu(menuItems);
          vm.process();
        });
      }

      reportsService.menuNodes().then(function (data) {
        vm.menu = data;
      });
    }]
  };

  angular.module('eHRD.modules.reports')
    .component('learningReportsMenu', learningReportsMenu);
})();

/**
 * Created by Bruce on 2016/10/20.
 */

(function () {
  'use strict';

  managerService.$inject = ['Restangular', '$httpParamSerializer'];
  function managerService(Restangular, $httpParamSerializer){

    var _ManagerService = Restangular.all('manager');

    return {
      getMemberTrainingRecords: function (params) {
        /*
         * api/manager/member-finished-enrollment
         * */
        return _ManagerService
          .customGETLIST('member-finished-enrollment', params);
      },
      getUnAssignableMmembers: function(isProgram, sessionId, params){
        /*
         * type: course
         * api/manager/unassignable-course/{sessionId}/members
         * type: program
         * api/manager/unassignable-program/{sessionId}/members
         * */
        if(isProgram){
          return _ManagerService
            .one('unassignable-program', sessionId)
            .customGETLIST('members', params);
        }else {
          return _ManagerService
            .one('unassignable-course', sessionId)
            .customGETLIST('members', params);
        }
      },
      UnAssignable: function (isProgram, sessionId, params) {
        /*
         * type: course
         * api/manager/unassign-course/{sessionId}
         * type: program
         * api/manager/unassign-program/{sessionId}
         * */
        if(isProgram){
          return _ManagerService
            .one('unassign-program', sessionId)
            .put(params);
        }else{
          return _ManagerService
            .one('unassign-course', sessionId)
            .put(params);
        }
      },

      getMemberCurriculum: function (formData) {
        /*
         * POST api/manager/member-course
         * */
        return _ManagerService
          .customPOST($httpParamSerializer(formData), 'member-course', [], {"content-type": "application/x-www-form-urlencoded"});
      },

      getMemberCurriculumDetail: function (params) {
        /*
         * GET api/manager/member-course-detail
         * */
        return _ManagerService
          .customGETLIST('member-course-detail', params);
      },

      getMemberDownloadDetail: function (params) {
        /*
         * GET api/manager/member-download-detail
         * */
        return _ManagerService
          .customGETLIST('member-download-detail', params);
      },

      getMemberLearningHistory: function (enrollmentId) {
        /*
         * GET api/manager/member-learning-history/{enrollmentId}
         * */
        return _ManagerService
          .one('member-learning-history', enrollmentId)
          .get();
      },

      getCourses: function (params) {
        /*
         * GET api/manager/category-activity
         * */
        return _ManagerService
            .customGETLIST('category-activity', params);
      },

      getDirectMembers: function (sessionId, params, isProgram) {
        /*
         * GET api/manager/assignable-course/{sessionId}/direct-members
         * GET api/manager/assignable-program/{sessionId}/direct-members
         * */
        isProgram = isProgram || false;
        if(isProgram){
          return _ManagerService
            .one('assignable-program', sessionId)
            .customGETLIST('direct-members', params);
        }else{
          return _ManagerService
            .one('assignable-course', sessionId)
            .customGETLIST('direct-members', params);
        }
      },

      getMembersByFilters: function (sessionId, params, isProgram) {
        /*
         * GET api/manager/assignable-course/{sessionId}/members
         * GET api/manager/assignable-program/{sessionId}/members
         * */
        isProgram = isProgram || false;
        if(isProgram){
          return _ManagerService
            .one('assignable-program', sessionId)
            .customGETLIST('members', params);
        }else{
          return _ManagerService
            .one('assignable-course', sessionId)
            .customGETLIST('members', params);
        }

      },

      getMemberSuggestLearningList: function (params) {
        /*
         * GET api/manager/recommen-learning-map?lmYearBegin={lmYearBegin}&lmMonthBegin={lmMonthBegin}&lmYearEnd={lmYearEnd}&lmMonthEnd={lmMonthEnd}&
         sourceType={sourceType}&memberId={memberId}&searchStatus={searchStatus}&sort={sort}&order={order}&current_page={current_page}&list_size={list_size}
         * */
        return _ManagerService
            .customGETLIST('recommen-learning-map',params);
      },

      updateMemberSuggestLearningList: function (formData, params) {
        /*
         * api/manager/recommen-learning-map/update
         * */
        return _ManagerService
            .one('recommen-learning-map')
            .customPUT($httpParamSerializer(formData), 'update', params, {"content-type": "application/x-www-form-urlencoded"});
      },

      deleteMemberSuggestLearningList: function (formData, params) {
        /*
         * api/manager/recommen-learning-map/delete
         * */
        return _ManagerService
            .one('recommen-learning-map')
            .customOperation('remove', 'delete', params, {"content-type": "application/x-www-form-urlencoded"}, $httpParamSerializer(formData));
      },

      addMemberSuggestLearningList: function (formData, params) {
        /*
         * api/manager/recommen-learning-map/add-view-item?userId={userId}
         * */
        return _ManagerService
            .one('recommen-learning-map')
            .customPOST({"addViewItems": formData}, 'add-view-item', params, {'Content-Type': 'application/json'});
      },

      deleteMemberSuggestLearningTemp: function (params) {
        /*
         * api/manager/recommen-learning-map/delete-temp?userId={userId}
         * */
        return _ManagerService
            .one('recommen-learning-map')
            .customDELETE('delete-temp', params);
      },

      getMemberSuggestLearningTemp: function (formData, params) {
        /*
         * api/manager/recommen-learning-map/view-temp-items
         * */
        return _ManagerService
            .one('recommen-learning-map')
            .customPOST({"viewItems": formData}, 'view-temp-items', params, {'Content-Type': 'application/json'});
      },

      AssignablePrecheck: function (isProgram, sessionId, params) {
        /*
         * type: course
         * api/manager/assign-course-precheck/{sessionId}?memberIds={memberIds}&enrollType={enrollType}
         * type: program
         * api/manager/assign-program-precheck/{sessionId}?memberIds={memberIds}&enrollType={enrollType}
         * */
        if(isProgram){
          return _ManagerService
            .one('assign-program-precheck', sessionId)
            .customGET(null, params);
        }else {
          return _ManagerService
            .one('assign-course-precheck', sessionId)
            .customGET(null, params);
        }
      },

      Assignable: function (isProgram, sessionId, params) {
        /*
         * type: course
         * api/manager/assign-course/{sessionId}
         * type: program
         * api/manager/assign-program/{sessionId}
         * */
        if(isProgram){
          return _ManagerService
            .one('assign-program', sessionId)
            .put(params);
        }else{
          return _ManagerService
            .one('assign-course', sessionId)
            .put(params);
        }
      },

      AssignableExternalCourse: function (sessionId, params) {
        /*
         * type: course
         * api/manager/assign-ext-course/{sessionId}
         * */
        return _ManagerService
          .one('assign-ext-course', sessionId)
          .put(params);
      },

      getTestHistory: function (sessionId, params) {
        /*
         * api/manager/exam/{sessionId}/exam-history?itemid={itemId}&startDate={startDate}&endDate={endDate}&userId={userId}
         * */
        return _ManagerService
          .one('exam', sessionId)
          .customGETLIST('exam-history', params);
      },

      getExamResult: function (sessionId, params) {
        /*
         * api/manager/exam/{sessionId}/result-info?itemid={itemId}&examhistoryId={examHistoryId}&userId={userId}
         * */
        return _ManagerService
          .one('exam', sessionId)
          .customGET('result-info', params);
      },

      getExamQuestionsReview: function (sessionId, params) {
        /*
         * api/manager/exam/{sessionId}/review-response?itemid={itemId}&examhistoryId={examHistoryId}&show-incorrect={showInCorrect}&userId={userId}
         * */
        return _ManagerService
          .one('exam', sessionId)
          .customGETLIST('review-response', params);
      },

      getReportProcess: function (enrollmentId, params) {
        /*
         * api/manager/member-learning-history/{enrollmentId}/report-process?isCourse={isCourse}
         * */
        return _ManagerService
          .one('member-learning-history', enrollmentId)
          .customGET('report-process', params);
      }


    };

  }


  angular.module('eHRD.modules.manager')
    .factory('managerService', managerService);
})();

/**
 * Created by Bruce on 2016/10/21.
 */
(function() {
  'use strict';

  MemberTrainingRecordsSearchDialogController.$inject = ['$scope', '$mdDialog','filters', 'PermPermissionStore', 'groups', 'groupMembers', 'userProfiles', 'SweetAlert', '$filter'];

  function MemberTrainingRecordsSearchDialogController($scope, $mdDialog, filters, PermPermissionStore, groups, groupMembers, userProfiles, SweetAlert, $filter) {
    var vm = this;
    var initializing = true;
    var permission = null;
    permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
    vm.hasCurriculumPermission = angular.isDefined(permission);
    permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
    vm.hasCertificationInnerPermission = angular.isDefined(permission);

    vm.groups = groups;
    vm.groupMembers = groupMembers;
    vm.filters = {
      keyword: angular.isDefined(filters.keyword) ? filters.keyword : '',
      cpType: angular.isDefined(filters.cpType) ? filters.cpType : 1,
      passResult: angular.isDefined(filters.passResult) ? filters.passResult : -1,
      learnerType: angular.isDefined(filters.learnerType) ? filters.learnerType : -1,
      groupId: angular.isDefined(filters.groupId) ? filters.groupId : ( groups.length>0 ? groups[0].groupId : -1),
      memberId: userProfiles.uid
    };

    $scope.$watch('MTRSDC.filters.groupId', function() {
      if(initializing)
        initializing=false;
      else
        vm.filters.memberId="";
    });

    vm.cancel = function() {
      $mdDialog.hide({});
    };

    vm.close = function() {
      $mdDialog.cancel();
    };

    vm.submit = function(filters) {
      if(vm.filters.memberId==="")
        SweetAlert.error('',$filter('translate')('MESSAGE.MSG_PLEASE_SELECT_DEPARTMENT_MEMBER'));
      else
        $mdDialog.hide(filters);
    };
  }

  angular.module('eHRD.modules.manager')
    .controller('MemberTrainingRecordsSearchDialogController', MemberTrainingRecordsSearchDialogController);
})();

/**
 * Created by Alan on 2016/11/24.
 */
(function() {
  'use strict';

  MemberDownloadDetailDialogController.$inject = ['managerService','params','$mdDialog'];

  function MemberDownloadDetailDialogController(managerService,params,$mdDialog) {
    var vm = this;

    managerService.getMemberDownloadDetail(params).then(function (downloadDetails) {
      vm.downloadDetails = downloadDetails;
      vm.courseName = downloadDetails.metadata.courseName;
      vm.sessionName = downloadDetails.metadata.sessionName;
    });

    vm.close = function() {
      $mdDialog.cancel();
    };
  }

  angular.module('eHRD.modules.manager')
    .controller('MemberDownloadDetailDialogController', MemberDownloadDetailDialogController);
})();

/**
 * Created by Alan on 2016/11/2.
 */
(function() {
  'use strict';

  memberCurriculumSearchDialogController.$inject = ['$scope','$mdDialog', 'NgTableParams', 'managerService', 'SweetAlert', 'filters', '$filter'];

  function memberCurriculumSearchDialogController($scope,$mdDialog, NgTableParams, managerService, SweetAlert, filters, $filter) {
    var vm = this;

    vm.isQueryAllDate = filters.isQueryAllDate;
    vm.isListAll = filters.isListAll;
    vm.keyword = filters.keyword;
    vm.sDate = filters.sDate;
    vm.eDate = filters.eDate;
    vm.page = filters.page;
    vm.count = filters.count;
    vm.id = {
      selectAll: false,
      selected: angular.isDefined(filters.selectItem)?filters.selectItem:[]
    };


    vm.corsesTable = new NgTableParams({}, {
      counts: [1,5,10,15],
      getData: function(tableParams) {
          var params = {};
          params.keyword = vm.keyword;
          params.current_page = tableParams.url().page;
          params.list_size = tableParams.url().count;
          return managerService.getCourses(params).then(function (courses) {
            tableParams.total(courses.metadata.pagination.total);
            vm.courses = courses;
            vm.id.selectAll = false;
            return courses;
          });
      }
    });
    vm.corsesTable.count(vm.count);
    vm.corsesTable.page(vm.page);

    // watch for check all checkbox
    $scope.$watch(function() {
      return vm.id.selectAll;
    }, function(value) {
      angular.forEach(vm.courses, function(courses) {
        vm.id.selected[courses.activity.id] = {
          value:value,
          id:courses.activity.id,
          courseName:courses.activity.name
        };
      });

    });

    vm.checkboxSelect = function(id,value,courseName){
      vm.id.selected[id] = {
        value:value,
        id:id,
        courseName:courseName
      };
    };

    $scope.$watch('MCSDC.keyword', function() {
        vm.corsesTable.reload();
    });

    vm.close = function() {
      $mdDialog.cancel();
    };

    vm.submit = function() {
      var courseNameList="";
      var courseIdList="";
      angular.forEach(vm.id.selected, function(courses) {
        if(courses.value) {
          courseNameList +=(courseNameList==='')?courses.courseName:","+courses.courseName;
          courseIdList +=(courseIdList==='')?courses.id:","+courses.id;
        }
      });

      var close = true;
      if(vm.isQueryAllDate===0){
        if(angular.isUndefined(vm.eDate)){
          SweetAlert.error('',$filter('translate')('MESSAGE.MSG_PLEASE_ENTER_END_DATE'));
          close=false;
        }
        if(angular.isUndefined(vm.sDate)){
          SweetAlert.error('',$filter('translate')('MESSAGE.MSG_PLEASE_ENTER_START_DATE'));
          close=false;
        }
      }
      if(vm.isListAll===0){
        if(courseIdList===''){
          SweetAlert.error('',$filter('translate')('MESSAGE.MSG_PLEASE_SELECT_AT_LEAST_ONE_COURSE'));
          close=false;
        }
      }
      var sCompareDate = new Date(vm.sDate);
      var eCompareDate = new Date(vm.eDate);
      if (eCompareDate < sCompareDate) {
        SweetAlert.error('',$filter('translate')('MESSAGE.MSG_THE_START_DATE_CAN_NOT_BE_GREATER_THAN_THE_END_DATE'));
        close=false;
      }
      if(close===true){
        if(vm.isListAll===1){
          vm.id = {
            selectAll: false,
            selected: []
          };
          courseIdList  = '';
          vm.keyword = ''
        }
        vm.filters = {
          page:vm.corsesTable.page(),
          count:vm.corsesTable.count(),
          selectItem:vm.id.selected,
          keyword:vm.keyword,
          isAdm:0,
          isListAll:vm.isListAll,
          courseIdList:courseIdList,
          isQueryAllDate:vm.isQueryAllDate,
          sDate: moment(vm.sDate).format("YYYY/MM/DD"),
          eDate: moment(vm.eDate).format("YYYY/MM/DD")
        };
        $mdDialog.hide(vm.filters);
      }

    };
  }

  angular.module('eHRD.modules.manager')
    .controller('memberCurriculumSearchDialogController', memberCurriculumSearchDialogController);
})();

/**
 * Created by Bruce on 2016/10/21.
 */
(function() {
  'use strict';

  MemberCurriculumDetailDialogController.$inject = ['managerService','params','course','$mdDialog'];

  function MemberCurriculumDetailDialogController(managerService,params,course,$mdDialog) {
    var vm = this;
    vm.courseName = course.courseName;
    vm.courseSession = course.courseSession;
    vm.courseType = course.courseType;
    vm.enrollmentType = params.type;
    managerService.getMemberCurriculumDetail(params).then(function (curriculumDetails) {
      vm.curriculumDetails = curriculumDetails;
    });

    vm.close = function() {
      $mdDialog.cancel();
    };
  }

  angular.module('eHRD.modules.manager')
    .controller('MemberCurriculumDetailDialogController', MemberCurriculumDetailDialogController);
})();

/**
 * Created by Alan on 2016/12/5.
 */
(function () {
  'use strict';

  var memberSuggestLearningList = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/member-suggest-learning-list.html',
      controller: ['PermPermissionStore', '$scope', 'NgTableParams', 'managerService', '$filter', 'ngTableColumnValueService', '$interpolate',
          function(PermPermissionStore, $scope, NgTableParams, managerService, $filter, ngTableColumnValueService, $interpolate){
          var vm = this;
          var permission = null;
          vm.firstInto = true;
          permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
          vm.hasCurriculumPermission = angular.isDefined(permission);
          permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
          vm.hasCertificationInnerPermission = angular.isDefined(permission);
          vm.enrollmentId = {
              selectAll: false,
              selected: []
          };
          vm.tableCols = prepareTableCols();
          vm.suggestLearningTable = new NgTableParams({ sorting: { 'PredictDueDate': "asc" } }, {
              counts: [1,5,10,15],
              getData: function(tableParams) {
                vm.firstInto = false;
                var params = {};
                //clear checkbox
                vm.enrollmentId = {
                    selectAll: false,
                    selected: []
                };
                angular.forEach(tableParams.sorting(), function (value, key) {
                    params.sort = key;
                    params.order = ((value === 'desc') ? "ASC" : "DESC");
                });
                angular.forEach(tableParams.filter(), function (value, key) {
                    params[key] = value;
                });

                params.current_page = tableParams.url().page;
                params.list_size = tableParams.url().count;
                return managerService.getMemberSuggestLearningList(params).then(function (memberSuggestLearningList) {
                    vm.memberSuggestLearningList = memberSuggestLearningList;
                    vm.userInfo = memberSuggestLearningList.metadata.userInfo;
                    vm.dataLength = memberSuggestLearningList.length;
                    tableParams.total(memberSuggestLearningList.metadata.pagination.total);
                    return memberSuggestLearningList;
                });
                }
          });

            function prepareTableCols() {
              var cols = [];
              cols = [
                {
                  field: 'checkbox',
                  title: '',
                  headerTemplateURL: 'headerCheckbox.html',
                  getValue: ngTableColumnValueService.interpolatedValue,
                  interpolateExpr: $interpolate("<md-checkbox flex class='md-primary checkbox'" +
                    "ng-model='$ctrl.enrollmentId.selected[row.enrollmentId].value'" +
                    "ng-click='$ctrl.checkboxSelect(row, $ctrl.enrollmentId.selected[row.enrollmentId].value)'> </md-checkbox>"
                  ),
                  priority: 1,
                  width: 5
                },
                {
                  field: 'predictDueDate',
                  title: $filter('translate')('FIELD.ESTIMATED_COMPLETION_DATE'),
                  getValue: ngTableColumnValueService.htmlTextValue,
                  sortable: 'PredictDueDate',
                  priority: 2,
                  width: 110
                },
                {
                  field: 'finishDate',
                  title: $filter('translate')('FIELD.FINISH_TIME'),
                  getValue: ngTableColumnValueService.htmlTextValue,
                  sortable: 'ResultModifiedDate',
                  priority: 1,
                  width: 80
                },
                {
                  field: 'activityName',
                  title: $filter('translate')('FIELD.LEARNING_ACTIVITY'),
                  getValue: ngTableColumnValueService.interpolatedValue,
                  interpolateExpr: $interpolate(htmlActivityName()),
                  sortable: 'ActivityName',
                  priority: 1
                },
                {
                  field: 'sessionName',
                  title: $filter('translate')('FIELD.SESSION'),
                  getValue: ngTableColumnValueService.htmlTextValue,
                  priority: 3
                },
                {
                  field: 'itemName',
                  title: $filter('translate')('FIELD.TYPE'),
                  getValue: ngTableColumnValueService.htmlTextValue,
                  sortable: 'ItemType',
                  priority: 3,
                  width: 50
                },
                {
                  field: 'sourceName',
                  title: $filter('translate')('FIELD.SOURCE'),
                  getValue: htmlSourceInfos,
                  sortable: 'Source',
                  priority: 2
                },
                {
                  field: 'properties',
                  title: $filter('translate')('FIELD.PROPERTIES'),
                  getValue: ngTableColumnValueService.interpolatedValue,
                  interpolateExpr: $interpolate("" +
                    "<div class='text' ng-if='row.itemType===99 || row.itemType===256'>N/A</div>" +
                    "<div class='text' ng-if='row.learnerType===0 && row.itemType!==99 && row.itemType!==256'>{{ 'FIELD.COURSE_ELECTIVE' |translate }}</div>" +
                    "<div class='text' ng-if='row.learnerType===1 && row.itemType!==99 && row.itemType!==256'>{{ 'FIELD.COURSE_REQUIRED' |translate }}</div>"
                  ),
                  sortable: 'LearnerType',
                  priority: 2
                },
                {
                  field: 'enrollName',
                  title: $filter('translate')('FIELD.ENROLL_TYPE') +'(' + $filter('translate')('FIELD.SPECIFY_APPLICANT') + ')',
                  headerTemplateURL: 'enrollTypeHeader.html',
                  getValue: ngTableColumnValueService.interpolatedValue,
                  interpolateExpr: $interpolate('<div>{{row.enrollName}}<br>' +
                    '<span ng-if=\' row.assignerFullName!=="" \'>(<a href=\'javascript:void(0)\' user-detail user-id=\'row.assignerId\'>{{row.assignerFullName}}</a>)</span> </div>'
                  ),
                  sortable: 'EnrollType',
                  priority: 3
                },
                {
                  field: 'enrollmentStatus',
                  title: $filter('translate')('FIELD.ENROLLMENT_STATUS'),
                  getValue: ngTableColumnValueService.interpolatedValue,
                  interpolateExpr: $interpolate(htmlEnrollmentStatus()),
                  priority: 1,
                  width: 100
                },
                {
                  field: 'leanerStatusName',
                  title: $filter('translate')('FIELD.LEARNING_STATUS'),
                  getValue: ngTableColumnValueService.htmlTextValue,
                  priority: 1
                }
              ];


              return cols;
            }

          // watch for check all checkbox
          $scope.$watch(function() {
              return vm.enrollmentId.selectAll;
          }, function(value) {
              angular.forEach(vm.memberSuggestLearningList, function(suggestLearningList) {
                  vm.checkboxSelect(suggestLearningList, value);
              });
          });

          //checkbox select
          vm.checkboxSelect = function(suggestLearningList, value){
              vm.enrollmentId.selected[suggestLearningList.enrollmentId] = {
                  value: value,
                  itemType: suggestLearningList.itemType,
                  canDelete: suggestLearningList.canDelete,
                  canUpdate: suggestLearningList.canUpdate,
                  activityName: suggestLearningList.activityName,
                  sourceInfos: suggestLearningList.sourceInfos,
                  status: suggestLearningList.status
              };
          };

            function htmlSourceInfos() {
              return '<div class=\'text\' ng-repeat=\'sourceInfo in row.sourceInfos track by $index\' >{{sourceInfo.sourceName}}</div>';
            }

            function htmlEnrollmentStatus() {
              var html = '<div class=\'progress th-line\' ng-if=\'row.status!=="Have not Executed Enrolled Assignment" && row.status!=="Enrollment Approval Pending" && row.status!=="Unenroll" && row.status!=="Exemption" && row.status!=="" \' style=\'width: 100px;\'>';
                  html += '<div class=\'progress-bar\' ng-style=\'{width: row.progress}\'>';
                    html += '<div class=\'progress-value\'>';
                      html += '<a  ng-if=\'row.itemType!==64 && row.itemType!==128\' learning-history enrollment-id=\'row.enrollmentId\' session-id=\'row.sessionId\' is-manager=\'true\' href=\'javascript:void(0);\'>';
                        html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                        html += '<span class="pt-value">{{row.statusProgress}}</span>';
                      html += '</a>';
                      html += '<a  ng-if=\'row.itemType===64 || row.itemType===128\' program-detail-lessons-results-dialog enrollment-id=\'row.enrollmentId\' is-manager=\'true\' href=\'javascript:void(0);\'>';
                        html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                        html += '<span class="pt-value">{{row.statusProgress}}</span>';
                      html += '</a>';
                    html += '</div>';
                  html += '</div>';
                html += '</div>';
              html += '<span ng-if=\'row.status==="Have not Executed Enrolled Assignment" || row.status==="Enrollment Approval Pending" || row.status==="Unenroll" || row.status==="Exemption" \'> {{row.statusName}}</span>';
              html += '<span ng-if=\'row.status==="" && row.itemType!==256\'> N/A </span>';
              html += '<span ng-if=\'row.status==="" && row.itemType===256\'> {{row.leanerStatusName}} </span>';
              return html;
            }

            function htmlActivityName() {
              var html = "<div ng-switch='row.itemType'>";
              html += "<a href='javascript:void(0)' ng-if='row.itemType!==64 && row.itemType!==128 && row.itemType!==256 && row.itemType!==99' course-detail-info-dialog course-id='row.itemId' is-published='row.isPublished' can-view='row.canViewByUser'>{{row.activityName}}</a>";
              html += "<a href='javascript:void(0)' ng-if='row.itemType===64 || row.itemType===128' program-detail-info-dialog program-id='row.itemId' is-published='row.isPublished' can-view='row.canViewByUser'>{{row.activityName}}</a>";
              html += "<a href='javascript:void(0)' ng-if='row.itemType===256' external-cert-detail-info-dialog subject-id='row.itemId' is-published='row.isPublished' can-view='row.canViewByUser'>{{row.activityName}}</a>";
              html += "<span ng-if='row.itemType===99'>{{row.activityName}}</span>";
              html += "</div>";
              return html;
            }
    }]
  };

  angular.module('eHRD.modules.manager')
    .component('memberSuggestLearningList', memberSuggestLearningList);
})();

/**
 * Created by Alan on 2017/5/10.
 */
(function () {
  'use strict';

  var memberFinancialCertRecordSearch = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/member-financial-cert-record-search.html',
    controller: ['serverSetting', function (serverSetting) {
      var vm = this;
      vm.url = serverSetting.baseConfig.baseURL + '/fc-query-application-default.do?isManager=true';
    }]
  };

  angular
    .module('eHRD.modules.manager')
    .component('memberFinancialCertRecordSearch' , memberFinancialCertRecordSearch);

})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var memberCurriculum = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/member-curriculum.html',
    controller: ['$interpolate', '$filter', 'ngTableColumnValueService' ,'NgTableParams','$mdDialog', '$document', 'managerService', 'PermPermissionStore', function($interpolate, $filter, ngTableColumnValueService, NgTableParams, $mdDialog, $document, managerService, PermPermissionStore ){
      var vm = this;
      var permission = null;
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.classroom');
      vm.hasCourseClassroomPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.approval');
      vm.hasApprovalPermission = angular.isDefined(permission);
      vm.filters = {
        isAdm:0,
        isListAll:1,
        isQueryAllDate:0,
        sDate: moment().subtract(89, 'day').format("YYYY/MM/DD"),
        eDate: moment().format("YYYY/MM/DD")
      };
      vm.tableCols = prepareTableCols();
      vm.memberCurriculumTable = new NgTableParams({}, {
        counts: [],
        getData: function(tableParams) {

          var params = {};
          angular.forEach(tableParams.sorting(), function (value, key) {
            params.sort = key;
            params.order = ((value === 'desc') ? 0 : 1);
          });

          angular.forEach(tableParams.filter(), function (value, key) {
            params[key] = value;
          });


          return managerService.getMemberCurriculum(params).then(function (curriculm) {
            vm.dataLength = curriculm.length;
            vm.groupIdList = curriculm.groupIdList;
            tableParams.total(curriculm.length);
            return curriculm;
          });

        }
      });

      function prepareTableCols() {
        var cols = [{
          field: 'courseName',
          title: $filter('translate')('FIELD.COURSE_NAME'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'categoryName',
          title: $filter('translate')('FIELD.LEARNING_CATEGORY'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'credit',
          title: $filter('translate')('FIELD.CREDITS'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'courseType',
          title: $filter('translate')('FIELD.COURSE_TYPE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlCourseType()),
          priority: 1
        },{
          field: 'sessionName',
          title: $filter('translate')('FIELD.SESSION'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'classTime',
          title: $filter('translate')('FIELD.COURSE_DATE'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'timeOfHours',
          title: $filter('translate')('FIELD.TIME_OF_HOURS'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlTimeOfHours()),
          priority: 1
        },{
          field: 'instructorName',
          title: $filter('translate')('FIELD.INSTRUCTOR'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'numOfValid',
          title: $filter('translate')('FIELD.ENROLLMENT_NUMBER_OF_PEOPLE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlNumTotalLearners()),
          priority: 1
        },{
          field: 'numOfDownload',
          title: $filter('translate')('FIELD.DOWNLOAD_COUNT'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlDowanloadCount()),
          priority: 1
        },{
          field: 'numOfNA',
          title:  $filter('translate')('FIELD.INCOMPLETED_NUMBER_OF_PEOPLE') ,
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlIncompletedNumberOfPeople()),
          priority: 1
        },{
          field: 'numOfExemption',
          title: $filter('translate')('FIELD.EXEMPTION_NUMBER_OF_PEOPLE'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 3
        },{
          field: 'numOfPass',
          title: $filter('translate')('FIELD.PASSED_NUMBER_OF_PEOPLE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlPassNumberOfPeople()),
          priority: 2
        },{
          field: 'numOfFail',
          title: $filter('translate')('FIELD.FAILED_NUMBER_OF_PEOPLE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlFailedNumberOfPeople()),
          priority: 2
        },{
          field: 'numOfWithdraw',
          title: $filter('translate')('FIELD.DROP_NUMBER_OF_PEOPLE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlDropNumberOfPeople()),
          priority: 2
        },{
          field: 'scoreOfLearnerStatisfy',
          title: $filter('translate')('FIELD.LEARNER_SATISFACTION'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 3
        },{
          field: 'scoreOfManagerStatisfy',
          title: $filter('translate')('FIELD.PASS_STATUS'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 3
        }];

        angular.forEach(cols, function (value ,key) {
          if (value.field === 'numOfExemption' && !vm.hasCourseClassroomPermission && !vm.hasApprovalPermission) {
            cols.splice(key, 1);
          }
        });

        return cols;
      }

      function htmlCourseType() {
        var html = '<div class="text" ng-switch="row.courseType">';
        html += '<span ng-switch-when="1">{{ \'FIELD.ONLINE_COURSE\' | translate}}</span>';
        html += '<span ng-switch-when="2">{{ \'FIELD.CLASS_ROOM_COURSE\' | translate}}</span>';
        html += '<span ng-switch-when="3">{{ \'FIELD.EXTERNAL_TRAINING\' | translate}}</span>';
        html += '<span ng-switch-when="4">{{ \'FIELD.ONLINE_TEST\' | translate}}</span>';
        html += '<span ng-switch-when="5">{{ \'FIELD.CLASS_ROOM_TEST\' | translate}}</span>';
        html += '<span ng-switch-when="6">{{ \'FIELD.QUESTIONNAIRE\' | translate}}</span>';
        html += '<span ng-switch-default>{{row.courseType}}</span>';
        html += '</div>';
        return html;
      }

      function htmlTimeOfHours() {
        var html = '<span ng-if="row.studyMin === 0">';
        html += '{{(row.studyHour === 0) ? \'\' : row.studyHour}}';
        html += '</span>';
        html += '<span ng-if="!(row.studyMin === 0)">';
        html += '{{(row.studyHour + (row.studyMin/60)) | number:2}}';
        html += '</span>';
        return html;

      }

      function htmlNumTotalLearners() {
        var html = '<div class="text" ng-if="row.numOfValid!==0">';
        html += '<a href="javascript:void(0);"  ng-click="$ctrl.memberCurriculumDetailDialog(row.courseId,row.sessionId,row.courseName,row.sessionName,row.courseType,4,$event)">{{row.numOfValid}}</a>';
        html += '</div>';
        html += '<div class="text" ng-if="row.numOfValid===0">{{row.numOfValid}}</div>';
        return html;
      }

      function htmlDowanloadCount() {
        var html = '<div class="text" ng-if="row.numOfDownload!==0">';
        html += '<a href="javascript:void(0);"  ng-click="$ctrl.memberDownloadDetailDialog(row.sessionId,$ctrl.groupIdList,$event)">{{row.numOfDownload}}</a>';
        html += '</div>';
        html += '<div class="text" ng-if="row.numOfDownload===0">{{row.numOfDownload}}</div>';
        return html;
      }

      function htmlIncompletedNumberOfPeople() {
        var html = '<div class="text" ng-if="row.numOfNA!==0">';
        html += '<a href="javascript:void(0);"  ng-click="$ctrl.memberCurriculumDetailDialog(row.courseId,row.sessionId,row.courseName,row.sessionName,row.courseType,0,$event)">{{row.numOfNA}}</a>';
        html += '</div>';
        html += '<div class="text" ng-if="row.numOfNA===0">{{row.numOfNA}}</div>';
        return html;
      }

      function htmlPassNumberOfPeople () {
        var html = '<div class="text" ng-if="row.numOfPass!==0">';
        html += '<a href="javascript:void(0);" ng-click="$ctrl.memberCurriculumDetailDialog(row.courseId,row.sessionId,row.courseName,row.sessionName,row.courseType,2,$event)">{{row.numOfPass}}</a>';
        html += '</div>';
        html += '<div class="text" ng-if="row.numOfPass===0">{{row.numOfPass}}</div>';
        return html;
      }

      function htmlFailedNumberOfPeople() {
        var html = '<div class="text" ng-if="row.numOfFail!==0">';
        html += '<a href="javascript:void(0);" ng-click="$ctrl.memberCurriculumDetailDialog(row.courseId,row.sessionId,row.courseName,row.sessionName,row.courseType,3,$event)">{{row.numOfFail}}</a>';
        html += '</div>';
        html += '<div class="text" ng-if="row.numOfFail===0">{{row.numOfFail}}</div>';
        return html;
      }

      function htmlDropNumberOfPeople() {
        var html = '<div class="text" ng-if="row.numOfWithdraw!==0">';
        html += '<a href="javascript:void(0);" ng-click="$ctrl.memberCurriculumDetailDialog(row.courseId,row.sessionId,row.courseName,row.sessionName,row.courseType,-1,$event)">{{row.numOfWithdraw}}</a>';
        html += '</div>';
        html += '<div class="text" ng-if="row.numOfWithdraw===0">{{row.numOfWithdraw}}</div>';
        return html;
      }

      vm.memberCurriculumTable = new NgTableParams({}, {
        counts: [],
        getData: function(tableParams) {
          var params = {};

          angular.forEach(tableParams.filter(), function (value, key) {
            params[key] = value;
          });

          return managerService.getMemberCurriculum(params).then(function (curriculm) {
            vm.dataLength = curriculm.length;
            vm.groupIdList = curriculm.groupIdList;
            return curriculm;
          });
        }
      });

      vm.memberCurriculumTable.filter(vm.filters);

      vm.memberCurriculumDetailDialog = function(courseId,sessionId,courseName,courseSession,courseType,type,ev){
        var params = {
          courseId:courseId,
          sessionId:sessionId,
          type:type
        };
        var course={
          courseName:courseName,
          courseSession:courseSession,
          courseType:courseType
        };
        $mdDialog.show({
          controller: 'MemberCurriculumDetailDialogController',
          controllerAs:'MCDDC',
          templateUrl: 'app/modules/manager/views/member-curriculum-detail-dialog.html',
          parent: angular.element($document[0].body),
          clickOutsideToClose:true,
          targetEvent: ev,
          locals:{
            params:params,
            course:course
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        });
      };

      vm.memberDownloadDetailDialog = function(sessionId, groupIdList,ev){
        var params = {
          sessionId:sessionId,
          groupIdList:groupIdList
        };
        $mdDialog.show({
          controller: 'MemberDownloadDetailDialogController',
          controllerAs:'MDDDC',
          templateUrl: 'app/modules/manager/views/member-download-detail-dialog.html',
          parent: angular.element($document[0].body),
          clickOutsideToClose:true,
          targetEvent: ev,
          locals:{
            params:params
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        });
      };

      vm.setFilter = function (filters, isClear) {
        if(isClear){
          filters = {};
        }
        // angular.extend(vm.myTrainingRecordsTable.filter(), filters);
        vm.memberCurriculumTable.filter(filters);

      };

      vm.showPrompt = function(ev) {
        // Appending dialog to document.body to cover sidenav in docs app
        $mdDialog.show({
          controller: 'memberCurriculumSearchDialogController',
          controllerAs:'MCSDC',
          templateUrl: 'app/modules/manager/views/member-curriculum-search-dialog.html',
          parent: angular.element($document[0].body),
          clickOutsideToClose:true,
          targetEvent: ev,
          locals:{
            filters:vm.filters
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        }).then(function(filters) {
          vm.filters = filters;
          vm.memberCurriculumTable.filter({
            isAdm: filters.isAdm,
            isListAll: filters.isListAll,
            isQueryAllDate: filters.isQueryAllDate,
            sDate: filters.sDate,
            eDate: filters.eDate,
            courseIdList: filters.courseIdList
          });
        }, function() { });
      };
    }]
  };

  angular.module('eHRD.modules.manager')
    .component('memberCurriculum', memberCurriculum);
})();

/**
 * Created by Bruce on 2017/5/15.
 */
(function () {
  'use strict';

  var memberCertRecordsSearch = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/member-cert-records-search.html',
    controller: ['PermPermissionStore', '$interpolate', '$scope', '$filter', 'NgTableParams', 'ngTableColumnValueService', '$mdDialog', '$document', 'certZoneService', '$auth', function (PermPermissionStore, $interpolate, $scope, $filter, NgTableParams, ngTableColumnValueService, $mdDialog, $document, certZoneService, $auth) {
      var vm = this;
      var permission = null;
      permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
      vm.hasCertificationInnerPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.certification.ext');
      vm.hasCertificationExtPermission = angular.isDefined(permission);
      vm.certType = ( (vm.hasCertificationInnerPermission) ? 'inner' : ((vm.hasCertificationExtPermission) ? 'ext': '')); // inner or ext

      vm.filter = {
        certType: vm.certType,
        validDateType: 0,
        memberId: $auth.getUserData().id
      };

      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.certTable = new NgTableParams({
          // sorting: {},
          filter: vm.filter
        }, {
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = value;
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            var isExtCert = (vm.certType === 'ext');

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;

            if(angular.isDefined(params['accessBegin'])) params['accessBegin'] = moment(params['accessBegin']).format('YYYY/MM/DD');
            if(angular.isDefined(params['accessEnd'])) params['accessEnd'] = moment(params['accessEnd']).format('YYYY/MM/DD');
            return certZoneService.getMemberCertRecords(isExtCert, params).then(function (certData) {
              vm.configuration = certData.metadata.configuration;
              if((vm.configuration.isShowCredit === 1) && angular.isDefined($filter('where')(vm.tableCols, {field: 'credits'}).length > 0)) {
                var credits_index = vm.tableCols.indexOf($filter('where')(vm.tableCols, {field: 'credits'})[0]);
                vm.tableCols[credits_index].show = true;
              }
              tableParams.total(certData.metadata.pagination.total);
              return certData;
            });
          }
        });

        vm.setFilter = function (filters, isClear) {
          if(isClear){
            filters = {};
          }
          vm.certType = angular.isDefined(filters.certType) ? filters.certType : '';
          vm.filter = filters;
          vm.certTable.filter(filters);
          vm.certTable.sorting({});
          vm.certTable.reload();
        };
      }

      function prepareTableCols() {
        var cols = [];
        switch (vm.certType){
          case 'inner':
            cols = [{
              field: 'classificationName',
              title: $filter('translate')('FIELD.CERTIFICATE_TYPE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              sortable: 'ClassificationName',
              priority: 1
            },{
              field: 'programName',
              sortable: 'Programs.ProgramName',
              title: $filter('translate')('FIELD.CERTIFICATION_NAME'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<a href='javascript:void(0)' tip-info tip-type='18' params='{certid: row.programId}'>{{row.programName}}</a>"),
              priority: 1
            },{
              field: 'credits',
              title: $filter('translate')('FIELD.CREDITS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              columnType: 'number',
              show: false
            },{
              field: 'acquireDate',
              sortable: 'Cert_SubjectToUser.AcquireDate',
              title: $filter('translate')('FIELD.ACQUIRE_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              columnType: 'date',
              width: 100
            },{
              field: 'validDate',
              sortable: 'Cert_SubjectToUser.ExpireDate',
              title: $filter('translate')('FIELD.VALID_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              columnType: 'date',
              width: 100
            },{
              field: 'score',
              title: $filter('translate')('FIELD.SCORE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              columnType: 'number',
              width: 50,
              priority: 2
            },{
              field: 'status',
              sortable: 'Cert_SubjectToUser.Status',
              title: $filter('translate')('FIELD.STATUS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 3
            },{
              field: 'bonus',
              title: $filter('translate')('FIELD.BONUS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              columnType: 'number',
              priority: 2
            },{
              field: 'references',
              title: $filter('translate')('FIELD.REFERENCE_MATERIAL'),
              getValue: ngTableColumnValueService.htmlReferences,
              priority: 2
            }];
            break;
          case 'ext':
            cols = [{
              field: 'companyName',
              sortable: 'Cert_Company.CompanyId',
              title: $filter('translate')('FIELD.ORIGINAL_FACTORY_NAME'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              width: 200
            },{
              field: 'subjectName',
              sortable: 'Cert_Subject.SubjectId',
              title: $filter('translate')('FIELD.CERTIFIED_SUBJECT'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<a href='javascript:void(0)' tip-info tip-type='7' params='{subid: row.subjectId}'>{{row.subjectName}}</a>"),
              priority: 1,
              width: 200
            },{
              field: 'credits',
              title: $filter('translate')('FIELD.CREDITS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              show: false,
              priority: 1
            },{
              field: 'acquireDate',
              sortable: 'Cert_SubjectToUser.AcquireDate',
              title: $filter('translate')('FIELD.ACQUIRE_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              width: 100
            },{
              field: 'validDate',
              sortable: 'Cert_SubjectToUser.ExpireDate',
              title: $filter('translate')('FIELD.VALID_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              width: 100
            },{
              field: 'subjectToUserCode',
              title: $filter('translate')('FIELD.CERTIFICATE_NUMBER'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 2
            },{
              field: 'grade',
              title: $filter('translate')('FIELD.SUBJECT_TO_USER_GRADE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 2
            },{
              field: 'bonus',
              title: $filter('translate')('FIELD.BONUS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 2
            },{
              field: 'relatedRefs',
              title: $filter('translate')('FIELD.REFERENCE_DOCUMENT'),
              getValue: ngTableColumnValueService.htmlReferences,
              priority: 2
            }];
            break;
        }


        return cols;
      }

      $scope.$watch(function () {
        return vm.certType
      }, function () {
        prepareTable();
      });


      vm.showPrompt = function(ev) {
        $mdDialog.show({
          templateUrl: 'app/modules/manager/views/member-cert-records-search-dialog.html',
          controller: ['$mdDialog', 'filters', function ($mdDialog, filters) {
            var vm = this;

            vm.filters = {
              groupId: angular.isDefined(filters.groupId) ? filters.groupId : '',
              memberId: angular.isDefined(filters.memberId) ? filters.memberId : '',
              companyId: angular.isDefined(filters.companyId) ? filters.companyId : '',
              subjectId: angular.isDefined(filters.subjectId) ? filters.subjectId : '',
              certClassId: angular.isDefined(filters.certClassId) ? filters.certClassId : '',
              certId: angular.isDefined(filters.certId) ? filters.certId : '',
              certType: angular.isDefined(filters.certType) ? filters.certType : '' ,
              validDateType: angular.isDefined(filters.validDateType) ? filters.validDateType : 0,
              accessBegin: angular.isDefined(filters.accessBegin) ? filters.accessBegin : undefined,
              accessEnd: angular.isDefined(filters.accessEnd) ? filters.accessEnd : undefined
            };

            vm.updateEndDateModel = function () {
              var beginningTime = moment(vm.filters.accessBegin);
              var endTime = moment(vm.filters.accessEnd);
              if(!beginningTime.isBefore(endTime)){
                vm.filters.accessEnd = vm.filters.accessBegin;
              }
            };

            vm.cancel = function() {
              $mdDialog.cancel();
            };
            vm.close = function() {
              $mdDialog.cancel();
            };
            vm.submit = function(filters) {
              $mdDialog.hide(filters);
            };
          }],
          controllerAs:'$ctrl',
          parent: angular.element($document[0].body),
          targetEvent: ev,
          clickOutsideToClose:true,
          locals : {
            filters : vm.certTable.filter()
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        }).then(function(filters) {
          vm.setFilter(filters, false);
        }, function() { });
      };
    }]
  };

  angular
    .module('eHRD.modules.manager')
    .component('memberCertRecordsSearch' , memberCertRecordsSearch);

})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var managerTrainingRecords = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/manager-training-records.html',
    controller: ['$scope', '$filter', '$interpolate', 'PermPermissionStore', 'ngTableColumnValueService', 'NgTableParams','$mdDialog', '$document', 'managerService', 'userService', function( $scope, $filter, $interpolate, PermPermissionStore, ngTableColumnValueService, NgTableParams, $mdDialog, $document, managerService, userService ){
      var vm = this;
      var permission = null;
      permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
      vm.hasCurriculumPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
      vm.hasCertificationInnerPermission = angular.isDefined(permission);
      vm.kernelUser = userService.getKernelUser();

      vm.filter = { };
      vm.cpType = 1;

      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.myTrainingRecordsTable = new NgTableParams({
          filter: vm.filter,
          sorting: {}
        }, {
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = ((value === 'desc') ? 0 : 1);
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.currentPage = tableParams.url().page;
            params.perPage = tableParams.url().count;
            
            return managerService.getMemberTrainingRecords(params).then(function (records) {
              vm.groups = records.metadata.groups;
              vm.groupMembers = records.metadata.groupMembers;
              vm.summary = records.metadata.summary;
              tableParams.total(records.metadata.pagination.total);
              if(angular.isDefined(tableParams.filter().memberId) && tableParams.filter().memberId!= -1){
                userService.getUserProfileById(tableParams.filter().memberId).then(function (userData) {
                  vm.userProfiles = userData;
                });
              }else{
                userService.getUserProfile().then(function (userData) {
                  vm.userProfiles = userData;
                });
              }
              tableParams.total(records.metadata.pagination.total);
              return records;
            });
          }
        });

        vm.setFilter = function (filters, isClear) {
          if(isClear){
            filters = {};
          }
          vm.cpType = filters.cpType;
          vm.filter = filters;
          vm.myTrainingRecordsTable.filter(filters);
          vm.myTrainingRecordsTable.sorting({});
          vm.myTrainingRecordsTable.reload();
        };
      }
      function prepareTableCols() {
        var cols = [];
        switch (vm.cpType){
          case 1:
            cols = [{
              field: 'courseName',
              title: $filter('translate')('FIELD.APPELLATION'),
              getValue: ngTableColumnValueService.htmlTextValue,
              sortable: '110',
              priority: 1
            },{
              field: 'sessionName',
              title: $filter('translate')('FIELD.SESSION') + '/' + $filter('translate')('FIELD.SESSION'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 3
            },{
              field: 'credits',
              title: $filter('translate')('FIELD.CREDITS'),
              sortable: '151',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class='text' ng-if='row.credits > 0'>{{row.credits}}</div>"),
              width: 50,
              priority: 2
            },{
              field: 'courseType',
              title: $filter('translate')('FIELD.TYPE'),
              sortable: '49',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlCourseType()),
              priority: 3
            },{
              field: 'history_course_time',
              title: $filter('translate')('FIELD.ENROLLMENT_TIME'),
              sortable: 'history_course_time',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlHistoryCourseTime()),
              width: 100,
              priority: 2
            },{
              field: 'HOURS',
              title: $filter('translate')('FIELD.HOURS'),
              sortable: '59',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlHours()),
              width: 50,
              priority: 3
            },{
              field: 'PersonalCost',
              title: $filter('translate')('FIELD.COST'),
              sortable: '56',
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 3
            },{
              field: 'PROPERTIES',
              title: $filter('translate')('FIELD.PROPERTIES'),
              sortable: '140',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlProperties()),
              width: 50,
              priority: 2
            },{
              field: 'enrollType',
              title: $filter('translate')('FIELD.ENROLL_TYPE'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class='text'>{{ 'STATUS.' + row.enrollType | uppercase | translate}}</div>"),
              priority: 3
            },{
              field: 'enrollmentHours',
              title:  $filter('translate')('FIELD.ENROLLMENT_HOURS') ,
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class=\"time\" ng-if=\"row.courseType === 1 || row.courseType === 4 || row.courseType === 6 || $ctrl.cpType === 2\">{{row.totalTime}}</div>"),
              priority: 2
            },{
              field: 'TEST_FRACTION',
              title: $filter('translate')('FIELD.TEST_FRACTION'),
              sortable: '64',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class=\"text\" ng-if=\"row.isFinalScoreViewable\">{{row.score}}</div><div class=\"text\" ng-if=\"!(row.isFinalScoreViewable)\">{{ 'STATUS.NOT_PUBLISHED' | translate}}</div>"),
              width: 50,
              priority: 3
            },{
              field: 'ENROLLMENT_STATUS',
              title: $filter('translate')('FIELD.ENROLLMENT_STATUS'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlEnrollmentStatus()),
              width: 100,
              priority: 1
            },{
              field: 'PASS_STATUS',
              title: $filter('translate')('FIELD.PASS_STATUS'),
              sortable: '46',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlPassStatus()),
              priority: 1
            }];

            break;
          case 2:
            cols = [{
              field: 'programName',
              title: $filter('translate')('FIELD.APPELLATION'),
              getValue: ngTableColumnValueService.htmlTextValue,
              sortable: '111',
              priority: 1
            },{
              field: 'sessionName',
              title: $filter('translate')('FIELD.SESSION'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 3
            },{
              field: 'credits',
              title: $filter('translate')('FIELD.CREDITS'),
              sortable: '151',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class='text' ng-if='row.credits > 0'>{{row.credits}}</div>"),
              width: 50,
              priority: 2
            },{
              field: 'programAccessTime',
              title: $filter('translate')('FIELD.CLASS_TIME'),
              sortable: 'Dynamic_ProgramAccessDate',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class='time'><span ng-bind-html='row.programAccessTime'></span></div>"),
              priority: 1
            },{
              field: 'includeCourse',
              title: $filter('translate')('COURSE_CONTAIN'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class='text'><span ng-bind-html=\"row.includeCourse |replaceAll:',':',<br>'\"></span></div>"),
              priority: 3
            },{
              field: 'PROPERTIES',
              title: $filter('translate')('FIELD.PROPERTIES'),
              sortable: '140',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlProperties()),
              width: 50,
              priority: 2
            },{
              field: 'enrollType',
              title: $filter('translate')('FIELD.ENROLL_TYPE'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class='text'>{{ 'STATUS.' + row.enrollType | uppercase | translate}}</div>"),
              priority: 3
            },{
              field: 'enrollmentHours',
              title: $filter('translate')('FIELD.LEARN_TOTAL_TIME'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class=\"time\" ng-if=\"row.courseType === 1 || row.courseType === 4 || row.courseType === 6 || $ctrl.cpType === 2\">{{row.totalTime}}</div>"),
              priority: 1
            },{
              field: 'passCount',
              title: $filter('translate')('FIELD.PASS_NUMBER'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class=\"text\">{{row.passCount}}</div>"),
              priority: 2
            },{
              field: 'failedCount',
              title: $filter('translate')('FIELD.FAILED_NUMBER'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class=\"text\">{{row.failedCount}}</div>"),
              priority: 3
            },{
              field: 'exemptionCount',
              title: $filter('translate')('FIELD.EXEMPTION_NUMBER'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<div class=\"text\">{{row.exemptionCount}}</div>"),
              priority: 3
            },{
              field: 'ENROLLMENT_STATUS',
              title: $filter('translate')('FIELD.ENROLLMENT_STATUS'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlEnrollmentStatus()),
              width: 100,
              priority: 1
            },{
              field: 'PASS_STATUS',
              title: $filter('translate')('FIELD.PASS_STATUS'),
              sortable: '46',
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate(htmlPassStatus()),
              priority: 1
            }];
            break;
        }
        return cols;
      }

      function htmlCourseType() {
        var html  = '<div class="text" ng-switch="row.courseType">';
            html += '<span ng-switch-when="1">{{ "FIELD.ONLINE_COURSE" | translate}}</span>';
            html += '<span ng-switch-when="2">{{ "FIELD.CLASS_ROOM_COURSE" | translate}}</span>';
            html += '<span ng-switch-when="3">{{ "FIELD.EXTERNAL_TRAINING" | translate}}</span>';
            html += '<span ng-switch-when="4">{{ "FIELD.ONLINE_TEST" | translate}}</span>';
            html += '<span ng-switch-when="5">{{ "FIELD.CLASS_ROOM_TEST" | translate}}</span>';
            html += '<span ng-switch-when="6">{{ "FIELD.QUESTIONNAIRE" | translate}}</span>';
            html += '<span ng-switch-default>{{row.courseType}}</span>';
            html += '</div>';
        return html;
      }

      function htmlHistoryCourseTime() {
        var html  = '<div class="text" ng-if="row.courseType ===1 || row.courseType===4 || row.courseType===6">';
            html += '<span ng-bind-html="row.lastAcessDate"></span>';
            html += '</div>';
            html += '<div class="text" ng-if="row.courseType ===2 || row.courseType===3 || row.courseType===5">';
            html += '<span ng-bind-html="row.classTime"></span>';
            html += '</div>';
        return html;
      }

      function htmlHours() {
        var html  = '<div class="text">';
            html += '<span ng-if="row.studyMin === 0">{{(row.studyHour === 0) ? "" : row.studyHour}}</span>';
            html += '<span ng-if="!(row.studyMin === 0)">';
            html += '{{(row.studyHour + (row.studyMin/60)) | number:2}}';
            html += '</span>';
            html += '</div>';
        return html;
      }

      function htmlProperties() {
        var html  = '<div class="text" ng-if="row.learnerType === \'0\'">{{ "FIELD.COURSE_ELECTIVE" | translate}}</div>';
            html += '<div class="text" ng-if="row.learnerType === \'1\'">{{ "FIELD.COURSE_REQUIRED" | translate}}</div>';
        return html;
      }

      function htmlEnrollmentStatus() {
        var html  = '<div class="text" ng-if="row.result!==1">';
              html += '<div class="progress th-line">';
                html += '<div class="progress-bar" ng-style="{\'width\': row.progress + \'%\'}">';
                  html += '<div class="progress-value">';
                    html += '<a ng-if="$ctrl.userProfiles.uid===$ctrl.kernelUser.id && row.result!==1 && $ctrl.cpType===1" ui-sref="supervisorZone.trainingRecords.courseSessionInfo({enrollmentId:row.enrollmentId})" >';
                      html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                      html += '<span class="pt-value">{{row.statusProgress}}</span>';
                    html += '</a>';
                    html += '<a ng-if="$ctrl.userProfiles.uid!==$ctrl.kernelUser.id && row.result!==1 && $ctrl.cpType===1" href="javascript:void(0);" learning-history enrollment-id="row.enrollmentId" session-id="row.sessionId" is-manager="true">';
                      html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                      html += '<span class="pt-value">{{row.statusProgress}}</span>';
                    html += '</a>';
                    html += '<a ng-if="$ctrl.userProfiles.uid===$ctrl.kernelUser.id && row.result!==1 && $ctrl.cpType===2" ui-sref="supervisorZone.trainingRecords.programSessionInfo({enrollmentId:row.enrollmentId})" >';
                      html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                      html += '<span class="pt-value">{{row.statusProgress}}</span>';
                    html += '</a>';
                    html += '<a ng-if="$ctrl.userProfiles.uid!==$ctrl.kernelUser.id && row.result!==1 && $ctrl.cpType===2" href="javascript:void(0);" program-detail-lessons-results-dialog enrollment-id="row.enrollmentId" is-manager="true">';
                      html += '<span class="pt-value">{{ \'STATUS.\' + row.status | uppercase | translate}}</span>';
                      html += '<span class="pt-value">{{row.statusProgress}}</span>';
                    html += '</a>';
                  html += '</div>';
                html += '</div>';
              html += '</div>';
            html += '</div>';
            html += '<a ng-if="row.result===1 && $ctrl.cpType===1" href="javascript:void(0);" learning-history enrollment-id="row.enrollmentId" session-id="row.sessionId" is-manager="true">{{ \'STATUS.\' + row.status | uppercase | translate}}</a>';
            html += '<a ng-if="row.result===1 && $ctrl.cpType===2" href="javascript:void(0);" program-detail-lessons-results-dialog enrollment-id="row.enrollmentId" is-manager="true">{{ \'STATUS.\' + row.status | uppercase | translate}}</a>';
        return html;
      }

      function htmlPassStatus() {
        var html  = '<div class="text" ng-switch="row.result">';
            html += '<span ng-switch-when="0">N/A</span>';
            html += '<span ng-switch-when="1">{{ \'STATUS.EXEMPTION\' | translate }}</span>';
            html += '<span ng-switch-when="2">{{ \'STATUS.PASSED\' | translate }}</span>';
            html += '<span ng-switch-when="3">{{ \'STATUS.FAILED\' | translate }}</span>';
            html += '</div>';
        return html;
      }


      $scope.$watch(function () {
        return vm.cpType;
      }, function () {
        prepareTable();
      });

      vm.showPrompt = function(ev) {
        // Appending dialog to document.body to cover sidenav in docs app
        $mdDialog.show({
          controller: 'MemberTrainingRecordsSearchDialogController',
          controllerAs:'MTRSDC',
          templateUrl: 'app/modules/manager/views/member-training-records-search-dialog.html',
          parent: angular.element($document[0].body),
          targetEvent: ev,
          clickOutsideToClose:true,
          locals : {
            filters : vm.myTrainingRecordsTable.filter(),
            groups: vm.groups,
            groupMembers: vm.groupMembers,
            userProfiles: vm.userProfiles
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        }).then(function(filters) {
            vm.setFilter(filters, false);
          }, function() { }
        );
      };
    }]
  };

  angular.module('eHRD.modules.manager')
    .component('managerTrainingRecords', managerTrainingRecords);
})();

/**
 * Created by Bruce on 2017/1/23.
 */
(function () {
  'use strict';

  var managerTrainingPlan = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/manager-training-plan.html',
    controller: ['serverSetting', function (serverSetting) {
      var vm = this;
      vm.url = serverSetting.baseConfig.baseURL + '/home-tp-manager-right.do';
    }]
  };

  angular
    .module('eHRD.modules.manager')
    .component('managerTrainingPlan' , managerTrainingPlan);

})();

/**
 * Created by Alan on 2017/8/8.
 */
(function () {
  'use strict';

  var embaMustRead = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/emba-must-read.html',
    controller: ['serverSetting', function (serverSetting) {
      var vm = this;
      vm.url = serverSetting.baseConfig.baseURL + '/emba-manager-mmustread.do';
    }]
  };

  angular
    .module('eHRD.modules.manager')
    .component('embaMustRead' , embaMustRead);

})();

/**
 * Created by Alan on 2017/8/8.
 */
(function () {
  'use strict';

  var embaCalendar = {
    bindings: {},
    templateUrl: 'app/modules/manager/views/emba-calendar.html',
    controller: ['serverSetting', function (serverSetting) {
      var vm = this;
      vm.url = serverSetting.baseConfig.baseURL + '/emba-manager-mcalendar.do';
    }]
  };

  angular
    .module('eHRD.modules.manager')
    .component('embaCalendar' , embaCalendar);

})();

/**
 * Created by Bruce on 2016/11/25.
 */

(function () {
  'use strict';

  angular
    .module('eHRD.modules.mailLink',[]);

})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var mailLinkProcess = {
    bindings: {},
    controller: ['$state', '$stateParams', 'courseResourceService', 'CourseObject', 'userService',
      function( $state, $stateParams, courseResourceService, CourseObject, userService){
      var isProgram = false;
      var tabSelect =  $stateParams.tabSelect || 'learningCenter';
      if(angular.isDefined($stateParams.linkType)){
        if(angular.isDefined($stateParams.programId)) isProgram = true;
        switch ($stateParams.linkType){
          case '912':
            if(isProgram){
              $state.go('courseResourceCatalog.ProgramInfo', {cid: 0,programId: $stateParams.programId});
            }else {
              var sessionId = $stateParams.sessionId;
              if (angular.isUndefinedOrNull(sessionId) || sessionId === '') {
              $state.go('courseResourceCatalog.CourseInfo', {cid: 0,courseId: $stateParams.courseId});
              } else {
                var userId = userService.getKernelUser().id;
                courseResourceService.getEnrollment($stateParams.sessionId, isProgram, userId).then(function (data) {console.log(data);
                  courseResourceService.getCourseEnrollment(data.enrollmentId, {}).then(function (courseEnrollment) {console.log(courseEnrollment);
                    switch (courseEnrollment.courseType) {
                      case CourseObject.COURSETYPE_CLASSROOM:
                      case CourseObject.COURSETYPE_ONLINE:
                      case CourseObject.PROGRAMTYPE_PROGRAM:
                        if (courseEnrollment.isBlock === 1 && courseEnrollment.fromProgramEnrollment > 0) {
                          tabSelect = "courseList";
                          $state.go('learningPassport.incompleteCourses.programInfo', {enrollmentId: courseEnrollment.fromProgramEnrollment, tabSelect: tabSelect});
                        } else {
                          $state.go('learningPassport.incompleteCourses.courseInfo', {enrollmentId: courseEnrollment.enrollmentId, tabSelect: tabSelect});
                        }
                        break;
                      case CourseObject.COURSETYPE_ONLINE_TEST:
                      case CourseObject.COURSETYPE_CLASSROOM_TEST:
                      case CourseObject.COURSETYPE_SURVEY:
                        if (courseEnrollment.isBlock === 1 && courseEnrollment.fromProgramEnrollment > 0) {
                          tabSelect = "courseList";
                          $state.go('learningPassport.incompleteCourses.programInfo', {enrollmentId: courseEnrollment.fromProgramEnrollment, tabSelect: tabSelect});
                        } else {
                          $state.go('learningPassport.testQuestionnaireCenter.courseInfo', {enrollmentId: courseEnrollment.enrollmentId, tabSelect: tabSelect});
                        }
                        break;
                      default:
                        $state.go('courseResourceCatalog.CourseInfo', {cid: 0,courseId: $stateParams.courseId});
                        break;
                    }
                  });
                });
              }
            }
            break;
          case '913':
            if(angular.isDefined($stateParams.sessionId)){
              courseResourceService.getEnrollment($stateParams.sessionId, isProgram).then(function (data) {
                if(isProgram){
                  courseResourceService.getProgramEnrollment(data.enrollmentId,{}).then(function (programEnrollment) {
                    switch (programEnrollment.programType){
                      case CourseObject.PROGRAMTYPE_INNERCERT :
                        $state.go('learningPassport.incompleteCourses.certificationInfo', {enrollmentId: data.enrollmentId, tabSelect: tabSelect});
                      break;
                      default:
                        $state.go('learningPassport.incompleteCourses.programInfo', {enrollmentId: data.enrollmentId, tabSelect: tabSelect});
                        break;
                    }
                  });
                }else {
                  courseResourceService.getCourseEnrollment(data.enrollmentId,{}).then(function (courseEnrollment) {
                    switch (courseEnrollment.courseType){
                      case CourseObject.COURSETYPE_ONLINE_TEST: case CourseObject.COURSETYPE_CLASSROOM_TEST: case CourseObject.COURSETYPE_SURVEY:
                      $state.go('learningPassport.testQuestionnaireCenter.courseInfo', {enrollmentId: courseEnrollment.enrollmentId});
                        break;
                      default:
                        $state.go('learningPassport.incompleteCourses.courseInfo', {enrollmentId: courseEnrollment.enrollmentId, tabSelect: tabSelect});
                        break;
                    }
                  });
                }
              });
            }
            break;
          case '914':
            var userId = (parseInt($stateParams.userId)<=0)?userService.getKernelUser().id:parseInt($stateParams.userId);
            courseResourceService.getEnrollment($stateParams.sessionId, isProgram, userId).then(function (data) {
              if ( data.enrollmentId === -1 ) {
                $state.go('modules.error');
              }
              else {
                if(isProgram){
                  if(userService.getKernelUser().id === userId) {
                    courseResourceService.getProgramEnrollment(data.enrollmentId,{}).then(function (programEnrollment) {
                      switch (programEnrollment.programType){
                        case CourseObject.PROGRAMTYPE_INNERCERT :
                          $state.go('learningPassport.incompleteCourses.certificationInfo', {enrollmentId: data.enrollmentId, tabSelect: tabSelect});
                          break;
                        default:
                          $state.go('learningPassport.incompleteCourses.programInfo', {enrollmentId: data.enrollmentId, tabSelect: tabSelect});
                          break;
                      }
                    });
                  }else {
                    $state.go('programInfo', {enrollmentId: data.enrollmentId});
                  }
                }else {
                  courseResourceService.getCourseEnrollment(data.enrollmentId,{}).then(function (courseEnrollment) {
                    if(userService.getKernelUser().id === userId) {
                      switch (courseEnrollment.courseType) {
                      case CourseObject.COURSETYPE_CLASSROOM:
                      case CourseObject.COURSETYPE_ONLINE:
                      case CourseObject.PROGRAMTYPE_PROGRAM:
                        if (courseEnrollment.isBlock === 1 && courseEnrollment.fromProgramEnrollment > 0) {
                          if(tabSelect ==="learningCenter")
                            tabSelect = "courseList";
                          $state.go('learningPassport.incompleteCourses.programInfo', {enrollmentId: courseEnrollment.fromProgramEnrollment, tabSelect: tabSelect});
                        } else {
                          $state.go('learningPassport.incompleteCourses.courseInfo', {enrollmentId: courseEnrollment.enrollmentId, tabSelect: tabSelect});
                        }
                        break;
                        case CourseObject.COURSETYPE_ONLINE_TEST:
                        case CourseObject.COURSETYPE_CLASSROOM_TEST:
                        case CourseObject.COURSETYPE_SURVEY:
                        if (courseEnrollment.isBlock === 1 && courseEnrollment.fromProgramEnrollment > 0) {
                          if(tabSelect ==="learningCenter")
                            tabSelect = "courseList";
                          $state.go('learningPassport.incompleteCourses.programInfo', {enrollmentId: courseEnrollment.fromProgramEnrollment, tabSelect: tabSelect});
                        } else {
                          $state.go('learningPassport.testQuestionnaireCenter.courseInfo', {enrollmentId: courseEnrollment.enrollmentId, tabSelect: tabSelect});
                        }
                          break;
                        default:
                          $state.go('learningPassport.incompleteCourses.courseInfo', {enrollmentId: courseEnrollment.enrollmentId, tabSelect: tabSelect});
                          break;
                      }
                    }
                    else {
                        $state.go('courseInfo', {enrollmentId: courseEnrollment.enrollmentId});
                    }
                  });
                }
              }
            });
            break;
          case '915':
            if (angular.isDefined($stateParams.threadId)) {
              $state.go('communityDiscussionZone.publicDiscussionZoneThread', {threadId: $stateParams.threadId});
            }else {
              if(angular.isDefined($stateParams.forumType)){
                if(parseInt($stateParams.forumType) === 0)
                  $state.go('communityDiscussionZone.publicDiscussionZone', {});
                else
                  $state.go('communityDiscussionZone.classesDiscussionZone', {});
              }else
                $state.go('communityDiscussionZone.publicDiscussionZone', {});
            }
            break;
        }
      }

    }]
  };

  angular.module('eHRD.modules.mailLink')
    .component('mailLinkProcess', mailLinkProcess);
})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.learningResource', []);

})();

/**
 * Created by Bruce on 2016/5/18.
 */

(function () {
  'use strict';

  function knowledgeManagementCenterService( Restangular) {

    /*
     * Build collection
     * api/learning-resource/folder/{ folderId }/userlist
     * ? keyword={ keyword }&sort={ sort }&order={ order }&current_page={ currentPage }&list_size={ listSize }
     */
    var _knowledgeManagementCenterService = Restangular.all('learning-resource');

    return{
      /*
       * Get list of samples
       */
      list: function (folderId, params) {
        /*
        *  GET /api/learning-resource/folder/{ folderId }/userlist
         * ? keyword={ keyword }&sort={ sort }&order={ order }&current_page={ currentPage }&list_size={ listSize }
        * */
        return _knowledgeManagementCenterService
          .one('folder', ( angular.isDefined(folderId) ? folderId : 'null' ))
          .getList('documents', params);
      },

      menuNodes: function (folderId) {
        // GET /api/sample
        return _knowledgeManagementCenterService
          .one('folder', ( angular.isDefined(folderId) ? folderId : 0 ))
          .getList('nodes',{limit_level:99});
      },

      newDocuments: function (params) {
        return _knowledgeManagementCenterService
          .one('folder', null)
          .getList('new-documents', params);
      },

      hotDocuments: function (params) {
        return _knowledgeManagementCenterService
          .one('folder', null)
          .getList('hot-documents', params);
      },

      setScore: function (docId,score) {
        // POST /api/learning-resource/document/{docId}/score/{score}
        return _knowledgeManagementCenterService
            .one('document',docId )
            .one('score',score )
            .put();
      },

      scoreInfo: function (docId) {
        //GET /api/learning-resource/document/{ docId }/info
        return _knowledgeManagementCenterService
            .one('document',docId)
            .customGET('info');
      }
    };

  }

  angular.module('eHRD.modules.learningResource')
    .factory('knowledgeManagementCenterService',knowledgeManagementCenterService)
    ;

})();

/**
 * Created by alan on 2016/10/26.
 */
(function () {
    'use strict';
    SetScoreController.$inject=['knowledgeManagementCenterService','$mdDialog','reload','docId','title'];
    function SetScoreController(knowledgeManagementCenterService,$mdDialog,reload,docId,title) {
        var vm  = this;
        vm.reload = reload;
        vm.docId = docId;
        vm.title = title;
        vm.average=false;
        vm.setScore = function (docId,score) {
            knowledgeManagementCenterService.setScore(docId,score).then(function () {
                vm.reload();
                $mdDialog.cancel();
            });
        }
        vm.getData = function () {
            knowledgeManagementCenterService.scoreInfo(vm.docId).then(function (scoreInfos) {
                vm.scoreInfos=scoreInfos;
                if(vm.scoreInfos.userScore==='')
                    vm.readOnly=false;
                else
                    vm.readOnly=true;
            });
        }

        vm.getData();

        vm.cancel = function () {
            $mdDialog.cancel();
        }
        vm.averageShow = function(){
            vm.average = (vm.average===true)?false:true;
        }

    }


    angular
        .module('eHRD.modules.learningResource')
        .controller('SetScoreController', SetScoreController)
    ;

})();
/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.courseResource', []);

})();

/**
 * Created by alan on 2016/10/26.
 */
(function () {
    'use strict';

    setScore.$inject = ['$mdDialog'];
    function setScore($mdDialog) {

        var directive ={
            restrict: 'EA',
            scope: {
                reload:'&?',
                docId:'=',
                title:'='
            },
            link:function(scope,element){
                element.on('click', function (ev) {
                    $mdDialog.show({
                        templateUrl: 'app/modules/learning-resource/views/set-score.html',
                        controller:'SetScoreController',
                        controllerAs:'SSC',
                        clickOutsideToClose:true,
                        targetEvent: ev,
                        locals:{
                            reload:scope.reload,
                            docId:scope.docId,
                            title:scope.title
                        },
                        fullscreen: true // Only for -xs, -sm breakpoints.
                    });
                })
            }
        };
        return directive;
    }


    angular.module('eHRD.modules.courseResource')
        .directive('setScore', setScore);
})();

/**
 * Created by Bruce on 2017/7/31.
 */

(function() {
  'use strict';

  var knowledgeDocument = {
    bindings: {
      catalogId: '=?catalogId',
      nodeId: '=?nodeId'
    },
    templateUrl: 'app/modules/learning-resource/views/knowledge-document-list.html',
    controller: ['$scope', 'sitemapService', 'knowledgeManagementCenterService', '$state', '$stateParams', '$filter', 'serverSetting', function($scope, sitemapService, knowledgeManagementCenterService, $state, $stateParams, $filter, serverSetting) {
      var vm = this;
      vm.isShowIndex = false;
      vm.isSearchMode = false;
      vm.isLoading = false;
      vm.catalogId = angular.isDefined(this.catalogId) ? parseInt(this.catalogId) : 0;
      vm.nodeId = angular.isDefined(this.nodeId) ? this.nodeId : undefined;
      if(vm.catalogId === 0 && angular.isUndefinedOrNull(vm.nodeId)) vm.isShowIndex = true;
      /**
       * Define initial value
       */
      var params = {};
      if(vm.isShowIndex){
        params = {keyword:""};
        vm.getData = function (params) {
          vm.params = params;
          if(angular.isUndefined(vm.params.keyword))
            vm.params.keyword='';
          if(vm.params.keyword!=='') {
            vm.isLoading = true;
            vm.sorts = [
              // {key : 'ModifiedDate', name:'FIELD.DATE'},
              // {key : 'LearningResourceEntries.avgScore', name:'ACTIONS.RATING'},
              // {key : 'LearningResourceEntries.clickCount', name:'FIELD.CLICK_COUNT'},
              // {key : 'LearningResourceEntries.Title', name:'FIELD.TITLE'}
              {key : 'ModifyDate', name:'FIELD.DATE'},
              {key : 'AvgScore', name:'ACTIONS.RATING'},
              {key : 'ClickCount', name:'FIELD.CLICK_COUNT'},
              {key : 'Title', name:'FIELD.TITLE'}
            ];
            knowledgeManagementCenterService.list(0, params).then(function(data) {
              vm.isSearchMode = true;
              vm.KnowledgeManagementCenterDatas = data.metadata.fullTextSearchData;
              vm.menulist = data.metadata.menulist;
              vm.pagination = data.metadata.pagination;
              sitemapService.getSiteMapNodes().walk(function (node) {
                if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
                  if(vm.menulist.length > 0 && parseInt(vm.menulist[0].id) === parseInt(node.model.stateParams['cid'])){
                    vm.menulist[0].title = node.model.title;
                  }
                }
                else {
                  if(angular.isUndefinedOrNull(vm.mainMenu) && node.model.state === 'courseResourceCatalog') {
                    if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === vm.catalogId){
                      if(vm.menulist.length > 0 && vm.menulist[0].id === node.model.stateParams['cid']){
                        vm.menulist[0].title = node.model.title;
                      }
                    }
                  }
                }
              });
              vm.learningResourceBreadcrumb = $filter('stringToBreadcrumb')(vm.menulist, 'sitemap-breadcrumb');
              $state.current._ncyBreadcrumbLabel = vm.learningResourceBreadcrumb;
              vm.learningResourceTitle = $filter('stringToBreadcrumb')(vm.menulist, 'text');
              vm.isLoading = false;
            });
          }
          else{
            vm.isSearchMode = false;
            var size = 4;
            vm.sorts = [];
            knowledgeManagementCenterService.newDocuments({'size': size}).then(function(data){
              vm.newDocumentsDatas = data;
              angular.element("html, body").animate({
                scrollTop: 0
              },200);
            });
            knowledgeManagementCenterService.hotDocuments( {'size': size}).then(function(data){
              vm.hotDocumentsDatas = data;
              angular.element("html, body").animate({
                scrollTop: 0
              },200);
            });
          }
        };
      }else {
        vm.getData = function (params) {
          vm.isLoading = false;
          var folderId = (angular.isDefined(vm.nodeId)? vm.nodeId : vm.catalogId);
          vm.params = params;
          vm.externalUrl = serverSetting.baseConfig.baseURL + '/learning-resource-doc-folder.do';
          vm.extenralRootUrl = serverSetting.baseConfig.baseURL + '/learning-resource-doc-list-search-result.do';
          if(angular.isUndefined(vm.params.keyword)){
            vm.params.keyword='';
          }
          vm.menulist = [];
          knowledgeManagementCenterService.list(folderId, params).then(function(data){
            if(!!params.keyword) {
              vm.isSearchMode = true;
              vm.KnowledgeManagementCenterDatas = data.metadata.fullTextSearchData;
            }else{
              vm.isSearchMode = false;
              vm.KnowledgeManagementCenterDatas = data;
            }
            vm.pagination = data.metadata.pagination;
            if(parseInt(vm.catalogId) === 0) {
              sitemapService.getSiteMapNodes().walk(function (node) {
                if (node.model.state === $state.current.name){
                  if(angular.equals(node.model.stateParams['mid'], $state.params['mid'])) {
                    vm.menulist.push({
                      id: node.getPath()[node.getPath().length - 1].model.stateParams['cid'],
                      isCWSubCh: false,
                      isEMBA: false,
                      isHBR: false,
                      title: node.getPath()[node.getPath().length - 1].model.title
                    });
                  }
                }
              });
            }

            vm.menulist = vm.menulist.concat(data.metadata.menulist);
            vm.lastMenulist = data.metadata.menulist[data.metadata.menulist.length-1];
            sitemapService.getSiteMapNodes().walk(function (node) {
              if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
                if(vm.menulist.length > 0 && parseInt(vm.menulist[0].id) === parseInt(node.model.stateParams['cid'])){
                  vm.menulist[0].title = node.model.title;
                }
              }
              else {
                if(angular.isUndefinedOrNull(vm.mainMenu) && node.model.state === 'courseResourceCatalog') {
                  if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === vm.catalogId){
                    if(vm.menulist.length > 0 && vm.menulist[0].id === node.model.stateParams['cid']){
                      vm.menulist[0].title = node.model.title;
                    }
                  }
                }
              }
            });
            vm.learningResourceBreadcrumb = $filter('stringToBreadcrumb')(vm.menulist, 'sitemap-breadcrumb');
            $state.current._ncyBreadcrumbLabel = vm.learningResourceBreadcrumb;
            vm.learningResourceTitle = $filter('stringToBreadcrumb')(vm.menulist, 'text');
            vm.isLoading = false;

            angular.element("html, body").animate({
              scrollTop: 0
            },200);
          });
        };
      }
      vm.getData(params);
    }]
  };

  angular.module('eHRD.modules.learningResource')
    .component('knowledgeDocument', knowledgeDocument);
})();

/**
 * Created by Bruce on 2017/7/31.
 */

(function() {
  'use strict';

  var knowledgeDocumentMenu = {
    bindings: {
      catalogId: '=?catalogId',
      nodeId: '=?nodeId'
    },
    templateUrl: 'app/modules/learning-resource/views/knowledge-document-menu.html',
    controller: [ 'knowledgeManagementCenterService', '$state', '$filter', 'serverSetting', 'sitemapService', function(knowledgeManagementCenterService, $state, $filter, serverSetting, sitemapService) {
      var vm = this;
      vm.catalogId = angular.isDefined(this.catalogId) ? this.catalogId : 0;
      vm.previousMenu = undefined;
      vm.mainMenu = undefined;

      vm.process = function() {
        sitemapService.getSiteMapNodes().walk(function (node) {
          if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
            vm.mainMenu = node.model;
            if ((node.getPath().length -2) > 0 && angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams) &&
              angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams['url']) &&
              node.getPath()[(node.getPath().length -2)].model.stateParams['url'].length > 0) {
              vm.previousMenu = node.getPath()[(node.getPath().length -2)];
            }
          }else {
            if(angular.isUndefinedOrNull(vm.mainMenu) && node.model.state === 'knowledgeDocumentCatalog') {
              if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === vm.catalogId){
                vm.mainMenu = node.model;
                if ((node.getPath().length -2) > 0 && angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams) &&
                  angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams['url']) &&
                  node.getPath()[(node.getPath().length -2)].model.stateParams['url'].length > 0) {
                  vm.previousMenu = node.getPath()[(node.getPath().length -2)];
                }
              }

            }
          }
        });

        if(!vm.previousMenu) {
          sitemapService.getSiteMapNodes().walk(function (node) {
            if(node.model.state === 'index') {
              vm.previousMenu = node;
            }
          });
        }
      };

      vm.toggleNode = function(node) {
        node.showChildren = node.showChildren ? false : true;
      };      

      if(sitemapService.getMenu().length > 0) {
        vm.process();
      } else {
        sitemapService.getProjectSideMenu().then(function (menuItems) {
          sitemapService.setMenu(menuItems);
          vm.process();
        });
      }


      knowledgeManagementCenterService.menuNodes(vm.catalogId).then(function (data) {
        vm.menu = data.map(function(node) {
          node.showChildren = false;
          return node;
        });
      });

    }]
  };

  angular.module('eHRD.modules.learningResource')
    .component('knowledgeDocumentMenu', knowledgeDocumentMenu);
})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  local.$inject = ['$translateProvider', 'systemConstantZhTW', 'messageConstantZhTW', 'httpErrorCodeConstantZhTW', 'formValidationConstantZhTW', 'actionsConstantZhTW', 'statusConstantZhTW'];
  function local($translateProvider, systemConstant, messageConstant, httpErrorCodeConstant, formValidationConstant, actionsConstant, statusConstant) {
    $translateProvider.translations('zh-tw', {
      "PDP": {
        "AGREE": "同意",
        "DISAGREE": "不同意",
        "NEXT": "下一步",
        "STAGE_DECLARE_TITLE": "電子簽章法同意確認",
        "STAGE_DECLARE_PHRASE1": "歡迎您使用教育訓練平台服務，當您使用本平台時，表示您同意以電子文件方式為表示方法，並同意<a href='http://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=J0080037' target='_blank'>電子簽章法</a>之規定。",
        "STAGE_DECLARE_PHRASE2": "如果您不同意以本服務條款之內容，您應立即停止使用本服務。",
        "STAGE_SERVICE_TITLE": "個人服務條款",
        "STAGE_DISAGREE_PHRASE1": "因為您目前不同意本系統的服務條款說明，故暫時無法使用本網站服務。",
        "STAGE_DISAGREE_PHRASE2": "若針對本平台使用個人資料上有任何問題，請與平台管理者聯絡。"
      },
      "FILE_SIZE_ERROR": "檔案大小超過{{value}}無法上傳",
      "FILE_TYPE_ERROR": "不支援的檔案格式 .{{value}}",
      "LANGUAGE":"語系",
      "LANGUAGE_EN":"English",
      "LANGUAGE_TW":"繁體中文",
      "LANGUAGE_CN":"简体中文",
      "LEARNING_DASHBOARD": "學習儀表板",
      "INCOMPLETE_COURSES": "待修課程",
      "ENROLLMENT": "待修課程",
      "TEST_QUESTIONNAIRE_CENTER": "測驗問卷中心",
      "APPROVE_RECORDS": "簽核紀錄查詢",
      "TRAINING_RECORDS": "訓練紀錄查詢",
      "COMMUNITY_DISCUSSION_ZONE":"社群討論區",
      "PUBLIC_DISCUSSION_ZONE": "公共討論區",
      "CLASSES_DISCUSSION_ZONE": "班次討論區",
      "INDEX": "首頁",
      "MY_CURRICULUM": "我的課表",
      "KNOWLEDGE_MANAGEMENT_CENTER": "知識管理中心",
      "REPORTS_ZONE":"報表專區",
      "LEARNING_REPORTS":"學習報表",
      "SUPERVISOR_ZONE":"主管專區",
      "DEPARTMENT_DASHBOARD": "部門儀表板",
      "TRAINING_APPROVE": "訓練待簽表單簽核",
      "TRAINING_APPROVE_RECORDS_SEARCH": "訓練簽核紀錄查詢",
      "MEMBER_CURRICULUM": "成員課表查詢",
      "MEMBER_TRAINING_RECORDS": "成員修課紀錄查詢",
      "LEARNING_PASSPORT": "我的學習護照",
      "MY_CALENDAR": "我的行事曆",
      "MY_SETTING": "我的設定",
      "COURSE_LEARNING_RESOURCE": "課程與學習資源",
      "EXTERNAL_TRAINING_ZONE": "外訓專區",
      "EXTERNAL_TRAINING_APPLY": "外訓申請",
      "EXTERNAL_TRAINING_APPLY_FORM": "外訓申請表單",
      "EDIT_EXTERNAL_TRAINING_APPLY_FORM": "編輯外訓申請表單",
      "VIEW_EXTERNAL_TRAINING_APPLY_FORM": "檢視外訓申請表單",
      "EXTERNAL_TRAINING_BULLETIN": "外訓公佈欄",
      "EXTERNAL_TRAINING_APPLY_RECORDS": "外訓申請紀錄",
      "COURSES_INFO": "課程資訊",
      "PROGRAM_INFO": "學程資訊",
      "CERTIFICATE_INFO": "證照資訊",
      "PROGRAM_INFO_DETAIL": "學程資料明細",
      "PREREQUISITE_ITEMS": "先修項目",
      "COURSE_CONTAIN": "包含課程",
      "GET_THE_PROCESS": "取得流程",
      "EXTEND_THE_PROCESS": "展期流程",
      "CERTIFICATE_INFO_DETAIL": "證照資料明細",
      "LEARNING_IS_TO_WALK_IN_THE_RIGHT_DIRECTION": "學習是為了走對方向",
      "LEARNING_IS_TO_BREAK_THROUGH_THEIR_OWN": "學習是為了突破自己",
      "MEMBER_SUGGEST_LEARNING_LIST": "成員建議學習項目查詢",
      "SUGGEST_LEARNING_LIST": "建議學習項目",
      "TRAINING_ROAD_MAP": "訓練藍圖",
      "NEED_GET_PREREQUISITE_ITEMS": "必須先取得證照",
      "TRAINING_PLAN": "訓練計畫",
      "CERT_ZONE":"證照專區",
      "EXTERNAL_CERT_REGISTER": "外部證照登錄",
      "EXTERNAL_CERT_EXAM_APPLICATION": "外部證照考試申請",
      "EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION": "外部證照考試補助申請",
      "EXTERNAL_CERT_QUALIFY_REWARD_APPLICATION": "外部證照合格獎勵申請",
      "EXTERNAL_CERT_APPLICATION_RECORDS_SEARCH": "外部證照申請紀錄查詢",
      "CERT_RECORDS_SEARCH": "證照紀錄查詢",
      "TRAINING_PROGRAM_PLANNING": "訓練計畫規劃",
      "YOU_MUST_FIRST_OBTAIN_A_CERTIFIED_SUBJECT": "必須先取得認證科目",
      "NEWLY_OBTAIN_THIS_CERTIFIED_SUBJECT_CONDITION": "新取得此認證科目條件",
      "EXPIRED_AFTER_REACQUISITION_OF_THIS_CERTIFIED_SUBJECT_CONDITION": "過期後重新取得此認證科目條件",
      "SATISFY_OF_ANY_CONDITION_TO_OBTAIN_A_CERTIFICATE": "滿足以下任一條件即可取得證照",
      "FINANCIAL_CERT_RECORD_APPLICATION": "金融證照記錄申請",
      "FINANCIAL_CERT_RECORD_SEARCH": "金融證照記錄查詢",
      "MEMBER_FINANCIAL_CERT_RECORD_SEARCH": "成員金融證照記錄查詢",
      "MEMBER_CERT_RECORDS_SEARCH": "成員證照記錄查詢",
      "COMPETENCY_ZONE": "職能專區",
      "COMPETENCY_EVALUATION_SUPERVISOR_REPORT": "職能評鑑主管報表",
      "DEPARTMENT_DROP_ANALYSIS": "部門落差分析",
      "MEMBER_DROP_ANALYSIS": "人員落差分析",
      "COMPANY_COMPETENCY_DEFINITION": "全公司職能定義",
      "CORE_COMPETENCY": "核心職能",
      "MANAGE_COMPETENCY": "管理職能",
      "PROFESSION_COMPETENCY": "專業職能",
      "PERSONAL_EVALUATION_LIST": "個人評鑑清單",
      "COMPETENCY_EVALUATION_PERSONAL_REPORT": "職能評鑑個人報表",
      "PERSONAL_DROP_ANALYSIS": "個人落差分析",
      "PLACEHOLDERS": {
        "PLEASE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD":"請輸入您的帳號及密碼",
        "SEARCH_COURSE_RESOURCE": "搜尋課程與學習資源",
        "YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED_TO_CANCEL_THE_REGISTRATION": "你可以送出訊息給被指定取消報名的學員。",
        "YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED": "你可以送出訊息給被指定的學員。",
        "CAN_CANCEL_THE_REGISTRATION_OF_STUDENTS": "可取消報名的學員",
        "PLEASE_ENTER_THE_STUDENT_NAME": "請輸入學員姓名",
        "PLEASE_ENTER_THE_NUMBER_OF_DAYS": "請輸入天數",
        "PLEASE_SELECT_DATE": "請選擇日期",
        "QUESTION_FILLING": "填充",
        "TOTAL_OF_QUESTIONS": "題數 : 總共 <span>{{value}}</span> 題",
        // #add by w3c, #87169  start
        "TOTAL_OF_GRADE_QUESTIONS": "答對 <span>{{value}}</span> 題",
        "TOTAL_OF_WRONG_QUESTIONS": "答錯 <span>{{value}}</span> 題",
        "MANUAL_GRADE_QUESTTIONS": "尚未評分(問答題)",
        // #add by w3c, #87169  end
        "THE_PAPER_WILL_BE_PUBLISHED": "試卷將於，{{value}}，後公佈(請至修課摘要頁查詢)",
        "N_PERSON_LEARNING": "{{value}} 人學習",
        "N_PERSON_FINISH_COURSE": "{{value}} 人完成課程",
        "PLEASE_ENTER_YOUR_OLD_PASSWORD": "請輸入您的舊密碼",
        "PLEASE_ENTER_YOUR_NEW_PASSWORD": "請輸入您的新密碼",
        "PLEASE_RECONFIRM_YOUR_NEW_PASSWORD": "請再次輸入新密碼",
        "PLEASE_ENTER_TEXT": "請輸入文字",
        "SELECT_VENDOR": "選擇主辦單位",
        "ENTER_AMOUNT": "輸入金額",
        "NT_CONVERSION": "台幣換算金額",
        "REASON_OF_LEAVE": "請假原因",
        "PLEASE_FILL_IN_INTERNAL_LECTURE_SCORE": "請填寫內部講授分數",
        "PLEASE_FILL_IN_OTHER_METHOD_REPORT_SCORE": "請填寫其他方式報告分數",
        "PLEASE_FILL_IN_ORAL_REPORT_SCORE": "請填寫口頭報告分數",
        "WEEK_W_OF_Y": "{{year}}年第{{week}}週 ",
        "PLEASE_SELECT_TRAINING_BLUEPRINT": "請選擇訓練藍圖",
        "FOR_LESS_THAN_N_THE_FOLLOWING_REPORTS_ARE_NOT_REQUIRED": "低於 {{value}} 元則無需下列報告",
        "PLEASE_SELECT_A_CATEGORY": "請選擇類別",
        "SEARCH_FOR_A_VENDORS": "查詢單位",
        "PLEASE_ENTER_KEYWORDS": "請輸入關鍵字",
        "CONVERSION_AMOUNT": "換算金額",
        "PLEASE_ENTER_DEPARTMENT_NAME": "請輸入部門名稱"
      },

      "SYSTEM": systemConstant,

      "FIELD": {
        "COURSE.RESOURCE.TYPE.MATERIAL": "教材",
        "COURSE.RESOURCE.TYPE.INSTRUCTOR": "講師",
        "COURSE.RESOURCE.TYPE.VENUE": "場地",
        "COURSE.RESOURCE.TYPE.FACILITY": "設備",
        "COURSE.RESOURCE.TYPE.EXT_VENDOR": "外訓廠商",
        "APPELLATION": "名稱",
        "TRACK_QUESTIONNAIRE": "追蹤問卷",
        "SURVEYBANK_GROUP_MATERIAL": "教材",
        "TABLE_HEADER_INSTRUCTOR": "講師",
        "VENUE": "場地",
        "FACILITY": "設備",
        "ATTENDANCE_RECORD": "出缺席記錄",
        "ATTENDANCE_RATE": "出席率",
        "ATTENDANCE_STATISTIC": "出席狀況",
        "TOTAL_ITEM": "總共<span class='text-danger'>{{value}}</span>項",
        "COMPLETE_ITEM": "完成<span class='text-danger'>{{value}}</span>項",
        "LEARNING_ITEM": "學習項目",
        "LEARNING_HISTORY": "學習歷程",
        "DOCUMENT_TITLE": "文件標題",
        "DOWNLOAD_TIME": "下載時間",
        "COURSE_CONTENT": "課程內容",
        "EXEMPTION_REASON": "免修原因 ",
        "EVER_ENROLLED_COURSE": "已修過相關課程",
        "EVER_ENROLLED_CERTIFICATION": "已領有相關外部證照",
        "EVER_ENROLLED_INNER_CERTIFICATION": "已領有相關內部證照",
        "CERTIFICATION_NAME": "證照名稱",
        "PROFESSIONAL_KNOWLEDGE": "專業知識",
        "TECHNICAL_OPERATION": "技術操作",
        "WORK_ATTITUDE": "工作態度",
        "COMMUNICATION": "人際溝通",
        "DEPUTY_DEPARTMENT": "被代理的部門",
        "SETTING_DATE":"設定日期",
        "DEPUTY": "代理人",
        "SETTING_DEPUTY": "設定簽核代理人",
        "DEPUTY_EFFECTIVE_DATE":"代理生效日",
        "DEPUTY_END_DATE":"代理結束日",
        "MY_DEPUTY_SETTING": "簽核代理人設定",
        "LIST_OF_UNEXPIRED_COURSE_TO_BE_EXPIRED": "即將到期課程未完訓名單",
        "DEPARTMENT_MEMBERS_FOR_THE_YEAR": "當年度轄下部門",
        "AVERAGE_TRAINING_HOURS": "平均訓練時數",
        "MONTHLY_ACCUMULATED_TRAINING_COSTS": "各月份累積訓練費用",
        "COMPLETION_RATE_OF_DEPARTMENT_MEMBERS": "轄下同仁完訓率",
        "ATTENDANCE_RATE_OF_DEPARTMENT_MEMBERS": "轄下同仁出席率",
        "CUMULATIVE_TRAINING_COSTS": "累積訓練費用",
        "COMPANY_AVERAGE": "公司平均",
        "DEPARTMENT_EVERYONE_AVERAGE": "部門每人平均",
		"COMPANY_TOTAL_COSTS": "公司累積",
		"CUMULATIVE_TRAINING_COSTS_OF_DEPARTMENT_GROUPS": "轄下部門累積訓練費用",
        "SEARCH_THIS_AND_SUB_CATEGORIES": "搜尋本目錄及子目錄",
        "EXTERNAL_TRAINING_WEBSITE": "外訓課程網址",
        "TIME": "時間",
        "LEAVE_TIME": "請假時間",
        "SELECT_LEAVE_TIME": "選擇請假時間",
        "COURSE_NOT_ATTENDED_REASON": "未出席原因",
        "CLASS_HOUR": "上課時數",
        "OTHER_METHOD": "其他方式",
        "INTERNAL_LECTURE":"內部講授",
        "SCORE_TO_BE_APPROVED": "需簽核評分",
        "ORAL_REPORT":"口頭報告",
        "LECTURE_DEADLINE":"講授期限",
        "SUBMIT_DEADLINE":"繳交期限",
        "REPORT_DEADLINE":"報告期限",
        "NEED_TO_SUBMIT":"需繳交",
        "UPLOAD_REPORT":"上傳報告",
        "NO_REPORT":"無需報告",
        "NEED_TO_COMPLETE_REPORT":"須完成下列報告",
        "CURRENCY": "貨幣",
        "AMOUNT": "金額",
        "SYSTEM_CURRENCY": "系統幣別",
        "TYPE_OF_SUBSIDY": "補助方式",
        "FULL": "全額",
        "SUBSIDY": "補助",
        "VOUCHER": "憑證",
        "TAXABLE_INVOICE": "應稅發票",
        "TAX_FREE_INVOICE": "未稅發票",
        "RECEIPT": "收據",
        "PAYMENT_DATE": "預定付款日期",
        "HIDDEN_COST_INFORMATION": "隱藏費用資訊",
        "SELECT_VENDOR": "選擇主辦單位",
        "ENROLLMENT_COST": "報名費用",
        "COURSE_COST": "課程費用",
        "COURSE_DETAIL": "課程詳細資訊",
        "FREE_COURSE": "免費課程",
        "PAY_COURSE": "付費課程",
        "KNOWLEDGE_MANAGEMENT_CENTER": "知識管理中心",
        "COURSE_DESCRIPTION":"課程說明",
        "REMARK": "備註",
        "CYCLE_MODE": "循環模式",
        "REPEAT_INTERVAL": "重複間隔",
        "WEEK": "週",
        "MONTH": "月",
        "YEAR": "年",
        "MONDAY": "星期一",
        "TUESDAY": "星期二",
        "WEDNESDAY": "星期三",
        "THURSDAY": "星期四",
        "FRIDAY": "星期五",
        "SATURDAY": "星期六",
        "SUNDAY": "星期日",
        "JANUARY": "一月",
        "FEBRUARY": "二月",
        "MARCH": "三月",
        "APRIL": "四月",
        "MAY": "五月",
        "JUNE": "六月",
        "JULY": "七月",
        "AUGUST": "八月",
        "SEPTEMBER": "九月",
        "OCTOBER": "十月",
        "NOVEMBER": "十一月",
        "DECEMBER": "十二月",
        "VENDOR": "主辦單位",
        "DOMESTIC": "國內",
        "ABROAD": "國外",
        "MULTIPLE_SELECT": "可複選",
        "JOIN_REASON": "參加理由",
        "TEACH_DEADLINE": "講授期限",
        "REST_TIME": "休息時間",
        "SETTING_CYCLE_WEEK": "設定循環週期",
        "TRAINING_NATURE": "訓練性質",
        "ASSIGNED_BY_MANAGER": "主管指派",
        "PERSONAL_REQUESTS": "個人需求",
        "TRUE": "是",
        "FALSE": "否",
        "UPLOAD_COURSE_DATA": "上傳課程資料",
        "UPLOAD_REFERENCE_FILE": "上傳參考文件",
        "ENROLLMENT_INFORMATION": "報名資訊",
        "ENROLLMENT_WEBSITE": "報名網址",
        "NO_INFORMATION": "暫無資料",
        "TRAINING_HOURS_IN_THE_QUARTER": "第{{value}}季累計訓練時數(通過)",
        "TRAINING_HOURS_IN_THE_YEAR": "年累計訓練時數(通過)",
        "AVERAGE_TRAINING_HOURS_OF_COMPANY": "全公司平均訓練時數(通過)",
        "TRAINING_BLUEPRINT_PROGRESS": "訓練藍圖進度",
        "INCOMPLETE_ITEM": "未完成項目",
        "INTERNAL_CERTIFICATION_PROGRESS": "內部證照取得進度",
        "PERFORM_LATEST_NEWS": "平台最新動態",
        "MY_LEARNING_RESUME": "我的學習履歷",
        "LOGIN_PLATFORM": "登入平台",
        "LEARNING_COURSE": "閱讀課程",
        "FILE_IN_ONLINE_QUESTIONNAIRE": "填寫問卷",
        "FILE_IN_ONLINE_TEST": "填寫測驗",
        "FILE_IN_QUESTIONNAIRE": "填寫問卷",
        "FILE_IN_TEST": "填寫測驗",
        "LEARNING_KNOWLEDGE_DOCUMENT_CENTER": "點閱知識文件中心",
        "VIEW_DOCUMENT_CENTER": "瀏覽文件中心",
        "FORUM_PUBLISHED_ARTICLE": "討論區發表文章",
        "ENROLLMENT_COURSE": "報名課程",
        "CANCEL_COURSE": "取消報名",
        "ONLINE_COURSE_LEARNING_TIME_CURVE": "線上課程學習時數曲線圖",
        "LEARNING_HOURS": "學習時數",
        "SIX_MONTH": "近六個月",
        "DISTRIBUTION_MAP_OF_COURSES_IN_EACH_CATEGORY": "各類別課程修課分布圖",
        "TOTAL_OF_ONLINE_COURSE_LEARNING_HOURS": "線上課程累計<span>閱讀時數</span>",
        "CUMULATIVE_OF_PASSED_COURSES": "累計通過<span>課程數</span>",
        "TOTAL_OF_CERTIFICATION": "取得<span>證照總數</span>",
        "CUMULATIVE_OF_TRAINING_COSTS_FOR_THE_YEAR": "當年度外訓<span>費用累計</span>",
        "PENDING_APPROVALS": "待簽表單",
        "APPROVE_PROCESS": "簽核流程",
        "APPROVE_DETAIL": "簽核詳細資訊",
        "APPROVE_RECORD": "簽核紀錄",
        "APPLY_COSTS": "本次申請費用",
        "STUDENT_TRAINING_COSTS_HAVE_OCCURRED": "已發生學生訓練費用",
        "DEPARTMENT_TRAINING_COSTS_HAVE_OCCURRED": "已發生部門訓練費用",
        "KEYWORD": "關鍵字",
        "DEPARTMENT_NAME": "部門名稱",
        "DEPARTMENT_MEMBER": "部門成員",
        "DEPARTMENT_MEMBERS": "轄下同仁",
        "LEARNING_ACTIVITY": "學習活動",
        "LEARNING_ACTIVITY_STATUS": "學習活動狀態",
        "SEARCH_COURSE_NAME": "搜尋課程名稱",
        "SELECT_SEARCH_FILTER": "選擇搜尋條件",
        "PLEASE_RATING": "請評分",
        "START_DATE": "開始日期",
        "END_DATE": "結束日期",
        "COURSE_START_DATE": "上課開始日期",
        "AUTHOR": "作者",
        "LOCATION": "位置",
        "ROOT_DIRECTORY": "總目錄",
        "CLICK_COUNT": "點閱次數",
        "DOWNLOAD_COUNT": "下載次數",
        "DOWNLOAD_COUNT_DETAIL": "下載次數明細",
        "I_WANT": "我要",
        "AVERAGE_RATING": "平均評分",
        "SHARE_DATE": "分享日期",
        "HOT_DOCUMENT": "熱門文件",
        "TITLE": "標題",
        "TYPE": "類型",
        "APPLICANT": "申請人",
        "APPLICANT_DEPARTMENT": "申請人部門",
        "APPLY_DATE": "申請日期",
        "ARRIVAL_DATE": "送達日期",
        "APPLY_START_DATE" :"申請開始日期",
        "APPLY_END_DATE" :"申請結束日期",
        "APPROVER" :"簽核人",
        "LEARNING_CATEGORY": "學習目錄",
        "ENROLLMENT_TIME": "修課時間",
        "COURSE_DATE": "上課日期",
        "HOURS": "時數",
        "TIME_OF_HOURS": "時數(小時)",
        "HOUR": "小時",
        "ENROLLMENT_HOURS": "修課時數",
        "PASS_STATUS": "通過狀態",
        "COST": "費用",
        "TEST_SCORE": "測驗成績",
        "LEARNING_REPORT": "學習報告",
        "ENROLLMENT_NUMBER_OF_PEOPLE": "修課人數",
        "DOWNLOAD_NUMBER_OF_PEOPLE": "下載人數",
        "INCOMPLETED_NUMBER_OF_PEOPLE": "未完成人數",
        "EXEMPTION_NUMBER_OF_PEOPLE": "免修人數",
        "EXEMPTION": "免修",
        "APPLY_FOR_EXEMPTION": "免修申請",
        "PASSED_NUMBER_OF_PEOPLE": "通過人數",
        "FAILED_NUMBER_OF_PEOPLE": "未通過人數",
        "DROP_NUMBER_OF_PEOPLE": "退選人數",
        "LEARNER_SATISFACTION":"學員總體滿意度",
        "MANAGER_SATISFACTION":"管理員總體滿意度",
        "PASSED_COUNT": "通過數",
        "EXEMPTION_COUNT": "免修數",
        "TOTAL": "總數",
        "ENROLLMENT_STATUS": "修課狀態",
        "CURRENT_PROCESS": "目前流程",
        "CHANGE_PASSWORD": "變更密碼",
        "INIT_PWD_PLEASE_CHANGE_PWD_PROMPT": "此密碼為系統預設密碼，請先更改密碼",
        "CHANGE_LOGIN_PASSWORD": "變更登入密碼",
        "TEST_QUESTIONNAIRE": "測驗問卷",
        "ALL_COURSE": "全部課程",
        "LATEST_COURSE": "最新課程",
        "HOT_COURSE": "熱門課程",
        "FEATURED_COURSE": "精選課程",
        "LATEST_NEWS": "最新公告",
        "ONLINE_COURSE_LEADERBOARD": "線上課程排行榜",
        "LATEST_DOCUMENT": "最新文件",
        "RELATED_SITES": "相關網站",
        "USERNAME": "使用者名稱",
        "USER_ACCOUNT": "使用者帳號",
        "ACCOUNT": "帳號",
        "NAME": "名字",
        "LAST_NAME": "姓氏",
        "PASSWORD":"密碼",
        "ACTION": "動作",
        "ALL": "全部",
        "ORDER": "順序",
        "PASSED_DATE": "通過日期",
        "SPECIFIC": "特定",
        "PROGRAM": "學程",
        "COURSE": "課程",
        "LIVE": "直播",
        "NO_LIVE_BROADCAST_YET": "直播尚未開始",
        "LIVE_NOW": "進入直播課程",
        "LIVE_END": "直播完畢",
        "LIVE_VIDEO": "直播完(VOD)",
        "NO_LIVE": "無法直播",
        "LIVE_NO_VIDEO": "直播完(沒VOD)",
        "NO_LIVE_CLASS": "本班次尚未直播",
        "LECTURER_SETTING_TIME_WRONG": "講師設定時間錯誤",
        "U_NO_LIVE": "U沒有直播",
        "CTMS_SERVER_LIVE_ERROR": "CTMS錯誤",
        "U_SERVER_LIVE_ERROR": "U直播錯誤",
        "OTHER_LIVE_ERROR": "其他錯誤",
        "ONLINE_COURSE": "線上課程",
        "CLASS_ROOM_COURSE": "教室課程",
        "EXTERNAL_TRAINING": "外訓",
        "INTERNAL_TRAINING": "內訓",
        "INTERNAL": "內部",
        "EXTERNAL": "外部",
        "ONLINE_TEST": "線上測驗",
        "CLASS_ROOM_TEST": "教室測驗",
        "TEST": "測驗",
        "QUESTIONNAIRE": "問卷",
        "INTERNAL_LICENSE": "內部證照",
        "EXTERNAL_LICENSE": "外部證照",
        "MY_FAVOURITE": "我的最愛",
        "ABOUT_THIS_COURSE": "關於本課程",
        "ABOUT_THIS_PROGRAM": "關於本學程",
        "ABOUT_THIS_CERTIFICATE": "關於本證照",
        "TOTAL_NUMBER_OF_CLASSES": "累計上課人數",
        "COURSE_NAME": "課程名稱",
        "PROGRAM_NAME": "學程名稱",
        "COURSE_INFO_DETAIL": "課程資料明細",
        "COURSE_INFO": "課程資訊",
        "SESSION": "班次",
        "SESSION_NAME": "班次名稱",
        "SESSION_INFO": "班次資訊",
        "CLASS_TIME": "上課時間",
        "ENROLL_DEADLINE": "報名期限",
        "TEST_DEADLINE": "測驗期限",
        "VIEW_DEADLINE": "觀看期限",
        "FILL_IN_DEADLINE": "填寫期限",
        "LAST_PLAYER": "上次播放至",
        "ENROLLMENT_INFO": "修課資訊",
        "REFERENCE_DOCUMENT": "參考文件",
        "REFERENCE_COURSE": "參考課程",
        "COURSE_TYPE": "課程類型",
        "INSTRUCTOR": "講師",
        "EVENT_LOCATION": "活動地點",
        "NUMBER_OF_PEOPLE": "人數",
        "ENROLL_NUMBER_OF_PEOPLE": "報名人數",
        "ENROLL_TYPE": "報名方式",
        "REMAINING_AMOUNT" : "尚餘名額",
        "NO_UPPER_LIMIT": "沒有上限",
        "PENDING_PREDETERMINED_COST": "預估每人費用",
        "COURSE_ATTRIBUTES": "課程屬性",
        "COURSE_INTRODUCTION": "課程簡介",
        "PROGRAM_INTRODUCTION": "學程簡介",
        "COURSE_OUTLINE": "課程大綱",
        "LEARNING_GOAL": "學習目標",
        "UNDERSTANDING": "了解",
        "THROUGH_THE_RULES": "通過規則",
        "APPLY_STATUS": "申請狀態",
        "SUITABLE_FOR_THE_OBJECT": "適合對象",
        "SUITABLE_FOR_LEVEL": "適合層級",
        "PREPARATORY_KNOWLEDGE": "預備知識",
        "DIFFICULTY": "難度",
        "DURATION": "長度",
        "PROPERTIES": "必選修",
        "COURSE_ELECTIVE": "選修",
        "COURSE_REQUIRED": "必修",
        "IS_WILL_EXPIRE": "即將到期",
        "LAST_LEARNING_DATE": "最後學習日",
        //#Add by w3c, #89088  start
        "DUE_DATE": "修習期限",
        //#Add by w3c, #89088  end
        "OVERALL_RESULT": "總成績",
        "ENROLL_MANAGER": "報名管理",
        "ASSIGNABLE_MEMBER_ENROLL": "指定成員報名",
        "ASSIGNABLE_MEMBER_ALTERNATE": "指定成員候補",
        "UN_ASSIGNABLE_MEMBER_ENROLL": "取消成員報名",
        "ASSIGNABLE_STATUS": "指定的狀態",
        "ASSIGNER": "指定者",
        "CLASSMATE": "同班同學",
        "FORUM": "討論區",
        "DESCRIPTION": "說明",
        "CREATE_DATE": "建立日期",
        "DATE": "日期",
        "BASIC_INFORMATION": "基本資料",
        "OTHER": "其他",
        "NOTHING": "無",
        "FULL_NAME": "姓名",
        "EMPLOYEE_NUMBER": "員工編號",
        "DEPARTMENT": "部門",
        "JOB_TITLE": "職稱",
        "EMAIL": "電子郵件",
        "OFFICE_PHONE": "辦公室電話",
        "ADD_DATE": "新增日期",
        "TOTAL_ENROLLMENT_COUNT": "總修課數",
        "REASON": "理由",
        "DUTY_DAY": "到職日",
        "GRADE_NAME": "職等",
        "DUTY_CODE": "職務代碼",
        "ADD_LEARNER": "新增學員",
        "SELFENROLLED": "自行報名",
        "ASSIGNED": "指定報名",
        "COURSE_DEADLINE": "課程到期日",
        "DIRECTLY_SPECIFY_DEADLINES": "直接指定期限",
        "UNLIMITED": "無限制",
        "LEARNING_CENTER": "學習中心",
        "COURSE_LIST": "課程清單",
        "LEARNING_RESULT": "學習成果",
        "MINIMUM_VIEWING_TIME": "最低觀看時間",
        "VIEWING_TIME": "觀看時間",
        "COURSE_TIME": "課程時間",
        "FINISH_TIME": "完成時間",
        "SELECTED": "已選擇",
        "FILES": "檔案",
        "LIST_ALL_SUBORDINATE_MEMBERS": "列出所有直屬部屬",
        "LIST_MY_GROUP_MEMBERS": "列出同部門同仁",
        "YOU_HAVE_SELECTED_MEMBERS": "您已選擇以下指定人員",
        "EXECUTION_DATE": "指定報名生效日",
        "DAYS": "天",
        "AFTER_THE_SUCCESSFUL_REGISTRATION": "報名成功後",
        "YOU_CAN_SET_A_DURATION_FOR_THE_TRAINEES": "您可以針對學員設定修習期限",
        "STATUS": "狀態",
        "REPORT": "報告",
        "SUBMIT_REPORT": "繳交報告",
        "SUBMIT_REPORT_DEADLINE": "繳交報告期限",
        "SUBMITTED_REPORT": "已繳交報告",
        "UPLOADED_REPORT_LIST": "已繳交報告清單",
        "SHOULD_BE_SUBMIT_REPORT": "應繳",
        "HAS_BEEN_PAID": "已繳",
        "SERIAL_NUMBER": "序號",
        "FILE_NAME": "檔案名稱",
        "SCORE": "分數",
        "POINT": "分",
        "NOT_YET_RATED": "尚未評分",
        "GRADE_QUESTIONS": "答對",
        "WRONG_QUESTIONS": "答錯",
        "DATE_OF_PAYMENT": "繳交日期",
        "APPROVE_STATUS": "簽核狀態",
        "COURSE_TITLE": "課程標題",
        "QUESTION_ANALYSIS": "解析",
        // #Add by w3c, #86573  start
        "CORRECT_ANSWER": "正確答案",
        // #Add by w3c, #86573  start
        // #Add by w3c, #86573 ,merge vip 83077 start
        "REFERENCE_ANSWER": "參考答案",
        // #Add by w3c, #86573 ,merge vip 83077 end
        "LECTURER_RATING_REQUIRED": "需講師評分",
        "INTRODUCTION": "簡介",
        "INSTRUCTOR_NAME": "講師姓名",
        "INSTRUCTOR_PROPERTIES": "講師屬性",
        "INSTRUCTOR_COMPANY": "講師廠商",
        "COMPANY": "公司",
        "EDUCATION": "學歷",
        "EXPERIENCE": "經歷",
        "CERTIFICATION": "認證資格",
        "EXPERTISE": "專長",
        "INSTRUCTOR_PHOTO": "講師照片",
        "INSTRUCTOR_DETAIL": "講師明細",
        "BIRTHDAY": "生日",
        "INDUCTION_DATE": "到任日",
        "ADDRESS": "地址",
        "MOBILE_PHONE": "行動電話",
        "HOME_PHONE": "住家電話",
        "MY_PREFERENCE": "喜好設定",
        "COURSE_FOLDER_PRESURVEY": "報名問卷",
        "COURSE_FOLDER_PRETEST": "課前測驗",
        "COURSE_FOLDER_CONTENT": "課程內容",
        "COURSE_FOLDER_POSTSURVEY": "課後問卷",
        "COURSE_FOLDER_POSTTEST": "課後測驗",
        "COURSE_FOLDER_REFERENCE": "參考文件",
        "COURSE_FOLDER_TEST": "測驗",
        "COURSE_FOLDER_SURVEY": "問卷",
        "COURSE_FOLDER": "課程目錄",
        "COURSE_FOLDER_LIVE": "直播",
        "VIEW_FILES": "觀看檔案",
        "TIME_LEFT": "剩餘時間",
        "QUESTION_ANSWERED": "已答題",
        "QUESTION_NOT_ANSWERED": "未答題",
        "QUESTION_REQUIRED": "必填題",
        "TEST_TIME": "測驗時間",
        "CAN_TEST_NUMBER_OF_TIMES": "可測驗之次數",
        "LAST_TEST_NUMBER_OF_TIMES": "剩餘測驗次數",
        "NUMBER_OF_TIMES": "次",
        "TO_THE_HIGHEST_SCORE": "以最高分為主",
        "EXAM_SCORE_ADOPTION": "測驗分數選擇方式",
        "SELECT_THE_LATEST_ONE": "選最後一次",
        "SELECT_THE_HIGHEST_SCORE_ONCE": "選最高分一次",
        "STAY_TUNED": "敬請期待",
        "RELATED_LINKS": "相關連結",
        "COURSE_LINKS": "課程連結",
        "SUMMARY": "摘要",
        "ALL_ANNOUNCEMENTS": "全部公告",
        "VIEW_MY_ANSWERED": "檢視我的答案",
        "PASSING": "通過",
        "PROPORTION_OF_PERSONNEL": "人員比例",
        "EXPIRED_ITEMS": "到期項目",
        "LEARNER_DURATION_OF_STUDY": "學員修習期限",
        "SESSION_CLASS_DEADLINE": "班次上課期限",
        "DETAILS": "詳細資料",
        "CREDITS": "學分",
        "TOTAL_CREDITS": "總學分",
        "PERSONAL_SETTING": "個人設定",
        "PART": "份",
        "ALL_DEPARTMENT": "所有部門",
        "NUMBER_OF": "筆",
        "PER_PAGE": "每頁",
        "BUSINESS_LEAVE": "公務出差",
        "PERSONAL_LEAVE": "私事請假",
        "SICK_LEAVE": "病假",
        "TRACKING_OBJECT": "追蹤對象",
        "TRACKING_DEPARTMENT": "追蹤部門",
        "TRACKING_PERIOD": "追蹤期別",
        "SIZE": "大小",
        "EXPIRED": "已滿",
        "UNEXPIRED": "未滿",
        "A_MONTH": "個月",
        "ALL_STAFF": "所有人員",
        "ANY_TIME_ZONE": "時間區段不限",
        "RELATED_TO_ME": "與部門相關",
        "MY_TRAINING":"我的藍圖",
        "THERE_IS_NO_DATA": "目前尚無資料",
        "PLEASE_AT": "請在",
        "SET_THE_CONDITIONS_CONDUCIVE_TO_SEARCH": "設定條件，利於進行搜尋",
        "EVALUATION_STAFF": "評鑑對象",
        "OTHER_NEED": "其他需求",
        "ADD_ITEM_FORM_STUDY_CATALOG": "從學習目錄加入項目",
        "SPECIFY_APPLICANT": "指定報名者",
        "TRAINING_PLAN": "訓練計劃",
        "TRAINING_BLUEPRINT": "訓練藍圖",
        "COMPETENCE_RECOMMEND": "職能建議",
        "SELF_DEMANDING": "自我要求",
        "MANAGER_RECOMMEND": "主管建議",
        "ABILITY_RECOMMEND": "能力建議",
        "PERSONAL_DEVELOPMENT": "個人發展",
        "SCORE_PASSING": "及格",
        "SCORE_FAILED": "不及格",
        "LEARNING_STATUS": "學員狀態",
        "SOURCE": "來源",
        "ESTIMATED_COMPLETION_DATE": "預定完成日期",
        "ENROLLMENT_DATE": "報名日期",
        "SEARCH_DEPUTY": "搜尋代理人",
        "WATCH_REPORT": "觀看報告",
        "CERTIFICATE_NAME": "證照名稱",
        "FILL_IN_END_DATE": "填寫結束日",
        "ANNOUNCEMENT_TIME": "公告時間",
        "DUTY": "到職",
        "INDUCTION": "到任",
        "YOU_HAVE_ADD_OTHER_REQUIREMENTS": "您已加入以下其他需求",
        "YOU_HAVE_SELECTED_COURSES": "您已選擇以下指定課程",
        "VIEW_ITEM": "檢視項目",
        "THOUSAND": "仟元",
        "ENCRYPTION": "加密",
        "COURSE_CODE": "課程代碼",
        "MINUTE": "分鐘",
        "CLASSIFICATION": "類別",
        "RELATED_CERTIFICATE": "關聯證照",
        "CERTIFICATE_RECOGNIZED_HOURS": "證照認列時數",
        "CERTIFICATE_TYPE": "證照類別",
        "REWARD_METHOD": "獎勵方式",
        "VALIDITY_PERIOD": "有效期限",
        "CERTIFICATE_CODE": "證照代碼",
        "PROGRAM_CODE": "學程代碼",
        "TEST_CODE": "測驗代碼",
        "TEST_TYPE": "測驗類型",
        "OTHERS": "其他",
        "COUNSELOR_DETAIL": "輔導員明細",
        "LEARNER_DETAIL": "學員明細",
        "SPECIALTY_COURSE_CLASSIFICATION": "專長課程類別",
        "SETTING_CLASS_TIME": "設定上課時間",
        "TIME_ZONE": "時間區段",
        "TIME_TABLE": "時間表",
        "LUNCH_TIME": "午休時間",
        "CYCLE_TIME": "循環週期",
        "INTERVAL": "間隔",
        "FULL_AMOUNT": "全額",
        "CASH": "現金",
        "REMITTANCE": "匯款",
        "CHEQUE": "支票",
        "PAYEE": "受款人",
        "REMITTANCE_INFORMATION": "匯款資料",
        "THE_TITLE_OF_THE_COMPANY": "抬頭",
        "BRANCHES": "分行",
        "RECEIPT_INFORMATION": "票據資料",
        "THE_TITLE_OF_THE_RECEIPT": "票據抬頭",
        "RECEIPT_EXPIRE_DATE": "票據到期日",
        "RECEIPT_FORMAT": "票據格式",
        "RECEIPT_DELINEATE": "票據劃線",
        "ENDORSEMENT_OR_TRANSFERENCE_PROHIBITED": "註明禁止背書轉讓",
        "APPLICATION_CONTENT": "請款內容",
        "COURSE_DATA": "課程資料",
        "FILL_IN_OTHER_METHOD": "填寫其他方式",
        "TEST_HISTORY_SEARCH": "測驗歷史查詢",
        "ANSWER_DATE":"作答日期",
        "TOTAL_COUNT": "總共{{value}}次",
        "AVERAGE_SATISFACTION": "平均滿意度",
        "NUMBER_OF_COURSES_DUE_WITHIN_THIS_WEEK": "一週內即將到期課程數",
        "CUMULATIVE_TRAINING_COSTS_FOR_THE_YEAR": "當年度累計訓練費用",
        "WILL_BE_EXPIRED_COURSES": "個將到期課程",
        "DOLLARS": "元",
        "THERE_IS_NO_ROADMAP_DATA": "尚無藍圖資料",
        "THERE_IS_NO_CERTIFICATE_DATA": "尚無證照資料",
        "TODAY_IS_NOT_ANY_SCHEDULE": "今天沒有任何行程",
        "REQUISITION_NUMBER": "申請單編號",
        "TRAINING_NAME": "訓練名稱",
        "APPLY_THW_WAY": "申請方式",
        "LEARN_TOTAL_TIME": "修習總時數",
        "PASS_NUMBER": "通過個數",
        "FAILED_NUMBER": "未通過個數",
        "EXEMPTION_NUMBER": "免修個數",
        "TEST_FRACTION": "測驗分數",
        "COMMUNITY": "社群",
        "CERTIFICATE_INTRODUCTION": "證照簡介",
        "COUNSELOR": "輔導員",
        "LANGUAGE": "語言",
        "GENERAL_SESSION": "一般班次",
        "EXTEND_SESSION": "展期班次",
        "SEARCH_SCOPE": "搜尋範圍",
        "SEARCH_SCOPE_ALL": "所有的",
        "SEARCH_SCOPE_DEPARTMENT": "轄下的",
        "NOTES": "附註",
        "CONTACT_PERSON": "聯絡人",
        "CONTACT_PERSON_EMAIL": "聯絡人電子信箱",
        "CONTACT_PERSON_PHONE": "聯絡人電話",
        "TOMORROW_TO_REMIND": "明日提醒",
        "TOMORROW_IS_NOT_ANY_SCHEDULE": "明日沒有任何行程",
        "TODAY": "今日",
        "DAY": "日",
        "WEEK_OF_YEAR": "{{year}} 年 第 {{week}} 週",
        "ITEM": "項目",
        "PROGRESS_OF_SUBMIT_REPORT": "繳交進度",
        "OCCUPY_WAIT_LIST": "目前候補",
        "REMAIN_WAIT_LIST": "尚餘候補",
        "DAYS_IN_DURATION": "區間內的",
        "INCLUDE": "包含",
        "REFERENCE_MATERIAL": "參考資料",
        "REFERENCE_MATERIAL_ASSIGNMENT": "參考資料",
        "SUBSIDY_COST": "補助費用",
        "SELF_COST": "自費",
        "LAST_EXTERNAL_TRAINING_HISTORY": "前次外訓紀錄",
        "EXTERNAL_TRAINING_APPLY_TIMES_PRE": "該員本年度已被核准",
        "EXTERNAL_TRAINING_APPLY_TIMES_POST": "次外訓申請",
        "EXTERNAL_TRAINING_APPLY_COST": "累計外訓金額",
        "TAX_FREE": "未稅",
        "EXTERNAL_TRAINING_REPORT": "心得報告",
        "EXTERNAL_TRAINING_NO_REPORT_NEED": "無須繳交",
        "UN_PAID": "未繳",
        "ORIGIN": "原因",
        "TRAINING_MATERIAL": "訓練教材",
        "APPLICANT_INFORMATION": "申請人資訊",
        "PAY_INFORMATION": "付費資訊",
        "VENDOR_RECEIVER_NAME": "廠商收件人",
        "APPROVAL_PROCESS_RECORDS": "簽核流程記錄",
        "EXTERNAL_TRAINING_APPLY_DETAIL": "外訓申請明細",
        "FILLER": "填表人",
        "COMPANY_DETAIL": "廠商明細",
        "DOCUMENT_REPORT": "文件報告",
        "NOT_CREATED": "尚未建立",
        "COMPLETION_PERCENTAGE": "已通過比例",
        "RECENTLY_COMPLETED_THE_TRAINEES": "最近通過學員",
        "THERE_IS_NO_SATISFACTION_DATA": "尚無滿意度資料",
        "FILL_IN_TIME": "填寫時間",
        "ORIGINAL_FACTORY_NAME": "原廠名稱",
        "CERTIFIED_SUBJECT": "認證科目",
        "APPLY_CATEGORY": "申請類別",
        "CERTIFICATE_GET_DATE": "證照取得日期",
        "CERTIFICATE_DEADLINE": "證照到期日",
        "NEW_APPLY": "新申請",
        "EXTENSION_APPLY": "展期申請",
        "PERMANENT": "永久有效",
        "CERTIFICATE_NUMBER": "證照編號",
        "ONE": "一",
        "TWO": "二",
        "THREE": "三",
        "TEST_DATE": "考試日期",
        "APPLY_REASON": "申請理由",
        "TEST_PLAN": "考試地點",
        "DETAIL_ADDRESS": "詳細地址",
        "TEST_COST": "考試費用",
        "ACQUIRE_DATE": "取得日期",
        "VALID_DATE": "有效日期",
        "BONUS": "獎勵",
        "CERT_TYPE": "證照種類",
        "SUBJECT_TO_USER_GRADE": "成績",
        "NEVER_EXPIRE": "永遠有效",
        "EXCERT_ADD_LICENSE_INFO": "補登資料",
        "SELECT_START_END_DATE": "選擇起迄日期",
        "VALID_DATE_START": "有效日期起",
        "VALID_DATE_END": "有效日期訖",
        "APPLICABLE_UNITS": "適用單位",
        "PERCENTAGE_OF_EXAMINATIONS": "考試補助比例",
        "CONDITION_NUMBER": "條件序號",
        "HAS_BEEN_CERTIFIED_SUBJECTS": "已取得認證科目",
        "PASS_THE_EXAM_PROJECT": "通過考試項目",
        "EXCERT_RELATED_FORM": "相關申請表單",
        "APPLY_DATE_START": "申請日期起",
        "APPLY_DATE_END": "申請日期訖",
        "EXCERT_APPLY_TEST_DATE": "考試申請日期",
        "EXCERT_UNAPPLIED_ITEMS": "未申請項目",
        "BONUS_COST": "獎金",
        "BONUS_APPLY_DATE": "獎勵申請日期",
        "EXCERT_APPLY_TEST": "考試申請",
        "TEST_ITEMS": "考試項目",
        "EXCERT_REAL_COMPENSATION": "實際補助金額",
        "COMPENSATION": "補助",
        "EXCERT_REGISTER_APPLY": "登錄申請",
        "REGISTER_APPLY_DATE": "登錄申請日期",
        "APPLY_INFO": "申請資訊",
        "EXTERNAL_CERT_EXAM_BASE_INFO": "外部證照考試基本資料",
        "CREATE_FROM": "課程來源(簽核通過後)",
        "EXTERNAL_AUTO_CREATE": "自動產生外訓課程",
        "EXTERNAL_ADD_COURSE": "將學員加入指定班次",
        "ASSIGNED_COURSE_CLASS": "已指定班次",
        "THE_PAYMENT_N_LEARNING_REPORT": "本次繳交 {{value}} 份學習報告",
        "I_WANT_TO_ENROLL":"我要報名",
        "PLAY_THE_COURSE":"播放課程",
        "YOU_MAY_BE_INTERESTED_IN_THE_FOLLOWING_COURSES": "您也許對下列課程也有興趣",
        "AVERAGE_TRAINING_HOURS_IN_EACH_DEPARTMENT": "轄下各部門平均訓練時數",
        "EMPLOYEE_TRAINING_HOURS": "同仁訓練時數",
        "AVERAGE_TRAINING_COSTS": "平均訓練費用",
        "CUMULATIVE_TRAINING_COSTS_IN_EACH_DEPARTMENT": "轄下各部門累積訓練費用",
        "EMPLOYEE_CUMULATIVE_TRAINING_COSTS": "同仁累積訓練費用",
        "IN_EACH_DEPARTMENT": "轄下部門",
        "CLICK_THE_PATH_AND_EXPAND_THE_DATA": "可點擊色塊並展開資料",
        "LICENSE": "證照",
        "LEARNING_DETAIL_OF_THE_YEAR": "當年度修課明細",
        "TEACHING_HOURS": "授課時數",
        "CERTIFICATE_LIST": "證照列表",
        "IN": "內",
        "OUT": "外",
        "THERE_IS_NO_COURSE_DATA": "尚無課程資料",
        "THERE_IS_NO_COST_DATA": "尚無費用資料",
        "CURRENT_DEPARTMENT": "目前所在部門",
        "LECTURER_TEACHING_DATA": "講師授課資料",
        "LECTURER_TEACHING_SATISFACTION": "講師授課滿意度",
        "CUMULATIVE_TEACHING_HOURS": "累積授課時數",
        "LECTURER_TEACHING_INFORMATION": "授課課程資訊",
        "VAT_NUMBER": "統一編號",
        "BANK_NAME": "銀行名稱",
        "BANK_ACCOUNT": "銀行帳號",
        "PHONE": "電話",
        "FAX": "傳真",
        "CONTACT_PERSON_DATA": "聯絡人資料",
        "URL": "網址",
        "DEPARTMENT_MEMBERS_OF_LEARNING_INFORMATION": "轄下同仁學習資訊",
        "NUMBER_OF_TEACHING_SESSIONS": "授課次數",
        "DOLLARS_NT": "(元)(幣別:新台幣)",
        "WEBSITE": "網址",
        "FULL_TEXT_SEARCH_NAME": "進階搜尋",
        "FULL_TEXT_QUERY_NAME": "搜尋課程內容及知識管理中心",
        "FULL_TEXT_SEARCH_CONTENT": "內容",
        "MODIFY_DATE": "更新日期",
        "NO_SEARCH_DATA": "查無資料",
        "SEARCH_KEYWORD": "搜尋關鍵字",
        "SEARCH_TIME": "搜尋時間"
      },

      "ACTIONS": actionsConstant,

      "STATUS": statusConstant,

      "MESSAGE": messageConstant,

      "FORM_VALIDATION": formValidationConstant,

      "ERROR": {
        "SERVERS_ERROR": "伺服器錯誤，請聯絡管理員!",
        "ACCOUNT_OR_PASSWORD_ERROR": "帳號或密碼錯誤！",
        "ERROR_ORIGIN_INCONSISTENT": "與原密碼不符",
        "CODE": httpErrorCodeConstant,
        "SIGN_IN_USER_TIMEOUT": "因閒置過久，系統將您自動登出，或您已從別的瀏覽器登入此帳號。請重新輸入您的帳號及密碼",
        "ERROR_MSG_NOT_ADD_DEPUTY_DUE_TO_OVERLAP": "由於職代時間與之前的職代記錄時間有所重疊且該部門已被設職代，因此無法再設定職代！",
        "SIGN_IN_USER_LIMIT": "系統使用人數已達上限，請稍後再登入",
        "C_SIGN_IN_USER_DISABLED": "您的帳號已停用,請洽管理員",
        "SIGN_IN_USER_NOT_FOUND": "您於該系統尚未建立帳號",
        "PLEASE_ENTER_OLD_PWD": "請輸入舊密碼",
        "PLEASE_ENTER_NEW_PWD": "請輸入新密碼",
        "PLEASE_ENTER_NEW_PWD_AGAIN": "請再次輸入新密碼",
        "NEW_PWD_INCONSISTENT": "新密碼不一致，請重新輸入",
        "OLD_NEW_PWD_CONSISTENT": "新密碼不得與舊密碼相同",
        "ERROR_PASSWORD_MUST_MORE_THAN_FOUR": "密碼最少需四個字元",
        "ERROR_PASSWORD_MUST_LESS_THAN_20": "密碼最多二十個字元",
        "ERROR_FULL_TEXT_KEYWORD_LENGTH": "中文請至少輸入2個字以利搜尋"
      },

      "YOU_DONT_HAVE_ACCESS": "你無權限存取此頁面"
    });
  }
  angular
    .module('eHRD.modules.language')
    .config(local);
})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  local.$inject = ['$translateProvider', 'systemConstantZhCN', 'messageConstantZhCN', 'httpErrorCodeConstantZhCN', 'formValidationConstantZhCN', 'actionsConstantZhCN', 'statusConstantZhCN'];
  function local($translateProvider, systemConstant, messageConstant, httpErrorCodeConstant, formValidationConstant, actionsConstant, statusConstant) {
    $translateProvider.translations('zh-cn', {
      "PDP": {
        "AGREE": "同意",
        "DISAGREE": "不同意",
        "NEXT": "下一步",
        "STAGE_DECLARE_TITLE": "电子签章法同意确认",
        "STAGE_DECLARE_PHRASE1": "欢迎您使用教育训练平台服务，当您使用本平台时，表示您同意以电子文件方式为表示方法，并同意<a href='http://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=J0080037' target='_blank'>电子签章法</a>之规定。",
        "STAGE_DECLARE_PHRASE2": "如果您不同意以本服务条款之内容，您应立即停止使用本服务。",
        "STAGE_SERVICE_TITLE": "个人服务条款",
        "STAGE_DISAGREE_PHRASE1": "因为您目前不同意本系统的服务条款说明，故暂时无法使用本网站服务。",
        "STAGE_DISAGREE_PHRASE2": "若针对本平台使用个人资料上有任何问题，请与平台管理者联络。"
      },
      "FILE_SIZE_ERROR": "档案大小超过{{value}}无法上传",
      "FILE_TYPE_ERROR": "不支援的档案格式 .{{value}}",
      "LANGUAGE":"语系",
      "LANGUAGE_EN":"English",
      "LANGUAGE_TW":"繁體中文",
      "LANGUAGE_CN":"简体中文",
      "LEARNING_DASHBOARD": "学习仪表板",
      "INCOMPLETE_COURSES": "待修课程",
      "ENROLLMENT": "待修课程",
      "TEST_QUESTIONNAIRE_CENTER": "测验问卷中心",
      "APPROVE_RECORDS": "簽核纪录查询",
      "TRAINING_RECORDS": "训练纪录查询",
      "COMMUNITY_DISCUSSION_ZONE":"社群讨论区",
      "PUBLIC_DISCUSSION_ZONE": "公共讨论区",
      "CLASSES_DISCUSSION_ZONE": "班次讨论区",
      "INDEX": "首页",
      "MY_CURRICULUM": "我的课表",
      "KNOWLEDGE_MANAGEMENT_CENTER": "知识管理中心",
      "REPORTS_ZONE":"报表专区",
      "LEARNING_REPORTS":"学习报表",
      "SUPERVISOR_ZONE":"主管专区",
      "DEPARTMENT_DASHBOARD": "部门仪表板",
      "TRAINING_APPROVE": "训练待簽表单簽核",
      "TRAINING_APPROVE_RECORDS_SEARCH": "训练簽核纪录查询",
      "MEMBER_CURRICULUM": "成员课表查询",
      "MEMBER_TRAINING_RECORDS": "成员修课纪录查询",
      "LEARNING_PASSPORT": "我的学习护照",
      "MY_CALENDAR": "我的行事历",
      "MY_SETTING": "我的设定",
      "COURSE_LEARNING_RESOURCE": "课程与学习资源",
      "EXTERNAL_TRAINING_ZONE": "外训专区",
      "EXTERNAL_TRAINING_APPLY": "外训申请",
      "EXTERNAL_TRAINING_APPLY_FORM": "外训申请表单",
      "EDIT_EXTERNAL_TRAINING_APPLY_FORM": "编辑外训申请表单",
      "VIEW_EXTERNAL_TRAINING_APPLY_FORM": "检视外训申请表单",
      "EXTERNAL_TRAINING_BULLETIN": "外训公布栏",
      "EXTERNAL_TRAINING_APPLY_RECORDS": "外训申请纪录",
      "COURSES_INFO": "课程资讯",
      "PROGRAM_INFO": "学程资讯",
      "CERTIFICATE_INFO": "证照资讯",
      "PROGRAM_INFO_DETAIL": "学程资料明细",
      "PREREQUISITE_ITEMS": "先修项目",
      "COURSE_CONTAIN": "包含课程",
      "GET_THE_PROCESS": "取得流程",
      "EXTEND_THE_PROCESS": "展期流程",
      "CERTIFICATE_INFO_DETAIL": "证照资料明细",
      "LEARNING_IS_TO_WALK_IN_THE_RIGHT_DIRECTION": "学习是为了走对方向",
      "LEARNING_IS_TO_BREAK_THROUGH_THEIR_OWN": "学习是为了突破自己",
      "MEMBER_SUGGEST_LEARNING_LIST": "成员建议学习项目查询",
      "SUGGEST_LEARNING_LIST": "建议学习项目",
      "TRAINING_ROAD_MAP": "训练蓝图",
      "NEED_GET_PREREQUISITE_ITEMS": "必须先取得证照",
      "TRAINING_PLAN": "训练计画",
      "CERT_ZONE":"证照专区",
      "EXTERNAL_CERT_REGISTER": "外部证照登录",
      "EXTERNAL_CERT_EXAM_APPLICATION": "外部证照考试申请",
      "EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION": "外部证照考试补助申请",
      "EXTERNAL_CERT_QUALIFY_REWARD_APPLICATION": "外部证照合格奖励申请",
      "EXTERNAL_CERT_APPLICATION_RECORDS_SEARCH": "外部证照申请纪录查询",
      "CERT_RECORDS_SEARCH": "证照纪录查询",
      "TRAINING_PROGRAM_PLANNING": "训练计画规划",
      "YOU_MUST_FIRST_OBTAIN_A_CERTIFIED_SUBJECT": "必须先取得认证科目",
      "NEWLY_OBTAIN_THIS_CERTIFIED_SUBJECT_CONDITION": "新取得此认证科目条件",
      "EXPIRED_AFTER_REACQUISITION_OF_THIS_CERTIFIED_SUBJECT_CONDITION": "过期后重新取得此认证科目条件",
      "SATISFY_OF_ANY_CONDITION_TO_OBTAIN_A_CERTIFICATE": "满足以下任一条件即可取得证照",
      "FINANCIAL_CERT_RECORD_APPLICATION": "金融证照记录申请",
      "FINANCIAL_CERT_RECORD_SEARCH": "金融证照记录查询",
      "MEMBER_FINANCIAL_CERT_RECORD_SEARCH": "成员金融证照记录查询",
      "MEMBER_CERT_RECORDS_SEARCH": "成员证照记录查询",
      "COMPETENCY_ZONE": "职能专区",
      "COMPETENCY_EVALUATION_SUPERVISOR_REPORT": "职能评鉴主管报表",
      "DEPARTMENT_DROP_ANALYSIS": "部门落差分析",
      "MEMBER_DROP_ANALYSIS": "人员落差分析",
      "COMPANY_COMPETENCY_DEFINITION": "全公司职能定义",
      "CORE_COMPETENCY": "核心职能",
      "MANAGE_COMPETENCY": "管理职能",
      "PROFESSION_COMPETENCY": "专业职能",
      "PERSONAL_EVALUATION_LIST": "个人评鉴清单",
      "COMPETENCY_EVALUATION_PERSONAL_REPORT": "职能评鉴个人报表",
      "PERSONAL_DROP_ANALYSIS": "个人落差分析",
      "PLACEHOLDERS": {
        "PLEASE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD":"请输入您的帐号及密码",
        "SEARCH_COURSE_RESOURCE": "搜寻课程与学习资源",
        "YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED_TO_CANCEL_THE_REGISTRATION": "你可以送出讯息给被指定取消报名的学员。",
        "YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED": "你可以送出讯息给被指定的学员。",
        "CAN_CANCEL_THE_REGISTRATION_OF_STUDENTS": "可取消报名的学员",
        "PLEASE_ENTER_THE_STUDENT_NAME": "请输入学员姓名",
        "PLEASE_ENTER_THE_NUMBER_OF_DAYS": "请输入天数",
        "PLEASE_SELECT_DATE": "请选择日期",
        "QUESTION_FILLING": "填充",
        "TOTAL_OF_QUESTIONS": "题数 : 总共 <span>{{value}}</span> 题",
        // #add by w3c, #87169  start
        "TOTAL_OF_GRADE_QUESTIONS": "答对 <span>{{value}}</span> 题",
        "TOTAL_OF_WRONG_QUESTIONS": "答错 <span>{{value}}</span> 题",
        "MANUAL_GRADE_QUESTTIONS": "尚未评分(问答题)",
        // #add by w3c, #87169  end
        "THE_PAPER_WILL_BE_PUBLISHED": "试卷将于，{{value}}，后公布(请至修课摘要页查询)",
        "N_PERSON_LEARNING": "{{value}} 人学习",
        "N_PERSON_FINISH_COURSE": "{{value}} 人完成课程",
        "PLEASE_ENTER_YOUR_OLD_PASSWORD": "请输入您的旧密码",
        "PLEASE_ENTER_YOUR_NEW_PASSWORD": "请输入您的新密码",
        "PLEASE_RECONFIRM_YOUR_NEW_PASSWORD": "请再次输入新密码",
        "PLEASE_ENTER_TEXT": "请输入文字",
        "SELECT_VENDOR": "选择主办单位",
        "ENTER_AMOUNT": "输入金额",
        "NT_CONVERSION": "台币换算金额",
        "REASON_OF_LEAVE": "请假原因",
        "PLEASE_FILL_IN_INTERNAL_LECTURE_SCORE": "请填写内部讲授分数",
        "PLEASE_FILL_IN_OTHER_METHOD_REPORT_SCORE": "请填写其他方式报告分数",
        "PLEASE_FILL_IN_ORAL_REPORT_SCORE": "请填写口头报告分数",
        "WEEK_W_OF_Y": "{{year}}年第{{week}}周 ",
        "PLEASE_SELECT_TRAINING_BLUEPRINT": "请选择训练蓝图",
        "FOR_LESS_THAN_N_THE_FOLLOWING_REPORTS_ARE_NOT_REQUIRED": "低于 {{value}} 元则无需下列报告",
        "PLEASE_SELECT_A_CATEGORY": "请选择类別",
        "SEARCH_FOR_A_VENDORS": "查询单位",
        "PLEASE_ENTER_KEYWORDS": "请输入关键字",
        "CONVERSION_AMOUNT": "换算金额",
        "PLEASE_ENTER_DEPARTMENT_NAME": "请输入部门名称"
      },

      "SYSTEM": systemConstant,

      "FIELD": {
        "COURSE.RESOURCE.TYPE.MATERIAL": "教材",
        "COURSE.RESOURCE.TYPE.INSTRUCTOR": "讲师",
        "COURSE.RESOURCE.TYPE.VENUE": "场地",
        "COURSE.RESOURCE.TYPE.FACILITY": "设备",
        "COURSE.RESOURCE.TYPE.EXT_VENDOR": "外训厂商",
        "APPELLATION": "名称",
        "TRACK_QUESTIONNAIRE": "追踪问卷",
        "SURVEYBANK_GROUP_MATERIAL": "教材",
        "TABLE_HEADER_INSTRUCTOR": "讲师",
        "VENUE": "场地",
        "FACILITY": "设备",
        "ATTENDANCE_RECORD": "出缺席记录",
        "ATTENDANCE_RATE": "出席率",
        "ATTENDANCE_STATISTIC": "出席状况",
        "TOTAL_ITEM": "总共<span class='text-danger'>{{value}}</span>项",
        "COMPLETE_ITEM": "完成<span class='text-danger'>{{value}}</span>项",
        "LEARNING_ITEM": "学习项目",
        "LEARNING_HISTORY": "学习历程",
        "DOCUMENT_TITLE": "文件标题",
        "DOWNLOAD_TIME": "下载时间",
        "COURSE_CONTENT": "课程内容",
        "EXEMPTION_REASON": "免修原因 ",
        "EVER_ENROLLED_COURSE": "已修过相关课程",
        "EVER_ENROLLED_CERTIFICATION": "已领有相关外部证照",
        "EVER_ENROLLED_INNER_CERTIFICATION": "已领有相关内部证照",
        "CERTIFICATION_NAME": "证照名称",
        "PROFESSIONAL_KNOWLEDGE": "专业知识",
        "TECHNICAL_OPERATION": "技术操作",
        "WORK_ATTITUDE": "工作态度",
        "COMMUNICATION": "人际沟通",
        "DEPUTY_DEPARTMENT": "被代理的部门",
        "SETTING_DATE":"设定日期",
        "DEPUTY": "代理人",
        "SETTING_DEPUTY": "设定簽核代理人",
        "DEPUTY_EFFECTIVE_DATE":"代理生效日",
        "DEPUTY_END_DATE":"代理结束日",
        "MY_DEPUTY_SETTING": "簽核代理人设定",
        "LIST_OF_UNEXPIRED_COURSE_TO_BE_EXPIRED": "即将到期课程未完训名单",
        "DEPARTMENT_MEMBERS_FOR_THE_YEAR": "当年度辖下部门",
        "AVERAGE_TRAINING_HOURS": "平均训练时数",
        "MONTHLY_ACCUMULATED_TRAINING_COSTS": "各月份累积训练费用",
        "COMPLETION_RATE_OF_DEPARTMENT_MEMBERS": "辖下同仁完训率",
        "ATTENDANCE_RATE_OF_DEPARTMENT_MEMBERS": "辖下同仁出席率",
        "CUMULATIVE_TRAINING_COSTS": "累积训练费用",
		"COMPANY_TOTAL_COSTS": "公司累积",
		"CUMULATIVE_TRAINING_COSTS_OF_DEPARTMENT_GROUPS": "辖下部门累积训练费用",
        "COMPANY_AVERAGE": "公司平均",
        "DEPARTMENT_EVERYONE_AVERAGE": "部门每人平均",
        "SEARCH_THIS_AND_SUB_CATEGORIES": "搜寻本目录及子目录",
        "EXTERNAL_TRAINING_WEBSITE": "外训课程网址",
        "TIME": "时间",
        "LEAVE_TIME": "请假时间",
        "SELECT_LEAVE_TIME": "选择请假时间",
        "COURSE_NOT_ATTENDED_REASON": "未出席原因",
        "CLASS_HOUR": "上课时数",
        "OTHER_METHOD": "其他方式",
        "INTERNAL_LECTURE":"内部讲授",
        "SCORE_TO_BE_APPROVED": "需簽核评分",
        "ORAL_REPORT":"口头报告",
        "LECTURE_DEADLINE":"讲授期限",
        "SUBMIT_DEADLINE":"缴交期限",
        "REPORT_DEADLINE":"报告期限",
        "NEED_TO_SUBMIT":"需缴交",
        "UPLOAD_REPORT":"上传报告",
        "NO_REPORT":"无需报告",
        "NEED_TO_COMPLETE_REPORT":"须完成下列报告",
        "CURRENCY": "货币",
        "AMOUNT": "金额",
        "SYSTEM_CURRENCY": "系统币別",
        "TYPE_OF_SUBSIDY": "补助方式",
        "FULL": "全额",
        "SUBSIDY": "补助",
        "VOUCHER": "凭证",
        "TAXABLE_INVOICE": "应稅发票",
        "TAX_FREE_INVOICE": "未稅发票",
        "RECEIPT": "收据",
        "PAYMENT_DATE": "预定付款日期",
        "HIDDEN_COST_INFORMATION": "隐藏费用资讯",
        "SELECT_VENDOR": "选择主办单位",
        "ENROLLMENT_COST": "报名费用",
        "COURSE_COST": "课程费用",
        "COURSE_DETAIL": "课程详细资讯",
        "FREE_COURSE": "免费课程",
        "PAY_COURSE": "付费课程",
        "KNOWLEDGE_MANAGEMENT_CENTER": "知识管理中心",
        "COURSE_DESCRIPTION":"课程说明",
        "REMARK": "备注",
        "CYCLE_MODE": "循环模式",
        "REPEAT_INTERVAL": "重复间隔",
        "WEEK": "周",
        "MONTH": "月",
        "YEAR": "年",
        "MONDAY": "星期一",
        "TUESDAY": "星期二",
        "WEDNESDAY": "星期三",
        "THURSDAY": "星期四",
        "FRIDAY": "星期五",
        "SATURDAY": "星期六",
        "SUNDAY": "星期日",
        "JANUARY": "一月",
        "FEBRUARY": "二月",
        "MARCH": "三月",
        "APRIL": "四月",
        "MAY": "五月",
        "JUNE": "六月",
        "JULY": "七月",
        "AUGUST": "八月",
        "SEPTEMBER": "九月",
        "OCTOBER": "十月",
        "NOVEMBER": "十一月",
        "DECEMBER": "十二月",
        "VENDOR": "主办单位",
        "DOMESTIC": "国内",
        "ABROAD": "国外",
        "MULTIPLE_SELECT": "可复选",
        "JOIN_REASON": "参加理由",
        "TEACH_DEADLINE": "讲授期限",
        "REST_TIME": "休息时间",
        "SETTING_CYCLE_WEEK": "设定循环周期",
        "TRAINING_NATURE": "训练性质",
        "ASSIGNED_BY_MANAGER": "主管指派",
        "PERSONAL_REQUESTS": "个人需求",
        "TRUE": "是",
        "FALSE": "否",
        "UPLOAD_COURSE_DATA": "上传课程资料",
        "UPLOAD_REFERENCE_FILE": "上传参考文件",
        "ENROLLMENT_INFORMATION": "报名资讯",
        "ENROLLMENT_WEBSITE": "报名网址",
        "NO_INFORMATION": "暂无资料",
        "TRAINING_HOURS_IN_THE_QUARTER": "第{{value}}季累计训练时数(通过)",
        "TRAINING_HOURS_IN_THE_YEAR": "年累计训练时数(通过)",
        "AVERAGE_TRAINING_HOURS_OF_COMPANY": "全公司平均训练时数(通过)",
        "TRAINING_BLUEPRINT_PROGRESS": "训练蓝图进度",
        "INCOMPLETE_ITEM": "未完成项目",
        "INTERNAL_CERTIFICATION_PROGRESS": "内部证照取得进度",
        "PERFORM_LATEST_NEWS": "平台最新动态",
        "MY_LEARNING_RESUME": "我的学习履历",
        "LOGIN_PLATFORM": "登入平台",
        "LEARNING_COURSE": "阅读课程",
        "FILE_IN_ONLINE_QUESTIONNAIRE": "填写问卷",
        "FILE_IN_ONLINE_TEST": "填写测验",
        "FILE_IN_QUESTIONNAIRE": "填写问卷",
        "FILE_IN_TEST": "填写测验",
        "LEARNING_KNOWLEDGE_DOCUMENT_CENTER": "点阅知识文件中心",
        "VIEW_DOCUMENT_CENTER": "浏览文件中心",
        "FORUM_PUBLISHED_ARTICLE": "讨论区发表文章",
        "ENROLLMENT_COURSE": "报名课程",
        "CANCEL_COURSE": "取消报名",
        "ONLINE_COURSE_LEARNING_TIME_CURVE": "线上课程学习时数曲线图",
        "LEARNING_HOURS": "学习时数",
        "SIX_MONTH": "近六个月",
        "DISTRIBUTION_MAP_OF_COURSES_IN_EACH_CATEGORY": "各类別课程修课分布图",
        "TOTAL_OF_ONLINE_COURSE_LEARNING_HOURS": "线上课程累计<span>阅读时数</span>",
        "CUMULATIVE_OF_PASSED_COURSES": "累计通过<span>课程数</span>",
        "TOTAL_OF_CERTIFICATION": "取得<span>证照总数</span>",
        "CUMULATIVE_OF_TRAINING_COSTS_FOR_THE_YEAR": "当年度外训<span>费用累计</span>",
        "PENDING_APPROVALS": "待簽表单",
        "APPROVE_PROCESS": "簽核流程",
        "APPROVE_DETAIL": "簽核详细资讯",
        "APPROVE_RECORD": "簽核纪录",
        "APPLY_COSTS": "本次申请费用",
        "STUDENT_TRAINING_COSTS_HAVE_OCCURRED": "已发生学生训练费用",
        "DEPARTMENT_TRAINING_COSTS_HAVE_OCCURRED": "已发生部门训练费用",
        "KEYWORD": "关键字",
        "DEPARTMENT_NAME": "部门名称",
        "DEPARTMENT_MEMBER": "部门成员",
        "DEPARTMENT_MEMBERS": "辖下同仁",
        "LEARNING_ACTIVITY": "学习活动",
        "LEARNING_ACTIVITY_STATUS": "学习活动状态",
        "SEARCH_COURSE_NAME": "搜寻课程名称",
        "SELECT_SEARCH_FILTER": "选择搜寻条件",
        "PLEASE_RATING": "请评分",
        "START_DATE": "开始日期",
        "END_DATE": "结束日期",
        "COURSE_START_DATE": "上课开始日期",
        "AUTHOR": "作者",
        "LOCATION": "位置",
        "ROOT_DIRECTORY": "总目录",
        "CLICK_COUNT": "点阅次数",
        "DOWNLOAD_COUNT": "下载次数",
        "DOWNLOAD_COUNT_DETAIL": "下载次数明细",
        "I_WANT": "我要",
        "AVERAGE_RATING": "平均评分",
        "SHARE_DATE": "分享日期",
        "HOT_DOCUMENT": "热门文件",
        "TITLE": "标题",
        "TYPE": "类型",
        "APPLICANT": "申请人",
        "APPLICANT_DEPARTMENT": "申请人部门",
        "APPLY_DATE": "申请日期",
        "ARRIVAL_DATE": "送达日期",
        "APPLY_START_DATE" :"申请开始日期",
        "APPLY_END_DATE" :"申请结束日期",
        "APPROVER" :"簽核人",
        "LEARNING_CATEGORY": "学习目录",
        "ENROLLMENT_TIME": "修课时间",
        "COURSE_DATE": "上课日期",
        "HOURS": "时数",
        "TIME_OF_HOURS": "时数(小时)",
        "HOUR": "小时",
        "ENROLLMENT_HOURS": "修课时数",
        "PASS_STATUS": "通过状态",
        "COST": "费用",
        "TEST_SCORE": "测验成绩",
        "LEARNING_REPORT": "学习报告",
        "ENROLLMENT_NUMBER_OF_PEOPLE": "修课人数",
        "DOWNLOAD_NUMBER_OF_PEOPLE": "下载人数",
        "INCOMPLETED_NUMBER_OF_PEOPLE": "未完成人数",
        "EXEMPTION_NUMBER_OF_PEOPLE": "免修人数",
        "EXEMPTION": "免修",
        "APPLY_FOR_EXEMPTION": "免修申请",
        "PASSED_NUMBER_OF_PEOPLE": "通过人数",
        "FAILED_NUMBER_OF_PEOPLE": "未通过人数",
        "DROP_NUMBER_OF_PEOPLE": "退选人数",
        "LEARNER_SATISFACTION":"学员总体满意度",
        "MANAGER_SATISFACTION":"管理员总体满意度",
        "PASSED_COUNT": "通过数",
        "EXEMPTION_COUNT": "免修数",
        "TOTAL": "总数",
        "ENROLLMENT_STATUS": "修课状态",
        "CURRENT_PROCESS": "目前流程",
        "CHANGE_PASSWORD": "变更密码",
        "INIT_PWD_PLEASE_CHANGE_PWD_PROMPT": "此密码为系统预设密码，请先更改密码",
        "CHANGE_LOGIN_PASSWORD": "变更登入密码",
        "TEST_QUESTIONNAIRE": "测验问卷",
        "ALL_COURSE": "全部课程",
        "LATEST_COURSE": "最新课程",
        "HOT_COURSE": "热门课程",
        "FEATURED_COURSE": "精选课程",
        "LATEST_NEWS": "最新公告",
        "ONLINE_COURSE_LEADERBOARD": "线上课程排行榜",
        "LATEST_DOCUMENT": "最新文件",
        "RELATED_SITES": "相关网站",
        "USERNAME": "使用者名称",
        "USER_ACCOUNT": "使用者帐号",
        "ACCOUNT": "帐号",
        "NAME": "名字",
        "LAST_NAME": "姓氏",
        "PASSWORD":"密码",
        "ACTION": "动作",
        "ALL": "全部",
        "ORDER": "顺序",
        "PASSED_DATE": "通过日期",
        "SPECIFIC": "特定",
        "PROGRAM": "学程",
        "COURSE": "课程",
        "LIVE": "直播",
        "NO_LIVE_BROADCAST_YET": "直播尚未开始",
        "LIVE_NOW": "进入直播课程",
        "LIVE_END": "直播完毕",
        "LIVE_VIDEO": "直播完(VOD)",
        "NO_LIVE": "无法直播",
        "LIVE_NO_VIDEO": "直播完(沒VOD)",
        "NO_LIVE_CLASS": "本班次尚未直播",
        "LECTURER_SETTING_TIME_WRONG": "讲师设定时间错误",
        "U_NO_LIVE": "U没有直播",
        "CTMS_SERVER_LIVE_ERROR": "CTMS错误",
        "U_SERVER_LIVE_ERROR": "U直播错误",
        "OTHER_LIVE_ERROR": "其他错误",
        "ONLINE_COURSE": "线上课程",
        "CLASS_ROOM_COURSE": "教室课程",
        "EXTERNAL_TRAINING": "外训",
        "INTERNAL_TRAINING": "内训",
        "INTERNAL": "内部",
        "EXTERNAL": "外部",
        "ONLINE_TEST": "线上测验",
        "CLASS_ROOM_TEST": "教室测验",
        "TEST": "测验",
        "QUESTIONNAIRE": "问卷",
        "INTERNAL_LICENSE": "内部证照",
        "EXTERNAL_LICENSE": "外部证照",
        "MY_FAVOURITE": "我的最爱",
        "ABOUT_THIS_COURSE": "关于本课程",
        "ABOUT_THIS_PROGRAM": "关于本学程",
        "ABOUT_THIS_CERTIFICATE": "关于本证照",
        "TOTAL_NUMBER_OF_CLASSES": "累计上课人数",
        "COURSE_NAME": "课程名称",
        "PROGRAM_NAME": "学程名称",
        "COURSE_INFO_DETAIL": "课程资料明细",
        "COURSE_INFO": "课程资讯",
        "SESSION": "班次",
        "SESSION_NAME": "班次名称",
        "SESSION_INFO": "班次资讯",
        "CLASS_TIME": "上课时间",
        "ENROLL_DEADLINE": "报名期限",
        "TEST_DEADLINE": "测验期限",
        "VIEW_DEADLINE": "观看期限",
        "FILL_IN_DEADLINE": "填写期限",
        "LAST_PLAYER": "上次播放至",
        "ENROLLMENT_INFO": "修课资讯",
        "REFERENCE_DOCUMENT": "参考文件",
        "REFERENCE_COURSE": "参考课程",
        "COURSE_TYPE": "课程类型",
        "INSTRUCTOR": "讲师",
        "EVENT_LOCATION": "活动地点",
        "NUMBER_OF_PEOPLE": "人数",
        "ENROLL_NUMBER_OF_PEOPLE": "报名人数",
        "ENROLL_TYPE": "报名方式",
        "REMAINING_AMOUNT" : "尚余名额",
        "NO_UPPER_LIMIT": "没有上限",
        "PENDING_PREDETERMINED_COST": "预估每人费用",
        "COURSE_ATTRIBUTES": "课程属性",
        "COURSE_INTRODUCTION": "课程简介",
        "PROGRAM_INTRODUCTION": "学程简介",
        "COURSE_OUTLINE": "课程大纲",
        "LEARNING_GOAL": "学习目标",
        "UNDERSTANDING": "了解",
        "THROUGH_THE_RULES": "通过规则",
        "APPLY_STATUS": "申请状态",
        "SUITABLE_FOR_THE_OBJECT": "适合对象",
        "SUITABLE_FOR_LEVEL": "适合层级",
        "PREPARATORY_KNOWLEDGE": "预备知识",
        "DIFFICULTY": "难度",
        "DURATION": "长度",
        "PROPERTIES": "必选修",
        "COURSE_ELECTIVE": "选修",
        "COURSE_REQUIRED": "必修",
        "IS_WILL_EXPIRE": "即将到期",
        "LAST_LEARNING_DATE": "最后学习日",
        //#Add by w3c, #89088  start
        "DUE_DATE": "修习期限",
        //#Add by w3c, #89088  end
        "OVERALL_RESULT": "总成绩",
        "ENROLL_MANAGER": "报名管理",
        "ASSIGNABLE_MEMBER_ENROLL": "指定成员报名",
        "ASSIGNABLE_MEMBER_ALTERNATE": "指定成员候补",
        "UN_ASSIGNABLE_MEMBER_ENROLL": "取消成员报名",
        "ASSIGNABLE_STATUS": "指定的状态",
        "ASSIGNER": "指定者",
        "CLASSMATE": "同班同学",
        "FORUM": "讨论区",
        "DESCRIPTION": "说明",
        "CREATE_DATE": "建立日期",
        "DATE": "日期",
        "BASIC_INFORMATION": "基本资料",
        "OTHER": "其他",
        "NOTHING": "无",
        "FULL_NAME": "姓名",
        "EMPLOYEE_NUMBER": "员工编号",
        "DEPARTMENT": "部门",
        "JOB_TITLE": "职称",
        "EMAIL": "电子邮件",
        "OFFICE_PHONE": "办公室电话",
        "ADD_DATE": "新增日期",
        "TOTAL_ENROLLMENT_COUNT": "总修课数",
        "REASON": "理由",
        "DUTY_DAY": "到职日",
        "GRADE_NAME": "职等",
        "DUTY_CODE": "职务代码",
        "ADD_LEARNER": "新增学员",
        "SELFENROLLED": "自行报名",
        "ASSIGNED": "指定报名",
        "COURSE_DEADLINE": "课程到期日",
        "DIRECTLY_SPECIFY_DEADLINES": "直接指定期限",
        "UNLIMITED": "无限制",
        "LEARNING_CENTER": "学习中心",
        "COURSE_LIST": "课程清单",
        "LEARNING_RESULT": "学习成果",
        "MINIMUM_VIEWING_TIME": "最低观看时间",
        "VIEWING_TIME": "观看时间",
        "COURSE_TIME": "课程时间",
        "FINISH_TIME": "完成时间",
        "SELECTED": "已选择",
        "FILES": "档案",
        "LIST_ALL_SUBORDINATE_MEMBERS": "列出所有直属部属",
        "LIST_MY_GROUP_MEMBERS": "列出同部门同仁",
        "YOU_HAVE_SELECTED_MEMBERS": "您已选择以下指定人员",
        "EXECUTION_DATE": "指定报名生效日",
        "DAYS": "天",
        "AFTER_THE_SUCCESSFUL_REGISTRATION": "报名成功后",
        "YOU_CAN_SET_A_DURATION_FOR_THE_TRAINEES": "您可以针对学员设定修习期限",
        "STATUS": "状态",
        "REPORT": "报告",
        "SUBMIT_REPORT": "缴交报告",
        "SUBMIT_REPORT_DEADLINE": "缴交报告期限",
        "SUBMITTED_REPORT": "已缴交报告",
        "UPLOADED_REPORT_LIST": "已缴交报告清单",
        "SHOULD_BE_SUBMIT_REPORT": "应缴",
        "HAS_BEEN_PAID": "已缴",
        "SERIAL_NUMBER": "序号",
        "FILE_NAME": "档案名称",
        "SCORE": "分数",
        "POINT": "分",
        "NOT_YET_RATED": "尚未评分",
        "GRADE_QUESTIONS": "答对",
        "WRONG_QUESTIONS": "答错",
        "DATE_OF_PAYMENT": "缴交日期",
        "APPROVE_STATUS": "簽核状态",
        "COURSE_TITLE": "课程标题",
        "QUESTION_ANALYSIS": "解析",
        // #Add by w3c, #86573  start
        "CORRECT_ANSWER": "正确答案",
        // #Add by w3c, #86573  start
        // #Add by w3c, #86573 ,merge vip 83077 start
        "REFERENCE_ANSWER": "参考答案",
        // #Add by w3c, #86573 ,merge vip 83077 end
        "LECTURER_RATING_REQUIRED": "需讲师评分",
        "INTRODUCTION": "简介",
        "INSTRUCTOR_NAME": "讲师姓名",
        "INSTRUCTOR_PROPERTIES": "讲师属性",
        "INSTRUCTOR_COMPANY": "讲师厂商",
        "COMPANY": "公司",
        "EDUCATION": "学历",
        "EXPERIENCE": "经历",
        "CERTIFICATION": "认证资格",
        "EXPERTISE": "专长",
        "INSTRUCTOR_PHOTO": "讲师照片",
        "INSTRUCTOR_DETAIL": "讲师明细",
        "BIRTHDAY": "生日",
        "INDUCTION_DATE": "到任日",
        "ADDRESS": "地址",
        "MOBILE_PHONE": "行动电话",
        "HOME_PHONE": "住家电话",
        "MY_PREFERENCE": "喜好设定",
        "COURSE_FOLDER_PRESURVEY": "报名问卷",
        "COURSE_FOLDER_PRETEST": "课前测验",
        "COURSE_FOLDER_CONTENT": "课程内容",
        "COURSE_FOLDER_POSTSURVEY": "课后问卷",
        "COURSE_FOLDER_POSTTEST": "课后测验",
        "COURSE_FOLDER_REFERENCE": "参考文件",
        "COURSE_FOLDER_TEST": "测验",
        "COURSE_FOLDER_SURVEY": "问卷",
        "COURSE_FOLDER": "课程目录",
        "COURSE_FOLDER_LIVE": "直播",
        "VIEW_FILES": "观看档案",
        "TIME_LEFT": "剩余时间",
        "QUESTION_ANSWERED": "已答题",
        "QUESTION_NOT_ANSWERED": "未答题",
        "QUESTION_REQUIRED": "必填题",
        "TEST_TIME": "测验时间",
        "CAN_TEST_NUMBER_OF_TIMES": "可测验之次数",
        "LAST_TEST_NUMBER_OF_TIMES": "剩余测验次数",
        "NUMBER_OF_TIMES": "次",
        "TO_THE_HIGHEST_SCORE": "以最高分为主",
        "EXAM_SCORE_ADOPTION": "测验分数选择方式",
        "SELECT_THE_LATEST_ONE": "选最后一次",
        "SELECT_THE_HIGHEST_SCORE_ONCE": "选最高分一次",
        "STAY_TUNED": "敬请期待",
        "RELATED_LINKS": "相关链接",
        "COURSE_LINKS": "课程链接",
        "SUMMARY": "摘要",
        "ALL_ANNOUNCEMENTS": "全部公告",
        "VIEW_MY_ANSWERED": "检视我的答案",
        "PASSING": "通过",
        "PROPORTION_OF_PERSONNEL": "人员比例",
        "EXPIRED_ITEMS": "到期项目",
        "LEARNER_DURATION_OF_STUDY": "学员修习期限",
        "SESSION_CLASS_DEADLINE": "班次上课期限",
        "DETAILS": "详细资料",
        "CREDITS": "学分",
        "TOTAL_CREDITS": "总学分",
        "PERSONAL_SETTING": "个人设定",
        "PART": "份",
        "ALL_DEPARTMENT": "所有部门",
        "NUMBER_OF": "笔",
        "PER_PAGE": "每页",
        "BUSINESS_LEAVE": "公务出差",
        "PERSONAL_LEAVE": "私事请假",
        "SICK_LEAVE": "病假",
        "TRACKING_OBJECT": "追踪对象",
        "TRACKING_DEPARTMENT": "追踪部门",
        "TRACKING_PERIOD": "追踪期別",
        "SIZE": "大小",
        "EXPIRED": "已满",
        "UNEXPIRED": "未满",
        "A_MONTH": "个月",
        "ALL_STAFF": "所有人员",
        "ANY_TIME_ZONE": "时间区段不限",
        "RELATED_TO_ME": "与部门相关",
        "MY_TRAINING":"我的蓝图",
        "THERE_IS_NO_DATA": "目前尚无资料",
        "PLEASE_AT": "请在",
        "SET_THE_CONDITIONS_CONDUCIVE_TO_SEARCH": "设定条件，利于进行搜寻",
        "EVALUATION_STAFF": "评鉴对象",
        "OTHER_NEED": "其他需求",
        "ADD_ITEM_FORM_STUDY_CATALOG": "从学习目录加入项目",
        "SPECIFY_APPLICANT": "指定报名者",
        "TRAINING_PLAN": "训练计划",
        "TRAINING_BLUEPRINT": "训练蓝图",
        "COMPETENCE_RECOMMEND": "职能建议",
        "SELF_DEMANDING": "自我要求",
        "MANAGER_RECOMMEND": "主管建议",
        "ABILITY_RECOMMEND": "能力建议",
        "PERSONAL_DEVELOPMENT": "个人发展",
        "SCORE_PASSING": "及格",
        "SCORE_FAILED": "不及格",
        "LEARNING_STATUS": "学员状态",
        "SOURCE": "来源",
        "ESTIMATED_COMPLETION_DATE": "预定完成日期",
        "ENROLLMENT_DATE": "报名日期",
        "SEARCH_DEPUTY": "搜寻代理人",
        "WATCH_REPORT": "观看报告",
        "CERTIFICATE_NAME": "证照名称",
        "FILL_IN_END_DATE": "填写结束日",
        "ANNOUNCEMENT_TIME": "公告时间",
        "DUTY": "到职",
        "INDUCTION": "到任",
        "YOU_HAVE_ADD_OTHER_REQUIREMENTS": "您已加入以下其他需求",
        "YOU_HAVE_SELECTED_COURSES": "您已选择以下指定课程",
        "VIEW_ITEM": "检视项目",
        "THOUSAND": "仟元",
        "ENCRYPTION": "加密",
        "COURSE_CODE": "课程代码",
        "MINUTE": "分钟",
        "CLASSIFICATION": "类別",
        "RELATED_CERTIFICATE": "关联证照",
        "CERTIFICATE_RECOGNIZED_HOURS": "证照认列时数",
        "CERTIFICATE_TYPE": "证照类別",
        "REWARD_METHOD": "奖励方式",
        "VALIDITY_PERIOD": "有效期限",
        "CERTIFICATE_CODE": "证照代码",
        "PROGRAM_CODE": "学程代码",
        "TEST_CODE": "测验代码",
        "TEST_TYPE": "测验类型",
        "OTHERS": "其他",
        "COUNSELOR_DETAIL": "辅导员明细",
        "LEARNER_DETAIL": "学员明细",
        "SPECIALTY_COURSE_CLASSIFICATION": "专长课程类別",
        "SETTING_CLASS_TIME": "设定上课时间",
        "TIME_ZONE": "时间区段",
        "TIME_TABLE": "时间表",
        "LUNCH_TIME": "午休时间",
        "CYCLE_TIME": "循环周期",
        "INTERVAL": "间隔",
        "FULL_AMOUNT": "全额",
        "CASH": "现金",
        "REMITTANCE": "汇款",
        "CHEQUE": "支票",
        "PAYEE": "受款人",
        "REMITTANCE_INFORMATION": "汇款资料",
        "THE_TITLE_OF_THE_COMPANY": "抬头",
        "BRANCHES": "分行",
        "RECEIPT_INFORMATION": "票据资料",
        "THE_TITLE_OF_THE_RECEIPT": "票据抬头",
        "RECEIPT_EXPIRE_DATE": "票据到期日",
        "RECEIPT_FORMAT": "票据格式",
        "RECEIPT_DELINEATE": "票据划线",
        "ENDORSEMENT_OR_TRANSFERENCE_PROHIBITED": "注明禁止背书转让",
        "APPLICATION_CONTENT": "请款内容",
        "COURSE_DATA": "课程资料",
        "FILL_IN_OTHER_METHOD": "填写其他方式",
        "TEST_HISTORY_SEARCH": "测验历史查询",
        "ANSWER_DATE":"作答日期",
        "TOTAL_COUNT": "总共{{value}}次",
        "AVERAGE_SATISFACTION": "平均满意度",
        "NUMBER_OF_COURSES_DUE_WITHIN_THIS_WEEK": "一周内即将到期课程数",
        "CUMULATIVE_TRAINING_COSTS_FOR_THE_YEAR": "当年度累计训练费用",
        "WILL_BE_EXPIRED_COURSES": "个将到期课程",
        "DOLLARS": "元",
        "THERE_IS_NO_ROADMAP_DATA": "尚无蓝图资料",
        "THERE_IS_NO_CERTIFICATE_DATA": "尚无证照资料",
        "TODAY_IS_NOT_ANY_SCHEDULE": "今天没有任何行程",
        "REQUISITION_NUMBER": "申请单编号",
        "TRAINING_NAME": "训练名称",
        "APPLY_THW_WAY": "申请方式",
        "LEARN_TOTAL_TIME": "修习总时数",
        "PASS_NUMBER": "通过个数",
        "FAILED_NUMBER": "未通过个数",
        "EXEMPTION_NUMBER": "免修个数",
        "TEST_FRACTION": "测验分数",
        "COMMUNITY": "社群",
        "CERTIFICATE_INTRODUCTION": "证照简介",
        "COUNSELOR": "辅导员",
        "LANGUAGE": "语言",
        "GENERAL_SESSION": "一般班次",
        "EXTEND_SESSION": "展期班次",
        "SEARCH_SCOPE": "搜寻范围",
        "SEARCH_SCOPE_ALL": "所有的",
        "SEARCH_SCOPE_DEPARTMENT": "辖下的",
        "NOTES": "附注",
        "CONTACT_PERSON": "联络人",
        "CONTACT_PERSON_EMAIL": "联络人电子信箱",
        "CONTACT_PERSON_PHONE": "联络人电话",
        "TOMORROW_TO_REMIND": "明日提醒",
        "TOMORROW_IS_NOT_ANY_SCHEDULE": "明日没有任何行程",
        "TODAY": "今日",
        "DAY": "日",
        "WEEK_OF_YEAR": "{{year}} 年 第 {{week}} 周",
        "ITEM": "项目",
        "PROGRESS_OF_SUBMIT_REPORT": "缴交进度",
        "OCCUPY_WAIT_LIST": "目前候补",
        "REMAIN_WAIT_LIST": "尚余候补",
        "DAYS_IN_DURATION": "区间内的",
        "INCLUDE": "包含",
        "REFERENCE_MATERIAL": "参考资料",
        "REFERENCE_MATERIAL_ASSIGNMENT": "参考资料",
        "SUBSIDY_COST": "补助费用",
        "SELF_COST": "自费",
        "LAST_EXTERNAL_TRAINING_HISTORY": "前次外训纪录",
        "EXTERNAL_TRAINING_APPLY_TIMES_PRE": "该员本年度已被核准",
        "EXTERNAL_TRAINING_APPLY_TIMES_POST": "次外训申请",
        "EXTERNAL_TRAINING_APPLY_COST": "累计外训金额",
        "TAX_FREE": "未稅",
        "EXTERNAL_TRAINING_REPORT": "心得报告",
        "EXTERNAL_TRAINING_NO_REPORT_NEED": "无须缴交",
        "UN_PAID": "未缴",
        "ORIGIN": "原因",
        "TRAINING_MATERIAL": "训练教材",
        "APPLICANT_INFORMATION": "申请人资讯",
        "PAY_INFORMATION": "付费资讯",
        "VENDOR_RECEIVER_NAME": "厂商收件人",
        "APPROVAL_PROCESS_RECORDS": "簽核流程记录",
        "EXTERNAL_TRAINING_APPLY_DETAIL": "外训申请明细",
        "FILLER": "填表人",
        "COMPANY_DETAIL": "厂商明细",
        "DOCUMENT_REPORT": "文件报告",
        "NOT_CREATED": "尚未建立",
        "COMPLETION_PERCENTAGE": "已通过比例",
        "RECENTLY_COMPLETED_THE_TRAINEES": "最近通过学员",
        "THERE_IS_NO_SATISFACTION_DATA": "尚无满意度资料",
        "FILL_IN_TIME": "填写时间",
        "ORIGINAL_FACTORY_NAME": "原厂名称",
        "CERTIFIED_SUBJECT": "认证科目",
        "APPLY_CATEGORY": "申请类別",
        "CERTIFICATE_GET_DATE": "证照取得日期",
        "CERTIFICATE_DEADLINE": "证照到期日",
        "NEW_APPLY": "新申请",
        "EXTENSION_APPLY": "展期申请",
        "PERMANENT": "永久有效",
        "CERTIFICATE_NUMBER": "证照编号",
        "ONE": "一",
        "TWO": "二",
        "THREE": "三",
        "TEST_DATE": "考试日期",
        "APPLY_REASON": "申请理由",
        "TEST_PLAN": "考试地点",
        "DETAIL_ADDRESS": "详细地址",
        "TEST_COST": "考试费用",
        "ACQUIRE_DATE": "取得日期",
        "VALID_DATE": "有效日期",
        "BONUS": "奖励",
        "CERT_TYPE": "证照种类",
        "SUBJECT_TO_USER_GRADE": "成绩",
        "NEVER_EXPIRE": "永远有效",
        "EXCERT_ADD_LICENSE_INFO": "补登资料",
        "SELECT_START_END_DATE": "选择起迄日期",
        "VALID_DATE_START": "有效日期起",
        "VALID_DATE_END": "有效日期讫",
        "APPLICABLE_UNITS": "适用单位",
        "PERCENTAGE_OF_EXAMINATIONS": "考试补助比例",
        "CONDITION_NUMBER": "条件序号",
        "HAS_BEEN_CERTIFIED_SUBJECTS": "已取得认证科目",
        "PASS_THE_EXAM_PROJECT": "通过考试项目",
        "EXCERT_RELATED_FORM": "相关申请表单",
        "APPLY_DATE_START": "申请日期起",
        "APPLY_DATE_END": "申请日期讫",
        "EXCERT_APPLY_TEST_DATE": "考试申请日期",
        "EXCERT_UNAPPLIED_ITEMS": "未申请项目",
        "BONUS_COST": "奖金",
        "BONUS_APPLY_DATE": "奖励申请日期",
        "EXCERT_APPLY_TEST": "考试申请",
        "TEST_ITEMS": "考试项目",
        "EXCERT_REAL_COMPENSATION": "实际补助金额",
        "COMPENSATION": "补助",
        "EXCERT_REGISTER_APPLY": "登录申请",
        "REGISTER_APPLY_DATE": "登录申请日期",
        "APPLY_INFO": "申请资讯",
        "EXTERNAL_CERT_EXAM_BASE_INFO": "外部证照考试基本资料",
        "CREATE_FROM": "课程来源(簽核通过后)",
        "EXTERNAL_AUTO_CREATE": "自动产生外训课程",
        "EXTERNAL_ADD_COURSE": "将学员加入指定班次",
        "ASSIGNED_COURSE_CLASS": "已指定班次",
        "THE_PAYMENT_N_LEARNING_REPORT": "本次缴交 {{value}} 份学习报告",
        "I_WANT_TO_ENROLL":"我要报名",
        "PLAY_THE_COURSE":"播放课程",
        "YOU_MAY_BE_INTERESTED_IN_THE_FOLLOWING_COURSES": "您也许对下列课程也有兴趣",
        "AVERAGE_TRAINING_HOURS_IN_EACH_DEPARTMENT": "辖下各部门平均训练时数",
        "EMPLOYEE_TRAINING_HOURS": "同仁训练时数",
        "AVERAGE_TRAINING_COSTS": "平均训练费用",
        "CUMULATIVE_TRAINING_COSTS_IN_EACH_DEPARTMENT": "辖下各部门累积训练费用",
        "EMPLOYEE_CUMULATIVE_TRAINING_COSTS": "同仁累积训练费用",
        "IN_EACH_DEPARTMENT":"辖下部门",
        "CLICK_THE_PATH_AND_EXPAND_THE_DATA":"可点击色块并展开资料",
        "LICENSE": "证照",
        "LEARNING_DETAIL_OF_THE_YEAR":"当年度修课明细",
        "TEACHING_HOURS":"授课时数",
        "CERTIFICATE_LIST": "证照列表",
        "IN": "内",
        "OUT": "外",
        "THERE_IS_NO_COURSE_DATA": "尚无课程资料",
        "THERE_IS_NO_COST_DATA": "尚无费用资料",
        "CURRENT_DEPARTMENT": "目前所在部门",
        "LECTURER_TEACHING_DATA": "讲师授课资料",
        "LECTURER_TEACHING_SATISFACTION": "讲师授课满意度",
        "CUMULATIVE_TEACHING_HOURS": "累积授课时数",
        "LECTURER_TEACHING_INFORMATION": "授课课程资讯",
        "VAT_NUMBER": "统一编号",
        "BANK_NAME": "银行名称",
        "BANK_ACCOUNT": "银行帐号",
        "PHONE": "电话",
        "FAX": "传真",
        "CONTACT_PERSON_DATA": "联络人资料",
        "URL": "网址",
        "DEPARTMENT_MEMBERS_OF_LEARNING_INFORMATION": "辖下同仁學習資訊",
        "NUMBER_OF_TEACHING_SESSIONS": "授课次数",
        "DOLLARS_NT": "(元)(币别:新台币)",
        "WEBSITE": "网址",
        "FULL_TEXT_SEARCH_NAME": "进阶搜寻",
        "FULL_TEXT_QUERY_NAME": "搜寻课程内容及知识管理中心",
        "FULL_TEXT_SEARCH_CONTENT": "内容",
        "MODIFY_DATE": "更新日期",
        "NO_SEARCH_DATA": "查无资料",
        "SEARCH_KEYWORD": "搜寻关键字",
        "SEARCH_TIME": "搜寻时间"
      },

      "ACTIONS": actionsConstant,

      "STATUS": statusConstant,

      "MESSAGE": messageConstant,

      "FORM_VALIDATION": formValidationConstant,

      "ERROR": {
        "SERVERS_ERROR": "伺服器错误，请联络管理员!",
        "ACCOUNT_OR_PASSWORD_ERROR": "帐号或密码错误！",
        "ERROR_ORIGIN_INCONSISTENT": "与原密码不符",
        "CODE": httpErrorCodeConstant,
        "SIGN_IN_USER_TIMEOUT": "因閒置过久，系统将您自动登出，或您已从別的浏览器登入此帐号。请重新输入您的帐号及密码",
        "ERROR_MSG_NOT_ADD_DEPUTY_DUE_TO_OVERLAP": "由于职代时间与之前的职代记录时间有所重叠且该部门已被设职代，因此无法再设定职代！",
        "SIGN_IN_USER_LIMIT": "系统使用人数已达上限，请稍后再登入",
        "C_SIGN_IN_USER_DISABLED": "您的帐号已停用，请洽管理员",
        "SIGN_IN_USER_NOT_FOUND": "您于该系统尚未建立帐号",
        "PLEASE_ENTER_OLD_PWD": "请输入旧密码",
        "PLEASE_ENTER_NEW_PWD": "请输入新密码",
        "PLEASE_ENTER_NEW_PWD_AGAIN": "请再次输入新密码",
        "NEW_PWD_INCONSISTENT": "新密码不一致，请重新输入",
        "OLD_NEW_PWD_CONSISTENT": "新密码不得与旧密码相同",
        "ERROR_PASSWORD_MUST_MORE_THAN_FOUR" : "密码最少需四个字元",
        "ERROR_PASSWORD_MUST_LESS_THAN_20": "密码最多二十个字元",
        "ERROR_FULL_TEXT_KEYWORD_LENGTH": "中文请至少输入2个字以利搜寻"
      },

      "YOU_DONT_HAVE_ACCESS": "你无权限存取此页面"
    });
  }
  angular
    .module('eHRD.modules.language')
    .config(local);
})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  local.$inject = ['$translateProvider', 'systemConstantEnUS', 'messageConstantEnUS', 'httpErrorCodeConstantEnUS', 'formValidationConstantEnUS', 'actionsConstantEnUS', 'statusConstantEnUS'];
  function local($translateProvider, systemConstant, messageConstant, httpErrorCodeConstant, formValidationConstant, actionsConstant, statusConstant) {
    $translateProvider.translations('en-us', {
      "PDP": {
        "AGREE": "Agree",
        "DISAGREE": "Disagree",
        "NEXT": "Next",
        "STAGE_DECLARE_TITLE": "Confirm Electronic Signatures Act",
        "STAGE_DECLARE_PHRASE1": "Welcome to use training management system services, you agree to <a href='http://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=J0080037' target='_blank'>representation of electronic documents</a>, and agree to the provisions of the Electronic Signatures Act.",
        "STAGE_DECLARE_PHRASE2": "If you do not agree to the Terms of Service, you should immediately stop using the service.",
        "STAGE_SERVICE_TITLE": "Term of Service",
        "STAGE_DISAGREE_PHRASE1": "Because you do not agree to the Terms of Service, you are unable to use the Service.",
        "STAGE_DISAGREE_PHRASE2": "For the CTMS to use personal information have any questions, please contact the LMS adminstrator."
      },
      "FILE_SIZE_ERROR": "File size exceeds {{value}} can not be uploaded",
      "FILE_TYPE_ERROR": "Un-supported file extension .{{value}}",
      "LANGUAGE":"language",
      "LANGUAGE_EN":"English",
      "LANGUAGE_TW":"繁體中文",
      "LANGUAGE_CN":"简体中文",
      "LEARNING_DASHBOARD": "Learning Dashboard",
      "INCOMPLETE_COURSES": "Incomplete Courses",
      "ENROLLMENT": "Enrollment",
      "TEST_QUESTIONNAIRE_CENTER": "Test and Questionnaire Center",
      "APPROVE_RECORDS": "Training Approval History",
      "TRAINING_RECORDS": "Learning Records",
      "COMMUNITY_DISCUSSION_ZONE":"Community Forum",
      "PUBLIC_DISCUSSION_ZONE": "Public Forum",
      "CLASSES_DISCUSSION_ZONE": "Class Forum",
      "INDEX": "Home",
      "MY_CURRICULUM": "My Curriculum",
      "KNOWLEDGE_MANAGEMENT_CENTER": "Knowledge Center ",
      "REPORTS_ZONE":"Reports",
      "LEARNING_REPORTS":"Learning Reports",
      "SUPERVISOR_ZONE":"Manager Tools",
      "DEPARTMENT_DASHBOARD": "Department Dashboard",
      "TRAINING_APPROVE": "Pending Training Approvals",
      "TRAINING_APPROVE_RECORDS_SEARCH": " Training Approval History",
      "MEMBER_CURRICULUM": "Members' Curriculum",
      "MEMBER_TRAINING_RECORDS": "Members' Learning History",
      "LEARNING_PASSPORT": "My Learning Passport",
      "MY_CALENDAR": "My Calendar",
      "MY_SETTING": "Personal Setting",
      "COURSE_LEARNING_RESOURCE": "Learning Resources",
      "EXTERNAL_TRAINING_ZONE": "External Training",
      "EXTERNAL_TRAINING_APPLY": "External Training Application",
      "EXTERNAL_TRAINING_APPLY_FORM": "External Training Apply Form",
      "EDIT_EXTERNAL_TRAINING_APPLY_FORM": "Edit External Training Apply Form",
      "VIEW_EXTERNAL_TRAINING_APPLY_FORM": "View External Training Apply Form",
      "EXTERNAL_TRAINING_BULLETIN": "External Training Bulletin",
      "EXTERNAL_TRAINING_APPLY_RECORDS": "External Training Application Records",
      "COURSES_INFO": "Course Info",
      "PROGRAM_INFO": "Curriculum Info",
      "CERTIFICATE_INFO": "Certificate Info",
      "PROGRAM_INFO_DETAIL": "Deatiled Curriculum Info",
      "PREREQUISITE_ITEMS": "Prerequisites",
      "COURSE_CONTAIN": "Including courses",
      "GET_THE_PROCESS": "Get the process",
      "EXTEND_THE_PROCESS": "Extend the process",
      "CERTIFICATE_INFO_DETAIL": "Certificate info detail",
      "LEARNING_IS_TO_WALK_IN_THE_RIGHT_DIRECTION": "Learning to walk in the right direction",
      "LEARNING_IS_TO_BREAK_THROUGH_THEIR_OWN": "Learning to break through yourself",
      "MEMBER_SUGGEST_LEARNING_LIST": "Members Suggested Learning",
      "SUGGEST_LEARNING_LIST": "Suggested Learning",
      "TRAINING_ROAD_MAP": "Training Roadmap",
      "NEED_GET_PREREQUISITE_ITEMS": "You must first obtain a license",
      "TRAINING_PLAN": "Training Plan",
      "CERT_ZONE":"Cert Zone",
      "EXTERNAL_CERT_REGISTER": "External Certificate Registration",
      "EXTERNAL_CERT_EXAM_APPLICATION": "External Certificate Exam Application",
      "EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION": "External Certificate Exam Subsidy Application",
      "EXTERNAL_CERT_QUALIFY_REWARD_APPLICATION": "External Certificate Reward Application",
      "EXTERNAL_CERT_APPLICATION_RECORDS_SEARCH": "External Certificate Application Record",
      "CERT_RECORDS_SEARCH": "Certificate History",
      "TRAINING_PROGRAM_PLANNING": "Training Program Planning",
      "YOU_MUST_FIRST_OBTAIN_A_CERTIFIED_SUBJECT": "You must first obtain a certified subject",
      "NEWLY_OBTAIN_THIS_CERTIFIED_SUBJECT_CONDITION": "Newly obtain this certified subject condition",
      "EXPIRED_AFTER_REACQUISITION_OF_THIS_CERTIFIED_SUBJECT_CONDITION": "Expired after reacquisition of this certified subject condition",
      "SATISFY_OF_ANY_CONDITION_TO_OBTAIN_A_CERTIFICATE": "Satisfy of any condition to obtain a certificate",
      "FINANCIAL_CERT_RECORD_APPLICATION": "Financial Certificate Record Application",
      "FINANCIAL_CERT_RECORD_SEARCH": "Financial Certificate Record",
      "MEMBER_FINANCIAL_CERT_RECORD_SEARCH": "Members Financial Certificate Record",
      "MEMBER_CERT_RECORDS_SEARCH": "Members Certificate Records",
      "COMPETENCY_ZONE": "Competence Zone",
      "COMPETENCY_EVALUATION_SUPERVISOR_REPORT": "Competence Evaluation Supervisor Report",
      "DEPARTMENT_DROP_ANALYSIS": "Department Drop Analysis",
      "MEMBER_DROP_ANALYSIS": "Member Drop Analysis",
      "COMPANY_COMPETENCY_DEFINITION": "Company Competence Definition",
      "CORE_COMPETENCY": "Core Competence",
      "MANAGE_COMPETENCY": "Manage Competence",
      "PROFESSION_COMPETENCY": "profession Competence",
      "PERSONAL_EVALUATION_LIST": "Personal Evaluation List",
      "COMPETENCY_EVALUATION_PERSONAL_REPORT": "Competence Evaluation Personal Report",
      "PERSONAL_DROP_ANALYSIS": "Personal Drop Analysis",
      "PLACEHOLDERS": {
        "PLEASE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD":"Please enter your account and password.",
        "SEARCH_COURSE_RESOURCE": "Search the Learning Resources.",
        "YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED_TO_CANCEL_THE_REGISTRATION": "Send information to learners who have been cancelled the registration.",
        "YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED": "Send information to the designated learners.",
        "CAN_CANCEL_THE_REGISTRATION_OF_STUDENTS": "Cancel the learners' registration.",
        "PLEASE_ENTER_THE_STUDENT_NAME": "Please enter the learner's name",
        "PLEASE_ENTER_THE_NUMBER_OF_DAYS": "Please enter the days",
        "PLEASE_SELECT_DATE": "Please select the date.",
        "QUESTION_FILLING": "fill-in-the-blank",
        "TOTAL_OF_QUESTIONS": "Questions: Total <span>{{value}}</span>",
        // #add by w3c, #87169  start
        "TOTAL_OF_GRADE_QUESTIONS": "Right answer <span>{{value}}</span>",
        "TOTAL_OF_WRONG_QUESTIONS": "Wrong answer <span>{{value}}</span>",
        "MANUAL_GRADE_QUESTTIONS": "To be scored (Essay questions)",
        // #add by w3c, #87169  end
        "THE_PAPER_WILL_BE_PUBLISHED": "Test result will be announced in{{value}}(Please check it in the Course Summary)",
        "N_PERSON_LEARNING": "{{value}} learners enrolled in this course.",
        "N_PERSON_FINISH_COURSE": "{{value}} learners completed this course.",
        "PLEASE_ENTER_YOUR_OLD_PASSWORD": "Please enter the old password.",
        "PLEASE_ENTER_YOUR_NEW_PASSWORD": "Please enter the new password.",
        "PLEASE_RECONFIRM_YOUR_NEW_PASSWORD": "Please enter the new password again.",
        "PLEASE_ENTER_TEXT": "Please enter the text.",
        "SELECT_VENDOR": "Please select the vendor.",
        "ENTER_AMOUNT": "Please enter the cost.",
        "NT_CONVERSION": "NT Conversions",
        "REASON_OF_LEAVE": "Reason of leave",
        "PLEASE_FILL_IN_INTERNAL_LECTURE_SCORE": "Please fill in internal lecture score",
        "PLEASE_FILL_IN_OTHER_METHOD_REPORT_SCORE": "Please fill in other method report score",
        "PLEASE_FILL_IN_ORAL_REPORT_SCORE": "Please fill in oral report score",
        "WEEK_W_OF_Y": "{{year}} year the {{week}} week ",
        "PLEASE_SELECT_TRAINING_BLUEPRINT": "Please select training roadmap",
        "FOR_LESS_THAN_N_THE_FOLLOWING_REPORTS_ARE_NOT_REQUIRED": "Less then {{value}} the following reports are not required",
        "PLEASE_SELECT_A_CATEGORY": "Please select a category",
        "SEARCH_FOR_A_VENDORS": "Search for a vendors",
        "PLEASE_ENTER_KEYWORDS": "Please enter the keywords",
        "CONVERSION_AMOUNT": "Conversion amount",
        "PLEASE_ENTER_DEPARTMENT_NAME": "Please enter department name"
      },

      "SYSTEM": systemConstant,

      "FIELD": {
        "COURSE.RESOURCE.TYPE.MATERIAL": "Textbooks",
        "COURSE.RESOURCE.TYPE.INSTRUCTOR": "Instructor",
        "COURSE.RESOURCE.TYPE.VENUE": "Venue",
        "COURSE.RESOURCE.TYPE.FACILITY": "Facility",
        "COURSE.RESOURCE.TYPE.EXT_VENDOR": "External training vendor",
        "APPELLATION": "Title",
        "TRACK_QUESTIONNAIRE": "Follow-up Questionnaire",
        "SURVEYBANK_GROUP_MATERIAL": "Materials",
        "TABLE_HEADER_INSTRUCTOR": "Instructors",
        "VENUE": "Venue",
        "FACILITY": "FACILITY",
        "ATTENDANCE_RECORD": "Attendance Records",
        "ATTENDANCE_RATE": "Attendance Rate",
        "ATTENDANCE_STATISTIC": "Attendance status",
        "TOTAL_ITEM": "Total <span class='text-danger'>{{value}}</span>",
        "COMPLETE_ITEM": "Complete <span class='text-danger'>{{value}}</span>",
        "LEARNING_ITEM": "Learning Items",
        "LEARNING_HISTORY": "Learning History",
        "DOCUMENT_TITLE": "Document Title",
        "DOWNLOAD_TIME": "Download Time",
        "COURSE_CONTENT": "Content",
        "EXEMPTION_REASON": "Reason of Exemption",
        "EVER_ENROLLED_COURSE": "Have enrolled the related courses.",
        "EVER_ENROLLED_CERTIFICATION": "Have the external certificate.",
        "EVER_ENROLLED_INNER_CERTIFICATION": "Have the internal certificate.",
        "CERTIFICATION_NAME": "Certificate name",
        "PROFESSIONAL_KNOWLEDGE": "Professional knowledge",
        "TECHNICAL_OPERATION": "Technical operation",
        "WORK_ATTITUDE": "Work attitude",
        "COMMUNICATION": "Communication",
        "DEPUTY_DEPARTMENT": "Deputy Department",
        "SETTING_DATE":"Set Date",
        "DEPUTY": "Deputy",
        "SETTING_DEPUTY": "Set Deputy",
        "DEPUTY_EFFECTIVE_DATE":"Deputy Effective Date",
        "DEPUTY_END_DATE":"Deputy End Date",
        "MY_DEPUTY_SETTING": "Set Deputy",
        "LIST_OF_UNEXPIRED_COURSE_TO_BE_EXPIRED": "List of incomplete learners of expired course.",
        "DEPARTMENT_MEMBERS_FOR_THE_YEAR": "Department members",
        "AVERAGE_TRAINING_HOURS": "Avg. Training hours",
        "MONTHLY_ACCUMULATED_TRAINING_COSTS": "Monthly Accumulated Train cost",
        "COMPLETION_RATE_OF_DEPARTMENT_MEMBERS": "Completion percentage of department members",
        "ATTENDANCE_RATE_OF_DEPARTMENT_MEMBERS": "Attendance percentage of department members",
        "CUMULATIVE_TRAINING_COSTS": "Accd. Train cost",
        "COMPANY_AVERAGE": "Co. Avg.",
        "DEPARTMENT_EVERYONE_AVERAGE": "Dept. Avg.",
		"COMPANY_TOTAL_COSTS": "Co. Total cost",
		"CUMULATIVE_TRAINING_COSTS_OF_DEPARTMENT_GROUPS": "Accd. Train cost of department members",
        "SEARCH_THIS_AND_SUB_CATEGORIES": "Search this and sub-categories",
        "EXTERNAL_TRAINING_WEBSITE": "Web URL for external training",
        "TIME": "Time",
        "LEAVE_TIME": "Ask-for-leave Time",
        "SELECT_LEAVE_TIME": "Select Ask-for-leave Time",
        "COURSE_NOT_ATTENDED_REASON": "Reasons for Absence",
        "CLASS_HOUR": "Class Hour",
        "OTHER_METHOD": "Other Methods",
        "INTERNAL_LECTURE":"Internal Teaching",
        "SCORE_TO_BE_APPROVED": "Score to be approved",
        "ORAL_REPORT":"Oral Report",
        "LECTURE_DEADLINE":"Teaching deadline",
        "SUBMIT_DEADLINE":"Submission deadline",
        "REPORT_DEADLINE":"Report deadline",
        "NEED_TO_SUBMIT":"Need to submit",
        "UPLOAD_REPORT":"Upload report",
        "NO_REPORT":"No report",
        "NEED_TO_COMPLETE_REPORT":"Following reports need to be completed",
        "CURRENCY": "Currency",
        "AMOUNT": "Amount",
        "SYSTEM_CURRENCY": "System Currency",
        "TYPE_OF_SUBSIDY": "Type of Subsidy",
        "FULL": "Full",
        "SUBSIDY": "Subsidy",
        "VOUCHER": "Voucher",
        "TAXABLE_INVOICE": "Taxable Invoice",
        "TAX_FREE_INVOICE": "Tax-free invoice",
        "RECEIPT": "Receipt ",
        "PAYMENT_DATE": "Payment Date",
        "HIDDEN_COST_INFORMATION": "Hide Detailed Cost Info",
        "SELECT_VENDOR": "Select Vendor",
        "ENROLLMENT_COST": "Enrollment Cost",
        "COURSE_COST": "Course Cost",
        "COURSE_DETAIL": "Detailed Course Info",
        "FREE_COURSE": "Free Course",
        "PAY_COURSE": "Pay Course",
        "KNOWLEDGE_MANAGEMENT_CENTER": "Internal Teaching",
        "COURSE_DESCRIPTION":"Course Description",
        "REMARK": "Note",
        "CYCLE_MODE": "Repeat",
        "REPEAT_INTERVAL": "Repeat Interval",
        "WEEK": "Week",
        "MONTH": "Month",
        "YEAR": "Year",
        "MONDAY": "Monday",
        "TUESDAY": "Tuesday",
        "WEDNESDAY": "Wednesday",
        "THURSDAY": "Thursday",
        "FRIDAY": "Friday",
        "SATURDAY": "Saturday",
        "SUNDAY": "Sunday",
        "JANUARY": "January",
        "FEBRUARY": "February",
        "MARCH": "March",
        "APRIL": "April",
        "MAY": "May",
        "JUNE": "June",
        "JULY": "July",
        "AUGUST": "August",
        "SEPTEMBER": "September",
        "OCTOBER": "October",
        "NOVEMBER": "November",
        "DECEMBER": "December",
        "VENDOR": "Domestic/Abroad",
        "DOMESTIC": "Domestic",
        "ABROAD": "Abroad",
        "MULTIPLE_SELECT": "Multiple Answers",
        "JOIN_REASON": "Purpose",
        "TEACH_DEADLINE": "Teaching deadline",
        "REST_TIME": "Rest time",
        "SETTING_CYCLE_WEEK": "Repeat",
        "TRAINING_NATURE": "Training Nature",
        "ASSIGNED_BY_MANAGER": "Assigned by Manager",
        "PERSONAL_REQUESTS": "Personal Requests",
        "TRUE": "Yes",
        "FALSE": "No",
        "UPLOAD_COURSE_DATA": "Upload Course Data",
        "UPLOAD_REFERENCE_FILE": "Upload reference file",
        "ENROLLMENT_INFORMATION": "Enrollment Info",
        "ENROLLMENT_WEBSITE": "URL for Enrollment",
        "NO_INFORMATION": "No data",
        "TRAINING_HOURS_IN_THE_QUARTER": "Accumulated training hours in the quarter(pass):",
        "TRAINING_HOURS_IN_THE_YEAR": "Accumulated training hours in the year(pass):",
        "AVERAGE_TRAINING_HOURS_OF_COMPANY": "Average training hours of company(pass)",
        "TRAINING_BLUEPRINT_PROGRESS": "Progress of training roadmap",
        "INCOMPLETE_ITEM": "Incomplete items",
        "INTERNAL_CERTIFICATION_PROGRESS": "Progress of internal certificate",
        "PERFORM_LATEST_NEWS": "Latest news",
        "MY_LEARNING_RESUME": "My Learning Resume",
        "LOGIN_PLATFORM": "Login",
        "LEARNING_COURSE": "Learning",
        "FILE_IN_ONLINE_QUESTIONNAIRE": "Fill in the questionnaire.",
        "FILE_IN_ONLINE_TEST": "Fill in the test.",
        "FILE_IN_QUESTIONNAIRE": "Fill in the questionnaire.",
        "FILE_IN_TEST": "Fill in the test.",
        "LEARNING_KNOWLEDGE_DOCUMENT_CENTER": "Use the knowledge center.",
        "VIEW_DOCUMENT_CENTER": "Use the document center.",
        "FORUM_PUBLISHED_ARTICLE": "Post a article in the forum.",
        "ENROLLMENT_COURSE": "Enroll",
        "CANCEL_COURSE": "Cancel",
        "ONLINE_COURSE_LEARNING_TIME_CURVE": "Curve of online course learning hours",
        "LEARNING_HOURS": "Learning hours",
        "SIX_MONTH": "Within six months",
        "DISTRIBUTION_MAP_OF_COURSES_IN_EACH_CATEGORY": "Course learning distribution by category",
        "TOTAL_OF_ONLINE_COURSE_LEARNING_HOURS": "Accumulated online course learning hours",
        "CUMULATIVE_OF_PASSED_COURSES": "Accumulated passed courses",
        "TOTAL_OF_CERTIFICATION": "Total certificates",
        "CUMULATIVE_OF_TRAINING_COSTS_FOR_THE_YEAR": "Accumulated external training cost of this year",
        "PENDING_APPROVALS": "Pending Approvals",
        "APPROVE_PROCESS": "Approval process",
        "APPROVE_DETAIL": "Details",
        "APPROVE_RECORD": "Approval records",
        "APPLY_COSTS": "Application Cost",
        "STUDENT_TRAINING_COSTS_HAVE_OCCURRED": "Members' Training Expenses",
        "DEPARTMENT_TRAINING_COSTS_HAVE_OCCURRED": "Department Training Expenses",
        "KEYWORD": "Keyword",
        "DEPARTMENT_NAME": "Department",
        "DEPARTMENT_MEMBER": "Department member",
        "DEPARTMENT_MEMBERS": "Dept. Member",
        "LEARNING_ACTIVITY": "Learning activity",
        "LEARNING_ACTIVITY_STATUS": "Learning activity status",
        "SEARCH_COURSE_NAME": "Search course",
        "SELECT_SEARCH_FILTER": "Conditional search",
        "PLEASE_RATING": "Please rate",
        "START_DATE": "Start date",
        "END_DATE": "End date",
        "COURSE_START_DATE": "Class start date",
        "AUTHOR": "Author",
        "LOCATION": "Location",
        "ROOT_DIRECTORY": "Root Category",
        "CLICK_COUNT": "Click Count",
        "DOWNLOAD_COUNT": " Download Count",
        "DOWNLOAD_COUNT_DETAIL": " Download Count Details",
        "I_WANT": "I want",
        "AVERAGE_RATING": "Average score",
        "SHARE_DATE": "Sharing date",
        "HOT_DOCUMENT": "Hot document",
        "TITLE": "Title",
        "TYPE": "Type",
        "APPLICANT": "Applicant",
        "APPLICANT_DEPARTMENT": "Applicant's Department",
        "APPLY_DATE": "Applied Date",
        "ARRIVAL_DATE": "Arrival Date",
        "APPLY_START_DATE" :"Application Start Date",
        "APPLY_END_DATE" :"Application End Date",
        "APPROVER" :"Approver",
        "LEARNING_CATEGORY": "Learning Category",
        "ENROLLMENT_TIME": "Class time",
        "COURSE_DATE": "Class time",
        "HOURS": "Hours",
        "TIME_OF_HOURS": "Hours",
        "HOUR": "Hours",
        "ENROLLMENT_HOURS": "Total Learning Hours",
        "PASS_STATUS": "Passing Status",
        "COST": "Cost",
        "TEST_SCORE": "Test Score",
        "LEARNING_REPORT": "Learning Report",
        "ENROLLMENT_NUMBER_OF_PEOPLE": "Total learners",
        "DOWNLOAD_NUMBER_OF_PEOPLE": "Download learners",
        "INCOMPLETED_NUMBER_OF_PEOPLE": "Incomplete learners",
        "EXEMPTION_NUMBER_OF_PEOPLE": "Exempted learners",
        "EXEMPTION": "Exemption",
        "APPLY_FOR_EXEMPTION": "Application of exemption",
        "PASSED_NUMBER_OF_PEOPLE": "Passed learners",
        "FAILED_NUMBER_OF_PEOPLE": "Failed learners",
        "DROP_NUMBER_OF_PEOPLE": "Drop learners",
        "LEARNER_SATISFACTION":"Learners' total satisfaction",
        "MANAGER_SATISFACTION":"Course administrators' total satisfaction",
        "PASSED_COUNT": "Pass rate",
        "EXEMPTION_COUNT": "Exemption rate",
        "TOTAL": "Total",
        "ENROLLMENT_STATUS": "Learning Status",
        "CURRENT_PROCESS": "Current process",
        "CHANGE_PASSWORD": "Change the password",
        "INIT_PWD_PLEASE_CHANGE_PWD_PROMPT": "This password is the system default password, please change the password first",
        "CHANGE_LOGIN_PASSWORD": "Change the login password",
        "TEST_QUESTIONNAIRE": "Test and Survey",
        "ALL_COURSE": "All Courses",
        "LATEST_COURSE": "Latest Courses",
        "HOT_COURSE": "Hot Courses",
        "FEATURED_COURSE": "Featured Courses",
        "LATEST_NEWS": "Latest News",
        "ONLINE_COURSE_LEADERBOARD": "Ranking of online course",
        "LATEST_DOCUMENT": "Latest Document",
        "RELATED_SITES": "Related Wedsites",
        "USERNAME": "Username",
        "USER_ACCOUNT": "User Account",
        "ACCOUNT": "Account",
        "NAME": "First Name",
        "LAST_NAME": "Last Name",
        "PASSWORD":"Password",
        "ACTION": "Action",
        "ALL": "All",
        "ORDER": "Order",
        "PASSED_DATE": "Passed Date",
        "SPECIFIC": "Specific",
        "PROGRAM": "Curriculum",
        "COURSE": "Course",
        "LIVE": "Live",
        "NO_LIVE_BROADCAST_YET": "No Live Broadcast Yet",
        "LIVE_NOW": "Join Webinar",
        "LIVE_END": "Live End",
        "LIVE_VIDEO": "End of live broadcast (VOD)",
        "NO_LIVE": "Unable to broadcast",
        "LIVE_NO_VIDEO": "End of live broadcast (NO VOD)",
        "NO_LIVE_CLASS": "Webinar not broadcasted",
        "LECTURER_SETTING_TIME_WRONG": "Lecturer Setting Time Wrong",
        "U_NO_LIVE": "U No Live",
        "CTMS_SERVER_LIVE_ERROR": "CTMS Error",
        "U_SERVER_LIVE_ERROR": "U Server Error",
        "OTHER_LIVE_ERROR": "Other Error",
        "ONLINE_COURSE": "Online Course",
        "CLASS_ROOM_COURSE": "Classroom Course",
        "EXTERNAL_TRAINING": "External Training",
        "INTERNAL_TRAINING": "Internal Training",
        "INTERNAL": "Internal",
        "EXTERNAL": "External",
        "ONLINE_TEST": "Online Test",
        "CLASS_ROOM_TEST": "Classroom Test",
        "TEST": "Test",
        "QUESTIONNAIRE": "Questionnaire",
        "INTERNAL_LICENSE": "Internal Certificate",
        "EXTERNAL_LICENSE": "External Certificate",
        "MY_FAVOURITE": "My favourites",
        "ABOUT_THIS_COURSE": "About Course",
        "ABOUT_THIS_PROGRAM": "About Curriculum",
        "ABOUT_THIS_CERTIFICATE": "About Certificate",
        "TOTAL_NUMBER_OF_CLASSES": "Accumulated learners",
        "COURSE_NAME": "Course Name",
        "PROGRAM_NAME": "Curriculum Name",
        "COURSE_INFO_DETAIL": "Course Details",
        "COURSE_INFO": "Course Info",
        "SESSION": "Class",
        "SESSION_NAME": "Class Name",
        "SESSION_INFO": "Class Info",
        "CLASS_TIME": "Class Time",
        "ENROLL_DEADLINE": "Enrollment Deadline",
        "TEST_DEADLINE": "Test Deadline",
        "VIEW_DEADLINE": "Access Period",
        "FILL_IN_DEADLINE": "Test Period ",
        "LAST_PLAYER": "Last Play",
        "ENROLLMENT_INFO": "Course Info",
        "REFERENCE_DOCUMENT": "References",
        "REFERENCE_COURSE": "References",
        "COURSE_TYPE": "Course Type",
        "INSTRUCTOR": "Lecturer",
        "EVENT_LOCATION": "Location",
        "NUMBER_OF_PEOPLE": "Learners",
        "ENROLL_NUMBER_OF_PEOPLE": "Total Enrollments",
        "ENROLL_TYPE": "Enrollment Type",
        "REMAINING_AMOUNT" : "Available Places",
        "NO_UPPER_LIMIT": "No limit",
        "PENDING_PREDETERMINED_COST": "Estimated cost of each learner",
        "COURSE_ATTRIBUTES": "Course Attributes",
        "COURSE_INTRODUCTION": "Course Introduction",
        "PROGRAM_INTRODUCTION": "Curriculum Introduction",
        "COURSE_OUTLINE": "Course Outline",
        "LEARNING_GOAL": "Learning Objectives",
        "UNDERSTANDING": "Understand",
        "THROUGH_THE_RULES": "Passing Rule",
        "APPLY_STATUS": "Apply Status",
        "SUITABLE_FOR_THE_OBJECT": "Target Audience",
        "SUITABLE_FOR_LEVEL": "Target Level",
        "PREPARATORY_KNOWLEDGE": "Prerequisite Knowledge",
        "DIFFICULTY": "Difficulty Level",
        "DURATION": "Length",
        "PROPERTIES": "Required or Elective",
        "COURSE_ELECTIVE": "Elective",
        "COURSE_REQUIRED": "Required",
        "IS_WILL_EXPIRE": " will expire",
        "LAST_LEARNING_DATE": "Last Learning Date",
        //#Add by w3c, #89088  start
        "DUE_DATE": "Due Date",
        //#Add by w3c, #89088  end
        "OVERALL_RESULT": "Final score",
        "ENROLL_MANAGER": "Enrollment Management",
        "ASSIGNABLE_MEMBER_ENROLL": "Assign Member",
        "ASSIGNABLE_MEMBER_ALTERNATE": "Assign Member on the waining list",
        "UN_ASSIGNABLE_MEMBER_ENROLL": "Cancel Member",
        "ASSIGNABLE_STATUS": "Assigned Status",
        "ASSIGNER": "Assigned By",
        "CLASSMATE": "Classmate",
        "FORUM": "Forum",
        "DESCRIPTION": "Description",
        "CREATE_DATE": "Creation Date",
        "DATE": "Date",
        "BASIC_INFORMATION": "Basic Info",
        "OTHER": "Others",
        "NOTHING": "None",
        "FULL_NAME": "Full Name",
        "EMPLOYEE_NUMBER": "Employee No.",
        "DEPARTMENT": "Department",
        "JOB_TITLE": "Title",
        "EMAIL": "E-mail",
        "OFFICE_PHONE": "Office Phone",
        "ADD_DATE": "Add Date",
        "TOTAL_ENROLLMENT_COUNT": "Courses",
        "REASON": "Reason",
        "DUTY_DAY": "Date Attended",
        "GRADE_NAME": "Grade",
        "DUTY_CODE": "Job Code",
        "ADD_LEARNER": "Add Learners",
        "SELFENROLLED": "Self-enrolled",
        "ASSIGNED": "Assigned",
        "COURSE_DEADLINE": "Course Deadline",
        "DIRECTLY_SPECIFY_DEADLINES": "Set the due date directly",
        "UNLIMITED": "Unlimited",
        "LEARNING_CENTER": "Learning Center",
        "COURSE_LIST": "Course List",
        "LEARNING_RESULT": "Learning Outcome",
        "MINIMUM_VIEWING_TIME": "Minimum View Time",
        "VIEWING_TIME": "View Time",
        "COURSE_TIME": "Course Time",
        "FINISH_TIME": "Complete Time",
        "SELECTED": "Selected",
        "FILES": "Files",
        "LIST_ALL_SUBORDINATE_MEMBERS": "List all the direct members.",
        "LIST_MY_GROUP_MEMBERS": "List my group members.",
        "YOU_HAVE_SELECTED_MEMBERS": "You have select the members",
        "EXECUTION_DATE": "Enrollment Effective Date",
        "DAYS": "Days",
        "AFTER_THE_SUCCESSFUL_REGISTRATION": "After the successful registration",
        "YOU_CAN_SET_A_DURATION_FOR_THE_TRAINEES": "you can set the due date of each learner",
        "STATUS": "Status",
        "REPORT": "Report",
        "SUBMIT_REPORT": "Reports list",
        "SUBMIT_REPORT_DEADLINE": "Submit Report Deadline",
        "SUBMITTED_REPORT": "Submitted Report",
        "UPLOADED_REPORT_LIST": "List of submitted reports",
        "SHOULD_BE_SUBMIT_REPORT": "Must be submitted",
        "HAS_BEEN_PAID": "Submitted",
        "SERIAL_NUMBER": "No.",
        "FILE_NAME": "File name",
        "SCORE": "Score",
        "POINT": "points",
        "NOT_YET_RATED": "Not yet rated",
        "GRADE_QUESTIONS": "Right answer",
        "WRONG_QUESTIONS": "Wrong answer",
        "DATE_OF_PAYMENT": "Submitted Date",
        "APPROVE_STATUS": "Approve Status",
        "COURSE_TITLE": "Course Title",
        "QUESTION_ANALYSIS": "Analyze",
        // #Add by w3c, #86573  start
        "CORRECT_ANSWER": "Correct Answer",
        // #Add by w3c, #86573  start
        // #Add by w3c, #86573 ,merge vip 83077 start
        "REFERENCE_ANSWER": "Reference Answer",
        // #Add by w3c, #86573 ,merge vip 83077 end
        "LECTURER_RATING_REQUIRED": "Require instructors to correct papers",
        "INTRODUCTION": "Introduction",
        "INSTRUCTOR_NAME": "Instructor Name",
        "INSTRUCTOR_PROPERTIES": "Instructor Attributes",
        "INSTRUCTOR_COMPANY": "Instructor Vendor",
        "COMPANY": "Company",
        "EDUCATION": "Academic Background",
        "EXPERIENCE": "Work Experience",
        "CERTIFICATION": "Certificate",
        "EXPERTISE": "Expertise",
        "INSTRUCTOR_PHOTO": "Instructor Photo",
        "INSTRUCTOR_DETAIL": "Instructor Details",
        "BIRTHDAY": "Birthday",
        "INDUCTION_DATE": "Onboard Date",
        "ADDRESS": "Address",
        "MOBILE_PHONE": "Mobile Phone",
        "HOME_PHONE": "Home Phone",
        "MY_PREFERENCE": "My Preference",
        "COURSE_FOLDER_PRESURVEY": "Enroll in survey",
        "COURSE_FOLDER_PRETEST": "Pre-class test",
        "COURSE_FOLDER_CONTENT": "Course content",
        "COURSE_FOLDER_POSTSURVEY": "After class survey",
        "COURSE_FOLDER_POSTTEST": "After class test",
        "COURSE_FOLDER_REFERENCE": "References",
        "COURSE_FOLDER_TEST": "Test",
        "COURSE_FOLDER_SURVEY": "Questionnaire",
        "COURSE_FOLDER": "Course Category",
        "COURSE_FOLDER_LIVE": "Live",
        "VIEW_FILES": "View File",
        "TIME_LEFT": "Time Left",
        "QUESTION_ANSWERED": "Answered Questions",
        "QUESTION_NOT_ANSWERED": "Incomplete Questions",
        "QUESTION_REQUIRED": "Mandatory",
        "TEST_TIME": "Test time limit",
        "CAN_TEST_NUMBER_OF_TIMES": "Maximum number of times this test can be taken",
        "LAST_TEST_NUMBER_OF_TIMES": "Remaining number of times this test can be taken",
        "NUMBER_OF_TIMES": "Number of times",
        "TO_THE_HIGHEST_SCORE": "One highest score",
        "EXAM_SCORE_ADOPTION": "Exam Score Adoption",
        "SELECT_THE_LATEST_ONE": "The latest one",
        "SELECT_THE_HIGHEST_SCORE_ONCE": "One highest score",
        "STAY_TUNED": "Stay Tuned",
        "RELATED_LINKS": "Related Links",
        "COURSE_LINKS": "Course Links",
        "SUMMARY": "Summary",
        "ALL_ANNOUNCEMENTS": "All Announce",
        "VIEW_MY_ANSWERED": "Review My Response",
        "PASSING": "Pass",
        "PROPORTION_OF_PERSONNEL": "Personal Ratios",
        "EXPIRED_ITEMS": "Expired",
        "LEARNER_DURATION_OF_STUDY": "Due date",
        "SESSION_CLASS_DEADLINE": "Due date",
        "DETAILS": "Details",
        "CREDITS": "Credits",
        "TOTAL_CREDITS": "Total Credits",
        "PERSONAL_SETTING": "Personal Setting",
        "PART": "report(s)",
        "ALL_DEPARTMENT": "All departments",
        "NUMBER_OF": "Number of records",
        "PER_PAGE": "Per page",
        "BUSINESS_LEAVE": "Business trips",
        "PERSONAL_LEAVE": "Personal leave",
        "SICK_LEAVE": "Sick leave",
        "TRACKING_OBJECT": "Tracking staff",
        "TRACKING_DEPARTMENT": "Tracking department",
        "TRACKING_PERIOD": "Tracking period",
        "SIZE": "Size",
        "EXPIRED": "Expired",
        "UNEXPIRED": "Unexpired",
        "A_MONTH": "month(s)",
        "ALL_STAFF": "All staff",
        "ANY_TIME_ZONE": "Any time zone",
        "RELATED_TO_ME": "Related",
        "MY_TRAINING": "Mine",
        "THERE_IS_NO_DATA": "There is no data available.",
        "PLEASE_AT": "Please click",
        "SET_THE_CONDITIONS_CONDUCIVE_TO_SEARCH": "to check your settings.",
        "EVALUATION_STAFF": "Evaluation staff",
        "OTHER_NEED": "Other requirement",
        "ADD_ITEM_FORM_STUDY_CATALOG": "Add item form study catalog",
        "SPECIFY_APPLICANT": "specify applicant",
        "TRAINING_PLAN": "Training roadmap planning",
        "TRAINING_BLUEPRINT": "Training roadmap",
        "COMPETENCE_RECOMMEND": "Competence recommend",
        "SELF_DEMANDING": "Self demanding",
        "MANAGER_RECOMMEND": "Manager recommend",
        "ABILITY_RECOMMEND": "Ability recommend",
        "PERSONAL_DEVELOPMENT": "Personal development",
        "SCORE_PASSING": "Pass",
        "SCORE_FAILED": "Fail",
        "LEARNING_STATUS": "Learning status",
        "SOURCE": "Source",
        "ESTIMATED_COMPLETION_DATE": "Estimated completion date",
        "ENROLLMENT_DATE": "Enrollment date",
        "SEARCH_DEPUTY": "Search deputy",
        "WATCH_REPORT": "Study report",
        "CERTIFICATE_NAME": "Certificate name",
        "FILL_IN_END_DATE": "Last day for filling in",
        "ANNOUNCEMENT_TIME": "Announcement time",
        "DUTY": "Duty",
        "INDUCTION": "Induction",
        "YOU_HAVE_ADD_OTHER_REQUIREMENTS": "You have added the following other requirements",
        "YOU_HAVE_SELECTED_COURSES": "You have selected the following Specifies courses",
        "VIEW_ITEM": "View item",
        "THOUSAND": "Thousand",
        "ENCRYPTION": "Encryption",
        "COURSE_CODE": "Course code",
        "MINUTE": "Minutes",
        "CLASSIFICATION": "Classification",
        "RELATED_CERTIFICATE": "Related Certificate",
        "CERTIFICATE_RECOGNIZED_HOURS": "Certificate recognized hours",
        "CERTIFICATE_TYPE": "Certificate type",
        "REWARD_METHOD": "Reward method",
        "VALIDITY_PERIOD": "Validity period",
        "CERTIFICATE_CODE": "Certificate code",
        "PROGRAM_CODE": "Program code",
        "TEST_CODE": "Test code",
        "TEST_TYPE": "Test type",
        "OTHERS": "Other",
        "COUNSELOR_DETAIL": "Counselor detail",
        "LEARNER_DETAIL": "Learner detail",
        "SPECIALTY_COURSE_CLASSIFICATION": "Specialty course classification",
        "SETTING_CLASS_TIME": "Setting class time",
        "TIME_ZONE": "Time-span",
        "TIME_TABLE": "Time table",
        "LUNCH_TIME": "Lunch Time",
        "CYCLE_TIME": "Cycle Time",
        "INTERVAL": "Interval",
        "FULL_AMOUNT": "Full",
        "CASH": "Cash",
        "REMITTANCE": "Remittance",
        "CHEQUE": "Check",
        "PAYEE": "Payee",
        "REMITTANCE_INFORMATION": "Remit Info",
        "THE_TITLE_OF_THE_COMPANY": "Title",
        "BRANCHES": "Branch",
        "RECEIPT_INFORMATION": "Check Info",
        "THE_TITLE_OF_THE_RECEIPT": "Check Title",
        "RECEIPT_EXPIRE_DATE": "Check Expiration Date",
        "RECEIPT_FORMAT": "Check Format",
        "RECEIPT_DELINEATE": "Across Check",
        "ENDORSEMENT_OR_TRANSFERENCE_PROHIBITED": "Endorsement or Transference Prohibited",
        "APPLICATION_CONTENT": "Application Content",
        "COURSE_DATA": "Course data",
        "FILL_IN_OTHER_METHOD": "Please fill in other report score",
        "TEST_HISTORY_SEARCH": "Test history search",
        "ANSWER_DATE":"Answer date",
        "TOTAL_COUNT": "Total {{value}}",
        "AVERAGE_SATISFACTION": "Satisfaction",
        "NUMBER_OF_COURSES_DUE_WITHIN_THIS_WEEK": "Number of courses due within this week",
        "CUMULATIVE_TRAINING_COSTS_FOR_THE_YEAR": "Cumulative training costs for the year",
        "WILL_BE_EXPIRED_COURSES": "course(s)",
        "DOLLARS": "Dollars",
        "THERE_IS_NO_ROADMAP_DATA": "There is no roadmap data",
        "THERE_IS_NO_CERTIFICATE_DATA": "There is no certificate data",
        "REQUISITION_NUMBER": "Application Form Number",
        "TRAINING_NAME": "Training Name",
        "APPLY_THW_WAY": "Application Type",
        "TODAY_IS_NOT_ANY_SCHEDULE": "There is no classroom course today",
        "LEARN_TOTAL_TIME": "Learning total time",
        "PASS_NUMBER": "Pass count",
        "FAILED_NUMBER": "Failed count",
        "EXEMPTION_NUMBER": "Exemption count",
        "TEST_FRACTION": "Test score",
        "COMMUNITY": "Community",
        "CERTIFICATE_INTRODUCTION": "Certificate introduction",
        "COUNSELOR": "Counselor",
        "LANGUAGE": "Language",
        "GENERAL_SESSION": "General class",
        "EXTEND_SESSION": "Extend class",
        "SEARCH_SCOPE": "Search Scope",
        "SEARCH_SCOPE_ALL": "All",
        "SEARCH_SCOPE_DEPARTMENT": "Department",
        "NOTES": "Note",
        "CONTACT_PERSON": "Contact person",
        "CONTACT_PERSON_EMAIL": "Contact person email",
        "CONTACT_PERSON_PHONE": "Contact person phone",
        "TOMORROW_TO_REMIND": "Tomorrow to remind",
        "TOMORROW_IS_NOT_ANY_SCHEDULE": "Tomorrow is not any schedule",
        "TODAY": "Today",
        "DAY": "Day",
        "WEEK_OF_YEAR": "Week {{week}} of {{year}}",
        "ITEM": "Item",
        "PROGRESS_OF_SUBMIT_REPORT": "Progress of submit report",
        "OCCUPY_WAIT_LIST": "Occupied Waitlist",
        "REMAIN_WAIT_LIST": "Remained Waitlist",
        "DAYS_IN_DURATION": "Days in duration",
        "INCLUDE": "Include",
        "REFERENCE_MATERIAL": "Reference material",
        "REFERENCE_MATERIAL_ASSIGNMENT": "Reference material assignment",
        "SUBSIDY_COST": "Subsidy cost",
        "SELF_COST": "Self cost",
        "LAST_EXTERNAL_TRAINING_HISTORY": "Last External Training History",
        "EXTERNAL_TRAINING_APPLY_TIMES_PRE": "external training applications have been approved",
        "EXTERNAL_TRAINING_APPLY_TIMES_POST": "for the learner this year",
        "EXTERNAL_TRAINING_APPLY_COST": "Accrued external training cost",
        "TAX_FREE": "Tax Free",
        "EXTERNAL_TRAINING_REPORT": "Learning Report",
        "EXTERNAL_TRAINING_NO_REPORT_NEED": "No need to submit",
        "UN_PAID": "Not submitted",
        "ORIGIN": "Origin",
        "TRAINING_MATERIAL": "Training Textbook",
        "APPLICANT_INFORMATION": "Applicant(s) Information",
        "PAY_INFORMATION": "Payment Information",
        "VENDOR_RECEIVER_NAME": "Vendor Receiver",
        "APPROVAL_PROCESS_RECORDS": "Approval Process Record(s)",
        "EXTERNAL_TRAINING_APPLY_DETAIL": "External Training Application Detail",
        "FILLER": "Applicant",
        "COMPANY_DETAIL": "Company Detail",
        "DOCUMENT_REPORT": "Document Report",
        "NOT_CREATED": "Not Created",
        "COMPLETION_PERCENTAGE": "Completion Percentage",
        "RECENTLY_COMPLETED_THE_TRAINEES": "Recently Completed The Trainees",
        "THERE_IS_NO_SATISFACTION_DATA": "Satisfaction: No data",
        "FILL_IN_TIME": "Fill in time",
        "ORIGINAL_FACTORY_NAME": "Original factory name",
        "CERTIFIED_SUBJECT": "Certified subject",
        "APPLY_CATEGORY": "Apply category",
        "CERTIFICATE_GET_DATE": "Certificate get date",
        "CERTIFICATE_DEADLINE": "Certificate deadline",
        "NEW_APPLY": "New apply",
        "EXTENSION_APPLY": "Extension apply",
        "PERMANENT": "Permanent",
        "CERTIFICATE_NUMBER": "Certificate number",
        "ONE": "One",
        "TWO": "Two",
        "THREE": "Three",
        "TEST_DATE": "Test date",
        "APPLY_REASON": "Apply reason",
        "TEST_PLAN": "Test plan",
        "DETAIL_ADDRESS": "Address",
        "TEST_COST": "Test cost",
        "ACQUIRE_DATE": "Issued date",
        "VALID_DATE": "Valid date",
        "BONUS": "Reward",
        "CERT_TYPE": "Certificate Type",
        "SUBJECT_TO_USER_GRADE": "Performance",
        "NEVER_EXPIRE": "Always available",
        "EXCERT_ADD_LICENSE_INFO": "Data entry",
        "SELECT_START_END_DATE": "Select start end date",
        "VALID_DATE_START": "Valid date start",
        "VALID_DATE_END": "Valid date end",
        "APPLICABLE_UNITS": "Applicable units",
        "PERCENTAGE_OF_EXAMINATIONS": "Percentage of examinations",
        "CONDITION_NUMBER": "Condition number",
        "HAS_BEEN_CERTIFIED_SUBJECTS": "Has been certified subjects",
        "PASS_THE_EXAM_PROJECT": "Pass the exam project",
        "EXCERT_RELATED_FORM": "Related application forms",
        "APPLY_DATE_START": "Date applied start",
        "APPLY_DATE_END": "Date applied end",
        "EXCERT_APPLY_TEST_DATE": "Test application date",
        "EXCERT_UNAPPLIED_ITEMS": "Items not applied for",
        "BONUS_COST": "Bonus",
        "BONUS_APPLY_DATE": "Reward application date",
        "EXCERT_APPLY_TEST": "Test application",
        "TEST_ITEMS": "Test item",
        "EXCERT_REAL_COMPENSATION": "Actual subsidy",
        "COMPENSATION": "Subsidy",
        "EXCERT_REGISTER_APPLY": "Registration application",
        "REGISTER_APPLY_DATE": "Registration application date",
        "APPLY_INFO": "Apply Information",
        "EXTERNAL_CERT_EXAM_BASE_INFO": "External cert exam base information",
        "CREATE_FROM": "Course source (After approval)",
        "EXTERNAL_AUTO_CREATE": "Create external course automatically",
        "EXTERNAL_ADD_COURSE": "Add learner to the specified class",
        "ASSIGNED_COURSE_CLASS": "Assigned course class",
        "THE_PAYMENT_N_LEARNING_REPORT": "This time submit {{value}} set of learning reports",
        "I_WANT_TO_ENROLL":"I want to enroll",
        "PLAY_THE_COURSE":"Play",
        "YOU_MAY_BE_INTERESTED_IN_THE_FOLLOWING_COURSES": "You may be interested in the following courses",
        "AVERAGE_TRAINING_HOURS_IN_EACH_DEPARTMENT": "Average training hours in each department",
        "EMPLOYEE_TRAINING_HOURS": "Employee training hours",
        "AVERAGE_TRAINING_COSTS": "Average training costs",
        "CUMULATIVE_TRAINING_COSTS_IN_EACH_DEPARTMENT": "Cumulative training costs in each department",
        "EMPLOYEE_CUMULATIVE_TRAINING_COSTS": "Employee cumulative training costs",
        "IN_EACH_DEPARTMENT": "In each department",
        "CLICK_THE_PATH_AND_EXPAND_THE_DATA": "Click the path and expand the data",
        "LICENSE": "Certification",
        "LEARNING_DETAIL_OF_THE_YEAR": "Learning detail of the year",
        "TEACHING_HOURS": "Teaching hour(s)",
        "CERTIFICATE_LIST": "Certificate list",
        "IN": "IN",
        "OUT": "EX",
        "THERE_IS_NO_COURSE_DATA": "There is no course data",
        "THERE_IS_NO_COST_DATA": "There is no cost data",
        "CURRENT_DEPARTMENT": "Current department",
        "LECTURER_TEACHING_DATA": "Lecturer teaching data",
        "LECTURER_TEACHING_SATISFACTION": "Lecturer teaching satisfaction",
        "CUMULATIVE_TEACHING_HOURS": "Cumulative teaching hours",
        "LECTURER_TEACHING_INFORMATION": "Lecturer teaching information",
        "VAT_NUMBER": "VAT number",
        "BANK_NAME": "Bank name",
        "BANK_ACCOUNT": "Bank account",
        "PHONE": "Phone",
        "FAX": "Fax",
        "CONTACT_PERSON_DATA": "Contact person data",
        "URL": "URL",
        "DEPARTMENT_MEMBERS_OF_LEARNING_INFORMATION": "Department members of learning information",
        "NUMBER_OF_TEACHING_SESSIONS": "Number of teaching sessions",
        "DOLLARS_NT": " (dollars)(Currency:NT)",
        "WEBSITE": "Web URL",
        "FULL_TEXT_SEARCH_NAME": "Advanced Search",
        "FULL_TEXT_QUERY_NAME": "Search course content and knowledge center.",
        "FULL_TEXT_SEARCH_CONTENT": "Content",
        "MODIFY_DATE": "Modified Date",
        "NO_SEARCH_DATA": "No Search Data",
        "SEARCH_KEYWORD": "Search Keyword",
        "SEARCH_TIME": "Search Time"
      },

      "ACTIONS": actionsConstant,

      "STATUS": statusConstant,

      "MESSAGE": messageConstant,

      "FORM_VALIDATION": formValidationConstant,

      "ERROR": {
        "SERVERS_ERROR": "Server error. Please contact the system administrator.",
        "ACCOUNT_OR_PASSWORD_ERROR": "Wrong account or password!",
        "ERROR_ORIGIN_INCONSISTENT": "Not match the original password.",
        "CODE": httpErrorCodeConstant,
        "SIGN_IN_USER_TIMEOUT": "System timed out, or you logged in from other browsers. Please enter your account and password again",
        "ERROR_MSG_NOT_ADD_DEPUTY_DUE_TO_OVERLAP": "As the staff time and the previous generation of record time overlap and the sector has been set on behalf of the staff, it can not set the staff generation!",
        "SIGN_IN_USER_LIMIT": "The number of concurrent users has reached the limit. Please sign in later",
        "C_SIGN_IN_USER_DISABLED": "This account was disabled, please contact administrator",
        "SIGN_IN_USER_NOT_FOUND": "This account cannot be found in the system",
        "PLEASE_ENTER_OLD_PWD": "Please enter old password",
        "PLEASE_ENTER_NEW_PWD": "Please enter a new password",
        "PLEASE_ENTER_NEW_PWD_AGAIN": "Please enter new password again",
        "NEW_PWD_INCONSISTENT": "The new password does not match, please re-enter",
        "OLD_NEW_PWD_CONSISTENT": "The new password must not be the same as the old password",
        "ERROR_PASSWORD_MUST_MORE_THAN_FOUR" : "The password must contain at least 4 characters",
        "ERROR_PASSWORD_MUST_LESS_THAN_20": "Password should not contain more than 20 characters",
        "ERROR_FULL_TEXT_KEYWORD_LENGTH": "Please input at least two words."
      },

      "YOU_DONT_HAVE_ACCESS": "You don't have access privilege."
    });
  }
  angular
    .module('eHRD.modules.language')
    .config(local);
})();

/**
 * Created by Bruce on 2016/5/27.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.index', []);

})();

/**
 * Created by Bruce on 2016/5/18.
 */

(function () {
  'use strict';

  function homepageService($rootScope, Restangular) {

    /*
     * Build collection /homepage
     */
    var _homepageService = Restangular.all('homepage');


    return{

      getBanners: function (params) {
        /*
        * api/homepage/banners
        * */
        return _homepageService
              .customGETLIST('banners', params);
      },

      getLatestPublishedCourses: function () {
        /*
        * api/homepage/latest-published-courses
        * */
        return _homepageService
          .customGETLIST('latest-published-courses');
      },

      getLatestNews: function (params) {
        /*
        * api/homepage/latest-news
        * */
        return _homepageService
          .customGETLIST('latest-news',params);
      },

      getLatestNewsDetail: function (newsId) {
        /*
         * api/homepage/latest-news/{newsId}
         * */
        return _homepageService
            .one('latest-news', newsId)
            .get();
      },

      getRecommendedCourses: function () {
        /*
        * api/homepage/recommendedcourses
        * */
        return _homepageService
          .customGETLIST('recommendedcourses');
      },

      getHotCourse: function () {
        /*
        * api/homepage/hot-courses
        * */
        return _homepageService
          .customGETLIST('hot-courses');
      },
      getWebsites: function (params) {
        /*
        * api/homepage/websites
        * */
        return _homepageService
          .customGETLIST('websites', params);
      },
      getComponent: function (params) {
        /*
         * api/homepage/websites
         * */
        return _homepageService
          .customGETLIST('component',params);
      }

    };

  }

  angular.module('eHRD.modules.index')
    .factory('homepageService',homepageService)
    ;

})();

/**
 * Created by Alan on 2017/4/26.
 * Modified by Vanish 2018/06/06
 */
(function() {
  'use strict';

  var relatedSites = {
    bindings: {
      subject: '=',
      size: '@'
    },
    templateUrl: 'app/modules/index/views/related-sites.html',
    controller: ['$mdDialog','homepageService', 'sitemapService',
      function($mdDialog,homepageService, sitemapService) {
        var vm = this;
        vm.subject = this.subject;
        var projectId = sitemapService.getProject('projectId');
        homepageService.getWebsites({size:this.size, projectId: projectId}).then(function(relatedSites) {
          vm.relatedSites = relatedSites;
        });
		
		 vm.relatedSitesMore = function(mode, event) {
          $mdDialog.show({
            templateUrl: 'app/modules/index/views/related-sites-more-dialog.html',
            controller: ['homepageService', 'mode', '$mdDialog', 'NgTableParams', '$state',
              function (homepageService, mode,  $mdDialog, NgTableParams, $state) {
              var vm = this;
              vm.mode = mode;

              vm.getAllSites = function(){
                vm.mode=1;
                vm.relatedsitesTable = new NgTableParams({}, {
                  counts: [1,5,10,15],
                  getData: function(tableParams) {
                    var params = {};
                    params.current_page = tableParams.url().page;
                    params.list_size = tableParams.url().count;
                    params.projectId = projectId;
                    return homepageService.getWebsites(params).then(function (relatedSites) {
                      tableParams.total(relatedSites.metadata.pagination.total);
                      return relatedSites;
                    });
                  }
                });
              };

              if(vm.mode===1)
                vm.getAllSites();

              vm.close = function() {
                $mdDialog.cancel();
              };


            }],
            controllerAs:'$ctrl',
            clickOutsideToClose: true,
            targetEvent: event,
            locals: {
              mode: mode
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        };
      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('relatedSites', relatedSites);
})();


/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var onlineCourseLeaderBoard = {
    bindings: {
      subject: '='
    },
    templateUrl: 'app/modules/index/views/online-course-leader-board.html',
    controller: ['homepageService',
      function(homepageService) {
        var vm = this;
        vm.subject = this.subject;
        homepageService.getHotCourse().then(function(course) {
          vm.hotCourse = course;
        });
      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('onlineCourseLeaderBoard', onlineCourseLeaderBoard);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var latestNews = {
    bindings: {
      subject: '=',
      size: '@'
    },
    templateUrl: 'app/modules/index/views/latest-news.html',
    controller: ['$mdDialog', 'homepageService', 'sitemapService',
      function($mdDialog, homepageService, sitemapService) {
        var vm = this;
        vm.subject = this.subject;
        var projectId = sitemapService.getProject('projectId');
        homepageService.getLatestNews({size: this.size, projectId: projectId}).then(function(latestNews) {
          vm.latestNews = latestNews;
        });

        vm.latestNewsMore = function(mode, newsId, event) {
          $mdDialog.show({
            templateUrl: 'app/modules/index/views/latest-news-more-dialog.html',
            controller: ['homepageService', 'mode', 'newsId', '$mdDialog', 'NgTableParams', '$state',
              function (homepageService, mode, newsId, $mdDialog, NgTableParams, $state) {
              var vm = this;
              vm.mode = mode;

              vm.getAllNews = function(){
                vm.mode=1;
                vm.latestnewsTable = new NgTableParams({}, {
                  counts: [1,5,10,15],
                  getData: function(tableParams) {
                    var params = {};
                    params.current_page = tableParams.url().page;
                    params.list_size = tableParams.url().count;
                    params.projectId = projectId;
                    return homepageService.getLatestNews(params).then(function (latestNews) {
                      tableParams.total(latestNews.metadata.pagination.total);
                      return latestNews;
                    });
                  }
                });
              };

              vm.getNews = function(newsId){
                vm.mode=0;
                homepageService.getLatestNewsDetail(newsId).then(function (news) {
                  vm.news =news;
                });

              };

              if(vm.mode===1)
                vm.getAllNews();
              else
                vm.getNews(newsId);

              vm.close = function() {
                $mdDialog.cancel();
              };

              vm.toCourseInfo = function(titleUrl) {
                var courseType = titleUrl.split('_')[0];
                var courseId = titleUrl.split('_')[1];
                if(courseType!=='64' && courseType!=='128')
                  $state.go('courseResourceCatalog.CourseInfo', {cid: 0, courseId:courseId, backState: 'courseResourceCatalog'});
                else
                  $state.go('courseResourceCatalog.ProgramInfo', {cid: 0, programId:courseId, backState: 'courseResourceCatalog'});
              }

            }],
            controllerAs:'$ctrl',
            clickOutsideToClose: true,
            targetEvent: event,
            locals: {
              mode: mode,
              newsId: newsId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        };

      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('latestNews', latestNews);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var latestCourse = {
    bindings: {
      subject: '='
    },
    templateUrl: 'app/modules/index/views/latest-course.html',
    controller: ['$state', '$filter', 'courseResourceService', '$window', '$document', '$scope', '$timeout',
      function($state, $filter, courseResourceService, $window, $document, $scope, $timeout) {
        var vm = this;
        vm.subject = this.subject;

        var latestCoursesDescriptionTemp = [];
        vm.delayStatus = false;

        courseResourceService.getLatestCourses().then(function(latestCourses) {
          vm.selectedItemId = (latestCourses.length > 0 ? latestCourses[0].itemId : -1);
          vm.latestCoursesInfo = (latestCourses.length > 0 ? latestCourses[0] : null);
          if (600 < $window.innerWidth && $window.innerWidth < 720) {
            vm.delayStatus = true;
          } else {
            vm.delayStatus = false;
          }
          angular.forEach(latestCourses, function (item, index) {
            if (index < 4){
              if ($window.innerWidth >= 420) {
                if (item.description.length >80) {
                  latestCourses[index].description  = item.description.slice(0, 80) + '...';
                  latestCoursesDescriptionTemp.push(item.description.slice(0, 80) + '...');
                } else {
                  latestCoursesDescriptionTemp.push(item.description);
                }

              } else {
                latestCoursesDescriptionTemp.push("");
              }
            }
          });
          vm.latestCourses = latestCourses;
        });

        $scope.$watch(function(){
          return $window.innerWidth;
        },function(){
          if ($window.innerWidth < 420) {
            angular.forEach(vm.latestCourses, function (item, index) {
              if (index <4) {
                if (item.description.length >0)
                  vm.latestCourses[index].description  = '';
              }
            });
            vm.delayStatus = false;
          } else if ($window.innerWidth >= 420) {
            if (600 < $window.innerWidth && $window.innerWidth < 720) {
              vm.delayStatus = true;
            } else {
              vm.delayStatus = false;
            }
            angular.forEach(vm.latestCourses, function (item, index) {
              if (index <4) {
                vm.latestCourses[index].description  = latestCoursesDescriptionTemp[index];
              }
            });
          }
        });




        vm.showLatestPublishedCourses = function (itemId, delayStatus) {
          if (!delayStatus) {
            if (600 < $window.innerWidth && $window.innerWidth < 720) {
              $timeout(function () {
                vm.latestCoursesInfo = $filter('filterBy')(vm.latestCourses, ['itemId'], itemId)[0];
              },700);
            } else {
              vm.latestCoursesInfo = $filter('filterBy')(vm.latestCourses, ['itemId'], itemId)[0];
            }
          } else if(delayStatus) {
            $timeout(function () {
              vm.latestCoursesInfo = $filter('filterBy')(vm.latestCourses, ['itemId'], vm.selectedItemId)[0];
            }, 0);
          }
        };
        vm.courseInfoPage = function(itemId, isCourse) {
          (isCourse) ?
            $state.go('courseResourceCatalog.CourseInfo', {
              cid: 0,
              courseId: itemId
            }): $state.go('courseResourceCatalog.ProgramInfo', {
              cid: 0,
              programId: itemId
          });
        };
      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('latestCourse', latestCourse);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var knowledgeManagementCenter = {
    bindings: {
      subject: '='
    },
    templateUrl: 'app/modules/index/views/knowledge-management-center.html',
    controller: ['knowledgeManagementCenterService',
      function(knowledgeManagementCenterService) {
        var vm = this;
        vm.subject = this.subject;
        knowledgeManagementCenterService.newDocuments({
          'size': 3
        }).then(function(documents) {
          vm.latestDocuments = documents;
        });

      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('knowledgeManagementCenter', knowledgeManagementCenter);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function() {
  'use strict';

  var index = {
    bindings: {},
    templateUrl: 'app/modules/index/views/index.html',
    controller: ['homepageService', 'calendarService', 'courseResourceService', '$state', '$filter', '$translate', 'sitemapService',
      function(homepageService, calendarService, courseResourceService, $state, $filter, $translate, sitemapService) {
        var vm = this;
        vm.leftComponents = [];
        vm.rightComponents = [];
        vm.customizeContent = [];
        var customizeContentCount = 0;
        var projectId = sitemapService.getProject('projectId');
        homepageService.getComponent({projectId:projectId}).then(function(components) {
          vm.components = $filter('orderBy')(components, 'orderNum');
          angular.forEach(vm.components, function(component){
            var subject = "";
            switch ($translate.use()){
              case 'en-us':
                subject = component.titleEN;
                break;
              case 'zh-tw':
                subject = component.titleTW;
                break;
              case 'zh-cn':
                subject = component.titleCN;
                break;
            }

            component['content'] =  getContent(component, subject, component.showNumber);
            switch(component.location) {
              case 1:
                vm.leftComponents.push(component);
                break;
              case 2:
                vm.rightComponents.push(component);
                break;
            }
          });
        });

        function getContent(component, subject, showNumber) {
          var content = "";
          switch(component.type) {
            case 1:
              vm.latestCourse = subject;
              content = '<latest-course subject="$ctrl.latestCourse"></latest-course>';
              break;
            case 2:
              vm.incompleteCourse = subject;
              content = '<incomplete-course subject="$ctrl.incompleteCourse"></incomplete-course>';
              break;
            case 3:
              vm.featuredCourse = subject;
              content = '<featured-course subject="$ctrl.featuredCourse"></featured-course>';
              break;
            case 4:
              vm.knowledgeManagementCenter = subject;
              content = '<knowledge-management-center subject="$ctrl.knowledgeManagementCenter"></knowledge-management-center>';
              break;
            case 5:
              vm.latestNews = subject;
              content = '<latest-news subject="$ctrl.latestNews" size="' + showNumber +'"></latest-news>';
              break;
            case 6:
              content = '<div  date-picker="$ctrl.viewDate" view="date" min-view="date" max-view="date" date-events="$ctrl.minDateEvents" ' +
                                'date-change="$ctrl.getCalendarEvents" watch-direct-changes="true" show-event-lightbox="true" permission ' +
                                'permission-only="[\'Modules.course.classroom\',\'Modules.course.classroomtest\']">' +
                          '</div>';
              break;
            case 7:
              vm.onlineCourseLeaderBoard = subject;
              content = '<online-course-leader-board subject="$ctrl.onlineCourseLeaderBoard"></online-course-leader-board>';
              break;
            case 8:
              vm.relatedSites = subject;
              content = '<related-sites subject="$ctrl.relatedSites" size="' + showNumber +'"></related-sites>';
              break;
            case 10:
              vm.customizeContent[customizeContentCount] = component.customizeContent;
              content = '<div class="th-web"><header> <h5>' + subject + '</h5></header><empty-iframe content="$ctrl.customizeContent['+ customizeContentCount +']"></empty-iframe>';
              customizeContentCount++;
              break;
          }
          return content;
        }

        homepageService.getBanners({prjId: projectId}).then(function(banners) {
          vm.banners = banners;
          vm.sbannerSpeed = 5000;
          switch(sitemapService.getProject('bannerRotateSpeed')) {
            case 1:
              vm.sbannerSpeed = 3000;
              break;
            case 2:
              vm.sbannerSpeed = 5000;
              break;
            case 3:
              vm.sbannerSpeed = 7000;
              break;
            case 4:
              vm.sbannerSpeed = -1;
              break;
          }
        });

        vm.minDateEvents = [];
        vm.viewDate = moment(new Date());

        vm.getCalendarEvents = function(date, isOnlyDay) {
          isOnlyDay = isOnlyDay || false;
          if (!isOnlyDay) {
            getCalendarWithOneBeforeAndAfter(date);
          }
          calendarService.getCalendarEvents(date, true).then(function(data) {
            angular.forEach(data, function(event, index) {
              var eventDate = moment(new Date(event.dateStr)).set({
                'hour': event.endTime.split(':')[0],
                'minute': event.endTime.split(':')[1],
                'second': "0"
              });
              if (eventDate.isBefore(moment(new Date()))) {
                data[index].isExpired = true;
              }
            });
            vm.dateEvents = data;
          });
        };

        var getCalendarWithOneBeforeAndAfter = function(baseDate) {
          if (!moment.isMoment(baseDate)) baseDate = moment(baseDate);
          vm.minDateEvents = [];
          var moreAction = function () {
            $state.go('myCalendar');
          };
          var linkAction = function (event) {
            event = event || undefined;
            if(angular.isDefined(event) && angular.isDefined(event.sessionId)){
              courseResourceService.getEnrollment(event.sessionId, false).then(function (enrollment) {
                $state.go('learningPassport.incompleteCourses.courseInfo', {'enrollmentId': enrollment.enrollmentId});
              });
            }
          };
          calendarService.getCalendarWithOneBeforeAndAfter(baseDate).then(function(data) {
            vm.minDateEvents = calendarService.minCalendarProcess(data, true, moreAction, linkAction);
          });
        };
        getCalendarWithOneBeforeAndAfter(vm.viewDate);
      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('index', index);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var incompleteCourse = {
    bindings: {
      subject: '='
    },
    templateUrl: 'app/modules/index/views/incomplete-course.html',
    controller: ['SweetAlert', '$filter', 'incompleteCoursesService',
      function(SweetAlert, $filter, incompleteCoursesService) {
        var vm = this;
        vm.subject = this.subject;
        var incompleteCoursesParams = {
          filter_key: 'courseType;programType',
          filter_value: '1,2,3;0,1',
          sort: 'EnrolledDate',
          order: 'DESC',
          current_page: 1,
          list_size: 3
        };

        incompleteCoursesService.list(incompleteCoursesParams).then(function(data) {
          vm.incompleteCoursesDatas = data;
        });

        vm.isCanView = function(status) {
          return (status !== 'enrollment_approval_pending');
        };

        vm.isCanLearn = function(status,enrollType) {
          if(enrollType===1){
            if(status !== 'not_executed')
              return true;
            else
              return false;
          } else {
            return true;
          }
        };

        vm.showStatus = function(courseType, status) {
          switch (courseType) {
            default: SweetAlert.error($filter('translate')('MESSAGE.MSG_CAN_NOT_TAKE_LESSONS'), $filter('translate')('STATUS.' + status.toUpperCase()));
              break;
            case 4:
            case 5:
            case 6:
              SweetAlert.error($filter('translate')('MESSAGE.MSG_CAN_NOT_TAKE_TEST_QUESTIONNAIRE'), $filter('translate')('STATUS.' + status.toUpperCase()));
              break;
          }
        };

      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('incompleteCourse', incompleteCourse);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var featuredCourse = {
    bindings: {
      subject: '='
    },
    templateUrl: 'app/modules/index/views/featured-course.html',
    controller: ['homepageService',
      function(homepageService) {
        var vm = this;
        vm.subject = this.subject;
        homepageService.getRecommendedCourses().then(function(recommendedCourses) {
          vm.recommendedCourses = recommendedCourses;
        });

      }
    ]
  };

  angular.module('eHRD.modules.index')
    .component('featuredCourse', featuredCourse);
})();

/**
 * Created by Van 2018/9/7
 */
(function () {
  'use strict';
  
   angular
    .module('eHRD.modules.fullTextSearch', []);
})();

/**
 * Created by Van 2018/9/7
 */

(function () {
    'use strict';
  
    function fullTextSearchService($rootScope, Restangular) {
      /* Build collection /full-text-search */
      var _fullTextSearchService = Restangular.all('full-text-search');
  
      return{
        search: function (categoryTreeId, params) {
          return _fullTextSearchService
            .one("node", categoryTreeId)
            .customGETLIST('search', params);
        },
        searchByType: function (categoryTreeId, type, params) {
          return _fullTextSearchService
            .one("node", categoryTreeId)
            .one("type", type)
            .customGETLIST('search', params);
        },
        searchByKey: function (type, key, params) {
          return _fullTextSearchService
            .one("type", type)
            .one(key)
            .customGET('search', params);
        }
      };
    }
  
    angular
      .module('eHRD.modules.fullTextSearch')
      .factory('fullTextSearchService', fullTextSearchService);
})();
  
/**
 * Created by Van on 2018/9/10
 */
(function () {
    'use strict';
  
    trustAsHtml.$inject = ['$sce'];
    function trustAsHtml($sce) {
        return function(string){
            return $sce.trustAsHtml(string);
        }
    };
  
    angular.module('eHRD.modules.fullTextSearch')
      .filter('trustAsHtml', trustAsHtml)
  })();
  
/**
 * Created by Van 2018/9/7
 */
(function () {
    'use strict';
  
    var fullTextSearchList = {
      bindings: {
        nodeId: '=?',
        tabSelect: '=?'
      },
      templateUrl: 'app/modules/full-text-search/views/full-text-search-list.html',
      controller: ['$state', '$stateParams', '$sce', 'fullTextSearchService', 'SweetAlert', '$filter', function ($state, $stateParams, $sce, fullTextSearchService, SweetAlert, $filter) {
        var vm = this;
        vm.nodeId = angular.isDefined($stateParams.nodeId) ? $stateParams.nodeId : 0;
        vm.tabSelect = angular.isDefined($stateParams.tabSelect) ? $stateParams.tabSelect : "";
        vm.hasParams = angular.isDefined($stateParams.params);
        vm.params = vm.hasParams ? $stateParams.params : {};
        vm.templateType = angular.isDefined(vm.params.templateType) ? vm.params.templateType : 'list';
        // Set Default Value
        vm.filter = [];
        vm.sorts = [];
        vm.searchTime = 0;
        vm.infoDatas = [];
        vm.infoDatasByType = [];
        vm.currentDatas = [];
        vm.isLoading = false;
        vm.pagination = {
          currentPage:1,
          perPage:10,
          total:0,
          sort:{sortKey:"", sortMethod:""},
          filter:{filterKey:"", filterValue:""}
        };

        vm.searchByPaging = function(params) {
          // Search All
          // vm.pagination.perPage = params.list_size;
          // vm.pagination.currentPage = params.current_page;
          // vm.setCurrentDatas();
          // Search By Type
          vm.searchByTypeAndPaging(vm.tabSelect, params);
        }
        
        vm.searchByType = function(type) {
          //console.log("searchByType.type : ", type);
          if(!!vm.tabSelect && vm.tabSelect != type){
            vm.params.current_page = 1;
          }
          vm.tabSelect = type;

          // Search All
          // vm.pagination.currentPage = 1;
          // vm.setCurrentDatas();
          // Search By Type
          vm.searchByTypeAndPaging(type, vm.params);
        }

        vm.changeType = function(type){
          if(type == 'Course'){
            $("#timeline").addClass("th-waitCourse");
            $("#timeline").addClass("th-resour");
            vm.filter = [
              {key : 'all', value:'-1', name:'FIELD.ALL', permissions:['Modules.course']},
              {key : 'courseType', value:'2', name:'FIELD.CLASS_ROOM_COURSE', permissions:['Modules.course.classroom']},
              {key : 'courseType', value:'1', name:'FIELD.ONLINE_COURSE', permissions:['Modules.course.online']},
              //{key : 'programType', value:'0', name:'FIELD.PROGRAM', permissions:['Modules.curriculum']},
              {key : 'courseType', value:'3', name:'FIELD.EXTERNAL_TRAINING', permissions:['Modules.course.external']},
              {key : 'courseType', value:'4', name:'FIELD.ONLINE_TEST', permissions:['Modules.course.onlinetest']},
              {key : 'courseType', value:'5', name:'FIELD.CLASS_ROOM_TEST', permissions:['Modules.course.classroomtest']},
              {key : 'courseType', value:'6', name:'FIELD.QUESTIONNAIRE', permissions:['Modules.course.survey']},
              //{key : 'programType', value:'1', name:'FIELD.INTERNAL_LICENSE', permissions:['Modules.certification.inner']},
              {key : 'onlyFavorite', value:'1', name:'FIELD.MY_FAVOURITE', permissions:['Modules.course.online','Modules.course.classroom','Modules.course.external','Modules.curriculum']}
            ]
            vm.sorts = [];
          }else if(type == 'LearningResource'){
            $("#timeline").removeClass("th-waitCourse");
            $("#timeline").removeClass("th-resour");
            vm.filter = [];
            vm.sorts = [
              {key : 'ModifyDate', name:'FIELD.DATE'},
              {key : 'AvgScore', name:'ACTIONS.RATING'},
              {key : 'ClickCount', name:'FIELD.CLICK_COUNT'},
              {key : 'Title', name:'FIELD.TITLE'}
            ];
          }
        }

        /** 分頁查詢 */
        vm.searchByTypeAndPaging = function(type, params) {
          vm.currentDatas = [];
          vm.infoDatasByType[type] = [];
          if(!params.keyword && vm.hasParams) { 
            params.keyword = $(".chat-search.ng-scope").find("input[ng-model='query.keywords']").val(); 
          }
          if(params.keyword != vm.params.keyword){ vm.infoDatasByType = []; }
          if(!type) { type = vm.tabSelect; }
          if(!!type && !!params.keyword) {
            if(checkKeyword(params.keyword)){
              SweetAlert.error('', $filter('translate')( "ERROR.ERROR_FULL_TEXT_KEYWORD_LENGTH"));
            }else{
              //console.log("SearchKeyword : ", params.keyword);
              vm.isLoading = true;
              vm.changeType(type);
              vm.params = params;
              var beginTime = new Date().getTime();
              fullTextSearchService.searchByType(vm.nodeId, type, params).then(function (infoDatas) {
                $(".chat-search.ng-scope").find("input[ng-model='query.keywords']").val(params.keyword);
                vm.pagination = infoDatas.metadata.pagination;
                vm.infoDatasByType[type] = new Array(vm.pagination.total);
                vm.currentDatas = infoDatas;
                vm.searchTime = spendTimeFormat(new Date().getTime() - beginTime);
                //console.log("SearchTime : ", vm.searchTime);
                angular.element("html, body").animate({
                  scrollTop: 0
                }, 10);
                vm.isLoading = false;
              });
            }
          }
        };

        /** 單筆查詢，查詢後替換原資料 */
        vm.searchByKey = function(type, key) {
          //console.log("searchByKey : ", key);
          if(!!type && !!key) {
            vm.isLoading = true;
            fullTextSearchService.searchByKey(type, key, vm.params).then(function (newInfoData) {
              //console.log("newInfoData : ", newInfoData);
              for (var inx in vm.infoDatasByType[type]) {
                if(vm.infoDatasByType[type][inx].key === newInfoData.key){
                  vm.infoDatasByType[type][inx] = newInfoData;
                }
              }
              for (var inx in vm.currentDatas) {
                if(vm.currentDatas[inx].key === newInfoData.key){
                  //console.log("vm.currentDatas[inx] : ", vm.currentDatas[inx]);
                  vm.currentDatas[inx] = newInfoData;
                }
              }
              vm.isLoading = false;
            });
          }
        };

        /** 全部查詢
        vm.search = function(params) {
          console.log("params : ", params);
          if(!params){ params = {}; }
          if(!params.keyword) { params.keyword = vm.params.keyword; }
          if(!!params && !!params.keyword) {
            if(checkKeyword(params.keyword)){
              SweetAlert.error('', $filter('translate')( "ERROR.ERROR_FULL_TEXT_KEYWORD_LENGTH"));
            }else{
              vm.isLoading = true;
              if(!!params.filter_key || !!params.sort){
                vm.filterOrSortCurrentData(params);
              }else{
                console.log("SearchKeyword : ", params.keyword);
                vm.params = params;
                var beginTime = new Date().getTime();
                vm.infoDatasByType = [];
                fullTextSearchService.search(vm.nodeId, params).then(function (infoDatas) {
                  vm.infoDatas = infoDatas;
                  console.log("vm.infoDatas : ", vm.infoDatas);
                  angular.forEach(vm.infoDatas, function(fullTextSearchVo) {
                    if(!vm.infoDatasByType[fullTextSearchVo.type]){
                      vm.infoDatasByType[fullTextSearchVo.type] = [];
                    }
                    vm.infoDatasByType[fullTextSearchVo.type].push(fullTextSearchVo);
                  });
                  console.log("vm.infoDatasByType : ", vm.infoDatasByType);
                  vm.searchByType(vm.tabSelect);
                  vm.searchTime = spendTimeFormat(new Date().getTime() - beginTime);
                  console.log("SearchTime : ", vm.searchTime);
                  vm.isLoading = false;
                });
              }
            }
          }
        };
        vm.search(vm.params); */

        /** 重新顯示分頁資料 for 全部查詢
         * 1. 判斷目前所在頁面為何(課程、知識管理中心...)，決定要顯示的資料來源
         * 2. vm.currentDatas為當前頁面資料物件，找出分頁資料存入 
        vm.setCurrentDatas = function(){
          vm.currentDatas = [];
          var fullTextDatas = vm.infoDatasByType[vm.tabSelect];
          if(!!fullTextDatas){
            vm.pagination.total = fullTextDatas.length;
            var end = vm.pagination.currentPage * vm.pagination.perPage;
            var start = end - vm.pagination.perPage;
            for (var index = start; index < end; index++) {
              if(index < fullTextDatas.length){
                vm.currentDatas.push(fullTextDatas[index]);
              }
            }
          }
        }
         */
        
        /** 在前端處理資料篩選及排序 for 全部查詢
         * 1. 課程為資料篩選，從vm.infoDatas過濾出指定類型的資料
         * 2. 知識管理中心為排序，直接對vm.learningResourceInfoDatas進行排序
         * 3. 更新vm.pagination，重新顯示分頁資料 
        vm.filterOrSortCurrentData = function(params){
          if(vm.tabSelect == 'Course'){
            vm.infoDatasByType[vm.tabSelect] = [];
            angular.forEach(vm.infoDatas, function(fullTextSearchVo) {
              if(fullTextSearchVo.type == vm.tabSelect){
                if(params.filter_key == 'courseType' && fullTextSearchVo.courseType == params.filter_value){
                  vm.infoDatasByType[vm.tabSelect].push(fullTextSearchVo);
                }else if(params.filter_key == 'onlyFavorite' && params.filter_value == '1' && fullTextSearchVo.favorite){
                  vm.infoDatasByType[vm.tabSelect].push(fullTextSearchVo);
                }
              }
            });
            vm.pagination.filter.filterKey = params.filter_key;
            vm.pagination.filter.filterValue = params.filter_value;
          }else if(vm.tabSelect == 'LearningResource'){
            vm.infoDatasByType[vm.tabSelect] = vm.infoDatasByType[vm.tabSelect].sort(function (a, b) {
              var compared = a[params.sort] > b[params.sort];
              if(params.sort == "modifyDate"){
                compared = new Date(a[params.sort]) > new Date(b[params.sort]);
              }
              if(params.order == "ASC"){
                return compared ? 1 : -1;
              }else{
                return compared ? -1 : 1;
              }
            });
            vm.pagination.sort.sortKey = params.sort;
            vm.pagination.sort.sortMethod = params.order;
          }
          vm.setCurrentDatas();
          vm.isLoading = false;
        }
         */

        // 毫秒轉為時間格式00:00:00.0
        function spendTimeFormat(spendTime){
          var second = ((spendTime / 1000) % 60).toFixed(3);
          var minute = Math.floor((spendTime / (1000 * 60)) % 60);
          var hour = Math.floor((spendTime / (1000 * 60 * 60)) % 24);
          return hour+":"+minute+":"+second;
        }
        // 檢核輸入關鍵字不可過短
        function checkKeyword(keyword) {
          if(keyword.length == 1){
            var char = keyword.charCodeAt(0);
            // /u4e00-/u9fa5 (中文)
            if(char >= 0x4E00 && char <= 0x9FA5) {
              return true;
            }
            // /u0800-/u4e00 (日文)
            if(char >= 0x0800 && char <= 0x4E00) {
              return true;
            }
          }
          return false;
        }
      }]
    };
  
    angular
      .module('eHRD.modules.fullTextSearch')
      .component('fullTextSearchList', fullTextSearchList);
  })();
  
/**
 * Created by Van on 2018/9/12.
 */
(function () {
    'use strict';
  
    var fullTextSearchLearningresourceInfo = {
      bindings: {
        infoData: '=',
        reloadFn: '&?'
      },
      templateUrl: 'app/modules/full-text-search/views/full-text-search-learningresource-info.html',
      controller: [ function(){
        var vm = this;
        vm.infoData = this.infoData;
        vm.reloadFn = angular.isFunction(this.reloadFn) ? this.reloadFn : null;
      }]
    };
  
    angular.module('eHRD.modules.fullTextSearch')
      .component('fullTextSearchLearningresourceInfo', fullTextSearchLearningresourceInfo);
  })();
  
/**
 * Created by Van on 2018/9/12.
 */
(function () {
    'use strict';
  
    var fullTextSearchCourseInfo = {
      bindings: {
        infoData: '=',
        reloadFn: '&?',
        nodeId: '=?',
        backState: '@?',
        params: '=?'
      },
      templateUrl: 'app/modules/full-text-search/views/full-text-search-course-info.html',
      controller: ['$stateParams', function($stateParams){
        var vm = this;
        vm.infoData = this.infoData;
        vm.reloadFn = angular.isFunction(this.reloadFn) ? this.reloadFn : null;
        vm.nodeId = angular.isDefined(this.nodeId) && vm.nodeId > 0 ? this.nodeId : undefined;
        vm.backState = angular.isDefined(this.backState) ? this.backState : undefined;
        vm.params = angular.isDefined(this.params) ? this.params : {};
        function templateTypeChange(){
          vm.templateType = angular.element("#timeline").hasClass("th-card") ? 'card' : 'list';
          vm.params.templateType = vm.templateType;
        };
        templateTypeChange();
        angular.element("#timeline").find(".array").bind("click", function(){
          templateTypeChange();
        });
      }]
    };
  
    angular.module('eHRD.modules.fullTextSearch')
      .component('fullTextSearchCourseInfo', fullTextSearchCourseInfo);
  })();
  
/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.forum', []);

})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var forum = {
    bindings: {},
    templateUrl: 'app/modules/forum/views/forum.html',
    controller: ['$stateParams', 'serverSetting', function( $stateParams, serverSetting ){
      var vm = this;
      if($stateParams.url.length > 0){
        vm.url = serverSetting.baseConfig.baseURL + '/' + $stateParams.url;

        if (angular.isDefined($stateParams.threadId)) {
          vm.url += $stateParams.threadId;
        }
      }              
    }]
  };

  angular.module('eHRD.modules.forum')
    .component('forum', forum);
})();

/**
 * Created by Bruce on 2016/10/6.
 */

(function () {
  'use strict';

  angular
    .module('eHRD.modules.fileProcess',[
      'angularFileUpload',
      'ngFileUpload'
    ]);

})();

/**
 * Created by Bruce on 2016/10/6.
 */

(function () {
  'use strict';

  fileProcessService.$inject = ['Restangular', 'serverSetting', 'fileProcess'];
  function fileProcessService(Restangular, serverSetting, fileProcess){

    /*
     * Build collection api/file
     */
    var _FileService = Restangular.all('file');

    return{

      learningReportUpload: function (enrollmentId, formData, isReplace) {
        /*
        * api/file/learning-report/{enrollmentId}/upload
        * */

        var url = serverSetting.baseConfig.baseApiFileProcessPath + 'learning-report/' + enrollmentId + '/upload';
        return new fileProcess.fileUpload(url, formData, 'File_Report', 'POST', (angular.isDefined(isReplace) ? isReplace : false));
      },

      learningReportUploadAction: function (enrollmentId, actionType, params) {
        /* PUT
         * api/file/learning-report/{enrollmentId}/action/{actionType}?reportid={reportId}&iscourse={isCourse}
         * */
        return _FileService
               .one('learning-report', enrollmentId)
               .one('action', actionType)
               .put(params);
      },

      learningReportSetScore: function (enrollmentId, data, params) {
        /* PUT
         * api/file/learning-report/86/set-report-score?iscourse={isCourse}&batchId={batchId}
         * */
        return _FileService
          .one('learning-report', enrollmentId)
          .customPUT(data, 'set-report-score', params, {});
      },

      getLearningReportList: function(enrollmentId, params){
        /* GET
         * api/file/learning-report/{enrollmentId}/flies?iscourse={isCourse}
         * */

        return _FileService
               .one('learning-report', enrollmentId)
               .customGETLIST('flies', params);

      },

      getLearningReport: function(params){
        /* GET
         * api/file/learning-report/session/files?courseId={courseId}&programId={programId}
         * */

        return _FileService
          .one('learning-report')
          .one('session')
          .customGETLIST('files', params);

      },

      getLearningReportStatus: function(enrollmentId, params){
        /* GET
         * api/file/learning-report/{enrollmentId}/status
         * */

        return _FileService
          .one('learning-report', enrollmentId)
          .customGET('status', params);

      },

      applyOtherReportApproval: function (enrollmentId, itemType, params) {
        /* PUT
         * api/file/learning-report/{enrollmentId}/itemType/{itemType}
         * */
        return _FileService
          .one('learning-report', enrollmentId)
          .one('itemType', itemType)
          .put(params);
      },

      getReportProcess: function (enrollmentId, params) {
        /*
         * api/file/learning-history/{enrollmentId}/report-process?isCourse={isCourse}
         * */
        return _FileService
          .one('learning-history', enrollmentId)
          .customGET('report-process', params);
      }

    };
  }

  angular
    .module('eHRD.modules.fileProcess')
    .factory('fileProcessService', fileProcessService);

})();

/**
 * Created by Bruce on 2016/10/6.
 */

(function () {
  'use strict';

  fileProcess.$inject = [];
  function fileProcess(){
    var provider = this;
    provider.$get = defaultFileProcess;

    defaultFileProcess.$inject = ['$auth', 'FileUploader', 'Upload', 'serverSetting', '$filter'];
    function defaultFileProcess($auth, FileUploader, Upload, serverSetting, $filter) {
      var _headers = {};
      var _filters = [];
      var fileMaxSize = $auth.getUserData().learningReportFileSize;
      function formatFileSize(bytes) {
        var unit = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
        var level = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(level))).toFixed(2) + unit[level];
      }

      function checkFileExtension(filename) {
        var unvalidFileExtensions = [
          "DLL","ACTION","APK","APP","BAT","BIN","CMD","COM","COMMAND","CPL","CSH","EXE","GADGET","INF1","INS","INX","IPA",
          "ISU","JOB","JSE","KSH","LNK","MSC","MSI","MSP","MST","OSX","OUT","PAF","PIF","PRG","PS1","REG","RGS","RUN",
          "SCR","SCT","SHB","SHS","U3P","VB","VBE","VBS","VBSCRIPT","WORKFLOW","WS","WSF","WSH","JSP","0XE","73K","89K",
          "A6P","AC","ACC","ACR","ACTM","AHK","AIR","APP","ARSCRIPT","AS","ASB","AWK","AZW2","BEAM","BTM","CEL","CELX",
          "CHM","COF","CRT","DEK","DLD","DMC","DOCM","DOTM","DXL","EAR","EBM","EBS","EBS2","ECF","EHAM","ELF","ES","EX4",
          "EXOPC","EZS","FAS","FKY","FPI","FRS","FXP","GS","HAM","HMS","HPF","HTA","IIM","IPF","ISP","JAR","JS","JSX","KIX",
          "LO","LS","MAM","MCR","MEL","MPX","MRC","MS","MS","MXE","NEXE","OBS","ORE","OTM","PEX","PLX","POTM","PPAM","PPSM",
          "PPTM","PRC","PVD","PWC","PYC","PYO","QPX","RBX","ROX","RPJ","S2A","SBS","SCA","SCAR","SCB","SCRIPT","SMM","SPR",
          "TCP","THM","TLB","TMS","UDF","UPX","URL","VLX","VPM","WCM","WIDGET","WIZ","WPK","WPM","XAP","XBAP","XLAM","XLM",
          "XLSM","XLTM","XQT","XYS","ZL9"
        ];

        var extension = filename.substring(filename.lastIndexOf('.') + 1);
        for (var j = 0; j < unvalidFileExtensions.length; j++) {
          var curExtension = unvalidFileExtensions[j];
          if (extension.toUpperCase() == curExtension) {
            alert(filename + ' : ' + $filter('translate')('FILE_TYPE_ERROR', {value: curExtension}));
            return false;
          }
        }
        return true;
      }

      function FileProcessInit(maxSize) {
        _filters = [];
        maxSize = maxSize || fileMaxSize;
        _headers[serverSetting.webServiceSetting.defaultAuthHeader] = serverSetting.webServiceSetting.defaultAuthToken + ' ' + $auth.getToken();
        _filters.push(
          { name: 'sizeFilter',
            fn: function(item) {
              if (!checkFileExtension(item.name)) {
                return false;
              } else if (item.size > maxSize) {
                alert(item.name + ' : ' + $filter('translate')('FILE_SIZE_ERROR', {value: formatFileSize(maxSize)}));
                return false;
              } else {
                return true;
              }
            }
          });
      }

      return {
        /**
         * Creates Default fileUpload Process
         * @url {String}
         * @formData [{Object}]
         * @fieldName {String} Default value is file
         * @requestMethod {String} Default value is POST
         * @isAutoUpload {String} Default value is False
         */
        fileUpload: function (url, formData, fieldName ,requestMethod, isAutoUpload, maxSize) {
          new FileProcessInit(maxSize);
          formData = formData || [];
          fieldName = fieldName || 'file';
          requestMethod = requestMethod || 'POST';
          isAutoUpload = isAutoUpload || false;
          url = serverSetting.baseConfig.baseURL + url;

          return new FileUploader({
            url: url,
            headers: _headers, //Headers to be sent along with the files. HTML5 browsers only.
            alias: fieldName, // Name of the field which will contain the file, default is file
            formData: formData, // Data to be sent along with the files
            queue: [], // Items to be uploaded
            progress: 1, // Upload queue progress percentage. Read only.
            filters: _filters, // Filters to be applied to the files before adding them to the queue. If the filter returns true the file will be added to the queue
            autoUpload: isAutoUpload, // Automatically upload files after adding them to the queue
            method: requestMethod, // It's a request method. By default POST. HTML5 browsers only.
            removeAfterUpload: true, // Remove files from the queue after uploading
            isHTML5: true, // true if uploader is html5-uploader. Read only.
            isUploading: true, // true if an upload is in progress. Read only.
            queueLimit: 5, // maximum count of files
            withCredentials: true // enable CORS. HTML5 browsers only.
          });
        },

        upload: function (url, formData, fileFieldName, files ,requestMethod) {
          new FileProcessInit();
          formData = formData || {};
          fileFieldName = fileFieldName || 'file';
          files = files || {};
          requestMethod = requestMethod || 'POST';
          url = serverSetting.baseConfig.baseURL + url;
          angular.forEach(files, function (file, index) {
            var _index = parseInt(index) + 1;
            formData[fileFieldName+_index] = angular.isUndefined(file) ? '' : file;
          });

          return new Upload.upload({
            url: url,
            data: formData,
            objectKey: 'k',
            arrayKey: '[i]',
            method: requestMethod,
            headers: _headers, // only for html5
            withCredentials: true
          });
        },

        checkUploadSize: function(files) {
          var isPass = true;
          angular.forEach(files, function (file) {
            if(angular.isDefined(file) && file.size > fileMaxSize) {
              isPass = false;
              alert(file.name + ' : ' + $filter('translate')('FILE_SIZE_ERROR', {value: formatFileSize(fileMaxSize)}));
            }
          });
          return isPass;
        },

        checkUploadType: function(files) {
          var isPass = true;
          angular.forEach(files, function (file) {
            if(angular.isDefined(file) && !checkFileExtension(file.name)) {
              isPass = false;
            }
          });
          return isPass;
        }
      };
    }
  }

  angular
    .module('eHRD.modules.fileProcess')
    .provider('fileProcess', fileProcess);

})();

/**
 * Created by Bruce on 2016/10/6.
 */

(function () {
  'use strict';

  fileProcessConfig.$inject = ['$provide', '$translatePartialLoaderProvider'];
  function fileProcessConfig($provide, $translatePartialLoaderProvider) {

    $translatePartialLoaderProvider.addPart('modules/file-process');

    $provide.decorator('FileUploader', ['$delegate', function(FileUploader) {
      // $delegate is FileUploader
      // add new method
      // FileUploader.prototype.yourMethod = function() {/*code*/};
      // override default over class ("nv-file-over")
      // FileUploader.FileOver.prototype.overClass = 'your-class-name';

      return FileUploader;
    }])
  }
  angular
    .module('eHRD.modules.fileProcess')
    .config(fileProcessConfig);

})();

/**
 * Created by Bruce on 2016/11/24.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.dashboard', []);

})();

/**
 * Created by Bruce on 2016/9/22.
 */
(function () {
  'use strict';

  userDashboardService.$inject = ['Restangular'];
  function userDashboardService(Restangular) {
    var _UserDashboardService = Restangular.all('dashboard');

    return {

      getLearningHourUnit: function(params) {
        /*
         * api/dashboard/learner/learning-hour-unit
         **/
         return _UserDashboardService.one('learner').customGET('learning-hour-unit', params);
      },

      getUserToDo: function () {
        /*
        * api/dashboard/learner/todo
        * */
        return _UserDashboardService
              .one('learner')
              .customGET('todo');
      },
      getUserToDoNewCourse : function () {
        /*
         * api/dashboard/learner/todo-new-course
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('todo-new-course');
      },
      getTrainingHours: function (params) {
        /*
         * api/dashboard/learner/training-hours
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('training-hours', params);
      },

      getLearningGraph: function (params) {
        /*
         * api/dashboard/learner/learning-graph
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('learning-graph', params);
      },

      getPlatformNews: function (params) {
        /*
        * api/dashboard/learner/latest-news?minuteofago={ minuteOfAgo }&shownum={ showNum }
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('latest-news', params);
      },

      getCoursePassCount: function (params) {
        /*
         * api/dashboard/learner/course-pass-count
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('course-pass-count', params);
      },

      getOnlineCourseHours: function (params) {
        /*
         * api/dashboard/onlinecourse-hours
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('onlinecourse-hours', params);
      },

      getMyLearningHistoryItem: function (params) {
        /*
        * api/dashboard/learner/my-learning-history?shownum={shownum}
        * */
        return _UserDashboardService
          .one('learner')
          .customGETLIST('my-learning-history', params);
      },

      getInCompleteItems: function (params) {
        /*
        * api/dashboard/learner/incomplete-items?dayfago={dayOfAgo}&course-type={courseType}
         * */
        return _UserDashboardService
          .one('learner')
          .customGETLIST('incomplete-items', params);
      },

      getDistributionMap: function (params) {
        /*
         * api/dashboard/learner/distribution-map
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('distribution-map', params);
      },

      getRoadmapProgress: function (params) {
        /*
         * api/dashboard/learner/roadmap-progress
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('roadmap-progress', params);
      },

      getCertProgress: function (params) {
        /*
         * api/dashboard/learner/cert-progress
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('cert-progress', params);
      },

      getCertSum: function (params) {
        /*
         * api/dashboard/learner/cert-sum
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('cert-sum', params);
      },

      getAnnualExternalCost: function (params) {
        /*
         * api/dashboard/learner/annual-external-cost
         * */
        return _UserDashboardService
          .one('learner')
          .customGET('annual-external-cost', params);
      },

      getComponent:function(params){
        /*
         * api/dashboard/learner/component
         * */

        return _UserDashboardService
          .one('learner')
          .customGETLIST('component', params);
      },

      getTrainingCost:function(params){
        /*
         * api/dashboard/learner/training-cost
         * */

        return _UserDashboardService
          .one('learner')
          .customGET('training-cost', params);
      },

      getTrainingDetail:function(params){
        /*
         * api/dashboard/learner/training-detail
         * */

        return _UserDashboardService
          .one('learner')
          .customGET('training-detail', params);
      }


    };

  }

  angular.module('eHRD.modules.dashboard')
    .factory('userDashboardService', userDashboardService);
})();

/**
 * Created by Alan on 2016/12/23.
 */
(function () {
  'use strict';

  departmentDashboardService.$inject = ['Restangular'];
  function departmentDashboardService(Restangular) {
    var _DepartmentDashboardService = Restangular.all('dashboard');

    return {

      getManagerGroup: function (params) {
        /*
        * api/dashboard/manager/manager-group
        * */
        return _DepartmentDashboardService
              .one('manager')
              .customGETLIST('manager-group', params);
      },

      getGroupTrainingHours: function (params) {
        /*
         * api/dashboard/manager/group-training-hours?groupId={groupId}
         * */
        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-training-hours', params);
      },

      getGroupCost: function (params) {
        /*
         * api/dashboard/manager/group-cost?groupId={groupId}&year={year}
         * */
        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-cost', params);
      },

      getGroupMonthCost: function (params) {
        /*
         * api/dashboard/manager/group-month-cost?groupId={groupId}&year={year}
         * */
        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-month-cost', params);
      },

      getGroupIncompletedCourse: function (params) {
        /*
         * api/dashboard/manager/group-incompleted-course?groupId={groupId}
         * */
        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-incompleted-course', params);
      },

      getGroupUserInfo: function (params) {
        /*
         * api/dashboard/manager/group-user-info?groupId={groupId}
         * */
        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-user-info', params);
      },

      getGroupAttendance: function (params) {
        /*
         * api/dashboard/manager/group-attendance?groupId={groupId}&year={year}
         * */
        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-attendance', params);
      },

      getGroupCompletion: function (params) {
        /*
         * api/dashboard/manager/group-completion?groupId={groupId}&year={year}
         * */
        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-completion', params);
      },

      getGroupTrainingHoursDetail: function (params) {
        /*
         * api/dashboard/manager/group-training-hours-detail?groupId={groupId}
         * */

        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-training-hours-detail', params);
      },

      getGroupUserTrainingHoursDetail: function (params) {
        /*
         * api/dashboard/manager/group-user-training-hours-detail?groupId={ groupId }
         * */

        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-user-training-hours-detail', params);
      },

      getGroupTrainingCostDetail: function (params) {
        /*
         * api/dashboard/manager/group-training-cost-detail?groupId={groupId}
         * */

        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-training-cost-detail', params);
      },

      getGroupUserTrainingCostDetail: function (params) {
        /*
         * api/dashboard/manager/group-user-training-cost-detail?groupId={ groupId }
         * */

        return _DepartmentDashboardService
          .one('manager')
          .customGET('group-user-training-cost-detail', params);
      }
    };

  }

  angular.module('eHRD.modules.dashboard')
    .factory('departmentDashboardService', departmentDashboardService);
})();

/**
 * Created by Alan on 2017/7/6.
 */

(function () {
  'use strict';

  lecturerInfoDialog.$inject = ['$mdDialog'];
  function lecturerInfoDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        lecturerId: '='
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/dashboard/views/manager/lecturer-info-dialog.html',
            controller: ['$mdDialog', 'instructorService', 'lecturerId',
              function ($mdDialog, instructorService, lecturerId) {
                var vm = this;
                vm.getData = function(params) {
                  instructorService.getTeachingRecord(lecturerId, params).then(function(lecturerInfo) {
                    vm.lecturerInfo = lecturerInfo;
                    vm.lecturerPagination = lecturerInfo.metadata.pagination;
                    vm.learnerTotlaScore = lecturerInfo.metadata.learnerTotlaScore;
                    vm.classroomTotalHour = lecturerInfo.metadata.classroomTotalHour;
                    vm.instructorInfo = lecturerInfo.metadata.instructorInfo;
                    vm.teachingTimes = lecturerInfo.metadata.teachingTimes;
                  });
                };

                vm.getData();

                vm.close = function() {
                  $mdDialog.cancel();
                };

              }],
            multiple: true,
            targetEvent: ev,
            controllerAs: '$ctrl',
            clickOutsideToClose:true,
            locals : {
              lecturerId: scope.lecturerId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });

      }
    };
    return directive;
  }

  angular.module('eHRD.modules.dashboard')
    .directive('lecturerInfoDialog', lecturerInfoDialog);

})();

/**
 * Created by Alan on 2017/6/8.
 */

(function () {
  'use strict';

  averageTrainingHoursDialog.$inject = ['$mdDialog'];
  function averageTrainingHoursDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        groupId: '='
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/dashboard/views/manager/average-training-hours-dialog.html',
            controller: ['$mdDialog', 'departmentDashboardService', 'groupId', '$q',
              function ($mdDialog, departmentDashboardService, groupId, $q) {
                var vm = this;
                vm.drillId = groupId;
                vm.chartColors = ['#83ccc5','#0277bd','#f48fb1'];
                vm.getGroupTrainingHours = function(id){
                  departmentDashboardService.getGroupTrainingHours({groupId: id }).then(function(groupTrainingHours){
                    vm.groupTrainingHours = groupTrainingHours;
                  });
                };

                vm.drillFn = function(id) {
                  var defer = $q.defer();
                  departmentDashboardService.getGroupTrainingHoursDetail({groupId: id}).then(function(data){
                    vm.getGroupTrainingHours(id);

                    vm.groupName = data.groupName;
                    if(data.subGroupIds.length === 0) {
                      departmentDashboardService.getGroupUserTrainingHoursDetail({groupId: id}).then(function(data){
                        vm.groupTrainingHoursParams = {
                          categories: data.userNames,
                          series: data.dataObject,
                          isClick: false,
                          subGroupIds: data.userIds,
                          parentGroupId: vm.parentGroupId
                        };
                        vm.isShowGroupUserTrainingHoursDetail = false;
                        defer.resolve(vm.groupTrainingHoursParams);
                      });
                    }
                    else {
                      vm.userDrillFn(id);
                      vm.parentGroupId = data.groupId;
                      vm.groupTrainingHoursParams = {
                        categories: data.subGroupNames,
                        series: data.dataObject,
                        isClick: true,
                        subGroupIds: data.subGroupIds,
                        parentGroupId: data.parentGroupId
                      };
                      vm.isShowGroupUserTrainingHoursDetail = true;
                      defer.resolve(vm.groupTrainingHoursParams);
                    }
                  });

                  return defer.promise;
                };

                vm.userDrillFn = function(id) {
                  departmentDashboardService.getGroupUserTrainingHoursDetail({groupId: id}).then(function(data){
                    vm.groupUserTrainingHoursParams = {
                      categories: data.userNames,
                      series: data.dataObject,
                      hasSubGroups: [],
                      subGroupIds: data.userIds
                    };
                  });
                };

                vm.close = function() {
                  $mdDialog.cancel();
                };

              }],
            multiple: true,
            targetEvent: ev,
            controllerAs: '$ctrl',
            clickOutsideToClose:true,
            locals : {
              groupId: scope.groupId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });

      }
    };
    return directive;
  }

  angular.module('eHRD.modules.dashboard')
    .directive('averageTrainingHoursDialog', averageTrainingHoursDialog);

})();

/**
 * Created by Alan on 2017/6/8.
 */

(function () {
  'use strict';

  averageTrainingCostDialog.$inject = ['$mdDialog'];
  function averageTrainingCostDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        groupId: '='
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/dashboard/views/manager/average-training-cost-dialog.html',
            controller: ['$mdDialog', 'departmentDashboardService', 'groupId', '$q',
              function ($mdDialog, departmentDashboardService, groupId, $q) {
                var vm = this;
                vm.drillId = groupId;
                vm.chartColors = ['#fca333','#f474b1','#81bbde'];
                vm.getGroupTrainingCost = function(id){
                  departmentDashboardService.getGroupCost({groupId: id }).then(function(groupTrainingCost){
                    vm.groupTrainingCost = groupTrainingCost;
                  });
                };

                vm.drillFn = function(id) {
                  var defer = $q.defer();
                  departmentDashboardService.getGroupTrainingCostDetail({groupId: id}).then(function(data){
                    vm.getGroupTrainingCost(id);

                    vm.groupName = data.groupName;
                    if(data.subGroupIds.length === 0) {
                      departmentDashboardService.getGroupUserTrainingCostDetail({groupId: id}).then(function(data){
                        vm.groupTrainingCostParams = {
                          categories: data.userNames,
                          series: data.dataObject,
                          isClick: false,
                          subGroupIds: data.userIds,
                          parentGroupId: vm.parentGroupId
                        };
                        vm.isShowGroupUserTrainingCostDetail = false;
                        defer.resolve(vm.groupTrainingCostParams);
                      });
                    }
                    else {
                      vm.userDrillFn(id);
                      vm.parentGroupId = data.groupId;
                      vm.groupTrainingCostParams = {
                        categories: data.subGroupNames,
                        series: data.dataObject,
                        isClick: true,
                        subGroupIds: data.subGroupIds,
                        parentGroupId: data.parentGroupId
                      };
                      vm.isShowGroupUserTrainingCostDetail = true;
                      defer.resolve(vm.groupTrainingCostParams);
                    }
                  });

                  return defer.promise;
                };

                vm.userDrillFn = function(id) {
                  departmentDashboardService.getGroupUserTrainingCostDetail({groupId: id}).then(function(data){
                    vm.groupUserTrainingCostParams = {
                      categories: data.userNames,
                      series: data.dataObject,
                      hasSubGroups: [],
                      subGroupIds: data.userIds
                    };
                  });
                };

                vm.close = function() {
                  $mdDialog.cancel();
                };

              }],
            multiple: true,
            targetEvent: ev,
            controllerAs: '$ctrl',
            clickOutsideToClose:true,
            locals : {
              groupId: scope.groupId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });

      }
    };
    return directive;
  }

  angular.module('eHRD.modules.dashboard')
    .directive('averageTrainingCostDialog', averageTrainingCostDialog);

})();

/**
 * Created by Alan on 2017/6/29.
 */
(function() {
  'use strict';

  var yearAccumulatedTrainingCosts = {
    bindings: {
      distributionMaps: '='
    },
    templateUrl: 'app/modules/dashboard/views/learning/year-accumulated-training-costs.html',
    controller: ['$timeout', '$scope', '$filter', 'PermPermissionStore', function($timeout, $scope, $filter, PermPermissionStore) {
      var vm = this;
      var permission = null;
      permission = PermPermissionStore.getPermissionDefinition('Modules.certification');
      vm.hasCertificationPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.curriculum');
      vm.hasCurriculumPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.course');
      vm.hasCoursePermission = angular.isDefined(permission);

      vm.distributionMaps = this.distributionMaps;
      $scope.$watch(function(){
        return vm.distributionMaps;
      },function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)) {
          $timeout(function() {
            vm.pies = [];
            if(vm.hasCertificationPermission) {
              vm.pies.push({
                categoryName: $filter('translate')('FIELD.LICENSE'),
                sum: vm.distributionMaps.certCost
              });
            }

            if(vm.hasCoursePermission) {
              vm.pies.push({
                categoryName: $filter('translate')('FIELD.EXTERNAL_TRAINING') + $filter('translate')('FIELD.COURSE'),
                sum: vm.distributionMaps.externalCost
              });
            }

            if(vm.hasCurriculumPermission) {
              vm.pies.push({
                categoryName: $filter('translate')('FIELD.INTERNAL_TRAINING') + $filter('translate')('FIELD.COURSE'),
                sum: vm.distributionMaps.internalCost
              });
            }

          }, 1000);
        }
      });

      vm.colorOpacity = function(color) {
        var c = d3.rgb(color).darker(0.1);
        return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + '0.5' + ')';
      }
    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('yearAccumulatedTrainingCosts', yearAccumulatedTrainingCosts);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var trainingRoadMapProgress = {
    bindings: {
      roadmapProgress: '=',
      trainingRoadButtonClose: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/learning/training-road-map-progress.html',
    controller: [function() {
        var vm = this;
        vm.roadmapProgress = this.roadmapProgress;
        vm.trainingRoadButtonClose = angular.isDefined(this.trainingRoadButtonClose)? this.trainingRoadButtonClose: false;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('trainingRoadMapProgress', trainingRoadMapProgress);
})();

/**
 * Created by Alan on 2017/6/29.
 */
(function() {
  'use strict';

  var totalBlock = {
    bindings: {
      blockBackground: '@',
      isMaterialIcon: '=',
      icon: '@',
      count: '=',
      blockTitle: '@'
    },
    templateUrl: 'app/modules/dashboard/views/learning/total-block.html',
    controller: [function() {
      var vm = this;
      vm.blockBackground = this.blockBackground;
      vm.isMaterialIcon = this.isMaterialIcon;
      vm.icon  = this.icon;
      vm.count = this.count;
      vm.blockTitle = this.blockTitle;
    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('totalBlock', totalBlock);
})();

/**
 * Created by Alan on 2017/6/1.
 */
(function () {
  'use strict';

  var rateProgressBars = {
    bindings: {
      progressTitle: '@',
      progresses: '=',
      valueKey: '@'
    },
    templateUrl: 'app/modules/dashboard/views/manager/rate-progress-bars.html',
    controller: [function () {
      var vm = this;
      vm.progressTitle = this.progressTitle;
      vm.progresses    = this.progresses;
      vm.valueKey      = this.valueKey;
    }]
  };

  angular
    .module('eHRD.modules.utils')
    .component('rateProgressBars', rateProgressBars);

})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var platformLatestNews = {
    bindings: {
      platformNews: '='
    },
    templateUrl: 'app/modules/dashboard/views/learning/platform-latest-news.html',
    controller: [function() {
        var vm = this;
        vm.platformNews = this.platformNews;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('platformLatestNews', platformLatestNews);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var onlineCourseCurve = {
    bindings: {
      learningGraphDatas: '=',
      learningGraph: '='
    },
    templateUrl: 'app/modules/dashboard/views/learning/online-course-curve.html',
    controller: ['userDashboardService', 'defaultFontFamily', '$filter', '$timeout', '$scope',
      function(userDashboardService, defaultFontFamily, $filter, $timeout, $scope) {
      var vm = this;
      vm.learningGraphDatas = this.learningGraphDatas;
      vm.learningGraph = this.learningGraph;

      $scope.$watch(function(){
        return vm.learningGraphDatas;
      },function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)) {
          $timeout(function() {
            vm.lineChartConfig = {
              options: {
                chart: {
                  type: 'areaspline',
                  style: {
                    fontFamily: defaultFontFamily
                  }
                },
                credits: false,
                responsive: true,
                exporting: {
                  enabled: false
                },
                tooltip: {
                  valueSuffix: $filter('translate')("FIELD.HOUR")
                }
              },
              series: [{
                name: $filter('translate')("FIELD.LEARNING_HOURS"),
                data: vm.learningGraphDatas
              }],
              title: {
                text: ''
              },
              xAxis: {
                categories: vm.learningGraph.lineChart.labels
              },
              yAxis: {
                title: {
                  text: $filter('translate')("FIELD.TIME_OF_HOURS")
                }
              },

              size: {
                height: "265"
              },
              loading: false
            };
            vm.chartFinish = true;
          }, 1000);
        }
      });


        // vm.dashboardData.learningGraph.lineChart.data = [];
        // vm.dashboardData.learningGraph.lineChart.series = ['學習時數'];
        // vm.dashboardData.learningGraph.lineChart.datasetOverride = [{
        //   yAxisID: 'y-axis-1'
        // }];
        // vm.dashboardData.learningGraph.lineChart.options = {
        //   scales: {
        //     yAxes: [{
        //       id: 'y-axis-1',
        //       type: 'linear',
        //       display: true,
        //       position: 'left'
        //     }]
        //   }
        // };
        //
        // var learningGraphDatas = [];
        // angular.forEach(learningGraph, function(learningGraphData) {
        //   var monthName = $filter('numberToMonth')(learningGraphData.month);
        //   vm.dashboardData.learningGraph.lineChart.labels.push($filter('translate')(monthName));
        //   learningGraphDatas.push(learningGraphData.hours)
        // });
        // vm.dashboardData.learningGraph.lineChart.data.push(learningGraphDatas);
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('onlineCourseCurve', onlineCourseCurve);
})();

/**
 *Created by Alan on 2017/6/1.
 */
(function() {
  'use strict';

  var monthCumulativeTrainingCosts = {
    bindings: {
      trainingCosts: '=',
      isGroupMonthCostNoData: '='
    },
    templateUrl: 'app/modules/dashboard/views/manager/month-cumulative-training-costs.html',
    controller: [
      function() {
        var vm = this;
        vm.trainingCosts = this.trainingCosts;
        vm.isGroupMonthCostNoData = this.isGroupMonthCostNoData;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('monthCumulativeTrainingCosts', monthCumulativeTrainingCosts);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var learningResume = {
    bindings: {
      myLearningHistoryItems: '=',
      isManager: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/learning/learning-resume.html',
    controller: [function() {
      var vm = this;
      vm.myLearningHistoryItems = this.myLearningHistoryItems;
      vm.isManager = angular.isUndefinedOrNull(this.isManager)?false:this.isManager;
    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('learningResume', learningResume);
})();

/**
 * Created by Alan on 2017/6/29.
 */
(function() {
  'use strict';

  var learningDetail = {
    bindings: {
      categories: '=',
      series: '='
    },
    templateUrl: 'app/modules/dashboard/views/learning/learning-detail.html',
    controller: ['defaultFontFamily', '$timeout', '$scope', function(defaultFontFamily, $timeout, $scope) {
      var vm = this;
      vm.categories = this.categories;
      vm.series = this.series;
      $scope.$watch(function(){
        return vm.categories;
      },function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)) {
          $timeout(function() {
            vm.chartConfig = {
              options: {
                chart: {
                  type: 'column',
                  style: {
                    fontFamily: defaultFontFamily
                  }
                },
                colors: ['#7EB9DC', '#FCA333' ,'#5CB65F','red'],
                credits: false,
                responsive: true,
                exporting: {
                  enabled: false
                }
              },
              title: {
                text: ''
              },
              xAxis: {
                labels: {
                  style: {
                    fontSize:'15px',
                    fontWeight: 'bold'
                  }
                },
                categories: vm.categories
              },
              yAxis: {
                tickInterval: 1,
                title: {
                  text: ''
                }
              },
              series: vm.series,
              size: {
                height: "255"
              },
              loading: false
            };
            vm.isNoData = true;
            angular.forEach(vm.series, function(series){
              angular.forEach(series.data, function(data){
                if(data > 0)
                  vm.isNoData = false;
              });
            });
            vm.chartFinish = true;
          }, 0);
        }
      });
    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('learningDetail', learningDetail);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var learningDashboard = {
    bindings: {},
    templateUrl: 'app/modules/dashboard/views/learning-dashboard.html',
    controller: [ 'sitemapService', 'PermPermissionStore', 'userDashboardService', '$filter', 'calendarService', 'defaultFontFamily', 'courseResourceService',
      function( sitemapService, PermPermissionStore, userDashboardService, $filter, calendarService, defaultFontFamily, courseResourceService ){
      var vm = this;
      vm.dashboardData = {};
      vm.today = new Date();
      vm.statsBy = '';

      vm.getData = function(){
        userDashboardService.getUserToDo().then(function(userToDoData) {
          vm.dashboardData.userToDo = userToDoData;
        });

        courseResourceService.getLatestCourses().then(function(latestCourses) {
          vm.dashboardData.toDoDataNewCourse = latestCourses.length;
        });

        var prjId = sitemapService.getProject('projectId');
        userDashboardService.getLearningHourUnit({projectId: prjId}).then(function(result) {
          vm.statsBy = result.unit==1 ? 'year': 'quarter';
          return userDashboardService.getTrainingHours({statsBy: vm.statsBy});
        }).then(function(trainingHours) {
          vm.dashboardData.trainingHours = trainingHours;
        })
      };

      vm.getData();

    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('learningDashboard', learningDashboard);
})();

/**
 * Created by Alan on 2017/7/3.
 */
(function () {
  'use strict';

  var learningDashboardBlocks = {
    bindings: {
      userId: '=?',
      reloadFn: '&?',
      isManager: '=?',
      trainingRoadButtonClose: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/learning-dashboard-blocks.html',
    controller: [ 'userDashboardService', 'calendarService', 'userService', 'sitemapService', '$filter',
      function( userDashboardService, calendarService, userService, sitemapService, $filter ){
      var vm = this;
      vm.dashboardData = {};
      vm.isManager = angular.isUndefinedOrNull(this.isManager)?false:this.isManager;
      var userId = angular.isUndefinedOrNull(this.userId)?userService.getKernelUser().userId:this.userId;
      vm.trainingRoadButtonClose = angular.isDefined(this.trainingRoadButtonClose)? this.trainingRoadButtonClose: false;
      vm.getData = function(){
        if(angular.isFunction(this.reloadFn)) {
          this.reloadFn();
        }
        var projectId = sitemapService.getProject('projectId');
        userDashboardService.getComponent({projectId:projectId, viewType:(vm.isManager)?1:0}).then(function(components) {
          vm.components = $filter('orderBy')(components, 'orderNum');
          angular.forEach(vm.components, function(component){
            vm.position = "th-board col-xs-12 col-sm-6 col-lg-4";
            vm.positionTwo = "th-board col-xs-12 col-sm-12 col-lg-8";
            if(component.isDisplay===1) {
              switch(component.type) {
                case 0:
                  var calendarParams = {
                    userId: userId
                  };
                  calendarService.getCalendar(moment().format('YYYY'), moment().format('MM'), moment().format('DD'), calendarParams).then(function (calendar) {
                    vm.calendar = calendar;
                  });
                  component.content = '<classroom-course-schedule ng-class="$ctrl.position" class="href" calendar="$ctrl.calendar" is-manager="$ctrl.isManager"></classroom-course-schedule>';
                  break;
                case 1:
                  userDashboardService.getInCompleteItems({'dayfago':90, userId: userId}).then(function (inCompleteItems) {
                    vm.inCompleteItems = inCompleteItems;
                  });
                  component.content = '<classroom-course-incomplete ng-class="$ctrl.position" is-manager="$ctrl.isManager" in-complete-items="$ctrl.inCompleteItems" reload-fn="$ctrl.getData()"></classroom-course-incomplete>';
                  break;
                case 2:
                  userDashboardService.getMyLearningHistoryItem({shownum:4, userId: userId}).then(function (myLearningHistoryItems) {
                    vm.myLearningHistoryItems = myLearningHistoryItems;
                  });
                  component.content = '<learning-resume ng-class="$ctrl.position" is-manager="$ctrl.isManager" my-learning-history-items="$ctrl.myLearningHistoryItems"></learning-resume>';
                  break;
                case 3:
                  userDashboardService.getTrainingDetail({userId: userId}).then(function(learningDetail){
                    vm.learningDetail = learningDetail;
                  });
                  component.content = '<learning-detail ng-class="$ctrl.position" categories="$ctrl.learningDetail.categories" series="$ctrl.learningDetail.series"></learning-detail>';
                  break;
                case 4:
                  userDashboardService.getTrainingCost({userId: userId}).then(function (trainingCost) {
                    vm.trainingCost= trainingCost;
                  });
                  component.content = '<year-accumulated-training-costs ng-class="$ctrl.position" distribution-maps="$ctrl.trainingCost"></year-accumulated-training-costs>';
                  break;
                case 5:
                  userDashboardService.getCoursePassCount({userId: userId}).then(function (coursePassCount) {
                    vm.coursePassCount = coursePassCount;
                  });
                  userDashboardService.getOnlineCourseHours({userId: userId}).then(function (onlineCourseHours) {
                    vm.onlineCourseHours = onlineCourseHours;
                  });
                  component.content = '<accumulation-block ng-class="$ctrl.position" is-manager="$ctrl.isManager" ' +
                    'online-course-hours="$ctrl.onlineCourseHours" course-pass-count="$ctrl.coursePassCount"> </accumulation-block>';
                  break;
                case 6:
                  userDashboardService.getRoadmapProgress({userId: userId}).then(function (roadmapProgress) {
                    vm.roadmapProgress = roadmapProgress;
                  });
                  component.content = '<training-road-map-progress training-road-button-close="$ctrl.trainingRoadButtonClose" ng-class="$ctrl.position" is-manager="$ctrl.isManager" roadmap-progress="$ctrl.roadmapProgress" ></training-road-map-progress>';
                  break;
                case 7:
                  userDashboardService.getCertProgress({userId: userId}).then(function (certProgress) {
                    vm.certProgress = certProgress;
                  });
                  component.content = '<certification-progress ng-class="$ctrl.positionTwo" is-manager="$ctrl.isManager" cert-progress="$ctrl.certProgress"></certification-progress>';
                  break;
                case 8:
                  userDashboardService.getLearningGraph({userId: userId}).then(function(learningGraph) {
                    vm.learningGraph = learningGraph;
                    vm.learningGraph.lineChart = {};
                    vm.learningGraph.lineChart.labels = [];
                    vm.learningGraphDatas = [];
                    angular.forEach(learningGraph, function (learningGraphData) {
                      var monthName = $filter('numberToMonth')(learningGraphData.month);
                      var uppercaseMonthName = $filter('uppercase')(monthName);
                      vm.learningGraph.lineChart.labels.push($filter('translate')("FIELD." + uppercaseMonthName));
                      vm.learningGraphDatas.push(learningGraphData.hours)
                    });
                  });
                  component.content = '<online-course-curve ng-class="$ctrl.positionTwo" learning-graph-datas="$ctrl.learningGraphDatas" learning-graph="$ctrl.learningGraph"></online-course-curve>';
                  break;
                case 9:
                  userDashboardService.getDistributionMap({userId: userId}).then(function (distributionMaps) {
                    vm.distributionMaps= distributionMaps;
                  });
                  component.content = '<distribution-map ng-class="$ctrl.position" distribution-maps="$ctrl.distributionMaps"></distribution-map>';
                  break;
                case 10:
                  userDashboardService.getPlatformNews({minuteofago:1440, shownum:5, userId: userId}).then(function (platformNews) {
                    vm.platformNews = platformNews;
                  });
                  component.content = '<platform-latest-news ng-class="$ctrl.position" platform-news="$ctrl.platformNews"></platform-latest-news>';
                  break;
              }
            }

          });
        });
      };

      vm.getData();

    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('learningDashboardBlocks', learningDashboardBlocks);
})();

/**
 * Created by Alan on 2017/6/1.
 */
(function() {
  'use strict';

  var groupUserInfo = {
    bindings: {
      groupUserInfo: '=',
      groupIncompletedCourse: '='
    },
    templateUrl: 'app/modules/dashboard/views/manager/group-user-info.html',
    controller: ['$filter', '$mdDialog',
      function($filter, $mdDialog) {
        var vm = this;
        vm.groupUserInfo = this.groupUserInfo;
        vm.groupIncompletedCourse = this.groupIncompletedCourse;
        vm.userWillExpireCount = function (userId) {
          return $filter('filter')(vm.groupIncompletedCourse, {userId: userId}, true).length;
        };

        vm.learningDashboardDialog = function(event, groupUserInfo) {
          $mdDialog.show({
            templateUrl: 'app/modules/dashboard/views/learning-dashboard-dialog.html',
            controller: ['$mdDialog', 'groupUserInfo',
              function ($mdDialog, groupUserInfo) {
                var vm = this;
                vm.groupUserInfo = groupUserInfo;
                vm.trainingRoadButtonClose = true;

                vm.close = function() {
                  $mdDialog.cancel();
                };

              }],
            controllerAs:'$ctrl',
            clickOutsideToClose: true,
            targetEvent: event,
            locals: {
              groupUserInfo: groupUserInfo
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        };
    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('groupUserInfo', groupUserInfo);
})();

/**
 * Created by Alan on 2017/6/1.
 */
(function() {
  'use strict';

  var groupIncompletedCourse = {
    bindings: {
      groupIncompletedCourse: '='
    },
    templateUrl: 'app/modules/dashboard/views/manager/group-incompleted-course.html',
    controller: [
      function() {
        var vm = this;
        vm.isMore = 1;
        vm.incompletedCourseCount = 7;
        vm.groupIncompletedCourse = this.groupIncompletedCourse;

        vm.incompletedCourseMore = function(isMore) {
          vm.isMore = (isMore===1)?0:1;
          vm.incompletedCourseCount = (isMore===1)?vm.groupIncompletedCourse.length:7;
        };
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('groupIncompletedCourse', groupIncompletedCourse);
})();

/**
 * Created by Alan on 2017/6/8.
 */
(function() {
  'use strict';

  var drillBarChart = {
    bindings: {
      chartId: '@',
      drillFn: '&?',  //return params: categories, series, isClick, subGroupIds, parentGroupId
      drillId: '=',
      params:  '=?',
      isWatch: '=?', //boolean
      colors:  '=',  //array
      stackLabelsFormat: '@?',
      yAxisText: '=?',
      isThousand: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/manager/drill-bar-chart.html',
    controller: ['$scope', '$mdDialog', '$filter', 'departmentDashboardService', 'defaultFontFamily',
      function($scope, $mdDialog, $filter, departmentDashboardService, defaultFontFamily) {
        Highcharts.setOptions({
          lang: {
            thousandsSep: ','
          }
        });
        var vm = this;
        vm.params  = this.params;
        vm.chartId = this.chartId;
        vm.drillId = this.drillId;
        vm.drillFn = this.drillFn;
        vm.isWatch = angular.isUndefinedOrNull(this.isWatch)?false:this.isWatch;
        vm.isNoData = 1;
        vm.colors  = this.colors;
        vm.stackLabels = angular.isUndefinedOrNull(this.stackLabels)?'':this.stackLabels;
        vm.yAxisText = angular.isUndefinedOrNull(this.yAxisText)?'':this.yAxisText;
        vm.isThousand = angular.isUndefinedOrNull(this.isThousand)?false:this.isThousand;

        if(vm.isWatch) {
          vm.count = 0;
          $scope.$watch(function(){
            return vm.params;
          }, function(data, oldVal) {
            if (!angular.equals(data, oldVal) && !angular.isUndefinedOrNull(data)) {
              if(vm.isNoData === 1) {
                getChart(data);
              }
              else {
                var chart = angular.element('#' + vm.chartId).highcharts();
                vm.drill = data;
                chart.xAxis[0].categories = vm.drill.categories;
                angular.forEach(vm.drill.series, function(value, key) {
                  chart.series[key].update(value);
                });
                chart.setSize(null, setHeight());
              }

            }
          });
        }
        else {
          vm.drillFn({id:  vm.drillId}).then(function (data) {
            getChart(data);
          });
        }

        function getChart(data){
          vm.drill = data;
          vm.isNoData = 0;
          vm.chartConfig = {
            options: {
              chart: {
                type: 'bar',
                spacingRight: 100,
                spacingLeft: 100,
                marginTop: 80,
                style: {
                  fontFamily: defaultFontFamily
                }
              },
              colors: $filter('hexConvertRgba')(vm.colors, (vm.drill.isClick)?1:0.5),
              credits: false,
              responsive: true,
              exporting: {
                enabled: false
              },
              legend: {
                align: 'right',
                verticalAlign: 'top',
                floating: true,
                backgroundColor: '#FFFFFF',
                reversed: true
              },
              plotOptions: {
                series: {
                  pointWidth: 15,
                  PointPadding:20,
                  stacking: 'normal',
                  cursor: 'pointer',
                  point: {
                    events: {
                      click: function (e) {
                        if(vm.drill.isClick) {
                          var chart = angular.element('#' + vm.chartId).highcharts();
                          var id = vm.drill.subGroupIds[e.point.index];
                          vm.drillFn({id: id}).then(function (childDrill) {
                            vm.drill = childDrill;
                            chart.xAxis[0].categories = vm.drill.categories;
                            angular.forEach(vm.drill.series, function(value, key) {
                              value.color = $filter('hexConvertRgba')(vm.colors[key], (vm.drill.isClick)?1:0.5);
                              chart.series[key].update(value);
                            });
                            addButton(childDrill.parentGroupId);

                            chart.setSize(null, setHeight());
                          });
                        }
                      }
                    }
                  },
                  style: {
                    'background-color':'green',
                    opacity:0.1
                  }
                }
              },
              tooltip: {
                valueSuffix: vm.stackLabels
              }
            },
            title: {
              text: ''
            },
            xAxis: {
              categories: vm.drill.categories,
              labels: {
                style:{
                  fontSize: '15px',
                  fontWeight: 'bold'
                },
                y:6
              },
              lineWidth: 0,
              tickLength: 0
            },
            yAxis: {
              min: 0,
              minRange: 1,
              title: {
                text: vm.yAxisText,
                align: "high",
                x: 50,
                y: 0,
                style:{
                  fontSize: '15px',
                  fontWeight: 'bold'
                }
              },
              labels: {
                style:{
                  fontSize: '15px',
                  fontWeight: 'bold'
                },
                formatter: function() {
                  if (this.value.toFixed(0) >= 1000000000000) {
                    return this.value.toFixed(0) / 1000000000000 + 'T';
                  }
                  else if (this.value.toFixed(0) >= 1000000000) {
                    return this.value.toFixed(0) / 1000000000 + 'G';
                  }
                  else if (this.value.toFixed(0) >= 1000000) {
                    return this.value.toFixed(0) / 1000000 + 'M';
                  }
                  else if (this.value.toFixed(0) >= 1000) {
                    return this.value.toFixed(0) / 1000 + 'K';
                  }
                  else {
                    return this.value;
                  }
                }
              },
              stackLabels: {
                enabled: true,
                format: vm.stackLabelsFormat
              }
            },
            series: vm.drill.series,
            size:{
              height: setHeight()
            },
            loading: false
          };
        }

        function addButton(parentGroupId) {
          var normalState = {};
          normalState.style = {color:'rgba(77, 174, 165, 0.7)', 'font-weight': 900};
          normalState.stroke = 'rgba(77, 174, 165, 0.7)';
          normalState.fill = 'white';

          var alignStyle = {
            align: 'right',
            x: -100,
            y: 40
          };
          var chart = angular.element('#' + vm.chartId).highcharts();
          var customButton = chart.renderer.button('↩' + $filter('translate')('ACTIONS.GO_BACK'), 500, null, function(){
            vm.drillFn({id: parentGroupId}).then(function (childDrill) {
              vm.drill = childDrill;
              chart.xAxis[0].categories = vm.drill.categories;
              angular.forEach(vm.drill.series, function(value, key) {
                value.color = $filter('hexConvertRgba')(vm.colors[key], (vm.drill.isClick)?1:0.5);
                chart.series[key].update(value);
              });
              customButton.destroy();
              chart.setSize(null, setHeight());
            });
          }, normalState).add().align(alignStyle, false, null);

        }

        function setHeight() {
          return 120 + vm.drill.categories.length * 50;
        }

      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('drillBarChart', drillBarChart);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var distributionMap = {
    bindings: {
      distributionMaps: '='
    },
    templateUrl: 'app/modules/dashboard/views/learning/distribution-map.html',
    controller: ['$timeout', '$scope', function($timeout, $scope) {
      var vm = this;
      vm.distributionMaps = this.distributionMaps;
      $scope.$watch(function(){
        return vm.distributionMaps;
      },function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)) {
          $timeout(function() {
            vm.distribution = vm.distributionMaps;
          }, 1000);
        }
      });

      vm.colorOpacity = function(color) {
        var c = d3.rgb(color).darker(0.1);
        return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + '0.5' + ')';
      }
    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('distributionMap', distributionMap);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var departmentDashboard = {
    bindings: {},
    templateUrl: 'app/modules/dashboard/views/department-dashboard.html',
    controller: [ '$scope', 'userDashboardService', 'departmentDashboardService', '$filter', 'defaultFontFamily', '$q',
      function( $scope, userDashboardService, departmentDashboardService, $filter, defaultFontFamily, $q){
        var vm = this;
        vm.selectedGroup = null;
        var localeDate = moment.localeData();
        vm.dashboardData = {};
        userDashboardService.getUserToDo().then(function(userToDoData) {
          vm.dashboardData.userToDo = userToDoData;
        });
        vm.getManagerGroup = function(isDefault, keyword) {
          var deferred = $q.defer();
          departmentDashboardService.getManagerGroup({keyword: keyword}).then(function(managerGroup) {
            vm.managerGroup = managerGroup;
            if(isDefault) {
              var allNoIsDefault = false;
              angular.forEach(vm.managerGroup, function (value) {
                if (value.isDefault === 0) {
                  allNoIsDefault = true;
                } else {
                  allNoIsDefault = false;
                  return;
                }
              });
              if (allNoIsDefault) {
                vm.managerGroup[0].isDefault = 1;
              }
              vm.selectGroup($filter('filter')(vm.managerGroup, {'isDefault': 1}, true)[0]);
            }
            else
              deferred.resolve(vm.managerGroup);
          });
          return deferred.promise;
        };

        vm.getManagerGroup(true);

        vm.selectGroup = function(group) {
          if(angular.isObject(group)) {
            var params = {
              groupId: group.groupId
            };
            vm.groupId = group.groupId;
            vm.selectedGroup = group.groupName;
            departmentDashboardService.getGroupTrainingHours(params).then(function (groupTrainingHours) {
              vm.groupTrainingHours = groupTrainingHours;
            });

            departmentDashboardService.getGroupCost(params).then(function (groupCost) {
              vm.groupCost = groupCost;
            });

            departmentDashboardService.getGroupMonthCost(params).then(function (groupMonthCost) {
              vm.groupMonthCost = groupMonthCost;
              vm.isGroupMonthCostNoData = ($filter('filter')(vm.groupMonthCost, {totalCost:-1}, true).length < 12)?0:1;
              vm.trainingCosts = {
                options: {
                  chart: {
                    zoomType: 'xy',
                    style: {
                      fontFamily: defaultFontFamily
                    }
                  },
                  exporting: {
                    enabled: false
                  },
                  credits: false,
                  responsive: true,
                  legend: {
                    enabled: false
                  },
                  tooltip: {
                    formatter: function() {
                      return '<span style="color:' + this.point.color + '">\u25CF</span>' + this.x + ' <b>' + this.y + '</b>';
                    }
                  }
                },
                series: [{
                  type: 'column',
                  yAxis: 0,
                  colorByPoint: false,
                  data: []
                }],
                title: {
                  text: ''
                },
                xAxis: [{
                  categories: localeDate._monthsShort,
                  crosshair: true
                }],
                yAxis: [{ // Primary yAxis
                  min: 0,
                  minRange: 1,
                  labels: {
                    formatter: function(){
                      return this.value;
                    },
                    style: {
                      color: Highcharts.getOptions().colors[1]
                    }
                  },
                  title: {
                    text: '(' + $filter('translate')("FIELD.DOLLARS") + ')',
                    style: {
                      color: Highcharts.getOptions().colors[1]
                    }
                  }
                }],
                size: {
                  height: "150"
                },
                loading: false
              };
              angular.forEach(groupMonthCost, function(groupMonthCost) {
                vm.trainingCosts.series[0].data.push((groupMonthCost.totalCost===-1)?0:groupMonthCost.totalCost);
                if(groupMonthCost.totalCost>=1000) {
                  vm.trainingCosts.yAxis[0].labels.formatter = function(){
                    return this.value.toString().slice(0,-3);
                  };
                  vm.trainingCosts.yAxis[0].title.text = '(' + $filter('translate')("FIELD.THOUSAND") + ')';
                }

              });
            });

            departmentDashboardService.getGroupIncompletedCourse(params).then(function (groupIncompletedCourse) {
              vm.groupIncompletedCourse = groupIncompletedCourse;
            });

            departmentDashboardService.getGroupUserInfo(params).then(function (groupUserInfo) {
              vm.groupUserInfo = groupUserInfo;
            });

            departmentDashboardService.getGroupAttendance(params).then(function (groupAttendance) {
              vm.groupAttendance = groupAttendance;
            });

            departmentDashboardService.getGroupCompletion(params).then(function (groupCompletion) {
              vm.groupCompletion = groupCompletion;
            });
          }
        }


      }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('departmentDashboard', departmentDashboard);
})();

/**
 * Created by Alan on 2017/6/1.
 */
(function() {
  'use strict';

  var cumulativeTrainingCosts = {
    bindings: {
      groupCost: '='
    },
    templateUrl: 'app/modules/dashboard/views/manager/cumulative-training-costs.html',
    controller: [
      function() {
        var vm = this;
        vm.groupCost = this.groupCost;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('cumulativeTrainingCosts', cumulativeTrainingCosts);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var classroomCourseSchedule = {
    bindings: {
      calendar: '=',
      isManager: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/learning/classroom-course-schedule.html',
    controller: [function() {
        var vm = this;
        vm.calendar = this.calendar;
        vm.isManager = angular.isUndefinedOrNull(this.isManager)?false:this.isManager;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('classroomCourseSchedule', classroomCourseSchedule);
})();

/**
 * Created by Alan on 2017/4/26.
 */
(function() {
  'use strict';

  var classroomCourseIncomplete = {
    bindings: {
      inCompleteItems: '=',
      reloadFn: '&?',
      isManager: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/learning/classroom-course-incomplete.html',
    controller: [
      function() {
        var vm = this;
        vm.inCompleteItems = this.inCompleteItems;
        vm.reloadFn = angular.isFunction(this.reloadFn)?this.reloadFn:null;
        vm.isManager = angular.isUndefinedOrNull(this.isManager)?false:this.isManager;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('classroomCourseIncomplete', classroomCourseIncomplete);
})();

/**
 * Created by Alan on 2017/6/30.
 */
(function() {
  'use strict';

  var certificationProgress = {
    bindings: {
      certProgress: '=',
      isManager: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/learning/certification-progress.html',
    controller: ['PermPermissionStore', function(PermPermissionStore) {
      var vm = this;

      vm.hasCertificationInnerPermission = angular.isDefined(PermPermissionStore.getPermissionDefinition('Modules.certification.inner'));
      vm.hasCertificationExtPermission = angular.isDefined(PermPermissionStore.getPermissionDefinition('Modules.certification.ext'));
      vm.certProgress = this.certProgress;
      vm.isManager = angular.isUndefinedOrNull(this.isManager)?false:this.isManager;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('certificationProgress', certificationProgress);
})();

/**
 * Created by Alan on 2017/6/1.
 */
(function() {
  'use strict';

  var averageTrainingHours = {
    bindings: {
      groupTrainingHours: '='
    },
    templateUrl: 'app/modules/dashboard/views/manager/average-training-hours.html',
    controller: [
      function() {
        var vm = this;
        vm.groupTrainingHours = this.groupTrainingHours;
      }
    ]
  };

  angular.module('eHRD.modules.dashboard')
    .component('averageTrainingHours', averageTrainingHours);
})();

/**
 * Created by Alan on 2017/6/29.
 */
(function() {
  'use strict';

  var accumulationBlock = {
    bindings: {
      onlineCourseHours: '=?',
      coursePassCount: '=?',
      isManager: '=?'
    },
    templateUrl: 'app/modules/dashboard/views/learning/accumulation-block.html',
    controller: ['PermPermissionStore', function(PermPermissionStore) {
      var vm = this;
      vm.onlineCourseHours = this.onlineCourseHours;
      vm.coursePassCount  = this.coursePassCount;
      vm.isManager = angular.isUndefinedOrNull(this.isManager)?false:this.isManager;

      vm.hasCourseOnlinePermission = angular.isDefined(PermPermissionStore.getPermissionDefinition('Modules.course.online'));
      vm.hasCoursePermission = angular.isDefined(PermPermissionStore.getPermissionDefinition('Modules.course'));

    }]
  };

  angular.module('eHRD.modules.dashboard')
    .component('accumulationBlock', accumulationBlock);
})();

/**
 * Created by Bruce on 2016/8/27.
 */

(function () {
  'use strict';
  testQuestionnaireService.$inject = ['Restangular', '$filter', 'SweetAlert', '$q', 'serverSetting', '$auth', 'AuthStorage', '$window', '$timeout'];
  function testQuestionnaireService(Restangular, $filter, SweetAlert, $q, serverSetting, $auth, AuthStorage, $window, $timeout){

    /*
     * Build collection api/feedback
     */
    var _testQuestionnaireService = Restangular.all('feedback');

    function setGroupQuestionTranslate (string) {
      var result = string;
      if(string === 'surveybank_group_material' ||
        string === 'table_header_instructor' ||
        string === 'venue' ||
        string === 'facility'||
		string === 'course.resource.type.MATERIAL' ||
		string === 'course.resource.type.INSTRUCTOR' ||
		string === 'course.resource.type.VENUE' ||
		string === 'course.resource.type.FACILITY' ||
		string === 'course.resource.type.EXT_VENDOR'
		){
        result = $filter('translate')("FIELD." + $filter('uppercase')(string))
      }
      return result;
    }

    return {
      getExamInfo: function (sessionId, params) {
        /*
         * api/feedback/exam/{sessionId}/info?itemid={itemId}
         * */
        return _testQuestionnaireService
              .one('exam', sessionId)
              .customGET('info', params);
      },
      getExamResult: function (sessionId, params) {
        /*
         * api/feedback/exam/{sessionId}/result-info?itemid={itemId}&examhistoryId={examHistoryId}
         * */
        return _testQuestionnaireService
          .one('exam', sessionId)
          .customGET('result-info', params);
      },
      getExamQuestionsReview: function (sessionId, params) {
        /*
        * api/feedback/exam/{sessionId}/review-response?itemid={itemId}&examhistoryId={examHistoryId}&show-incorrect={showInCorrect}
        * */
        return _testQuestionnaireService
          .one('exam', sessionId)
          .customGETLIST('review-response', params);
      },

      getExamToken: function (sessionId, params) {
        /*
        * api/feedback/assessment/{sessionId}/redirect?itemid={itemId}
        * */
        return _testQuestionnaireService
              .one('assessment', sessionId)
              .customGET('redirect', params);
      },

      getQuestions: function (sessionId, params) {
        /* questionnaireType != evaluationSurvey
         * api/feedback/exam/{sessionId}/questions?itemid={itemId}&examhistoryId={examHistoryId}
         *
         * questionnaireType = evaluationSurvey
         * api/feedback/ev-survey/questions?relationId={relationId}&amp;surveyId={surveyId}
         * */
        if(angular.isDefined(sessionId)){
          return _testQuestionnaireService
            .one('exam', sessionId)
            .customGETLIST('questions', params);
        }
        else{
          return _testQuestionnaireService
            .one('ev-survey')
            .customGETLIST('questions', params);
          }
      },
      getQuestionsMenu: function (sessionId, params) {
        /*
         * api/feedback/exam/{sessionId}/menu-questions?itemid={itemId}&examhistoryId={examHistoryId}
         * */
        return _testQuestionnaireService
          .one('exam', sessionId)
          .customGETLIST('menu-questions', params);
      },

      getAssessment: function (sessionId) {
        /*
         * api/feedback/assessment/{sessionId}
         * */
        return _testQuestionnaireService
          .one('assessment', sessionId);
      },

      putAjaxTestAnswerTime: function (params, data) {
        /*
         * api/feedback/assessment/{sessionId}/session-time?itemid={itemId}&examhistoryId={examHistoryId}
         * */
        $.ajax({
          url: serverSetting.baseConfig.baseURL + '/api/feedback/assessment/'+ params.sessionId + '/session-time?itemid=' + params.itemId + '&examhistoryId=' + params.examHistoryId,
          type:'POST',
          data: angular.toJson(data),
          contentType:'application/json',
          dataType: 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          async:false,
          headers: {
            'ClientAuthorization': serverSetting.webServiceSetting.defaultAuthToken + ' ' + $auth.getToken(),
            "Content-Type": "application/json;charset=UTF-8",
            "Accept":"application/json, text/plain, */*"
          },
          cache: true
        }).done(function() { });

      },

      // getAssessment2: function (sessionId) {
      //   var deferred = $q.defer(); // 声明延后执行，表示要去监控后面的执行
      //     _testQuestionnaireService.one('assessment', sessionId).get().then(function (data) {
      //       deferred.resolve(data);
      //     }, function (message) {
      //       deferred.reject(message);
      //     });
      //   return deferred.promise;   // 返回承诺，这里并不是最终数据，而是访问最终数据的API
      // },

      // jqueryAjaxTest: function (sessionId) {
      //   $.ajax({
      //     url: baseConfig.baseURL + '/api/feedback/assessment/'+sessionId,
      //     xhrFields: {
      //       withCredentials: true
      //     },
      //     async:false,
      //     headers: {
      //       'Authorization':'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwiZGF0YSI6eyJpZCI6MSwidXNlcm5hbWUiOiJBZG1pbmlzdHJhdG9yIENUTVMiLCJhY2NvdW50IjoiYWRtIiwiUGVybWlzc2lvbnMiOlsiVXNlcnNfTWFuYWdlbWVudCIsIlJvbGVzX01hbmFnZW1lbnQiXSwiUm9sZXMiOlt7IlVzZXIiOlsiVXNlcnNfTWFuYWdlbWVudCIsIlJvbGVzX01hbmFnZW1lbnQiXX1dLCJyYyI6InpoX3R3In0sImV4cCI6MTQ3Mzc1MTY0NiwiaWF0IjoxNDczMTQ2ODQ2fQ.OKWAR_NvjzYgd-BQ7cHhXeUrBYYa_fCgUGdyXUH54OM',
      //       'Accept':'application/json, text/plain, */*'
      //     },
      //     accepts: {
      //       Accept: 'application/json'
      //     },
      //     contentType:'application/x-www-form-urlencoded; charset=UTF-8'
      //
      //   }).done(function(data) { });
      // },

      putTestAnswerTime: function (assessment, data, params) {
        /*
         * api/feedback/assessment/{sessionId}/session-time?itemid={itemId}&examhistoryId={examHistoryId}
         * */
        return assessment.customPOST(data, "session-time", params, {});
      },

      putTestAnswer: function (assessment, data, params) {
        /*
        * api/feedback/assessment/{sessionId}/interaction?itemid={itemId}&examhistoryId={examHistoryId}
        * */
        return assessment.customPOST(data, "interaction", params, {});
      },
      putTestFinish: function (assessment, params) {
        /*
         *api/feedback/assessment/{sessionId}/complete?itemid={itemId}&examhistoryId={examHistoryId}
         * */
        return assessment.customPOST({}, "complete", params, {});
      },

      putEvaluationSurveyAnswer: function (formData, params) {
        /*
         *api/feedback/ev-survey/answers?relationId={ relationId }&amp;surveyId={ surveyId }
         * */
        return _testQuestionnaireService
            .one('ev-survey')
            .customPUT({"answers": formData}, "answers", params, {'Content-Type': 'application/json'});
      },

      getTestHistory: function (sessionId, params) {
        /*
         * api/feedback/exam/{sessionId}/exam-history?itemid={itemId}&startDate={startDate}&endDate={endDate}
         * */
        return _testQuestionnaireService
          .one('exam', sessionId)
          .customGETLIST('exam-history', params);
      },

      getQuestionModel: function (questionnaireData) {
        var questionModel = {};
        angular.forEach(questionnaireData, function (questionsData) {
          questionModel[questionsData.questionId] = questionModelInit(questionsData);
          questionModel[questionsData.questionId].instructor = {};
          angular.forEach(questionsData.instructorQuestions, function (instructor) {
            questionModel[questionsData.questionId].instructor[instructor.raId] = questionModelInit(instructor);
            questionModel[questionsData.questionId].instructor[instructor.raId].raId = instructor.raId;
          });
        });
        return questionModel;
        function questionModelInit (questionsData) {
          var questionModel={};
          questionModel[questionsData.questionId] = {};
          questionModel[questionsData.questionId].index = questionsData.index;
          questionModel[questionsData.questionId].qId = questionsData.questionId;
          questionModel[questionsData.questionId].completed = (questionsData.studentResponse.length>0);
          questionModel[questionsData.questionId].isRequired = questionsData.isRequired;
          questionModel[questionsData.questionId].optionNumber = questionsData.studentResponse;
          questionModel[questionsData.questionId].optionOtherValue = questionsData.otherAnswer;
          questionModel[questionsData.questionId].qType = 'choice';
          questionModel[questionsData.questionId].selectOptionType = questionsData.selectOptionType;
          questionModel[questionsData.questionId].selectedOptionCount = questionsData.selectedOptionCount;
          questionModel[questionsData.questionId].questionType = questionsData.questionType;
          questionModel[questionsData.questionId].surveyGroupId = questionsData.surveyGroupId;
          questionModel[questionsData.questionId].surveyGroupName = questionsData.surveyGroupName;

          switch (questionsData.questionType){
            case 3: case 7:
            questionModel[questionsData.questionId].qType = 'fill-in';
            break;
            case 2:
              questionModel[questionsData.questionId].optionNumber = [];
              if(questionsData.studentResponse.length > 0){
                angular.forEach(questionsData.studentResponse.split(','), function (value) {
                  if(value.length > 0){
                    questionModel[questionsData.questionId].optionNumber.push(parseInt(value));
                  }
                });
              }
              break;
          }
          return questionModel[questionsData.questionId];
        }
      },

      updateQuestionStatus: function (questionModel, questionId) {
        if(Object.keys(questionModel[questionId].instructor).length > 0){
          var completedCount = 0;
          angular.forEach(questionModel[questionId].instructor, function (instructorQuestions) {
            questionModel[questionId].instructor[instructorQuestions.raId].completed = _newModelStatus(questionId, instructorQuestions.optionNumber, instructorQuestions.selectOptionType);
            if(questionModel[questionId].instructor[instructorQuestions.raId].completed) completedCount+=1;
          });

          questionModel[questionId].completed = completedCount === Object.keys(questionModel[questionId].instructor).length;

        }else {
          questionModel[questionId].completed = _newModelStatus(questionId, questionModel[questionId].optionNumber, questionModel[questionId].selectOptionType);
        }
        return questionModel;
        function _newModelStatus(questionId,optionNumber, selectOptionType) {
          if(angular.isNumber(optionNumber) && optionNumber > 0){
            return true;
          }else if(angular.isArray(optionNumber) && optionNumber.length > 0){
            switch (selectOptionType){
              case 2:
                return (!(optionNumber.length < questionModel[questionId].selectedOptionCount));
              default:
                return true;
            }
          }else if(angular.isString(optionNumber) && optionNumber.length > 0){
            return true;
          }else{
            return false;
          }
        }
      },

      getAnswers: function(questionModel, questions, questionId) {
        if(angular.isDefined(questionId)){
          var question = questionModel[questionId];
          return answersProcess(questions, question);
        }else{
          var answers = [];
          angular.forEach(questionModel, function (question) {
            answers.push(answersProcess(questions, question)[0]) ;
          });
          return answers;
        }
        function answersProcess(questions, question) {
          var answers = [];
          var answersData = {};
          answersData.qId = question.qId;
          answersData.qType = question.qType;
          if(!(angular.isDefined(question.optionOtherValue) && question.optionOtherValue.length > 0)){
            answersData.qResponse = (angular.isArray(question.optionNumber) ? question.optionNumber.toString() : question.optionNumber);
            questions[question.index-1].studentResponse = answersData.qResponse;
          }else{
            answersData.qResponse = (angular.isArray(question.optionNumber) ? question.optionNumber.toString() : question.optionNumber);
            answersData.qResponse += ',clOtherAnswer=' + question.optionOtherValue;
            questions[question.index-1].studentResponse = answersData.qResponse;
          }

          answersData.answerInstructor = [];
          if(angular.isDefined(question.instructor)){
            angular.forEach(question.instructor, function (instructorQuestion, key) {
              var instructorAnswersData = {};
              instructorAnswersData.qId = instructorQuestion.qId;
              instructorAnswersData.ruId = instructorQuestion.raId;
              if(!(angular.isDefined(instructorQuestion.optionOtherValue) && instructorQuestion.optionOtherValue.length > 0)){
                instructorAnswersData.ruResponse = (angular.isArray(instructorQuestion.optionNumber) ? instructorQuestion.optionNumber.toString() : instructorQuestion.optionNumber);
                $filter('getArrayObjectByKey')(questions[question.index-1].instructorQuestions,'raId', key).studentResponse = instructorAnswersData.ruResponse;
              }else{
                instructorAnswersData.ruResponse = (angular.isArray(instructorQuestion.optionNumber) ? instructorQuestion.optionNumber.toString() : instructorQuestion.optionNumber);
                instructorAnswersData.ruResponse += ',clOtherAnswer=' + instructorQuestion.optionOtherValue;
                $filter('getArrayObjectByKey')(questions[question.index-1].instructorQuestions,'raId', key).studentResponse = instructorAnswersData.ruResponse;
              }

              answersData.answerInstructor.push(instructorAnswersData)
            });
          }
          answers.push(answersData);
          return answers;
        }
      },

      finishedExam: function (questionModel, feedbackStyle) {
        var q = $q.defer();
        var groupQuestion= [];
        var incomplete = [];
        var unfilled = [];
        var errorFilled = [];

        if(feedbackStyle===4) {
          angular.forEach($filter('groupBy')(questionModel, 'surveyGroupId'), function (groupData) {
            groupQuestion.push({
              index: groupData[0].index,
              surveyGroupName: groupData[0].surveyGroupName,
              incomplete:[],
              errorFilled:[]
            });
            angular.forEach(groupData, function (group, groupIndex) {
              var index = groupQuestion.length - 1;
              if (angular.isUndefined(group.optionOtherValue)) {
                groupQuestion[index].errorFilled.push(groupIndex + 1);
                errorFilled.push(groupIndex);
              }
              if (angular.isUndefined(group.optionNumber)) {
                groupQuestion[index].errorFilled.push(groupIndex + 1);
                errorFilled.push(groupIndex);
              }
              if (group.isRequired > 0 && !group.completed && angular.isDefined(group.optionNumber)) {
                groupQuestion[index].incomplete.push(groupIndex + 1);
                incomplete.push(groupIndex);
              }
            });
          });
          groupQuestion = $filter('orderBy')(groupQuestion, 'index');
        }
        else {
          angular.forEach(questionModel, function (data) {
            if (angular.isUndefined(data.optionOtherValue))
              errorFilled.push(data.index);

            if (angular.isUndefined(data.optionNumber))
              errorFilled.push(data.index);

            if (data.isRequired > 0 && !data.completed && angular.isDefined(data.optionNumber))
              incomplete.push(data.index);

            if (!data.completed)
              unfilled.push(data.index);
          });
        }


        var title, text, value="";
        if(errorFilled.length > 0){
          if(feedbackStyle === 4) {
            angular.forEach($filter('groupBy')(questionModel, 'surveyGroupId'), function (group) {
              if(group.errorFilled.length > 0) {
                value += "<br>" + setGroupQuestionTranslate(group.surveyGroupName) + ":" + group.errorFilled.toString();
              }
            });
          }
          else {
            value = errorFilled.sort(sortNumber).toString();
          }
          title = $filter('translate')('MESSAGE.MSG_QUESTION_OPTION_EXCEEDS_WORD_LIMIT' , {'value': value});
          text = $filter('translate')('MESSAGE.MSG_PLEASE_RETURN_TO_FILL_IN');
          SweetAlert.errorRetutn(title, text, function() {
			  q.reject(false);
		  });
          if (feedbackStyle != 4) {
            this.putQuestionStatusLog(JSON.stringify(questionModel)).then(function (data) {
              if (data) {
                title = $filter('translate')('MESSAGE.MSG_UNABLE_SEND_REFRESH');
                text = $filter('translate')('MESSAGE.MSG_PLEASE_RETURN_TO_FILL_IN');
               SweetAlert.errorRetutn(title, text, function() {
					q.reject(false);
				});
                AuthStorage.set("testQuestionnaireRefersh", true);
                $timeout(function () {
                  $window.location.reload();
                }, 3000);
              }
            });
          }
        } else if(incomplete.length > 0){
          if(feedbackStyle === 4) {
            angular.forEach(groupQuestion, function (group) {
              if(group.incomplete.length > 0) {
                value += "<br>" + setGroupQuestionTranslate(group.surveyGroupName) + ":" + group.incomplete.toString();
              }
            });
          }
          else {
            value = incomplete.sort(sortNumber).toString();
          }
          title = $filter('translate')('MESSAGE.MSG_YOU_HAVE_REQUIRED_SUBJECT_NOT_YET_ANSWERED' , {'value': value});
          text = $filter('translate')('MESSAGE.MSG_PLEASE_RETURN_TO_FILL_IN');
          SweetAlert.errorRetutn(title, text, function() {
					q.reject(false);
				});
		  
        } else if(unfilled.length > 0){
          value = unfilled.sort(sortNumber).toString();
          SweetAlert.check($filter('translate')('MESSAGE.MSG_NOT_YET_COMPLETED_WHETHER_TO_SEND_OUT', {'value': value}), '', 'question', function() {
            q.resolve();
          }, function() {
			  q.reject(false);
		  });
        }
        else{
          SweetAlert.check($filter('translate')('MESSAGE.MSG_IS_SURE_TO_PAY'), '', 'question', function() {
            q.resolve();
          }, function() {
			  q.reject(false);
		  });
        }
        return q.promise;

        function sortNumber(a,b)
        {
          return a - b
        }
      },

      putQuestionStatusLog: function (log) {
        /*
          *api/feedback/ev-survey/test-log?log=log
        * */
        var params = {
          Log: log
        };

        return _testQuestionnaireService
          .one('ev-survey')
          //.customGET('test-log', params)
          .customPOST(params, "test-log", {}, {'Content-Type': 'application/json'});
      },

      setGroupQuestionTranslate: setGroupQuestionTranslate

    };

  }

  angular.module('eHRD.modules.courseResource')
    .factory('testQuestionnaireService', testQuestionnaireService);

})();

/**
 * Created by Alan on 2016/11/14.
 */

(function () {
  'use strict';

  function instructorService(Restangular){

    return {
      getInstructorDetail: function (instructorId) {
        /*
         * api/instructor/{instructorId}/info
         * */
        return Restangular
            .one('instructor', instructorId)
            .customGET('info');
      },

      getTeachingRecord: function (instructorId, params) {
        /*
         * api/instructor/{instructorId}/teaching-record
         * */
        return Restangular
          .one('instructor', instructorId)
          .customGETLIST('teaching-record', params);
      }


    };

  }

  angular.module('eHRD.modules.courseResource')
    .factory('instructorService', instructorService);

})();

/**
 * Created by Bruce on 2016/12/20.
 */
(function () {
  'use strict';

  externalTrainingService.$inject = ['Restangular', 'serverSetting', 'fileProcess', '$cacheFactory'];
  function externalTrainingService(Restangular, serverSetting, fileProcess, $cacheFactory){

    /*
     * Build collection api/external-training
     */
    var _service = Restangular.all('external-training');
    var cache = $cacheFactory('externalTraining');
    return {
      setCacheData: function (key, value) {
        cache.put(key, value)
      },
      getCache: function () {
        return cache;
      },

      getExtCourseFormByCourseSession: function (courseId, sessionId) {
        /*
         * api/external-training/ext-course/{courseId}/session/{sessionId}
         * */
        return _service
          .one('ext-course', courseId)
          .one('session', sessionId)
          .customGET();
      },
      getExtCourseFormByBulletin: function (bulletinId) {
        /*
        * api/external-training/bulletin/{bulletinId}
        * */
        return _service
          .one('bulletin', bulletinId)
          .customGET();
      },
      getExtCourseForm: function (externalId) {
        /*
        * api/external-training/ext-course-form/{externalId}
        * */
        return _service
          .one('ext-course-form', externalId)
          .customGET();
      },
      getExtCourseApplyReasons: function ( ) {
        /*
         * api/external-training/ext-course-apply-reason
         * */
        return _service
          .customGETLIST('ext-course-apply-reason');
      },
      getCleanExtCourseForm: function () {
        /*
         * api/external-training/clean-ext-course-form
         * */
        return _service
          .customGET('clean-ext-course-form');
      },

      getCurrencys: function () {
        /*
         * api/external-training/currency
         * */
        return _service
          .customGETLIST('currency');
      },
      getVendors: function (params) {
        /*
         * api/external-training/vendor?keyword={keyword}&list_size={10}&current_page={1}
         * */
        return _service
          .customGETLIST('vendor', params);

      },

      getVendor: function(vendorId) {
        /*
         * api/external-training/vendor/{vendorId}
         * */        
        return _service
          .one('vendor', vendorId)
          .customGET();
      },

      submitApplyForm: function (formData, fileFieldName, files, formType) {
        formType = formType || 'create';
        /*
         * api/external-training/ext-course  (Create Form for default and from bulletin)
         * api/external-training/ext-course-from-catalog (Create Form for Course Session)
         * api/external-training/update-ext-course/{externalId}  (Edit Form)
         * api/external-training/resend-ext-course/{externalId}  (re-submit Form )
         * */
        var url = serverSetting.baseConfig.baseApiPath + '/external-training/ext-course';
        switch (formType){
          case 'create': case 'createByBulletin':
            url = serverSetting.baseConfig.baseApiPath + '/external-training/ext-course';
            break;
          case 'createByCourseSession':
            url = serverSetting.baseConfig.baseApiPath + '/external-training/ext-course-from-catalog';
            break;
          case 'edit':
            url = serverSetting.baseConfig.baseApiPath + '/external-training/update-ext-course/' + formData.externalId;
            break;
          case 'reSubmit':
            url = serverSetting.baseConfig.baseApiPath + '/external-training/resend-ext-course/' + formData.externalId;
            break;
        }
        return new fileProcess.upload(url, formData, fileFieldName, files , 'POST');
      },

      getExternalTrainingRecords: function (params) {
        /*
         * api/external-training/ext-form
         * */
        return _service
          .customGETLIST('ext-form', params);
      },

      addVendor: function (formData, fileFieldName, files) {
        /*
         * api/instruresource/add-vendor
         * */
        var url = serverSetting.baseConfig.baseApiPath + '/instruresource/add-vendor';
        return new fileProcess.upload(url, formData, fileFieldName, files , 'POST');
      }

  };

  }

  angular.module('eHRD.modules.courseResource')
    .factory('externalTrainingService', externalTrainingService);

})();

/**
 * Created by Bruce on 2016/5/18.
 */

(function () {
  'use strict';

  function externalTrainingBulletinService(Restangular) {

    /*
     * Build collection api/external-training-bulletin/userlist?keyword={ keyword }&sort={ sort }
     * &order={ order }&current_page={ currentPage }&list_size={ listSize }
     */
    var _externalTrainingBulletinService = Restangular.all('external-training-bulletin');

    return{

      list: function (params) {
       /*
        * GET /api/external-training- bulletin/userlist?keyword={ keyword }&sort={ sort }
        *     &order={ order }&current_page={ currentPage }&list_size={ listSize }
        */
        return   _externalTrainingBulletinService
                .customGETLIST('bulletins', params);

      },

      getBulletinsInfo: function (bulletinId, courseId, sessionId) {
        /*
        * api/external-training-bulletin/bulletins-info?bulletinId=3&courseId={courseId}&sessionId={sessionId}
         * */
        bulletinId = bulletinId || undefined;
        courseId = courseId || undefined;
        sessionId = sessionId || undefined;
        var params = {};
        if(angular.isDefined(bulletinId)) params['bulletinId'] = bulletinId;
        if(angular.isDefined(courseId)) params['courseId'] = courseId;
        if(angular.isDefined(sessionId)) params['sessionId'] = sessionId;

        return _externalTrainingBulletinService
          .customGET('bulletins-info', params);
      }

    };

  }

  angular.module('eHRD.modules.courseResource')
    .factory('externalTrainingBulletinService',externalTrainingBulletinService)
    ;

})();

/**
 * Created by Herry on 2018/06/19
 */

(function () {
  'use strict';

  courseULiveService.$inject = ['$http', 'serverSetting', '$filter'];
  function courseULiveService($http, serverSetting, $filter){

    var uLiveCourseStateUrl = serverSetting.baseConfig.baseURL + '/uLiveCourse-state.do',
        uLiveCourseJoinUrl = serverSetting.baseConfig.baseURL + '/uLiveCourse-join.do';

    return {

      getULiveCourseState: function (courseId, sessionId) {
        var uLiveCourse = {
          method: 'GET',
          url: uLiveCourseStateUrl,
          withCredentials: true,
          params: {courseId: courseId, sessionId: sessionId}
        };

        return $http(uLiveCourse).then(function (response) {
          return response.data;
        });

      },
      getULiveCourseJoin: function (courseId, sessionId) {
        var transferUrl = {
          method: 'GET',
          url: uLiveCourseJoinUrl,
          withCredentials: true,
          params: {courseId: courseId, sessionId: sessionId}
        };
        return $http(transferUrl).then(function (response) {
          return response.data;
        });
      },

      getCourseULiveStatus: function (status) {

        var uLiveStatusMessage;

        switch(status)
        {
          case 0:
            uLiveStatusMessage =  $filter('translate')('FIELD.NO_LIVE');
            break;
          case 1:
            uLiveStatusMessage = $filter('translate')('FIELD.NO_LIVE_BROADCAST_YET');
            break;
          case 2:
            uLiveStatusMessage = $filter('translate')('FIELD.LIVE_NOW');
            break;
          case 3:
            uLiveStatusMessage = $filter('translate')('FIELD.LIVE_END');
            break;
          case 4:
            uLiveStatusMessage = $filter('translate')('FIELD.LIVE_NO_VIDEO');
            break;
          case 5:
            uLiveStatusMessage = $filter('translate')('FIELD.LIVE_VIDEO');
            break;
          case -1:
            uLiveStatusMessage = $filter('translate')('FIELD.U_NO_LIVE');
            break;
          case -125:
            uLiveStatusMessage = $filter('translate')('FIELD.CTMS_SERVER_LIVE_ERROR');
            break;
          case -126:
            uLiveStatusMessage = $filter('translate')('FIELD.U_SERVER_LIVE_ERROR');
            break;
          case -127:
            uLiveStatusMessage = $filter('translate')('FIELD.OTHER_LIVE_ERROR');
            break;
        }

          return uLiveStatusMessage;
      }

    }

  }

  angular.module('eHRD.modules.courseResource')
    .factory('courseULiveService', courseULiveService);

})();

/**
 * Created by Bruce on 2016/8/15.
 */

(function () {
  'use strict';

  courseResourceService.$inject = ['Restangular', '$auth'];
  function courseResourceService(Restangular, $auth){

    /*
     * Build collection api/course-resource
     */
    var _CourseResourceService = Restangular.all('course-resource');
    var courseId;

    return {
      getCourseId: function () {
        return courseId;
      },
      setCourseId: function(value) {
        courseId = value;
      },

      getClassifications: function (typeId) {
        /*
         * /api/course-resource/classification/type/typeId
         * */
        return _CourseResourceService
          .one('classification', null)
          .one('type', typeId)
          .customGETLIST();
      },

      getEnrollment: function ( sessionId, isProgram, userId) {
        /*
         * api/course-resource/session/{sessionId}/course-enrollmentId
         * */
        userId = userId || $auth.getUserData().id;
        isProgram = isProgram || false;
        return _CourseResourceService
          .one('session', sessionId)
          .customGET((isProgram ? 'program-enrollmentId': 'course-enrollmentId'), {userId: userId});
      },

      getCourseResourceMenuNodes: function (categoryTreeId) {
        /*
        * api/course-resource/catalog-info/{categoryTreeId}/nodes
        * */
        return _CourseResourceService
          .one('catalog-info', ( angular.isDefined(categoryTreeId) ? categoryTreeId : 0 ))
          .customGETLIST('nodes');
      },

      getCourseResourceCatalogMenu: function (categoryTreeId) {
        /*
         * api/course-resource/catalog-info/{categoryTreeId}/catalog-menu
         * */
        return _CourseResourceService
          .one('catalog-info', categoryTreeId)
          .customGETLIST('catalog-menu');
      },

      getCourseResource: function (categoryTreeId, params) {
        /*
         * api/course-resource/catalog-info/{categoryTreeId}/infos?keyword={keyword}&objecttype={objecttype}&onlyfavorite={onlyFavorite}
         * &sort:{ sort }&order:{ order }&current_page:{ currentPage }&list_size:{ listSize }
         * */
        return _CourseResourceService
          .one('catalog-info', categoryTreeId)
          .customGETLIST('infos', params);
      },


      getProgramEnrollment: function(enrollmentId, params) {
        /*
         * api/course-resource/program-enrollment/{enrollmentId}
         */
        return _CourseResourceService
          .one('program-enrollment', enrollmentId)
          .get(params);
      },
      getCourseEnrollment: function(enrollmentId, params) {
        /*
         * api/course-resource/course-enrollment/{enrollmentId}
         */
        return _CourseResourceService
              .one('course-enrollment', enrollmentId)
              .get(params);
      },

      getLearningResult: function (enrollmentId, isProgram) {
        /*
         * isProgram: true api/course-resource/program-enrollment/{enrollmentId}/result
         * isProgram: false api/course-resource/course-enrollment/{enrollmentId}/result
         */
        isProgram = isProgram || false;
        return _CourseResourceService
          .one((isProgram ? 'program-enrollment': 'course-enrollment'), enrollmentId)
          .customGET('result');
      },
      getProgram: function (programId, params) {
        /*
         * api/course-resource/program/{programId}
         */
        return _CourseResourceService
          .one('program', programId)
          .get(params);
      },
      getCourse: function (courseId, params) {
        /*
        * api/course-resource/course/{courseId}
        */
        return _CourseResourceService
              .one('course', courseId)
              .get(params);
      },
      getCourseEnrollSessions: function (courseId, params) {
        /*
         * api/course-resource/course/{ courseId }/enroll-sessions
         */
        return _CourseResourceService
          .one('course', courseId)
          .customGETLIST('enroll-sessions', params);
      },
      getProgramEnrollSessions: function (programId , params) {
        /*
         * api/course-resource/program/{ programId  }/enroll-sessions
         */
        return _CourseResourceService
          .one('program', programId )
          .customGETLIST('enroll-sessions', params);
      },
      getCourseContent: function (courseId) {
        /*
        * api/course-resource/course/{courseId}/content
        */
        return _CourseResourceService
              .one('course', courseId)
              .customGET('content');
      },

      getProgramSession: function (sessionId, params) {
        /*
         * api/course-resource/program-session/{sessionId}
         */
        return _CourseResourceService
          .one('program-session', sessionId)
          .get(params);
      },
      getCourseSession: function (sessionId, params) {
        /*
        * api/course-resource/course-session/{sessionId}
        */
        return _CourseResourceService
              .one('course-session', sessionId)
              .get(params);
      },
      getCourseSessionLearners: function (sessionId, params) {
        /*
         * api/course-resource/course-session/{sessionId}/learners
         */
        return _CourseResourceService
          .one('course-session', sessionId)
          .customGETLIST('learners', params);
      },
      getProgramSessionLearners: function (sessionId, params) {
        /*
         * api/course-resource/program-session/{sessionId}/learners
         */
        return _CourseResourceService
          .one('program-session', sessionId)
          .customGETLIST('learners', params);
      },
      getProgramSessionLearnersCompletionRate: function(sessionId, params){
        /*
         * api/course-resource/program-session/{sessionId}/learners-completion-rate
         */
        return _CourseResourceService
          .one('program-session', sessionId)
          .customGET('learners-completion-rate', params);
      },
      getCourseSessionLearnersCompletionRate: function(sessionId, params){
        /*
         * api/course-resource/course-session/{sessionId}/learners-completion-rate
         */
        return _CourseResourceService
          .one('course-session', sessionId)
          .customGET('learners-completion-rate', params);
      },
      getEnrollmentWillExpire: function (enrollmentId, params, isCourse) {
        /*
        * api/course-resource/course-enrollment/{enrollmentId}/will-expired-items
        * */
        if(isCourse){
          return _CourseResourceService
            .one('course-enrollment', enrollmentId)
            .customGETLIST('will-expired-items', params);
        }else {
          return _CourseResourceService
            .one('program-enrollment', enrollmentId)
            .customGETLIST('will-expired-items', params);
        }

      },

      getCourseReference: function (courseId, params) {
        /*
         * api/course-resource/course/{ courseId }/reference
         * */
        return _CourseResourceService
          .one('course', courseId)
          .customGETLIST('reference', params);
      },

      getSessionEnrollReq: function (sessionId, params, isProgram) {
        /*
         * api/course-resource/course-session/{sessionId}/enroll-req
         * */
        isProgram = isProgram || false;
        if(isProgram){
          return _CourseResourceService
            .one('program-session', sessionId)
            .customGET('enroll-req', params);
        }else {
          return _CourseResourceService
            .one('course-session', sessionId)
            .customGET('enroll-req', params);
        }
      },

      getSessionUnEnrollReq: function (enrollmentId, params, isProgram) {
        /*
        * api/course-resource/program-enrollment/{enrollmentId}/unenroll-req
        * api/course-resource/course-enrollment/{enrollmentId}/unenroll-req
        * */
        isProgram = isProgram || false;
        if(isProgram){
          return _CourseResourceService
            .one('program-enrollment', enrollmentId)
            .customGET('unenroll-req', params);
        }else{
          return _CourseResourceService
            .one('course-enrollment', enrollmentId)
            .customGET('unenroll-req', params);
        }
      },

      getPassCourse: function () {
        /*
        * api/course-resource/exemption-reason/pass-course
        * */
        return _CourseResourceService
          .one('exemption-reason', null)
          .customGET('pass-course');
      },
      getPassExtCert: function () {
        /*
         * api/course-resource/exemption-reason/pass-ext-cert
         * */
          return _CourseResourceService
            .one('exemption-reason', null)
            .customGET('pass-ext-cert');
      },
      getPassIntCert: function () {
        /*
         * api/course-resource/exemption-reason/pass-int-cert
         * */
        return _CourseResourceService
          .one('exemption-reason', null)
          .customGET('pass-int-cert');
      },

      getLeaveInfo: function (enrollmentId, params) {
        /*
         * api/course-resource/course-enrollment/{enrollmentId}/leave-info
         * */
        return _CourseResourceService
          .one('course-enrollment', enrollmentId)
          .customGETLIST('leave-info', params);
      },

      setLeave: function (enrollmentId, params) {
        /*
         * api/course-resource/course-enrollment/{enrollmentId}/
         * apply-leave?reason={reason}&periodList={periods}&reasonIdList={reasonIds}
         * */
        return _CourseResourceService
          .one('course-enrollment', enrollmentId)
          .customPUT({}, "apply-leave", params, {});
      },

      setExemption: function (enrollmentId, params, isProgram) {
        /*
         * api/course-resource/course-enrollment/{{enrollmentId}}/exempt
         * ?reason={{reason}}&exemptionType={{exemptionType}}&exemptionId={{exemptionId}}
         *
         * api/course-resource/program-enrollment/{enrollmentId}/exempt
         * ?reason={{reason}}&exemptionType={{exemptionType}}&exemptionId={{exemptionId}}
         * */
        isProgram = isProgram || false;
        if(isProgram){
          return _CourseResourceService
            .one('program-enrollment', enrollmentId)
            .customPUT({}, "exempt", params, {});
        }else{
          return _CourseResourceService
            .one('course-enrollment', enrollmentId)
            .customPUT({}, "exempt", params, {});
        }

      },

      setSessionUnEnroll: function (enrollmentId, params, isProgram) {
        /*
         * api/course-resource/course-enrollment/{enrollmentId}/unenroll-course?unenrollReason={unenrollReason}
         * api/course-resource/program-enrollment/{enrollmentId}/program-course?unenrollReason={unenrollReason}
         * */
        isProgram = isProgram || false;
        if(isProgram){
          return _CourseResourceService
            .one('program-enrollment', enrollmentId)
            .customPUT({}, "unenroll-program", params, {});
        }else{
          return _CourseResourceService
            .one('course-enrollment', enrollmentId)
            .customPUT({}, "unenroll-course", params, {});
        }
      },

      getSessionEnrollPreCheck: function (isProgram, sessionId, params) {
        /*
         * api/course-resource/course-session/{sessionId}/enroll-course-check
         * api/course-resource/program-session/{sessionId}/enroll-program-check
         * */
        if(isProgram){
          return _CourseResourceService
            .one('program-session', sessionId)
            .customGET('enroll-program-check', params);
        }else {
          return _CourseResourceService
            .one('course-session', sessionId)
            .customGET('enroll-course-check', params);
        }
      },

      setSessionEnroll: function (sessionId, params, isProgram) {
        /*
         * api/course-resource/course-session/{sessionId}/enroll-course
         * api/course-resource/program-session/{sessionId}/enroll-program
         * */
        if(isProgram){
          return _CourseResourceService
            .one('program-session', sessionId)
            .customPUT({}, "enroll-program", params, {});
        }else{
          return _CourseResourceService
            .one('course-session', sessionId)
            .customPUT({}, "enroll-course", params, {});
        }
      },

      setFavorite: function (courseId,courseType, params) {
        /* {courseType}=0
         * api/course-resource/favorite-program/{courseId}?isMyFavorite={isMyFavorite}
         * {courseType}!=0
         * api/course-resource/favorite-course/{courseId}?isMyFavorite={isMyFavorite}
         * */
        var route=(courseType===0)?"favorite-program":"favorite-course";

        return _CourseResourceService
            .one(route, courseId)
            .put(params, {});

      },

      getLearningHistory: function (enrollmentId, params) {
        /*
         * api/course-resource/course-enrollment/{enrollmentId}/learning-history
         * */
        return _CourseResourceService
          .one('course-enrollment', enrollmentId)
          .customGET('learning-history', params);

      },

      getLatestCourses: function (params) {
        /*
         * api/course-resource/catalog-info/0/latest-courses
         * */
        return _CourseResourceService
          .one('catalog-info', 0)
          .customGETLIST('latest-courses', params);

      },

      getHotCourses: function (params) {
        /*
         * api/course-resource/catalog-info/0/hot-courses
         * */
        return _CourseResourceService
          .one('catalog-info', 0)
          .customGETLIST('hot-courses', params);

      },

      getFeaturedCourses: function (params) {
        /*
         * api/course-resource/catalog-info/0/recommended-courses?current_page={current_page}&list_size={list_size}
         * */
        return _CourseResourceService
          .one('catalog-info', 0)
          .customGETLIST('featured-courses', params);

      },

      getRecommendedCourses: function (params) {
        /*
         * api/course-resource/catalog-info/0/category-recommended-courses?yearAgo={yearAgo}&size={size}&itemType={itemType}&itemId={itemId}&sessionId={sessionId}
         * */
        return _CourseResourceService
          .one('catalog-info', 0)
          .customGETLIST('recommended-courses', params);

      }
    };

  }

  angular.module('eHRD.modules.courseResource')
    .factory('courseResourceService', courseResourceService);

})();

/**
 * Created by Bruce on 2016/11/30.
 */
(function () {
  'use strict';

  displayMinNumber.inject = [];
  function displayMinNumber() {
    return function (number, displayMinNumber) {
      if(Math.floor(number).toString().length < displayMinNumber){
        var prefix_num = displayMinNumber - Math.floor(number).toString().length;
        var prefix = '';
        while (prefix_num > 0){
          prefix = prefix + '0';
          prefix_num -- ;
        }
        return prefix + number;
      }else{
        return number;
      }
    }
  }

  angular.module('eHRD.modules.courseResource')
    .filter('displayMinNumber', displayMinNumber)
})();

/**
 * Created by Bruce on 2016/11/1.
 */
(function () {
  'use strict';

  unAssignableMembers.$inject = ['$mdDialog', '$document'];
  function unAssignableMembers($mdDialog, $document) {
    var directive = {
      restrict: 'A',
      scope: {
        isProgram:'=?',
        sessionId: '=',
        sessionName:'=',
        reloadFn:'&'
      },

      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            controller: ['$scope', '$filter', 'NgTableParams','$mdDialog', 'SweetAlert', 'managerService', 'isProgram', 'sessionId', 'sessionName', 'WizardHandler',
              function ($scope, $filter, NgTableParams, $mdDialog, SweetAlert, managerService, isProgram, sessionId, sessionName, WizardHandler) {
                var vm = this;
                $scope.close = function() {
                  $mdDialog.cancel();
                };
                vm.wzBtn ={
                  next:true,
                  previous: false,
                  finish: false
                };
                var _members = {};
                vm.sessionName = sessionName;

                vm.enroll = {
                  reason: ''
                };

                vm.close = function() {
                  $mdDialog.cancel();
                };
                vm.unAssignableMemberTable = new NgTableParams({}, {
                  counts: [1,5,10,15],
                  getData: function(tableParams) {
                    var params = {};
                    angular.forEach(tableParams.sorting(), function (value, key) {
                      params.sort = key;
                      params.order = ((value === 'desc') ? 0 : 1);
                    });

                    angular.forEach(tableParams.filter(), function (value, key) {
                      params[key] = value;
                    });

                    params.current_page = tableParams.url().page;
                    params.list_size = tableParams.url().count;

                    return managerService.getUnAssignableMmembers(isProgram, sessionId, params).then(function (members) {
                      tableParams.total(members.metadata.pagination.total);
                      vm.members = members;

                      vm.users = {
                        selectAll: false,
                        selected: {}
                      };

                      // watch for check all checkbox
                      $scope.$watch(function() {
                        return vm.users.selectAll;
                      }, function(value) {
                        angular.forEach(vm.members, function(member) {
                          vm.users.selected[member.enrollmentId] = value;
                        });
                      });

                      vm.nextStep = function () {
                        WizardHandler.wizard('unassign').next();
                        vm.setSelected();
                      };

                      vm.previousStep = function () {
                        WizardHandler.wizard('unassign').previous();
                      };

                      vm.finishStep = function () {
                        WizardHandler.wizard('unassign').finish();
                      };

                      vm.setSelected = function () {
                        vm.selectedMembers = [];
                        angular.forEach(vm.users.selected,function (val, key) {
                          if(val){
                            vm.selectedMembers.push($filter('where')(members, {'enrollmentId': key})[0]);
                          }
                        });
                      };

                      vm.unassign = function (enroll) {
                        var enrollmentIds = '';
                        angular.forEach(vm.users.selected,function (val, key) {
                          if(val){
                            if(enrollmentIds.length > 0) enrollmentIds += ',' + key;
                            else enrollmentIds += key;
                          }
                        });

                        var params = {
                          enrollmentIds: enrollmentIds,
                          reason: (angular.isDefined(enroll.reason)? enroll.reason: '')
                        };
                        managerService.UnAssignable(isProgram, sessionId,params).then(function (data) {
                          if(data){
                            SweetAlert.success('', $filter('translate')('MESSAGE.MSG_TAKES_TIME_ACTION'));
                            $mdDialog.hide();
                          }else{
                            SweetAlert.error('', '');
                          }
                        });
                      };

                      vm.resetWzBtn = function () {
                        vm.wzBtn ={
                          next:true,
                          previous: false,
                          finish: false
                        };
                        return true;
                      };
                      vm.canNext = function () {
                        var hasSelected = false;
                        if(Object.keys(vm.users.selected).length === 0){
                          hasSelected = false;
                        }else {
                          angular.forEach(vm.users.selected,function (val) {
                            if(val){
                              hasSelected = true;
                            }
                          });
                        }
                        if(!hasSelected) SweetAlert.error( "", $filter('translate')('MESSAGE.MSG_PLEASE_SELECT_AT_LEAST_ONE_STUDENT'));

                        if(hasSelected){
                          vm.wzBtn ={
                            next:false,
                            previous: true,
                            finish: true
                          };
                        }
                        return hasSelected;
                      };

                      angular.forEach(members, function (member) {
                        _members[member.userId] = member;
                      });

                      return members;
                    });
                  }
                });
            }],
            multiple: true,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/unassignable-members.html',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              isProgram: scope.isProgram,
              sessionId: scope.sessionId,
              sessionName: scope.sessionName
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function() {
            if(angular.isFunction(scope.reloadFn)) scope.reloadFn();
            }, function() { }
          );
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('unAssignableMembers', unAssignableMembers);

})();

/**
 * Created by Alan on 2017/1/17.
 */

(function () {
  'use strict';

  testHistorySearchDialog.$inject = ['$mdDialog'];
  function testHistorySearchDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        sessionId: '=?',
        itemId: '=?',
        courseContent: '=?',
        userId: '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/test-history-search-dialog.html',
            controller: ['$filter', 'SweetAlert', 'NgTableParams','testQuestionnaireService', 'managerService', '$mdDialog', 'WizardHandler', 'sessionId', 'itemId', 'userId', 'courseContent',
              function ($filter, SweetAlert, NgTableParams,testQuestionnaireService, managerService, $mdDialog, WizardHandler, sessionId, itemId, userId, courseContent) {
                var vm = this;
                vm.userId = (angular.isUndefined(userId))?null:userId;
                vm.sessionId = sessionId;
                vm.itemId = itemId;
                vm.courseContent = courseContent;
                vm.testHistoryTable = new NgTableParams({}, {
                  counts: [],
                  getData: function() {
                    vm.examHistoryId = '';
                    var params = {
                      itemid:    itemId,
                      startDate: (angular.isUndefinedOrNull(vm.startDate))?'':moment(vm.startDate).format("YYYY/MM/DD"),
                      endDate:    (angular.isUndefinedOrNull(vm.endDate))?'':moment(vm.endDate).format("YYYY/MM/DD")
                    };
                    var getTestHistory;
                    if(vm.userId===null){
                      getTestHistory = testQuestionnaireService.getTestHistory(sessionId, params);
                    }
                    else {
                      params.userId = vm.userId;
                      getTestHistory = managerService.getTestHistory(sessionId, params);
                    }

                    testQuestionnaireService.getExamInfo(vm.sessionId, {itemid: vm.itemId}).then(function (exam) {
                      vm.exam = exam;
                    });
                    return getTestHistory.then(function (testHistory) {
                      vm.testHistory = testHistory;
                      return testHistory;
                    });
                  }
                });
                vm.testHistoryReload = function() {
                  if(vm.startDate > vm.endDate) {
                    SweetAlert.error('',$filter('translate')('MESSAGE.MSG_THE_START_DATE_NEED_TO_EARLIER_THAN_THE_END_DATE'));
                  }
                  else {
                    vm.testHistoryTable.reload();
                  }

                };
                vm.searchPage = function () {
                  vm.wzBtn ={
                    next:false,
                    previous: true,
                    finish: true
                  };
                  return true;
                };

                vm.viewPage = function () {
                  vm.wzBtn ={
                    next:true,
                    previous: false,
                    finish: false
                  };
                  return true;
                };
                vm.viewPage();
                vm.nextStep = function () {
                  WizardHandler.wizard('testHistorySearch').next();
                };

                vm.previousStep = function () {
                  WizardHandler.wizard('testHistorySearch').previous();
                };

                vm.finishStep = function () {
                  WizardHandler.wizard('testHistorySearch').finish();
                };

                vm.updateEndDateModel = function () {
                  var beginningTime = moment(vm.startDate);
                  var endTime = moment(vm.endDate);
                  if(!beginningTime.isBefore(endTime)){
                    vm.endDate = vm.startDate;
                  }
                };

                vm.getExamResult = function() {
                  vm.examResultParams = {
                    itemid: vm.itemId,
                    examhistoryId: vm.examHistoryId,
                    userId: angular.isUndefinedOrNull(vm.userId)?null:vm.userId
                  };
                  var getExamResult = (angular.isUndefinedOrNull(vm.userId))
                    ?testQuestionnaireService.getExamResult(vm.sessionId, vm.examResultParams)
                    :managerService.getExamResult(vm.sessionId, vm.examResultParams);

                  getExamResult.then(function (examResult) {
                    vm.examResult = examResult;
                  });
                };

                vm.close = function() {
                  $mdDialog.cancel();
                };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              sessionId : scope.sessionId,
              itemId: scope.itemId,
              courseContent: scope.courseContent,
              userId: scope.userId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('testHistorySearchDialog', testHistorySearchDialog);

})();

/**
 * Created by alan on 2016/10/26.
 */
(function () {
    'use strict';

    setFavorite.$inject = ['courseResourceService', 'SweetAlert', '$filter'];
    function setFavorite(courseResourceService, SweetAlert, $filter) {

        var directive ={
            restrict: 'EA',
            scope: {
                courseId:'=',
                courseName:'=',
                courseType:'=',
                isFavorite:'=',
                reload:'&?'
            },
            link:function(scope,element){
                element.on('click', function () {
                    var check;
                    check=(scope.isFavorite===false)?"MSG_DO_YOU_WANT_TO_ADD_MY_FAVORITE":"MSG_DO_YOU_WANT_TO_CANCEL_MY_FAVORITE";
                    SweetAlert.check('', $filter('translate')('MESSAGE.' + check, {value: scope.courseName}), 'warning', function() {
                      scope.isFavorite=(scope.isFavorite===false)?true:false;
                      var params={
                        isMyFavorite:scope.isFavorite
                      };
                      courseResourceService.setFavorite(scope.courseId,scope.courseType,params).then(function () {
                        scope.reload();
                      });
                    });

                })
            }
        };
        return directive;
    }


    angular.module('eHRD.modules.courseResource')
        .directive('setFavorite', setFavorite);
})();

/**
 * Created by Bruce on 2016/11/15.
 */
(function() {
  'use strict';

  sessionEnrolledMembersDialog.$inject = ['$document', '$mdDialog'];
  function sessionEnrolledMembersDialog($document, $mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        sessionId: '=?',
        isProgram: '=?',
        reloadFn: '&?'
      },
      link: function(scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/session-enrolled-members-dialog.html',
            controller: ['$scope', '$mdDialog', 'NgTableParams', 'courseResourceService', 'sessionId' , 'isProgram' ,
              function($scope, $mdDialog, NgTableParams, courseResourceService, sessionId , isProgram ) {

              if(isProgram){
                courseResourceService.getProgramSession(sessionId, {}).then(function(sessionData) {
                  $scope.sessionData = sessionData;
                });
              }else {
                courseResourceService.getCourseSession(sessionId, {}).then(function(sessionData) {
                  $scope.sessionData = sessionData;
                });
              }


                $scope.courseSessionLearnersTable = new NgTableParams({}, {
                  counts: [1,5,10,15],
                  getData: function(tableParams) {
                    var params = {};
                    angular.forEach(tableParams.sorting(), function (value, key) {
                      params.sort = key;
                      params.order = ((value === 'desc') ? 0 : 1);
                    });

                    angular.forEach(tableParams.filter(), function (value, key) {
                      params[key] = value;
                    });

                    params.current_page = tableParams.url().page;
                    params.list_size = tableParams.url().count;

                    if(isProgram){
                      return courseResourceService.getProgramSessionLearners(sessionId, params).then(function (sessionLearnersData) {
                        tableParams.total(sessionLearnersData.metadata.pagination.total);
                        return sessionLearnersData;
                      });
                    }else{
                      return courseResourceService.getCourseSessionLearners(sessionId, params).then(function (sessionLearnersData) {
                        tableParams.total(sessionLearnersData.metadata.pagination.total);
                        return sessionLearnersData;
                      });
                    }
                  }
                });
                $scope.close = function() {
                  $mdDialog.cancel();
                };
              }
            ],
            multiple: true,
            controllerAs: 'SEMDC',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              sessionId: scope.sessionId,
              isProgram: scope.isProgram
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function() {
            if (angular.isDefined(scope.reloadFn)) scope.reloadFn();
          }, function() {
            if (angular.isDefined(scope.reloadFn)) scope.reloadFn();
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('sessionEnrolledMembersDialog', sessionEnrolledMembersDialog);
})();

/**
 * Created by Bruce on 2016/11/30.
 */
(function () {
  'use strict';

  sessionActionUnEnroll.$inject = ['$mdDialog', '$document'];
  function sessionActionUnEnroll($mdDialog, $document) {
    var directive = {
      restrict: 'A',
      scope: {
        enrollmentId: '=?',
        isProgram: '=?',
        reloadFn:'&?'
      },

      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/session-action-un-enroll-dialog.html',
            controller: ['$scope', 'NgTableParams', '$filter', '$mdDialog', '$state', 'courseResourceService', 'enrollmentId', 'isProgram', 'SweetAlert',
              function ($scope, NgTableParams, $filter, $mdDialog, $state, courseResourceService, enrollmentId, isProgram, SweetAlert) {
                var vm = this;
                var isNeedBackPage = (
                  $state.includes('learningPassport.incompleteCourses.courseInfo') ||
                  $state.includes('learningPassport.incompleteCourses.programInfo') ||
                  $state.includes('learningPassport.incompleteCourses.programInfo.courseInfo') ||
                  $state.includes('learningPassport.testQuestionnaireCenter.courseInfo') ||
                  $state.includes('courseResourceCatalog.CourseInfo.SessionInfo') ||
                  $state.includes('courseResourceCatalog.ProgramInfo.SessionInfo') ||
                  $state.includes('learningPassport.incompleteCourses.certificationInfo')
                );

                $scope.close = function() {
                  $mdDialog.cancel();
                };
                vm.scope = $scope;
                vm.submitFn = null;

                courseResourceService.getSessionUnEnrollReq(enrollmentId, {}, isProgram).then(function (unEnrollReq) {
                  vm.unEnrollReqData = unEnrollReq;
                });
                vm.submitFn = unEnrollCourseSession;

                function unEnrollCourseSession () {
                  var params = {};
                  if(angular.isDefined(vm.enroll.reason)) params.unenrollReason = vm.enroll.reason;
                  courseResourceService.setSessionUnEnroll(enrollmentId, params, isProgram).then(function (res) {
                    if(res.status === 0){
                      if(!res.isNeedApproval){
                        if(isNeedBackPage){
                          $mdDialog.cancel();
                          if($state.current.name === 'learningPassport.incompleteCourses.programInfo.courseInfo')
                            $state.go('learningPassport.incompleteCourses.programInfo', {enrollmentId: $state.params.programEnrollmentId});
                          else if (angular.isUndefinedOrNull($state.params.backState))
                            $state.go('learningPassport.incompleteCourses');
                          else
                            $state.go($state.params.backState, $state.params);
                        }else {
                          $mdDialog.hide();
                        }
                      }else {
                        SweetAlert.warning('',$filter('translate')('MESSAGE.MSG_ENROLLMENT_APPROVAL_PENDING'));
                        $mdDialog.hide();
                      }
                    }
                  });
                }


              }],
            multiple: true,
            controllerAs: '$ctrl',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              enrollmentId: scope.enrollmentId,
              isProgram: angular.isUndefinedOrNull(scope.isProgram) ? false : scope.isProgram
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function() {
              if(angular.isDefined(scope.reloadFn)) scope.reloadFn();
            }
          );
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('sessionActionUnEnroll', sessionActionUnEnroll);

})();

/**
 * Created by Bruce on 2016/11/30.
 */
(function () {
  'use strict';

  sessionActionLeave.$inject = ['$mdDialog', '$document'];
  function sessionActionLeave($mdDialog, $document) {
    var directive = {
      restrict: 'A',
      scope: {
        enrollmentId: '=?',
        reloadFn:'&?'
      },

      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/session-action-leave-dialog.html',
            controller: ['$scope', 'NgTableParams', '$filter', '$mdDialog', '$state', 'courseResourceService', 'enrollmentId', 'WizardHandler', 'SweetAlert',
              function ($scope, NgTableParams, $filter, $mdDialog, $state, courseResourceService, enrollmentId, WizardHandler, SweetAlert) {
                var vm = this;
                vm.leaveForm = null;
                $scope.close = function() {
                  $mdDialog.cancel();
                };

                vm.scope = $scope;
                vm.submitFn = null;
                vm.leaveTable = new NgTableParams({}, {
                  counts: [],
                  getData: function(tableParams) {
                    var params = {};
                    angular.forEach(tableParams.sorting(), function (value, key) {
                      params.sort = key;
                      params.order = ((value === 'desc') ? 0 : 1);
                    });

                    angular.forEach(tableParams.filter(), function (value, key) {
                      params[key] = value;
                    });

                    params.current_page = tableParams.url().page;
                    params.list_size = tableParams.url().count;

                    return courseResourceService.getLeaveInfo(enrollmentId, {}).then(function (leaveDatas) {
                      vm.leaves = {};
                      angular.forEach(leaveDatas, function (leaveData) {
                        vm.leaves[leaveData.id] = {};

                        if(!leaveData.hasLeaveRecord){
                          vm.leaves[leaveData.id].reason = "2";
                          vm.leaves[leaveData.id].selected = false;
                        }
                      });

                      // watch for check all checkbox
                      $scope.$watch(function() {
                        return vm.selectAllLeave;
                      }, function(value) {
                        if(angular.isDefined(value)){
                          angular.forEach(leaveDatas, function (leaveData) {
                            if(!leaveData.hasLeaveRecord){
                              vm.leaves[leaveData.id].selected = value;
                            }
                          });
                        }
                      });
                      return leaveDatas;
                    });
                  }
                });

                vm.submitFn = leaveSession;
                function leaveSession() {
                  if(vm.formValidation()){
                    vm.submitError = false;
                    var params = {};
                    params.reason = vm.reason;
                    params.periodList = '';
                    params.reasonIdList = '';
                    var periodList = [], reasonIdList = [];
                    angular.forEach(vm.leaves, function (leave, index) {
                      if(angular.isDefined(leave.selected) && leave.selected){
                        var period = '';
                        period += index + '_' + $filter('displayMinNumber')(leave.startHH, 2) +
                                  $filter('displayMinNumber')(leave.startMM, 2) + '_' +
                                  $filter('displayMinNumber')(leave.endHH, 2) +
                                  $filter('displayMinNumber')(leave.endMM, 2);
                        periodList.push(period);
                        reasonIdList.push(leave.reason);
                      }
                    });
                    params.periodList = periodList.toString();
                    params.reasonIdList = reasonIdList.toString();

                    courseResourceService.setLeave(enrollmentId, params).then(function (res) {
                      if(res.status === 0){
                        if(!res.isNeedApproval){
                          $mdDialog.hide();
                        }else {
                          SweetAlert.warning('',$filter('translate')('MESSAGE.MSG_ENROLLMENT_APPROVAL_PENDING'));
                          $mdDialog.hide();
                        }
                      }
                    });
                  }else{
                    vm.submitError = true;
                    SweetAlert.error( "", $filter('translate')('MESSAGE.MSG_PLEASE_FILL_IN_THE_REASON'));
                  }
                }

                vm.formValidation = function () {
                  if(angular.isDefined(vm.leaveForm) && vm.leaveForm.$valid) {
                    return vm.leaveForm.$valid;
                  }else{
                    return false;
                  }
                };

                vm.wzBtn ={
                  next:true,
                  previous: false,
                  finish: false
                };

                vm.resetWzBtn = function () {
                  vm.wzBtn ={
                    next:true,
                    previous: false,
                    finish: false
                  };
                  return true;
                };

                vm.canNext = function () {
                  var hasSelected = false;
                  var checkTime = true;
                  angular.forEach(vm.leaves,function (leave) {
                    if(angular.isDefined(leave.selected) && leave.selected){
                      hasSelected = true;
                      if((parseInt(leave.startHH) > parseInt(leave.endHH)) || (parseInt(leave.startHH) === parseInt(leave.endHH) && parseInt(leave.startMM) >= parseInt(leave.endMM) ))
                        checkTime = false;
                    }
                  });

                  if(!hasSelected) SweetAlert.error( "", $filter('translate')('MESSAGE.MSG_PLEASE_SELECT_AT_LEAST_ONE_TIME_PERIOD'));
                  if(hasSelected && !checkTime) SweetAlert.error( "", $filter('translate')('MESSAGE.MSG_THE_TIME_RANGE_IS_ERROR'));

                  if(hasSelected && checkTime){
                    vm.wzBtn ={
                      next:false,
                      previous: true,
                      finish: true
                    };
                  }
                  return (hasSelected && checkTime);
                };

                vm.nextStep = function () {
                  WizardHandler.wizard('leave').next();
                };

                vm.previousStep = function () {
                  WizardHandler.wizard('leave').previous();
                };

                vm.finishStep = function () {
                  WizardHandler.wizard('leave').finish();
                };
              }],
            controllerAs: '$ctrl',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              enrollmentId: scope.enrollmentId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function() {
              if(angular.isDefined(scope.reloadFn)) scope.reloadFn();
            }
          );
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('sessionActionLeave', sessionActionLeave);

})();

/**
 * Created by Bruce on 2016/11/30.
 */
(function () {
  'use strict';

  sessionActionExemption.$inject = ['$mdDialog', '$document'];
  function sessionActionExemption($mdDialog, $document) {
    var directive = {
      restrict: 'A',
      scope: {
        enrollmentId: '=?',
        isProgram: '=?',
        reloadFn:'&?'
      },

      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/session-action-exemption-dialog.html',
            controller: ['$scope', 'NgTableParams', '$filter', '$mdDialog', '$state', 'courseResourceService', 'enrollmentId', 'isProgram', 'SweetAlert',
              function ($scope, NgTableParams, $filter, $mdDialog, $state, courseResourceService, enrollmentId, isProgram, SweetAlert) {
                var vm = this;
                $scope.close = function() {
                  $mdDialog.cancel();
                };

                vm.scope = $scope;
                vm.submitFn = null;

                vm.exemption = {
                  reason:'',
                  exemptionType: 1,
                  exemptionId: 0
                };

                vm.loadPassedCertification = function() {
                  courseResourceService.getPassExtCert().then(function (ext_cert) {
                    return vm.ext_cert = ext_cert;
                  });
                };
                vm.loadPassedInnerCertification = function () {
                  courseResourceService.getPassIntCert().then(function (int_cert) {
                    return vm.int_cert = int_cert;
                  });
                };
                vm.loadPassedCourse = function () {
                  courseResourceService.getPassCourse().then(function (course) {
                    return vm.course = course;
                  });
                };

                vm.submitFn = exemptionSession;

                function exemptionSession() {
                  var params = {
                    reason: vm.exemption.reason,
                    exemptionType: vm.exemption.exemptionType,
                    exemptionId: (vm.exemption.exemptionType === 3 ? 0 : vm.exemption.exemptionId)
                  };

                  courseResourceService.setExemption(enrollmentId, params, isProgram).then(function (res) {
                    if(res.status === 0){
                      if(!res.isNeedApproval){
                        $state.go('learningPassport.incompleteCourses');
                        $mdDialog.cancel();
                      }else {
                        SweetAlert.warning('',$filter('translate')('MESSAGE.MSG_ENROLLMENT_APPROVAL_PENDING'));
                        $mdDialog.hide();
                      }
                    }
                  });
                }

              }],
            controllerAs: '$ctrl',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              enrollmentId: scope.enrollmentId,
              isProgram: angular.isUndefinedOrNull(scope.isProgram) ? false : scope.isProgram
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function() {
              if(angular.isDefined(scope.reloadFn)) scope.reloadFn();
            }
          );
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('sessionActionExemption', sessionActionExemption);

})();

/**
 * Created by Bruce on 2016/11/30.
 */
(function () {
  'use strict';

  sessionActionEnroll.$inject = ['$mdDialog', '$document', 'courseResourceService', 'SweetAlert', '$filter'];
  function sessionActionEnroll($mdDialog, $document, courseResourceService, SweetAlert, $filter) {
    var directive = {
      restrict: 'A',
      scope: {
        sessionId: '=?',
        isProgram: '=?',
        reloadFn:'&?'
      },

      link: function (scope, element) {
        element.bind('click', function(ev) {
          if(angular.isDefined(scope.isProgram) && angular.isDefined(scope.sessionId)){
            courseResourceService.getSessionEnrollPreCheck(scope.isProgram, scope.sessionId, {}).then(function (res) {
              switch (res.statusCode){
                case 'OK':
                  showEnrollDialog();
                  break;
                case 'FAIL_CHECK_NOT_PUBLISH':
                  SweetAlert.warning('',$filter('translate')('MESSAGE.MSG_ERROR_NOT_PUBLISH'));
                  break;
                case 'FAIL_CHECK_SESSIONQUOTAFULL': case 'FAIL_CKECK_PRIVILEGE': case 'FAIL_CHECK_OUT_OF_QUOTA':
                  SweetAlert.warning('',$filter('translate')('STATUS.' + res.statusCode));
                  break;
                case 'FAIL_CHECK_PREREQUESTED':
                  var prerequisites = [];
                  angular.forEach(res.preItems, function (preItem) {
                    angular.forEach(preItem.records, function (record) {
                      prerequisites.push(record.objectName)
                    });
                  });
                  SweetAlert.warning($filter('translate')('MESSAGE.MSG_ERROR_NEED_FINISH_PREREQUISITE_ITEMS'), $filter('arrayToString')(prerequisites, '<br>'));
                  break;
                case 'FAIL_CHECK_OTHERCLASSPASSED':
                  if(res.isForbidEnrollClassAfterPass){
                    SweetAlert.warning($filter('translate')('MESSAGE.MSG_ERROR_MESSAGE_CAN_NOT_ENROLL_CAUSE_PASS_RESULT'),
                      res.detail);
                  }else{
                    SweetAlert.check($filter('translate')('MESSAGE.MSG_ERROR_MESSAGE_ENROLL_CAUSE_PASS_RESULT'), res.detail, 'warning', function() {
                      showEnrollDialog();
                    }, null, $filter('translate')('ACTIONS.CONTINUE_ENROLL'));
                  }
                  break;
                case 'FAIL_CKECK_CONFLICTCLASSTIME':
                  SweetAlert.warning($filter('translate')('MESSAGE.MSG_CLASS_TIME_CONFLICT', { 'value': res.detail}),'');
                  break;
                case 'FAIL_CHECK_INNERCERTEXTEND':
                  SweetAlert.warning($filter('translate')('MESSAGE.MSG_INNERCERT_CANNOT_ENROLL_EXTENDED_SESSION'),
                    res.detail);
                  break;
              }
            });
          }

          function showEnrollDialog() {
            $mdDialog.show({
              templateUrl: 'app/modules/course-resource/views/course-session-info-template/session-action-enroll-dialog.html',
              controller: ['$scope', 'NgTableParams', '$filter', '$mdDialog', '$state', 'courseResourceService', 'sessionId', 'isProgram', 'SweetAlert', 'testQuestionnaireService', '$location', '$anchorScroll', 'WizardHandler',
                function ($scope, NgTableParams, $filter, $mdDialog, $state, courseResourceService, sessionId, isProgram, SweetAlert, testQuestionnaireService, $location, $anchorScroll, WizardHandler) {
                  var vm = this;
                  $scope.close = function() {
                    $mdDialog.cancel();
                  };
                  vm.scope = $scope;
                  vm.submitFn = null;
                  vm.sessionId = sessionId;
                  vm.pageView = 'reason';
                  vm.isStartFillIn = false;

                  courseResourceService.getSessionEnrollReq(sessionId, {}, isProgram).then(function (enrollReq) {
                    vm.enrollReqData = enrollReq;
                    vm.itemId = enrollReq.preEnrollSurveyItemId;
                  });
                  vm.submitFn = enrollCourseSession;

                  function enrollCourseSession() {
                    var params = {};
                    if(angular.isDefined(vm.enroll.reason)) params.enrollReason = vm.enroll.reason;
                    params.isConfirmHasAlreadyCourse = false;

                    setSessionEnroll(params);

                    function setSessionEnroll(params) {
                      courseResourceService.setSessionEnroll(sessionId, params, isProgram).then(function (res) {
                        switch (res.status){
                          case -1:
                            SweetAlert.warning('',$filter('translate')('MESSAGE.MSG_ERROR_NOT_PUBLISH'));
                            break;
                          case 6:
                            SweetAlert.warning('',$filter('translate')('MESSAGE.MSG_ERROR_MESSAGE_CAN_ENROLL_WAITLSTED_RESULT'));
                            if(vm.enrollReqData.isHasPreEnrollSurvey)
                              save(testQuestionnaireService.getAnswers(vm.questionModel, vm.questionnaireData), vm.exam.feedbackType, true);
                            $mdDialog.hide();
                            break;
                          case 3:
                            SweetAlert.warning('',$filter('translate')('STATUS.FAIL_CHECK_PRIVILEGE'));
                            break;
                          case 2:
                            params.isConfirmHasAlreadyCourse = true;
                            setSessionEnroll(params);
                            break;
                          case 9:
                            SweetAlert.warning($filter('translate')('MESSAGE.MSG_CLASS_TIME_CONFLICT_NO_BLOCK', { 'value': res.detail}),'');
                            $mdDialog.hide();
                            if(vm.enrollReqData.isHasPreEnrollSurvey)
                              save(testQuestionnaireService.getAnswers(vm.questionModel, vm.questionnaireData), vm.exam.feedbackType, true);
                            break;
                          case 0:case 4:case 5:case 8:
                          params.isConfirmHasAlreadyCourse = true;
                          SweetAlert.check($filter('translate')('MESSAGE.MSG_ERROR_MESSAGE_CAN_NOT_ENROLL_CAUSE_PASS_RESULT'), res.detail, 'warning',
                            function() {
                              setSessionEnroll(params);
                            });
                          break;
                          case 1:
                            var prerequisites = [];
                            angular.forEach(res.preItems, function (preItem) {
                              angular.forEach(preItem.records, function (record) {
                                prerequisites.push(record.objectName)
                              });
                            });

                            SweetAlert.warning($filter('translate')('MESSAGE.MSG_ERROR_NEED_FINISH_PREREQUISITE_ITEMS'), $filter('arrayToString')(prerequisites, '<br>'));
                            break;
                          case 7:
                            if(res.isNeedApproval){
                              SweetAlert.warning('',$filter('translate')('MESSAGE.MSG_ENROLLMENT_APPROVAL_PENDING'));
                            }
                            $mdDialog.hide();
                            if(vm.enrollReqData.isHasPreEnrollSurvey)
                              save(testQuestionnaireService.getAnswers(vm.questionModel, vm.questionnaireData), vm.exam.feedbackType, true);
                            break;
                        }

                      });
                    }
                  }


                  vm.reasonCheck = function () {
                    vm.form.$setSubmitted();
                    if(!vm.form.$valid) {
                      return false;
                    }
                    else {
                      if(!vm.isStartFillIn) {
                        SweetAlert.check('', $filter('translate')('MESSAGE.MSG_BEFORE_YOU_REGISTER_YOU_MUST_FILL_OUT_THE_REGISTRATION_QUESTIONNAIRE_ARE_YOU_SURE_YOU_WANT_TO_CONTINUE'), 'warning', function() {
                          vm.getTestInfo(vm.sessionId, vm.itemId);
                        },function(){
                          $scope.close();
                        });
                      }else {
                        vm.pageView='form';
                      }
                      return true;
                    }

                  };

                  vm.nextStep = function () {
                    WizardHandler.wizard('sessionActionEnroll').next();
                  };

                  vm.previousStep = function () {
                    WizardHandler.wizard('sessionActionEnroll').previous();
                    vm.pageView ='reason';
                  };

                  //questionnaire
                  vm.getTestInfo = function(sessionId, itemId) {
                    testQuestionnaireService.getExamInfo(sessionId, {itemid: itemId}).then(function (examInfo) {
                      vm.exam = examInfo;
                      if(examInfo.isOverMaxViewTimes > 0 || examInfo.isNotAccessPeriod > 0 || examInfo.isNotValidReTest > 0 || examInfo.canPlay === 0 || examInfo.isNotFitAttedDance === 1){
                        vm.pageView = 'status';
                      } else{
                        vm.pageView = 'start';
                      }
                    });
                  };

                  vm.startExam = function () {
                    testQuestionnaireService.getExamToken(vm.sessionId, {itemid:vm.itemId}).then(function (data) {
                      vm.examHistoryId = data.examhistoryId;
                      var params = {
                        itemid: vm.itemId,
                        examhistoryId: vm.examHistoryId
                      };
                      getQuestions(vm.sessionId, params);
                      vm.isStartFillIn = true;
                      vm.questionCurrentPage = 1;
                    });
                  };

                  var getQuestions = function(sessionId, params) {
                    testQuestionnaireService.getQuestions(vm.sessionId, params).then(function (questionnaireData) {
                      vm.questionnaireData = questionnaireData;
                      vm.questionsPagination = questionnaireData.metadata.pagination;
                      vm.questionModel = testQuestionnaireService.getQuestionModel(questionnaireData);
                      vm.pageView = 'form';
                    });
                  };

                  vm.finishedExam = function () {
                    testQuestionnaireService.finishedExam(vm.questionModel).then(function(){
                      vm.submitFn();
                    });
                  };

                  var save = function (answers, feedbackType, isFinished) {

                    var assessment = testQuestionnaireService.getAssessment(sessionId);
                    assessment.get().then(function () {

                      testQuestionnaireService.putTestAnswer(assessment, {answers: answers}, {itemid:vm.itemId, examhistoryId: vm.examHistoryId}).then(function (response) {

                        if(response.status === 1 && isFinished){
                          testQuestionnaireService.putTestFinish(assessment, {itemid:vm.itemId, examhistoryId: vm.examHistoryId}).then(function () {
                          });
                        }
                      });
                    });

                  };

                }],
              multiple: true,
              controllerAs: '$ctrl',
              parent: angular.element($document[0].body),
              targetEvent: ev,
              clickOutsideToClose:true,
              locals : {
                sessionId: scope.sessionId,
                isProgram: angular.isUndefinedOrNull(scope.isProgram) ? false : scope.isProgram
              },
              fullscreen: true // Only for -xs, -sm breakpoints.
            }).then(function() {
                if(angular.isDefined(scope.reloadFn)) scope.reloadFn();
              }
            );
          }
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('sessionActionEnroll', sessionActionEnroll);

})();

/**
 * Created by Alan on 2016/12/20.
 */

(function () {
  'use strict';

  programDetailLessonsResultsDialog.$inject = ['$mdDialog'];
  function programDetailLessonsResultsDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        enrollmentId: '=?',
        isManager:    '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/program-detail-lessons-results-dialog.html',
            controller: ['courseResourceService', '$mdDialog', 'enrollmentId',
              function (courseResourceService, $mdDialog, enrollmentId) {
                var vm = this;
                vm.enrollmentId = enrollmentId;
                vm.isManager = angular.isUndefinedOrNull(this.isManager) ? false : this.isManager;

                courseResourceService.getLearningResult(enrollmentId, true).then(function (learningResult) {
                  vm.learningResult = learningResult;
                });

                courseResourceService.getProgramEnrollment(enrollmentId, {}).then(function (enrollmentData) {
                  vm.enrollmentData = enrollmentData;
                });

                vm.close = function() {
                  $mdDialog.cancel();
                };

            }],
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              enrollmentId: scope.enrollmentId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('programDetailLessonsResultsDialog', programDetailLessonsResultsDialog);

})();

/**
 * Created by Alan on 2016/12/20.
 */

(function () {
  'use strict';

  programDetailInfoDialog.$inject = ['$mdDialog', 'SweetAlert', '$filter'];
  function programDetailInfoDialog($mdDialog ,SweetAlert, $filter) {
    var directive = {
      restrict: 'A',
      scope: {
        programId: '=?',
        isPublished: '=?',
        canView: '=?'
      },
      link: function (scope, element) {
          element.bind('click', function (ev) {
            if(scope.isPublished===0)
              SweetAlert.warning('', $filter('translate')('MESSAGE.MSG_ERROR_NOT_PUBLISH'));
            else if(scope.canView===0)
              SweetAlert.warning('', $filter('translate')('MESSAGE.MSG_YOU_DO_NOT_HAVE_PERMISSION_TO_VIEW_THIS_LEARNING_ACTIVITY'));
            else {
              $mdDialog.show({
                templateUrl: 'app/modules/course-resource/views/program-detail-info-dialog.html',
                controller: ['courseResourceService', '$mdDialog', 'programId',
                  function (courseResourceService, $mdDialog, programId) {
                    var vm = this;
                    courseResourceService.getProgram(programId, null).then(function (programData) {
                      vm.programData = programData;
                      vm.programData.courseName = vm.programData.programName;
                    });

                    vm.close = function () {
                      $mdDialog.cancel();
                    };

                  }],
                controllerAs: '$ctrl',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                  programId: scope.programId
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
              });
            }
          });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('programDetailInfoDialog', programDetailInfoDialog);

})();

/**
 * Created by Bruce on 2016/6/4.
 */
(function () {
  'use strict';

  optionsTpl.$inject = ['$filter','SweetAlert'];
  function optionsTpl($filter,SweetAlert) {

    var directive ={
      restrict: 'EA',
      require: 'ngModel',
      scope: {
        raId: "=",
        questionId: "=",
        questionModel:"=ngModel",
        questionType:"=",
        questionOptions: "=",
        feedbackStyle: "=",
        feedbackType: "=",
        studentResponse: "=",
        otherAnswer: "=",
        isOnlyReviewQuestion: "=?",
        isAllowViewScore: "=?",
        isAllowViewCorrectAns: "=?",
        selectOptionType:"=?",
        selectedOptionCount: "=?",
        onChange: "&?"
      },
      templateUrl:'app/modules/course-resource/views/test-questionnaire/options-tpl.html',
      link : function(scope){
        scope.isValueChange = false;
        scope.$watch('questionModel', function(newValue, oldValue) {
          if (!(angular.equals(oldValue.optionNumber, newValue.optionNumber)) || !(angular.equals(oldValue.optionOtherValue, newValue.optionOtherValue))){
            if(scope.onChange && scope.questionType!==3 ){
              scope.onChange();
            }else {
              scope.isValueChange = true
            }
          } else {
            if (!angular.isUndefinedOrNull(newValue.optionOtherValue)) {
              if (scope.countWords(newValue.optionOtherValue) > 50) {
                SweetAlert.error('', $filter('translate')('MESSAGE.MSG_INPUT_ANSWER_EXCEED_LIMIT'));
              }
            }
          }
        },true);

        scope.blurFn = function() {
          if(scope.isValueChange)
            scope.onChange();
          scope.isValueChange = false;
        }
      },
      controller: ['$window', '$scope', function ($window, $scope) {
        $scope.isOnlyReviewQuestion = angular.isUndefined($scope.isOnlyReviewQuestion) ? false : $scope.isOnlyReviewQuestion;
        $scope.isAllowViewScore = angular.isUndefined($scope.isAllowViewScore) ? false : $scope.isAllowViewScore;
        $scope.isAllowViewCorrectAns = angular.isUndefined($scope.isAllowViewCorrectAns) ? false : $scope.isAllowViewCorrectAns;


        if($scope.feedbackStyle === 4){
          $scope.iconFaces=[];
          switch ($scope.questionOptions.length){// 01 Bad -> 10 Good
            case 1:case 2:case 3:case 4:case 5:
              $scope.iconFaces=['01','06','08','09','10'];
              break;
            case 6:
              $scope.iconFaces=['01','05','06','08','09','10'];
              break;
            case 7:
              $scope.iconFaces=['01','05','06','07','08','09','10'];
              break;
            case 8:
              $scope.iconFaces=['01','04','05','06','07','08','09','10'];
              break;
            case 9:
              $scope.iconFaces=['01','02','04','05','06','07','08','09','10'];
              break;
            case 10:
              $scope.iconFaces=['01','02','03','04','05','06','07','08','09','10'];
              break;
            default:
              break;
          }
        }

        if(angular.isUndefined($scope.$parent.questionModel)) $scope.$parent.questionModel={};
        if(angular.isUndefined($scope.questionModel)) $scope.questionModel={};

        if($scope.raId > 0) $scope.questionModel.raId = $scope.raId;
        if($scope.otherAnswer.length > 0) $scope.questionModel.optionOtherValue = $scope.otherAnswer;

        $scope.disabledOption = function (newVal, oldVal, type) {
          switch (type){
            case 'radio':
              if(newVal != oldVal) {
                $scope.questionModel.optionOtherValue = '';
              }
              return (newVal != oldVal);
            case 'checkbox':
              var isDisable = true;
              if(angular.isDefined(newVal)) {
                if(!newVal.includes(oldVal)) $scope.questionModel.optionOtherValue = '';
                if (newVal.includes(oldVal)) isDisable = false;
              }
              return isDisable;
          }
        };

        $scope.checkSelectCount = function (option) {
          if(angular.isUndefined($scope.questionModel.optionNumber)) $scope.questionModel.optionNumber=[];
          if($scope.selectOptionType === 1 && ($scope.questionModel.optionNumber.length === parseInt($scope.selectedOptionCount))
          ){
            return (true && !($scope.questionModel.optionNumber.indexOf(option.optionNumber) > -1));
          }else{
            return (false && !($scope.questionModel.optionNumber.indexOf(option.optionNumber) > -1));
          }
        };

        $scope.optionsToggle = function (item, type) {

          switch (type){
            case 'checkbox':
              if(angular.isUndefined($scope.questionModel.optionNumber)) $scope.questionModel.optionNumber=[];
              var idx = $scope.questionModel.optionNumber.indexOf(item.optionNumber);
              if (idx > -1) {
                $scope.questionModel.optionNumber.splice(idx, 1);
              }
              else {
                $scope.questionModel.optionNumber.push(item.optionNumber);
              }
              break;
            default:
              $scope.questionModel.optionNumber = item.optionNumber;
              break;
          }
        };

        $scope.openImage = function(imgUrl) {
          $window.open(imgUrl, 'QImag', 'width=' + $window.innerWidth*2/3 + ',height=' + $window.innerHeight*2/3 + ',location=no, scrollbars=yes, resizable=yes');
        };

        $scope.optionOtherValueOnKeyup = function(event){
          if($scope.countWords(event.delegateTarget.value) > 50){
            var newOptionValue = $scope.optionSubstring(event.delegateTarget.value, 50);
            $scope.questionModel.optionOtherValue = newOptionValue;
            $scope.questionModel.otherAnswer = newOptionValue;
            SweetAlert.error('', $filter('translate')('MESSAGE.MSG_INPUT_ANSWER_EXCEED_LIMIT'));
          }
        }

        $scope.optionOtherValueOnBlur = function(event){
          if($scope.countWords(event.delegateTarget.value) > 50){
            var newOptionValue = $scope.optionSubstring(event.delegateTarget.value, 50);
            $scope.questionModel.optionOtherValue = newOptionValue;
            $scope.questionModel.otherAnswer = newOptionValue;
          }
        }

        $scope.optionSubstring = function (str, length) {
          return str.substring(0, $scope.countWords(str) < length ? str.length : length);
        }


        $scope.countWords = function(word){
          if(word === null || word === '' || typeof word === 'undefined'){
            return 0;
          }
          return word.length;
        };

      }]
    };
    return directive;
  }


  angular.module('eHRD.modules.courseResource')
    .directive('optionsTpl', optionsTpl);
})();

/**
 * Created by Blan on 2017/05/22.
 */
(function() {
  'use strict';

  learningReportListDialog.$inject = ['$mdDialog'];
  function learningReportListDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        mode: '@?',
        batchId: '=?',
        enrollmentId: '=?',
        activityName: '=?', //courseName or programName
        isProgram: '=?',
        canEdit: '=?'
      },
      link: function(scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/learning-report-list-dialog.html',
            controller: ['SweetAlert', '$interpolate', '$scope', '$filter', '$mdDialog', 'NgTableParams', 'ngTableColumnValueService', 'fileProcessService', 'courseResourceService', 'mode', 'batchId', 'enrollmentId', 'isProgram', 'activityName', 'canEdit',
              function(SweetAlert, $interpolate, $scope, $filter, $mdDialog, NgTableParams, ngTableColumnValueService, fileProcessService, courseResourceService, mode, batchId, enrollmentId, isProgram, activityName, canEdit ) {
                var vm = this;
                vm.canEdit = canEdit;
                vm.isProgram = isProgram;
                vm.activityName = activityName;
                prepareTable();
                function prepareTable() {
                  vm.tableCols = prepareTableCols();
                  vm.learningReportListTable = new NgTableParams({}, {
                    counts: [],
                    getData: function() {
                      var params = {};
                      switch (mode){
                        case 'workflow':
                          params.mode = mode;
                          params.batchId = batchId;
                          break;
                      }
                      if(vm.isProgram) params.iscourse=0;
                      return fileProcessService.getLearningReportList(enrollmentId, params).then(function(learningReport){
                        vm.learningReport = learningReport;
                        angular.forEach(vm.learningReport, function (val, key) {
                          vm.learningReport[key].$index = key;
                        });
                        return learningReport ;
                      });
                    }
                  });
                }

                function prepareTableCols() {
                  return [{
                    field: 'index',
                    title: '#',
                    getValue: ngTableColumnValueService.htmlTextValue,
                    width: 50,
                    priority: 1
                  },{
                    field: 'fileName',
                    title: $filter('translate')('FIELD.FILE_NAME'),
                    getValue: ngTableColumnValueService.interpolatedValue,
                    interpolateExpr: $interpolate("<div class='text'><a ng-href='{{row.fileUrl}}' target='_blank'>{{row.fileName}}</a></div>"),
                    priority: 1
                  },{
                    field: 'submitDate',
                    title: $filter('translate')('FIELD.DATE_OF_PAYMENT'),
                    getValue: ngTableColumnValueService.htmlTextValue,
                    priority: 1
                  },{
                    field: 'fileSize',
                    columnType: 'number',
                    title: $filter('translate')('FIELD.SIZE'),
                    getValue: ngTableColumnValueService.interpolatedValue,
                    interpolateExpr: $interpolate("<div class='text'>{{row.fileSize | suffixes: 'byte'}}</div>"),
                    priority: 1
                  },{
                    field: 'score',
                    title: $filter('translate')('FIELD.SCORE'),
                    getValue: ngTableColumnValueService.interpolatedValue,
                    interpolateExpr: $interpolate("<md-input-container md-no-float class='m-t-0 m-b-0 no-md-errors-spacer'><input ng-model='$ctrl.learningReport[row.$index].score' placeholder='SCORE' ng-disabled='!$ctrl.canEdit'></md-input-container>"
                    ),
                    priority: 1
                  }];
                }

                vm.submit = function () {
                  var params = {};
                  params.iscourse = (vm.isProgram) ? 0 : 1;
                  params.batchId = batchId;
                  var data = [];
                  angular.forEach(vm.learningReport, function (learningReport) {
                    data.push({
                      learningReportId: learningReport.learningReportId,
                      score: learningReport.score
                    })
                  });

                  function preConfirm() {
                    return new Promise(function (resolve) {
                      fileProcessService.learningReportSetScore(enrollmentId, { learningReportItems: data }, params).then(function (res) {
                        if(res.status === 1) {
                          SweetAlert.insertSuccessQueueStep('',$filter('translate')('MESSAGE.MSG_SUCCESSFUL_OPERATION'), false, $mdDialog.cancel());
                        }else if(res.status === 0){
                          SweetAlert.insertErrorQueueStep('',$filter('translate')('MESSAGE.MSG_FAILED_OPERATION') , false);
                        }
                        resolve();
                      });
                    });
                  }

                  SweetAlert.submitCheck('',$filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                };

                vm.close = function() {
                  $mdDialog.cancel();
                };
              }
            ],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              mode: angular.isDefined(scope.mode) ? scope.mode : '',
              batchId: angular.isDefined(scope.batchId) ? scope.batchId : -1,
              enrollmentId: scope.enrollmentId,
              activityName: scope.activityName,
              isProgram: scope.isProgram,
              canEdit: angular.isDefined(scope.canEdit) ? scope.canEdit : false
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('learningReportListDialog', learningReportListDialog);
})();

/**
 * Created by Alan on 2016/12/27.
 */
(function() {
  'use strict';

  learningReportDialog.$inject = ['$mdDialog'];
  function learningReportDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        courseId: '=?',
        programId: '=?',
        activityName: '=?', //courseName or programName
        isProgram: '=?'
      },
      link: function(scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/learning-report-dialog.html',
            controller: ['$scope', '$mdDialog', 'NgTableParams', 'fileProcessService', 'courseResourceService', 'courseId', 'programId', 'isProgram', 'activityName',
              function($scope, $mdDialog, NgTableParams, fileProcessService, courseResourceService, courseId, programId, isProgram, activityName ) {
                var vm = this;
                vm.isProgram = isProgram;
                vm.activityName = activityName;

                if(vm.isProgram===1) {
                  courseResourceService.getProgram(programId).then(function(program){
                    vm.program = program;
                    vm.programIncludeCourse = 0;
                    $scope.$watch('$ctrl.programIncludeCourse', function(programIncludeCourse) {
                      courseId = programIncludeCourse;
                      vm.learningReportTable.reload();
                    });
                  });
                }
                vm.learningReportTable = new NgTableParams({ sorting: { 'LearningReport.SubmitDate': "desc" } }, {
                  counts: [1,5,10,15],
                  getData: function(tableParams) {
                    var params = {};

                    if(vm.isProgram===1) {
                      params.programId = programId;
                      params.courseId = courseId;
                    }
                    else {
                      params.courseId = courseId;
                    }

                    angular.forEach(tableParams.sorting(), function (value, key) {
                      params.sort = key;
                      params.order = ((value === 'desc') ? "DESC" : "ASC");
                    });

                    params.current_page = tableParams.url().page;
                    params.list_size = tableParams.url().count;
                    return fileProcessService.getLearningReport(params).then(function(learningReport){
                      tableParams.total(learningReport.metadata.pagination.total);
                      return learningReport ;
                    });
                  }
                });

                vm.close = function() {
                  $mdDialog.cancel();
                };
              }
            ],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              courseId: scope.courseId,
              programId: scope.programId,
              activityName: scope.activityName,
              isProgram: scope.isProgram
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('learningReportDialog', learningReportDialog);
})();

/**
 * Created by Alan on 2016/11/25.
 */

(function () {
  'use strict';

  learningHistory.$inject = ['$mdDialog'];
  function learningHistory($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        enrollmentId: '=?',
        sessionId:    '=?',
        isManager:    '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/learning-history-dialog.html',
            controller: ['managerService', 'enrollmentId', 'sessionId', '$mdDialog', 'courseResourceService',
              function (managerService, enrollmentId, sessionId, $mdDialog, courseResourceService) {
                var vm = this;
                vm.sessionId = sessionId;
                vm.enrollmentId = enrollmentId;
                vm.isManager = angular.isUndefinedOrNull(this.isManager) ? false : this.isManager;
                var learningHistoryService = (vm.isManager)? managerService.getMemberLearningHistory(enrollmentId) : courseResourceService.getLearningHistory(enrollmentId);
                learningHistoryService.then(function (learningHistory) {
                  vm.learningHistory = learningHistory;
                  vm.attendanceRecords = learningHistory.attendanceRecord;
                  vm.learningHistoryItems = learningHistory.learningHistoryItem;
                });

                vm.close = function() {
                  $mdDialog.cancel();
                };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              enrollmentId: scope.enrollmentId,
              sessionId:    scope.sessionId
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.manager')
    .directive('learningHistory', learningHistory);

})();

/**
 * Created by Alan on 2016/11/14.
 */
(function () {
    'use strict';

    instructorDetail.$inject = ['$mdDialog'];
    function instructorDetail($mdDialog) {

        var directive ={
            restrict: 'EA',
            scope: {
                instructorId:'='
            },
            link:function(scope,element){
                element.on('click', function (ev) {
                    $mdDialog.show({
                        multiple: true,
                        templateUrl: 'app/modules/course-resource/views/instructor-detail.html',
                        controller:'InstructorDetailController',
                        controllerAs:'IDC',
                        clickOutsideToClose:true,
                        targetEvent: ev,
                        locals:{
                            instructorId:scope.instructorId
                        },
                        fullscreen: true // Only for -xs, -sm breakpoints.
                    });
                })
            }
        };
        return directive;
    }


    angular.module('eHRD.modules.courseResource')
        .directive('instructorDetail', instructorDetail);
})();

/**
 * Created by Bruce on 2016/12/8.
 */

(function () {
  'use strict';

  incompleteDynamicTemplate.$inject = [];
  function incompleteDynamicTemplate() {
    return {
      restrict: 'A',
      controller: ['$http', '$templateCache', '$interpolate', '$compile', '$scope', '$attrs', '$element', 'incompleteTemplates',
        function ($http, $templateCache, $interpolate, $compile, $scope, $attrs, $element, incompleteTemplates) {
          $scope.$watch($attrs.name, function(name) {
            var templateName = incompleteTemplates[name];
            if(angular.isUndefined($templateCache.get(templateName))){
              $http.get(templateName).then(function(response) {
                var templateContents = response.data
                  .replace('{{', $interpolate.startSymbol())
                  .replace('}}', $interpolate.endSymbol());
                $templateCache.put(templateName, templateContents);
                var template = $templateCache.get(templateName);
                $element.html(template);
                $compile($element.contents())($scope);
              });
            }else{
              var template = $templateCache.get(templateName);
              $element.html(template);
              $compile($element.contents())($scope);
            }

          });

      }]
    };
  }
  angular.module('eHRD.modules.courseResource')
    .directive('incompleteDynamicTemplate', incompleteDynamicTemplate);

})();

/**
 * Created by Bruce on 2017/2/3.
 */
(function () {
  'use strict';

  externalTrainingBulletinDetailedDialog.$inject = ['$mdDialog', '$document'];
  function externalTrainingBulletinDetailedDialog($mdDialog, $document) {
    var directive = {
      restrict: 'A',
      scope: {
        bulletinId: '=?',
        courseId: '=?',
        sessionId: '=?',
        isCourse: '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            templateUrl: 'app/modules/course-resource/views/external/external-training-bulletin-detailed-dialog.html',
            controller: ['externalTrainingService', '$mdDialog', 'isCourse', 'bulletinId', 'courseId', 'sessionId',
              function (externalTrainingService, $mdDialog, isCourse, bulletinId, courseId, sessionId) {
                var vm = this;
                if(angular.isDefined(isCourse) && isCourse){
                  externalTrainingService.getExtCourseFormByCourseSession(courseId, sessionId).then(function (data) {
                    vm.bulletinDetailed = data;
                  });
                }else{
                  externalTrainingService.getExtCourseFormByBulletin(bulletinId).then(function (data) {
                    vm.bulletinDetailed = data;
                  });
                }

                vm.close = function() {
                  $mdDialog.cancel();
                };

              }],
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              bulletinId: scope.bulletinId,
              courseId: scope.courseId,
              sessionId: scope.sessionId,
              isCourse: scope.isCourse
            },
            multiple: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('externalTrainingBulletinDetailedDialog', externalTrainingBulletinDetailedDialog);

})();

/**
 * Created by Bruce on 2017/3/1.
 */
(function () {
  'use strict';

  externalTrainingApplyFormViewDialog.$inject = ['$document', '$mdDialog'];
  function externalTrainingApplyFormViewDialog($document, $mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        formData : '=?',
        externalId: '=?externalId'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            template:
            '<md-dialog aria-label="{{ \'EXTERNAL_TRAINING_APPLY_FORM\' | translate}}" flex="80">' +
              '<md-toolbar>' +
                '<div class="md-toolbar-tools">' +
                  '<h2>{{ \'EXTERNAL_TRAINING_APPLY_FORM\' | translate}}/{{ \'FIELD.REQUISITION_NUMBER\' | translate }}:<strong>{{$ctrl.formData.externalId}}</strong></h2>' +
                  '<span flex></span>' +
                  '<md-button class="md-icon-button" external-training-apply-form-print-dialog form-data="$ctrl.formData" ng-if="$ctrl.formData.flowStatus === 0 || $ctrl.formData.flowStatus === 1">' +
                    '<md-tooltip md-direction="bottom">{{ \'ACTIONS.PRINT\' | translate}}</md-tooltip>' +
                    '<md-icon md-font-set="md" aria-label="{{ \'ACTIONS.PRINT\' | translate}}">print</md-icon>' +
                  '</md-button>' +
                  '<md-button class="md-icon-button" ng-click="$ctrl.close()">' +
                    '<md-tooltip md-direction="bottom">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip>' +
                    '<md-icon md-font-set="md" aria-label="{{ \'ACTIONS.CLOSE\' | translate}}">close</md-icon>' +
                  '</md-button>' +
                '</div>' +
              '</md-toolbar>' +
              '<md-dialog-content>' +
                '<md-content class="md-padding">' +
                  '<external-training-apply-form-view data="$ctrl.formData"></external-training-apply-form-view>' +
                '</md-content>' +
              '</md-dialog-content>' +
            '</md-dialog>',
            controller: [ 'userService', 'externalTrainingService', 'externalId', function (userService, externalTrainingService, externalId) {
                var vm = this;
                vm.externalId = angular.isDefined(externalId) ? externalId : undefined;

                if(angular.isDefined(vm.externalId)){
                  externalTrainingService.getExtCourseForm(vm.externalId).then(function (formData) {
                    vm.formData = formData;
                  });
                }

                vm.close = function() {
                  $mdDialog.cancel();
                };
              }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formData: scope.formData,
              externalId: scope.externalId
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('externalTrainingApplyFormViewDialog', externalTrainingApplyFormViewDialog);

})();

/**
 * Created by Bruce on 2017/2/21.
 */
(function () {
  'use strict';

  externalTrainingApplyFormPrintDialog.$inject = ['$window', 'serverSetting'];
  function externalTrainingApplyFormPrintDialog($window, serverSetting) {
    var directive = {
      restrict: 'A',
      scope: {
        formData : '=?'
      },
      link: function (scope, element) {
        element.bind('click', function() {
          if(angular.isDefined(scope.formData) && scope.formData.externalId > 0){
            var url = serverSetting.baseConfig.baseURL + '/home-external-print-form.do?id=' + scope.formData.externalId;
            $window.open(url, 'print', 'width=' + $window.innerWidth + ',height=' + $window.innerHeight + ',location=no');
          }
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('externalTrainingApplyFormPrintDialog', externalTrainingApplyFormPrintDialog);

})();

/**
 * Created by Alan on 2017/7/12.
 */
(function () {
  'use strict';

  externalCompanyInsertDialog.$inject = ['$mdDialog', 'fileProcess'];
  function externalCompanyInsertDialog($mdDialog, fileProcess) {
    var directive = {
      restrict: 'A',
      scope: {
        isVendorsReload: '=?',
        addVendor: '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/external/external-company-insert-dialog.html',
            controller: ['$mdDialog', 'externalTrainingService', '$timeout', 'SweetAlert', '$filter', 'addVendor',
              function ($mdDialog, externalTrainingService, $timeout, SweetAlert, $filter, addVendor) {
                var vm = this;
                vm.externalTrainingVendors = true;
                vm.form = "";
                vm.formData = {
                  vendorName: '',
                  vendorNumber: '',
                  bankName: '',
                  bankAccount: '',
                  classificationId: '',
                  vendorAddress: '',
                  vendorTel: '',
                  vendorFax: '',
                  contact: [
                    {
                      fullName: '',
                      phone: '',
                      mobilePhone: '',
                      mail: ''
                    }
                  ],
                  introduction: '',
                  url: '',
                  vendorComment: '',
                  receiverName: ''
                };

                vm.addContact = function() {
                  vm.formData.contact.push({
                    fullName: '',
                    phone: '',
                    mobilePhone: '',
                    mail: ''
                  });
                };

                vm.removeContact = function(contact) {
                  vm.formData.contact.splice(vm.formData.contact.indexOf(contact), 1);
                };

                vm.submit = function(files) {
                  vm.submitted = true;
                  vm.form.$setSubmitted();
                  $timeout(function() {
                    if(vm.form.$valid) {
                      if(fileProcess.checkUploadType(files) && fileProcess.checkUploadSize(files)) {
                        SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_EXTERNAL_TRAINING_APPLY_SUMMIT_CHECK'), preConfirm);
                      }
                    }
                  });

                  function preConfirm() {
                    return new Promise(function (resolve) {
                      var formData = {
                        VendorName: vm.formData.vendorName,
                        VendorNumber: vm.formData.vendorNumber,
                        VendorAddress: vm.formData.vendorAddress,
                        VendorTel: vm.formData.vendorTel,
                        VendorFax: vm.formData.vendorFax,
                        VendorURL: vm.formData.url,
                        VendorComment: vm.formData.vendorComment,
                        BankName: vm.formData.bankName,
                        BankAccount: vm.formData.bankAccount,
                        VendorIntroduction: vm.formData.introduction,
                        ReceiverName: vm.formData.receiverName,
                        ClassificationId: vm.formData.classificationId
                      };
                      var contactCount = 1;
                      angular.forEach(vm.formData.contact, function(contact){
                        if(contact.fullName!=='' || contact.phone!=='' || contact.mobilePhone!=='' || contact.mail!=='') {
                          formData['personName_' + contactCount]   = contact.fullName;
                          formData['personPhone_' + contactCount]  = contact.phone;
                          formData['personMPhone_' + contactCount] = contact.mobilePhone;
                          formData['personEmail_' + contactCount]  = contact.mail;
                          contactCount++;
                        }
                      });

                      externalTrainingService.addVendor(formData, 'ref', files).then(function(result){
                        if(angular.isDefined(addVendor))
                          //addVendor.push(result.data.data.vendorId);
                          addVendor.push({
                            vendorId: result.data.data.vendorId,
                            vendorName: result.data.data.vendorName
                          });
                        SweetAlert.insertSuccessQueueStep('', $filter('translate')('MESSAGE.MSG_YOU_HAVE_SUCCESSFULLY_ADDED_EXTERNAL_VENDOR'), false, function(){
                          $mdDialog.cancel();
                        });
                        resolve();
                      });
                    });
                  }

                };

                vm.close = function() {
                  $mdDialog.cancel();
                };

              }],
            multiple: true,
            controllerAs: '$ctrl',
            clickOutsideToClose:true,
            targetEvent: ev,
            locals : {
              addVendor: scope.addVendor
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(null, function() {
            if(angular.isDefined(scope.isVendorsReload)) scope.isVendorsReload = true;
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('externalCompanyInsertDialog', externalCompanyInsertDialog);

})();

/**
 * Created by Bruce on 2016/12/13.
 */
(function () {
  'use strict';

  evaluationSurveyPlayer.$inject = [ '$window', '$interval', '$state'];
  function evaluationSurveyPlayer( $window, $interval, $state) {
    var directive = {
      restrict: 'A',
      scope: {
        enrollmentId:'=?',
        relationshipId: '=?',
        surveyId: '=?',
        isCheckTime:'@?',
        reloadFn:'&?'
      },
      link: function (scope, element) {
        scope.enrollmentId = angular.isUndefined(scope.enrollmentId) ? null : scope.enrollmentId;
        scope.isCheckTime = angular.isUndefined(scope.isCheckTime) ? false : scope.isCheckTime;

        element.bind('click', function() {
          var relationshipId = scope.relationshipId,
              surveyId = scope.surveyId;
          if(!angular.isUndefinedOrNull(scope.enrollmentId)){
              playWindowController(relationshipId, surveyId);
          }
        });


        function playWindowController(relationshipId, surveyId) {
          //var playUrl = serverSetting.baseConfig.baseURL + '/ev-survey-play.do?relationId='+ relationshipId +'&surveyId=' + surveyId + '&playMode=start&preview=false&targetName=Administrator%20CTMS';
          var playUrl = $state.href('evaluationSurvey', {relationId: relationshipId, surveyId: surveyId});
          var playerWindow = $window.open(playUrl, 'player', 'width=' + $window.innerWidth + ',height=' + $window.innerHeight + ',location=no, scrollbars=yes, resizable=yes');

          var checkTimer = $interval(checkPlayWindow, 500);

          function checkPlayWindow() {
            if(playerWindow.closed) {
              if(angular.isDefined(scope.reloadFn) && angular.isFunction(scope.reloadFn)) scope.reloadFn();
              $interval.cancel(checkTimer);
            }
          }
        }
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('evaluationSurveyPlayer', evaluationSurveyPlayer);

})();

/**
 * Created by Alan on 2016/2/6.
 */

(function () {
  'use strict';

  detailSessionListDialog.$inject = ['$mdDialog'];
  function detailSessionListDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        courseId: '=',
        isProgram: '=',
        reloadFn:'&?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/detail-session-list-dialog.html',
            controller: ['courseResourceService', '$mdDialog', 'courseId', 'isProgram',
              function (courseResourceService, $mdDialog, courseId, isProgram) {
                var vm = this;
                vm.courseId = courseId;
                vm.isProgram = isProgram;

                vm.close = function() {
                  $mdDialog.cancel();
                };

            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              courseId: scope.courseId,
              isProgram: scope.isProgram
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(null, function() {
            if(angular.isDefined(scope.reloadFn)) scope.reloadFn();
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('detailSessionListDialog', detailSessionListDialog);

})();

/**
 * Created by Bruce on 2016/11/19.
 */

(function () {
  'use strict';

  courseTypeTag.$inject = [];
  function courseTypeTag() {
    var directive = {
      restrict: 'EA',
      templateUrl:'app/modules/course-resource/views/course-session-info-template/course-type-tag.html',
      scope: {
        courseType: '=?',
        isProgram: '=?',
        programType: '=?',
        isShowText:'=?',
        isShowClass: '=?'
      },
      controller: ['$scope', function ($scope) {
        $scope.courseType = angular.isDefined($scope.courseType) ? $scope.courseType : null;
        $scope.isProgram = angular.isDefined($scope.isProgram) ? $scope.isProgram : null;
        $scope.programType = angular.isDefined($scope.programType) ? $scope.programType : 0;
        $scope.isShowText = angular.isDefined($scope.isShowText) ? $scope.isShowText : true;
        $scope.isShowClass = angular.isDefined($scope.isShowClass) ? $scope.isShowClass : false;
      }]
    };
    return directive;
  }

angular.module('eHRD.modules.courseResource')
  .directive('courseTypeTag', courseTypeTag);

})();

/**
 * Created by Bruce on 2016/10/26.
 */
(function () {
  'use strict';

  courseInfoSessionWillExpire.$inject = ['$mdDialog'];
  function courseInfoSessionWillExpire($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        enrollmentId: '=',
        courseType: '=',
        isCourse: '='
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/course-resource/views/will-expire-list.html',
            controller: ['courseResourceService', '$mdDialog', 'enrollmentId', 'courseType', 'isCourse',
              function (courseResourceService, $mdDialog, enrollmentId, courseType, isCourse) {
                var vm = this;
                vm.courseType = courseType;
                courseResourceService.getEnrollmentWillExpire(enrollmentId, {}, isCourse).then(function (willExpireDatas) {
                  vm.willExpireDatas = willExpireDatas;
                });

                vm.close = function() {
                  $mdDialog.cancel();
                };

              }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              enrollmentId: scope.enrollmentId,
              courseType: scope.courseType,
              isCourse: scope.isCourse
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('courseInfoSessionWillExpire', courseInfoSessionWillExpire);

})();

/**
 * Created by Bruce on 2016/10/26.
 */
(function () {
  'use strict';

  courseInfoReference.$inject = ['ngDialog', 'courseResourceService'];
  function courseInfoReference(ngDialog, courseResourceService) {
    var directive = {
      restrict: 'A',
      scope: {
        courseId: '='
      },
      link: function (scope, element) {
        element.bind('click', function() {
          courseResourceService.setCourseId(scope.courseId);
          ngDialog.open({
            template: 'app/modules/course-resource/views/reference-list.html',
            className: 'ngdialog-theme-default',
            width: '70%',
            controller: 'CourseReferenceController',
            controllerAs: 'CRC'
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('courseInfoReference', courseInfoReference);

})();

/**
 * Created by Bruce on 2016/10/26.
 */
(function () {
  'use strict';

  courseInfoPlayer.$inject = [ '$window', 'serverSetting', '$interval', 'SweetAlert', 'courseResourceService', 'courseULiveService', 'courseULiveService'];
  function courseInfoPlayer( $window, serverSetting, $interval,SweetAlert , courseResourceService, courseULiveService ) {
    var directive = {
      restrict: 'A',
      scope: {
        uLiveCourseData: '=?',
        playItemId: '=?',
        sessionId: '=?',
        courseId: '=?',
        enrollmentId:'=?',
        isCheckTime:'@?',
        reloadFn:'&?',
        playDisable: '=?',
        enrollmentData: '=?'
      },
      link: function (scope, element) {

        if(angular.isDefined(scope.playDisable) && scope.playDisable) {
          return;
        }

        scope.uLiveCourseData = angular.isUndefined(scope.uLiveCourseData) ? null : scope.uLiveCourseData;
        scope.enrollmentId = angular.isUndefined(scope.enrollmentId) ? null : scope.enrollmentId;
        scope.isCheckTime = angular.isUndefined(scope.isCheckTime) ? false : scope.isCheckTime;
        scope.enrollmentData = angular.isUndefined(scope.enrollmentData) ? null : scope.enrollmentData;


        element.addClass('tree-label');


        if (angular.isDefined(scope.uLiveCourseData)) {
          if(scope.uLiveCourseData.wState === 1 || scope.uLiveCourseData.wState === 3 || scope.uLiveCourseData.wState === 4 ||  scope.uLiveCourseData.wState === 0) {
            element.css('cursor', 'default');
          }
        }

        element.bind('click', function() {
          var playItemId = scope.playItemId,
              sessionId = scope.sessionId,
              courseId = scope.courseId,
              uLiveCourseData = scope.uLiveCourseData;

           if(!angular.isUndefinedOrNull(scope.uLiveCourseData) ) {
             uLiveWindowController(uLiveCourseData, scope.enrollmentData);
           }
           else if (!angular.isUndefinedOrNull(scope.enrollmentId)) {
             courseResourceService.getCourseEnrollment(scope.enrollmentId, {}).then(function (enrollmentData) {
               playItemId = enrollmentData.lastLeaningItem.itemId;
               sessionId = enrollmentData.sessionId;
               playWindowController(playItemId, sessionId, courseId);
             });
           } else {
             playWindowController(playItemId, sessionId, courseId);
           }

        });

        function uLiveWindowController(uLiveCourseData){
          if(uLiveCourseData.wState === 2 ||  uLiveCourseData.wState === 5){
            courseULiveService.getULiveCourseJoin(scope.enrollmentData.courseId, scope.enrollmentData.sessionId, {}).then(function (response) {
              $window.open( response.result, 'ULive', 'width=' + $window.innerWidth  + ',height=' + $window.innerHeight  + ',location=no, scrollbars=yes, resizable=yes');
            });
          }
        }

        function playWindowController(playItemId, sessionId, courseId) {
          var playUrl = serverSetting.baseConfig.baseURL + '/play-index-home.do?itemid='+ playItemId +'&TCMSCLASSID=' + sessionId;
          if(scope.isCheckTime && angular.isDefined(courseId)){
            playUrl = serverSetting.baseConfig.baseURL + '/play-check-time.do?courseId=' + courseId+ '&sessionId=' + sessionId + '&itemId=' + playItemId;
          }

          var playerWindow = $window.open(playUrl, 'player', 'width=' + $window.innerWidth + ',height=' + $window.innerHeight + ',location=no, scrollbars=yes, resizable=yes');

          var checkTimer = $interval(checkPlayWindow, 500);

          function checkPlayWindow() {
            if(playerWindow.closed) {
              if(angular.isDefined(scope.reloadFn) && angular.isFunction(scope.reloadFn)) scope.reloadFn();
                $interval.cancel(checkTimer);
            }
          }
        }

      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('courseInfoPlayer', courseInfoPlayer);

})();

/**
 * Created by Alan on 2016/12/20.
 */

(function () {
  'use strict';

  courseDetailInfoDialog.$inject = ['$mdDialog', 'SweetAlert', '$filter'];
  function courseDetailInfoDialog($mdDialog, SweetAlert, $filter) {
    var directive = {
      restrict: 'A',
      scope: {
        courseId: '=?',
        isPublished: '=?',
        canView: '=?'
      },
      link: function (scope, element) {

        element.bind('click', function(ev) {
          if(scope.isPublished===0)
            SweetAlert.warning('', $filter('translate')('MESSAGE.MSG_ERROR_NOT_PUBLISH'));
          else if(scope.canView===0)
            SweetAlert.warning('', $filter('translate')('MESSAGE.MSG_YOU_DO_NOT_HAVE_PERMISSION_TO_VIEW_THIS_LEARNING_ACTIVITY'));
          else {
            $mdDialog.show({
              templateUrl: 'app/modules/course-resource/views/course-detail-info-dialog.html',
              controller: ['courseResourceService', '$mdDialog', 'courseId',
                function (courseResourceService, $mdDialog, courseId) {
                  var vm = this;

                  courseResourceService.getCourse(courseId, null).then(function (courseData) {
                    vm.courseData = courseData;
                  });

                  courseResourceService.getCourseReference(courseId, {}).then(function (referenceData) {
                    vm.referenceData = referenceData;
                  });

                  vm.close = function() {
                    $mdDialog.cancel();
                  };

                }],
              controllerAs: '$ctrl',
              targetEvent: ev,
              clickOutsideToClose:true,
              locals : {
                courseId: scope.courseId,
                isCourse: scope.isCourse
              },
              fullscreen: true // Only for -xs, -sm breakpoints.
            });
          }
        });

      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('courseDetailInfoDialog', courseDetailInfoDialog);

})();

/**
 * Created by Bruce on 2016/11/1.
 */
(function() {
  'use strict';

  assignableMembers.$inject = ['$mdDialog', '$document', '$filter'];

  function assignableMembers($mdDialog, $document, $filter) {
    var directive = {
      restrict: 'A',
      scope: {
        isProgram: '=?',
        sessionId: '=',
        courseId: '=?',
        sessionName: '=',
        isExternal: '=',
        reloadFn: '&?',
        maxAssignableMembers: '=?maxAssignableMembers',
        enrollType: '@?enrollType' // learner, wait
      },

      link: function(scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            controller: ['$scope', '$q', 'WizardHandler', '$timeout', '$mdDialog', 'sessionName', 'courseId', 'sessionId', 'isProgram', 'isExternal', 'maxAssignableMembers', 'enrollType', 'managerService', 'externalTrainingService', 'SweetAlert',
              function($scope, $q, WizardHandler, $timeout, $mdDialog, sessionName, courseId, sessionId, isProgram, isExternal, maxAssignableMembers, enrollType, managerService, externalTrainingService, SweetAlert) {
                var vm = this;
                vm.isExternal = isExternal;

                /*
                 *  Start: Default assignableForm setting
                 * */
                vm.assignableForm = null;
                vm.assignable = {
                  learnerType: 0,
                  executeDate: new Date(),
                  dueDateType: 0,
                  dueDays: null,
                  dueDate: null,
                  message: ''
                };

                if(isExternal){
                  externalTrainingService.getCurrencys().then(function (currencys) {
                    vm.currencys = currencys;
                    angular.forEach(currencys, function (currency) {
                      if(currency.isBasic){
                        vm.defaultCostCurrency = currency.currencyId;
                      }
                    });

                    externalTrainingService.getExtCourseFormByCourseSession(courseId, sessionId).then(function (data) {
                      vm.assignable['isForFree'] = data.isForFree;
                      vm.assignable['course_cost_currency'] = data.enrollCost.course_cost_currency;
                      vm.assignable['course_cost_amount'] = data.enrollCost.course_cost_amount;
                      vm.assignable['course_converting_amount'] = data.enrollCost.course_converting_amount;
                      vm.assignable['subsidyType'] = data.enrollCost.subsidyType;
                      vm.assignable['subsidyPercentage'] = data.enrollCost.subsidyPercentage;
                      vm.assignable['voucherType'] = data.enrollCost.voucherType;
                      vm.assignable['payingDate'] = data.payingDate === "" ? new Date() : new Date(data.payingDate);

                      vm.courseConvertingAmount = function () {
                        var exchangeRate = angular.isDefined($filter('filterBy')(vm.currencys, ['currencyId'], vm.assignable['course_cost_currency'])) ? $filter('filterBy')(vm.currencys, ['currencyId'], vm.assignable['course_cost_currency'])[0].exchangeRate: 1;
                        vm.assignable['course_converting_amount'] = $filter('number')(vm.assignable['course_cost_amount'] * exchangeRate, 2);
                      }
                    });
                  });

                }
                /*
                 *  End: Default assignableForm setting
                 * */


                vm.selectedPersons = [];
                vm.isDirectMembers = false;
                vm.filters = {};
                vm.filters.learningType = false;
                vm.filters.selectedPersons = [];

                /*
                 *  Start: search model-1 for select person
                 * */
                var cachedQuery, lastSearch;
                var pendingSearch, cancelSearch = angular.noop;
                vm.selectPersonModel1 = [];

                vm.querySearch = function(criteria) {
                  cachedQuery = cachedQuery || criteria;
                  return managerService.getMembersByFilters(sessionId, {
                    'keyword': cachedQuery
                  }, isProgram).then(function(members) {
                    vm.showMutiMembers = [];
                    angular.forEach(members, function(member) {
                      if (!member.isGray) vm.showMutiMembers.push(member);
                    });
                    return vm.showMutiMembers;
                  });
                };

                vm.delayedQuerySearch = function(criteria) {
                  cachedQuery = criteria;
                  if (!pendingSearch || !debounceSearch()) {
                    cancelSearch();
                    return pendingSearch = $q(function(resolve, reject) {
                      cancelSearch = reject;
                      $timeout(function() {
                        resolve(vm.querySearch());
                        refreshDebounce();
                      }, Math.random() * 500, true)
                    });
                  }
                  return pendingSearch;
                };

                function refreshDebounce() {
                  lastSearch = 0;
                  pendingSearch = null;
                  cancelSearch = angular.noop;
                }

                // Debounce if querying faster than 300ms
                function debounceSearch() {
                  var now = new Date().getMilliseconds();
                  lastSearch = lastSearch || now;
                  return ((now - lastSearch) < 300);
                }
                /*
                 *  End: search model-1 for select person
                 * */

                /*
                 *  Start: search model-2 for select person
                 * */
                vm.optionsToggle = function(member) {

                  if (!$filter('getArrayObjectByKey')(vm.selectedPersons, 'userId', member.userId)) {
                    vm.selectedPersons.push(member);
                    vm.selectPersonModel1.push(member);
                  } else {
                    // Bind selectedPersons Model
                    angular.forEach(vm.selectedPersons, function(data, idx) {
                      if (angular.equals(data.userId, member.userId)) vm.selectedPersons.splice(idx, 1);
                    });
                    // Bind selectPersonModel1 Model
                    angular.forEach(vm.selectPersonModel1, function(data, idx) {
                      if (angular.equals(data.userId, member.userId)) vm.selectPersonModel1.splice(idx, 1);
                    });
                  }
                };

                $scope.$watch(function() {
                  return vm.isDirectMembers;
                }, function(newVal) {
                  if (newVal) {
                    getDirectMembers()
                  }
                }, true);

                $scope.$watch(function() {
                  return vm.selectedPersons;
                }, function(newVal, oldVal) {
                  if (!angular.equals(newVal, oldVal)) {
                    getDirectMembers()
                  }
                }, true);

                function getDirectMembers() {
                  managerService.getDirectMembers(sessionId, {}, isProgram).then(function(members) {
                    vm.members = members;
                    vm.filters.showMembers = {};
                    angular.forEach(members, function(member) {
                      if ($filter('getArrayObjectByKey')(vm.selectedPersons, 'userId', member.userId)) vm.filters.showMembers[member.userId] = true;
                      if (!$filter('getArrayObjectByKey')(vm.selectedPersons, 'userId', member.userId)) vm.filters.showMembers[member.userId] = false;
                      if (member.isGray) vm.filters.showMembers[member.userId] = member.isGray;
                    });
                  });
                }
                /*
                 *  End: search model-2 for select person
                 * */

                /*
                 *  Start: wizard step Controller
                 * */
                vm.currentStep = 0;
                vm.formVerified = false;

                vm.wzBtn = {
                  next: true,
                  previous: false,
                  finish: false
                };

                vm.canNext = function() {
                  var isCanNext = false;
                  if (vm.selectedPersons.length > 0) isCanNext = true;
                  if (!isCanNext) SweetAlert.error("", $filter('translate')('MESSAGE.MSG_PLEASE_SELECT_AT_LEAST_ONE_STUDENT'));
                  if(maxAssignableMembers> 0 && vm.selectedPersons.length > maxAssignableMembers) {
                    isCanNext = false;
                    SweetAlert.error("", $filter('translate')('MESSAGE.MSG_ASSIGN_EXCEED_MAX', {'value1': vm.selectedPersons.length, 'value2': maxAssignableMembers}));
                  }
                  return isCanNext;
                };

                vm.formValidation = function() {
                  if (angular.isDefined(vm.assignableForm) && vm.assignableForm.$valid) return vm.assignableForm.$valid;
                  else return false;
                };

                vm.assignableMembers = function() {
                  if (angular.isDefined(vm.assignableForm) && vm.assignableForm.$valid) {
                    var arr_memberIds = [];
                    angular.forEach(vm.selectedPersons, function(member) {
                      arr_memberIds.push(member.userId);
                    });

                    var params = {
                      memberIds: arr_memberIds.toString(),
                      message: vm.assignable.message,
                      learnerType: vm.assignable.learnerType,
                      executeDate: vm.assignable.executeDate,
                      dueType: vm.assignable.dueDateType
                    };
                    if (vm.assignable.dueDateType === '1') params.dueDays = vm.assignable.dueDays;
                    if (vm.assignable.dueDateType === '2') params.dueDate = moment(vm.assignable.dueDate).format("YYYY/MM/DD");

                    if(isExternal){
                      params['isForFree'] = (vm.assignable['isForFree'] === 1) ? true : false;
                      params['courseConvertingAmount'] = vm.assignable['course_converting_amount'].replace(/,/g , '') ;
                      params['courseCostAmount'] = vm.assignable['course_cost_amount'];
                      params['courseCostCurrency'] = vm.assignable['course_cost_currency'];
                      params['subsidyType'] = vm.assignable['subsidyType'];
                      params['subsidyPercentage'] = vm.assignable['subsidyPercentage'];
                      params['payingDate'] = moment(vm.assignable['payingDate']).format("YYYY/MM/DD") ;
                      params['voucherType'] = vm.assignable['voucherType'];

                      managerService.AssignableExternalCourse(sessionId, params).then(assignableProcess);
                    }else {
                      managerService.AssignablePrecheck(isProgram, sessionId, {memberIds: arr_memberIds.toString(), enrollType: enrollType}).then(function (res) {
                        switch (res.statusCode){
                          case 'OK':
                            managerService.Assignable(isProgram, sessionId, params).then(assignableProcess);
                            break;
                          case 'OUT_OF_QUOTA':
                            SweetAlert.error("", $filter('translate')('MESSAGE.MSG_ASSIGN_EXCEED_MAX', {'value1': res.totalNum, 'value2': res.maxEnrollment}));
                            break;
                        }
                      });
                    }
                  } else {
                    vm.assignableForm.$setSubmitted();
                    SweetAlert.error('', $filter('translate')('MESSAGE.MSG_THERE_ARE_OPTIONS_NOT_FILLED_OUT'));
                  }

                  function assignableProcess(res) {
                    if (res.resultState === 0) {
                      if (res.errorList.length > 0) {
                        //#add by w3c, #78080, start
                        SweetAlert.warning('', res.errorList);
                        //#add by w3c, #78080, end
                      } else {
                        //#add by w3c, #78080, start
                        SweetAlert.success('', $filter('translate')('MESSAGE.MSG_SUCCESSFUL_OPERATION'));
                        //#add by w3c, #78080, end
                      }
                    } else if (res.resultState === 1) {
                      if (res.preItems.length > 0) {
                        var prerequisites = [];
                        angular.forEach(res.preItems, function(preItem) {
                          var userName = preItem.userName;
                          angular.forEach(preItem.records, function(record) {
                            prerequisites.push(userName + '/' + record.objectName)
                          });
                        });

                        SweetAlert.warning($filter('translate')('MESSAGE.MSG_ERROR_NEED_FINISH_PREREQUISITE_ITEMS'), $filter('arrayToString')(prerequisites, '<br>'));
                      } else {
                        SweetAlert.success('', $filter('translate')('MESSAGE.MSG_TAKES_TIME_ACTION'));
                      }
                    }
                    //#add by w3c, #78080, start
                    else if(res.errorList.length > 0){
                      SweetAlert.warning('', $filter('translate')(res.errorList));
                    } else {
                      SweetAlert.success('', $filter('translate')('MESSAGE.MESSAGE.MSG_SUCCESSFUL_OPERATION'));
                    }
                    //#add by w3c, #78080, end
                    $mdDialog.hide();
                  }
                };

                vm.nextStep = function() {
                  WizardHandler.wizard('assignable').next();
                  vm.updateCurrentStep('next')
                };

                vm.previousStep = function() {
                  WizardHandler.wizard('assignable').previous();
                  vm.updateCurrentStep('previous');
                };

                vm.finishStep = function() {
                  WizardHandler.wizard('assignable').finish();
                };

                vm.updateCurrentStep = function(type) {
                  if (vm.canNext()) {
                    switch (type) {
                      case 'next':
                        vm.currentStep = WizardHandler.wizard('assignable').currentStepNumber() + 1;
                        break;
                      case 'previous':
                        vm.currentStep = WizardHandler.wizard('assignable').currentStepNumber() - 1;
                        break;
                    }
                  }
                };

                $scope.$watch(function() {
                  return vm.currentStep;
                }, function(newVal, oldVal) {
                  if (!angular.equals(newVal, oldVal) && angular.isDefined(newVal)) {
                    switch (newVal) {
                      case 1:
                        vm.wzBtn = {
                          next: true,
                          previous: false,
                          finish: false
                        };
                        break;
                      case 2:
                        vm.wzBtn = {
                          next: false,
                          previous: true,
                          finish: true
                        };
                        break;
                    }
                  }
                }, true);
                /*
                 *  END: wizard step Controller
                 * */


                $scope.sessionName = sessionName;
                $scope.close = function() {
                  $mdDialog.cancel();
                };

              }
            ],
            multiple: true,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/course-resource/views/course-session-info-template/assignable-members.html',
            parent: angular.element($document[0].body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              isProgram: scope.isProgram,
              sessionId: scope.sessionId,
              courseId: scope.courseId,
              isExternal: scope.isExternal,
              sessionName: scope.sessionName,
              maxAssignableMembers: scope.maxAssignableMembers,
              enrollType: angular.isDefined(scope.enrollType) ? scope.enrollType : 'learner'
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function() {
            if (angular.isFunction(scope.reloadFn)) scope.reloadFn();
          }, function() {});
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.courseResource')
    .directive('assignableMembers', assignableMembers);

})();

/**
 * Created by Alan on 2016/11/14.
 */
(function() {
    'use strict';

    InstructorDetailController.$inject = ['$mdDialog', 'instructorService', 'instructorId'];
    function InstructorDetailController($mdDialog, instructorService, instructorId) {
        var vm = this;

        instructorService.getInstructorDetail(instructorId).then(function (instructorDetail) {
            vm.instructorDetail = instructorDetail;
        });

        vm.close = function() {
            $mdDialog.cancel();
        };

    }

    angular
        .module('eHRD.modules.courseResource')
        .controller('InstructorDetailController', InstructorDetailController);

})();

/**
 * Created by Bruce on 2016/6/22.
 */
(function () {
  'use strict';

  CourseResourceController.$inject = ['$state', '$stateParams', 'courseResourceService', '$filter'];
  function CourseResourceController($state, $stateParams, courseResourceService, $filter) {
    var vm = this;
    var params = {};
    vm.getData = function(params) {
      vm.reloadParams=params;
      vm.categoryTreeId = ( angular.isUndefined($stateParams.id) ? 0 :$stateParams.id);
      courseResourceService.getCourseResource(vm.categoryTreeId, params).then(function (data) {
        vm.courseResourceDatas = data;
        vm.menulist = vm.courseResourceDatas.metadata.menulist;
        vm.pagination = vm.courseResourceDatas.metadata.pagination;
        vm.courseResourceBreadcrumb = $filter('stringToBreadcrumb')(vm.menulist, 'breadcrumb');
        $state.current._ncyBreadcrumbLabel = vm.courseResourceBreadcrumb;

        vm.courseResourceTitle = $filter('stringToBreadcrumb')(vm.menulist, 'text');

        angular.element("html, body").animate({
          scrollTop: 0
        }, 10);
      });
    };

    vm.getData(params);

  }

  angular
    .module('eHRD.modules.courseResource')
    .controller('CourseResourceController', CourseResourceController)
    ;

})();

/**
 * Created by Bruce on 2016/6/22.
 */
(function () {
  'use strict';

  CourseResourceMenuController.$inject = ['courseResourceService'];
  function CourseResourceMenuController(courseResourceService) {
    var vm = this;

    courseResourceService.getCourseResourceMenuNodes().then(function (data) {
      vm.menu = data;
    });

  }

  angular
    .module('eHRD.modules.courseResource')
    .controller('CourseResourceMenuController', CourseResourceMenuController)
    ;

})();

/**
 * Created by Bruce on 2016/10/13.
 */

(function () {
  'use strict';

  CourseReferenceController.$inject = ['courseResourceService'];
  function CourseReferenceController( courseResourceService ) {
    var vm = this;
    courseResourceService.getCourseReference(courseResourceService.getCourseId(), {}).then(function (referenceDatas) {
      vm.referenceDatas = referenceDatas;
    });

  }

  angular.module('eHRD.modules.courseResource')
    .controller('CourseReferenceController', CourseReferenceController);

})();

/**
 * Created by Alan on 2017/4/19.
 */
(function () {
  'use strict';

  var SessionObject = {
    COURSE:  1,
    PROGRAM: 2
  };
  angular.module('eHRD.modules.courseResource')
    .constant('SessionObject',SessionObject);
})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var questionType = {

  };
  angular.module('eHRD.modules.courseResource')
    .constant('questionType',questionType);
})();

/**
 * Created by Bruce on 2016/12/08.
 */
(function () {
  'use strict';

  var incompleteTemplates = {

    online: 'app/modules/course-resource/views/single-info-template/incomplete-course-type-online.html',
    classroom: 'app/modules/course-resource/views/single-info-template/incomplete-course-type-classroom.html',
    external: 'app/modules/course-resource/views/single-info-template/incomplete-course-type-external.html',
    online_test: 'app/modules/course-resource/views/single-info-template/incomplete-course-type-online-test.html',
    classroom_test: 'app/modules/course-resource/views/single-info-template/incomplete-course-type-classroom-test.html',
    survey: 'app/modules/course-resource/views/single-info-template/incomplete-course-type-survey.html',
    evaluation_survey: 'app/modules/course-resource/views/single-info-template/incomplete-evaluation-survey.html',
    program: 'app/modules/course-resource/views/single-info-template/incomplete-program-type-program.html',
    innercert: 'app/modules/course-resource/views/single-info-template/incomplete-program-type-innercert.html'

  };
  angular.module('eHRD.modules.courseResource')
    .constant('incompleteTemplates',incompleteTemplates);
})();

/**
 * Created by Bruce on 2016/11/18.
 */
(function () {
  'use strict';

  var CourseObject = {
    COURSETYPE_ONLINE: 1,
    COURSETYPE_CLASSROOM: 2,
    COURSETYPE_EXTERNAL: 3,
    COURSETYPE_ONLINE_TEST: 4,
    COURSETYPE_CLASSROOM_TEST: 5,
    COURSETYPE_SURVEY: 6,
    PROGRAMTYPE_PROGRAM: 0,
    PROGRAMTYPE_INNERCERT: 1,
    EVALUATION_SURVEY: 9
  };
  angular.module('eHRD.modules.courseResource')
    .constant('CourseObject',CourseObject);
})();

/**
 * Created by Alan on 2017/4/13.
 */
(function () {
  'use strict';

  var testQuestionnaire = {
    bindings: {
      sessionId: '=?',
      itemId: '=?',
      userId: '=?',
      questionnaireType: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/test-questionnaire/test-questionnaire-component.html',
    controller: ['testQuestionnaireService', '$window', 'sitemapService', 'AuthStorage', function (testQuestionnaireService, $window,sitemapService ,AuthStorage) {
      var vm = this;
      vm.sessionId         = angular.isUndefinedOrNull(this.sessionId)?null:this.sessionId;
      vm.itemId            = angular.isUndefinedOrNull(this.itemId)?null:this.itemId;
      vm.questionnaireType = angular.isUndefinedOrNull(this.questionnaireType)?'testQuestionnaire':this.questionnaireType;
      vm.examHistoryId = '';
      vm.canExam = false;
      vm.canViewResult = false;
      vm.loadView = false;
      vm.buttonDisabled = false;


      //enter start or status
      testQuestionnaireService.getExamInfo(vm.sessionId, {itemid: vm.itemId}).then(function (examInfo) {
        vm.exam = examInfo;
        if(examInfo.isOverMaxViewTimes > 0 || examInfo.isNotAccessPeriod > 0 || examInfo.isNotValidReTest > 0 || examInfo.canPlay === 0 || examInfo.isNotFitAttedDance === 1){
          vm.pageView = 'status';
        } else{
          vm.pageView = 'start';
        }
      });

      vm.startExam = function () {
        vm.loadView = true;
        vm.buttonDisabled = true;
        testQuestionnaireService.getExamToken(vm.sessionId, {itemid:vm.itemId}).then(function (data) {
          vm.examHistoryId = data.examhistoryId;
          // #add by w3c, #78228, start
          testQuestionnaireService.getExamInfo(vm.sessionId, {itemid: vm.itemId}).then(function (examInfo) {
            vm.exam = examInfo;
          });
          // #add by w3c, #78228, end
          getQuestions();
        });
      };

      var getQuestions = function() {
         vm.params = {
           itemid: vm.itemId,
           examhistoryId: vm.examHistoryId
         };
        testQuestionnaireService.getQuestions(vm.sessionId, vm.params).then(function (questionnaireData) {
          vm.questionnaireData = questionnaireData;
          vm.questionsPagination = questionnaireData.metadata.pagination;
          vm.questionModel = testQuestionnaireService.getQuestionModel(questionnaireData);
          vm.pageView = 'form';
        });
        vm.loadView = false;
      };



      vm.testAgain = function () {
        testQuestionnaireService.getExamInfo(vm.sessionId, {itemid: vm.itemId}).then(function (examInfo) {
          vm.exam = examInfo;
          switch(examInfo.feedbackStyle){
            case 3: case 4 :
              vm.pageView = (examInfo.isOverMaxViewTimes > 0)?'status':'start';
              break;
            default:
              if(examInfo.isOverMaxViewTimes > 0 || examInfo.isNotAccessPeriod > 0 || examInfo.isNotValidReTest > 0 || examInfo.isNotFitAttedDance === 1){
                vm.pageView = 'status';
              } else{
                vm.pageView = 'start';
              }
              break;
          }
        });
      };
	  
	  vm.buttonDisabledFn = function() { 
		vm.buttonDisabled = false; 
     }; 

      var testQuestionnaireRefersh = angular.isUndefined(AuthStorage.get("testQuestionnaireRefersh")) ? false : AuthStorage.get("testQuestionnaireRefersh");
      if (testQuestionnaireRefersh) {
        vm.startExam();
      }



      $window.onbeforeunload = $window.onunload;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('testQuestionnaire', testQuestionnaire);
})();

/**
 * Created by Alan on 2017/4/13.
 */
(function () {
  'use strict';

  var testQuestionnaireStatus = {
    bindings: {
      exam: '=',
      examResult: '='
    },
    templateUrl: 'app/modules/course-resource/views/test-questionnaire/test-questionnaire-status-component.html',
    controller: [function () {
      var vm = this;
      vm.exam = this.exam;
      vm.examResult = this.examResult;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('testQuestionnaireStatus', testQuestionnaireStatus);
})();

/**
 * Created by Alan on 2017/4/13.
 */
(function () {
  'use strict';

  var testQuestionnaireStart = {
    bindings: {
      exam: '=',
      startFn: '&',
      questionnaireType: '@?',
      buttonDisabled: '='
    },
    templateUrl: 'app/modules/course-resource/views/test-questionnaire/test-questionnaire-start-component.html',
    controller: [function () {
      var vm = this;
      vm.exam = this.exam;
      vm.startFn = this.startFn;
      vm.questionnaireType   = angular.isUndefinedOrNull(this.questionnaireType)?'testQuestionnaire':this.questionnaireType;
      vm.buttonDisabled   = angular.isUndefinedOrNull(this.buttonDisabled) ? false :this.buttonDisabled;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('testQuestionnaireStart', testQuestionnaireStart);
})();

/**
 * Created by Alan on 2017/4/13.
 */
(function () {
  'use strict';

  var testQuestionnaireResult = {
    bindings: {
      sessionId: '=',
      exam: '=',
      examResult: '=',
      params: '=',  // itemid(=), examhistoryId(=), userId(?)
      testAgain: '&?'
    },
    templateUrl: 'app/modules/course-resource/views/test-questionnaire/test-questionnaire-result-component.html',
    controller: ['testQuestionnaireService', 'managerService', '$scope', '$location', '$anchorScroll', '$filter',
      function (testQuestionnaireService, managerService, $scope,$location, $anchorScroll, $filter) {
        var vm = this;
        vm.sessionId = this.sessionId;
        vm.exam = this.exam;
        vm.params = this.params;
        vm.isFunction = 0;
        //test again function
        if(angular.isFunction(this.testAgain)) {
          vm.isFunction = 1;
        }
        vm.showInCorrect = -1;
        vm.examResultPieChartLabels = [
          $filter('translate')('FIELD.GRADE_QUESTIONS'),
          $filter('translate')('FIELD.WRONG_QUESTIONS'),
          $filter('translate')('FIELD.NOT_YET_RATED')
        ];
        vm.examResultPieChartOptions = {
          responsive: false,
          maintainAspectRatio: true,
          cutoutPercentage: 0
        };
        $scope.$on('$viewContentLoaded',function () {
          $location.hash('result');
          $anchorScroll();
        });

        $scope.$watch(function() {
          return vm.examResult;
        }, function() {
          if(angular.isDefined(vm.examResult)) {
            vm.examResultPieChartData = [vm.examResult.scored, vm.examResult.wrong, vm.examResult.waitGradeQue];
            vm.getExamQuestionsReview(vm.params, -1);
          }
        });

        vm.getExamQuestionsReview = function(params, showInCorrect) {
          vm.showInCorrect = showInCorrect;
          params['show-incorrect'] = showInCorrect;
          var getExamQuestionsReview = (angular.isUndefinedOrNull(params.userId))
            ?testQuestionnaireService.getExamQuestionsReview(vm.sessionId, params)
            :managerService.getExamQuestionsReview(vm.sessionId, params);

          getExamQuestionsReview.then(function (examReviewQuestionsDatas) {
            vm.examReviewQuestionsDatas = (showInCorrect===-1)?[]:examReviewQuestionsDatas;
            vm.questionModel = testQuestionnaireService.getQuestionModel(examReviewQuestionsDatas);
          });
        };
      }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('testQuestionnaireResult', testQuestionnaireResult);
})();

/**
 * Created by Alan on 2017/4/13.
 */
(function () {
  'use strict';

  var testQuestionnaireForm = {
    bindings: {
      exam: '=',
      relationId: '=?', //evaluationSurvey
      surveyId: '=?',   //evaluationSurvey
      sessionId: '=?',
      itemId: '=?',
      examHistoryId: '=?',
      questionModel: '=',
      questionnaireData: '=',
      questionsPagination: '=',
      questionCurrentPage: '=?',
      questionnaireType: '@?',
      pageView: '=?',
      isPageFooter: '=?',
      examResult: '=?',
      buttonDisabledFn: '&?'
    },
    templateUrl: 'app/modules/course-resource/views/test-questionnaire/test-questionnaire-form-component.html',
    controller: ['$scope', 'testQuestionnaireService', '$interval', '$location', '$anchorScroll', 'SweetAlert', '$window', 'AuthStorage',
      function ($scope, testQuestionnaireService, $interval, $location, $anchorScroll, SweetAlert, $window, AuthStorage) {
      var vm = this;
      vm.exam = this.exam;
      vm.questionModel = this.questionModel;
      vm.questions = this.questionnaireData;
      vm.questionsPagination = this.questionsPagination;
      vm.relationId          = angular.isUndefinedOrNull(this.relationId)?null:this.relationId;//evaluationSurvey
      vm.surveyId            = angular.isUndefinedOrNull(this.surveyId)?null:this.surveyId;//evaluationSurvey
      vm.sessionId           = angular.isUndefinedOrNull(this.sessionId)?null:this.sessionId;
      vm.itemId              = angular.isUndefinedOrNull(this.itemId)?null:this.itemId;
      vm.examHistoryId       = angular.isUndefinedOrNull(this.examHistoryId)?null:this.examHistoryId;
      vm.questionnaireType   = angular.isUndefinedOrNull(this.questionnaireType)?'testQuestionnaire':this.questionnaireType;
      vm.isPageFooter        = angular.isUndefinedOrNull(this.isPageFooter)?true:this.isPageFooter;
      vm.examResult          = angular.isUndefinedOrNull(this.examResult)?true:this.examResult;
      vm.pageView            = this.pageView;
      vm.questionCurrentPage = 1;
	  vm.buttonSubmmitDisabled = false;
      vm.buttonDisabledFn    = angular.isUndefined(this.buttonDisabledFn) ? null : this.buttonDisabledFn;
      //#edit by w3c, #90596 start
      vm.intervalsTickSecond = 1;
      vm.accExamSessionTime = 0;
      vm.waitTimeToSaveMaxTime = 5;
      vm.waitTimeToSaveMinTime = 3;
      resetTimeToSave();
      //#edit by w3c, #90596 end

      if(angular.isFunction(vm.buttonDisabledFn)) {
        vm.buttonDisabledFn();
      }
      //timer
      if (vm.exam.testSessionDuration === 0)
        vm.exam.sessionTime = 0;
      vm.timer = vm.exam.limitMins * 60 - vm.exam.testSessionDuration;


      vm.questionPanelSelected = false;
      vm.selectQuestionPanel = function () {
        vm.questionPanelSelected = (!vm.questionPanelSelected);
      };

      // refersh test questionnaire
      var testQuestionnaireRefersh = angular.isUndefined(AuthStorage.get("testQuestionnaireRefersh")) ? false : AuthStorage.get("testQuestionnaireRefersh");
      if (testQuestionnaireRefersh) {
        jumpQuestionFinishedExam(vm.questions.length);
      }
      function jumpQuestionFinishedExam (index) {
        vm.questionCurrentPage = Math.ceil(index/vm.questionsPagination.perPage);
        if(angular.isDefined(index)){
          $location.hash('question-'+ index);
          $anchorScroll();
          AuthStorage.remove("testQuestionnaireRefersh");
          testQuestionnaireService.finishedExam(vm.questionModel, vm.exam.feedbackStyle).then(function(){
            if(vm.questionnaireType==='testQuestionnaire')
              save(getAnswers(), vm.exam.feedbackType, true);
            else
              evaluationSurvey();
          });
        }
      }

      vm.paginationChanged =  function (params, type, index) {
        switch (type){
          case 'index':
            vm.questionCurrentPage = Math.ceil(index/vm.questionsPagination.perPage);
            if(angular.isDefined(index)){
              $location.hash('question-'+ index);
              $anchorScroll();
            }
            break;
          case 'pagination':
            if(vm.questionnaireType==='testQuestionnaire')
              save(getAnswers(), vm.exam.feedbackType, false);
            break;
        }
      };

      vm.questionsChanged = function (questionId) {
        if(vm.questionnaireType==='testQuestionnaire')
          save(getAnswers(questionId), vm.exam.feedbackType, false);
        testQuestionnaireService.updateQuestionStatus(vm.questionModel, questionId);
      };

      var getAnswers = function (questionId) {
        questionId = angular.isUndefinedOrNull(questionId)?null:questionId;
        return testQuestionnaireService.getAnswers(vm.questionModel, vm.questions, questionId);
      };

      vm.finishedExam = function () {
		 vm.buttonSubmmitDisabled = true;
        testQuestionnaireService.finishedExam(vm.questionModel, vm.exam.feedbackStyle).then(function(){
          if(vm.questionnaireType==='testQuestionnaire')
            save(getAnswers(), vm.exam.feedbackType, true);
          else
            evaluationSurvey();
        }, function(err) {
			 vm.buttonSubmmitDisabled = err;
		});
      };

      vm.timerFinished = function () {
        SweetAlert.timeoutAlert(function() {
          if(vm.questionnaireType==='testQuestionnaire')
            save(getAnswers(), vm.exam.feedbackType, true);
        });
      };
        //#edit by w3c, #90596 start
        function resetTimeToSave() {
          vm.timeToSave = generateNumber();
          vm.timeToSaveCount = vm.timeToSave;
        }

        function generateNumber() {
          return Math.floor(Math.random() * (vm.waitTimeToSaveMaxTime - vm.waitTimeToSaveMinTime + 1) + vm.waitTimeToSaveMinTime);
        }

        vm.checkIdelTimeBeforeChageEventTimer = function () {
          if (vm.timer > 0) {
            vm.timeToSave -= vm.intervalsTickSecond;
            vm.accExamSessionTime += vm.intervalsTickSecond;
            if(vm.timeToSave <= 0) {
              vm.timeToSaveCount += Math.abs(vm.timeToSave);
              var assessment = testQuestionnaireService.getAssessment(vm.sessionId);
              assessment.get().then(function () {
                testQuestionnaireService.putTestAnswerTime(assessment,
                  {sessionTime: vm.accExamSessionTime, pageTime: vm.timeToSaveCount},
                  {itemid: vm.itemId, examhistoryId: vm.examHistoryId});
              });
              resetTimeToSave();
            }
          }
        };

        $interval(vm.checkIdelTimeBeforeChageEventTimer, vm.intervalsTickSecond * 1000);
        //#edit by w3c, #90596 end
      vm.openImage = function(imgUrl) {
        $window.open(imgUrl, 'QImag', 'width=' + $window.innerWidth*2/3 + ',height=' + $window.innerHeight*2/3 + ',location=no, scrollbars=yes, resizable=yes');
      };

      var save = function (answers, feedbackType, isFinished) {
        var assessment = testQuestionnaireService.getAssessment(vm.sessionId);
        assessment.get().then(function () {
          testQuestionnaireService.putTestAnswerTime(  assessment,
            //#edit by w3c, #90596 start
            {sessionTime: vm.accExamSessionTime, pageTime: 0},
            //#edit by w3c, #90596 end
            {itemid: vm.itemId, examhistoryId: vm.examHistoryId});

          testQuestionnaireService.putTestAnswer(assessment, {answers: answers}, {itemid: vm.itemId, examhistoryId: vm.examHistoryId}).then(function (response) {
            if(response.status === 1 && isFinished){
              testQuestionnaireService.putTestFinish(assessment, {itemid: vm.itemId, examhistoryId: vm.examHistoryId}).then(function (response) {

                if(response.status === 1) {
                  testQuestionnaireService.getExamInfo(vm.sessionId, {itemid: vm.itemId}).then(function (examInfo) {
                    vm.exam = examInfo;
                    if(vm.exam.feedbackType === 2){
                      testQuestionnaireService.getExamResult(vm.sessionId, {itemid: vm.itemId, examhistoryId: vm.examHistoryId}).then(function (examResult) {
                        vm.pageView = ( (examResult.isFeedbackAllowViewResult > 0) ? 'result' : 'status' );
                        vm.examResult = examResult;
                      });
                    }else{
                      vm.pageView = 'status';
                    }
                  });

                }
              });
            }
          });
        });
      };

      function evaluationSurvey() {
        var params = {
          relationId: vm.relationId,
          surveyId: vm.surveyId
        };
        var formData = [];
        var count = 0;
        angular.forEach(vm.questionModel, function(questionValue) {
          formData.push({
            questionId: questionValue.qId,
            questionType: questionValue.questionType,
            options: []
          });
          if(questionValue.questionType===3) {
            formData[count].options.push({
              optionId: vm.questions[count].questionOptions[0].optionId,
              optionType: vm.questions[count].questionOptions[0].optionType,
              text: questionValue.optionNumber
            });
          }
          else if(questionValue.questionType===5) {
            formData[count].options.push({
              optionId: vm.questions[count].questionOptions[questionValue.optionNumber-1].optionId,
              optionType: vm.questions[count].questionOptions[questionValue.optionNumber-1].optionType,
              text: ''
            });
          }
          else {
            angular.forEach(questionValue.optionNumber, function(optionValue) {
              formData[count].options.push({
                optionId: vm.questions[count].questionOptions[parseInt(optionValue-1)].optionId,
                optionType: vm.questions[count].questionOptions[parseInt(optionValue-1)].optionType,
                text: questionValue.optionOtherValue
              });
              if(vm.questions[count].questionOptions[parseInt(optionValue-1)].optionType===2){
                formData[count].options.text = questionValue.optionOtherValue;
              }
            });
          }

          count++;
        });

        testQuestionnaireService.putEvaluationSurveyAnswer(formData, params).then(function () {
          vm.pageView = 'status';

        });
      }

      //#edit by w3c, #90596 start
      var onExit = function (/*event*/) {
      };

      $window.onbeforeunload = onExit;
      //#edit by w3c, #90596 end

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('testQuestionnaireForm', testQuestionnaireForm);
})();

/**
 * Created by Bruce on 2017/1/17.
 */
(function () {
  'use strict';

  var showStatus = {
    bindings: {
      status: '=?status',
      statusType: '@?statusType'
    },
    template: '{{ "STATUS."+$ctrl.status | translate}}',
    controller:['$scope', '$filter', function ($scope, $filter) {
        var vm = this;
        vm.status = angular.isDefined(this.status) ? this.status : undefined;
        vm.statusType = angular.isDefined(this.statusType) ? this.statusType : undefined;

        if(angular.isDefined(vm.statusType)){
          switch (vm.statusType){
            case 'enroll':
              if (vm.status == 0) {
                vm.status = 'SELFENROLLED';
              }else if(vm.status == 1) {
                vm.status = 'ASSIGNED';
              }
              break;
            case 'externalTrainingRecordsApprove':
                switch (vm.status){
                  case 0:
                    vm.status = $filter('uppercase')('NO_APPROVAL');
                    break;
                  case 1:
                    vm.status = $filter('uppercase')('APPROVALED');
                    break;
                  case 2:
                    vm.status = $filter('uppercase')('NOT_YET_APPROVAL');
                    break;
                  case 3:
                    vm.status = $filter('uppercase')('REJECTED');
                    break;
                  case 4:
                    vm.status = $filter('uppercase')('CANCEL');
                    break;
                }
              break;
          }
        }

        // $scope.$watch(function () {
        //   return vm.status;
        // },function (newVal) {
        //   if(angular.isDefined(newVal)){
        //
        //   }
        // },true);

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('showStatus', showStatus);
})();

/**
 * Created by Alan on 2017/12/13.
 */
(function () {
  'use strict';

  var reportResult = {
    bindings: {
      isManager:    '=?',
      enrollmentId: '=',
      isCourse:     '=?'
    },
    templateUrl: 'app/modules/course-resource/views/report-result.html',
    controller: ['managerService', 'fileProcessService', function(managerService, fileProcessService){
      var vm = this;
      vm.isManager = angular.isUndefinedOrNull(this.isManager) ? false : this.isManager;
      vm.enrollmentId = this.enrollmentId;
      vm.isCourse = angular.isUndefinedOrNull(this.isCourse) ? true : this.isCourse;

      var reportProcessService = (vm.isManager)
        ? managerService.getReportProcess(vm.enrollmentId, {isCourse: vm.isCourse})
        : fileProcessService.getReportProcess(vm.enrollmentId, {isCourse: vm.isCourse});
      reportProcessService.then(function (report) {
        vm.report = report;
      });
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('reportResult', reportResult);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var programSessionInfo = {
    bindings: {
      catalogId: '=?',
      programId: '=?',
      backState: '=?',
      enrollmentId: '=?',
      nodeId: '=?',
      isUser: '=?',  //mail link use
      tabSelect: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/program-session-info.html',
    controller: ['$timeout', '$state', '$filter', '$stateParams', 'courseResourceService', function($timeout, $state, $filter, $stateParams, courseResourceService, SessionObject ){
      var vm = this;
      vm.SessionObject = SessionObject;
      var catalogId           = angular.isDefined(this.catalogId) ? this.catalogId: null;
      var programId            = angular.isDefined(this.programId) ? this.programId: null;
      var nodeId              = angular.isDefined(this.nodeId) ? this.nodeId: null;
      var backState           = angular.isDefined(this.backState) ? this.backState: null;
      vm.enrollmentId = angular.isDefined(this.enrollmentId) ? this.enrollmentId: null;
      vm.isUser       = angular.isDefined(this.isUser) ? this.isUser: true;
      vm.tabSelect            = angular.isDefined(this.tabSelect) ? this.tabSelect: 'courseList';

      if(!angular.isUndefinedOrNull(catalogId) && !angular.isUndefinedOrNull(programId)){
        if(angular.isDefined(backState)){
          vm.goBack={
            title: $filter('translate')('FIELD.COURSE_INFO'),
            state: backState,
            stateParams:{
              cid: catalogId, programId: programId, nid: nodeId
            }
          };
        }
      }

      $timeout(function() {
        courseResourceService.getProgramEnrollment(vm.enrollmentId, params).then(function (enrollmentData) {
          vm.programTypeTitle = (enrollmentData.programType===0)?$filter('translate')('PROGRAM_INFO'):$filter('translate')('CERTIFICATE_INFO');
          $state.current._ncyBreadcrumbLabel = vm.programTypeTitle;
        });
      }, 0)
      var params = {};
      vm.getProgramData = function () {
        courseResourceService.getProgramEnrollment(vm.enrollmentId, params).then(function (enrollmentData) {

          vm.enrollmentData = enrollmentData;
          courseResourceService.getProgram(enrollmentData.programId, params).then(function (programData) {
            vm.programData = programData;
          });
          courseResourceService.getProgramSessionLearnersCompletionRate(enrollmentData.sessionId,{}).then(function (courseSessionLearnersCompletionRateData) {
            vm.completionRateData = courseSessionLearnersCompletionRateData;
          });

          courseResourceService.getLearningResult(enrollmentData.enrollmentId, true).then(function (learningResult) {
            vm.learningResult = learningResult;
          });

          courseResourceService.getProgramSession(enrollmentData.sessionId, params).then(function (sessionData) {
            vm.sessionData = sessionData;
          });
        });
      };
      vm.getProgramData();
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programSessionInfo', programSessionInfo);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var programInfo = {
    bindings: {
      catalogId: '=?catalogId',
      programId: '=?programId',
      nodeId: '=?nodeId'
    },
    templateUrl: 'app/modules/course-resource/views/program-info.html',
    controller: ['$state', '$filter', '$stateParams', 'courseResourceService', 'sitemapService', function( $state, $filter, $stateParams, courseResourceService, sitemapService ){
      var vm = this;
      var programId = angular.isDefined(this.programId) ? this.programId : undefined;
      var params = {};
      vm.nodeId = angular.isDefined($stateParams.nid) ? $stateParams.nid : undefined;

      vm.getProgramData = function () {
        courseResourceService.getProgram(programId, params).then(function (programData) {
          vm.programData = programData
          vm.programData.includeCourses.isShowCredit = programData.isShowCredit;
          vm.catalogId = angular.isDefined($stateParams.catalogId) ? $stateParams.catalogId : angular.isDefined($stateParams.cid) ? $stateParams.cid : undefined;
          if(angular.isDefined(vm.catalogId)){
            courseResourceService.getCourseResourceCatalogMenu(vm.catalogId).then(function (menuList) {
              var breadcrumbLabel = vm.programData.programName;

              sitemapService.getSiteMapNodes().walk(function (node) {
                if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
                  if(menuList.length > 0 && parseInt(menuList[0].id) === parseInt(node.model.stateParams['cid'])  && !vm.nodeId){
                    menuList[0].title = node.model.title;
                  }
                } else {
                  if(angular.isUndefinedOrNull(vm.mainMenu) && node.model.state === 'courseResourceCatalog') {
                    if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === vm.catalogId){
                      if(menuList.length > 0 && menuList[0].id === node.model.stateParams['cid']  && !vm.nodeId){
                        menuList[0].title = node.model.title;
                      }
                    }
                  }
                }
              });

              vm.courseResourceBreadcrumb = $filter('stringToBreadcrumb')(menuList, 'sitemap-breadcrumb', breadcrumbLabel);
              $state.current._ncyBreadcrumbLabel = vm.courseResourceBreadcrumb;

            });

            if(angular.isDefined($stateParams.backState)){
              if($stateParams.backState == 'fullTextSearchList'){
                vm.goBack={
                  title: $filter('translate')('FIELD.FULL_TEXT_SEARCH_NAME'),
                  state:$stateParams.backState,
                  stateParams:{tabSelect: 'Course', params: $stateParams.params}
                };
              }else{
                var tabSelect = !!$stateParams.params ? $stateParams.params.tabSelect : '';
                vm.goBack={
                  title: $filter('translate')('FIELD.COURSE_FOLDER'),
                  state:$stateParams.backState,
                  stateParams:{cid: vm.catalogId, nid: vm.nodeId, tabSelect: tabSelect, params: $stateParams.params}
                };
              }
            }
          }
        });

      };


      if(angular.isDefined(programId)){
        vm.getProgramData();
      }
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programInfo', programInfo);
})();

/**
 * Created by Bruce on 2016/10/24.
 */
(function () {
  'use strict';

  var programDetailLessonsResults = {
    bindings: {
      enrollmentData: '=',
      data: '=',
      reloadFn: '&?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/program-detail-lessons-results.html',
    controller: ['$filter','ngTableColumnValueService','$interpolate', '$scope', 'NgTableParams', function($filter, ngTableColumnValueService, $interpolate, $scope, NgTableParams){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? null : this.data;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.isShowCredit = false;
      var watchData = $scope.$watch(function () {
        return vm.data;
      },function (newVal) {
        vm.tableCols = prepareTableCols();
        vm.lessonsResultsTable = new NgTableParams({
        }, {
          counts: [],
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = ((value === 'desc') ? 0 : 1);
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            })
            return vm.data;
          }
        });
        if(!angular.isUndefinedOrNull(newVal)){
          vm.total_credits = 0;
          angular.forEach(vm.data, function (data) {
            vm.total_credits += data.credits;
          });
          watchData();
        }
      });

      var watchEnrollmentData = $scope.$watch(function () {
        return vm.enrollmentData;
      },function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)){
          vm.enrollmentData = newVal;
          watchEnrollmentData();
        }
      });

      function prepareTableCols() {
        var cols = [{
          field: 'index',
          title: $filter('translate')('FIELD.ORDER'),
          getValue: ngTableColumnValueService.htmlTextValue,
          interpolateExpr: $interpolate('<span class="text">{{row.index}}</span>'),
          priority: 1
        }, {
          field: 'courseType',
          title: $filter('translate')('FIELD.TYPE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlCourseType()),
          priority: 1
        },{
          field: 'courseName',
          title: $filter('translate')('FIELD.COURSE_TITLE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlCourseTitle()),
          priority: 1
        }, {
          field: 'credits',
          title: $filter('translate')('FIELD.CREDITS'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate('<span class="=text">{{row.credits}}</span>'),
          priority: 1,
          show: isShowCredit()
        }, {
          field: 'status',
          title: $filter('translate')('FIELD.STATUS'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlStatus()),
          priority: 1
        }, {
          field: 'resultModifiedDate',
          title: $filter('translate')('FIELD.PASSED_DATE'),
          getValue: ngTableColumnValueService.htmlTextValue,
          interpolateExpr: $interpolate('<span class="=text">{{row.resultModifiedDate}}</span>'),
          priority: 1
        }, {
          field: 'score',
          title: $filter('translate')('FIELD.SCORE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate('<span class="=text">{{row.score}}</span>'),
          priority: 1
        }];
        return cols;
      }

      function  htmlCourseTitle() {
        var html = '<div class="text">';
        html += '<ng-switch on="row.learnerType">';
        html += '<span class="pick" ng-switch-when="0">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span>';
        html += '<span class="surely" ng-switch-when="1">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span>';
        html += '</ng-switch>';
        html += '<a ng-if="row.courseType===1 || row.courseType===2" href="javascript:void(0)" tip-info tip-type="1" params="{cid: row.courseId}" >{{row.courseName}}</a>';
        html += '<a ng-if="row.courseType===3" href="javascript:void(0)" tip-info tip-type="13" params="{cid: row.courseId}" >{{row.courseName}}</a>';
        html += '<a ng-if="row.courseType===4 || row.courseType===5" href="javascript:void(0)" tip-info tip-type="16" params="{id: row.courseId}" >{{row.courseName}}</a>';
        html += '<a ng-if="row.courseType===6" href="javascript:void(0)" tip-info tip-type="17" params="{id: row.courseId}" >{{row.courseName}}</a>';
        html += '</div>';
        return html;
      }

      function htmlStatus() {
        var html = '<div class="text">';
        html += '<div class="progress th-line" ng-if="row.status!==\'Unenroll\'">';
        html += '<div class="progress-bar" ng-style="{\'width\': row.progress + \'%\'}">';
        html += '<div class="progress-value">';
        html += '<a href="javascript:void(0);" learning-history enrollment-id="row.enrollmentId" session-id="row.sessionId">{{ \'STATUS.\' + row.status | uppercase | translate}}&nbsp;{{ row.progressStatus}}</a>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        return html;
      }

      function htmlCourseType() {
        var html = '<div style="float: left;"><course-type-tag  course-type="row.courseType" is-show-text="false" is-show-class="true"></course-type-tag></div>';
        return html;
      }

      function isShowCredit() {
        if (angular.isDefined(vm.data)) {
          vm.isShowCredit = vm.data[0].isShowCredit === 1 ? true : false;
        }
        return vm.isShowCredit;
      }


    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programDetailLessonsResults', programDetailLessonsResults);
})();

/**
 * Created by Bruce on 2016/10/24.
 */
(function () {
  'use strict';

  var programDetailLessonsList = {
    bindings: {
      data: '=',
      reloadFn: '&?',
      enrollmentId: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/program-detail-lessons-list.html',
    controller: [function(){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? null : this.data;
      vm.enrollmentId = angular.isUndefined(this.enrollmentId) ? null : this.enrollmentId;


    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programDetailLessonsList', programDetailLessonsList);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var programDetailInfo = {
    bindings: {
      data: '='
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/program-detail-info.html',
    controller: [function( ){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? null : this.data;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programDetailInfo', programDetailInfo);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var programDetailEnrollment = {
    bindings: {
      data: '=',
      sessionData: '=',
      enrollmentData: '=',
      reloadFn:'&?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/program-detail-enrollment.html',
    controller: [function(){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? null : this.data;
      vm.sessionData = angular.isUndefined(this.sessionData) ? null : this.sessionData;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.reloadFn = angular.isUndefined(this.reloadFn) ? null : this.reloadFn;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programDetailEnrollment', programDetailEnrollment);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var programDetailEnrollmentLearningReport = {
    bindings: {
      enrollmentData: '=',
      sessionData: '='
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/program-detail-enrollment-learning-report.html',
    controller: ['$scope', '$filter', 'SweetAlert', 'fileProcessService', 'CourseObject', function( $scope, $filter, SweetAlert, fileProcessService, CourseObject ){
      var vm = this;
      vm.CourseObject = CourseObject;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.sessionData    = angular.isUndefined(this.sessionData) ? null : this.sessionData;
      var formData = [
        {'isCourse': 2},
        {'packageId':vm.enrollmentData.enrollmentId},
        {'enrollmentId': vm.enrollmentData.enrollmentId}
      ];
      var uploader = $scope.uploader = fileProcessService.learningReportUpload(vm.enrollmentData.enrollmentId, formData);

      uploader.onErrorItem = function(/*fileItem, response, status, headers*/) {

      };
      uploader.onCompleteAll = function () {
        vm.learningReportUploadAction('confirm-temp', 2);
      };

      vm.getLearningReportList = function () {
        fileProcessService.getLearningReportList(vm.enrollmentData.enrollmentId, {iscourse: 2}).then(function (LearningReportDatas) {
          vm.learningReportData = LearningReportDatas;
          vm.learningReportData.paid = 0;
          vm.learningReportFileReplace = {};
          angular.forEach(LearningReportDatas, function (data) {
            if(data.appState === 1){
              vm.learningReportData.paid += 1;

              var formData = [
                {'isCourse': 2},
                {'packageId':vm.enrollmentData.enrollmentId},
                {'enrollmentId': vm.enrollmentData.enrollmentId},
                {'reportId': data.learningReportId},
                {'op': 'replace'}
              ];
              vm.learningReportFileReplace[data.learningReportId] = fileProcessService.learningReportUpload(vm.enrollmentData.enrollmentId, formData, true);

              vm.learningReportFileReplace[data.learningReportId].onCompleteAll = function () {
                vm.getLearningReportList();
              };
            }
          });
        });
      };

      vm.getLearningReportList();

      vm.learningReportUploadAction = function (actionType, isCourse, reportId) {
        var fileParams = {};
        fileParams.iscourse = (angular.isDefined(isCourse) ? isCourse : 2);
        fileParams.reportid = (angular.isDefined(reportId) ? reportId : 0);

        switch(actionType){
          case 'cancelrow':

            var text = $filter('translate')('MESSAGE.MSG_THIS_ACTION_WILL_RELEVANT_STUDY_REPORT') + '，'
              + $filter('translate')('MESSAGE.MSG_IS_CONTINUE');

            SweetAlert.check('', text, 'warning', function() {
              _learningReportUploadAction();
            });

            break;
          default:
            _learningReportUploadAction();
            break;

        }
        function _learningReportUploadAction(){
          fileProcessService.learningReportUploadAction(vm.enrollmentData.enrollmentId, actionType, fileParams).then(function () {
            vm.getLearningReportList();
          });
        }
      };

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programDetailEnrollmentLearningReport', programDetailEnrollmentLearningReport);
})();

/**
 * Created by Bruce on 2016/11/21.
 */
(function () {
  'use strict';

  var programDetailContainLessons = {
    bindings: {
      data: '=',
      sessionType: '='
    },
    templateUrl:'app/modules/course-resource/views/course-session-info-template/program-detail-contain-lessons.html',
    controller: ['ngTableColumnValueService','$interpolate','$scope', 'NgTableParams', '$filter', function(ngTableColumnValueService,$interpolate, $scope, NgTableParams, $filter) {
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? null : this.data
      vm.isShowCredit = false;
      $scope.$watch(function () {
        return vm.data;
      }, function (newVal) {
        if(!angular.isUndefinedOrNull(newVal)){
          vm.tableCols = prepareTableCols();
          vm.filterData = $filter('filter')(newVal, {sessionType: vm.sessionType}, true);
          vm.containLessonsTable = new NgTableParams({}, {
            counts: [],
            getData: function(tableParams) {
              var params = {};
              angular.forEach(tableParams.sorting(), function (value, key) {
                params.sort = key;
                params.order = ((value === 'desc') ? 0 : 1);
              });

              angular.forEach(tableParams.filter(), function (value, key) {
                params[key] = value;
              });

              return vm.filterData;
            }
          });
        }
      })

      function prepareTableCols() {
        var cols = [{
          field: 'index',
          title: $filter('translate')('FIELD.ORDER'),
          getValue: ngTableColumnValueService.htmlTextValue,
          interpolateExpr: $interpolate('<span class="text">{{row.index}}</span>'),
          priority: 1
        }, {
          field: 'courseType',
          title: $filter('translate')('FIELD.TYPE'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate('<course-type-tag course-type="row.courseType" is-show-text="false"></course-type-tag>'),
          priority: 1
        },{
          field: 'courseName',
          title: $filter('translate')('FIELD.COURSE_NAME'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlCourseName()),
          priority: 1
        }, {
          field: 'credits',
          title: $filter('translate')('FIELD.CREDITS'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate('<span class="=text">{{row.credits}}</span>'),
          priority: 1,
          show: isShowCredit()
        }, {
          field: 'learnerType',
          title: $filter('translate')('FIELD.PROPERTIES'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlLearnerType()),
          priority: 1
        }];
        return cols;
      }

      function htmlCourseName() {
        var html = '<div class="text">';
        html += '<a ng-if="row.courseType===1 || row.courseType===2" href="javascript:void(0)" tip-info tip-type="1" params="{cid: row.courseId}" >{{row.courseName}}</a>';
        html += '<a ng-if="row.courseType===3" href="javascript:void(0)" tip-info tip-type="13" params="{cid: row.courseId}" >{{row.courseName}}</a>';
        html += '<a ng-if="row.courseType===4 || row.courseType===5" href="javascript:void(0)" tip-info tip-type="16" params="{id: row.courseId}" >{{row.courseName}}</a>';
        html += '<a ng-if="row.courseType===6" href="javascript:void(0)" tip-info tip-type="17" params="{id: row.courseId}" >{{row.courseName}}</a>';
        return html;
      }

      function htmlLearnerType() {
        var html = '<div class="text">';
        html += '<ng-switch on="row.learnerType" class="switchTag">';
        html += '<span ng-switch-when="0">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span>';
        html += '<span ng-switch-when="1">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span>';
        html += '</ng-switch>';
        html += '</div>';
        return html;
      }

      function isShowCredit() {
        var isShowCredit = false;
        if (angular.isDefined(vm.data)) {
          isShowCredit = vm.data.isShowCredit === 1 ? true : false;
        }
        return isShowCredit
      }

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('programDetailContainLessons', programDetailContainLessons);
})();

/**
 * Created by Alan on 2017/9/4.
 */
(function () {
  'use strict';

  var passRule = {
    bindings: {
      enrollmentData: '='
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/pass-rule.html',
    controller: [function(){
      var vm = this;
      vm.passRuleSwitch = 0;
      vm.enrollmentData = this.enrollmentData;
      vm.passRule = function() {
        vm.passRuleSwitch = (vm.passRuleSwitch===0)?1:0;
      }
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('passRule', passRule);
})();

/**
 * Created by Bruce on 2016/12/08.
 */
(function () {
  'use strict';

  var incompleteInfoListCard = {
    template: '<div incomplete-dynamic-template name="$ctrl.templateType"></div>',
    bindings: {
      courseData: '=?',
      reloadFn: '&?'
    },
    controller: incompleteInfoListCardCtrl
  };

  incompleteInfoListCardCtrl.$inject = ['CourseObject', '$scope', '$filter', 'SweetAlert'];
  function incompleteInfoListCardCtrl(CourseObject, $scope, $filter, SweetAlert) {
    var vm = this;
    vm.courseData = this.courseData;


    $scope.$watch(function () {
      return vm.courseData;
    },function () {
      vm.isCanView = (
        vm.courseData.status === 'incompleted_status' ||
        vm.courseData.status === 'status_not_available' ||
        vm.courseData.status === 'sco_non_attempt' ||
        (vm.courseData.programType === CourseObject.PROGRAMTYPE_INNERCERT && vm.courseData.status === 'completed_status') ||
        (vm.courseData.programType === CourseObject.PROGRAMTYPE_PROGRAM && vm.courseData.status === 'completed_status'))

      switch (vm.courseData.courseType){
        case CourseObject.COURSETYPE_ONLINE:
          vm.templateType = 'online';
          break;
        case CourseObject.COURSETYPE_CLASSROOM:
          vm.templateType = 'classroom';
          break;
        case CourseObject.COURSETYPE_EXTERNAL:
          vm.templateType = 'external';
          break;
        case CourseObject.COURSETYPE_ONLINE_TEST:
          vm.templateType = 'online_test';
          break;
        case CourseObject.COURSETYPE_CLASSROOM_TEST:
          vm.templateType = 'classroom_test';
          break;
        case CourseObject.COURSETYPE_SURVEY:
          vm.templateType = 'survey';
          break;
        case CourseObject.EVALUATION_SURVEY:
          vm.templateType = 'evaluation_survey';
          break;
        default:
          if(vm.courseData.programType === CourseObject.PROGRAMTYPE_PROGRAM) vm.templateType = 'program';
          if(vm.courseData.programType === CourseObject.PROGRAMTYPE_INNERCERT) vm.templateType = 'innercert';
          break;
      }
    });

    vm.showStatus = function (status) {
      switch (vm.courseData.courseType){
        default:
          SweetAlert.error($filter('translate')( 'MESSAGE.MSG_CAN_NOT_TAKE_LESSONS'), $filter('translate')( 'STATUS.' + status.toUpperCase()));
          break;
        case 4: case 5: case 6:
        SweetAlert.error($filter('translate')( 'MESSAGE.MSG_CAN_NOT_TAKE_TEST_QUESTIONNAIRE'), $filter('translate')( 'STATUS.' + status.toUpperCase()));
        break;
      }

    };

    vm.doughnutOptions = {
      responsive: false,
      responsiveAnimationDuration: 500,
      maintainAspectRatio: true,
      cutoutPercentage: 75,
      legend: {
        display: false
      }
    };
  }

  angular.module('eHRD.modules.courseResource')
    .component('incompleteInfoListCard', incompleteInfoListCard);

})();

/**
 * Created by Bruce on 2017/1/17.
 */
(function () {
  'use strict';

  var externalTrainingRecords = {
    bindings: {
      defaultParams: '=?defaultParams'
    },
    templateUrl: 'app/modules/course-resource/views/external/external-training-records.html',
    controller: ['PermPermissionStore', '$scope', '$mdDialog', '$window','$document', 'serverSetting', 'NgTableParams', 'externalTrainingService',
      function (PermPermissionStore, $scope, $mdDialog, $window, $document, serverSetting, NgTableParams, externalTrainingService) {
      var vm = this;
        vm.defaultParams = angular.isDefined(this.defaultParams) ? this.defaultParams : null;
        var permission = null;
        permission = PermPermissionStore.getPermissionDefinition('Manage_Learning_affairs_daily_operations');
        vm.isLearningAdmin = angular.isDefined(permission);

        var defaultFilter = {};
        if(angular.isDefined(vm.defaultParams)){
          if(angular.isDefined(vm.defaultParams.scopeType)) defaultFilter['scopeType'] = vm.defaultParams.scopeType;
          if(angular.isDefined(vm.defaultParams.extId)) defaultFilter['extId'] = vm.defaultParams.extId;
          if(angular.isDefined(vm.defaultParams.trainingName)) defaultFilter['trainingName'] = vm.defaultParams.trainingName;
          if(angular.isDefined(vm.defaultParams.instructorName)) defaultFilter['instructorName'] = vm.defaultParams.instructorName;
          if(angular.isDefined(vm.defaultParams.startDate)) defaultFilter['startDate'] = vm.defaultParams.startDate;
          if(angular.isDefined(vm.defaultParams.endDate)) defaultFilter['endDate'] = vm.defaultParams.endDate;
        }

        if(angular.isDefined(vm.defaultParams)){
          var defaultSorting = {};
          if(angular.isDefined(vm.defaultParams.sort) && angular.isDefined(vm.defaultParams.order)){
            defaultSorting[vm.defaultParams.sort] = (vm.defaultParams.order === 0 ) ? "desc" : "asc";
          }
        }
        vm.externalTrainingRecordsTable = new NgTableParams({
          count: angular.isDefined(vm.defaultParams) ? vm.defaultParams.list_size: 10,
          page: angular.isDefined(vm.defaultParams) ? vm.defaultParams.current_page: 1,
          sorting: defaultSorting || { 0: "desc" },
          filter: defaultFilter
        },{
          counts: [1,5,10,15],
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = ((value === 'desc') ? 0 : 1);
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;
            vm.backStateParams = params;
            return externalTrainingService.getExternalTrainingRecords(params).then(function (externalTrainingRecords) {
              tableParams.total(externalTrainingRecords.metadata.pagination.total);
              return externalTrainingRecords;
            });
          }
        });

      vm.setFilter = function (filters, isClear) {
          if(isClear){
            filters = {};
          }
          vm.externalTrainingRecordsTable.filter(filters);
          vm.externalTrainingRecordsTable.reload();
      };

      vm.showPrompt = function(ev) {
        $mdDialog.show({
          templateUrl: 'app/modules/course-resource/views/external/external-training-records-search-dialog.html',
          controller: [ '$mdDialog', 'filters', 'PermPermissionStore', function ($mdDialog, filters, PermPermissionStore) {
            var vm = this;
            vm.filters = {
              scopeType: angular.isDefined(PermPermissionStore.getPermissionDefinition('Manage_All_External_Event')) ? 'all' : angular.isDefined(filters.scopeType) ? filters.scopeType : 'department',
              extId: angular.isDefined(filters.extId) ? filters.extId : '',
              trainingName: angular.isDefined(filters.trainingName) ? filters.trainingName : '',
              instructorName: angular.isDefined(filters.instructorName) ? filters.instructorName : '',
              startDate: angular.isDefined(filters.startDate) ? filters.startDate : undefined,
              endDate: angular.isDefined(filters.endDate) ? filters.endDate : undefined
            };

            vm.cancel = function() {
              $mdDialog.hide({});
            };
            vm.close = function() {
              $mdDialog.cancel();
            };
            vm.submit = function(filters) {
              $mdDialog.hide(filters);
            };

            vm.updateEndDateModel = function () {
              var beginningTime = moment(vm.filters.startDate);
              var endTime = moment(vm.filters.endDate);
              if(!beginningTime.isBefore(endTime)){
                vm.filters.endDate = vm.filters.startDate;
              }
            };
          }],
          controllerAs:'$ctrl',
          parent: angular.element($document[0].body),
          targetEvent: ev,
          clickOutsideToClose:true,
          locals : {
            filters : vm.externalTrainingRecordsTable.filter()
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        }).then(function(filters) {
            vm.setFilter(filters, false);
          }, function() { }
        );
      };


      // vm.openEditDialog = function (externalId) {
      //   $scope.externalId = externalId;
      //   $mdDialog.show({
      //     template: '<md-dialog flex="90"><md-content><external-training-apply type="edit" external-id="externalId"></external-training-apply></md-content></md-dialog>',
      //     scope: $scope,
      //     preserveScope: true,
      //     clickOutsideToClose: true
      //   });
      // };

      vm.showApproveStatus = function (workflowId) {
        var url = serverSetting.baseConfig.baseURL + '/apv_status.do?isFromInbox=1&id='+ workflowId;
        $window.open(url, 'player', 'width=' + $window.innerWidth + ',height=' + $window.innerHeight + ',location=no, scrollbars=yes');
      };

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('externalTrainingRecords', externalTrainingRecords);
})();

/**
 * Created by Bruce on 2017/1/25.
 */
(function () {
  'use strict';

  var externalTrainingBulletin = {
    bindings: {
      defaultParams: '=?defaultParams'
    },
    templateUrl: 'app/modules/course-resource/views/external/external-training-bulletin.html',
    controller: ['$scope', 'externalTrainingBulletinService', 'courseResourceService', 'ngDialog',
      function ($scope, externalTrainingBulletinService, courseResourceService, ngDialog) {
        var vm = this;
        var params = {};
        vm.defaultParams = angular.isDefined(this.defaultParams) ? this.defaultParams : null;
        if(angular.isDefined(vm.defaultParams)){
          params = vm.defaultParams;
        }

        vm.getData = function (params) {
          vm.backStateParams = params;
          externalTrainingBulletinService.list(params).then(function(data){
            vm.bulletinApplyKnowHow = data.metadata.bulletinApplyKnowHow;
            vm.ExternalTrainingBulletinDatas = data;
            vm.pagination = vm.ExternalTrainingBulletinDatas.metadata.pagination;

            angular.element("html, body").animate({
              scrollTop: 0
            },200);
          });
        };

        vm.getData(params);


        vm.openDetailed = function () {
          ngDialog.open({
            template: 'app/modules/course-resource/views/external/external-training-bulletin-detailed.html',
            className: 'ngdialog-theme-default',
            scope: $scope
          });
        };

        courseResourceService.getClassifications(11).then(function (classifications) {
          vm.classifications = classifications;
        });

      }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('externalTrainingBulletin', externalTrainingBulletin);
})();

/**
 * Created by Bruce on 2017/2/3.
 */
(function () {
  'use strict';

  var externalTrainingBulletinDetailed = {
    bindings: {
      bulletinId: '=?',
      courseId: '=?',
      sessionId: '=?',
      data: '=?data'
    },
    templateUrl: 'app/modules/course-resource/views/external/external-training-bulletin-detailed.html',
    controller: ['$scope', 'externalTrainingService', function( $scope, externalTrainingService ){
      var vm = this;
      vm.bulletinId = angular.isDefined(this.bulletinId) ? this.bulletinId : undefined;
      vm.courseId = angular.isDefined(this.courseId) ? this.bulletinId : undefined;
      vm.sessionId = angular.isDefined(this.sessionId) ? this.bulletinId : undefined;
      vm.data = angular.isDefined(this.data) ? this.data : undefined;

      $scope.$watch(function () {
        return vm.data;
      }, function (newVal) {
        if(angular.isDefined(newVal)){
          externalTrainingService.getCurrencys().then(function (currencys) {
            vm.currencys = currencys;
            angular.forEach(currencys, function (currency) {
              if(currency.isBasic){
                vm.defaultCostCurrency = currency.currencyId;
                vm.basicCurrencyName = currency.currencyName;
              }
            });
          });
          vm.h_organizationIds = vm.data.organizationId.split(',').filter(function (value) {
            return value.length > 0
          }).map(function(item) {
            return parseInt(item, 10);
          });
        }
      }, true);
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('externalTrainingBulletinDetailed', externalTrainingBulletinDetailed);
})();

/**
 * Created by Bruce on 2016/12/20.
 */
(function () {
  'use strict';

  var externalTrainingApply = {
    bindings: {
      formType: '@?type',
      externalId: '=?externalId',
      bulletinId: '=?bulletinId',
      courseId: '=?courseId',
      sessionId: '=?sessionId',
      backStateObject: '=?backStateObject'
    },
    templateUrl: 'app/modules/course-resource/views/external/external-training-apply.html',
    controller: [ 'fileProcess', 'toastr', 'CoreService', '$cacheFactory', '$filter', '$q', '$auth', '$scope', 'Upload', '$queueFactory', 'externalTrainingService', 'SweetAlert', '$state',
      function( fileProcess, toastr, CoreService, $cacheFactory, $filter, $q, $auth, $scope, Upload, $queueFactory, externalTrainingService, SweetAlert, $state){
      var vm = this;
      vm.$state = $state;
      var cache = externalTrainingService.getCache();
      var oldRefs = [];

      vm.formType = angular.isDefined(this.formType) ? this.formType : undefined;
      vm.externalId = angular.isDefined(this.externalId) ? this.externalId : undefined;
      vm.bulletinId = angular.isDefined(this.bulletinId) ? this.bulletinId : undefined;
      vm.courseId = angular.isDefined(this.courseId) ? this.courseId : undefined;
      vm.sessionId = angular.isDefined(this.sessionId) ? this.sessionId : undefined;


      var queue = $queueFactory(1);
      queue.enqueue(function(){
        return externalTrainingService.getCleanExtCourseForm().then(function (defaultFormSetting) {
          vm.defaultFormSetting = defaultFormSetting;
          vm.applyForm = {};
          vm.learningReportObject = {
            isManager: vm.defaultFormSetting.isManager, // 是否為主管.
            isLearningAdmin: vm.defaultFormSetting.isLearningAdmin, // 是否為管理員.
            isCanEditSetting: vm.defaultFormSetting.isCanEditSetting, // 是否能編輯(學習報告設定).
            isHasDefaultSetting: vm.defaultFormSetting.isHasDefaultSetting, // 表單是否開啟預設設定 False: 由學員自行決定是否繳交報告, True: 帶入設定規則.
            isShowReportLowerBound: vm.defaultFormSetting.isShowReportLowerBound, // 低於Ｎ無需繳交報告.
            submitRptRate: vm.defaultFormSetting.submitRptRate, // 低於Ｎ值.
            isNeedReport: vm.defaultFormSetting.classInfo.isNeedReport, // 是否需要繳交報告.
            defaultSetting: {
              numOfDocReport: vm.defaultFormSetting.classInfo.numOfDocReport,
              isNeedDocReport: vm.defaultFormSetting.classInfo.isNeedDocReport,
              docReportMonth: vm.defaultFormSetting.classInfo.docReportMonth,
              docReportDay: vm.defaultFormSetting.classInfo.docReportDay,
              isNeedOralReport: vm.defaultFormSetting.classInfo.isNeedOralReport,
              isOralReportNeedGrade: vm.defaultFormSetting.classInfo.isOralReportNeedGrade,
              oralReportMonth: vm.defaultFormSetting.classInfo.oralReportMonth,
              oralReportDay: vm.defaultFormSetting.classInfo.oralReportDay,
              isNeedTeaching: vm.defaultFormSetting.classInfo.isNeedTeaching,
              teachingMonth: vm.defaultFormSetting.classInfo.teachingMonth,
              teachingDay: vm.defaultFormSetting.classInfo.teachingDay,
              isTeachingNeedGrade: vm.defaultFormSetting.classInfo.isTeachingNeedGrade,
              isNeedOther: vm.defaultFormSetting.classInfo.isNeedOther,
              otherReportWay: vm.defaultFormSetting.classInfo.otherReportWay
            }
          };

          switch (vm.formType){
            case 'create':
              vm.isCanEditForm = true;
              vm.isCreateForm = true;
              createFormInit();
              break;
            case 'createByCourseSession': case 'createByBulletin':
              vm.isCanEditForm = true;
              vm.isCreateForm = true;
              getFormInit();
              break;
            case 'edit': case 'reSubmit':
              vm.isCanEditForm = true;
              getFormInit();
              break;
            case 'view':
              vm.isCanEditForm = false;
              getFormInit();
              break;
          }
        });
      });


      function getFormInit() {
        if(angular.isDefined(vm.courseId) && angular.isDefined(vm.sessionId)){
          externalTrainingService.getExtCourseFormByCourseSession(vm.courseId, vm.sessionId).then(formProcess);
        } else if(angular.isDefined(vm.externalId)){
          externalTrainingService.getExtCourseForm(vm.externalId).then(formProcess);
        } else if(angular.isDefined(vm.bulletinId)){
          externalTrainingService.getExtCourseFormByBulletin(vm.bulletinId).then(formProcess);
        }
      }

      function formProcess(extCourseForm) {
        vm.extCourseForm = extCourseForm;
        vm.defaultDisableField = (parseInt(extCourseForm.joinCourseId) > 0 || parseInt(extCourseForm.joinCourseSessionId) > 0 || parseInt(extCourseForm.fromBulletinId) > 0);
        vm.fromBulletinDisableField = (parseInt(extCourseForm.fromBulletinId) > 0);
        vm.fromCourseSessionDisableField = (parseInt(extCourseForm.joinCourseId) > 0 || parseInt(extCourseForm.joinCourseSessionId) > 0);
        vm.createFromDisplay = (vm.formType === 'edit') && vm.defaultFormSetting.isLearningAdmin && (!extCourseForm.hasEnrollCreated);

        if(vm.defaultDisableField || (!vm.isCanEditForm))
          vm.defaultDisableFieldAndIsCanEditFormStatus = true;
        else
          vm.defaultDisableFieldAndIsCanEditFormStatus = false;

        if(vm.createFromDisplay && extCourseForm.auto_create === 0){
          vm.selectExternalClass = {};
          vm.selectExternalClass['courseId'] = extCourseForm.joinCourseId;
          vm.selectExternalClass['sessionId'] = extCourseForm.joinCourseSessionId;
        }

        vm.applicants = extCourseForm.applicantsInfo;
        vm.applicantsStrArray = [];
        vm.enrollCosts = {};
        if(vm.applicants.length === 0){
          var applicant = {
            userId: $auth.getUserData().id,
            fullName: $auth.getUserData().username
          };
          vm.applicants.push(applicant);
        }

        angular.forEach(vm.applicants, function (applicant) {
          vm.applicantsStrArray.push(applicant.userId);
          vm.enrollCosts[applicant.userId] = {
            fullName: applicant.fullName,
            costObject: extCourseForm.enrollCost
          };
        });
        vm.classTimeObjects = [];
        angular.forEach(extCourseForm.timeRule, function (timeRule) {
          var classTimeObjects = timeRule;
          classTimeObjects['startDate'] = new Date(timeRule.startDate);
          classTimeObjects['endDate'] = new Date(timeRule.endDate);
          vm.classTimeObjects.push(classTimeObjects);
        });

        //vm.h_organizationIds

        var vendorPromises= extCourseForm.organizationId.split(',').filter(function (value) {
          return value.length > 0
        }).map(function(vendorId) {
          //return parseInt(item, 10);
          return externalTrainingService.getVendor(vendorId).then(function(vendor) {
            return {
              vendorId: parseInt(vendor.vendorId, 10),
              vendorName: vendor.vendorName
            }
          })
        });

        Promise.all(vendorPromises).then(function(vendorList) {
          vm.h_organizationIds = vendorList;
        });
        vm.applyReason =  extCourseForm.applyReason.split(',').filter(function (value) {
          return value.length > 0
        }).map(function(item) {
          return parseInt(item, 10);
        });

        vm.learningReportObject['isFormOwner'] = $filter('filter')(extCourseForm.applicantsInfo, { userId: $auth.getUserData().id }, true).length > 0; // ??否??自己表?? true: ?? false: 他人表單
        vm.learningReportObject['isManagerCanEditSetting'] = extCourseForm.isManagerCanEditSetting; // 主管??否??編輯表??
        if(!vm.isCreateForm){
          vm.learningReportObject['data'] = {
            isNeedReport: extCourseForm.learningReport.isNeedReport,
            isNeedDocReport: extCourseForm.learningReport.isNeedDocReport,
            numOfDocReport: extCourseForm.learningReport.numOfDocReport,
            docReportDeadLine: new Date(extCourseForm.learningReport.docReportDeadLine),
            isNeedOralReport: extCourseForm.learningReport.isNeedOralReport,
            oralReportDeadLine: new Date(extCourseForm.learningReport.oralReportDeadLine) ,
            isOralReportNeedGrade: extCourseForm.learningReport.isOralReportNeedGrade,
            isNeedTeaching: extCourseForm.learningReport.isNeedTeaching,
            teachingDeadLine: new Date(extCourseForm.learningReport.teachingDeadLine) ,
            isTeachingNeedGrade: extCourseForm.learningReport.isTeachingNeedGrade,
            isNeedOther: extCourseForm.learningReport.isNeedOther,
            otherReportWay: extCourseForm.learningReport.otherReportWay
          };
        }

        vm.refs = extCourseForm.refs;
        oldRefs = angular.copy(vm.extCourseForm.refs);

        vm.applyForm = {
          memberids: (extCourseForm.applicants.length === 0) ? vm.applicantsStrArray.toString(): extCourseForm.applicants,
          externalId: (extCourseForm.externalId === "" || extCourseForm.externalId === -1) ? "" : extCourseForm.externalId,
          extId: (extCourseForm.externalId === "" || extCourseForm.externalId === -1) ? 0 : extCourseForm.externalId,
          courseName: extCourseForm.courseName,
          hasEnroll: (extCourseForm.hasEnroll === -1) ? undefined : extCourseForm.hasEnroll,
          reason: extCourseForm.reason,
          applyReason: extCourseForm.applyReason,
          otherApplyReason: extCourseForm.otherApplyReason,
          type: extCourseForm.type,
          h_organizationId: extCourseForm.organizationId,
          classTime: '',
          location: extCourseForm.location,
          project_code: extCourseForm.projectCode,
          isForFree: extCourseForm.isForFree.toString(),
          payingDate: extCourseForm.payingDate === "" ? undefined : new Date(extCourseForm.payingDate),
          trainType: extCourseForm.trainType.toString(),
          refLink: extCourseForm.reflink,
          note: extCourseForm.note,
          enrollStart: extCourseForm.enrollStart === "" ? undefined :  new Date(extCourseForm.enrollStart),
          enrollEnd: extCourseForm.enrollEnd === "" ? undefined : new Date(extCourseForm.enrollEnd),
          instructor: extCourseForm.instructor,
          summary: extCourseForm.description,
          objective: extCourseForm.objective,
          prerequesite: extCourseForm.prerequesite,
          audience: extCourseForm.audience,
          outline: extCourseForm.outline,
          backurl: null,
          isEditByManager: false,
          TimeSpanRefId: extCourseForm.timeSpanRefId,
          category: extCourseForm.classification,
          auto_create: extCourseForm.auto_create,
          joinCourseId: extCourseForm.joinCourseId,
          joinCourseSessionId: extCourseForm.joinCourseSessionId,
          fromBulletinId: extCourseForm.fromBulletinId,
        };

        if(extCourseForm.hasPreviousEnrollRecord === 1){
          vm.applyForm['learningReportReason'] = extCourseForm.learningReportReason;
          vm.applyForm['oralReportReason'] = extCourseForm.oralReportReason;
          vm.applyForm['teachingReportReason'] = extCourseForm.teachingReportReason;
          vm.applyForm['otherReportReason'] = extCourseForm.otherReportReason;
          vm.applyForm['materialSubmit'] = extCourseForm.materialSubmit;
          vm.applyForm['materialReason'] = extCourseForm.materialReason;
        }

        if(angular.isDefined($cacheFactory.get('coreCache'))
          && $cacheFactory.get('coreCache').get('rememberScope')){
          reloadFormDataByCaches()
        }
      }

      function updateEnrollCosts() {
        angular.forEach(vm.enrollCosts, function (enrollCost, key) {
          if(!$filter('getArrayObjectByKey')(vm.applicants, 'userId', key)) delete vm.enrollCosts[key];
        });
        var memberids = [];
        angular.forEach(vm.applicants,  function (applicant) {
          memberids.push(applicant.userId);
          if(angular.isUndefinedOrNull(vm.enrollCosts[applicant.userId])) {
            vm.enrollCosts[applicant.userId] = {
              fullName: applicant.fullName,
              costObject: {}
            };
          }
        });
        vm.applyForm.memberids = memberids.toString();
      }

      function createFormInit() {
        vm.learningReportObject['isFormOwner'] = true;
        vm.needRequired = false;
        vm.applicants = [{
          userId: $auth.getUserData().id,
          fullName: $auth.getUserData().username
        }];
        vm.enrollCosts = {};
        angular.forEach(vm.applicants, function (applicant) {
          vm.enrollCosts[applicant.userId] = {
            fullName: applicant.fullName,
            costObject: {}
          };
        });
        vm.courseFiles = {};
        var memberids = [];
        angular.forEach(vm.applicants, function (applicant) {
          memberids.push(applicant.userId);
        });

        $scope.$watch(function () {
          return vm.applicants;
        },function (newVal) {
          if( angular.isDefined(newVal)){
            updateEnrollCosts();
          }
        },true);

        vm.applyForm = {
          memberids: memberids.toString(),
          externalId: '',
          extId: 0,
          courseName: '',
          hasEnroll: '',
          reason: '',
          applyReason: '',
          otherApplyReason: '',
          type: 0,
          h_organizationId: '',
          classTime: '',
          location: '',
          project_code: '',
          isForFree: '0',
          payingDate: undefined,
          trainType: '1',
          isNeedReport: (vm.defaultFormSetting.classInfo.isNeedReport ? '1' : '0'),
          isNeedDocReport: '',
          numOfDocReport: '',
          docReportDeadLine: undefined,
          isNeedOralReport: '',
          oralReportDeadLine: undefined,
          isOralReportNeedGrade: '',
          isNeedTeaching: '',
          teachingDeadLine: undefined,
          isTeachingNeedGrade: '',
          isNeedOther: '',
          otherReportWay: '',
          refLink: '',
          note: '',
          enrollStart: undefined,
          enrollEnd: undefined,
          instructor: '',
          summary: '',
          objective: '',
          prerequesite: '',
          audience: '',
          outline: '',
          backurl: null,
          isEditByManager: false,
          TimeSpanRefId: 0
        };

        if(angular.isDefined($cacheFactory.get('coreCache'))
          && $cacheFactory.get('coreCache').get('rememberScope')){
          reloadFormDataByCaches();
        }
      }

      queue.enqueue(function(){
        return externalTrainingService.getExtCourseApplyReasons().then(function (applyReasons) {
          vm.applyReasons = applyReasons;
        });
      });

      $scope.$watch(function () {
        return vm.applyReason;
      },function (newVal) {
        if(angular.isDefined(newVal) && angular.isArray(newVal) && angular.isDefined(vm.applyForm)){
          vm.applyForm['applyReason'] =  vm.applyReason.length > 0 ? vm.applyReason.toString() : '';
        }
      },true);

      vm.canExitStep1 = function () {
        vm.needRequired = true;
        // if(vm.formType !== 'view'){
        //   vm.wizardForm1.$setSubmitted();
        //   if(!vm.wizardForm1.$valid){
        //     SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
        //   }
        // }

        // return (vm.formType === 'view') ? true : vm.wizardForm1.$valid;

        var promise = $q(function(resolve, reject) {
          setTimeout(function() {
            if(vm.formType !== 'view'){
              vm.wizardForm1.$setSubmitted();
              if(!vm.wizardForm1.$valid){
                SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
              }
            }

            resolve((vm.formType === 'view') ? true : vm.wizardForm1.$valid);
          }, 0);

        });

        return promise;
      };

      vm.canExitStep2 = function () {
        //#edit by w3c, #87981  start
        vm.needRequired = true;
    		var needReportAlert = false;
        var promise = $q(function(resolve, reject) {
          setTimeout(function() {
        if(vm.formType !== 'view'){
          vm.wizardForm2.$setSubmitted();

          var numOfDocReport_outOfRange = false ;
          if(vm.learningReport.isNeedReport){
            if(!vm.learningReport.isNeedDocReport&&!vm.learningReport.isNeedOralReport&&!vm.learningReport.isNeedTeaching&&!vm.learningReport.isNeedOther)
              needReportAlert = true;
            if ( vm.learningReport.isNeedDocReport ) {
              if ( isNaN( vm.learningReport.numOfDocReport )
                  || vm.learningReport.numOfDocReport < 1 || 100 < vm.learningReport.numOfDocReport ) {
                needReportAlert = true;
                numOfDocReport_outOfRange = true ;
              }
            }
          }

              if (angular.isDefined(vm.enrollCosts)) {
                angular.forEach(vm.enrollCosts, function (enrollCost) {
                  if (angular.isDefined(enrollCost.costObject['apply_type'])) {
                    enrollCost.costObject.remit_title_error = {};
                    enrollCost.costObject.remit_branch_error = {};
                    enrollCost.costObject.remit_account_error = {};
                    enrollCost.costObject.check_title_error = {};
                    enrollCost.costObject.check_expired_date_error = {};
                    if (enrollCost.costObject.apply_type === "1") {
                      if (angular.isDefined(enrollCost.costObject['remit_title']) && enrollCost.costObject.remit_title.length === 0) {
                        needReportAlert = true;
                        enrollCost.costObject.remit_title_error = {required: true};
                      }
                      if (angular.isDefined(enrollCost.costObject['remit_branch']) && enrollCost.costObject.remit_branch.length === 0) {
                        needReportAlert = true;
                        enrollCost.costObject.remit_branch_error = {required: true};
                      }
                      if (angular.isDefined(enrollCost.costObject['remit_account']) && enrollCost.costObject.remit_account.length === 0) {
                        needReportAlert = true;
                        enrollCost.costObject.remit_account_error = {required: true};
                      }
                    } else if(enrollCost.costObject.apply_type === "2"){
                      if (angular.isDefined(enrollCost.costObject['check_title']) && enrollCost.costObject.check_title.length === 0) {
                        needReportAlert = true;
                        enrollCost.costObject.check_title_error = {required: true};
                      }
                      if (!angular.isDefined(enrollCost.costObject['check_expired_date']) ||
                        (angular.isDefined(enrollCost.costObject['check_expired_date']) && enrollCost.costObject.check_expired_date.length === 0)) {
                        needReportAlert = true;
                        enrollCost.costObject.check_expired_date_error = {required: true};
                      } else {
                        //console.log(moment(enrollCost.costObject.check_expired_date).format('YYYY/MM/DD'));
                      }
                    }
                  }
                });
              }

          if (!vm.wizardForm2.$valid || needReportAlert) {
            if ( numOfDocReport_outOfRange )
              SweetAlert.error('', $filter('translate')('FORM_VALIDATION.NUMBEROFREPORTS_ERROR_SETTING'));
            else
              SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
          }
        }
            var toNextPate = true;
            if(!vm.wizardForm2.$valid){
              toNextPate = false;
            } else if(needReportAlert){
              toNextPate = false;
            }
            resolve((vm.formType === 'view') ? true : toNextPate);
          }, 0);

        });

        return promise;
        //#edit by w3c, #87981  end
      };

      function parseClassTimeObjectsToFormData() {
        var classTimeObjectFormData = {};
        classTimeObjectFormData['timeSpanCount'] = vm.classTimeObjects.length;
        classTimeObjectFormData['classTime'] = (vm.classTime.length > 0 ? vm.classTime.toString() : '');

        angular.forEach(vm.classTimeObjects, function (classTimeObject, index) {
          classTimeObjectFormData['startDate' + index] = moment(classTimeObject.startDate).format('YYYY/MM/DD');
          classTimeObjectFormData['endDate' + index] = moment(classTimeObject.endDate).format('YYYY/MM/DD');
          classTimeObjectFormData['startH' + index] = classTimeObject.startH;
          classTimeObjectFormData['startM' + index] = classTimeObject.startM;
          classTimeObjectFormData['endH' + index] = classTimeObject.endH;
          classTimeObjectFormData['endM' + index] = classTimeObject.endM;
          classTimeObjectFormData['isEnableRestTime' + index] = (classTimeObject.isEnableRestTime ? 1 : 0);
          classTimeObjectFormData['rest_startH' + index] = classTimeObject.rest_startH;
          classTimeObjectFormData['rest_startM' + index] = classTimeObject.rest_startM;
          classTimeObjectFormData['rest_endH' + index] = classTimeObject.rest_endH;
          classTimeObjectFormData['rest_endM' + index] = classTimeObject.rest_endM;
          classTimeObjectFormData['isEnableRepeat' + index] = (classTimeObject.isEnableRepeat ? 1 : 0);
          classTimeObjectFormData['repeatIntervalNumber' + index] = classTimeObject.repeatIntervalNumber;
          classTimeObjectFormData['repeatIntervalUnit' + index] = classTimeObject.repeatIntervalUnit;

          classTimeObjectFormData['includeDay' + index + '_0'] = (classTimeObject.includeDays.indexOf(0) > -1 ? 1 : '');
          classTimeObjectFormData['includeDay' + index + '_1'] = (classTimeObject.includeDays.indexOf(1) > -1 ? 1 : '');
          classTimeObjectFormData['includeDay' + index + '_2'] = (classTimeObject.includeDays.indexOf(2) > -1 ? 1 : '');
          classTimeObjectFormData['includeDay' + index + '_3'] = (classTimeObject.includeDays.indexOf(3) > -1 ? 1 : '');
          classTimeObjectFormData['includeDay' + index + '_4'] = (classTimeObject.includeDays.indexOf(4) > -1 ? 1 : '');
          classTimeObjectFormData['includeDay' + index + '_5'] = (classTimeObject.includeDays.indexOf(5) > -1 ? 1 : '');
          classTimeObjectFormData['includeDay' + index + '_6'] = (classTimeObject.includeDays.indexOf(6) > -1 ? 1 : '');
        });
        return classTimeObjectFormData;
      }

      function parseEnrollCosts() {
        var enrollCostsFormData = {};
        angular.forEach(vm.enrollCosts, function (enrollCost, index) {
          enrollCostsFormData['course_cost_currency_' + index] = enrollCost.costObject.course_cost_currency;
          enrollCostsFormData['course_cost_amount_' + index] = enrollCost.costObject.course_cost_amount;
          enrollCostsFormData['course_converting_amount_' + index] = enrollCost.costObject.course_converting_amount.replace(/,/g , '');
          enrollCostsFormData['subsidyType_' + index] = enrollCost.costObject.subsidyType;
          enrollCostsFormData['subsidyPercentage_' + index] = enrollCost.costObject.subsidyPercentage;
          enrollCostsFormData['voucherType_' + index] = enrollCost.costObject.voucherType;
          enrollCostsFormData['apply_type_' + index] = enrollCost.costObject.apply_type;
          enrollCostsFormData['payee_' + index] = enrollCost.costObject.payee;
          enrollCostsFormData['remit_title_' + index] = enrollCost.costObject.remit_title;
          enrollCostsFormData['remit_branch_' + index] = enrollCost.costObject.remit_branch;
          enrollCostsFormData['remit_account_' + index] = enrollCost.costObject.remit_account;
          enrollCostsFormData['check_title_' + index] = enrollCost.costObject.check_title;
          //#edit by w3c, #87983  start
          enrollCostsFormData['check_expired_date_' + index] = getUTCDate((enrollCost.costObject.check_expired_date));
          //#edit by w3c, #87983  end
          enrollCostsFormData['check_format1_' + index] = enrollCost.costObject.check_format1;
          enrollCostsFormData['check_format2_' + index] = enrollCost.costObject.check_format2;
        });
        return enrollCostsFormData;
      }

        //#add by w3c, #87983  start
        function getUTCDate(date) {
          if(date === '' || date === null || typeof date === 'undefined'){
            return date;
          }
          if (angular.isDefined(date)) {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
          }
          return date;
        }
        //#edit by w3c, #87983  end
      function parseLearningReport() {
        var learningReportObject = {};
        learningReportObject['isNeedReport'] = vm.learningReport.isNeedReport ? 1 : 0;
        learningReportObject['isNeedDocReport'] = vm.learningReport.isNeedDocReport ? 1 : 0;
        learningReportObject['numOfDocReport'] = vm.learningReport.numOfDocReport;
        learningReportObject['docReportDeadLine'] = moment(vm.learningReport.docReportDeadLine).format('YYYY/MM/DD');
        learningReportObject['isNeedOralReport'] = vm.learningReport.isNeedOralReport ? 1 : 0;
        learningReportObject['oralReportDeadLine'] = moment(vm.learningReport.oralReportDeadLine).format('YYYY/MM/DD');
        learningReportObject['isOralReportNeedGrade'] = vm.learningReport.isOralReportNeedGrade ? 1 : 0;
        learningReportObject['isNeedTeaching'] = vm.learningReport.isNeedTeaching ? 1 : 0;
        learningReportObject['teachingDeadLine'] = moment(vm.learningReport.teachingDeadLine).format('YYYY/MM/DD');
        learningReportObject['isTeachingNeedGrade'] = vm.learningReport.isTeachingNeedGrade ? 1 : 0;
        learningReportObject['isNeedOther'] = vm.learningReport.isNeedOther ? 1 : 0;
        learningReportObject['otherReportWay'] = vm.learningReport.otherReportWay;
        return learningReportObject;
      }

      vm.submitApplyForm = function () {
        vm.applyForm['h_organizationId'] =
          (vm.h_organizationIds.length > 0
            ? vm.h_organizationIds.map(function(vendor) {
              return vendor.vendorId;
            }).toString()
            : '');
        if(vm.formType === 'edit' && vm.applyForm['auto_create'] === 0 && angular.isDefined(vm.selectExternalClass)){
          vm.applyForm['joinCourseId'] = vm.selectExternalClass.courseId;
          vm.applyForm['joinCourseSessionId'] = vm.selectExternalClass.sessionId;
        }

        vm.applyForm = angular.extend(vm.applyForm, parseClassTimeObjectsToFormData());
        vm.applyForm = angular.extend(vm.applyForm, parseEnrollCosts());
        vm.applyForm = angular.extend(vm.applyForm, parseLearningReport());

        if(vm.applyForm['payingDate']!== undefined)vm.applyForm['payingDate']= moment(new Date(vm.applyForm['payingDate'])).format('YYYY-MM-DD');
        if(vm.applyForm['enrollStart']!== undefined)vm.applyForm['enrollStart']= moment(new Date(vm.applyForm['enrollStart'])).format('YYYY-MM-DD');
        if(vm.applyForm['enrollEnd']!== undefined)vm.applyForm['enrollEnd']= moment(new Date(vm.applyForm['enrollEnd'])).format('YYYY-MM-DD');

        for(var i=0; i<3; i++) {
          var num = i+1;
          if(vm.refs[i] && oldRefs[i])
            vm.applyForm['delref' + num] = 0;
          else if(!vm.refs[i] && oldRefs[i]) vm.applyForm['delref' + num] = 1;
          else vm.applyForm['delref' + num] = 0;
        }


        saveToCaches();
        function preConfirm() {
          return new Promise(function (resolve) {
            var uploaderForm = externalTrainingService.submitApplyForm(vm.applyForm, 'ref', vm.courseFiles, vm.formType);
            uploaderForm.then(function(resp) {
              var res = resp.data;
              switch (res.data.result){
                case 'MSG_TAKES_TIME_ACTION_WITH_SOMETHING_ERROR':
                  SweetAlert.insertErrorQueueStep('',res.data.description, true);
                  // #edit by w3c, #87981  start
                  var message = '';
                  if(res.data.crsEnrollResult.isNeedApproval){
                    message = $filter('translate')('MESSAGE.MSG_' + res.data.crsEnrollResult.detail.toUpperCase());
                  }else{
                    message = $filter('translate')('MESSAGE.MSG_SUCCESSFUL_OPERATION');
                  }
                  SweetAlert.insertSuccessQueueStep('', message, false, function () {
                    if(angular.isDefined(vm.backStateObject)){
                      $state.go(vm.backStateObject.state,vm.backStateObject.params);
                    }else{
                      $state.go('externalTrainingZone.externalTrainingApplyRecords');
                    }
                  });
                  // #edit by w3c, #87981  end
                  break;
                case 'MSG_TAKES_TIME_ACTION_WITH_SOMETHING_WARN':
                  SweetAlert.insertSuccessQueueStep( '',res.data.description, true );
                case 'external_apply_success':
                case 'SUCCESS_MSG_UPDATE_USER_PREFERENCE':
                  SweetAlert.insertSuccessQueueStep('', $filter('translate')('MESSAGE.MSG_SUCCESSFUL_OPERATION'), false, function () {
                    if(angular.isDefined(vm.backStateObject)){
                      $state.go(vm.backStateObject.state,vm.backStateObject.params);
                    }else{
                      $state.go('externalTrainingZone.externalTrainingApplyRecords');
                    }
                  });
                  break;
                case 'doEnroll':
                  if(res.data.crsEnrollResult.status === 7){
                    var message = '';
                    if(res.data.crsEnrollResult.isNeedApproval){
                      message = $filter('translate')('MESSAGE.MSG_' + res.data.crsEnrollResult.detail.toUpperCase());
                    }else{
                      message = $filter('translate')('MESSAGE.MSG_SUCCESSFUL_OPERATION');
                    }

                    SweetAlert.insertSuccessQueueStep('', message, false, function () {
                      if(angular.isDefined(vm.backStateObject)){
                        $state.go(vm.backStateObject.state,vm.backStateObject.params);
                      }else{
                        $state.go('externalTrainingZone.externalTrainingApplyRecords');
                      }
                    });
                  }else if(res.data.crsEnrollResult.status === 5){
                    SweetAlert.insertErrorQueueStep('',$filter('translate')('MESSAGE.MSG_CLASS_TIME_CONFLICT',{value: res.data.crsEnrollResult.detail}) , true);
                  } else if( res.data.crsEnrollResult.status === 9 ) {
                    SweetAlert.insertSuccessQueueStep('', $filter('translate')('MESSAGE.MSG_CLASS_TIME_CONFLICT_NO_BLOCK',{value: res.data.crsEnrollResult.detail}), true, function () {
                      if(angular.isDefined(vm.backStateObject)){
                        $state.go(vm.backStateObject.state,vm.backStateObject.params);
                      }else{
                        $state.go('externalTrainingZone.externalTrainingApplyRecords');
                      }
                    });
                  } else if (res.data.crsEnrollResult.status === 2) {
                    SweetAlert.insertErrorQueueStep($filter('translate')('MESSAGE.MSG_ERROR_MESSAGE_CAN_NOT_ENROLL_CAUSE_PASS_RESULT'), res.data.crsEnrollResult.detail, true);
                  } else{
                    SweetAlert.insertErrorQueueStep('',res.data.crsEnrollResult.detail, true);
                  }
                  break;
              }
              resolve();
            }, function () {
              $cacheFactory.get('coreCache').put('rememberScope', true);
              CoreService.refreshAccesstoken();
            });
          })
        }
        if(fileProcess.checkUploadType(vm.courseFiles) && fileProcess.checkUploadSize(vm.courseFiles)) {
          SweetAlert.submitCheck('',$filter('translate')('MESSAGE.MSG_EXTERNAL_TRAINING_APPLY_SUMMIT_CHECK'), preConfirm);
        }
      };

      $scope.$watch(function () {
        return [
          vm.applyForm,
          vm.applyReason,
          vm.h_organizationIds,
          vm.classTimeObjects,
          vm.classTime,
          vm.enrollCosts,
          vm.learningReport,
          vm.learningReportObject
        ];
      }, function () {
        saveToCaches();
      }, true);
      $scope.$watchCollection(function () {
        return vm.courseFiles;
      }, function () {
        saveToCaches();
      });

      function reloadFormDataByCaches() {
        if( angular.equals(cache.get('formType'), vm.formType) &&
          angular.equals(cache.get('externalId'), vm.externalId) &&
          angular.equals(cache.get('bulletinId'), vm.bulletinId) &&
          angular.equals(cache.get('courseId'), vm.courseId) &&
          angular.equals(cache.get('sessionId'), vm.sessionId) ){

          toastr.info($filter('translate')('MESSAGE.MSG_RESTORE_LAST_TIME_UNFINISHED_FORM'));

          vm.applyForm = cache.get('applyForm');
          vm.applyReason = cache.get('applyReason');
          vm.h_organizationIds = cache.get('h_organizationIds');
          vm.classTimeObjects = cache.get('classTimeObjects');
          vm.classTime = cache.get('classTime');
          vm.enrollCosts = cache.get('enrollCosts');
          vm.learningReport = cache.get('learningReport');
          vm.learningReportObject = cache.get('learningReportObject');
          vm._courseFiles = cache.get('courseFiles');

          var isShowFileInfo = false;
          angular.forEach(vm._courseFiles, function (file) {
            if(angular.isDefined(file)){
              isShowFileInfo = true;
            }
          });
          if(isShowFileInfo) toastr.info($filter('translate')('MESSAGE.MSG_COURSE_DATA_FILE_NEED_RE_CHOOSE'));
        }
        $cacheFactory.get('coreCache').put('rememberScope', false);
      }

      function saveToCaches() {
        if(!(angular.isDefined($cacheFactory.get('coreCache'))
          && $cacheFactory.get('coreCache').get('rememberScope'))){
          externalTrainingService.setCacheData("applyForm", vm.applyForm);
          externalTrainingService.setCacheData("applyReason", vm.applyReason);
          externalTrainingService.setCacheData("h_organizationIds", vm.h_organizationIds);
          externalTrainingService.setCacheData("classTimeObjects", vm.classTimeObjects);
          externalTrainingService.setCacheData("classTime", vm.classTime);
          externalTrainingService.setCacheData("enrollCosts", vm.enrollCosts);
          externalTrainingService.setCacheData("learningReport", vm.learningReport);
          externalTrainingService.setCacheData("learningReportObject", vm.learningReportObject);
          externalTrainingService.setCacheData("courseFiles", vm.courseFiles);

          externalTrainingService.setCacheData("formType", vm.formType);
          externalTrainingService.setCacheData("externalId", vm.externalId);
          externalTrainingService.setCacheData("bulletinId", vm.bulletinId);
          externalTrainingService.setCacheData("courseId", vm.courseId);
          externalTrainingService.setCacheData("sessionId", vm.sessionId);
        }
      }
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('externalTrainingApply', externalTrainingApply);
})();

/**
 * Created by Bruce on 2017/2/21.
 */
(function () {
  'use strict';

  var externalTrainingApplyFormView = {
    bindings: {
      data: '=?data'
    },
    templateUrl: 'app/modules/course-resource/views/external/external-training-apply-form-view.html',
    controller: ['$translate', '$filter', '$scope', 'userService', 'externalTrainingService', 'courseResourceService', 'utilsService', function($translate, $filter, $scope, userService, externalTrainingService, courseResourceService, utilsService ){
        var vm = this;
        vm.data = angular.isUndefined(this.data) ? undefined : this.data;
        vm.currencys = [];vm.classifications = [];vm.organizationDatas = {};
        vm.orgSize = 0;

      switch ($translate.use()){
        case 'en-us':
          vm.languageFamilyType =  1;
          break;
        case 'zh-tw':
          vm.languageFamilType = 2;
          break;
        case 'zh-cn':
          vm.languageFamilyType = 3;
          break;
      }

        var watchData = $scope.$watch(function () {
          return vm.data;
        }, function () {
          if(angular.isDefined(vm.data) ){
            if( vm.data.applicantsInfo.length > 0) {
              userService.getUserProfileDetailById(vm.data.applicantsInfo[0].userId).then(function (applicantInfo) {
                vm.applicantInfo = applicantInfo;
              });
            }
            externalTrainingService.getExtCourseApplyReasons().then(function (applyReasons) {
              vm.applyReasons = applyReasons;
              vm.applyReason =  vm.data.applyReason.split(',').filter(function (value) {
                return value.length > 0
              }).map(function(item) {
                return parseInt(item, 10);
              });
            });
            externalTrainingService.getCurrencys().then(function (currencys) {
              vm.currencys = currencys;
              angular.forEach(currencys, function (currency) {
                if(currency.isBasic){
                  vm.defaultCostCurrency = currency.currencyId;
                }
              });
            });
            courseResourceService.getClassifications(11).then(function (classifications) {
              vm.classifications = classifications;
            });

            vm.h_organizationIds = vm.data.organizationId.split(',').filter(function (value) {
              return value.length > 0
            }).map(function(item) {
              return parseInt(item, 10);
            });
            angular.forEach(vm.h_organizationIds, function (organizationId) {
              utilsService.getTipInfo(26, {'vendorType': 2, 'vendorId': organizationId}).then(function (data) {
                vm.organizationDatas[organizationId] = $filter('where')(data, {'rcKey': 'vendor_name'})[0].data;
                vm.orgSize = Object.keys(vm.organizationDatas).length;
              });
            });
            watchData();
          }
        });

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('externalTrainingApplyFormView', externalTrainingApplyFormView);
})();

/**
 * Created by Alan on 2017/1/17.
 */
(function () {
  'use strict';

  var evaluationSurvey = {
    bindings: {
      relationId: '=?',
      surveyId: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/test-questionnaire/evaluation-survey.html',
    controller: ['testQuestionnaireService', '$window', 'sitemapService', function (testQuestionnaireService, $window) {
      var vm = this;
      vm.relationId        = angular.isUndefinedOrNull(this.relationId)?null:this.relationId;//evaluationSurvey
      vm.surveyId          = angular.isUndefinedOrNull(this.surveyId)?null:this.surveyId;  //evaluationSurvey
      vm.canExam = false;
      vm.canViewResult = false;

      vm.pageView = 'start';

      var params = {
        relationId: vm.relationId,
        surveyId: vm.surveyId
      };
      testQuestionnaireService.getQuestions(null, params).then(function (questionnaireData) {
        var evSurveyInfo = questionnaireData.metadata.evSurveyInfo;
        vm.questionnaireData = questionnaireData;
        vm.exam = {
          name: evSurveyInfo.surveyName,
          description: evSurveyInfo.description,
          targetName: evSurveyInfo.targetName,
          feedbackStyle: 3,
          feedbackType: 1,
          isOverMaxViewTimes: 1,
          isNotFitAttedDance: 0
        };
        vm.questionsPagination =  {
          currentPage: 1,
          perPage: questionnaireData.metadata.evSurveyInfo.pageSize,
          total: questionnaireData.length
        };
        vm.questionModel = testQuestionnaireService.getQuestionModel(questionnaireData);
      });

      vm.startExam = function () {
        vm.pageView = 'form';
      };

      $window.onbeforeunload = $window.onunload;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('evaluationSurvey', evaluationSurvey);
})();

/**
 * Created by Bruce on 2016/10/24.
 */
(function () {
  'use strict';

  var detailSessionList = {
    bindings: {
      courseId: '=?',
      isProgram: '=?',
      mdDialogClose: '&?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/detail-session-list.html',
    controller: [ '$scope', 'NgTableParams','$state', '$stateParams', 'courseResourceService', 'CourseObject', 'SweetAlert', '$filter', 'ngTableColumnValueService', '$interpolate', 'PermPermissionStore',
      function( $scope, NgTableParams, $state, $stateParams, courseResourceService, CourseObject, SweetAlert, $filter, ngTableColumnValueService, $interpolate, PermPermissionStore ){
      var vm = this;
      var permission = PermPermissionStore.getPermissionDefinition('Modules.course.onlinetest');

      vm.courseId = angular.isUndefined(this.courseId) ? null : this.courseId;
      vm.isProgram = angular.isUndefined(this.isProgram) ? false : this.isProgram;
      vm.catalogId = angular.isUndefined($stateParams.cid) ? 0 : $stateParams.cid;
      vm.nodeId = angular.isUndefined($stateParams.nid) ? undefined : $stateParams.nid;
      vm.mdDialogClose = angular.isUndefined(this.mdDialogClose) ? null : this.mdDialogClose;
      vm.closeDialogClick = angular.isUndefined(this.closeDialogClick) ? null : this.closeDialogClick;
      vm.CourseObject = CourseObject;
      vm.hasAssignCoursePermission = PermPermissionStore.hasPermissionDefinition('Assign_Courses_to_Team_members');
      vm.hasCancelCourseAssignmentsPermission = PermPermissionStore.hasPermissionDefinition('Cancel_Course_Assignments');


      vm.reloadTable = function () {
        vm.enrollSessionsDataTable.reload();
      };

      vm.startLearning = function(catalogId, courseId, enrollmentId, status) {
        if(status!=='Waitlisted'){
          (!vm.isProgram)
            ? $state.go('courseResourceCatalog.CourseInfo.SessionInfo', {
              cid: parseInt(vm.catalogId),
              courseId: courseId,
              enrollmentId: enrollmentId,
              nid: parseInt(catalogId)
            })
            : $state.go('courseResourceCatalog.ProgramInfo.SessionInfo', {
              cid: parseInt(vm.catalogId),
              programId: courseId,
              enrollmentId: enrollmentId,
              nid: parseInt(catalogId)
            });
          if(angular.isFunction(vm.mdDialogClose)) {
            vm.mdDialogClose();
          }
        }
        else {
          SweetAlert.error($filter('translate')( 'MESSAGE.MSG_CAN_NOT_TAKE_LESSONS'), $filter('translate')( 'STATUS.ENROLLMENT_WAITLISTED'));
        }

      };

      $scope.$watch(function(){
        return vm.courseId;
      }, function(newVal){
        if(!angular.isUndefinedOrNull(newVal)){
          prepareTable();
        }
      });


      function prepareTableCols() {
        return [
          {
            field: 'sessionName',
            title: $filter('translate')('FIELD.SESSION'),
            getValue: ngTableColumnValueService.interpolatedValue,
            interpolateExpr: $interpolate(htmlSessionName()),
            width: 20,
            priority: 1
          },
          {
            field: 'sessionType',
            title: $filter('translate')('FIELD.TYPE'),
            getValue: ngTableColumnValueService.interpolatedValue,
            interpolateExpr: $interpolate(htmlSessionType()),
            show: (vm.programType===1),
            width: 5,
            priority: 1
          },
          {
            field: 'classTime',
            title: $filter('translate')('FIELD.CLASS_TIME'),
            getValue: ngTableColumnValueService.interpolatedValue,
            interpolateExpr: $interpolate('<div class="time" ng-bind-html="row.classTime |replaceAll:\'\\n\\n\':\'<br>\'"></div>'),
            width: 10,
            priority: 1
          },
          {
            field: 'deadline',
            title: $filter('translate')('FIELD.ENROLL_DEADLINE'),
            getValue: ngTableColumnValueService.htmlTextValue,
            width: 5,
            priority: 3
          },
          {
            field: 'instructor',
            title: $filter('translate')('FIELD.INSTRUCTOR'),
            getValue: htmlInstructor,
            show: (vm.programType!==1),
            width: 10,
            priority: 2
          },
          {
            field: 'counselor',
            title: $filter('translate')('FIELD.COUNSELOR'),
            getValue: ngTableColumnValueService.interpolatedValue,
            interpolateExpr: $interpolate(htmlCounselor()),
            show: (vm.programType===1),
            width: 10,
            priority: 2
          },
          {
            field: 'venue',
            title: $filter('translate')('FIELD.EVENT_LOCATION'),
            getValue: ngTableColumnValueService.htmlTextValue,
            show: (!vm.isProgram),
            width: 10,
            priority: 2
          },
          {
            field: 'people',
            title: $filter('translate')('FIELD.NUMBER_OF_PEOPLE'),
            getValue: ngTableColumnValueService.interpolatedValue,
            interpolateExpr: $interpolate(htmlPeople()),
            width: 5,
            priority: 3
          },
          {
            field: 'action',
            title: $filter('translate')('FIELD.ACTION'),
            getValue: ngTableColumnValueService.interpolatedValue,
            interpolateExpr: $interpolate(htmlAction()),
            width: '50px',
            priority: 1
          },
          {
            field: 'enrollManager',
            title: $filter('translate')('FIELD.ENROLL_MANAGER'),
            getValue: ngTableColumnValueService.interpolatedValue,
            interpolateExpr: $interpolate(htmlEnrollManager()),
            width: '50px',
            show: (permission),
            priority: 1
          }
        ];
      }

      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.enrollSessionsDataTable = new NgTableParams({}, {
          counts: [],
          getData: function(tableParams) {
            vm.backStateParams = {
              catalogId: vm.catalogId,
              courseId: vm.courseId
            };
            if(!vm.isProgram){
              return courseResourceService.getCourseEnrollSessions(vm.courseId, {}).then(function (enrollSessions) {
                tableParams.total(enrollSessions.length);
                vm.isExecuted = enrollSessions[0].isExecuted;
                vm.isExecutionEnroll = enrollSessions[0].isExecutionEnroll;
                return enrollSessions;
              });
            }else{
              return courseResourceService.getProgramEnrollSessions(vm.courseId, {}).then(function (enrollSessions) {
                tableParams.total(enrollSessions.length);
                vm.programType = enrollSessions[0].programType;
                vm.isExecuted = enrollSessions[0].isExecuted;
                vm.isExecutionEnroll = enrollSessions[0].isExecutionEnroll;
                return enrollSessions;
              });
            }
          }
        });
      }

      function htmlSessionName() {
        var html  = '<a href="javascript:void(0);" ng-if="$ctrl.isProgram" tip-info tip-type="4" params="{pid: row.programId, sid: row.sessionId}">';
              html += '{{row.sessionName}}';
            html += '</a>';
            html += '<a href="javascript:void(0);" ng-if="!$ctrl.isProgram && row.courseType===3" tip-info tip-type="6" params="{\'cid\': row.courseId, \'sid\': row.sessionId}">';
              html += '{{row.sessionName}}';
            html += '</a>';
            html += '<a href="javascript:void(0);" ng-if="!$ctrl.isProgram && (row.courseType===5 || row.courseType===4)" tip-info tip-type="19" params="{\'cid\': row.courseId, \'sid\': row.sessionId}">';
              html += '{{row.sessionName}}';
            html += '</a>';
            html += '<a href="javascript:void(0);" ng-if="!$ctrl.isProgram && row.courseType===6" tip-info tip-type="20" params="{\'cid\': row.courseId, \'sid\': row.sessionId}">';
              html += '{{row.sessionName}}';
            html += '</a>';
            html += '<a href="javascript:void(0);" ng-if="!$ctrl.isProgram && (row.courseType===1 || row.courseType===2)" tip-info tip-type="2" params="{\'cid\': row.courseId, \'sid\': row.sessionId}">';
              html += '{{row.sessionName}}';
            html += '</a>';
        return html;
      }

      function htmlSessionType() {
        var html  = '<div ng-if="row.sessionType===0">';
              html += '{{ \'FIELD.GENERAL_SESSION\' | translate}}';
            html += '</div>';
            html += '<div ng-if="row.sessionType===1">';
              html += '{{ \'FIELD.EXTEND_SESSION\' | translate}}';
            html += '</div>';
        return html;
      }

      function htmlInstructor() {
        var html = '';
        html += '<div ng-if="row.courseType!==3">';
          html += '<a href="javascript:void(0);" instructor-detail instructor-id="instructor.instructorId" ng-repeat="instructor in row.instructorList" >';
            html += '{{instructor.instructorName | htmlEscapedDecode | markSplit:$index:\'&nbsp;/&nbsp;\'}}';
          html += '</a>';
        html += '</div>';
        html += '<div ng-if="row.courseType===3" ng-repeat="instructor in row.instructorList">';
          html += '{{instructor.instructorName | htmlEscapedDecode | markSplit:$index:\'&nbsp;/&nbsp;\'}}';
        html += '</div>';
        return html;
      }

      function htmlCounselor() {
        var html = '';
        html += '<div class="text-center">';
          html += '<a href="javascript:void(0);" user-detail  user-id="instructor.instructorId" is-certificate="1" ng-repeat="instructor in row.instructorList" >';
            html += '{{instructor.instructorName | markSplit:$index:\'&nbsp;/&nbsp;\'}}';
          html += '</a>';
        html += '</div>';
        return html;
      }

      function htmlPeople() {
        var html = '';
        html += '<div>';
          html += '{{ \'FIELD.ENROLL_NUMBER_OF_PEOPLE\' | translate}}:';
          html += '<a href="javascript:void(0);" ng-if="row.canViewEnrollLearner===1" session-enrolled-members-dialog course-id="row.courseId" session-id="row.sessionId" is-program="$ctrl.isProgram">';
            html += ' {{row.enrolledPeople}}';
          html += '</a>';
        html += '<span ng-if="row.canViewEnrollLearner===0">{{row.enrolledPeople}}</span>';
          html += '<span ng-if="row.courseType!==3"> ; {{ \'FIELD.REMAINING_AMOUNT\' | translate}}:';
            html += '<span ng-if="row.availableQuota === -1"> {{ \'FIELD.NO_UPPER_LIMIT\' | translate}}</span>';
            html += '<span ng-if="row.availableQuota !== -1"> {{row.availableQuota}}</span>';
          html += '</span>';
          html += '<span ng-if="row.isEnabledWaitlist"> ; {{ \'FIELD.OCCUPY_WAIT_LIST\' | translate}}: {{row.occupyQuota}}</span>';
          html += '<span ng-if="row.isEnabledWaitlist && (!row.isLimitlessWaitlist)"> ; {{ \'FIELD.REMAIN_WAIT_LIST\' | translate}}: {{row.remainQuota}}</span>';
        html += '</div>';
        return html;
      }

      function htmlAction() {
        var html = '';
        html += '<div ng-switch="row.actionStatus">';
          html += '<p class="pt-mark" ng-switch-when="0">{{row.actionMessage}}</p>';
          html += '<p class="pt-mark" ng-switch-when="1">';
            html += '<md-button course-info-player play-item-id="row.surveyItemId" course-id="row.courseId" session-id="row.sessionId" is-check-time="true" reload-fn="$ctrl.reloadTable()" class="md-raised md-primary">';
              html += '<md-icon md-font-set="md">play_circle_filled</md-icon>';
            html += '</md-button>';
          html += '</p>';
          html += '<p ng-switch-when="2">';
            html += '<md-button class="md-raised md-primary" session-action-enroll session-id="row.sessionId" is-program="$ctrl.isProgram" reload-fn="$ctrl.reloadTable()" ng-if="row.courseType !== $ctrl.CourseObject.COURSETYPE_EXTERNAL">';
              html += '<md-icon md-font-set="md">person_add</md-icon>';
              html += '{{ \'ACTIONS.ENROLL\' | translate}}';
            html += '</md-button>';
            html += '<md-button class="md-raised md-primary" ui-sref="courseResourceCatalog.CourseInfo.applyFormCreateByCourseSession({cid:0, nid: row.categoryTreeId, courseId: row.courseId, sessionId: row.sessionId, backStateParams: $ctrl.backStateParams})" ng-if="row.courseType === $ctrl.CourseObject.COURSETYPE_EXTERNAL" ng-click="$ctrl.mdDialogClose()">';
              html += '<md-icon md-font-set="md">person_add</md-icon>';
              html += '{{ \'ACTIONS.ENROLL\' | translate}}';
            html += '</md-button>';
          html += '</p>';
          html += '<p ng-switch-when="3">';
            html += '<md-button class="md-raised md-warn" session-action-un-enroll enrollment-id="row.enrollmentId" is-program="$ctrl.isProgram" reload-fn="$ctrl.reloadTable()">';
              html += '{{row.actionMessage}}';
            html += '</md-button>';
          html += '</p>';
          html += '<p ng-switch-when="4">';
            html += '<md-button ng-if="$ctrl.isCanView($ctrl.isExecuted,$ctrl.isExecutionEnroll)" ng-click="$ctrl.startLearning(row.categoryTreeId, (!$ctrl.isProgram)?row.courseId:row.programId, row.enrollmentId, row.status)" class="md-raised md-primary">';
              html += '<md-icon md-font-set="md">play_circle_filled</md-icon>';
              html += '{{ \'ACTIONS.START_LEARNING\' | translate}}';
            html += '</md-button>';
          html += '<md-button ng-if="!$ctrl.isCanView($ctrl.isExecuted,$ctrl.isExecutionEnroll)" ng-click="$ctrl.showStatus($ctrl.isExecuted)" class="md-raised md-primary">';
            html += '<md-icon md-font-set="md">play_circle_filled</md-icon>';
            html += '{{ \'ACTIONS.START_LEARNING\' | translate}}';
          html += '</md-button>'
          html += '</p>';
        html += '</div>';
        return html;
      }

      vm.isCanView = function(isExecuted, isExecutionEnroll){
        if(isExecutionEnroll===1){
          if(isExecuted!==0){
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }

      vm.showStatus = function(isExecuted){
        if(isExecuted===0) {
          SweetAlert.error($filter('translate')('MESSAGE.MSG_CAN_NOT_TAKE_LESSONS'), $filter('translate')('STATUS.HAVE NOT EXECUTED ENROLLED ASSIGNMENT'));
        }
      }

      function htmlEnrollManager() {
        var html = '';
        html += '<div class="condition">';
          html += '<p ng-if="row.assignOther === 1 && $ctrl.hasAssignCoursePermission">';
            html += '<a href="javascript:void(0);" assignable-members is-program="$ctrl.isProgram" session-id="row.sessionId" session-name="row.sessionName" is-external="row.courseType === $ctrl.CourseObject.COURSETYPE_EXTERNAL" course-id="($ctrl.isProgram ? row.programId : row.courseId)" max-assignable-members="row.availableQuota" enroll-type="learner" reload-fn="$ctrl.reloadTable()">';
                html += '{{ \'FIELD.ASSIGNABLE_MEMBER_ENROLL\' | translate}}';
            html += '</a>';
          html += '</p>';
          html += '<p ng-if="row.assignWait === 1">';
            html += '<a href="javascript:void(0);" assignable-members is-program="$ctrl.isProgram" session-id="row.sessionId" session-name="row.sessionName" is-external="row.courseType === $ctrl.CourseObject.COURSETYPE_EXTERNAL" course-id="($ctrl.isProgram ? row.programId : row.courseId)" max-assignable-members="row.remainQuota" enroll-type="wait" reload-fn="$ctrl.reloadTable()">';
                html += '{{ \'FIELD.ASSIGNABLE_MEMBER_ALTERNATE\' | translate}}';
            html += '</a>';
          html += '</p>';
          html += '<p ng-if="row.cancelOther === 1 && $ctrl.hasCancelCourseAssignmentsPermission">';
            html += '<a href="javascript:void(0);" un-assignable-members is-program="$ctrl.isProgram" session-id="row.sessionId" session-name="row.sessionName" reload-fn="$ctrl.reloadTable()" >';
              html += '{{ \'FIELD.UN_ASSIGNABLE_MEMBER_ENROLL\' | translate}}';
            html += '</a>';
          html += '</p>';
        html += '</div>';
        return html;
      }
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('detailSessionList', detailSessionList);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var detailSessionLearners = {
    bindings: {
      sessionId: '=',
      isProgram: '@?',
      reload:'='
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/detail-session-learners.html',
    controller: ['$scope', 'NgTableParams', 'courseResourceService', function( $scope, NgTableParams, courseResourceService ){
      var vm = this;
      vm.sessionId = angular.isUndefined(this.sessionId) ? null : this.sessionId;
      vm.isProgram = angular.isUndefined(this.isProgram) ? false : this.isProgram;
      vm.reload = angular.isUndefined(this.reload) ? false : this.reload;
      $scope.$watch(function(){
        return vm.reload;
      }, function(newVal, oldVal){
          if(!angular.equals(newVal, oldVal) && !angular.isUndefinedOrNull(newVal) && newVal){
            vm.sessionLearnersTable = new NgTableParams({}, {
              counts: [1,5,10,15],
              getData: function(tableParams) {
                var params = {};
                angular.forEach(tableParams.sorting(), function (value, key) {
                  params.sort = key;
                  params.order = ((value === 'desc') ? 0 : 1);
                });

                angular.forEach(tableParams.filter(), function (value, key) {
                  params[key] = value;
                });

                params.current_page = tableParams.url().page;
                params.list_size = tableParams.url().count;

                if(vm.isProgram){
                  return courseResourceService.getProgramSessionLearners(vm.sessionId, params).then(function (sessionLearnersData) {
                    tableParams.total(sessionLearnersData.metadata.pagination.total);
                    return sessionLearnersData;
                  });
                }else{
                  return courseResourceService.getCourseSessionLearners(vm.sessionId, params).then(function (sessionLearnersData) {
                    tableParams.total(sessionLearnersData.metadata.pagination.total);
                    return sessionLearnersData;
                  });
                }
              }
            });
          }
      });
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('detailSessionLearners', detailSessionLearners);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var detailCompletionRate = {
    bindings: {
      data: '=',
      isShow: '='
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/detail-completion-rate.html',
    controller: [function( ){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? null : this.data;
      vm.isShow = angular.isUndefined(this.isShow) ? false : this.isShow;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('detailCompletionRate', detailCompletionRate);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseSessionInfo = {
    bindings: {
      catalogId: '=?',
      courseId: '=?',
      programEnrollmentId: '=?',
      backState: '=?',
      enrollmentId: '=?',
      nodeId: '=?',
      tabSelect: '=?',
      isUser: '=?'  //mail link use
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info.html',
    controller: ['$timeout' ,'sitemapService', '$state', '$stateParams', '$http', '$filter', 'courseResourceService', 'serverSetting', 'courseULiveService', function($timeout, sitemapService, $state,$stateParams, $http, $filter, courseResourceService, serverSetting, courseULiveService ){
      var vm = this;
      var params;
      var catalogId           = angular.isDefined(this.catalogId) ? this.catalogId: null;
      var courseId            = angular.isDefined(this.courseId) ? this.courseId: null;
      var nodeId              = angular.isDefined(this.nodeId) ? this.nodeId: null;
      var programEnrollmentId = angular.isDefined(this.programEnrollmentId) ? this.programEnrollmentId: null;
      var backState           = angular.isDefined(this.backState) ? this.backState: null;
      var enrollmentId        = angular.isDefined(this.enrollmentId) ? this.enrollmentId: null;
      vm.tabSelect            = angular.isDefined(this.tabSelect) ? this.tabSelect: null;
      vm.isUser               = angular.isDefined(this.isUser) ? this.isUser: true;

      vm.isShowBreadCrumb = angular.isUndefinedOrNull($stateParams['ncyBreadcrumb'] && $stateParams['ncyBreadcrumb'].isShowBreadCrumb) ? true : $stateParams['ncyBreadcrumb'].isShowBreadCrumb;

      $stateParams.enrollmentId = programEnrollmentId;
      if(angular.isDefined(backState)) {
        if(!angular.isUndefinedOrNull(catalogId) && !angular.isUndefinedOrNull(courseId)){
          vm.goBack={
            title: $filter('translate')('FIELD.COURSE_INFO'),
            state:backState,
            stateParams:{
              cid: catalogId, courseId: courseId, nid: nodeId
            }
          };
        }
        else if(!angular.isUndefinedOrNull(programEnrollmentId)) {
          courseResourceService.getProgramEnrollment(programEnrollmentId, {}).then(function (programData) {
            vm.goBack={
              title: (programData.programType===0)?$filter('translate')('PROGRAM_INFO'):$filter('translate')('CERTIFICATE_INFO'),
              state: (programData.programType===0)?'learningPassport.incompleteCourses.programInfo':'learningPassport.incompleteCourses.certificationInfo',
              stateParams:{enrollmentId: programEnrollmentId}
            };
          });
        }
      }


      if (!vm.isShowBreadCrumb) {
        $timeout(function() {
          courseResourceService.getProgramEnrollment(programEnrollmentId, {}).then(function (programData) {
            vm.programTypeTitle = (programData.programType===0)?$filter('translate')('PROGRAM_INFO'):$filter('translate')('CERTIFICATE_INFO');
            vm.menulist = [
              {
                title: $filter('translate')('INDEX'),
                patch: "#/?mid=" + sitemapService.getSiteMapNodes().children[0].model.stateParams.mid
              },{
                title: $filter('translate')('LEARNING_PASSPORT'),
                patch: null
              },{
                title: $filter('translate')('INCOMPLETE_COURSES'),
                patch: "#/learning-passport/incomplete-courses?mid=" + sitemapService.getSiteMapNodes().children[2].children[1].model.stateParams.mid
              },{
                title: vm.programTypeTitle,
                patch: "#/learning-passport/incomplete-courses/program-info/"+ $stateParams.programEnrollmentId
              },{
                title: $filter('translate')('FIELD.COURSE_INFO'),
                patch: null
              }
            ];
            vm.menulistBreadcrumb = $filter('stringToBreadcrumb')(vm.menulist, 'programSessionInfoBreadcrumb', null);
            $state.current._ncyBreadcrumbLabel = vm.menulistBreadcrumb;

          });
        }, 0)
      }




      params = {};
      vm.getCourseData = function () {
        courseResourceService.getCourseEnrollment(enrollmentId, params).then(function (enrollmentData) {

          vm.enrollmentData = enrollmentData;

          courseULiveService.getULiveCourseState(vm.enrollmentData.courseId, vm.enrollmentData.sessionId, {}).then(function (response) {
            vm.uLiveCourseData = response;
          });

          courseResourceService.getCourse(enrollmentData.courseId, params).then(function (courseData) {
            vm.courseData = courseData;
          });

          courseResourceService.getCourseSessionLearnersCompletionRate(enrollmentData.sessionId,{}).then(function (courseSessionLearnersCompletionRateData) {
            vm.completionRateData = courseSessionLearnersCompletionRateData;
          });

          courseResourceService.getLearningResult(enrollmentData.enrollmentId).then(function (courseContentData) {
            vm.courseContentData = courseContentData;
          });

          courseResourceService.getCourseSession(enrollmentData.sessionId, params).then(function (sessionData) {
            vm.sessionData = sessionData;
            if(angular.isUndefinedOrNull(vm.tabSelect)) {
              vm.tabSelect = (vm.sessionData.canAction===0 || vm.enrollmentData.isBlock===1)?"learningResult":"learningCenter";
            }
          });

          courseResourceService.getLearningHistory(enrollmentData.enrollmentId).then(function (learningHistory) {
            vm.attendanceRecords = learningHistory.attendanceRecord;
            vm.learningHistory = learningHistory;
          });

        });
      };
      vm.getCourseData();
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseSessionInfo', courseSessionInfo);
})();

/**
 * Created by Alan on 2017/5/2.
 */
(function () {
  'use strict';

  var courseSearch = {
    bindings: {
      params: '=?',       //api: api/ctl/catalog-course-search
      chooseCourse: '=',  //object
      chooseMethod: '@?'  //checkbox or radio
    },
    templateUrl: 'app/modules/course-resource/views/course-search.html',
    controller: ['$scope', 'ctlService', 'NgTableParams', '$filter', function($scope, ctlService, NgTableParams, $filter){
      var vm = this;
      vm.params       = angular.isUndefinedOrNull(this.params)?[]:this.params;
      vm.chooseCourse = this.chooseCourse;
      vm.chooseMethod = angular.isUndefinedOrNull(this.chooseMethod)?'checkbox':this.chooseMethod;

      vm.corsesTable = new NgTableParams({}, {
        counts: [1,5,10,15],
        getData: function(tableParams) {
          vm.params.keyword = vm.keyword;
          vm.params.current_page = tableParams.url().page;
          vm.params.list_size = tableParams.url().count;
          return ctlService.getCatalogCourseSearch(vm.params).then(function (courses) {
            tableParams.total(courses.metadata.pagination.total);
            vm.courses = courses;
            vm.courseSelectAll = false;
            return courses;
          });
        }
      });

      $scope.$watch('$ctrl.keyword', function() {
        vm.corsesTable.page(1);
        vm.corsesTable.reload();
      });

      vm.selectCourse = function () {
        angular.forEach(vm.courses, function(course) {
          if(vm.courseSelectAll) {
            (($filter('arrayObjectIndexOf')(vm.chooseCourse, course)) === -1)?vm.addCourse(course):"";
          }
          else {
            (($filter('arrayObjectIndexOf')(vm.chooseCourse, course)) > -1)?vm.removeCourse(course):"";
          }
        });
      };

      vm.addCourse = function (course) {
        vm.chooseCourse.push(course);
      };

      vm.removeCourse = function (course) {
        vm.chooseCourse.splice($filter('arrayObjectIndexOf')(vm.chooseCourse, course), 1);
      };

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseSearch', courseSearch);
})();

/**
 * Created by Bruce on 2017/08/03.
 */
(function () {
  'use strict';

  var courseResourceCatalogList = {
    bindings: {
      catalogId: '=?catalogId',
      nodeId: '=?nodeId',
      tabSelect: '=?tabSelect'
    },
    templateUrl: 'app/modules/course-resource/views/course-resource-catalog-list.html',
    controller: [ 'sitemapService', '$state', '$stateParams', 'courseResourceService', '$filter', function( sitemapService, $state, $stateParams, courseResourceService, $filter){
      var vm = this;
      vm.isShowIndex = false;
      vm.catalogId = (angular.isDefined(this.catalogId) && this.catalogId.length > 0) ? parseInt(this.catalogId) : 0;
      vm.nodeId = angular.isDefined(this.nodeId) ? (this.nodeId === 'courseLearningResourceIndex'? 0 : this.nodeId) : undefined;
      vm.hasParams = angular.isDefined($stateParams.params);
      vm.params = vm.hasParams ? $stateParams.params : {};
      $stateParams.params = undefined;
      vm.templateType = angular.isDefined(vm.params.templateType) ? vm.params.templateType : 'card';
      vm.isLoading = false;
      vm.isSearchMode = false;
      if(angular.isUndefinedOrNull(vm.nodeId)){
       if(vm.catalogId === 0){
          vm.isShowIndex = true;
          vm.nodeId = '0';
       }
	  } else{
		 vm.isShowIndex = vm.nodeId==='0';
	  }

      if(vm.isShowIndex) {
        vm.tabSelect = (angular.isUndefinedOrNull(this.tabSelect))?'latestCourse':this.tabSelect;
        vm.filter = [];
        vm.pagination = {
          perPage: 10
        };
        vm.searchData = function(params) {
          if(!params.keyword && vm.hasParams) { 
            params.keyword = $(".chat-search.ng-scope").find("input[ng-model='query.keywords']").val(); 
          }
          if(params.keyword!=='' && angular.isDefined(params.keyword)) {
            vm.isLoading = true;
            vm.params = params;
            courseResourceService.getCourseResource(0, params).then(function (data) {
              $(".chat-search.ng-scope").find("input[ng-model='query.keywords']").val(params.keyword);
              vm.courseResourceDatas = data.metadata.fullTextSearchData;
              vm.menulist = data.metadata.menulist;
              vm.pagination = data.metadata.pagination;
              vm.isSearchMode = true;
              vm.filter = [
                {key : 'all', value:'-1', name:'FIELD.ALL', permissions:['Modules.course']},
                {key : 'courseType', value:'2', name:'FIELD.CLASS_ROOM_COURSE', permissions:['Modules.course.classroom']},
                {key : 'courseType', value:'1', name:'FIELD.ONLINE_COURSE', permissions:['Modules.course.online']},
                {key : 'programType', value:'0', name:'FIELD.PROGRAM', permissions:['Modules.curriculum']},
                {key : 'courseType', value:'3', name:'FIELD.EXTERNAL_TRAINING', permissions:['Modules.course.external']},
                {key : 'courseType', value:'4', name:'FIELD.ONLINE_TEST', permissions:['Modules.course.onlinetest']},
                {key : 'courseType', value:'5', name:'FIELD.CLASS_ROOM_TEST', permissions:['Modules.course.classroomtest']},
                {key : 'courseType', value:'6', name:'FIELD.QUESTIONNAIRE', permissions:['Modules.course.survey']},
                {key : 'programType', value:'1', name:'FIELD.INTERNAL_LICENSE', permissions:['Modules.certification.inner']},
                {key : 'onlyFavorite', value:'1', name:'FIELD.MY_FAVOURITE', permissions:['Modules.course.online','Modules.course.classroom','Modules.course.external','Modules.curriculum']}
              ];
              vm.isLoading = false;
            });
          }
          else {
            vm.isSearchMode = false;
            vm.filter = [];
          }
        };
        vm.searchData(vm.params);

        vm.getLatestCourses = function() {
          vm.tabSelect = 'latestCourse';
          vm.params.tabSelect = 'latestCourse';
          courseResourceService.getLatestCourses().then(function(latestCourses) {
            vm.latestCourses = latestCourses;
          });
        };

        vm.getHotCourse = function() {
          vm.tabSelect = 'hotCourse';
          vm.params.tabSelect = 'hotCourse';
          courseResourceService.getHotCourses().then(function(hotCourses) {
            vm.hotCourses = hotCourses;
          });
        };

        vm.getFeaturedCourses = function(params) {
          vm.params = params;
          vm.tabSelect = 'featuredCourse';
          vm.params.tabSelect = 'featuredCourse';
          courseResourceService.getFeaturedCourses(params).then(function(featuredCourses) {
            vm.featuredCourses = featuredCourses;
            vm.featuredCoursesPagination = featuredCourses.metadata.pagination;
          });
        };
      } else {
        vm.getData = function(params) {
          if(!params.keyword && vm.hasParams) { 
            params.keyword = $(".chat-search.ng-scope").find("input[ng-model='query.keywords']").val(); 
          }
          vm.isLoading = true;
          vm.params = params;
          vm.categoryTreeId = (angular.isDefined(vm.nodeId)? vm.nodeId : vm.catalogId);
          vm.menulist = [];
          courseResourceService.getCourseResource(vm.categoryTreeId, params).then(function (data) {
            vm.pagination = data.metadata.pagination;
            if(!!params.keyword) {
              $(".chat-search.ng-scope").find("input[ng-model='query.keywords']").val(params.keyword);
              vm.courseResourceDatas = data.metadata.fullTextSearchData;
              vm.isSearchMode = true;
            }else{
              vm.courseResourceDatas = data;
              vm.isSearchMode = false;
            }

            if(parseInt(vm.catalogId) === 0) {
              sitemapService.getSiteMapNodes().walk(function (node) {
                if (node.model.state === $state.current.name){
                  if(angular.equals(node.model.stateParams['mid'], $state.params['mid']) && vm.isLoading) {
                    vm.menulist.push({
                      id: angular.isUndefinedOrNull(node.getPath()[node.getPath().length - 1].model.stateParams['cid']) ? 0 : node.getPath()[node.getPath().length - 1].model.stateParams['cid'],
                      title: node.getPath()[node.getPath().length - 1].model.title
                    });
                  }
                }
              });
            }
            vm.menulist = vm.menulist.concat(data.metadata.menulist);
            vm.lastMenulist = data.metadata.menulist[vm.menulist.length-1];

            sitemapService.getSiteMapNodes().walk(function (node) {
              if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
                if(vm.menulist.length > 0 && parseInt(vm.menulist[0].id) === parseInt(node.model.stateParams['cid'])){
                  vm.menulist[0].title = node.model.title;
                }
              } else {
                if(angular.isUndefinedOrNull(vm.mainMenu) && node.model.state === 'courseResourceCatalog') {
                  if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === vm.catalogId){
                    if(vm.menulist.length > 0 && vm.menulist[0].id === node.model.stateParams['cid']){
                      vm.menulist[0].title = node.model.title;
                    }
                  }
                }
              }
            });
            if(vm.isLoading) {
              vm.courseResourceBreadcrumb = $filter('stringToBreadcrumb')(vm.menulist, 'sitemap-breadcrumb');
              $state.current._ncyBreadcrumbLabel = vm.courseResourceBreadcrumb;
              vm.courseResourceTitle = $filter('stringToBreadcrumb')(vm.menulist, 'text');
            }
            angular.element("html, body").animate({
              scrollTop: 0
            }, 10);
            vm.isLoading = false;
          });
        };
        vm.getData(vm.params);
      }
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseResourceCatalogList', courseResourceCatalogList);
})();

/**
 * Created by Bruce on 2017/7/31.
 */

(function() {
  'use strict';

  var courseLearningResourceMenu = {
    bindings: {
      catalogId: '=?catalogId',
      nodeId: '=?nodeId'
    },
    templateUrl: 'app/modules/course-resource/views/course-learning-resource-menu.html',
    controller: [ 'courseResourceService', '$state', '$filter', 'serverSetting', 'sitemapService', function( courseResourceService, $state, $filter, serverSetting, sitemapService) {
      var vm = this;
      vm.catalogId = (angular.isDefined(this.catalogId) && this.catalogId.length > 0) ? this.catalogId : 0;
      vm.previousMenu = undefined;
      vm.mainMenu = undefined;

      vm.process = function() {
        angular.forEach(sitemapService.getMenu(), function (item) {
          if (item.state === 'courseResourceCatalog') {
            vm.courseResourceCatalogNode = item;
          }
        });
        sitemapService.getSiteMapNodes().walk(function (node) {
          if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
            if (node.model.state != 'learningPassport.myCurriculum') {
              vm.mainMenu = node.model;
            }
            if ((node.getPath().length -2) > 0 && angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams) &&
              angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams['url']) &&
              node.getPath()[(node.getPath().length -2)].model.stateParams['url'].length > 0) {
              vm.previousMenu = node.getPath()[(node.getPath().length -2)];
              if (vm.previousMenu.model.state === 'page') {
                if (vm.mainMenu.state === 'learningActivity')
                  vm.mainMenu = vm.courseResourceCatalogNode;
              }

            }
          } else {
            if(angular.isUndefinedOrNull(vm.mainMenu) && node.model.state === 'courseResourceCatalog') {
              if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === vm.catalogId){
                vm.mainMenu = node.model;
                if ((node.getPath().length -2) > 0 && angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams) &&
                  angular.isDefined(node.getPath()[(node.getPath().length -2)].model.stateParams['url']) &&
                  node.getPath()[(node.getPath().length -2)].model.stateParams['url'].length > 0) {
                  vm.previousMenu = node.getPath()[(node.getPath().length -2)];
                }
              }
            }
          }
        });

        if(!vm.previousMenu) {
          sitemapService.getSiteMapNodes().walk(function (node) {
            if(node.model.state === 'index') {
              vm.previousMenu = node;
            }
          });
        }
      };

      vm.toggleNode = function(node) {
        node.showChildren = node.showChildren ? false : true;
      };


      if(sitemapService.getMenu().length ) {
        vm.process();
      } else {
        sitemapService.getProjectSideMenu().then(function (menuItems) {
          sitemapService.setMenu(menuItems);
          vm.process();
        });
      }

      courseResourceService.getCourseResourceMenuNodes(vm.catalogId).then(function (data) {
        vm.menu = data.map(function(node) {
          node.showChildren = false;
          return node;
        });
      });

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseLearningResourceMenu', courseLearningResourceMenu);
})();

/**
 * Created by Bruce on 2016/11/24.
 */
(function () {
  'use strict';

  var courseLearningResourceInfo = {
    bindings: {
      courseResourceData: '=',
      reloadFn: '&?',
      nodeId: '=?',
      params: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/single-info-template/course-learning-resource-info.html',
    controller: [ function(){
      var vm = this;
      vm.courseResourceData = this.courseResourceData;
      vm.reloadFn = (angular.isFunction(this.reloadFn))?this.reloadFn:null;
      vm.nodeId = angular.isDefined(this.nodeId) ? this.nodeId : undefined;
      vm.params = angular.isDefined(this.params) ? this.params : {};
      function templateTypeChange(){
        vm.templateType = angular.element("#timeline").hasClass("th-card") ? 'card' : 'list';
        vm.params.templateType = vm.templateType;
      };
      templateTypeChange();
      angular.element("#timeline").find(".array").bind("click", function(){
        templateTypeChange();
      });
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseLearningResourceInfo', courseLearningResourceInfo);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseInfo = {
    bindings: {
      catalogId: '=?catalogId',
      courseId: '=?courseId',
      nodeId: '=?nodeId'
    },
    templateUrl: 'app/modules/course-resource/views/course-info.html',
    controller: ['$state','$scope', '$filter', '$stateParams', 'courseResourceService', 'sitemapService', function( $state, $scope, $filter, $stateParams, courseResourceService, sitemapService ){
      var vm = this;
      var courseId = angular.isDefined(this.courseId) ? this.courseId : undefined;
      var params = {};
      vm.nodeId = angular.isDefined($stateParams.nid) ? ($stateParams.nid === 'courseLearningResourceIndex' ? null : $stateParams.nid) : undefined;

      vm.getCourseData = function () {
        courseResourceService.getCourse(courseId, params).then(function (courseData) {
          vm.courseData = courseData;
          vm.catalogId = angular.isDefined($stateParams.catalogId) ? $stateParams.catalogId : angular.isDefined($stateParams.cid) ? $stateParams.cid : undefined;
          if(angular.isDefined(vm.catalogId)){

            courseResourceService.getCourseResourceCatalogMenu(vm.catalogId).then(function (menuList) {
              var breadcrumbLabel = vm.courseData.courseName;
              sitemapService.getSiteMapNodes().walk(function (node) {
                if(angular.isDefined(node.model.stateParams) && angular.isDefined(node.model.stateParams['mid']) && (node.model.stateParams['mid'] === $state.params['mid'])){
                  if(menuList.length > 0 && parseInt(menuList[0].id) === parseInt(node.model.stateParams['cid']) && !vm.nodeId){
                      menuList[0].title = node.model.title;
                  }
                }
                else {
                  if(angular.isUndefinedOrNull(vm.mainMenu) && node.model.state === 'courseResourceCatalog') {
                    if(node.model.stateParams['cid'] === null || node.model.stateParams['cid'] === vm.catalogId){
                      if(menuList.length > 0 && menuList[0].id === node.model.stateParams['cid'] && !vm.nodeId){
                        menuList[0].title = node.model.title;
                      }
                    }
                  }
                }
              });

              vm.courseResourceBreadcrumb = $filter('stringToBreadcrumb')(menuList, 'sitemap-breadcrumb', breadcrumbLabel);
              $state.current._ncyBreadcrumbLabel = vm.courseResourceBreadcrumb;

            });
            if(angular.isDefined($stateParams.backState)){
              if($stateParams.backState == 'fullTextSearchList'){
                vm.goBack={
                  title: $filter('translate')('FIELD.FULL_TEXT_SEARCH_NAME'),
                  state:$stateParams.backState,
                  stateParams:{tabSelect: 'Course', params: $stateParams.params}
                };
              }else{
                var tabSelect = !!$stateParams.params ? $stateParams.params.tabSelect : '';
                vm.goBack={
                  title: $filter('translate')('FIELD.COURSE_FOLDER'),
                  state:$stateParams.backState,
                  stateParams:{cid: vm.catalogId, nid: vm.nodeId, tabSelect: tabSelect, params: $stateParams.params}
                };
              }
            }
          }
        });

        courseResourceService.getCourseReference(courseId, {}).then(function (referenceData) {
          vm.referenceData = referenceData;
        });

        courseResourceService.getCourseEnrollSessions(courseId, params).then(function (enrollSessions) {
          vm.enrollSessions = enrollSessions;
        });




      };



      if(angular.isDefined(courseId)){
        vm.getCourseData();
      }
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseInfo', courseInfo);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailRecommendLessons = {
    bindings: {
      yearAgo: '=?',
      size: '=?',
      itemType: '=?', //course = 1, program = 2
      itemId: '=',  //courseId or programId
      sessionId: '=',
      catalogId: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-recommend-lessons.html',
    controller: [ '$scope', 'courseResourceService', 'SessionObject', function($scope, courseResourceService, SessionObject){

      var vm = this;
      var yearAgo      = angular.isUndefinedOrNull(this.yearAgo)?1:this.yearAgo;
      var size         = angular.isUndefinedOrNull(this.size)?12:this.size;
      vm.itemType      = angular.isUndefinedOrNull(this.itemType)?SessionObject.COURSE:this.itemType;
      vm.itemId        = this.itemId;
      vm.sessionId     = this.sessionId;
      vm.SessionObject = SessionObject;

      vm.catalogId = angular.isDefined(this.catalogId) ? this.catalogId : 0;

      vm.miniGalleryResponsive = [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ];

      $scope.$watch(function(){
        return vm.itemId;
      }, function(){
        if(!angular.isUndefinedOrNull(vm.itemId)) {
          var params = {
            yearAgo: yearAgo,
            size: size,
            itemType: vm.itemType,
            itemId: vm.itemId,
            sessionId: vm.sessionId
          };
          courseResourceService.getRecommendedCourses(params).then(function (recommendCourses) {
            vm.recommendCourses = recommendCourses;
          });
        }
      });
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailRecommendLessons', courseDetailRecommendLessons);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailPrerequisiteItems = {
    bindings: {
      data: '=',
      programType: '=?',
      courseType: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-prerequisite-items.html',
    controller: [function(  ){
      var vm = this;
      vm.programType = angular.isUndefined(this.programType) ? null : this.programType;
      vm.courseType = angular.isUndefined(this.courseType) ? null : this.courseType;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailPrerequisiteItems', courseDetailPrerequisiteItems);
})();

/**
 *  Created by Herry on 2018/04/03
 */
(function () {
  'use strict'
  var courseDetailLearningUliveContent = {
    bindings: {
      uLiveCourseData:"=?",
      courseContentData: '=',
      enrollmentData: '=?',
      courseSessionId:'=?',
      isProgram:'@?',
      reloadFn:'&?',
      sessionData: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-learning-ulive-content.html',
    controller: [ '$scope', '$filter', '$TreeTableConvert', 'CourseObject', '$http', '$window', 'SweetAlert','$interval', 'courseULiveService', function( $scope, $filter, $TreeTableConvert, CourseObject, $http, $window, SweetAlert,$interval,courseULiveService){
      var vm = this;
      vm.uLiveCourseData = angular.isDefined(this.uLiveCourseData) ? this.uLiveCourseData: null;
      vm.courseContentData = angular.isUndefined(this.courseContentData) ? null : this.courseContentData;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.courseSessionId = angular.isUndefined(this.courseSessionId) ? null : this.courseSessionId;
      vm.isProgram = angular.isUndefined(this.isProgram) ? false : this.isProgram;
      vm.reloadFn = angular.isUndefined(this.reloadFn) ? null : this.reloadFn;
      vm.sessionData = angular.isUndefined(this.sessionData) ? null : this.sessionData;
      var params = {};

      vm.uLiveStatus = courseULiveService.getCourseULiveStatus(vm.uLiveCourseData.wState);

      var intervalULive = $interval(function () {
        courseULiveService.getULiveCourseState(vm.enrollmentData.courseId, vm.enrollmentData.sessionId, params).then(function (response) {
          vm.uLiveCourseData = response;
            vm.uLiveStatus = courseULiveService.getCourseULiveStatus(vm.uLiveCourseData.wState);
        });
      }, 10000);

      $scope.$on('$destroy',function(){
        $interval.cancel(intervalULive);
      });


      $scope.$watch(function(){
        if(vm.courseContentData && vm.uLiveStatus)
          return vm.uLiveStatus;
        else if(angular.isDefined(vm.courseContentData)) return vm.courseContentData;
      }, function(newVal, oldVal){

        if(vm.uLiveCourseData.wState === 0 || vm.uLiveCourseData.wState === 3 || vm.uLiveCourseData.wState === 4 || vm.uLiveCourseData.wState === 5)
          $interval.cancel(intervalULive);

        var _courseContentData = [];
        var uliveItemArray = [{
            itemId: 0,
            itemSection: "Reference",
            itemType: "URL",
            isFolderType: 0,
            title: vm.uLiveStatus,
            belongCourseId: 0,
            minTime: 1,
            showLength: "",
            resourceId: 4,
            createDate: "",
            uLiveCourseData: vm.uLiveCourseData
        }];
        var uliveDataObject = {
          // SCODataInfo: SCODataInfo,
          __children__: uliveItemArray,
          itemId: 0,
          itemSection: "Reference",
          itemType: "Folder.reference",
          isFolderType: 1,
          title: "course_folder_live",
          belongCourseId: 0,
          minTime: 0,
          showLength: "",
          resourceId: 0,
          createDate: "",
          uLiveCourseData: vm.uLiveCourseData
        };


        var presurvey = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.presurvey.length > 0) ? ((vm.courseContentData.presurvey[0]['items'].length > 0) ? vm.courseContentData.presurvey : []) : []);
        var pretest = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.pretest.length > 0) ? ((vm.courseContentData.pretest[0]['items'].length > 0) ? vm.courseContentData.pretest : []) : []);
        var content = vm.courseContentData.content;
        var posttest = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.posttest.length > 0) ? ((vm.courseContentData.posttest[0]['items'].length > 0) ? vm.courseContentData.posttest : []) : []);
        var postsurvey = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.postsurvey.length > 0) ? ((vm.courseContentData.postsurvey[0]['items'].length > 0) ? vm.courseContentData.postsurvey : []) : []);
        var reference = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.reference.length > 0) ? ((vm.courseContentData.reference[0]['items'].length > 0) ? vm.courseContentData.reference : []) : []);
        var test = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.test.length > 0) ? ((vm.courseContentData.test[0]['isFolderType']===1) ?
            ((vm.courseContentData.test[0]['items'].length > 0) ? vm.courseContentData.test : []) : vm.courseContentData.test) : []);
        var testClassroom = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.testClassroom.length > 0) ? vm.courseContentData.testClassroom : []);
        var survey = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          ((vm.courseContentData.survey.length > 0) ? ((vm.courseContentData.survey[0]['isFolderType']===1) ?
            ((vm.courseContentData.survey[0]['items'].length > 0) ? vm.courseContentData.survey : []) : vm.courseContentData.survey) : []);
        switch (vm.enrollmentData.courseType){
          default :
            _courseContentData = [presurvey, pretest, content, posttest, postsurvey, reference, test, testClassroom, survey];
            break;
          case CourseObject.COURSETYPE_ONLINE_TEST:
            _courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, reference, testClassroom, survey];
            break;
          case CourseObject.COURSETYPE_SURVEY:
            _courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, testClassroom, survey, reference];
            break;
        }
        vm.courseContent = $TreeTableConvert.arrayTree2tableTree(angular.copy(_courseContentData), 'items');
        vm.courseContent.push(uliveDataObject);

        vm.courseContentTable = {
          courseContentProperty:{
            field: 'title',
            titleClass:  'col-xs-9',
            cellClass:   'col-xs-9',
            displayName: $filter('translate')('FIELD.COURSE_TITLE')
          },
          courseContentColDef:[
            {
              field: 'showLength',
              titleClass:   'col-xs-1',
              cellClass:   'col-xs-1',
              displayName:  $filter('translate')('FIELD.COURSE_TIME')
            },
            {
              field: 'lessonStatus',
              fieldGroup:'SCODataInfo',
              titleClass:   'col-xs-1',
              cellClass:   'col-xs-1 appear',
              displayName:  $filter('translate')('FIELD.STATUS')
            }
          ],
          courseResultProperty:{
            field: 'title',
            titleClass:  'col-xs-7',
            cellClass:   'col-xs-7',
            displayName: $filter('translate')('FIELD.COURSE_TITLE')
          },
          courseResultColDef:[
            {
              field: 'accessDate',
              fieldGroup:'SCODataInfo',
              titleClass:   'col-xs-2',
              cellClass:   'col-xs-2',
              displayName:  $filter('translate')('FIELD.FINISH_TIME')
            },
            {
              field: 'scoreRaw',
              fieldGroup:'SCODataInfo',
              titleClass:   'col-xs-1',
              cellClass:   'col-xs-1 appear',
              displayName:  $filter('translate')('FIELD.SCORE')
            },
            {
              field: 'lessonStatus',
              fieldGroup:'SCODataInfo',
              titleClass:   'col-xs-1',
              cellClass:   'col-xs-1 appear',
              displayName:  $filter('translate')('FIELD.STATUS')
            }
          ]
        };
      });
    }]
  }
  angular.module('eHRD.modules.courseResource')
    .component('courseDetailLearningUliveContent', courseDetailLearningUliveContent);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailLearningResults = {
    bindings: {
      courseContentData: '=?',
      enrollmentData: '=?',
      courseSessionId:'=?',
      isProgram:'@?',
      reloadFn:'&?',
      learningHistoryData: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-learning-results.html',
    controller: ['$scope', '$filter', '$TreeTableConvert', 'CourseObject', function(  $scope, $filter, $TreeTableConvert, CourseObject ){
      var vm = this;
      vm.courseContentData = angular.isUndefined(this.courseContentData) ? null : this.courseContentData;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.courseSessionId = angular.isUndefined(this.courseSessionId) ? null : this.courseSessionId;
      vm.isProgram = angular.isUndefined(this.isProgram) ? false : this.isProgram;
      vm.reloadFn = angular.isUndefined(this.reloadFn) ? null : this.reloadFn;
      vm.learningHistoryData = angular.isUndefined(this.learningHistoryData) ? null : this.learningHistoryData;
      $scope.$watch(function(){
        return vm.courseContentData;
      }, function(newVal, oldVal){
        if(!angular.equals(newVal, oldVal) && angular.isDefined(newVal)){
          var _courseContentData = [];
          var presurvey = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.presurvey.length > 0) ? ((vm.courseContentData.presurvey[0]['items'].length > 0) ? vm.courseContentData.presurvey : []) : []);
          var pretest = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.pretest.length > 0) ? ((vm.courseContentData.pretest[0]['items'].length > 0) ? vm.courseContentData.pretest : []) : []);
          var posttest = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.posttest.length > 0) ? ((vm.courseContentData.posttest[0]['items'].length > 0) ? vm.courseContentData.posttest : []) : []);
          var content = vm.courseContentData.content;
          var postsurvey = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.postsurvey.length > 0) ? ((vm.courseContentData.postsurvey[0]['items'].length > 0) ? vm.courseContentData.postsurvey : []) : []);
          var reference = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.reference.length > 0) ? ((vm.courseContentData.reference[0]['items'].length > 0) ? vm.courseContentData.reference : []) : []);
          var test = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.test.length > 0) ? ((vm.courseContentData.test[0]['isFolderType']===1) ?
              ((vm.courseContentData.test[0]['items'].length > 0) ? vm.courseContentData.test : []) : vm.courseContentData.test) : []);
          var testClassroom = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.testClassroom.length > 0) ? vm.courseContentData.testClassroom : []);
          var survey =
            ((vm.courseContentData.survey.length > 0) ? ((vm.courseContentData.survey[0]['isFolderType']===1) ?
              ((vm.courseContentData.survey[0]['items'].length > 0) ? vm.courseContentData.survey : []) : vm.courseContentData.survey) : []);

          switch (vm.enrollmentData.courseType){
            default :
              _courseContentData = [presurvey, pretest, content, posttest, postsurvey, reference, test, testClassroom, survey];
              break;
            case CourseObject.COURSETYPE_ONLINE_TEST:
              _courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, reference, testClassroom, survey];
              break;
            case CourseObject.COURSETYPE_SURVEY:
              _courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, testClassroom, survey, reference];
              break;
          }

          vm.courseResult = $TreeTableConvert.arrayTree2tableTree(angular.copy(_courseContentData), 'items');

          vm.courseContentTable = {
            courseContentProperty:{
              field: 'title',
              titleClass:  'col-xs-9',
              cellClass:   'col-xs-9',
              displayName: $filter('translate')('FIELD.COURSE_TITLE')
            },
            courseContentColDef:[
              {
                field: 'showLength',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1',
                displayName:  $filter('translate')('FIELD.COURSE_TIME')
              },
              {
                field: 'lessonStatus',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1 appear',
                displayName:  $filter('translate')('FIELD.STATUS')
              }
            ],
            courseResultProperty:{
              field: 'title',
              titleClass:  'col-xs-7',
              cellClass:   'col-xs-7',
              displayName: $filter('translate')('FIELD.COURSE_TITLE')
            },
            courseResultColDef:[
              {
                field: 'totalTime',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1',
                displayName:  $filter('translate')('FIELD.VIEWING_TIME')
              },
              {
                field: 'accessDate',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-2',
                cellClass:   'col-xs-2',
                displayName:  $filter('translate')('FIELD.FINISH_TIME')
              },
              {
                field: 'scoreRaw',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1 appear',
                displayName:  $filter('translate')('FIELD.SCORE')
              },
              {
                field: 'lessonStatus',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1 appear',
                displayName:  $filter('translate')('FIELD.STATUS')
              }
            ]
          };
        }
      });

      $scope.$watch(function(){
        return vm.learningHistoryData;
      }, function(newVal, oldVal){
        if(!angular.equals(newVal, oldVal) && angular.isDefined(newVal)){
          vm.attendanceRecords = newVal.attendanceRecord;
          vm.learningHistoryData = newVal;
        }
      });






    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailLearningResults', courseDetailLearningResults);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailLearningContent = {
    bindings: {
      courseContentData: '=',
      enrollmentData: '=?',
      courseSessionId:'=?',
      isProgram:'@?',
      reloadFn:'&?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-learning-content.html',
    controller: [ '$scope', '$filter', '$TreeTableConvert', 'CourseObject', function( $scope, $filter, $TreeTableConvert, CourseObject ){
      var vm = this;
      vm.courseContentData = angular.isUndefined(this.courseContentData) ? null : this.courseContentData;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.courseSessionId = angular.isUndefined(this.courseSessionId) ? null : this.courseSessionId;
      vm.isProgram = angular.isUndefined(this.isProgram) ? false : this.isProgram;
      vm.reloadFn = angular.isUndefined(this.reloadFn) ? null : this.reloadFn;
      $scope.$watch(function(){
        return vm.courseContentData;
      }, function(newVal, oldVal){
        if(!angular.equals(newVal, oldVal) && angular.isDefined(newVal)){
          var _courseContentData = [];
          var presurvey = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.presurvey.length > 0) ? ((vm.courseContentData.presurvey[0]['items'].length > 0) ? vm.courseContentData.presurvey : []) : []);
          var pretest = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.pretest.length > 0) ? ((vm.courseContentData.pretest[0]['items'].length > 0) ? vm.courseContentData.pretest : []) : []);
          var content = vm.courseContentData.content;
          var posttest = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.posttest.length > 0) ? ((vm.courseContentData.posttest[0]['items'].length > 0) ? vm.courseContentData.posttest : []) : []);
          var postsurvey = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.postsurvey.length > 0) ? ((vm.courseContentData.postsurvey[0]['items'].length > 0) ? vm.courseContentData.postsurvey : []) : []);
          var reference = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.reference.length > 0) ? ((vm.courseContentData.reference[0]['items'].length > 0) ? vm.courseContentData.reference : []) : []);
          var test = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
            ((vm.courseContentData.test.length > 0) ? ((vm.courseContentData.test[0]['isFolderType']===1) ?
              ((vm.courseContentData.test[0]['items'].length > 0) ? vm.courseContentData.test : []) : vm.courseContentData.test) : []);
          // var testClassroom = (vm.enrollmentData.courseType === CourseObject.COURSETYPE_EXTERNAL) ? [] :
          //   ((vm.courseContentData.testClassroom.length > 0) ? vm.courseContentData.testClassroom : []);
          var survey = 
            ((vm.courseContentData.survey.length > 0) ? ((vm.courseContentData.survey[0]['isFolderType']===1) ?
              ((vm.courseContentData.survey[0]['items'].length > 0) ? vm.courseContentData.survey : []) : vm.courseContentData.survey) : []);

          switch (vm.enrollmentData.courseType){
            default :
              //_courseContentData = [presurvey, pretest, content, posttest, postsurvey, reference, test, testClassroom, survey];
              _courseContentData = [presurvey, pretest, content, posttest, postsurvey, reference, test, survey];
              break;
            case CourseObject.COURSETYPE_ONLINE_TEST:
              //_courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, reference, testClassroom, survey];
              _courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, reference, survey];
              break;
            case CourseObject.COURSETYPE_SURVEY:
              //_courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, testClassroom, survey, reference];
              _courseContentData = [presurvey, pretest, content, posttest, postsurvey, test, survey, reference];
              break;
          }

          vm.courseContent = $TreeTableConvert.arrayTree2tableTree(angular.copy(_courseContentData), 'items');

          vm.courseContentTable = {
            courseContentProperty:{
              field: 'title',
              titleClass:  'col-xs-9',
              cellClass:   'col-xs-9',
              displayName: $filter('translate')('FIELD.COURSE_TITLE')
            },
            courseContentColDef:[
              {
                field: 'showLength',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1',
                displayName:  $filter('translate')('FIELD.COURSE_TIME')
              },
              {
                field: 'lessonStatus',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1 appear',
                displayName:  $filter('translate')('FIELD.STATUS')
              }
            ],
            courseResultProperty:{
              field: 'title',
              titleClass:  'col-xs-7',
              cellClass:   'col-xs-7',
              displayName: $filter('translate')('FIELD.COURSE_TITLE')
            },
            courseResultColDef:[
              {
                field: 'accessDate',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-2',
                cellClass:   'col-xs-2',
                displayName:  $filter('translate')('FIELD.FINISH_TIME')
              },
              {
                field: 'scoreRaw',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1 appear',
                displayName:  $filter('translate')('FIELD.SCORE')
              },
              {
                field: 'lessonStatus',
                fieldGroup:'SCODataInfo',
                titleClass:   'col-xs-1',
                cellClass:   'col-xs-1 appear',
                displayName:  $filter('translate')('FIELD.STATUS')
              }
            ]
          };
        }
      });


    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailLearningContent', courseDetailLearningContent);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailInfo = {
    bindings: {
      data: '=',
      referenceData: '=?' // Non-external courses
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-info.html',
    controller: [function(){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? null : this.data;
      vm.referenceData = angular.isUndefinedOrNull(this.referenceData) ? [] : this.referenceData;

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailInfo', courseDetailInfo);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailHeader = {
    bindings: {
      data: '=',
      enrollmentData: '=?',
      isProgram: '@?',
      goBack:'=?',
      reloadFn:'&?',
      isUser: '=?'  //mail link use
    },
    templateUrl:'app/modules/course-resource/views/course-session-info-template/course-detail-header.html',
    controller: ['$scope', 'ngDialog', 'PermPermissionStore', function( $scope, ngDialog, PermPermissionStore ){
      var vm = this;
      var permission = null;
      permission = PermPermissionStore.getPermissionDefinition('Modules.course.classroom');
      vm.hasCourseClassroomPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.approval');
      vm.hasApprovalPermission = angular.isDefined(permission);

      vm.data = angular.isUndefined(this.data) ? null : this.data;
      vm.isProgram = angular.isUndefined(this.isProgram) ? false : this.isProgram;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.goBack = angular.isUndefined(this.goBack) ? null : this.goBack;
      vm.reloadFn = angular.isUndefined(this.reloadFn) ? null : this.reloadFn;
      vm.isUser   = angular.isUndefined(this.isUser) ? null: this.isUser;
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailHeader', courseDetailHeader);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailEnrollment = {
    bindings: {
      data: '=',
      sessionData: '=',
      enrollmentData: '=',
      isProgram: '@?',
      reloadFn:'&?',
      uLiveCourseData: '=?',
      isULive: '=?'
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-enrollment.html',
    controller: ['$scope',function($scope){
      var vm = this;
      vm.passRuleSwitch = 0;
      vm.data = angular.isUndefined(this.data) ? null : this.data;
      vm.sessionData = angular.isUndefined(this.sessionData) ? null : this.sessionData;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.isProgram = angular.isUndefined(this.isProgram) ? null : this.isProgram;
      vm.reloadFn = angular.isUndefined(this.reloadFn) ? null : this.reloadFn;
      vm.uLiveCourseData = angular.isUndefined(this.uLiveCourseData) ? null : this.uLiveCourseData;
      vm.isULive = angular.isUndefined(this.isULive) ? 0 : this.isULive;


      $scope.$watch(function(){
        return vm.isULive;
      }, function(newVal){
        vm.isULive = newVal;
      });
      $scope.$watch(function(){
        return vm.enrollmentData;
      }, function(newVal){
        vm.enrollmentData = newVal;
      });
      $scope.$watch(function(){
        return vm.uLiveCourseData;
      }, function(newVal){
        vm.uLiveCourseData = newVal;
      });
    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailEnrollment', courseDetailEnrollment);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var courseDetailEnrollmentLearningReport = {
    bindings: {
      enrollmentData: '=',
      sessionData: '='
    },
    templateUrl: 'app/modules/course-resource/views/course-session-info-template/course-detail-enrollment-learning-report.html',
    controller: ['$scope', '$filter', 'SweetAlert', 'fileProcessService', 'CourseObject', function( $scope, $filter, SweetAlert, fileProcessService, CourseObject ){
      var vm = this;
      vm.CourseObject = CourseObject;
      vm.enrollmentData = angular.isUndefined(this.enrollmentData) ? null : this.enrollmentData;
      vm.sessionData    = angular.isUndefined(this.sessionData) ? null : this.sessionData;
      var formData = [
        {'isCourse': 1},
        {'packageId':vm.enrollmentData.enrollmentId},
        {'enrollmentId': vm.enrollmentData.enrollmentId}
      ];
      var uploader = $scope.uploader = fileProcessService.learningReportUpload(vm.enrollmentData.enrollmentId, formData);

      uploader.onErrorItem = function(/*fileItem, response, status, headers*/) {

      };
      uploader.onCompleteAll = function () {
        vm.learningReportUploadAction('confirm-temp', 1);
      };

      vm.applyOtherReportApproval = function (itemType) {
        fileProcessService.applyOtherReportApproval(vm.enrollmentData.enrollmentId, itemType, {}).then(function () {
          vm.getLearningReportList();
        });
      };

      vm.getLearningReportList = function () {
        fileProcessService.getLearningReportStatus(vm.enrollmentData.enrollmentId, {}).then(function (LearningReportStatus) {
          vm.learningReportStatus = LearningReportStatus;
        });
        fileProcessService.getLearningReportList(vm.enrollmentData.enrollmentId, {}).then(function (LearningReportDatas) {
          vm.learningReportData = LearningReportDatas;
          vm.learningReportData.paid = 0;
          vm.learningReportFileReplace = {};
          angular.forEach(LearningReportDatas, function (data) {
            if(data.appState === 1){
              vm.learningReportData.paid += 1;

              var formData = [
                {'isCourse': 1},
                {'packageId':vm.enrollmentData.enrollmentId},
                {'enrollmentId': vm.enrollmentData.enrollmentId},
                {'reportId': data.learningReportId},
                {'op': 'replace'}
              ];
              vm.learningReportFileReplace[data.learningReportId] = fileProcessService.learningReportUpload(vm.enrollmentData.enrollmentId, formData, true);

              vm.learningReportFileReplace[data.learningReportId].onCompleteAll = function () {
                vm.getLearningReportList();
              };
            }
          });
        });
      };

      vm.getLearningReportList();

      vm.learningReportUploadAction = function (actionType, isCourse, reportId) {
        var fileParams = {};
        fileParams.iscourse = (angular.isDefined(isCourse) ? isCourse : 0);
        fileParams.reportid = (angular.isDefined(reportId) ? reportId : 0);

        switch(actionType){
          case 'cancelrow':

            var text = $filter('translate')('MESSAGE.MSG_THIS_ACTION_WILL_RELEVANT_STUDY_REPORT') + '，'
              + $filter('translate')('MESSAGE.MSG_IS_CONTINUE');

            SweetAlert.check('', text, 'warning', function() {
              _learningReportUploadAction();
            });

            break;
          default:
            _learningReportUploadAction();
            break;

        }
        function _learningReportUploadAction(){
          fileProcessService.learningReportUploadAction(vm.enrollmentData.enrollmentId, actionType, fileParams).then(function () {
            vm.getLearningReportList();
          });
        }
      };

    }]
  };

  angular.module('eHRD.modules.courseResource')
    .component('courseDetailEnrollmentLearningReport', courseDetailEnrollmentLearningReport);
})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  angular
    .module('eHRD.modules.certZone',[]);

})();

/**
 * Created by Alan on 2017/3/14.
 */
(function () {
  'use strict';

  certZoneService.$inject = ['serverSetting', 'Restangular', 'fileProcess'];
  function certZoneService(serverSetting, Restangular, fileProcess) {
    var _ExtCertService = Restangular.all('extcert');
    var _InnerCertService = Restangular.all('innercert');

    return {

      getExtCertTestCompensateSearch: function (params) {
        params = params || {};
        /*
         * api/extcert/user/compensate-search?current_page={current_page}&list_size={list_size}
         * */
        return _ExtCertService
          .one('user', null)
          .customGETLIST('compensate-search', params);
      },
      getExtCertBonusSearch: function (params) {
        params = params || {};
        /*
         * api/extcert/user/bonus-search?current_page={current_page}&list_size={list_size}
         * */
        return _ExtCertService
          .one('user', null)
          .customGETLIST('bonus-search', params);
      },
      getExtCertApplyForm: function (formType, params) {
        params = params || {};
        /*
         * formType = 1: api/extcert/test-form-info?formId={formId}
         * formType = 2: api/extcert/register-form-info?formId={formId}
         * formType = 3: api/extcert/compensation-form-info?formId={formId}
         * formType = 4: api/extcert/bonus-form-info?formId={formId}
         * */
        var resource = undefined;
        switch (formType){
          case 1:
            resource = 'test-form-info';
            break;
          case 2:
            resource = 'register-form-info';
            break;
          case 3:
            resource = 'compensation-form-info';
            break;
          case 4:
            resource = 'bonus-form-info';
            break;
        }
        return _ExtCertService
              .customGET(resource, params);
      },

      getExtCertApplyRecordSearch: function (params) {
        /*
         * api/extcert/user/apply-record-search
         * */
        return _ExtCertService
          .one('user', null)
          .customGETLIST('apply-record-search', params);
      },

      getMemberCertRecords: function (isExtCert, params) {
        isExtCert = isExtCert || false;
        /*
         * api/innercert/manager/record-search
         * api/extcert/manager/record-search
         * */
        if(isExtCert){
          return _ExtCertService
            .one('manager', null)
            .customGETLIST('record-search', params);
        }else {
          return _InnerCertService
            .one('manager', null)
            .customGETLIST('record-search', params);
        }
      },

      getCertRecords: function (isExtCert, params) {
        isExtCert = isExtCert || false;
        /*
        * api/innercert/user/record-search
        * api/extcert/user/record-search
         * */
        if(isExtCert){
          return _ExtCertService
            .one('user', null)
            .customGETLIST('record-search', params);
        }else {
          return _InnerCertService
            .one('user', null)
            .customGETLIST('record-search', params);
        }
      },

      certificateForm: function (params, formData, fileFieldName, files, formType) {
        /*
        * api/extcert/apply-register?subjectId={subjectId}&isReNew={isReNew}&passCheckApplyForm={passCheckApplyForm}
        * api/extcert/apply-test?subjectId={subjectId}&isReNew={isReNew}&passCheckApplyForm={passCheckApplyForm}
        *
        * apply-compensation: api/extcert/apply-compensation?rootFormId={rootFormId}
         * */
        var url = serverSetting.baseConfig.baseApiPath;
        switch (formType){
          case 'register':
            url += '/extcert/apply-register?subjectId=' + params.subjectId + "&isReNew=" + params.isReNew + "&passCheckApplyForm=" + params.passCheckApplyForm;
            break;
          case 'test':
            url += '/extcert/apply-test?subjectId=' + params.subjectId + "&isReNew=" + params.isReNew + "&passCheckApplyForm=" + params.passCheckApplyForm;
            break;
          case 'apply-compensation':
            url += '/extcert/apply-compensation?rootFormId=' + params.rootFormId;
            break;
          case 'apply-test-bonus':
            url += '/extcert/apply-test-bonus?rootFormId=' + params.rootFormId;
            break;
          case 'apply-register-bonus':
            url += '/extcert/apply-register-bonus?rootFormId=' + params.rootFormId;
            break;
          case 'update-test-bonus':
            url += '/extcert/update-test-bonus?formId=' + params.formId;
            break;
          case 'update-register-bonus':
            url += '/extcert/update-register-bonus?formId=' + params.formId;
            break;
          case 'update-compensation':
            url += '/extcert/update-compensation?formId=' + params.formId;
            break;
          case 'update-test':
            url += '/extcert/update-test?formId=' + params.formId;
            break;
          case 'update-register':
            url += '/extcert/update-register?formId=' + params.formId;
            break;
        }
        return new fileProcess.upload(url, formData, fileFieldName, files , 'POST');
      },

      getExtCertInfo: function (params) {
        /*
         * api/extcert/info?subjectId={subjectId}
         * */
        return _ExtCertService
          .customGET('info', params);
      },

      parseTestTimes: function (testTimes, dateFormat) {
        dateFormat = dateFormat || 'YYYY/MM/DD';
        testTimes = testTimes || [];
        var _testTimes = '';
        angular.forEach(testTimes, function (val) {
          _testTimes += moment(val).format(dateFormat) + ' 0:0-0:0,';
        });
        return _testTimes;
      }

    };

  }

  angular.module('eHRD.modules.certZone')
    .factory('certZoneService', certZoneService);
})();

/**
 * Created by Alan on 2017/3/24.
 */

(function () {
  'use strict';

  externalCertDetailInfoDialog.$inject = ['$mdDialog', 'SweetAlert', '$filter', 'NgTableParams'];
  function externalCertDetailInfoDialog($mdDialog, SweetAlert, $filter, NgTableParams) {
    var directive = {
      restrict: 'A',
      scope: {
        subjectId: '=?',
        isPublished: '=?',
        canView: '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          if(scope.isPublished===0)
            SweetAlert.warning('', $filter('translate')('MESSAGE.MSG_ERROR_NOT_PUBLISH'));
          else if(scope.canView===0)
            SweetAlert.warning('', $filter('translate')('MESSAGE.MSG_YOU_DO_NOT_HAVE_PERMISSION_TO_VIEW_THIS_LEARNING_ACTIVITY'));
          else {
            $mdDialog.show({
              templateUrl: 'app/modules/cert-zone/views/external-cert-detail-info-dialog.html',
              controller: ['certZoneService', '$mdDialog', 'subjectId',
                function (certZoneService, $mdDialog, subjectId) {
                  var vm = this;
                  var params = {
                    subjectId: subjectId
                  };

                  certZoneService.getExtCertInfo(params).then(function (extCertInfo) {
                    vm.extCertInfo = extCertInfo;
                    vm.prerequisiteItem = extCertInfo.prerequisiteItem;
                    vm.newApplyRuleItem = new NgTableParams({}, {
                        counts: [],
                        getData: function() {
                            return extCertInfo.newApplyRuleItem;
                        }
                    });
                    vm.renewApplyRuleItem = new NgTableParams({}, {
                        counts: [],
                        getData: function() {
                            return extCertInfo.renewApplyRuleItem;
                        }
                    });
                  });

                  vm.close = function() {
                    $mdDialog.cancel();
                  };

                }],
              controllerAs: '$ctrl',
              targetEvent: ev,
              clickOutsideToClose:true,
              locals : {
                subjectId: scope.subjectId
              },
              fullscreen: true // Only for -xs, -sm breakpoints.
            });
          }
        });

      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('externalCertDetailInfoDialog', externalCertDetailInfoDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormViewDialog.$inject = ['$document', '$mdDialog'];
  function extCertApplyFormViewDialog($document, $mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            template:
            '<md-dialog aria-label="{{ \'EXTERNAL_TRAINING_APPLY_FORM\' | translate}}" flex="80">' +
            '<md-toolbar>' +
            '<div class="md-toolbar-tools">' +
            '<h2 ng-if="$ctrl.formType === 1">{{ \'EXTERNAL_CERT_EXAM_APPLICATION\' | translate}}</h2>' +
            '<h2 ng-if="$ctrl.formType === 2">{{ \'EXTERNAL_CERT_REGISTER\' | translate}}</h2>' +
            '<h2 ng-if="$ctrl.formType === 3">{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}</h2>' +
            '<h2 ng-if="$ctrl.formType === 4">{{ \'EXTERNAL_CERT_QUALIFY_REWARD_APPLICATION\' | translate}}</h2>' +
            '<span flex></span>' +
            '<md-button class="md-icon-button" ng-click="$ctrl.close()">' +
            '<md-tooltip md-direction="bottom">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip>' +
            '<md-icon md-font-set="md" aria-label="{{ \'ACTIONS.CLOSE\' | translate}}">close</md-icon>' +
            '</md-button>' +
            '</div>' +
            '</md-toolbar>' +
            '<md-dialog-content>' +
            '<md-content class="md-padding">' +
            '<ext-cert-apply-form-test-view data="$ctrl.formData" ng-if="$ctrl.formType === 1"></ext-cert-apply-form-test-view>' +
            '<ext-cert-apply-form-reg-view data="$ctrl.formData" ng-if="$ctrl.formType === 2"></ext-cert-apply-form-reg-view>' +
            '<cert-applyform-compensation-view data="$ctrl.formData" ng-if="$ctrl.formType === 3"></cert-applyform-compensation-view>' +
            '<ext-cert-apply-form-bonus-view data="$ctrl.formData" ng-if="$ctrl.formType === 4"></ext-cert-apply-form-bonus-view>' +
            '</md-content>' +
            '</md-dialog-content>' +
            '</md-dialog>',
            controller: [ 'userService', 'certZoneService', 'formType', 'formId', function (userService, certZoneService, formType, formId) {
              var vm = this;
              vm.formType = angular.isDefined(formType) ? formType : undefined;
              vm.formId = angular.isDefined(formId) ? formId : undefined;

              if(angular.isDefined(vm.formType) && angular.isDefined(vm.formId)){
                certZoneService.getExtCertApplyForm(vm.formType, {formId: vm.formId}).then(function (formData) {
                  vm.formData = formData;
                });
              }

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formType: scope.formType,
              formId: scope.formId,
              formData: scope.formData
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormViewDialog', extCertApplyFormViewDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormTestEditDialog.$inject = ['$document', '$mdDialog', 'fileProcess'];
  function extCertApplyFormTestEditDialog($document, $mdDialog, fileProcess) {
    var directive = {
      restrict: 'A',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?',
        reloadFn: '&?reloadFn'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            templateUrl: 'app/modules/cert-zone/views/apply-form/test-edit-dialog.html',
            controller: [ '$filter', 'SweetAlert', 'CoreService', 'userService', 'certZoneService', 'formId', function ($filter, SweetAlert, CoreService, userService, certZoneService, formId) {
              var vm = this;
              vm.form = {};
              vm.currencys = undefined;
              vm.formId = angular.isDefined(formId) ? formId : undefined;
              vm.formType = 1;
              if(angular.isDefined(vm.formType) && angular.isDefined(vm.formId)){
                certZoneService.getExtCertApplyForm(vm.formType, {formId: vm.formId}).then(function (data) {
                  vm.data = data;

                  vm.form['testFeeCurrency'] = vm.data.testFeeCurrency;
                  vm.form['testFeeAmount'] = vm.data.testFeeAmount;
                  vm.form['testFee'] = vm.data.testFee;

                  if( angular.isDefined(vm.data.userId)) {
                    userService.getUserProfileDetailById(vm.data.userId).then(function (applicantInfo) {
                      vm.applicantInfo = applicantInfo;
                    });
                  }

                });
              }

              vm.calculateTestFee = function () {
                if(angular.isDefined(vm.data)){
                  if( angular.isDefined(vm.form.testFeeCurrency) && angular.isDefined(vm.currencys)){
                    var currency = $filter('where')(vm.currencys, { value: vm.form.testFeeCurrency});
                    if( currency.length > 0 ){
                      vm.form.testFee = (parseInt(vm.form.testFeeAmount) * currency[0].operation);
                      vm.form.testFee = $filter('number')(vm.form.testFee, 2);
                    }
                  }
                }
              };

              vm.submitApplyForm = function ($formValid) {

                function preConfirm() {
                  return new Promise(function (resolve) {
                    vm.form['testTimes'] = certZoneService.parseTestTimes( vm.data.testTimes );
                    vm.form['testFee'] = $filter('replaceAll')(vm.form['testFee'], ',', '');
                    angular.forEach(vm.refFiles, function (ref, key) {
                      if(ref==='') {
                        vm.form['del_' + (parseInt(key)+1)] =  1;
                      }
                    });
                    var uploaderForm = certZoneService.certificateForm({formId: vm.formId}, vm.form, 'ref_', vm.refFiles, 'update-test');
                    uploaderForm.then(function(resp) {
                      var res = resp.data;
                      switch (res.data.status){
                        default:
                          SweetAlert.insertSuccessQueueStep('', $filter('translate')('MESSAGE.MSG_THE_APPLICATION_FORM_WAS_UPDATED_SUCCESSFULLY'), false, $mdDialog.hide());
                          break;
                      }
                      resolve();
                    }, function () {
                      CoreService.refreshAccesstoken();
                    });
                  });
                }
                if($formValid){
                  if(fileProcess.checkUploadType(vm.refFiles) && fileProcess.checkUploadSize(vm.refFiles)) {
                    SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                  }
                }else{
                  SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
                }
              };

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formType: scope.formType,
              formId: scope.formId,
              formData: scope.formData
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function () {
            if (angular.isFunction(scope.reloadFn)) scope.reloadFn();
          }, function() {});
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormTestEditDialog', extCertApplyFormTestEditDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormRegisterEditDialog.$inject = ['$document', '$mdDialog', 'fileProcess'];
  function extCertApplyFormRegisterEditDialog($document, $mdDialog, fileProcess) {
    var directive = {
      restrict: 'A',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?',
        reloadFn: '&?reloadFn'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            templateUrl: 'app/modules/cert-zone/views/apply-form/register-edit-dialog.html',
            controller: [ '$filter', 'SweetAlert', 'CoreService', 'userService', 'certZoneService', 'formId', function ($filter, SweetAlert, CoreService, userService, certZoneService, formId) {
              var vm = this;
              vm.form = {};
              vm.currencys = undefined;
              vm.formId = angular.isDefined(formId) ? formId : undefined;
              vm.formType = 2;
              if(angular.isDefined(vm.formType) && angular.isDefined(vm.formId)){
                certZoneService.getExtCertApplyForm(vm.formType, {formId: vm.formId}).then(function (data) {
                  vm.data = data;


                  vm.form['acquireDate'] = (angular.isDefined(vm.data.acquireDate) && vm.data.acquireDate !== '') ? moment(vm.data.acquireDate).toDate() : undefined;
                  vm.form['expireDate'] = (angular.isDefined(vm.data.expireDate) && vm.data.expireDate !== '') ? moment(vm.data.expireDate).toDate() : undefined;
                  vm.form['isForever'] = angular.isDefined(vm.data.isForever) ? vm.data.isForever : 0;

                  vm.form['licenseId'] = vm.data.licenseId;
                  vm.form['comment'] = vm.data.comment;


                  if( angular.isDefined(vm.data.userId)) {
                    userService.getUserProfileDetailById(vm.data.userId).then(function (applicantInfo) {
                      vm.applicantInfo = applicantInfo;
                    });
                  }

                });
              }

              vm.submitApplyForm = function ($formValid) {

                function preConfirm() {
                  return new Promise(function (resolve) {
                    var formData = {};
                    formData['licenseId'] =  vm.form.licenseId;
                    formData['acquireDate'] =  (angular.isDefined(vm.form.acquireDate) && vm.form.acquireDate !== '') ? moment(vm.form.acquireDate).format('YYYY/MM/DD') : '';
                    formData['expireDate'] =  (angular.isDefined(vm.form.expireDate) && vm.form.expireDate !== '') ?  moment(vm.form.expireDate).format('YYYY/MM/DD') : '';
                    formData['isForever'] =  vm.form.isForever;
                    formData['comment'] =  vm.form.comment;
                    angular.forEach(vm.refFiles, function (ref, key) {
                      if(ref==='') {
                        formData['del_' + (parseInt(key)+1)] =  1;
                      }
                    });
                    var uploaderForm = certZoneService.certificateForm({formId: vm.formId}, formData, 'ref_', vm.refFiles, 'update-register');
                    uploaderForm.then(function(resp) {
                      var res = resp.data;
                      switch (res.data.status){
                        default:
                          SweetAlert.insertSuccessQueueStep('', $filter('translate')('MESSAGE.MSG_THE_APPLICATION_FORM_WAS_UPDATED_SUCCESSFULLY'), false, $mdDialog.hide());
                          break;
                      }
                      resolve();
                    }, function () {
                      CoreService.refreshAccesstoken();
                    });
                  });
                }
                if($formValid){
                  if(fileProcess.checkUploadType(vm.refFiles) && fileProcess.checkUploadSize(vm.refFiles)) {
                    SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                  }
                }else{
                  SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
                }
              };

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formType: scope.formType,
              formId: scope.formId,
              formData: scope.formData
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function () {
            if (angular.isFunction(scope.reloadFn)) scope.reloadFn();
          }, function() {});
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormRegisterEditDialog', extCertApplyFormRegisterEditDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormDialog.$inject = ['$document', '$mdDialog', '$compile'];
  function extCertApplyFormDialog($document, $mdDialog, $compile) {
    var directive = {
      restrict: 'EA',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?',
        reloadFn: '&?reloadFn'
      },
      link: function (scope,element/*, attrs*/) {
        scope.$watch(function () {
          return scope.formType;
        },function (newVal) {
          if(angular.isDefined(newVal)){
            switch(newVal){
              case 1:
                element.html("<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-test-edit-dialog form-id='formId' reload-fn='reloadFn()'>{{ 'ACTIONS.FORM_EDIT' | translate}}</a>");
                break;
              case 2:
                element.html("<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-register-edit-dialog form-id='formId' reload-fn='reloadFn()'>{{ 'ACTIONS.FORM_EDIT' | translate}}</a>");
                break;
              case 3:
                element.html("<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-compensation-edit-dialog form-id='formId' reload-fn='reloadFn()'>{{ 'ACTIONS.FORM_EDIT' | translate}}</a>");
                break;
              case 4:
                element.html("<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-bonus-edit-dialog form-id='formId' reload-fn='reloadFn()'>{{ 'ACTIONS.FORM_EDIT' | translate}}</a>");
                break;
            }
          }
          $compile(element.contents())(scope);
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormDialog', extCertApplyFormDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormCompensationEditDialog.$inject = ['$document', '$mdDialog', 'fileProcess'];
  function extCertApplyFormCompensationEditDialog($document, $mdDialog, fileProcess) {
    var directive = {
      restrict: 'A',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?',
        reloadFn: '&?reloadFn'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            templateUrl: 'app/modules/cert-zone/views/apply-form/compensation-edit-dialog.html',
            controller: [ '$filter', 'SweetAlert', 'CoreService', 'userService', 'certZoneService', 'formId', function ($filter, SweetAlert, CoreService, userService, certZoneService, formId) {
              var vm = this;
              vm.form = {
                compFee: ''
              };
              vm.currencys = undefined;
              vm.formId = angular.isDefined(formId) ? formId : undefined;
              vm.formType = 3;
              if(angular.isDefined(vm.formType) && angular.isDefined(vm.formId)){
                certZoneService.getExtCertApplyForm(vm.formType, {formId: vm.formId}).then(function (data) {
                  vm.data = data;
                  if(data.registerFormInfo !== null) vm.data.formData = data.registerFormInfo;
                  if(data.testFormInfo !== null) vm.data.formData = data.testFormInfo;

                  vm.form['compFeeCurrency'] = vm.data.compFeeCurrency;
                  vm.form['compFeeAmount'] = vm.data.compFeeAmount;
                  vm.form['compFee'] = vm.data.compFee;
                  vm.form['realCompFee'] = vm.data.realCompFee;

                  if( angular.isDefined(vm.data.formData.userId)) {
                    userService.getUserProfileDetailById(vm.data.formData.userId).then(function (applicantInfo) {
                      vm.applicantInfo = applicantInfo;
                    });
                  }

                });
              }

              vm.calculateCompFee = function () {
                if(angular.isDefined(vm.data)){
                  if( angular.isDefined(vm.form.compFeeCurrency) && angular.isDefined(vm.currencys)){
                    var currency = $filter('where')(vm.currencys, { value: vm.form.compFeeCurrency});
                    if( currency.length > 0 ){
                      var cardinalNumber = 1;
                      if( angular.isDefined(currency[0].operation.split(".")[1])){
                        cardinalNumber = Math.pow(10, currency[0].operation.split(".")[1].toString().length);
                      }
                      vm.form.compFee = ((parseFloat(vm.form.compFeeAmount) * parseFloat(currency[0].operation * cardinalNumber)) / cardinalNumber);
                    }
                  }

                  if(vm.data.compRatio === -1){
                    if(vm.form.compFee >= 0){
                      if (vm.form.compFee < vm.data.compensationCost) {
                        vm.form.realCompFee = vm.form.compFee;
                        vm.form.realCompFee = $filter('number')(vm.form.realCompFee, 2);
                      }else {
                        vm.form.realCompFee = vm.data.compensationCost;
                        vm.form.realCompFee = $filter('number')(vm.form.realCompFee, 2);
                      }
                    }
                  } else{
                    var cardinalNumber2 = Math.pow(10, vm.form.compFee.toString().length);
                    vm.form.realCompFee = (parseFloat(vm.form.compFee * cardinalNumber2) * (parseFloat(vm.data.compRatio) / 100) / cardinalNumber2);
                    vm.form.realCompFee = $filter('number')(vm.form.realCompFee, 2);
                  }
                  vm.form.compFee = $filter('number')(vm.form.compFee, 2);
                }
              };

              vm.submitApplyForm = function ($formValid) {

                function preConfirm() {
                  return new Promise(function (resolve) {
                    angular.forEach(vm.refFiles, function (ref, key) {
                      if(ref==='') {
                        vm.form['del_' + (parseInt(key)+1)] =  1;
                      }
                    });
                    vm.form.realCompFee = $filter('replaceAll')(vm.form.realCompFee, ',', '');
                    vm.form.compFee = $filter('replaceAll')(vm.form.compFee, ',', '');
                    var uploaderForm = certZoneService.certificateForm({formId: vm.formId}, vm.form, 'ref_', vm.refFiles, 'update-compensation');
                    uploaderForm.then(function(resp) {
                      var res = resp.data;
                      switch (res.data.status){
                        default:
                          SweetAlert.insertSuccessQueueStep('', $filter('translate')('MESSAGE.MSG_THE_APPLICATION_FORM_WAS_UPDATED_SUCCESSFULLY'), false, $mdDialog.hide());
                          break;
                      }
                      resolve();
                    }, function () {
                      CoreService.refreshAccesstoken();
                    });
                  });
                }
                if($formValid){
                  if(fileProcess.checkUploadType(vm.refFiles) && fileProcess.checkUploadSize(vm.refFiles)) {
                    SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                  }
                }else{
                  SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
                }
              };

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formType: scope.formType,
              formId: scope.formId,
              formData: scope.formData
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function () {
            if (angular.isFunction(scope.reloadFn)) scope.reloadFn();
          }, function() {});
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormCompensationEditDialog', extCertApplyFormCompensationEditDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormCompensationDialog.$inject = ['$document', '$mdDialog', 'fileProcess'];
  function extCertApplyFormCompensationDialog($document, $mdDialog, fileProcess) {
    var directive = {
      restrict: 'A',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?',
        reloadFn: '&?reloadFn'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            templateUrl: 'app/modules/cert-zone/views/apply-form/compensation-dialog.html',
            controller: [ '$filter', 'SweetAlert', 'CoreService', 'userService', 'certZoneService', 'formId', 'formType', function ($filter, SweetAlert, CoreService, userService, certZoneService, formId, formType) {
              var vm = this;
              vm.form = {};
              vm.currencys = undefined;
              vm.formId = angular.isDefined(formId) ? formId : undefined;
              vm.formType = angular.isDefined(formType) ? formType : undefined;
              if(angular.isDefined(vm.formType) && angular.isDefined(vm.formId)){
                certZoneService.getExtCertApplyForm(vm.formType, {formId: vm.formId}).then(function (formData) {
                  vm.formData = formData;
                });
              }

              vm.calculateCompFee = function () {
                if(angular.isDefined(vm.formData)){
                  if( angular.isDefined(vm.form.compFeeCurrency) && angular.isDefined(vm.currencys)){
                    var currency = $filter('where')(vm.currencys, { value: vm.form.compFeeCurrency});
                    if( currency.length > 0 ){
                      var cardinalNumber = 1;
                      if( angular.isDefined(currency[0].operation.split(".")[1])){
                        cardinalNumber = Math.pow(10, currency[0].operation.split(".")[1].toString().length);
                      }

                      vm.form.compFee = ((parseFloat(vm.form.compFeeAmount) * parseFloat(currency[0].operation * cardinalNumber)) / cardinalNumber);
                    }
                  }
                  if(vm.formData.compRatio === -1){
                    if(vm.form.compFee >= 0){
                      if (vm.form.compFee < vm.formData.compensationCost) {
                        vm.form.realCompFee = vm.form.compFee;
                        vm.form.realCompFee = $filter('number')(vm.form.realCompFee, 2);
                      }else {
                        vm.form.realCompFee = vm.formData.compensationCost;
                        vm.form.realCompFee = $filter('number')(vm.form.realCompFee, 2);
                      }
                    }
                  } else{
                    var cardinalNumber2 = Math.pow(10, vm.form.compFee.toString().length);
                    vm.form.realCompFee = (parseFloat(vm.form.compFee * cardinalNumber2) * (parseFloat(vm.formData.compRatio) / 100) / cardinalNumber2);
                    vm.form.realCompFee = $filter('number')(vm.form.realCompFee, 2);
                  }
                  vm.form.compFee = $filter('number')(vm.form.compFee, 2);
                }
              };

              vm.submitApplyForm = function ($formValid) {

                function preConfirm() {
                  return new Promise(function (resolve) {
                    vm.form.compFee = $filter('replaceAll')(vm.form.compFee, ',', '');
                    vm.form.realCompFee = $filter('replaceAll')(vm.form.realCompFee, ',', '');
                    var uploaderForm = certZoneService.certificateForm({rootFormId: vm.formId}, vm.form, 'ref_', vm.refFiles, 'apply-compensation');
                    uploaderForm.then(function(resp) {
                      var res = resp.data;
                      switch (res.data.status){
                        default:
                          SweetAlert.insertSuccessQueueStep('',res.data.message, false, $mdDialog.hide());
                          break;
                      }
                      resolve();
                    }, function () {
                      CoreService.refreshAccesstoken();
                    });
                  });
                }
                if($formValid){
                  if(fileProcess.checkUploadType(vm.refFiles) && fileProcess.checkUploadSize(vm.refFiles)) {
                    SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                  }
                }else{
                  SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
                }
              };

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formType: scope.formType,
              formId: scope.formId,
              formData: scope.formData
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function () {
            if (angular.isFunction(scope.reloadFn)) scope.reloadFn();
          }, function() {});
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormCompensationDialog', extCertApplyFormCompensationDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormBonusEditDialog.$inject = ['$document', '$mdDialog'];
  function extCertApplyFormBonusEditDialog($document, $mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?',
        reloadFn: '&?reloadFn'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            templateUrl: 'app/modules/cert-zone/views/apply-form/bonus-edit-dialog.html',
            controller: [ '$filter', 'SweetAlert', 'CoreService', 'ctlService', 'userService', 'certZoneService', 'formId', 'fileProcess',
              function ($filter, SweetAlert, CoreService, ctlService, userService, certZoneService, formId, fileProcess) {
              var vm = this;
              vm.form = {};
              vm.currencys = undefined;
              vm.formId = angular.isDefined(formId) ? formId : undefined;
              vm.formType = 4;
              if(angular.isDefined(vm.formType) && angular.isDefined(vm.formId)){
                certZoneService.getExtCertApplyForm(vm.formType, {formId: vm.formId}).then(function (data) {
                  vm.data = data;
                  if(data.registerFormInfo !== null) vm.data.formData = data.registerFormInfo;
                  if(data.testFormInfo !== null) vm.data.formData = data.testFormInfo;

                  if( angular.isDefined(vm.data.formData.userId)) {
                    userService.getUserProfileDetailById(vm.data.formData.userId).then(function (applicantInfo) {
                      vm.applicantInfo = applicantInfo;
                    });
                  }

                  if(vm.data.formData.type === 1) {
                    vm.form['acquireDate'] = (angular.isDefined(vm.data.acquireDate) && vm.data.acquireDate !== '') ? moment(vm.data.acquireDate).toDate() : undefined;
                    vm.form['expireDate'] = (angular.isDefined(vm.data.expireDate) && vm.data.expireDate !== '') ? moment(vm.data.expireDate).toDate() : undefined;
                    vm.form['isForever'] = angular.isDefined(vm.data.isForever) ? vm.data.isForever : 0;
                  }
                  vm.form['licenseId'] = vm.data.licenseId;

                  vm.form['bonusType'] = angular.isDefined(vm.data.bonusType) ? vm.data.bonusType : '0';
                  vm.form['bonusOtherWay'] = angular.isDefined(vm.data.bonusOtherWay) ? vm.data.bonusOtherWay : '0';
                  vm.form['bonusCost'] = angular.isDefined(vm.data.bonusCost) ? vm.data.bonusCost : '0';
                });
              }

              ctlService.getAllCurrency({selectedValue: 0}).then(function (currencys) {
                var currency = $filter('where')(currencys, {selected: 1});
                if(currency.length > 0){
                  vm.currency = currency[0];
                }
              });


              vm.submitApplyForm = function ($formValid) {
                function preConfirm() {
                  return new Promise(function (resolve) {
                    var formType = '';
                    var formData = {
                      bonusType: vm.form.bonusType,
                      bonusOtherWay: vm.form.bonusOtherWay,
                      bonusCost: vm.form.bonusCost,
                      licenseId: vm.form.licenseId
                    };
                    if(vm.data.formData.type === 1) {
                      formType = 'update-test-bonus';
                      formData['acquireDate'] =  (angular.isDefined(vm.form.acquireDate) && vm.form.acquireDate !== '') ? moment(vm.form.acquireDate).format('YYYY/MM/DD') : '';
                      formData['expireDate'] =  (angular.isDefined(vm.form.expireDate) && vm.form.expireDate !== '') ?  moment(vm.form.expireDate).format('YYYY/MM/DD') : '';
                      formData['isForever'] =  vm.form.isForever;
                    }
                    if(vm.data.formData.type === 2) formType = 'update-register-bonus';

                    if(formType !== ''){
                      angular.forEach(vm.refFiles, function (ref, key) {
                        if(ref==='') {
                          formData['del_' + (parseInt(key)+1)] =  1;
                        }
                      });
                      var uploaderForm = certZoneService.certificateForm({formId: vm.formId}, formData, 'ref_', vm.refFiles, formType);
                      uploaderForm.then(function(resp) {
                        var res = resp.data;
                        switch (res.data.status){
                          default:
                            SweetAlert.insertSuccessQueueStep('', $filter('translate')('MESSAGE.MSG_THE_APPLICATION_FORM_WAS_UPDATED_SUCCESSFULLY'), false, $mdDialog.hide());
                            break;
                        }
                        resolve();
                      }, function () {
                        CoreService.refreshAccesstoken();
                      });
                    }
                  });
                }
                if($formValid){
                  if(fileProcess.checkUploadType(vm.refFiles) && fileProcess.checkUploadSize(vm.refFiles)) {
                    SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                  }
                }else{
                  SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
                }
              };

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formType: scope.formType,
              formId: scope.formId,
              formData: scope.formData
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function () {
            if (angular.isFunction(scope.reloadFn)) scope.reloadFn();
          }, function() {});
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormBonusEditDialog', extCertApplyFormBonusEditDialog);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  extCertApplyFormBonusDialog.$inject = ['$document', '$mdDialog', 'fileProcess'];
  function extCertApplyFormBonusDialog($document, $mdDialog, fileProcess) {
    var directive = {
      restrict: 'A',
      scope: {
        formType: '=?formType',
        formId: '=?formId',
        formData : '=?',
        reloadFn: '&?reloadFn'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            parent: angular.element($document[0].body),
            templateUrl: 'app/modules/cert-zone/views/apply-form/bonus-dialog.html',
            controller: [ '$filter', 'SweetAlert', 'CoreService', 'ctlService', 'userService', 'certZoneService', 'formId', 'formType', function ($filter, SweetAlert, CoreService, ctlService, userService, certZoneService, formId, formType) {
              var vm = this;
              vm.form = {};
              vm.currencys = undefined;
              vm.formId = angular.isDefined(formId) ? formId : undefined;
              vm.formType = angular.isDefined(formType) ? formType : undefined;
              if(angular.isDefined(vm.formType) && angular.isDefined(vm.formId)){
                certZoneService.getExtCertApplyForm(vm.formType, {formId: vm.formId}).then(function (formData) {
                  vm.formData = formData;
                  if(vm.formType === 1) {
                    vm.form = {
                      licenseId: vm.formData.licenseId,
                      acquireDate: (angular.isDefined(vm.formData.acquireDate) && vm.formData.acquireDate !== '') ? vm.formData.acquireDate : undefined,
                      expireDate: (angular.isDefined(vm.formData.expireDate) && vm.formData.expireDate !== '') ? vm.formData.expireDate : undefined
                    };
                  }
                  vm.form.bonusType = angular.isDefined(formData.bonusType) ? formData.bonusType : '0';
                  vm.form.bonusOtherWay = angular.isDefined(formData.bonusOtherWay) ? formData.bonusOtherWay : '0';
                  vm.form.bonusCost = angular.isDefined(formData.bonusCost) ? formData.bonusCost : '0';
                  vm.form.isForever = angular.isDefined(formData.isForever) ? formData.isForever : 0;
                });
              }

              ctlService.getAllCurrency({selectedValue: 0}).then(function (currencys) {
                var currency = $filter('where')(currencys, {selected: 1});
                if(currency.length > 0){
                  vm.currency = currency[0];
                }
              });


              vm.submitApplyForm = function ($formValid) {
                function preConfirm() {
                  return new Promise(function (resolve) {
                    var formType = '';
                    var formData = {
                      bonusType: vm.form.bonusType,
                      bonusOtherWay: vm.form.bonusOtherWay,
                      bonusCost: vm.form.bonusCost,
                      licenseId: vm.form.licenseId
                    };
                    if(vm.formType === 1) {
                      formType = 'apply-test-bonus';
                      formData['licenseId'] =  vm.form.licenseId;
                      formData['acquireDate'] =  (angular.isDefined(vm.form.acquireDate) && vm.form.acquireDate !== '') ? moment(vm.form.acquireDate).format('YYYY/MM/DD') : '';
                      formData['isForever'] =  vm.form.isForever;
                      if(vm.form.isForever === 0){
                        formData['expireDate'] =  (angular.isDefined(vm.form.expireDate) && vm.form.expireDate !== '') ?  moment(vm.form.expireDate).format('YYYY/MM/DD') : '';
                      }
                    }
                    if(vm.formType === 2) formType = 'apply-register-bonus';

                    if(formType !== ''){
                      var uploaderForm = certZoneService.certificateForm({rootFormId: vm.formId}, formData, 'ref_', vm.refFiles, formType);
                      uploaderForm.then(function(resp) {
                        var res = resp.data;
                        switch (res.data.status){
                          default:
                            SweetAlert.insertSuccessQueueStep('',res.data.message, false, $mdDialog.hide());
                            break;
                        }
                        resolve();
                      }, function () {
                        CoreService.refreshAccesstoken();
                      });
                    }
                  });
                }
                if($formValid){
                  if(fileProcess.checkUploadType(vm.refFiles)) {
                    SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                  } else if(fileProcess.checkUploadSize(vm.refFiles)) {
                    SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_IS_CONTINUE'), preConfirm);
                  }
                }else{
                  SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
                }
              };

              vm.close = function() {
                $mdDialog.cancel();
              };
            }],
            multiple: true,
            controllerAs: '$ctrl',
            targetEvent: ev,
            locals:{
              formType: scope.formType,
              formId: scope.formId,
              formData: scope.formData
            },
            clickOutsideToClose:true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function () {
            if (angular.isFunction(scope.reloadFn)) scope.reloadFn();
          }, function() {});
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.certZone')
    .directive('extCertApplyFormBonusDialog', extCertApplyFormBonusDialog);

})();

/**
 * Created by Alan on 2017/5/10.
 */
(function () {
  'use strict';

  var financialCertRecordSearch = {
    bindings: {},
    templateUrl: 'app/modules/cert-zone/views/financial-cert-record-search.html',
    controller: ['serverSetting', function (serverSetting) {
      var vm = this;
      vm.url = serverSetting.baseConfig.baseURL + '/fc-query-application-default.do?isManager=false';
    }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('financialCertRecordSearch' , financialCertRecordSearch);

})();

/**
 * Created by Alan on 2017/5/10.
 */
(function () {
  'use strict';

  var financialCertRecordApplication = {
    bindings: {},
    templateUrl: 'app/modules/cert-zone/views/financial-cert-record-application.html',
    controller: ['serverSetting', function (serverSetting) {
      var vm = this;
      vm.url = serverSetting.baseConfig.baseURL + '/fc-application-default.do';
    }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('financialCertRecordApplication' , financialCertRecordApplication);

})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  var externalCertRegister = {
    bindings: {},
    templateUrl: 'app/modules/cert-zone/views/external-cert-register.html',
    controller: ['ctlService', 'certZoneService', '$filter', 'SweetAlert', '$state', '$timeout', 'fileProcess',
      function (ctlService, certZoneService, $filter, SweetAlert, $state, $timeout, fileProcess) {
      var vm = this;
        vm.certificateForm="";
      vm.params ={
        subjectId: '',
        isReNew: '',
        passCheckApplyForm: false
      };
      vm.formData = {
        acquireDate: null,
        isForever: 1,
        expireDate: null,
        licenseId: '',
        comment: ''
      };
      vm.refFile =[];
      vm.required = false;
      ctlService.getCompanys({}).then(function (companys) {
        vm.companys = companys;
        vm.companyId = vm.companys[0].value;
        vm.companySubject(vm.companyId);
      });

      vm.companySubject = function(companyId) {
        var params = {
          companyId: companyId,
          showAllOption: false
        };
        ctlService.getCompanySubjects(params).then(function (subjects) {
          vm.subjects = subjects;
          vm.canReNew = (vm.subjects.length === 0)?"0":vm.subjects[0].operation;
          vm.params.subjectId = (vm.subjects.length === 0)?"":vm.subjects[0].value;
          vm.params.isReNew = 0;
        });
      };

      vm.getCanReNew = function(subjectId){
        vm.canReNew = $filter('filter')(vm.subjects,{'value': subjectId}, true)[0].operation;
      };

      vm.selectFile = function (index, files) {
        if(files.length === 0){
          vm.refFile[index] = undefined;
        }else {
          vm.refFile[index] = files[0];
        }
      };

      vm.finish = function(formData) {
        vm.required = true;
        vm.certificateForm.$setSubmitted();

        $timeout(function() {
          if(!vm.certificateForm.$valid) {
            SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
          }
          else {
            if(fileProcess.checkUploadType(vm.refFile) && fileProcess.checkUploadSize(vm.refFile)) {
              SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_EXTERNAL_TRAINING_APPLY_SUMMIT_CHECK'), preConfirm, function(result){
                if(result[0].status === 'repeat') {
                  vm.params.passCheckApplyForm = true;
                  SweetAlert.submitCheck('', result[0].message, preConfirm, function () {}, function () {
                    vm.params.passCheckApplyForm = false;
                  });
                }
              });
            }
          }
        }, 200);

        function preConfirm() {
          return new Promise(function (resolve) {

            var registerData = {
              acquireDate: moment(formData.acquireDate).format('YYYY/MM/DD'),
              isForever: formData.isForever,
              expireDate: moment(formData.expireDate).format('YYYY/MM/DD'),
              licenseId: formData.licenseId,
              comment: formData.comment
            };
            certZoneService.certificateForm(vm.params, registerData, 'ref_', vm.refFile, 'register').then(function(result) {
              var info = result.data.data;
              if(info.status===1 || info.status===2) {
                SweetAlert.insertSuccessQueueStep('', info.message, false, function(){
                  $state.go('certZone.externalCertRegister', {}, {reload: true});
                });
              }
              else if(info.status===-1){
                SweetAlert.insertErrorQueueStep('',info.message, true);
              }
              else if(info.status===-2){
                resolve({
                  status: 'repeat',
                  message: info.message
                });
              }
              resolve();
            });
          });
        }
      }
    }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('externalCertRegister' , externalCertRegister);

})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  var externalCertQualifyRewardApplication = {
    bindings: {},
    templateUrl: 'app/modules/cert-zone/views/external-cert-qualify-reward-application.html',
    controller: ['$compile', '$interpolate', '$scope', '$filter', 'NgTableParams', 'ngTableColumnValueService', '$mdDialog', '$document', 'certZoneService', function ($compile, $interpolate, $scope, $filter, NgTableParams, ngTableColumnValueService, $mdDialog, $document, certZoneService) {
      var vm = this;
      prepareTable();
      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.certTable = new NgTableParams({
          filter: vm.filter || {}
        }, {
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = value;
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;
            return certZoneService.getExtCertBonusSearch(params).then(function (datas) {
              tableParams.total(datas.metadata.pagination.total);
              return datas;
            });
          }
        });
        vm.reloadTable = function(){
          if(angular.isDefined(vm.certTable)){
            vm.certTable.reload();
          }
        };
      }
      function prepareTableCols() {
        var cols = [{
          field: 'classification',
          title: $filter('translate')('FIELD.CLASSIFICATION'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'companyName',
          title: $filter('translate')('FIELD.ORIGINAL_FACTORY_NAME'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 2
        },{
          field: 'subjectName',
          title: $filter('translate')('FIELD.CERTIFIED_SUBJECT'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate("<a href='javascript:void(0)' tip-info tip-type='7' params='{subid: row.subjectId}'>{{row.subjectName}}</a>"),
          priority: 1
        },{
          field: 'applyDate',
          title: $filter('translate')('FIELD.EXCERT_APPLY_TEST_DATE'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'relatedRefs',
          title: $filter('translate')('FIELD.REFERENCE_DOCUMENT'),
          getValue: ngTableColumnValueService.htmlReferences,
          priority: 2
        },{
          field: 'action',
          title: $filter('translate')('FIELD.ACTION'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlAction()),
          priority: 1
        }];
        return cols;
      }

      function htmlAction() {
        var html = "<div class='condition'>";
        html += "<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-view-dialog form-type='row.type' form-id='row.formId'>{{ 'ACTIONS.FORM_VIEW' | translate}}</a>";
        html += "<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-bonus-dialog form-type='row.type' form-id='row.formId' reload-fn='$ctrl.reloadTable()'>{{ 'ACTIONS.EXCERT_APPLY_BONUS' | translate}}</a>";
        html += "</div>";
        return html;
      }
    }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('externalCertQualifyRewardApplication' , externalCertQualifyRewardApplication);

})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  var externalCertExamApplication = {
    bindings: {},
    templateUrl: 'app/modules/cert-zone/views/external-cert-exam-application.html',
    controller: ['ctlService', 'certZoneService', '$filter', 'SweetAlert', '$state', '$timeout', 'fileProcess',
      function (ctlService, certZoneService, $filter, SweetAlert, $state, $timeout, fileProcess) {
        var vm = this;

        vm.getData = function() {
          vm.params ={
            subjectId: '',
            isReNew: '',
            passCheckApplyForm: false
          };
          vm.testTimes = [{
            value: '',
            time:'',
            repeat: false
          }];
          vm.formData = {
            isForever: 1,
            reason: null,
            licenseId: '',
            comment: '',
            isDomestic: 0,
            address: '',
            testFeeCurrency: '',
            testFeeAmount: 0,
            testFee: '0'
          };
          vm.refFile =[];
          vm.required = false;

          ctlService.getCompanys({showAllOption: false}).then(function (companys) {
            vm.companys = companys;
            vm.companyId = vm.companys[0].value;
            vm.companySubject(vm.companyId);
          });

          ctlService.getAllCurrency({}).then(function (currencys) {
            vm.currencys = currencys;
            vm.formData.testFeeCurrency = vm.currencys[0].value;
          });
        };

        vm.getData();


        vm.companySubject = function(companyId) {
          var params = {
            companyId: companyId,
            showAllOption: false
          };
          ctlService.getCompanySubjects(params).then(function (subjects) {
            vm.subjects = subjects;
            vm.canReNew = (vm.subjects.length === 0)?"0":vm.subjects[0].operation;
            vm.params.subjectId = (vm.subjects.length === 0)?"":vm.subjects[0].value;
            vm.params.isReNew = 0;
          });
        };

        vm.getCanReNew = function(subjectId){
          vm.canReNew = $filter('filter')(vm.subjects,{'value': subjectId}, true)[0].operation;
        };

        vm.getExchangeRate = function(){
          vm.exchangeRate = $filter('filter')(vm.currencys,{'value': vm.formData.testFeeCurrency}, true)[0].operation;
          var cardinalNumber = 1;
          if( angular.isDefined(vm.exchangeRate.split(".")[1])){
            cardinalNumber = Math.pow(10, vm.exchangeRate.split(".")[1].toString().length);
          }
          if(vm.formData.testFeeAmount!==''){
            vm.formData.testFee = ((vm.exchangeRate * cardinalNumber) * vm.formData.testFeeAmount) / cardinalNumber;
            vm.formData.testFee = $filter('number')(vm.formData.testFee, 2);
          }

        };

        vm.selectFile = function (index, files) {
          if(files.length === 0){
            vm.refFile[index] = undefined;
          }else {
            vm.refFile[index] = files[0];
          }
        };

        vm.addTimeSelect = function(){
          vm.testTimes.push({
            value: '',
            time:'',
            repeat: false
          });
        };

        vm.removeTimeSelect = function (index) {
          vm.testTimes.splice(index, 1);
          vm.checkTimeRepeat();
        };

        vm.checkTimeRepeat = function(testTime, index) {
          if(angular.isDefined(index))
            vm.testTimes[index].time = $filter('date')(testTime, 'yyyy/MM/dd');
          angular.forEach(vm.testTimes, function (time) {
            time.repeat = ($filter('filter')(vm.testTimes,{time: time.time, value: '!'}, true).length > 1);
          });
        };

        vm.finish = function(formData) {
          vm.required = true;
          vm.certificateForm.$setSubmitted();
          var times = $filter('filter')(vm.testTimes,{repeat: false}, true);
          $timeout(function() {
            if(!vm.certificateForm.$valid || vm.testTimes.length !== times.length) {
              SweetAlert.error('', $filter('translate')('FORM_VALIDATION.THERE_IS_NO_FORM_COMPLETED_PLEASE_RE_CONFIRM'));
            }
            else {
              if(fileProcess.checkUploadType(vm.refFile) && fileProcess.checkUploadSize(vm.refFile)) {
                SweetAlert.submitCheck('', $filter('translate')('MESSAGE.MSG_EXTERNAL_TRAINING_APPLY_SUMMIT_CHECK'), preConfirm, function(result){
                  if(result[0].status === 'repeat') {
                    vm.params.passCheckApplyForm = true;
                    SweetAlert.submitCheck('', result[0].message, preConfirm, function () {}, function () {
                      vm.params.passCheckApplyForm = false;
                    });
                  }
                });
              }
            }
          }, 0);

          function preConfirm() {
            return new Promise(function (resolve) {
              var testTimes="";
              angular.forEach(times, function (time) {
                testTimes += time.time + '_0:0-0:0,';
              });
              var registerData = {
                testTimes: testTimes,
                isForever: formData.isForever,
                reason: formData.reason,
                licenseId: formData.licenseId,
                comment: formData.comment,
                isDomestic: formData.isDomestic,
                address: formData.address,
                testFeeCurrency: formData.testFeeCurrency,
                testFeeAmount: formData.testFeeAmount,
                testFee: $filter('replaceAll')(formData.testFee, ',', '')
              };
              certZoneService.certificateForm(vm.params, registerData, 'ref_', vm.refFile, 'test').then(function(result) {
                var info = result.data.data;
                if(info.status===1 || info.status===2) {
                  SweetAlert.insertSuccessQueueStep('', info.message, false, function(){
                    $state.go('certZone.externalCertExamApplication', {}, {reload: true});
                  });
                }
                else if(info.status===-1){
                  SweetAlert.insertErrorQueueStep('',info.message, true);
                }
                else if(info.status===-2){
                  resolve({
                    status: 'repeat',
                    message: info.message
                  });
                }
                resolve();
              });
            });
          }
        }
      }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('externalCertExamApplication' , externalCertExamApplication);

})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  var externalCertExamAllowanceApplication = {
    bindings: {},
    templateUrl: 'app/modules/cert-zone/views/external-cert-exam-allowance-application.html',
    controller: ['$compile', '$interpolate', '$scope', '$filter', 'NgTableParams', 'ngTableColumnValueService', '$mdDialog', '$document', 'certZoneService', function ($compile, $interpolate, $scope, $filter, NgTableParams, ngTableColumnValueService, $mdDialog, $document, certZoneService) {
      var vm = this;
      prepareTable();
      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.certTable = new NgTableParams({
          filter: vm.filter || {}
        }, {
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = value;
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;
            return certZoneService.getExtCertTestCompensateSearch(params).then(function (datas) {
              tableParams.total(datas.metadata.pagination.total);
              return datas;
            });
          }
        });

        vm.reloadTable = function(){
          if(angular.isDefined(vm.certTable)){
            vm.certTable.reload();
          }
        };
      }
      function prepareTableCols() {
        var cols = [{
          field: 'classification',
          title: $filter('translate')('FIELD.CLASSIFICATION'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'companyName',
          title: $filter('translate')('FIELD.ORIGINAL_FACTORY_NAME'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 2
        },{
          field: 'subjectName',
          title: $filter('translate')('FIELD.CERTIFIED_SUBJECT'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate("<a href='javascript:void(0)' tip-info tip-type='7' params='{subid: row.subjectId}'>{{row.subjectName}}</a>"),
          priority: 1
        },{
          field: 'unappliedItems',
          title: $filter('translate')('FIELD.EXCERT_UNAPPLIED_ITEMS'),
          getValue: htmlUnappliedItems,
          priority: 2
        },{
          field: 'applyDate',
          title: $filter('translate')('FIELD.EXCERT_APPLY_TEST_DATE'),
          getValue: ngTableColumnValueService.htmlTextValue,
          priority: 1
        },{
          field: 'relatedRefs',
          title: $filter('translate')('FIELD.REFERENCE_DOCUMENT'),
          getValue: ngTableColumnValueService.htmlReferences,
          priority: 2
        },{
          field: 'action',
          title: $filter('translate')('FIELD.ACTION'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlAction()),
          priority: 1
        }];
        return cols;
      }

      function htmlAction() {
        var html = "<div class='condition'>";
        html += "<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-view-dialog form-type='row.type' form-id='row.formId'>{{ 'ACTIONS.FORM_VIEW' | translate}}</a>";
        html += "<a href='javascript:void(0);' class='btn btn-sm btn-primary' ext-cert-apply-form-compensation-dialog form-type='row.type' form-id='row.formId' reload-fn='$ctrl.reloadTable()'>{{ 'ACTIONS.EXCERT_APPLY_COMPENSATION' | translate}}</a>";
        html += "</div>";
        return html;
      }

      function htmlUnappliedItems() {
        return '<div ng-repeat="unappliedItem in row.unappliedItems">{{unappliedItem}}</div>';
      }

    }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('externalCertExamAllowanceApplication' , externalCertExamAllowanceApplication);

})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  var externalCertApplicationRecordsSearch = {
    bindings: {},
    templateUrl: 'app/modules/cert-zone/views/external-cert-application-records-search.html',
    controller: ['$window', '$compile', '$interpolate', '$scope', '$filter', 'NgTableParams', 'ngTableColumnValueService', '$mdDialog', '$document', 'certZoneService', function ($window, $compile, $interpolate, $scope, $filter, NgTableParams, ngTableColumnValueService, $mdDialog, $document, certZoneService) {
      var vm = this;
      prepareTable();
      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.certTable = new NgTableParams({
          filter: vm.filter || {}
        }, {
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = value;
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;

            if(angular.isDefined(params['beginDate'])) params['beginDate'] = moment(params['beginDate']).format('YYYY/MM/DD');
            if(angular.isDefined(params['endDate'])) params['endDate'] = moment(params['endDate']).format('YYYY/MM/DD');
            return certZoneService.getExtCertApplyRecordSearch(params).then(function (datas) {
              tableParams.total(datas.metadata.pagination.total);
              return datas;
            });
          }
        });

        vm.reloadTable = function () {
          vm.certTable.reload();
        };

        vm.setFilter = function (filters, isClear) {
          if(isClear){
            filters = {};
          }
          vm.filter = filters;
          vm.certTable.filter(filters);
          vm.certTable.sorting({});
          vm.certTable.reload();
        };
      }
      function prepareTableCols() {
        var cols = [{
          field: 'classification',
          title: $filter('translate')('FIELD.CLASSIFICATION'),
          getValue: ngTableColumnValueService.htmlTextValue,
          sortable: 'Cert_ApplyFormCommon.Type',
          priority: 1
        },{
          field: 'companyName',
          title: $filter('translate')('FIELD.ORIGINAL_FACTORY_NAME'),
          getValue: ngTableColumnValueService.htmlTextValue,
          sortable: 'CompanyName',
          priority: 1
        },{
          field: 'subjectName',
          title: $filter('translate')('FIELD.CERTIFIED_SUBJECT'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate("<a href='javascript:void(0)' tip-info tip-type='7' params='{subid: row.subjectId}'>{{row.subjectName}}</a>"),
          sortable: 'SubjectName',
          priority: 1
        },{
          field: 'applyDate',
          title: $filter('translate')('FIELD.APPLY_DATE'),
          getValue: ngTableColumnValueService.htmlTextValue,
          sortable: 'ApplyDate',
          priority: 1
        },{
          field: 'approvalStatus',
          title: $filter('translate')('FIELD.STATUS'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate("<a href='javascript:void(0);' ng-click='$ctrl.iframeWindow(row.workflowUrl )' ng-if='row.workflowId!==0'>{{ row.approvalStatus }}</a><span ng-if='row.workflowId===0'>{{ row.approvalStatus }}</span>"),
          priority: 1
        },{
          field: 'relatedRefs',
          title: $filter('translate')('FIELD.REFERENCE_DOCUMENT'),
          getValue: ngTableColumnValueService.htmlReferences,
          priority: 2
        },{
          field: 'relatedForms',
          title: $filter('translate')('FIELD.EXCERT_RELATED_FORM'),
          getValue: htmlRelatedForms,
          priority: 2,
          width: 100
        },{
          field: 'action',
          title: $filter('translate')('FIELD.ACTION'),
          getValue: ngTableColumnValueService.interpolatedValue,
          interpolateExpr: $interpolate(htmlAction()),
          priority: 1
        }];
        return cols;
      }

      function htmlAction() {
        var html = "<div class='condition'>";
        html += "<a href='javascript:void(0);' class='btn btn-sm btn-primary' ng-if='row.canView === 1' ext-cert-apply-form-view-dialog form-type='row.type' form-id='row.formId'>{{ 'ACTIONS.FORM_VIEW' | translate}}</a>";
        html += "<div ng-if='row.canEdit === 1' ext-cert-apply-form-dialog form-type='row.type' form-id='row.formId' reload-fn='$ctrl.reloadTable()'>{{ 'ACTIONS.FORM_EDIT' | translate}}</div>";
        html += "<a href='javascript:void(0);' class='btn btn-sm btn-danger' ng-if='row.canCancel === 1' form-status-dialog workflow-id='row.workflowId' approve-type='cancel' table='$ctrl.certTable'>{{ 'ACTIONS.CANCEL' | translate}}</a>";
        html += "</div>";
        return html;
      }

      function htmlRelatedForms() {
        return '<div ng-repeat="relatedForm in row.relatedForms"><a href="javascript:void(0);" ext-cert-apply-form-view-dialog form-type="relatedForm.type" form-id="relatedForm.formId">{{relatedForm.formId}}</a></div>';
      }

      vm.iframeWindow = function(formDetailUrl){
        $window.open(formDetailUrl, 'player', 'width=' + $window.innerWidth / 2 + ',height=' + $window.innerHeight / 2 + ',location=no, scrollbars=yes, resizable=yes');
      };

      vm.showPrompt = function(ev) {
        $mdDialog.show({
          templateUrl: 'app/modules/cert-zone/views/external-cert-application-records-search-dialog.html',
          controller: ['$mdDialog', 'filters', function ($mdDialog, filters) {
            var vm = this;
            vm.filters = {
              formType: angular.isDefined(filters.formType) ? filters.formType : '',
              companyId: angular.isDefined(filters.companyId) ? filters.companyId : '',
              subjectId: angular.isDefined(filters.subjectId) ? filters.subjectId : '',
              status: angular.isDefined(filters.status) ? filters.status : '',
              beginDate: angular.isDefined(filters.beginDate) ? filters.beginDate : undefined,
              endDate: angular.isDefined(filters.endDate) ? filters.endDate : undefined
            };

            vm.updateEndDateModel = function () {
              var beginningTime = moment(vm.filters.beginDate);
              var endTime = moment(vm.filters.endDate);
              if(!beginningTime.isBefore(endTime)){
                vm.filters.endDate = vm.filters.beginDate;
              }
            };

            vm.cancel = function() {
              $mdDialog.cancel();
            };
            vm.close = function() {
              $mdDialog.cancel();
            };
            vm.submit = function(filters) {
              $mdDialog.hide(filters);
            };
          }],
          controllerAs:'$ctrl',
          parent: angular.element($document[0].body),
          targetEvent: ev,
          clickOutsideToClose:true,
          locals : {
            filters : vm.certTable.filter()
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        }).then(function(filters) {
          vm.setFilter(filters, false);
        }, function() { });
      };
    }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('externalCertApplicationRecordsSearch' , externalCertApplicationRecordsSearch);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  var extCertApplyFormTestView = {
    bindings: {
      data: '=?data'
    },
    templateUrl: 'app/modules/cert-zone/views/ext-cert-apply-form-test-view.html',
    controller: ['$filter', '$scope', 'userService', 'ctlService', function( $filter, $scope, userService, ctlService ){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? undefined : this.data;
      var watchData = $scope.$watch(function () {
        return vm.data;
      }, function () {
        if(angular.isDefined(vm.data) ){
          if( angular.isDefined(vm.data.userId)) {
            userService.getUserProfileDetailById(vm.data.userId).then(function (applicantInfo) {
              vm.applicantInfo = applicantInfo;
            });
            ctlService.getAllCurrency({selectedValue: 0}).then(function (currencys) {
              var currency = $filter('where')(currencys, {selected: 1});
              if(currency.length > 0){
                vm.currency = currency[0];
              }
            });
          }
          watchData();
        }
      });

    }]
  };

  angular.module('eHRD.modules.certZone')
    .component('extCertApplyFormTestView', extCertApplyFormTestView);
})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  var extCertApplyFormRegView = {
    bindings: {
      data: '=?data'
    },
    templateUrl: 'app/modules/cert-zone/views/ext-cert-apply-form-reg-view.html',
    controller: ['$filter', '$scope', 'userService', function( $filter, $scope, userService ){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? undefined : this.data;
      var watchData = $scope.$watch(function () {
        return vm.data;
      }, function () {
        if(angular.isDefined(vm.data) ){
          if( angular.isDefined(vm.data.userId)) {
            userService.getUserProfileDetailById(vm.data.userId).then(function (applicantInfo) {
              vm.applicantInfo = applicantInfo;
            });
          }
          watchData();
        }
      });

    }]
  };

  angular.module('eHRD.modules.certZone')
    .component('extCertApplyFormRegView', extCertApplyFormRegView);
})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  var extCertApplyFormBonusView = {
    bindings: {
      data: '=?data'
    },
    templateUrl: 'app/modules/cert-zone/views/ext-cert-apply-form-bonus-view.html',
    controller: ['$translate','$filter', '$scope', 'userService', 'ctlService', function( $translate, $filter, $scope, userService, ctlService ){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? undefined : this.data;
      vm.languageFamily;
      switch ($translate.use()){
        case 'en-us':
          vm.languageFamilyType =  1;
          break;
        case 'zh-tw':
          vm.languageFamilType = 2;
          break;
        case 'zh-cn':
          vm.languageFamilyType = 3;
          break;
      }


      var watchData = $scope.$watch(function () {
        return vm.data;
      }, function () {
        if(angular.isDefined(vm.data) ){
          if(angular.isDefined(vm.data.registerFormInfo) && vm.data.registerFormInfo !== null) vm.data.formInfo = vm.data.registerFormInfo;
          if(angular.isDefined(vm.data.testFormInfo) && vm.data.testFormInfo !== null) vm.data.formInfo = vm.data.testFormInfo;
          if( angular.isDefined(vm.data.formInfo.userId)) {
            userService.getUserProfileDetailById(vm.data.formInfo.userId).then(function (applicantInfo) {
              vm.applicantInfo = applicantInfo;
            });
          }

          ctlService.getAllCurrency({selectedValue: 0}).then(function (currencys) {
            var currency = $filter('where')(currencys, {selected: 1});
            if(currency.length > 0){
              vm.currency = currency[0];
            }
          });
          watchData();
        }
      });


    }]
  };

  angular.module('eHRD.modules.certZone')
    .component('extCertApplyFormBonusView', extCertApplyFormBonusView);
})();

/**
 * Created by Bruce on 2017/1/18.
 */
(function () {
  'use strict';

  var certRecordsSearch = {
    bindings: {
      defaultParams: '=?defaultParams'
    },
    templateUrl: 'app/modules/cert-zone/views/cert-records-search.html',
    controller: ['PermPermissionStore', '$interpolate', '$scope', '$filter', 'NgTableParams', 'ngTableColumnValueService', '$mdDialog', '$document', 'certZoneService', function (PermPermissionStore, $interpolate, $scope, $filter, NgTableParams, ngTableColumnValueService, $mdDialog, $document, certZoneService) {
      var vm = this;
      var permission = null;
      permission = PermPermissionStore.getPermissionDefinition('Modules.certification.inner');
      vm.hasCertificationInnerPermission = angular.isDefined(permission);
      permission = PermPermissionStore.getPermissionDefinition('Modules.certification.ext');
      vm.hasCertificationExtPermission = angular.isDefined(permission);
      
      if (angular.isDefined(vm.defaultParams)) {
        if ((vm.defaultParams.defaultCertType === 'ext' && vm.hasCertificationExtPermission))
          vm.certType = 'ext'
        else if (vm.defaultParams.defaultCertType === 'inner' && vm.hasCertificationExtPermission)
          vm.certType = 'inner'
        else 
          vm.certType = ( (vm.hasCertificationInnerPermission) ? 'inner' : ((vm.hasCertificationExtPermission) ? 'ext': '')); // inner or ext
      } else {
        vm.certType = ( (vm.hasCertificationInnerPermission) ? 'inner' : ((vm.hasCertificationExtPermission) ? 'ext': '')); // inner or ext
      }

      vm.filter = {
        certType: vm.certType,
        validDateType: 0
      };

      function prepareTable() {
        vm.tableCols = prepareTableCols();
        vm.certTable = new NgTableParams({
          // sorting: {},
          filter: vm.filter
        }, {
          getData: function(tableParams) {
            var params = {};
            angular.forEach(tableParams.sorting(), function (value, key) {
              params.sort = key;
              params.order = value;
            });

            angular.forEach(tableParams.filter(), function (value, key) {
              params[key] = value;
            });

            var isExtCert = (vm.certType === 'ext') ;

            params.current_page = tableParams.url().page;
            params.list_size = tableParams.url().count;

            if(angular.isDefined(params['accessBegin'])) params['accessBegin'] = moment(params['accessBegin']).format('YYYY/MM/DD');
            if(angular.isDefined(params['accessEnd'])) params['accessEnd'] = moment(params['accessEnd']).format('YYYY/MM/DD');
            return certZoneService.getCertRecords(isExtCert, params).then(function (certData) {
              tableParams.total(certData.metadata.pagination.total);
              return certData;
            });
          }
        });

        vm.setFilter = function (filters, isClear) {
          if(isClear){
            filters = {};
          }
          vm.certType = angular.isDefined(filters.certType) ? filters.certType : '';
          vm.filter = filters;
          vm.certTable.filter(filters);
          vm.certTable.sorting({});
          vm.certTable.reload();
        };
      }

      function prepareTableCols() {
        var cols = [];
        switch (vm.certType){
          case 'inner':
            cols = [{
              field: 'classificationName',
              title: $filter('translate')('FIELD.CERTIFICATE_TYPE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              sortable: 'ClassificationName',
              priority: 1
            },{
              field: 'programName',
              sortable: 'Programs.ProgramName',
              title: $filter('translate')('FIELD.CERTIFICATION_NAME'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<a href='javascript:void(0)' tip-info tip-type='18' params='{certid: row.programId}'>{{row.programName}}</a>"),
              priority: 1
            },{
              field: 'credits',
              title: $filter('translate')('FIELD.CREDITS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              columnType: 'number',
              show: false
            },{
              field: 'acquireDate',
              sortable: 'Cert_SubjectToUser.AcquireDate',
              title: $filter('translate')('FIELD.ACQUIRE_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              columnType: 'date',
              width: 100
            },{
              field: 'validDate',
              sortable: 'Cert_SubjectToUser.ExpireDate',
              title: $filter('translate')('FIELD.VALID_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              columnType: 'date',
              width: 100
            },{
              field: 'score',
              title: $filter('translate')('FIELD.SCORE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              columnType: 'number',
              width: 50,
              priority: 2
            },{
              field: 'status',
              sortable: 'Cert_SubjectToUser.Status',
              title: $filter('translate')('FIELD.STATUS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 3
            },{
              field: 'bonus',
              title: $filter('translate')('FIELD.BONUS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              columnType: 'number',
              priority: 2
            },{
              field: 'references',
              title: $filter('translate')('FIELD.REFERENCE_MATERIAL'),
              getValue: ngTableColumnValueService.htmlReferences,
              priority: 2
            }];
            break;
          case 'ext':
            cols = [{
              field: 'companyName',
              sortable: 'Cert_Company.CompanyId',
              title: $filter('translate')('FIELD.ORIGINAL_FACTORY_NAME'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              width: 200
            },{
              field: 'subjectName',
              sortable: 'Cert_Subject.SubjectId',
              title: $filter('translate')('FIELD.CERTIFIED_SUBJECT'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<a href='javascript:void(0)' tip-info tip-type='7' params='{subid: row.subjectId}'>{{row.subjectName}}</a>"),
              priority: 1,
              width: 200
            },{
              field: 'credits',
              title: $filter('translate')('FIELD.CREDITS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              show: false,
              priority: 1
            },{
              field: 'acquireDate',
              sortable: 'Cert_SubjectToUser.AcquireDate',
              title: $filter('translate')('FIELD.ACQUIRE_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              width: 100
            },{
              field: 'validDate',
              sortable: 'Cert_SubjectToUser.ExpireDate',
              title: $filter('translate')('FIELD.VALID_DATE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 1,
              width: 100
            },{
              field: 'subjectToUserCode',
              title: $filter('translate')('FIELD.CERTIFICATE_NUMBER'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 2
            },{
              field: 'grade',
              title: $filter('translate')('FIELD.SUBJECT_TO_USER_GRADE'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 2
            },{
              field: 'bonus',
              title: $filter('translate')('FIELD.BONUS'),
              getValue: ngTableColumnValueService.htmlTextValue,
              priority: 2
            },{
              field: 'relatedRefs',
              title: $filter('translate')('FIELD.REFERENCE_DOCUMENT'),
              getValue: ngTableColumnValueService.htmlReferences,
              priority: 2
            },{
              field: 'action',
              title: $filter('translate')('FIELD.ACTION'),
              getValue: ngTableColumnValueService.interpolatedValue,
              interpolateExpr: $interpolate("<a href='javascript:void(0);' class='btn btn-sm btn-primary' ng-if='row.isRecruitedInfo === 1'>{{ 'FIELD.EXCERT_ADD_LICENSE_INFO' | translate}}{{row.subjectId}}</a>"),
              priority: 1
            }];
            break;
        }


        return cols;
      }

      $scope.$watch(function () {
        return vm.certType
      }, function () {
        prepareTable();
      });


      vm.showPrompt = function(ev) {
        $mdDialog.show({
          templateUrl: 'app/modules/cert-zone/views/cert-records-search-dialog.html',
          controller: ['$mdDialog', 'filters', function ($mdDialog, filters) {
            var vm = this;
            vm.filters = {
              companyId: angular.isDefined(filters.companyId) ? filters.companyId : '',
              subjectId: angular.isDefined(filters.subjectId) ? filters.subjectId : '',
              certClassId: angular.isDefined(filters.certClassId) ? filters.certClassId : '',
              certId: angular.isDefined(filters.certId) ? filters.certId : '',
              certType: angular.isDefined(filters.certType) ? filters.certType : '' ,
              validDateType: angular.isDefined(filters.validDateType) ? filters.validDateType : 0,
              accessBegin: angular.isDefined(filters.accessBegin) ? filters.accessBegin : undefined,
              accessEnd: angular.isDefined(filters.accessEnd) ? filters.accessEnd : undefined
            };

            vm.updateEndDateModel = function () {
              var beginningTime = moment(vm.filters.accessBegin);
              var endTime = moment(vm.filters.accessEnd);
              if(!beginningTime.isBefore(endTime)){
                vm.filters.accessEnd = vm.filters.accessBegin;
              }
            };

            vm.cancel = function() {
              $mdDialog.cancel();
            };
            vm.close = function() {
              $mdDialog.cancel();
            };
            vm.submit = function(filters) {
              $mdDialog.hide(filters);
            };
          }],
          controllerAs:'$ctrl',
          parent: angular.element($document[0].body),
          targetEvent: ev,
          clickOutsideToClose:true,
          locals : {
            filters : vm.certTable.filter()
          },
          fullscreen: true // Only for -xs, -sm breakpoints.
        }).then(function(filters) {
          vm.setFilter(filters, false);
        }, function() { });
      };
    }]
  };

  angular
    .module('eHRD.modules.certZone')
    .component('certRecordsSearch' , certRecordsSearch);

})();

/**
 * Created by Bruce on 2017/3/23.
 */
(function () {
  'use strict';

  var certApplyformCompensationView = {
    bindings: {
      data: '=?data'
    },
    templateUrl: 'app/modules/cert-zone/views/cert-applyform-compensation-view.html',
    controller: ['$translate', '$filter', '$scope', 'userService', function($translate, $filter, $scope, userService ){
      var vm = this;
      vm.data = angular.isUndefined(this.data) ? undefined : this.data;
      switch ($translate.use()){
        case 'en-us':
          vm.languageFamilyType =  1;
          break;
        case 'zh-tw':
          vm.languageFamilType = 2;
          break;
        case 'zh-cn':
          vm.languageFamilyType = 3;
          break;
      }
      var watchData = $scope.$watch(function () {
        return vm.data;
      }, function () {
        if(angular.isDefined(vm.data) ){
          if(angular.isDefined(vm.data.registerFormInfo) && vm.data.registerFormInfo !== null) vm.data.formInfo = vm.data.registerFormInfo;
          if(angular.isDefined(vm.data.testFormInfo) && vm.data.testFormInfo !== null) vm.data.formInfo = vm.data.testFormInfo;
          if( angular.isDefined(vm.data.formInfo.userId)) {
            userService.getUserProfileDetailById(vm.data.formInfo.userId).then(function (applicantInfo) {
              vm.applicantInfo = applicantInfo;
            });
          }
          watchData();
        }
      });

    }]
  };

  angular.module('eHRD.modules.certZone')
    .component('certApplyformCompensationView', certApplyformCompensationView);
})();

/**
 * Created by Alan on 2017/1/19.
 */
(function () {
  'use strict';

  angular
    .module('eHRD.modules.calendar',[]);

})();

/**
 * Created by Alan on 2017/1/19.
 */
(function() {
  'use strict';

  calendarService.$inject = [ '$rootScope', '$q', '$queueFactory', 'Restangular'];

  function calendarService( $rootScope, $q, $queueFactory, Restangular) {

    /*
     * Build collection api/calendar
     */
    var _service = Restangular.all('calendar');

    function getCalendarByYearMonthDay(year, month, day, params) {
      /*
       * api/calendar/{{yyyy}}/{{mm}}/{{dd}}?userId={userId}&rangeBefore={rangeBefore}&rangeAfter={rangeAfter}&courseType={courseType}
       * */
      return _service
        .one(year, month)
        .customGETLIST(day, params);
    }

    function getCalendarByYearMonth(year, month, params) {
      /*
       * api/calendar/{{yyyy}}/{{mm}}/{{dd}}?userId={userId}&rangeBefore={rangeBefore}&rangeAfter={rangeAfter}&courseType={courseType}
       * */
      return _service
        .one(year, null)
        .customGETLIST(month, params);
    }

    function getCalendarEvents(date, isOnlyDay) {
      isOnlyDay = isOnlyDay || false;
      var year, month, day;
      if(!moment.isMoment(date)){
        date = moment(date);
      }
      year = date.format('YYYY');
      month = date.format('M');
      day = date.format('D');

      var defer = $q.defer();
      if(!isOnlyDay){
        getCalendarByYearMonth(year, month, {}).then(dateProcess);
      }else {
        getCalendarByYearMonthDay(year, month, day, {}).then(dateProcess);
      }

      function dateProcess(data) {
        defer.resolve(data);
      }
      return defer.promise;
    }

    function minCalendarProcess(calendars, resObj, moreAction, linkAction) {
      resObj = resObj || false;
      moreAction = moreAction || undefined;
      linkAction = linkAction || undefined;
      var minCalendars;
      if(resObj){
        minCalendars = {};
        angular.forEach(calendars, function (calendar) {
          if(angular.isUndefined(minCalendars[calendar.dateStr])){
            minCalendars[calendar.dateStr] = [];
          }
          if(angular.isFunction(moreAction)){
            calendar.moreAction = moreAction;
          }
          if(angular.isFunction(linkAction)){
            calendar.linkAction = linkAction;
          }
          minCalendars[calendar.dateStr].push(calendar);
        });
      }else {
        minCalendars = [];
        angular.forEach(calendars, function (calendar) {
          minCalendars.push(calendar.dateStr);
        });
      }

      return minCalendars;
    }


    return {
      getCalendar: getCalendarByYearMonthDay,
      getCalendarByYearMonth: getCalendarByYearMonth,

      getCalendarEvents: getCalendarEvents,

      getCalendarWithOneBeforeAndAfter: function (baseDate) {
        if(!moment.isMoment(baseDate)) baseDate = moment(baseDate);
        var queueFinish = false;
        var queue = $queueFactory(1);
        var calendarEvents = [];
        queue.enqueue(function(){
          return getCalendarEvents(moment(baseDate.toDate()).add(-1, 'months')).then(function (data) {
            calendarEvents = calendarEvents.concat(data);
          });
        });
        queue.enqueue(function(){
          return getCalendarEvents(moment(baseDate.toDate())).then(function (data) {
            calendarEvents = calendarEvents.concat(data);
          });
        });
        queue.enqueue(function(){
          return getCalendarEvents(moment(baseDate.toDate()).add(1, 'months')).then(function (data) {
            calendarEvents = calendarEvents.concat(data);
          });
        });

        queue.enqueue(function(){
          queueFinish = true;
        });


        var defer = $q.defer();
        var watchQueueFinishChanged = $rootScope.$watch(function() {
          return queueFinish;
        }, function watchCallback(newValue) {
          if(angular.isDefined(newValue) && queueFinish){
            defer.resolve(calendarEvents);
          }
        });

        defer.promise.then(function () {
          $rootScope.$on('$destroy', watchQueueFinishChanged);
        });

        return defer.promise;
      },

      minCalendarProcess: minCalendarProcess
    };

  }

  angular.module('eHRD.modules.calendar')
    .factory('calendarService', calendarService);

})();

/**
 * Created by Bruce on 2016/9/13.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.approve', []);

})();

/**
 * Created by Bruce on 2016/9/13.
 */

(function () {
  'use strict';
  approveService.$inject = ['Restangular', '$httpParamSerializer'];
  function approveService(Restangular, $httpParamSerializer){

    /*
     * Build collection api/approval
     */
    var _approveService = Restangular.all('approval');

    return {
      getFormsHandleByTodo: function (params) {
        /*
         * api/approval/forms-handleby-todo
         * */
        return _approveService
          .customGETLIST('forms-handleby-todo', params);
      },

      getFormsHandleByFinish: function (params) {
        /*
         * api/approval/forms-handleby-finish?status={status}&eventtype={eventtype}&applydate_from={from}&applydate_end={end}&applicant_keyword={applicant}
         * */
        return _approveService
          .customGETLIST('forms-handleby-finish', params);
      },

      getEvetTypes: function () {
        /*
         * api/approval/evet-types
         * */
        return _approveService
            .customGET('evet-types');
      },

      getFormsApplyBy: function (params) {
        /*
         * api/approval/forms-applyby? status={status}&eventtype={eventtype}&applydate_from={applydate_from}&applydate_end={applydate_end}applicant_keyword={applicant_keyword}&sort={sort}&order={order}&current_page={currentPage}&list_size={listSize}
         * */
        return _approveService
            .customGETLIST('forms-applyby', params);
      },

      getFormsActionStatus: function (params) {
        /*
         * api/approval/forms-action-status?ids={ids}&type={type}
         * */
        return _approveService
            .customGET('forms-action-status', params);
      },

      updateFormsActionStatus: function (formData,params) {
        /*
         * api/approval/forms-application
         * */
        return _approveService
            .customPUT($httpParamSerializer(formData), 'forms-application', params, {"content-type": "application/x-www-form-urlencoded"});
      }



    };

  }

  angular.module('eHRD.modules.approve')
    .factory('approveService', approveService);

})();

/**
 * Created by Alan on 2016/12/1.
 */

(function () {
  'use strict';

  formStatusDialog.$inject = ['$mdDialog'];
  function formStatusDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
       workflowId: '=?',
       approveType: '@?',
       table: '=?',
       clear: '&?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/approve/views/form-status-dialog.html',
            controller: ['approveService', '$mdDialog', 'workflowId', 'approveType', 'table', 'clear', 'SweetAlert', '$filter',
              function (approveService, $mdDialog, workflowId, approveType, table, clear, SweetAlert, $filter) {
                var vm = this;
                vm.approveType = approveType;
                vm.reason='';
                var params={
                  ids: workflowId,
                  approveType: approveType
                };
                approveService.getFormsActionStatus(params).then(function (actionStatus) {
                  vm.actionStatus = actionStatus;
                });
                vm.submit = function() {
                  var form={
                      "ids": workflowId,
                      "type": approveType,
                      "reason": vm.reason,
                      "oralReportScore": vm.actionStatus.oralReportScore,
                      "teachingScore": vm.actionStatus.innerTeachingScore,
                      "extraReportScore": vm.actionStatus.extraReportScore
                  };
                  if(approveType==='reject' && vm.reason===''){
                    SweetAlert.error('', $filter('translate')( "MESSAGE.MSG_PLEASE_FILE_IN_THE_REASON_FOR_REJECT"));
                  }
                  else{
                    approveService.updateFormsActionStatus(form, "").then(function (result) {
                      if(result.status === 1){
                        if(angular.isFunction(clear)){
                          clear();
                        }
                        table.reload();
                        $mdDialog.cancel();
                      }else{
                        SweetAlert.error('', result.message);
                      }
                    });
                  }

                };
                vm.close = function() {
                  $mdDialog.cancel();
                };
            }],
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
              workflowId: scope.workflowId,
              approveType: scope.approveType,
              table: scope.table,
              clear: scope.clear
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.approve')
    .directive('formStatusDialog', formStatusDialog);

})();

/**
 * Created by Alan on 2016/11/30.
 */

(function () {
  'use strict';

  approveRecordsSearchDialog.$inject = ['$mdDialog'];
  function approveRecordsSearchDialog($mdDialog) {
    var directive = {
      restrict: 'A',
      scope: {
        filter: '&',
        table: '=',
        permissionType: '@?'
      },
      link: function (scope, element) {
        element.bind('click', function(ev) {
          $mdDialog.show({
            templateUrl: 'app/modules/approve/views/manager-approve-records-search-dialog.html',
            controller: ['approveService', '$mdDialog', 'filters', 'permissionType', 'SweetAlert', '$filter',
              function (approveService, $mdDialog, filters, permissionType, SweetAlert, $filter) {
                var vm = this;
                vm.permissionType = permissionType;
                approveService.getEvetTypes().then(function (evetTypes) {
                  vm.evetTypes = evetTypes;
                });
                vm.filters = {
                    status: angular.isDefined(filters.status) ? filters.status : 0,
                    eventtype: angular.isDefined(filters.eventtype) ? filters.eventtype : 0,
                    applydate_from: (angular.isDefined(filters.applydate_from) && filters.applydate_from!=="") ?  new Date(filters.applydate_from): "",
                    applydate_end:  (angular.isDefined(filters.applydate_end) && filters.applydate_end!=="")   ?  new Date(filters.applydate_end) : "",
                    applicant_keyword: angular.isDefined(filters.applicant_keyword) ? filters.applicant_keyword : ""
                };

                vm.updateEndDateModel = function () {
                  var beginningTime = moment(vm.startDate);
                  var endTime = moment(vm.endDate);
                  if(!beginningTime.isBefore(endTime)){
                    vm.endDate = vm.startDate;
                  }
                };

                vm.submit = function(filters) {

                    if (filters.applydate_end < filters.applydate_from && filters.applydate_from!='' && filters.applydate_end!='') {
                        SweetAlert.error('',$filter('translate')('MESSAGE.MSG_THE_START_DATE_CAN_NOT_BE_GREATER_THAN_THE_END_DATE'));
                    }
                    else {
                      $mdDialog.hide(filters);
                    }

                };
                vm.close = function() {
                  $mdDialog.cancel();
                };
            }],
            controllerAs: '$ctrl',
            targetEvent: ev,
            clickOutsideToClose:true,
            locals : {
                filters : scope.table.filter(),
                permissionType: scope.permissionType
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          }).then(function(filters) {
            filters.applydate_from = angular.isDate(filters.applydate_from)?moment(filters.applydate_from).format("YYYY/MM/DD"):"";
            filters.applydate_end  = angular.isDate(filters.applydate_end)?moment(filters.applydate_end).format("YYYY/MM/DD"):"";
            scope.table.filter(filters);
            scope.table.reload();
           }, function() { }
          );
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.modules.approve')
    .directive('approveRecordsSearchDialog', approveRecordsSearchDialog);

})();

// /**
//  * Created by Bruce on 2016/9/12.
//  */
//
// (function () {
//   'use strict';
//
//   ApproveController.$inject = ['$scope', 'NgTableParams', 'approveService', 'ngDialog', 'SweetAlert'];
//   function ApproveController($scope, NgTableParams, approveService, ngDialog, SweetAlert) {
//
//
//   }
//
//   angular.module('eHRD.modules.approve')
//     .controller('ApproveController', ApproveController);
//
// })();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var userApproveRecords = {
    bindings: {
      defaultParams: '=?defaultParams'
    },
    templateUrl: 'app/modules/approve/views/user-approve-records.html',
    controller: [ 'NgTableParams', 'approveService', '$window', '$filter', function( NgTableParams, approveService, $window, $filter ){
        var vm = this;
        vm.defaultParams = angular.isDefined(this.defaultParams) ? this.defaultParams : null;

        var defaultFilter = {};
        if(angular.isDefined(vm.defaultParams)){
          if(angular.isDefined(vm.defaultParams.status)) defaultFilter['status'] = vm.defaultParams.status;
          if(angular.isDefined(vm.defaultParams.eventtype)) defaultFilter['eventtype'] = vm.defaultParams.eventtype;
          if(angular.isDefined(vm.defaultParams.applydate_from)) defaultFilter['applydate_from'] = vm.defaultParams.applydate_from;
          if(angular.isDefined(vm.defaultParams.applydate_end)) defaultFilter['applydate_end'] = vm.defaultParams.applydate_end;
          if(angular.isDefined(vm.defaultParams.applicant_keyword)) defaultFilter['applicant_keyword'] = vm.defaultParams.applicant_keyword;
        }

        if(angular.isDefined(vm.defaultParams)){
          var defaultSorting = {};
          if(angular.isDefined(vm.defaultParams.sort) && angular.isDefined(vm.defaultParams.order)){
            defaultSorting[vm.defaultParams.sort] = vm.defaultParams.order;
          }
        }
        vm.userApproveRecordsTable = new NgTableParams({
          count: angular.isDefined(vm.defaultParams) ? vm.defaultParams.list_size: 10,
          page: angular.isDefined(vm.defaultParams) ? vm.defaultParams.current_page: 1,
          sorting: defaultSorting || { IssuedDate: "desc" },
          filter: defaultFilter
        }, {
            counts: [1,5,10,15],
            getData: function(tableParams) {
                var params = {};
                angular.forEach(tableParams.sorting(), function (value, key) {
                    params.sort = key;
                    params.order = ((value === 'desc' || $filter('uppercase')(value) === 'DESC') ? "DESC" : "ASC");
                });

                angular.forEach(tableParams.filter(), function (value, key) {
                    params[key] = value;
                });

                params.current_page = tableParams.url().page;
                params.list_size = tableParams.url().count;
                vm.backStateParams = params;
                return approveService.getFormsApplyBy(params).then(function (records) {
                    tableParams.total(records.metadata.pagination.total);
                    return records;
                });
            }
        });

        vm.iframeWindow = function(formDetailUrl){
            $window.open(formDetailUrl, 'player', 'width=' + $window.innerWidth / 2 + ',height=' + $window.innerHeight / 2 + ',location=no, scrollbars=yes, resizable=yes');
        };
    }]
  };

  angular.module('eHRD.modules.approve')
    .component('userApproveRecords', userApproveRecords);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var managerApprove = {
    bindings: {
      defaultParams: '=?defaultParams'
    },
    templateUrl: 'app/modules/approve/views/manager-approve.html',
    controller: [ '$scope', 'NgTableParams', 'approveService', 'ngDialog', 'SweetAlert', '$window', '$filter',
      function( $scope, NgTableParams, approveService, ngDialog, SweetAlert, $window, $filter ){
      var vm = this;
      vm.selectApprove = [];
      vm.selectAll = false;

      if(angular.isDefined(vm.defaultParams)){
          var defaultSorting = {};
          if(angular.isDefined(vm.defaultParams.sort) && angular.isDefined(vm.defaultParams.order)){
            defaultSorting[vm.defaultParams.sort] = vm.defaultParams.order;
          }
      }

      vm.approveTable = new NgTableParams({
        count: angular.isDefined(vm.defaultParams) ? vm.defaultParams.list_size: 10,
        page: angular.isDefined(vm.defaultParams) ? vm.defaultParams.current_page: 1,
        sorting: defaultSorting || { IssuedDate: "desc" }
      }, {
        counts: [1,5,10,15],
        getData: function(tableParams) {
          var params = {};
          angular.forEach(tableParams.sorting(), function (value, key) {
            params.sort = key;
            params.order = ((value === 'desc' || $filter('uppercase')(value) === 'DESC') ? "DESC" : "ASC");
          });
          params.current_page = tableParams.url().page;
          params.list_size = tableParams.url().count;
          vm.backStateParams = params;
          return approveService.getFormsHandleByTodo(params).then(function (approve) {
            vm.approve = approve;
            // params.count(data.metadata.pagination.perPage);
            tableParams.total(approve.metadata.pagination.total);
            return approve;
          });
        }
      });

      // watch for check all checkbox
      $scope.$watch(function() {
        return vm.selectAll;
      }, function(value) {
        angular.forEach(vm.approve, function(approve) {
          vm.selectApproveCheckbox(approve, value);
        });
      });

      vm.selectApproveCheckbox = function(approve, selectAll) {
        if($filter('arrayObjectIndexOf')(vm.selectApprove, approve) === -1 && selectAll!==false)
          vm.selectApprove.push(approve);
        else if($filter('arrayObjectIndexOf')(vm.selectApprove, approve) > -1 && angular.isUndefined(selectAll) ){
          vm.selectApprove.splice($filter('arrayObjectIndexOf')(vm.selectApprove, approve), 1);
        }
        else if(selectAll===false)
          vm.selectApprove.splice($filter('arrayObjectIndexOf')(vm.selectApprove, approve), 1);
      };

      vm.idList = function(){
        var idList="";
        angular.forEach(vm.selectApprove, function(approve) {
          idList += (idList==='')?approve.approvalId:"," + approve.approvalId;
        });
        return idList;
      };

      vm.clear = function(){
        vm.selectAll = false;
        vm.selectApprove = [];
      };

      vm.openStatus = function(/*row*/){
        // console.log(row);
        ngDialog.open({
          template: 'app/modules/approve/views/approve-status.html',
          className: 'ngdialog-theme-default',
          width: '70%',
          height: 400,
          closeByDocument: false,
          trapFocus: false,
          scope: $scope
        });
      };

      vm.iframeWindow = function(formDetailUrl){
          $window.open(formDetailUrl, 'player', 'width=' + $window.innerWidth / 2 + ',height=' + $window.innerHeight / 2 + ',location=no, scrollbars=yes, resizable=yes');
      };

    }]
  };

  angular.module('eHRD.modules.approve')
    .component('managerApprove', managerApprove);
})();

/**
 * Created by Bruce on 2016/11/22.
 */
(function () {
  'use strict';

  var managerApproveRecords = {
    bindings: {
      defaultParams: '=?defaultParams'
    },
    templateUrl: 'app/modules/approve/views/manager-approve-records.html',
    controller: [ 'NgTableParams', 'approveService', '$window', function( NgTableParams, approveService, $window ){
      var vm = this;
      var defaultFilter = {};
      if(angular.isDefined(vm.defaultParams)){
        if(angular.isDefined(vm.defaultParams.status)) defaultFilter['status'] = vm.defaultParams.status;
        if(angular.isDefined(vm.defaultParams.eventtype)) defaultFilter['eventtype'] = vm.defaultParams.eventtype;
        if(angular.isDefined(vm.defaultParams.applydate_from)) defaultFilter['applydate_from'] = vm.defaultParams.applydate_from;
        if(angular.isDefined(vm.defaultParams.applydate_end)) defaultFilter['applydate_end'] = vm.defaultParams.applydate_end;
        if(angular.isDefined(vm.defaultParams.applicant_keyword)) defaultFilter['applicant_keyword'] = vm.defaultParams.applicant_keyword;
      }

      if(angular.isDefined(vm.defaultParams)){
        var defaultSorting = {};
        if(angular.isDefined(vm.defaultParams.sort) && angular.isDefined(vm.defaultParams.order)){
          defaultSorting[vm.defaultParams.sort] = vm.defaultParams.order;
        }
      }

      vm.managerApproveRecordsTable = new NgTableParams({
        count: angular.isDefined(vm.defaultParams) ? vm.defaultParams.list_size: 10,
        page: angular.isDefined(vm.defaultParams) ? vm.defaultParams.current_page: 1,
        sorting: defaultSorting || { IssuedDate: "desc" },
        filter: defaultFilter
      }, {
        counts: [1,5,10,15],
        getData: function(tableParams) {
          var params = {};
          angular.forEach(tableParams.sorting(), function (value, key) {
            params.sort = key;
            params.order = ((value === 'desc') ? "DESC" : "ASC");
          });

          angular.forEach(tableParams.filter(), function (value, key) {
            params[key] = value;
          });

          params.current_page = tableParams.url().page;
          params.list_size = tableParams.url().count;
          vm.backStateParams = params;
          return approveService.getFormsHandleByFinish(params).then(function (records) {
            tableParams.total(records.metadata.pagination.total);
            return records;
          });
        }
      });

      vm.iframeWindow = function(formDetailUrl){
        $window.open(formDetailUrl, 'player', 'width=' + $window.innerWidth / 2 + ',height=' + $window.innerHeight / 2 + ',location=no, scrollbars=yes, resizable=yes');
      };
    }]
  };

  angular.module('eHRD.modules.approve')
    .component('managerApproveRecords', managerApproveRecords);
})();

/**
 * Created by Bruce on 2017/1/23.
 */
(function () {
  'use strict';

  var approveStatus = {
    bindings: {
      workflowId: '=?workflowId'
    },
    templateUrl: 'app/modules/approve/views/approve-status.html',
    controller: [ '$scope', 'serverSetting',
      function( $scope, serverSetting){
        var vm = this;
        vm.url = serverSetting.baseConfig.baseURL + '/apv_status.do?isFromInbox=1&id='+ this.workflowId;
      }]
  };

  angular.module('eHRD.modules.approve')
    .component('approveStatus', approveStatus);
})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  treeTableRun.$inject = ['$templateCache'];
  function treeTableRun($templateCache) {
    $templateCache.put(
      'template/TreeTable/TreeTable.html',
      ['<table ng-class="$tree_class">',
        '    <thead>',
        '  <tr>',
        '     <th ng-class="expandingProperty.titleClass" ng-style="expandingProperty.titleStyle">',
        '         {{expandingProperty.displayName || expandingProperty.field || expandingProperty}}',
        '        <\/th>',
        '        <th ng-repeat="col in colDefinitions" ng-class="col.titleClass" ng-style="col.titleStyle">',
        '         {{col.displayName || col.field}}',
        '     </th>',
        '    </tr>',
        '    </thead>',
        ' <tbody tree-table-nodes>',
        '  <tr tree-table-node="node" ng-repeat="node in tree_nodes track by node.__hashKey__" ',
        '       ng-if="(node.__inited__ || node.__visible__)"',
        '       ng-click="onSelect(node)" ',
        '       ng-class="(node.__selected__ ? \' active\':\'\')">',
        '        <td tree-table-node-handle',
        '          ng-style="expandingProperty.cellStyle ? expandingProperty.cellStyle : {\'padding-left\': $callbacks.calsIndent(node.__level__)}"',
        '          ng-class="expandingProperty.cellClass"',
        '          compile="expandingProperty.cellTemplate">',
        '              <a data-nodrag>',
        '                  <i ng-class="node.__icon_class__" ng-click="toggleExpand(node)"',
        '                     class="tree-icon"></i>',
        '              </a>',
        '             {{node[expandingProperty.field] || node[expandingProperty]}}',
        '        </td>',
        '        <td ng-repeat="col in colDefinitions" ng-class="col.cellClass" ng-style="col.cellStyle"',
        '            compile="col.cellTemplate">',
        '            {{node[col.field]}}',
        '        </td>',
        '    </tr>',
        '    </tbody>',
        '</table>'].join('\n')
    );

    $templateCache.put(
      'template/TreeTable/TreeTableStatusCopy.html',
      '<label><i class="fa fa-copy"></i>&nbsp;<b>Copying</b></label>'
    );

    $templateCache.put(
      'template/TreeTable/TreeTableStatusMove.html',
      '<label><i class="fa fa-file-text"></i>&nbsp;<b>Moving</b></label>'
    );
  }

  angular.module('eHRD.kernel.uiElements.treeTable')
    .run(treeTableRun);

})();

/**
 * Created by Bruce on 2016/8/22.
 */
(function () {
  'use strict';

  var treeTableConfig = {
    tree:   'tree-table',
    empty:  'tree-table-empty',
    hidden: 'tree-table-hidden',
    node:   'tree-table-node',
    nodes:  'tree-table-nodes',
    handle: 'tree-table-handle',
    place:  'tree-table-placeholder',
    drag:   'tree-table-drag',
    status: 'tree-table-status',
    icon:   {
      '1':  'glyphicon glyphicon-minus',
      '0':  'glyphicon glyphicon-plus',
      '-1': 'glyphicon glyphicon-file'
    }
  };

  angular.module('eHRD.kernel.uiElements.treeTable')
    .constant('$TreeTableClass', treeTableConfig);

})();

/**
 * Created by Bruce on 2016/6/17.
 */
(function () {
  'use strict';

  var treeConfig = {
    treeClass: '',//angular-ui-tree
    emptyTreeClass: 'angular-ui-tree-empty',//angular-ui-tree-empty
    hiddenClass: '',//angular-ui-tree-hidden
    nodesClass: '',//angular-ui-tree-nodes
    nodeClass: '', // angular-ui-tree-node nav-parent
    handleClass: '',//angular-ui-tree-handle
    // placeholderClass: 'angular-ui-tree-placeholder',
    levelThreshold: 30,
    defaultCollapsed: true
  };

  angular.module('eHRD.kernel.uiElements.tree')
    .constant('treeConfig', treeConfig);

})();

/**
 * Created by Bruce on 2016/9/4.
 */

(function () {
  'use strict';

  timer.$inject = ['$compile'];
  function timer($compile) {
    return  {
      restrict: 'EA',
      replace: false,
      require: 'ngModel',
      scope: {
        interval: '=interval',
        startTimeAttr: '=startTime',
        endTimeAttr: '=endTime',
        countdownattr: '=countdown',
        finishCallback: '&finishCallback',
        autoStart: '&autoStart',
        language: '@?',
        fallback: '@?',
        maxTimeUnit: '=',
        seconds: '=?',
        minutes: '=?',
        hours: '=?',
        days: '=?',
        months: '=?',
        years: '=?',
        secondsS: '=?',
        minutesS: '=?',
        hoursS: '=?',
        daysS: '=?',
        monthsS: '=?',
        yearsS: '=?',
        timeModel: '=ngModel'
      },
      link: function (scope, element, attrs, ngModel) {
        scope.$watch('timeModel', function(newVal) {
          ngModel.$setViewValue(newVal);
        });
      },
      controller: ['$scope', '$element', '$attrs', '$timeout', 'I18nService', '$interpolate', 'progressBarService', function ($scope, $element, $attrs, $timeout, I18nService, $interpolate, progressBarService) {

        // Checking for trim function since IE8 doesn't have it
        // If not a function, create tirm with RegEx to mimic native trim
        if (angular.isFunction(String.prototype.trim)) {
          String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
          };
        }

        //angular 1.2 doesn't support attributes ending in "-start", so we're
        //supporting both "autostart" and "auto-start" as a solution for
        //backward and forward compatibility.
        $scope.autoStart = $attrs.autoStart || $attrs.autostart;


        $scope.language = $scope.language || 'en';
        $scope.fallback = $scope.fallback || 'en';

        //allow to change the language of the directive while already launched
        $scope.$watch('language', function(newVal/*, oldVal*/) {
          if(angular.isDefined(newVal)) {
            i18nService.init(newVal, $scope.fallback);
          }
        });

        //init momentJS i18n, default english
        var i18nService = new I18nService();
        i18nService.init($scope.language, $scope.fallback);

        //progress bar
        $scope.displayProgressBar = 0;
        $scope.displayProgressActive = 'active'; //Bootstrap active effect for progress bar

        if ($element.html().trim().length === 0) {
          $element.append($compile('<span>' + $interpolate.startSymbol() + 'millis' + $interpolate.endSymbol() + '</span>')($scope));
        } else {
          $element.append($compile($element.contents())($scope));
        }

        $scope.startTime = null;
        $scope.endTime = null;
        $scope.timeoutId = null;
        $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) >= 0 ? parseInt($scope.countdownattr, 10) : undefined;
        $scope.isRunning = false;

        $scope.$on('timer-start', function () {
          $scope.start();
        });

        $scope.$on('timer-resume', function () {
          $scope.resume();
        });

        $scope.$on('timer-stop', function () {
          $scope.stop();
        });

        $scope.$on('timer-clear', function () {
          $scope.clear();
        });

        $scope.$on('timer-reset', function () {
          $scope.reset();
        });

        $scope.$on('timer-set-countdown', function (e, countdown) {
          $scope.countdown = countdown;
        });

        function resetTimeout() {
          if ($scope.timeoutId) {
            clearTimeout($scope.timeoutId);
          }
        }

        $scope.$watch('startTimeAttr', function(newValue, oldValue) {
          if (newValue !== oldValue && $scope.isRunning) {
            $scope.start();
          }
        });

        $scope.$watch('endTimeAttr', function(newValue, oldValue) {
          if (newValue !== oldValue && $scope.isRunning) {
            $scope.start();
          }
        });

        $scope.start = $element[0].start = function () {
          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
          if (!angular.isNumber($scope.countdown)) {
            $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
          }
          resetTimeout();
          tick();
          $scope.isRunning = true;
        };

        $scope.resume = $element[0].resume = function () {
          resetTimeout();
          if ($scope.countdownattr) {
            $scope.countdown += 1;
          }
          $scope.startTime = moment().diff((moment($scope.stoppedTime).diff(moment($scope.startTime))));
          tick();
          $scope.isRunning = true;
        };

        $scope.stop = $scope.pause = $element[0].stop = $element[0].pause = function () {
          var timeoutId = $scope.timeoutId;
          $scope.clear();
          $scope.$emit('timer-stopped', {timeoutId: timeoutId, millis: $scope.millis, seconds: $scope.seconds, minutes: $scope.minutes, hours: $scope.hours, days: $scope.days});
        };

        $scope.clear = $element[0].clear = function () {
          // same as stop but without the event being triggered
          $scope.stoppedTime = moment();
          resetTimeout();
          $scope.timeoutId = null;
          $scope.isRunning = false;
        };

        $scope.reset = $element[0].reset = function () {
          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
          $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
          resetTimeout();
          tick();
          $scope.isRunning = false;
          $scope.clear();
        };

        $element.bind('$destroy', function () {
          resetTimeout();
          $scope.isRunning = false;
        });


        function calculateTimeUnits() {
          var timeUnits = {}; //will contains time with units

          if (angular.isDefined($attrs.startTime) ){
            $scope.millis = moment().diff(moment($scope.startTimeAttr));
          }

          timeUnits = i18nService.getTimeUnits($scope.millis);

          // compute time values based on maxTimeUnit specification
          if (!$scope.maxTimeUnit || $scope.maxTimeUnit === 'day') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
            $scope.days = Math.floor((($scope.millis / (3600000)) / 24));
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'second') {
            $scope.seconds = Math.floor($scope.millis / 1000);
            $scope.minutes = 0;
            $scope.hours = 0;
            $scope.days = 0;
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'minute') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor($scope.millis / 60000);
            $scope.hours = 0;
            $scope.days = 0;
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'hour') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor($scope.millis / 3600000);
            $scope.days = 0;
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'month') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
            $scope.months = Math.floor((($scope.millis / (3600000)) / 24) / 30);
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'year') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
            $scope.months = Math.floor((($scope.millis / (3600000)) / 24 / 30) % 12);
            $scope.years = Math.floor(($scope.millis / (3600000)) / 24 / 365);
          }
          // plural - singular unit decision (old syntax, for backwards compatibility and English only, could be deprecated!)
          $scope.secondsS = ($scope.seconds === 1) ? '' : 's';
          $scope.minutesS = ($scope.minutes === 1) ? '' : 's';
          $scope.hoursS = ($scope.hours === 1) ? '' : 's';
          $scope.daysS = ($scope.days === 1)? '' : 's';
          $scope.monthsS = ($scope.months === 1)? '' : 's';
          $scope.yearsS = ($scope.years === 1)? '' : 's';


          // new plural-singular unit decision functions (for custom units and multilingual support)
          $scope.secondUnit = timeUnits.seconds;
          $scope.minuteUnit = timeUnits.minutes;
          $scope.hourUnit = timeUnits.hours;
          $scope.dayUnit = timeUnits.days;
          $scope.monthUnit = timeUnits.months;
          $scope.yearUnit = timeUnits.years;

          //add leading zero if number is smaller than 10
          $scope.sseconds = $scope.seconds < 10 ? '0' + $scope.seconds : $scope.seconds;
          $scope.mminutes = $scope.minutes < 10 ? '0' + $scope.minutes : $scope.minutes;
          $scope.hhours = $scope.hours < 10 ? '0' + $scope.hours : $scope.hours;
          $scope.ddays = $scope.days < 10 ? '0' + $scope.days : $scope.days;
          $scope.mmonths = $scope.months < 10 ? '0' + $scope.months : $scope.months;
          $scope.yyears = $scope.years < 10 ? '0' + $scope.years : $scope.years;

          if(angular.isDefined($scope.timeModel)) {
            $scope.timeModel={
              seconds : $scope.sseconds
            };
          }


        }

        //determine initial values of time units and add AddSeconds functionality
        if ($scope.countdownattr) {
          $scope.millis = $scope.countdownattr * 1000;

          $scope.addCDSeconds = $element[0].addCDSeconds = function (extraSeconds) {
            $scope.countdown += extraSeconds;
            $scope.$digest();
            if (!$scope.isRunning) {
              $scope.start();
            }
          };

          $scope.$on('timer-add-cd-seconds', function (e, extraSeconds) {
            $timeout(function () {
              $scope.addCDSeconds(extraSeconds);
            });
          });

          $scope.$on('timer-set-countdown-seconds', function (e, countdownSeconds) {
            if (!$scope.isRunning) {
              $scope.clear();
            }

            $scope.countdown = countdownSeconds;
            $scope.millis = countdownSeconds * 1000;
            calculateTimeUnits();
          });
        } else {
          $scope.millis = 0;
        }
        calculateTimeUnits();

        var tick = function tick() {
          var typeTimer = null; // countdown or endTimeAttr
          $scope.millis = moment().diff($scope.startTime);
          // var adjustment = $scope.millis % 1000;

          if ($scope.endTimeAttr) {
            typeTimer = $scope.endTimeAttr;
            $scope.millis = moment($scope.endTime).diff(moment());
            // adjustment = $scope.interval - $scope.millis % 1000;
          }

          if ($scope.countdownattr) {
            typeTimer = $scope.countdownattr;
            $scope.millis = $scope.countdown * 1000;
          }

          if ($scope.millis < 0) {
            $scope.stop();
            $scope.millis = 0;
            calculateTimeUnits();
            if($scope.finishCallback) {
              $scope.$eval($scope.finishCallback);
            }
            return;
          }
          calculateTimeUnits();

          //We are not using $timeout for a reason. Please read here - https://github.com/siddii/angular-timer/pull/5
          $scope.timeoutId = setTimeout(function () {
            tick();
            $scope.$digest();
          }, $scope.interval); // $scope.interval - adjustment

          $scope.$emit('timer-tick', {timeoutId: $scope.timeoutId, millis: $scope.millis, timerElement: $element[0]});

          if ($scope.countdown > 0) {
            $scope.countdown--;
          }
          else if ($scope.countdown <= 0) {
            $scope.stop();
            if($scope.finishCallback) {
              $scope.$eval($scope.finishCallback);
            }
          }

          if(typeTimer !== null){
            //calculate progress bar
            $scope.progressBar = progressBarService.calculateProgressBar($scope.startTime, $scope.millis, $scope.endTime, $scope.countdownattr);

            if($scope.progressBar === 100){
              $scope.displayProgressActive = ''; //No more Bootstrap active effect
            }
          }
        };

        if (angular.isUndefined($scope.autoStart) || $scope.autoStart === true) {
          $scope.start();
        }
      }]
    };
  }

  angular.module('eHRD.kernel.uiElements.timer')
    .directive('timer', timer);
})();

/**
 * Created by Bruce on 2016/9/13.
 */
(function () {
  'use strict';

  angular.module('eHRD.kernel.uiElements.uiTable')
    .value('ngTableDefaults', {
      counts: [1,5,10,15],
      params: {},
      settings: {}
    });

})();

/**
 * Created by Bruce on 2016/6/22.
 */

(function () {
  'use strict';
  uibPagination.$inject = ['$templateCache'];

  function uibPagination($templateCache) {
    $templateCache.put("uib/template/pagination/pagination.html",
      "<ul class=\"pagination\">\n" +
      "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\"><span class=\"glyphicon glyphicon-fast-backward\"></span></a></li>\n" +
      "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a></li>\n" +
      "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
      "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a></li>\n" +
      "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\"><span class=\"glyphicon glyphicon-fast-forward\"></span></a></li>\n" +
      "</ul>" +
      "");
  }
  angular.module("uib/template/pagination/pagination.html").run(uibPagination);
})();

/**
 * Created by Bruce on 2016/6/27.
 */

(function () {
  'use strict';

  paginationRun.$inject = ['$templateCache'];
  function paginationRun($templateCache) {
    $templateCache.put('default.pagination.template',
      '<ul class="pagination" ng-if="1 < pages.length || !autoHide">' +
      '<li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li>' +
      '<li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li>' +
      '<li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ' +
        'ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }">' +
        '<a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li>' +
      '<li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }">' +
        '<a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li>' +
      '<li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }">' +
        '<a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li>' +
      '</ul>');
  }
  angular.module('eHRD.kernel.uiElements.pagination')
    .run(paginationRun);
})();

/**
 * Created by Bruce on 2016/6/27.
 */

(function () {
  'use strict';

  var uiPaginationConfig = {
    DEFAULT_ID: '__default',
    DEFAULT_ContentLayoutTemplate:'card'
  }
  angular.module('eHRD.kernel.uiElements.pagination')
    .constant('uiPaginationConfig', uiPaginationConfig);
})();

/**
 * Created by Bruce on 2016/6/27.
 */

(function () {
  'use strict';

  function uiPaginationConfig(paginationTemplateProvider) {
    paginationTemplateProvider.setHeaderPath('app/kernel/ui-elements/pagination/views/ui-pagination-header.tpl.html');
    paginationTemplateProvider.setPath('app/kernel/ui-elements/pagination/views/ui-pagination.tpl.html');
  }

  angular.module('eHRD.kernel.uiElements.pagination')
    .config(uiPaginationConfig);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  mdPickersRun.$inject = ["$templateCache", "mdpIconsRegistry"];

  function mdPickersRun($templateCache, mdpIconsRegistry) {
    angular.forEach(mdpIconsRegistry, function(icon /*, index*/ ) {
      $templateCache.put(icon.url, icon.svg);
    });
  }

  angular.module('mdPickers')
    .run(mdPickersRun);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  var mdpIconsRegistry = [{
    id: 'mdp-chevron-left',
    url: 'mdp-chevron-left.svg',
    svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
  }, {
    id: 'mdp-chevron-right',
    url: 'mdp-chevron-right.svg',
    svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
  }, {
    id: 'mdp-access-time',
    url: 'mdp-access-time.svg',
    svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>'
  }, {
    id: 'mdp-event',
    url: 'mdp-event.svg',
    svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
  }];

  angular.module('mdPickers')
    .constant("mdpIconsRegistry", mdpIconsRegistry);
})();

/**
 * Created by Bruce on 2016/7/11.
 */
(function() {
  'use strict';

  mdPickersConfig.$inject = ["$mdIconProvider", "mdpIconsRegistry"];

  function mdPickersConfig($mdIconProvider, mdpIconsRegistry) {
    angular.forEach(mdpIconsRegistry, function(icon /*, index*/ ) {
      $mdIconProvider.icon(icon.id, icon.url);
    });
  }

  angular.module('mdPickers')
    .config(mdPickersConfig);
})();

/**
 * Created by Bruce on 2016/11/14.
 */

(function () {
  'use strict';

  config.$inject = [];
  function config() {
    // console.log()
    // if (!-[1,]) {
    //   document.createElement('twitch');
    //   document.createElement('justin');
    //   document.createElement('flash');
    //   document.createElement('youtube');
    // }
  }
  angular.module('eHRD.kernel.uiElements.media')
    .config(config);
})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.auth',[
    'permission',
    'permission.ui'
  ]);

})();

/**
 * Created by Bruce on 2018/3/14.
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.auth')

    .factory('Md5Utils', function() {
      var hex_chr = "0123456789abcdef";
      function rhex(num) {
        var str = "";
        for(var j = 0; j <= 3; j++)
          str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) +
            hex_chr.charAt((num >> (j * 8)) & 0x0F);
        return str;
      }

      /*
       * Convert a string to a sequence of 16-word blocks, stored as an array.
       * Append padding bits and the length, as described in the MD5 standard.
       */
      function str2blks_MD5(str) {
        var nblk = ((str.length + 8) >> 6) + 1;
        var blks = new Array(nblk * 16);
        for(var i = 0; i < nblk * 16; i++) blks[i] = 0;
        for(i = 0; i < str.length; i++)
          blks[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
        blks[i >> 2] |= 0x80 << ((i % 4) * 8);
        blks[nblk * 16 - 2] = str.length * 8;
        return blks;
      }

      /*
       * Add integers, wrapping at 2^32. This uses 16-bit operations internally
       * to work around bugs in some JS interpreters.
       */
      function add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xFFFF);
      }

      /*
       * Bitwise rotate a 32-bit number to the left
       */
      function rol(num, cnt) {
        return (num << cnt) | (num >>> (32 - cnt));
      }

      /*
       * These functions implement the basic operation for each round of the
       * algorithm.
       */
      function cmn(q, a, b, x, s, t) {
        return add(rol(add(add(a, q), add(x, t)), s), b);
      }

      function ff(a, b, c, d, x, s, t) {
        return cmn((b & c) | ((~b) & d), a, b, x, s, t);
      }

      function gg(a, b, c, d, x, s, t) {
        return cmn((b & d) | (c & (~d)), a, b, x, s, t);
      }

      function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
      }

      function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | (~d)), a, b, x, s, t);
      }

      /*
       * Take a string and return the hex representation of its MD5.
       */
      this.calcMD5 = function(str) {
        var x = str2blks_MD5(str);
        var a =  1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d =  271733878;

        for(var i = 0; i < x.length; i += 16) {
          var olda = a;
          var oldb = b;
          var oldc = c;
          var oldd = d;

          a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
          d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
          c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
          b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
          a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
          d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
          c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
          b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
          a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
          d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
          c = ff(c, d, a, b, x[i+10], 17, -42063);
          b = ff(b, c, d, a, x[i+11], 22, -1990404162);
          a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
          d = ff(d, a, b, c, x[i+13], 12, -40341101);
          c = ff(c, d, a, b, x[i+14], 17, -1502002290);
          b = ff(b, c, d, a, x[i+15], 22,  1236535329);

          a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
          d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
          c = gg(c, d, a, b, x[i+11], 14,  643717713);
          b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
          a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
          d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
          c = gg(c, d, a, b, x[i+15], 14, -660478335);
          b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
          a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
          d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
          c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
          b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
          a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
          d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
          c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
          b = gg(b, c, d, a, x[i+12], 20, -1926607734);

          a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
          d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
          c = hh(c, d, a, b, x[i+11], 16,  1839030562);
          b = hh(b, c, d, a, x[i+14], 23, -35309556);
          a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
          d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
          c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
          b = hh(b, c, d, a, x[i+10], 23, -1094730640);
          a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
          d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
          c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
          b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
          a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
          d = hh(d, a, b, c, x[i+12], 11, -421815835);
          c = hh(c, d, a, b, x[i+15], 16,  530742520);
          b = hh(b, c, d, a, x[i+ 2], 23, -995338651);

          a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
          d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
          c = ii(c, d, a, b, x[i+14], 15, -1416354905);
          b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
          a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
          d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
          c = ii(c, d, a, b, x[i+10], 15, -1051523);
          b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
          a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
          d = ii(d, a, b, c, x[i+15], 10, -30611744);
          c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
          b = ii(b, c, d, a, x[i+13], 21,  1309151649);
          a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
          d = ii(d, a, b, c, x[i+11], 10, -1120210379);
          c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
          b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

          a = add(a, olda);
          b = add(b, oldb);
          c = add(c, oldc);
          d = add(d, oldd);
        }
        return rhex(a) + rhex(b) + rhex(c) + rhex(d);
      };

      return this;
    });

})();

/**
 * Created by Bruce on 2018/3/14.
 */

(function () {
  'use strict';

  EncryptUtils.$inject = ['AesUtils', 'Md5Utils'];
  function EncryptUtils(AesUtils, Md5Utils) {
    var iv             = 'F289D4E55B1FDBE4ED098C5CB8BE7C41';
    var salt           = '63BE12E34AFBDF0C33C82D4D935598FCCCD00B76690DB4BD741CBDC16EDFD206';
    var keySize        = 128;
    var iterationCount = 1;
    var passPhrase     = 'thisissunnetehrdctmsappaescryptpassphrase';
    var plainText      = undefined;



    function setProperty(cfg) {
      iv             = angular.isUndefined(cfg.iv) ? iv : cfg.iv;
      salt           = angular.isUndefined(cfg.salt) ? salt : cfg.salt;
      keySize        = angular.isUndefined(cfg.keySize) ? keySize : cfg.keySize;
      iterationCount = angular.isUndefined(cfg.iterationCount) ? iterationCount : cfg.iterationCount;
      passPhrase     = angular.isUndefined(cfg.passPhrase) ? passPhrase : cfg.passPhrase;
      plainText      = cfg.plainText;
      AesUtils.init(keySize, iterationCount);
    }

    function getDefaultKey(code) {
      var orgKey = passPhrase, reverseKey, md5Key;
      reverseKey = orgKey.split('').reverse().join('');
      md5Key = Md5Utils.calcMD5(reverseKey).toUpperCase();
      if (code === null || angular.isUndefined(code)) {
        code = 8;
      }
      return Md5Utils.calcMD5(md5Key.substr(0, code)).toUpperCase();
    }

    function Encrypt() {
      return AesUtils.encrypt(AesUtils.generateKey(salt, getDefaultKey()), iv, plainText)
    }


    return {
      setProperty: setProperty,
      getDefaultKey: getDefaultKey,
      Encrypt: Encrypt
    };
  }

  angular.module('eHRD.kernel.auth')
    .factory('EncryptUtils', EncryptUtils);

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.auth')

    .factory('AuthUtils', function() {

      this.getFullUrlPath = function(location) {
        return location.protocol + '//' + location.hostname +
          (location.port ? ':' + location.port : '') + location.pathname;
      };

      this.camelCase = function(name) {
        return name.replace(/([\:\-\_]+(.))/g, function(_, separator, letter, offset) {
          return offset ? letter.toUpperCase() : letter;
        });
      };

      this.parseQueryString = function(keyValue) {
        var obj = {}, key, value;
        angular.forEach((keyValue || '').split('&'), function(keyValue) {
          if (keyValue) {
            value = keyValue.split('=');
            key = decodeURIComponent(value[0]);
            obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
          }
        });
        return obj;
      };

      this.joinUrl = function(baseUrl, url) {
        if (/^(?:[a-z]+:)?\/\//i.test(url)) {
          return url;
        }

        var joined = [baseUrl, url].join('/');

        var normalize = function(str) {
          return str
            .replace(/[\/]+/g, '/')
            .replace(/\/\?/g, '?')
            .replace(/\/\#/g, '#')
            .replace(/\:\//g, '://');
        };

        return normalize(joined);
      };

      this.merge = function(obj1, obj2) {
        var result = {};
        for (var i in obj1) {
          if (obj1.hasOwnProperty(i)) {
            if ((i in obj2) && (angular.isObject(obj1[i])) && (i !== null)) {
              result[i] = this.merge(obj1[i], obj2[i]);
            } else {
              result[i] = obj1[i];
            }
          }
        }
        for (i in obj2) {
          if (obj2.hasOwnProperty(i)) {
            if (i in result) {
              continue;
            }
            result[i] = obj2[i];
          }

        }
        return result;
      };

      return this;
    })

  ;

})();

/**
 * Created by Bruce on 2018/3/14.
 */

(function () {
  'use strict';

  AesUtils.$inject = [];
  function AesUtils() {

    this.init = function(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    };

    this.generateKey = function(salt, passPhrase) {
      var key = CryptoJS.PBKDF2(
        passPhrase,
        CryptoJS.enc.Hex.parse(salt),
        { keySize: this.keySize, iterations: this.iterationCount });
      return key;
    };

    this.encrypt = function(key, iv, plainText) {
      var encrypted = CryptoJS.AES.encrypt(
        plainText,
        key,
        { iv: CryptoJS.enc.Hex.parse(iv) });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };

    this.decrypt = function(key, iv, cipherText) {
      var cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(cipherText)
      });
      var decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        key,
        { iv: CryptoJS.enc.Hex.parse(iv) });
      return decrypted.toString(CryptoJS.enc.Utf8);
    };


    return this;
  }

  angular.module('eHRD.kernel.auth')
    .factory('AesUtils', AesUtils);

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthStorage.$inject=[
    '$window', '$log', 'AuthConfig'
  ];

 function AuthStorage($window, $log, config){
   var store = {};

   // Check if localStorage or sessionStorage is available or enabled
   var isStorageAvailable = (function() {
     try {
       var supported = config.storageType in $window && $window[config.storageType] !== null;

       if (supported) {
         var key = Math.random().toString(36).substring(7);
         $window[config.storageType].setItem(key, '');
         $window[config.storageType].removeItem(key);
       }

       return supported;
     } catch (e) {
       return false;
     }
   })();

   if (!isStorageAvailable) {
     $log.warn(config.storageType + ' is not available.');
   }

   return {
     get: function(key) {
       return isStorageAvailable ? $window[config.storageType].getItem(key) : store[key];
     },
     set: function(key, value) {
       return isStorageAvailable ? $window[config.storageType].setItem(key, value) : store[key] = value;
     },
     remove: function(key) {
       return isStorageAvailable ? $window[config.storageType].removeItem(key): delete store[key];
     }
   };
 }

  angular.module('eHRD.kernel.auth')

    .factory('AuthStorage', AuthStorage)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthShared.$inject=[
    '$q',
    '$window',
    '$location',
    '$log',
    'AuthConfig',
    'AuthStorage',
    'PermPermissionStore',
    'PermRoleStore'
  ];

  function AuthShared($q, $window, $location, $log, config, storage, PermissionStore, RoleStore){
    var Shared = {};
    var tokenName = config.tokenPrefix ? [config.tokenPrefix, config.tokenName].join('_') : config.tokenName;
    var dataTokenName = config.tokenPrefix + '_data';

    Shared.initToken = function (tokenPrefix) {
      tokenName = [tokenPrefix, config.tokenName].join('_');
      dataTokenName = tokenPrefix + '_data';
    };

    Shared.getToken = function() {
      return storage.get(tokenName);
    };
    Shared.getDataToken = function() {
      return storage.get(dataTokenName);
    };

    Shared.clearPermissionStore = function (){
      PermissionStore.clearStore();
    };
    Shared.setPermissions = function (Permissions) {
      this.clearPermissionStore();
      angular.forEach(Permissions, function(Permission) {
        PermissionStore
          .definePermission(Permission, function () {
            return true;
          });
      });
    };
    Shared.setSystemModulesPermissions = function (SystemModulesPermissions) {
      angular.forEach(SystemModulesPermissions, function(SystemModulesPermission) {
        PermissionStore
          .definePermission('Modules.' + SystemModulesPermission, function () {
            return true;
          });
      });
    };

    Shared.setRoles = function (Roles) {
      angular.forEach(Roles, function(Role) {
        angular.forEach(Role, function(Permissions, _Role) {
          switch (_Role){
            case 'MgrUser':
              if(Permissions.length > 0) RoleStore.defineRole(_Role, Permissions);
              break;
            default:
              RoleStore.defineRole(_Role, Permissions);
              break;
          }

        });
      });
    };

    Shared.setACL = function (token) {
      if (token && token.split('.').length === 3) {
        try {
          var base64Url = token.split('.')[1];
          // console.log("base64Url : " + base64Url);
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          // console.log("base64 : " + base64);
          console.log("列印base64Url及base64");
          console.log("Shared.setACL data");
          // console.dir($window.atob(base64));
          // console.dir($window.atob(base64));
          var ACLData = angular.fromJson(decodeURIComponent(escape($window.atob(base64)))).data;
          // console.dir(angular.fromJson(decodeURIComponent(escape($window.atob(base64)))).data);
          this.setPermissions(ACLData.Permissions);
          this.setSystemModulesPermissions(ACLData.SystemModulesPermission);
          this.setRoles(ACLData.Roles);
        } catch(e) {
          return undefined;
        }
      }
    };

    Shared.getUserData = function () {
        var allData ;
        var UserData;
        if( angular.isDefined(this.getPayload() ) ){
          allData = this.getPayload().data;
          UserData = allData;
        }else {
          UserData = undefined;
        }
        return UserData;
    };

    Shared.getPayload = function() {
      var token = storage.get(dataTokenName);

      if (token && token.split('.').length === 3) {
        try {
          var base64Url = token.split('.')[1];
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          return angular.fromJson(decodeURIComponent(escape($window.atob(base64))));
        } catch(e) {
          return undefined;
        }
      }
    };

    Shared.setToken = function(response) {
      if (!response) {
        return $log.warn('Can\'t set token without passing a value');
      }

      var accessToken = response && response.access_token;
      var token, data_token;


      if (accessToken) {
        if (angular.isObject(accessToken) && angular.isObject(accessToken.data)) {
          response = accessToken;
        } else if (angular.isString(accessToken)) {
          token = accessToken;
        }
      }

      if (!token && response) {
        var tokenRootData = config.tokenRoot && config.tokenRoot.split('.').reduce(function(o, x) { return o[x]; }, response.data);
        token = tokenRootData ? tokenRootData[config.tokenName] : response.data && response.data[config.tokenName];
        data_token = response.data['data'];
      }

      if (!token) {
        var tokenPath = config.tokenRoot ? config.tokenRoot + '.' + config.tokenName : config.tokenName;
        return $log.warn('Expecting a token named "' + tokenPath);
      }

      this.setACL(data_token);
      storage.set(tokenName, token);
      storage.set(dataTokenName, data_token);
    };

    Shared.removeToken = function() {
      storage.remove(tokenName);
      storage.remove(dataTokenName);
      storage.remove("projectData");
    };

    /**
     * @returns {boolean}
     */
    Shared.isAuthenticated = function() {
      var token = storage.get(tokenName);
      var data_token = storage.get(dataTokenName);
      // A token is present
      if (token && data_token) {
        // Token with a valid JWT format XXX.YYY.ZZZ
        if (token.split('.').length === 3) {
          // Could be a valid JWT or an access token with the same format
          try {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var exp = angular.fromJson($window.atob(base64)).exp;
            // JWT with an optonal expiration claims
            if (exp) {
              var isExpired = Math.round(new Date().getTime() / 1000) >= exp;
              if (isExpired) {
                // FAIL: Expired token
                return false;
              } else {
                // PASS: Non-expired token
                return true;
              }
            }
          } catch(e) {
            // PASS: Non-JWT token that looks like JWT
            return true;
          }
        }
        // PASS: All other tokens
        return true;
      }
      // FAIL: No token at all
      return false;
    };

    Shared.logout = function() {
      storage.remove(tokenName);
      storage.remove(dataTokenName);
      storage.remove("projectData");
      this.clearPermissionStore();
      return $q.when();
    };

    Shared.setStorageType = function(type) {
      config.storageType = type;
    };

    Shared.setAuthType = function(type) {
      config.authType = type;
    };

    return Shared;
  }


  angular.module('eHRD.kernel.auth')

    .factory('AuthShared', AuthShared)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthPopup.$inject = [
    '$q',
    '$interval',
    '$window',
    'AuthConfig',
    'AuthUtils'
  ];

  function AuthPopup($q, $interval, $window, config, utils, $document) {
    var Popup = {};

    Popup.url = '';
    Popup.popupWindow = null;

    Popup.open = function(url, name, options) {
      Popup.url = url;

      var stringifiedOptions = Popup.stringifyOptions(Popup.prepareOptions(options));
      var UA = $window.navigator.userAgent;
      var windowName = ($window.cordova || UA.indexOf('CriOS') > -1) ? '_blank' : name;

      Popup.popupWindow = $window.open(url, windowName, stringifiedOptions);

      $window.popup = Popup.popupWindow;

      if (Popup.popupWindow && Popup.popupWindow.focus) {
        Popup.popupWindow.focus();
      }

      return Popup;
    };

    Popup.eventListener = function(redirectUri) {
      var deferred = $q.defer();

      Popup.popupWindow.addEventListener('loadstart', function(event) {
        if (event.url.indexOf(redirectUri) !== 0) {
          return;
        }

        var parser = $document.createElement('a');
        parser.href = event.url;

        if (parser.search || parser.hash) {
          var queryParams = parser.search.substring(1).replace(/\/$/, '');
          var hashParams = parser.hash.substring(1).replace(/\/$/, '');
          var hash = utils.parseQueryString(hashParams);
          var qs = utils.parseQueryString(queryParams);

          angular.extend(qs, hash);

          if (!qs.error) {
            deferred.resolve(qs);
          }

          Popup.popupWindow.close();
        }
      });

      Popup.popupWindow.addEventListener('loaderror', function() {
        deferred.reject('Authorization Failed');
      });

      return deferred.promise;
    };

    Popup.pollPopup = function(redirectUri) {
      var deferred = $q.defer();

      var redirectUriParser = $document.createElement('a');
      redirectUriParser.href = redirectUri;

      var redirectUriPath = utils.getFullUrlPath(redirectUriParser);

      var polling = $interval(function() {
        if (!Popup.popupWindow || Popup.popupWindow.closed || angular.isUndefined(Popup.popupWindow.closed)) {
          deferred.reject('The popup window was closed.');
          $interval.cancel(polling);
        }

        try {
          var popupWindowPath = utils.getFullUrlPath(Popup.popupWindow.location);

          // Redirect has occurred.
          if (popupWindowPath === redirectUriPath) {
            // Contains query/hash parameters as expected.
            if (Popup.popupWindow.location.search || Popup.popupWindow.location.hash) {
              var queryParams = Popup.popupWindow.location.search.substring(1).replace(/\/$/, '');
              var hashParams = Popup.popupWindow.location.hash.substring(1).replace(/[\/$]/, '');
              var hash = utils.parseQueryString(hashParams);
              var qs = utils.parseQueryString(queryParams);

              angular.extend(qs, hash);

              if (qs.error) {
                deferred.reject(qs);
              } else {
                deferred.resolve(qs);
              }
            } else {
              // Does not contain query/hash parameters, can't do anything at this point.
              deferred.reject(
                'Redirect has occurred but no query or hash parameters were found. ' +
                'They were either not set during the redirect, or were removed before Satellizer ' +
                'could read them, e.g. AngularJS routing mechanism.'
              );
            }

            $interval.cancel(polling);
            Popup.popupWindow.close();
          }
        } catch (error) {
          // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
          // A hack to get around same-origin security policy errors in IE.
        }
      }, 20);

      return deferred.promise;
    };

    Popup.prepareOptions = function(options) {
      options = options || {};
      var width = options.width || 500;
      var height = options.height || 500;

      return angular.extend({
        width: width,
        height: height,
        left: $window.screenX + (($window.outerWidth - width) / 2),
        top: $window.screenY + (($window.outerHeight - height) / 2.5)
      }, options);
    };

    Popup.stringifyOptions = function(options) {
      var parts = [];
      angular.forEach(options, function(value, key) {
        parts.push(key + '=' + value);
      });
      return parts.join(',');
    };

    return Popup;
  }

  angular.module('eHRD.kernel.auth')

    .factory('AuthPopup', AuthPopup)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthOauth2.$inject = [
    '$q',
    '$http',
    '$window',
    '$timeout',
    'AuthPopup',
    'AuthUtils',
    'AuthConfig',
    'AuthStorage'
  ];

  function AuthOauth2($q, $http, $window, $timeout, popup, utils, config, storage) {
    return function() {
      var Oauth2 = {};

      var defaults = {
        defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
        responseType: 'code',
        responseParams: {
          code: 'code',
          clientId: 'clientId',
          redirectUri: 'redirectUri'
        }
      };

      Oauth2.open = function(options, userData) {
        defaults = utils.merge(options, defaults);
        var defer = $q.defer();

        $timeout(function () {
          var url;
          var openPopup;
          var stateName = defaults.name + '_state';

          if (angular.isFunction(defaults.state)) {
            storage.set(stateName, defaults.state());
          } else if (angular.isString(defaults.state)) {
            storage.set(stateName, defaults.state);
          }

          url = [defaults.authorizationEndpoint, Oauth2.buildQueryString()].join('?');

          if ($window.cordova) {
            openPopup = popup.open(url, defaults.name, defaults.popupOptions, defaults.redirectUri).eventListener(defaults.redirectUri);
          } else {
            openPopup = popup.open(url, defaults.name, defaults.popupOptions, defaults.redirectUri).pollPopup(defaults.redirectUri);
          }

          return openPopup
            .then(function(oauthData) {
              // When no server URL provided, return popup params as-is.
              // This is for a scenario when someone wishes to opt out from
              // Satellizer's magic by doing authorization code exchange and
              // saving a token manually.
              if (defaults.responseType === 'token' || !defaults.url) {
                defer.resolve(oauthData);
              }

              if (oauthData.state && oauthData.state !== storage.get(stateName)) {
                return defer.reject(
                  'The value returned in the state parameter does not match the state value from your original ' +
                  'authorization code request.'
                );
              }

              defer.resolve(Oauth2.exchangeForToken(oauthData, userData));
            });
        });

        return defer.promise;
      };

      Oauth2.exchangeForToken = function(oauthData, userData) {
        var data = angular.extend({}, userData);

        angular.forEach(defaults.responseParams, function(value, key) {
          switch (key) {
            case 'code':
              data[value] = oauthData.code;
              break;
            case 'clientId':
              data[value] = defaults.clientId;
              break;
            case 'redirectUri':
              data[value] = defaults.redirectUri;
              break;
            default:
              data[value] = oauthData[key];
          }
        });

        if (oauthData.state) {
          data.state = oauthData.state;
        }

        var exchangeForTokenUrl = config.baseUrl ? utils.joinUrl(config.baseUrl, defaults.url) : defaults.url;

        return $http.post(exchangeForTokenUrl, data, { withCredentials: config.withCredentials });
      };

      Oauth2.buildQueryString = function() {
        var keyValuePairs = [];
        var urlParamsCategories = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];

        angular.forEach(urlParamsCategories, function(paramsCategory) {
          angular.forEach(defaults[paramsCategory], function(paramName) {
            var camelizedName = utils.camelCase(paramName);
            var paramValue = angular.isFunction(defaults[paramName]) ? defaults[paramName]() : defaults[camelizedName];

            if (paramName === 'redirect_uri' && !paramValue) {
              return;
            }

            if (paramName === 'state') {
              var stateName = defaults.name + '_state';
              paramValue = encodeURIComponent(storage.get(stateName));
            }

            if (paramName === 'scope' && angular.isArray(paramValue)) {
              paramValue = paramValue.join(defaults.scopeDelimiter);

              if (defaults.scopePrefix) {
                paramValue = [defaults.scopePrefix, paramValue].join(defaults.scopeDelimiter);
              }
            }

            keyValuePairs.push([paramName, paramValue]);
          });
        });

        return keyValuePairs.map(function(pair) {
          return pair.join('=');
        }).join('&');
      };

      return Oauth2;
    };
  }

  angular.module('eHRD.kernel.auth')

    .factory('AuthOauth2', AuthOauth2)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthOauth1.$inject = [
    '$q',
    '$http',
    'AuthPopup',
    'AuthConfig',
    'AuthUtils'
  ];

  function AuthOauth1($q, $http, popup, config, utils, $window) {
    return function() {
      var Oauth1 = {};

      var defaults = {
        url: null,
        name: null,
        popupOptions: null,
        redirectUri: null,
        authorizationEndpoint: null
      };

      Oauth1.open = function(options, userData) {
        angular.extend(defaults, options);
        var popupWindow;
        var serverUrl = config.baseUrl ? utils.joinUrl(config.baseUrl, defaults.url) : defaults.url;

        if (!$window.cordova) {
          popupWindow = popup.open('', defaults.name, defaults.popupOptions, defaults.redirectUri);
        }

        return $http.post(serverUrl, defaults)
          .then(function(response) {
            var url = [defaults.authorizationEndpoint, Oauth1.buildQueryString(response.data)].join('?');

            if ($window.cordova) {
              popupWindow = popup.open(url, defaults.name, defaults.popupOptions, defaults.redirectUri);
            } else {
              popupWindow.popupWindow.location = url;
            }

            var popupListener;

            if ($window.cordova) {
              popupListener = popupWindow.eventListener(defaults.redirectUri);
            } else {
              popupListener = popupWindow.pollPopup(defaults.redirectUri);
            }

            return popupListener
              .then(function(response) {
                return Oauth1.exchangeForToken(response, userData);
              });
          });

      };

      Oauth1.exchangeForToken = function(oauthData, userData) {
        var data = angular.extend({}, userData, oauthData);
        var exchangeForTokenUrl = config.baseUrl ? utils.joinUrl(config.baseUrl, defaults.url) : defaults.url;
        return $http.post(exchangeForTokenUrl, data, { withCredentials: config.withCredentials });
      };

      Oauth1.buildQueryString = function(obj) {
        var str = [];

        angular.forEach(obj, function(value, key) {
          str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        });

        return str.join('&');
      };

      return Oauth1;
    };
  }
  angular.module('eHRD.kernel.auth')

    .factory('AuthOauth1', AuthOauth1)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthOauth.$inject=[
    '$q',
    '$http',
    'AuthConfig',
    'AuthUtils',
    'AuthShared',
    'AuthOauth1',
    'AuthOauth2'
  ];
  function AuthOauth($q, $http, config, utils, shared, Oauth1, Oauth2) {
    var Oauth = {};

    Oauth.authenticate = function(name, userData) {
      var provider = config.providers[name].oauthType === '1.0' ? new Oauth1() : new Oauth2();
      var deferred = $q.defer();

      provider.open(config.providers[name], userData || {})
        .then(function(response) {
          // This is for a scenario when someone wishes to opt out from
          // Satellizer's magic by doing authorization code exchange and
          // saving a token manually.
          if (config.providers[name].url) {
            shared.setToken(response, false);
          }
          deferred.resolve(response);
        })
        .catch(function(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    };

    Oauth.unlink = function(provider, opts) {
      opts = opts || {};
      opts.url = opts.url ? opts.url : utils.joinUrl(config.baseUrl, config.unlinkUrl);
      opts.data = { provider: provider } || opts.data;
      opts.method = opts.method || 'POST';
      opts.withCredentials = opts.withCredentials || config.withCredentials;

      return $http(opts);
    };

    return Oauth;
  }
  angular.module('eHRD.kernel.auth')

    .factory('AuthOauth', AuthOauth)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthLocal.$inject=[
    '$http',
    'AuthUtils',
    'AuthShared',
    'AuthConfig',
    '$location',
    'serverSetting',
    'EncryptUtils'
  ];

  function AuthLocal($http, utils, shared, config, $location, serverSetting, EncryptUtils){
    var Local = {};

    Local.checkServerStatus = function (data, opts) {
      opts = opts || {};
      opts.url = opts.url ? opts.url : utils.joinUrl(config.baseUrl, config.checkServerStatusUrl);
      opts.data = data || opts.data;
      opts.method = opts.method || 'POST';
      opts.withCredentials = opts.withCredentials || config.withCredentials;

      return $http(opts);
    };

    Local.logout = function () {
      var opts = {};
      if(serverSetting.SSLType === 1){
        var url = [['https', serverSetting.serverDomain].join('://'), serverSetting.SSLPort].join((serverSetting.SSLPort.length > 0) ? ':' : '');
        url = [url, serverSetting.contextPath].join('/');
        opts.url = utils.joinUrl(url, config.logoutUrl);
      }else {
        opts.url = opts.url ? opts.url : utils.joinUrl(config.baseUrl, config.logoutUrl);
      }
      // opts.url = opts.url ? opts.url : utils.joinUrl(config.baseUrl, config.logoutUrl);
      opts.method = 'POST';
      opts.withCredentials = config.withCredentials;

      return $http(opts).then(function(response) {
        shared.logout();
        return response;
      });
    };

    Local.getCasLogoutUrl = function() {
      var opts = {};
      opts.url = utils.joinUrl(config.baseUrl, config.logoutUrl) + '/cas-url';
      opts.method = 'GET';
      opts.withCredentials = config.withCredentials;

      return $http(opts);
    }

    Local.login = function(user, opts) {
      opts = opts || {};
      if(serverSetting.SSLType === 2){
        var url = [['https', serverSetting.serverDomain].join('://'), serverSetting.SSLPort].join((serverSetting.SSLPort.length > 0) ? ':' : '');
            url = [url, serverSetting.contextPath].join('/');
        opts.url = utils.joinUrl(url, config.loginUrl);
      }else{
        opts.url = opts.url ? opts.url : utils.joinUrl(config.baseUrl, config.loginUrl);
      }

      opts.data = user || opts.data;
      opts.method = opts.method || 'POST';
      opts.withCredentials = opts.withCredentials || config.withCredentials;

      EncryptUtils.setProperty({
        plainText: opts.data.password
      });
      opts.data.password = EncryptUtils.Encrypt();

      return $http(opts).then(function(response) {
        shared.setToken(response);
        return response;
      });
    };

    Local.OtherLogin = function () {
      if(serverSetting.authConfig.enabledSSOQueryParams){
        return Local.SSOLogin();
      }else{
        return Local.NTlmLogin();
      }
    };

    Local.NTlmLogin = function () {
      /*
      * create-validation-token.do
      * */
      var opts = {};
      opts.url = utils.joinUrl(config.baseUrl, 'create-validation-token.do');
      opts.method = 'GET';
      opts.withCredentials = config.withCredentials;
      opts.headers= {
        'Accept': 'application/json'
      };
      return $http(opts);
    };

    Local.SSOLogin = function () {
      /*
       * create-validation-token.do
       * */
      var opts = {};
      var ssoQueryParams = '?';
      angular.forEach(serverSetting.authConfig.SSOQueryParamsKey, function (param, index) {
          ssoQueryParams+= param;
          ssoQueryParams+= '=' + $location.search()[param];
          if((index+1) !== serverSetting.authConfig.SSOQueryParamsKey.length) ssoQueryParams+='&'
      });

      opts.url = utils.joinUrl(config.baseUrl, 'create-validation-token.do' + ssoQueryParams);
      opts.method = 'GET';
      opts.withCredentials = config.withCredentials;
      opts.headers= {
        'Accept': 'application/json'
      };
      return $http(opts);
    };

    Local.validateToken = function () {
      /*
       * create-validation-token.do
       * */
      var opts = {};
      opts.url = utils.joinUrl(config.baseUrl, 'create-validation-token.do');
      opts.method = 'GET';
      opts.withCredentials = config.withCredentials;
      opts.headers= {
        'Accept': 'application/json'
      };
      return $http(opts);
    };

    return Local;

  }

  angular.module('eHRD.kernel.auth')

    .factory('AuthLocal', AuthLocal)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  AuthInterceptor.$inject=[
    '$q',
    '$location',
    'AuthConfig',
    'AuthStorage',
    'AuthShared'
  ];

  function AuthInterceptor($q, $location, config, storage, shared) {
    return {
      request: function(request) {
        if (request.skipAuthorization) {
          return request;
        }

        if (shared.isAuthenticated() && config.httpInterceptor(request)) {
          var tokenName = config.tokenPrefix ? [config.tokenPrefix, config.tokenName].join('_') : config.tokenName;
          var token = storage.get(tokenName);

          if (config.authHeader && config.authToken) {
            token = config.authToken + ' ' + token;
          }

          request.headers[config.authHeader] = token;
        }

        return request;
      },
      responseError: function(response) {
        return $q.reject(response);
      }
    };
  }

  angular.module('eHRD.kernel.auth')

    .factory('AuthInterceptor', AuthInterceptor)
  ;

})();

/**
 * Created by Bruce on 2016/7/22.
 */
(function () {
  'use strict';

  function MyErrorHandler($q, $log) {
    return function (part, lang) {
      $log.error('The "' + part + '/' + lang + '" part was not loaded.');
      return $q.when({});
    };
  }

  function RequireTranslations($translatePartialLoader, $translate,$rootScope) {
    return function() {
      angular.forEach(arguments, function(translationKey) {
        $translatePartialLoader.addPart(translationKey);
      });
      return $translate.refresh().then(
        function(){
          return $translate.use($rootScope.currentLanguage);
        }
      );
    };
  }

  angular.module('eHRD.shared')
    .factory('MyErrorHandler', MyErrorHandler)
    .factory('RequireTranslations', RequireTranslations);
})();

// /**
//  * Created by Alan on 2017/5/31.
//  */
//
// (function () {
//   'use strict';
//   sitemapService.$inject = ['Restangular', 'AuthStorage', '$q'];
//   function sitemapService(Restangular, AuthStorage, $q){
//
//     /*
//      * Build collection api/approval
//      */
//     var _sitemapService = Restangular.all('sitemap');
//     var _SitemapLoginService = Restangular.all('sitemap-login');
//     return {
//       getProjectId: function (pid) {
//         /*
//          * api/sitemap//project-info
//          * */
//         if(angular.isUndefinedOrNull(pid) || pid==='')
//           return _sitemapService.customGET('project-info');
//         else
//           return _sitemapService.one("project-info").customGET('review',{projectId:pid});
//       },
//
//       getProject: function (name) {
//         return angular.fromJson(AuthStorage.get("projectData"))[name];
//       },
//
//       loginSitemapRequired: function(params) {
//         /*
//          * api/sitemap-login/info?companyName={companyName}
//          * */
//         var deferred = $q.defer();
//         _SitemapLoginService.customGET('info', params).then(function(data){
//           deferred.resolve(data);
//         });
//
//         return deferred.promise;
//       },
//
//       loginSitemapPreviewRequired: function(params) {
//         /*
//          * api/sitemap-login/info/review?projectId={projectId}
//          * */
//         var deferred = $q.defer();
//         _SitemapLoginService.one('info').customGET('review', params).then(function(data){
//           deferred.resolve(data);
//         });
//
//         return deferred.promise;
//       },
//
//       getOnlineUserNumber: function (params) {
//         /*
//          * api/ctl/online-user-number
//          * */
//         return _SitemapLoginService
//           .customGET('online-user-number', params);
//       }
//
//     };
//
//   }
//
//   angular.module('eHRD.shared')
//     .factory('sitemapService', sitemapService);
//
// })();

(function () {
  'use strict';
  pdpService.$inject = ['Restangular'];
  function pdpService(Restangular){

    /*
     * Build collection api/pdp
     */
    var _pdpService = Restangular.all('pdp');


    return {
      getPdpTermsOfService: function() {
         /*
         * api/pdp/pdp-service-terms
         *  */
         return _pdpService
          .customGET('pdp-service-terms');       
      },
      setPdpAuthorizeAgree: function(agree) {
        /*
         * api/pdp/pdp-set-agree
         *  */
         return _pdpService
          .customPOST({}, 'pdp-set-authorize-agree', {"agree": agree});         
         // return _pdpService
         //  .customGET('pdp-set-authorize-agree/' + agree);
      }
    };

  }

  angular.module('eHRD.shared')
    .factory('pdpService', pdpService);

})();

/**
 * Created by Bruce on 2016/5/12.
 */

(function() {
  'use strict';

  /** @ngInject */
  function navigationServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state) {
      return new _factory();

      function _factory() {
        this.updateScrollbar = function () {};
        this.scrollBarConfig = {
          scrollButtons: {
            enable: false
          },
          autoHideScrollbar: angular.element(this).hasClass('show-scroll') ? false : true,
          theme: 'light-2',
          axis: 'xy', // enable 2 axis scrollbars by default,
          advanced:{
            updateOnContentResize: true
          },
          scrollInertia: 250
        };

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level === 0 ;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level === 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;

          });
          return menuItems.concat(staticMenuItems);
        };



        function defineMenuItemStates() {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta;
            })
            .map(function(s) {
              var meta = s.sidebarMeta;
              return {
                abstract:s.abstract,
                name: s.name,
                title: s.title,
                level: (s.name.match(/\./g) || []).length,
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
                permissions: ((angular.isDefined(s.data) && angular.isDefined(s.data.permissions) && angular.isDefined(s.data.permissions.only)) ? s.data.permissions.only : []),
                permissionsAll: ((angular.isDefined(s.data) && angular.isDefined(s.data.permissions) && angular.isDefined(s.data.permissions.all)) ? s.data.permissions.all : [])
              };
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }
      }

    };
  }

  angular
    .module('eHRD.shared')
    .provider('navigationService', navigationServiceProvider)
  ;


})();



/**
 * Created by Alan on 2017/5/23.
 */

(function () {
  'use strict';
  loginService.$inject = ['Restangular'];
  function loginService(Restangular){

    /*
     * Build collection api/login
     */
    var _LoginService = Restangular.all('login');


    return {
      checkUserLimit: function () {
        /*
         * api/api/login/check-user-limit
         * */
        return _LoginService
          .customGET('check-user-limit');
      },
      checkNewPasswordAuth: function(newPasswordInfo) {
        /*
         * api/api/login/new-password-auth
         *  */
        return _LoginService
          .customPOST(newPasswordInfo, 'new-password-auth');
      }
    };

  }

  angular.module('eHRD.shared')
    .factory('loginService', loginService);

})();

/**
 * Created by Bruce on 2016/5/18.
 */

(function () {
  'use strict';

  CoreService.$inject = ['$window', 'localStorageService', '$cacheFactory', 'Restangular', '$q', '$state', '$http', '$location', 'AuthShared', '$auth', 'serverSetting', 'SweetAlert', 'toastr','$filter'];
  function CoreService($window, localStorageService, $cacheFactory, Restangular, $q, $state, $http, $location, AuthShared, $auth, serverSetting, SweetAlert, toastr, $filter) {
    var core_cache = $cacheFactory('coreCache');

    var refreshAccesstoken = function(/*response*/) {
      var deferred = $q.defer();
      // Refresh access-token logic
      SweetAlert.swal(
        {
          title: '',
          text: $filter('translate')('ERROR.SIGN_IN_USER_TIMEOUT'),
          type: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: $filter('translate')('ACTIONS.LOGIN_AGAIN'),
          allowOutsideClick: false,
          allowEscapeKey: false
        },function () {
          $auth.logout()
            .then(function() {
              //toastr.error($filter('translate')('MESSAGE.YOU_HAVE_BEEN_LOGGED_OUT'));
              AuthShared.logout().then(function () {
                if (serverSetting.authConfig.CAS_ENABLED) {
                  $auth.getCasLogoutUrl().then(function success(response) {
                    var casLogoutUrl = response.data;
                    $window.location.href = casLogoutUrl;
                  });
                }else {
                  $state.go('login');  
                }
              });
            });
        }
      );
      return deferred.promise;
    };

    function responseErrorProcess(errorCode) {
      var deferred = $q.defer();

      // Response Error Process logic
      deferred.reject(true);
      $state.go('error', {id: errorCode});

      return deferred.promise;
    }

    function systemInit() {
      $http.get('assets/info.ini').success(function(data) {
        if(angular.isObject(data)){
          localStorageService.clearAll();
          angular.forEach(data, function (val, key) {
            if(localStorageService.isSupported) {
              localStorageService.set(key, (val.length > 0) ? val : null);
            }
          })
        }
      });
    }

    return{
      refreshAccesstoken: refreshAccesstoken,
      RestangularInit: function () {
        Restangular.setBaseUrl(serverSetting.getServerConfig().baseURL + '/api');
        Restangular.setDefaultHttpFields({'withCredentials':'true'});
        // Restangular.setDefaultHeaders({ClientAuthorization: $auth.getToken()});

        Restangular.addFullRequestInterceptor(function(element, operation, route, url, headers, params, httpConfig) {
          if (operation === 'get' || operation === 'getList' || operation === 'customGET' || operation === 'customGETLIST') {
            httpConfig['ignoreLoadingBar'] = true;
          } else {
            httpConfig['ignoreLoadingBar'] = false;
          }
          return {
            element: element,
            params: params,
            headers: headers,
            httpConfig: httpConfig
          };
        });
        Restangular.setResponseInterceptor(function (data, operation/*, what, url, response, deferred*/) {
          var responseData = data;
          if (operation === 'getList' && data.data) {
            responseData = data.data;
            responseData.metadata = _.omit(data, 'data');
          }else {
            responseData = data.data;
          }
          return responseData; // error handled
        });
        Restangular.setErrorInterceptor(function(response, deferred, responseHandler) {
          switch (response.status){
            case 401:
              core_cache.put('rememberScope', true);
              core_cache.put('currentUser', $auth.getUserData().id);
              refreshAccesstoken(response).then(function() {
                // Repeat the request and then call the handlers the usual way.
                $http(response.config).then(responseHandler, deferred.reject);
                // Be aware that no request interceptors are called this way.
              });
              break;
            default:
              responseErrorProcess(response.status).then(function() {
                // Repeat the request and then call the handlers the usual way.
                $http(response.config).then(responseHandler, deferred.reject);
                // Be aware that no request interceptors are called this way.
              });
              break;
          }
          return false; // error handled
        });
      },
      serverSettingInit: function () {
        serverSetting.setProtocol($location.protocol());
      },
      authInit: function () {
        AuthShared.initToken(serverSetting.authConfig.defaultTokenPrefix + '_' + serverSetting.contextPath);
        $auth.setHttpInterceptor(function() { return true; });
        $auth.setWithCredentials(true);
        $auth.setTokenRoot(null);
        $auth.setBaseUrl(serverSetting.getServerConfig().baseURL);
        $auth.setLoginUrl(serverSetting.getServerConfig().baseApiLoginPath);
        $auth.setUnlinkUrl('/api/unlink/');
        $auth.setTokenName(serverSetting.authConfig.defaultTokenName);
        $auth.setTokenPrefix(serverSetting.authConfig.defaultTokenPrefix + '_' + serverSetting.contextPath);
        $auth.setAuthHeader(serverSetting.authConfig.defaultAuthHeader);
        $auth.setAuthToken(serverSetting.authConfig.defaultAuthToken);
        $auth.setStorageType(serverSetting.authConfig.defaultStorageType);
        // $auth.setAuthType(serverSetting.authConfig.defaultAuthType);
      },
      systemInit: systemInit
    };

  }

  angular.module('eHRD.shared')
    .factory('CoreService',CoreService)
    ;

})();

/**
 * Created by Bruce on 2016/9/26.
 */
(function () {
  'use strict';

  stringToBreadcrumb.inject = ['$state', '$stateParams', 'translateFilter'];
  function stringToBreadcrumb($state, $stateParams, translateFilter) {
    return function (menuList, type, lastLabel) {
      var _lastLabel = lastLabel || null;
      var _menuList = angular.fromJson(menuList);
      var result = '';
      switch (type){
        case 'sitemap-breadcrumb':
          result += '<ol class="breadcrumb">';
          angular.forEach(_menuList, function(value, index) {
            if(value.title !== "root") {
              result += '<li>';
              if (index === _menuList.length - 1 && angular.isUndefinedOrNull(_lastLabel)){
                result += '<span>' + value.title + '</span>';
              } else{
                var _url = $state.$current.url.prefix;
                if($stateParams['cid']) _url += $stateParams['cid'];
                if($stateParams['nid']){
                  if($stateParams['cid'].toString() !== value.id.toString()) {
                    _url = _url + '?nid=' + value.id;
                    if($stateParams['mid']) _url = _url + '&mid=' + $stateParams['mid'];
                  }else {
                    if($stateParams['mid']) _url = _url + '?mid=' + $stateParams['mid'];
                  }
                }else {
                  if($stateParams['mid']) _url = _url + '?mid=' + $stateParams['mid'];
                }
                result += '<a href="#'+ _url + '"><span>' + value.title + '</span></a>';
              }
              result += '</li>';
            }

          });
          if(!angular.isUndefinedOrNull(_lastLabel)){
            result += '<li>';
            result += '<span>' + _lastLabel + '</span>';
            result += '</li>';
          }
          result += '</ol>';
          return result;
        case 'breadcrumb':
          result += '<ol class="breadcrumb">';
          angular.forEach(_menuList, function(value, index) {
            if(value.title !== "root") {
              result += '<li>';
              if (index === _menuList.length - 1 && angular.isUndefinedOrNull(_lastLabel))
                result += '<span>' + value.title + '</span>';
              else
                result += '<a href="#'+ $state.$current.url.prefix + value.id + '"><span>' + value.title + '</span></a>';
              result += '</li>';
            }

          });
          if(!angular.isUndefinedOrNull(_lastLabel)){
            result += '<li>';
             result += '<span>' + _lastLabel + '</span>';
            result += '</li>';
          }
          result += '</ol>';
          return result;
        case 'text':
          angular.forEach(_menuList, function(value, index) {
            if(index === _menuList.length-1){
              result = (value.title === "root" ? translateFilter(value.title): value.title);
            }
          });
          return result;
        case 'programSessionInfoBreadcrumb':
          result +=  '<ol class="breadcrumb">';
          angular.forEach(_menuList, function(value) {

            result += '<li>';
            if (value.patch)
             result += '<a href=\"' + value.patch + '\">' + value.title + '</a>';
            else if(value.patch === null)
              result += '<span>' + value.title + '</span>';
            result += '</li>';
          });
          result += '</ol>';
          return result;
      }


    }
  }

  angular.module('eHRD.shared')
    .filter('stringToBreadcrumb', stringToBreadcrumb)
})();

/**
 * Created by Bruce on 2016/10/19.
 */

(function () {
  'use strict';

  serverSettingProvider.$inject = [
    'defaultServerAddress',
    'defaultServerDomain',
    'defaultContextPath',
    'defaultServerPort',
    'webServiceSetting',
    'serverAddress',
    'serverDomain',
    'contextPath',
    'serverPort',
    'SSLType',
    'SSLPort',
    'enabledSSOQueryParams',
    'SSOQueryParamsKey',
    'defaultSSLType',
    'CAS_ENABLED',
    'CAS_VALIDATE_PATH'
  ];
  /* @ngInject */
  function serverSettingProvider(defaultServerAddress, defaultServerDomain, defaultContextPath, defaultServerPort,
                                 webServiceSetting, serverAddress, serverDomain, contextPath, serverPort, SSLType,
                                 SSLPort,
                                 enabledSSOQueryParams, SSOQueryParamsKey, defaultSSLType, CAS_ENABLED, CAS_VALIDATE_PATH ){

    this.protocol = 'http';

    if(serverAddress.length > 0){
      this.defaultServerAddress = serverAddress;
      this.serverDomain = serverDomain;
      this.contextPath = contextPath;
      this.serverPort = serverPort;
      this.SSLType = SSLType;
      this.SSLPort = SSLPort;
    }else{
      this.defaultServerAddress = defaultServerAddress;
      this.serverDomain = defaultServerDomain;
      this.contextPath = defaultContextPath;
      this.serverPort = defaultServerPort;
      this.SSLType = defaultSSLType;
    }

    this.webServiceSetting = webServiceSetting;

    var baseURL = "";
    if(this.SSLType === 1){
      baseURL = [['https', this.serverDomain].join('://'), this.SSLPort].join((this.SSLPort.length > 0) ? ':' : '');
      baseURL = [baseURL, this.contextPath].join('/');
    }else {
      baseURL = this.defaultServerAddress +((this.serverPort.length > 0) ? ':'+ this.serverPort : '' ) + '/' + this.contextPath;
    }

    this.baseConfig = {
        serverAddress: this.defaultServerAddress +((this.serverPort.length > 0) ? ':'+ this.serverPort : '' ),
        baseURL: baseURL,
        baseApiLoginPath: this.webServiceSetting.defaultApiPath + this.webServiceSetting.defaultApiLoginPath,
        baseApiPath: this.webServiceSetting.defaultApiPath,
        baseApiFileProcessPath: this.webServiceSetting.defaultApiPath + this.webServiceSetting.defaultApiFileProcessPath
    };

    this.authConfig = {
      defaultApiPath: this.webServiceSetting.defaultApiPath,
      defaultApiFileProcessPath: this.webServiceSetting.defaultApiFileProcessPath,
      defaultApiLoginPath: this.webServiceSetting.defaultApiLoginPath,
      defaultTokenName: this.webServiceSetting.defaultTokenName,
      defaultTokenPrefix: this.webServiceSetting.defaultTokenPrefix,
      defaultAuthHeader: this.webServiceSetting.defaultAuthHeader,
      defaultAuthToken: this.webServiceSetting.defaultAuthToken,
      defaultStorageType: this.webServiceSetting.defaultStorageType,
      enabledSSOQueryParams: enabledSSOQueryParams,
      SSOQueryParamsKey: SSOQueryParamsKey,
      CAS_ENABLED: CAS_ENABLED,
      CAS_VALIDATE_PATH: CAS_VALIDATE_PATH
    };

    this.$get = function () {
      var vm = this;
      return{
        getProtocol: function(){
          return vm.protocol;
        },
        setProtocol: function (val) {
          vm.protocol = val;
          if( vm.protocol === 'https' && vm.SSLType === 1 ){
            vm.defaultServerAddress = [vm.protocol, vm.serverDomain].join('://');
            vm.baseConfig = {
              serverAddress: vm.defaultServerAddress +((vm.SSLPort.length > 0) ? ':'+ vm.SSLPort : '' ),
              baseURL: vm.defaultServerAddress +((vm.SSLPort.length > 0) ? ':'+ vm.SSLPort : '' ) + '/' + vm.contextPath,
              baseApiLoginPath: vm.webServiceSetting.defaultApiPath + vm.webServiceSetting.defaultApiLoginPath,
              baseApiPath: vm.webServiceSetting.defaultApiPath,
              baseApiFileProcessPath: vm.webServiceSetting.defaultApiPath + vm.webServiceSetting.defaultApiFileProcessPath
            };
          }
        },
        getAuthConfig: function () {
          return vm.authConfig;
        },
        getServerConfig: function () {
            return vm.baseConfig;
        },
        getServerPath: function () {
          return vm.baseConfig.baseURL;
        },
        defaultServerAddress: vm.defaultServerAddress,
        contextPath: vm.contextPath,
        webServiceSetting: vm.webServiceSetting,
        baseConfig: vm.baseConfig,
        clientConfig: vm.clientConfig,
        authConfig: vm.authConfig,
        protocol: vm.protocol,
        SSLType: vm.SSLType,
        SSLPort: vm.SSLPort,
        serverDomain: vm.serverDomain
      };
    }
  }

  angular.module('eHRD.shared')
    .provider('serverSetting', serverSettingProvider);
})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function() {
  'use strict';

  angular
    .module('eHRD.shared')
    .directive('themeTopBar', themeTopBar)
  ;

  /*
   * topnavbar
   * */
  function themeTopBar($timeout) {
    function link() {
      // Call the metsiMenu plugin and plug it to sidebar navigation
      $timeout(function(){

      });
    }
    var directive = {
      templateUrl: 'app/shared/views/topbar.html',
      restrict: 'E',
      link: link,
      controller: ['$scope','PermPermissionStore', function ($scope, PermPermissionStore) {
        var vm = this,
        isManager = PermPermissionStore.hasPermissionDefinition('Manager_Privilege'),
        hasApprovalPermission = PermPermissionStore.hasPermissionDefinition('Approval_Privilege');


        function _showApprovalIcon(){
          if(isManager)
            return true;
          var userToDo=$scope.UC.userToDo;
          if(hasApprovalPermission && (angular.isDefined(userToDo) && userToDo.penddingCount > 0))
            return true;
          return false;
        };

        $scope.$watch(function(){
          return angular.element(document.querySelectorAll(".topbar"))[0].clientWidth;
        },function(){
          var topbarWidth = angular.element(document.querySelectorAll(".topbar"));
          if (topbarWidth[0].clientWidth < 238) {
            vm.humanAvatar = {
              overflow: 'hidden'
            };
          } else {
            vm.humanAvatar = {};
          }
        });

        $scope.$watch(function(){
          return $scope.UC.userToDo;
        },function(){
          vm.showApprovalIcon=_showApprovalIcon();
        });

      }],
      controllerAs: '$ctrl'
     };
    return directive;
  }

})();




/**
 * Created by Bruce on 2016/5/11.
 */

(function() {
  'use strict';

  themeMaterialInit.$inject=[
    '$timeout'
  ];
  function themeMaterialInit($timeout) {

    function link() {
      $timeout(function(){
        angular.element.material.init();
      },0);
    }
    var directive = {
      link: link
     };
    return directive;
  }

  angular
    .module('eHRD.shared')
    .directive('themeMaterialInit', themeMaterialInit)
  ;

})();




/**
 * Created by Bruce on 2016/5/11.
 */

(function() {
  'use strict';

  themeApplication.$inject=[
    '$timeout','$window'
  ];
  function themeApplication($timeout, $window) {

    var windowWidth;
    var windowHeight;
    var topbarWidth;
    var headerLeftWidth;
    var headerRightWidth;

    function applicationService(){

      return {

        /* ==========================================================*/
        /* BEGIN OTHER                                               */
        /* ========================================================= */

        /* Switch Top navigation to Sidebar */
        reposition_topnav: function() {
          if (angular.element('.nav-horizontal').length > 0) {
            topbarWidth = angular.element('.topbar').width();
            headerRightWidth = angular.element('.header-right').width();
            if (angular.element('.header-left .nav-horizontal').length) headerLeftWidth = angular.element('.header-left').width() + 40;
            else headerLeftWidth = angular.element('.nav-sidebar.nav-horizontal > li').length * 140;
            var topbarSpace = topbarWidth - headerLeftWidth - headerRightWidth;
            // top navigation move to left nav if not enough space in topbar
            if (angular.element('.nav-horizontal').css('position') == 'relative' || topbarSpace < 0) {
              if (angular.element('.sidebar .nav-sidebar').length == 2) {
                angular.element('.nav-horizontal').insertAfter('.nav-sidebar:eq(1)');
              } else {
                // only add to bottom if .nav-horizontal is not yet in the left panel
                if (angular.element('.sidebar .nav-horizontal').length == 0) {
                  angular.element('.nav-horizontal').appendTo('.sidebar-inner');
                  angular.element('.sidebar-widgets').css('margin-bottom', 20);
                }
              }
              angular.element('.nav-horizontal').css({
                display: 'block'
              }).addClass('nav-sidebar').css('margin-bottom', 100);
              // applicationService().createSideScroll();
              angular.element('.nav-horizontal .children').removeClass('dropdown-menu');
              angular.element('.nav-horizontal > li').each(function () {
                angular.element(this).removeClass('open');
                angular.element(this).find('a').removeAttr('class');
                angular.element(this).find('a').removeAttr('data-toggle');
              });
              /* We hide mega menu in sidebar since video / images are too big and not adapted to sidebar */
              if (angular.element('.nav-horizontal').hasClass('mmenu')) angular.element('.nav-horizontal.mmenu').css('height', 0).css('overflow', 'hidden');
            } else {
              if (angular.element('.sidebar .nav-horizontal').length > 0) {
                angular.element('.sidebar-widgets').css('margin-bottom', 100);
                angular.element('.nav-horizontal').removeClass('nav-sidebar').appendTo('.topnav');
                angular.element('.nav-horizontal .children').addClass('dropdown-menu').removeAttr('style');
                angular.element('.nav-horizontal li:last-child').show();
                angular.element('.nav-horizontal > li > a').each(function () {
                  angular.element(this).parent().removeClass('active');
                  if (angular.element(this).parent().find('.dropdown-menu').length > 0) {
                    angular.element(this).attr('class', 'dropdown-toggle');
                    angular.element(this).attr('data-toggle', 'dropdown');
                  }
                });
              }
              /* If mega menu, we make it visible */
              if (angular.element('.nav-horizontal').hasClass('mmenu')) angular.element('.nav-horizontal.mmenu').css('height', '').css('overflow', '');
            }
          }
        },

        /***** Scroll to top button *****/
        scrollTop: function() {
          angular.element(window).scroll(function () {
            if (angular.element(this).scrollTop() > 100) {
              angular.element('.scrollup').fadeIn();
            } else {
              angular.element('.scrollup').fadeOut();
            }
          });
          angular.element('.scrollup').click(function () {
            angular.element("html, body").animate({
              scrollTop: 0
            }, 1000);
            return false;
          });
        },

        sidebarBehaviour: function() {
          windowWidth = angular.element(window).width();
          windowHeight = angular.element(window).height() - angular.element('.topbar').height();
          var sidebarMenuHeight = angular.element('.nav-sidebar').height();
          if (windowWidth < 1024) {
            angular.element('body').removeClass('sidebar-collapsed');
          }
          if (angular.element('body').hasClass('sidebar-collapsed') && sidebarMenuHeight > windowHeight) {
            angular.element('body').removeClass('fixed-sidebar');
            // applicationService().destroySideScroll();
          }
        },

        mobileSidebar: function(){
          angular.element('html').on('click', '.sidebar-show .nav-sidebar li:not(.metismenu-parent) > a',function(){
            angular.element('body').removeClass('sidebar-show');
          });
        },

        detectIE: function() {
          var ua = navigator.userAgent;
          var msie = ua.indexOf('MSIE ');
          var trident = ua.indexOf('Trident/');
          var edge = ua.indexOf('Edge/');
          if (msie > 0 || trident > 0 || edge > 0) {
            angular.element('html').addClass('ie-browser');
          }
        },

        /* ========================================================= */
        /*********************** END OTHER  **************************/
        /* ========================================================= */


        init: function () {

          windowHeight = angular.element(window).height();
          topbarWidth = angular.element('.topbar').width();
          headerLeftWidth = angular.element('.header-left').width();
          headerRightWidth = angular.element('.header-right').width();

          // Check if sidebar is collapsed
          if ( angular.element('body').hasClass('sidebar-collapsed'))
            angular.element('.nav-sidebar .children').css({
              display: ''
            });

          applicationService().reposition_topnav();
          applicationService().scrollTop();
          applicationService().sidebarBehaviour();
          applicationService().detectIE();
          applicationService().mobileSidebar();

        }
      };
    }

    function link($scope, element) {

      $timeout(function(){
        angular.element.material.init();
        // Theme Application Init
        applicationService().init($scope, element);

        angular.element('.main-content .page-content > .row').css("min-height", angular.element($window).height());
        // Window resize Function
        angular.element(window).bind("resize", function() {
          $timeout(function () {
            applicationService().reposition_topnav();
            if (!angular.element('body').hasClass('fixed-sidebar') && !angular.element('body').hasClass('builder-admin')) applicationService().sidebarBehaviour();
          }, 100);
        });
      });
    }
    var directive = {
      link: link
     };
    return directive;
  }

  angular
    .module('eHRD.shared')
    .directive('themeApplication', themeApplication)
  ;

})();



/**
 * Created by Bruce on 2016/6/23.
 */

(function() {
  'use strict';

  /*
   * themeSidebarHandle
   * */
  themeSidebarHandle.$inject = ['$timeout', 'navigationService'];
  function themeSidebarHandle($timeout, navigationService) {

    function link(scope/*, elem, attrs*/) {
      $timeout(function(){
        navigationService.updateScrollbar('scrollTo', 10);

        if (angular.element('body').hasClass('sidebar-collapsed')) {
          navigationService.updateScrollbar('destroy');
          angular.element('body').addClass('sidebar-collapsed');
          angular.element('.sidebar').css('width', '').resizable().resizable('destroy');
          angular.element('.nav-sidebar ul').attr('style', '');
          angular.element(this).addClass('menu-collapsed');
          angular.element('#switch-sidebar').prop('checked');
        }
        else {
          navigationService.scrollBarConfig = {
            scrollButtons: {
              enable: false
            },
            autoHideScrollbar: angular.element(this).hasClass('show-scroll') ? false : true,
            theme: 'light-2',
            axis: 'xy', // enable 2 axis scrollbars by default,
            advanced:{
              updateOnContentResize: true
            },
            scrollInertia: 250
          };
        }

        /* Toggle submenu open */
        // Check if sidebar is collapsed
        if (angular.element('body').hasClass('sidebar-collapsed') || angular.element('body').hasClass('sidebar-top') || angular.element('body').hasClass('submenu-hover')){
          angular.element('.nav-sidebar .children').css({
            display: ''
          });
        }else{
          angular.element('.nav-active.active .children').css('display', 'block');
        }
        angular.element('.sidebar').on('click', '.nav-sidebar li.nav-parent > a', function (e) {
          e.preventDefault();
          angular.element('.nav-active.active .children').css('display', 'block');
          if (angular.element('body').hasClass('sidebar-collapsed') && !angular.element('body').hasClass('sidebar-hover')) return;
          if (angular.element('body').hasClass('submenu-hover')) return;
          var parent = angular.element(this).parent().parent();
          parent.children('li.active').children('.children').slideUp(200);
          angular.element('.nav-sidebar .arrow').removeClass('active');
          parent.children('li.active').removeClass('active');
          var sub = angular.element(this).next();
          if (sub.is(":visible")) {
            sub.children().addClass('hidden-item')
            angular.element(this).parent().removeClass("active");
            sub.slideUp(200, function () {
              sub.children().removeClass('hidden-item')
            });
          } else {
            angular.element(this).find('.arrow').addClass('active');
            sub.children().addClass('is-hidden');
            $timeout(function () {
              sub.children().addClass('is-shown');
            }, 0);
            sub.slideDown(200, function () {
              angular.element(this).parent().addClass("active");
              // applicationService().createSideScroll();
              $timeout(function () {
                sub.children().removeClass('is-hidden').removeClass('is-shown');
              }, 500);
            });
          }

        });
      });
    }
    var directive = {
      restrict: 'A',
      link: link
    };
    return directive;
  }

  angular
    .module('eHRD.shared')
    .directive('themeSidebarHandle', themeSidebarHandle)
  ;

})();



/**
 * Created by Bruce on 2016/6/24.
 */
(function() {
  'use strict';

  /*
   * themeSidebarCollapsed
   * */
  themeSidebarCollapsed.$inject = ['$timeout', '$state', 'navigationService'];
  function themeSidebarCollapsed($timeout, $state, navigationService) {

    function link(scope, elem/*, attrs*/) {
      $timeout(function(){
        elem.bind('click', function(event) {
          event.preventDefault();
          //Click top bar to expend all folder with  knowledgeManagementCenter, reportsZone and courseResource
          if ((angular.element('body').hasClass('sidebar-collapsed') || angular.element('body').css('position') === 'relative') &&
            $state.includes('knowledgeManagementCenter.*') || $state.includes('reportsZone') ||
            $state.includes('courseResourceCatalog.*') || $state.includes('courseResourceCatalog.*.*')) {
            angular.element('.nav-sidebar li ul').css({
              display: 'block'
            });
          }
          var toggleLayout = angular.element(this).data('toggle');
          if (toggleLayout === 'sidebar-collapsed') collapsedSidebar();
        });

        function collapsedSidebar() {
          if (angular.element('body').css('position') !== 'relative') {
            if (!angular.element('body').hasClass('sidebar-collapsed')) {
              navigationService.updateScrollbar('destroy');
              angular.element('body').addClass('sidebar-collapsed');
              angular.element('.sidebar').css('width', '').resizable().resizable('destroy');
              angular.element('.nav-sidebar ul').attr('style', '');
              angular.element(this).addClass('menu-collapsed');
              angular.element('#switch-sidebar').prop('checked');
            } else{
              navigationService.scrollBarConfig = {
                scrollButtons: {
                  enable: false
                },
                autoHideScrollbar: angular.element(this).hasClass('show-scroll') ? false : true,
                theme: 'light-2',
                axis: 'xy', // enable 2 axis scrollbars by default,
                advanced:{
                  updateOnContentResize: true
                },
                scrollInertia: 250
              };
              angular.element('body').removeClass('sidebar-collapsed');
              if (!angular.element('body').hasClass('submenu-hover'))

                angular.element('.nav-sidebar li.active ul').css({
                  display: 'block'
                });
              angular.element(this).removeClass('menu-collapsed');
              if (angular.element('body').hasClass('sidebar-light') && !angular.element('body').hasClass('sidebar-fixed')) {
                angular.element('.sidebar').height('');

              }
            }
          } else {
            if (angular.element('body').hasClass('sidebar-show')) angular.element('body').removeClass('sidebar-show');
            else angular.element('body').addClass('sidebar-show');
          }
        }

      });
    }
    var directive = {
      restrict: 'A',
      link: link
    };
    return directive;
  }

  angular
    .module('eHRD.shared')
    .directive('themeSidebarCollapsed', themeSidebarCollapsed)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function() {
  'use strict';

  angular
    .module('eHRD.shared')
    .directive('pageTitle', pageTitle)
  ;



  // pageTitle
  function pageTitle($timeout, $filter, sitemapService, AuthStorage) {
    function link(scope, element) {
      var listener = function() {
        // Default title - load on Dashboard 1
        var title = angular.isDefined(AuthStorage.get("projectData")) ? sitemapService.getProject('broswerTitle') : 'eHRD | Learning System';
        // Create your own title pattern
        $timeout(function() {
          element.text(title);
        });
      };
      scope.$on('$stateChangeSuccess', listener);
    }
    var directive = {
      link: link
    };

    return directive;
  }

})();

/**
 * Created by Bruce on 2016/6/8.
 */
(function () {
  'use strict';

  //ngSpinnerLoader
  ngSpinnerLoader.$inject = ['$rootScope', '$timeout','$state'];
  function ngSpinnerLoader($rootScope, $timeout, $state){

    function link(scope, element) {

      // by defult hide the spinner bar
      element.addClass('hide'); // hide spinner bar by default
      // display the spinner bar whenever the route changes(the content part started loading)
      var routeChangeStart = $rootScope.$on('$stateChangeStart', function() {
        // if( $state.current.name !== 'modules.error') {
        //   element.removeClass('hide'); // show spinner bar
        // }
        // if ($state.current.name === 'login' || $state.current_name === ''){
        //   element.addClass('hide');
        // }
      });
      $rootScope.$on('$destroy', routeChangeStart);

      var stateChangeError= $rootScope.$on('$stateChangeError', function() {
          $timeout(function(){
            element.addClass('hide'); // hide spinner bar
          },500);
          angular.element("html, body").animate({
            scrollTop: 0
          }, 500);
      });
      $rootScope.$on('$destroy', stateChangeError);

      // hide the spinner bar on rounte change success(after the content loaded)
      var routeChangeSuccess = $rootScope.$on('$stateChangeSuccess', function() {
        $timeout(function(){
          element.addClass('hide'); // hide spinner bar
        },500);
        angular.element("html, body").animate({
          scrollTop: 0
        }, 500);
      });
      $rootScope.$on('$destroy', routeChangeSuccess);
    }
    var directive = {
      link :link
    };

    return directive;
  }


  angular.module('eHRD.shared')
    .directive('ngSpinnerLoader', ngSpinnerLoader);
})();

/**
 * Created by Alan on 2017/3/28.
 */

(function () {
  'use strict';

  mobileSidebar.$inject = ['$timeout'];
  function mobileSidebar($timeout) {
    var directive = {
      restrict: 'A',
        scope: false,
      link: function (scope, element) {
        element.hover(function () {
          if (angular.element('body').hasClass('sidebar-collapsed') && angular.element('body').css('position') !== 'relative') {

            element.find('ul').css('visibility','hidden');
            element.removeClass('active');
          }
        }, function () {
            if (angular.element('body').hasClass('sidebar-collapsed') && angular.element('body').css('position') !== 'relative') {
              $timeout(function () {
                  element.find('ul').css('visibility','');
                }, 200);
            }
        });

        element.click(function() {
          if (angular.element('body').hasClass('sidebar-collapsed') && angular.element('body').css('position') !== 'relative') {
            angular.element('.nav-sidebar li.active ul').css('visibility','');
            angular.element('body').removeClass('sidebar-collapsed');
            angular.element('.nav-sidebar li ul').css({
              display: 'block'
            });
          }
        });
      }
    };
    return directive;
  }

  angular.module('eHRD.shared')
    .directive('mobileSidebar', mobileSidebar);

})();

/**
 * Created by Alan on 2016/11/8.
 */

(function() {
    'use strict';

    angular
        .module('eHRD.shared')
        .directive('mdDatepickerFocusOpen', mdDatepickerFocusOpen);



    // pageTitle
    function mdDatepickerFocusOpen($timeout) {
        function link (scope, element, attributes, DatePickerCtrl) {
            element.find('input').on('click', function (e) {
                $timeout(DatePickerCtrl.openCalendarPane.bind(DatePickerCtrl, e));
            });
        }

        var directive = {
            restrict: 'A',
            require: 'mdDatepicker',
            link: link
        };

        return directive;
    }

})();

/**
 * Created by Alan on 2016/11/4.
 */

(function() {
  'use strict';

  angular
    .module('eHRD.shared')
    .directive('embedSrc', embedSrc)
  ;



  // pageTitle
  function embedSrc() {
    function link(scope, element, attrs) {
      var current = element;
      scope.$watch(function() { return attrs.embedSrc; }, function () {
        var clone = element
            .clone()
            .attr('src', attrs.embedSrc);
        current.replaceWith(clone);
        current = clone;
      });
    }
    var directive = {
      restrict: 'A',
      link: link
    };

    return directive;
  }

})();

/**
 * Created by Bruce on 2016/6/4.
 */
(function () {
  'use strict';

  countTo.$inject = ['$timeout'];
  function countTo($timeout) {
    function link(scope, element, attrs){

      var e = element[0];
      var num, refreshInterval, duration, steps, step, countTo, increment;

      var calculate = function () {
        refreshInterval = 30;
        step = 0;
        scope.timoutId = null;
        countTo = parseFloat(attrs.countTo) || 0;
        scope.value = parseFloat(attrs.value, 10) || 0;
        duration = (parseFloat(attrs.duration) * 1000) || 0;

        steps = Math.ceil(duration / refreshInterval);
        increment = ((countTo - scope.value) / steps);
        num = scope.value;
      };

      var tick = function () {
        scope.timoutId = $timeout(function () {
          num += increment;
          step++;
          if (step >= steps) {
            $timeout.cancel(scope.timoutId);
            num = countTo;
            e.textContent = countTo;
          } else {
            e.textContent = Math.round(num);
            tick();
          }
        }, refreshInterval);

      };

      var start = function () {
        if (scope.timoutId) {
          $timeout.cancel(scope.timoutId);
        }
        calculate();
        tick();
      };

      attrs.$observe('countTo', function (val) {
        if (val) {
          start();
        }
      });

      attrs.$observe('value', function () {
        start();
      });

      return true;
    }

    var directive ={
      replace: false,
      scope: true,
      link: link
    };
    return directive;
  }


  angular.module('eHRD.shared')
    .directive('countTo', countTo);
})();

/**
 * Created by Bruce on 2016/5/12.
 */

(function() {
  'use strict';

  /**
   * translateCtrl - Controller for translate
   */
  function translateCtrl($translate) {
    var vm = this;
    vm.changeLanguage = function (langKey) {
      $translate.use(langKey);
      vm.language = langKey;
    };
  }

  angular
    .module('eHRD.shared')
    .controller('TranslateController', translateCtrl);
})();



/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  LogoutController.$inject = [ '$auth', 'toastr', '$state', 'serverSetting', '$window'/*,'Restangular','$filter'/*, '$location'*/];
  function LogoutController($auth, toastr, $state, serverSetting, $window/*, Restangular, $filter, $location*/) {
    if (!$auth.isAuthenticated()) { return; }
    $auth.logout()
      .then(function() {
        // Restangular.all('logout').post().then(function () {
          //toastr.error($filter('translate')('MESSAGE.YOU_HAVE_BEEN_LOGGED_OUT'));
          
          if (serverSetting.authConfig.CAS_ENABLED) {
            $auth.getCasLogoutUrl().then(function success(response) {
              var casLogoutUrl = response.data;
              $window.location.href = casLogoutUrl;
            });
          }else {
            $auth._redirct = 'logout';
            $state.go('login', {}, { reload: true });
          }
        // });
      });
  }

  angular.module('eHRD.shared')
    .controller('LogoutController', LogoutController)
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  LoginController.$inject = ['$cacheFactory', '$scope', '$location', '$auth', 'toastr', '$filter', '$translate', 'cfpLoadingBar', 'amMoment', '$state', 'loginService', '$stateParams', 'sitemapService', '$mdDialog'];
  function LoginController($cacheFactory, $scope, $location, $auth, toastr, $filter, $translate, cfpLoadingBar, amMoment, $state, loginService, $stateParams, sitemapService, $mdDialog) {
    var vm = this;

    vm.isLoginPage = true;
    vm.checkUserLimit = 1;
    loginService.checkUserLimit().then(function(result){
      vm.checkUserLimit = result.status;
    });
    sitemapService.getOnlineUserNumber().then(function(result){
      vm.number = result.number;
    });
    vm.isPreview = !(angular.isUndefinedOrNull($stateParams.pid) || $stateParams.pid==='');

    var loginSitmap = $state.$current.locals.globals.loginSitemapRequired;

    switch ($translate.use()){
      case 'en-us':
        vm.headWording = loginSitmap.headWording.en;
        vm.footWording = loginSitmap.footWording.en;
        break;
      case 'zh-tw':
        vm.headWording = loginSitmap.headWording.tw;
        vm.footWording = loginSitmap.footWording.tw;
        break;
      case 'zh-cn':
        vm.headWording = loginSitmap.headWording.cn;
        vm.footWording = loginSitmap.footWording.cn;
        break;
    }
    vm.copyright = loginSitmap.copyright;
    vm.logoUrl = loginSitmap.logoUrl;
    sitemapService.setMaterialColor( loginSitmap.panelType);

    vm.login = function(valid, ev) {
      if(valid){
        cfpLoadingBar.start();
        $auth.login($scope.user)
          .then(function(status) {
            if(angular.isDefined($auth.getUserData())){
              if($auth.getUserData().rc === 'en'){
                $translate.use('en_us');
              }else{
                $translate.use($auth.getUserData().rc);
              }
              amMoment.changeLocale($translate.use());
            }
            /*
            $translate('MESSAGE.YOU_HAVE_SUCCESSFULLY_SIGNED_IN').then(function (translation) {
              toastr.success(translation);
            });
            */
            if( angular.isDefined($auth._redirct) && $auth._redirct!=='/login' && $auth._redirct!=='/logout' && $auth._redirct!== '/' ){
              if($cacheFactory.get('coreCache') && $cacheFactory.get('coreCache').get('currentUser') &&
                (!angular.equals($cacheFactory.get('coreCache').get('currentUser'), $auth.getUserData().id))
              ){
                $cacheFactory.get('coreCache').put('rememberScope', false);
                defaultRedirct();
              }else{
                $location.path($auth._redirct).search($auth._redirctSearch);
              }
            }else {
              if(angular.isDefined($auth.getUserData())){
                var changePassword = $auth.getUserData().changePassword
                if(angular.isDefined(changePassword) && changePassword) {
                  $mdDialog.show({
                    templateUrl: 'app/shared/views/login-change-password.html',
                    controller: [
                      function () {
                        var dialog = this;
                        dialog.oldPassword;
                        dialog.newPassword;
                        dialog.newPassword2;
                        dialog.message;
                        dialog.status;
                        dialog.auth = function() {
                          dialog.status = vm.newPasswordAuth(dialog)
                          if (dialog.status) {
                            var newPasswordInfo = {
                              oldPassword : dialog.oldPassword,
                              newPassword :dialog.newPassword,
                              currentUserId : $auth.getUserData().id
                            }

                            loginService.checkNewPasswordAuth(newPasswordInfo)
                            .then(function(result){
                              if (result.status) {
                                defaultRedirct();
                                $mdDialog.cancel();
                              } else {
                                dialog.status = result.status;
                                dialog.message = result.message;
                              }
                            });
                          }
                        }
                      }
                    ],
                    controllerAs: '$ctrl',
                    targetEvent: ev
                  })
                } else {
                  defaultRedirct();
                }
              } else {
                defaultRedirct();
              }
            }

            function defaultRedirct() {
              if(angular.isDefined($auth.getUserData())){
                sitemapService.getProjectId($stateParams.pid).then(function(data){
                  sitemapService.getProjectSideMenu(data.projectId).then(function (menuItems) {
                    sitemapService.setMenu(menuItems);
                      switch ($auth.getUserData().DefaultLoginPage){
                        case 'homepage':
                          $state.go('index');
                          break;
                        case 'overview':
                          $state.go('learningPassport.learningDashboard');
                          break;
                        default:
                          $location.path('/');
                      }
                  });
                });
              }else {
                vm.errorData = status.data;
                switch(status.data) {
                  case 'sign_in_user_limit':
                    toastr.error($filter('translate')('ERROR.SIGN_IN_USER_LIMIT'));
                    break;
                  case 'c_sign_in_user_disabled':
                    toastr.error($filter('translate')('ERROR.C_SIGN_IN_USER_DISABLED'));
                    break;
                  case 'sign_in_user_notfound':
                    toastr.error($filter('translate')('ERROR.SIGN_IN_USER_NOT_FOUND'));
                    break;
                  case 'sign_in_re_ask_password':
                    toastr.error($filter('translate')('ERROR.ACCOUNT_OR_PASSWORD_ERROR') + $filter('translate')('FORM_VALIDATION.PLEASE_RE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD'));
                    break;
                }
              }
            }
          })
          .catch(function(error) {
            if (error.error) {
              // Popup error - invalid redirect_uri, pressed cancel button, etc.
              toastr.error( $filter('translate')('ERROR.ACCOUNT_OR_PASSWORD_ERROR') + $filter('translate')('FORM_VALIDATION.PLEASE_RE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD'));
            }
            else {
              if(error.status === -1){
                toastr.error($filter('translate')('ERROR.SERVERS_ERROR'));
              }else{
                toastr.error( $filter('translate')('ERROR.ACCOUNT_OR_PASSWORD_ERROR') + $filter('translate')('FORM_VALIDATION.PLEASE_RE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD'));
              }
            }
          })
          .finally(function () {
            cfpLoadingBar.complete();
          });
      }
    };

    vm.authenticate = function(provider) {
      $auth.authenticate(provider)
        .then(function() {
          toastr.success('You have successfully signed in with ' + provider + '!');
          $location.path('/');
        })
        .catch(function(error) {
          if (error.error) {
            // Popup error - invalid redirect_uri, pressed cancel button, etc.
            toastr.error(error.error);
          } else if (error.data) {
            // HTTP response error from server
            toastr.error(error.data.message, error.status);
          } else {
            toastr.error(error);
          }
        });
    };

    vm.newPasswordAuth = function(fm) {
      if (angular.isUndefinedOrNull(fm.oldPassword) || fm.oldPassword === '') {
        fm.message = $filter('translate')('ERROR.PLEASE_ENTER_OLD_PWD')
        return false;
      }
      if (angular.isUndefinedOrNull(fm.newPassword) || fm.newPassword === '') {
        fm.message = $filter('translate')('ERROR.PLEASE_ENTER_NEW_PWD')
        return false;
      }
      if (angular.isUndefinedOrNull(fm.newPassword2) || fm.newPassword2 === '') {
        fm.message = $filter('translate')('ERROR.PLEASE_ENTER_NEW_PWD_AGAIN')
        return false;
      }
      if (fm.newPassword !== fm.newPassword2) {
        fm.message = $filter('translate')('ERROR.NEW_PWD_INCONSISTENT')
        return false;
      }
      if (fm.newPassword === fm.oldPassword) {
        fm.message = $filter('translate')('ERROR.OLD_NEW_PWD_CONSISTENT')
        return false;
      }
      if (fm.newPassword.length < 4) {
        fm.message = $filter('translate')('ERROR.ERROR_PASSWORD_MUST_MORE_THAN_FOUR')
        return false;
      }
      if (fm.newPassword.length > 20) {
        fm.message = $filter('translate')('ERROR.ERROR_PASSWORD_MUST_LESS_THAN_20')
        return false;
      }
      return true;
    }
  }

  angular.module('eHRD.shared')
    .controller('LoginController', LoginController)
    ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  ErrorController.$inject = ['$stateParams', '$filter'];
  function ErrorController($stateParams, $filter) {
    var vm = this;
    vm.isErrorPage = true;
    vm.errorTitle = '';
    vm.serverStatus = '';
    vm.errorContent = '';
    switch ($stateParams.id){
      case '-1':
        vm.serverStatus = '500';
        vm.errorTitle = $filter('translate')('ERROR.CODE.500_TITLE');
        vm.errorContent =  $filter('translate')('ERROR.CODE.500_CONTENT');
            break;
      default:
        vm.serverStatus = $stateParams.id;
        vm.errorTitle = $filter('translate')('ERROR.CODE.'+$stateParams.id+'_TITLE');
        vm.errorContent = $filter('translate')('ERROR.CODE.'+$stateParams.id+'_CONTENT');
            break;
    }

  }

  angular.module('eHRD.shared')
    .controller('ErrorController', ErrorController)
    ;

})();

/**
 * Created by Bruce on 2016/7/21.
 */
(function () {
  'use strict';
  var IMAGES_ROOT = 'assets/images/';

  var layoutPaths = {
    images: {
      root: IMAGES_ROOT,
      profile: IMAGES_ROOT + 'profiles/',
      course: IMAGES_ROOT + 'course/',
      sunnet: IMAGES_ROOT + 'sunnet/',
      make: IMAGES_ROOT + 'make/'
    }
  };

  var themeConfig = {
    mainColor : 'color-green',
    backgroundColor:'bg-light-dark'
  };

  var defaultFontFamily = "\'Microsoft JhengHei\', RobotoDraft,Roboto,Helvetica Neue,Helvetica,Arial,sans-serif";


  angular.module('eHRD.shared')
    .constant('layoutPaths',layoutPaths)
    .constant('themeConfig',themeConfig)
    .constant('defaultFontFamily', defaultFontFamily);
})();

/**
 * Created by Bruce on 2016/10/5.
 */
(function () {
  'use strict';


  var webServiceSetting = {
    defaultApiPath:'/api',
    defaultApiFileProcessPath:'/file/',
    defaultApiLoginPath:'/login',
    defaultTokenName: 'token',
    defaultTokenPrefix: 'eHRDAuth',
    defaultAuthHeader: 'ClientAuthorization',
    defaultAuthToken: 'Bearer',
    defaultStorageType: 'localStorage'
  };

  var defaultEnabledSSOQueryParams = false;
  var defaultSSOQueryParamsKey = [];

  angular.module('eHRD.shared.server',[])
    .constant('webServiceSetting',webServiceSetting)
    .constant('defaultServerAddress','')
    .constant('defaultServerDomain','')
    .constant('defaultServerPort','')
    .constant('defaultContextPath','')
    .constant('defaultSSLType', 3)
    .constant('defaultEnabledSSOQueryParams', defaultEnabledSSOQueryParams)
    .constant('defaultSSOQueryParamsKey',defaultSSOQueryParamsKey);
})();

/**
 * Created by Bruce on 2016/7/21.
 */
(function () {
  'use strict';
  routerConfig.$inject = [ '$urlRouterProvider'];
  function routerConfig( $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');
  }

  angular.module('eHRD.shared')
    .config(routerConfig);
})();

/**
 * Created by Bruce on 2016/7/21.
 */
(function () {
  'use strict';

  coreConfig.$inject = [ 'localStorageServiceProvider', '$windowProvider','$httpProvider', '$authProvider', '$translateProvider', 'RestangularProvider',
    '$breadcrumbsProvider', '$ocLazyLoadProvider', '$translatePartialLoaderProvider',
    'tmhDynamicLocaleProvider', 'ChartJsProvider','cfpLoadingBarProvider', '$locationProvider', 'serverSettingProvider','ngDialogProvider', 'ScrollBarsProvider'];
  function coreConfig( localStorageServiceProvider, $windowProvider,$httpProvider, $authProvider, $translateProvider, RestangularProvider, $breadcrumbsProvider,
                      $ocLazyLoadProvider, $translatePartialLoaderProvider, tmhDynamicLocaleProvider, ChartJsProvider
    ,cfpLoadingBarProvider, $locationProvider, serverSettingProvider, ngDialogProvider, ScrollBarsProvider){

    localStorageServiceProvider
      .setPrefix('client');

    // set default ScrollBars config
    ScrollBarsProvider.defaults = {
      // theme: 'dark',
      // scrollButtons: {
      //   scrollAmount: 'auto', // scroll amount when button pressed
      //   enable: true // enable scrolling buttons by default
      // },
      // scrollInertia: 400, // adjust however you want
      axis: 'y', // enable 2 axis scrollbars by default,
      autoHideScrollbar: true,
      advanced:{
        updateOnContentResize: true
      }
    };

    // Get IE or Edge browser version
    var isIEversion = detectIE($windowProvider);
    if(isIEversion!=false){
      //http://stackoverflow.com/questions/16098430/angular-ie-caching-issue-for-http
      //initialize get if not there
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      // Answer edited to include suggestions from comments
      // because previous version of code introduced browser-related errors
      //disable IE ajax request caching
      $httpProvider.defaults.headers.get['If-Modified-Since'] = new Date().getTime();
      // // extra
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      //no-cache, no-store, must-revalidate
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
      $httpProvider.defaults.headers.get['Expires'] = '0';
    }


    $locationProvider.html5Mode(false);

    cfpLoadingBarProvider.includeBar = true;
    cfpLoadingBarProvider.spinnerTemplate = '<div class="page-spinner-loader show"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';


    ngDialogProvider.setDefaults({
      className: 'ngdialog-theme-default'
    });

    ChartJsProvider.setOptions({
      colours: ['#FF5252', '#FF8A80'],
      responsive: true
    });

    // Configure all charts
    ChartJsProvider.setOptions({
      colors: ['#97BBCD', '#DCDCDC', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360']
    });
    // Configure all doughnut charts
    ChartJsProvider.setOptions('doughnut', {
      cutoutPercentage:70,
      tooltips: { enabled: false }
    });
    ChartJsProvider.setOptions('bubble', {
      tooltips: { enabled: false }
    });


    $translateProvider
      .useSanitizeValueStrategy(null)// for prevent from XSS vulnerability but this has problem with utf-8 language
      .fallbackLanguage(['en-us', 'zh-tw','zh-cn']) //Registering a fallback language
      .registerAvailableLanguageKeys(['en-us', 'zh-tw','zh-cn'], { // register your language key and browser key find
        'en_*': 'en-us',
        'zh_tw': 'zh-tw',
        'zh_cn': 'zh-cn'
      })
      .useLoaderCache(true)//use cache to loading translate file
      .useCookieStorage()// using cookie to keep current language
      .forceAsyncReload(true)
      //.useMissingTranslationHandlerLog() // you can remove in production
      //.determinePreferredLanguage();// define language by browser language
      .preferredLanguage('zh-tw')
    ;

    /* angular locale dynamic load */
    tmhDynamicLocaleProvider.localeLocationPattern('assets/plugins/angular-i18n/angular-locale_{{locale}}.js');


    var ocLazyLoadConfig = {
      debug: true,
      events: true,
      modules: [
        {
          name:'server-config',
          files: ['app/js/TestModule.js']
        },
        {
          name:'default',
          files:['assets/material-theme/default.css']
        },
        {
          name:'redTheme',
          files:['assets/material-theme/redTheme.css']
        },
        {
          name:'pinkTheme',
          files:['assets/material-theme/pinkTheme.css']
        },
        {
          name:'blueTheme',
          files:['assets/material-theme/blueTheme.css']
        },
        {
          name:'tealTheme',
          files:['assets/material-theme/tealTheme.css']
        },
        {
          name:'greenTheme',
          files:['assets/material-theme/greenTheme.css']
        },
        {
          name:'orangeTheme',
          files:['assets/material-theme/orangeTheme.css']
        },                                                
        {
          name:'blackTheme',
          files:['assets/material-theme/blackTheme.css']
        },   
        {
          name:'purpleTheme',
          files:['assets/material-theme/purpleTheme.css']
        },                   
        {
          name:'theme-plugins',
          files:[
            'assets/plugins/modernizr/modernizr-2.6.2-respond-1.1.0.min.js',
            'assets/plugins/jstree/dist/themes/default/style.css',
            'assets/plugins/slick/slick.css',
            'assets/plugins/icheck/skins/all.css',
            'assets/plugins/bootstrap/css/jasny-bootstrap.css',
            'assets/icons/line-icons/line-icons.css',
            'assets/icons/rounded/style.css',
            'assets/plugins/step-form-wizard/css/step-form-wizard.css',
            'assets/plugins/step-form-wizard/js/step-form-wizard.js'
          ]
        },
        {
          name:'stepFormWizard',
          files:[
            'assets/plugins/step-form-wizard/css/step-form-wizard.css',
            'assets/plugins/step-form-wizard/js/step-form-wizard.js'
          ]
        }
      ]
    };

    $ocLazyLoadProvider.config(ocLazyLoadConfig);

    // Setting breadcrumbs
    $breadcrumbsProvider.setOptions({
      prefixStateName: 'index',
      includeAbstract: true,
      templateUrl:'app/shared/views/breadcrumbTemplate.html'
    });
  }


  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  function detectIE($windowProvider) {
    var $window = $windowProvider.$get();
    var ua = $window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  angular.module('eHRD.shared')
    .config(coreConfig);
})();

/**
 * Created by Bruce on 2016/7/21.
 */
(function () {
  'use strict';

  materialConfig.$inject = ['$mdThemingProvider', '$mdIconProvider', '$mdDateLocaleProvider'];
  function materialConfig( $mdThemingProvider, $mdIconProvider, $mdDateLocaleProvider){

    $mdThemingProvider.disableTheming();
    var localeDate = moment.localeData();
    $mdDateLocaleProvider.months = localeDate._months;
    $mdDateLocaleProvider.shortMonths = localeDate._monthsShort;
    $mdDateLocaleProvider.days = localeDate._weekdays;
    $mdDateLocaleProvider.shortDays = localeDate._weekdaysMin;
    // Can change week display to start on Monday.
    $mdDateLocaleProvider.firstDayOfWeek = 1;
    // Optional.
    // $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
    // Example uses moment.js to parse and format dates.
    $mdDateLocaleProvider.parseDate = function(dateString) {
      var m = moment(dateString, 'YYYY/MM/DD', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
    $mdDateLocaleProvider.formatDate = function(date) {
      var m = moment(date);
      if(!date){
        return '';
      }
      return m.isValid() ? m.format('YYYY/MM/DD') : '';
    };

    // $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
    //   return shortMonths[date.getMonth()] + ' ' + date.getFullYear();
    // };

    // In addition to date display, date components also need localized messages
    // for aria-labels for screen-reader users.

    $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
      return 'Semaine ' + weekNumber;
    };

    $mdDateLocaleProvider.msgCalendar = 'Calendrier';
    $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';

    // You can also set when your calendar begins and ends.
    // $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
    // $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);


    $mdIconProvider
    // .iconSet('fa', 'assets/icons/font-awesome/MaterialIcons-Regular.svg', 24)
    // .defaultIconSet('assets/icons/MaterialIcons-Regular.svg', 24)
      .fontSet('md', 'material-icons');

    //black background color
    // var backgroundPalette = $mdThemingProvider.extendPalette('grey', { '50': 'ffffff' });
    // $mdThemingProvider.definePalette('background', backgroundPalette);
    //
    // var grey = $mdThemingProvider.extendPalette('grey', {
    //   '0':  '#ffffff',
    //   '50': '#fafafa',
    //   '100': '#f5f5f5',
    //   '200': '#eeeeee',
    //   '300': '#e0e0e0',
    //   '400': '#bdbdbd',
    //   '500': '#9e9e9e',
    //   '600': '#757575',
    //   '700': '#616161',
    //   '800': '#424242',
    //   '900': '#212121',
    //   'A100': '#ffffff',
    //   'A200': '#000000',
    //   'A400': '#303030',
    //   'A700': '#616161',
    //   'contrastDefaultColor': 'dark',
    //   'contrastLightColors': '600 700 800 900 A200 A400 A700'
    // });
    // $mdThemingProvider.definePalette('grey', grey);

    //red
    // $mdThemingProvider.theme('redTheme')
    //   .primaryPalette('red')
    //   .accentPalette('brown')
    //   .warnPalette('orange')
    //   .backgroundPalette('background');
    //
    // //pink
    // $mdThemingProvider.theme('pinkTheme')
    //   .primaryPalette('pink')
    //   .accentPalette('indigo')
    //   .warnPalette('orange')
    //   .backgroundPalette('background');
    //
    // //blue
    // $mdThemingProvider.theme('blueTheme')
    //   .primaryPalette('blue')
    //   .accentPalette('orange')
    //   .warnPalette('red')
    //   .backgroundPalette('background');
    //
    // //teal
    // $mdThemingProvider.theme('tealTheme')
    //   .primaryPalette('teal')
    //   .accentPalette('light-green')
    //   .warnPalette('deep-orange')
    //   .backgroundPalette('background');
    //
    // //green
    // $mdThemingProvider.theme('greenTheme')
    //   .primaryPalette('green')
    //   .accentPalette('teal')
    //   .warnPalette('deep-orange')
    //   .backgroundPalette('background');
    //
    // //orange
    // $mdThemingProvider.theme('orangeTheme')
    //   .primaryPalette('orange')
    //   .accentPalette('light-green')
    //   .warnPalette('red')
    //   .backgroundPalette('background');
    //
    // //black
    // $mdThemingProvider.theme('blackTheme')
    //   .primaryPalette('blue-grey')
    //   .accentPalette('blue')
    //   .warnPalette('deep-orange')
    //   .backgroundPalette('background');
    //
    // //purple
    // $mdThemingProvider.theme('purpleTheme')
    //   .primaryPalette('deep-purple')
    //   .accentPalette('orange')
    //   .warnPalette('red')
    //   .backgroundPalette('background');
    //
    // $mdThemingProvider.theme('default')
    //   .primaryPalette('teal')
    //   .accentPalette('teal',{
    //     'default': '300'
    //   })
    //   .warnPalette('red',{
    //     'default': '800'
    //   })
    //   .backgroundPalette('background');
    //
    // $mdThemingProvider.theme('docs-dark', 'default')
    //   .primaryPalette('teal')
    //   .dark();
    //
    // $mdThemingProvider.theme('btn')
    //   .primaryPalette('purple')
    //   .accentPalette('green');
    //
    // $mdThemingProvider.setDefaultTheme('default');

  }

  angular.module('eHRD.shared')
    .config(materialConfig);
})();

/**
 * Created by Bruce on 2017/02/08.
 */

(function () {
  'use strict';

   angular
     .module('eHRD.modules.backgroundSchedule', []);

})();

/**
 * Created by Bruce on 2017/02/08.
 */

(function () {
  'use strict';

  backgroundScheduleService.$inject = ['$log', '$auth', '$interval', 'Restangular'];
  function backgroundScheduleService($log, $auth, $interval, Restangular) {
    var connTouchTimer;
    var connTouchService = Restangular.all('conn-touch');
    function checkConnTouch() {
      if($auth.isAuthenticated()){
        connTouchService.customGET().then(function (data) {
          if(data.status === '1'){
            $log.info("Reset User Browser Conn Touch Time!")
          }else {
            $log.warn("Reset User Browser Conn Touch Time!")
          }

        });
      }else {
        $interval.cancel(connTouchTimer);
      }
    }
    function initBackgroundSchedule() {
      connTouchTimer = $interval(checkConnTouch, 60000);
    }
    return {
      initBackgroundSchedule : initBackgroundSchedule
    };
  }

   angular
     .module('eHRD.modules.backgroundSchedule')
     .factory('backgroundScheduleService', backgroundScheduleService);

})();

/**
 * Created by Bruce on 2016/5/17.
 */
(function () {
  'use strict';
  authProvider.$inject = ['AuthConfig'];
  function authProvider(config) {
    Object.defineProperties(this, {
      httpInterceptor: {
        get: function() { return config.httpInterceptor; },
        set: function(value) {
          if (angular.isFunction(value)) {
            config.httpInterceptor = value;
          } else {
            config.httpInterceptor = function() {
              return value;
            };
          }
        }
      },
      baseUrl: {
        get: function() { return config.baseUrl; },
        set: function(value) { config.baseUrl = value; }
      },
      loginUrl: {
        get: function() { return config.loginUrl; },
        set: function(value) { config.loginUrl = value; }
      },
      tokenRoot: {
        get: function() { return config.tokenRoot; },
        set: function(value) { config.tokenRoot = value; }
      },
      tokenName: {
        get: function() { return config.tokenName; },
        set: function(value) { config.tokenName = value; }
      },
      tokenPrefix: {
        get: function() { return config.tokenPrefix; },
        set: function(value) { config.tokenPrefix = value; }
      },
      unlinkUrl: {
        get: function() { return config.unlinkUrl; },
        set: function(value) { config.unlinkUrl = value; }
      },
      authHeader: {
        get: function() { return config.authHeader; },
        set: function(value) { config.authHeader = value; }
      },
      authToken: {
        get: function() { return config.authToken; },
        set: function(value) { config.authToken = value; }
      },
      withCredentials: {
        get: function() { return config.withCredentials; },
        set: function(value) { config.withCredentials = value; }
      },
      storageType: {
        get: function() { return config.storageType; },
        set: function(value) { config.storageType = value; }
      },
      authType: {
        get: function() { return config.authType; },
        set: function(value) { config.authType = value; }
      }
    });
    angular.forEach(Object.keys(config.providers), function(provider) {
      this[provider] = function(params) {
        return angular.extend(config.providers[provider], params);
      };
    }, this);
    var oauth = function(params) {
      config.providers[params.name] = config.providers[params.name] || {};
      angular.extend(config.providers[params.name], params);
    };
    this.oauth1 = function(params) {
      oauth(params);
      config.providers[params.name].oauthType = '1.0';
    };
    this.oauth2 = function(params) {
      oauth(params);
      config.providers[params.name].oauthType = '2.0';
    };

    auth.$inject=[
      '$q',
      '$window',
      'AuthShared',
      'AuthLocal',
      'AuthOauth',
      '$location',
      '$state',
      'AuthConfig', 'AuthStorage', 'sitemapService', 'serverSetting'];
    function auth($q, $window, shared, local, oauth, $location, $state, AuthConfig, AuthStorage, sitemapService, serverSetting) {
      var $auth = {};

      $auth.setHttpInterceptor = function (val) {
        AuthConfig.httpInterceptor = val;
      };
      $auth.setWithCredentials = function (val) {
        AuthConfig.withCredentials = val;
      };
      $auth.setTokenRoot = function (val) {
        AuthConfig.tokenRoot = val;
      };
      $auth.setBaseUrl = function (val) {
        AuthConfig.baseUrl = val;
      };
      $auth.setLoginUrl = function (val) {
        AuthConfig.loginUrl = val;
      };
      $auth.setUnlinkUrl = function (val) {
        AuthConfig.unlinkUrl = val;
      };
      $auth.setTokenName = function (val) {
        AuthConfig.tokenName = val;
      };
      $auth.setTokenPrefix = function (val) {
        AuthConfig.tokenPrefix = val;
      };
      $auth.setAuthHeader = function (val) {
        AuthConfig.authHeader = val;
      };
      $auth.setAuthToken = function (val) {
        AuthConfig.authToken = val;
      };
      $auth.setStorageType = function (val) {
        AuthConfig.storageType = val;
      };
      $auth.setAuthType = function (val) {
        AuthConfig.authType = val;
      };

      $auth.checkServerStatus = function (options) {
        var data = {token:this.getToken()};
        local.checkServerStatus(data, options)
          .catch(function (error) {
            switch (error.status){
              default:
                $location.path('/error/'+error.status);
                break;
              }
            }
          );
      };

      $auth.login = function(user, opts) {
        return local.login(user, opts);
      };

      $auth.logout = function() {
        // return isShared? shared.logout() : local.logout();
        return local.logout();
      };

      $auth.getCasLogoutUrl = function() {
        return local.getCasLogoutUrl();
      }

      $auth.authenticate = function(name, userData) {
        return oauth.authenticate(name, userData);
      };
      $auth.link = function(name, userData) {
        return oauth.authenticate(name, userData);
      };
      $auth.unlink = function(provider, opts) {
        return oauth.unlink(provider, opts);
      };
      $auth.isAuthenticated = function() {
        return shared.isAuthenticated();
      };
      $auth.getToken = function() {
        return shared.getToken();
      };
      $auth.getDataToken = function() {
        return shared.getDataToken();
      };
      $auth.setACL = function () {
        var token = this.getDataToken();
        return shared.setACL(token);
      };
      $auth.setToken = function(token) {
        return shared.setToken({ access_token: token });
      };
      $auth.removeToken = function() {
        return shared.removeToken();
      };
      $auth.getUserData = function(){
        return shared.getUserData();
      };
      $auth.getPayload = function() {
        return shared.getPayload();
      };
      $auth.setStorageType = function(type) {
        return shared.setStorageType(type);
      };
      $auth.setAuthType = function(type) {
        return shared.setAuthType(type);
      };

      $auth.skipIfLoggedIn = function(){
        var deferred = $q.defer();
        if ($auth.isAuthenticated()) {
          if($auth._redirct !== 'logout' && $auth._redirct !== '/logout' && $auth._redirct !== 'login' && $auth._redirct !== '/login'){
            $location.path($auth._redirct);
          } else if ($auth._redirct === 'logout' || $auth._redirct === '/logout') {
            deferred.resolve();
          } else {
            $state.go('index');
          }
        } else {
          if($auth._redirct !== 'logout' && $auth._redirct !== '/logout'){
            local.OtherLogin().then(function successCallback(response) {
              if(angular.isObject(response.data)){
                shared.setToken(response);
                if ($auth.isAuthenticated()) {
                  sitemapService.getProjectId().then(function(data){
                    sitemapService.setSiteMap(data);
                    $location.path($auth._redirct);
                    $window.location.reload();
                  });
                }else{
                  deferred.resolve();
                }
              } else {
                if (serverSetting.authConfig.CAS_ENABLED) {
                  var CAS_VALIDATE_PATH = [serverSetting.baseConfig.baseURL, serverSetting.authConfig.CAS_VALIDATE_PATH].join('/');
                  if (encodeURIComponent($auth._redirct).length > 0 && $auth._redirct!=='logout' && $auth._redirct!=='/logout'){
                    CAS_VALIDATE_PATH = CAS_VALIDATE_PATH + '?referer=' + ($auth._redirct);
                  }
                  $window.location.href = CAS_VALIDATE_PATH;
                } else {
                  deferred.resolve();
                }
              }
            }, function errorCallback() {
              if (serverSetting.authConfig.CAS_ENABLED) {
                var CAS_VALIDATE_PATH = [serverSetting.baseConfig.baseURL, serverSetting.authConfig.CAS_VALIDATE_PATH].join('/');
                if (encodeURIComponent($auth._redirct).length > 0 && $auth._redirct!=='logout' && $auth._redirct!=='/logout'){
                  CAS_VALIDATE_PATH = CAS_VALIDATE_PATH + '?referer=' + ($auth._redirct);
                }
                $window.location.href = CAS_VALIDATE_PATH;
              } else {
                deferred.resolve();
              }
            });
          }else{
            deferred.resolve();
          }
        }
        return deferred.promise;
      };

      $auth.loginRequired = function (pid) {
        var deferred = $q.defer();
        $auth._redirct = $location.path();
        $auth._redirctSearch = $location.search();
        if ( $auth.isAuthenticated()) {
            local.validateToken().then(function (response) {
              if(angular.isObject(response.data)){
                shared.setToken(response);
                sitemapService.getProjectId(pid).then(function(data){
                  sitemapService.setSiteMap(data);
                  deferred.resolve();
                });
              }else{
                if (serverSetting.authConfig.CAS_ENABLED){
                  var CAS_VALIDATE_PATH = [serverSetting.baseConfig.baseURL, serverSetting.authConfig.CAS_VALIDATE_PATH].join('/');
                  if (encodeURIComponent($auth._redirct).length > 0 && $auth._redirct!=='logout' && $auth._redirct!=='/logout'){
                    CAS_VALIDATE_PATH = CAS_VALIDATE_PATH + '?referer=' + ($auth._redirct);
                  }
                  $window.location.href = CAS_VALIDATE_PATH;
                } else {
                  shared.logout();
                  $state.go('login');
                }
              }
            }, function (error) {
              if (serverSetting.authConfig.CAS_ENABLED){
                var CAS_VALIDATE_PATH = [serverSetting.baseConfig.baseURL, serverSetting.authConfig.CAS_VALIDATE_PATH].join('/');
                if (encodeURIComponent($auth._redirct).length > 0 && $auth._redirct!=='logout' && $auth._redirct!=='/logout'){
                  CAS_VALIDATE_PATH = CAS_VALIDATE_PATH + '?referer=' + ($auth._redirct);
                }
                $window.location.href = CAS_VALIDATE_PATH;
              } else {
                if( error.status === 401){
                  shared.logout();
                  $state.go('login');
                }else {
                  $state.go('error', {id: error.status});
                }
              }
            });
        } else {
           $state.go('login');
        }
         return deferred.promise;
      };

      return $auth;
    }

    this.$get = auth;

  }
  angular.module('eHRD.kernel.auth')
    .provider('$auth', authProvider)
  ;
})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  angular.module('eHRD.kernel.auth')

    .constant('AuthConfig', {
      httpInterceptor: function() { return true; },
      withCredentials: false,
      tokenRoot: null,
      baseUrl: '/',
      loginUrl: '/api/login',
      logoutUrl: '/api/logout',
      checkServerStatusUrl: 'auth/checkServerStatus',
      unlinkUrl: '/api/unlink/',
      tokenName: 'token',
      tokenPrefix: 'eHRDAuth',
      authHeader: 'Authorization',
      authToken: 'Bearer',
      storageType: 'localStorage',
      authType: 'General',// NTlm, SSO, General
      providers: {

      }
    })
  ;

})();

/**
 * Created by Bruce on 2016/5/17.
 */

(function () {
  'use strict';

  authConfig.$inject = ['$httpProvider'];
  function authConfig( $httpProvider){
    $httpProvider.interceptors.push('AuthInterceptor');
  }

  angular.module('eHRD.kernel.auth')

    .config(authConfig);

})();

/**
 * Created by Bruce on 2016/7/21.
 */
(function () {
  'use strict';

  /** @ngInject */
  runThemeBlock.$inject=[
    '$timeout',
    '$rootScope',
    '$q',
    '$auth',
    '$translate',
    'CoreService',
    '$state',
    'tmhDynamicLocale',
    'amMoment',
    '$mdDateLocale',
    'backgroundScheduleService'
  ];

  function runThemeBlock($timeout, $rootScope, $q, $auth,$translate, CoreService,$state, tmhDynamicLocale, amMoment, $mdDateLocale, backgroundScheduleService) {
    CoreService.systemInit();
    CoreService.serverSettingInit();
    CoreService.authInit();
    CoreService.RestangularInit();
    $auth.setACL();

    backgroundScheduleService.initBackgroundSchedule();
    var $translatePartialLoaderStructureChanged = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
      $translate.refresh();
    });
    $rootScope.$on('$destroy', $translatePartialLoaderStructureChanged);

    var $translateChangeEnd = $rootScope.$on('$translateChangeEnd', function() {
      // get current language
      $rootScope.currentLanguage = $translate.use();
      //dynamic load angularjs locale
      tmhDynamicLocale.set($rootScope.currentLanguage);
      // change direction to right-to-left language
      if($rootScope.currentLanguage==='ar-ae' || $rootScope.currentLanguage==='fa-ir'){
        $rootScope.currentDirection = 'rtl';
      } else{
        $rootScope.currentDirection = 'ltr';
      }
      // set lang parameter for any request that with Restangular
      // Restangular.setDefaultRequestParams({lang: $rootScope.currentLanguage});

      amMoment.changeLocale($translate.use());
      var localeDate = moment.localeData();
      $mdDateLocale.months = localeDate._months;
      $mdDateLocale.shortMonths = localeDate._monthsShort;
      $mdDateLocale.days = localeDate._weekdays;
      $mdDateLocale.shortDays = localeDate._weekdaysMin;
    });
    $rootScope.$on('$destroy', $translateChangeEnd);

    if(angular.isDefined($auth.getUserData())){
      // $translate.use($auth.getUserData().rc);
    }

    $rootScope.$state = $state;

    var scope = $rootScope;

    scope.$isMobile =  (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());

    var whatToWait = [
      $timeout(0)
    ];

    $q.all(whatToWait).then(function () {
      scope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!scope.$pageFinishedLoading) {
        scope.$pageFinishedLoading = true;
      }
    }, 1000);

    scope.$watch('$pageFinishedLoading', function(newValue) {
      if(newValue){
        angular.element('.loader-overlay').addClass('loaded');
        angular.element('body > section').animate({
          opacity: 1
        }, 400);
      }
    });

    scope.$on('$viewContentLoaded', function () {
      angular.element('.nav.nav-sidebar .nav-active').removeClass('nav-active active');
      angular.element('.nav.nav-sidebar .active:not(.nav-parent)').closest('.nav-parent').addClass('nav-active active');

      $timeout(function(){
        // Add class everytime a mouse pointer hover over it
        var hoverTimeout;
        angular.element('.nav-sidebar > li').hover(function () {
          clearTimeout(hoverTimeout);
          angular.element(this).siblings().removeClass('nav-hover');
          angular.element(this).addClass('nav-hover');
        }, function () {
          var $self =  angular.element(this);
          hoverTimeout = $timeout(function () {
            $self.removeClass('nav-hover');
          }, 200);
        });

        angular.element('.nav-sidebar > li .children').hover(function () {
          clearTimeout(hoverTimeout);
          angular.element(this).closest('.nav-parent').siblings().removeClass('nav-hover');
          angular.element(this).closest('.nav-parent').addClass('nav-hover');
        }, function () {
          var $self =  angular.element(this);
          hoverTimeout = $timeout(function () {
            $self.closest('.nav-parent').removeClass('nav-hover');
          }, 200);
        });
      });
    });

    scope.$on('$stateChangeSuccess',function (/*ev, to, toParams, from, fromParams*/) {
      // console.log(ev, to, toParams, from, fromParams)
      angular.element("html, body").animate({
        scrollTop: 0
      }, 10);
    });

  }

  angular.module('eHRD.shared')
    .run(runThemeBlock);
})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function () {
  'use strict';

  angular
    .module('eHRD.modules',[
      'eHRD.modules.sitemap',
      'eHRD.modules.staticPage',
      'eHRD.modules.utils',
      'eHRD.modules.language',
      'eHRD.modules.dashboard',
      'eHRD.modules.system',
      'eHRD.modules.fileProcess',
      'eHRD.modules.index',
      'eHRD.modules.approve',
      'eHRD.modules.manager',
      'eHRD.modules.user',
      'eHRD.modules.courseResource',
      'eHRD.modules.learningResource',
      'eHRD.modules.reports',
      'eHRD.modules.forum',
      'eHRD.modules.mailLink',
      'eHRD.modules.training',
      'eHRD.modules.trainingRoadMap',
      'eHRD.modules.certZone',
      'eHRD.modules.calendar',
      'eHRD.modules.routing',
      'eHRD.modules.backgroundSchedule',
      'eHRD.modules.fullTextSearch'
    ]);

})();

/**
 * Created by Bruce on 2016/5/11.
 */

(function() {
  'use strict';

  angular
    .module('eHRD', [
      'ngMaterial',
      'mdPickers',
      'ngCookies',
      'ngTouch',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',                    // Routing
      'oc.lazyLoad',                  // ocLazyLoad
      'ui.bootstrap',                 // Ui Bootstrap
      'slick',
      'ngRateIt',
      'LocalStorageModule',
      'ngQueue',
      'angular.filter',
      'ngSanitize',                    // ngSanitize
      'toastr',
      'angular-loading-bar',
      'ngScrollbars',
      'tmh.dynamicLocale',
      'pascalprecht.translate',
      'angularMoment',
      'restangular',
      'eHRD.kernel.auth',
      'eHRD.kernel.uiElements',
      'chart.js',
      'highcharts-ng',
      'gridshore.c3js.chart',
      'ngDialog',
      'eHRD.shared',
      'eHRD.modules'

    ]);

})();

angular.module("eHRD").run(["$templateCache", function($templateCache) {$templateCache.put("app/shared/views/breadcrumbTemplate.html","<ol class=\"breadcrumb\"><li ng-repeat=\"step in steps track by $index\" ng-class=\"{active: $last}\" ng-switch=\"$last || !!step.abstract\"><a ng-switch-when=\"false\" href=\"{{step.ncyBreadcrumbLink}}\" ng-bind-html=\"(step._ncyBreadcrumbLabel || step.ncyBreadcrumbLabel) | translate\"></a> <span ng-switch-when=\"true\" ng-bind-html=\"(step._ncyBreadcrumbLabel || step.ncyBreadcrumbLabel) | translate\"></span></li></ol>");
$templateCache.put("app/shared/views/content.html","<section theme-application=\"\"><sidebar></sidebar><div class=\"main-content\"><theme-top-bar></theme-top-bar><div class=\"page-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"breadcrumb-wrapper th-bread\" ng-if=\"!($state.includes(\'*.error\') || $state.includes(\'index\') || $state.includes(\'myCalendar\'))\"><div breadcrumb=\"\"></div></div><div id=\"content_view\" ui-view=\"\" class=\"\" theme-material-init=\"\"></div></div></div><div class=\"footer\"><div class=\"copyright\"><p class=\"pull-left sm-pull-reset\"><span>{{UC.copyright}}</span></p></div></div></div></div><a href=\"#\" class=\"scrollup\"><i class=\"fa fa-angle-up\"></i></a></section>");
$templateCache.put("app/shared/views/error-page.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"manager th-train\"><div class=\"th-title\"><h2>{{\'YOU_DONT_HAVE_ACCESS\' | translate}}</h2></div></section></div></div>");
$templateCache.put("app/shared/views/error.html","<div class=\"col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 col-xs-12 animated fadeInDown\"><div class=\"error-container\"><div class=\"error-main\"><h1><span>{{vm.serverStatus}}</span><span class=\"typed-cursor\" style=\"animation: none; opacity: 0;\">|</span></h1><h3><span>{{vm.errorTitle}}</span><span class=\"typed-cursor\" style=\"animation: none; opacity: 0;\">|</span></h3><h4><span>{{vm.errorContent}}</span><span class=\"typed-cursor\">|</span></h4><br><div class=\"row\" style=\"display: block;\"><div class=\"col-md-12 text-center\"><div class=\"btn-group\"><a class=\"btn btn-white\" href=\"#\"><i class=\"fa fa-angle-left\"></i> Go back</a> <a class=\"btn btn-white btn-home\" ui-sref=\"index\"><i class=\"icon-home\"></i> Home Page</a> <a class=\"btn btn-white\" ui-sref=\"logout\"><i class=\"icon-login\"></i> Login</a></div></div></div></div></div></div><div class=\"footer\"><div class=\"copyright\">© Copyright Themes Lab, 2015 Themes Lab Inc.</div></div>");
$templateCache.put("app/shared/views/login-change-password.html","<md-dialog flex=\"30\"><md-dialog-content layout-padding=\"\" class=\"hidden-x-scrollbar\" style=\"display: inline;\"><form name=\"secondAuthForm\" class=\"form-signin\" ng-submit=\"$ctrl.auth()\"><md-content class=\"md-no-momentum\"><h3 class=\"md-title\">{{ \'FIELD.INIT_PWD_PLEASE_CHANGE_PWD_PROMPT\' | translate}}</h3><br><md-input-container class=\"md-icon-float md-block\"><label>{{ \'PLACEHOLDERS.PLEASE_ENTER_YOUR_OLD_PASSWORD\' | translate}}</label> <input ng-model=\"$ctrl.oldPassword\" type=\"password\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{ \'PLACEHOLDERS.PLEASE_ENTER_YOUR_NEW_PASSWORD\' | translate}}</label> <input ng-model=\"$ctrl.newPassword\" type=\"password\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{ \'PLACEHOLDERS.PLEASE_RECONFIRM_YOUR_NEW_PASSWORD\' | translate}}</label> <input ng-model=\"$ctrl.newPassword2\" type=\"password\"></md-input-container><div ng-if=\"$ctrl.status === false\" id=\"status\"><b style=\"color: #c60008;\" layout=\"row\" layout-align=\"center center\" class=\"md-padding\">{{$ctrl.message}}</b></div><md-button class=\"md-raised md-primary center-block\" type=\"submit\">{{ \'FIELD.CHANGE_LOGIN_PASSWORD\' | translate}}</md-button></md-content></form></md-dialog-content></md-dialog>");
$templateCache.put("app/shared/views/login.html","<div class=\"wp-login\" xmlns=\"http://www.w3.org/1999/html\"><header><h1><a href=\"#\"><img ng-src=\"{{vm.logoUrl}}\" alt=\"\"></a></h1><div class=\"th-info m-r-20\"><div class=\"time\"><ds-widget-clock data-show-digital=\"\" only-text=\"true\" digital-format=\"\'HH:mm\'\"></ds-widget-clock></div><div class=\"number\" ng-if=\"vm.number >= 0\">{{ \'SYSTEM.ONLINE_USER_NO\' | translate}}: {{vm.number}}</div></div></header><div class=\"th-login\"><div class=\"login-head\" compile=\"vm.headWording\"></div><p>{{ \'PLACEHOLDERS.PLEASE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD\' | translate}}</p><div class=\"md-login\"><form name=\"signinForm\" class=\"form-signin\" ng-submit=\"vm.login(signinForm.$valid, $event)\" novalidate=\"\"><div class=\"pt-login\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.USERNAME\' | translate }}</label> <input ng-model=\"user.account\" type=\"text\" name=\"account\" required=\"\"><md-icon md-font-set=\"material-icons\" style=\"display:inline-block;\">account_circle</md-icon></md-input-container></div><div class=\"pt-login\"><md-input-container class=\"md-block\"><label>{{ \'FIELD.PASSWORD\' | translate }}</label> <input ng-model=\"user.password\" type=\"password\" name=\"password\" required=\"\"><md-icon md-font-set=\"material-icons\" style=\"display:inline-block;\">https</md-icon></md-input-container></div><p class=\"pt-mark pt-mark-override\" ng-if=\"vm.errorData===\'sign_in_re_ask_password\'\">{{\'ERROR.ACCOUNT_OR_PASSWORD_ERROR\'| translate}}{{\'FORM_VALIDATION.PLEASE_RE_ENTER_YOUR_ACCOUNT_NUMBER_AND_PASSWORD\'| translate}}</p><p class=\"pt-mark pt-mark-override\" ng-if=\"vm.checkUserLimit===0 || vm.errorData===\'sign_in_user_limit\'\">{{\'ERROR.SIGN_IN_USER_LIMIT\'| translate}}</p><p class=\"pt-mark pt-mark-override\" ng-if=\"vm.errorData===\'c_sign_in_user_disabled\'\">{{\'ERROR.C_SIGN_IN_USER_DISABLED\'| translate}}</p><p class=\"pt-mark pt-mark-override\" ng-if=\"vm.errorData===\'sign_in_user_notfound\'\">{{\'ERROR.SIGN_IN_USER_NOT_FOUND\'| translate}}</p><div class=\"link\"><md-button type=\"submit\" class=\"md-raised md-primary btn btn-block\" ng-disabled=\"vm.isPreview\">{{ \'ACTIONS.LOGIN\' | translate }}</md-button></div></form></div><div class=\"login-foot\" compile=\"vm.footWording\"></div></div><footer class=\"th-copyRight\"><p>{{vm.copyright}}</p></footer></div>");
$templateCache.put("app/shared/views/pdp-agreement.html","<md-dialog flex=\"60\"><md-dialog-content layout-padding=\"\" class=\"hidden-x-scrollbar\" style=\"display: inline;\"><md-content class=\"md-no-momentum\"><h3 ng-if=\"$ctrl.stage===\'declare\'\" class=\"md-title\">{{ \'PDP.STAGE_DECLARE_TITLE\' | translate}}</h3><h3 ng-if=\"$ctrl.stage===\'confirm\'\" class=\"md-title\">{{ \'PDP.STAGE_SERVICE_TITLE\' | translate}}</h3><br><div ng-if=\"$ctrl.stage===\'declare\'\"><p ng-bind-html=\"\'PDP.STAGE_DECLARE_PHRASE1\' | translate\"></p><p ng-bind-html=\"\'PDP.STAGE_DECLARE_PHRASE2\' | translate\"></p></div><div ng-if=\"$ctrl.stage===\'confirm\'\" layout=\"row\" layout-align=\"center center\"><p ng-bind-html=\"$ctrl.termsOfService | trustAsHtml\"></p></div><div ng-if=\"$ctrl.stage===\'disagree\'\"><p layout=\"row\" layout-align=\"center center\">{{ \'PDP.STAGE_DISAGREE_PHRASE1\' | translate}}</p><p layout=\"row\" layout-align=\"center center\">{{ \'PDP.STAGE_DISAGREE_PHRASE2\' | translate}}</p></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"$ctrl.stage===\'declare\'\" ng-click=\"$ctrl.showTerms()\" class=\"md-raised md-primary\">{{ \'PDP.AGREE\' | translate}}</md-button><md-button ng-if=\"$ctrl.stage===\'confirm\'\" ng-click=\"$ctrl.agree()\" class=\"md-raised md-primary\">{{ \'PDP.AGREE\' | translate}}</md-button><md-button ng-if=\"$ctrl.stage===\'declare\' || $ctrl.stage===\'confirm\'\" ng-click=\"$ctrl.disagree()\" class=\"md-raised md-primary\">{{ \'PDP.DISAGREE\' | translate}}</md-button><md-button ng-if=\"$ctrl.stage===\'disagree\'\" ng-click=\"$ctrl.relogin()\" class=\"md-raised md-primary\">{{ \'ACTIONS.LOGIN_AGAIN\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/shared/views/topbar.html","<div class=\"topbar\" ng-style=\"$ctrl.humanAvatar\"><div class=\"header-left\" style=\"display: block;\"><div class=\"topnav\"><a class=\"menutoggle\" href=\"#\" data-toggle=\"sidebar-collapsed\" theme-sidebar-collapsed=\"\"><span class=\"menu__handle\"><span>Menu</span></span></a></div><div class=\"chat-search\"></div></div><div class=\"header-right\"><ul class=\"header-menu nav navbar-nav m-r-20\"><li uib-dropdown=\"\" class=\"dropdown\" title=\"{{\'INCOMPLETE_COURSES\' |translate}}\"><a ui-sref=\"learningPassport.incompleteCourses\" ui-sref-opts=\"{reload:true}\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" data-hover=\"dropdown\" data-close-others=\"true\"><i class=\"icon-book-open\"></i> <span class=\"badge badge-danger badge-header pt-blueG\">{{UC.userToDo.incompleteCount}}</span></a></li><li uib-dropdown=\"\" class=\"dropdown\" title=\"{{\'FIELD.TEST_QUESTIONNAIRE\' |translate}}\"><a ui-sref=\"learningPassport.testQuestionnaireCenter\" ui-sref-opts=\"{reload:true}\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" data-hover=\"dropdown\" data-close-others=\"true\"><i class=\"icon icons-documents-bookmarks-01\"></i> <span class=\"badge badge-danger badge-header pt-blue\">{{UC.userToDo.quizCount}}</span></a></li><li uib-dropdown=\"\" class=\"dropdown\" title=\"{{\'FIELD.PENDING_APPROVALS\' |translate}}\" permission=\"\" permission-only=\"[\'Modules.approval\']\"><a ui-sref=\"supervisorZone.approve\" ui-sref-opts=\"{reload:true}\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" data-hover=\"dropdown\" data-close-others=\"true\" permission=\"\" permission-only=\"[\'Manager_Privilege\',\'Approval_Privilege\']\" ng-if=\"$ctrl.showApprovalIcon\"><i class=\"icon-note\"></i> <span class=\"badge badge-danger badge-header pt-purple\">{{UC.userToDo.penddingCount}}</span></a></li><li uib-dropdown=\"\" class=\"dropdown\" id=\"user-header\" ng-controller=\"SystemController as SC\"><a href=\"#\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\" data-hover=\"dropdown\" data-close-others=\"true\" class=\"el-person\"><avatar avatar-url=\"UC.userProfiles.avatarUrl\" first-name=\"UC.userProfiles.firstName\" font-size=\"12\"></avatar><span class=\"username\">{{UC.userProfiles.name}}</span></a><ul uib-dropdown-menu=\"\" class=\"dropdown-menu\"><li permission=\"\" permission-only=\"[\'Modules.calendar\']\"><a ui-sref=\"myCalendar\" ui-sref-opts=\"{reload:true}\"><i class=\"icon-calendar\"></i><span>{{\'MY_CALENDAR\' | translate}}</span></a></li><li><a ui-sref=\"mySetting\" ui-sref-opts=\"{reload:true}\"><i class=\"icon-settings\"></i><span>{{\'MY_SETTING\' | translate}}</span></a></li><li permission=\"\" permission-only=\"\'MgrUser\'\"><a ng-href=\"{{SC.defaultMgrUrl}}\" target=\"_blank\"><i class=\"material-icons\">vpn_key</i><span>{{\'SYSTEM.MANAGER_CENTER\' | translate}}</span></a></li><li><a ui-sref=\"logout\"><i class=\"icon-logout\"></i><span>{{\'ACTIONS.LOGOUT\' | translate}}</span></a></li></ul></li><li class=\"text\"><ds-widget-clock data-show-digital=\"\" only-text=\"true\" digital-format=\"\'HH:mm\'\"></ds-widget-clock></li><li class=\"text\" ng-if=\"UC.number >= 0\">{{ \'SYSTEM.ONLINE_USER_NO\' | translate}}: {{UC.number}}</li></ul></div></div>");
$templateCache.put("app/modules/approve/views/approve-status.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/approve/views/form-status-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"50\"><form ng-submit=\"$ctrl.submit()\" name=\"validForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'ACTIONS.\' + $ctrl.approveType |uppercase |translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"$ctrl.actionStatus.hasInnerTeachingScore===1\"><label>{{ \'PLACEHOLDERS.PLEASE_FILL_IN_INTERNAL_LECTURE_SCORE\' | translate}}</label> <input ng-model=\"$ctrl.actionStatus.innerTeachingScore\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"$ctrl.actionStatus.hasOralReportScore===1\"><label>{{ \'PLACEHOLDERS.PLEASE_FILL_IN_ORAL_REPORT_SCORE\' | translate}}</label> <input ng-model=\"$ctrl.actionStatus.oralReportScore\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"$ctrl.actionStatus.hasExtraReportScore===1\"><label>{{ \'PLACEHOLDERS.PLEASE_FILL_IN_OTHER_METHOD_REPORT_SCORE\' | translate}}</label> <input ng-model=\"$ctrl.actionStatus.extraReportScore\"></md-input-container><md-input-container class=\"md-block\"><label>{{$ctrl.actionStatus.title}}</label> <textarea ng-model=\"$ctrl.reason\" md-maxlength=\"200\" rows=\"1\" md-select-on-focus=\"\"></textarea></md-input-container><div flex-gt-xs=\"\">{{$ctrl.approverTitle}}</div><div flex-gt-xs=\"\">{{$ctrl.rejectReson}}</div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/approve/views/manager-approve-records-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"50\"><form ng-submit=\"$ctrl.submit($ctrl.filters)\" name=\"validForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><div flex-gt-xs=\"\">{{ \'FIELD.APPLY_DATE\' | translate}}<md-datepicker ng-change=\"$ctrl.updateEndDateModel()\" ng-model=\"$ctrl.filters.applydate_from\" md-placeholder=\"{{ \'FIELD.START_DATE\' | translate }}\" md-datepicker-focus-open=\"\"></md-datepicker>To<md-datepicker md-min-date=\"$ctrl.filters.applydate_from\" ng-model=\"$ctrl.filters.applydate_end\" md-placeholder=\"{{ \'FIELD.END_DATE\' | translate }}\" md-datepicker-focus-open=\"\"></md-datepicker></div><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.TYPE\' | translate}}</label><md-select ng-model=\"$ctrl.filters.eventtype\"><md-option ng-repeat=\"evetType in $ctrl.evetTypes\" ng-value=\"evetType.value\">{{evetType.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.STATUS\' | translate}}</label><md-select ng-model=\"$ctrl.filters.status\"><md-option ng-value=\"0\">{{ \'FIELD.ALL\' |translate }}</md-option><md-option ng-value=\"1\">{{ \'STATUS.APPROVALED\' |translate }}</md-option><md-option ng-value=\"3\">{{ \'STATUS.REJECTED\' |translate }}</md-option><md-option ng-value=\"4\">{{ \'STATUS.CANCEL\' |translate }}</md-option></md-select></md-input-container><md-input-container ng-if=\"$ctrl.permissionType===\'manager\'\" md-no-float=\"\" class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.APPLICANT\' | translate}}</label> <input ng-model=\"$ctrl.filters.applicant_keyword\" placeholder=\"\"></md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/approve/views/manager-approve-records.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"manager\"><div class=\"th-title\"><h2>{{ \'TRAINING_APPROVE_RECORDS_SEARCH\' | translate}}</h2></div><div class=\"th-manager\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" approve-records-search-dialog=\"\" table=\"$ctrl.managerApproveRecordsTable\" permission-type=\"manager\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><table ng-table=\"$ctrl.managerApproveRecordsTable\" class=\"tb-Collapse tb-check\"><colgroup><col width=\"10%\"><col width=\"15%\"><col width=\"20%\"><col width=\"10%\"><col width=\"15%\"><col width=\"10%\"><col width=\"10%\"><col width=\"10%\"></colgroup><tr ng-repeat=\"row in $data\"><td data-title=\"\'FIELD.APPLICANT\' | translate\" header-class=\"\'appear\'\" class=\"appear\" sortable=\"\'FullName\'\"><div class=\"text\"><a href=\"javascript:void(0);\" user-detail=\"\" user-id=\"row.applicantId\">{{row.applicantName}}</a></div></td><td data-title=\"\'FIELD.TYPE\' | translate\" sortable=\"\'ApvType\'\"><div class=\"text\">{{row.approvalType}}</div></td><td data-title=\"\'FIELD.APPELLATION\' | translate\" header-class=\"\'appear\'\" class=\"appear\" sortable=\"\'AppName\'\"><div class=\"pt-title\" ng-if=\"row.eventType !== 5\"><a href=\"javascript:void(0);\" ng-if=\"row.objectType===2\" tip-info=\"\" tip-type=\"4\" params=\"{pid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===3 && row.courseType!==3\" tip-info=\"\" tip-type=\"2\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===3 && row.courseType===3\" tip-info=\"\" tip-type=\"6\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===4\" tip-info=\"\" tip-type=\"7\" params=\"{subid: row.subjectId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===5\" tip-info=\"\" tip-type=\"21\" params=\"{id: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===6 || row.objectType===7\" tip-info=\"\" tip-type=\"19\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===8\" tip-info=\"\" tip-type=\"20\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a> <span ng-if=\"row.objectType>8\">{{row.formName}}</span></div><div class=\"pt-title\" ng-if=\"row.eventType === 5\"><a href=\"javascript:void(0);\" tip-info=\"\" tip-type=\"5\" params=\"{exid: row.itemId}\">{{row.formName}}</a></div></td><td data-title=\"\'FIELD.APPLICANT_DEPARTMENT\' | translate\"><div class=\"text\">{{row.groups.slice(0,-1)}}</div></td><td data-title=\"\'FIELD.APPLY_DATE\' | translate\" sortable=\"\'IssuedDate\'\"><div class=\"time\">{{row.formattedApplyDate}}</div></td><td data-title=\"\'FIELD.APPROVER\' | translate\"><div class=\"text\">{{row.approver}}</div></td><td data-title=\"\'FIELD.STATUS\' | translate\" header-class=\"\'appear\'\" class=\"appear\" sortable=\"\'status\'\"><div class=\"text\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.iframeWindow(row.formDetailUrl )\"><span>{{row.statusMessage}}</span></a></div></td><td data-title=\"\'FIELD.ACTION\' | translate\" header-class=\"\'appear\'\" class=\"appear\"><div class=\"condition\"><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.historyActionEditExternal === 1\" ui-sref=\"supervisorZone.approveRecordsExternalTrainingApplyRecordsFormEdit({externalId: row.itemId, backStateParams: $ctrl.backStateParams})\">{{ \'ACTIONS.FORM_EDIT\' | translate}}</a><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.apvType === 8 && row.enrollType === 1\" learning-report-list-dialog=\"\" mode=\"workflow\" enrollment-id=\"row.enrollmentId\" can-edit=\"true\" batch-id=\"row.categoryTreeId\" activity-name=\"row.formName\" is-program=\"(row.objectType === 2||row.objectType === 5)\">{{ \'ACTIONS.VIEW_REPORT\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.historyActionEditExternal === 0\" external-training-apply-form-view-dialog=\"\" external-id=\"row.itemId\">{{ \'ACTIONS.FORM_VIEW\' | translate}}</a> <a href=\"javascript:void(0);\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.historyActionResendExternal===1\" ng-click=\"$ctrl.iframeWindow(row.historyActionResendExternalUrl )\" class=\"btn btn-sm btn-primary\">{{ \'ACTIONS.RESEND\' | translate }}</a> <button title=\"{{row.historyActionUrlMessage}}\" ng-if=\"(!(row.apvType === 8 && row.enrollType === 1)) && row.eventType !== 5 && row.apvType !== 4 && row.historyActionUrl!==\'\'\" ng-click=\"$ctrl.iframeWindow(row.historyActionUrl )\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-eye\"></i></button> <a href=\"javascript:void(0);\" ng-if=\"row.historyActionCancel===1\" form-status-dialog=\"\" workflow-id=\"row.workflowId\" approve-type=\"cancel\" table=\"$ctrl.managerApproveRecordsTable\" class=\"btn btn-sm btn-danger\">{{ \'ACTIONS.CANCEL\' | translate }}</a> <a href=\"javascript:void(0);\" class=\"more\"><i class=\"material-icons\">more_vert</i></a><div class=\"pt-detail\"><ul><li><p>{{\'FIELD.TYPE\' | translate}} :</p><div class=\"text\">自行報名(外訓)</div></li><li><p>{{\'FIELD.APPLICANT_DEPARTMENT\' | translate}} :</p><div class=\"text\">桃園分行(0277)</div></li><li><p>{{\'FIELD.APPLY_DATE\' | translate}} :</p><div class=\"time\">2016/07/01</div></li><li><p>{{\'FIELD.APPROVER\' | translate}} :</p><div class=\"time\">2016/07/22</div></li></ul></div></div></td></tr></table></div></section></div></div>");
$templateCache.put("app/modules/approve/views/manager-approve.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"manager\"><div class=\"th-title\"><h2>{{ \'TRAINING_APPROVE\' | translate}}</h2></div><div class=\"th-manager\"><script type=\"text/ng-template\" id=\"headerCheckbox.html\"><md-checkbox flex class=\"md-primary checkbox\" ng-model=\"$ctrl.selectAll\"></md-checkbox></script><table ng-table=\"$ctrl.approveTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td header=\"\'headerCheckbox.html\'\" header-class=\"\'appear\'\" class=\"appear check\"><md-checkbox flex=\"\" class=\"md-primary checkbox\" style=\"margin-left: 10px;\" ng-checked=\"($ctrl.selectApprove |arrayObjectIndexOf:row) > -1\" ng-click=\"$ctrl.selectApproveCheckbox(row)\"></md-checkbox></td><td data-title=\"\'FIELD.TYPE\' | translate\"><div class=\"text\">{{row.approvalType}}</div></td><td data-title=\"\'FIELD.APPELLATION\' | translate\" sortable=\"\'AppName\'\"><div class=\"pt-title\" ng-if=\"row.eventType !== 5\"><a href=\"javascript:void(0);\" ng-if=\"row.objectType===2\" tip-info=\"\" tip-type=\"4\" params=\"{pid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===3 && row.courseType!==3\" tip-info=\"\" tip-type=\"2\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===3 && row.courseType===3\" tip-info=\"\" tip-type=\"6\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===4\" tip-info=\"\" tip-type=\"7\" params=\"{subid: row.subjectId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===5\" tip-info=\"\" tip-type=\"21\" params=\"{id: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===6 || row.objectType===7\" tip-info=\"\" tip-type=\"19\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===8\" tip-info=\"\" tip-type=\"20\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a> <span ng-if=\"row.objectType>8\">{{row.formName}}</span></div><div class=\"pt-title\" ng-if=\"row.eventType === 5\"><a href=\"javascript:void(0);\" tip-info=\"\" tip-type=\"5\" params=\"{exid: row.itemId}\">{{row.formName}}</a></div></td><td data-title=\"\'FIELD.SESSION_NAME\' | translate\" sortable=\"\'SessionName\'\"><div class=\"text\">{{row.sessionName}}</div></td><td data-title=\"\'FIELD.APPLICANT\' | translate\" sortable=\"\'FullName\'\"><div class=\"text\"><a href=\"javascript:void(0);\" user-detail=\"\" user-id=\"row.applicantId\">{{row.applicantName}}</a></div></td><td data-title=\"\'FIELD.DEPARTMENT\' | translate\" width=\"12%\"><div class=\"text\">{{row.groups.slice(0,-1)}}</div></td><td data-title=\"\'FIELD.APPLY_DATE\' | translate\" width=\"12%\" sortable=\"\'IssuedDate\'\"><div class=\"time\">{{row.formattedApplyDate}}</div></td><td data-title=\"\'FIELD.ARRIVAL_DATE\' | translate\" width=\"12%\"><div class=\"time\">{{row.formattedModifiedDate}}</div></td><td data-title=\"\'FIELD.CURRENT_PROCESS\' | translate\"><div class=\"text\">{{row.pendingMessage}}</div></td><td data-title=\"\'FIELD.STATUS\' | translate\" header-class=\"\'appear\'\" class=\"appear\" sortable=\"\'Status\'\"><div class=\"text\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.iframeWindow(row.formDetailUrl )\"><span>{{row.statusMessage}}</span></a></div></td><td data-title=\"\'FIELD.ACTION\' | translate\" header-class=\"\'appear\'\" class=\"appear\"><div class=\"condition\"><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.pandingActionEditExternal === 1\" ui-sref=\"supervisorZone.approveExternalTrainingApplyRecordsFormEdit({externalId: row.itemId, backStateParams: $ctrl.backStateParams})\">{{ \'ACTIONS.FORM_EDIT\' | translate}}</a><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.apvType === 8 && row.enrollType === 1\" learning-report-list-dialog=\"\" mode=\"workflow\" enrollment-id=\"row.enrollmentId\" can-edit=\"true\" batch-id=\"row.categoryTreeId\" activity-name=\"row.formName\" is-program=\"(row.objectType === 2 ||row.objectType === 5)\">{{ \'ACTIONS.VIEW_REPORT\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.pandingActionEditExternal === 0\" external-training-apply-form-view-dialog=\"\" external-id=\"row.itemId\">{{ \'ACTIONS.FORM_VIEW\' | translate}}</a> <a href=\"javascript:void(0);\" ng-if=\"row.pandingActionResend===1\" class=\"btn btn-sm btn-primary\" form-status-dialog=\"\" workflow-id=\"row.workflowId\" approve-type=\"resend\" table=\"$ctrl.approveTable\">{{ \'ACTIONS.RESEND\' | translate }}</a> <button title=\"{{row.historyActionUrlMessage}}\" ng-if=\"(!(row.apvType === 8 && row.enrollType === 1)) && row.eventType !== 5 && row.apvType !== 4 && row.pandingActionUrl\" ng-click=\"$ctrl.iframeWindow(row.pandingActionUrl )\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-eye\"></i></button> <a href=\"javascript:void(0);\" ng-if=\"row.pandingActionCancel===1\" class=\"btn btn-sm btn-danger\" form-status-dialog=\"\" workflow-id=\"row.workflowId\" approve-type=\"cancel\" table=\"$ctrl.approveTable\">{{ \'ACTIONS.CANCEL\' | translate }}</a> <a href=\"javascript:void(0);\" ng-if=\"row.pandingActionReject===1\" class=\"btn btn-sm btn-danger\" form-status-dialog=\"\" workflow-id=\"row.workflowId\" approve-type=\"reject\" table=\"$ctrl.approveTable\">{{ \'ACTIONS.NO_APPROVAL\' | translate }}</a> <a href=\"javascript:void(0);\" class=\"more\"><i class=\"material-icons\">more_vert</i></a><div class=\"pt-detail\" style=\"display:none\"><ul><li><p>{{ \'FIELD.TYPE\' | translate}} :</p><div class=\"text\">自行報名(外訓)</div></li><li><p>{{ \'FIELD.DEPARTMENT\' | translate}} :</p><div class=\"text\">桃園分行(0277)</div></li><li><p>{{ \'FIELD.APPLY_DATE\' | translate}} :</p><div class=\"time\">2016/07/01</div></li><li><p>{{ \'FIELD.ARRIVAL_DATE\' | translate}} :</p><div class=\"time\">2016/07/22</div></li><li><p>{{ \'FIELD.CURRENT_PROCESS\' | translate}} :</p><div class=\"text\">新到</div></li></ul></div></div></td></tr></table><div class=\"link\"><md-button class=\"md-raised md-primary md-btn\" form-status-dialog=\"\" clear=\"$ctrl.clear()\" workflow-id=\"$ctrl.idList()\" approve-type=\"approval\" table=\"$ctrl.approveTable\" ng-disabled=\"$ctrl.selectApprove.length===0\">{{ \'ACTIONS.APPROVAL\' | translate}}</md-button></div></div></section></div></div>");
$templateCache.put("app/modules/approve/views/user-approve-records.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"manager\"><div class=\"th-title\"><h2>{{ \'APPROVE_RECORDS\' | translate}}</h2></div><div class=\"th-manager\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" approve-records-search-dialog=\"\" table=\"$ctrl.userApproveRecordsTable\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><table ng-table=\"$ctrl.userApproveRecordsTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'FIELD.TYPE\' | translate\" sortable=\"\'ApvType\'\"><div class=\"text\">{{row.approvalType}}</div></td><td data-title=\"\'FIELD.APPELLATION\' | translate\" header-class=\"\'appear\'\" class=\"appear\" sortable=\"\'AppName\'\"><div class=\"pt-title\" ng-if=\"row.eventType !== 5\"><a href=\"javascript:void(0);\" ng-if=\"row.objectType===2\" tip-info=\"\" tip-type=\"4\" params=\"{pid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===3 && row.courseType!==3\" tip-info=\"\" tip-type=\"2\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===3 && row.courseType===3\" tip-info=\"\" tip-type=\"6\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===4\" tip-info=\"\" tip-type=\"7\" params=\"{subid: row.subjectId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===5\" tip-info=\"\" tip-type=\"21\" params=\"{id: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===6 || row.objectType===7\" tip-info=\"\" tip-type=\"19\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a><a href=\"javascript:void(0);\" ng-if=\"row.objectType===8\" tip-info=\"\" tip-type=\"20\" params=\"{cid: row.itemId, sid: row.sessionId}\">{{row.formName}}</a></div><div class=\"pt-title\" ng-if=\"row.eventType === 5\"><a href=\"javascript:void(0);\" tip-info=\"\" tip-type=\"5\" params=\"{exid: row.itemId}\">{{row.formName}}</a></div></td><td data-title=\"\'FIELD.APPLY_DATE\' | translate\" sortable=\"\'IssuedDate\'\"><div class=\"time\">{{row.formattedApplyDate}}</div></td><td data-title=\"\'FIELD.APPROVER\' | translate\"><div class=\"text\">{{row.approver}}</div></td><td data-title=\"\'FIELD.STATUS\' | translate\" header-class=\"\'appear\'\" class=\"appear\" sortable=\"\'status\'\"><div class=\"text\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.iframeWindow(row.formDetailUrl )\"><span>{{row.statusMessage}}</span></a></div></td><td data-title=\"\'FIELD.ACTION\' | translate\" header-class=\"\'appear\'\" class=\"appear\"><div class=\"condition\"><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.historyActionEditExternal === 1\" ui-sref=\"learningPassport.approveRecordsExternalTrainingApplyRecordsFormEdit({externalId: row.itemId, backStateParams: $ctrl.backStateParams})\">{{ \'ACTIONS.FORM_EDIT\' | translate}}</a><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.apvType === 8 && row.enrollType === 1\" learning-report-list-dialog=\"\" mode=\"workflow\" enrollment-id=\"row.enrollmentId\" batch-id=\"row.categoryTreeId\" activity-name=\"row.formName\" is-program=\"(row.objectType === 2 ||row.objectType === 5)\">{{ \'ACTIONS.VIEW_REPORT\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.historyActionViewExternal === 1\" external-training-apply-form-view-dialog=\"\" external-id=\"row.itemId\">{{ \'ACTIONS.FORM_VIEW\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.eventType === 5 && row.apvType === 4 && row.historyActionResendExternal===1\" ui-sref=\"learningPassport.approveRecordsExternalTrainingApplyRecordsFormReSubmit({externalId: row.itemId, backStateParams: $ctrl.backStateParams})\">{{ \'ACTIONS.RESEND\' | translate }}</a><button title=\"{{row.historyActionUrlMessage}}\" ng-if=\"(!(row.apvType === 8 && row.enrollType === 1)) && row.eventType !== 5 && row.apvType !== 4 && row.historyActionUrl!==\'\'\" ng-click=\"$ctrl.iframeWindow(row.historyActionUrl )\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-eye\"></i></button> <a href=\"javascript:void(0);\" ng-if=\"row.historyActionCancel===1\" form-status-dialog=\"\" workflow-id=\"row.workflowId\" approve-type=\"cancel\" table=\"$ctrl.userApproveRecordsTable\" class=\"btn btn-sm btn-danger\">{{ \'ACTIONS.CANCEL\' | translate }}</a> <a href=\"javascript:void(0);\" class=\"more\"><i class=\"material-icons\">more_vert</i></a><div class=\"pt-detail\"><ul><li><p>{{\'FIELD.TYPE\' | translate}} :</p><div class=\"text\">自行報名(外訓)</div></li><li><p>{{\'FIELD.APPLICANT_DEPARTMENT\' | translate}} :</p><div class=\"text\">桃園分行(0277)</div></li><li><p>{{\'FIELD.APPLY_DATE\' | translate}} :</p><div class=\"time\">2016/07/01</div></li><li><p>{{\'FIELD.APPROVER\' | translate}} :</p><div class=\"time\">2016/07/22</div></li></ul></div></div></td></tr></table></div></section></div></div>");
$templateCache.put("app/modules/cert-zone/views/cert-applyform-compensation-view.html","<div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.formInfo.applyDate}}</td></tr></tbody></table><table class=\"BoxTable BoxTable-text-left\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.formInfo.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.formInfo.subjectName}}</td></tr><tr><th>{{ \'FIELD.APPLY_REASON\' | translate}}</th><td>{{::$ctrl.data.formInfo.reason}}</td></tr><tr><th>{{ \'FIELD.TEST_DATE\' | translate}}</th><td><div ng-repeat=\"testTimes in ::$ctrl.data.formInfo.testTimes\">{{testTimes}}</div></td></tr><tr><th>{{ \'FIELD.TEST_PLAN\' | translate}}</th><td>{{::$ctrl.data.formInfo.testPlace}}</td></tr><tr><th>{{ \'FIELD.EXCERT_APPLY_TEST\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;</span>{{ \'FIELD.REFERENCE_MATERIAL\' | translate | lowercase}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.formInfo.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.TEST_ITEMS\' | translate}}</th><td>{{ ::$ctrl.data.testItemName}}</td></tr><tr><th>{{ \'FIELD.SUBSIDY_COST\' | translate}}</th><td>{{$ctrl.data.compFee | suffixes: (\'FIELD.DOLLARS\' | translate)}}</td></tr><tr><th>{{ \'FIELD.PERCENTAGE_OF_EXAMINATIONS\' | translate}}</th><td>{{$ctrl.data.compRatio | suffixes: \'%\'}}</td></tr><tr><th>{{ \'FIELD.EXCERT_REAL_COMPENSATION\' | translate}}</th><td>{{$ctrl.data.realCompFee | suffixes: (\'FIELD.DOLLARS\' | translate)}}</td></tr><tr><th>{{ \'FIELD.COMPENSATION\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;</span>{{ \'FIELD.REFERENCE_MATERIAL\' | translate | lowercase}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.STATUS\' | translate}}</th><td>{{::$ctrl.data.approvalStatus}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/cert-zone/views/cert-records-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"30\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERT_TYPE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.filters.certType\"><md-radio-button class=\"el-inBlock p-r-20\" value=\"inner\" permission=\"\" permission-only=\"[\'Modules.certification.inner\']\">{{\'FIELD.INTERNAL_LICENSE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"ext\" permission=\"\" permission-only=\"[\'Modules.certification.ext\']\">{{\'FIELD.EXTERNAL_LICENSE\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'inner\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERTIFICATE_TYPE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"innercert-classes\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.certClassId}\" ng-model=\"$ctrl.filters.certClassId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'inner\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERTIFICATION_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"innercerts\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.certId, classificationId: $ctrl.filters.certClassId}\" ng-model=\"$ctrl.filters.certId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'ext\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"companys\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.companyId}\" ng-model=\"$ctrl.filters.companyId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'ext\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"subjects\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.subjectId, companyId: $ctrl.filters.companyId}\" ng-model=\"$ctrl.filters.subjectId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.VALID_DATE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.filters.validDateType\"><md-radio-button class=\"el-inBlock p-r-20\" value=\"0\">{{\'FIELD.ALL\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"1\">{{\'FIELD.NEVER_EXPIRE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"2\">{{\'FIELD.SELECT_START_END_DATE\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.validDateType === \'2\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.VALID_DATE_START\' | translate}}</div><div flex-gt-xs=\"75\" class=\"\"><md-datepicker ng-model=\"$ctrl.filters.accessBegin\" ng-change=\"$ctrl.updateEndDateModel()\" md-placeholder=\"{{\'MESSAGE.MSG_PLEASE_ENTER_START_DATE\' |translate}}\"></md-datepicker></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.validDateType === \'2\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.VALID_DATE_END\' | translate}}</div><cus-md-datepicker flex-gt-xs=\"75\" ng-model=\"$ctrl.filters.accessEnd\" md-min-date=\"$ctrl.filters.accessBegin\" md-placeholder=\"{{\'MESSAGE.MSG_PLEASE_ENTER_END_DATE\' |translate}}\"></cus-md-datepicker></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.cancel()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-click=\"$ctrl.submit($ctrl.filters)\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/cert-records-search.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'CERT_RECORDS_SEARCH\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.showPrompt($event)\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.certTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></section></div></div>");
$templateCache.put("app/modules/cert-zone/views/ext-cert-apply-form-bonus-view.html","<div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.BONUS_APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.formInfo.applyDate}}</td></tr></tbody></table><table class=\"BoxTable BoxTable-text-left\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.formInfo.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.formInfo.subjectName}}</td></tr><tr ng-if=\"$ctrl.data.formInfo.type === 1\"><th>{{ \'FIELD.APPLY_REASON\' | translate}}</th><td>{{::$ctrl.data.formInfo.reason}}</td></tr><tr ng-if=\"$ctrl.data.formInfo.type === 2\"><th>{{ \'FIELD.REMARK\' | translate}}</th><td>{{::$ctrl.data.formInfo.comment}}</td></tr><tr><th>{{ \'FIELD.EXCERT_REGISTER_APPLY\' | translate }}<span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;</span>{{ \'FIELD.REFERENCE_MATERIAL_ASSIGNMENT\' | translate | lowercase}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.formInfo.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.CERTIFICATE_GET_DATE\' | translate}}</th><td>{{ $ctrl.data.acquireDate }}</td></tr><tr><th>{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</th><td><span ng-if=\"$ctrl.data.isForever === 0\">{{ ::$ctrl.data.expireDate}}</span> <span ng-if=\"$ctrl.data.isForever === 1\">{{ \'FIELD.NEVER_EXPIRE\' | translate}}</span></td></tr><tr><th>{{ \'FIELD.CERTIFICATE_NUMBER\' | translate}}</th><td>{{::$ctrl.data.licenseId}}</td></tr><tr><th>{{ \'FIELD.BONUS\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;</span>{{ \'FIELD.REFERENCE_MATERIAL\' | translate | lowercase}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.REWARD_METHOD\' | translate}}</th><td><div><span ng-if=\"$ctrl.data.bonusType === 1\">{{ \'FIELD.BONUS_COST\' | translate }}&nbsp;{{ ::$ctrl.currency.name}}&nbsp;{{ ::$ctrl.data.bonusCost}}</span> <span ng-if=\"$ctrl.data.bonusType === 2\">{{ ::$ctrl.data.bonusOtherWay}}</span></div></td></tr><tr><th>{{ \'FIELD.STATUS\' | translate}}</th><td>{{::$ctrl.data.approvalStatus}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/cert-zone/views/ext-cert-apply-form-reg-view.html","<div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.applyDate}}</td></tr></tbody></table><table class=\"BoxTable BoxTable-text-left\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.subjectName}}</td></tr><tr><th>{{ \'FIELD.CERTIFICATE_GET_DATE\' | translate}}</th><td>{{::$ctrl.data.acquireDate}}</td></tr><tr><th>{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</th><td><span ng-if=\"$ctrl.data.isForever === 0\">{{ ::$ctrl.data.expireDate}}</span> <span ng-if=\"$ctrl.data.isForever === 1\">{{ \'FIELD.NEVER_EXPIRE\' | translate}}</span></td></tr><tr><th>{{ \'FIELD.CERTIFICATE_NUMBER\' | translate}}</th><td>{{::$ctrl.data.licenseId}}</td></tr><tr><th>{{ \'FIELD.REMARK\' | translate}}</th><td>{{::$ctrl.data.comment}}</td></tr><tr><th>{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.STATUS\' | translate}}</th><td>{{::$ctrl.data.approvalStatus}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/cert-zone/views/ext-cert-apply-form-test-view.html","<div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.applyDate}}</td></tr></tbody></table><table class=\"BoxTable BoxTable-text-left\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.subjectName}}</td></tr><tr><th>{{ \'FIELD.APPLY_REASON\' | translate}}</th><td>{{::$ctrl.data.reason}}</td></tr><tr><th>{{ \'FIELD.TEST_DATE\' | translate}}</th><td><div ng-repeat=\"testTimes in ::$ctrl.data.testTimes\">{{testTimes}}</div></td></tr><tr><th>{{ \'FIELD.TEST_PLAN\' | translate}}</th><td>{{::$ctrl.data.testPlace}}</td></tr><tr><th>{{ \'FIELD.TEST_COST\' | translate}}</th><td>{{::$ctrl.currency.name}}&nbsp;{{::$ctrl.data.testFee |number}}</td></tr><tr><th>{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.STATUS\' | translate}}</th><td>{{::$ctrl.data.approvalStatus}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/cert-zone/views/external-cert-application-records-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"30\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"extcert-apply-classes\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.formType}\" ng-model=\"$ctrl.filters.formType\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"companys\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.companyId}\" ng-model=\"$ctrl.filters.companyId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"subjects\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.subjectId, companyId: $ctrl.filters.companyId}\" ng-model=\"$ctrl.filters.subjectId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.STATUS\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"static-approve-status\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.status}\" ng-model=\"$ctrl.filters.status\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.APPLY_DATE_START\' | translate}}</div><div flex-gt-xs=\"75\" class=\"\"><md-datepicker ng-model=\"$ctrl.filters.beginDate\" ng-change=\"$ctrl.updateEndDateModel()\" md-placeholder=\"{{\'MESSAGE.MSG_PLEASE_ENTER_START_DATE\' |translate}}\"></md-datepicker></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.APPLY_DATE_END\' | translate}}</div><div flex-gt-xs=\"75\" class=\"\"><cus-md-datepicker ng-model=\"$ctrl.filters.endDate\" md-min-date=\"$ctrl.filters.beginDate\" md-placeholder=\"{{\'MESSAGE.MSG_PLEASE_ENTER_END_DATE\' |translate}}\"></cus-md-datepicker></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.cancel()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-click=\"$ctrl.submit($ctrl.filters)\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/external-cert-application-records-search.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_CERT_APPLICATION_RECORDS_SEARCH\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.showPrompt($event)\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.certTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></section></div></div>");
$templateCache.put("app/modules/cert-zone/views/external-cert-detail-info-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'CERTIFICATE_INFO_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\" class=\"hidden-x-scrollbar\"><div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><div class=\"th-title\"><h2>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}: {{$ctrl.extCertInfo.subject}}</h2><div class=\"tagBox\"><span class=\"spanTag\">{{ \'FIELD.EXTERNAL_LICENSE\' | translate}}</span> <span ng-repeat=\"category in $ctrl.extCertInfo.categoryList\" class=\"spanTag\">{{category.categoryName}}</span></div></div><div class=\"th-tab\"><div class=\"tab-content\"><div class=\"tab-pane th-courseData\"><h4>{{ \'CERTIFICATE_INFO_DETAIL\' | translate}}</h4><dl><dt>{{ \'FIELD.BASIC_INFORMATION\' | translate}}</dt><dd><ul><li><p class=\"li-title\">{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.companyName}}</p></li><li ng-if=\"$ctrl.extCertInfo.credits!==\'\' && $ctrl.extCertInfo.isShowCredit === 1\"><p class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.credits}}</p></li><li ng-if=\"$ctrl.extCertInfo.classification!==\'\'\"><p class=\"li-title\">{{ \'FIELD.CLASSIFICATION\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.classification}}</p></li><li ng-if=\"$ctrl.extCertInfo.suitableDepartment!==\'\'\"><p class=\"li-title\">{{ \'FIELD.APPLICABLE_UNITS\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.suitableDepartment}}</p></li><li><p class=\"li-title\">{{ \'FIELD.REWARD_METHOD\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.bonusWay}}</p></li></ul></dd></dl><dl ng-if=\"$ctrl.extCertInfo.description!==\'\' || $ctrl.extCertInfo.newApplyRule!==\'\' || $ctrl.extCertInfo.renewApplyRule!==\'\'\"><dt>{{ \'FIELD.COURSE_INTRODUCTION\' | translate}}</dt><dd><ul class=\"pt-full\"><li ng-if=\"$ctrl.extCertInfo.description!==\'\'\"><p class=\"li-title\">{{ \'FIELD.DESCRIPTION\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.description}}</p></li><li ng-if=\"$ctrl.extCertInfo.newApplyRule!==\'\'\"><p class=\"li-title\">{{ \'NEWLY_OBTAIN_THIS_CERTIFIED_SUBJECT_CONDITION\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.newApplyRule}}</p></li><li ng-if=\"$ctrl.extCertInfo.renewApplyRule!==\'\'\"><p class=\"li-title\">{{ \'EXPIRED_AFTER_REACQUISITION_OF_THIS_CERTIFIED_SUBJECT_CONDITION\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.renewApplyRule}}</p></li></ul></dd></dl><dl><dt>{{ \'FIELD.OTHER\' | translate}}</dt><dd><ul><li><p class=\"li-title\">{{ \'FIELD.DIFFICULTY\' | translate}}：</p><p class=\"text\"><ng-rate-it ng-model=\"$ctrl.extCertInfo.difficulty\" read-only=\"true\"></ng-rate-it></p></li><li ng-if=\"$ctrl.extCertInfo.compensationRatio!==\'\'\"><p class=\"li-title\">{{ \'FIELD.PERCENTAGE_OF_EXAMINATIONS\' | translate}}：</p><p class=\"text\">{{$ctrl.extCertInfo.compensationRatio}}</p></li><li ng-if=\"$ctrl.extCertInfo.referenceCourses.length > 0\"><p class=\"li-title\">{{ \'FIELD.REFERENCE_COURSE\' | translate}}：</p><a href=\"javascript:void(0)\" ng-repeat=\"references in $ctrl.extCertInfo.referenceCourses\" tip-info=\"\" tip-type=\"{{references.type}}\" params=\"{id: references.id}\"><p class=\"text\">{{references.name}}</p></a></li></ul></dd></dl></div><div class=\"tab-pane th-courseData\" ng-if=\"$ctrl.prerequisiteItem.length > 0\"><h4>{{ \'YOU_MUST_FIRST_OBTAIN_A_CERTIFIED_SUBJECT\' | translate}}</h4><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div ng-repeat=\"prerequisite in $ctrl.prerequisiteItem\" layout=\"column\"><md-checkbox class=\"m-r-20\" ng-disabled=\"true\" ng-checked=\"prerequisite.isPass\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"7\" params=\"{subid: prerequisite.id}\">{{prerequisite.name}}</a></md-checkbox></div></div></div><div class=\"tab-pane th-assign\"><h4>{{ \'NEWLY_OBTAIN_THIS_CERTIFIED_SUBJECT_CONDITION\' | translate}}</h4><table ng-table=\"$ctrl.newApplyRuleItem\" class=\"animate tb-transfer\" ng-table-columns-binding=\"cols\"><tr ng-repeat=\"newApplyRuleItem in $data\"><td data-title=\"\'FIELD.CONDITION_NUMBER\' | translate\">{{newApplyRuleItem.index}}</td><td data-title=\"\'FIELD.HAS_BEEN_CERTIFIED_SUBJECTS\' | translate\"><span ng-repeat=\"acquired in newApplyRuleItem.acquiredSubject\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"{{acquired.type}}\" params=\"{id: acquired.id}\">{{acquired.name | markSplit:$index:\' , \'}}</a></span></td><td data-title=\"\'FIELD.PASS_THE_EXAM_PROJECT\' | translate\"><span ng-repeat=\"passed in newApplyRuleItem.passedTestItem\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"{{passed.type}}\" params=\"{id: passed.id}\">{{passed.name | markSplit:$index:\' , \'}}</a></span></td></tr></table></div><div class=\"tab-pane th-assign\"><h4>{{ \'EXPIRED_AFTER_REACQUISITION_OF_THIS_CERTIFIED_SUBJECT_CONDITION\' | translate}}</h4><table ng-table=\"$ctrl.renewApplyRuleItem\" class=\"animate tb-transfer\" ng-table-columns-binding=\"cols\"><tr ng-repeat=\"renewApplyRule in $data\"><td data-title=\"\'FIELD.CONDITION_NUMBER\' | translate\">{{renewApplyRule.index}}</td><td data-title=\"\'FIELD.HAS_BEEN_CERTIFIED_SUBJECTS\' | translate\"><span ng-repeat=\"acquired in renewApplyRule.acquiredSubject\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"{{acquired.type}}\" params=\"{id: acquired.id}\">{{acquired.name | markSplit:$index:\' , \'}}</a></span></td><td data-title=\"\'FIELD.PASS_THE_EXAM_PROJECT\' | translate\"><span ng-repeat=\"passed in renewApplyRule.passedTestItem\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"{{passed.type}}\" params=\"{id: passed.id}\">{{passed.name | markSplit:$index:\' , \'}}</a></span></td></tr></table></div></div></div></section></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/external-cert-exam-allowance-application.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.certTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></section></div></div>");
$templateCache.put("app/modules/cert-zone/views/external-cert-exam-application.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_CERT_EXAM_APPLICATION\' |translate}}</h2></div><div class=\"th-license\"><form name=\"$ctrl.certificateForm\"><div class=\"md-license\"><md-content layout-padding=\"\"><div class=\"thForm\"><div layout-gt-xs=\"row\" ng-repeat=\"testTime in $ctrl.testTimes track by $index\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span ng-if=\"$index===0\"><span class=\"pt-mark\">*</span>{{ \'FIELD.TEST_DATE\' | translate}}</span></div><div layout=\"row\" flex-gt-xs=\"70\"><div flex-gt-xs=\"95\" class=\"p-l-20\"><md-input-container><label>{{ \'FIELD.TEST_DATE\' | translate}}</label><md-datepicker name=\"testTime{{$index}}\" ng-model=\"testTime.value\" ng-change=\"$ctrl.checkTimeRepeat(testTime.value, $index)\" ng-required=\"$ctrl.required\"></md-datepicker></md-input-container><div ng-messages=\"$ctrl.certificateForm[\'testTime\' + $index].$error\" role=\"alert\"><span ng-if=\"$ctrl.certificateForm[\'testTime\' + $index].$touched\" ng-message=\"valid\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.PLEASE_ENTER_A_VALID_DATE\' | translate}}</span> <span ng-show=\"testTime.repeat\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.SET_THE_TIME_PART_OF_OVERLAP_PLEASE_RESET\' | translate}}</span></div></div><div flex-gt-xs=\"5\" class=\"el-inBlock m-t-12\" ng-if=\"$index!==0\"><button type=\"button\" title=\"{{ \'ACTIONS.DELETE_A_TIME\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-danger\" ng-click=\"$ctrl.removeTimeSelect($index)\"><i class=\"fa fa-trash-o\"></i><div class=\"ripple-wrapper\"></div></button></div><div flex-gt-xs=\"5\" class=\"el-inBlock m-t-12\" ng-if=\"$index===0\"><button type=\"button\" title=\"{{ \'ACTIONS.ADD_A_TIME\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" ng-click=\"$ctrl.addTimeSelect($index)\"><i class=\"fa fa-plus\"></i><div class=\"ripple-wrapper\"></div></button></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-select ng-model=\"$ctrl.companyId\" ng-change=\"$ctrl.companySubject($ctrl.companyId)\"><md-option ng-repeat=\"company in $ctrl.companys track by $index\" ng-value=\"company.value\">{{company.name}}</md-option></md-select></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-select name=\"subjectId\" ng-model=\"$ctrl.params.subjectId\" ng-change=\"$ctrl.getCanReNew($ctrl.params.subjectId)\" ng-required=\"$ctrl.required\"><md-option ng-repeat=\"subject in $ctrl.subjects track by $index\" ng-value=\"subject.value\">{{subject.name}}</md-option></md-select><div ng-messages=\"$ctrl.certificateForm.subjectId.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.APPLY_CATEGORY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-20\"><md-radio-group ng-model=\"$ctrl.params.isReNew\"><md-radio-button value=\"0\" class=\"el-inBlock p-r-20\">{{ \'FIELD.NEW_APPLY\' | translate}}</md-radio-button><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\" ng-disabled=\"$ctrl.canReNew===\'0\'\">{{ \'FIELD.EXTENSION_APPLY\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.APPLY_REASON\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container><textarea name=\"reason\" ng-required=\"$ctrl.required || $ctrl.certificateForm.reason.$touched\" ng-model=\"$ctrl.formData.reason\" placeholder=\"{{ \'FIELD.APPLY_REASON\' | translate}}\" md-maxlength=\"150\" rows=\"1\">\n                      </textarea></md-input-container><div ng-messages=\"$ctrl.certificateForm.reason.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.TEST_PLAN\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-20\"><md-radio-group ng-model=\"$ctrl.formData.isDomestic\"><md-radio-button value=\"0\" class=\"el-inBlock p-r-20\">{{ \'FIELD.DOMESTIC\' | translate}}</md-radio-button><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.ABROAD\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.DETAIL_ADDRESS\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container><input name=\"address\" ng-required=\"$ctrl.required || $ctrl.certificateForm.address.$touched\" ng-model=\"$ctrl.formData.address\" placeholder=\"{{ \'FIELD.DETAIL_ADDRESS\' | translate}}\"></md-input-container><div ng-messages=\"$ctrl.certificateForm.address.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div></div></md-content></div><div class=\"md-license\"><md-content layout-padding=\"\"><div class=\"thForm\"><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.TEST_COST\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><div class=\"p-10 pt-bgGroup\"><div layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.CURRENCY\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-select ng-model=\"$ctrl.formData.testFeeCurrency\" ng-change=\"$ctrl.getExchangeRate()\"><md-option ng-repeat=\"currency in $ctrl.currencys track by $index\" ng-value=\"currency.value\">{{currency.name}}</md-option></md-select></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.AMOUNT\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container><input ng-model=\"$ctrl.formData.testFeeAmount\" type=\"number\" ng-pattern=\"/^-?[0-9][^\\.]*$/\" ng-change=\"$ctrl.getExchangeRate()\" placeholder=\"{{ \'FIELD.AMOUNT\' | translate}}\"></md-input-container></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.SYSTEM_CURRENCY\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container><input ng-model=\"$ctrl.formData.testFee\" placeholder=\"{{ \'PLACEHOLDERS.CONVERSION_AMOUNT\' | translate}}\" readonly=\"\"></md-input-container></div></div></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} {{\'FIELD.ONE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-12\"><div class=\"p-10 pt-bgGroup\"><input type=\"file\" ngf-select=\"$ctrl.selectFile(0, $files)\"></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} {{\'FIELD.TWO\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-12\"><div class=\"p-10 pt-bgGroup\"><input type=\"file\" ngf-select=\"$ctrl.selectFile(1, $files)\"></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} {{\'FIELD.THREE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-12\"><div class=\"p-10 pt-bgGroup\"><input type=\"file\" ngf-select=\"$ctrl.selectFile(2, $files)\"></div></div></div></div></md-content></div><footer class=\"th-submit\"><md-button class=\"md-raised md-warn md-btn btn-transparent\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" ng-click=\"$ctrl.finish($ctrl.formData)\">{{ \'ACTIONS.SEND_APPLY\' | translate}}</md-button></footer></form></div></section></div></div>");
$templateCache.put("app/modules/cert-zone/views/external-cert-qualify-reward-application.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_CERT_QUALIFY_REWARD_APPLICATION\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.certTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></section></div></div>");
$templateCache.put("app/modules/cert-zone/views/external-cert-register.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_CERT_REGISTER\' |translate}}</h2></div><div class=\"th-license\"><form name=\"$ctrl.certificateForm\"><div class=\"md-license\"><md-content layout-padding=\"\"><div class=\"thForm\"><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-select ng-model=\"$ctrl.companyId\" ng-change=\"$ctrl.companySubject($ctrl.companyId)\"><md-option ng-repeat=\"company in $ctrl.companys track by $index\" ng-value=\"company.value\">{{company.name}}</md-option></md-select></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-select name=\"subjectId\" ng-model=\"$ctrl.params.subjectId\" ng-change=\"$ctrl.getCanReNew($ctrl.params.subjectId)\" ng-required=\"$ctrl.required\"><md-option ng-repeat=\"subject in $ctrl.subjects track by $index\" ng-value=\"subject.value\">{{subject.name}}</md-option></md-select><div ng-messages=\"$ctrl.certificateForm.subjectId.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.APPLY_CATEGORY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-20\"><md-radio-group ng-model=\"$ctrl.params.isReNew\"><md-radio-button value=\"0\" class=\"el-inBlock p-r-20\">{{ \'FIELD.NEW_APPLY\' | translate}}</md-radio-button><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\" ng-disabled=\"$ctrl.canReNew===\'0\'\">{{ \'FIELD.EXTENSION_APPLY\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.CERTIFICATE_GET_DATE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container><label>{{ \'FIELD.CERTIFICATE_GET_DATE\' | translate}}</label><md-datepicker ng-model=\"$ctrl.formData.acquireDate\" name=\"acquireDate\" ng-required=\"$ctrl.required\"></md-datepicker></md-input-container><div ng-messages=\"$ctrl.certificateForm.acquireDate.$error\" role=\"alert\"><span ng-message=\"valid\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.PLEASE_ENTER_A_VALID_DATE\' | translate}}</span> <span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-20\"><md-radio-group ng-model=\"$ctrl.formData.isForever\"><md-radio-button ng-value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.PERMANENT\' | translate}}</md-radio-button><md-radio-button ng-value=\"0\" class=\"el-inBlock p-r-20\">{{\'ACTIONS.SELECT\' | translate}}{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</md-radio-button></md-radio-group><md-input-container><span class=\"pt-mark\">*</span><label>{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</label><md-datepicker ng-model=\"$ctrl.formData.expireDate\" ng-disabled=\"$ctrl.formData.isForever===1\" name=\"expireDate\" ng-required=\"($ctrl.required || $ctrl.certificateForm.expireDate.$touched) && $ctrl.formData.isForever===0\"></md-datepicker></md-input-container><div ng-messages=\"$ctrl.certificateForm.expireDate.$error\" ng-show=\"$ctrl.formData.isForever===0\" role=\"alert\"><span ng-message=\"valid\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.PLEASE_ENTER_A_VALID_DATE\' | translate}}</span> <span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div></div></md-content></div><div class=\"md-license\"><md-content layout-padding=\"\"><div class=\"thForm\"><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.CERTIFICATE_NUMBER\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container><input name=\"licenseId\" ng-required=\"$ctrl.required || $ctrl.certificateForm.licenseId.$touched\" ng-model=\"$ctrl.formData.licenseId\" placeholder=\"{{ \'FIELD.CERTIFICATE_NUMBER\' | translate}}\"></md-input-container><div ng-messages=\"$ctrl.certificateForm.licenseId.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REMARK\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container><textarea name=\"comment\" ng-model=\"$ctrl.formData.comment\" md-maxlength=\"150\" rows=\"1\" placeholder=\"{{ \'FIELD.REMARK\' | translate}}\"></textarea></md-input-container></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} {{\'FIELD.ONE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-12\"><div class=\"p-10 pt-bgGroup\"><input type=\"file\" ngf-select=\"$ctrl.selectFile(0, $files)\"></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} {{\'FIELD.TWO\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-12\"><div class=\"p-10 pt-bgGroup\"><input type=\"file\" ngf-select=\"$ctrl.selectFile(1, $files)\"></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} {{\'FIELD.THREE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20 m-t-12\"><div class=\"p-10 pt-bgGroup\"><input type=\"file\" ngf-select=\"$ctrl.selectFile(2, $files)\"></div></div></div></div></md-content></div><footer class=\"th-submit\"><md-button class=\"md-raised md-warn md-btn btn-transparent\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" ng-click=\"$ctrl.finish($ctrl.formData)\">{{ \'ACTIONS.SEND_APPLY\' | translate}}</md-button></footer></form></div></section></div></div>");
$templateCache.put("app/modules/cert-zone/views/financial-cert-record-application.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/cert-zone/views/financial-cert-record-search.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/course-resource/views/course-detail-info-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\" class=\"dialog-transition-none\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.COURSE_INFO_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\" class=\"hidden-x-scrollbar\"><div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><course-detail-header data=\"$ctrl.courseData\"></course-detail-header><div class=\"th-tab\"><div class=\"tab-content\"><course-detail-info data=\"$ctrl.courseData\" reference-data=\"$ctrl.referenceData\"></course-detail-info><course-detail-prerequisite-items data=\"$ctrl.courseData.prerequisites\" course-type=\"$ctrl.courseData.courseType\"></course-detail-prerequisite-items><detail-session-list md-dialog-close=\"$ctrl.close()\" course-id=\"$ctrl.courseData.courseId\"></detail-session-list></div></div></section></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-info.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><course-detail-header data=\"$ctrl.courseData\" go-back=\"$ctrl.goBack\"></course-detail-header><div class=\"th-tab\"><div class=\"tab-content\"><course-detail-info data=\"$ctrl.courseData\" reference-data=\"$ctrl.referenceData\"></course-detail-info><course-detail-prerequisite-items data=\"$ctrl.courseData.prerequisites\" course-type=\"$ctrl.courseData.courseType\"></course-detail-prerequisite-items><detail-session-list course-id=\"$ctrl.courseData.courseId\"></detail-session-list></div></div></section></div></div>");
$templateCache.put("app/modules/course-resource/views/course-learning-resource-menu.html","<script type=\"text/ng-template\" id=\"course_resource_nodes_renderer.html\"><a ui-sref=\"courseResourceCatalog(::{cid:$ctrl.catalogId, nid:node.id})\" ng-if=\"::node.nodes.length > 0\" aria-expanded=\"false\" ng-click=\"$ctrl.toggleNode(node)\"> <i class=\"fa fa-fw fa-folder\"></i> <span>{{::node.title}}</span> </a> <a ui-sref=\"courseResourceCatalog(::{cid:$ctrl.catalogId, nid:node.id})\" ng-if=\"::node.nodes.length === 0\" aria-expanded=\"false\" ng-click=\"$ctrl.toggleNode(node)\"> <span class=\"fa fa-fw fa-folder-o\"></span> <span>{{::node.title}}</span> </a> <ul naria-expanded=\"false\" ng-class=\"{in: node.showChildren}\" class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-if=\"node.showChildren && node.nodes.length > 0\"> <li ng-repeat=\"node in node.nodes\" ng-class=\"{active: node.showChildren}\" ui-tree-node ng-include=\"\'course_resource_nodes_renderer.html\'\"></li> </ul></script><ul class=\"nav nav-sidebar metismenu\"><li ng-if=\"$ctrl.previousMenu\"><a ng-if=\"$ctrl.previousMenu.model[\'state\'] != \'page\'\" ui-sref=\"{{$ctrl.previousMenu.model[\'state\']}}({mid: $ctrl.previousMenu.model[\'stateParams\'][\'mid\']})\" ui-sref-opts=\"{reload:true}\"><i class=\"icon-home\"></i><span>{{\'ACTIONS.RETURN\' | translate}}{{ $ctrl.previousMenu.model[\'title\'] }}</span></a> <a ng-if=\"$ctrl.previousMenu.model[\'state\'] == \'page\'\" ui-sref=\"page({mid: $ctrl.previousMenu.model[\'stateParams\'][\'mid\'], url: $ctrl.previousMenu.model[\'stateParams\'][\'url\']})\" ui-sref-opts=\"{reload:true}\"><i class=\"icon-home\"></i><span>{{\'ACTIONS.RETURN\' | translate}}{{ $ctrl.previousMenu.model[\'title\'] }}</span></a></li><li ng-metis=\"\" mobile-sidebar=\"\" class=\"metismenu-parent active\" ui-tree=\"\" ng-click=\"$ctrl.initScrollBar()\" ng-if=\"$ctrl.mainMenu\"><a ui-sref=\"courseResourceCatalog({cid: $ctrl.mainMenu.stateParams[\'cid\'], nid: undefined})\" ng-if=\"$ctrl.menu.length === 0\"><i class=\"icon icons-education-science-18\"></i> <span>{{ $ctrl.mainMenu.title }}</span></a> <a ui-sref=\"courseResourceCatalog({cid: $ctrl.mainMenu.stateParams[\'cid\'], nid: undefined})\" ng-if=\"$ctrl.menu.length > 0\"><i class=\"icon icons-education-science-18\"></i> <span>{{ $ctrl.mainMenu.title }}</span> <span class=\"fa arrow\"></span></a><ul class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"$ctrl.menu\" id=\"course-resource-tree-root\"><li ng-metis=\"\" ng-repeat=\"node in $ctrl.menu\" ui-tree-node=\"\" ng-class=\"{active: node.showChildren}\" ng-click=\"treeNode.toggle(this)\" ng-include=\"\'course_resource_nodes_renderer.html\'\"></li></ul></li></ul>");
$templateCache.put("app/modules/course-resource/views/course-resource-catalog-list.html","<div class=\"row animated fadeIn\" ng-if=\"!$ctrl.isShowIndex\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList th-waitCourse th-resour\"><div class=\"th-title\"><h2>{{$ctrl.courseResourceTitle}}</h2></div><header><ui-pagination-header-controls pagination-id=\"courseResource\" pagination-filter=\"$ctrl.pagination.filter\" filters=\"[{key : \'all\', value:\'-1\', name:\'FIELD.ALL\', permissions:[\'Modules.course\']}, {key : \'programType\', value:\'0\', name:\'FIELD.PROGRAM\', permissions:[\'Modules.curriculum\']}, {key : \'courseType\', value:\'1\', name:\'FIELD.ONLINE_COURSE\', permissions:[\'Modules.course.online\']}, {key : \'courseType\', value:\'2\', name:\'FIELD.CLASS_ROOM_COURSE\', permissions:[\'Modules.course.classroom\']}, {key : \'courseType\', value:\'3\', name:\'FIELD.EXTERNAL_TRAINING\', permissions:[\'Modules.course.external\']}, {key : \'courseType\', value:\'4\', name:\'FIELD.ONLINE_TEST\', permissions:[\'Modules.course.onlinetest\']}, {key : \'courseType\', value:\'5\', name:\'FIELD.CLASS_ROOM_TEST\', permissions:[\'Modules.course.classroomtest\']}, {key : \'courseType\', value:\'6\', name:\'FIELD.QUESTIONNAIRE\', permissions:[\'Modules.course.survey\']}, {key : \'programType\', value:\'1\', name:\'FIELD.INTERNAL_LICENSE\', permissions:[\'Modules.certification.inner\']}, {key : \'onlyFavorite\', value:\'1\', name:\'FIELD.MY_FAVOURITE\', permissions:[\'Modules.course.online\',\'Modules.course.classroom\',\'Modules.course.external\',\'Modules.curriculum\']}]\" reload-pagination-data=\"$ctrl.getData(params)\" has-search-box=\"true\" has-change-template=\"true\" template-type=\"{{$ctrl.templateType}}\" placeholder=\"{{ \'PLACEHOLDERS.SEARCH_COURSE_RESOURCE\' | translate}}\"></ui-pagination-header-controls></header><div ng-if=\"$ctrl.isLoading\" class=\"page-spinner-loader\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"courseResourceData in $ctrl.courseResourceDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" pagination-id=\"courseResource\" ng-class=\"{1:\'elearn\', 2:\'room\', 3:\'train\',4:\'test-e\',5:\'test\', 6:\'package\', 0:{0:\'package\', 1:\'licenses\'}[courseResourceData.programType]}[courseResourceData.courseType]\"><course-learning-resource-info ng-if=\"!$ctrl.isSearchMode || courseResourceData.courseType === 0\" node-id=\"$ctrl.nodeId\" course-resource-data=\"courseResourceData\" reload-fn=\"$ctrl.getData($ctrl.params)\" params=\"$ctrl.params\"></course-learning-resource-info><full-text-search-course-info ng-if=\"$ctrl.isSearchMode && courseResourceData.courseType !== 0\" node-id=\"$ctrl.nodeId\" info-data=\"courseResourceData\" reload-fn=\"$ctrl.getData($ctrl.params)\" back-state=\"courseResourceCatalog\" params=\"$ctrl.params\"></full-text-search-course-info></div></div></div><footer ng-if=\"$ctrl.courseResourceDatas.length > 0\"><ui-pagination-controls on-page-change=\"$ctrl.getData(params)\" pagination-id=\"courseResource\"></ui-pagination-controls></footer></section></div></div><div class=\"row animated fadeIn\" ng-if=\"$ctrl.isShowIndex\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList th-waitCourse th-resour\"><div class=\"th-title\"><h2>{{ \'COURSE_LEARNING_RESOURCE\' | translate}}</h2></div><header><ui-pagination-header-controls pagination-id=\"courseResource\" pagination-filter=\"$ctrl.pagination.filter\" filters=\"$ctrl.filter\" reload-pagination-data=\"$ctrl.searchData(params)\" has-search-box=\"true\" has-change-template=\"true\" template-type=\"{{$ctrl.templateType}}\" placeholder=\"{{ \'PLACEHOLDERS.SEARCH_COURSE_RESOURCE\' | translate}}\"></ui-pagination-header-controls></header><div ng-if=\"$ctrl.isLoading\" class=\"page-spinner-loader\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div><md-tabs md-active=\"$ctrl.tabSelect===\'latestCourse\'\" ng-if=\"!$ctrl.isSearchMode\" md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=\"true\"><md-tab md-on-deselect=\"$ctrl.reload = false\" md-on-select=\"$ctrl.getLatestCourses()\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.LATEST_COURSE\' | translate}}</span></md-tab-label><md-tab-body><div class=\"row md-padding\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ng-repeat=\"courseResourceData in $ctrl.latestCourses\" ng-class=\"{0:\'package\', 1:\'elearn\', 2:\'room\', 3:\'train\',4:\'test-e\',5:\'test\'}[courseResourceData.courseType]\"><course-learning-resource-info node-id=\"$ctrl.nodeId\" course-resource-data=\"courseResourceData\" reload-fn=\"$ctrl.getLatestCourses()\" params=\"$ctrl.params\"></course-learning-resource-info></div></div></div></md-tab-body></md-tab><md-tab md-active=\"$ctrl.tabSelect===\'hotCourse\'\" md-on-deselect=\"$ctrl.reload = false\" md-on-select=\"$ctrl.getHotCourse()\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.HOT_COURSE\' | translate}}</span></md-tab-label><md-tab-body><div class=\"row md-padding\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ng-repeat=\"courseResourceData in $ctrl.hotCourses\" ng-class=\"{0:\'package\', 1:\'elearn\', 2:\'room\', 3:\'train\',4:\'test-e\',5:\'test\'}[courseResourceData.courseType]\"><course-learning-resource-info node-id=\"$ctrl.nodeId\" course-resource-data=\"courseResourceData\" reload-fn=\"$ctrl.getHotCourse()\" params=\"$ctrl.params\"></course-learning-resource-info></div></div></div></md-tab-body></md-tab><md-tab md-active=\"$ctrl.tabSelect===\'featuredCourse\'\" md-on-deselect=\"$ctrl.reload = false\" md-on-select=\"$ctrl.getFeaturedCourses($ctrl.params)\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.FEATURED_COURSE\' | translate}}</span></md-tab-label><md-tab-body><div class=\"row md-padding\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"courseResourceData in $ctrl.featuredCourses | itemsPerPage:$ctrl.featuredCoursesPagination.perPage\" total-items=\"$ctrl.featuredCoursesPagination.total\" current-page=\"$ctrl.featuredCoursesPagination.currentPage\" pagination-id=\"featuredCourses\" ng-class=\"{0:\'package\', 1:\'elearn\', 2:\'room\', 3:\'train\',4:\'test-e\',5:\'test\'}[courseResourceData.courseType]\"><course-learning-resource-info node-id=\"$ctrl.nodeId\" course-resource-data=\"courseResourceData\" reload-fn=\"$ctrl.getFeaturedCourses()\" params=\"$ctrl.params\"></course-learning-resource-info></div></div></div></md-tab-body></md-tab></md-tabs><footer ng-if=\"!$ctrl.isSearchMode && $ctrl.tabSelect ===\'featuredCourse\' && $ctrl.featuredCourses.length > 0\"><ui-pagination-controls on-page-change=\"$ctrl.getFeaturedCourses(params)\" pagination-id=\"featuredCourses\"></ui-pagination-controls></footer><div class=\"row\" ng-show=\"$ctrl.isSearchMode\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"courseResourceData in $ctrl.courseResourceDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" pagination-id=\"courseResource\" ng-class=\"{1:\'elearn\', 2:\'room\', 3:\'train\',4:\'test-e\',5:\'test\', 6:\'package\', 0:{0:\'package\', 1:\'licenses\'}[courseResourceData.programType]}[courseResourceData.courseType]\"><course-learning-resource-info ng-if=\"!$ctrl.isSearchMode || courseResourceData.courseType === 0\" node-id=\"$ctrl.nodeId\" course-resource-data=\"courseResourceData\" reload-fn=\"$ctrl.searchData($ctrl.params)\" params=\"$ctrl.params\"></course-learning-resource-info><full-text-search-course-info ng-if=\"$ctrl.isSearchMode && courseResourceData.courseType !== 0\" node-id=\"$ctrl.nodeId\" info-data=\"courseResourceData\" reload-fn=\"$ctrl.searchData($ctrl.params)\" back-state=\"courseResourceCatalog\" params=\"$ctrl.params\"></full-text-search-course-info></div><div class=\"pt-noData\" ng-if=\"$ctrl.courseResourceDatas.length===0 && !$ctrl.isLoading\"><i class=\"ctms-icons icon-face-10\"></i><p>{{ \'FIELD.THERE_IS_NO_DATA\' | translate}}</p></div></div></div><footer ng-if=\"$ctrl.isSearchMode\"><ui-pagination-controls on-page-change=\"$ctrl.searchData(params)\" pagination-id=\"courseResource\"></ui-pagination-controls></footer></section></div></div>");
$templateCache.put("app/modules/course-resource/views/course-search.html","<script type=\"text/ng-template\" id=\"courseHeaderCheckbox.html\"><md-checkbox flex class=\"md-primary checkbox\" ng-if=\"$ctrl.chooseMethod===\'checkbox\'\" ng-model=\"$ctrl.courseSelectAll\" ng-change=\"$ctrl.selectCourse()\"></md-checkbox></script><h4 class=\"el-header\">{{ \'FIELD.ADD_ITEM_FORM_STUDY_CATALOG\' | translate }}</h4><div class=\"chat-search\"><div class=\"append-icon\"><input type=\"text\" ng-model=\"$ctrl.keyword\" class=\"form-control\" placeholder=\"{{ \'FIELD.SEARCH_COURSE_NAME\' | translate }}\"> <i class=\"icon-magnifier\"></i></div></div><div class=\"box-content md-course-search tb-Collapse\" ng-if=\"$ctrl.chooseCourse.length > 0\"><p>{{ \'FIELD.YOU_HAVE_SELECTED_COURSES\' | translate}}</p><div class=\"pt-assign\"><span ng-repeat=\"course in $ctrl.chooseCourse track by $index\">{{course.activity.name}}<md-icon md-font-set=\"md\" aria-label=\"Close dialog\" ng-click=\"(($ctrl.chooseCourse |arrayObjectIndexOf:course) > -1)?$ctrl.removeCourse(course):$ctrl.addCourse(course)\">close</md-icon></span></div></div><table ng-table=\"$ctrl.corsesTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"course in $data track by $index\"><td data-title=\"\'ACTIONS.SELECT_ALL\' | translate\" header=\"\'courseHeaderCheckbox.html\'\"><md-checkbox flex=\"\" class=\"md-primary checkbox\" ng-checked=\"($ctrl.chooseCourse |arrayObjectIndexOf:course) > -1\" ng-if=\"$ctrl.chooseMethod===\'checkbox\'\" ng-click=\"(($ctrl.chooseCourse |arrayObjectIndexOf:course) > -1)?$ctrl.removeCourse(course):$ctrl.addCourse(course)\"></md-checkbox><md-radio-group ng-if=\"$ctrl.chooseMethod===\'radio\'\" ng-model=\"$ctrl.radio\"><md-radio-button class=\"md-primary radio\" ng-value=\"course\" ng-click=\"$ctrl.removeCourse(course);$ctrl.addCourse(course)\"></md-radio-button></md-radio-group></td><td data-title=\"\'FIELD.COURSE_NAME\' | translate\"><div class=\"text-center\">{{course.activity.name}}</div></td><td data-title=\"\'FIELD.TYPE\' | translate\"><div class=\"text-center\" ng-switch=\"course.itemType\"><span ng-switch-when=\"1\">{{ \'FIELD.ONLINE_COURSE\' | translate}}</span> <span ng-switch-when=\"2\">{{ \'FIELD.CLASS_ROOM_COURSE\' | translate}}</span> <span ng-switch-when=\"4\">{{ \'FIELD.EXTERNAL_TRAINING\' | translate}}</span> <span ng-switch-when=\"8\">{{ \'FIELD.ONLINE_TEST\' | translate}}</span> <span ng-switch-when=\"16\">{{ \'FIELD.CLASS_ROOM_TEST\' | translate}}</span> <span ng-switch-when=\"32\">{{ \'FIELD.QUESTIONNAIRE\' | translate}}</span> <span ng-switch-when=\"64\">{{ \'FIELD.PROGRAM\' | translate}}</span> <span ng-switch-when=\"128\">{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</span> <span ng-switch-when=\"256\">{{ \'FIELD.EXTERNAL_LICENSE\' | translate}}</span> <span ng-switch-default=\"\">{{course.activity.type}}</span></div></td><td data-title=\"\'FIELD.LEARNING_ACTIVITY_STATUS\' | translate\"><div class=\"text-center\" ng-if=\"course.activity.isPublished===true\">{{\'STATUS.PUBLISHED\' | translate}}</div></td></tr></table>");
$templateCache.put("app/modules/course-resource/views/course-session-info.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><course-detail-header data=\"$ctrl.courseData\" enrollment-data=\"$ctrl.enrollmentData\" go-back=\"$ctrl.goBack\" reload-fn=\"$ctrl.getCourseData()\" is-user=\"$ctrl.isUser\"></course-detail-header><course-detail-enrollment data=\"$ctrl.courseData\" enrollment-data=\"$ctrl.enrollmentData\" session-data=\"$ctrl.sessionData\" reload-fn=\"$ctrl.getCourseData()\" u-live-course-data=\"$ctrl.uLiveCourseData\" is-u-live=\"$ctrl.sessionData.isULive\"></course-detail-enrollment><detail-completion-rate is-show=\"$ctrl.sessionData.isShowCompletionRate\" data=\"$ctrl.completionRateData\"></detail-completion-rate><div class=\"th-tab\"><div class=\"tab-content\"><md-content><md-tabs ng-if=\"$ctrl.enrollmentData\" md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab md-active=\"$ctrl.tabSelect===\'learningCenter\'\" ng-disabled=\"$ctrl.isUser===false || $ctrl.sessionData.canAction===0\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.LEARNING_CENTER\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div ng-if=\"$ctrl.sessionData.isULive === 0\"><course-detail-learning-content course-content-data=\"$ctrl.courseContentData\" enrollment-data=\"$ctrl.enrollmentData\" course-session-id=\"$ctrl.enrollmentData.sessionId\" result-type=\"content\" reload-fn=\"$ctrl.getCourseData()\" session-data=\"$ctrl.sessionData\"></course-detail-learning-content></div><div ng-if=\"$ctrl.sessionData.isULive > 0 && $ctrl.uLiveCourseData\"><course-detail-learning-ulive-content course-content-data=\"$ctrl.courseContentData\" u-live-course-data=\"$ctrl.uLiveCourseData\" enrollment-data=\"$ctrl.enrollmentData\" course-session-id=\"$ctrl.enrollmentData.sessionId\" result-type=\"content\" reload-fn=\"$ctrl.getCourseData()\" session-data=\"$ctrl.sessionData\"></course-detail-learning-ulive-content></div></md-content></md-tab-body></md-tab><md-tab md-active=\"$ctrl.tabSelect===\'aboutThisCourse\'\" ng-disabled=\"$ctrl.isUser===false\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.ABOUT_THIS_COURSE\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding tab-content\"><course-detail-info data=\"$ctrl.courseData\"></course-detail-info></md-content></md-tab-body></md-tab><md-tab md-on-deselect=\"reload = false\" md-on-select=\"reload = true;\" ng-disabled=\"$ctrl.enrollmentData.canViewEnrollLearner===0 || $ctrl.isUser===false\" md-active=\"$ctrl.tabSelect===\'classmate\'\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.CLASSMATE\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><detail-session-learners session-id=\"$ctrl.enrollmentData.sessionId\" reload=\"reload\"></detail-session-learners></md-content></md-tab-body></md-tab><md-tab md-on-deselect=\"reportReload = false\" md-on-select=\"reportReload = true;\" md-active=\"$ctrl.tabSelect===\'learningResult\'\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.LEARNING_RESULT\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><course-detail-learning-results course-content-data=\"$ctrl.courseContentData\" enrollment-data=\"$ctrl.enrollmentData\" learning-history-data=\"$ctrl.learningHistory\"></course-detail-learning-results><report-result ng-if=\"$ctrl.enrollmentData.enrollmentId && reportReload\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" is-manager=\"!$ctrl.isUser\"></report-result></md-content></md-tab-body></md-tab><md-tab ng-if=\"$ctrl.enrollmentData.canReport === 1\" md-on-deselect=\"$ctrl.reload = false\" md-on-select=\"$ctrl.reload = true;\" md-active=\"$ctrl.tabSelect===\'submitReport\'\" ng-disabled=\"$ctrl.isUser===false\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.SUBMIT_REPORT\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><course-detail-enrollment-learning-report enrollment-data=\"$ctrl.enrollmentData\" session-data=\"$ctrl.sessionData\" ng-if=\"$ctrl.reload\"></course-detail-enrollment-learning-report></md-content></md-tab-body></md-tab></md-tabs></md-content></div></div><course-detail-recommend-lessons ng-if=\"$ctrl.enrollmentData.courseType===1 || $ctrl.enrollmentData.courseType===2 || $ctrl.enrollmentData.courseType===3\" catalog-id=\"$ctrl.catalogId\" item-id=\"$ctrl.courseData.courseId\" session-id=\"$ctrl.enrollmentData.sessionId\"></course-detail-recommend-lessons></section></div></div>");
$templateCache.put("app/modules/course-resource/views/instructor-detail.html","<md-dialog aria-label=\"{{ \'FIELD.INSTRUCTOR_DETAIL\' | translate}}\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.INSTRUCTOR_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"IDC.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><div class=\"personInfor\"><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.INSTRUCTOR_NAME\' | translate}}</th><td>{{IDC.instructorDetail.instructorName}}</td></tr><tr><th>{{ \'FIELD.INSTRUCTOR_PROPERTIES\' | translate}}</th><td ng-if=\"IDC.instructorDetail.isInternal===1\">{{ \'FIELD.INTERNAL\' | translate}}</td><td ng-if=\"IDC.instructorDetail.isInternal===0\">{{ \'FIELD.EXTERNAL\' | translate}}</td></tr><tr ng-if=\"IDC.instructorDetail.company!==\'\'\"><th>{{ \'FIELD.INSTRUCTOR_COMPANY\' | translate}}</th><td>{{IDC.instructorDetail.company}}</td></tr><tr><th>{{ \'FIELD.EMAIL\' | translate}}</th><td>{{IDC.instructorDetail.email}}</td></tr><tr ng-if=\"IDC.instructorDetail.specialty!==\'\'\"><th>{{ \'FIELD.SPECIALTY_COURSE_CLASSIFICATION\' | translate}}</th><td>{{IDC.instructorDetail.specialty}}</td></tr><tr ng-if=\"IDC.instructorDetail.intrudoction!==\'\'\"><th>{{ \'FIELD.INTRODUCTION\' | translate}}</th><td>{{IDC.instructorDetail.intrudoction}}</td></tr><tr ng-if=\"IDC.instructorDetail.education!==\'\'\"><th>{{ \'FIELD.EDUCATION\' | translate}}</th><td>{{IDC.instructorDetail.education}}</td></tr><tr ng-if=\"IDC.instructorDetail.experience!==\'\'\"><th>{{ \'FIELD.EXPERIENCE\' | translate}}</th><td>{{IDC.instructorDetail.experience}}</td></tr><tr ng-if=\"IDC.instructorDetail.certification!==\'\'\"><th>{{ \'FIELD.CERTIFICATION\' | translate}}</th><td>{{IDC.instructorDetail.certification}}</td></tr><tr ng-if=\"IDC.instructorDetail.expertise!==\'\'\"><th>{{ \'FIELD.EXPERTISE\' | translate}}</th><td>{{IDC.instructorDetail.expertise}}</td></tr><tr ng-if=\"IDC.instructorDetail.photoUrl!==\'\'\"><th>{{ \'FIELD.INSTRUCTOR_PHOTO\' | translate}}</th><td><img ng-src=\"{{IDC.instructorDetail.photoUrl}}\" class=\"img-responsive\"></td></tr><tr ng-if=\"IDC.instructorDetail.refereeFiles.length>0\"><th>{{ \'FIELD.REFERENCE_DOCUMENT\' | translate}}</th><td><span ng-repeat=\"refereeFile in IDC.instructorDetail.refereeFiles\"><a href=\"{{refereeFile.fileUrl}}\">{{refereeFile.fileName}}</a><br></span></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn btn\" ng-click=\"IDC.close()\">{{ \'ACTIONS.CLOSE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/course-resource/views/learning-history-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"70\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'FIELD.LEARNING_HISTORY\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><div class=\"lightBox Box-repeat\"><header ng-if=\"$ctrl.attendanceRecords.length > 0\"><h3>{{\'FIELD.ATTENDANCE_RECORD\' | translate}}: {{\'FIELD.ATTENDANCE_RATE\' | translate }} <span class=\"text-danger\">{{$ctrl.learningHistory.attendance}} %</span></h3></header><table class=\"tb-Collapse tb-check\" ng-if=\"$ctrl.attendanceRecords.length > 0\"><thead><tr><th>{{\'FIELD.DATE\' | translate}}</th><th>{{\'FIELD.TIME\' | translate}}</th><th>{{\'FIELD.CLASS_HOUR\' | translate}}</th><th>{{\'FIELD.ATTENDANCE_STATISTIC\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"attendanceRecord in $ctrl.attendanceRecords\"><td>{{attendanceRecord.date}}</td><td>{{attendanceRecord.time}}</td><td>{{attendanceRecord.hourLength}}{{\'FIELD.HOUR\' | translate}}</td><td ng-if=\"attendanceRecord.hasLeaveRecord===0\">{{\'STATUS.ATTENDANCE\' | translate}}</td><td ng-if=\"attendanceRecord.hasLeaveRecord===1\" ng-repeat=\"attendanceStatistic in attendanceRecord.attendanceStatistic\">{{attendanceStatistic.formatTime}} <span ng-if=\"attendanceStatistic.attendanceType===0\">{{\'STATUS.LEAVE_APPROVAL_PENDING\' | translate}}</span> <span ng-if=\"attendanceStatistic.attendanceType===1\">{{\'STATUS.ABSENCE\' | translate}}</span> <span ng-if=\"attendanceStatistic.attendanceType===2\">{{\'ACTIONS.LEAVE\' | translate}}</span></td></tr></tbody></table><header ng-if=\"$ctrl.learningHistoryItems.length > 0\"><h3>{{\'FIELD.LEARNING_ITEM\' | translate}}: <span ng-bind-html=\"\'FIELD.TOTAL_ITEM\' | translate:{\'value\': $ctrl.learningHistory.totalItemSize}\"></span>, <span ng-bind-html=\"\'FIELD.COMPLETE_ITEM\' | translate:{\'value\': $ctrl.learningHistory.completedItemSize}\"></span></h3></header><table class=\"tb-Collapse tb-check\" ng-if=\"$ctrl.learningHistoryItems.length > 0\"><thead><tr><th>{{\'FIELD.COURSE_CONTENT\' | translate}}</th><th>{{\'FIELD.TYPE\' | translate}}</th><th>{{\'FIELD.VIEWING_TIME\' | translate}}</th><th>{{\'FIELD.FINISH_TIME\' | translate}}</th><th>{{\'FIELD.STATUS\' | translate}}</th><th>{{\'FIELD.SCORE\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"learningHistoryItem in $ctrl.learningHistoryItems\"><td><span ng-if=\"learningHistoryItem.notInProgress===1\" class=\"text-danger\">*</span>{{learningHistoryItem.content}}</td><td ng-if=\"learningHistoryItem.itemSection===\'Content\'\">{{\'FIELD.COURSE_CONTENT\' | translate}}</td><td ng-if=\"learningHistoryItem.itemSection===\'Test\'\">{{\'FIELD.TEST\' | translate}}</td><td ng-if=\"learningHistoryItem.itemSection===\'Survey\'\">{{\'FIELD.QUESTIONNAIRE\' | translate}}</td><td>{{learningHistoryItem.totalTime}}</td><td>{{learningHistoryItem.completedDate}}</td><td ng-if=\"learningHistoryItem.lessonStatus===\'\'\"></td><td ng-if=\"learningHistoryItem.lessonStatus!==\'\'\">{{\'STATUS.\' + learningHistoryItem.lessonStatus | uppercase | translate}}</td><td><span ng-if=\"learningHistoryItem.totalTime!==\'\' && learningHistoryItem.itemSection===\'Test\' && learningHistoryItem.isAllowViewScore===1\"><a href=\"javascript:void(0);\" test-history-search-dialog=\"\" user-id=\"$ctrl.learningHistory.userId\" session-id=\"$ctrl.sessionId\" item-id=\"learningHistoryItem.itemId\" course-content=\"learningHistoryItem.content\">{{learningHistoryItem.score}}</a></span> <span ng-if=\"learningHistoryItem.totalTime!==\'\' && learningHistoryItem.itemSection===\'Test\' && learningHistoryItem.isAllowViewScore===0\">{{ \'STATUS.NOT_PUBLISHED\' | translate }}</span></td></tr></tbody></table><report-result enrollment-id=\"$ctrl.enrollmentId\" is-manager=\"$ctrl.isManager\"></report-result></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/learning-report-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.LEARNING_REPORT\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><div class=\"lightBox th-manager\"><header><h3 ng-if=\"$ctrl.isProgram===0\">{{\'FIELD.COURSE_NAME\' | translate}}:{{$ctrl.activityName}}</h3><div layout=\"row\" ng-if=\"$ctrl.isProgram===1\" layout-align=\"start center\"><h3>{{\'FIELD.VIEW_ITEM\' | translate}}:</h3><div flex=\"\"><md-select ng-model=\"$ctrl.programIncludeCourse\" class=\"md-title\"><md-option ng-value=\"0\">{{$ctrl.activityName}}</md-option><md-option ng-repeat=\"course in $ctrl.program.includeCourses\" ng-value=\"course.courseId\">{{course.courseName}}</md-option></md-select></div></div></header><table ng-table=\"$ctrl.learningReportTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'FIELD.AUTHOR\' | translate\" sortable=\"\'View_LRCrsRelatedDoc.Author\'\" class=\"appear\"><div class=\"text\">{{row.author}}</div></td><td data-title=\"\'FIELD.SESSION\' | translate\" sortable=\"\'SessionName\'\" class=\"appear\"><div class=\"text\">{{row.sessionName}}</div></td><td data-title=\"\'FIELD.TITLE\' | translate\" sortable=\"\'View_LRCrsRelatedDoc.Title\'\" class=\"appear\"><div class=\"text\"><a ng-href=\"{{row.fileUrl}}\" target=\"_blank\">{{row.fileName}}</a></div></td><td data-title=\"\'FIELD.CREATE_DATE\' | translate\" sortable=\"\'LearningReport.SubmitDate\'\" class=\"appear\"><div class=\"text\">{{row.createDate}}</div></td><td data-title=\"\'FIELD.SIZE\' | translate\" sortable=\"\'FileSize\'\" class=\"appear\"><div class=\"text\">{{row.fileSize}}</div></td></tr></table></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/learning-report-list-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{$ctrl.activityName}} - {{ \'FIELD.LEARNING_REPORT\' | translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"lightBox Box-repeat\"><h6><span>{{ \'FIELD.THE_PAYMENT_N_LEARNING_REPORT\' | translate: {\'value\': $ctrl.learningReport.length} }}</span></h6><table ng-table-dynamic=\"$ctrl.learningReportListTable with $ctrl.tableCols\" class=\"tb-transfer tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table><div class=\"pt-noData\" ng-if=\"$ctrl.learningReport.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></md-dialog-content><md-dialog-actions layout=\"row\" ng-if=\"$ctrl.canEdit && $ctrl.learningReport.length > 0\"><span flex=\"\"></span><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.submit()\">{{ \'ACTIONS.SET_REPORT_SCORE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/course-resource/views/program-detail-info-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\" class=\"dialog-transition-none\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"$ctrl.programData.programType === 0\">{{ \'PROGRAM_INFO_DETAIL\' | translate}}</h2><h2 ng-if=\"$ctrl.programData.programType === 1\">{{ \'CERTIFICATE_INFO_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\" class=\"hidden-x-scrollbar\"><div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><course-detail-header data=\"$ctrl.programData\"></course-detail-header><div class=\"th-tab\"><div class=\"tab-content\"><program-detail-info data=\"$ctrl.programData\"></program-detail-info><course-detail-prerequisite-items data=\"$ctrl.programData.prerequisites\" program-type=\"$ctrl.programData.programType\"></course-detail-prerequisite-items><program-detail-contain-lessons data=\"$ctrl.programData.includeCourses\" session-type=\"($ctrl.programData.programType===0)?-1:0\"></program-detail-contain-lessons><program-detail-contain-lessons data=\"$ctrl.programData.includeCourses\" session-type=\"1\"></program-detail-contain-lessons><detail-session-list md-dialog-close=\"$ctrl.close()\" course-id=\"$ctrl.programData.programId\" is-program=\"true\"></detail-session-list></div></div></section></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/program-info.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><course-detail-header data=\"$ctrl.programData\" go-back=\"$ctrl.goBack\" is-program=\"true\"></course-detail-header><div class=\"th-tab\"><div class=\"tab-content\"><program-detail-info data=\"$ctrl.programData\"></program-detail-info><course-detail-prerequisite-items data=\"$ctrl.programData.prerequisites\" program-type=\"$ctrl.programData.programType\"></course-detail-prerequisite-items><program-detail-contain-lessons data=\"$ctrl.programData.includeCourses\" session-type=\"($ctrl.programData.programType===0)?-1:0\"></program-detail-contain-lessons><program-detail-contain-lessons data=\"$ctrl.programData.includeCourses\" session-type=\"1\"></program-detail-contain-lessons><detail-session-list course-id=\"$ctrl.programData.programId\" is-program=\"true\"></detail-session-list></div></div></section></div></div>");
$templateCache.put("app/modules/course-resource/views/program-session-info.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><course-detail-header data=\"$ctrl.programData\" enrollment-data=\"$ctrl.enrollmentData\" go-back=\"$ctrl.goBack\" is-program=\"true\" reload-fn=\"$ctrl.getProgramData()\" is-user=\"$ctrl.isUser\"></course-detail-header><program-detail-enrollment data=\"$ctrl.programData\" enrollment-data=\"$ctrl.enrollmentData\" session-data=\"$ctrl.sessionData\" reload-fn=\"$ctrl.getProgramData()\"></program-detail-enrollment><detail-completion-rate is-show=\"$ctrl.sessionData.isShowCompletionRate\" data=\"$ctrl.completionRateData\"></detail-completion-rate><div class=\"th-tab\"><div class=\"tab-content\"><md-content><md-tabs ng-if=\"$ctrl.enrollmentData\" md-dynamic-height=\"\" md-border-bottom=\"\" md-autoselect=\"\"><md-tab ng-disabled=\"$ctrl.isUser===false\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.COURSE_LIST\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><program-detail-lessons-list data=\"$ctrl.learningResult\" reload-fn=\"$ctrl.getProgramData()\" enrollment-id=\"$ctrl.enrollmentId\"></program-detail-lessons-list></md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$ctrl.isUser===false\"><md-tab-label><span class=\"tab-label\" ng-if=\"$ctrl.programData.programType===0\">{{ \'FIELD.ABOUT_THIS_PROGRAM\' | translate}}</span> <span class=\"tab-label\" ng-if=\"$ctrl.programData.programType===1\">{{ \'FIELD.ABOUT_THIS_CERTIFICATE\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding tab-content\"><program-detail-info data=\"$ctrl.programData\"></program-detail-info></md-content></md-tab-body></md-tab><md-tab md-on-deselect=\"reload = false\" md-on-select=\"reload = true;\" ng-disabled=\"$ctrl.enrollmentData.canViewEnrollLearner===0 || $ctrl.isUser===false\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.CLASSMATE\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><detail-session-learners session-id=\"$ctrl.enrollmentData.sessionId\" reload=\"reload\" is-program=\"true\"></detail-session-learners></md-content></md-tab-body></md-tab><md-tab md-on-deselect=\"reportReload = false\" md-on-select=\"reportReload = true;\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.LEARNING_RESULT\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><program-detail-lessons-results enrollment-data=\"$ctrl.enrollmentData\" data=\"$ctrl.learningResult\"></program-detail-lessons-results><report-result ng-if=\"reportReload\" enrollment-id=\"$ctrl.enrollmentId\" is-manager=\"!$ctrl.isUser\" is-course=\"false\"></report-result></md-content></md-tab-body></md-tab><md-tab ng-if=\"$ctrl.enrollmentData.canReport === 1\" md-on-deselect=\"$ctrl.reload = false\" md-on-select=\"$ctrl.reload = true;\" md-active=\"$ctrl.tabSelect===\'submitReport\'\" ng-disabled=\"$ctrl.isUser===false\"><md-tab-label><span class=\"tab-label\">{{ \'FIELD.SUBMIT_REPORT\' | translate}}</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><program-detail-enrollment-learning-report enrollment-data=\"$ctrl.enrollmentData\" session-data=\"$ctrl.sessionData\" ng-if=\"$ctrl.reload\"></program-detail-enrollment-learning-report></md-content></md-tab-body></md-tab></md-tabs></md-content></div></div><course-detail-recommend-lessons ng-if=\"$ctrl.enrollmentData.programType===0\" item-id=\"$ctrl.programData.programId\" session-id=\"$ctrl.enrollmentData.sessionId\" item-type=\"$ctrl.SessionObject.PROGRAM\"></course-detail-recommend-lessons></section></div></div>");
$templateCache.put("app/modules/course-resource/views/reference-list.html","<div class=\"lightBox Box-download\"><header><h3>{{ \'FIELD.REFERENCE_DOCUMENT\' | translate}}</h3></header><table class=\"BoxTable\"><tr ng-repeat=\"referenceData in CRC.referenceDatas\"><td>{{referenceData.fileName}}</td><td>{{referenceData.fileSize}}</td><td><a ng-href=\"{{referenceData.downloadUrl}}\" target=\"_blank\"><md-button class=\"md-raised md-primary btn\" ng-if=\"referenceData.itemType === \'URL\'\"><i class=\"material-icons\">link</i>{{ \'ACTIONS.OPEN_LINK\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-if=\"referenceData.itemType !== \'URL\'\"><i class=\"material-icons\">cloud_download</i>{{ \'ACTIONS.DOWNLOAD_FILE\' | translate}}</md-button></a></td></tr></table></div>");
$templateCache.put("app/modules/course-resource/views/report-result.html","<div class=\"th-report\"><header layout=\"row\" layout-align=\"start start\"><p ng-if=\"$ctrl.report.isNeedReport\">{{\'FIELD.SUBMIT_REPORT\' | translate}}: {{ \'FIELD.SHOULD_BE_SUBMIT_REPORT\' | translate}} <span>{{$ctrl.report.numOfReports}}</span> {{ \'FIELD.PART\' | translate}}/ {{ \'FIELD.HAS_BEEN_PAID\' | translate}} <span>{{$ctrl.report.learningReportSubmitted}}</span> {{ \'FIELD.PART\' | translate}}</p></header></div>");
$templateCache.put("app/modules/course-resource/views/test-history-search-dialog.html","<script type=\"text/ng-template\" id=\"test-history-search.html\"><div ng-transclude></div></script><script type=\"text/ng-template\" id=\"test-history-search-step.html\"><div ng-show=\"selected\" ng-transclude></div></script><md-dialog aria-label=\"Mango (Fruit)\" flex=\"70\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.TEST_HISTORY_SEARCH\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"height:500px\"><wizard name=\"testHistorySearch\" on-finish=\"\" template=\"test-history-search.html\"><wz-step template=\"test-history-search-step.html\" wz-title=\"\" canexit=\"$ctrl.searchPage\" canenter=\"$ctrl.viewPage\"><div class=\"lightBox Box-leave\"><header><h3>{{ \'FIELD.COURSE_CONTENT\' | translate}}：{{$ctrl.courseContent}}</h3></header><div flex-gt-xs=\"\">{{ \'FIELD.ANSWER_DATE\' | translate}}<md-datepicker ng-change=\"$ctrl.updateEndDateModel()\" ng-model=\"$ctrl.startDate\" md-placeholder=\"{{ \'FIELD.START_DATE\' | translate }}\" md-datepicker-focus-open=\"\" onkeydown=\"return false\"></md-datepicker>To<md-datepicker md-min-date=\"$ctrl.startDate\" ng-model=\"$ctrl.endDate\" md-placeholder=\"{{ \'FIELD.END_DATE\' | translate }}\" md-datepicker-focus-open=\"\" onkeydown=\"return false\"></md-datepicker><md-button class=\"md-raised md-primary md-btn\" ng-click=\"$ctrl.testHistoryReload()\">{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div><table ng-table=\"$ctrl.testHistoryTable\" class=\"tb-Collapse tb-check\"><colgroup><col width=\"10%\"><col width=\"15%\"><col width=\"20%\"></colgroup><tr ng-repeat=\"testHistory in $data\"><td data-title=\"\'ACTIONS.SELECT\' | translate\" class=\"appear\"><div class=\"text\"><md-radio-group ng-model=\"$ctrl.examHistoryId\" ng-change=\"$ctrl.getExamResult()\"><md-radio-button class=\"md-primary radio\" ng-value=\"testHistory.examhistoryId\"></md-radio-button></md-radio-group></div></td><td data-title=\"\'FIELD.ANSWER_DATE\' | translate\" class=\"appear\"><div class=\"text\">{{testHistory.examDate}}</div></td><td data-title=\"\'FIELD.SCORE\' | translate\" class=\"appear\"><div class=\"text\">{{testHistory.score}}</div></td></tr></table><div layout=\"row\" layout-align=\"end start\"><div>{{\'FIELD.TOTAL_COUNT\' | translate:{\'value\': $ctrl.testHistory.length} }}</div></div></div></wz-step><wz-step template=\"test-history-search-step.html\" wz-title=\"\"><div class=\"play-main\"><div class=\"wp-play\"><header></header><test-questionnaire-result session-id=\"$ctrl.sessionId\" exam=\"$ctrl.exam\" exam-result=\"$ctrl.examResult\" params=\"$ctrl.examResultParams\"></test-questionnaire-result></div></div></wz-step></wizard></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.nextStep()\" ng-if=\"$ctrl.wzBtn.next\" ng-disabled=\"$ctrl.examHistoryId===\'\'\">{{ \'ACTIONS.NEXT_STEP\' | translate}}<md-icon md-font-set=\"md\">keyboard_arrow_right</md-icon></md-button><md-button class=\"md-raised md-warn md-btn btn-transparent\" type=\"button\" ng-click=\"$ctrl.previousStep()\" ng-if=\"$ctrl.wzBtn.previous\"><md-icon md-font-set=\"md\">keyboard_arrow_left</md-icon>{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/course-resource/views/will-expire-list.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\" class=\"hidden-x-scrollbar\"><div class=\"lightBox Box-repeat\"><table class=\"tb-Collapse tb-check\"><thead><tr><th>#</th><th>{{ \'FIELD.EXPIRED_ITEMS\' | translate}}</th><th>{{ \'FIELD.DATE\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"willExpireData in $ctrl.willExpireDatas\"><td>{{$index + 1}}</td><td ng-switch=\"willExpireData.itemType\"><span ng-switch-when=\"0\">{{willExpireData.itemTitle}} - {{ \'FIELD.LEARNER_DURATION_OF_STUDY\' | translate}}</span> <span ng-switch-when=\"1\">{{willExpireData.itemTitle}} - <span ng-if=\"$ctrl.courseType===1\">{{ \'FIELD.SESSION\' | translate}}{{ \'FIELD.VIEW_DEADLINE\' | translate}}</span> <span ng-if=\"$ctrl.courseType===4\">{{ \'FIELD.SESSION\' | translate}}{{ \'FIELD.TEST_DEADLINE\' | translate}}</span> <span ng-if=\"$ctrl.courseType===6\">{{ \'FIELD.SESSION\' | translate}}{{ \'FIELD.FILL_IN_DEADLINE\' | translate}}</span> <span ng-if=\"$ctrl.courseType!==1 && $ctrl.courseType!==4 && $ctrl.courseType!==6\">{{ \'FIELD.SESSION_CLASS_DEADLINE\' | translate}}</span></span> <span ng-switch-when=\"2\">{{willExpireData.itemTitle}} - {{ \'FIELD.SUBMIT_REPORT_DEADLINE\' | translate}}</span> <span ng-switch-when=\"3\">{{willExpireData.itemTitle}} - {{ \'FIELD.SESSION\' | translate}}{{ \'FIELD.TEST_DEADLINE\' | translate}}</span> <span ng-switch-when=\"4\">{{willExpireData.itemTitle}} - {{ \'FIELD.SESSION\' | translate}}{{ \'FIELD.FILL_IN_DEADLINE\' | translate}}</span></td><td>{{willExpireData.willExpiredDate}}</td></tr></tbody></table></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/dashboard/views/department-dashboard.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><div class=\"ly-board\"><div class=\"header th-leader\"><div class=\"th-profil\"><figure><img ng-src=\"{{::( \'board-bg-1\' | sunnetPicture:\'jpg\' )}}\" alt=\"\"></figure><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.dashboardData.userToDo.avatarUrl\" first-name=\"::$ctrl.dashboardData.userToDo.firstName\" line-height=\"100\" font-size=\"36\"></avatar><span>{{$ctrl.dashboardData.userToDo.name}}</span></div></div><div class=\"th-choose\"><span class=\"li-title\">{{ \'FIELD.CURRENT_DEPARTMENT\' | translate}} :</span> <span class=\"text\"><div layout=\"row\"><md-autocomplete flex=\"90\" md-search-text=\"$ctrl.keyword\" md-items=\"group in $ctrl.getManagerGroup(false, $ctrl.keyword.trim())\" md-item-text=\"group.groupName\" md-require-match=\"\" md-selected-item=\"$ctrl.selectedGroup\" md-selected-item-change=\"$ctrl.selectGroup(group)\" md-floating-label=\"{{\'PLACEHOLDERS.PLEASE_ENTER_DEPARTMENT_NAME\' |translate}}\" md-clear-button=\"true\" ng-trim=\"false\" md-min-length=\"0\"><md-item-template><span md-highlight-text=\"$ctrl.keyword\">{{group.groupName}}</span></md-item-template></md-autocomplete></div></span></div></div><div class=\"row boot-20\"><div class=\"col-md-12 col-lg-5\"><div class=\"row boot-20\"><div group-id=\"$ctrl.groupId\" average-training-hours-dialog=\"\"><average-training-hours class=\"th-board th-leader col-xs-6\" group-training-hours=\"$ctrl.groupTrainingHours\"></average-training-hours></div><div group-id=\"$ctrl.groupId\" average-training-cost-dialog=\"\"><cumulative-training-costs class=\"th-board th-leader col-xs-6\" group-cost=\"$ctrl.groupCost\"></cumulative-training-costs></div><month-cumulative-training-costs class=\"th-board th-leader col-xs-12\" training-costs=\"$ctrl.trainingCosts\" is-group-month-cost-no-data=\"$ctrl.isGroupMonthCostNoData\"></month-cumulative-training-costs></div></div><div class=\"col-md-12 col-lg-7\"><div class=\"row boot-20\"><group-user-info class=\"th-board col-xs-12\" group-user-info=\"$ctrl.groupUserInfo\" group-incompleted-course=\"$ctrl.groupIncompletedCourse\"></group-user-info></div></div></div><div class=\"row\"><group-incompleted-course class=\"th-board col-md-12\" group-incompleted-course=\"$ctrl.groupIncompletedCourse\"></group-incompleted-course></div><div class=\"row th-board boot-20\"><rate-progress-bars class=\"th-board col-md-6\" progress-title=\"FIELD.COMPLETION_RATE_OF_DEPARTMENT_MEMBERS\" progresses=\"$ctrl.groupCompletion\" value-key=\"completion\"></rate-progress-bars><rate-progress-bars permission=\"\" permission-only=\"[\'Modules.course.classroom\',\'Modules.course.classroomtest\']\" class=\"th-board col-md-6\" progress-title=\"FIELD.ATTENDANCE_RATE_OF_DEPARTMENT_MEMBERS\" progresses=\"$ctrl.groupAttendance\" value-key=\"attendance\"></rate-progress-bars></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning-dashboard-blocks.html","<div class=\"col-xs-12\"><div ng-repeat=\"components in $ctrl.components track by $index\" compile=\"components.content\"></div></div>");
$templateCache.put("app/modules/dashboard/views/learning-dashboard-dialog.html","<md-dialog flex=\"80\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.DEPARTMENT_MEMBERS_OF_LEARNING_INFORMATION\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:600px;\"><md-content layout-padding=\"\" style=\"background: #F5F5F5;\"><div class=\"col-xs-12\"><div class=\"th-staff p-l-10 m-b-m30\"><div class=\"el-person\"><avatar avatar-url=\"$ctrl.groupUserInfo.avatarUrl\" first-name=\"$ctrl.groupUserInfo.firstName\" line-height=\"60\" font-size=\"24\"></avatar><span class=\"dashboard-el-person\">{{$ctrl.groupUserInfo.fullName}}</span><div class=\"icon-detail\" ng-if=\"$ctrl.groupUserInfo.isInstructor===1\" permission=\"\" permission-only=\"[\'Modules.course.classroom\']\"><div class=\"icon\"><span><i class=\"material-icons\">school</i></span></div><div class=\"detail\"><span ng-if=\"$ctrl.groupUserInfo.instructorTeachingHours<=0\">N/A</span> <span ng-if=\"$ctrl.groupUserInfo.instructorTeachingHours>0\">{{($ctrl.groupUserInfo.instructorTeachingHours/60).toFixed(1) |replaceAll:\'\\\\.?0+$\':\'\'}}</span><p>{{\'FIELD.TEACHING_HOURS\' |translate}}</p></div></div><div class=\"icon-detail\" ng-if=\"$ctrl.groupUserInfo.isInstructor===1\"><div class=\"icon\"><span><i class=\"fa fa-microphone\"></i></span></div><div class=\"detail\"><span ng-if=\"$ctrl.groupUserInfo.instructorScore<=0\">-</span> <span ng-if=\"$ctrl.groupUserInfo.instructorScore>0\">{{$ctrl.groupUserInfo.instructorScore |number:2}}</span><p>{{\'FIELD.LECTURER_TEACHING_SATISFACTION\' |translate}}</p></div></div></div></div></div><learning-dashboard-blocks training-road-button-close=\"$ctrl.trainingRoadButtonClose\" user-id=\"$ctrl.groupUserInfo.userId\" is-manager=\"true\"></learning-dashboard-blocks></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/dashboard/views/learning-dashboard.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><div class=\"ly-board\"><div class=\"header\"><div class=\"th-profil\"><figure><img ng-src=\"{{::( \'board-bg\' | sunnetPicture:\'jpg\' )}}\" alt=\"\"></figure><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.dashboardData.userToDo.avatarUrl\" first-name=\"::$ctrl.dashboardData.userToDo.firstName\" line-height=\"100\" font-size=\"36\"></avatar><span>{{::$ctrl.dashboardData.userToDo.name}}</span></div></div><div class=\"th-data\"><div class=\"th-list\"><div class=\"list pt-blueG\" permission=\"\" permission-only=\"[\'Modules.course.online\',\'Modules.course.classroom\',\'Modules.course.external\']\" ui-sref=\"learningPassport.incompleteCourses\"><i class=\"icon icon-book-open\"></i><div class=\"right\"><span count-to=\"{{$ctrl.dashboardData.userToDo.incompleteCount}}\" value=\"0\" duration=\"0.5\">{{::$ctrl.dashboardData.userToDo.incompleteCount}}</span><p>{{ ::\'ENROLLMENT\' | translate }}</p></div></div><div class=\"list pt-blue\" permission=\"\" permission-only=\"[\'Modules.course.onlinetest\',\'Modules.course.classroomtest\',\'Modules.course.survey\']\" ui-sref=\"learningPassport.testQuestionnaireCenter\"><i class=\"icon icons-documents-bookmarks-01\"></i><div class=\"right\"><span count-to=\"{{$ctrl.dashboardData.userToDo.quizCount}}\" value=\"0\" duration=\"0.5\">{{::$ctrl.dashboardData.userToDo.quizCount}}</span><p>{{ ::\'FIELD.TEST_QUESTIONNAIRE\' | translate }}</p></div></div><div class=\"list pt-purple\" ui-sref=\"supervisorZone.approve\" permission=\"\" permission-all=\"[\'Manager_Privilege\', \'Modules.approval\']\"><i class=\"icon icon-note\"></i><div class=\"right\"><span count-to=\"{{$ctrl.dashboardData.userToDo.penddingCount }}\" value=\"0\" duration=\"0.5\">- {{::$ctrl.dashboardData.userToDo.penddingCount }}</span><p>{{ ::\'FIELD.PENDING_APPROVALS\' | translate }}</p></div></div><div class=\"list pt-purple\" ui-sref=\"learningPassport.approveRecords\" permission=\"\" permission-except=\"[\'Manager_Privilege\']\" permission-only=\"[\'Modules.approval\']\"><i class=\"icon icon-note\"></i><div class=\"right\"><span count-to=\"{{$ctrl.dashboardData.userToDo.penddingCount }}\" value=\"0\" duration=\"0.5\">- {{::$ctrl.dashboardData.userToDo.penddingCount }}</span><p>{{ ::\'FIELD.PENDING_APPROVALS\' | translate }}</p></div></div><div class=\"list pt-orange\" permission=\"\" permission-only=\"[\'Modules.course.online\',\'Modules.course.classroom\',\'Modules.course.external\']\" ui-sref=\"courseResourceCatalog({cid:0, mid: null})\"><i class=\"icon icon-graduation\"></i><div class=\"right\"><span count-to=\"{{$ctrl.dashboardData.toDoDataNewCourse}}\" value=\"0\" duration=\"0.5\">{{::$ctrl.dashboardData.toDoDataNewCourse}}</span><p>{{ ::\'FIELD.LATEST_COURSE\' | translate }}</p></div></div></div><div class=\"th-hours\" permission=\"\" permission-only=\"[\'Modules.course.online\',\'Modules.course.classroom\',\'Modules.course.external\']\"><div class=\"md-hours\" ng-init=\"to\" ui-sref=\"learningPassport.trainingRecords\" layout=\"row\"><h6>{{::$ctrl.today | date:\'yyyy\'}} <span ng-if=\"$ctrl.statsBy == \'quarter\'\">{{ \'FIELD.TRAINING_HOURS_IN_THE_QUARTER\' | translate: {\'value\': $ctrl.dashboardData.trainingHours.quarter} }}</span> <span ng-if=\"$ctrl.statsBy == \'year\'\">{{ ::\'FIELD.TRAINING_HOURS_IN_THE_YEAR\' | translate }}</span></h6><p class=\"pt-hours\" flex=\"none\"><span count-to=\"{{$ctrl.dashboardData.trainingHours.personalHours}}\" value=\"0\" duration=\"0.5\">{{::$ctrl.dashboardData.trainingHours.personalHours}}</span>{{ ::\'FIELD.HOUR\' | translate }}</p></div><div class=\"average\">{{ ::\'FIELD.AVERAGE_TRAINING_HOURS_OF_COMPANY\' | translate}}: <span count-to=\"{{$ctrl.dashboardData.trainingHours.avgHours}}\" value=\"0\" duration=\"0.5\">{{::$ctrl.dashboardData.trainingHours.avgHours}}</span>{{ ::\'FIELD.HOUR\' | translate }}</div></div></div></div><learning-dashboard-blocks reload-fn=\"$ctrl.getData()\"></learning-dashboard-blocks></div></div></div>");
$templateCache.put("app/modules/forum/views/forum.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/full-text-search/views/full-text-search-course-info.html","<div class=\"timeline-content\"><div class=\"el-tag\" ng-if=\"$ctrl.infoData.isLatest===1\">{{ \'STATUS.NEW\' | translate }}</div><div class=\"el-tag\" ng-if=\"$ctrl.infoData.isHot===1\">{{ \'STATUS.HOT\' | translate }}</div><div class=\"el-tag\" ng-if=\"$ctrl.infoData.isRecommended===1\">{{ \'STATUS.FEATURED\' | translate }}</div><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.infoData.courseType\" is-program=\"$ctrl.infoData.courseType===0\" program-type=\"$ctrl.infoData.programType\"></course-type-tag><figure><a ui-sref=\"courseResourceCatalog.CourseInfo({cid: 0, courseId:$ctrl.infoData.courseId, nid: $ctrl.nodeId, backState: $ctrl.backState, params:$ctrl.params})\"><img ng-src=\"{{$ctrl.infoData.logoUrl}}\"></a></figure><div class=\"pt-contentList\"><h6><a ui-sref=\"courseResourceCatalog.CourseInfo({cid: 0, courseId:$ctrl.infoData.courseId, nid: $ctrl.nodeId, backState: $ctrl.backState, params:$ctrl.params})\"><span ng-bind-html=\"$ctrl.infoData.title | trustAsHtml\"></span></a></h6><ul class=\"left\"><li layout=\"row\" layout-align=\"space-between start\"><div flex=\"85\"><span class=\"li-title total\"><i class=\"material-icons\">group</i>{{ \'FIELD.TOTAL_NUMBER_OF_CLASSES\' | translate}}:</span> <span class=\"text\">{{$ctrl.infoData.learnerCount}}</span></div><div flex=\"\" class=\"like\" ng-include=\"\'fullTextCoursefavorite.html\'\" ng-if=\"$ctrl.infoData.courseType == 3 || $ctrl.infoData.courseType == 6\"></div></li><li ng-if=\"$ctrl.infoData.courseType != 3 && $ctrl.infoData.courseType != 6\"><div class=\"th-rateit\"><cus-rate-it class=\"rateit override-rateit\" step=\"1\" value=\"$ctrl.infoData.avgScoreForAll\"></cus-rate-it><span>{{$ctrl.infoData.avgScoreForAll | number:2}}</span></div><div class=\"like\" ng-include=\"\'fullTextCoursefavorite.html\'\"></div></li></ul></div></div><div style=\"margin-left: 140px;\" class=\"card-display block-with-text\">{{ \'FIELD.FULL_TEXT_SEARCH_CONTENT\' | translate}} : <span ng-bind-html=\"$ctrl.infoData.content | trustAsHtml\"></span></div><script type=\"text/ng-template\" id=\"fullTextCoursefavorite.html\"><a class=\"fa fa-heart\" ng-class=\"{true: \'on\'}[$ctrl.infoData.favorite]\" href=\"javascript:void(0);\" set-favorite course-id=\"$ctrl.infoData.courseId\" course-name=\"$ctrl.infoData.courseName\" course-type=\"$ctrl.infoData.courseType\" is-favorite=\"$ctrl.infoData.favorite\" reload=\"$ctrl.reloadFn()\"></a></script><div class=\"explain\"><span ng-if=\"$ctrl.infoData.result !== 0\" ng-switch=\"$ctrl.infoData.result\" ng-class=\"{\'off\': ($ctrl.infoData.result === -1 || $ctrl.infoData.result === 3)}\"><i class=\"material-icons\" ng-switch-when=\"-1\">person_add</i> <i class=\"material-icons\" ng-switch-when=\"2\">assignment_turned_in</i> <i class=\"material-icons\" ng-switch-when=\"3\">assignment_turned_in</i> {{$ctrl.infoData.statusMessage}}</span> <span ng-if=\"$ctrl.infoData.result === 0\" ng-switch=\"$ctrl.infoData.status.toLowerCase()\" ng-class=\"{\'off\': ($ctrl.infoData.status.toLowerCase() === \'incompleted\' || $ctrl.infoData.status.toLowerCase() === \'not attempted\' || $ctrl.infoData.status.toLowerCase() === \'unenroll\'|| $ctrl.infoData.status.toLowerCase() === \'unpublished assigned\')}\"><i class=\"material-icons\" ng-switch-when=\"unenroll\">person_add</i> <i class=\"material-icons\" ng-switch-when=\"incompleted\">check</i> <i class=\"material-icons\" ng-switch-when=\"not attempted\">visibility</i> <i class=\"fa fa-exclamation\" ng-switch-default=\"\"></i> {{$ctrl.infoData.statusMessage}}</span></div></div>");
$templateCache.put("app/modules/full-text-search/views/full-text-search-learningresource-info.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><figure><a href=\"{{$ctrl.infoData.browseUrl}}\" target=\"_blank\"><img ng-if=\"!!$ctrl.infoData.logoUrl\" ng-src=\"{{::$ctrl.infoData.logoUrl}}\"> <img ng-if=\"!$ctrl.infoData.logoUrl\" ng-src=\"{{::( \'knowledge_\' + ($ctrl.infoData.learningResourceId % 17) | sunnetPicture:\'jpg\' )}}\"></a></figure><div class=\"pt-contentList\"><h6><a href=\"{{$ctrl.infoData.browseUrl}}\" target=\"_blank\"><span ng-bind-html=\"$ctrl.infoData.title | trustAsHtml\"></span></a></h6><ul><li>{{ \'FIELD.AUTHOR\' | translate}}: <a ng-if=\"$ctrl.infoData.isExternalCWSubCh === -1\" href=\"javascript:void(0);\" class=\"author\" user-detail=\"\" user-id=\"$ctrl.infoData.publisherId\">{{$ctrl.infoData.author}}</a> <span ng-if=\"$ctrl.infoData.isExternalCWSubCh > -1\">{{$ctrl.infoData.author}}</span></li><li style=\"width:100%\">{{ \'FIELD.LOCATION\' | translate}}: {{ \'FIELD.ROOT_DIRECTORY\' | translate}}/ <span ng-repeat=\"menu in $ctrl.infoData.menulist\">{{menu.title | markSplit:$index:\'/\'}}</span></li><li>{{ \'FIELD.CLICK_COUNT\' | translate}}: {{$ctrl.infoData.clickCount}} <span ng-if=\"$ctrl.infoData.isExternalCWSubCh === -1\">,&nbsp; {{ \'FIELD.DOWNLOAD_COUNT\' | translate}}: {{$ctrl.infoData.downloadCount}}</span></li><li>{{ \'FIELD.I_WANT\' | translate}}: <a ng-if=\"$ctrl.infoData.isExternalCWSubCh === -1\" href=\"{{$ctrl.infoData.downloadUrl}}\" target=\"_blank\" class=\"download\">{{ \'ACTIONS.DOWNLOAD\' | translate}}</a> <span ng-if=\"$ctrl.infoData.isExternalCWSubCh === -1\">|</span> <a href=\"javascript:void(0)\" set-score=\"\" reload=\"$ctrl.reloadFn()\" doc-id=\"$ctrl.infoData.learningResourceId\" title=\"$ctrl.infoData.name\" class=\"score\">{{ \'ACTIONS.RATING\' | translate}}</a></li><li>{{ \'FIELD.AVERAGE_RATING\' | translate}}:<div class=\"rateit\" data-value=\"2.5\" data-readonly=\"true\"><ng-rate-it ng-model=\"$ctrl.infoData.avgScore\" step=\"0.1\" read-only=\"true\"></ng-rate-it></div><span>{{$ctrl.infoData.avgScore|number:2}}</span></li><li>{{ \'FIELD.SHARE_DATE\' | translate}}: <span>{{$ctrl.infoData.shareDate}}</span></li></ul><footer><a href=\"{{$ctrl.infoData.browseUrl}}\" target=\"_blank\" class=\"btn btn-primary\">{{ \'ACTIONS.READ\' | translate}}</a></footer></div></div><div style=\"margin-left: 200px;\" class=\"explain block-with-text\">{{ \'FIELD.FULL_TEXT_SEARCH_CONTENT\' | translate}} : <span ng-bind-html=\"$ctrl.infoData.content | trustAsHtml\"></span></div><div style=\"margin-left: 200px;\" class=\"explain block-with-text\" ng-show=\"$ctrl.infoData.directions.length > 0\">{{ \'FIELD.DESCRIPTION\' | translate}} : {{$ctrl.infoData.directions}}</div><div class=\"read\" ng-if=\"$ctrl.infoData.hasRead === 1\"><i class=\"fa fa-check-circle\"></i><span>{{ \'FIELD.HAS_BEEN_READ\' | translate}}</span></div></div>");
$templateCache.put("app/modules/full-text-search/views/full-text-search-list.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList th-waitCourse th-resour\"><div class=\"th-title\"><h2>{{ \'FIELD.FULL_TEXT_SEARCH_NAME\' | translate}}</h2></div><header><ui-pagination-header-controls pagination-id=\"fullTextSearch\" pagination-sort=\"$ctrl.pagination.sort\" pagination-filter=\"$ctrl.pagination.filter\" filters=\"$ctrl.filter\" sorts=\"$ctrl.sorts\" reload-pagination-data=\"$ctrl.searchByPaging(params)\" has-search-box=\"true\" has-change-template=\"true\" template-type=\"{{$ctrl.templateType}}\" placeholder=\"{{ \'FIELD.FULL_TEXT_QUERY_NAME\' | translate}}\"></ui-pagination-header-controls><br></header><div ng-if=\"$ctrl.isLoading\" class=\"page-spinner-loader\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div><div ng-show=\"!!$ctrl.params.keyword\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=\"\"><md-tab md-active=\"$ctrl.tabSelect===\'Course\'\" md-on-select=\"$ctrl.searchByType(\'Course\')\"><md-tab-label><span class=\"tab-label\">{{ \'COURSE_LEARNING_RESOURCE\' | translate}}</span></md-tab-label><md-tab-body><div class=\"row md-padding\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"courseInfoData in $ctrl.currentDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" pagination-id=\"fullTextSearch\" ng-class=\"{0:\'package\', 1:\'elearn\', 2:\'room\', 3:\'train\',4:\'test-e\',5:\'test\',6:\'package\'}[courseInfoData.courseType]\"><full-text-search-course-info info-data=\"courseInfoData\" node-id=\"courseInfoData.nid\" reload-fn=\"$ctrl.searchByKey(\'Course\', courseInfoData.key)\" back-state=\"fullTextSearchList\" params=\"$ctrl.params\"></full-text-search-course-info></div><div class=\"pt-noData\" ng-if=\"$ctrl.currentDatas.length == 0 && !$ctrl.isLoading\"><i class=\"ctms-icons icon-face-10\"></i><p>{{ \'FIELD.NO_SEARCH_DATA\' | translate}}</p></div></div></div></md-tab-body></md-tab><md-tab md-active=\"$ctrl.tabSelect===\'LearningResource\'\" md-on-select=\"$ctrl.searchByType(\'LearningResource\')\"><md-tab-label><span class=\"tab-label\">{{ \'KNOWLEDGE_MANAGEMENT_CENTER\' | translate}}</span></md-tab-label><md-tab-body><div class=\"row md-padding\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"lreInfoData in $ctrl.currentDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" pagination-id=\"fullTextSearch\"><full-text-search-learningresource-info info-data=\"lreInfoData\" reload-fn=\"$ctrl.searchByKey(\'LearningResource\', lreInfoData.key)\"></full-text-search-learningresource-info></div><div class=\"pt-noData\" ng-if=\"$ctrl.currentDatas.length == 0 && !$ctrl.isLoading\"><i class=\"ctms-icons icon-face-10\"></i><p>{{ \'FIELD.NO_SEARCH_DATA\' | translate}}</p></div></div></div></md-tab-body></md-tab></md-tabs><footer><ui-pagination-controls ng-if=\"$ctrl.currentDatas.length > 0\" on-page-change=\"$ctrl.searchByPaging(params)\" pagination-id=\"fullTextSearch\"></ui-pagination-controls></footer></div></section></div></div>");
$templateCache.put("app/modules/index/views/featured-course.html","<div class=\"th-myCourse\"><header class=\"el-header\"><h4>{{$ctrl.subject}}</h4><a ui-sref=\"courseResourceCatalog({tabSelect:\'featuredCourse\'})\" class=\"more\"><i class=\"material-icons\">more_horiz</i></a></header><div class=\"md-myCourse\" ng-if=\"$ctrl.recommendedCourses.length > 0\"><div class=\"md-packList\" ng-repeat=\"course in $ctrl.recommendedCourses\" ng-class=\"{0:\'package\',1:\'elearn\', 2:\'room\', 3:\'train\', 4:\'package\', 5:\'licenses\', 6:\'licenses\'}[course.activityType]\"><course-type-tag course-type=\"course.activityType\" is-program=\"(!course.course)\"></course-type-tag><figure><a ng-if=\"course.course\" ui-sref=\"courseResourceCatalog.CourseInfo({cid:0, nid:course.categoryTreeId, courseId:course.activityId, mid: null})\"><img ng-src=\"{{::( course.activityLogoUrl | serverResource:false )}}\"></a> <a ng-if=\"!course.course\" ui-sref=\"courseResourceCatalog.ProgramInfo({cid:0, nid:course.categoryTreeId, programId:course.activityId, mid: null})\"><img ng-src=\"{{::( course.activityLogoUrl | serverResource:false )}}\"></a></figure><div class=\"pt-contentList\"><h6><a ng-if=\"course.course\" ui-sref=\"courseResourceCatalog.CourseInfo({cid:0, nid:course.categoryTreeId, courseId:course.activityId, mid: null})\">{{course.activiyName}}</a> <a ng-if=\"!course.course\" ui-sref=\"courseResourceCatalog.ProgramInfo({cid:0, nid:course.categoryTreeId, programId:course.activityId, mid: null})\">{{course.activiyName}}</a></h6></div></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.recommendedCourses.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/index/views/incomplete-course.html","<div class=\"th-myCourse\"><header class=\"el-header\"><h4>{{$ctrl.subject}}</h4><a ui-sref=\"learningPassport.incompleteCourses\" class=\"more\"><i class=\"material-icons\">more_horiz</i></a></header><div class=\"md-myCourse\" ng-if=\"$ctrl.incompleteCoursesDatas.length > 0\"><div class=\"md-packList\" ng-repeat=\"course in $ctrl.incompleteCoursesDatas\" ng-class=\"{1:\'elearn\', 2:\'room\', 3:\'train\', 7:\'package\', 8:\'licenses\', 0:{0:\'package\', 1:\'licenses\'}[course.programType]}[course.courseType]\"><course-type-tag course-type=\"course.courseType\" is-program=\"(course.courseType === 0)\" program-type=\"course.programType\"></course-type-tag><figure ng-if=\"$ctrl.isCanView(course.status)\"><a href=\"javascript:void(0)\" ng-if=\"course.courseType !== 0 && $ctrl.isCanLearn(course.status,course.enrollType)\" ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:course.enrollmentId})\"><img ng-src=\"{{course.logoUrl}}\"></a> <a href=\"javascript:void(0)\" ng-if=\"course.courseType === 0 && $ctrl.isCanLearn(course.status,course.enrollType)\" ui-sref=\"learningPassport.incompleteCourses.programInfo({enrollmentId:course.enrollmentId})\"><img ng-src=\"{{course.logoUrl}}\"></a> <a href=\"javascript:void(0)\" ng-if=\"!$ctrl.isCanLearn(course.status,course.enrollType)\" ng-click=\"$ctrl.showStatus(course.courseType, course.status)\"><img ng-src=\"{{course.logoUrl}}\"></a></figure><figure ng-if=\"!$ctrl.isCanView(course.status)\"><img ng-src=\"{{course.logoUrl}}\"></figure><div class=\"pt-contentList\"><h6><a ng-if=\"$ctrl.isCanView(course.status) && $ctrl.isCanLearn(course.status,course.enrollType) && course.courseType !== 0\" ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:course.enrollmentId})\">{{course.courseName}}</a> <a ng-if=\"$ctrl.isCanView(course.status) && $ctrl.isCanLearn(course.status,course.enrollType) && course.courseType === 0\" ui-sref=\"learningPassport.incompleteCourses.programInfo({enrollmentId:course.enrollmentId})\">{{course.courseName}}</a> <a ng-if=\"!$ctrl.isCanView(course.status) || !$ctrl.isCanLearn(course.status,course.enrollType)\" ng-click=\"$ctrl.showStatus(course.courseType, course.status)\" href=\"javascript:void(0)\">{{course.courseName}}</a></h6><p class=\"info\" ng-if=\"course.courseType === 2 || course.courseType === 3\"><span ng-if=\"course.instructorList.length > 0\">{{ \'FIELD.INSTRUCTOR\' | translate}}: <a href=\"javascript:void(0);\" instructor-detail=\"\" instructor-id=\"instructor.instructorId\" ng-repeat=\"instructor in course.instructorList\" ng-if=\"course.courseType !== 3\">{{instructor.instructorName | markSplit:$index:\'&nbsp;/&nbsp;\'}}</a> <span ng-repeat=\"instructor in course.instructorList\" ng-if=\"course.courseType === 3\">{{instructor.instructorName | markSplit:$index:\'&nbsp;/&nbsp;\'}}</span> |</span> <span ng-if=\"course.place!==\'\'\">{{course.place}}</span></p><p class=\"el-day\"><i class=\"material-icons\">event_note</i> <span ng-if=\"course.courseType === 1\">{{course.enrolledDate}}</span> <span ng-if=\"course.courseType === 2 || course.courseType === 3\">{{course.expireStart}}</span> <span ng-if=\"course.courseType === 0\">{{course.expireStart}}~{{course.expireEnd}}</span></p></div><div class=\"link\"><md-button class=\"md-raised md-primary btn\" title=\"{{ \'FIELD.COURSE_DATA\' | translate}}\" ng-if=\"$ctrl.isCanView(course.status) && $ctrl.isCanLearn(course.status,course.enrollType) && course.courseType !== 0\" ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:course.enrollmentId})\"><md-icon md-font-set=\"fa\" class=\"fa-file-text-o\"></md-icon></md-button><md-button class=\"md-raised md-primary btn\" title=\"{{ \'FIELD.COURSE_DATA\' | translate}}\" ng-if=\"$ctrl.isCanView(course.status) && $ctrl.isCanLearn(course.status,course.enrollType) && course.courseType === 0\" ui-sref=\"learningPassport.incompleteCourses.programInfo({enrollmentId:course.enrollmentId})\"><md-icon md-font-set=\"fa\" class=\"fa-file-text-o\"></md-icon></md-button><md-button class=\"md-raised md-primary btn\" title=\"{{ \'FIELD.COURSE_DATA\' | translate}}\" ng-if=\"!$ctrl.isCanView(course.status) || !$ctrl.isCanLearn(course.status,course.enrollType)\" ng-click=\"$ctrl.showStatus(course.courseType, course.status)\" href=\"javascript:void(0)\"><md-icon md-font-set=\"fa\" class=\"fa-file-text-o\"></md-icon></md-button><md-button class=\"md-raised md-primary btn\" title=\"{{ \'FIELD.PLAY_THE_COURSE\' | translate}}\" ng-if=\"course.courseType === 1 && $ctrl.isCanView(course.status) && $ctrl.isCanLearn(course.status,course.enrollType)\" course-info-player=\"\" enrollment-id=\"course.enrollmentId\" reload-fn=\"$ctrl.reloadCourseRelatedData()\"><md-icon md-font-set=\"md\">play_circle_filledo</md-icon></md-button><md-button class=\"md-raised md-primary btn\" title=\"{{ \'FIELD.PLAY_THE_COURSE\' | translate}}\" ng-if=\"course.courseType === 1 && (!$ctrl.isCanView(course.status) || !$ctrl.isCanLearn(course.status,course.enrollType))\" ng-click=\"$ctrl.showStatus(course.courseType, course.status)\" href=\"javascript:void(0)\"><md-icon md-font-set=\"md\">play_circle_filledo</md-icon></md-button></div></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.incompleteCoursesDatas.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/index/views/index.html","<div class=\"row animated fadeIn\"><div class=\"col-lg-12\"><div class=\"ly-index\"><div class=\"th-banner\"><div class=\"md-banner\" uib-carousel=\"\" active=\"0\" interval=\"$ctrl.sbannerSpeed\" no-wrap=\"false\"><div class=\"pt-banner\" uib-slide=\"\" ng-repeat=\"slide in $ctrl.banners | toArray | orderBy: \'order\'\" index=\"$index\" ng-switch=\"slide.targetType\"><img ng-src=\"{{slide.imgSrc}}\" ng-if=\"!(slide.imgSrc | endsWith:\'.swf\')\" ng-switch-when=\"0\"><media-flash width=\"100%\" height=\"350\" src=\"{{slide.imgSrc | trustAsResourceUrl}}\" ng-if=\"(slide.imgSrc | endsWith:\'.swf\')\" ng-switch-when=\"0\"></media-flash><a ng-switch-when=\"1\" ng-href=\"{{slide.targetUrl}}\" ng-target-blank=\"{{slide.openNewWindow}}\"><img ng-src=\"{{slide.imgSrc }}\" ng-if=\"!(slide.imgSrc | endsWith:\'.swf\')\"><media-flash width=\"100%\" height=\"350\" src=\"{{slide.imgSrc | trustAsResourceUrl}}\" ng-if=\"(slide.imgSrc | endsWith:\'.swf\')\"></media-flash></a> <a ng-switch-when=\"2\" ng-if=\"slide.targetActivity.program\" ui-sref=\"courseResourceCatalog.ProgramInfo({cid:0, programId:slide.targetActivity.activityId})\" ng-target-blank=\"{{slide.openNewWindow}}\"><img ng-src=\"{{slide.imgSrc}}\" ng-if=\"!(slide.imgSrc | endsWith:\'.swf\')\"><media-flash width=\"100%\" height=\"350\" src=\"{{slide.imgSrc | trustAsResourceUrl}}\" ng-if=\"(slide.imgSrc | endsWith:\'.swf\')\"></media-flash></a> <a ng-switch-when=\"2\" ng-if=\"!slide.targetActivity.program\" ui-sref=\"courseResourceCatalog.CourseInfo({cid: 0, courseId:slide.targetActivity.activityId})\" ng-target-blank=\"{{slide.openNewWindow}}\"><img ng-src=\"{{slide.imgSrc}}\" ng-if=\"!(slide.imgSrc | endsWith:\'.swf\')\"><media-flash width=\"100%\" height=\"350\" src=\"{{slide.imgSrc | trustAsResourceUrl}}\" ng-if=\"(slide.imgSrc | endsWith:\'.swf\')\"></media-flash></a></div></div></div><div class=\"th-index\"><div class=\"th-indexMain\"><div ng-repeat=\"components in $ctrl.leftComponents track by $index\" compile=\"components.content\"></div></div><div class=\"th-indexSide\"><div ng-repeat=\"components in $ctrl.rightComponents track by $index\" compile=\"components.content\"></div></div></div></div></div></div>");
$templateCache.put("app/modules/index/views/knowledge-management-center.html","<div class=\"th-knowledge\"><header class=\"el-header\"><h4>{{$ctrl.subject}}</h4><a ui-sref=\"knowledgeDocumentCatalog({cid:0, mid: null})\" class=\"more\"><i class=\"material-icons\">more_horiz</i></a></header><div class=\"md-knowledge\" ng-if=\"$ctrl.latestDocuments.length > 0\"><div class=\"md-packList\" ng-repeat=\"documents in $ctrl.latestDocuments\"><figure><a href=\"{{documents.browseLink}}\" target=\"_blank\"><img ng-if=\"documents.logoLink !==\'\'\" ng-src=\"{{::documents.logoLink}}\"> <img ng-if=\"documents.logoLink ===\'\'\" ng-src=\"{{::( \'knowledge_\' + (documents.id % 17) | sunnetPicture:\'jpg\' )}}\"></a></figure><div class=\"pt-contentList\"><h6><a href=\"{{documents.browseLink}}\" target=\"_blank\">{{documents.title}}</a></h6></div><div class=\"link\"><md-button href=\"{{documents.browseLink}}\" target=\"_blank\" class=\"md-raised md-primary btn\">{{ \'ACTIONS.READ\' | translate}}</md-button></div></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.latestDocuments.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/index/views/latest-course.html","<div class=\"th-news\"><header class=\"el-header\"><h4>{{$ctrl.subject}}</h4><a ui-sref=\"courseResourceCatalog({cid:0, mid: null})\" class=\"more\"><i class=\"material-icons\">more_horiz</i></a></header><div class=\"md-news\" ng-if=\"$ctrl.latestCourses.length > 0\"><div class=\"md-banner\"><div class=\"pt-banner\"><figure><a href=\"javascript:void(0)\" ng-click=\"$ctrl.courseInfoPage($ctrl.latestCoursesInfo.itemId, $ctrl.latestCoursesInfo.courseType!==0)\"><img ng-src=\"{{$ctrl.latestCoursesInfo.logoUrl}}\" alt=\"\"></a></figure><div class=\"md-intro\"><a href=\"javascript:void(0)\" ng-click=\"$ctrl.courseInfoPage($ctrl.latestCoursesInfo.itemId, $ctrl.latestCoursesInfo.courseType!==0)\">{{$ctrl.latestCoursesInfo.objectName}}</a> <span class=\"text lateest-course-word-break-text\">{{$ctrl.latestCoursesInfo.description}}</span><div class=\"link\"><md-button class=\"md-raised md-primary btn\" title=\"{{ \'FIELD.COURSE_DATA\' | translate}}\" ng-click=\"$ctrl.courseInfoPage($ctrl.latestCoursesInfo.itemId, $ctrl.latestCoursesInfo.courseType!==0)\"><md-icon md-font-set=\"fa\" class=\"fa-file-text-o\"></md-icon></md-button><md-button class=\"md-raised md-primary btn\" title=\"{{ \'FIELD.I_WANT_TO_ENROLL\' | translate}}\" detail-session-list-dialog=\"\" course-id=\"$ctrl.latestCoursesInfo.itemId\" is-program=\"$ctrl.latestCoursesInfo.courseType===0\" reload-fn=\"$ctrl.reloadCourseRelatedData()\"><md-icon md-font-set=\"md\">person_add</md-icon></md-button></div></div></div></div><div class=\"md-list\"><ul><li ng-repeat=\"latestCourses in $ctrl.latestCourses |limitTo:4\" ng-class=\"{\'active\': $ctrl.selectedItemId === latestCourses.itemId}\" ng-click=\"$ctrl.showLatestPublishedCourses(latestCourses.itemId, false);$ctrl.selectedItemId = latestCourses.itemId\" ng-mouseleave=\"$ctrl.showLatestPublishedCourses($ctrl.selectedItemId, $ctrl.delayStatus);\" ng-mouseover=\"$ctrl.showLatestPublishedCourses(latestCourses.itemId, false);\"><a href=\"javascript:void(0);\"><img ng-src=\"{{latestCourses.logoUrl}}\" alt=\"\"></a></li></ul></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.latestCourses.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/index/views/latest-news-more-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width:50%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"$ctrl.mode===1\">{{ \'FIELD.ALL_ANNOUNCEMENTS\' | translate}}</h2><h2 ng-if=\"$ctrl.mode===0\">{{$ctrl.news.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><div class=\"lightBox Box-leave\"><div ng-show=\"$ctrl.mode===1\"><table ng-table=\"$ctrl.latestnewsTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'#\'\"><div class=\"text\">{{$index+1}}</div></td><td data-title=\"\'FIELD.TITLE\' | translate\"><div class=\"text\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.getNews(row.id)\">{{row.title}}</a></div></td></tr></table></div><div class=\"lightBox Box-person\" ng-if=\"$ctrl.mode===0\"><table class=\"BoxTable\"><tbody><tr ng-if=\"$ctrl.news.digest!==\'\'\"><th>{{ \'FIELD.SUMMARY\' | translate}}</th><td style=\"white-space:pre-wrap\">{{$ctrl.news.digest}}</td></tr><tr ng-if=\"$ctrl.news.content!==\'\'\"><th>{{ \'FIELD.DESCRIPTION\' | translate}}</th><td><span ng-bind-html=\"$ctrl.news.content |trustAsHtml\"></span></td></tr><tr ng-if=\"$ctrl.news.titleURL!==\'\'\"><th ng-if=\"$ctrl.news.isTitleToCourse===0\">{{ \'FIELD.RELATED_LINKS\' | translate}}</th><th ng-if=\"$ctrl.news.isTitleToCourse===1\">{{ \'FIELD.COURSE_LINKS\' | translate}}</th><td ng-if=\"$ctrl.news.isTitleToCourse===0\"><a target=\"_blank\" href=\"{{$ctrl.news.titleURL}}\">{{$ctrl.news.titleURL}}</a></td><td ng-if=\"$ctrl.news.isTitleToCourse===1\"><a href=\"javascript:void(0)\" ng-click=\"$ctrl.toCourseInfo($ctrl.news.titleURL);$ctrl.close()\">{{$ctrl.news.titleCourseName}}</a></td></tr><tr><th>{{ \'FIELD.ANNOUNCEMENT_TIME\' | translate}}</th><td><span ng-bind-html=\"$ctrl.news.createDate\"></span></td></tr></tbody></table><div ng-if=\"$ctrl.news.flashAccessURL!==\'\'\" style=\"text-align: center\"><embed embed-src=\"{{$ctrl.news.flashAccessURL}}\" type=\"application/x-shockwave-flash\"></div><div ng-if=\"$ctrl.news.imageURL!==\'\'\"><a href=\"{{$ctrl.news.imageURL}}\" target=\"_blank\" ng-if=\"$ctrl.news.isImageToCourse===0\"><img ng-src=\"{{$ctrl.news.imageAccessURL}}\" class=\"img-responsive\" ng-if=\"$ctrl.news.imageAccessURL!==\'\'\" target=\"_blank\"></a> <a href=\"javascript:void(0)\" ng-click=\"$ctrl.toCourseInfo($ctrl.news.imageURL);$ctrl.close()\" ng-if=\"$ctrl.news.isImageToCourse===1\"><img ng-src=\"{{$ctrl.news.imageAccessURL}}\" class=\"img-responsive\" ng-if=\"$ctrl.news.imageAccessURL!==\'\'\"></a></div><img ng-src=\"{{$ctrl.news.imageAccessURL}}\" class=\"img-responsive\" ng-if=\"$ctrl.news.imageURL===\'\' && $ctrl.news.imageAccessURL!==\'\'\"></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CLOSE\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-click=\"$ctrl.getAllNews()\" style=\"margin-right:20px;\" ng-if=\"$ctrl.mode===0\">{{ \'ACTIONS.ALL_ANNOUNCEMENTS\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/index/views/latest-news.html","<div class=\"th-bulletin\"><header><h5 ng-style=\"{width:\'90%\'}\"><i class=\"glyphicon glyphicon-bullhorn\"></i>{{$ctrl.subject}} :</h5><a href=\"javascript:void(0);\" ng-click=\"$ctrl.latestNewsMore(1,null, $event)\" class=\"more\"><i class=\"material-icons\">more_horiz</i></a></header><div class=\"md-bulletin\" ng-if=\"$ctrl.latestNews.length > 0\"><ul><li ng-repeat=\"news in $ctrl.latestNews\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.latestNewsMore(0, news.id, $event)\" style=\"cursor:pointer\">{{news.title}}</a></li></ul></div><div class=\"pt-noData\" ng-if=\"$ctrl.latestNews.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/index/views/online-course-leader-board.html","<div class=\"th-hotCourse\"><header class=\"\"><h5>{{$ctrl.subject}}</h5></header><div class=\"md-hotCourse\" ng-if=\"$ctrl.hotCourse.length > 0\"><dl><dd ng-repeat=\"hotCourse in $ctrl.hotCourse\"><figure ng-if=\"$index === 0\"><a ui-sref=\"courseResourceCatalog.CourseInfo({cid:0, courseId:hotCourse.activityId, mid: null})\"><img ng-src=\"{{hotCourse.activityLogoUrl}}\" alt=\"\"></a></figure><div class=\"md-ranking\" ng-if=\"$index === 0\"><i class=\"fa fa-trophy\"></i> <a ui-sref=\"courseResourceCatalog.CourseInfo({cid:0, courseId:hotCourse.activityId, mid: null})\">{{hotCourse.activiyName}}</a></div><p class=\"pt-ranking\" ng-if=\"$index > 0\">{{$index+1}}</p><a ui-sref=\"courseResourceCatalog.CourseInfo({cid:0, courseId:hotCourse.activityId, mid: null})\" ng-if=\"$index > 0\">{{hotCourse.activiyName}}</a></dd></dl></div><div class=\"pt-noData\" ng-if=\"$ctrl.hotCourse.length === 0\"><i class=\"fa fa-trophy\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/index/views/related-sites-more-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width:50%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"$ctrl.mode===1\">{{ \'FIELD.RELATED_SITES\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><div class=\"lightBox Box-leave\"><div ng-show=\"$ctrl.mode===1\"><table ng-table=\"$ctrl.relatedsitesTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'#\'\"><div class=\"text\">{{$index+1}}</div></td><td data-title=\"\'FIELD.WEBSITE\' | translate\"><div class=\"text\"><a ng-href=\"{{row.titleUrl}}\" target=\"_blank\">{{row.title}}</a></div></td></tr></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CLOSE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/index/views/related-sites.html","<div class=\"th-web\"><header><h5>{{$ctrl.subject}}</h5><div class=\"moreDiv\"><a href=\"javascript:void(0);\" ng-if=\"$ctrl.relatedSites.length >2\" ng-click=\"$ctrl.relatedSitesMore(1,$event);\"><i class=\"material-icons\">more_horiz</i></a></div></header><div class=\"md-web\" ng-if=\"$ctrl.relatedSites.length > 0\"><ul><li ng-repeat=\"websites in $ctrl.relatedSites\"><a ng-href=\"{{websites.titleUrl}}\" target=\"_blank\">{{websites.title}}</a></li></ul></div><div class=\"pt-noData\" ng-if=\"$ctrl.relatedSites.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/learning-resource/views/knowledge-document-list.html","<div class=\"row animated fadeIn\" ng-if=\"!$ctrl.isShowIndex\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList\"><div class=\"th-title\"><h2>{{$ctrl.learningResourceTitle}}</h2></div><header ng-if=\"!$ctrl.lastMenulist.isCWSubCh && !$ctrl.lastMenulist.isEMBARoot && !$ctrl.lastMenulist.isHBRRoot\"><ui-pagination-header-controls pagination-id=\"knowledgeManagementCenter\" pagination-sort=\"$ctrl.pagination.sort\" sorts=\"[{key : \'ModifiedDate\', name:\'FIELD.DATE\'},{key : \'LearningResourceEntries.avgScore\', name:\'ACTIONS.RATING\'},{key : \'LearningResourceEntries.clickCount\', name:\'FIELD.CLICK_COUNT\'},{key : \'LearningResourceEntries.Title\', name:\'FIELD.TITLE\'}]\" reload-pagination-data=\"$ctrl.getData(params)\" has-search-box=\"true\" has-change-template=\"true\" template-type=\"card\"></ui-pagination-header-controls></header><div ng-if=\"$ctrl.isLoading\" class=\"page-spinner-loader\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div><img ng-if=\"$ctrl.lastMenulist.isHBR && !$ctrl.lastMenulist.isHBRRoot\" ng-src=\"{{::( \'hbr-logo\' | sunnetPicture:\'png\' )}}\" alt=\"\" width=\"300\"><div ng-if=\"!$ctrl.lastMenulist.isCWSubCh && !$ctrl.lastMenulist.isEMBARoot && !$ctrl.lastMenulist.isHBRRoot\" class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"KnowledgeManagementCenterData in $ctrl.KnowledgeManagementCenterDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" pagination-id=\"knowledgeManagementCenter\"><full-text-search-learningresource-info ng-if=\"$ctrl.isSearchMode\" info-data=\"KnowledgeManagementCenterData\" reload-fn=\"$ctrl.getData($ctrl.params)\"></full-text-search-learningresource-info><div ng-if=\"!$ctrl.isSearchMode\" class=\"timeline-content\"><div class=\"md-contentList\"><figure><a href=\"{{KnowledgeManagementCenterData.browseLink}}\" target=\"_blank\"><img ng-if=\"KnowledgeManagementCenterData.logoLink !==\'\'\" ng-src=\"{{::KnowledgeManagementCenterData.logoLink}}\"> <img ng-if=\"KnowledgeManagementCenterData.logoLink ===\'\'\" ng-src=\"{{::( \'knowledge_\' + (KnowledgeManagementCenterData.id % 17) | sunnetPicture:\'jpg\' )}}\"></a></figure><div class=\"pt-contentList\"><h6><a href=\"{{KnowledgeManagementCenterData.browseLink}}\" target=\"_blank\">{{KnowledgeManagementCenterData.title}}</a></h6><ul><li ng-if=\"KnowledgeManagementCenterData.author !== \'null\'\">{{ \'FIELD.AUTHOR\' | translate}}: <a ng-if=\"KnowledgeManagementCenterData.isExternalCWSubCh ===-1\" href=\"javascript:void(0);\" class=\"author\" user-detail=\"\" user-id=\"KnowledgeManagementCenterData.publisherId\">{{KnowledgeManagementCenterData.author}}</a> <span ng-if=\"KnowledgeManagementCenterData.isExternalCWSubCh >-1\">{{KnowledgeManagementCenterData.author}}</span></li><li ng-if=\"KnowledgeManagementCenterData.author === \'null\'\">{{ \'FIELD.AUTHOR\' | translate}}:</li><li ng-if=\"$ctrl.params.keyword!==\'\'\">{{ \'FIELD.LOCATION\' | translate}}: {{ \'FIELD.ROOT_DIRECTORY\' | translate}}/<span ng-repeat=\"menu in KnowledgeManagementCenterData.menulist\">{{menu.title | markSplit:$index:\'/\'}}</span></li><li><span>{{ \'FIELD.CLICK_COUNT\' | translate}}: {{KnowledgeManagementCenterData.clickCount}}</span> <span ng-if=\"KnowledgeManagementCenterData.isExternalCWSubCh ===-1\">,&nbsp; {{ \'FIELD.DOWNLOAD_COUNT\' | translate}}: {{KnowledgeManagementCenterData.downloadCount}}</span></li><li>{{ \'FIELD.I_WANT\' | translate}}: <a ng-if=\"KnowledgeManagementCenterData.isExternalCWSubCh ===-1\" href=\"{{KnowledgeManagementCenterData.downloadLink}}\" target=\"_blank\" class=\"download\">{{ \'ACTIONS.DOWNLOAD\' | translate}}</a> <span ng-if=\"KnowledgeManagementCenterData.isExternalCWSubCh ===-1\">|</span> <a href=\"javascript:void(0)\" set-score=\"\" reload=\"$ctrl.getData($ctrl.params)\" doc-id=\"KnowledgeManagementCenterData.id\" title=\"KnowledgeManagementCenterData.title\" class=\"score\">{{ \'ACTIONS.RATING\' | translate}}</a></li><li>{{ \'FIELD.AVERAGE_RATING\' | translate}}:<div class=\"rateit\" data-value=\"2.5\" data-readonly=\"true\"><ng-rate-it ng-model=\"KnowledgeManagementCenterData.averageScore\" step=\"0.1\" read-only=\"true\"></ng-rate-it></div><span>{{KnowledgeManagementCenterData.averageScore|number:2}}</span></li><li>{{ \'FIELD.SHARE_DATE\' | translate}}: <span>{{KnowledgeManagementCenterData.shareDate}}</span></li></ul><footer><a href=\"{{KnowledgeManagementCenterData.browseLink}}\" target=\"_blank\" class=\"btn btn-primary\">{{ \'ACTIONS.READ\' | translate}}</a></footer></div></div><div class=\"explain\" ng-show=\"KnowledgeManagementCenterData.directions.length > 0\">{{ \'FIELD.DESCRIPTION\' | translate}} : {{KnowledgeManagementCenterData.directions}}</div><div class=\"read\" ng-if=\"KnowledgeManagementCenterData.hasRead===1\"><i class=\"fa fa-check-circle\"></i><span>{{ \'FIELD.HAS_BEEN_READ\' | translate}}</span></div></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.KnowledgeManagementCenterDatas.length === 0 && !$ctrl.isLoading\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div><iframe width=\"100%\" height=\"2000px\" frameborder=\"0\" scrolling=\"no\" ng-if=\"$ctrl.lastMenulist.isHBRRoot && $ctrl.catalogId\" ng-src=\"{{$ctrl.extenralRootUrl + \'?folderId=\' + $ctrl.catalogId | trustAsResourceUrl}}\"></iframe><iframe width=\"100%\" height=\"2000px\" frameborder=\"0\" scrolling=\"no\" ng-if=\"$ctrl.lastMenulist.isHBRRoot && $ctrl.catalogId ===0 && $ctrl.nodeId\" ng-src=\"{{$ctrl.extenralRootUrl + \'?folderId=\' + $ctrl.nodeId | trustAsResourceUrl}}\"></iframe><iframe width=\"100%\" style=\"border: none; padding: 0; margin: 0;height: 95vh;\" frameborder=\"0\" scrolling=\"no\" ng-if=\"$ctrl.lastMenulist.isEMBARoot\" ng-src=\"{{$ctrl.extenralRootUrl + \'?folderId=\' + $ctrl.catalogId | trustAsResourceUrl}}\"></iframe><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;\" ng-if=\"$ctrl.lastMenulist.isCWSubCh && !$ctrl.lastMenulist.isEMBARoot\" ng-src=\"{{$ctrl.externalUrl + \'?folderId=\' + $ctrl.lastMenulist.id +\'&from=SiteMapFrontEnd\' | trustAsResourceUrl}}\"></iframe><footer ng-if=\"!$ctrl.lastMenulist.isCWSubCh && !$ctrl.lastMenulist.isEMBARoot && !$ctrl.lastMenulist.isHBRRoot\"><ui-pagination-controls on-page-change=\"$ctrl.getData(params)\" pagination-id=\"knowledgeManagementCenter\"></ui-pagination-controls></footer></section></div></div><div class=\"row animated fadeIn\" ng-if=\"$ctrl.isShowIndex\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList th-card\"><div class=\"th-title\"><h2>{{ \'KNOWLEDGE_MANAGEMENT_CENTER\' | translate}}</h2></div><header><ui-pagination-header-controls pagination-id=\"knowledgeManagementCenterIndex\" pagination-sort=\"$ctrl.pagination.sort\" sorts=\"$ctrl.sorts\" reload-pagination-data=\"$ctrl.getData(params)\" has-search-box=\"true\" has-change-template=\"true\" template-type=\"card\"></ui-pagination-header-controls></header><div ng-if=\"$ctrl.isLoading\" class=\"page-spinner-loader\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div><div ng-show=\"$ctrl.params.keyword!==\'\'\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"KnowledgeManagementCenterData in $ctrl.KnowledgeManagementCenterDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" pagination-id=\"knowledgeManagementCenterIndex\"><full-text-search-learningresource-info info-data=\"KnowledgeManagementCenterData\" reload-fn=\"$ctrl.getData($ctrl.params)\"></full-text-search-learningresource-info></div><div class=\"pt-noData\" ng-if=\"$ctrl.KnowledgeManagementCenterDatas.length === 0 && !$ctrl.isLoading\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div><footer><ui-pagination-controls on-page-change=\"$ctrl.getData(params)\" pagination-id=\"knowledgeManagementCenterIndex\"></ui-pagination-controls></footer></div><div ng-show=\"$ctrl.params.keyword===\'\'\"><header class=\"el-header\"><h4>{{ \'FIELD.LATEST_DOCUMENT\' | translate}}</h4></header><div class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ng-repeat=\"documentsData in $ctrl.newDocumentsDatas\"><div class=\"timeline-content\"><div class=\"md-contentList\"><figure><a href=\"{{documentsData.browseLink}}\" target=\"_blank\"><img ng-if=\"documentsData.logoLink !==\'\'\" ng-src=\"{{::documentsData.logoLink}}\"> <img ng-if=\"documentsData.logoLink ===\'\'\" ng-src=\"{{::( \'knowledge_\' + (documentsData.id % 17) | sunnetPicture:\'jpg\' )}}\"></a></figure><div class=\"pt-contentList\"><h6><a href=\"{{documentsData.browseLink}}\" target=\"_blank\">{{documentsData.title}}</a></h6><ul><li>{{ \'FIELD.AUTHOR\' | translate}}: <a ng-if=\"documentsData.author !== \'null\'\" href=\"javascript:void(0);\" class=\"author\" user-detail=\"\" user-id=\"documentsData.publisherId\">{{documentsData.author}}</a></li><li>{{ \'FIELD.LOCATION\' | translate}}: {{ \'FIELD.ROOT_DIRECTORY\' | translate}}/<span ng-repeat=\"menu in documentsData.menulist\">{{menu.title | markSplit:$index:\'/\'}}</span></li><li>{{ \'FIELD.CLICK_COUNT\' | translate}}: <span>{{documentsData.clickCount}}</span>,&nbsp; {{ \'FIELD.DOWNLOAD_COUNT\' | translate}}: <span>{{documentsData.downloadCount}}</span></li><li>{{ \'FIELD.I_WANT\' | translate}}: <a href=\"{{documentsData.downloadLink}}\" target=\"_blank\" class=\"download\">{{ \'ACTIONS.DOWNLOAD\' | translate}}</a> | <a href=\"javascript:void(0);\" set-score=\"\" reload=\"$ctrl.getData($ctrl.params)\" doc-id=\"documentsData.id\" title=\"documentsData.title\" class=\"score\">{{ \'ACTIONS.RATING\' | translate}}</a></li><li>{{ \'FIELD.AVERAGE_RATING\' | translate}}:<div class=\"rateit\" data-value=\"2.5\" data-readonly=\"true\"><ng-rate-it ng-model=\"documentsData.averageScore\" step=\"0.1\" read-only=\"true\"></ng-rate-it></div><span>{{documentsData.averageScore|number:2}}</span></li><li>{{ \'FIELD.SHARE_DATE\' | translate}}: <span>{{documentsData.shareDate}}</span></li></ul><footer><a href=\"{{documentsData.browseLink}}\" target=\"_blank\" class=\"btn btn-primary\">{{ \'ACTIONS.READ\' | translate}}</a></footer></div></div><div class=\"explain\" ng-show=\"documentsData.directions.length > 0\">{{ \'FIELD.DESCRIPTION\' | translate}} : {{documentsData.directions}}</div><div class=\"read\" ng-if=\"documentsData.hasRead===1\"><i class=\"fa fa-check-circle\"></i><span>{{ \'FIELD.HAS_BEEN_READ\' | translate}}</span></div></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.newDocumentsDatas.length === 0 && !$ctrl.isLoading\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div><header class=\"el-header\"><h4>{{ \'FIELD.HOT_DOCUMENT\' | translate}}</h4></header><div class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ng-repeat=\"documentsData in $ctrl.hotDocumentsDatas\"><div class=\"timeline-content\"><div class=\"md-contentList\"><figure><a href=\"{{documentsData.browseLink}}\" target=\"_blank\"><img ng-if=\"documentsData.logoLink !==\'\'\" ng-src=\"{{::documentsData.logoLink}}\"> <img ng-if=\"documentsData.logoLink ===\'\'\" ng-src=\"{{::( \'knowledge_\' + (documentsData.id % 17) | sunnetPicture:\'jpg\' )}}\"></a></figure><div class=\"pt-contentList\"><h6><a href=\"{{documentsData.browseLink}}\" target=\"_blank\">{{documentsData.title}}</a></h6><ul><li>{{ \'FIELD.AUTHOR\' | translate}}: <a ng-if=\"documentsData.author !== \'null\'\" href=\"javascript:void(0);\" class=\"author\" user-detail=\"\" user-id=\"documentsData.publisherId\">{{documentsData.author}}</a></li><li>{{ \'FIELD.LOCATION\' | translate}}: {{ \'FIELD.ROOT_DIRECTORY\' | translate}}/<span ng-repeat=\"menu in documentsData.menulist\">{{menu.title | markSplit:$index:\'/\'}}</span></li><li>{{ \'FIELD.CLICK_COUNT\' | translate}}: <span>{{documentsData.clickCount}}</span>,&nbsp; {{ \'FIELD.DOWNLOAD_COUNT\' | translate}}: <span>{{documentsData.downloadCount}}</span></li><li>{{ \'FIELD.I_WANT\' | translate}}: <a href=\"{{documentsData.downloadLink}}\" target=\"_blank\" class=\"download\">{{ \'ACTIONS.DOWNLOAD\' | translate}}</a> | <a href=\"javascript:void(0);\" set-score=\"\" reload=\"$ctrl.getData($ctrl.params)\" doc-id=\"documentsData.id\" class=\"score\">{{ \'ACTIONS.RATING\' | translate}}</a></li><li>{{ \'FIELD.AVERAGE_RATING\' | translate}}:<div class=\"rateit\" data-value=\"2.5\" data-readonly=\"true\"><ng-rate-it ng-model=\"documentsData.averageScore\" step=\"0.1\" read-only=\"true\"></ng-rate-it></div><span>{{documentsData.averageScore|number:2}}</span></li><li>{{ \'FIELD.SHARE_DATE\' | translate}}: <span>{{documentsData.shareDate}}</span></li></ul><footer><a href=\"{{documentsData.browseLink}}\" target=\"_blank\" class=\"btn btn-primary\">{{ \'ACTIONS.READ\' | translate}}</a></footer></div></div><div class=\"explain\" ng-show=\"documentsData.directions.length > 0\">{{ \'FIELD.DESCRIPTION\' | translate}} : {{documentsData.directions}}</div><div class=\"read\" ng-if=\"documentsData.hasRead===1\"><i class=\"fa fa-check-circle\"></i><span>{{ \'FIELD.HAS_BEEN_READ\' | translate}}</span></div></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.hotDocumentsDatas.length === 0 && !$ctrl.isLoading\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div></div></section></div></div>");
$templateCache.put("app/modules/learning-resource/views/knowledge-document-menu.html","<script type=\"text/ng-template\" id=\"Knowledge_document_nodes_renderer.html\"><a ui-sref=\"knowledgeDocumentCatalog(::{cid:$ctrl.catalogId, nid:node.id})\" ui-sref-opts=\"{reload:false}\" ng-if=\"::node.nodes.length > 0\" aria-expanded=\"false\" ng-click=\"$ctrl.toggleNode(node)\"> <i class=\"fa fa-fw fa-folder\"></i> <span>{{::node.title}}</span> </a> <a ui-sref=\"knowledgeDocumentCatalog(::{cid:$ctrl.catalogId, nid:node.id})\" ui-sref-opts=\"{reload:false}\" ng-if=\"::node.nodes.length === 0\" aria-expanded=\"false\" ng-click=\"$ctrl.toggleNode(node)\"> <span class=\"fa fa-fw fa-folder-o\"></span> <span>{{::node.title}}</span> </a> <ul naria-expanded=\"false\" ng-class=\"{in: node.showChildren}\" class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-if=\"node.showChildren && node.nodes.length > 0\"> <li ng-repeat=\"node in node.nodes\" ng-class=\"{active: node.showChildren}\" ui-tree-node ng-include=\"\'Knowledge_document_nodes_renderer.html\'\"></li> </ul></script><ul class=\"nav nav-sidebar metismenu\"><li ng-if=\"$ctrl.previousMenu\"><a ui-sref=\"{{$ctrl.previousMenu.model[\'state\']}}({mid: $ctrl.previousMenu.model[\'stateParams\'][\'mid\']})\" ui-sref-opts=\"{reload:true}\"><i class=\"icon-home\"></i><span>{{\'ACTIONS.RETURN\' | translate}}{{ $ctrl.previousMenu.model[\'title\'] }}</span></a></li><li ng-metis=\"\" mobile-sidebar=\"\" class=\"metismenu-parent active\" ui-tree=\"\" ng-click=\"$ctrl.initScrollBar()\" ng-if=\"$ctrl.mainMenu\"><a ui-sref=\"knowledgeDocumentCatalog({cid: $ctrl.mainMenu.stateParams[\'cid\'], nid: undefined})\" ng-if=\"$ctrl.menu.length === 0\"><i class=\"icon icons-education-science-18\"></i> <span>{{ $ctrl.mainMenu.title }}</span></a> <a ui-sref=\"knowledgeDocumentCatalog({cid: $ctrl.mainMenu.stateParams[\'cid\'], nid: undefined})\" ng-if=\"$ctrl.menu.length > 0\"><i class=\"icon icons-education-science-18\"></i> <span>{{ $ctrl.mainMenu.title }}</span> <span class=\"fa fa-fw arrow\"></span></a><ul class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"$ctrl.menu\" id=\"knowledge-document-tree-root\"><li ng-metis=\"\" ng-repeat=\"node in $ctrl.menu\" ui-tree-node=\"\" ng-class=\"{active: node.showChildren}\" ng-click=\"treeNode.toggle(this)\" ng-include=\"\'Knowledge_document_nodes_renderer.html\'\"></li></ul></li></ul>");
$templateCache.put("app/modules/learning-resource/views/set-score.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"40\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{SSC.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"SSC.cancel()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><div class=\"lightBox\"><h5>{{ \'FIELD.PLEASE_RATING\' | translate}}</h5><div class=\"th-rateit\" style=\"text-align:center;\"><ng-rate-it ng-model=\"SSC.scoreInfos.userScore\" step=\"1\" read-only=\"SSC.readOnly\" star-width=\"32\" star-height=\"32\" resetable=\"false\" class=\"bigstar\" style=\"text-align:center;\"></ng-rate-it><span class=\"total\"><i class=\"material-icons\" style=\"vertical-align:top;\">group</i> {{SSC.scoreInfos.scorePerson}}</span></div><br><p class=\"show\" style=\"text-align:center;\"><a href=\"javascript:void(0)\" ng-click=\"SSC.averageShow()\" ng-if=\"SSC.average===false\">{{ \'ACTIONS.SHOW_AVERAGE_RATING\' | translate}}</a> <a href=\"javascript:void(0)\" ng-click=\"SSC.averageShow()\" ng-if=\"SSC.average===true\">{{ \'ACTIONS.HIDDEN_AVERAGE_RATING\' | translate}}</a></p><div class=\"md-rateit\" ng-show=\"SSC.average\"><div class=\"col-md-9 col-md-offset-1\"><div class=\"pt-rateit\" style=\"text-align:right;\" ng-repeat=\"scoreInfo in SSC.scoreInfos.percentages\"><ng-rate-it ng-model=\"scoreInfo.gradeScore\" max=\"scoreInfo.gradeScore\" read-only=\"true\" resetable=\"false\" style=\"display: inline-block;vertical-align:top;\"></ng-rate-it><div class=\"progress th-line\" style=\"width: 70%;display: inline-block;margin-top:6px;\"><div class=\"progress-bar\" style=\"width: {{scoreInfo.percentage}};\"></div><div class=\"progress-value\" style=\"right:-60px;top:-10px\">{{scoreInfo.percentage}}</div></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn btn\" ng-click=\"SSC.cancel()\">{{ \'ACTIONS.CLOSE\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-click=\"SSC.setScore(SSC.docId,SSC.scoreInfos.userScore)\" ng-if=\"SSC.readOnly===false\" ng-disabled=\"SSC.scoreInfos.userScore===\'\'\">{{ \'ACTIONS.SUBMIT_RATING\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/manager/views/emba-calendar.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/manager/views/emba-must-read.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/manager/views/manager-training-plan.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/manager/views/manager-training-records.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'MEMBER_TRAINING_RECORDS\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.showPrompt($event)\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><div class=\"th-staff\"><div class=\"el-person\"><avatar avatar-url=\"$ctrl.userProfiles.avatarUrl\" first-name=\"$ctrl.userProfiles.firstName\" line-height=\"60\" font-size=\"24\"></avatar></div><div class=\"md-staff\"><p class=\"name\">{{$ctrl.userProfiles.name}}</p><ul><li class=\"pt-blueG\"><i class=\"material-icons\">assignment_turned_in</i>{{ \'FIELD.PASSED_COUNT\' | translate}} :<strong>{{$ctrl.summary.passedCount}}</strong></li><li class=\"pt-red\"><i class=\"material-icons\">assignment_late</i>{{ \'STATUS.FAILED\' | translate}} :<strong>{{$ctrl.summary.failedCount}}</strong></li><li class=\"pt-blue\" ng-if=\"$ctrl.hasCurriculumPermission && $ctrl.hasCertificationInnerPermission\"><i class=\"fa fa-share-square-o\"></i> {{ \'FIELD.EXEMPTION_COUNT\' | translate}} :<strong>{{$ctrl.summary.exemptionCount}}</strong></li><li class=\"pt-red\"><i class=\"material-icons\">assignment_late</i>N/A :<strong>{{$ctrl.summary.naCount}}</strong></li><li>{{ \'FIELD.TOTAL\' | translate}} :<strong>{{($ctrl.summary.passedCount + $ctrl.summary.failedCount + $ctrl.summary.exemptionCount + $ctrl.summary.naCount)}}</strong></li></ul></div></div><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.myTrainingRecordsTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></section></div></div>");
$templateCache.put("app/modules/manager/views/member-cert-records-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"30\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.DEPARTMENT_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"manage-groups\" params=\"{showAllOption: false, selectedValue: $ctrl.filters.groupId}\" default-select-first=\"true\" ng-model=\"$ctrl.filters.groupId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.DEPARTMENT_MEMBER\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"manage-members\" params=\"{showAllOption: false, selectedValue: $ctrl.filters.memberId, groupId: $ctrl.filters.groupId, filterSelf: false}\" ng-model=\"$ctrl.filters.memberId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERT_TYPE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.filters.certType\"><md-radio-button class=\"el-inBlock p-r-20\" value=\"inner\" permission=\"\" permission-only=\"[\'Modules.certification.inner\']\">{{\'FIELD.INTERNAL_LICENSE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"ext\" permission=\"\" permission-only=\"[\'Modules.certification.ext\']\">{{\'FIELD.EXTERNAL_LICENSE\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'inner\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERTIFICATE_TYPE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"innercert-classes\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.certClassId}\" ng-model=\"$ctrl.filters.certClassId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'inner\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERTIFICATION_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"innercerts\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.certId, classificationId: $ctrl.filters.certClassId}\" ng-model=\"$ctrl.filters.certId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'ext\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"companys\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.companyId}\" ng-model=\"$ctrl.filters.companyId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.certType === \'ext\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-ctl type=\"subjects\" params=\"{showAllOption: true, selectedValue: $ctrl.filters.subjectId, companyId: $ctrl.filters.companyId}\" ng-model=\"$ctrl.filters.subjectId\"></select-ctl></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.VALID_DATE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.filters.validDateType\"><md-radio-button class=\"el-inBlock p-r-20\" value=\"0\">{{\'FIELD.ALL\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"1\">{{\'FIELD.NEVER_EXPIRE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"2\">{{\'FIELD.SELECT_START_END_DATE\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.validDateType === \'2\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.VALID_DATE_START\' | translate}}</div><div flex-gt-xs=\"75\" class=\"\"><md-datepicker ng-model=\"$ctrl.filters.accessBegin\" ng-change=\"$ctrl.updateEndDateModel()\" md-placeholder=\"{{\'MESSAGE.MSG_PLEASE_ENTER_START_DATE\' |translate}}\"></md-datepicker></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" ng-if=\"$ctrl.filters.validDateType === \'2\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.VALID_DATE_END\' | translate}}</div><cus-md-datepicker flex-gt-xs=\"75\" ng-model=\"$ctrl.filters.accessEnd\" md-min-date=\"$ctrl.filters.accessBegin\" md-placeholder=\"{{\'MESSAGE.MSG_PLEASE_ENTER_END_DATE\' |translate}}\"></cus-md-datepicker></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.cancel()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-click=\"$ctrl.submit($ctrl.filters)\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/manager/views/member-cert-records-search.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'CERT_RECORDS_SEARCH\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.showPrompt($event)\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.certTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></section></div></div>");
$templateCache.put("app/modules/manager/views/member-curriculum-detail-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"80\"><md-toolbar><div class=\"md-toolbar-tools\"><ng-switch on=\"MCDDC.enrollmentType\"><h2 ng-switch-when=\"-1\">{{\'FIELD.DROP_NUMBER_OF_PEOPLE\' | translate}}</h2><h2 ng-switch-when=\"0\">{{\'FIELD.INCOMPLETED_NUMBER_OF_PEOPLE\' | translate}}</h2><h2 ng-switch-when=\"1\">{{\'FIELD.EXEMPTION_NUMBER_OF_PEOPLE\' | translate}}</h2><h2 ng-switch-when=\"2\">{{\'FIELD.PASSED_NUMBER_OF_PEOPLE\' | translate}}</h2><h2 ng-switch-when=\"3\">{{\'FIELD.FAILED_NUMBER_OF_PEOPLE\' | translate}}</h2><h2 ng-switch-when=\"4\">{{\'FIELD.ENROLLMENT_NUMBER_OF_PEOPLE\' | translate}}</h2></ng-switch><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"MCDDC.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><div class=\"lightBox Box-repeat\"><header><h3>{{MCDDC.courseName}}</h3></header><h5>{{\'FIELD.SESSION_NAME\' | translate}}: {{MCDDC.courseSession}}</h5><table class=\"tb-Collapse tb-check\"><thead><tr><th>{{\'FIELD.EMPLOYEE_NUMBER\' | translate}}</th><th>{{\'FIELD.FULL_NAME\' | translate}}</th><th>{{\'FIELD.DEPARTMENT\' | translate}}</th><th>{{\'FIELD.DUTY_DAY\' | translate}}</th><th>{{\'FIELD.INDUCTION_DATE\' | translate}}</th><th>{{\'FIELD.PROPERTIES\' | translate}}</th><th ng-if=\"MCDDC.enrollmentType!==-1\">{{ \'FIELD.ENROLLMENT_HOURS\' | translate}}({{\'FIELD.HOUR\' | translate}})</th><th ng-if=\"MCDDC.enrollmentType!==-1\">{{ \'FIELD.PASS_STATUS\' | translate}}</th><th ng-if=\"MCDDC.enrollmentType!==-1\">{{ \'FIELD.COST\' | translate}}</th><th ng-if=\"MCDDC.enrollmentType!==-1\">{{ \'FIELD.TEST_SCORE\' | translate}}</th><th ng-if=\"MCDDC.enrollmentType!==-1\">{{ \'FIELD.LEARNING_REPORT\' | translate}}</th><th ng-if=\"MCDDC.enrollmentType===-1\">{{ \'FIELD.REASON\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"curriculumDetail in MCDDC.curriculumDetails\"><td>{{curriculumDetail.employeeNumber}}</td><td>{{curriculumDetail.fullName}}</td><td>{{curriculumDetail.joinGroupName}}</td><td>{{curriculumDetail.onboardDate}}</td><td>{{curriculumDetail.inboardDate}}</td><td><span ng-if=\"curriculumDetail.learnerType===0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span ng-if=\"curriculumDetail.learnerType===1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></td><td ng-if=\"MCDDC.enrollmentType!==-1\">{{curriculumDetail.totalTime}}</td><td ng-switch=\"curriculumDetail.result\" ng-if=\"MCDDC.enrollmentType!==-1\"><span ng-switch-when=\"0\">{{\"N/A\"}}</span> <span ng-switch-when=\"1\">{{ \'STATUS.EXEMPTION\' | translate}}</span> <span ng-switch-when=\"2\">{{ \'STATUS.PASSED\' | translate}}</span> <span ng-switch-when=\"3\">{{ \'STATUS.FAILED\' | translate}}</span></td><td ng-if=\"MCDDC.enrollmentType!==-1\">{{curriculumDetail.personalCost}}</td><td ng-if=\"MCDDC.enrollmentType!==-1\">{{curriculumDetail.score}}</td><td ng-if=\"MCDDC.enrollmentType!==-1 && (curriculumDetail.isNeedReport === 1 && MCDDC.courseType!==3) || ( curriculumDetail.isNeedDocReport ===1 && MCDDC.courseType===3)\"><span ng-if=\"curriculumDetail.learningReportSummitted===0\">{{ \'STATUS.NOT_SUBMIT\' | translate}}</span> <span ng-if=\"curriculumDetail.learningReportSummitted>0\">{{ \'STATUS.SUBMITTED\' | translate}}</span> ({{curriculumDetail.learningReportSummitted}}/{{curriculumDetail.numOfReports}})</td><td ng-if=\"MCDDC.enrollmentType!==-1 && (curriculumDetail.isNeedReport === 0 && MCDDC.courseType!==3 ) || ( curriculumDetail.isNeedDocReport ===0 && MCDDC.courseType===3)\">{{ \'STATUS.EXEMPTION_SUBMIT\' | translate}}</td><td ng-if=\"MCDDC.enrollmentType===-1\">{{curriculumDetail.unenrollReason}}</td></tr></tbody></table></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/manager/views/member-curriculum-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"50\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"MCSDC.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><script type=\"text/ng-template\" id=\"headerCheckbox.html\"><md-checkbox flex class=\"md-primary checkbox\" ng-model=\"MCSDC.id.selectAll\"></md-checkbox></script><md-dialog-content><md-content layout-padding=\"\" class=\"lightBox Box-assign\"><h5 ng-show=\"MCSDC.isListAll!==0\">{{ \'FIELD.ALL_COURSE\' | translate}} :</h5><h5 ng-show=\"MCSDC.isListAll===0\">{{ \'FIELD.SPECIFIC\' | translate}}{{ \'FIELD.COURSE\' | translate}} :</h5><md-radio-group layout=\"row\" ng-model=\"MCSDC.isListAll\"><md-radio-button ng-value=\"1\" class=\"md-primary\" ng-click=\"MCSDC.reloadData()\">{{ \'FIELD.ALL\' | translate}}</md-radio-button><md-radio-button ng-value=\"0\" class=\"md-primary\" ng-click=\"MCSDC.reloadData()\">{{ \'FIELD.SPECIFIC\' | translate}}</md-radio-button></md-radio-group><div ng-show=\"MCSDC.isListAll===0\"><div class=\"chat-search\"><form class=\"form-inverse\" ng-submit=\"MCSDC.reloadData()\" role=\"search\"><div class=\"append-icon\"><input type=\"text\" ng-model=\"MCSDC.keyword\" class=\"form-control remove-close\" placeholder=\"{{ \'FIELD.SEARCH_COURSE_NAME\' | translate }}\"> <i class=\"icon-magnifier\"></i></div></form></div><div class=\"box-content md-course-search tb-Collapse\" ng-if=\"(MCSDC.id.selected | filter: { value: true }).length > 0\"><p>{{ \'FIELD.YOU_HAVE_SELECTED_COURSES\' | translate}}</p><div class=\"pt-assign\"><span ng-repeat=\"select in MCSDC.id.selected | filter: { value: true }\">{{select.courseName}}<md-icon md-font-set=\"md\" aria-label=\"Close dialog\" ng-click=\"MCSDC.checkboxSelect(select.id,false,select.name);\">close</md-icon></span></div></div><table ng-table=\"MCSDC.corsesTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'ACTIONS.SELECT_ALL\' | translate\" header=\"\'headerCheckbox.html\'\"><md-checkbox flex=\"\" class=\"md-primary checkbox\" ng-model=\"MCSDC.id.selected[row.activity.id].value\" ng-click=\"MCSDC.checkboxSelect(row.activity.id,MCSDC.id.selected[row.activity.id].value,row.activity.name);\"></md-checkbox></td><td data-title=\"\'FIELD.COURSE_NAME\' | translate\"><div class=\"text\">{{row.activity.name}}</div></td><td data-title=\"\'FIELD.TYPE\' | translate\"><div class=\"text\" ng-switch=\"row.activity.type\"><span ng-switch-when=\"1\">{{ \'FIELD.ONLINE_COURSE\' | translate}}</span> <span ng-switch-when=\"2\">{{ \'FIELD.CLASS_ROOM_COURSE\' | translate}}</span> <span ng-switch-when=\"3\">{{ \'FIELD.EXTERNAL_TRAINING\' | translate}}</span> <span ng-switch-when=\"4\">{{ \'FIELD.ONLINE_TEST\' | translate}}</span> <span ng-switch-when=\"5\">{{ \'FIELD.CLASS_ROOM_TEST\' | translate}}</span> <span ng-switch-when=\"6\">{{ \'FIELD.QUESTIONNAIRE\' | translate}}</span> <span ng-switch-default=\"\">{{row.activity.type}}</span></div></td><td data-title=\"\'FIELD.LEARNING_ACTIVITY_STATUS\' | translate\"><div class=\"text\" ng-if=\"row.activity.isPublished===true\">{{\'STATUS.PUBLISHED\' | translate}}</div></td></tr></table></div><h5>{{ \'FIELD.COURSE_DATE\' | translate }} :</h5><md-radio-group layout=\"row\" ng-model=\"MCSDC.isQueryAllDate\"><md-radio-button ng-value=\"1\" class=\"md-primary\">{{ \'FIELD.ALL\' | translate }}</md-radio-button><md-radio-button ng-value=\"0\" class=\"md-primary\">{{ \'FIELD.SPECIFIC\' | translate }}</md-radio-button></md-radio-group><div layout-gt-xs=\"row\" ng-show=\"MCSDC.isQueryAllDate===0\"><div flex-gt-xs=\"\"><md-datepicker ng-model=\"MCSDC.sDate\" md-placeholder=\"{{ \'FIELD.START_DATE\' | translate }}\" md-datepicker-focus-open=\"\" ng-disabled=\"MCSDC.isQueryAllDate===1\"></md-datepicker>To<md-datepicker ng-model=\"MCSDC.eDate\" md-placeholder=\"{{ \'FIELD.END_DATE\' | translate }}\" md-datepicker-focus-open=\"\" ng-disabled=\"MCSDC.isQueryAllDate===1\"></md-datepicker></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"MCSDC.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" ng-click=\"MCSDC.submit()\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/manager/views/member-curriculum.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"manager th-train\"><div class=\"th-title\"><h2>{{ \'MEMBER_CURRICULUM\' | translate}}</h2></div><div class=\"th-tab\"><div class=\"tab-content\"><div class=\"th-search\"><div class=\"th-filter\"><span ng-if=\"$ctrl.dataLength > 0\">{{ \'FIELD.COURSE_START_DATE\' | translate}}:</span> <span ng-if=\"$ctrl.dataLength > 0 && $ctrl.filters.isQueryAllDate===1\">{{ \'FIELD.ALL\' | translate}}</span> <span ng-if=\"$ctrl.dataLength > 0 && $ctrl.filters.isQueryAllDate===0\">{{$ctrl.filters.sDate}} ~ {{$ctrl.filters.eDate}}</span> <span ng-if=\"$ctrl.dataLength === 0\">{{ \'MESSAGE.MSG_CAN_NOT_FIND_THE_LATEST_INFORMATION\' | translate}}</span></div><div class=\"link\"><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.showPrompt($event)\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><div ng-show=\"$ctrl.dataLength > 0\"><table ng-table-dynamic=\"$ctrl.memberCurriculumTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></div></section></div></div>");
$templateCache.put("app/modules/manager/views/member-download-detail-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"70\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'FIELD.DOWNLOAD_COUNT_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"MDDDC.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><div class=\"lightBox Box-repeat\"><header><h3>{{MDDDC.courseName}}</h3></header><h5>{{\'FIELD.SESSION_NAME\' | translate}}: {{MDDDC.sessionName}}</h5><table class=\"tb-Collapse tb-check\"><thead><tr><th>{{\'FIELD.FULL_NAME\' | translate}}</th><th>{{\'FIELD.EMPLOYEE_NUMBER\' | translate}}</th><th>{{\'FIELD.DEPARTMENT\' | translate}}</th><th>{{\'FIELD.TYPE\' | translate}}</th><th>{{\'FIELD.DOCUMENT_TITLE\' | translate}}</th><th>{{\'FIELD.DOWNLOAD_TIME\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"downloadDetail in MDDDC.downloadDetails\"><td>{{downloadDetail.fullName}}</td><td>{{downloadDetail.employeeNumber}}</td><td>{{downloadDetail.joinGroupName}}</td><td ng-if=\"downloadDetail.isRef===0\">{{\'FIELD.COURSE_CONTENT\' | translate}}</td><td ng-if=\"downloadDetail.isRef===1\">{{\'FIELD.REFERENCE_DOCUMENT\' | translate}}</td><td>{{downloadDetail.fileTitle}}</td><td>{{downloadDetail.downloadDate}}</td></tr></tbody></table></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/manager/views/member-financial-cert-record-search.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/manager/views/member-suggest-learning-list.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'MEMBER_SUGGEST_LEARNING_LIST\' | translate}}</h2></div><div class=\"th-license\" ng-if=\"$ctrl.dataLength===0 || $ctrl.firstInto\"><div class=\"pt-noData\"><i class=\"ctms-icons icon-face-10\"></i></div><div flex-offset=\"25\" layout=\"row\" layout-wrap=\"\"><div flex=\"initial\"><p style=\"font-size:22px\">{{ \'FIELD.THERE_IS_NO_DATA\' | translate}}</p><p style=\"font-size:22px\">{{ \'FIELD.PLEASE_AT\' | translate}}「{{ \'ACTIONS.SEARCH\' | translate}}」 {{\'FIELD.SET_THE_CONDITIONS_CONDUCIVE_TO_SEARCH\' | translate}}</p></div><div flex=\"initial\" class=\"m-l-30\"><md-button class=\"md-primary md-raised\" suggest-learning-search-dialog=\"\" table=\"$ctrl.suggestLearningTable\" permission-type=\"manager\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div></div><div class=\"th-license\" ng-if=\"$ctrl.dataLength > 0\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" suggest-learning-search-dialog=\"\" table=\"$ctrl.suggestLearningTable\" permission-type=\"manager\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div><div class=\"th-staff\"><div class=\"el-person\"><avatar avatar-url=\"$ctrl.userInfo.userData.avatarUrl\" first-name=\"$ctrl.userInfo.userData.firstName\" line-height=\"60\" font-size=\"24\"></avatar></div><div class=\"link right\" add-suggest-learning-list=\"\" table=\"$ctrl.suggestLearningTable\" permission-type=\"manager\" user-id=\"$ctrl.userInfo.userData.uid\"><md-button class=\"md-primary md-raised\"><md-icon md-font-set=\"fa\" class=\"fa-plus\"></md-icon>{{ \'ACTIONS.ADD_MANAGER_SUGGEST_ITEM\' | translate}}</md-button></div><div class=\"md-staff\"><p class=\"name\">{{$ctrl.userInfo.userData.name}}</p><ul><li class=\"pt-blueG\"><i class=\"material-icons\">assignment_turned_in</i>{{ \'FIELD.PASSED_COUNT\' | translate}} :<strong>{{$ctrl.userInfo.pass}}</strong></li><li class=\"pt-red\"><i class=\"material-icons\">assignment_late</i>{{ \'STATUS.FAILED\' | translate}} :<strong>{{$ctrl.userInfo.fail}}</strong></li><li class=\"pt-blue\" ng-if=\"$ctrl.hasCurriculumPermission && $ctrl.hasCertificationInnerPermission\"><i class=\"fa fa-share-square-o\"></i> {{ \'FIELD.EXEMPTION_COUNT\' | translate}} :<strong>{{$ctrl.userInfo.exemption}}</strong></li><li>{{ \'FIELD.TOTAL\' | translate}} :<strong>{{($ctrl.userInfo.sum)}}</strong></li></ul></div></div></div><script type=\"text/ng-template\" id=\"headerCheckbox.html\"><md-checkbox flex class=\"md-primary checkbox\" ng-model=\"$ctrl.enrollmentId.selectAll\"></md-checkbox></script><script type=\"text/ng-template\" id=\"enrollTypeHeader.html\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\" class=\"sort-indicator\"> {{ \'FIELD.ENROLL_TYPE\' | translate }}<br>({{ \'FIELD.SPECIFY_APPLICANT\' | translate}}) </span></script><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.suggestLearningTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div><div class=\"link\" ng-if=\"$ctrl.dataLength > 0\"><md-button class=\"md-raised md-primary md-btn\" update-estimated-completion-date=\"\" table=\"$ctrl.suggestLearningTable\" enrollment-id-list=\"$ctrl.enrollmentId.selected\" permission-type=\"manager\">{{ \'ACTIONS.UPDATE_ESTIMATED_COMPLETION_DATE\' | translate}}</md-button><md-button class=\"md-raised md-warn md-btn\" delete-suggest-learning-list=\"\" table=\"$ctrl.suggestLearningTable\" enrollment-id-list=\"$ctrl.enrollmentId.selected\" permission-type=\"manager\"><md-icon md-font-set=\"fa\" class=\"fa-trash-o\"></md-icon>{{ \'ACTIONS.DELETE\' | translate}}</md-button></div></section></div></div>");
$templateCache.put("app/modules/manager/views/member-training-records-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"25\"><form ng-submit=\"MTRSDC.submit(MTRSDC.filters)\" name=\"validForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"MTRSDC.close()()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><md-input-container md-no-float=\"\" class=\"md-block\"><label>{{ \'FIELD.KEYWORD\' | translate}}</label> <input ng-model=\"MTRSDC.filters.keyword\" placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.DEPARTMENT_NAME\' | translate}}</label><md-select ng-model=\"MTRSDC.filters.groupId\"><md-option ng-repeat=\"group in MTRSDC.groups\" ng-value=\"group.groupId\">{{group.groupName}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.DEPARTMENT_MEMBER\' | translate}}</label><md-select ng-model=\"MTRSDC.filters.memberId\" name=\"memberId\" required=\"\"><md-option ng-repeat=\"groupMember in MTRSDC.groupMembers | filterBy: [\'groupId\']: MTRSDC.filters.groupId :true\" ng-value=\"groupMember.userId\">{{groupMember.fullName}}</md-option></md-select><div class=\"errors\" ng-messages=\"validForm.memberId.$error\"><div ng-message=\"required\">{{ \'MESSAGE.MSG_PLEASE_SELECT_DEPARTMENT_MEMBER\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.LEARNING_ACTIVITY\' | translate}}</label><md-select ng-model=\"MTRSDC.filters.cpType\"><md-option ng-value=\"1\">{{ \'FIELD.LEARNING_ACTIVITY\' | translate}},{{ \'FIELD.COURSE_FOLDER_TEST\' | translate}},{{ \'FIELD.COURSE_FOLDER_SURVEY\' | translate}}</md-option><md-option ng-value=\"2\" ng-if=\"MTRSDC.hasCurriculumPermission && MTRSDC.hasCertificationInnerPermission\">{{ \'FIELD.PROGRAM\' | translate}},{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</md-option><md-option ng-value=\"2\" ng-if=\"MTRSDC.hasCurriculumPermission && !MTRSDC.hasCertificationInnerPermission\">{{ \'FIELD.PROGRAM\' | translate}}</md-option><md-option ng-value=\"2\" ng-if=\"!MTRSDC.hasCurriculumPermission && MTRSDC.hasCertificationInnerPermission\">{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.PASS_STATUS\' | translate}}</label><md-select ng-model=\"MTRSDC.filters.passResult\"><md-option value=\"-1\">{{ \'FIELD.ALL\' | translate}}</md-option><md-option value=\"0\">N/A</md-option><md-option value=\"1\" ng-if=\"MTRSDC.hasCurriculumPermission && MTRSDC.hasCertificationInnerPermission\">{{ \'STATUS.EXEMPTION\' | translate}}</md-option><md-option value=\"2\">{{ \'STATUS.PASSED\' | translate}}</md-option><md-option value=\"3\">{{ \'STATUS.FAILED\' | translate}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.PROPERTIES\' | translate}}</label><md-select ng-model=\"MTRSDC.filters.learnerType\"><md-option value=\"-1\">{{ \'FIELD.ALL\' | translate}}</md-option><md-option value=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</md-option><md-option value=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</md-option></md-select></md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"MTRSDC.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/reports/views/learning-reports-menu.html","<script type=\"text/ng-template\" id=\"reports_nodes_renderer.html\"><a href=\"javascript:void(0);\" ng-if=\"node.nodes.length > 0\" aria-expanded=\"false\"> <i class=\"fa fa-fw fa-folder-o\"></i> <span>{{node.title}}</span> </a> <a ui-sref=\"reportsZone({id:node.id, url:node.url})\" ui-sref-opts=\"{reload:false}\" ng-if=\"node.nodes.length === 0\" aria-expanded=\"false\"> <span class=\"fa fa-fw fa-file\"></span> <span>{{node.title}}</span> </a> <ul naria-expanded=\"false\" ng-metis class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-if=\"node.nodes.length > 0\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'reports_nodes_renderer.html\'\"></li> </ul></script><ul class=\"nav nav-sidebar metismenu\"><li ng-if=\"$ctrl.previousMenu\"><a ui-sref=\"{{$ctrl.previousMenu.model[\'state\']}}({mid: $ctrl.previousMenu.model[\'stateParams\'][\'mid\']})\" ui-sref-opts=\"{reload:true}\"><i class=\"icon-home\"></i><span>{{\'ACTIONS.RETURN\' | translate}}{{ $ctrl.previousMenu.model[\'title\'] }}</span></a></li><li ng-metis=\"\" mobile-sidebar=\"\" class=\"metismenu-parent active\" ui-tree=\"\" ng-click=\"$ctrl.initScrollBar()\" ng-if=\"$ctrl.mainMenu\"><a ui-sref=\"reportsZone({cid: $ctrl.mainMenu.stateParams[\'cid\'], nid: undefined})\" ng-if=\"$ctrl.menu.length === 0\"><i class=\"icon icons-education-science-18\"></i> <span>{{ $ctrl.mainMenu.title }}</span></a> <a ui-sref=\"reportsZone({cid: $ctrl.mainMenu.stateParams[\'cid\'], nid: undefined})\" ng-if=\"$ctrl.menu.length > 0\"><i class=\"icon icons-education-science-18\"></i> <span>{{ $ctrl.mainMenu.title }}</span> <span class=\"fa fa-fw arrow\"></span></a><ul class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"$ctrl.menu\" id=\"reports-tree-root\"><li ng-metis=\"\" ng-repeat=\"node in $ctrl.menu\" ui-tree-node=\"\" ng-click=\"treeNode.toggle(this)\" ng-include=\"\'reports_nodes_renderer.html\'\"></li></ul></li></ul>");
$templateCache.put("app/modules/reports/views/learning-reports.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/sitemap/views/sidebar.html","<script type=\"text/ng-template\" id=\"sidebar_renderer.html\"><a ui-sref=\"{{node.state}}({{node.stateParams}})\" ng-if=\"node._children && node._children.length > 0\" aria-expanded=\"false\"> <i class=\"fa {{ node.icon}}\"></i> <span>{{ node.title | translate}}</span> <span class=\"fa arrow\"></span> </a> <a ui-sref=\"{{node.state}}({{node.stateParams}})\" ui-sref-opts=\"{reload: true}\" ng-if=\"!node._children || node._children.length === 0\" aria-expanded=\"false\"> <i class=\"fa {{ node.icon}}\"></i> <span>{{ node.title | translate}}</span> </a> <ul naria-expanded=\"false\" class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"node._children\"> <li ng-metis ng-repeat=\"node in ::node._children\" permission permission-only=\"node.permissions\" permission-all=\"node.permissionsAll\" ui-tree-node ng-include=\"\'sidebar_renderer.html\'\"> </li> </ul></script><div class=\"sidebar\" theme-sidebar-handle=\"\"><div class=\"logopanel\"><h1><a href=\"#/\"><img ng-src=\"{{$ctrl.logoUrl}}\" load-image-resize=\"\" set-width=\"220\" set-height=\"30\"></a></h1></div><div class=\"sidebar-inner\" ng-scrollbars=\"\" ng-scrollbars-config=\"$ctrl.scrollBarConfig\" ng-scrollbars-update=\"$ctrl.updateScrollbar\"><div class=\"menu-title\"></div><ul class=\"nav nav-sidebar metismenu\" ng-if=\"!$ctrl.$state.includes(\'reportsZone\') && !$ctrl.$state.includes(\'knowledgeDocumentCatalog.*\') && !$ctrl.$state.includes(\'courseResourceCatalog.*\') && !$ctrl.$state.includes(\'courseResourceCatalog.*.*\')\"><li ng-metis=\"\" ui-tree=\"\" ng-repeat=\"item in ::$ctrl.menuItems\" ng-class=\"{\'active\': $ctrl.checkMenu(item), \'metismenu-parent\':item._children && item._children.length > 0}\" permission=\"\" permission-only=\"item.permissions\" permission-all=\"item.permissionsAll\"><a ui-sref=\"{{item.state}}({{item.stateParams}})\" ui-sref-opts=\"{reload:true}\" ng-if=\"::!item._children || (item._children && item._children.length === 0)\"><i class=\"fa fa-fw {{ ::item.icon}}\"></i> <span>{{ item.title | translate}}</span></a> <a ng-if=\"::item._children && item._children.length > 0 && item.isMenu\"><i class=\"fa fa-fw {{ ::item.icon}}\"></i> <span ng-if=\"(item.stateParams && item.stateParams[\'url\'] && item.stateParams[\'url\'].length > 0)\" ui-sref=\"{{item.state}}({{item.stateParams}})\" ui-sref-opts=\"{reload:true, inherit: false}\">{{ item.title | translate}}</span> <span ng-if=\"!(item.stateParams && item.stateParams[\'url\'] && item.stateParams[\'url\'].length > 0)\">{{ item.title | translate}}</span> <span class=\"fa fa-fw arrow\"></span></a><ul class=\"children collapse\" ui-tree-nodes=\"\" ng-if=\"::item._children && item._children.length > 0 && item.isMenu\" ng-class=\"{\'in\': $ctrl.checkMenu(item)}\" ng-model=\"item._children\" id=\"sidebar-tree-root\"><li ng-metis=\"\" ng-repeat=\"node in item._children\" permission=\"\" permission-only=\"node.permissions\" permission-all=\"node.permissionsAll\" ui-tree-node=\"\" ng-include=\"\'sidebar_renderer.html\'\"></li></ul></li></ul><div ui-tree=\"\" ng-if=\"$ctrl.$state.includes(\'courseResourceCatalog.*\') || $ctrl.$state.includes(\'courseResourceCatalog.*.*\')\"><course-learning-resource-menu catalog-id=\"$ctrl.$stateParams[\'cid\']\"></course-learning-resource-menu></div><div ui-tree=\"\" ng-if=\"$ctrl.$state.includes(\'knowledgeDocumentCatalog.*\')\"><knowledge-document-menu catalog-id=\"$ctrl.$stateParams[\'cid\']\"></knowledge-document-menu></div><div ui-tree=\"\" ng-if=\"$ctrl.$state.includes(\'reportsZone\')\" ng-controller=\"ReportsMenuController as rmc\"><learning-reports-menu></learning-reports-menu></div></div></div>");
$templateCache.put("app/modules/static-page/views/static-page.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0 && $ctrl.url!== \'null\'\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/system/views/system-info.html","<div class=\"wp-login\" xmlns=\"http://www.w3.org/1999/html\"><header><h1><a href=\"#\"><img ng-src=\"{{::( \'sun-logo\' | sunnetPicture:\'png\' )}}\" alt=\"\"></a></h1><div class=\"th-info\"><div class=\"time\"><ds-widget-clock data-show-digital=\"\" only-text=\"true\"></ds-widget-clock></div></div></header><div style=\"padding: 30px 20px; box-sizing: border-box; background: rgba(255, 255, 255, 0.8); position: relative; z-index: 10;\"><div class=\"account-info\"><h4>Build_Info</h4><div class=\"lightBox\"><div class=\"box-content\" style=\"background: none;\"><table><tbody><tr ng-repeat=\"(key, info) in $ctrl.systemInfos\"><th style=\"width: 150px;\">{{key}} :</th><td style=\"min-width: 150px;\">{{info}}</td></tr></tbody></table></div></div></div></div><footer class=\"th-copyRight\"><p><strong>Copyright</strong> Sunnet eHRD © 2016</p></footer></div>");
$templateCache.put("app/modules/training/views/training-plan.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\" ng-if=\"$ctrl.url.length > 0\"><div class=\"panel\" style=\"height: 100vh;\"><div class=\"panel-content\" style=\"height: 100vh;\"><iframe width=\"100%\" frameborder=\"0\" style=\"border: none; padding: 0; margin: 0;height: 95vh;;\" ng-src=\"{{$ctrl.url | trustAsResourceUrl}}\"></iframe></div></div></div></div></div></div>");
$templateCache.put("app/modules/training-road-map/views/training-road-map.html","<section class=\"blueprint\"><div class=\"th-title\"><h2>{{ \'TRAINING_ROAD_MAP\' | translate}}</h2></div><div class=\"th-blueprint\"><div class=\"th-search\"><div class=\"pt-select\"><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><div flex=\"25\" class=\"f-14 w-700 c-black t-right\">{{ \'PLACEHOLDERS.PLEASE_SELECT_TRAINING_BLUEPRINT\' | translate}} :</div><md-select ng-model=\"$ctrl.trainingRoadMapId\"><md-option ng-repeat=\"data in $ctrl.trainingRoadMapList\" ng-value=\"data.trainingRoadmapId\">{{data.trainingRoadmapName}} <span ng-if=\"data.isInvolved===true && data.isMyTraining!==true\">({{ \'FIELD.RELATED_TO_ME\' | translate}})</span> <span ng-if=\"data.isMyTraining===true\">({{ \'FIELD.MY_TRAINING\' | translate}})</span></md-option></md-select></div></div></div><div class=\"th-subject\"><h5>{{$ctrl.trainingRoadMapInfo.trainingRoadmapName}}</h5></div><div class=\"nav-tab\"><ul><li ng-repeat=\"data in $ctrl.titleGroups\" ng-class=\"{\'active\':$ctrl.selectZone === \'zone-\' + $index, \'on\':$ctrl.userCurrentCondition.titleGroupId===data.titleGroupId}\"><a href=\"javascript:void(0)\" ng-click=\"$ctrl.clickZone(\'zone-\' + $index)\" class=\"href-underline\"><i class=\"icon icons-faces-users-03\" ng-if=\"$ctrl.userCurrentCondition.titleGroupId===data.titleGroupId\"></i> <span ng-if=\"data.titleGroupName!==\'all\'\">{{data.titleGroupName}}</span> <span ng-if=\"data.titleGroupName===\'all\'\">{{ \'FIELD.ALL_STAFF\' | translate}}</span></a></li></ul></div><div class=\"md-blueprint\" ng-repeat=\"titleGroups in $ctrl.titleGroups\"><a id=\"{{\'zone-\' + $index}}\" class=\"pt-anchor\"></a><div class=\"pt-blueprint\"><div class=\"left\" ng-class=\"{\'on\':$ctrl.userCurrentCondition.titleGroupId===titleGroups.titleGroupId}\"><i class=\"icon icons-faces-users-03\" ng-if=\"$ctrl.userCurrentCondition.titleGroupId===titleGroups.titleGroupId\"></i> <span ng-if=\"titleGroups.titleGroupName!==\'all\'\">{{titleGroups.titleGroupName}}</span> <span ng-if=\"titleGroups.titleGroupName===\'all\'\">{{ \'FIELD.ALL_STAFF\' | translate }}</span></div><div class=\"right\"><div class=\"th-interval\" ng-repeat=\"timeSpans in titleGroups.timeSpans\"><header><span ng-if=\"timeSpans.beginYear===-2 && timeSpans.beginMonth===-2 && timeSpans.endYear===-2 && timeSpans.endMonth===-2\">{{ \'FIELD.ANY_TIME_ZONE\' | translate}}</span> <span ng-if=\"$ctrl.trainingRoadMapInfo.isByOnboard===true && timeSpans.beginYear!==-2\">{{ \'FIELD.DUTY\' | translate}}</span> <span ng-if=\"$ctrl.trainingRoadMapInfo.isByOnboard===false && timeSpans.beginYear!==-2\">{{ \'FIELD.INDUCTION\' | translate}}</span> <span ng-if=\"timeSpans.beginYear > 0 || timeSpans.beginMonth > 0\">{{ \'FIELD.EXPIRED\' | translate}} <span ng-if=\"timeSpans.beginYear > 0\">{{timeSpans.beginYear}} {{ \'FIELD.YEAR\' | translate}}</span> <span ng-if=\"timeSpans.beginMonth > 0\">{{timeSpans.beginMonth}} {{ \'FIELD.A_MONTH\' | translate}}</span> <span>~</span></span> <span ng-if=\"timeSpans.endYear > 0 || timeSpans.endMonth > 0\">{{ \'FIELD.UNEXPIRED\' | translate}} <span ng-if=\"timeSpans.endYear > 0\">{{timeSpans.endYear}} {{ \'FIELD.YEAR\' | translate}}</span> <span ng-if=\"timeSpans.endMonth > 0\">{{timeSpans.endMonth}} {{ \'FIELD.A_MONTH\' | translate}}</span></span></header><div class=\"pt-interval\" ng-class=\"{\'on\':$ctrl.userCurrentCondition.titleGroupId===titleGroups.titleGroupId}\"><ul><li ng-repeat=\"activities in timeSpans.activities\"><a href=\"javascript:void(0)\" course-id=\"activities.activityId\" ng-if=\"activities.activityType!==64 && activities.activityType!==128\" ng-click=\"$ctrl.goToCourse(activities)\"><ng-switch on=\"activities.activityType\"><span class=\"elearn tag\" title=\"{{ \'FIELD.ONLINE_COURSE\' | translate }}\" ng-switch-when=\"1\"><i class=\"icon icon-globe\"></i></span> <span class=\"room tag\" title=\"{{ \'FIELD.CLASS_ROOM_COURSE\' | translate }}\" ng-switch-when=\"2\"><i class=\"material-icons mdi-social-school\">school</i></span> <span class=\"train tag\" title=\"{{ \'FIELD.EXTERNAL_TRAINING\' | translate }}{{ \'FIELD.COURSE\' | translate }}\" ng-switch-when=\"4\"><i class=\"material-icons mdi-action-perm-camera-mic\">perm_camera_mic</i></span> <span class=\"test-e tag\" title=\"{{ \'FIELD.ONLINE_TEST\' | translate }}\" ng-switch-when=\"8\"><i class=\"fa fa-pencil\"></i></span> <span class=\"test tag\" title=\"{{ \'FIELD.CLASS_ROOM_TEST\' | translate }}\" ng-switch-when=\"16\"><i class=\"fa fa-pencil\"></i></span></ng-switch>{{activities.activityName}} <span class=\"pass\" ng-if=\"activities.enrollResult===2\"><i class=\"fa fa-check-circle\"></i></span></a> <a href=\"javascript:void(0)\" program-id=\"activities.activityId\" ng-if=\"activities.activityType===64 || activities.activityType===128\" ng-click=\"$ctrl.goToCourse(activities)\"><ng-switch on=\"activities.activityType\"><span class=\"package tag\" title=\"{{ \'FIELD.PROGRAM\' | translate }}\" ng-switch-when=\"64\"><i class=\"material-icons mdi-file-folder-shared\">folder_shared</i></span> <span class=\"package tag\" title=\"{{ \'FIELD.INTERNAL_LICENSE\' | translate }}\" ng-switch-when=\"128\"><i class=\"material-icons mdi-action-assignment-ind\">assignment_ind</i></span></ng-switch>{{activities.activityName}} <span class=\"pass\" ng-if=\"activities.enrollResult===2\"><i class=\"fa fa-check-circle\"></i></span></a></li></ul></div></div></div></div></div></div></section>");
$templateCache.put("app/modules/user/views/add-suggest-learning-list.html","<script type=\"text/ng-template\" id=\"addSuggestLearningList.html\"><div ng-transclude></div></script><script type=\"text/ng-template\" id=\"add-suggest-learning-list-step.html\"><div ng-show=\"selected\" ng-transclude></div></script><script type=\"text/ng-template\" id=\"headerCheckbox.html\"><md-checkbox flex class=\"md-primary checkbox\" ng-model=\"$ctrl.selectAll\"></md-checkbox></script><md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\" ng-style=\"$ctrl.dialogFullScreen\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"$ctrl.permissionType===\'manager\'\">{{ \'ACTIONS.ADD_MANAGER_SUGGEST_ITEM\' | translate }}</h2><h2 ng-if=\"$ctrl.permissionType!==\'manager\'\">{{ \'ACTIONS.ADD_PERSONAL_ELECTIVE_ITEM\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><wizard name=\"suggestLearning\" on-finish=\"$ctrl.addSuggestLearning()\" template=\"addSuggestLearningList.html\"><wz-step template=\"add-suggest-learning-list-step.html\" wz-title=\"\" canexit=\"$ctrl.addItemPage\" canenter=\"$ctrl.chooseItemPage\"><md-content layout-padding=\"\"><div class=\"lightBox Box-assign\"><div layout=\"row\" flex=\"\"><h4 class=\"el-header\">{{ \'FIELD.OTHER_NEED\' | translate}}</h4></div><md-input-container class=\"md-block\"><label>{{ \'FIELD.APPELLATION\' | translate}}</label> <input ng-model=\"$ctrl.other.itemName\" placeholder=\"\"></md-input-container><md-input-container class=\"md-block\"><label>{{ \'FIELD.DESCRIPTION\' | translate}}</label> <textarea ng-model=\"$ctrl.other.otherDescription\" rows=\"1\" md-detect-hidden=\"\"></textarea><div layout=\"row\" layout-align=\"end end\"><md-button class=\"md-raised md-warn md-btn btn-transparent\" type=\"button\" ng-click=\"$ctrl.clearOther()\" \"=\"\" ng-if=\"$ctrl.other.update===1\"><span>{{ \'ACTIONS.CANCEL\' | translate}}</span></md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.addOther($ctrl.other)\" ng-disabled=\"$ctrl.other.itemName===\'\'\"><span ng-if=\"$ctrl.other.update===0\">{{ \'ACTIONS.ENTER\' | translate}}</span> <span ng-if=\"$ctrl.other.update===1\">{{ \'ACTIONS.UPDATE\' | translate}}</span></md-button></div></md-input-container><div class=\"box-content md-course-search tb-Collapse\" ng-if=\"$ctrl.chooseList.other.length > 0\"><p>{{ \'FIELD.YOU_HAVE_ADD_OTHER_REQUIREMENTS\' | translate}}</p><div class=\"pt-assign\"><span ng-repeat=\"other in $ctrl.chooseList.other track by $index\"><a href=\"javascript:void(0)\" ng-click=\"$ctrl.getOther($index)\">{{other.itemName}}</a><md-icon md-font-set=\"md\" aria-label=\"Close dialog\" ng-click=\"$ctrl.removeOther($index)\">close</md-icon></span></div></div><course-search choose-course=\"$ctrl.chooseList\"></course-search></div></md-content></wz-step><wz-step template=\"add-suggest-learning-list-step.html\" wz-title=\"\"><div class=\"lightBox Box-leave\"><table ng-table=\"$ctrl.tempItemsTable\" class=\"animate tb-Collapse\"><colgroup><col width=\"1%\"><col width=\"10%\"><col width=\"7%\"><col width=\"18%\"><col width=\"15%\"></colgroup><tr ng-repeat=\"row in $data track by $index\"><td header=\"\'headerCheckbox.html\'\" header-class=\"\'appear\'\" class=\"appear\"><md-checkbox ng-if=\"row.itemType===99\" ng-model=\"$ctrl.chooseList.other[$index].checkValue\" flex=\"\" class=\"md-primary checkbox\" ng-disabled=\"row.disabled===1\"></md-checkbox><md-checkbox ng-if=\"row.itemType!==99\" ng-model=\"$ctrl.temp[row.itemType + \'_\' + row.itemId].checkValue\" flex=\"\" class=\"md-primary checkbox\" ng-disabled=\"row.disabled===1\"></md-checkbox></td><td data-title=\"\'FIELD.TYPE\' | translate\"><div class=\"text\">{{row.itemTypeName}}</div></td><td data-title=\"\'FIELD.NAME\' | translate\"><div class=\"text\">{{row.itemName}}</div></td><td data-title=\"\'FIELD.STATUS\' | translate\"><div class=\"text\">{{row.status}}</div></td><td data-title=\"\'FIELD.ESTIMATED_COMPLETION_DATE\' | translate\"><md-datepicker ng-if=\"row.itemType===99\" ng-model=\"$ctrl.chooseList.other[$index].predictDueDate\" md-datepicker-focus-open=\"\" ng-disabled=\"row.disabled===1\"></md-datepicker><md-datepicker ng-if=\"row.itemType!==99\" ng-model=\"$ctrl.temp[row.itemType + \'_\' + row.itemId].predictDueDate\" md-datepicker-focus-open=\"\" ng-disabled=\"row.disabled===1\"></md-datepicker></td></tr></table></div></wz-step></wizard></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.nextStep()\" ng-if=\"$ctrl.wzBtn.next\">{{ \'ACTIONS.NEXT_STEP\' | translate}}<md-icon md-font-set=\"md\">keyboard_arrow_right</md-icon></md-button><md-button class=\"md-raised md-warn md-btn btn-transparent\" type=\"button\" ng-click=\"$ctrl.previousStep()\" ng-if=\"$ctrl.wzBtn.previous\"><md-icon md-font-set=\"md\">keyboard_arrow_left</md-icon>{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.finishStep()\" ng-if=\"$ctrl.wzBtn.finish\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/user/views/deputy-record-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"50\"><form ng-submit=\"$ctrl.submit($ctrl.form)\" name=\"validForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SETTING_DEPUTY\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><div class=\"lightBox Box-leave\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.DEPUTY_DEPARTMENT\' | translate}}</label><md-select ng-model=\"$ctrl.form.groupId\"><md-option ng-value=\"-1\">{{ \'FIELD.ALL_DEPARTMENT\' | translate }}</md-option><md-option ng-repeat=\"managedGroup in $ctrl.managedGroups\" ng-value=\"managedGroup.groupId\">{{managedGroup.groupName}}</md-option></md-select></md-input-container>{{ \'FIELD.DEPUTY_EFFECTIVE_DATE\' | translate}}<div flex-gt-xs=\"\"><md-datepicker ng-model=\"$ctrl.form.deputyFrom\" md-placeholder=\"{{ \'FIELD.START_DATE\' | translate }}\" md-datepicker-focus-open=\"\"></md-datepicker><div class=\"pt-select\"><select-date type=\"hours\" ng-model=\"$ctrl.deputyFromHH\" max=\"23\" default-value=\"$ctrl.deputyFromHH\"></select-date><span>:</span><select-date type=\"minute\" ng-model=\"$ctrl.deputyFromMM\" default-value=\"$ctrl.deputyFromMM\"></select-date></div></div>{{ \'FIELD.DEPUTY_END_DATE\' | translate}}<div flex-gt-xs=\"\"><md-datepicker ng-model=\"$ctrl.form.deputyTo\" md-placeholder=\"{{ \'FIELD.END_DATE\' | translate }}\" md-datepicker-focus-open=\"\"></md-datepicker><div class=\"pt-select\"><select-date type=\"hours\" ng-model=\"$ctrl.deputyToHH\" max=\"23\" default-value=\"$ctrl.deputyToHH\"></select-date><span>:</span><select-date type=\"minute\" ng-model=\"$ctrl.deputyToMM\" default-value=\"$ctrl.deputyToMM\"></select-date></div></div><div flex-gt-xs=\"\">{{ \'FIELD.DEPUTY\' | translate}}&nbsp&nbsp {{$ctrl.agentFullName}}</div><div class=\"chat-search\"><div class=\"append-icon\"><input type=\"text\" ng-model=\"$ctrl.keyword\" class=\"form-control\" placeholder=\"{{ \'FIELD.SEARCH_DEPUTY\' | translate }}\"> <i class=\"icon-magnifier\"></i></div></div><div ng-show=\"$ctrl.keyword!==\'\'\"><table ng-table=\"$ctrl.agentTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'ACTIONS.SELECT\' | translate\"><md-radio-group ng-model=\"$ctrl.form.agentId\"><md-radio-button class=\"md-primary radio\" ng-value=\"row.userId\" ng-click=\"$ctrl.getAgentFullName(row.fullName)\"></md-radio-button></md-radio-group></td><td data-title=\"\'FIELD.EMPLOYEE_NUMBER\' | translate\"><div class=\"text\">{{row.account}}</div></td><td data-title=\"\'FIELD.FULL_NAME\' | translate\"><div class=\"text\">{{row.fullName}}</div></td><td data-title=\"\'FIELD.DEPARTMENT_NAME\' | translate\">{{row.joinGroupName}}</td></tr></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/user/views/incomplete-courses.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList th-waitCourse\"><div class=\"th-title\"><h2>{{ \'INCOMPLETE_COURSES\' | translate}}</h2></div><div class=\"th-wait\"><ul><li class=\"all active\" permission=\"\" permission-only=\"[\'Modules.course.online\', \'Modules.course.classroom\', \'Modules.course.external\', \'Modules.curriculum\', \'Modules.certification.inner\']\" ng-if=\"$ctrl.hasCourseOnlinePermission && ($ctrl.hasCourseClassroomPermission || $ctrl.hasCourseExternalPermission || $ctrl.hasCurriculumPermission || $ctrl.hasCertificationInnerPermission)\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === $ctrl.defaultFilterType) && ($ctrl.pagination.filter.filterValue === $ctrl.defaultFilterValue)}\"><a href=\"\" ng-click=\"$ctrl.dataFilter()\"><div class=\"tag\"><i>ALL</i><p class=\"p-marigin-negative-value-top\">{{ \'FIELD.ALL_COURSE\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.sum}}\" value=\"0\" duration=\"0.5\">{{$ctrl.courseCount.sum}}</span></a></li><li class=\"room\" permission=\"\" permission-only=\"[\'Modules.course.classroom\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === \'2\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'courseType\', 2)\"><div class=\"tag\"><i class=\"material-icons\">school</i><p>{{ \'FIELD.CLASS_ROOM_COURSE\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.classRoom}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.classRoom}}</span></a></li><li class=\"elearn\" permission=\"\" permission-only=\"[\'Modules.course.online\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === \'1\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'courseType\', 1)\"><div class=\"tag\"><i class=\"icon icon-globe\"></i><p class=\"p-marigin-negative-value-top\">{{ \'FIELD.ONLINE_COURSE\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.online}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.online}}</span></a></li><li class=\"package\" permission=\"\" permission-only=\"[\'Modules.curriculum\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'programType\') && ($ctrl.pagination.filter.filterValue === \'0\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'programType\', 0)\"><div class=\"tag\"><i class=\"material-icons\">folder_shared</i><p>{{ \'FIELD.PROGRAM\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.program}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.program}}</span></a></li><li class=\"train\" permission=\"\" permission-only=\"[\'Modules.course.external\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === \'3\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'courseType\', 3)\"><div class=\"tag\"><i class=\"material-icons\">perm_camera_mic</i><p>{{ \'FIELD.EXTERNAL_TRAINING\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.external}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.external}}</span></a></li><li class=\"licenses\" permission=\"\" permission-only=\"[\'Modules.certification.inner\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'programType\') && ($ctrl.pagination.filter.filterValue === \'1\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'programType\', 1)\"><div class=\"tag\"><i class=\"material-icons\">assignment_ind</i><p>{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.innercert}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.innercert}}</span></a></li></ul></div><header><ui-pagination-header-controls pagination-id=\"incompleteCourses\" pagination-filter=\"$ctrl.pagination.filter\" pagination-sort=\"$ctrl.pagination.sort\" sorts=\"[ {key : \'ExpireEnd\', name:\'FIELD.COURSE_DEADLINE\'}, {key : \'EnrolledDate\', name: \'FIELD.ENROLLMENT_DATE\', order: \'DESC\'}, {key : \'LearnerType\', name: \'FIELD.PROPERTIES\'}, {key : \'IsMyFavorite\', name: \'FIELD.MY_FAVOURITE\'} ]\" reload-pagination-data=\"$ctrl.getData(params)\" has-search-box=\"false\"></ui-pagination-header-controls></header><div class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"incompleteCoursesData in $ctrl.incompleteCoursesDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" filter-option=\"$ctrl.pagination.filters\" pagination-id=\"incompleteCourses\" ng-class=\"{1:\'elearn\', 2:\'room\', 3:\'train\', 0:{0:\'package\', 1:\'licenses\'}[incompleteCoursesData.programType]}[incompleteCoursesData.courseType]\"><incomplete-info-list-card course-data=\"incompleteCoursesData\" reload-fn=\"$ctrl.getData($ctrl.params)\"></incomplete-info-list-card></div></div></div><footer><ui-pagination-controls on-page-change=\"$ctrl.getData(params)\" pagination-id=\"incompleteCourses\"></ui-pagination-controls></footer></section></div></div>");
$templateCache.put("app/modules/user/views/incomplete-test-surveys.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList th-waitCourse\"><div class=\"th-title\"><h2>{{ \'TEST_QUESTIONNAIRE_CENTER\' | translate}}</h2></div><div class=\"th-wait\"><ul><li class=\"all\" permission=\"\" permission-only=\"[\'Modules.course.onlinetest\', \'Modules.course.classroomtest\', \'Modules.course.survey\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === $ctrl.defaultFilterValue)}\"><a href=\"\" ng-click=\"$ctrl.dataFilter()\"><div class=\"tag\"><i>ALL</i><p class=\"p-marigin-negative-value-top\">{{ \'FIELD.TEST_QUESTIONNAIRE\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.sum}}\" value=\"0\" duration=\"0.5\">{{$ctrl.courseCount.sum}}</span></a></li><li class=\"test-e\" permission=\"\" permission-only=\"[\'Modules.course.onlinetest\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === \'4\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'courseType\', 4)\"><div class=\"tag\"><i class=\"fa fa-pencil\"></i><p class=\"p-marigin-negative-value-top\">{{ \'FIELD.ONLINE_TEST\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.onlineTest}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.onlineTest}}</span></a></li><li class=\"test\" permission=\"\" permission-only=\"[\'Modules.course.classroomtest\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === \'5\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'courseType\', 5)\"><div class=\"tag\"><i class=\"fa fa-pencil\"></i><p class=\"p-marigin-negative-value-top\">{{ \'FIELD.CLASS_ROOM_TEST\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.classRoomTest}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.classRoomTest}}</span></a></li><li class=\"package\" permission=\"\" permission-only=\"[\'Modules.course.survey\']\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === \'6\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'courseType\', 6)\"><div class=\"tag\"><i class=\"fa fa-file-text\"></i><p class=\"p-marigin-negative-value-top\">{{ \'FIELD.QUESTIONNAIRE\' | translate}}</p></div><span count-to=\"{{$ctrl.courseCount.survey}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.survey}}</span></a></li><li class=\"train\" ng-class=\"{\'active\': ($ctrl.pagination.filter.filterKey === \'courseType\') && ($ctrl.pagination.filter.filterValue === \'9\')}\"><a href=\"\" ng-click=\"$ctrl.dataFilter(\'courseType\', 9)\"><div class=\"tag\"><i class=\"fa fa-file-text\"></i><p class=\"p-marigin-negative-value-top\">{{ \'FIELD.TRACK_QUESTIONNAIRE\' |translate }}</p></div><span count-to=\"{{$ctrl.courseCount.evaluationSurvey}}\" value=\"0\" duration=\"0.1\">{{$ctrl.courseCount.evaluationSurvey}}</span></a></li></ul></div><header><ui-pagination-header-controls pagination-id=\"incompleteCourses\" pagination-sort=\"$ctrl.pagination.sort\" pagination-filter=\"$ctrl.pagination.filter\" sorts=\"[ {key : \'ExpireEnd\', name:\'FIELD.COURSE_DEADLINE\'}, {key : \'LearnerType\', name:\'FIELD.PROPERTIES\'}]\" reload-pagination-data=\"$ctrl.getData(params)\" has-search-box=\"false\"></ui-pagination-header-controls></header><div class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"incompleteCoursesData in $ctrl.incompleteCoursesDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" filter-option=\"$ctrl.pagination.filters\" pagination-id=\"incompleteCourses\" ng-class=\"{4:\'test-e\', 5:\'test\', 6:\'package\', 9:\'train\'}[incompleteCoursesData.courseType]\"><incomplete-info-list-card course-data=\"incompleteCoursesData\" reload-fn=\"$ctrl.getData($ctrl.params)\"></incomplete-info-list-card></div></div></div><footer><ui-pagination-controls on-page-change=\"$ctrl.getData(params)\" pagination-id=\"incompleteCourses\"></ui-pagination-controls></footer></section></div></div>");
$templateCache.put("app/modules/user/views/my-calendar.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"calendar\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-lg-3\"><div class=\"pt-part sort\"><div class=\"tag left\"><i class=\"material-icons\">event_note</i></div><div class=\"right\"><span class=\"on\">{{ \'MY_CALENDAR\' | translate}}</span></div></div><div date-picker=\"$ctrl.viewDate\" view=\"date\" min-view=\"date\" date-events=\"$ctrl.minDateEvents\" date-change=\"$ctrl.getCalendarEvents\" watch-direct-changes=\"true\"></div><div class=\"th-dateEvent\"><div class=\"pt-part\" ng-repeat=\"event in $ctrl.dateEvents\" ng-class=\"{\'post\': event.isExpired, \'room\': event.courseType === 2, \'train\': event.courseType === 3, \'test\': event.courseType === 5}\"><div class=\"tag left\"><span>{{event.dateStr | date : \'MM\'}}/</span> <span class=\"day\">{{event.dateStr | date : \'dd\'}}</span></div><div class=\"right\"><div class=\"md-event\"><p>{{event.startTime}} - {{event.endTime}}</p></div><div class=\"el-event\"><a href=\"javascript: void(0);\" ng-click=\"$ctrl.linkToCourseSessionPage(event)\">{{event.eventName}}</a></div><div class=\"md-event\"><div class=\"pt-interval\"><i class=\"fa fa-map-marker\"></i> {{event.place}} <span ng-if=\"event.placeMap\" ng-click=\"$ctrl.openPlaceMap(event.placeMap)\"><i class=\"icon-map\"></i></span></div></div></div></div><div class=\"pt-noData\" ng-if=\"!$ctrl.dateEvents || $ctrl.dateEvents.length===0\"><i class=\"icon icons-food-17\"></i><p>{{ \'FIELD.TODAY_IS_NOT_ANY_SCHEDULE\' |translate }}</p><p>Have a nice day!</p></div></div><header class=\"el-header\" ng-if=\"$ctrl.isCanShowTomorrowEvents\"><h4>{{ \'FIELD.TOMORROW_TO_REMIND\' | translate}}</h4></header><div class=\"th-dateEvent\" ng-if=\"$ctrl.isCanShowTomorrowEvents\"><div class=\"pt-part\" ng-repeat=\"event in $ctrl.tomorrowEvents\" ng-class=\"{\'post\': event.isExpired, \'room\': event.courseType === 2, \'train\': event.courseType === 3, \'test\': event.courseType === 5}\"><div class=\"tag left\"><span>{{event.dateStr | date : \'MM\'}}/</span> <span class=\"day\">{{event.dateStr | date : \'dd\'}}</span></div><div class=\"right\"><div class=\"md-event\"><p>{{event.startTime}} - {{event.endTime}}</p></div><div class=\"el-event\"><a href=\"javascript: void(0);\" ng-click=\"$ctrl.linkToCourseSessionPage(event)\">{{event.eventName}}</a></div><div class=\"md-event\"><div class=\"pt-interval\"><i class=\"fa fa-map-marker\"></i> {{event.place}} <span ng-if=\"event.placeMap\" ng-click=\"$ctrl.openPlaceMap(event.placeMap)\"><i class=\"icon-map\"></i></span></div></div></div></div><div class=\"pt-noData\" ng-if=\"!$ctrl.tomorrowEvents || $ctrl.tomorrowEvents.length===0\"><i class=\"icon icons-food-17\"></i><p>{{ \'FIELD.TOMORROW_IS_NOT_ANY_SCHEDULE\' |translate }}</p><p>Have a nice day!</p></div></div></div><div class=\"col-xs-12 col-sm-8 col-lg-9\"><div class=\"th-dayTitle\" layout=\"row\" layout-align=\"space-between center\"><div class=\"pt-transform left pt-transform-override\" flex=\"nogrow\"><a href=\"javascript:void(0);\" class=\"prev\" mwl-date-modifier=\"\" date=\"$ctrl.viewDate\" decrement=\"$ctrl.calendarView\" date-change=\"$ctrl.getCalendarEvents\" ng-click=\"$ctrl.cellIsOpen = false;\"><i class=\"fa fa-chevron-left\"></i></a> <a href=\"javascript:void(0);\" class=\"today\" mwl-date-modifier=\"\" date=\"$ctrl.viewDate\" set-to-today=\"\" date-change=\"$ctrl.getCalendarEvents\" ng-click=\"$ctrl.cellIsOpen = false\">{{ \'FIELD.TODAY\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"next\" mwl-date-modifier=\"\" date=\"$ctrl.viewDate\" increment=\"$ctrl.calendarView\" date-change=\"$ctrl.getCalendarEvents\" ng-click=\"$ctrl.cellIsOpen = false\"><i class=\"fa fa-chevron-right\"></i></a></div><div class=\"pt-now pt-now-override\" flex=\"auto\">{{$ctrl.calendarTitle}}</div><div class=\"pt-transform right pt-transform-override right-override\" flex=\"nogrow\"><a href=\"javascript:void(0);\" ng-model=\"$ctrl.calendarView\" uib-btn-radio=\"\'month\'\" ng-click=\"$ctrl.cellIsOpen = false\">{{ \'FIELD.MONTH\' | translate}}</a> <a href=\"javascript:void(0);\" ng-model=\"$ctrl.calendarView\" uib-btn-radio=\"\'week\'\" ng-click=\"$ctrl.cellIsOpen = false\">{{ \'FIELD.WEEK\' | translate}}</a> <a href=\"javascript:void(0);\" ng-model=\"$ctrl.calendarView\" uib-btn-radio=\"\'day\'\" ng-click=\"$ctrl.cellIsOpen = false\">{{ \'FIELD.DAY\' | translate}}</a></div></div><mwl-calendar view=\"$ctrl.calendarView\" view-date=\"$ctrl.viewDate\" events=\"$ctrl.bigCalendarEvents\" view-title=\"$ctrl.calendarTitle\" on-timespan-click=\"$ctrl.updateViewDate(calendarDate)\" on-event-click=\"$ctrl.linkToCourseSessionPage(calendarEvent)\" on-event-times-changed=\"calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd\" cell-is-open=\"true\" week-number-label-disabled=\"true\"></mwl-calendar></div></div></section></div></div>");
$templateCache.put("app/modules/user/views/my-curriculum.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'MY_CURRICULUM\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" suggest-learning-search-dialog=\"\" table=\"$ctrl.suggestLearningTable\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div><div class=\"th-staff\"><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.userInfo.userData.avatarUrl\" first-name=\"::$ctrl.userInfo.userData.firstName\" line-height=\"60\" font-size=\"24\"></avatar></div><div class=\"link right\"><md-button class=\"md-primary md-raised\" add-suggest-learning-list=\"\" table=\"$ctrl.suggestLearningTable\"><md-icon md-font-set=\"fa\" class=\"fa-plus\"></md-icon>{{ \'ACTIONS.ADD_PERSONAL_ELECTIVE_ITEM\' | translate}}</md-button></div><div class=\"md-staff\"><p class=\"name\">{{$ctrl.userInfo.userData.name}}</p><ul><li class=\"pt-blueG\"><i class=\"material-icons\">assignment_turned_in</i>{{ \'FIELD.PASSED_COUNT\' | translate}} :<strong>{{$ctrl.userInfo.pass}}</strong></li><li class=\"pt-red\"><i class=\"material-icons\">assignment_late</i>{{ \'STATUS.FAILED\' | translate}} :<strong>{{$ctrl.userInfo.fail}}</strong></li><li class=\"pt-blue\" ng-if=\"$ctrl.hasCurriculumPermission && $ctrl.hasCertificationInnerPermission\"><i class=\"fa fa-share-square-o\"></i> {{ \'FIELD.EXEMPTION_COUNT\' | translate}} :<strong>{{$ctrl.userInfo.exemption}}</strong></li><li>{{ \'FIELD.TOTAL\' | translate}} :<strong>{{($ctrl.userInfo.sum)}}</strong></li></ul></div></div></div><script type=\"text/ng-template\" id=\"headerCheckbox.html\"><md-checkbox flex class=\"md-primary checkbox\" ng-model=\"$ctrl.enrollmentId.selectAll\"></md-checkbox></script><script type=\"text/ng-template\" id=\"enrollTypeHeader.html\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\" class=\"sort-indicator\"> {{ \'FIELD.ENROLL_TYPE\' | translate }}<br>({{ \'FIELD.SPECIFY_APPLICANT\' | translate}}) </span></script><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.suggestLearningTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div><div class=\"link\"><md-button class=\"md-raised md-primary md-btn\" update-estimated-completion-date=\"\" table=\"$ctrl.suggestLearningTable\" enrollment-id-list=\"$ctrl.enrollmentId.selected\">{{ \'ACTIONS.UPDATE_ESTIMATED_COMPLETION_DATE\' | translate}}</md-button><md-button class=\"md-raised md-warn md-btn\" delete-suggest-learning-list=\"\" table=\"$ctrl.suggestLearningTable\" enrollment-id-list=\"$ctrl.enrollmentId.selected\"><md-icon md-font-set=\"fa\" class=\"fa-trash-o\"></md-icon>{{ \'ACTIONS.DELETE\' | translate}}</md-button></div></section></div></div>");
$templateCache.put("app/modules/user/views/my-setting.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"setting\"><div class=\"th-title\"><h2>{{ \'FIELD.PERSONAL_SETTING\' | translate}}</h2></div><div class=\"th-person\"><div class=\"el-person\"><avatar avatar-url=\"$ctrl.userProfilesDetail.avatarUrl\" first-name=\"$ctrl.userProfilesDetail.FirstName\" line-height=\"140\" font-size=\"48\"></avatar><span class=\"btn photo btn-file\" ng-if=\"uploader && !$ctrl.userInfoIsExternal\"><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" filters=\"sizeFilter\"> <i class=\"material-icons\">photo_camera</i></span></div><div class=\"personInfor\"><table class=\"BoxTable override\"><tbody><tr><th>{{ \'FIELD.ACCOUNT\' | translate}}</th><td>{{$ctrl.userProfilesDetail.Account}}</td></tr><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{$ctrl.userProfilesDetail.FullName}}</td></tr><tr><th>{{ \'FIELD.EMPLOYEE_NUMBER\' | translate}}</th><td>{{$ctrl.userProfilesDetail.EmployeeNumber}}</td></tr></tbody></table><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in $ctrl.userProfilesDetail.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.EMAIL\' | translate}}</th><td><a ng-href=\"mailto:{{ $ctrl.userProfilesDetail.Email }}\" target=\"_blank\">{{$ctrl.userProfilesDetail.Email}}</a></td></tr><tr><th>{{ \'FIELD.TOTAL_ENROLLMENT_COUNT\' | translate}}</th><td>{{$ctrl.userProfilesDetail.totalEnrollmentCount}}</td></tr></tbody></table></div></div><div class=\"th-setting\" ng-if=\"$ctrl.userProfilesDetail\"><form ng-if=\"$ctrl.userProfilesDetail.ChangePwdByLA!==\'0\'\" name=\"pwdForm\" ng-submit=\"pwdForm.$valid && $ctrl.changePassword($ctrl.personal.pwds)\" ng-init=\"$ctrl.personal.pwds = {}\"><div class=\"md-passWord\"><header><h5 class=\"el-h5\">{{ \'FIELD.CHANGE_PASSWORD\' | translate}}</h5></header><div class=\"pt-passWord\"><md-input-container md-no-float=\"\" class=\"md-block\"><label class=\"md-caption\">{{ \'PLACEHOLDERS.PLEASE_ENTER_YOUR_OLD_PASSWORD\' | translate}}</label> <input name=\"oldPwd\" ng-model=\"$ctrl.personal.pwds.oldPwd\" type=\"password\" class=\"md-caption\" required=\"\" md-maxlength=\"\"><div ng-messages=\"pwdForm.oldPwd.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"md-caption\">{{ \'PLACEHOLDERS.PLEASE_ENTER_YOUR_NEW_PASSWORD\' | translate}}</label> <input name=\"newPwd\" ng-model=\"$ctrl.personal.pwds.newPwd\" type=\"password\" class=\"md-caption\" required=\"\"><div ng-messages=\"pwdForm.newPwd.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"md-caption\">{{ \'PLACEHOLDERS.PLEASE_RECONFIRM_YOUR_NEW_PASSWORD\' | translate}}</label> <input name=\"reNewPwd\" ng-model=\"reNewPwd\" type=\"password\" class=\"md-caption\" md-compare-to=\"$ctrl.personal.pwds.newPwd\" required=\"\"><div ng-messages=\"pwdForm.reNewPwd.$error\"><div ng-message=\"md-compare-to\">{{\'FORM_VALIDATION.PLEASE_RE_CHECK_NEW_PASSWORD\' | translate}}</div><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></md-input-container></div><footer><md-button type=\"submit\" class=\"md-primary md-raised\">{{ \'ACTIONS.CHANGE_LOGIN_PASSWORD\' | translate}}</md-button></footer></div></form><form name=\"preferLangForm\" ng-submit=\"preferLangForm.$valid && $ctrl.updatePreferLang($ctrl.personal.rc)\"><div class=\"md-leng\" ng-class=\"{\'w-100\': $ctrl.userProfilesDetail.ChangePwdByLA===\'0\'}\"><header><h5 class=\"el-h5\">{{ \'FIELD.MY_PREFERENCE\' | translate}}</h5></header><div class=\"pt-leng\"><md-radio-group layout=\"row\" layout-align=\"center\" ng-model=\"$ctrl.personal.rc\"><md-radio-button ng-value=\"2\">{{\'LANGUAGE_TW\' | translate}}</md-radio-button><md-radio-button ng-value=\"3\">{{\'LANGUAGE_CN\' | translate}}</md-radio-button><md-radio-button ng-value=\"1\">{{\'LANGUAGE_EN\' | translate}}</md-radio-button></md-radio-group></div><footer><md-button type=\"submit\" class=\"md-primary md-raised\">{{ \'ACTIONS.APPLY\' | translate}}</md-button></footer></div></form></div><div class=\"th-agent\" style=\"display: none\"><header><h5 class=\"el-h5\">{{ \'FIELD.MY_DEPUTY_SETTING\' | translate}}</h5></header><div class=\"pt-noData\"><i class=\"ctms-face-10\"></i><md-button class=\"md-primary md-raised\" ng-click=\"\">{{ \'FIELD.SETTING_DEPUTY\' | translate}}</md-button></div></div><div class=\"th-agent\" permission=\"\" permission-only=\"[\'Modules.approval\']\"><header><h5 class=\"el-h5\">{{ \'FIELD.MY_DEPUTY_SETTING\' | translate}}</h5></header><div class=\"link\"><md-button class=\"md-primary md-raised\" deputy-record-dialog=\"\" table=\"$ctrl.deputyRecordsTable\">{{ \'FIELD.SETTING_DEPUTY\' | translate}}</md-button></div><div class=\"md-agent th-tab\"><table class=\"tb-transfer tb-check\" ng-table=\"$ctrl.deputyRecordsTable\"><thead><tr><th class=\"check\"><md-checkbox flex=\"\" class=\"md-primary checkbox\" style=\"margin-left: 10px;\" ng-model=\"$ctrl.agentWorkId.selectAll\"></md-checkbox></th><th>{{ \'FIELD.DEPUTY_DEPARTMENT\' | translate}}</th><th>{{ \'FIELD.DEPUTY_EFFECTIVE_DATE\' | translate}}</th><th class=\"no\">{{ \'FIELD.DEPUTY_END_DATE\' | translate}}</th><th>{{ \'FIELD.DEPUTY\' | translate}}</th><th class=\"no\">{{ \'FIELD.SETTING_DATE\' | translate}}</th><th>{{ \'FIELD.ACTION\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"record in $data\"><td class=\"check\" data-title=\"\'ACTIONS.SELECT\' | translate\"><md-checkbox flex=\"\" class=\"md-primary checkbox\" style=\"margin-left: 10px;\" ng-model=\"$ctrl.agentWorkId.selected[record.agentWorkId].value\" ng-click=\"$ctrl.checkboxSelect(record.agentWorkId, $ctrl.agentWorkId.selected[record.agentWorkId].value)\"></md-checkbox></td><td data-title=\"{{ \'FIELD.DEPUTY_DEPARTMENT\' |translate }}\"><div class=\"text\">{{record.deputyGroupName}}</div></td><td data-title=\"{{ \'FIELD.DEPUTY_EFFECTIVE_DATE\' |translate }}\"><div class=\"time\">{{record.deputyFrom}}</div></td><td data-title=\"{{ \'FIELD.DEPUTY_END_DATE\' |translate }}\" class=\"no\"><div class=\"time\">{{record.deputyTo}}</div></td><td data-title=\"{{ \'FIELD.DEPUTY\' |translate }}\"><div class=\"text\">{{record.agentName}}</div></td><td data-title=\"{{ \'FIELD.SETTING_DATE\' |translate }}\" class=\"no\"><div class=\"time\">{{record.createDate}}</div></td><td data-title=\"{{ \'FIELD.ACTION\' |translate }}\"><div class=\"condition\"><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" title=\"{{ \'ACTIONS.VIEW\' | translate}}\" deputy-record-dialog=\"\" table=\"$ctrl.deputyRecordsTable\" data=\"record\"><i class=\"icon-note\"></i></a> <a href=\"javascript:void(0);\" class=\"more\" title=\"{{ \'ACTIONS.EDIT\' | translate}}\"><i class=\"mdi-navigation-more-vert\"></i></a></div></td></tr></tbody></table><div class=\"link\"><button type=\"button\" class=\"btn btn-sm btn-danger\" title=\"{{ \'ACTIONS.DELETE\' | translate}}\" ng-click=\"$ctrl.deleteDeputyRecords()\"><i class=\"fa fa-trash-o\"></i></button></div></div></div></section></div></div>");
$templateCache.put("app/modules/user/views/suggest-learning-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"30\"><form ng-submit=\"$ctrl.submit($ctrl.filters)\" name=\"validForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><div class=\"lightBox Box-leave\">{{ \'FIELD.ESTIMATED_COMPLETION_DATE\' | translate}}<div layout=\"row\" layout-sm=\"column\"><md-input-container flex=\"\"><label>{{ \'FIELD.YEAR\' | translate}}</label><md-select ng-model=\"$ctrl.filters.lmYearBegin\"><md-option ng-repeat=\"value in $ctrl.year\" ng-value=\"value\">{{value}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>{{ \'FIELD.MONTH\' | translate}}</label><md-select ng-model=\"$ctrl.filters.lmMonthBegin\"><md-option ng-repeat=\"value in $ctrl.month\" ng-value=\"value\">{{value+1}}</md-option></md-select></md-input-container></div>To<div layout=\"row\" layout-sm=\"column\"><md-input-container flex=\"\"><label>{{ \'FIELD.YEAR\' | translate}}</label><md-select ng-model=\"$ctrl.filters.lmYearEnd\"><md-option ng-repeat=\"value in $ctrl.year\" ng-value=\"value\">{{value}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>{{ \'FIELD.MONTH\' | translate}}</label><md-select ng-model=\"$ctrl.filters.lmMonthEnd\"><md-option ng-repeat=\"value in $ctrl.month\" ng-value=\"value\">{{value+1}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\">{{ \'FIELD.SOURCE\' | translate}}<md-input-container flex=\"100\"><md-select ng-model=\"$ctrl.filters.sourceType\"><md-option ng-value=\"-101\">{{ \'FIELD.ALL\' | translate}}</md-option><md-option ng-if=\"$ctrl.hasTrainingPlanPermission\" ng-value=\"1\">{{ \'FIELD.TRAINING_PLAN\' | translate}}</md-option><md-option ng-if=\"$ctrl.hasTrainingRoadMapPermission\" ng-value=\"2\">{{ \'FIELD.TRAINING_BLUEPRINT\' | translate}}</md-option><md-option ng-if=\"$ctrl.hasCompetencePermission\" ng-value=\"3\">{{ \'FIELD.COMPETENCE_RECOMMEND\' | translate}}</md-option><md-option ng-value=\"4\">{{ \'FIELD.SELF_DEMANDING\' | translate}}</md-option><md-option ng-value=\"5\">{{ \'FIELD.MANAGER_RECOMMEND\' | translate}}</md-option><md-option ng-if=\"$ctrl.hasKnowLedgePermission\" ng-value=\"6\">{{ \'FIELD.ABILITY_RECOMMEND\' | translate}}</md-option><md-option ng-if=\"$ctrl.hasIdpForCpasPermission\" ng-value=\"7\">{{ \'FIELD.PERSONAL_DEVELOPMENT\' | translate}}</md-option><md-option ng-value=\"0\">{{ \'FIELD.OTHER\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\">{{ \'FIELD.LEARNING_STATUS\' | translate}}<md-input-container flex=\"100\"><md-select ng-model=\"$ctrl.filters.searchStatus\"><md-option ng-value=\"\'All\'\">{{ \'FIELD.ALL\' | translate}}</md-option><md-option ng-value=\"\'Unenroll\'\">{{ \'STATUS.UNENROLLED\' | translate}}</md-option><md-option ng-value=\"\'Enrolled\'\">{{ \'STATUS.ENROLLED\' | translate}}</md-option><md-option ng-value=\"\'Not Executed\'\">{{ \'STATUS.NOT_EXECUTED\' | translate}}</md-option><md-option ng-if=\"$ctrl.hasApprovalPermission\" ng-value=\"\'Enrollment Approval Pending\'\">{{ \'STATUS.ENROLLMENT_APPROVAL_PENDING\' | translate}}</md-option><md-option ng-value=\"\'Executed\'\">{{ \'STATUS.EXECUTED\' | translate}}</md-option><md-option ng-value=\"0\">N/A</md-option><md-option ng-if=\"$ctrl.hasApprovalPermission\" ng-value=\"1\">{{ \'STATUS.EXEMPTION\' | translate}}</md-option><md-option ng-value=\"2\">{{ \'STATUS.PASSED\' | translate}}</md-option><md-option ng-value=\"3\">{{ \'STATUS.FAILED\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"$ctrl.permissionType===\'manager\'\">{{ \'FIELD.DEPARTMENT\' | translate}}<md-input-container flex=\"100\"><md-select ng-model=\"$ctrl.filters.groupId\"><md-option ng-repeat=\"managerGroup in $ctrl.managerGroups\" ng-value=\"managerGroup.value\">{{managerGroup.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap=\"\" ng-if=\"$ctrl.permissionType===\'manager\'\">{{ \'FIELD.FULL_NAME\' | translate}}<md-input-container flex=\"100\"><md-select ng-model=\"$ctrl.filters.memberId\"><md-option ng-repeat=\"managerMember in $ctrl.managerMembers\" ng-value=\"managerMember.value\">{{managerMember.name}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/user/views/training-records-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"25\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"TRSDC.close()()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><md-input-container md-no-float=\"\" class=\"md-block\"><label>{{ \'FIELD.KEYWORD\' | translate}}</label> <input ng-model=\"TRSDC.filters.keyword\" placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.LEARNING_ACTIVITY\' | translate}}</label><md-select ng-model=\"TRSDC.filters.cpType\"><md-option ng-value=\"1\">{{ \'FIELD.LEARNING_ACTIVITY\' | translate}},{{ \'FIELD.COURSE_FOLDER_TEST\' | translate}},{{ \'FIELD.COURSE_FOLDER_SURVEY\' | translate}}</md-option><md-option ng-value=\"2\" ng-if=\"TRSDC.hasCurriculumPermission && TRSDC.hasCertificationInnerPermission\">{{ \'FIELD.PROGRAM\' | translate}},{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</md-option><md-option ng-value=\"2\" ng-if=\"TRSDC.hasCurriculumPermission && !TRSDC.hasCertificationInnerPermission\">{{ \'FIELD.PROGRAM\' | translate}}</md-option><md-option ng-value=\"2\" ng-if=\"!TRSDC.hasCurriculumPermission && TRSDC.hasCertificationInnerPermission\">{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.PASS_STATUS\' | translate}}</label><md-select ng-model=\"TRSDC.filters.passResult\"><md-option value=\"-1\">{{ \'FIELD.ALL\' | translate}}</md-option><md-option value=\"0\">N/A</md-option><md-option value=\"1\" ng-if=\"TRSDC.hasCurriculumPermission && TRSDC.hasCertificationInnerPermission\">{{ \'STATUS.EXEMPTION\' | translate}}</md-option><md-option value=\"2\">{{ \'STATUS.PASSED\' | translate}}</md-option><md-option value=\"3\">{{ \'STATUS.FAILED\' | translate}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.PROPERTIES\' | translate}}</label><md-select ng-model=\"TRSDC.filters.learnerType\"><md-option value=\"-1\">{{ \'FIELD.ALL\' | translate}}</md-option><md-option value=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</md-option><md-option value=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</md-option></md-select></md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"TRSDC.cancel()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-click=\"TRSDC.submit(TRSDC.filters)\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/user/views/training-records.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"license\"><div class=\"th-title\"><h2>{{ \'TRAINING_RECORDS\' | translate}}</h2></div><div class=\"th-license\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.showPrompt($event)\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate}}</md-button></div></div><div class=\"th-staff\"><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.userProfiles.avatarUrl\" first-name=\"::$ctrl.userProfiles.firstName\" line-height=\"60\" font-size=\"24\"></avatar></div><div class=\"md-staff\"><p class=\"name\">{{$ctrl.userProfiles.name}}</p><ul><li class=\"pt-blueG\"><i class=\"material-icons\">assignment_turned_in</i>{{ \'FIELD.PASSED_COUNT\' | translate}} :<strong>{{$ctrl.summary.passedCount}}</strong></li><li class=\"pt-red\"><i class=\"material-icons\">assignment_late</i>{{ \'STATUS.FAILED\' | translate}} :<strong>{{$ctrl.summary.failedCount}}</strong></li><li class=\"pt-blue\" ng-if=\"$ctrl.hasCurriculumPermission && $ctrl.hasCertificationInnerPermission\"><i class=\"fa fa-share-square-o\"></i> {{ \'FIELD.EXEMPTION_COUNT\' | translate}} :<strong>{{$ctrl.summary.exemptionCount}}</strong></li><li class=\"pt-red\"><i class=\"material-icons\">assignment_late</i>N/A :<strong>{{$ctrl.summary.naCount}}</strong></li><li>{{ \'FIELD.TOTAL\' | translate}} :<strong>{{($ctrl.summary.passedCount + $ctrl.summary.failedCount + $ctrl.summary.exemptionCount + $ctrl.summary.naCount)}}</strong></li></ul></div></div><div class=\"th-tab\"><table ng-table-dynamic=\"$ctrl.myTrainingRecordsTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div></section></div></div>");
$templateCache.put("app/modules/user/views/update-estimated-completion-date.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"25\"><form ng-submit=\"$ctrl.submit($ctrl.form)\" name=\"validForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.ESTIMATED_COMPLETION_DATE\' |translate }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><md-content layout-padding=\"\"><md-datepicker ng-model=\"$ctrl.form.predictDate\" md-placeholder=\"{{ \'FIELD.START_DATE\' | translate }}\" md-datepicker-focus-open=\"\" onkeydown=\"return false\"></md-datepicker></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/user/views/user-detail.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"$ctrl.isCertificate===\'1\'\">{{ \'FIELD.COUNSELOR_DETAIL\' | translate}}</h2><h2 ng-if=\"$ctrl.isCertificate===\'0\'\">{{ \'FIELD.LEARNER_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-height:400px;\"><div class=\"lightBox Box-person\"><div class=\"el-person\" flex=\"\" layout=\"row\"><avatar flex=\"auto\" avatar-url=\"::$ctrl.userProfile.avatarUrl\" first-name=\"::$ctrl.userProfile.FirstName\" line-height=\"100\" font-size=\"36\"></avatar><div flex=\"auto\" class=\"personInfor\"><header><h4 ng-if=\"$ctrl.isCertificate===\'1\'\">{{ \'FIELD.COUNSELOR_DETAIL\' | translate}}</h4><h4 ng-if=\"$ctrl.isCertificate===\'0\'\">{{ \'FIELD.LEARNER_DETAIL\' | translate}}</h4></header><table class=\"BoxTable person-table\"><tbody><tr ng-if=\"$ctrl.userProfile.FirstName!==\'\'\"><th>{{ \'FIELD.NAME\' | translate}}</th><td class=\"session-enrolled-members-dialog-emailbreakall\">{{$ctrl.userProfile.FirstName}}</td></tr><tr ng-if=\"$ctrl.userProfile.LastName!==\'\'\"><th>{{ \'FIELD.LAST_NAME\' | translate}}</th><td class=\"session-enrolled-members-dialog-emailbreakall\">{{$ctrl.userProfile.LastName}}</td></tr><tr ng-if=\"$ctrl.userProfile.EmployeeNumber!==\'\'\"><th>{{ \'FIELD.EMPLOYEE_NUMBER\' | translate}}</th><td>{{$ctrl.userProfile.EmployeeNumber}}</td></tr><tr ng-if=\"$ctrl.userProfile.Team.length!==0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"group in $ctrl.userProfile.Team\">{{group |markSplit:$index:\',\'}}</span></td></tr><tr ng-if=\"$ctrl.userProfile.Company!==\'\'\"><th>{{ \'FIELD.COMPANY\' | translate}}</th><td>{{$ctrl.userProfile.Company}}</td></tr><tr ng-if=\"$ctrl.userProfile.Email!==\'\'\"><th>{{ \'FIELD.EMAIL\' | translate}}</th><td>{{$ctrl.userProfile.Email}}</td></tr><tr ng-if=\"$ctrl.userProfile.OfficePhone!==\'\'\"><th>{{ \'FIELD.OFFICE_PHONE\' | translate}}</th><td>{{$ctrl.userProfile.OfficePhone}}</td></tr></tbody></table></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CLOSE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/utils/views/avatar.html","<figure ng-class=\"avatarUrl!==\'\'?\'avatar\':\'\'\" ng-style=\"{\'background\': (avatarUrl===\'\')?getRandom:\'\'}\"><img ng-if=\"avatarUrl!==\'\'\" ng-src=\"{{ avatarUrl | urlIncludesServerPath}}\" alt=\"\"> <span ng-if=\"avatarUrl===\'\'\" ng-style=\"{ \'line-height\': (lineHeight===\'\')?\'\':lineHeight + \'px\', \'font-size\': (fontSize===\'\')?\'\':fontSize + \'px\' }\">{{firstName |nameRegular}}</span></figure>");
$templateCache.put("app/modules/utils/views/choice-external-course-sessions.html","<div class=\"th-tab\" ng-if=\"$ctrl.displayType === \'table\'\"><table ng-table-dynamic=\"$ctrl.table with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div><div ng-if=\"$ctrl.displayType === \'list\'\"><div layout-gt-xs=\"row\"><div flex-gt-xs=\"\"><md-radio-group ng-model=\"$ctrl.ngModel\"><div class=\"row\"><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><md-radio-button flex=\"\" ng-value=\"-1\" class=\"m-b-0 md-primary\">{{ \'ACTIONS.ADD_NEW_CLASS\' | translate }}</md-radio-button></div><md-divider></md-divider></div><div ng-repeat=\"data in $ctrl.datas\" class=\"row\"><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><md-radio-button flex=\"\" ng-value=\"data.SessionId\" class=\"m-b-0 md-primary\">{{data.SessionName}}</md-radio-button></div><md-divider></md-divider></div></md-radio-group></div></div></div>");
$templateCache.put("app/modules/utils/views/choice-external-courses.html","<div class=\"th-tab\" ng-if=\"$ctrl.displayType === \'table\'\"><table ng-table-dynamic=\"$ctrl.table with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div><div ng-if=\"$ctrl.displayType === \'list\'\"><div layout-gt-xs=\"row\"><div flex-gt-xs=\"\"><md-radio-group ng-model=\"$ctrl.ngModel\"><div ng-repeat=\"data in $ctrl.datas\" class=\"row\"><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><md-radio-button flex=\"\" ng-value=\"data.courseId\" class=\"m-b-0 md-primary\">{{data.courseName}}</md-radio-button></div><md-divider></md-divider></div></md-radio-group></div></div></div>");
$templateCache.put("app/modules/utils/views/class-time-dialog.html","<md-dialog aria-label=\"{{ \'FIELD.SETTING_CLASS_TIME\' | translate}}\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SETTING_CLASS_TIME\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"lightBox Box-assign\"><div class=\"box-content checkboxdemoSyncing\"><md-content layout-padding=\"\"><div class=\"thForm\"><form name=\"userForm\"><div class=\"el-h4\">{{ \'FIELD.COURSE_DATE\' | translate}}</div><div layout-gt-xs=\"row\" layout-gt-sm=\"row\"><div flex-gt-xs=\"40\" flex-gt-sm=\"45\"><div layout=\"row\" layout-margin=\"\"><div flex=\"90\"><md-input-container><label>{{ \'FIELD.START_DATE\' | translate}}</label><md-datepicker ng-model=\"$ctrl.classTime.startDate\" ng-change=\"$ctrl.updateEndDateModel()\"></md-datepicker></md-input-container></div></div></div><div flex-gt-xs=\"5\" flex-gt-sm=\"5\" class=\"center pt-to\">to</div><div flex-gt-xs=\"40\" flex-gt-sm=\"45\"><div layout=\"row\" layout-margin=\"\"><div flex=\"90\"><md-input-container><label>{{ \'FIELD.END_DATE\' | translate}}</label><cus-md-datepicker md-min-date=\"$ctrl.classTime.startDate\" ng-model=\"$ctrl.classTime.endDate\"></cus-md-datepicker></md-input-container></div></div></div></div><div class=\"el-h4\">{{ \'FIELD.CLASS_TIME\' | translate}}</div><div layout-gt-xs=\"row\" layout-gt-sm=\"row\"><div flex-gt-xs=\"40\" flex-gt-sm=\"30\"><div layout=\"row\" layout-margin=\"\"><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.startH\" type=\"hours\"></md-select-time></div><div flex=\"5\" class=\"center\">:</div><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.startM\" type=\"minute\" is-array-index=\"true\"></md-select-time></div></div></div><div flex-gt-xs=\"5\" flex-gt-sm=\"5\" class=\"center pt-to\">to</div><div flex-gt-xs=\"40\" flex-gt-sm=\"30\"><div layout=\"row\" layout-margin=\"\"><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.endH\" type=\"hours\" form-time=\"{{$ctrl.classTime.startH}}:{{$ctrl.classTime.startM}}\" to-time=\"{{$ctrl.classTime.endH}}:{{$ctrl.classTime.endM}}\"></md-select-time></div><div flex=\"5\" class=\"center\">:</div><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.endM\" type=\"minute\" form-time=\"{{$ctrl.classTime.startH}}:{{$ctrl.classTime.startM}}\" to-time=\"{{$ctrl.classTime.endH}}:{{$ctrl.classTime.endM}}\" is-array-index=\"true\"></md-select-time></div></div></div></div><div class=\"el-h4\"><md-input-container class=\"md-blodiv\" flex-gt-sm=\"\"><md-checkbox ng-model=\"$ctrl.classTime.isEnableRestTime\" aria-label=\"Checkbox 1\">{{ \'FIELD.REST_TIME\' | translate}}</md-checkbox></md-input-container></div><div layout-gt-xs=\"row\" layout-gt-sm=\"row\" ng-show=\"$ctrl.classTime.isEnableRestTime\"><div flex-gt-xs=\"40\" flex-gt-sm=\"30\"><div layout=\"row\" layout-margin=\"\"><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.rest_startH\" type=\"hours\"></md-select-time></div><div flex=\"5\" class=\"center\">:</div><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.rest_startM\" type=\"minute\" is-array-index=\"true\"></md-select-time></div></div></div><div flex-gt-xs=\"5\" flex-gt-sm=\"5\" class=\"center pt-to\">to</div><div flex-gt-xs=\"40\" flex-gt-sm=\"30\"><div layout=\"row\" layout-margin=\"\"><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.rest_endH\" type=\"hours\" form-time=\"{{$ctrl.classTime.rest_startH}}:{{$ctrl.classTime.rest_startM}}\" to-time=\"{{$ctrl.classTime.rest_endH}}:{{$ctrl.classTime.rest_endM}}\"></md-select-time></div><div flex=\"5\" class=\"center\">:</div><div flex=\"35\"><md-select-time ng-model=\"$ctrl.classTime.rest_endM\" type=\"minute\" form-time=\"{{$ctrl.classTime.rest_startH}}:{{$ctrl.classTime.rest_startM}}\" to-time=\"{{$ctrl.classTime.rest_endH}}:{{$ctrl.classTime.rest_endM}}\" is-array-index=\"true\"></md-select-time></div></div></div></div><div class=\"el-h4\">{{ \'FIELD.INCLUDE\' | translate}}</div><div layout-gt-sm=\"row\" layout-xs=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox ng-repeat=\"weekDay in $ctrl.weekDays\" class=\"m-r-20\" ng-click=\"$ctrl.includeDaysToggle($index);\" ng-checked=\"$ctrl.classTime.includeDays.indexOf($index) > -1\">{{weekDay}}</md-checkbox></md-input-container></div><div class=\"el-h4\"><md-input-container class=\"md-blodiv\" flex-gt-sm=\"\"><md-checkbox ng-model=\"$ctrl.classTime.isEnableRepeat\" aria-label=\"Checkbox 1\">{{ \'FIELD.CYCLE_MODE\' | translate}}</md-checkbox></md-input-container></div><div layout=\"row\" layout-xs=\"\" layout-margin=\"\" ng-show=\"$ctrl.classTime.isEnableRepeat\"><div class=\"center\">{{ \'FIELD.REPEAT_INTERVAL\' | translate}}</div><div flex=\"8\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"$ctrl.classTime.repeatIntervalNumber\"><md-option ng-repeat=\"repeatIntervalNumber in $ctrl.repeatIntervalNumbers\" value=\"{{repeatIntervalNumber}}\">{{repeatIntervalNumber}}</md-option></md-select></md-input-container></div><div flex=\"8\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-select ng-model=\"$ctrl.classTime.repeatIntervalUnit\"><md-option ng-repeat=\"repeatIntervalUnit in $ctrl.repeatIntervalUnits\" value=\"{{repeatIntervalUnit}}\">{{repeatIntervalUnit}}</md-option></md-select></md-input-container></div></div></form></div></md-content></div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.submit()\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/utils/views/class-time.html","<input type=\"hidden\" name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.classTimeStr\" ng-required=\"$ctrl.required\"><div ng-if=\"$ctrl.classTimeObjects.length === 0\"><div class=\"el-inBlock m-l-10 m-r-10\"><button type=\"button\" title=\"{{ \'ACTIONS.ADD_A_TIME_ZONE\' | translate}}\" class-time-handle=\"add\" class-time-pools=\"$ctrl.classTimeObjects\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"fa fa-plus\"></i><div class=\"ripple-wrapper\"></div></button></div></div><div ng-repeat=\"classTimeObject in $ctrl.classTimeObjects\" ng-class=\"{\'m-t-20\' : $index > 0}\"><div class=\"rectangle m-b-10\">{{ \'FIELD.TIME_TABLE\' | translate}}({{ \'FIELD.TIME_ZONE\' | translate}}{{$index+1}})</div><div class=\"p-10 pt-bgGroup\"><p><span class=\"li-title\">{{ \'FIELD.COURSE_DATE\' | translate}}</span> <span class=\"text m-l-10\">{{ classTimeObject.startDate | amDateFormat:\'YYYY/MM/DD\'}}~{{ classTimeObject.endDate | amDateFormat:\'YYYY/MM/DD\'}}</span></p><p><span class=\"li-title\">{{ \'FIELD.CLASS_TIME\' | translate}}</span> <span class=\"text m-l-10\">{{ classTimeObject.startH | displayMinNumber : 2 }} : {{(classTimeObject.startM*5) | displayMinNumber : 2 }} ~ {{ classTimeObject.endH | displayMinNumber : 2 }} : {{(classTimeObject.endM*5) | displayMinNumber : 2 }}</span></p><p ng-if=\"classTimeObject.isEnableRestTime\"><span class=\"li-title\">{{ \'FIELD.REST_TIME\' | translate}}</span> <span class=\"text m-l-10\">{{ classTimeObject.rest_startH | displayMinNumber : 2 }} : {{(classTimeObject.rest_startM*5) | displayMinNumber : 2 }} ~ {{ classTimeObject.rest_endH | displayMinNumber : 2 }} : {{(classTimeObject.rest_endM*5) | displayMinNumber : 2 }}</span></p><p ng-if=\"classTimeObject.includeDays.length < 7\"><span class=\"li-title\">{{ \'FIELD.DAYS_IN_DURATION\' | translate}}</span> <span class=\"text m-l-10\"><span class=\"el-inBlock m-r-5 m-l-5\" ng-repeat=\"includeDay in classTimeObject.includeDays | orderBy\">{{$ctrl.weekDays[includeDay]}}</span></span></p><p ng-if=\"classTimeObject.isEnableRepeat\"><span class=\"li-title\">{{ \'FIELD.CYCLE_MODE\' | translate}}</span> <span class=\"text m-l-10\"><span class=\"text m-l-10\">{{ \'FIELD.INTERVAL\' | translate}}&nbsp;{{classTimeObject.repeatIntervalNumber}}&nbsp;{{classTimeObject.repeatIntervalUnit}}</span></span></p></div><div class=\"text-center\"><div class=\"el-inBlock m-l-10 m-r-10\"><button type=\"button\" title=\"{{ \'ACTIONS.ADD_A_TIME_ZONE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" class-time-handle=\"add\" class-time-pools=\"$ctrl.classTimeObjects\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"fa fa-plus\"></i><div class=\"ripple-wrapper\"></div></button></div><div class=\"el-inBlock m-l-10 m-r-10\"><button type=\"button\" title=\"{{ \'ACTIONS.EDIT_A_TIME_ZONE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" class-time-handle=\"edit\" class-time-pools=\"$ctrl.classTimeObjects\" editor-id=\"$index\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"icon-note\"></i><div class=\"ripple-wrapper\"></div></button></div><div class=\"el-inBlock m-l-10 m-r-10\"><button type=\"button\" title=\"{{ \'ACTIONS.DELETE_A_TIME_ZONE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-danger\" ng-click=\"$ctrl.classTimeObjects.splice($index, 1)\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"fa fa-trash-o\"></i><div class=\"ripple-wrapper\"></div></button></div></div></div>");
$templateCache.put("app/modules/utils/views/enroll-costs.html","<div ng-if=\"$ctrl.isCanRenderHtml\" ng-repeat=\"(key, applicant) in $ctrl.ngModel\">{{applicant.fullName}}&nbsp;:<div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20\">{{ \'FIELD.CURRENCY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><select-currency currencys=\"$ctrl.currencys\" ng-model=\"$ctrl.ngModel[key].costObject.course_cost_currency\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.defaultDisableField\"></select-currency></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20\"><span class=\"pt-mark\">*</span>{{ \'FIELD.AMOUNT\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input name=\"course_cost_amount\" ng-model=\"$ctrl.ngModel[key].costObject.course_cost_amount\" required=\"\" type=\"number\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.defaultDisableField\" min=\"0\"></md-input-container><div ng-messages=\"$ctrl.form.course_cost_amount.$error\" role=\"alert\"><span ng-message=\"min\" class=\"pt-mark\">{{\'FORM_VALIDATION.PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY\' | translate}}</span></div></div></div><div layout-gt-xs=\"row\" class=\"m-b-20\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20\">{{ \'FIELD.SYSTEM_CURRENCY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'PLACEHOLDERS.NT_CONVERSION\' | translate}}</label> <input ng-model=\"$ctrl.ngModel[key].costObject.course_converting_amount\" readonly=\"\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.defaultDisableField\"></md-input-container></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-b-20\">{{ \'FIELD.TYPE_OF_SUBSIDY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.ngModel[key].costObject.subsidyType\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.defaultDisableField\"><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.FULL_AMOUNT\' | translate}}</md-radio-button><md-radio-button value=\"2\" class=\"el-inBlock p-r-20\">{{ \'FIELD.SUBSIDY\' | translate}}</md-radio-button><md-input-container class=\"m-t-0\" flex-gt-xs=\"30\" flex-xs=\"40\"><input ng-model=\"$ctrl.ngModel[key].costObject.subsidyPercentage\" ng-disabled=\"($ctrl.ngModel[key].costObject.subsidyType !== \'2\') || ($ctrl.ngDisabled || $ctrl.defaultDisableField)\"></md-input-container>％</md-radio-group></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-b-20\">{{ \'FIELD.VOUCHER\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.ngModel[key].costObject.voucherType\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.defaultDisableField\"><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.TAXABLE_INVOICE\' | translate}}</md-radio-button><md-radio-button value=\"2\" class=\"el-inBlock p-r-20\">{{ \'FIELD.TAX_FREE_INVOICE\' | translate}}</md-radio-button><md-radio-button value=\"3\" class=\"el-inBlock p-r-20\">{{ \'FIELD.RECEIPT\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\" class=\"text-right m-b-20\">{{ \'FIELD.APPLICATION_CONTENT\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.ngModel[key].costObject.apply_type\" ng-disabled=\"$ctrl.ngDisabled\"><md-radio-button value=\"0\" class=\"el-inBlock p-r-20\">{{ \'FIELD.CASH\' | translate}}</md-radio-button><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.REMITTANCE\' | translate}}</md-radio-button><md-radio-button value=\"2\" class=\"el-inBlock p-r-20\">{{ \'FIELD.CHEQUE\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-gt-xs=\"row\" ng-if=\"$ctrl.ngModel[key].costObject.apply_type === \'0\'\"><div flex-gt-xs=\"20\" class=\"text-right\">{{ \'FIELD.PAYEE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container class=\"m-t-0\"><input ng-model=\"$ctrl.ngModel[key].costObject.payee\" ng-disabled=\"$ctrl.ngDisabled\"></md-input-container></div></div><div layout-gt-xs=\"row\" ng-if=\"$ctrl.ngModel[key].costObject.apply_type === \'1\'\"><div flex-gt-xs=\"20\" class=\"text-right\">{{ \'FIELD.REMITTANCE_INFORMATION\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span class=\"pt-mark\">*</span>&nbsp;{{ \'FIELD.THE_TITLE_OF_THE_COMPANY\' | translate}}</label> <input name=\"remit_title\" ng-model=\"$ctrl.ngModel[key].costObject.remit_title\" ng-disabled=\"$ctrl.ngDisabled\" ng-click=\"$ctrl.ngModel[key].costObject.remit_title_error = {}\" required=\"\" minlength=\"-1\"><div ng-messages=\"$ctrl.ngModel[key].costObject.remit_title_error\" role=\"alert\"><div ng-message=\"required\"><span class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span class=\"pt-mark\">*</span>&nbsp;{{ \'FIELD.BRANCHES\' | translate}}</label> <input name=\"remit_branch\" ng-model=\"$ctrl.ngModel[key].costObject.remit_branch\" ng-disabled=\"$ctrl.ngDisabled\" ng-click=\"$ctrl.ngModel[key].costObject.remit_branch_error = {}\" required=\"\"><div ng-messages=\"$ctrl.ngModel[key].costObject.remit_branch_error\" role=\"alert\"><div ng-message=\"required\"><span class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span class=\"pt-mark\">*</span>&nbsp;{{ \'FIELD.ACCOUNT\' | translate}}</label> <input name=\"remit_account\" ng-model=\"$ctrl.ngModel[key].costObject.remit_account\" ng-disabled=\"$ctrl.ngDisabled\" ng-click=\"$ctrl.ngModel[key].costObject.remit_account_error = {}\" required=\"\"><div ng-messages=\"$ctrl.ngModel[key].costObject.remit_account_error\" role=\"alert\"><div ng-message=\"required\"><span class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></md-input-container></div></div><div layout-gt-xs=\"row\" ng-if=\"$ctrl.ngModel[key].costObject.apply_type === \'2\'\"><div flex-gt-xs=\"20\" class=\"text-right\">{{ \'FIELD.RECEIPT_INFORMATION\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><div layout-gt-xs=\"column\"><div layout-xs=\"column\" layout-gt-xs=\"row\"><div><span class=\"pt-mark\">*</span>{{ \'FIELD.THE_TITLE_OF_THE_RECEIPT\' | translate}}&nbsp;:</div><div flex-gt-xs=\"70\" class=\"p-l-20\"><md-input-container class=\"md-block m-t-0\" flex-gt-sm=\"\"><input name=\"check_title\" ng-model=\"$ctrl.ngModel[key].costObject.check_title\" ng-disabled=\"$ctrl.ngDisabled\" ng-click=\"$ctrl.ngModel[key].costObject.check_title_error = {}\" required=\"\"><div ng-messages=\"$ctrl.ngModel[key].costObject.check_title_error\" role=\"alert\"><div ng-message=\"required\"><span class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div><span class=\"pt-mark\">*</span>{{ \'FIELD.RECEIPT_EXPIRE_DATE\' | translate}}&nbsp;:</div><div flex-gt-xs=\"70\" class=\"p-l-20\"><md-input-container class=\"md-block m-t-0\" flex-gt-sm=\"\"><md-datepicker ng-model=\"$ctrl.ngModel[key].costObject.check_expired_date\" ng-disabled=\"$ctrl.ngDisabled\" ng-click=\"$ctrl.ngModel[key].costObject.check_expired_date_error = {}\" required=\"\"></md-datepicker><div ng-messages=\"$ctrl.ngModel[key].costObject.check_expired_date_error\" role=\"alert\"><div ng-message=\"required\"><span class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\"><div>{{ \'FIELD.RECEIPT_FORMAT\' | translate}}&nbsp;:</div><div flex-gt-xs=\"70\" class=\"p-l-20\"><md-input-container class=\"md-block m-t-0\" flex-gt-sm=\"\"><md-checkbox ng-model=\"$ctrl.ngModel[key].costObject.check_format1\" aria-label=\"Checkbox 1\" ng-disabled=\"$ctrl.ngDisabled\">{{ \'FIELD.RECEIPT_DELINEATE\' | translate}}</md-checkbox><md-checkbox ng-model=\"$ctrl.ngModel[key].costObject.check_format2\" aria-label=\"Checkbox 1\" ng-disabled=\"$ctrl.ngDisabled\">{{ \'FIELD.ENDORSEMENT_OR_TRANSFERENCE_PROHIBITED\' | translate}}</md-checkbox></md-input-container></div></div></div></div></div></div>");
$templateCache.put("app/modules/utils/views/learning-report-setting.html","<div layout-gt-xs=\"row\"><div flex-gt-xs=\"\" class=\"m-t-20\"><md-radio-group ng-model=\"$ctrl.ngModel.isNeedReport\" ng-disabled=\"$ctrl.ngDisabled || (!$ctrl.isCanEditSetting)\"><md-radio-button ng-value=\"false\">{{\'FIELD.NO_REPORT\' | translate}}</md-radio-button><md-radio-button ng-value=\"true\">{{\'FIELD.NEED_TO_COMPLETE_REPORT\' | translate}} <span class=\"pt-mark\" ng-if=\"(!$ctrl.isCanEditSetting) && $ctrl.settingRule.isShowReportLowerBound\">({{ \'PLACEHOLDERS.FOR_LESS_THAN_N_THE_FOLLOWING_REPORTS_ARE_NOT_REQUIRED\' | translate: {\'value\': $ctrl.settingRule.submitRptRate} }})</span></md-radio-button></md-radio-group></div></div><div layout-gt-sm=\"column\" class=\"pt-bgGroup p-10 m-b-10\"><div class=\"m-r-20 title-bg\"><md-input-container flex-gt-sm=\"\"><md-checkbox ng-model=\"$ctrl.ngModel.isNeedDocReport\" ng-disabled=\"$ctrl.ngDisabled || (!($ctrl.isCanEditSetting && $ctrl.ngModel.isNeedReport))\">{{ \'FIELD.UPLOAD_REPORT\' | translate}} :</md-checkbox></md-input-container></div><div class=\"m-l-10\"><div layout-gt-sm=\"column\"><div>{{ \'FIELD.NEED_TO_SUBMIT\' | translate}}<div flex-xs=\"20\" flex-gt-sm=\"20\" class=\"el-inBlock\"><md-input-container flex-gt-sm=\"\"><input ng-model=\"$ctrl.ngModel.numOfDocReport\" ng-disabled=\"$ctrl.ngDisabled || (!( $ctrl.ngModel.isNeedReport && $ctrl.isCanEditSetting && $ctrl.ngModel.isNeedDocReport))\"></md-input-container></div>{{ \'FIELD.PART\' | translate}}{{ \'FIELD.LEARNING_REPORT\' | translate}}</div></div><div><div layout-sm=\"row\" layout-gt-sm=\"row\"><span class=\"m-t-20\"><span class=\"pt-mark\" ng-if=\"$ctrl.ngModel.isNeedDocReport\">*</span>{{ \'FIELD.SUBMIT_DEADLINE\' | translate}}</span><div flex-sm=\"70\" flex-gt-sm=\"50\"><md-input-container md-no-float=\"\"><md-datepicker ng-model=\"$ctrl.ngModel.docReportDeadLine\" placeholder=\"{{ \'FIELD.SUBMIT_DEADLINE\' | translate}}\" ng-required=\"$ctrl.ngModel.isNeedReport && $ctrl.ngModel.isNeedDocReport\" ng-disabled=\"$ctrl.ngDisabled || (!( $ctrl.ngModel.isNeedReport && $ctrl.isCanEditSetting && $ctrl.ngModel.isNeedDocReport))\"></md-datepicker></md-input-container></div></div></div></div></div><div layout-gt-sm=\"column\" class=\"pt-bgGroup p-10 m-b-10\"><div class=\"m-r-20 title-bg\"><md-input-container flex-gt-sm=\"\"><md-checkbox ng-model=\"$ctrl.ngModel.isNeedOralReport\" ng-disabled=\"$ctrl.ngDisabled || (!($ctrl.isCanEditSetting && $ctrl.ngModel.isNeedReport))\">{{ \'FIELD.ORAL_REPORT\' | translate}} :</md-checkbox></md-input-container></div><div><div layout-gt-sm=\"row\"><div flex-gt-sm=\"60\"><div layout-sm=\"row\" layout-gt-sm=\"row\"><span class=\"m-t-20\"><span class=\"pt-mark\" ng-if=\"$ctrl.ngModel.isNeedOralReport\">*</span>{{ \'FIELD.REPORT_DEADLINE\' | translate}}</span><div flex-sm=\"70\" flex-gt-sm=\"auto\"><md-input-container md-no-float=\"\"><md-datepicker ng-model=\"$ctrl.ngModel.oralReportDeadLine\" placeholder=\"{{ \'FIELD.REPORT_DEADLINE\' | translate}}\" ng-required=\"$ctrl.ngModel.isNeedReport && $ctrl.ngModel.isNeedOralReport\" ng-disabled=\"$ctrl.ngDisabled || (!( $ctrl.ngModel.isNeedReport && $ctrl.isCanEditSetting && $ctrl.ngModel.isNeedOralReport))\"></md-datepicker></md-input-container></div></div></div><div flex-gt-sm=\"40\" class=\"p-l-20\"><md-input-container flex-gt-sm=\"\"><md-checkbox ng-model=\"$ctrl.ngModel.isOralReportNeedGrade\" ng-disabled=\"$ctrl.ngDisabled || (!( $ctrl.ngModel.isNeedReport && $ctrl.isCanEditSetting && $ctrl.ngModel.isNeedOralReport))\">{{ \'FIELD.SCORE_TO_BE_APPROVED\' | translate}}</md-checkbox></md-input-container></div></div></div></div><div layout-gt-sm=\"column\" class=\"pt-bgGroup p-10 m-b-10\"><div class=\"m-r-20 title-bg\"><md-input-container><md-checkbox ng-model=\"$ctrl.ngModel.isNeedTeaching\" ng-disabled=\"$ctrl.ngDisabled || (!($ctrl.isCanEditSetting && $ctrl.ngModel.isNeedReport))\">{{ \'FIELD.INTERNAL_LECTURE\' | translate}} :</md-checkbox></md-input-container></div><div><div layout-gt-sm=\"row\"><div flex-gt-sm=\"60\"><div layout-sm=\"row\" layout-gt-sm=\"row\"><span class=\"m-t-20\"><span class=\"pt-mark\" ng-if=\"$ctrl.ngModel.isNeedTeaching\">*</span>{{ \'FIELD.LECTURE_DEADLINE\' | translate}}</span><div flex-sm=\"70\" flex-gt-sm=\"auto\"><md-input-container md-no-float=\"\"><md-datepicker ng-model=\"$ctrl.ngModel.teachingDeadLine\" placeholder=\"{{ \'FIELD.LECTURE_DEADLINE\' | translate}}\" ng-required=\"$ctrl.ngModel.isNeedReport && $ctrl.ngModel.isNeedTeaching\" ng-disabled=\"$ctrl.ngDisabled || (!( $ctrl.ngModel.isNeedReport && $ctrl.isCanEditSetting && $ctrl.ngModel.isNeedTeaching))\"></md-datepicker></md-input-container></div></div></div><div flex-gt-sm=\"40\" class=\"p-l-20\"><md-input-container flex-gt-sm=\"\"><md-checkbox ng-model=\"$ctrl.ngModel.isTeachingNeedGrade\" ng-disabled=\"$ctrl.ngDisabled || (!($ctrl.ngModel.isNeedReport && $ctrl.isCanEditSetting && $ctrl.ngModel.isNeedTeaching))\">{{ \'FIELD.SCORE_TO_BE_APPROVED\' | translate}}</md-checkbox></md-input-container></div></div></div></div><div layout-gt-sm=\"column\" class=\"pt-bgGroup p-10\"><div class=\"m-r-20 title-bg\"><md-input-container><md-checkbox ng-model=\"$ctrl.ngModel.isNeedOther\" ng-disabled=\"$ctrl.ngDisabled || (!($ctrl.isCanEditSetting && $ctrl.ngModel.isNeedReport))\">{{ \'FIELD.OTHER_METHOD\' | translate}} :</md-checkbox></md-input-container></div><div><md-input-container class=\"md-block\" md-no-float=\"\"><input ng-model=\"$ctrl.ngModel.otherReportWay\" placeholder=\"{{ \'FIELD.FILL_IN_OTHER_METHOD\' | translate}}\" ng-required=\"$ctrl.ngModel.isNeedReport && $ctrl.ngModel.isNeedOther\" ng-disabled=\"$ctrl.ngDisabled || (!( $ctrl.ngModel.isNeedReport && $ctrl.isCanEditSetting && $ctrl.ngModel.isNeedOther))\"></md-input-container></div></div>");
$templateCache.put("app/modules/utils/views/md-time-select.html","<ng-switch on=\"$ctrl.type\"><md-select flex=\"\" ng-switch-when=\"hours\" ng-model=\"$ctrl.ngModel\"><md-option ng-repeat=\"hour in $ctrl.hours\" ng-disabled=\"$index < $ctrl.hours.indexOf($ctrl.min)\" ng-value=\"$index\">{{hour | displayMinNumber:2}}</md-option></md-select><md-select flex=\"\" ng-switch-when=\"minute\" ng-model=\"$ctrl.ngModel\"><md-option ng-repeat=\"minute in $ctrl.minutes\" ng-disabled=\"$index < $ctrl.minutes.indexOf($ctrl.min)\" ng-value=\"$index\">{{minute | displayMinNumber:2}}</md-option></md-select></ng-switch>");
$templateCache.put("app/modules/utils/views/member-selection-dialog.html","<md-dialog aria-label=\"material virtual repeater\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'ACTIONS.ADD_APPLY_MEMBER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\"><div class=\"lightBox Box-assign\"><div class=\"box-content checkboxdemoSyncing\"><md-content class=\"md-padding autocomplete\" layout=\"column\"><md-person-chips ng-model=\"$ctrl.selectPersonModel1\" md-persons=\"$ctrl.delayedQuerySearch($query)\" md-person-name=\"fullName\" md-person-group=\"groupName\" md-person-is-gray=\"isGray\" md-require-match=\"true\" md-highlight-flags=\"i\" selected-persons=\"$ctrl.selectMembers\" filter-selected=\"true\" placeholder=\"{{ \'PLACEHOLDERS.PLEASE_ENTER_THE_STUDENT_NAME\' | translate}}\"></md-person-chips></md-content><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.isDirectMembers=!($ctrl.isDirectMembers);\">{{ \'FIELD.LIST_MY_GROUP_MEMBERS\' | translate}}</md-button><div layout=\"row\" layout-wrap=\"\" flex=\"\" ng-if=\"$ctrl.isDirectMembers\"><div ng-if=\"$ctrl.members.length <= 100\" ng-repeat=\"member in $ctrl.members track by $index\" layout=\"column\"><md-checkbox class=\"m-r-20\" ng-click=\"$ctrl.optionsToggle(member);\" ng-disabled=\"member.isGray\" ng-checked=\"$ctrl.memberIsChecked(member)\">{{member.fullName}}</md-checkbox></div><div class=\"virtualRepeatdemoVerticalUsage\" ng-if=\"$ctrl.members.length > 100\"><md-virtual-repeat-container id=\"vertical-container\"><div md-virtual-repeat=\"member in $ctrl.members\" class=\"repeated-item\" flex=\"\" layout=\"column\" md-item-size=\"10\"><md-checkbox class=\"m-r-20\" ng-click=\"$ctrl.optionsToggle(member);\" ng-disabled=\"member.isGray\" ng-checked=\"$ctrl.memberIsChecked(member)\">{{member.fullName}}</md-checkbox></div></md-virtual-repeat-container></div></div><div class=\"box-content md-assign\" ng-if=\"$ctrl.selectMembers.length > 0\"><p>{{ \'FIELD.YOU_HAVE_SELECTED_MEMBERS\' | translate}}</p><div class=\"pt-assign\"><span ng-repeat=\"selectedPerson in $ctrl.selectMembers\">{{selectedPerson.fullName}}</span></div></div></div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.submit()\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/utils/views/multi-checkbox.html","<md-checkbox ng-repeat=\"data in $ctrl.datas\" ng-click=\"$ctrl.toggle(data[$ctrl.valueKey]);\" ng-checked=\"$ctrl.ngModel.indexOf(data[$ctrl.valueKey]) > -1\" ng-disabled=\"$ctrl.ngDisabled\">{{data[$ctrl.titleKey]}}</md-checkbox>");
$templateCache.put("app/modules/utils/views/multi-date-picker-ctrl.html","<div layout=\"row\" ng-repeat=\"date in $ctrl.ngModel track by $index\"><md-input-container class=\"md-block m-t-0 m-b-0\" md-no-float=\"\"><md-datepicker ng-model=\"$ctrl.ngModel[$index]\" md-placeholder=\"Enter date\" ng-required=\"$ctrl.ngRequired\"></md-datepicker></md-input-container><div class=\"el-inBlock m-l-10 m-r-10\" ng-if=\"$ctrl.ngModel.length !== 1\"><button type=\"button\" title=\"{{ \'ACTIONS.REMOVE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-danger\" ng-click=\"$ctrl.remove($index)\"><i class=\"fa fa-minus\"></i><div class=\"ripple-wrapper\"></div></button></div><div class=\"el-inBlock m-l-10 m-r-10\" ng-if=\"($index+1) === $ctrl.ngModel.length\"><button type=\"button\" title=\"{{ \'ACTIONS.ADD\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" ng-click=\"$ctrl.add($index)\"><i class=\"fa fa-plus\"></i><div class=\"ripple-wrapper\"></div></button></div></div>");
$templateCache.put("app/modules/utils/views/select-classification.html","<md-input-container class=\"md-block m-t-0\" ng-if=\"!$ctrl.onlyText\" md-no-float=\"\"><md-select ng-model=\"$ctrl.ngModel\" ng-disabled=\"$ctrl.ngDisabled\" placeholder=\"{{ \'PLACEHOLDERS.PLEASE_SELECT_A_CATEGORY\' | translate}}\"><md-option><em>None</em></md-option><md-option ng-repeat=\"classification in $ctrl.classifications\" ng-value=\"classification.id\">{{classification.name}}</md-option></md-select></md-input-container><span ng-if=\"$ctrl.onlyText\" ng-repeat=\"classification in $ctrl.classifications | filterBy: [\'id\']: $ctrl.ngModel :true\">{{classification.name}}</span>");
$templateCache.put("app/modules/utils/views/select-ctl.html","<md-input-container class=\"md-block m-t-0\" ng-if=\"!$ctrl.onlyText\" md-no-float=\"\"><md-select ng-model=\"$ctrl.ngModel\" ng-disabled=\"$ctrl.ngDisabled\" placeholder=\"{{ \'PLACEHOLDERS.PLEASE_SELECT_A_CATEGORY\' | translate}}\"><md-option ng-repeat=\"data in $ctrl.datas\" ng-value=\"data.value\" ng-selected=\"data.selected === 1\">{{data.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/modules/utils/views/select-currency.html","<md-select ng-model=\"$ctrl.ngModel\" ng-disabled=\"$ctrl.ngDisabled\"><md-option ng-repeat=\"currency in $ctrl.currencys\" ng-value=\"currency.currencyId\">{{currency.currencyName}}</md-option></md-select>");
$templateCache.put("app/modules/utils/views/select-external-class.html","<script type=\"text/ng-template\" id=\"select-external-class-wizard.html\"><div ng-transclude></div></script><script type=\"text/ng-template\" id=\"select-external-class-step.html\"><div ng-show=\"selected\" ng-transclude></div></script><md-dialog aria-label=\"\" flex=\"30\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"$ctrl.currentStep === 1\">{{ \'ACTIONS.SELECT_COURSE\' | translate}}</h2><h2 ng-if=\"$ctrl.currentStep === 2\">{{ \'ACTIONS.SELECT_CLASS\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-tooltip md-direction=\"bottom\">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><wizard name=\"selectExternalClass\" on-finish=\"$ctrl.updateModel()\" template=\"select-external-class-wizard.html\"><wz-step template=\"select-external-class-step.html\" wz-title=\"\" canexit=\"$ctrl.canExitStep1\"><choice-external-courses display-type=\"list\" ng-model=\"$ctrl.choiceCourseId\"></choice-external-courses></wz-step><wz-step template=\"select-external-class-step.html\" wz-title=\"\" canexit=\"true\"><choice-external-course-sessions display-type=\"list\" course-id=\"$ctrl.choiceCourseId\" ng-model=\"$ctrl.choiceSessionId\" params=\"{externalId: $ctrl.externalId, applicantId: $ctrl.applicantId}\"></choice-external-course-sessions></wz-step></wizard></md-content></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.nextStep()\" ng-if=\"$ctrl.currentStep < $ctrl.totalStep\">{{ \'ACTIONS.NEXT_STEP\' | translate}}<md-icon md-font-set=\"md\">keyboard_arrow_right</md-icon></md-button><md-button class=\"md-raised md-warn md-btn btn-transparent\" type=\"button\" ng-click=\"$ctrl.previousStep()\" ng-if=\"$ctrl.currentStep !== 1\"><md-icon md-font-set=\"md\">keyboard_arrow_left</md-icon>{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.finishStep()\" ng-if=\"$ctrl.currentStep === $ctrl.totalStep\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/utils/views/select-external-training-vendors.html","<md-input-container class=\"md-block m-t-0\" ng-if=\"!$ctrl.onlyText\"><label></label><md-chips name=\"vendors\" class=\"md-contact-chips\" ng-model=\"$ctrl.ngModel\" md-require-match=\"true\" ng-required=\"$ctrl.required\" md-on-add=\"$ctrl.removeDuplicatedVendor($chip)\" md-removable=\"!$ctrl.ngDisabled\" md-autocomplete-snap=\"\" md-autocomplete-wrap-override=\"\"><md-autocomplete ng-disabled=\"$ctrl.inputDisabled\" md-menu-class=\"md-contact-chips-suggestions\" md-selected-item=\"$ctrl.selectedVendor\" md-search-text=\"$ctrl.searchTerm\" md-items=\"vendor in $ctrl.queryVendors($ctrl.searchTerm)\" md-item-text=\"vendor.vendorName\" md-no-cache=\"true\" md-autoselect=\"\" placeholder=\"{{\'PLACEHOLDERS.PLEASE_ENTER_KEYWORDS\' | translate}},{{ \'PLACEHOLDERS.SEARCH_FOR_A_VENDORS\' | translate}}\"><md-item-template><span>{{vendor.vendorName}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip.vendorName}}</span></md-chip-template></md-chips></md-input-container><div ng-if=\"$ctrl.onlyText\" ng-repeat=\"model in $ctrl.ngModel\"><span ng-repeat=\"val in $ctrl.vendors | filterBy: [\'vendorId\']: model\" ng-if=\"val.vendorId | isEqualTo: model\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"26\" params=\"{\'vendorId\': val.vendorId, \'vendorType\': $ctrl.vendorType}\">{{val.vendorName}}</a></span></div>");
$templateCache.put("app/modules/utils/views/square-text.html","<div class=\"li-icon\" ng-style=\"{width: $ctrl.width + \'px\', height: $ctrl.height + \'px\', background: $ctrl.color}\"><span ng-style=\"{\'font-size\': $ctrl.fontSize + \'px\'}\">{{$ctrl.text |translate}}</span></div>");
$templateCache.put("app/modules/utils/views/tip-info-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\" ng-switch=\"$ctrl.tipType\"><h2 ng-switch-when=\"1\">{{ \'FIELD.COURSE_INFO\' | translate}}</h2><h2 ng-switch-when=\"2\">{{ \'FIELD.SESSION_INFO\' | translate}}</h2><h2 ng-switch-when=\"3\">{{ \'PROGRAM_INFO\' | translate}}</h2><h2 ng-switch-when=\"4\">{{ \'FIELD.SESSION_INFO\' | translate}}</h2><h2 ng-switch-when=\"5\">{{ \'FIELD.EXTERNAL_TRAINING_APPLY_DETAIL\' | translate}}</h2><h2 ng-switch-when=\"6\">{{ \'FIELD.SESSION_INFO\' | translate}}</h2><h2 ng-switch-when=\"7\">{{ \'CERTIFICATE_INFO_DETAIL\' | translate}}</h2><h2 ng-switch-when=\"13\">{{ \'FIELD.COURSE_INFO\' | translate}}</h2><h2 ng-switch-when=\"16\">{{ \'FIELD.COURSE_INFO\' | translate}}</h2><h2 ng-switch-when=\"17\">{{ \'FIELD.COURSE_INFO\' | translate}}</h2><h2 ng-switch-when=\"18\">{{ \'CERTIFICATE_INFO_DETAIL\' | translate}}</h2><h2 ng-switch-when=\"19\">{{ \'FIELD.SESSION_INFO\' | translate}}</h2><h2 ng-switch-when=\"20\">{{ \'FIELD.SESSION_INFO\' | translate}}</h2><h2 ng-switch-when=\"26\">{{ \'FIELD.COMPANY_DETAIL\' | translate}}</h2><h2 ng-switch-default=\"\">{{ \'FIELD.COURSE_INFO_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\" class=\"hidden-x-scrollbar\"><div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><div class=\"lightBox Box-billboard\"><header><h4>{{ $ctrl.displayName }}</h4></header><div class=\"box-content\"><table style=\"width: 100%;\"><tbody><tr ng-repeat=\"tipInfo in $ctrl.tipInfos\" ng-if=\"tipInfo.data !== \'\' && (tipInfo.data | htmlEscapedDecode | trim ).length > 0\"><th width=\"20%\">{{tipInfo.rcValue}}&nbsp;:</th><td><div ng-if=\"tipInfo.rcKey === \'responsible_division\'\"><span ng-repeat=\"dataDetailInfo in tipInfo.dataDetailInfo\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"26\" params=\"{\'vendorId\': dataDetailInfo.id, \'vendorType\': 2}\">{{dataDetailInfo.value}}</a></span> <span ng-if=\"tipInfo.dataDetailInfo.length === 0\">{{ tipInfo.data}}</span></div><div ng-if=\"tipInfo.rcKey === \'external_ref_link\'\"><span ng-repeat=\"dataDetailInfo in tipInfo.dataDetailInfo\"><a ng-href=\"{{dataDetailInfo.value | trustAsResourceUrl}}\" target=\"_blank\">{{dataDetailInfo.value}}</a></span> <span ng-if=\"tipInfo.dataDetailInfo.length === 0\">{{ tipInfo.data}}</span></div><div ng-if=\"tipInfo.rcKey === \'external_refs\'\"><span ng-repeat=\"dataDetailInfo in tipInfo.dataDetailInfo\"><a href=\"javascript:void(0);\" external-reference-servlet=\"\" external-id=\"dataDetailInfo.id\" num=\"dataDetailInfo.property1\">{{dataDetailInfo.value}}</a><br></span> <span ng-if=\"tipInfo.dataDetailInfo.length === 0\">{{ tipInfo.data}}</span></div><div ng-if=\"tipInfo.rcKey === \'table_header_difficulty\'\"><span ng-repeat=\"dataDetailInfo in tipInfo.dataDetailInfo\"><ng-rate-it ng-model=\"dataDetailInfo.value\" read-only=\"true\"></ng-rate-it></span></div><div ng-if=\"tipInfo.rcKey === \'reference_files\' || tipInfo.rcKey === \'References\'\"><div ng-repeat=\"dataDetailInfo in tipInfo.dataDetailInfo\"><a href=\"javascript:void(0)\" view-ctms-reference=\"\" package-id=\"dataDetailInfo.id\" file-name=\"dataDetailInfo.property1\">{{dataDetailInfo.value}}</a></div></div><div ng-if=\"tipInfo.rcKey === \'prerequisite_item\'\"><span ng-repeat=\"dataDetailInfo in tipInfo.dataDetailInfo\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"{{dataDetailInfo.property1}}\" params=\"{id: dataDetailInfo.id}\">{{dataDetailInfo.value | markSplit:$index:\',\'}}</a></span></div><div ng-if=\"tipInfo.rcKey !== \'responsible_division\' && tipInfo.rcKey !== \'external_ref_link\' && tipInfo.rcKey !== \'external_refs\' && tipInfo.rcKey !== \'table_header_difficulty\' && tipInfo.rcKey !== \'reference_files\' && tipInfo.rcKey !== \'References\' && tipInfo.rcKey !== \'prerequisite_item\'\"><span class=\"break-line-text\" ng-bind-html=\"tipInfo.data\"></span></div></td></tr></tbody></table></div></div></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/utils/views/upload-course-data-files.html","<div ng-repeat=\"file in $ctrl.files\" ng-class=\"{\'m-t-20\' : $index > 0}\"><div ng-if=\"!$ctrl.externalTrainingVendors\" class=\"rectangle m-b-10\">{{ \'FIELD.COURSE_DATA\' | translate}} {{($index+1)}}</div><div ng-if=\"$ctrl.externalTrainingVendors\" class=\"rectangle m-b-10\">{{ \'FIELD.REFERENCE_DOCUMENT\' | translate}} {{($index+1)}}</div><div class=\"p-10 pt-bgGroup\"><div ng-if=\"!$ctrl.refsObject[$index]\"><input type=\"file\" ngf-select=\"$ctrl.selectFile($index, $files)\" ngf-multiple=\"$ctrl.isMultiple\" ng-disabled=\"$ctrl.ngDisabled\"></div><div ng-if=\"$ctrl.refsObject[$index]\"><span ng-if=\"!$ctrl._files[$index]\"><a href=\"javascript:void(0);\" external-reference-servlet=\"\" external-id=\"$ctrl.externalId\" num=\"$ctrl.refsObject[$index].num\">{{$ctrl.refsObject[$index].fileName}}</a></span> <span ng-if=\"$ctrl._files[$index]\">{{$ctrl._files[$index].name}}</span><div ng-if=\"!$ctrl.ngDisabled\"><span class=\"btn btn-primary btn-file\"><span class=\"fileinput-new\"><i class=\"material-icons\">add_circle</i>{{ \'ACTIONS.REPLACE_FILES\' | translate}}</span> <input type=\"file\" ngf-select=\"$ctrl.replaceFile($index, $files)\" ngf-multiple=\"$ctrl.isMultiple\"></span></div></div></div><div class=\"text-center\"><div class=\"el-inBlock m-l-10 m-r-10\" ng-if=\"(($index+1)===$ctrl.files.length) && ($ctrl.maxCount === -1 || (($index+1) < $ctrl.maxCount))\"><button type=\"button\" title=\"{{ \'ACTIONS.ADD_FILE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" ng-click=\"$ctrl.addFileSelect($index)\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"fa fa-plus\"></i><div class=\"ripple-wrapper\"></div></button></div><div class=\"el-inBlock m-l-10 m-r-10\" ng-if=\"file > 0 && (($index+1)===$ctrl.files.length)\"><button type=\"button\" title=\"{{ \'ACTIONS.DELETE_FILE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-danger\" ng-click=\"$ctrl.removeFileSelect($index)\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"fa fa-trash-o\"></i><div class=\"ripple-wrapper\"></div></button></div></div></div>");
$templateCache.put("app/modules/utils/views/upload-refs.html","<div ng-repeat=\"file in $ctrl.files\" ng-class=\"{\'m-t-20\' : $index > 0}\"><div class=\"rectangle m-b-10\">{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} {{($index+1)}}</div><div class=\"p-10 pt-bgGroup\"><div ng-if=\"!$ctrl.refsObject[$index]\"><input type=\"file\" ngf-select=\"$ctrl.selectFile($index, $files)\" ngf-multiple=\"$ctrl.isMultiple\" ng-disabled=\"$ctrl.ngDisabled\"></div><div ng-if=\"$ctrl.refsObject[$index]\"><span ng-if=\"!$ctrl._files[$index]\"><a href=\"javascript:void(0);\" view-ctms-reference=\"\" package-id=\"$ctrl.refsObject[$index].packageId\" item-section=\"$ctrl.refsObject[$index].itemSection\" file-name=\"$ctrl.refsObject[$index].systemFileName\">{{$ctrl.refsObject[$index].fileName}}</a></span> <span ng-if=\"$ctrl._files[$index]\">{{$ctrl._files[$index].name}}</span><div ng-if=\"!$ctrl.ngDisabled\"><span class=\"btn btn-primary btn-file\"><span class=\"fileinput-new\"><i class=\"material-icons\">add_circle</i>{{ \'ACTIONS.REPLACE_FILES\' | translate}}</span> <input type=\"file\" ngf-select=\"$ctrl.replaceFile($index, $files)\" ngf-multiple=\"$ctrl.isMultiple\"></span></div></div></div><div class=\"text-center\"><div class=\"el-inBlock m-l-10 m-r-10\" ng-if=\"(($index+1)===$ctrl.files.length) && ($ctrl.maxCount === -1 || (($index+1) < $ctrl.maxCount))\"><button type=\"button\" title=\"{{ \'ACTIONS.ADD_FILE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" ng-click=\"$ctrl.addFileSelect($index)\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"fa fa-plus\"></i><div class=\"ripple-wrapper\"></div></button></div><div class=\"el-inBlock m-l-10 m-r-10\" ng-if=\"file > 0 && (($index+1)===$ctrl.files.length)\"><button type=\"button\" title=\"{{ \'ACTIONS.DELETE_FILE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-danger\" ng-click=\"$ctrl.removeFileSelect($index)\" ng-if=\"!$ctrl.ngDisabled\"><i class=\"fa fa-trash-o\"></i><div class=\"ripple-wrapper\"></div></button></div></div></div>");
$templateCache.put("app/kernel/ui-elements/angular-clock/views/clock-template.html","<span ng-if=\"onlyText\">{{digital}}</span><div class=\"widget-clock\" ng-class=\"themeClass\" ng-if=\"date && !onlyText\"><div class=\"digital\" ng-if=\"digital\"><span class=\"time\"><span class=\"hours\">{{digital}}</span></span></div><div class=\"analog\" ng-if=\"analog\"><div class=\"square\"><svg viewbox=\"0 0 100 100\"><g transform=\"translate(50,50)\"><circle class=\"clock-face\" r=\"48\"></circle><line ng-repeat=\"minor in minors track by $index\" class=\"minor\" y1=\"42\" y2=\"45\" ng-attr-transform=\"rotate({{360 * $index / minors.length}})\"></line><line ng-repeat=\"major in majors track by $index\" class=\"major\" y1=\"35\" y2=\"46\" ng-attr-transform=\"rotate({{360 * $index / majors.length}})\"></line><line class=\"hour\" y1=\"2\" y2=\"-20\" ng-attr-transform=\"rotate({{30 * date.hrs + date.mins / 2}})\"></line><line class=\"minute\" y1=\"4\" y2=\"-30\" ng-attr-transform=\"rotate({{6 * date.mins + date.secs / 10}})\"></line><g ng-attr-transform=\"rotate({{6 * date.secs}})\"><line class=\"second\" y1=\"10\" y2=\"-38\"></line><line class=\"second-counterweight\" y1=\"10\" y2=\"2\"></line></g></g></svg></div></div><div ng-if=\"gmtInfo\" class=\"gmt-info\">{{gmtInfo}}</div></div>");
$templateCache.put("app/kernel/ui-elements/cus-rate-it/views/cus-rate-it.html","<div class=\"ngrateit ngrateit-readonly\"><div class=\"ngrateit-rating\"><span ng-repeat=\"i in $ctrl.ratesArray track by $index\" class=\"ngrateit-star ngrateit-bg-star rateit\" ng-class=\"{\'ngrateit-selected\': $ctrl.isSelected($index) }\" ng-style=\"{\'width\': (16*$ctrl.step) + \'px\', \'height\': $ctrl.height + \'px\', \'background-position\': $ctrl.getStarOffset($index) + \'px 0\'}\"></span></div></div>");
$templateCache.put("app/kernel/ui-elements/md-date-pickers/views/calendar.template.html","<div class=\"mdp-calendar\"><div layout=\"row\" layout-align=\"space-between center\"><md-button aria-label=\"previous month\" class=\"md-icon-button\" ng-click=\"calendar.prevMonth()\"><md-icon md-svg-icon=\"mdp-chevron-left\"></md-icon></md-button><div class=\"mdp-calendar-monthyear\" ng-show=\"!calendar.animating\">{{ calendar.date.format(\"MMMM YYYY\") }}</div><md-button aria-label=\"next month\" class=\"md-icon-button\" ng-click=\"calendar.nextMonth()\"><md-icon md-svg-icon=\"mdp-chevron-right\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"space-around center\" class=\"mdp-calendar-week-days\" ng-show=\"!calendar.animating\"><div layout=\"\" layout-align=\"center center\" ng-repeat=\"d in calendar.weekDays track by $index\">{{ d }}</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\" class=\"mdp-calendar-days\" ng-class=\"{ \'mdp-animate-next\': calendar.animating }\" ng-show=\"!calendar.animating\" md-swipe-left=\"calendar.nextMonth()\" md-swipe-right=\"calendar.prevMonth()\"><div layout=\"\" layout-align=\"center center\" ng-repeat-start=\"day in calendar.daysInMonth track by $index\" ng-class=\"{ \'mdp-day-placeholder\': !day }\"><md-button class=\"md-icon-button md-raised\" aria-label=\"Select day\" ng-if=\"day\" ng-class=\"{ \'md-accent\': calendar.date.date() == day.value }\" ng-click=\"calendar.selectDate(day.value)\" ng-disabled=\"!day.enabled\">{{ day.value }}</md-button></div><div flex=\"100\" ng-if=\"($index + 1) % 7 == 0\" ng-repeat-end=\"\"></div></div></div>");
$templateCache.put("app/kernel/ui-elements/pagination/views/ui-pagination-header.tpl.html","<div ng-init=\"query = {}\"><div class=\"chat-search\" ng-if=\"hasSearchBox\"><form class=\"form-inverse\" ng-submit=\"search()\" role=\"search\"><div class=\"append-icon\"><input type=\"text\" ng-model=\"query.keywords\" class=\"form-control\" placeholder=\"{{placeholder}}\"> <i class=\"icon-magnifier\"></i><i class=\"icon-magnifier\" ng-click=\"search()\"></i></div></form></div></div><div class=\"seqBox\"><div class=\"seq\" ng-if=\"sorts.length > 0\"><span><i class=\"fa fa-exchange fa-rotate-90\"></i>{{ \'ACTIONS.SORT\' | translate}} :</span><ul><li ng-repeat=\"sort in sorts\" ng-class=\"{\'active\': paginationSort.sortKey===sort.key }\"><a href=\"\" ng-click=\"setSort(sort.key, sort.order);\">{{sort.name | translate}} <i class=\"fa\" ng-class=\"{ \'fa-sort-asc\': paginationSort.sortMethod===\'ASC\' && paginationSort.sortKey===sort.key, \'fa-sort-desc\': paginationSort.sortMethod===\'DESC\' && paginationSort.sortKey===sort.key }\" aria-hidden=\"true\"></i></a></li></ul></div><div class=\"seq\" ng-if=\"filters.length > 0\"><span><i class=\"fa fa-filter\"></i>{{ \'ACTIONS.FILTERS\' | translate}} :</span><ul><li ng-repeat=\"filter in filters\" permission=\"\" permission-only=\"filter.permissions\" ng-class=\"{\'active\': (paginationFilter.filterKey === filter.key && paginationFilter.filterValue === filter.value) }\"><a href=\"\" ng-click=\"setFilter(filter.key, filter.value);\">{{filter.name | translate}}</a></li></ul></div><div class=\"array\" ng-if=\"hasChangeTemplate\"><span>{{ \'ACTIONS.SORT_METHOD\' | translate}} :</span><ul><li ng-click=\"templateChange(\'card\')\" ng-class=\"{\'active\': templateType === \'card\'}\"><a><i class=\"material-icons\">view_module</i></a></li><li ng-click=\"templateChange(\'list\')\" ng-class=\"{\'active\': templateType === \'list\'}\"><a><i class=\"material-icons\">view_stream</i></a></li></ul></div></div>");
$templateCache.put("app/kernel/ui-elements/pagination/views/ui-pagination.tpl.html","<div class=\"pagination2\"><ul class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" ng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.last)\">&raquo;</a></li></ul></div><div class=\"pageTotal\">{{ \'FIELD.TOTAL\' | translate}}<span class=\"mark\">{{range.total}}</span>{{ \'FIELD.NUMBER_OF\' | translate}} | {{ \'FIELD.PER_PAGE\' | translate}}<div class=\"dataTables_length\"><md-select ng-model=\"pagination.perPage\" ng-change=\"setItemsPerPage(pagination.perPage)\" aria-label=\"Select\" ng-if=\"canSelectOption\"><md-option ng-repeat=\"state in units\" value=\"{{state.id}}\">{{state.id}}</md-option></md-select><span ng-if=\"!canSelectOption\">{{pagination.perPage}}</span></div>{{ \'FIELD.NUMBER_OF\' | translate}}</div>");
$templateCache.put("app/kernel/ui-elements/table/views/filterRow.html","<tr ng-show=\"show_filter\" class=\"ng-table-filters\"><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=\"$column.show(this)\" class=\"filter {{$column.class(this)}}\" ng-class=\"params.settings().filterOptions.filterLayout === \'horizontal\' ? \'filter-horizontal\' : \'\'\"><div ng-repeat=\"(name, filter) in $column.filter(this)\" ng-include=\"config.getTemplateUrl(filter)\" class=\"filter-cell\" ng-class=\"[getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? \'last\' : \'\']\"></div></th></tr>");
$templateCache.put("app/kernel/ui-elements/table/views/groupRow.html","<tr ng-if=\"params.hasGroup()\" ng-show=\"$groupRow.show\" class=\"ng-table-group-header\"><th colspan=\"{{getVisibleColumns().length}}\" class=\"sortable\" ng-class=\"{ \'sort-asc\': params.hasGroup($selGroup, \'asc\'), \'sort-desc\':params.hasGroup($selGroup, \'desc\') }\"><a href=\"\" ng-click=\"isSelectorOpen = !isSelectorOpen\" class=\"ng-table-group-selector\"><strong class=\"sort-indicator\">{{$selGroupTitle}}</strong> <button class=\"btn btn-default btn-xs ng-table-group-close\" ng-click=\"$groupRow.show = false; $event.preventDefault(); $event.stopPropagation();\"><span class=\"glyphicon glyphicon-remove\"></span></button> <button class=\"btn btn-default btn-xs ng-table-group-toggle\" ng-click=\"toggleDetail(); $event.preventDefault(); $event.stopPropagation();\"><span class=\"glyphicon\" ng-class=\"{ \'glyphicon-resize-small\': params.settings().groupOptions.isExpanded, \'glyphicon-resize-full\': !params.settings().groupOptions.isExpanded }\"></span></button></a><div class=\"list-group\" ng-if=\"isSelectorOpen\"><a href=\"\" class=\"list-group-item\" ng-repeat=\"group in getGroupables()\" ng-click=\"groupBy(group)\"><strong>{{ getGroupTitle(group)}}</strong> <strong ng-class=\"isSelectedGroup(group) && \'sort-indicator\'\"></strong></a></div></th></tr>");
$templateCache.put("app/kernel/ui-elements/table/views/header.html","<ng-table-group-row></ng-table-group-row><ng-table-sorter-row></ng-table-sorter-row><ng-table-filter-row></ng-table-filter-row>");
$templateCache.put("app/kernel/ui-elements/table/views/pager.html","<footer class=\"page\" ng-if=\"params.settings().counts.length\"><div class=\"ng-cloak pagination2\"><ul ng-if=\"pages.length\" class=\"pagination\"><li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\"><a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">&laquo;</a> <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a> <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a> <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a> <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a> <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">&raquo;</a></li></ul></div><div class=\"pageTotal\" ng-if=\"params.settings().counts.length\">{{ \'FIELD.TOTAL\' | translate}}<span class=\"mark\">{{params.settings().total}}</span>{{ \'FIELD.NUMBER_OF\' | translate}} | {{ \'FIELD.PER_PAGE\' | translate}}<div class=\"dataTables_length\" ng-init=\"paramsCount = params.count();\"><md-select ng-model=\"paramsCount\" ng-change=\"params.count(paramsCount)\" aria-label=\"Select\"><md-option ng-repeat=\"count in params.settings().counts\" value=\"{{count}}\">{{count}}</md-option></md-select></div>{{ \'FIELD.NUMBER_OF\' | translate}}</div></footer>");
$templateCache.put("app/kernel/ui-elements/table/views/responsive-row.html","<tr id=\"responsive-child\" class=\"th-child\"><td colspan=\"{{$columns.length}}\"><div class=\"pt-detail\" ng-style=\"{\'display\' : canHideControlColumn ? \'none\': \'\'}\"><ul><li ng-repeat=\"col in ::$columns track by $index\" ng-if=\"col.canHideColumn() && col.show(this) && col.title().length > 0\"><p>{{col.title()}} :</p><div class=\"text\" bind-compiled-html=\"::col.getValue(this, row)\"></div></li></ul></div></td></tr>");
$templateCache.put("app/kernel/ui-elements/table/views/sorterRow.html","<tr class=\"ng-table-sort-header\"><th title=\"{{$column.headerTitle(this)}}\" ng-repeat=\"$column in $columns\" ng-style=\"{ \'width\': $column.minWidth()}\" ng-class=\"{ \'sortable\': $column.sortable(this), \'sort-asc\': (params.sorting()[$column.sortable(this)] | uppercase ) ===\'ASC\', \'sort-desc\': (params.sorting()[$column.sortable(this)] | uppercase ) ===\'DESC\' }\" ng-click=\"tsrc.sortBy($column, $event)\" ng-if=\"$column.show(this) && (!$column.hideColumn(this))\" ng-init=\"template = $column.headerTemplateURL(this)\" class=\"header {{$column.class(this)}}\"><div ng-if=\"!template\" class=\"ng-table-header\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-bind=\"$column.title(this)\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"></span></div><div ng-if=\"template\" ng-include=\"template\"></div></th></tr>");
$templateCache.put("app/kernel/ui-elements/tree/views/menu-tree.html","<script type=\"text/ng-template\" id=\"nodes_renderer.html\">{{node.nodes}} <a href=\"\" ng-if=\"node.nodes.length > 0\"> <span>{{node.title}}</span> <span class=\"fa arrow\" ng-click=\"treeNode.toggle(this)\"></span> </a> <a href=\"\" ng-if=\"node.nodes.length === 0\"> <span>{{node.title}}</span> </a> <ul class=\"children collapse\" ui-tree-nodes=\"\" ng-model=\"node.nodes\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"> </li> </ul></script><div ui-tree=\"\"><ul class=\"nav nav-sidebar\" ui-tree-nodes=\"\" ng-model=\"data\" id=\"tree-root\"><li ng-repeat=\"node in data\" ui-tree-node=\"\" ng-include=\"\'nodes_renderer.html\'\"></li></ul></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendar.html","<div class=\"cal-context\" ng-switch=\"$ctrl.view\" ng-if=\"$ctrl.templatesLoaded\"><div class=\"alert alert-danger\" ng-switch-default=\"\">The value passed to the view attribute of the calendar is not set</div><div class=\"alert alert-danger\" ng-hide=\"$ctrl.viewDate\">The value passed to view-date attribute of the calendar is not set</div><mwl-calendar-year events=\"$ctrl.events\" view-date=\"$ctrl.viewDate\" on-event-click=\"$ctrl.onEventClick\" on-event-times-changed=\"$ctrl.onEventTimesChanged\" on-timespan-click=\"$ctrl.onTimespanClick\" cell-is-open=\"$ctrl.cellIsOpen\" cell-modifier=\"$ctrl.cellModifier\" slide-box-disabled=\"$ctrl.slideBoxDisabled\" custom-template-urls=\"$ctrl.customTemplateUrls\" template-scope=\"$ctrl.templateScope\" cell-auto-open-disabled=\"$ctrl.cellAutoOpenDisabled\" ng-switch-when=\"year\"></mwl-calendar-year><mwl-calendar-month events=\"$ctrl.events\" view-date=\"$ctrl.viewDate\" on-event-click=\"$ctrl.onEventClick\" on-event-times-changed=\"$ctrl.onEventTimesChanged\" on-timespan-click=\"$ctrl.onTimespanClick\" on-date-range-select=\"$ctrl.onDateRangeSelect\" cell-is-open=\"$ctrl.cellIsOpen\" cell-modifier=\"$ctrl.cellModifier\" slide-box-disabled=\"$ctrl.slideBoxDisabled\" custom-template-urls=\"$ctrl.customTemplateUrls\" template-scope=\"$ctrl.templateScope\" cell-auto-open-disabled=\"$ctrl.cellAutoOpenDisabled\" ng-switch-when=\"month\" week-number-label-disabled=\"$ctrl.weekNumberLabelDisabled\"></mwl-calendar-month><mwl-calendar-week events=\"$ctrl.events\" view-date=\"$ctrl.viewDate\" on-event-click=\"$ctrl.onEventClick\" on-event-times-changed=\"$ctrl.onEventTimesChanged\" day-view-start=\"$ctrl.dayViewStart\" day-view-end=\"$ctrl.dayViewEnd\" day-view-split=\"$ctrl.dayViewSplit\" day-view-event-chunk-size=\"$ctrl.dayViewEventChunkSize\" on-timespan-click=\"$ctrl.onTimespanClick\" on-date-range-select=\"$ctrl.onDateRangeSelect\" custom-template-urls=\"$ctrl.customTemplateUrls\" cell-modifier=\"$ctrl.cellModifier\" template-scope=\"$ctrl.templateScope\" ng-switch-when=\"week\"></mwl-calendar-week><mwl-calendar-day events=\"$ctrl.events\" view-date=\"$ctrl.viewDate\" on-event-click=\"$ctrl.onEventClick\" on-event-times-changed=\"$ctrl.onEventTimesChanged\" on-timespan-click=\"$ctrl.onTimespanClick\" on-date-range-select=\"$ctrl.onDateRangeSelect\" day-view-start=\"$ctrl.dayViewStart\" day-view-end=\"$ctrl.dayViewEnd\" day-view-split=\"$ctrl.dayViewSplit\" day-view-event-chunk-size=\"$ctrl.dayViewEventChunkSize\" day-view-event-width=\"$ctrl.dayViewEventWidth\" custom-template-urls=\"$ctrl.customTemplateUrls\" cell-modifier=\"$ctrl.cellModifier\" template-scope=\"$ctrl.templateScope\" ng-switch-when=\"day\"></mwl-calendar-day></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarDayView.html","<div class=\"cal-week-box cal-all-day-events-box\" ng-if=\"$ctrl.allDayEvents.length > 0\"><div class=\"cal-day-panel clearfix\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"cal-row-fluid\"><div class=\"cal-cell-6 day-highlight\" ng-style=\"{backgroundColor: event.color.secondary}\" data-event-class=\"\" ng-repeat=\"event in $ctrl.allDayEvents track by event.calendarEventId\"><strong><span ng-bind=\"event.startsAt | calendarDate:\'datetime\':true\"></span> <span ng-if=\"event.endsAt\">- <span ng-bind=\"event.endsAt | calendarDate:\'datetime\':true\"></span></span></strong> <a href=\"javascript:;\" class=\"event-item\" ng-bind-html=\"$ctrl.calendarEventTitle.dayView(event) | calendarTrustAsHtml\"></a></div></div></div></div></div></div><div class=\"cal-day-box\"><div class=\"cal-day-panel clearfix\" ng-style=\"{height: $ctrl.dayViewHeight + \'px\', minWidth: $ctrl.viewWidth + \'px\'}\"><mwl-calendar-hour-list day-view-start=\"$ctrl.dayViewStart\" day-view-end=\"$ctrl.dayViewEnd\" day-view-split=\"$ctrl.dayViewSplit\" on-timespan-click=\"$ctrl.onTimespanClick\" on-date-range-select=\"$ctrl.onDateRangeSelect\" on-event-times-changed=\"$ctrl.onEventTimesChanged\" view-date=\"$ctrl.viewDate\" custom-template-urls=\"$ctrl.customTemplateUrls\" template-scope=\"$ctrl.templateScope\" cell-modifier=\"$ctrl.cellModifier\"></mwl-calendar-hour-list><div class=\"pull-left day-event day-highlight\" ng-repeat=\"dayEvent in $ctrl.nonAllDayEvents track by dayEvent.event.calendarEventId\" ng-class=\"dayEvent.event.cssClass\" ng-style=\"{ top: dayEvent.top - 1 + \'px\', left: dayEvent.left + 60 + \'px\', height: dayEvent.height + \'px\', width: dayEvent.width + \'px\', backgroundColor: dayEvent.event.color.secondary, borderColor: dayEvent.event.color.primary }\" mwl-draggable=\"dayEvent.event.draggable === true\" axis=\"\'xy\'\" snap-grid=\"{y: $ctrl.dayViewEventChunkSize || 30, x: 50}\" on-drag=\"$ctrl.eventDragged(dayEvent.event, y / 30)\" on-drag-end=\"$ctrl.eventDragComplete(dayEvent.event, y / 30)\" mwl-resizable=\"dayEvent.event.resizable === true && dayEvent.event.endsAt\" resize-edges=\"{top: true, bottom: true}\" on-resize=\"$ctrl.eventResized(dayEvent.event, edge, y / 30)\" on-resize-end=\"$ctrl.eventResizeComplete(dayEvent.event, edge, y / 30)\" tooltip-append-to-body=\"true\"><md-tooltip md-direction=\"left\"><span ng-bind-html=\"$ctrl.calendarEventTitle.dayViewTooltip(dayEvent.event) | calendarTrustAsHtml\"></span></md-tooltip><span class=\"cal-hours\"><span ng-show=\"dayEvent.top == 0\"><span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:\'day\':true\"></span>,</span> <span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:\'time\':true\"></span></span> <a href=\"javascript:;\" class=\"event-item\" ng-click=\"$ctrl.onEventClick({calendarEvent: dayEvent.event})\"><span ng-bind-html=\"$ctrl.calendarEventTitle.dayView(dayEvent.event) | calendarTrustAsHtml\"></span></a> <a href=\"javascript:;\" class=\"event-item-action\" ng-repeat=\"action in dayEvent.event.actions track by $index\" ng-class=\"action.cssClass\" ng-bind-html=\"action.label | calendarTrustAsHtml\" ng-click=\"action.onClick({calendarEvent: dayEvent.event})\"></a></div></div></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarHourList.html","<div class=\"cal-day-panel-hour\"><div class=\"cal-day-hour\" ng-repeat=\"hour in $ctrl.hourGrid track by $index\"><div class=\"cal-day-hour-part\" ng-repeat=\"segment in hour.segments track by $index\" ng-class=\"[{ \'cal-day-hour-part-selected\': $ctrl.dateRangeSelect && $ctrl.dateRangeSelect.startDate <= segment.date && segment.date < $ctrl.dateRangeSelect.endDate }, segment.cssClass]\" ng-click=\"$ctrl.onTimespanClick({calendarDate: segment.date})\" mwl-droppable=\"\" on-drop=\"$ctrl.eventDropped(dropData.event, segment.date)\" mwl-drag-select=\"!!$ctrl.onDateRangeSelect\" on-drag-select-start=\"$ctrl.onDragSelectStart(segment.date)\" on-drag-select-move=\"$ctrl.onDragSelectMove(segment.nextSegmentDate)\" on-drag-select-end=\"$ctrl.onDragSelectEnd(segment.nextSegmentDate)\" ng-if=\"!$ctrl.dayWidth\"><div class=\"cal-day-hour-part-time\"><strong ng-bind=\"segment.date | calendarDate:\'hour\':true\" ng-show=\"segment.isStart\"></strong></div></div><div class=\"cal-day-hour-part\" ng-repeat=\"segment in hour.segments track by $index\" ng-if=\"$ctrl.dayWidth\"><div class=\"cal-day-hour-part-time\"><strong ng-bind=\"segment.date | calendarDate:\'hour\':true\" ng-show=\"segment.isStart\"></strong> &nbsp;</div><div class=\"cal-day-hour-part-spacer\" ng-repeat=\"day in segment.days track by $index\" ng-style=\"{width: $ctrl.dayWidth + \'px\'}\" ng-class=\"[{ \'cal-day-hour-part-selected\': $ctrl.dateRangeSelect && $ctrl.dateRangeSelect.startDate <= day.date && day.date < $ctrl.dateRangeSelect.endDate }, day.cssClass]\" ng-click=\"$ctrl.onTimespanClick({calendarDate: day.date})\" mwl-droppable=\"\" on-drop=\"$ctrl.eventDropped(dropData.event, day.date)\" mwl-drag-select=\"!!$ctrl.onDateRangeSelect\" on-drag-select-start=\"$ctrl.onDragSelectStart(day.date)\" on-drag-select-move=\"$ctrl.onDragSelectMove(day.nextSegmentDate)\" on-drag-select-end=\"$ctrl.onDragSelectEnd(day.nextSegmentDate)\"></div></div></div></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarMonthCell.html","<div mwl-droppable=\"\" on-drop=\"$ctrl.handleEventDrop(dropData.event, day.date, dropData.draggedFromDate)\" mwl-drag-select=\"!!$ctrl.onDateRangeSelect\" on-drag-select-start=\"$ctrl.onDragSelectStart(day)\" on-drag-select-move=\"$ctrl.onDragSelectMove(day)\" on-drag-select-end=\"$ctrl.onDragSelectEnd(day)\" class=\"cal-month-day {{ day.cssClass }}\" ng-class=\"{ \'cal-day-outmonth\': !day.inMonth, \'cal-day-inmonth\': day.inMonth, \'cal-day-weekend\': day.isWeekend, \'cal-day-past\': day.isPast, \'cal-day-today\': day.isToday, \'cal-day-future\': day.isFuture, \'cal-day-selected\': $ctrl.dateRangeSelect && $ctrl.dateRangeSelect.startDate <= day.date && day.date <= $ctrl.dateRangeSelect.endDate, \'cal-day-open\': dayIndex === $ctrl.openDayIndex }\"><small class=\"cal-events-num badge badge-important pull-left\" ng-show=\"day.badgeTotal > 0\" ng-bind=\"day.badgeTotal\"></small> <span class=\"pull-right\" data-cal-date=\"\" ng-click=\"$ctrl.calendarCtrl.dateClicked(day.date)\" ng-bind=\"day.label\"></span><div class=\"cal-day-tick\" ng-show=\"dayIndex === $ctrl.openDayIndex && ($ctrl.cellAutoOpenDisabled || $ctrl.view[$ctrl.openDayIndex].events.length > 0) && !$ctrl.slideBoxDisabled\"><i class=\"glyphicon glyphicon-chevron-up\"></i> <i class=\"fa fa-chevron-up\"></i></div><ng-include src=\"$ctrl.customTemplateUrls.calendarMonthCellEvents || $ctrl.calendarConfig.templates.calendarMonthCellEvents\"></ng-include><div id=\"cal-week-box\" ng-if=\"(!$ctrl.weekNumberLabelDisabled) && $first && rowHovered\"><span ng-bind=\"$ctrl.getWeekNumberLabel(day)\"></span></div></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarMonthCellEvents.html","<div class=\"events-list\" ng-show=\"day.events.length > 0\" style=\"width: 100%;\"><a ng-repeat=\"event in day.events | orderBy:\'startsAt\' track by event.calendarEventId\" href=\"javascript:;\" ng-click=\"$event.stopPropagation(); $ctrl.onEventClick({calendarEvent: event})\" class=\"pull-left event\" ng-class=\"event.cssClass\" ng-style=\"{backgroundColor: event.color.primary}\" ng-mouseenter=\"$ctrl.highlightEvent(event, true)\" ng-mouseleave=\"$ctrl.highlightEvent(event, false)\" tooltip-append-to-body=\"true\" mwl-draggable=\"event.draggable === true\" drop-data=\"{event: event, draggedFromDate: day.date.toDate()}\" ng-if=\"!($index > 4)\"><md-tooltip md-direction=\"top\"><span ng-bind-html=\"$ctrl.calendarEventTitle.monthViewTooltip(event) | calendarTrustAsHtml\"></span></md-tooltip></a> <a href=\"javascript:void(0);\" class=\"more\" style=\"float:right;\" ng-if=\"day.events.length > 5\"><i class=\"material-icons\">more_vert</i></a></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarMonthView.html","<div class=\"cal-row-fluid cal-row-head\"><div class=\"cal-cell1\" ng-repeat=\"day in $ctrl.weekDays track by $index\" ng-bind=\"day\"></div></div><div class=\"cal-month-box\"><div ng-repeat=\"rowOffset in $ctrl.monthOffsets track by rowOffset\" ng-mouseenter=\"rowHovered = true\" ng-mouseleave=\"rowHovered = false\"><div class=\"cal-row-fluid cal-before-eventlist\"><div ng-repeat=\"day in $ctrl.view | calendarLimitTo:7:rowOffset track by $index\" ng-init=\"dayIndex = $ctrl.view.indexOf(day)\" class=\"cal-cell1 cal-cell {{ day.highlightClass }}\" ng-style=\"{backgroundColor: day.backgroundColor}\" ng-click=\"$ctrl.dayClicked(day, false, $event)\" ng-class=\"{pointer: day.events.length > 0}\"><ng-include src=\"$ctrl.customTemplateUrls.calendarMonthCell || $ctrl.calendarConfig.templates.calendarMonthCell\"></ng-include></div></div><mwl-calendar-slide-box is-open=\"$ctrl.openRowIndex === $index && ($ctrl.cellAutoOpenDisabled || $ctrl.view[$ctrl.openDayIndex].events.length > 0) && !$ctrl.slideBoxDisabled\" events=\"$ctrl.view[$ctrl.openDayIndex].events\" on-event-click=\"$ctrl.onEventClick\" cell=\"$ctrl.view[$ctrl.openDayIndex]\" custom-template-urls=\"$ctrl.customTemplateUrls\" template-scope=\"$ctrl.templateScope\"></mwl-calendar-slide-box></div></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarSlideBox.html","<div class=\"cal-slide-box\" uib-collapse=\"$ctrl.isCollapsed\" mwl-collapse-fallback=\"$ctrl.isCollapsed\"><div class=\"cal-slide-content cal-event-list\"><ul class=\"unstyled list-unstyled\"><li ng-repeat=\"event in $ctrl.events | orderBy:\'startsAt\' track by event.calendarEventId\" ng-class=\"event.cssClass\" mwl-draggable=\"event.draggable === true\" drop-data=\"{event: event}\"><span class=\"pull-left event\" ng-style=\"{backgroundColor: event.color.primary}\"></span> &nbsp; <a href=\"javascript:;\" class=\"event-item\" ng-click=\"$ctrl.onEventClick({calendarEvent: event})\"><span ng-bind-html=\"isMonthView ? $ctrl.calendarEventTitle.monthView(event) : $ctrl.calendarEventTitle.yearView(event) | calendarTrustAsHtml\"></span></a> <a href=\"javascript:;\" class=\"event-item-action\" ng-class=\"action.cssClass\" ng-repeat=\"action in event.actions track by $index\" ng-bind-html=\"action.label | calendarTrustAsHtml\" ng-click=\"action.onClick({calendarEvent: event})\"></a></li></ul></div></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarWeekView.html","<div class=\"cal-week-box\" ng-class=\"{\'cal-day-box\': $ctrl.showTimes}\"><div class=\"cal-row-fluid cal-row-head\"><div class=\"cal-cell1\" ng-repeat=\"day in $ctrl.view.days track by $index\" ng-class=\"{ \'cal-day-weekend\': day.isWeekend, \'cal-day-past\': day.isPast, \'cal-day-today\': day.isToday, \'cal-day-future\': day.isFuture}\" mwl-element-dimensions=\"$ctrl.dayColumnDimensions\" mwl-droppable=\"\" on-drop=\"$ctrl.eventDropped(dropData.event, day.date)\"><span ng-bind=\"day.weekDayLabel\"></span><br><small><span data-cal-date=\"\" ng-click=\"$ctrl.calendarCtrl.dateClicked(day.date)\" class=\"pointer\" ng-bind=\"day.dayLabel\"></span></small></div></div><div class=\"cal-day-panel clearfix\" ng-style=\"{height: $ctrl.showTimes ? ($ctrl.dayViewHeight + \'px\') : \'auto\'}\"><mwl-calendar-hour-list day-view-start=\"$ctrl.dayViewStart\" day-view-end=\"$ctrl.dayViewEnd\" day-view-split=\"$ctrl.dayViewSplit\" day-width=\"$ctrl.dayColumnDimensions.width\" view-date=\"$ctrl.viewDate\" on-timespan-click=\"$ctrl.onTimespanClick\" on-date-range-select=\"$ctrl.onDateRangeSelect\" custom-template-urls=\"$ctrl.customTemplateUrls\" cell-modifier=\"$ctrl.cellModifier\" template-scope=\"$ctrl.templateScope\" ng-if=\"$ctrl.showTimes\"></mwl-calendar-hour-list><div class=\"row\" ng-repeat=\"row in $ctrl.view.eventRows track by $index\"><div class=\"col-xs-12\"><div class=\"cal-row-fluid\"><div ng-repeat=\"eventRow in row.row track by eventRow.event.calendarEventId\" ng-class=\"\'cal-cell\' + ($ctrl.showTimes ? 1 : eventRow.span) + ($ctrl.showTimes ? \'\' : \' cal-offset\' + eventRow.offset)\" ng-style=\"{ top: $ctrl.showTimes ? ((eventRow.top) + \'px\') : \'auto\', position: $ctrl.showTimes ? \'absolute\' : \'inherit\', width: $ctrl.showTimes ? ($ctrl.dayColumnDimensions.width + \'px\') : \'\', left: $ctrl.showTimes ? ($ctrl.dayColumnDimensions.width * eventRow.offset) + 15 + \'px\' : \'\' }\"><div class=\"day-highlight\" ng-class=\"[eventRow.event.cssClass, !$ctrl.showTimes && eventRow.startsBeforeWeek ? \'\' : \'border-left-rounded\', !$ctrl.showTimes && eventRow.endsAfterWeek ? \'\' : \'border-right-rounded\']\" ng-style=\"{backgroundColor: eventRow.event.color.secondary}\" data-event-class=\"\" mwl-draggable=\"eventRow.event.draggable === true\" axis=\"$ctrl.showTimes ? \'xy\' : \'x\'\" snap-grid=\"$ctrl.showTimes ? {x: $ctrl.dayColumnDimensions.width, y: $ctrl.dayViewEventChunkSize || 30} : {x: $ctrl.dayColumnDimensions.width}\" on-drag=\"$ctrl.tempTimeChanged(eventRow.event, y / 30)\" on-drag-end=\"$ctrl.weekDragged(eventRow.event, x / $ctrl.dayColumnDimensions.width, y / 30)\" mwl-resizable=\"eventRow.event.resizable === true && eventRow.event.endsAt && !$ctrl.showTimes\" resize-edges=\"{left: true, right: true}\" on-resize-end=\"$ctrl.weekResized(eventRow.event, edge, x / $ctrl.dayColumnDimensions.width)\"><strong ng-bind=\"(eventRow.event.tempStartsAt || eventRow.event.startsAt) | calendarDate:\'time\':true\" ng-show=\"$ctrl.showTimes\"></strong><a href=\"javascript:;\" ng-click=\"$ctrl.onEventClick({calendarEvent: eventRow.event})\" class=\"event-item\" ng-bind-html=\"$ctrl.calendarEventTitle.weekView(eventRow.event) | calendarTrustAsHtml\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\"><md-tooltip md-direction=\"left\"><span ng-bind-html=\"$ctrl.calendarEventTitle.weekViewTooltip(eventRow.event) | calendarTrustAsHtml\"></span></md-tooltip></a></div></div></div></div></div></div></div>");
$templateCache.put("app/kernel/ui-elements/ui-calendar/views/calendarYearView.html","<div class=\"cal-year-box\"><div ng-repeat=\"rowOffset in [0, 4, 8] track by rowOffset\"><div class=\"row cal-before-eventlist\"><div class=\"span3 col-md-3 col-xs-6 cal-cell {{ day.cssClass }}\" ng-repeat=\"month in $ctrl.view | calendarLimitTo:4:rowOffset track by $index\" ng-init=\"monthIndex = $ctrl.view.indexOf(month)\" ng-click=\"$ctrl.monthClicked(month, false, $event)\" ng-class=\"{pointer: month.events.length > 0, \'cal-day-today\': month.isToday}\" mwl-droppable=\"\" on-drop=\"$ctrl.handleEventDrop(dropData.event, month.date)\"><span class=\"pull-right\" data-cal-date=\"\" ng-click=\"$ctrl.calendarCtrl.dateClicked(month.date)\" ng-bind=\"month.label\"></span> <small class=\"cal-events-num badge badge-important pull-left\" ng-show=\"month.badgeTotal > 0\" ng-bind=\"month.badgeTotal\"></small><div class=\"cal-day-tick\" ng-show=\"monthIndex === $ctrl.openMonthIndex && ($ctrl.cellAutoOpenDisabled || $ctrl.view[$ctrl.openMonthIndex].events.length > 0) && !$ctrl.slideBoxDisabled\"><i class=\"glyphicon glyphicon-chevron-up\"></i> <i class=\"fa fa-chevron-up\"></i></div></div></div><mwl-calendar-slide-box is-open=\"$ctrl.openRowIndex === $index && ($ctrl.cellAutoOpenDisabled || $ctrl.view[$ctrl.openMonthIndex].events.length > 0) && !$ctrl.slideBoxDisabled\" events=\"$ctrl.view[$ctrl.openMonthIndex].events\" on-event-click=\"$ctrl.onEventClick\" cell=\"$ctrl.view[$ctrl.openMonthIndex]\" custom-template-urls=\"$ctrl.customTemplateUrls\" template-scope=\"$ctrl.templateScope\"></mwl-calendar-slide-box></div></div>");
$templateCache.put("app/kernel/ui-elements/ui-datepicker/views/datepicker.html","<div ng-switch=\"view\"><div ng-switch-when=\"date\" class=\"th-calendar\"><header><a href=\"javascript:void(0);\" class=\"prev\" ng-click=\"prev()\"><i class=\"fa fa-chevron-left\"></i></a><p ng-click=\"setView(\'month\')\" ng-bind=\"date|mFormat:\'YYYY MMMM\':tz\"></p><a href=\"javascript:void(0);\" class=\"next\" ng-click=\"next()\"><i class=\"fa fa-chevron-right\"></i></a></header><div class=\"sun-calendar\"><table><thead><tr><th ng-repeat=\"day in weekdays track by $index\" style=\"overflow: hidden\" ng-bind=\"day|mFormat:\'dd\':tz\"></th></tr></thead><tbody><tr ng-repeat=\"week in weeks track by $index\" ng-init=\"$index2 = $index\"><td ng-repeat=\"day in week track by $index\"><div ng-class=\"classes[$index2][$index]\" ng-click=\"selectDate(day, true)\"><span ng-bind=\"day|mFormat:\'DD\':tz\"></span></div></td></tr></tbody></table><div class=\"pt-calendarEven\" ng-show=\"showEventLightbox && showEvents && lightBoxEvents\"><p class=\"el-day\"><span>{{ lightBoxEvents[0].dateStr}}</span> <span>{{ lightBoxEvents[0].startTime}}~{{ lightBoxEvents[0].endTime}}</span></p><a href=\"javascript: void(0);\" ng-click=\"lightBoxEvents[0].linkAction(lightBoxEvents[0])\">{{ lightBoxEvents[0].eventName}}</a><div class=\"link\"><a href=\"javascript: void(0);\" class=\"btn-sm btn-primary\" ng-click=\"lightBoxEvents[0].moreAction()\">more</a></div><div class=\"pt-close\"><a href=\"javascript: void(0);\" class=\"btn btn-sm btn-primary\" title=\"close\" ng-click=\"closeLightBox();\"><i class=\"material-icons\">close</i></a></div></div></div></div><div ng-switch-when=\"year\" class=\"th-calendar\"><header><a href=\"javascript:void(0);\" class=\"prev\" ng-click=\"prev(10)\"><i class=\"fa fa-chevron-left\"></i></a><p ng-bind=\"years[0].year()+\' - \'+years[years.length-1].year()\"></p><a href=\"javascript:void(0);\" class=\"next\" ng-click=\"next(10)\"><i class=\"fa fa-chevron-right\"></i></a></header><div class=\"sun-calendar\"><table><tbody><tr><td colspan=\"7\"><span class=\"text-center\" style=\"width: 33%; float: left;\" ng-class=\"classes[$index]\" ng-repeat=\"year in years track by $index\" ng-click=\"selectDate(year)\" ng-bind=\"year.year()\"></span></td></tr></tbody></table></div></div><div ng-switch-when=\"month\" class=\"th-calendar\"><header><a href=\"javascript:void(0);\" class=\"prev\" ng-click=\"prev()\"><i class=\"fa fa-chevron-left\"></i></a><p ng-click=\"setView(\'year\')\" ng-bind=\"date|mFormat:\'YYYY\':tz\"></p><a href=\"javascript:void(0);\" class=\"next\" ng-click=\"next()\"><i class=\"fa fa-chevron-right\"></i></a></header><div class=\"sun-calendar\"><table><tbody><tr><td colspan=\"7\"><span ng-repeat=\"month in months track by $index\" class=\"text-center\" ng-class=\"classes[$index]\" style=\"width: 33%; float: left;\" ng-click=\"selectDate(month)\" ng-bind=\"month|mFormat:\'MMM\':tz\"></span></td></tr></tbody></table></div></div><div ng-switch-when=\"hours\"><table><thead><tr><th ng-click=\"prev(24)\">&lsaquo;</th><th colspan=\"5\" class=\"switch\" ng-click=\"setView(\'date\')\" ng-bind=\"date|mFormat:\'DD MMMM YYYY\':tz\"></th><th ng-click=\"next(24)\">&rsaquo;</th></tr></thead><tbody><tr><td colspan=\"7\"><span ng-repeat=\"hour in hours track by $index\" ng-class=\"classes[$index]\" ng-click=\"selectDate(hour)\" ng-bind=\"hour|mFormat:\'HH:mm\':tz\"></span></td></tr></tbody></table></div><div ng-switch-when=\"minutes\"><table><thead><tr><th ng-click=\"prev()\">&lsaquo;</th><th colspan=\"5\" class=\"switch\" ng-click=\"setView(\'hours\')\" ng-bind=\"date|mFormat:\'DD MMMM YYYY\':tz\"></th><th ng-click=\"next()\">&rsaquo;</th></tr></thead><tbody><tr><td colspan=\"7\"><span ng-repeat=\"minute in minutes track by $index\" ng-class=\"classes[$index]\" ng-click=\"selectDate(minute)\" ng-bind=\"minute|mFormat:\'HH:mm\':tz\"></span></td></tr></tbody></table></div></div>");
$templateCache.put("app/kernel/ui-elements/widgets/views/doughnut-gauge.html","<div ng-if=\"gaugeSize\" style=\"text-align:center;\"><canvas class=\"chart chart-doughnut\" height=\"{{gaugeSize}}\" width=\"{{gaugeSize}}\" chart-legend=\"true\" chart-options=\"gaugeOptions\" chart-colors=\"gaugeColors\" chart-data=\"gaugeData\" chart-labels=\"gaugeLabels\"></canvas><div class=\"word\">{{gaugeValue}}{{valueSuffix}}</div></div>");
$templateCache.put("app/kernel/ui-elements/widgets/views/infobox.html","<div ng-switch=\"type\"><div class=\"infobox panel\" ng-switch-when=\"0\"><div class=\"left\"><i class=\"{{icon}} {{iconColor}}\"></i></div><div class=\"right\"><div><span class=\"c-primary pull-left\" count-to=\"{{count}}\" value=\"0\" duration=\"1\">{{count}}</span> <span class=\"c-primary pull-right\">8%</span></div><div class=\"txt\">{{title}}</div></div></div><div class=\"panel\" ng-switch-when=\"1\"><div class=\"panel-content widget-info\"><div class=\"row\"><div class=\"left\"><i class=\"{{icon}} {{iconColor}}\"></i></div><div class=\"right\"><p class=\"number countup\" count-to=\"{{count}}\" value=\"0\" duration=\"1\">{{count}}</p><p class=\"text\">{{title}}</p></div></div></div></div></div>");
$templateCache.put("app/kernel/ui-elements/widgets/views/md-chips-select-template.html","<md-chips-wrap class=\"md-chips-select\" ng-class=\"{ \'md-focused\': isFocused() }\"><md-chip ng-repeat=\"chip in mdChipItems\" class=\"md-chip\"><span class=\"md-chip-content\">{{chip.mainTitle}}</span> <button class=\"md-remove\" ng-click=\"removeFromChips(chip)\"><span class=\"remove\"><svg version=\"1.1\" x=\"0px\" y=\"0px\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" fit=\"\" height=\"100%\" width=\"100%\" preserveaspectratio=\"xMidYMid meet\" style=\"pointer-events: none; display: block;\"><g><path d=\"M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z\"></path></g></svg></span></button></md-chip><div class=\"md-chip-input-container\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\" flex-gt-sm=\"\"><input type=\"text\" ng-focus=\"onInputFocus($event)\" ng-model=\"chipInput\" ng-blur=\"onInputBlur()\" ng-keydown=\"onKeyDown($event)\"></md-input-container></div><md-select-list ng-show=\"selectActive\" ng-style=\"{top: ytop, left: xleft}\"><md-select-item-wrapper ng-repeat=\"item in mdSelectItems\" ng-class=\"{\'active\': !isInChips(item)}\" ng-show=\"inputQuery(item)\" ng-click=\"toggleItem(item)\"><md-select-item-title>{{item.mainTitle}}</md-select-item-title><span ng-show=\"!isInChips(item)\" class=\"checksymbol\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewbox=\"0 0 24 24\"><path d=\"M0 0h24v24h-24z\" fill=\"none\"></path><path d=\"M9 16.17l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41z\"></path></svg></span></md-select-item-wrapper></md-select-list></md-chips-wrap>");
$templateCache.put("app/kernel/ui-elements/widgets/views/md-company-chips-template.html","<cus-md-chips class=\"md-contact-chips\" ng-model=\"$mdPersonChipsCtrl.persons\" md-require-match=\"$mdPersonChipsCtrl.requireMatch\" md-on-add=\"$mdPersonChipsCtrl.addChipToSelectedPersons($chip)\" md-on-remove=\"$mdPersonChipsCtrl.removeChipToSelectedPersons($chip)\" md-autocomplete-snap=\"\" md-autocomplete-wrap-override=\"\"><cus-md-autocomplete flex=\"\" md-menu-class=\"md-contact-chips-suggestions\" md-selected-item=\"$mdPersonChipsCtrl.selectedItem\" md-selected-item-change=\"$mdPersonChipsCtrl.selectedItemChange(item)\" md-search-text=\"$mdPersonChipsCtrl.searchText\" md-items=\"item in $mdPersonChipsCtrl.queryPerson($mdPersonChipsCtrl.searchText)\" md-item-text=\"$mdPersonChipsCtrl.itemName(item)\" md-no-cache=\"true\" md-min-length=\"0\" md-autoselect=\"\" md-item-disabled=\"item[$mdPersonChipsCtrl.personIsGray]\" placeholder=\"{{$mdPersonChipsCtrl.persons.length == 0 ? $mdPersonChipsCtrl.placeholder : $mdPersonChipsCtrl.secondaryPlaceholder}}\"><md-item-template><md-checkbox ng-change=\"$mdPersonChipsCtrl.checked(item)\" ng-model=\"$mdPersonChipsCtrl.autoCompleteSelected[item.userId].checked\"><div class=\"md-contact-suggestion\"><span class=\"md-contact-name\" md-highlight-text=\"$mdPersonChipsCtrl.searchText\" ng-class=\"{\'cursor-no-drop\' : item[$mdPersonChipsCtrl.personIsGray]}\" md-highlight-flags=\"{{$mdPersonChipsCtrl.highlightFlags}}\">{{item[$mdPersonChipsCtrl.personName]}}</span> <span class=\"md-contact-email\">{{item[$mdPersonChipsCtrl.personEmail]}}</span></div></md-checkbox></md-item-template></cus-md-autocomplete><md-chip-template><div class=\"md-contact-name\">{{$chip[$mdPersonChipsCtrl.personName]}}</div></md-chip-template></cus-md-chips>");
$templateCache.put("app/kernel/ui-elements/widgets/views/md-person-chips-template.html","<md-chips class=\"md-contact-chips\" ng-model=\"$mdPersonChipsCtrl.persons\" md-require-match=\"$mdPersonChipsCtrl.requireMatch\" md-on-add=\"$mdPersonChipsCtrl.addChipToSelectedPersons($chip)\" md-on-remove=\"$mdPersonChipsCtrl.removeChipToSelectedPersons($chip)\" md-autocomplete-snap=\"\" md-autocomplete-wrap-override=\"\"><md-autocomplete md-menu-class=\"md-contact-chips-suggestions\" md-selected-item=\"$mdPersonChipsCtrl.selectedItem\" md-search-text=\"$mdPersonChipsCtrl.searchText\" md-items=\"item in $mdPersonChipsCtrl.queryPerson($mdPersonChipsCtrl.searchText)\" md-item-text=\"$mdPersonChipsCtrl.itemName(item)\" md-no-cache=\"true\" md-autoselect=\"\" md-item-disabled=\"item[$mdPersonChipsCtrl.personIsGray]\" placeholder=\"{{$mdPersonChipsCtrl.persons.length == 0 ? $mdPersonChipsCtrl.placeholder : $mdPersonChipsCtrl.secondaryPlaceholder}}\"><md-item-template><div class=\"md-contact-suggestion\"><img ng-src=\"{{item[$mdPersonChipsCtrl.personImage]}}\" alt=\"{{item[$mdPersonChipsCtrl.personName]}}\" ng-if=\"item[$mdPersonChipsCtrl.personImage]\"> <span class=\"md-contact-name\" md-highlight-text=\"$mdPersonChipsCtrl.searchText\" ng-class=\"{\'cursor-no-drop\' : item[$mdPersonChipsCtrl.personIsGray]}\" md-highlight-flags=\"{{$mdPersonChipsCtrl.highlightFlags}}\">{{item[$mdPersonChipsCtrl.personName]}}</span> <span class=\"md-contact-email\">{{item[$mdPersonChipsCtrl.personEmail]}}</span> <span class=\"md-contact-email\">{{item[$mdPersonChipsCtrl.personGroup]}}</span></div></md-item-template></md-autocomplete><md-chip-template><div class=\"md-contact-avatar\"><img ng-src=\"{{$chip[$mdPersonChipsCtrl.personImage]}}\" alt=\"{{$chip[$mdPersonChipsCtrl.personName]}}\" ng-if=\"$chip[$mdPersonChipsCtrl.personImage]\"></div><div class=\"md-contact-name\">{{$chip[$mdPersonChipsCtrl.personName]}}</div></md-chip-template></md-chips>");
$templateCache.put("app/kernel/ui-elements/widgets/views/select-date.html","<ng-switch on=\"$ctrl.type\"><select flex=\"\" ng-switch-when=\"hours\" ng-model=\"$ctrl.ngModel\"><option ng-repeat=\"hour in $ctrl.hours\" value=\"{{hour}}\" ng-disabled=\"hour < $ctrl.min || hour > $ctrl.max\">{{hour | displayMinNumber:2}}</option></select><select flex=\"\" ng-switch-when=\"minute\" ng-model=\"$ctrl.ngModel\"><option ng-repeat=\"minute in $ctrl.minutes\" value=\"{{minute}}\">{{minute | displayMinNumber:2}}</option></select></ng-switch>");
$templateCache.put("app/kernel/ui-elements/wizard/views/step.html","<div class=\"sf-step\"><fieldset ng-show=\"selected\" ng-class=\"{current: selected, animated: selected, fadeIn: selected, done: completed}\" ng-transclude=\"\"></fieldset></div>");
$templateCache.put("app/kernel/ui-elements/wizard/views/wizard.html","<div class=\"wizard-div current wizard-sea th-form sf-sea\"><div class=\"sf-wizard\"><div class=\"sf-nav-wrap sf-nav-top\"><ul class=\"sf-nav\" ng-if=\"!hideIndicators\"><li class=\"sf-nav-step sf-nav-step-{{getEnabledSteps().length}} sf-li-number sf-nav-link\" ng-class=\"{\'sf-active\': step.selected}\" ng-repeat=\"step in getEnabledSteps()\" ng-click=\"goTo(step)\"><span class=\"sf-nav-subtext\" ng-bind-html=\"step.title || step.wzTitle\"></span><div class=\"sf-nav-number\"><span class=\"sf-nav-number-inner\">{{$index + 1}}</span></div><div></div></li></ul></div><div class=\"wizard ng-pristine ng-valid sf-nav-on-top\"><div class=\"sf-viewport\"><div class=\"sf-fieldwrap\"><div class=\"steps\" ng-transclude=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/modules/cert-zone/views/apply-form/bonus-dialog.html","<md-dialog aria-label=\"{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}\" flex=\"45\"><form name=\"$ctrl.applyForm\" ng-submit=\"$ctrl.submitApplyForm($ctrl.applyForm.$valid)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'EXTERNAL_CERT_QUALIFY_REWARD_APPLICATION\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-tooltip md-direction=\"bottom\">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip><md-icon md-font-set=\"md\" aria-label=\"{{ \'ACTIONS.CLOSE\' | translate}}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.EXTERNAL_CERT_EXAM_BASE_INFO\' | translate}}</h6><div class=\"el-person\"><div class=\"tag licenses\"><i class=\"material-icons\">assignment_ind</i></div></div><div class=\"personInfor\"><div class=\"mainInfor\"><ul class=\"basic\"><li><span class=\"li-title\">{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.companyName }}</span></li><li><span class=\"li-title\">{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.subjectName }}</span></li><li><span class=\"li-title\" ng-if=\"$ctrl.formType === 1\">{{ \'FIELD.EXCERT_APPLY_TEST_DATE\' | translate}}:</span> <span class=\"li-title\" ng-if=\"$ctrl.formType === 2\">{{ \'FIELD.REGISTER_APPLY_DATE\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.applyDate }}</span></li><li ng-if=\"$ctrl.formType === 1\"><span class=\"li-title\">{{ \'FIELD.APPLY_REASON\' | translate}}:</span> <span class=\"text\">{{::$ctrl.formData.reason }}</span></li><li ng-if=\"$ctrl.formType === 2\"><span class=\"li-title\">{{ \'FIELD.REMARK\' | translate}}:</span> <span class=\"text\">{{::$ctrl.formData.comment }}</span></li><li ng-if=\"$ctrl.formType === 1\"><span class=\"li-title\">{{ \'FIELD.TEST_DATE\' | translate}}:</span> <span class=\"text\"><span ng-repeat=\"testTime in ::$ctrl.formData.testTimes\">{{ testTime }}</span></span></li><li ng-if=\"$ctrl.formType === 1\"><span class=\"li-title\">{{ \'FIELD.TEST_PLAN\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.testPlace}}</span></li></ul></div></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'FIELD.APPLY_INFO\' | translate}}</h6><table class=\"BoxTable th-tableForm\"><tbody><tr ng-if=\"$ctrl.formType === 1\"><th>{{ \'FIELD.TEST_COST\' | translate}}</th><td><div>{{ ::$ctrl.currency.name}}&nbsp;{{ ::$ctrl.formData.testFee | number:1}}</div></td></tr><tr><th>{{ \'FIELD.SUBSIDY_COST\' | translate}}</th><td><div>{{ ::$ctrl.currency.name}}&nbsp;{{ ::$ctrl.formData.totalRealCompFee | number:1}}</div></td></tr><tr><th><span class=\"pt-mark\" ng-if=\"$ctrl.formType === 1\">*</span>{{ \'FIELD.CERTIFICATE_NUMBER\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\" ng-if=\"$ctrl.formType === 1\"><input placeholder=\"\" name=\"licenseId\" ng-value=\"$ctrl.formData.licenseId\" ng-model=\"$ctrl.form.licenseId\" ng-required=\"true\"></md-input-container><span ng-if=\"$ctrl.formType === 2\">{{ ::$ctrl.formData.licenseId }}</span></div></td></tr><tr><th><span class=\"pt-mark\" ng-if=\"$ctrl.formType === 1\">*</span>{{ \'FIELD.CERTIFICATE_GET_DATE\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\" ng-if=\"$ctrl.formType === 1\"><md-datepicker name=\"acquireDate\" md-placeholder=\"Enter date\" ng-model=\"$ctrl.form.acquireDate\" ng-required=\"true\"></md-datepicker></md-input-container><span ng-if=\"$ctrl.formType === 2\">{{ ::$ctrl.formData.acquireDate }}</span></div></td></tr><tr><th><span class=\"pt-mark\" ng-if=\"$ctrl.formType === 1\">*</span>{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</th><td><div ng-if=\"$ctrl.formType === 1\"><md-radio-group ng-model=\"$ctrl.form.isForever\"><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"1\">{{\'FIELD.NEVER_EXPIRE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"0\"></md-radio-button></md-radio-group><md-input-container class=\"m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><md-datepicker name=\"expireDate\" md-placeholder=\"Enter date\" ng-model=\"$ctrl.form.expireDate\" ng-required=\"$ctrl.form.isForever === 0\" ng-disabled=\"$ctrl.form.isForever === 1\"></md-datepicker></md-input-container></div><div ng-if=\"$ctrl.formType === 2\"><span ng-if=\"$ctrl.form.isForever === 0\">{{ ::$ctrl.formData.expireDate}}</span> <span ng-if=\"$ctrl.form.isForever === 1\">{{ \'FIELD.NEVER_EXPIRE\' | translate}}</span></div></td></tr><tr><th>{{ \'FIELD.REWARD_METHOD\' | translate}}</th><td><div><span ng-if=\"$ctrl.formData.bonusType === 1\">{{ \'FIELD.BONUS_COST\' | translate }}&nbsp;{{ ::$ctrl.currency.name}}&nbsp;{{ ::$ctrl.formData.bonusCost}}</span> <span ng-if=\"$ctrl.formData.bonusType === 2\">{{ ::$ctrl.formData.bonusOtherWay}}</span></div></td></tr><tr><th>{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><div><upload-refs ng-model=\"$ctrl.refFiles\" refs=\"$ctrl.refs\" max-count=\"3\"></upload-refs></div></td></tr></tbody></table></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/apply-form/bonus-edit-dialog.html","<md-dialog aria-label=\"{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}\" flex=\"80\"><form name=\"$ctrl.applyForm\" ng-submit=\"$ctrl.submitApplyForm($ctrl.applyForm.$valid)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'EXTERNAL_CERT_QUALIFY_REWARD_APPLICATION\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-tooltip md-direction=\"bottom\">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip><md-icon md-font-set=\"md\" aria-label=\"{{ \'ACTIONS.CLOSE\' | translate}}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.BONUS_APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.applyDate}}</td></tr></tbody></table><table class=\"BoxTable BoxTable-text-left\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable BoxTable-text-left\"><tbody><tr><th>{{ \'FIELD.REGISTER_APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.formData.applyDate}}</td></tr><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.formData.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.formData.subjectName}}</td></tr><tr ng-if=\"$ctrl.data.formData.type === 1\"><th>{{ \'FIELD.APPLY_REASON\' | translate}}</th><td>{{::$ctrl.data.formData.reason}}</td></tr><tr ng-if=\"$ctrl.data.formData.type === 2\"><th>{{ \'FIELD.REMARK\' | translate}}</th><td>{{::$ctrl.data.formData.comment}}</td></tr><tr ng-if=\"$ctrl.data.formData.type === 1\"><th>{{ \'FIELD.TEST_DATE\' | translate}}</th><td><div ng-repeat=\"testTime in ::$ctrl.data.formData.testTimes\">{{testTime}}</div></td></tr><tr ng-if=\"$ctrl.data.formData.type === 1\"><th>{{ \'FIELD.TEST_PLAN\' | translate}}</th><td>{{::$ctrl.data.formData.testPlace}}</td></tr><tr ng-if=\"$ctrl.data.formData.type === 1\"><th>{{ \'FIELD.TEST_COST\' | translate}}</th><td>{{ ::$ctrl.currency.name}}&nbsp;{{::$ctrl.data.formData.testFee}}</td></tr><tr><th ng-if=\"$ctrl.data.formData.type === 1\">{{ \'FIELD.EXCERT_APPLY_TEST\' | translate}}{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><th ng-if=\"$ctrl.data.formData.type === 2\">{{ \'FIELD.EXCERT_REGISTER_APPLY\' | translate}}{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.formData.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th><span class=\"pt-mark\" ng-if=\"$ctrl.data.formData.type === 1\">*</span>{{ \'FIELD.CERTIFICATE_NUMBER\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"\" name=\"licenseId\" ng-value=\"$ctrl.data.licenseId\" ng-model=\"$ctrl.form.licenseId\" ng-required=\"true\"></md-input-container></div></td></tr><tr><th><span class=\"pt-mark\" ng-if=\"$ctrl.data.formData.type === 1\">*</span>{{ \'FIELD.CERTIFICATE_GET_DATE\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\" ng-if=\"$ctrl.data.formData.type === 1\"><md-datepicker name=\"acquireDate\" md-placeholder=\"Enter date\" ng-model=\"$ctrl.form.acquireDate\" ng-required=\"true\"></md-datepicker></md-input-container><span ng-if=\"$ctrl.data.formData.type === 2\">{{ ::$ctrl.data.acquireDate }}</span></div></td></tr><tr><th><span class=\"pt-mark\" ng-if=\"$ctrl.data.formData.type === 1\">*</span>{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</th><td><div ng-if=\"$ctrl.data.formData.type === 1\"><md-radio-group ng-model=\"$ctrl.form.isForever\"><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"1\">{{\'FIELD.NEVER_EXPIRE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"0\"></md-radio-button></md-radio-group><md-input-container class=\"m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><md-datepicker name=\"expireDate\" md-placeholder=\"Enter date\" ng-model=\"$ctrl.form.expireDate\" ng-required=\"$ctrl.form.isForever === 0\" ng-disabled=\"$ctrl.form.isForever === 1\"></md-datepicker></md-input-container></div><div ng-if=\"$ctrl.data.formData.type === 2\"><span ng-if=\"$ctrl.data.isForever === 0\">{{ ::$ctrl.data.expireDate}}</span> <span ng-if=\"$ctrl.data.isForever === 1\">{{ \'FIELD.NEVER_EXPIRE\' | translate}}</span></div></td></tr><tr><th>{{ \'FIELD.REWARD_METHOD\' | translate}}</th><td><div><span ng-if=\"$ctrl.data.bonusType === 1\">{{ \'FIELD.BONUS_COST\' | translate }}&nbsp;{{ ::$ctrl.currency.name}}&nbsp;{{ ::$ctrl.data.bonusCost}}</span> <span ng-if=\"$ctrl.data.bonusType === 2\">{{ ::$ctrl.data.bonusOtherWay}}</span></div></td></tr><tr><th>{{ \'FIELD.BONUS\' | translate}}{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><upload-refs ng-model=\"$ctrl.refFiles\" refs=\"$ctrl.data.relatedRefsOne\" max-count=\"3\"></upload-refs></td></tr></tbody></table></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/apply-form/compensation-dialog.html","<md-dialog aria-label=\"{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}\" flex=\"45\"><form name=\"$ctrl.applyForm\" ng-submit=\"$ctrl.submitApplyForm($ctrl.applyForm.$valid)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-tooltip md-direction=\"bottom\">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip><md-icon md-font-set=\"md\" aria-label=\"{{ \'ACTIONS.CLOSE\' | translate}}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.EXTERNAL_CERT_EXAM_BASE_INFO\' | translate}}</h6><div class=\"el-person\"><div class=\"tag licenses\"><i class=\"material-icons\">assignment_ind</i></div></div><div class=\"personInfor\"><div class=\"mainInfor\"><ul class=\"basic\"><li><span class=\"li-title\">{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.companyName }}</span></li><li><span class=\"li-title\">{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.subjectName }}</span></li><li><span class=\"li-title\">{{ \'FIELD.EXCERT_APPLY_TEST_DATE\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.applyDate }}</span></li><li><span class=\"li-title\">{{ \'FIELD.APPLY_REASON\' | translate}}:</span> <span class=\"text\">{{::$ctrl.formData.reason }}</span></li><li><span class=\"li-title\">{{ \'FIELD.TEST_DATE\' | translate}}:</span> <span class=\"text\"><span ng-repeat=\"testTime in ::$ctrl.formData.testTimes\">{{ testTime }}</span></span></li><li><span class=\"li-title\">{{ \'FIELD.TEST_PLAN\' | translate}}:</span> <span class=\"text\">{{ ::$ctrl.formData.testPlace}}</span></li></ul></div></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'FIELD.APPLY_INFO\' | translate}}</h6><table class=\"BoxTable th-tableForm\"><tbody><tr><th>{{ \'FIELD.TEST_ITEMS\' | translate}}</th><td><div><select-ctl type=\"compensation-test-item\" name=\"testItemId\" params=\"{selectedValue: $ctrl.form.testItemId, testApplyFormId: $ctrl.formId}\" default-select-first=\"true\" ng-model=\"$ctrl.form.testItemId\"></select-ctl></div></td></tr><tr><th>{{ \'FIELD.CURRENCY\' | translate}}</th><td><div><select-ctl type=\"all-currency\" params=\"{selectedValue: $ctrl.form.compFeeCurrency}\" name=\"compFeeCurrency\" default-select-first=\"true\" ng-model=\"$ctrl.form.compFeeCurrency\" ctl-data=\"$ctrl.currencys\" ng-change=\"$ctrl.calculateCompFee()\"></select-ctl></div></td></tr><tr><th><span class=\"pt-mark\">*</span>{{ \'FIELD.AMOUNT\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"{{ \'FORM_VALIDATION.PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY\' | translate}}\" name=\"compFeeAmount\" type=\"number\" step=\"1\" ng-change=\"$ctrl.calculateCompFee()\" ng-pattern=\"/^-?[0-9][^\\.]*$/\" ng-model=\"$ctrl.form.compFeeAmount\" ng-required=\"true\"><div ng-messages=\"$ctrl.applyForm.compFeeAmount.$error\" ng-show=\"$ctrl.applyForm.compFeeAmount.$dirty\"><div ng-message=\"number\">{{ \'FORM_VALIDATION.PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY\' | translate }}</div></div></md-input-container></div></td></tr><tr><th>{{ \'PLACEHOLDERS.CONVERSION_AMOUNT\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"\" name=\"compFee\" ng-model=\"$ctrl.form.compFee\" ng-disabled=\"true\"></md-input-container></div></td></tr><tr><th>{{ \'FIELD.PERCENTAGE_OF_EXAMINATIONS\' | translate}}</th><td><div class=\"text\" ng-if=\"$ctrl.formData.compRatio !== -1\">{{ $ctrl.formData.compRatio | suffixes: \'%\'}}</div><div class=\"text\" ng-if=\"$ctrl.formData.compRatio === -1\">{{ $ctrl.formData.compensationCost | suffixes: (\'FIELD.DOLLARS\' | translate)}}</div></td></tr><tr><th>{{ \'FIELD.EXCERT_REAL_COMPENSATION\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"\" name=\"realCompFee\" ng-model=\"$ctrl.form.realCompFee\" ng-disabled=\"true\"></md-input-container></div></td></tr><tr><th>{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><div><upload-refs ng-model=\"$ctrl.refFiles\" refs=\"$ctrl.refs\" max-count=\"3\"></upload-refs></div></td></tr></tbody></table></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/apply-form/compensation-edit-dialog.html","<md-dialog aria-label=\"{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}\" flex=\"80\"><form name=\"$ctrl.applyForm\" ng-submit=\"$ctrl.submitApplyForm($ctrl.applyForm.$valid)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-tooltip md-direction=\"bottom\">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip><md-icon md-font-set=\"md\" aria-label=\"{{ \'ACTIONS.CLOSE\' | translate}}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.applyDate}}</td></tr></tbody></table><table class=\"BoxTable\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.EXCERT_APPLY_TEST_DATE\' | translate}}</th><td>{{ ::$ctrl.data.formData.applyDate}}</td></tr><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.formData.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.formData.subjectName}}</td></tr><tr ng-if=\"$ctrl.data.formData.type === 1\"><th>{{ \'FIELD.APPLY_REASON\' | translate}}</th><td>{{::$ctrl.data.formData.reason}}</td></tr><tr ng-if=\"$ctrl.data.formData.type === 2\"><th>{{ \'FIELD.REMARK\' | translate}}</th><td>{{::$ctrl.data.formData.comment}}</td></tr><tr ng-if=\"$ctrl.data.formData.type === 1\"><th>{{ \'FIELD.TEST_DATE\' | translate}}</th><td><div ng-repeat=\"testTime in ::$ctrl.data.formData.testTimes\">{{testTime}}</div></td></tr><tr ng-if=\"$ctrl.data.formData.type === 1\"><th>{{ \'FIELD.TEST_PLAN\' | translate}}</th><td>{{::$ctrl.data.formData.testPlace}}</td></tr><tr><th ng-if=\"$ctrl.data.formData.type === 1\">{{ \'FIELD.EXCERT_APPLY_TEST\' | translate}}{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><th ng-if=\"$ctrl.data.formData.type === 2\">{{ \'FIELD.EXCERT_REGISTER_APPLY\' | translate}}{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.formData.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.TEST_ITEMS\' | translate}}</th><td><div>{{ ::$ctrl.data.testItemName}}</div></td></tr><tr><th>{{ \'FIELD.CURRENCY\' | translate}}</th><td><div><select-ctl type=\"all-currency\" params=\"{selectedValue: $ctrl.data.compFeeCurrency}\" name=\"compFeeCurrency\" ng-model=\"$ctrl.form.compFeeCurrency\" ctl-data=\"$ctrl.currencys\" ng-change=\"$ctrl.calculateCompFee()\"></select-ctl></div></td></tr><tr><th><span class=\"pt-mark\">*</span>{{ \'FIELD.AMOUNT\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"{{ \'FORM_VALIDATION.PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY\' | translate}}\" name=\"compFeeAmount\" type=\"number\" step=\"1\" ng-change=\"$ctrl.calculateCompFee()\" ng-pattern=\"/^-?[0-9][^\\.]*$/\" ng-model=\"$ctrl.form.compFeeAmount\" ng-required=\"true\"><div ng-messages=\"$ctrl.applyForm.compFeeAmount.$error\" ng-show=\"$ctrl.applyForm.compFeeAmount.$dirty\"><div ng-message=\"number\">{{ \'FORM_VALIDATION.PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY\' | translate }}</div></div></md-input-container></div></td></tr><tr><th>{{ \'PLACEHOLDERS.CONVERSION_AMOUNT\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"\" name=\"compFee\" ng-model=\"$ctrl.form.compFee\" ng-disabled=\"true\"></md-input-container></div></td></tr><tr><th>{{ \'FIELD.PERCENTAGE_OF_EXAMINATIONS\' | translate}}</th><td><div class=\"text\" ng-if=\"$ctrl.data.compRatio !== -1\">{{ $ctrl.data.compRatio | suffixes: \'%\'}}</div><div class=\"text\" ng-if=\"$ctrl.data.compRatio === -1\">{{ $ctrl.data.compensationCost | suffixes: (\'FIELD.DOLLARS\' | translate)}}</div></td></tr><tr><th>{{ \'FIELD.EXCERT_REAL_COMPENSATION\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"\" name=\"realCompFee\" ng-model=\"$ctrl.form.realCompFee\" ng-disabled=\"true\"></md-input-container></div></td></tr><tr><th>{{ \'FIELD.COMPENSATION\' | translate}}{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><upload-refs ng-model=\"$ctrl.refFiles\" refs=\"$ctrl.data.relatedRefsOne\" max-count=\"3\"></upload-refs></td></tr></tbody></table></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/apply-form/register-edit-dialog.html","<md-dialog aria-label=\"{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}\" flex=\"80\"><form name=\"$ctrl.applyForm\" ng-submit=\"$ctrl.submitApplyForm($ctrl.applyForm.$valid)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'EXTERNAL_CERT_REGISTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-tooltip md-direction=\"bottom\">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip><md-icon md-font-set=\"md\" aria-label=\"{{ \'ACTIONS.CLOSE\' | translate}}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.applyDate}}</td></tr></tbody></table><table class=\"BoxTable\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.subjectName}}</td></tr><tr><th>{{ \'FIELD.CERTIFICATE_GET_DATE\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><md-datepicker name=\"acquireDate\" md-placeholder=\"Enter date\" ng-model=\"$ctrl.form.acquireDate\" ng-required=\"true\"></md-datepicker></md-input-container></div></td></tr><tr><th>{{ \'FIELD.CERTIFICATE_DEADLINE\' | translate}}</th><td><div><md-radio-group ng-model=\"$ctrl.form.isForever\"><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"1\">{{\'FIELD.NEVER_EXPIRE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"0\"></md-radio-button></md-radio-group><md-input-container class=\"m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><md-datepicker name=\"expireDate\" md-placeholder=\"Enter date\" ng-model=\"$ctrl.form.expireDate\" ng-required=\"$ctrl.form.isForever === 0\" ng-disabled=\"$ctrl.form.isForever === 1\"></md-datepicker></md-input-container></div></td></tr><tr><th>{{ \'FIELD.CERTIFICATE_NUMBER\' | translate}}</th><td><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"\" name=\"licenseId\" ng-value=\"$ctrl.data.licenseId\" ng-model=\"$ctrl.form.licenseId\" ng-required=\"true\"></md-input-container></td></tr><tr><th>{{ \'FIELD.REMARK\' | translate}}</th><td><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><textarea name=\"comment\" md-maxlength=\"150\" rows=\"1\" placeholder=\"{{ \'FIELD.REMARK\' | translate}}\" ng-model=\"$ctrl.form.comment\"></textarea></md-input-container></td></tr><tr><th>{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><upload-refs ng-model=\"$ctrl.refFiles\" refs=\"$ctrl.data.relatedRefsOne\" max-count=\"3\"></upload-refs></td></tr></tbody></table></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/cert-zone/views/apply-form/test-edit-dialog.html","<md-dialog aria-label=\"{{ \'EXTERNAL_CERT_EXAM_ALLOWANCE_APPLICATION\' | translate}}\" flex=\"80\"><form name=\"$ctrl.applyForm\" ng-submit=\"$ctrl.submitApplyForm($ctrl.applyForm.$valid)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'EXTERNAL_CERT_EXAM_APPLICATION\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-tooltip md-direction=\"bottom\">{{ \'ACTIONS.CLOSE\' | translate}}</md-tooltip><md-icon md-font-set=\"md\" aria-label=\"{{ \'ACTIONS.CLOSE\' | translate}}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><div class=\"lightBox Box-billboard\"><header></header><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr><th>{{ \'FIELD.APPLY_DATE\' | translate}}</th><td>{{ ::$ctrl.data.applyDate}}</td></tr></tbody></table><table class=\"BoxTable\"><tbody><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr><tr><th>{{ \'FIELD.JOB_TITLE\' | translate}}</th><td>{{::$ctrl.applicantInfo.TitleName}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'CERTIFICATE_INFO\' | translate}}</h6><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</th><td>{{::$ctrl.data.companyName}}</td></tr><tr><th>{{ \'FIELD.CERTIFIED_SUBJECT\' | translate}}</th><td>{{::$ctrl.data.subjectName}}</td></tr><tr><th>{{ \'FIELD.APPLY_REASON\' | translate}}</th><td>{{::$ctrl.data.reason}}</td></tr><tr><th>{{ \'FIELD.TEST_DATE\' | translate}}</th><td><div><multi-date-picker-ctrl ng-model=\"$ctrl.data.testTimes\" ng-required=\"true\"></multi-date-picker-ctrl></div></td></tr><tr><th>{{ \'FIELD.TEST_PLAN\' | translate}}</th><td>{{::$ctrl.data.testPlace}}</td></tr><tr><th>{{ \'FIELD.EXCERT_APPLY_TEST\' | translate}}{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><a href=\"javascript:void(0)\" ng-repeat=\"ref in $ctrl.data.relatedRefsOne\" ng-if=\"ref.type===1\" view-ctms-reference=\"\" package-id=\"ref.packageId\" item-section=\"ref.itemSection\" file-name=\"ref.systemFileName\"><i class=\"material-icons\">assignment</i></a></td></tr><tr><th>{{ \'FIELD.CURRENCY\' | translate}}</th><td><div><select-ctl type=\"all-currency\" params=\"{selectedValue: $ctrl.data.testFeeCurrency}\" name=\"testFeeCurrency\" ng-model=\"$ctrl.form.testFeeCurrency\" ctl-data=\"$ctrl.currencys\" ng-change=\"$ctrl.calculateTestFee()\"></select-ctl></div></td></tr><tr><th><span class=\"pt-mark\">*</span>{{ \'FIELD.AMOUNT\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"{{ \'FORM_VALIDATION.PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY\' | translate}}\" name=\"testFeeAmount\" type=\"number\" step=\"1\" ng-change=\"$ctrl.calculateTestFee()\" ng-model=\"$ctrl.form.testFeeAmount\" ng-required=\"true\"><div ng-messages=\"$ctrl.applyForm.testFeeAmount.$error\" ng-show=\"$ctrl.applyForm.testFeeAmount.$dirty\"><div ng-message=\"number\">{{ \'FORM_VALIDATION.PLEASE_ENTER_A_VALID_AMOUNT_OF_MONEY\' | translate }}</div></div></md-input-container></div></td></tr><tr><th>{{ \'PLACEHOLDERS.CONVERSION_AMOUNT\' | translate}}</th><td><div><md-input-container class=\"md-block m-t-10 m-b-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"\" name=\"testFee\" ng-model=\"$ctrl.form.testFee\" ng-disabled=\"true\"></md-input-container></div></td></tr><tr><th>{{ \'FIELD.REFERENCE_MATERIAL\' | translate}}</th><td><upload-refs ng-model=\"$ctrl.refFiles\" refs=\"$ctrl.data.relatedRefsOne\" max-count=\"3\"></upload-refs></td></tr></tbody></table></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/assignable-members.html","<script type=\"text/ng-template\" id=\"assignable-member-wizard.html\"><div ng-transclude></div></script><script type=\"text/ng-template\" id=\"assignable-member-step.html\"><div ng-show=\"selected\" ng-transclude></div></script><md-dialog aria-label=\"{{ \'FIELD.ASSIGNABLE_MEMBER_ENROLL\' | translate}}\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SESSION\' | translate}}：{{sessionName}}&nbsp;{{ \'FIELD.ASSIGNABLE_MEMBER_ENROLL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><wizard name=\"assignable\" on-finish=\"$ctrl.assignableMembers()\" template=\"assignable-member-wizard.html\"><wz-step template=\"assignable-member-step.html\" wz-title=\"\" canexit=\"$ctrl.canNext\"><div class=\"lightBox Box-assign\"><div class=\"box-content checkboxdemoSyncing\"><p>{{ \'FIELD.ADD_LEARNER\' | translate}}</p><md-radio-group layout=\"row\" layout-align=\"left\" ng-model=\"$ctrl.assignable.learnerType\"><md-radio-button value=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</md-radio-button><md-radio-button value=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</md-radio-button></md-radio-group><md-content class=\"md-padding autocomplete\" layout=\"column\"><md-person-chips ng-model=\"$ctrl.selectPersonModel1\" md-persons=\"$ctrl.delayedQuerySearch($query)\" md-person-name=\"fullName\" md-person-group=\"groupName\" md-person-is-gray=\"isGray\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"{{ \'PLACEHOLDERS.PLEASE_ENTER_THE_STUDENT_NAME\' | translate}}\" selected-persons=\"$ctrl.selectedPersons\"></md-person-chips></md-content><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.isDirectMembers=!($ctrl.isDirectMembers);\">{{ \'FIELD.LIST_ALL_SUBORDINATE_MEMBERS\' | translate}}</md-button><div layout=\"row\" layout-wrap=\"\" flex=\"\" ng-if=\"$ctrl.isDirectMembers\"><div ng-repeat=\"member in $ctrl.members\" layout=\"column\"><md-checkbox class=\"m-r-20\" ng-model=\"$ctrl.filters.showMembers[member.userId]\" ng-click=\"$ctrl.optionsToggle(member);\" ng-disabled=\"member.isGray\">{{member.fullName}}</md-checkbox></div></div><div class=\"box-content md-assign\" ng-if=\"$ctrl.selectedPersons.length > 0\"><p>{{ \'FIELD.YOU_HAVE_SELECTED_MEMBERS\' | translate}}</p><div class=\"pt-assign\"><span ng-repeat=\"selectedPerson in $ctrl.selectedPersons\">{{selectedPerson.fullName}}</span></div></div></div></div></wz-step><wz-step template=\"assignable-member-step.html\" wz-title=\"\" canexit=\"$ctrl.formValidation()\"><form name=\"$ctrl.assignableForm\" novalidate=\"\"><div class=\"lightBox Box-assign\"><div class=\"box-content m-t-20\"><div flex=\"\" flex-gt-xs=\"\"><p class=\"m-t-20\">{{ \'FIELD.EXECUTION_DATE\' | translate}}:</p><md-datepicker name=\"executeDate\" ng-model=\"$ctrl.assignable.executeDate\" md-placeholder=\"{{ \'PLACEHOLDERS.PLEASE_SELECT_DATE\' | translate}}\" required=\"\"></md-datepicker><div class=\"validation-messages\" ng-messages=\"$ctrl.assignableForm.executeDate.$error\"><div ng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></div><div flex=\"\" flex-gt-xs=\"\" ng-if=\"!$ctrl.isExternal\"><p class=\"m-t-20\">{{ \'FIELD.YOU_CAN_SET_A_DURATION_FOR_THE_TRAINEES\' | translate}}:</p><md-radio-group ng-model=\"$ctrl.assignable.dueDateType\"><div layout=\"row\" layout-align=\"start center\"><md-radio-button value=\"0\" class=\"md-primary\">{{ \'FIELD.UNLIMITED\' | translate}}</md-radio-button></div><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"center center\"><md-radio-button value=\"1\">{{ \'FIELD.AFTER_THE_SUCCESSFUL_REGISTRATION\' | translate}}</md-radio-button></div><div layout=\"column\" layout-align=\"center center\"><md-input-container class=\"m-t-0 m-b-0\" md-no-float=\"true\"><label>{{ \'PLACEHOLDERS.PLEASE_ENTER_THE_NUMBER_OF_DAYS\' | translate}}</label> <input ng-disabled=\"!($ctrl.assignable.dueDateType === \'1\')\" type=\"number\" name=\"dueDays\" ng-model=\"$ctrl.assignable.dueDays\" min=\"1\" ng-required=\"($ctrl.assignable.dueDateType === \'1\')\" md-autofocus=\"\"><div class=\"validation-messages\" ng-messages=\"$ctrl.assignableForm.dueDays.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></md-input-container></div><div layout=\"column\" layout-align=\"center center\"><p>，{{ \'FIELD.DAYS\' | translate}}</p></div></div><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"center center\"><md-radio-button class=\"m-t-20\" value=\"2\">{{ \'FIELD.DIRECTLY_SPECIFY_DEADLINES\' | translate}}</md-radio-button></div><div layout=\"column\" layout-align=\"center center\"><md-datepicker name=\"dueDate\" ng-model=\"$ctrl.assignable.dueDate\" ng-disabled=\"!($ctrl.assignable.dueDateType === \'2\')\" md-placeholder=\"{{ \'FIELD.DIRECTLY_SPECIFY_DEADLINES\' | translate}}\" ng-required=\"($ctrl.assignable.dueDateType === \'2\')\"></md-datepicker><div class=\"validation-messages\" ng-messages=\"$ctrl.assignableForm.dueDate.$error\"><div ng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></div></div></md-radio-group></div><div flex=\"\" flex-gt-xs=\"\" ng-if=\"$ctrl.isExternal\"><p class=\"m-t-20\">{{ \'FIELD.COURSE_TYPE\' | translate}}:</p><md-radio-group ng-model=\"$ctrl.assignable.isForFree\"><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"1\">{{\'FIELD.FREE_COURSE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"0\">{{\'FIELD.PAY_COURSE\' | translate}}</md-radio-button></md-radio-group><p class=\"m-t-20\" ng-if=\"$ctrl.assignable.isForFree === 0\">{{ \'FIELD.PENDING_PREDETERMINED_COST\' | translate}}:</p><div layout-gt-xs=\"row\" ng-if=\"$ctrl.assignable.isForFree === 0\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20\">{{ \'FIELD.CURRENCY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><select-currency currencys=\"$ctrl.currencys\" ng-model=\"$ctrl.assignable.course_cost_currency\" ng-change=\"$ctrl.courseConvertingAmount()\"></select-currency></div></div><div layout-gt-xs=\"row\" ng-if=\"$ctrl.assignable.isForFree === 0\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20\"><span class=\"pt-mark\">*</span>{{ \'FIELD.AMOUNT\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input ng-model=\"$ctrl.assignable.course_cost_amount\" required=\"\" type=\"number\" ng-change=\"$ctrl.courseConvertingAmount()\"></md-input-container></div></div><div layout-gt-xs=\"row\" class=\"m-b-20\" ng-if=\"$ctrl.assignable.isForFree === 0\"><div flex-gt-xs=\"20\" class=\"text-right m-t-20\">{{ \'FIELD.SYSTEM_CURRENCY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'PLACEHOLDERS.NT_CONVERSION\' | translate}}</label> <input ng-model=\"$ctrl.assignable.course_converting_amount\" readonly=\"\" ng-disabled=\"$ctrl.ngDisabled\"></md-input-container></div></div><div layout-gt-xs=\"row\" ng-if=\"$ctrl.assignable.isForFree === 0\"><div flex-gt-xs=\"20\" class=\"text-right m-b-20\">{{ \'FIELD.TYPE_OF_SUBSIDY\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.assignable.subsidyType\"><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.FULL_AMOUNT\' | translate}}</md-radio-button><md-radio-button value=\"2\" class=\"el-inBlock p-r-20\">{{ \'FIELD.SUBSIDY\' | translate}}</md-radio-button><md-input-container class=\"m-t-0\" flex-gt-xs=\"30\" flex-xs=\"40\"><input ng-model=\"$ctrl.assignable.subsidyPercentage\" ng-disabled=\"$ctrl.assignable.subsidyType !== \'2\'\"></md-input-container>％</md-radio-group></div></div><div layout-gt-xs=\"row\" ng-if=\"$ctrl.assignable.isForFree === 0\"><div flex-gt-xs=\"20\" class=\"text-right m-b-20\">{{ \'FIELD.PAYMENT_DATE\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-datepicker ng-model=\"$ctrl.assignable.payingDate\"></md-datepicker></div></div><div layout-gt-xs=\"row\" class=\"m-t-20\" ng-if=\"$ctrl.assignable.isForFree === 0\"><div flex-gt-xs=\"20\" class=\"text-right m-b-20\">{{ \'FIELD.VOUCHER\' | translate}}</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.assignable.voucherType\"><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.TAXABLE_INVOICE\' | translate}}</md-radio-button><md-radio-button value=\"2\" class=\"el-inBlock p-r-20\">{{ \'FIELD.TAX_FREE_INVOICE\' | translate}}</md-radio-button><md-radio-button value=\"3\" class=\"el-inBlock p-r-20\">{{ \'FIELD.RECEIPT\' | translate}}</md-radio-button></md-radio-group></div></div></div><div flex=\"\" flex-gt-xs=\"\"><md-input-container class=\"md-block\"><label>{{ \'PLACEHOLDERS.YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED\' | translate}}</label> <textarea ng-model=\"$ctrl.assignable.message\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" md-detect-hidden=\"\"></textarea></md-input-container></div></div></div></form></wz-step></wizard></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.nextStep()\" ng-if=\"$ctrl.wzBtn.next\">{{ \'ACTIONS.NEXT_STEP\' | translate}}<md-icon md-font-set=\"md\">keyboard_arrow_right</md-icon></md-button><md-button class=\"md-raised md-warn md-btn btn-transparent\" type=\"button\" ng-click=\"$ctrl.previousStep()\" ng-if=\"$ctrl.wzBtn.previous\"><md-icon md-font-set=\"md\">keyboard_arrow_left</md-icon>{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.finishStep()\" ng-if=\"$ctrl.wzBtn.finish\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-enrollment-learning-report.html","<div class=\"tab-pane th-report\" id=\"tab_5\" ng-if=\"uploader\"><h4>{{ \'FIELD.SUBMIT_REPORT\' | translate}}</h4><header><p>{{ \'FIELD.UPLOADED_REPORT_LIST\' | translate}} : <span class=\"reportDeadline\" ng-if=\"$ctrl.sessionData.isReportBeforeClose===0 && $ctrl.enrollmentData.courseType!==3\">({{ \'FIELD.SUBMIT_DEADLINE\' | translate}} : {{$ctrl.sessionData.reportSubmitDeadline}})</span> <span class=\"reportDeadline\" ng-if=\"$ctrl.learningReportStatus.reportSubmitDeadline!==null && $ctrl.enrollmentData.courseType===3\">({{ \'FIELD.SUBMIT_DEADLINE\' | translate}} : {{$ctrl.learningReportStatus.reportSubmitDeadline}})</span> <span>{{ \'FIELD.SHOULD_BE_SUBMIT_REPORT\' | translate}} {{$ctrl.enrollmentData.reportsTotal}} {{ \'FIELD.PART\' | translate}}, {{ \'FIELD.HAS_BEEN_PAID\' | translate}} {{$ctrl.learningReportData.paid}} {{ \'FIELD.PART\' | translate}}</span></p><p ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\">{{ \'FIELD.SELECTED\' | translate}} {{ uploader.queue.length || 0}} {{ \'FIELD.PART\' | translate}}{{ \'FIELD.FILES\' | translate}}</p><div class=\"center\" ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\"><span class=\"btn btn-primary btn-file\"><span class=\"fileinput-new\"><i class=\"material-icons\">add_circle</i>{{ \'ACTIONS.SELECT_FILES\' | translate}}</span> <input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" filters=\"sizeFilter\"></span> <button class=\"btn btn-blue\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\"><i class=\"material-icons\">cloud_upload</i>{{ \'ACTIONS.UPLOAD_ALL\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\"><i class=\"fa fa-trash-o\"></i>{{ \'ACTIONS.DELETE_ALL\' | translate}}</button></div></header><table class=\"small\"><tbody><tr ng-repeat=\"item in uploader.queue\"><td><div class=\"pt-title\">{{ item.file.name }}<p class=\"mark\" ng-show=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></p><p class=\"mark\" ng-show=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></p><p class=\"mark\" ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i> Server Error {{ item._xhr.status + \' \' + item._xhr.statusText}}</p></div></td><td><div class=\"progress\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"><div class=\"progress-value\">{{ item.file.size/1024/1024|number:2 }} MB</div></div></div></td><td><div class=\"linkBox\"><button class=\"btn btn-blue\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><i class=\"material-icons\">cloud_upload</i></button> <button class=\"btn btn-danger\" ng-click=\"item.remove()\"><i class=\"fa fa-trash-o\"></i></button></div></td></tr></tbody></table><h4>{{ \'FIELD.SUBMITTED_REPORT\' | translate}}</h4><table class=\"basic\"><thead><tr><th>{{ \'FIELD.SERIAL_NUMBER\' | translate}}</th><th>{{ \'FIELD.FILE_NAME\' | translate}}</th><th>{{ \'FIELD.DATE_OF_PAYMENT\' | translate}}</th><th>{{ \'FIELD.SCORE\' | translate}}</th><th>{{ \'FIELD.APPROVE_STATUS\' | translate}}</th><th ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\">{{ \'FIELD.ACTION\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"learningReport in $ctrl.learningReportData\"><td data-th=\"{{ \'FIELD.SERIAL_NUMBER\' | translate}}\">{{learningReport.index}}</td><td data-th=\"{{ \'FIELD.FILE_NAME\' | translate}}\"><div class=\"pt-title\" ng-if=\"$ctrl.learningReportFileReplace[learningReport.learningReportId].queue.length > 0\">{{$ctrl.learningReportFileReplace[learningReport.learningReportId].queue[0].file.name}}<div class=\"progress\"><div class=\"progress-bar\" ng-style=\"{ \'width\': $ctrl.learningReportFileReplace[learningReport.learningReportId].queue[0].progress + \'%\' }\"><div class=\"progress-value\">{{ $ctrl.learningReportFileReplace[learningReport.learningReportId].queue[0].file.size/1024/1024|number:2 }} MB</div></div></div></div><div class=\"pt-title\" ng-if=\"!($ctrl.learningReportFileReplace[learningReport.learningReportId].queue.length > 0)\"><a ng-href=\"{{learningReport.fileUrl}}\" target=\"_blank\">{{learningReport.fileName}}</a></div></td><td data-th=\"{{ \'FIELD.DATE_OF_PAYMENT\' | translate}}\">{{learningReport.submitDate}}</td><td data-th=\"{{ \'FIELD.SCORE\' | translate}}\">{{learningReport.score}}</td><td data-th=\"{{ \'FIELD.APPROVE_STATUS\' | translate}}\"><div class=\"text\">{{ \'STATUS.\' + learningReport.appStateWording | uppercase | translate}}</div></td><td data-th=\"{{ \'FIELD.ACTION\' | translate}}\" ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\"><span class=\"btn btn-primary btn-file\" ng-if=\"learningReport.actionState === 1\"><span class=\"fileinput-new\">{{ \'ACTIONS.REPLACE\' | translate}}</span> <input type=\"file\" nv-file-select=\"\" uploader=\"$ctrl.learningReportFileReplace[learningReport.learningReportId]\" filters=\"sizeFilter\"></span><md-button class=\"md-raised md-warn md-btn\" ng-if=\"learningReport.actionState === 2\" ng-click=\"$ctrl.learningReportUploadAction(\'cancelrow\', 1, learningReport.learningReportId)\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-warn md-btn\" ng-if=\"learningReport.actionState === 3\" ng-click=\"$ctrl.learningReportUploadAction(\'delete\', 1, learningReport.learningReportId)\">{{ \'ACTIONS.DELETE\' | translate}}</md-button></td></tr></tbody></table><div ng-if=\"$ctrl.learningReportStatus.isNeedOralReport || $ctrl.learningReportStatus.isNeedTeaching || $ctrl.learningReportStatus.isNeedOtherReport\"><h4 ng-if=\"$ctrl.enrollmentData.courseType === $ctrl.CourseObject.COURSETYPE_EXTERNAL\">{{ \'FIELD.OTHER\' | translate}}</h4><table class=\"basic\" ng-if=\"$ctrl.enrollmentData.courseType === $ctrl.CourseObject.COURSETYPE_EXTERNAL\"><thead><tr><th style=\"width: 40%\">{{ \'FIELD.ITEM\' | translate}}</th><th style=\"width: 40%\">{{ \'FIELD.PROGRESS_OF_SUBMIT_REPORT\' | translate}}</th><th style=\"width: 20%\">{{ \'FIELD.ACTION\' | translate}}</th></tr></thead><tbody><tr ng-if=\"$ctrl.learningReportStatus.isNeedOralReport\"><td><div>{{ \'FIELD.ORAL_REPORT\' | translate}}&nbsp;: <span ng-if=\"$ctrl.learningReportStatus.oralReportDeadline !== \'\'\">({{ \'FIELD.SUBMIT_DEADLINE\' | translate }} : {{ $ctrl.learningReportStatus.oralReportDeadline }})</span></div></td><td><div class=\"pt-mark\"><div ng-if=\"$ctrl.learningReportStatus.oralReportStatus === 0\"><span ng-if=\"$ctrl.learningReportStatus.isOralBeenApproved === 0\">{{ \'STATUS.NOT_SUBMIT\' | translate}}</span><div ng-if=\"$ctrl.learningReportStatus.isOralBeenApproved !== 0\"><span ng-if=\"$ctrl.learningReportStatus.isOralReportNeedGrade === 0\">{{ \'STATUS.SUBMITTED\' | translate}}({{ \'STATUS.NO_RATING_REQUIRED\' | translate}})</span> <span ng-if=\"$ctrl.learningReportStatus.isOralReportNeedGrade !== 0\">{{ \'STATUS.SUBMITTED\' | translate}} {{ \'FIELD.SCORE\' | translate}}&nbsp;:{{$ctrl.learningReportStatus.oralreportScore}}</span></div></div><span ng-if=\"$ctrl.learningReportStatus.oralReportStatus === 1\">{{ \'STATUS.APPROVALED\' | translate}}, <span ng-if=\"$ctrl.learningReportStatus.isOralReportNeedGrade === 1\">{{ \'FIELD.SCORE\' | translate}}&nbsp;:{{$ctrl.learningReportStatus.oralreportScore}}</span></span> <span ng-if=\"$ctrl.learningReportStatus.oralReportStatus === 2\">{{ \'STATUS.WAITING_APPROVAL\' | translate}}</span> <span ng-if=\"$ctrl.learningReportStatus.oralReportStatus === 3\">{{ \'STATUS.PUBLIC_STATUS_REJECT\' | translate}}</span> <span ng-if=\"$ctrl.learningReportStatus.oralReportStatus === 4\">{{ \'STATUS.CANCEL\' | translate}}</span></div></td><td><md-button ng-click=\"$ctrl.applyOtherReportApproval(2)\" ng-if=\"$ctrl.learningReportStatus.isCanSubmitOralReport\" class=\"md-raised md-primary\">{{ \'ACTIONS.APPLY_APPROVAL\' | translate}}</md-button></td></tr><tr ng-if=\"$ctrl.learningReportStatus.isNeedTeaching\"><td><div>{{ \'FIELD.INTERNAL_LECTURE\' | translate}}&nbsp;: <span ng-if=\"$ctrl.learningReportStatus.teacherDeadline !== \'\'\">({{ \'FIELD.SUBMIT_DEADLINE\' | translate }} : {{ $ctrl.learningReportStatus.teacherDeadline }})</span></div></td><td><div class=\"pt-mark\"><div ng-if=\"$ctrl.learningReportStatus.teachingStatus === 0\"><span ng-if=\"$ctrl.learningReportStatus.isTeachingBeenApproved === 0\">{{ \'STATUS.NOT_SUBMIT\' | translate}}</span><div ng-if=\"$ctrl.learningReportStatus.isTeachingBeenApproved !== 0\"><span ng-if=\"$ctrl.learningReportStatus.isTeachingNeedGrade === 0\">{{ \'STATUS.SUBMITTED\' | translate}}({{ \'STATUS.NO_RATING_REQUIRED\' | translate}})</span> <span ng-if=\"$ctrl.learningReportStatus.isTeachingNeedGrade !== 0\">{{ \'STATUS.SUBMITTED\' | translate}} {{ \'FIELD.SCORE\' | translate}}&nbsp;:{{$ctrl.learningReportStatus.teachingScore}}</span></div></div><span ng-if=\"$ctrl.learningReportStatus.teachingStatus === 1\">{{ \'STATUS.APPROVALED\' | translate}}, <span ng-if=\"$ctrl.learningReportStatus.isTeachingNeedGrade === 1\">{{ \'FIELD.SCORE\' | translate}}&nbsp;:{{$ctrl.learningReportStatus.teachingScore}}</span></span> <span ng-if=\"$ctrl.learningReportStatus.teachingStatus === 2\">{{ \'STATUS.WAITING_APPROVAL\' | translate}}</span> <span ng-if=\"$ctrl.learningReportStatus.teachingStatus === 3\">{{ \'STATUS.PUBLIC_STATUS_REJECT\' | translate}}</span> <span ng-if=\"$ctrl.learningReportStatus.teachingStatus === 4\">{{ \'STATUS.CANCEL\' | translate}}</span></div></td><td><md-button ng-click=\"$ctrl.applyOtherReportApproval(3)\" ng-if=\"$ctrl.learningReportStatus.isCanSubmitTeaching\" class=\"md-raised md-primary\">{{ \'ACTIONS.APPLY_APPROVAL\' | translate}}</md-button></td></tr><tr ng-if=\"$ctrl.learningReportStatus.isNeedOtherReport\"><td><div>{{ \'FIELD.OTHER_METHOD\' | translate}}({{$ctrl.learningReportStatus.otherReportWay}})&nbsp;:</div></td><td><div class=\"pt-mark\"><div ng-if=\"$ctrl.learningReportStatus.otherReportStatus === 0\"><span ng-if=\"$ctrl.learningReportStatus.isOtherReportBeenApproved === 0\">{{ \'STATUS.NOT_SUBMIT\' | translate}}</span><div ng-if=\"$ctrl.learningReportStatus.isOtherReportBeenApproved !== 0\"><span>{{ \'STATUS.SUBMITTED\' | translate}} {{ \'FIELD.SCORE\' | translate}}&nbsp;:{{$ctrl.learningReportStatus.otherReportScore}}</span></div></div><span ng-if=\"$ctrl.learningReportStatus.otherReportStatus === 1\">{{ \'STATUS.APPROVALED\' | translate}}, <span>{{ \'FIELD.SCORE\' | translate}}&nbsp;:{{$ctrl.learningReportStatus.otherReportScore}}</span></span> <span ng-if=\"$ctrl.learningReportStatus.otherReportStatus === 2\">{{ \'STATUS.WAITING_APPROVAL\' | translate}}</span> <span ng-if=\"$ctrl.learningReportStatus.otherReportStatus === 3\">{{ \'STATUS.PUBLIC_STATUS_REJECT\' | translate}}</span> <span ng-if=\"$ctrl.learningReportStatus.otherReportStatus === 4\">{{ \'STATUS.CANCEL\' | translate}}</span></div></td><td><md-button ng-click=\"$ctrl.applyOtherReportApproval(4)\" ng-if=\"$ctrl.learningReportStatus.isCanSubmitOtherReport\" class=\"md-raised md-primary\">{{ \'ACTIONS.APPLY_APPROVAL\' | translate}}</md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-enrollment.html","<div class=\"course\"><div class=\"album\" ng-if=\"$ctrl.data.courseType!==2 && $ctrl.data.courseType!==3 && $ctrl.data.courseType!==5 && $ctrl.sessionData.canAction===1 && $ctrl.enrollmentData.isBlock===0 && $ctrl.isULive === 0\"><a href=\"javascript:void(0);\" course-info-player=\"\" play-item-id=\"$ctrl.enrollmentData.lastLeaningItem.itemId\" session-id=\"$ctrl.enrollmentData.sessionId\" reload-fn=\"$ctrl.reloadFn()\"><img ng-src=\"{{$ctrl.data.logoUrl}}\" alt=\"\"> <span class=\"play\"><i class=\"material-icons\">play_arrow</i></span></a><p>{{ \'FIELD.LAST_PLAYER\' | translate}}: {{$ctrl.enrollmentData.lastLeaningItem.title | translate}}</p></div><div class=\"album\" ng-if=\"$ctrl.isULive === 0 && ($ctrl.data.courseType===2 || $ctrl.data.courseType===3 || $ctrl.data.courseType===5) || $ctrl.sessionData.canAction===0 || $ctrl.enrollmentData.isBlock===1\"><img ng-src=\"{{$ctrl.data.logoUrl}}\" alt=\"\"></div><div class=\"album\" ng-if=\"$ctrl.uLiveCourseData.respCode===200 && $ctrl.isULive === 1\"><a href=\"javascript:void(0);\" course-info-player=\"\" u-live-course-data=\"$ctrl.uLiveCourseData\" enrollment-data=\"$ctrl.enrollmentData\"><img ng-src=\"{{$ctrl.data.logoUrl}}\" alt=\"\"> <span ng-if=\"$ctrl.uLiveCourseData.wState ===2 || $ctrl.uLiveCourseData.wState ===5\" class=\"play\"><i class=\"material-icons\">play_arrow</i></span></a><p>{{ \'FIELD.LAST_PLAYER\' | translate}}: {{$ctrl.enrollmentData.lastLeaningItem.title | translate}}</p></div><div class=\"album\" ng-if=\"$ctrl.isULive === 1 && $ctrl.uLiveCourseData.respCode != 200\"><img ng-src=\"{{$ctrl.data.logoUrl}}\" alt=\"\"></div><div class=\"md-course\"><header><h3>{{ \'FIELD.ENROLLMENT_INFO\' | translate}}</h3><ul class=\"right\"><li ng-if=\"$ctrl.enrollmentData.isBlock===0 && $ctrl.enrollmentData.hasReference===1\"><a href=\"\" course-info-reference=\"\" course-id=\"$ctrl.enrollmentData.courseId\" class=\"btn btn-info\"><i class=\"fa fa-book\"></i></a> <span>{{ \'FIELD.REFERENCE_DOCUMENT\' | translate}}</span></li><li ng-if=\"$ctrl.sessionData.forumUrl.length > 0\"><a href=\"{{$ctrl.sessionData.forumUrl}}\" target=\"_blank\" class=\"btn btn-warning\"><i class=\"fa fa-comments\"></i></a> <span>{{ \'FIELD.FORUM\' | translate}}</span></li></ul></header><div class=\"pt-course\"><header><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"{ responsive: false, responsiveAnimationDuration: 500, maintainAspectRatio: true, cutoutPercentage: 75, legend: { display: false }}\" gauge-colors=\"[\'#319DB5\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.enrollmentData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\'+ $ctrl.enrollmentData.status | uppercase | translate}}</span></div><span class=\"warning\" course-info-session-will-expire=\"\" ng-if=\"$ctrl.enrollmentData.isWillExpire === 1\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" course-type=\"$ctrl.data.courseType\" is-course=\"true\"><i class=\"material-icons\">alarm</i> {{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span></header><div class=\"course-list\"><div class=\"left\"><ul><li ng-if=\"$ctrl.enrollmentData.score.length > 0 && $ctrl.data.courseType!==3\"><span class=\"li-title\">{{ \'FIELD.OVERALL_RESULT\' | translate}} :</span> <span class=\"text\" ng-if=\"$ctrl.enrollmentData.score | isNumber\">{{$ctrl.enrollmentData.score}} &nbsp;分</span> <span class=\"text\" ng-if=\"$ctrl.enrollmentData.score | isString\">{{$ctrl.enrollmentData.score}}</span></li><li><span class=\"li-title title-top\" ng-if=\"$ctrl.data.courseType!==4 && $ctrl.data.courseType!==5 && $ctrl.data.courseType!==6\">{{ \'FIELD.CLASS_TIME\' | translate}} :</span> <span class=\"li-title title-top\" ng-if=\"$ctrl.data.courseType===4 || $ctrl.data.courseType===5\">{{ \'FIELD.TEST_TIME\' | translate}} :</span> <span class=\"li-title title-top\" ng-if=\"$ctrl.data.courseType===6\">{{ \'FIELD.FILL_IN_TIME\' | translate}} :</span> <span class=\"text\" ng-bind-html=\"$ctrl.sessionData.accessPeriod |replaceAll:\'\\n\\n\':\'<br>\'\"></span></li><li ng-if=\"$ctrl.sessionData.instructorList.length > 0\"><span class=\"li-title\">{{ \'FIELD.INSTRUCTOR\' | translate}} :</span> <span class=\"text\" ng-if=\"$ctrl.data.courseType!==3\" ng-repeat=\"instructor in $ctrl.sessionData.instructorList\"><a href=\"javascript:void(0);\" instructor-detail=\"\" instructor-id=\"instructor.instructorId\">{{instructor.instructorName | htmlEscapedDecode | markSplit:$index:\'&nbsp;/&nbsp;\'}}</a></span> <span class=\"text\" ng-if=\"$ctrl.data.courseType===3\" ng-repeat=\"instructor in $ctrl.sessionData.instructorList\">{{instructor.instructorName | htmlEscapedDecode | markSplit:$index:\'&nbsp;/&nbsp;\'}}</span></li><li ng-if=\"$ctrl.data.courseType===1\"><span class=\"li-title\">{{ \'FIELD.LAST_LEARNING_DATE\' | translate}} :</span> <span class=\"text\">{{$ctrl.enrollmentData.lastLearningTime}}</span></li><li ng-if=\"($ctrl.data.courseType===1 || $ctrl.data.courseType===4 || $ctrl.data.courseType===6) && $ctrl.enrollmentData.dueDate !== \'\'\"><span class=\"li-title\">{{ \'FIELD.DUE_DATE\' | translate}} :</span> <span class=\"text\">{{$ctrl.enrollmentData.dueDate}}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span> <span class=\"text\">{{$ctrl.sessionData.sessionName}}</span></li><li ng-if=\"$ctrl.sessionData.contactPerson\"><span class=\"li-title\">{{ \'FIELD.CONTACT_PERSON\' | translate}} :</span> <span class=\"text\">{{$ctrl.sessionData.contactPerson}}</span> <a ng-if=\"$ctrl.sessionData.contactMail\" ng-href=\"mailto:{{$ctrl.sessionData.contactMail}}\"><i class=\"fa fa-envelope\"></i></a> <span ng-if=\"$ctrl.sessionData.contactPhone\" class=\"text\">({{$ctrl.sessionData.contactPhone}})</span></li><li ng-if=\"$ctrl.sessionData.place.length > 0\"><span class=\"li-title\">{{ \'FIELD.EVENT_LOCATION\' | translate}} :</span> <span class=\"text\">{{$ctrl.sessionData.place}}</span></li><li ng-if=\"$ctrl.data.duration !==-1\"><span class=\"li-title\">{{ \'FIELD.DURATION\' | translate}} :</span> <span class=\"text\">{{$ctrl.data.duration}}</span></li><li ng-if=\"$ctrl.enrollmentData.applyStatusMsg.length > 0\"><span class=\"li-title\">{{ \'FIELD.APPLY_STATUS\' | translate}} :</span> <span class=\"text\">{{$ctrl.enrollmentData.applyStatusMsg}}</span></li></ul></div><pass-rule enrollment-data=\"$ctrl.enrollmentData\"></pass-rule></div></div></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-header.html","<div class=\"th-title\" ng-if=\"!$ctrl.isProgram\"><h2>{{ \'FIELD.COURSE_NAME\' | translate}}: {{$ctrl.data.courseName}}</h2><div class=\"tagBox\"><ng-switch on=\"$ctrl.enrollmentData.learnerType\" class=\"switchTag\"><span ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><ng-switch on=\"$ctrl.data.courseType\" class=\"switchTag\"><span ng-switch-when=\"1\">{{ \'FIELD.ONLINE_COURSE\' | translate}}</span> <span ng-switch-when=\"2\">{{ \'FIELD.CLASS_ROOM_COURSE\' | translate}}</span> <span ng-switch-when=\"3\">{{ \'FIELD.EXTERNAL_TRAINING\' | translate}}{{ \'FIELD.COURSE\' | translate}}</span> <span ng-switch-when=\"4\">{{ \'FIELD.ONLINE_TEST\' | translate}}</span> <span ng-switch-when=\"5\">{{ \'FIELD.CLASS_ROOM_TEST\' | translate}}</span> <span ng-switch-when=\"6\">{{ \'FIELD.QUESTIONNAIRE\' | translate}}</span></ng-switch><span ng-repeat=\"category in $ctrl.data.categoryList\" class=\"spanTag\">{{category.categoryName}}</span></div><div class=\"right\" ng-if=\"$ctrl.goBack || $ctrl.enrollmentData.canUnEnroll || $ctrl.enrollmentData.canExemption || $ctrl.enrollmentData.canLeave\"><div class=\"el-fixed\" ng-if=\"$ctrl.goBack\"><a ui-sref=\"{{$ctrl.goBack.state}}({{$ctrl.goBack.stateParams}})\" class=\"bt-goback\"><i class=\"material-icons\">keyboard_return</i> {{ \'ACTIONS.RETURN\' | translate}}{{$ctrl.goBack.title}}</a></div><a href=\"javascript:void(0);\" class=\"bt-remove\" ng-if=\"$ctrl.enrollmentData.canUnEnroll && $ctrl.isUser!==false\" session-action-un-enroll=\"\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" is-program=\"$ctrl.isProgram\" reload-fn=\"$ctrl.reloadFn()\"><i class=\"fa fa-remove\"></i> {{ \'ACTIONS.UN_ENROLL\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"bt-not\" ng-if=\"$ctrl.enrollmentData.canExemption && $ctrl.isUser!==false && ($ctrl.hasCourseClassroomPermission && $ctrl.hasApprovalPermission)\" session-action-exemption=\"\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" is-program=\"$ctrl.isProgram\" reload-fn=\"$ctrl.reloadFn()\" permission=\"\" permission-only=\"[\'Modules.approval\']\"><i class=\"fa fa-share-square-o\"></i>{{ \'ACTIONS.EXEMPTION\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"bt-not\" ng-if=\"$ctrl.enrollmentData.canLeave && $ctrl.isUser!==false\" session-action-leave=\"\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" reload-fn=\"$ctrl.reloadFn()\"><i class=\"fa fa-user-times\"></i> {{ \'ACTIONS.LEAVE\' | translate}}</a></div></div><div class=\"th-title\" ng-if=\"$ctrl.isProgram\"><h2 ng-if=\"$ctrl.data.programType === 0\">{{ \'FIELD.PROGRAM_NAME\' | translate}}: {{$ctrl.data.programName}}</h2><h2 ng-if=\"$ctrl.data.programType === 1\">{{ \'FIELD.CERTIFICATE_NAME\' | translate}}: {{$ctrl.data.programName}}</h2><div class=\"tagBox\"><ng-switch on=\"$ctrl.enrollmentData.learnerType\" class=\"switchTag\"><span ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><ng-switch on=\"$ctrl.data.programType\" class=\"switchTag\"><span ng-switch-when=\"0\">{{ \'FIELD.PROGRAM\' | translate}}</span> <span ng-switch-when=\"1\">{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</span></ng-switch><span ng-repeat=\"category in $ctrl.data.categoryList\" class=\"spanTag\">{{category.categoryName}}</span></div><div class=\"right\" ng-if=\"$ctrl.goBack || $ctrl.enrollmentData.canUnEnroll || $ctrl.enrollmentData.canExemption || $ctrl.enrollmentData.canLeave\"><div class=\"el-fixed\" ng-if=\"$ctrl.goBack\"><a ui-sref=\"{{$ctrl.goBack.state}}({{$ctrl.goBack.stateParams}})\" class=\"bt-goback\"><i class=\"material-icons\">keyboard_return</i> {{ \'ACTIONS.RETURN\' | translate}}{{$ctrl.goBack.title}}</a></div><a href=\"javascript:void(0);\" class=\"bt-remove\" ng-if=\"$ctrl.enrollmentData.canUnEnroll && $ctrl.isUser!==false\" session-action-un-enroll=\"\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" is-program=\"$ctrl.isProgram\" reload-fn=\"$ctrl.reloadFn()\"><i class=\"fa fa-remove\"></i> {{ \'ACTIONS.UN_ENROLL\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"bt-not\" ng-if=\"$ctrl.enrollmentData.canExemption && $ctrl.isUser!==false && ($ctrl.hasCourseClassroomPermission && $ctrl.hasApprovalPermission)\" session-action-exemption=\"\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" is-program=\"$ctrl.isProgram\" reload-fn=\"$ctrl.reloadFn()\" permission=\"\" permission-only=\"[\'Modules.approval\']\"><i class=\"fa fa-share-square-o\"></i>{{ \'ACTIONS.EXEMPTION\' | translate}}</a> <a href=\"javascript:void(0);\" class=\"bt-not\" ng-if=\"$ctrl.enrollmentData.canLeave && $ctrl.isUser!==false\"><i class=\"fa fa-share-square-o\"></i>{{ \'ACTIONS.LEAVE\' | translate}}</a></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-info.html","<div class=\"tab-pane th-courseData\"><h4>{{ \'FIELD.COURSE_INFO_DETAIL\' | translate}}</h4><dl><dt>{{ \'FIELD.BASIC_INFORMATION\' | translate}}</dt><dd><ul><li><p class=\"li-title\">{{ \'FIELD.CREATE_DATE\' | translate}}：</p><p class=\"text\">{{$ctrl.data.createDate}}</p></li><li><p class=\"li-title\">{{ \'FIELD.COURSE_ATTRIBUTES\' | translate}}：</p><p class=\"text\" ng-if=\"$ctrl.data.courseType !== 3\">{{ \'FIELD.INTERNAL_TRAINING\' | translate}}</p><p class=\"text\" ng-if=\"$ctrl.data.courseType === 3\">{{ \'FIELD.EXTERNAL_TRAINING\' | translate}}</p></li><li ng-if=\"$ctrl.data.courseCode!==\'\' && $ctrl.data.courseType !== 3\"><p class=\"li-title\" ng-if=\"$ctrl.data.courseType!==4 && $ctrl.data.courseType!==5\">{{ \'FIELD.COURSE_CODE\' | translate}}：</p><p class=\"li-title\" ng-if=\"$ctrl.data.courseType===4 || $ctrl.data.courseType===5\">{{ \'FIELD.TEST_CODE\' | translate}}：</p><p class=\"text\">{{$ctrl.data.courseCode}}</p></li><li ng-if=\"$ctrl.data.duration!==-1\"><p class=\"li-title\">{{ \'FIELD.DURATION\' | translate}}：</p><p class=\"text\">{{$ctrl.data.duration | durationFormat:\"HH:mm:ss\"}}</p></li><li ng-if=\"$ctrl.data.targetAudience!==\'\'\"><p class=\"li-title\">{{ \'FIELD.SUITABLE_FOR_THE_OBJECT\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.targetAudience}}</p></li><li ng-if=\"$ctrl.data.courseType !== 3\"><p class=\"li-title\">{{ \'FIELD.ENCRYPTION\' | translate}}：</p><i class=\"material-icons red-text\" ng-if=\"$ctrl.data.isSecurity===1\">lock</i> <i class=\"material-icons green-text\" ng-if=\"$ctrl.data.isSecurity===0\">lock_open</i></li><li ng-if=\"$ctrl.data.courseType === 3\"><p class=\"li-title\">{{ \'FIELD.DOMESTIC\' | translate}}/{{ \'FIELD.ABROAD\' | translate}}：</p><p class=\"text\" ng-if=\"$ctrl.data.IsDomestic===1\">{{ \'FIELD.DOMESTIC\' | translate}}</p><p class=\"text\" ng-if=\"$ctrl.data.IsDomestic===0\">{{ \'FIELD.ABROAD\' | translate}}</p></li><li ng-if=\"$ctrl.data.availableTier!==\'\'\"><p class=\"li-title\">{{ \'FIELD.SUITABLE_FOR_LEVEL\' | translate}}：</p><p class=\"text\">{{$ctrl.data.availableTier}}</p></li><li ng-if=\"$ctrl.data.isShowCredit === 1\"><p class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}}：</p><p class=\"text\">{{$ctrl.data.credits}}</p></li><li ng-if=\"$ctrl.data.classification!==\'\'\"><p class=\"li-title\">{{ \'FIELD.CLASSIFICATION\' | translate}}：</p><p class=\"text\">{{$ctrl.data.classification}}</p></li></ul></dd></dl><dl ng-if=\"$ctrl.data.enrollmentLink!==\'\' || $ctrl.data.courseObjectives!==\'\' || $ctrl.data.description!==\'\' || $ctrl.data.note!==\'\' || $ctrl.data.remark!==\'\'\"><dt>{{ \'FIELD.COURSE_INTRODUCTION\' | translate}}</dt><dd><ul class=\"pt-full\"><li ng-if=\"$ctrl.data.enrollmentLink!==\'\'\"><p class=\"li-title\">{{ \'FIELD.ENROLLMENT_WEBSITE\' | translate}}：</p><p class=\"text\"><a ng-href=\"{{$ctrl.data.enrollmentLink}}\" target=\"_blank\">{{$ctrl.data.enrollmentLink}}</a></p></li><li ng-if=\"$ctrl.data.courseObjectives!==\'\'\"><p class=\"li-title\">{{ \'FIELD.LEARNING_GOAL\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.courseObjectives}}</p></li><li ng-if=\"$ctrl.data.description!==\'\'\"><p class=\"li-title\">{{ \'FIELD.COURSE_OUTLINE\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.description}}</p></li><li ng-if=\"$ctrl.data.note!==\'\'\"><p class=\"li-title\">{{ \'FIELD.DESCRIPTION\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.note}}</p></li><li ng-if=\"$ctrl.data.remark!==\'\'\"><p class=\"li-title\">{{ \'FIELD.REMARK\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.remark}}</p></li></ul></dd></dl><dl><dt>{{ \'FIELD.OTHER\' | translate}}</dt><dd><ul><li ng-if=\"$ctrl.data.prerequesiteKnowledge!==\'\'\"><p class=\"li-title\">{{ \'FIELD.PREPARATORY_KNOWLEDGE\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.prerequesiteKnowledge}}</p></li><li ng-if=\"$ctrl.data.courseType !== 3\"><p class=\"li-title\">{{ \'FIELD.DIFFICULTY\' | translate}}：</p><p class=\"text\" ng-if=\"$ctrl.data.difficulty!==0\"><ng-rate-it ng-model=\"$ctrl.data.difficulty\" read-only=\"true\"></ng-rate-it></p><p class=\"text\" ng-if=\"$ctrl.data.difficulty===0\">{{ \'FIELD.NOTHING\' | translate}}</p></li><li ng-if=\"$ctrl.data.keyword!==\'\'\"><p class=\"li-title\">{{ \'FIELD.KEYWORD\' | translate}}：</p><p class=\"text\">{{$ctrl.data.keyword}}</p></li><li ng-if=\"$ctrl.data.certificate!==\'\'\"><p class=\"li-title\">{{ \'FIELD.RELATED_CERTIFICATE\' | translate}}：</p><p class=\"text\">{{$ctrl.data.certificate}}</p></li><li ng-if=\"$ctrl.data.certificate!==\'\'\"><p class=\"li-title\">{{ \'FIELD.CERTIFICATE_RECOGNIZED_HOURS\' | translate}}：</p><p class=\"text\">{{$ctrl.data.certificateAuthHours}}hr</p></li><li ng-if=\"$ctrl.data.learingReportCount!==0\"><p class=\"li-title\">{{ \'FIELD.LEARNING_REPORT\' | translate}}：</p><p class=\"text\"><a href=\"javascript:void(0)\" learning-report-dialog=\"\" course-id=\"$ctrl.data.courseId\" activity-name=\"$ctrl.data.courseName\" is-program=\"0\">{{ \'FIELD.WATCH_REPORT\' | translate }}</a></p></li><li ng-if=\"$ctrl.data.externalCourseReferences.length > 0\"><p class=\"li-title\">{{ \'FIELD.REFERENCE_DOCUMENT\' | translate}}：</p><a ng-repeat=\"references in $ctrl.data.externalCourseReferences\" ng-href=\"{{references.downloadUrl | trustAsResourceUrl}}\" target=\"_blank\"><p class=\"text\">{{references.fileName}}</p></a></li><li ng-if=\"$ctrl.referenceData.length > 0\"><p class=\"li-title\">{{ \'FIELD.REFERENCE_DOCUMENT\' | translate}}：</p><a ng-repeat=\"referenceData in $ctrl.referenceData\" ng-href=\"{{referenceData.downloadUrl | trustAsResourceUrl}}\" target=\"_blank\"><p class=\"text\">{{referenceData.fileName}}</p></a></li></ul></dd></dl></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-learning-content.html","<div class=\"tab-pane th-core\" id=\"tab_1\" ng-if=\"!$ctrl.isProgram\"><h4>{{ \'FIELD.LEARNING_CENTER\' | translate}}</h4><tree-table tree-class=\"\" icon-leaf=\"fa fa-film\" template-url=\"tree-table-course-content-template.html\" data-indent=\"15\" data-indent-unit=\"px\" data-indent-plus=\"10\" tree-control=\"\" tree-data=\"$ctrl.courseContent\" column-defs=\"$ctrl.courseContentTable.courseContentColDef\" expand-on=\"$ctrl.courseContentTable.courseContentProperty\" ng-if=\"$ctrl.courseContent.length > 0\"></tree-table><div class=\"pt-noData\" ng-if=\"$ctrl.courseContent.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'MESSAGE.MSG_CURRENTLY_ON_THE_TEMPORARY_LEARNING_RESOURCES\' | translate}}</p></div><script type=\"text/ng-template\" id=\"tree-table-course-content-template.html\"><table ng-class=\"$tree_class\"> <thead> <tr> <th ng-class=\"expandingProperty.titleClass\" ng-style=\"expandingProperty.titleStyle\"> {{expandingProperty.displayName || expandingProperty.field || expandingProperty}} </th> <th ng-repeat=\"col in colDefinitions\" ng-class=\"col.titleClass\" ng-style=\"col.titleStyle\"> {{col.displayName || col.field}} </th> </tr> </thead> <tbody tree-table-nodes> <tr tree-table-node=\"node\" ng-repeat=\"node in tree_nodes track by node.__hashKey__\" ng-if=\"(node.__inited__ || node.__visible__)\" ng-class=\"(node.__selected__ ? \'active\':\'\')\" > <td tree-table-node-handle ng-style=\"expandingProperty.cellStyle ? expandingProperty.cellStyle : {\'padding-left\': $callbacks.calsIndent(node.__level__)}\" ng-class=\"expandingProperty.cellClass\" compile=\"expandingProperty.cellTemplate\"> <div class=\"pt-title\"> <div class=\"title\"> <div data-nodrag style=\"width:100%\"> <i ng-class=\"node.__icon_class__\" class=\"tree-icon\" ng-click=\"onSelect(node); (node.isFolderType===1)?toggleExpand(node):null\" ></i> <div style=\"display:inline-block;width:90%\" course-info-player play-item-id=\"node[\'itemId\']\" session-id=\"$ctrl.courseSessionId\" reload-fn=\"$ctrl.reloadFn()\" play-disable=\"(node.resourceId<=0)\"> <span ng-if=\"node.isFolderType > 0 && (node[expandingProperty.field] === \'course_folder_presurvey\' || node[expandingProperty.field] === \'course_folder_pretest\' || node[expandingProperty.field] === \'course_folder_content\' || node[expandingProperty.field] === \'course_folder_postsurvey\' || node[expandingProperty.field] === \'course_folder_posttest\' || node[expandingProperty.field] === \'course_folder_reference\' || node[expandingProperty.field] === \'course_folder_test\' || node[expandingProperty.field] === \'course_folder_survey\')\"> {{ \'FIELD.\'+ node[expandingProperty.field] || node[expandingProperty] | uppercase | translate}} </span> <span ng-if=\"!(node.isFolderType > 0 && (node[expandingProperty.field] === \'course_folder_presurvey\' || node[expandingProperty.field] === \'course_folder_pretest\' || node[expandingProperty.field] === \'course_folder_content\' || node[expandingProperty.field] === \'course_folder_postsurvey\' || node[expandingProperty.field] === \'course_folder_posttest\' || node[expandingProperty.field] === \'course_folder_reference\' || node[expandingProperty.field] === \'course_folder_test\' || node[expandingProperty.field] === \'course_folder_survey\'))\"> {{node[expandingProperty.field] || node[expandingProperty]}} </span> </div> </div> </div> <a href=\"\" class=\"more\"><i class=\"material-icons\">more_vert</i></a> </div> </td> <td ng-repeat=\"col in colDefinitions\" ng-class=\"col.cellClass\" ng-style=\"col.cellStyle\" compile=\"col.cellTemplate\"> <ng-switch on=\"col.field\"> <div class=\"time\" ng-switch-when=\"totalTime\"> {{ node[col.fieldGroup][col.field]}} </div> <div class=\"time\" ng-switch-when=\"showLength\"> {{node[col.field]}} </div> <div class=\"condition\" ng-if=\"node[\'resourceId\']>0 && node[\'itemSection\']!==\'Reference\'\" ng-switch-when=\"lessonStatus\" ng-class=\"{\'ok\': (node[col.fieldGroup][col.field] === \'passed\' || node[col.fieldGroup][col.field] ===\'completed\')}\" ng-switch=\"node[col.fieldGroup][col.field]\"> <i class=\"material-icons\" ng-switch-when=\"passed\">assignment_turned_in</i> <i class=\"material-icons\" ng-switch-when=\"failed\">error_outline</i> <i class=\"material-icons\" ng-switch-when=\"incomplete\">assignment_late</i> <i class=\"material-icons\" ng-switch-when=\"completed\">check_circle</i> {{ \'STATUS.\' + node[col.fieldGroup][col.field] | uppercase | translate}} </div> <span ng-switch-default>{{node[col.field]}}</span> </ng-switch> </td> <!--#remove by w3c, #85085, start--> <!--<td class=\"pt-detail\" ng-repeat=\"col in colDefinitions\" compile=\"col.cellTemplate\">--> <!--<ul>--> <!--<li>--> <!--<p>{{ \'FIELD.MINIMUM_VIEWING_TIME\' | translate}} : </p>--> <!--<div class=\"progress\">--> <!--<div class=\"progress-bar\" style=\"width: 100%;\">--> <!--<span class=\"progress-icon\"></span>--> <!--<div class=\"progress-value\">190min</div>--> <!--</div>--> <!--</div>--> <!--</li>--> <!--<li>--> <!--<p>{{ \'FIELD.COURSE_TIME\' | translate}} : </p>--> <!--<div class=\"time\">190Min</div>--> <!--</li>--> <!--<li>--> <!--<p>{{ \'FIELD.STATUS\' | translate}} : </p>--> <!--<div class=\"condition\"><i class=\"mdi-action-info-outline\"></i>{{ \'FIELD.INCOMPLETED\' | translate}}</div>--> <!--</li>--> <!--</ul>--> <!--</td>--> <!--#remove by w3c, #85085, end--> </tr> </tbody> </table></script></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-learning-results.html","<div class=\"tab-pane th-core\" id=\"tab_1\" ng-if=\"!$ctrl.isProgram\"><h4>{{ \'FIELD.LEARNING_RESULT\' | translate}}</h4><header ng-if=\"$ctrl.attendanceRecords.length > 0\"><h3>{{\'FIELD.ATTENDANCE_RECORD\' | translate}}: {{\'FIELD.ATTENDANCE_RATE\' | translate }} <span class=\"text-danger\">{{$ctrl.learningHistoryData.attendance}} %</span></h3></header><table class=\"tb-learningHistory tb-check\" ng-if=\"$ctrl.attendanceRecords.length > 0\"><thead><tr><th>{{\'FIELD.DATE\' | translate}}</th><th>{{\'FIELD.TIME\' | translate}}</th><th>{{\'FIELD.CLASS_HOUR\' | translate}}</th><th>{{\'FIELD.ATTENDANCE_STATISTIC\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"attendanceRecord in $ctrl.attendanceRecords\"><td>{{attendanceRecord.date}}</td><td>{{attendanceRecord.time}}</td><td>{{attendanceRecord.hourLength}}{{\'FIELD.HOUR\' | translate}}</td><td ng-if=\"attendanceRecord.hasLeaveRecord===0\">{{\'STATUS.ATTENDANCE\' | translate}}</td><td ng-if=\"attendanceRecord.hasLeaveRecord===1\" ng-repeat=\"attendanceStatistic in attendanceRecord.attendanceStatistic\">{{attendanceStatistic.formatTime}} <span ng-if=\"attendanceStatistic.attendanceType===0\">{{\'STATUS.LEAVE_APPROVAL_PENDING\' | translate}}</span> <span ng-if=\"attendanceStatistic.attendanceType===1\">{{\'STATUS.ABSENCE\' | translate}}</span> <span ng-if=\"attendanceStatistic.attendanceType===2\">{{\'ACTIONS.LEAVE\' | translate}}</span></td></tr></tbody></table><tree-table tree-class=\"\" icon-leaf=\"fa fa-film\" template-url=\"tree-table-course-result-template.html\" data-indent=\"15\" data-indent-unit=\"px\" data-indent-plus=\"10\" tree-control=\"\" tree-data=\"$ctrl.courseResult\" column-defs=\"$ctrl.courseContentTable.courseResultColDef\" expand-on=\"$ctrl.courseContentTable.courseResultProperty\" ng-if=\"$ctrl.courseResult.length > 0\"></tree-table><script type=\"text/ng-template\" id=\"tree-table-course-result-template.html\"><table ng-class=\"$tree_class\"> <thead> <tr> <th ng-class=\"expandingProperty.titleClass\" ng-style=\"expandingProperty.titleStyle\"> {{expandingProperty.displayName || expandingProperty.field || expandingProperty}} </th> <th ng-repeat=\"col in colDefinitions\" ng-class=\"col.titleClass\" ng-style=\"col.titleStyle\"> {{col.displayName || col.field}} </th> </tr> </thead> <tbody tree-table-nodes> <tr tree-table-node=\"node\" ng-repeat=\"node in tree_nodes track by node.__hashKey__\" ng-if=\"(node.__inited__ || node.__visible__||node.ivqType!=0)\" ng-click=\"toggleExpand(node)\" ng-class=\"[{true: \'active\'}[node.__selected__ ], {true: \'cursor-default\'}[node.isFolderType===0]]\"> <td ng-style=\"expandingProperty.cellStyle ? expandingProperty.cellStyle : {\'padding-left\': $callbacks.calsIndent(node.__level__)}\" ng-class=\"expandingProperty.cellClass\" compile=\"expandingProperty.cellTemplate\"> <div class=\"pt-title\"> <div class=\"title\" > <a href=\"\" data-nodrag ng-style=\"node.__icon_class__===\'fa fa-film\' && {\'cursor\':\'default\'}\"> <i ng-class=\"node.__icon_class__\" ng-style=\"node.__icon_class__===\'fa fa-film\' && {\'cursor\':\'default\'}\" class=\"tree-icon\"></i> </a> <span style=\"color:black;\" ng-if=\"node.isFolderType > 0 && (node[expandingProperty.field] === \'course_folder_presurvey\' || node[expandingProperty.field] === \'course_folder_pretest\' || node[expandingProperty.field] === \'course_folder_content\' || node[expandingProperty.field] === \'course_folder_postsurvey\' || node[expandingProperty.field] === \'course_folder_posttest\' || node[expandingProperty.field] === \'course_folder_reference\' || node[expandingProperty.field] === \'course_folder_test\' || node[expandingProperty.field] === \'course_folder_survey\')\"> {{ \'FIELD.\'+ node[expandingProperty.field] || node[expandingProperty] | uppercase | translate}} </span> <span style=\"color:black;\" ng-if=\"!(node.isFolderType > 0 && (node[expandingProperty.field] === \'course_folder_presurvey\' || node[expandingProperty.field] === \'course_folder_pretest\' || node[expandingProperty.field] === \'course_folder_content\' || node[expandingProperty.field] === \'course_folder_postsurvey\' || node[expandingProperty.field] === \'course_folder_posttest\' || node[expandingProperty.field] === \'course_folder_reference\' || node[expandingProperty.field] === \'course_folder_test\' || node[expandingProperty.field] === \'course_folder_survey\'))\"> {{node[expandingProperty.field] || node[expandingProperty]}} </span> </div> <a href=\"\" class=\"more\"><i class=\"material-icons\">more_vert</i></a> </div> </td> <td ng-repeat=\"col in colDefinitions\" ng-class=\"col.cellClass\" ng-style=\"col.cellStyle\" compile=\"col.cellTemplate\" data-th=\"{{col.displayName}}\"> <ng-switch on=\"col.field\"> <div class=\"time\" ng-switch-when=\"totalTime\"> {{ node[col.fieldGroup][col.field]}} </div> <div class=\"time\" ng-switch-when=\"accessDate\"> {{ node[col.fieldGroup][col.field]}} </div> <div class=\"time\" ng-switch-when=\"scoreRaw\"> <a ng-if=\"node[col.fieldGroup][\'isValidAnnounce\']===1 && node[col.fieldGroup][\'isAllowViewScore\']===1\" href=\"javascript:void(0);\" test-history-search-dialog session-id=\"node[col.fieldGroup][\'sessionId\']\" item-id=\"node[col.fieldGroup][\'itemId\']\" course-content=\"node[expandingProperty.field]\"> {{ node[col.fieldGroup][col.field]}} </a> <span ng-if=\"node[col.fieldGroup][\'isValidAnnounce\']===0 && node[col.fieldGroup][\'isAllowViewScore\']===1\"> {{ node[col.fieldGroup][col.field]}} </span> <span ng-if=\"node[col.fieldGroup][\'isTestClassScoreView\'] === 1\"> {{ node[col.fieldGroup][col.field]}} </span> </div> <div class=\"condition\" ng-if=\"node[\'resourceId\']>0 && node[\'itemSection\']!==\'Reference\'\" ng-switch-when=\"lessonStatus\" ng-class=\"{\'ok\': (node[col.fieldGroup][col.field] === \'passed\' || node[col.fieldGroup][col.field] ===\'completed\')}\" ng-switch=\"node[col.fieldGroup][col.field]\"> <i class=\"material-icons\" ng-switch-when=\"passed\">assignment_turned_in</i> <i class=\"material-icons\" ng-switch-when=\"failed\">error_outline</i> <i class=\"material-icons\" ng-switch-when=\"incomplete\">assignment_late</i> <i class=\"material-icons\" ng-switch-when=\"completed\">check_circle</i> <span ng-if = \" node[col.fieldGroup][col.field] === \'passed\' || node[col.fieldGroup][col.field] === \'failed\' || node[col.fieldGroup][col.field] === \'incomplete\' || node[col.fieldGroup][col.field] === \'completed\' \"> {{ \'STATUS.\' + node[col.fieldGroup][col.field] | uppercase | translate}} </span> </div> <span ng-switch-default> {{ node[col.fieldGroup][col.field]}} </span> </ng-switch> </td> <td class=\"pt-detail\" ng-repeat=\"col in colDefinitions\" compile=\"col.cellTemplate\"> <ul> <li> <p>{{ \'FIELD.MINIMUM_VIEWING_TIME\' | translate}} : </p> <div class=\"progress\"> <div class=\"progress-bar\" style=\"width: 100%;\"> <span class=\"progress-icon\"></span> <div class=\"progress-value\">190min</div> </div> </div> </li> <li> <p>{{ \'FIELD.COURSE_TIME\' | translate}} : </p> <div class=\"time\">190Min</div> </li> <li> <p>{{ \'FIELD.STATUS\' | translate}} : </p> <div class=\"condition\"><i class=\"mdi-action-info-outline\"></i>{{ \'FIELD.INCOMPLETED\' | translate}}</div> </li> </ul> </td> </tr> </tbody> </table></script></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-learning-ulive-content.html","<div class=\"tab-pane th-core\" id=\"tab_1\" ng-if=\"!$ctrl.isProgram\"><h4>{{ \'FIELD.LEARNING_CENTER\' | translate}}</h4><tree-table tree-class=\"\" icon-leaf=\"fa fa-film\" template-url=\"tree-table-course-content-template.html\" data-indent=\"15\" data-indent-unit=\"px\" data-indent-plus=\"10\" tree-control=\"\" tree-data=\"$ctrl.courseContent\" column-defs=\"$ctrl.courseContentTable.courseContentColDef\" expand-on=\"$ctrl.courseContentTable.courseContentProperty\"></tree-table><script type=\"text/ng-template\" id=\"tree-table-course-content-template.html\"><table ng-class=\"$tree_class\"> <thead> <tr> <th ng-class=\"expandingProperty.titleClass\" ng-style=\"expandingProperty.titleStyle\"> {{expandingProperty.displayName || expandingProperty.field || expandingProperty}} </th> <th ng-repeat=\"col in colDefinitions\" ng-class=\"col.titleClass\" ng-style=\"col.titleStyle\"> {{col.displayName || col.field}} </th> </tr> </thead> <tbody tree-table-nodes> <tr tree-table-node=\"node\" ng-repeat=\"node in tree_nodes track by node.__hashKey__\" ng-if=\"(node.__inited__ || node.__visible__)\" ng-class=\"(node.__selected__ ? \'active\':\'\')\" > <td tree-table-node-handle ng-style=\"expandingProperty.cellStyle ? expandingProperty.cellStyle : {\'padding-left\': $callbacks.calsIndent(node.__level__)}\" ng-class=\"expandingProperty.cellClass\" compile=\"expandingProperty.cellTemplate\"> <div class=\"pt-title\"> <div class=\"title\"> <div data-nodrag style=\"width:100%\"> <i ng-class=\"node.__icon_class__\" class=\"tree-icon\" ng-click=\"onSelect(node); (node.isFolderType===1)?toggleExpand(node):null\" ></i> <div style=\"display:inline-block;width:90%\" course-info-player enrollment-data=\"$ctrl.enrollmentData\" u-live-course-data=\"node[\'uLiveCourseData\']\" play-item-id=\"node[\'itemId\']\" session-id=\"$ctrl.courseSessionId\" reload-fn=\"$ctrl.reloadFn()\" play-disable=\"(node.resourceId<=0)\"> <span ng-if=\"node.isFolderType > 0 && (node[expandingProperty.field] === \'course_folder_presurvey\' || node[expandingProperty.field] === \'course_folder_pretest\' || node[expandingProperty.field] === \'course_folder_content\' || node[expandingProperty.field] === \'course_folder_postsurvey\' || node[expandingProperty.field] === \'course_folder_posttest\' || node[expandingProperty.field] === \'course_folder_reference\' || node[expandingProperty.field] === \'course_folder_test\' || node[expandingProperty.field] === \'course_folder_survey\' || node[expandingProperty.field] === \'course_folder_live\')\"> {{ \'FIELD.\'+ node[expandingProperty.field] || node[expandingProperty] | uppercase | translate}} </span> <span ng-if=\"!(node.isFolderType > 0 && (node[expandingProperty.field] === \'course_folder_presurvey\' || node[expandingProperty.field] === \'course_folder_pretest\' || node[expandingProperty.field] === \'course_folder_content\' || node[expandingProperty.field] === \'course_folder_postsurvey\' || node[expandingProperty.field] === \'course_folder_posttest\' || node[expandingProperty.field] === \'course_folder_reference\' || node[expandingProperty.field] === \'course_folder_test\' || node[expandingProperty.field] === \'course_folder_survey\'|| node[expandingProperty.field] === \'course_folder_live\'))\"> {{node[expandingProperty.field] || node[expandingProperty]}} </span> </div> </div> </div> <a href=\"\" class=\"more\"><i class=\"material-icons\">more_vert</i></a> </div> </td> <td ng-repeat=\"col in colDefinitions\" ng-class=\"col.cellClass\" ng-style=\"col.cellStyle\" compile=\"col.cellTemplate\"> <ng-switch on=\"col.field\"> <div class=\"time\" ng-switch-when=\"totalTime\"> {{ node[col.fieldGroup][col.field]}} </div> <div class=\"time\" ng-switch-when=\"showLength\"> {{node[col.field]}} </div> <div class=\"condition\" ng-if=\"node[\'resourceId\']>0 && node[\'itemSection\']!==\'Reference\'\" ng-switch-when=\"lessonStatus\" ng-class=\"{\'ok\': (node[col.fieldGroup][col.field] === \'passed\' || node[col.fieldGroup][col.field] ===\'completed\')}\" ng-switch=\"node[col.fieldGroup][col.field]\"> <i class=\"material-icons\" ng-switch-when=\"passed\">assignment_turned_in</i> <i class=\"material-icons\" ng-switch-when=\"failed\">error_outline</i> <i class=\"material-icons\" ng-switch-when=\"incomplete\">assignment_late</i> <i class=\"material-icons\" ng-switch-when=\"completed\">check_circle</i> {{ \'STATUS.\' + node[col.fieldGroup][col.field] | uppercase | translate}} </div> <span ng-switch-default>{{node[col.field]}}</span> </ng-switch> </td> <td class=\"pt-detail\" ng-repeat=\"col in colDefinitions\" compile=\"col.cellTemplate\"> <ul> <li ng-if=\"!$ctrl.uLiveCourseData\"> <p>{{ \'FIELD.MINIMUM_VIEWING_TIME\' | translate}} : </p> <div class=\"progress\"> <div class=\"progress-bar\" style=\"width: 100%;\"> <span class=\"progress-icon\"></span> <div class=\"progress-value\">190min</div> </div> </div> </li> <li> <p>{{ \'FIELD.COURSE_TIME\' | translate}} : </p> <div class=\"time\">190Min</div> </li> <li> <p>{{ \'FIELD.STATUS\' | translate}} : </p> <div class=\"condition\"><i class=\"mdi-action-info-outline\"></i>{{ \'FIELD.INCOMPLETED\' | translate}}</div> </li> </ul> </td> </tr> </tbody> </table></script></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-prerequisite-items.html","<div class=\"tab-pane th-courseData\" ng-if=\"$ctrl.data.length > 0\"><h4 ng-if=\"$ctrl.programType === 0 || $ctrl.courseType!==null\">{{ \'PREREQUISITE_ITEMS\' | translate}}</h4><h4 ng-if=\"$ctrl.programType === 1\">{{ \'NEED_GET_PREREQUISITE_ITEMS\' | translate}}</h4><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div ng-repeat=\"prerequisite in $ctrl.data\" layout=\"column\"><md-checkbox class=\"m-r-20\" ng-disabled=\"true\" ng-checked=\"prerequisite.isPass\"><a ng-if=\"prerequisite.courseType===1 || prerequisite.courseType===2\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"1\" params=\"{cid: prerequisite.itemId}\">{{prerequisite.itemName}}</a> <a ng-if=\"prerequisite.courseType===3\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"13\" params=\"{cid: prerequisite.itemId}\">{{prerequisite.itemName}}</a> <a ng-if=\"prerequisite.courseType===4 || prerequisite.courseType===5\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"16\" params=\"{id: prerequisite.itemId}\">{{prerequisite.itemName}}</a> <a ng-if=\"prerequisite.courseType===6\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"17\" params=\"{id: prerequisite.itemId}\">{{prerequisite.itemName}}</a> <a ng-if=\"prerequisite.itemType===2\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"3\" params=\"{pid: prerequisite.itemId}\">{{prerequisite.itemName}}</a> <a ng-if=\"prerequisite.itemType===3\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"18\" params=\"{certid: prerequisite.itemId}\">{{prerequisite.itemName}}</a> <a ng-if=\"prerequisite.itemType===4\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"7\" params=\"{subid: prerequisite.itemId}\">{{prerequisite.itemName}}</a></md-checkbox></div></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-detail-recommend-lessons.html","<div class=\"widget widget_slider th-slide\"><h4>{{ \'FIELD.YOU_MAY_BE_INTERESTED_IN_THE_FOLLOWING_COURSES\' |translate}}</h4><slick dots=\"false\" infinite=\"false\" speed=\"300\" slides-to-show=\"6\" responsive=\"$ctrl.miniGalleryResponsive\" touch-move=\"true\" slides-to-scroll=\"6\" ng-if=\"$ctrl.recommendCourses.length > 0\"><div class=\"slide md-packList side-border\" ng-class=\"{1:\'elearn\', 2:\'room\', 3:\'train\', 7:\'package\', 8:\'licenses\', 0:{0:\'package\', 1:\'licenses\'}[recommendCourse.programType]}[recommendCourse.courseType]\" ng-repeat=\"recommendCourse in $ctrl.recommendCourses track by $index\"><a href=\"javascript:void(0)\" ng-if=\"recommendCourse.itemType===$ctrl.SessionObject.COURSE\" ui-sref=\"courseResourceCatalog.CourseInfo({cid: $ctrl.catalogId, nid: recommendCourse.categoryTreeId, courseId:recommendCourse.itemId})\"><course-type-tag course-type=\"recommendCourse.courseType\" is-program=\"false\"></course-type-tag><figure><img ng-src=\"{{::recommendCourse.logoUrl}}\" alt=\"\"></figure><span>{{::recommendCourse.itemName}}</span></a> <a href=\"javascript:void(0)\" ng-if=\"recommendCourse.itemType===$ctrl.SessionObject.PROGRAM\" ui-sref=\"courseResourceCatalog.ProgramInfo({cid: $ctrl.catalogId, nid: recommendCourse.categoryTreeId, programId:recommendCourse.itemId})\"><course-type-tag program-type=\"recommendCourse.programType\" is-program=\"true\"></course-type-tag><figure><img ng-src=\"{{::recommendCourse.logoUrl}}\" alt=\"\"></figure><span>{{::recommendCourse.itemName}}</span></a></div></slick><div class=\"pt-noData\" ng-if=\"$ctrl.recommendCourses.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.STAY_TUNED\' | translate}}</p></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/course-type-tag.html","<ng-switch on=\"courseType\" ng-if=\"!isProgram\"><div class=\"tag\" ng-switch-when=\"1\" ng-class=\"{\'elearn\': isShowClass}\"><i class=\"icon icon-globe\"></i><p ng-if=\"isShowText\">{{ \'FIELD.ONLINE_COURSE\' | translate}}</p></div><div class=\"tag\" ng-switch-when=\"2\" ng-class=\"{\'room\': isShowClass}\"><i class=\"material-icons\">school</i><p ng-if=\"isShowText\">{{ \'FIELD.CLASS_ROOM_COURSE\' | translate}}</p></div><div class=\"tag\" ng-switch-when=\"3\" ng-class=\"{\'train\': isShowClass}\"><i class=\"material-icons\">perm_camera_mic</i><p ng-if=\"isShowText\">{{ \'FIELD.EXTERNAL_TRAINING\' | translate}}</p></div><div class=\"tag\" ng-switch-when=\"4\" ng-class=\"{\'test-e\': isShowClass}\"><i class=\"fa fa-pencil\"></i><p ng-if=\"isShowText\">{{ \'FIELD.ONLINE_TEST\' | translate}}</p></div><div class=\"tag\" ng-switch-when=\"5\" ng-class=\"{\'test\': isShowClass}\"><i class=\"fa fa-pencil\"></i><p ng-if=\"isShowText\">{{ \'FIELD.CLASS_ROOM_TEST\' | translate}}</p></div><div class=\"tag\" ng-switch-when=\"6\" ng-class=\"{\'package\': isShowClass}\"><i class=\"fa fa-file-text\"></i><p ng-if=\"isShowText\">{{ \'FIELD.QUESTIONNAIRE\' | translate}}</p></div><div class=\"tag\" ng-switch-when=\"9\" ng-class=\"{\'train\': isShowClass}\"><i class=\"fa fa-file-text\"></i><p ng-if=\"isShowText\">{{ \'FIELD.TRACK_QUESTIONNAIRE\' |translate }}</p></div></ng-switch><div class=\"tag\" ng-if=\"isProgram\" ng-switch=\"programType\"><i ng-switch-when=\"0\" class=\"material-icons\">folder_shared</i> <i ng-switch-when=\"1\" class=\"material-icons\">assignment_ind</i><p ng-switch-when=\"0\" ng-if=\"isShowText\">{{ \'FIELD.PROGRAM\' | translate}}</p><p ng-switch-when=\"1\" ng-if=\"isShowText\">{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</p></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/detail-completion-rate.html","<div class=\"th-complete\" ng-if=\"$ctrl.isShow\"><div class=\"md-complete\"><h6>{{ \'FIELD.COMPLETION_PERCENTAGE\' | translate}}</h6><div class=\"progress\"><div class=\"progress-bar\" ng-style=\"{\'width\': $ctrl.data.completionRate}\"><span class=\"progress-icon\"><i class=\"material-icons\">directions_walk</i></span></div><div class=\"progress-value\">{{$ctrl.data.completionRate}}</div></div></div><footer><h6>{{ \'FIELD.RECENTLY_COMPLETED_THE_TRAINEES\' | translate}}</h6><ul><li ng-repeat=\"classmate in $ctrl.data.classmate\"><div class=\"el-person\"><avatar avatar-url=\"classmate.avatarUrl\" first-name=\"classmate.firstName\"></avatar><span>{{classmate.userName}}</span></div></li></ul></footer></div><div class=\"th-complete\" ng-if=\"!$ctrl.isShow\"><div class=\"slogan\"><div class=\"md-slogan\" ng-if=\"$ctrl.data.classmate.length > 0\"><span class=\"word\">{{ \'LEARNING_IS_TO_WALK_IN_THE_RIGHT_DIRECTION\' | translate}}</span><i class=\"ctms-icons ctms-sn-map\"></i></div><div class=\"md-slogan pt-blue\" ng-if=\"$ctrl.data.classmate.length === 0\"><span class=\"word\">{{ \'LEARNING_IS_TO_BREAK_THROUGH_THEIR_OWN\' | translate}}</span><i class=\"ctms-icons ctms-sn-runner\"></i></div></div><footer><h6 ng-if=\"$ctrl.data.classmate.length > 0\">{{ \'FIELD.RECENTLY_COMPLETED_THE_TRAINEES\' | translate}}</h6><h6 ng-if=\"$ctrl.data.classmate.length === 0\">{{ \'FIELD.RECENTLY_COMPLETED_THE_TRAINEES\' | translate}}</h6><div class=\"pic\" ng-if=\"$ctrl.data.classmate.length === 0\"><img ng-src=\"{{ \'completion-rate-03\' | sunnetPicture:\'png\'}}\" alt=\"\"></div><ul ng-if=\"$ctrl.data.classmate.length > 0\"><li ng-repeat=\"classmate in $ctrl.data.classmate\"><div class=\"el-person\"><avatar avatar-url=\"classmate.avatarUrl\" first-name=\"classmate.firstName\"></avatar><span>{{classmate.userName}}</span></div></li></ul></footer></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/detail-session-learners.html","<div class=\"tab-pane th-classmate\" id=\"tab_3\"><h4>{{ \'FIELD.CLASSMATE\' | translate}}</h4><table ng-table=\"$ctrl.sessionLearnersTable\" class=\"animate\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'FIELD.FULL_NAME\' | translate\"><div class=\"el-person\"><avatar avatar-url=\"row.avatarUrl\" first-name=\"row.firstName\"></avatar><span>{{row.userName}}</span></div></td><td data-title=\"\'FIELD.DEPARTMENT\' | translate\"><div class=\"text\">{{row.groupName}}</div></td><td data-title=\"\'FIELD.EMAIL\' | translate\"><a ng-href=\"mailto:{{ row.mail }}\" target=\"_blank\">{{row.mail}}</a></td><td data-title=\"\'FIELD.OFFICE_PHONE\' | translate\"><div class=\"text\">{{row.phone}}</div></td></tr></table></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/detail-session-list-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"70\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SESSION_INFO\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"th-tab\"><div class=\"tab-content\"><md-content class=\"md-padding\"><detail-session-list course-id=\"$ctrl.courseId\" is-program=\"$ctrl.isProgram\" md-dialog-close=\"$ctrl.close()\"></detail-session-list></md-content></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/detail-session-list.html","<div class=\"tab-pane th-assign\"><h4>{{ \'FIELD.SESSION_INFO\' | translate}}</h4><div ng-if=\"$ctrl.enrollSessionsDataTable\"><table ng-table-dynamic=\"$ctrl.enrollSessionsDataTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/pass-rule.html","<div class=\"right\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.passRule()\" class=\"link rule-link\">{{ \'FIELD.UNDERSTANDING\' | translate}}{{ \'FIELD.THROUGH_THE_RULES\' | translate}}<i class=\"material-icons\">keyboard_arrow_right</i></a><div class=\"link rule\" ng-if=\"$ctrl.passRuleSwitch===1\"><ul><li ng-repeat=\"passRule in $ctrl.enrollmentData.passRules\" ng-class=\"{\'active\': passRule.status===1, \'fail\':passRule.status===2}\" ng-switch=\"passRule.status\"><i class=\"material-icons\" ng-switch-when=\"0\">check_box_outline_blank</i> <i class=\"material-icons\" ng-switch-when=\"1\">check_box</i> <i class=\"material-icons\" ng-switch-when=\"2\">cancel</i> <span ng-bind-html=\"passRule.title |replaceAll:\'\\n\':\'<br>\'\"></span></li></ul></div><div class=\"rule\" ng-if=\"$ctrl.enrollmentData.courseType!==3 && $ctrl.enrollmentData.passRules.length>0\"><header><i class=\"material-icons\">info_outline</i>{{ \'FIELD.THROUGH_THE_RULES\' | translate}} :</header><ul><li ng-repeat=\"passRule in $ctrl.enrollmentData.passRules\" ng-class=\"{\'active\': passRule.status===1, \'fail\':passRule.status===2}\" ng-switch=\"passRule.status\"><i class=\"material-icons\" ng-switch-when=\"0\">check_box_outline_blank</i> <i class=\"material-icons\" ng-switch-when=\"1\">check_box</i> <i class=\"material-icons\" ng-switch-when=\"2\">cancel</i> <span ng-bind-html=\"passRule.title |replaceAll:\'\\n\':\'<br>\'\"></span></li></ul></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/program-detail-contain-lessons.html","<div class=\"tab-pane th-courseData\" ng-if=\"$ctrl.filterData.length > 0\"><h4 ng-if=\"$ctrl.sessionType === -1\">{{ \'COURSE_CONTAIN\' | translate}}</h4><h4 ng-if=\"$ctrl.sessionType === 0\">{{ \'GET_THE_PROCESS\' | translate}}</h4><h4 ng-if=\"$ctrl.sessionType === 1\">{{ \'EXTEND_THE_PROCESS\' | translate}}</h4><table ng-table-dynamic=\"$ctrl.containLessonsTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/program-detail-enrollment-learning-report.html","<div class=\"tab-pane th-report\" id=\"tab_5\" ng-if=\"uploader\"><h4>{{ \'FIELD.SUBMIT_REPORT\' | translate}}</h4><header><p>{{ \'FIELD.UPLOADED_REPORT_LIST\' | translate}} : <span class=\"reportDeadline\" ng-if=\"$ctrl.sessionData.isReportBeforeClose===0\">({{ \'FIELD.SUBMIT_DEADLINE\' | translate}} : {{$ctrl.sessionData.reportSubmitDeadline}})</span> <span>{{ \'FIELD.SHOULD_BE_SUBMIT_REPORT\' | translate}} {{$ctrl.enrollmentData.reportsTotal}} {{ \'FIELD.PART\' | translate}}, {{ \'FIELD.HAS_BEEN_PAID\' | translate}} {{$ctrl.learningReportData.paid}} {{ \'FIELD.PART\' | translate}}</span></p><p ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\">{{ \'FIELD.SELECTED\' | translate}} {{ uploader.queue.length || 0}} {{ \'FIELD.PART\' | translate}}{{ \'FIELD.FILES\' | translate}}</p><div class=\"center\" ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\"><span class=\"btn btn-primary btn-file\"><span class=\"fileinput-new\"><i class=\"material-icons\">add_circle</i>{{ \'ACTIONS.SELECT_FILES\' | translate}}</span> <input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" filters=\"sizeFilter\"></span> <button class=\"btn btn-blue\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\"><i class=\"material-icons\">cloud_upload</i>{{ \'ACTIONS.UPLOAD_ALL\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\"><i class=\"fa fa-trash-o\"></i>{{ \'ACTIONS.DELETE_ALL\' | translate}}</button></div></header><table class=\"small\"><tbody><tr ng-repeat=\"item in uploader.queue\"><td><div class=\"pt-title\">{{ item.file.name }}<p class=\"mark\" ng-show=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></p><p class=\"mark\" ng-show=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></p><p class=\"mark\" ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i> Server Error {{ item._xhr.status + \' \' + item._xhr.statusText}}</p></div></td><td><div class=\"progress\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"><div class=\"progress-value\">{{ item.file.size/1024/1024|number:2 }} MB</div></div></div></td><td><div class=\"linkBox\"><button class=\"btn btn-blue\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><i class=\"material-icons\">cloud_upload</i></button> <button class=\"btn btn-danger\" ng-click=\"item.remove()\"><i class=\"fa fa-trash-o\"></i></button></div></td></tr></tbody></table><h4>{{ \'FIELD.SUBMITTED_REPORT\' | translate}}</h4><table class=\"basic\"><thead><tr><th>{{ \'FIELD.SERIAL_NUMBER\' | translate}}</th><th>{{ \'FIELD.FILE_NAME\' | translate}}</th><th>{{ \'FIELD.DATE_OF_PAYMENT\' | translate}}</th><th>{{ \'FIELD.SCORE\' | translate}}</th><th>{{ \'FIELD.APPROVE_STATUS\' | translate}}</th><th ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\">{{ \'FIELD.ACTION\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"learningReport in $ctrl.learningReportData\"><td data-th=\"{{ \'FIELD.SERIAL_NUMBER\' | translate}}\">{{learningReport.index}}</td><td data-th=\"{{ \'FIELD.FILE_NAME\' | translate}}\"><div class=\"pt-title\" ng-if=\"$ctrl.learningReportFileReplace[learningReport.learningReportId].queue.length > 0\">{{$ctrl.learningReportFileReplace[learningReport.learningReportId].queue[0].file.name}}<div class=\"progress\"><div class=\"progress-bar\" ng-style=\"{ \'width\': $ctrl.learningReportFileReplace[learningReport.learningReportId].queue[0].progress + \'%\' }\"><div class=\"progress-value\">{{ $ctrl.learningReportFileReplace[learningReport.learningReportId].queue[0].file.size/1024/1024|number:2 }} MB</div></div></div></div><div class=\"pt-title\" ng-if=\"!($ctrl.learningReportFileReplace[learningReport.learningReportId].queue.length > 0)\"><a ng-href=\"{{learningReport.fileUrl}}\" target=\"_blank\">{{learningReport.fileName}}</a></div></td><td data-th=\"{{ \'FIELD.DATE_OF_PAYMENT\' | translate}}\">{{learningReport.submitDate}}</td><td data-th=\"{{ \'FIELD.SCORE\' | translate}}\">{{learningReport.score}}</td><td data-th=\"{{ \'FIELD.APPROVE_STATUS\' | translate}}\"><div class=\"text\">{{ \'STATUS.\' + learningReport.appStateWording | uppercase | translate}}</div></td><td data-th=\"{{ \'FIELD.ACTION\' | translate}}\" ng-if=\"$ctrl.enrollmentData.isBeforeDeadline === 1\"><span class=\"btn btn-primary btn-file\" ng-if=\"learningReport.actionState === 1\"><span class=\"fileinput-new\">{{ \'ACTIONS.REPLACE\' | translate}}</span> <input type=\"file\" nv-file-select=\"\" uploader=\"$ctrl.learningReportFileReplace[learningReport.learningReportId]\" filters=\"sizeFilter\"></span><md-button class=\"md-raised md-warn md-btn\" ng-if=\"learningReport.actionState === 2\" ng-click=\"$ctrl.learningReportUploadAction(\'cancelrow\', 2, learningReport.learningReportId)\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-warn md-btn\" ng-if=\"learningReport.actionState === 3\" ng-click=\"$ctrl.learningReportUploadAction(\'delete\', 2, learningReport.learningReportId)\">{{ \'ACTIONS.DELETE\' | translate}}</md-button></td></tr></tbody></table></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/program-detail-enrollment.html","<div class=\"course\"><div class=\"album\"><img ng-src=\"{{$ctrl.data.logoUrl}}\" alt=\"\"></div><div class=\"md-course\"><header><h3>{{ \'FIELD.ENROLLMENT_INFO\' | translate}}</h3><ul class=\"right\"></ul></header><div class=\"pt-course\"><header><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"{ responsive: false, responsiveAnimationDuration: 500, maintainAspectRatio: true, cutoutPercentage: 75, legend: { display: false }}\" gauge-colors=\"[\'#319DB5\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.enrollmentData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\'+ $ctrl.enrollmentData.status | uppercase | translate}}</span></div><span class=\"warning\" course-info-session-will-expire=\"\" ng-if=\"$ctrl.enrollmentData.isWillExpire === 1\" enrollment-id=\"$ctrl.enrollmentData.enrollmentId\" course-type=\"$ctrl.data.courseType\" is-course=\"false\"><i class=\"material-icons\">alarm</i> {{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span></header><div class=\"course-list\"><div class=\"left\"><ul><li><span class=\"li-title\">{{ \'FIELD.CLASS_TIME\' | translate}} :</span> <span class=\"text\">{{$ctrl.sessionData.accessPeriod}}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span> <span class=\"text\">{{$ctrl.sessionData.sessionName}}</span></li><li ng-if=\"$ctrl.sessionData.contactPerson\"><span class=\"li-title\">{{ \'FIELD.CONTACT_PERSON\' | translate}} :</span> <span class=\"text\">{{$ctrl.sessionData.contactPerson}}</span> <a ng-if=\"$ctrl.sessionData.contactMail\" ng-href=\"mailto:{{$ctrl.sessionData.contactMail}}\"><i class=\"fa fa-envelope\"></i></a> <span ng-if=\"$ctrl.sessionData.contactPhone\" class=\"text\">({{$ctrl.sessionData.contactPhone}})</span></li><li ng-if=\"$ctrl.enrollmentData.applyStatusMsg.length > 0\"><span class=\"li-title\">{{ \'FIELD.APPLY_STATUS\' | translate}} :</span> <span class=\"text\">{{$ctrl.enrollmentData.applyStatusMsg}}</span></li></ul></div><pass-rule enrollment-data=\"$ctrl.enrollmentData\"></pass-rule></div></div></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/program-detail-info.html","<div class=\"tab-pane th-courseData\"><h4 ng-if=\"$ctrl.data.programType === 0\">{{ \'PROGRAM_INFO_DETAIL\' | translate}}</h4><h4 ng-if=\"$ctrl.data.programType === 1\">{{ \'CERTIFICATE_INFO_DETAIL\' | translate}}</h4><dl><dt>{{ \'FIELD.BASIC_INFORMATION\' | translate}}</dt><dd><ul><li><p class=\"li-title\">{{ \'FIELD.CREATE_DATE\' | translate}}：</p><p class=\"text\">{{$ctrl.data.createDate}}</p></li><li><p class=\"li-title\">{{ \'FIELD.TYPE\' | translate}}：</p><p class=\"text\" ng-if=\"$ctrl.data.programType === 0\">{{ \'FIELD.PROGRAM\' | translate}}</p><p class=\"text\" ng-if=\"$ctrl.data.programType === 1\">{{ \'FIELD.INTERNAL_LICENSE\' | translate}}</p></li><li ng-if=\"$ctrl.data.programCode!==\'\'\"><p class=\"li-title\" ng-if=\"$ctrl.data.programType === 0\">{{ \'FIELD.PROGRAM_CODE\' | translate}}：</p><p class=\"li-title\" ng-if=\"$ctrl.data.programType === 1\">{{ \'FIELD.CERTIFICATE_CODE\' | translate}}：</p><p class=\"text\">{{$ctrl.data.programCode}}</p></li><li ng-if=\"$ctrl.data.classification!==\'\'\"><p class=\"li-title\" ng-if=\"$ctrl.data.programType===0\">{{ \'FIELD.CLASSIFICATION\' | translate}}：</p><p class=\"li-title\" ng-if=\"$ctrl.data.programType===1\">{{ \'FIELD.CERTIFICATE_TYPE\' | translate}}：</p><p class=\"text\">{{$ctrl.data.classification}}</p></li><li ng-if=\"$ctrl.data.innercertExpireDay!==\'\'\"><p class=\"li-title\">{{ \'FIELD.VALIDITY_PERIOD\' | translate}}：</p><p class=\"text\" ng-bind-html=\"$ctrl.data.innercertExpireDay\"></p></li><li ng-if=\"$ctrl.data.innercertRewardType!==\'\'\"><p class=\"li-title\">{{ \'FIELD.REWARD_METHOD\' | translate}}：</p><p class=\"text\">{{$ctrl.data.innercertRewardType}}</p></li><li ng-if=\"$ctrl.data.targetAudience!==\'\'\"><p class=\"li-title\">{{ \'FIELD.SUITABLE_FOR_THE_OBJECT\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.targetAudience}}</p></li><li ng-if=\"$ctrl.data.isShowCredit === 1\"><p class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}}：</p><p class=\"text\">{{$ctrl.data.credits}}</p></li></ul></dd></dl><dl ng-if=\"$ctrl.data.description!==\'\'\"><dt ng-if=\"$ctrl.data.programType === 0\">{{ \'FIELD.PROGRAM_INTRODUCTION\' | translate}}</dt><dt ng-if=\"$ctrl.data.programType === 1\">{{ \'FIELD.CERTIFICATE_INTRODUCTION\' | translate}}</dt><dd><ul class=\"pt-full\"><li ng-if=\"$ctrl.data.description!==\'\'\"><p class=\"li-title\">{{ \'FIELD.DESCRIPTION\' | translate}}：</p><p class=\"text break-line-text\">{{$ctrl.data.description}}</p></li></ul></dd></dl><dl><dt>{{ \'FIELD.OTHER\' | translate}}</dt><dd><ul><li ng-if=\"$ctrl.data.programType !== 0\"><p class=\"li-title\">{{ \'FIELD.DIFFICULTY\' | translate}}：</p><p class=\"text\" ng-if=\"$ctrl.data.difficulty!==0\"><ng-rate-it ng-model=\"$ctrl.data.difficulty\" read-only=\"true\"></ng-rate-it></p><p class=\"text\" ng-if=\"$ctrl.data.difficulty===0\">{{ \'FIELD.NOTHING\' | translate}}</p></li><li ng-if=\"$ctrl.data.keyword!==\'\'\"><p class=\"li-title\">{{ \'FIELD.KEYWORD\' | translate}}：</p><p class=\"text\">{{$ctrl.data.keyword}}</p></li><li ng-if=\"$ctrl.data.learingReportCount!==0\"><p class=\"li-title\">{{ \'FIELD.LEARNING_REPORT\' | translate}}：</p><p class=\"text\"><a href=\"javascript:void(0)\" learning-report-dialog=\"\" program-id=\"$ctrl.data.programId\" activity-name=\"$ctrl.data.programName\" is-program=\"1\">{{ \'FIELD.WATCH_REPORT\' | translate }}</a></p></li></ul></dd></dl></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/program-detail-lessons-list.html","<div class=\"tab-pane th-packList\"><h4>{{ \'FIELD.COURSE_LIST\' | translate}}</h4><div class=\"md-packList md-program-packList\" ng-repeat=\"data in $ctrl.data\" ng-class=\"{1:\'elearn\', 2:\'room\', 3:\'train\',4:\'test-e\',5:\'test\', 6:\'package\'}[data.courseType]\"><course-type-tag course-type=\"data.courseType\" is-program=\"(data.courseType === 0)\"></course-type-tag><figure><a ng-if=\"data.status!==\'Unenroll\' && data.status!==\'Blocked\'\" href=\"javascript:void(0);\" ui-sref=\"learningPassport.incompleteCourses.programInfo.courseInfo({programEnrollmentId:$ctrl.enrollmentId, enrollmentId:data.enrollmentId})\"><img ng-src=\"{{data.logoUrl}}\"></a> <img ng-if=\"data.status===\'Unenroll\' || data.status===\'Blocked\'\" ng-src=\"{{data.logoUrl}}\"></figure><div class=\"pt-contentList\"><h6><ng-switch on=\"row.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><a ng-if=\"data.courseType===1 || data.courseType===2\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"1\" params=\"{cid: data.courseId}\">{{data.courseName}}</a> <a ng-if=\"data.courseType===3\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"13\" params=\"{cid: data.courseId}\">{{data.courseName}}</a> <a ng-if=\"data.courseType===4 || data.courseType===5\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"16\" params=\"{id: data.courseId}\">{{data.courseName}}</a> <a ng-if=\"data.courseType===6\" href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"17\" params=\"{id: data.courseId}\">{{data.courseName}}</a></h6><div class=\"progress th-line\" ng-if=\"data.status!==\'Unenroll\' && data.status!==\'Blocked\'\"><div class=\"progress-bar\" ng-style=\"{\'width\': data.progress + \'%\'}\"><div class=\"progress-value\"><a href=\"javascript:void(0);\" ui-sref=\"learningPassport.incompleteCourses.programInfo.courseInfo({programEnrollmentId:$ctrl.enrollmentId, enrollmentId:data.enrollmentId})\">{{ \'STATUS.\' + data.status | uppercase | translate}}&nbsp;{{ data.progressStatus}}</a></div></div></div><div ng-if=\"data.status===\'Blocked\'\" class=\"no-program text-center\">{{ \'STATUS.\' + data.status | uppercase | translate}}</div><div ng-if=\"data.status===\'Unenroll\'\" class=\"no-program text-center\">{{ \'STATUS.UNENROLLED\'| translate}}</div></div><ng-switch on=\"data.actionStatus\"><div class=\"link\" ng-switch-when=\"0\">{{data.actionMessage}}</div><div class=\"link\" ng-switch-when=\"1\"><md-button course-info-player=\"\" play-item-id=\"data.surveyItemId\" course-id=\"data.courseId\" session-id=\"data.sessionId\" reload-fn=\"$ctrl.reloadFn()\" class=\"md-raised md-primary\"><md-icon md-font-set=\"md\">play_circle_filled</md-icon>{{ \'ACTIONS.FILL_IN\' | translate}}</md-button></div><div class=\"link\" ng-switch-when=\"2\"><md-button session-action-enroll=\"\" session-id=\"data.sessionId\" reload-fn=\"$ctrl.reloadFn()\" is-program=\"(data.courseType === 0)\" class=\"md-raised md-primary\"><md-icon md-font-set=\"md\">person_add</md-icon>{{ \'ACTIONS.ENROLL\' | translate}}</md-button></div><div class=\"link\" ng-switch-when=\"3\"><md-button session-action-un-enroll=\"\" enrollment-id=\"data.enrollmentId\" reload-fn=\"$ctrl.reloadFn()\" class=\"md-raised md-warn\">{{row.actionMessage}}</md-button></div><div class=\"link\" ng-switch-when=\"4\"><md-button ui-sref=\"learningPassport.incompleteCourses.programInfo.courseInfo({programEnrollmentId:$ctrl.enrollmentId, enrollmentId:data.enrollmentId})\" class=\"md-raised md-primary\" ng-disabled=\"data.status===\'Blocked\'\"><md-icon md-font-set=\"md\">play_circle_filled</md-icon>{{ \'ACTIONS.START_LEARNING\' | translate}}</md-button></div></ng-switch></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/program-detail-lessons-results-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.LEARNING_HISTORY\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"th-tab\"><div class=\"tab-content\"><md-content class=\"md-padding\"><program-detail-lessons-results enrollment-data=\"$ctrl.enrollmentData\" data=\"$ctrl.learningResult\"></program-detail-lessons-results><report-result enrollment-id=\"$ctrl.enrollmentId\" is-manager=\"$ctrl.isManager\" is-course=\"false\"></report-result></md-content></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/program-detail-lessons-results.html","<div class=\"tab-pane th-packResult\"><h4>{{ \'FIELD.LEARNING_RESULT\' | translate}}</h4><table ng-table-dynamic=\"$ctrl.lessonsResultsTable with $ctrl.tableCols\" class=\"tb-transfer\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes !== \'control\')\"><div bind-compiled-html=\"col.getValue($ctrl, row)\"></div></td><td ng-repeat=\"col in $columns\" ng-class=\"col.classes\" ng-if=\"!col.hideColumn(this) && col.show(this) && (col.classes === \'control\')\" ng-click=\"col.clickFn(row, $event)\"></td></tr></table><div class=\"th-total\"><ul ng-if=\"$ctrl.isShowCredit\"><li><span class=\"li-title\">{{ \'FIELD.TOTAL_CREDITS\' | translate}} :</span> <span class=\"text\">{{ $ctrl.total_credits}}</span></li><li ng-if=\"$ctrl.enrollmentData.score!==\'\'\"><span class=\"li-title\">{{ \'FIELD.OVERALL_RESULT\' | translate}} :</span> <span class=\"text\">{{ $ctrl.enrollmentData.score}}</span></li></ul></div></div>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/session-action-enroll-dialog.html","<script type=\"text/ng-template\" id=\"session-action-enroll-dialog.html\"><div ng-transclude></div></script><script type=\"text/ng-template\" id=\"session-action-enroll-step.html\"><div ng-show=\"selected\" ng-transclude></div></script><script type=\"text/ng-template\" id=\"questionnaire.pagination.html\"><div layout=\"row\"> <div flex=\"33\" ng-if=\"directionLinks && (pagination.current === 1)\"></div> <div flex=\"40\" layout-align=\"start center\" ng-if=\"directionLinks && (pagination.current !== 1)\"> <md-button class=\"md-raised md-primary md-btn\" ng-click=\"setCurrent(pagination.current - 1)\"> <md-icon>navigate_before</md-icon> {{ \'ACTIONS.PREVIOUS_PAGE\' | translate}} </md-button> </div> <div flex=\"20\" layout=\"row\" layout-align=\"center center\"> <div ng-if=\"1 < pages.length || !autoHide\"> <span>{{pagination.current}}/{{pages.length}}</span> </div> <div ng-if=\"!(1 < pages.length || !autoHide)\"> <span>{{pagination.current}}/{{pages.length}}</span> </div> </div> <div flex layout=\"row\" layout-align=\"end center\"> <div ng-if=\"1 < pages.length || !autoHide\"> <md-button class=\"md-raised md-primary md-btn right\" ng-if=\"directionLinks && (pagination.current !== pagination.last)\" ng-click=\"setCurrent(pagination.current + 1)\"> {{ \'ACTIONS.NEXT_PAGE\' | translate}} <md-icon>navigate_next</md-icon> </md-button> </div> <md-button class=\"md-raised md-primary md-btn\" ng-if=\"directionLinks && (pagination.current === pagination.last)\" ng-click=\"btnFinishFn()\"> {{ \'ACTIONS.FINISH\' | translate}} </md-button> </div> </div></script><md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'MESSAGE.MSG_IS_SURE_ENROLL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form name=\"$ctrl.form\" ng-submit=\"$ctrl.form.$valid\"><md-dialog-content style=\"max-height:500px;\"><wizard name=\"sessionActionEnroll\" on-finish=\"\" template=\"session-action-enroll-dialog.html\"><wz-step template=\"session-action-enroll-step.html\" wz-title=\"\" canexit=\"$ctrl.reasonCheck\" canenter=\"\"><div class=\"lightBox Box-sigh\" ng-init=\"$ctrl.enroll = {}\"><div class=\"wirte\"><md-input-container class=\"md-block\" ng-if=\"$ctrl.enrollReqData.isNeedReason\"><label>{{ \'FIELD.REASON\' | translate}}</label> <textarea name=\"reason\" ng-model=\"$ctrl.enroll.reason\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" required=\"\"></textarea><div ng-messages=\"$ctrl.form.reason.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div><div ng-message=\"md-maxlength\">The description must be less than 30 characters long.</div></div></md-input-container></div></div></wz-step><wz-step template=\"session-action-enroll-step.html\" wz-title=\"\"><div class=\"play-main\"><div class=\"wp-play\"><header class=\"preClass\"></header><test-questionnaire-start exam=\"$ctrl.exam\" start-fn=\"$ctrl.startExam()\" ng-if=\"$ctrl.pageView===\'start\'\"></test-questionnaire-start><test-questionnaire-form exam=\"$ctrl.exam\" session-id=\"$ctrl.sessionId\" item-id=\"$ctrl.itemId\" exam-history-id=\"$ctrl.examHistoryId\" question-model=\"$ctrl.questionModel\" questionnaire-data=\"$ctrl.questionnaireData\" questions-pagination=\"$ctrl.questionsPagination\" question-current-page=\"$ctrl.questionCurrentPage\" page-view=\"$ctrl.pageView\" is-page-footer=\"false\" ng-if=\"$ctrl.pageView===\'form\'\"></test-questionnaire-form><test-questionnaire-status exam=\"$ctrl.exam\" exam-result=\"$ctrl.examResult\" ng-if=\"$ctrl.pageView===\'status\'\"></test-questionnaire-status></div></div></wz-step></wizard></md-dialog-content><md-dialog-actions layout=\"row\" ng-if=\"$ctrl.form.reason!==\'\'\"><md-button class=\"md-raised md-warn md-btn\" layout-align=\"start center\" type=\"button\" ng-click=\"$ctrl.previousStep()\" ng-if=\"$ctrl.pageView===\'start\' || ($ctrl.questionCurrentPage === 1 && $ctrl.pageView===\'form\')\"><md-icon md-font-set=\"md\">keyboard_arrow_left</md-icon>{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</md-button><span flex=\"\"></span><ui-pagination-controls flex=\"100\" ng-if=\"$ctrl.pageView===\'form\'\" on-page-change=\"$ctrl.paginationChanged(params, \'pagination\')\" pagination-id=\"question\" can-select-option=\"false\" template-url=\"questionnaire.pagination.html\" btn-finish-fn=\"$ctrl.finishedExam()\" max-size=\"$ctrl.questionsPagination.total\"></ui-pagination-controls><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"close()\" ng-if=\"($ctrl.pageView===\'reason\' && $ctrl.enrollReqData.isHasPreEnrollSurvey) || $ctrl.pageView===\'status\'\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.nextStep();\" ng-if=\"$ctrl.pageView===\'reason\' && $ctrl.enrollReqData.isHasPreEnrollSurvey\">{{ \'ACTIONS.NEXT_STEP\' | translate}}<md-icon md-font-set=\"md\">keyboard_arrow_right</md-icon></md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-if=\"!$ctrl.enrollReqData.isHasPreEnrollSurvey\" ng-click=\"$ctrl.submitFn()\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/session-action-exemption-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><form name=\"form\" ng-submit=\"form.$valid && $ctrl.submitFn()\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.APPLY_FOR_EXEMPTION\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"lightBox Box-sigh\" ng-init=\"$ctrl.enroll = {}\"><div class=\"wirte\"><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><div flex=\"15\" layout=\"column\">{{ \'FIELD.APPLY_DATE\' | translate }}&nbsp;:</div><div flex=\"85\" layout=\"column\"><ds-widget-clock show-digital=\"\" only-text=\"true\" digital-format=\"\'yyyy/MM/dd\'\">></ds-widget-clock></div></div><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><div flex=\"15\" layout=\"column\">{{ \'FIELD.EXEMPTION_REASON\' | translate }}&nbsp;:</div><div flex=\"85\" layout=\"column\"><md-input-container md-no-float=\"\"><label></label><md-select ng-model=\"$ctrl.exemption.exemptionType\"><md-option ng-value=\"1\"><em>{{ \'FIELD.EVER_ENROLLED_CERTIFICATION\' | translate}}</em></md-option><md-option ng-value=\"4\"><em>{{ \'FIELD.EVER_ENROLLED_INNER_CERTIFICATION\' | translate}}</em></md-option><md-option ng-value=\"2\"><em>{{ \'FIELD.EVER_ENROLLED_COURSE\' | translate}}</em></md-option><md-option ng-value=\"3\"><em>{{ \'FIELD.OTHER\' | translate}}</em></md-option></md-select></md-input-container></div></div><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\" ng-if=\"$ctrl.exemption.exemptionType === 1 || $ctrl.exemption.exemptionType === 4\" ng-init=\"$ctrl.exemption.exemptionId = 0;\"><div flex=\"15\" layout=\"column\">{{ \'FIELD.CERTIFICATION_NAME\' | translate }}&nbsp;:</div><div flex=\"85\" layout=\"column\"><md-input-container md-no-float=\"\" ng-if=\"$ctrl.exemption.exemptionType === 1\"><label></label><md-select placeholder=\"\" name=\"exemptionType\" ng-model=\"$ctrl.exemption.exemptionId\" md-on-open=\"$ctrl.loadPassedCertification()\" style=\"min-width: 200px;\" required=\"\"><md-option ng-value=\"cert.subjectToUserId\" ng-repeat=\"cert in $ctrl.ext_cert\">{{cert.certName}}</md-option></md-select><div ng-messages=\"form.exemptionType.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container md-no-float=\"\" ng-if=\"$ctrl.exemption.exemptionType === 4\"><label></label><md-select placeholder=\"\" name=\"exemptionType\" ng-model=\"$ctrl.exemption.exemptionId\" md-on-open=\"$ctrl.loadPassedInnerCertification()\" ng-if=\"$ctrl.exemption.exemptionType === 4\" style=\"min-width: 200px;\" required=\"\"><md-option ng-value=\"cert.subjectToUserId\" ng-repeat=\"cert in $ctrl.int_cert\">{{cert.certName}}</md-option></md-select><div ng-messages=\"form.exemptionType.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></md-input-container></div></div><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\" ng-if=\"$ctrl.exemption.exemptionType === 2\" ng-init=\"$ctrl.exemption.exemptionId = 0;\"><div flex=\"15\" layout=\"column\">{{ \'FIELD.COURSE_NAME\' | translate }}&nbsp;:</div><div flex=\"85\" layout=\"column\"><md-input-container md-no-float=\"\"><label></label><md-select placeholder=\"\" name=\"exemptionType\" ng-model=\"$ctrl.exemption.exemptionId\" md-on-open=\"$ctrl.loadPassedCourse()\" style=\"min-width: 200px;\" required=\"\"><md-option ng-value=\"course.courseEnrollmentId\" ng-repeat=\"course in $ctrl.course\">{{course.courseName}} / {{course.sessionName}}</md-option></md-select><div ng-messages=\"form.exemptionType.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div></div></md-input-container></div></div><div flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"start center\"><div flex=\"\" layout=\"column\"><md-input-container class=\"md-block\"><label>{{ \'FIELD.REASON\' | translate}}</label> <textarea name=\"reason\" ng-model=\"$ctrl.exemption.reason\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\"></textarea><div ng-messages=\"form.reason.$error\"><div ng-message=\"md-maxlength\">The description must be less than 30 characters long.</div></div></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/session-action-leave-dialog.html","<script type=\"text/ng-template\" id=\"session-leave-wizard.html\"><div ng-transclude ></div></script><script type=\"text/ng-template\" id=\"session-leave-step.html\"><div ng-show=\"selected\" ng-transclude class=\"lightBox Box-leave\"></div></script><script type=\"text/ng-template\" id=\"headerCheckbox.html\"><md-checkbox ng-model=\"$ctrl.selectAllLeave\"></md-checkbox></script><md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_LEAVE_TIME\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><wizard name=\"leave\" on-finish=\"$ctrl.submitFn()\" template=\"session-leave-wizard.html\"><wz-step template=\"session-leave-step.html\" wz-title=\"\" canexit=\"$ctrl.canNext\" canenter=\"$ctrl.resetWzBtn\"><table ng-table=\"$ctrl.leaveTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'ACTIONS.SELECT_ALL\' | translate\" header=\"\'headerCheckbox.html\'\"><md-checkbox ng-model=\"$ctrl.leaves[row.id].selected\" ng-disabled=\"row.hasLeaveRecord\"></md-checkbox></td><td data-title=\"\'FIELD.DATE\' | translate\"><div class=\"text\">{{ row.date}}</div></td><td data-title=\"\'FIELD.TIME\' | translate\"><div class=\"text\">{{ row.startTimeHH | displayMinNumber:2}}:{{ row.startTimeMM*5 | displayMinNumber:2 }}~ {{ row.endTimeHH | displayMinNumber:2}}:{{ row.endTimeMM*5 | displayMinNumber:2}}</div></td><td data-title=\"\'FIELD.CLASS_HOUR\' | translate\"><div class=\"text\">{{(((row.endTimeHH*60) + (row.endTimeMM*5)) - ((row.startTimeHH * 60) + (row.startTimeMM*5)))/60 | number: ((((row.endTimeHH*60) + (row.endTimeMM*5)) - ((row.startTimeHH * 60) + (row.startTimeMM*5)))%60===0)?1:2 }} {{ \'FIELD.HOUR\' | translate}}</div></td><td data-title=\"\'FIELD.LEAVE_TIME\' | translate\"><div class=\"text\" ng-repeat=\"leave in row.leaves\" ng-if=\"row.leaves.length > 0\">{{ leave.startHH | displayMinNumber:2}}:{{ leave.startMM | displayMinNumber:2 }}~ {{ leave.endHH | displayMinNumber:2}}:{{ leave.endMM | displayMinNumber:2}} {{ \'STATUS.\' + leave.status | uppercase | translate}}</div><div class=\"pt-select\" ng-if=\"row.leaves.length === 0\"><select-date type=\"hours\" ng-model=\"$ctrl.leaves[row.id].startHH\" min=\"row.startTimeHH\" max=\"row.endTimeHH\" default-value=\"row.startTimeHH\"></select-date><span>:</span><select-date type=\"minute\" ng-model=\"$ctrl.leaves[row.id].startMM\" default-value=\"row.startTimeMM*5\"></select-date><span>~</span><select-date type=\"hours\" ng-model=\"$ctrl.leaves[row.id].endHH\" min=\"row.startTimeHH\" max=\"row.endTimeHH\" default-value=\"row.endTimeHH\"></select-date><span>:</span><select-date type=\"minute\" ng-model=\"$ctrl.leaves[row.id].endMM\" default-value=\"row.endTimeMM*5\"></select-date></div></td><td data-title=\"\'FIELD.COURSE_NOT_ATTENDED_REASON\' | translate\"><div class=\"text\" ng-repeat=\"leave in row.leaves\"><ng-switch on=\"leave.status\"><div ng-switch-when=\"absent\">{{ \'STATUS.ABSENT\' | translate }}</div><div ng-switch-when=\"leave\"><span ng-if=\"leave.isFromAdm\">{{ \'STATUS.ADMINISTRATOR_REGISTER\' | translate }}</span> <span ng-if=\"!leave.isFromAdm\">{{ \'STATUS.LEARNER_ASK_LEAVE\' | translate }}</span> ({{ \'FIELD.\' + leave.leaveType | uppercase | translate}})</div></ng-switch></div><div class=\"text\" ng-if=\"row.leaves.length === 0\"><select flex=\"\" ng-model=\"$ctrl.leaves[row.id].reason\"><option value=\"2\">{{ \'FIELD.BUSINESS_LEAVE\' | translate}}</option><option value=\"3\">{{ \'FIELD.PERSONAL_LEAVE\' | translate}}</option><option value=\"4\">{{ \'FIELD.SICK_LEAVE\' | translate}}</option><option value=\"5\">{{ \'FIELD.OTHER\' | translate}}</option></select></div></td><td data-title=\"\'FIELD.ACTION\' | translate\"><div class=\"text\"></div></td></tr></table></wz-step><wz-step template=\"session-leave-step.html\" wz-title=\"\"><form name=\"$ctrl.leaveForm\" novalidate=\"\"><div class=\"lightBox Box-sigh\"><div class=\"wirte\"><md-input-container class=\"md-block\" md-is-error=\"$ctrl.submitError || $ctrl.leaveForm.$dirty && $ctrl.leaveForm.$invalid\"><label>{{ \'PLACEHOLDERS.REASON_OF_LEAVE\' | translate}}</label> <textarea name=\"reason\" ng-model=\"$ctrl.reason\" md-maxlength=\"250\" rows=\"1\" md-detect-hidden=\"\" required=\"\"></textarea><div ng-messages=\"$ctrl.leaveForm.reason.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div><div ng-message=\"md-maxlength\">The description must be less than 30 characters long.</div></div></md-input-container></div></div></form></wz-step></wizard></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.nextStep()\" ng-if=\"$ctrl.wzBtn.next\">{{ \'ACTIONS.NEXT_STEP\' | translate}}</md-button><md-button class=\"md-raised md-warn md-btn btn-transparent\" type=\"button\" ng-click=\"$ctrl.previousStep()\" ng-if=\"$ctrl.wzBtn.previous\">{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.finishStep()\" ng-if=\"$ctrl.wzBtn.finish\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/session-action-un-enroll-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><form name=\"form\" ng-submit=\"form.$valid && $ctrl.submitFn()\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'MESSAGE.MSG_IS_SURE_UN_ENROLL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"lightBox Box-sigh\" ng-init=\"$ctrl.enroll = {}\"><div class=\"wirte\"><md-input-container class=\"md-block\" ng-if=\"$ctrl.unEnrollReqData.isNeedReason\"><label>{{ \'FIELD.REASON\' | translate}}</label> <textarea name=\"reason\" ng-model=\"$ctrl.enroll.reason\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" required=\"\"></textarea><div ng-messages=\"form.reason.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div><div ng-message=\"md-maxlength\">The description must be less than 30 characters long.</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/session-enrolled-members-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"80\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SESSION\' | translate}}：{{sessionData.sessionName}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"lightBox Box-billboard\"><div class=\"box-content\"><div class=\"th-contentList single\"><div class=\"md-contentList\"><table ng-table=\"courseSessionLearnersTable\" class=\"BoxTable\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'FIELD.FULL_NAME\' | translate\"><div class=\"el-person\"><md-tooltip md-direction=\"left\">{{row.userName}}</md-tooltip><avatar avatar-url=\"::row.avatarUrl\" first-name=\"::row.firstName\"></avatar><span>{{row.userName}}</span></div></td><td data-title=\"\'FIELD.DEPARTMENT\' | translate\"><div class=\"text\">{{row.groupName}}</div></td><td data-title=\"\'FIELD.EMAIL\' | translate\" class=\"session-enrolled-members-dialog-emailbreakall\"><a ng-href=\"mailto:{{ row.mail }}\" target=\"_blank\">{{row.mail}}</a></td><td data-title=\"\'FIELD.OFFICE_PHONE\' | translate\"><div class=\"text\">{{row.phone}}</div></td></tr></table></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/course-session-info-template/unassignable-members.html","<script type=\"text/ng-template\" id=\"unassignable-member-wizard.html\"><div ng-transclude></div></script><script type=\"text/ng-template\" id=\"unassignable-member-step.html\"><div ng-show=\"selected\" ng-transclude></div></script><script type=\"text/ng-template\" id=\"headerCheckbox.html\"><input type=\"checkbox\" ng-model=\"$ctrl.users.selectAll\" class=\"select-all\" value=\"\" /></script><md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SESSION\' | translate}}：{{$ctrl.sessionName}}&nbsp;{{ \'FIELD.UN_ASSIGNABLE_MEMBER_ENROLL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><wizard name=\"unassign\" on-finish=\"$ctrl.unassign($ctrl.enroll)\" template=\"unassignable-member-wizard.html\"><wz-step template=\"unassignable-member-step.html\" wz-title=\"\" canexit=\"$ctrl.canNext\" canenter=\"$ctrl.resetWzBtn\"><div class=\"lightBox Box-leave\"><table ng-table=\"$ctrl.unAssignableMemberTable\" class=\"tb-Collapse tb-check\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'ACTIONS.SELECT_ALL\' | translate\" header=\"\'headerCheckbox.html\'\"><input type=\"checkbox\" ng-model=\"$ctrl.users.selected[row.enrollmentId]\"></td><td data-title=\"\'FIELD.EMPLOYEE_NUMBER\' | translate\"><div class=\"text\">{{row.employeeNumber}}</div></td><td data-title=\"\'FIELD.FULL_NAME\' | translate\"><div class=\"text\">{{row.fullName}}</div></td><td data-title=\"\'FIELD.DEPARTMENT\' | translate\"><div class=\"text\">{{row.groupName}}</div></td><td data-title=\"\'FIELD.ENROLL_TYPE\' | translate\"><div class=\"text\">{{ \'FIELD.\' + row.enrollType | uppercase | translate}}</div></td><td data-title=\"\'FIELD.ASSIGNABLE_STATUS\' | translate\"><div class=\"text\" ng-if=\"!(row.assignerId === row.userId)\">{{ \'STATUS.\' + row.status | uppercase | translate}}</div></td><td data-title=\"\'FIELD.ADD_DATE\' | translate\"><div class=\"text\">{{row.enrollDate}}</div></td><td data-title=\"\'FIELD.ASSIGNER\' | translate\"><div class=\"text\" ng-if=\"!(row.assignerId === row.userId)\">{{row.assignerFullName}}</div></td></tr></table></div></wz-step><wz-step template=\"unassignable-member-step.html\" wz-title=\"\"><div class=\"lightBox Box-sigh\"><header><h4>{{ \'PLACEHOLDERS.CAN_CANCEL_THE_REGISTRATION_OF_STUDENTS\' | translate}}: <span ng-repeat=\"selectedMember in $ctrl.selectedMembers\">{{selectedMember.fullName}}&nbsp;;</span></h4></header><form name=\"form\"><div class=\"wirte\"><md-input-container class=\"md-block\"><label>{{ \'PLACEHOLDERS.YOU_CAN_SEND_A_MESSAGE_TO_THE_STUDENT_WHO_HAS_BEEN_DESIGNATED_TO_CANCEL_THE_REGISTRATION\' | translate}}</label> <textarea name=\"reason\" ng-model=\"$ctrl.enroll.reason\" md-maxlength=\"150\" rows=\"1\" md-detect-hidden=\"\"></textarea><div ng-messages=\"form.reason.$error\"><div ng-message=\"required\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</div><div ng-message=\"md-maxlength\">The description must be less than 30 characters long.</div></div></md-input-container></div></form></div></wz-step></wizard></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-warn md-btn btn-transparent\" ng-click=\"close()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"button\" ng-click=\"$ctrl.nextStep()\" ng-if=\"$ctrl.wzBtn.next\">{{ \'ACTIONS.NEXT_STEP\' | translate}}<md-icon md-font-set=\"md\">keyboard_arrow_right</md-icon></md-button><md-button class=\"md-raised md-warn md-btn btn-transparent\" type=\"button\" ng-click=\"$ctrl.previousStep()\" ng-if=\"$ctrl.wzBtn.previous\"><md-icon md-font-set=\"md\">keyboard_arrow_left</md-icon>{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</md-button><md-button class=\"md-raised md-primary md-btn\" type=\"submit\" ng-click=\"$ctrl.finishStep()\" ng-if=\"$ctrl.wzBtn.finish\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/course-resource/views/external/external-company-insert-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><form name=\"$ctrl.form\" ng-submit=\"$ctrl.submit($ctrl.files)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><div class=\"thForm\"><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input name=\"vendorName\" ng-model=\"$ctrl.formData.vendorName\" placeholder=\"{{ \'FIELD.ORIGINAL_FACTORY_NAME\' | translate}}\" ng-required=\"$ctrl.submitted\"></md-input-container><div ng-messages=\"$ctrl.form.vendorName.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.VAT_NUMBER\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.vendorNumber\" placeholder=\"{{ \'FIELD.VAT_NUMBER\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.BANK_NAME\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.bankName\" placeholder=\"{{ \'FIELD.BANK_NAME\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.BANK_ACCOUNT\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input name=\"address\" ng-model=\"$ctrl.formData.bankAccount\" placeholder=\"{{ \'FIELD.BANK_ACCOUNT\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.CLASSIFICATION\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><select-ctl class=\"md-block\" type=\"classifications\" ng-model=\"$ctrl.formData.classificationId\"></select-ctl></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.ADDRESS\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.vendorAddress\" placeholder=\"{{ \'FIELD.ADDRESS\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.PHONE\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.vendorTel\" placeholder=\"{{ \'FIELD.PHONE\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.FAX\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.vendorFax\" placeholder=\"{{ \'FIELD.FAX\' | translate}}\"></md-input-container></div></div><div ng-repeat=\"contact in $ctrl.formData.contact\"><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.CONTACT_PERSON_DATA\' | translate}}{{$index + 1}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"contact.fullName\" placeholder=\"{{ \'FIELD.FULL_NAME\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\"></div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input name=\"address\" ng-model=\"contact.phone\" placeholder=\"{{ \'FIELD.PHONE\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\"></div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"contact.mobilePhone\" placeholder=\"{{ \'FIELD.MOBILE_PHONE\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\"></div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input type=\"email\" name=\"mail[$index]\" ng-model=\"contact.mail\" placeholder=\"mail\"></md-input-container><div ng-messages=\"$ctrl.form.mail[$index].$error\" role=\"alert\"><span ng-message=\"email\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.PLEASE_ENTER_A_VALID_EMAIL\' | translate}}</span></div></div></div><div class=\"text-center\"><div class=\"el-inBlock m-l-10 m-r-10\"><button type=\"button\" title=\"{{ \'ACTIONS.ADD_FILE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-primary\" ng-click=\"$ctrl.addContact()\"><i class=\"fa fa-plus\"></i><div class=\"ripple-wrapper\"></div></button></div><div class=\"el-inBlock m-l-10 m-r-10\" ng-if=\"$index > 0\"><button type=\"button\" title=\"{{ \'ACTIONS.DELETE_FILE\' | translate}}\" class=\"btn btn-sm btn-icon btn-rounded btn-danger\" ng-click=\"$ctrl.removeContact(contact)\"><i class=\"fa fa-trash-o\"></i><div class=\"ripple-wrapper\"></div></button></div></div></div><div layout=\"row\" layout-margin=\"\"><div flex=\"15\" class=\"text-right w-700\">{{ \'FIELD.UPLOAD_REFERENCE_FILE\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><upload-course-data-files external-training-vendors=\"$ctrl.externalTrainingVendors\" ng-model=\"$ctrl.files\" refs=\"$ctrl.refs\" max-count=\"3\"></upload-course-data-files></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.INTRODUCTION\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.introduction\" placeholder=\"{{ \'FIELD.INTRODUCTION\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.URL\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.url\" placeholder=\"{{ \'FIELD.URL\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.NOTES\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.vendorComment\" placeholder=\"{{ \'FIELD.NOTES\' | translate}}\"></md-input-container></div></div><div layout=\"row\"><div flex=\"15\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.VENDOR_RECEIVER_NAME\' | translate}}</div><div flex=\"80\" class=\"p-l-20\"><md-input-container class=\"md-block\"><input ng-model=\"$ctrl.formData.receiverName\" placeholder=\"{{ \'FIELD.VENDOR_RECEIVER_NAME\' | translate}}\"></md-input-container></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.cancel()\">{{ \'ACTIONS.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/course-resource/views/external/external-training-apply-form-view.html","<div class=\"lightBox Box-billboard\"><header></header><p>{{ \'FIELD.FILLER\' | translate}}：{{ ::$ctrl.data.requesterName}}</p><div class=\"box-content\"><div class=\"th-person\"><h6 class=\"el-h6\">{{ \'FIELD.APPLICANT\' | translate}}</h6><div class=\"el-person\"><avatar avatar-url=\"::$ctrl.applicantInfo.avatarUrl\" first-name=\"::$ctrl.applicantInfo.FirstName\" line-height=\"50\"></avatar></div><div class=\"personInfor\"><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.FULL_NAME\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.FirstName}}</td></tr><tr ng-if=\"$ctrl.applicantInfo.Team.length > 0\"><th>{{ \'FIELD.DEPARTMENT\' | translate}}</th><td><span ng-repeat=\"team in ::$ctrl.applicantInfo.Team\">{{team}}&nbsp;;</span></td></tr></tbody></table><table class=\"BoxTable\"><tbody><tr ng-if=\"($ctrl.applicantInfo.Email | trim).length > 0\"><th>{{ \'FIELD.EMAIL\' | translate}}</th><td><a ng-href=\"mailto:{{ ::$ctrl.applicantInfo.Email }}\" target=\"_blank\">{{ ::$ctrl.applicantInfo.Email}}</a></td></tr><tr ng-if=\"($ctrl.applicantInfo.OfficePhone | trim).length > 0\"><th>{{ \'FIELD.OFFICE_PHONE\' | translate}}</th><td>{{ ::$ctrl.applicantInfo.OfficePhone}}</td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'FIELD.ENROLLMENT_INFORMATION\' | translate}}</h6><table class=\"BoxTable BoxTable-text-left\"><tbody><tr ng-if=\"($ctrl.data.courseName | trim).length > 0\"><th>{{ \'FIELD.COURSE_NAME\' | translate}}</th><td>{{ ::$ctrl.data.courseName}}</td></tr><tr ng-if=\"($ctrl.data.hasEnroll | trim).length > 0\"><th>{{ \'STATUS.ENROLLED\' | translate}}</th><td><span ng-if=\"$ctrl.data.hasEnroll === 1\">{{\'FIELD.TRUE\' | translate}}</span> <span ng-if=\"$ctrl.data.hasEnroll === 0\">{{\'FIELD.FALSE\' | translate}}</span></td></tr><tr ng-if=\"($ctrl.data.reason | trim).length > 0\"><th>{{ \'FIELD.DESCRIPTION\' | translate}}</th><td>{{ ::$ctrl.data.reason}}</td></tr><tr ng-if=\"$ctrl.applyReason.length > 0\"><th>{{ \'FIELD.JOIN_REASON\' | translate}}</th><td><span ng-repeat=\"reason in $ctrl.applyReason track by $index\" ng-init=\"reasonIndex = $index\"><span ng-repeat=\"applyReason in $ctrl.applyReasons | where : {reasonId: reason} track by applyReason.reasonId\">{{ ::applyReason.reasonName | markSplit:reasonIndex:\'/&nbsp;\'}}</span></span></td></tr><tr ng-if=\"($ctrl.data.type | trim).length > 0\"><th>{{ \'FIELD.DOMESTIC\' | translate}}/{{ \'FIELD.ABROAD\' | translate}}</th><td><span ng-if=\"$ctrl.data.type === 0\">{{\'FIELD.DOMESTIC\' | translate}}</span> <span ng-if=\"$ctrl.data.type === 1\">{{\'FIELD.ABROAD\' | translate}}</span></td></tr><tr ng-if=\"$ctrl.orgSize > 0\"><th>{{ \'FIELD.VENDOR\' | translate}}</th><td><span ng-repeat=\"(key,organizationData) in $ctrl.organizationDatas track by $index\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"26\" params=\"{\'vendorType\': 2, \'vendorId\': key}\">{{ organizationData}}</a></span></td></tr><tr ng-if=\"($ctrl.data.timeDesc | trim).length > 0\"><th>{{ \'FIELD.CLASS_TIME\' | translate}}</th><td>{{ ::$ctrl.data.timeDesc}}</td></tr><tr ng-if=\"($ctrl.data.location | trim).length > 0\"><th>{{ \'FIELD.EVENT_LOCATION\' | translate}}</th><td>{{ ::$ctrl.data.location}}</td></tr><tr ng-if=\"($ctrl.data.trainType | trim).length > 0\"><th>{{ \'FIELD.TRAINING_NATURE\' | translate}}</th><td><span ng-if=\"$ctrl.data.trainType === 1\">{{\'FIELD.ASSIGNED_BY_MANAGER\' | translate}}</span> <span ng-if=\"$ctrl.data.trainType === 2\">{{\'FIELD.PERSONAL_REQUESTS\' | translate}}</span></td></tr><tr ng-if=\"($ctrl.data.reflink | trim).length > 0\"><th>{{ \'FIELD.ENROLLMENT_WEBSITE\' | translate}}</th><td><a ng-href=\"{{::$ctrl.data.reflink}}\" target=\"_blank\" ng-if=\"($ctrl.data.reflink | trim).length > 0\">{{ \'FIELD.ENROLLMENT_WEBSITE\' | translate}}</a></td></tr><tr ng-if=\"$ctrl.data.refs.length > 0\"><th>{{ \'FIELD.UPLOAD_COURSE_DATA\' | translate}}</th><td><span ng-repeat=\"ref in $ctrl.data.refs track by $index\"><a href=\"javascript:void(0);\" external-reference-servlet=\"\" external-id=\"$ctrl.data.externalId\" num=\"ref.num\">{{ref.fileName | markSplit:$index:\'/&nbsp;\'}}</a></span></td></tr><tr ng-if=\"($ctrl.data.note | trim).length > 0\"><th>{{ \'FIELD.REMARK\' | translate}}</th><td>{{ ::$ctrl.data.note}}</td></tr></tbody></table></div><div class=\"md-contentList\"><h6 class=\"el-h6\">{{ \'FIELD.COURSE_COST\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;</span>{{ \'FIELD.LEARNING_REPORT\' | translate}}</h6><table class=\"BoxTable BoxTable-text-left\"><tbody><tr ng-if=\"($ctrl.data.isForFree | trim).length > 0\"><th>{{ \'FIELD.COURSE_TYPE\' | translate}}</th><td><span ng-if=\"$ctrl.data.isForFree === 1\">{{\'FIELD.FREE_COURSE\' | translate}}</span> <span ng-if=\"$ctrl.data.isForFree === 0\">{{\'FIELD.PAY_COURSE\' | translate}}</span></td></tr><tr ng-if=\"$ctrl.data.isForFree === 0\"><th>{{\'FIELD.ENROLLMENT_COST\' | translate}}</th><td><div class=\"pl-apart\"><ul><li ng-if=\"($ctrl.data.enrollCost.course_cost_currency | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.CURRENCY\' | translate}}</span> <span ng-repeat=\"currency in $ctrl.currencys | where:{currencyId: $ctrl.data.enrollCost.course_cost_currency} track by $index\">{{ ::currency.currencyName }}</span></li><li ng-if=\"($ctrl.data.enrollCost.course_cost_amount | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.AMOUNT\' | translate}}</span> <span class=\"text\">{{ ::$ctrl.data.enrollCost.course_cost_amount | number}}</span></li><li ng-if=\"($ctrl.data.enrollCost.course_converting_amount | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.SYSTEM_CURRENCY\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\"><span ng-repeat=\"currency in $ctrl.currencys | where:{isBasic: true} track by $index\">{{ ::currency.currencyName }}</span><br>{{ \'PLACEHOLDERS.NT_CONVERSION\' | translate}}:<span>{{ ::$ctrl.data.enrollCost.course_converting_amount | number:1}}</span></span></li><li ng-if=\"($ctrl.data.enrollCost.subsidyType | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.TYPE_OF_SUBSIDY\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.subsidyType === \'1\'\">{{ \'FIELD.FULL_AMOUNT\' | translate}}</span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.subsidyType === \'2\'\">{{ \'FIELD.SUBSIDY\' | translate}}, {{ ::$ctrl.data.enrollCost.subsidyPercentage}}%</span></li><li ng-if=\"($ctrl.data.enrollCost.voucherType | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.VOUCHER\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.voucherType === \'1\'\">{{ \'FIELD.TAXABLE_INVOICE\' | translate}}</span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.voucherType === \'2\'\">{{ \'FIELD.TAX_FREE_INVOICE\' | translate}}</span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.voucherType === \'3\'\">{{ \'FIELD.RECEIPT\' | translate}}</span></li><li ng-if=\"($ctrl.data.enrollCost.apply_type | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.APPLICATION_CONTENT\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.apply_type === \'0\'\">{{ \'FIELD.CASH\' | translate}}</span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.apply_type === \'1\'\">{{ \'FIELD.REMITTANCE\' | translate}}</span> <span class=\"text\" ng-if=\"$ctrl.data.enrollCost.apply_type === \'2\'\">{{ \'FIELD.CHEQUE\' | translate}}</span></li><li ng-if=\"$ctrl.data.enrollCost.apply_type === \'0\' && ($ctrl.data.enrollCost.payee | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.PAYEE\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\">{{ ::$ctrl.data.enrollCost.payee}} &nbsp;</span></li><li ng-if=\"$ctrl.data.enrollCost.apply_type === \'1\'\"><span class=\"li-title\">{{ \'FIELD.REMITTANCE_INFORMATION\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\">{{ \'FIELD.THE_TITLE_OF_THE_COMPANY\' | translate}}: {{ ::$ctrl.data.enrollCost.remit_title}}<br><span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;&nbsp;&nbsp;</span>{{ \'FIELD.BRANCHES\' | translate}}: {{ ::$ctrl.data.enrollCost.remit_branch}}<br><span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;&nbsp;&nbsp;</span>{{ \'FIELD.ACCOUNT\' | translate}}: {{ ::$ctrl.data.enrollCost.remit_account}}<br></span></li><li ng-if=\"$ctrl.data.enrollCost.apply_type === \'2\'\"><span class=\"li-title\">{{ \'FIELD.RECEIPT_INFORMATION\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\">{{ \'FIELD.THE_TITLE_OF_THE_RECEIPT\' | translate}}: {{ ::$ctrl.data.enrollCost.check_title}}<br><span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;&nbsp;&nbsp;</span>{{ \'FIELD.RECEIPT_EXPIRE_DATE\' | translate}}: {{ ::$ctrl.data.enrollCost.check_expired_date}}<br><span ng-if=\"$ctrl.languageFamilyType === 1\">&nbsp;&nbsp;&nbsp;</span>{{ \'FIELD.RECEIPT_FORMAT\' | translate}}: <span ng-if=\"$ctrl.data.enrollCost.check_format1\">{{ \'FIELD.RECEIPT_DELINEATE\' | translate}}</span> <span ng-if=\"$ctrl.data.enrollCost.check_format2\">{{ \'FIELD.ENDORSEMENT_OR_TRANSFERENCE_PROHIBITED\' | translate}}</span><br></span></li></ul></div></td></tr><tr ng-if=\"($ctrl.data.payingDate | trim).length > 0\"><th>{{\'FIELD.PAYMENT_DATE\' | translate}}</th><td>{{ ::$ctrl.data.payingDate}}</td></tr><tr><th>{{ \'FIELD.LEARNING_REPORT\' | translate}}</th><td><span ng-if=\"!$ctrl.data.learningReport.isNeedReport\">{{ \'FIELD.NO_REPORT\' | translate}}</span><div class=\"pl-apart\" ng-if=\"$ctrl.data.learningReport.isNeedReport\"><ul><li><span class=\"li-title\">{{ \'FIELD.DOCUMENT_REPORT\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\" ng-if=\"$ctrl.data.learningReport.isNeedDocReport\">{{ \'FIELD.SHOULD_BE_SUBMIT_REPORT\' | translate}} {{ ::$ctrl.data.learningReport.numOfDocReport}}&nbsp;{{ \'FIELD.PART\' | translate}}, {{ \'FIELD.SUBMIT_DEADLINE\' | translate}} {{ ::$ctrl.data.learningReport.docReportDeadLine}}</span> <span class=\"text\" ng-if=\"!$ctrl.data.learningReport.isNeedDocReport\">&nbsp;{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ORAL_REPORT\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\" ng-if=\"$ctrl.data.learningReport.isNeedOralReport\">{{ \'FIELD.REPORT_DEADLINE\' | translate}} {{ ::$ctrl.data.learningReport.oralReportDeadLine}}</span> <span class=\"text\" ng-if=\"!$ctrl.data.learningReport.isNeedOralReport\">&nbsp;{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</span></li><li><span class=\"li-title\">{{ \'FIELD.INTERNAL_LECTURE\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\" ng-if=\"$ctrl.data.learningReport.isNeedTeaching\">{{ \'FIELD.LECTURE_DEADLINE\' | translate}} {{ ::$ctrl.data.learningReport.teachingDeadLine}}</span> <span class=\"text\" ng-if=\"!$ctrl.data.learningReport.isNeedTeaching\">&nbsp;{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</span></li><li><span class=\"li-title\">{{ \'FIELD.OTHER_METHOD\' | translate}}<span ng-if=\"$ctrl.languageFamilyType === 1\">：</span></span> <span class=\"text\" ng-if=\"$ctrl.data.learningReport.isNeedOther\">{{ ::$ctrl.data.learningReport.otherReportWay}}</span> <span class=\"text\" ng-if=\"!$ctrl.data.learningReport.isNeedOther\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</span></li></ul></div></td></tr></tbody></table></div></div><div class=\"th-contentList single\"><div class=\"md-contentList\" ng-if=\"($ctrl.data.enrollStart | trim).length > 0 || ($ctrl.data.enrollEnd | trim).length > 0 || ($ctrl.data.instructor | trim).length > 0 || ($ctrl.data.classification | trim).length > 0 || ($ctrl.data.description | trim).length > 0 || ($ctrl.data.objective | trim).length > 0 || ($ctrl.data.prerequesite | trim).length > 0 || ($ctrl.data.audience | trim).length > 0 || ($ctrl.data.outline | trim).length > 0\"><h6 class=\"el-h6\">{{ \'FIELD.COURSE_DETAIL\' | translate}}</h6><table class=\"BoxTable\"><tbody><tr ng-if=\"($ctrl.data.enrollStart | trim).length > 0 || ($ctrl.data.enrollEnd | trim).length > 0\"><th>{{ \'FIELD.ENROLL_DEADLINE\' | translate}}</th><td>{{ ::$ctrl.data.enrollStart}}<span>~ {{ ::$ctrl.data.enrollEnd}}</span></td></tr><tr ng-if=\"($ctrl.data.instructor | trim).length > 0\"><th>{{ \'FIELD.INSTRUCTOR_NAME\' | translate}}</th><td>{{ ::$ctrl.data.instructor}}</td></tr><tr ng-if=\"($ctrl.data.classification | trim).length > 0\"><th>{{ \'FIELD.CLASSIFICATION\' | translate}}</th><td><span ng-repeat=\"classification in $ctrl.classifications | where:{id:$ctrl.data.classification}\">{{ ::classification.name}}</span></td></tr><tr ng-if=\"($ctrl.data.description | trim).length > 0\"><th>{{ \'FIELD.COURSE_DESCRIPTION\' | translate}}</th><td>{{ ::$ctrl.data.description}}</td></tr><tr ng-if=\"($ctrl.data.objective | trim).length > 0\"><th>{{ \'FIELD.LEARNING_GOAL\' | translate}}</th><td>{{ ::$ctrl.data.objective}}</td></tr><tr ng-if=\"($ctrl.data.prerequesite | trim).length > 0\"><th>{{ \'FIELD.PREPARATORY_KNOWLEDGE\' | translate}}</th><td>{{ ::$ctrl.data.prerequesite}}</td></tr><tr ng-if=\"($ctrl.data.audience | trim).length > 0\"><th>{{ \'FIELD.SUITABLE_FOR_THE_OBJECT\' | translate}}</th><td>{{ ::$ctrl.data.audience}}</td></tr><tr ng-if=\"($ctrl.data.outline | trim).length > 0\"><th>{{ \'FIELD.COURSE_OUTLINE\' | translate}}</th><td>{{ ::$ctrl.data.outline}}</td></tr></tbody></table></div><div class=\"md-contentList\" ng-if=\"$ctrl.data.hasPreviousEnrollRecord === 1\"><h6 class=\"el-h6\">{{ \'FIELD.LAST_EXTERNAL_TRAINING_HISTORY\' | translate}}</h6><p>{{ \'FIELD.EXTERNAL_TRAINING_APPLY_TIMES_PRE\' | translate}} <span class=\"pt-mark\">{{ ::$ctrl.data.numOfTimes }}</span> {{ \'FIELD.EXTERNAL_TRAINING_APPLY_TIMES_POST\' | translate}} <span class=\"pt-mark\">{{ ::$ctrl.data.annualCost }}</span> {{ \'FIELD.EXTERNAL_TRAINING_APPLY_COST\' | translate}}. ({{ \'FIELD.TAX_FREE\' | translate}})</p><table class=\"BoxTable\"><tbody><tr><th>{{ \'FIELD.TRAINING_NAME\' | translate}}:</th><td>{{ ::$ctrl.data.previousCourseName}}</td></tr><tr><th>{{ \'FIELD.EXTERNAL_TRAINING_REPORT\' | translate}}:</th><td><div ng-if=\"$ctrl.data.learningReportStatus === \'\'\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.data.learningReportStatus !== \'\'\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}}: {{ ::$ctrl.data.learningReportStatus | stringSplitToValue: \'/\' : 0}}, {{ \'FIELD.UN_PAID\' | translate}}: {{ ::$ctrl.data.learningReportStatus | stringSplitToValue: \'/\' : 1}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:{{ ::$ctrl.data.learningReportReason}}</div></td></tr><tr><th>{{ \'FIELD.ORAL_REPORT\' | translate}}:</th><td><div ng-if=\"$ctrl.data.oralReportSubmit === -4\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.data.oralReportSubmit === 1\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}} <span ng-if=\"$ctrl.data.learningReport.isOralReportNeedGrade\">, {{ \'FIELD.SCORE\' | translate}} <span ng-if=\"$ctrl.data.oralStatus === 2\">{{ \'FIELD.NOT_YET_RATED\' | translate}}</span> <span ng-if=\"$ctrl.data.oralStatus !== 2\">{{ ::$ctrl.data.oralReportScore}}</span></span></div><div ng-if=\"($ctrl.data.oralReportSubmit !== -4) && ($ctrl.data.oralReportSubmit !== 1)\">{{ \'FIELD.UN_PAID\' | translate}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:{{ ::$ctrl.data.oralReportReason}}</div></td></tr><tr><th>{{ \'FIELD.INTERNAL_LECTURE\' | translate}}:</th><td><div ng-if=\"$ctrl.data.teachingReportSubmit === -4\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.data.teachingReportSubmit === 1\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}} <span ng-if=\"$ctrl.data.learningReport.isTeachingNeedGrade\">, {{ \'FIELD.SCORE\' | translate}} <span ng-if=\"$ctrl.data.teachingStatus === 2\">{{ \'FIELD.NOT_YET_RATED\' | translate}}</span> <span ng-if=\"$ctrl.data.teachingStatus !== 2\">{{ ::$ctrl.data.teachingScore}}</span></span></div><div ng-if=\"($ctrl.data.teachingReportSubmit !== -4) && ($ctrl.data.teachingReportSubmit !== 1)\">{{ \'FIELD.UN_PAID\' | translate}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:{{ ::$ctrl.data.teachingReportReason}}</div></td></tr><tr><th>{{ \'FIELD.OTHER_METHOD\' | translate}}:</th><td><div ng-if=\"$ctrl.data.otherReportSubmit === -4\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.data.otherReportSubmit === 1\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}}</div><div ng-if=\"($ctrl.data.otherReportSubmit !== -4) && ($ctrl.data.otherReportSubmit !== 1)\">{{ \'FIELD.UN_PAID\' | translate}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:{{ ::$ctrl.data.otherReportReason}}</div></td></tr><tr><th>{{ \'FIELD.TRAINING_MATERIAL\' | translate}}:</th><td><span ng-if=\"$ctrl.data.materialSubmit === 1\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}}</span> <span ng-if=\"$ctrl.data.materialSubmit === 0\">{{ \'FIELD.UN_PAID\' | translate}}</span> <span ng-if=\"$ctrl.data.materialSubmit === 0 && $ctrl.data.materialReason.lenght > 0\"><br>{{ \'FIELD.ORIGIN\' | translate}}:{{ ::$ctrl.data.materialReason}}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/course-resource/views/external/external-training-apply.html","<div class=\"row\"><div class=\"col-md-12 col-lg-12\"><section class=\"th-courseInfor\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_TRAINING_APPLY_FORM\' | translate}}</h2><div class=\"right\" ng-if=\"$ctrl.backStateObject\"><div class=\"el-fixed\"><a ui-sref=\"{{$ctrl.backStateObject.state}}({{$ctrl.backStateObject.params}})\" ui-state-opts=\"{reload:true, inherit: false}\" class=\"bt-goback\"><i class=\"material-icons\">keyboard_return</i> {{ \'ACTIONS.RETURN\' | translate}}</a></div></div></div><div class=\"tabs tabs-linetriangle\"><div class=\"tab-content\"><div class=\"tab-pane active\"><wizard on-finish=\"$ctrl.submitApplyForm()\"><wz-step wz-title=\"{{ \'FIELD.ENROLLMENT_INFORMATION\' | translate}}<br>{{ \'FIELD.COURSE_LINKS\' | translate}}\" canexit=\"$ctrl.canExitStep1\"><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 col-md-12\"><md-content layout-padding=\"\"><div class=\"thForm\"><form name=\"$ctrl.wizardForm1\"><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.APPLICANT\' | translate}}</div><div flex-gt-xs=\"65\" class=\"p-l-20\"><md-chips class=\"md-chips\" ng-model=\"$ctrl.applicants\" readonly=\"true\" md-removable=\"$ctrl.applicants.length > 1\" name=\"applicants\" ng-class=\"{\'ng-invalid\': $ctrl.applicants.length === 0}\"><md-chip-template><span>{{$chip.fullName}}</span></md-chip-template></md-chips><div ng-messages=\"$ctrl.wizardForm1.applicants.$error\" role=\"alert\"><span ng-show=\"$ctrl.applicants.length === 0\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></div><member-selection ng-model=\"$ctrl.applicants\" button-type=\"FAB\" display-icon=\"add\" is-mini=\"true\" ng-if=\"$ctrl.defaultFormSetting.isCanApplyForOthers && $ctrl.formType === \'create\'\"></member-selection></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.COURSE_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block m-t-0\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"{{ \'FIELD.COURSE_NAME\' | translate}}\" name=\"courseName\" ng-model=\"$ctrl.applyForm.courseName\" required=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\"><span class=\"pt-mark\">*</span>{{ \'STATUS.ENROLLED\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group name=\"hasEnroll\" ng-model=\"$ctrl.applyForm.hasEnroll\" ng-required=\"$ctrl.needRequired\" ng-disabled=\"!$ctrl.isCanEditForm\"><md-radio-button class=\"el-inBlock p-r-20\" value=\"1\">{{\'FIELD.TRUE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"0\">{{\'FIELD.FALSE\' | translate}}</md-radio-button><div ng-messages=\"$ctrl.wizardForm1.hasEnroll.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.THIS_IS_REQUIRED\' | translate}}</span></div></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.DESCRIPTION\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block m-t-0 w-700\" md-no-float=\"\"><input placeholder=\"{{ \'FIELD.DESCRIPTION\' | translate}}\" name=\"reason\" ng-model=\"$ctrl.applyForm.reason\" required=\"\" ng-disabled=\"!$ctrl.isCanEditForm\"></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.JOIN_REASON\' | translate}}({{ \'FIELD.MULTIPLE_SELECT\' | translate}})</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block m-t-0\"><multi-checkbox ng-model=\"$ctrl.applyReason\" datas=\"$ctrl.applyReasons\" title-key=\"reasonName\" value-key=\"reasonId\" ng-disabled=\"!$ctrl.isCanEditForm\"></multi-checkbox><input type=\"hidden\" name=\"applyReason\" ng-model=\"$ctrl.applyForm.applyReason\" ng-required=\"$ctrl.needRequired && (!$ctrl.applyForm.otherApplyReason.length>0)\" ng-disabled=\"!$ctrl.isCanEditForm\"></md-input-container><md-input-container class=\"md-block m-t-0 w-700\" md-no-float=\"\"><input placeholder=\"{{ \'FIELD.OTHER\' | translate}}\" name=\"otherApplyReason\" ng-model=\"$ctrl.applyForm.otherApplyReason\" ng-disabled=\"!$ctrl.isCanEditForm\"></md-input-container><div ng-messages=\"$ctrl.wizardForm1.applyReason.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.PLEASE_SELECT_AT_LEAST_ONE_ITEM\' | translate}}</span></div></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.DOMESTIC\' | translate}}/{{ \'FIELD.ABROAD\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.applyForm.type\" ng-disabled=\"$ctrl.formType === \'edit\' || ((!$ctrl.isCanEditForm) || $ctrl.defaultDisableField)\"><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"0\">{{\'FIELD.DOMESTIC\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" ng-value=\"1\">{{\'FIELD.ABROAD\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.VENDOR\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-external-training-vendors name=\"h_organizationIds\" ng-model=\"$ctrl.h_organizationIds\" ng-required=\"$ctrl.needRequired\" input-disabled=\"$ctrl.defaultDisableFieldAndIsCanEditFormStatus\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\" is-reload=\"$ctrl.isVendorsReload\"></select-external-training-vendors><div ng-messages=\"$ctrl.wizardForm1.vendors.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{\'FORM_VALIDATION.PLEASE_SELECT_AT_LEAST_ONE_ITEM\' | translate}}</span></div></div></div><a ng-if=\"$ctrl.defaultFormSetting.isShowAddVendor\" flex-offset=\"30\" href=\"javascript:void(0)\" external-company-insert-dialog=\"\" is-vendors-reload=\"$ctrl.isVendorsReload\" add-vendor=\"$ctrl.h_organizationIds\">{{\'MESSAGE.ADDED_EXTERNAL_VENDOR\' |translate}}</a><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.CLASS_TIME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><class-time name=\"classTime\" ng-model=\"$ctrl.classTime\" class-time-objects=\"$ctrl.classTimeObjects\" ng-required=\"$ctrl.needRequired\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></class-time><div ng-messages=\"$ctrl.wizardForm1.classTime.$error\" role=\"alert\"><span ng-message=\"required\" class=\"pt-mark pt-mark-override\">{{ \'FORM_VALIDATION.PLEASE_SET_AT_LEAST_ONE_TIME_ZONE\' | translate}}</span></div></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\" ng-if=\"$ctrl.createFromDisplay && $ctrl.$state.includes(\'supervisorZone.approveExternalTrainingApplyRecordsFormEdit\')\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.CREATE_FROM\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.applyForm.auto_create\"><md-radio-button class=\"p-r-20\" ng-value=\"1\">{{\'FIELD.EXTERNAL_AUTO_CREATE\' | translate}}</md-radio-button><md-radio-button class=\"p-r-20\" ng-value=\"0\">{{\'FIELD.EXTERNAL_ADD_COURSE\' | translate}}</md-radio-button></md-radio-group><div layout=\"row\" class=\"p-l-30\" ng-if=\"$ctrl.selectExternalClass\"><span>{{ \'FIELD.ASSIGNED_COURSE_CLASS\' | translate}}：</span><show-course-session-name course-id=\"$ctrl.selectExternalClass.courseId\" session-id=\"$ctrl.selectExternalClass.sessionId\"></show-course-session-name></div><div layout=\"row\" class=\"p-l-20\"><select-external-class ng-disabled=\"$ctrl.applyForm.auto_create !== 0\" external-id=\"$ctrl.extCourseForm.externalId\" applicant-id=\"$ctrl.extCourseForm.applicants\" ng-model=\"$ctrl.selectExternalClass\"></select-external-class></div></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\"><span class=\"pt-mark\">*</span>{{ \'FIELD.EVENT_LOCATION\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"{{ \'FIELD.EVENT_LOCATION\' | translate}}\" type=\"text\" name=\"location\" ng-model=\"$ctrl.applyForm.location\" required=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.TRAINING_NATURE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.applyForm.trainType\" ng-disabled=\"!$ctrl.isCanEditForm\"><md-radio-button class=\"el-inBlock p-r-20\" value=\"1\">{{\'FIELD.ASSIGNED_BY_MANAGER\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"2\">{{\'FIELD.PERSONAL_REQUESTS\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.ENROLLMENT_WEBSITE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"{{ \'FIELD.ENROLLMENT_WEBSITE\' | translate}}\" type=\"url\" ng-model=\"$ctrl.applyForm.refLink\" name=\"refLink\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"><div ng-messages=\"$ctrl.wizardForm1.refLink.$error\" ng-show=\"$ctrl.wizardForm1.refLink.$dirty\"><div ng-message=\"url\">{{ \'FORM_VALIDATION.PLEASE_ENTER_A_VALID_URL\' | translate }}</div></div></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.UPLOAD_COURSE_DATA\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><upload-course-data-files ng-model=\"$ctrl.courseFiles\" refs=\"$ctrl.refs\" max-count=\"3\" external-id=\"$ctrl.applyForm.externalId\" ng-disabled=\"!$ctrl.isCanEditForm\"></upload-course-data-files></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.REMARK\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><textarea ng-attr-placeholder=\"{{ \'FIELD.REMARK\' | translate}}\" ng-model=\"$ctrl.applyForm.note\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" md-detect-hidden=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></textarea></md-input-container></div></div><div class=\"sf-controls clearfix\"><a class=\"next-btn sf-right sf-btn sf-btn-next\" href=\"#\" wz-next=\"\">{{ \'ACTIONS.NEXT_STEP\' | translate}}</a></div></form></div></md-content></div></div></wz-step><wz-step canexit=\"$ctrl.canExitStep2\" wz-title=\"{{ \'FIELD.COURSE_COST\' | translate}}<br>{{ \'FIELD.LEARNING_REPORT\' | translate}}\"><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 col-md-12\"><md-content layout-padding=\"\"><div class=\"thForm\"><form name=\"$ctrl.wizardForm2\"><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.COURSE_TYPE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.applyForm.isForFree\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"><md-radio-button class=\"el-inBlock p-r-20\" value=\"1\">{{\'FIELD.FREE_COURSE\' | translate}}</md-radio-button><md-radio-button class=\"el-inBlock p-r-20\" value=\"0\">{{\'FIELD.PAY_COURSE\' | translate}}</md-radio-button></md-radio-group></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\" ng-if=\"$ctrl.applyForm.isForFree === \'0\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{\'FIELD.ENROLLMENT_COST\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-20 p-t-0 pt-bgGroup\" layout-padding=\"\"><enroll-costs ng-model=\"$ctrl.enrollCosts\" form=\"$ctrl.wizardForm2\" default-disable-field=\"$ctrl.fromBulletinDisableField\" ng-disabled=\"!$ctrl.isCanEditForm\"></enroll-costs></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\" ng-if=\"$ctrl.applyForm.isForFree === \'0\'\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{\'FIELD.PAYMENT_DATE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-20 p-t-0\" layout-padding=\"\"><md-datepicker ng-model=\"$ctrl.applyForm.payingDate\" ng-disabled=\"!$ctrl.isCanEditForm\"></md-datepicker></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.LEARNING_REPORT\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-20 p-t-0 pt-bgGroup\"><learning-report-setting ng-model=\"$ctrl.learningReport\" setting-rule=\"$ctrl.learningReportObject\" class-time-objects=\"$ctrl.classTimeObjects\" ng-disabled=\"!$ctrl.isCanEditForm\" is-create-form=\"$ctrl.isCreateForm\"></learning-report-setting></div></div><div class=\"sf-controls clearfix\"><a class=\"prev-btn sf-left sf-btn sf-btn-prev\" href=\"#\" wz-previous=\"\">{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</a> <a class=\"next-btn sf-right sf-btn sf-btn-next\" href=\"#\" wz-next=\"\">{{ \'ACTIONS.NEXT_STEP\' | translate}}</a></div></form></div></md-content></div></div></wz-step><wz-step wz-title=\"{{ \'FIELD.COURSE_DETAIL\' | translate}}\"><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 col-md-12\"><md-content layout-padding=\"\"><div class=\"thForm\"><form name=\"wizardForm3\"><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.ENROLL_DEADLINE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><div layout-xs=\"column\" layout-gt-xs=\"row\"><div flex=\"grow\"><div layout=\"row\" flex-xs=\"90\"><md-input-container class=\"md-block m-t-0\"><label>{{ \'FIELD.START_DATE\' | translate}}</label><md-datepicker ng-model=\"$ctrl.applyForm.enrollStart\" ng-disabled=\"!$ctrl.isCanEditForm\"></md-datepicker></md-input-container></div></div><div flex-xs=\"grow\" flex-gt-xs=\"5\" class=\"center\">to</div><div flex=\"grow\"><div layout=\"row\" flex-xs=\"90\"><md-input-container class=\"md-block m-t-0\"><label>{{ \'FIELD.END_DATE\' | translate}}</label><cus-md-datepicker ng-model=\"$ctrl.applyForm.enrollEnd\" md-min-date=\"$ctrl.applyForm.enrollStart\" ng-disabled=\"!$ctrl.isCanEditForm\"></cus-md-datepicker></md-input-container></div></div></div></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.INSTRUCTOR_NAME\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><input placeholder=\"{{ \'FIELD.INSTRUCTOR_NAME\' | translate}}\" ng-model=\"$ctrl.applyForm.instructor\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.CLASSIFICATION\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><select-classification ng-model=\"$ctrl.applyForm.category\" type=\"11\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></select-classification></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.COURSE_DESCRIPTION\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><textarea ng-attr-placeholder=\"{{ \'FIELD.COURSE_DESCRIPTION\' | translate}}\" ng-model=\"$ctrl.applyForm.summary\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" md-detect-hidden=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></textarea></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.LEARNING_GOAL\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><textarea ng-attr-placeholder=\"{{ \'FIELD.LEARNING_GOAL\' | translate}}\" ng-model=\"$ctrl.applyForm.objective\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" md-detect-hidden=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></textarea></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.PREPARATORY_KNOWLEDGE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><textarea ng-attr-placeholder=\"{{ \'FIELD.PREPARATORY_KNOWLEDGE\' | translate}}\" ng-model=\"$ctrl.applyForm.prerequesite\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" md-detect-hidden=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></textarea></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.SUITABLE_FOR_THE_OBJECT\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><textarea ng-attr-placeholder=\"{{ \'FIELD.SUITABLE_FOR_THE_OBJECT\' | translate}}\" ng-model=\"$ctrl.applyForm.audience\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" md-detect-hidden=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></textarea></md-input-container></div></div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right m-t-20 w-700\">{{ \'FIELD.COURSE_OUTLINE\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-l-20\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-no-float=\"\"><textarea ng-attr-placeholder=\"{{ \'FIELD.COURSE_OUTLINE\' | translate}}\" ng-model=\"$ctrl.applyForm.outline\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\" md-detect-hidden=\"\" ng-disabled=\"(!$ctrl.isCanEditForm) || $ctrl.defaultDisableField\"></textarea></md-input-container></div></div><div ng-if=\"$ctrl.extCourseForm.hasPreviousEnrollRecord === 0\"><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.LAST_EXTERNAL_TRAINING_HISTORY\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-20 p-t-0 pt-bgGroup\" layout-padding=\"\"><div layout-gt-xs=\"row\" class=\"m-t-20\"><div flex-gt-xs=\"20\" class=\"text-right\">{{ \'FIELD.TRAINING_NAME\' | translate}}:</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><div>{{ \'FIELD.NOTHING\' | translate}}</div></div></div></div></div></div><div ng-if=\"$ctrl.extCourseForm.hasPreviousEnrollRecord === 1\"><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-margin=\"\"><div flex-gt-xs=\"25\" class=\"text-right w-700\">{{ \'FIELD.LAST_EXTERNAL_TRAINING_HISTORY\' | translate}}</div><div flex-gt-xs=\"75\" class=\"p-20 p-t-0 pt-bgGroup\" layout-padding=\"\"><div layout-gt-xs=\"row\" class=\"m-t-20\"><p>{{ \'FIELD.EXTERNAL_TRAINING_APPLY_TIMES_PRE\' | translate}} <span class=\"pt-mark pt-mark-override\">{{ $ctrl.extCourseForm.numOfTimes }}</span> {{ \'FIELD.EXTERNAL_TRAINING_APPLY_TIMES_POST\' | translate}} <span class=\"pt-mark pt-mark-override\">{{ $ctrl.extCourseForm.annualCost }}</span> {{ \'FIELD.EXTERNAL_TRAINING_APPLY_COST\' | translate}}. ({{ \'FIELD.TAX_FREE\' | translate}})</p></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\">{{ \'FIELD.TRAINING_NAME\' | translate}}:</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><span>{{$ctrl.extCourseForm.previousCourseName}}</span></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\">{{ \'FIELD.EXTERNAL_TRAINING_REPORT\' | translate}}:</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><div ng-if=\"$ctrl.extCourseForm.learningReportStatus === \'\'\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.extCourseForm.learningReportStatus !== \'\'\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}}: {{ $ctrl.extCourseForm.learningReportStatus | stringSplitToValue: \'/\' : 0}}, {{ \'FIELD.UN_PAID\' | translate}}: {{ $ctrl.extCourseForm.learningReportStatus | stringSplitToValue: \'/\' : 1}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:<md-input-container class=\"m-t-0\" flex-gt-xs=\"30\" flex-xs=\"40\" md-no-float=\"\"><input placeholder=\"\" ng-model=\"$ctrl.applyForm.learningReportReason\" ng-disabled=\"!$ctrl.defaultFormSetting.isLearningAdmin\"></md-input-container></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\">{{ \'FIELD.ORAL_REPORT\' | translate}}:</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><div ng-if=\"$ctrl.extCourseForm.oralReportSubmit === -4\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.extCourseForm.oralReportSubmit === 1\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}} <span ng-if=\"$ctrl.extCourseForm.learningReport.isOralReportNeedGrade\">, {{ \'FIELD.SCORE\' | translate}} <span ng-if=\"$ctrl.extCourseForm.oralStatus === 2\">{{ \'FIELD.NOT_YET_RATED\' | translate}}</span> <span ng-if=\"$ctrl.extCourseForm.oralStatus !== 2\">{{ $ctrl.extCourseForm.oralReportScore}}</span></span></div><div ng-if=\"($ctrl.extCourseForm.oralReportSubmit !== -4) && ($ctrl.extCourseForm.oralReportSubmit !== 1)\">{{ \'FIELD.UN_PAID\' | translate}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:<md-input-container class=\"m-t-0\" flex-gt-xs=\"30\" flex-xs=\"40\" md-no-float=\"\"><input placeholder=\"\" ng-model=\"$ctrl.applyForm.oralReportReason\" ng-disabled=\"!$ctrl.defaultFormSetting.isLearningAdmin\"></md-input-container></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\">{{ \'FIELD.INTERNAL_LECTURE\' | translate}}:</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><div ng-if=\"$ctrl.extCourseForm.teachingReportSubmit === -4\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.extCourseForm.teachingReportSubmit === 1\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}} <span ng-if=\"$ctrl.extCourseForm.learningReport.isTeachingNeedGrade\">, {{ \'FIELD.SCORE\' | translate}} <span ng-if=\"$ctrl.extCourseForm.teachingStatus === 2\">{{ \'FIELD.NOT_YET_RATED\' | translate}}</span> <span ng-if=\"$ctrl.extCourseForm.teachingStatus !== 2\">{{ $ctrl.extCourseForm.teachingScore}}</span></span></div><div ng-if=\"($ctrl.extCourseForm.teachingReportSubmit !== -4) && ($ctrl.extCourseForm.teachingReportSubmit !== 1)\">{{ \'FIELD.UN_PAID\' | translate}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:<md-input-container class=\"m-t-0\" flex-gt-xs=\"30\" flex-xs=\"40\" md-no-float=\"\"><input placeholder=\"\" ng-model=\"$ctrl.applyForm.teachingReportReason\" ng-disabled=\"!$ctrl.defaultFormSetting.isLearningAdmin\"></md-input-container></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\">{{ \'FIELD.OTHER_METHOD\' | translate}}:</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><div ng-if=\"$ctrl.extCourseForm.otherReportSubmit === -4\">{{ \'FIELD.EXTERNAL_TRAINING_NO_REPORT_NEED\' | translate}}</div><div ng-if=\"$ctrl.extCourseForm.otherReportSubmit === 1\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}}</div><div ng-if=\"($ctrl.extCourseForm.otherReportSubmit !== -4) && ($ctrl.extCourseForm.otherReportSubmit !== 1)\">{{ \'FIELD.UN_PAID\' | translate}} &nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:<md-input-container class=\"m-t-0\" flex-gt-xs=\"30\" flex-xs=\"40\" md-no-float=\"\"><input placeholder=\"\" ng-model=\"$ctrl.applyForm.otherReportReason\" ng-disabled=\"!$ctrl.defaultFormSetting.isLearningAdmin\"></md-input-container></div></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"20\">{{ \'FIELD.TRAINING_MATERIAL\' | translate}}:</div><div flex-gt-xs=\"80\" class=\"p-l-20\"><md-radio-group ng-model=\"$ctrl.applyForm.materialSubmit\" ng-disabled=\"!$ctrl.defaultFormSetting.isLearningAdmin\"><md-radio-button value=\"1\" class=\"el-inBlock p-r-20\">{{ \'FIELD.HAS_BEEN_PAID\' | translate}}</md-radio-button><md-radio-button value=\"0\" class=\"el-inBlock p-r-20\">{{ \'FIELD.UN_PAID\' | translate}}</md-radio-button>&nbsp;&nbsp;{{ \'FIELD.ORIGIN\' | translate}}:<md-input-container class=\"m-t-0\" flex-gt-xs=\"30\" flex-xs=\"40\"><input placeholder=\"\" ng-model=\"$ctrl.applyForm.materialReason\" ng-disabled=\"!$ctrl.defaultFormSetting.isLearningAdmin\"></md-input-container></md-radio-group></div></div></div></div></div><div class=\"sf-controls clearfix\"><a class=\"prev-btn sf-left sf-btn sf-btn-prev\" href=\"#\" wz-previous=\"\">{{ \'ACTIONS.PREVIOUS_STEP\' | translate}}</a> <input class=\"finish-btn sf-right sf-btn sf-btn-finish\" type=\"submit\" wz-finish=\"\" value=\"{{ \'ACTIONS.FINISH\' | translate}}\" ng-if=\"$ctrl.isCanEditForm\"></div></form></div></md-content></div></div></wz-step></wizard></div></div></div></section></div></div>");
$templateCache.put("app/modules/course-resource/views/external/external-training-bulletin-detailed-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"60\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.COURSE_INFO_DETAIL\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\" class=\"hidden-x-scrollbar\"><div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><external-training-bulletin-detailed data=\"$ctrl.bulletinDetailed\"></external-training-bulletin-detailed></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/course-resource/views/external/external-training-bulletin-detailed.html","<div class=\"lightBox Box-billboard\"><header><h4>{{ $ctrl.data.courseName}}</h4></header><div class=\"box-content\"><table><tbody><tr ng-if=\"$ctrl.data.classification.length > 0\"><th>{{ \'FIELD.CLASSIFICATION\' | translate}}:</th><td><select-classification ng-model=\"$ctrl.data.classification\" type=\"11\" only-text=\"true\"></select-classification></td></tr><tr><th>{{ \'FIELD.DOMESTIC\' | translate}}/{{ \'FIELD.ABROAD\' | translate}} :</th><td><span ng-if=\"$ctrl.data.type === 0\">{{ \'FIELD.DOMESTIC\' | translate }}</span> <span ng-if=\"$ctrl.data.type !== 0\">{{ \'FIELD.ABROAD\' | translate }}</span></td></tr><tr ng-if=\"$ctrl.data.enrollStart.length > 0 || $ctrl.data.enrollEnd.length > 0\"><th>{{ \'FIELD.ENROLL_DEADLINE\' | translate}} :</th><td>{{$ctrl.data.enrollStart}} ~ {{$ctrl.data.enrollEnd}}</td></tr><tr ng-if=\"($ctrl.data.instructor | trim ).length > 0\"><th>{{ \'FIELD.INSTRUCTOR_NAME\' | translate}} :</th><td>{{$ctrl.data.instructor}}</td></tr><tr ng-if=\"($ctrl.data.description | trim ).length > 0\"><th>{{ \'FIELD.COURSE_DESCRIPTION\' | translate}} :</th><td><span ng-bind-html=\"$ctrl.data.description\"></span></td></tr><tr ng-if=\"($ctrl.data.objective | trim ).length > 0\"><th>{{ \'FIELD.LEARNING_GOAL\' | translate}} :</th><td><span ng-bind-html=\"$ctrl.data.objective\"></span></td></tr><tr ng-if=\"($ctrl.data.prerequesite | trim ).length > 0\"><th>{{ \'FIELD.PREPARATORY_KNOWLEDGE\' | translate}} :</th><td><span ng-bind-html=\"$ctrl.data.prerequesite\"></span></td></tr><tr ng-if=\"($ctrl.data.audience | trim ).length > 0\"><th>{{ \'FIELD.SUITABLE_FOR_THE_OBJECT\' | translate}} :</th><td><span ng-bind-html=\"$ctrl.data.audience\"></span></td></tr><tr ng-if=\"($ctrl.data.outline | trim ).length > 0\"><th>{{ \'FIELD.COURSE_OUTLINE\' | translate}} :</th><td><span ng-bind-html=\"$ctrl.data.outline\"></span></td></tr><tr><th>{{ \'FIELD.VENDOR\' | translate}} :</th><td><select-external-training-vendors ng-model=\"$ctrl.h_organizationIds\" only-text=\"true\"></select-external-training-vendors></td></tr><tr ng-if=\"($ctrl.data.timeDesc | trim ).length > 0\"><th>{{ \'FIELD.CLASS_TIME\' | translate}} :</th><td>{{$ctrl.data.timeDesc}}</td></tr><tr ng-if=\"($ctrl.data.location | trim ).length > 0\"><th>{{ \'FIELD.EVENT_LOCATION\' | translate}} :</th><td>{{$ctrl.data.location}}</td></tr><tr><th>{{ \'FIELD.COURSE_TYPE\' | translate}} :</th><td><span ng-if=\"$ctrl.data.isForFree === 1\">{{\'FIELD.FREE_COURSE\' | translate}}</span> <span ng-if=\"$ctrl.data.isForFree === 0\">{{\'FIELD.PAY_COURSE\' | translate}}</span></td></tr><tr ng-if=\"$ctrl.data.isForFree === 0\"><th>{{ \'FIELD.ENROLLMENT_COST\' | translate}} :</th><td>{{$ctrl.data.ExtTotalCost | number : 0}}&nbsp;&nbsp;{{$ctrl.basicCurrencyName}}</td></tr><tr ng-if=\"$ctrl.data.isForFree === 0\"><th>{{ \'FIELD.SUBSIDY_COST\' | translate}} :</th><td>{{$ctrl.data.ExtSubsidy | number : 0}}&nbsp;&nbsp;{{$ctrl.basicCurrencyName}}({{$ctrl.data.enrollCost.subsidyPercentage}}%)</td></tr><tr ng-if=\"$ctrl.data.isForFree === 0\"><th>{{ \'FIELD.SELF_COST\' | translate}} :</th><td>{{$ctrl.data.ExtLearnerCost | number : 0}}&nbsp;&nbsp;{{$ctrl.basicCurrencyName}}({{100 - ($ctrl.data.enrollCost.subsidyPercentage | stringToNumber)}}%)</td></tr><tr ng-if=\"$ctrl.data.courseRefs.length > 0\"><th>{{ \'FIELD.REFERENCE_MATERIAL\' | translate}} :</th><td><div ng-repeat=\"courseRef in $ctrl.data.courseRefs\"><a href=\"javascript:void(0)\" view-ctms-reference=\"\" package-id=\"$ctrl.data.CTMSReferencesRootId\" file-name=\"courseRef.systemFileName\">{{courseRef.fileName}}</a></div></td></tr><tr ng-if=\"($ctrl.data.note | trim ).length > 0\"><th>{{ \'FIELD.REMARK\' | translate}} :</th><td>{{$ctrl.data.note}}</td></tr><tr ng-if=\"($ctrl.data.RTEContent | trim ).length > 0\"><th>{{ \'FIELD.DESCRIPTION\' | translate}} :</th><td><div ng-bind-html=\"$ctrl.data.RTEContent | trustAsHtml\"></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/course-resource/views/external/external-training-bulletin.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section id=\"timeline\" class=\"th-contentList th-billboard\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_TRAINING_BULLETIN\' | translate}}</h2><div class=\"right\" ng-if=\"$ctrl.bulletinApplyKnowHow.hasKnowHow\"><a href=\"javascript:void(0)\" class=\"apply\" view-ctms-reference=\"\" package-id=\"$ctrl.bulletinApplyKnowHow.CTMSReferencesRootId\" file-name=\"$ctrl.bulletinApplyKnowHow.SystemFileName\"><i class=\"material-icons\">cloud_download</i> {{ \'ACTIONS.APPLY_INFORMATION\' | translate}}</a></div></div><header><ui-pagination-header-controls pagination-id=\"externalTrainingBulletin\" pagination-sort=\"$ctrl.pagination.sort\" sorts=\"[{key : \'StartDate\', name:\'FIELD.DATE\'},{key : \'Name\', name:\'FIELD.TITLE\'}]\" reload-pagination-data=\"$ctrl.getData(params)\" has-search-box=\"true\" has-change-template=\"true\" template-type=\"card\"></ui-pagination-header-controls></header><div class=\"row\"><div class=\"col-lg-12\"><div class=\"timeline-block\" ui-paginate=\"ExternalTrainingBulletinData in $ctrl.ExternalTrainingBulletinDatas | itemsPerPage:$ctrl.pagination.perPage\" total-items=\"$ctrl.pagination.total\" current-page=\"$ctrl.pagination.currentPage\" pagination-id=\"externalTrainingBulletin\"><div class=\"timeline-content\"><div class=\"md-contentList\"><figure><a href=\"javascript:void(0)\"><img ng-src=\"{{ExternalTrainingBulletinData.logoImageUrl}}\"></a></figure><div class=\"pt-contentList\"><h6><a href=\"javascript:void(0)\" external-training-bulletin-detailed-dialog=\"\" bulletin-id=\"ExternalTrainingBulletinData.id\" course-id=\"ExternalTrainingBulletinData.courseId\" session-id=\"ExternalTrainingBulletinData.sessionId\" is-course=\"ExternalTrainingBulletinData.isCourse\">{{ExternalTrainingBulletinData.title}}</a></h6><ul class=\"left\"><li><span class=\"li-title\">{{ \'FIELD.TIME\' | translate}}:</span><span class=\"text\">{{ExternalTrainingBulletinData.dateTime}}</span></li><li><span class=\"li-title\">{{ \'FIELD.HOURS\' | translate}}:</span> <span class=\"text\" ng-if=\"(ExternalTrainingBulletinData.hours | numberFormat:\'abs\') > 0\">{{ExternalTrainingBulletinData.hours}}{{ \'FIELD.HOUR\' | translate}}</span> <span class=\"text\" ng-if=\"(ExternalTrainingBulletinData.minutes | numberFormat:\'abs\') > 0\">{{ExternalTrainingBulletinData.minutes}}{{ \'FIELD.MINUTE\' | translate}}</span></li><li ng-if=\"(ExternalTrainingBulletinData.lecturer | trim).length > 0\"><span class=\"li-title\">{{ \'FIELD.INSTRUCTOR\' | translate}}:</span> <span class=\"text\">{{ExternalTrainingBulletinData.lecturer}}</span></li><li><span class=\"li-title\"></span> <span class=\"text\"><a href=\"{{ExternalTrainingBulletinData.externalTrainingUrl}}\" ng-if=\"ExternalTrainingBulletinData.externalTrainingUrl !== \'\'\" target=\"_blank\" class=\"webLink\"><i class=\"material-icons\">language</i> {{ \'FIELD.EXTERNAL_TRAINING_WEBSITE\' | translate}}</a></span></li></ul><ul class=\"right\"><li><span class=\"li-title\">{{ \'FIELD.VENDOR\' | translate}}:</span> <span class=\"text\">{{ExternalTrainingBulletinData.theOrganizer}}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}}:</span> <span class=\"text\" ng-if=\"ExternalTrainingBulletinData.classes.length > 0\">{{ExternalTrainingBulletinData.classes}}</span> <span class=\"text\" ng-if=\"ExternalTrainingBulletinData.classes.length === 0\">{{ \'FIELD.SESSION\' | translate}}1({{ \'FIELD.NOT_CREATED\' | translate}})</span></li><li ng-if=\"ExternalTrainingBulletinData.classification.length > 0\"><span class=\"li-title\">{{ \'FIELD.CLASSIFICATION\' | translate}}:</span> <span class=\"text bulletin-classification\">{{ExternalTrainingBulletinData.classification}}</span></li></ul></div></div><div class=\"explain\" ng-switch=\"ExternalTrainingBulletinData.status\"><a ui-sref=\"externalTrainingZone.externalTrainingBulletinApplyFormCreateByBulletin({bulletinId: ExternalTrainingBulletinData.id, backStateParams: $ctrl.backStateParams})\" class=\"apply\" ng-switch-when=\"1\"><div class=\"icon-preview\"><i class=\"material-icons\">person_add</i></div>{{ \'ACTIONS.APPLY_ENROLLMENT\' | translate}}</a> <a ui-sref=\"externalTrainingZone.externalTrainingBulletinApplyFormCreateByCourseSession({courseId: ExternalTrainingBulletinData.courseId, sessionId: ExternalTrainingBulletinData.sessionId, backStateParams: $ctrl.backStateParams})\" class=\"apply\" ng-switch-when=\"2\"><div class=\"icon-preview\"><i class=\"material-icons\">person_add</i></div>{{ \'ACTIONS.APPLY_ENROLLMENT\' | translate}}</a> <span class=\"off\" ng-switch-when=\"3\"><i class=\"fa fa-user\"></i> {{ \'STATUS.ENROLLED\' | translate}}</span> <span class=\"off\" ng-switch-when=\"4\"><i class=\"fa fa-user\"></i> {{ \'STATUS.NOT_ENROLLMENT\' | translate}}</span> <span class=\"off\" ng-switch-when=\"5\"><i class=\"fa fa-user\"></i> {{ \'STATUS.ENROLLMENT_DEADLINE\' | translate}}</span></div></div></div></div></div><footer><ui-pagination-controls on-page-change=\"$ctrl.getData(params)\" pagination-id=\"externalTrainingBulletin\"></ui-pagination-controls></footer></section></div></div>");
$templateCache.put("app/modules/course-resource/views/external/external-training-records-search-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"25\"><form ng-submit=\"$ctrl.submit($ctrl.filters)\" name=\"validForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'FIELD.SELECT_SEARCH_FILTER\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \'FIELD.SEARCH_SCOPE\' | translate}}</label><md-select ng-model=\"$ctrl.filters.scopeType\"><md-option value=\"all\" permission=\"\" permission-only=\"[\'Manage_All_External_Event\']\">{{ \'FIELD.SEARCH_SCOPE_ALL\' | translate}}</md-option><md-option value=\"department\">{{ \'FIELD.SEARCH_SCOPE_DEPARTMENT\' | translate}}</md-option></md-select></md-input-container><md-input-container md-no-float=\"\" class=\"md-block m-t-0\" flex-gt-sm=\"\"><label>{{ \'FIELD.REQUISITION_NUMBER\' | translate}}</label> <input ng-model=\"$ctrl.filters.extId\" placeholder=\"\"></md-input-container><md-input-container md-no-float=\"\" class=\"md-block m-t-0\" flex-gt-sm=\"\"><label>{{ \'FIELD.TRAINING_NAME\' | translate}}</label> <input ng-model=\"$ctrl.filters.trainingName\" placeholder=\"\"></md-input-container><md-input-container md-no-float=\"\" class=\"md-block m-t-0 m-b-0\" flex-gt-sm=\"\"><label>{{ \'FIELD.INSTRUCTOR\' | translate}}</label> <input ng-model=\"$ctrl.filters.instructorName\" placeholder=\"\"></md-input-container><div>{{ \'FIELD.APPLY_DATE\' | translate}}</div><md-input-container class=\"md-block m-t-0 m-b-0\" md-no-float=\"\"><md-datepicker placeholder=\"{{ \'FIELD.START_DATE\' | translate}}\" ng-model=\"$ctrl.filters.startDate\" ng-change=\"$ctrl.updateEndDateModel()\"></md-datepicker></md-input-container><md-input-container class=\"md-block m-t-0 m-b-0\" md-no-float=\"\"><md-datepicker placeholder=\"{{ \'FIELD.END_DATE\' | translate}}\" md-min-date=\"$ctrl.filters.startDate\" ng-model=\"$ctrl.filters.endDate\"></md-datepicker></md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-warn btn\" ng-click=\"$ctrl.close()\">{{ \'ACTIONS.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary btn\" type=\"submit\" style=\"margin-right:20px;\">{{ \'ACTIONS.ENTER\' | translate }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/course-resource/views/external/external-training-records.html","<div class=\"row animated fadeIn\"><div class=\"col-md-12 col-lg-12\"><section class=\"manager th-train\"><div class=\"th-title\"><h2>{{ \'EXTERNAL_TRAINING_APPLY_RECORDS\' | translate }}</h2></div><div class=\"th-manager\"><div class=\"th-search\"><div class=\"link\"><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.showPrompt($event)\"><md-icon md-font-set=\"fa\" class=\"fa-filter\"></md-icon>{{ \'ACTIONS.SEARCH\' | translate }}</md-button></div></div><table ng-table=\"$ctrl.externalTrainingRecordsTable\" class=\"animate tb-Collapse\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'FIELD.REQUISITION_NUMBER\' | translate\" class=\"appear\"><div class=\"text\">{{row.id}}</div></td><td data-title=\"\'FIELD.TRAINING_NAME\' | translate\" class=\"appear\" sortable=\"\'1\'\"><div class=\"text\"><a href=\"javascript:void(0)\" tip-info=\"\" tip-type=\"5\" params=\"{exid: row.id}\">{{row.extName}}</a></div></td><td data-title=\"\'FIELD.TABLE_HEADER_INSTRUCTOR\' | translate\" class=\"appear\" sortable=\"\'3\'\"><div class=\"text\">{{row.instructors}}</div></td><td data-title=\"\'FIELD.APPLICANT\' | translate\" class=\"appear\"><div class=\"text\"><a href=\"javascript:void(0);\" user-detail=\"\" user-id=\"row.applicantId\">{{row.applicantName}}</a></div></td><td data-title=\"\'FIELD.APPLY_THW_WAY\' | translate\" class=\"appear\"><div class=\"text\"><show-status status=\"row.enrollType\" status-type=\"enroll\"></show-status></div></td><td data-title=\"\'FIELD.APPLY_DATE\' | translate\" class=\"appear\" sortable=\"\'0\'\"><div class=\"text\">{{row.createDate}}</div></td><td data-title=\"\'FIELD.STATUS\' | translate\" class=\"appear\"><div class=\"text\"><a href=\"javascript:void(0);\" ng-if=\"row.status!==\'NO_APPROVAL\'\" ng-click=\"$ctrl.showApproveStatus(row.workflowId)\"><show-status status=\"row.status\" status-type=\"externalTrainingRecordsApprove\"></show-status></a><show-status status=\"row.status\" ng-if=\"row.status===\'NO_APPROVAL\'\" status-type=\"externalTrainingRecordsApprove\"></show-status></div></td><td data-title=\"\'FIELD.ACTION\' | translate\" class=\"appear\"><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.noOneApprove === 1 || $ctrl.isLearningAdmin\" ui-sref=\"externalTrainingZone.externalTrainingApplyRecordsFormEdit({externalId: row.id, backStateParams: $ctrl.backStateParams})\">{{ \'ACTIONS.FORM_EDIT\' | translate}}</a><a href=\"javascript:void(0);\" class=\"btn btn-sm btn-primary\" ng-if=\"row.noOneApprove !== 1 && (!$ctrl.isLearningAdmin)\" external-training-apply-form-view-dialog=\"\" external-id=\"row.id\">{{ \'ACTIONS.FORM_VIEW\' | translate}}</a></td></tr></table></div></section></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/course-learning-resource-info.html","<div class=\"timeline-content\"><div class=\"el-tag\" ng-if=\"$ctrl.courseResourceData.isLatest===1\">{{ \'STATUS.NEW\' |translate }}</div><div class=\"el-tag\" ng-if=\"$ctrl.courseResourceData.isHot===1\">{{ \'STATUS.HOT\' |translate }}</div><div class=\"el-tag\" ng-if=\"$ctrl.courseResourceData.isRecommended===1\">{{ \'STATUS.FEATURED\' |translate }}</div><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseResourceData.courseType\" is-program=\"$ctrl.courseResourceData.courseType===0\" program-type=\"$ctrl.courseResourceData.programType\"></course-type-tag><figure><a ng-if=\"$ctrl.courseResourceData.courseType !== 0\" ui-sref=\"courseResourceCatalog.CourseInfo({cid: 0, courseId:$ctrl.courseResourceData.itemId, nid: $ctrl.nodeId, backState: \'courseResourceCatalog\', params:$ctrl.params})\"><img ng-src=\"{{$ctrl.courseResourceData.logoUrl}}\"></a> <a ng-if=\"$ctrl.courseResourceData.courseType === 0\" ui-sref=\"courseResourceCatalog.ProgramInfo({cid: 0, programId:$ctrl.courseResourceData.itemId, nid: $ctrl.nodeId, backState: \'courseResourceCatalog\', params:$ctrl.params})\"><img ng-src=\"{{$ctrl.courseResourceData.logoUrl}}\"></a></figure><div class=\"pt-contentList\"><h6 ng-if=\"$ctrl.courseResourceData.courseType !== 0\"><a ui-sref=\"courseResourceCatalog.CourseInfo({cid: 0, courseId:$ctrl.courseResourceData.itemId, nid: $ctrl.nodeId, backState: \'courseResourceCatalog\', params:$ctrl.params})\">{{$ctrl.courseResourceData.objectName}}</a></h6><h6 ng-if=\"$ctrl.courseResourceData.courseType === 0\"><a ui-sref=\"courseResourceCatalog.ProgramInfo({cid: 0, programId:$ctrl.courseResourceData.itemId, nid: $ctrl.nodeId, backState: \'courseResourceCatalog\', params:$ctrl.params})\">{{$ctrl.courseResourceData.objectName}}</a></h6><ul class=\"left\"><li layout=\"row\" layout-align=\"space-between start\"><div flex=\"85\"><span class=\"li-title total\"><i class=\"material-icons\">group</i>{{ \'FIELD.TOTAL_NUMBER_OF_CLASSES\' | translate}}:</span> <span class=\"text\">{{$ctrl.courseResourceData.learnerCount}}</span></div><div flex=\"\" class=\"like\" ng-include=\"\'favorite.html\'\" ng-if=\"$ctrl.courseResourceData.programType===1 || $ctrl.courseResourceData.courseType===3 || $ctrl.courseResourceData.courseType===6\"></div></li><li ng-if=\"$ctrl.courseResourceData.programType!==1 && $ctrl.courseResourceData.courseType!==3 && $ctrl.courseResourceData.courseType!==6\"><div class=\"th-rateit\"><cus-rate-it class=\"rateit override-rateit\" step=\"1\" value=\"$ctrl.courseResourceData.avgScoreForAll\"></cus-rate-it><span>{{$ctrl.courseResourceData.avgScoreForAll | number:2}}</span></div><div class=\"like\" ng-include=\"\'favorite.html\'\"></div></li></ul></div></div><script type=\"text/ng-template\" id=\"favorite.html\"><a class=\"fa fa-heart\" ng-class=\"{true: \'on\'}[$ctrl.courseResourceData.isFavorite]\" href=\"javascript:void(0);\" set-favorite course-id=\"$ctrl.courseResourceData.itemId\" course-name=\"$ctrl.courseResourceData.objectName\" course-type=\"$ctrl.courseResourceData.courseType\" is-favorite=\"$ctrl.courseResourceData.isFavorite\" reload=\"$ctrl.reloadFn()\"></a></script><div class=\"explain\"><span ng-if=\"$ctrl.courseResourceData.result !== 0\" ng-switch=\"$ctrl.courseResourceData.result\" ng-class=\"{\'off\': ($ctrl.courseResourceData.result === -1 || $ctrl.courseResourceData.result === 3)}\"><i class=\"material-icons\" ng-switch-when=\"-1\">person_add</i> <i class=\"material-icons\" ng-switch-when=\"2\">assignment_turned_in</i> <i class=\"material-icons\" ng-switch-when=\"3\">assignment_turned_in</i> {{$ctrl.courseResourceData.statusMessage}}</span> <span ng-if=\"$ctrl.courseResourceData.result === 0\" ng-switch=\"$ctrl.courseResourceData.status.toLowerCase()\" ng-class=\"{\'off\': ($ctrl.courseResourceData.status.toLowerCase() === \'incompleted\' || $ctrl.courseResourceData.status.toLowerCase() === \'not attempted\' || $ctrl.courseResourceData.status.toLowerCase() === \'unenroll\'|| $ctrl.courseResourceData.status.toLowerCase() === \'unpublished assigned\')}\"><i class=\"material-icons\" ng-switch-when=\"unenroll\">person_add</i> <i class=\"material-icons\" ng-switch-when=\"incompleted\">check</i> <i class=\"material-icons\" ng-switch-when=\"not attempted\">visibility</i> <i class=\"fa fa-exclamation\" ng-switch-default=\"\"></i> {{$ctrl.courseResourceData.statusMessage}}</span></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-course-type-classroom-test.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\"></course-type-tag><figure><a ui-sref=\"learningPassport.testQuestionnaireCenter.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"($ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#4ca64f\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.testQuestionnaireCenter.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">schedule</i></span><span class=\"text\">{{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li><li><span class=\"li-title\"><i class=\"material-icons\">room</i></span><span class=\"text\">{{$ctrl.courseData.place}}</span></li></ul><a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li ng-if=\"$ctrl.courseData.courseType!=4\"><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-course-type-classroom.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\"></course-type-tag><figure><a ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"($ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#4DAEA5\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">schedule</i></span><span class=\"text\">{{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li><li><span class=\"li-title\"><i class=\"material-icons\">room</i></span><span class=\"text\">{{$ctrl.courseData.place}}</span></li></ul><a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div><div class=\"like\"><a class=\"fa fa-comments\" href=\"{{$ctrl.courseData.forumUrl}}\" target=\"_blank\" ng-if=\"$ctrl.courseData.forumUrl.length > 0\"></a> <a class=\"fa fa-heart\" href=\"javascript:void(0);\" ng-class=\"{\'on\': $ctrl.courseData.isFavorite > 0}\" set-favorite=\"\" course-id=\"$ctrl.courseData.courseId\" course-name=\"$ctrl.courseData.courseName\" course-type=\"$ctrl.courseData.courseType\" is-favorite=\"$ctrl.courseData.isFavorite\" reload=\"$ctrl.reloadFn()\"></a></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-course-type-external.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\"></course-type-tag><figure><a ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"($ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#E98BAB\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">schedule</i></span><span class=\"text\">{{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li><li><span class=\"li-title\"><i class=\"material-icons\">room</i></span><span class=\"text\">{{$ctrl.courseData.place}}</span></li></ul><a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div><div class=\"like\"><a class=\"fa fa-comments\" href=\"{{$ctrl.courseData.forumUrl}}\" target=\"_blank\" ng-if=\"$ctrl.courseData.forumUrl.length > 0\"></a> <a class=\"fa fa-heart\" href=\"javascript:void(0);\" ng-class=\"{\'on\': $ctrl.courseData.isFavorite > 0}\" set-favorite=\"\" course-id=\"$ctrl.courseData.courseId\" course-name=\"$ctrl.courseData.courseName\" course-type=\"$ctrl.courseData.courseType\" is-favorite=\"$ctrl.courseData.isFavorite\" reload=\"$ctrl.reloadFn()\"></a></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-course-type-online-test.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\"></course-type-tag><figure><a ui-sref=\"learningPassport.testQuestionnaireCenter.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"($ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#319DB5\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.testQuestionnaireCenter.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">event_note</i></span> <span class=\"text\">{{ \'FIELD.TEST_DEADLINE\' | translate}} : {{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li><br ng-if=\"$ctrl.courseData.dueDate !== \'\'\"><li ng-if=\"$ctrl.courseData.dueDate !== \'\'\"><span class=\"li-title\"><i class=\"material-icons\">event_note</i></span> <span class=\"text\">{{ \'FIELD.DUE_DATE\' | translate}} : {{$ctrl.courseData.dueDate}}</span></li></ul><a href=\"\" class=\"btn-play\" course-info-player=\"\" enrollment-id=\"$ctrl.courseData.enrollmentId\" reload-fn=\"$ctrl.reloadFn()\" ng-if=\"$ctrl.isCanView\"><span>{{ \'ACTIONS.FILL_IN_TEST_SURVEY\' | translate}}</span> <i class=\"material-icons\">play_circle_filled</i></a> <a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-course-type-online.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\"></course-type-tag><figure><a ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"( $ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#319DB5\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">event_note</i></span><span class=\"text\">{{ \'FIELD.VIEW_DEADLINE\' | translate}} : {{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li><li ng-if=\"$ctrl.courseData.dueDate !== \'\'\"><span class=\"li-title\"><i class=\"material-icons\">event_note</i></span><span class=\"text\">{{ \'FIELD.DUE_DATE\' | translate}} : {{$ctrl.courseData.dueDate}}</span></li></ul><a href=\"\" class=\"btn-play\" course-info-player=\"\" enrollment-id=\"$ctrl.courseData.enrollmentId\" reload-fn=\"$ctrl.reloadFn()\" ng-if=\"$ctrl.isCanView\"><span ng-if=\"$ctrl.courseData.courseType === 1\">{{ \'ACTIONS.PLAY_COURSE\' | translate}}</span> <i class=\"material-icons\">play_circle_filled</i></a> <a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div><div class=\"like\"><a class=\"fa fa-comments\" href=\"{{$ctrl.courseData.forumUrl}}\" target=\"_blank\" ng-if=\"$ctrl.courseData.forumUrl.length > 0\"></a> <a class=\"fa fa-heart\" href=\"javascript:void(0);\" ng-class=\"{\'on\': $ctrl.courseData.isFavorite > 0}\" set-favorite=\"\" course-id=\"$ctrl.courseData.courseId\" course-name=\"$ctrl.courseData.courseName\" course-type=\"$ctrl.courseData.courseType\" is-favorite=\"$ctrl.courseData.isFavorite\" reload=\"$ctrl.reloadFn()\"></a></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-course-type-survey.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\"></course-type-tag><figure><a ui-sref=\"learningPassport.testQuestionnaireCenter.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"($ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#856DA9\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.testQuestionnaireCenter.courseInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">event_note</i></span><span class=\"text\">{{ \'FIELD.FILL_IN_DEADLINE\' | translate}} : {{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li><li ng-if=\"$ctrl.courseData.dueDate !== \'\'\"><span class=\"li-title\"><i class=\"material-icons\">event_note</i></span><span class=\"text\">{{ \'FIELD.DUE_DATE\' | translate}} : {{$ctrl.courseData.dueDate}}</span></li></ul><a href=\"\" class=\"btn-play\" course-info-player=\"\" enrollment-id=\"$ctrl.courseData.enrollmentId\" reload-fn=\"$ctrl.reloadFn()\" ng-if=\"$ctrl.isCanView\"><span>{{ \'ACTIONS.FILL_IN_TEST_SURVEY\' | translate}}</span> <i class=\"material-icons\">play_circle_filled</i></a> <a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-evaluation-survey.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\"></course-type-tag><figure><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a class=\"not-link\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">event_note</i></span> <span class=\"text\">{{ \'FIELD.FILL_IN_END_DATE\' | translate}} : {{$ctrl.courseData.surveyEndDate | amUtc | amLocal | amDateFormat:\'YYYY-MM-DD\'}}</span></li></ul><a href=\"\" class=\"btn-play\" evaluation-survey-player=\"\" relationship-id=\"$ctrl.courseData.relationshipId\" survey-id=\"$ctrl.courseData.surveyId\" enrollment-id=\"$ctrl.courseData.enrollmentId\" reload-fn=\"$ctrl.reloadFn()\" ng-if=\"$ctrl.courseData.isEvSurveyFillIn===1\"><span>{{ \'ACTIONS.FILL_IN_TEST_SURVEY\' | translate}}</span> <i class=\"material-icons\">play_circle_filled</i></a> <a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title\">{{ \'FIELD.TRACKING_OBJECT\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.fullName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.TRACKING_DEPARTMENT\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.jointGroupName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.TRACKING_PERIOD\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.startDays}} {{ \'FIELD.DAYS\' |translate}}</span></li></ul></div></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-program-type-innercert.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\" is-program=\"$ctrl.courseData.courseType === 0\" program-type=\"$ctrl.courseData.programType\"></course-type-tag><figure><a ui-sref=\"learningPassport.incompleteCourses.certificationInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"($ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#E57373\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.incompleteCourses.certificationInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">schedule</i></span><span class=\"text\">{{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li></ul><a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div><div class=\"like\"><a class=\"fa fa-comments\" href=\"{{$ctrl.courseData.forumUrl}}\" target=\"_blank\" ng-if=\"$ctrl.courseData.forumUrl.length > 0\"></a> <a class=\"fa fa-heart\" href=\"javascript:void(0);\" ng-class=\"{\'on\': $ctrl.courseData.isFavorite > 0}\" set-favorite=\"\" course-id=\"$ctrl.courseData.courseId\" course-name=\"$ctrl.courseData.courseName\" course-type=\"0\" is-favorite=\"$ctrl.courseData.isFavorite\" reload=\"$ctrl.reloadFn()\"></a></div></div>");
$templateCache.put("app/modules/course-resource/views/single-info-template/incomplete-program-type-program.html","<div class=\"timeline-content\"><div class=\"md-contentList\"><course-type-tag course-type=\"$ctrl.courseData.courseType\" is-program=\"$ctrl.courseData.courseType === 0\" program-type=\"$ctrl.courseData.programType\"></course-type-tag><figure><a ui-sref=\"learningPassport.incompleteCourses.programInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"($ctrl.courseData.status === \'incompleted_status\' || $ctrl.courseData.status === \'status_not_available\' || $ctrl.courseData.status === \'sco_non_attempt\')\"><img ng-src=\"{{$ctrl.courseData.logoUrl}}\"></a> <img ng-if=\"$ctrl.courseData.status !== \'incompleted_status\' && $ctrl.courseData.status !== \'status_not_available\' && $ctrl.courseData.status !== \'sco_non_attempt\'\" ng-src=\"{{$ctrl.courseData.logoUrl}}\"></figure><div class=\"status\"><div class=\"circle\"><doughnut-gauge gauge-size=\"100\" gauge-options=\"$ctrl.doughnutOptions\" gauge-colors=\"[\'#856DA9\', \'#DDDDDD\']\" gauge-value=\"{{$ctrl.courseData.progress}}\" value-suffix=\"%\"></doughnut-gauge></div><span>{{ \'STATUS.\' + $ctrl.courseData.status | uppercase | translate}}</span></div><div class=\"pt-contentList\"><h6><ng-switch on=\"$ctrl.courseData.learnerType\"><span class=\"pick\" ng-switch-when=\"0\">{{ \'FIELD.COURSE_ELECTIVE\' | translate}}</span> <span class=\"surely\" ng-switch-when=\"1\">{{ \'FIELD.COURSE_REQUIRED\' | translate}}</span></ng-switch><span class=\"warning\" ng-if=\"$ctrl.courseData.isWillExpire === 1\"><i class=\"material-icons\">alarm</i>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}</span> <a ui-sref=\"learningPassport.incompleteCourses.programInfo({enrollmentId:$ctrl.courseData.enrollmentId})\" ng-if=\"$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a> <a href=\"javascript:void(0);\" ng-click=\"$ctrl.showStatus($ctrl.courseData.status)\" ng-if=\"!$ctrl.isCanView\">{{$ctrl.courseData.courseName}}</a></h6><ul class=\"left\"><li><span class=\"li-title\"><i class=\"material-icons\">schedule</i></span><span class=\"text\">{{$ctrl.courseData.expireStart}}~{{$ctrl.courseData.expireEnd}}</span></li></ul><a href=\"#\" class=\"btn-close\"><span>{{ \'FIELD.DETAILS\' | translate}}</span><i class=\"material-icons\">expand_more</i></a><ul class=\"detail\"><li><span class=\"li-title total\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_LEARNING\' | translate: {\'value\': $ctrl.courseData.learnCount} }}</span></li><li><span class=\"li-title complete\"><i class=\"material-icons\">group</i></span><span class=\"text\">{{ \'PLACEHOLDERS.N_PERSON_FINISH_COURSE\' | translate: {\'value\': $ctrl.courseData.completeCount} }}</span></li><li><span class=\"li-title\">{{ \'FIELD.SESSION\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.sessionName}}</span></li><li><span class=\"li-title\">{{ \'FIELD.ENROLL_TYPE\' | translate}} :</span><ng-switch on=\"$ctrl.courseData.enrollType\"><span class=\"text\" ng-switch-when=\"0\">{{ \'FIELD.SELFENROLLED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"1\">{{ \'FIELD.ASSIGNED\' | translate}}</span> <span class=\"text\" ng-switch-when=\"2\">{{ \'STATUS.UNENROLL\' | translate}}</span> <span class=\"text\" ng-switch-default=\"\">{{ \'STATUS.UNKNOW_STATUS\' | translate}}</span></ng-switch></li><li ng-if=\"$ctrl.courseData.isShowCredit === 1\"><span class=\"li-title\">{{ \'FIELD.CREDITS\' | translate}} :</span><span class=\"text\">{{$ctrl.courseData.credits}}</span></li></ul></div></div><div class=\"like\"><a class=\"fa fa-comments\" href=\"{{$ctrl.courseData.forumUrl}}\" target=\"_blank\" ng-if=\"$ctrl.courseData.forumUrl.length > 0\"></a> <a class=\"fa fa-heart\" href=\"javascript:void(0);\" ng-class=\"{\'on\': $ctrl.courseData.isFavorite > 0}\" set-favorite=\"\" course-id=\"$ctrl.courseData.courseId\" course-name=\"$ctrl.courseData.courseName\" course-type=\"0\" is-favorite=\"$ctrl.courseData.isFavorite\" reload=\"$ctrl.reloadFn()\"></a></div></div>");
$templateCache.put("app/modules/course-resource/views/test-questionnaire/evaluation-survey.html","<div class=\"play-main\"><div class=\"wp-play\"><header></header><test-questionnaire-start exam=\"$ctrl.exam\" start-fn=\"$ctrl.startExam()\" questionnaire-type=\"evaluationSurvey\" ng-if=\"$ctrl.pageView===\'start\'\"></test-questionnaire-start><test-questionnaire-form exam=\"$ctrl.exam\" relation-id=\"$ctrl.relationId\" survey-id=\"$ctrl.surveyId\" question-model=\"$ctrl.questionModel\" questionnaire-data=\"$ctrl.questionnaireData\" questions-pagination=\"$ctrl.questionsPagination\" page-view=\"$ctrl.pageView\" questionnaire-type=\"evaluationSurvey\" exam-result=\"$ctrl.examResult\" ng-if=\"$ctrl.pageView===\'form\'\"></test-questionnaire-form><test-questionnaire-status exam=\"$ctrl.exam\" exam-result=\"$ctrl.examResult\" ng-if=\"$ctrl.pageView===\'status\'\"></test-questionnaire-status></div></div>");
$templateCache.put("app/modules/course-resource/views/test-questionnaire/options-tpl.html","<ng-switch on=\"questionType\"><div class=\"exam-options\" ng-switch-when=\"1\"><md-radio-group ng-model=\"$parent.questionModel.optionNumber\"><div ng-repeat=\"option in questionOptions track by $index\" class=\"row\"><div layout=\"row\"><div flex=\"\" style=\"max-width:30px;\" ng-if=\"isAllowViewCorrectAns\"><i class=\"fa fa-check-circle\" ng-if=\"option.isRightOption === 1\"></i></div><div layout=\"row\"><div><md-radio-button flex=\"\" class=\"md-primary\" value=\"{{option.optionNumber}}\" ng-disabled=\"isOnlyReviewQuestion\"><span ng-bind-html=\"option.optionValue\"></span></md-radio-button></div><div><a ng-href=\"{{option.href}}\" target=\"_blank\" ng-if=\"option.hasImage===0 && option.href.length > 0\">&nbsp; &nbsp; ({{ \'FIELD.VIEW_FILES\' | translate}})</a></div></div></div><img ng-src=\"{{option.href}}\" ng-style=\"option.imgDisplayType==0 && {\'cursor\': \'default\'} || option.imgDisplayType==1 && {\'cursor\': \'default\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==2 && option.imgWidth != 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==2 && option.imgWidth == 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (option.imgDisplayType==2 && option.imgWidth != 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth} || (option.imgDisplayType==2 && option.imgWidth == 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':option.imgHeight} || (option.imgDisplayType==3 && option.imgWidth != 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==3 && option.imgWidth == 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (option.imgDisplayType==3 && option.imgWidth != 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth} || (option.imgDisplayType==3 && option.imgWidth == 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':option.imgHeight}\" style=\"display:block;margin-left: 20px;margin-bottom: 20px;\" ng-if=\"option.hasImage===1 && option.href.length > 0\" ng-click=\"(option.imgDisplayType==2 || option.imgDisplayType==3) && openImage(option.viewHref)\"></div></md-radio-group><md-input-container ng-if=\"questionOptions[questionOptions.length -1].optionType === 2\"><label>Other</label><input type=\"text\" ng-model=\"questionModel.optionOtherValue\" name=\"optionOtherValue\" required=\"\" aria-label=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-keyup=\"optionOtherValueOnKeyup($event)\" ng-blur=\"optionOtherValueOnBlur($event)\" ng-disabled=\"disabledOption($parent.questionModel.optionNumber, questionOptions[questionOptions.length-1].optionNumber, \'radio\')\" size=\"100\" ng-maxlength=\"50\" md-maxlength=\"50\"></md-input-container></div><div class=\"exam-options\" ng-switch-when=\"2\"><div ng-repeat=\"option in questionOptions track by $index\" class=\"row\"><div layout=\"row\"><div flex=\"\" style=\"max-width:30px;\" ng-if=\"isAllowViewCorrectAns\"><i class=\"fa fa-check-circle\" ng-if=\"option.isRightOption === 1\"></i></div><md-checkbox flex=\"\" class=\"md-primary\" ng-click=\"optionsToggle(option, \'checkbox\');\" ng-disabled=\"(isOnlyReviewQuestion || checkSelectCount(option))\" ng-checked=\"$parent.questionModel.optionNumber.indexOf(option.optionNumber) > -1\"><span ng-bind-html=\"option.optionValue\"></span> <a ng-href=\"{{option.href}}\" target=\"_blank\" ng-if=\"option.hasImage===0 && option.href.length > 0\">&nbsp; &nbsp; ({{ \'FIELD.VIEW_FILES\' | translate}})</a></md-checkbox></div><img ng-src=\"{{option.href}}\" ng-style=\"option.imgDisplayType==0 && {\'cursor\': \'default\'} || option.imgDisplayType==1 && {\'cursor\': \'default\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==2 && option.imgWidth != 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==2 && option.imgWidth == 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (option.imgDisplayType==2 && option.imgWidth != 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth} || (option.imgDisplayType==2 && option.imgWidth == 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':option.imgHeight} || (option.imgDisplayType==3 && option.imgWidth != 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==3 && option.imgWidth == 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (option.imgDisplayType==3 && option.imgWidth != 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth} || (option.imgDisplayType==3 && option.imgWidth == 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':option.imgHeight}\" style=\"display:block;margin-left: 20px;margin-bottom: 20px;\" ng-if=\"option.hasImage===1 && option.href.length > 0\" ng-click=\"(option.imgDisplayType==2 || option.imgDisplayType==3) && openImage(option.viewHref)\"></div><md-input-container ng-if=\"questionOptions[questionOptions.length -1].optionType === 2\"><label>Other</label><input type=\"text\" ng-model=\"questionModel.optionOtherValue\" name=\"optionOtherValue\" required=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-keyup=\"optionOtherValueOnKeyup($event)\" ng-blur=\"optionOtherValueOnBlur($event)\" ng-disabled=\"disabledOption($parent.questionModel.optionNumber, questionOptions[questionOptions.length-1].optionNumber, \'checkbox\')\" size=\"100\" ng-maxlength=\"50\" md-maxlength=\"50\"></md-input-container></div><div class=\"exam-options\" ng-switch-when=\"3\"><md-input-container class=\"md-block\" aria-label=\"\" ng-repeat=\"option in questionOptions track by $index\"><label></label> <textarea ng-model=\"$parent.questionModel.optionNumber\" ng-blur=\"blurFn()\" md-maxlength=\"1000\" rows=\"1\" md-select-on-focus=\"\" ng-disabled=\"isOnlyReviewQuestion\"></textarea></md-input-container></div><div class=\"col-md12 th-satisfied\" ng-if=\"questionType === 4 || questionType === 5\"><header ng-if=\"feedbackStyle === 3 && questionType === 4\"><span class=\"left\" ng-bind-html=\"questionOptions[questionOptions.length - 1].optionValue\"></span> <span class=\"right\" ng-bind-html=\"questionOptions[0].optionValue\"></span></header><header ng-if=\"feedbackStyle === 3 && questionType === 5\"><span class=\"left\" ng-bind-html=\"questionOptions[0].optionValue\"></span> <span class=\"right\" ng-bind-html=\"questionOptions[questionOptions.length - 1].optionValue\"></span></header><div class=\"rateit big ev-survey-rate\" data-value=\"2.5\" data-readonly=\"true\" ng-if=\"feedbackStyle === 3\" ng-class=\"{\'rate-margin-15\': (questionOptions.length > 4 && questionOptions.length <10), \'rate-margin-40\': (questionOptions.length < 5)}\"><ng-rate-it ng-model=\"$parent.questionModel.optionNumber\" max=\"questionOptions.length\" star-width=\"32\" star-height=\"32\" class=\"bigstar\" resetable=\"false\" step=\"1\" read-only=\"isOnlyReviewQuestion\"></ng-rate-it></div><div class=\"th-satisfied\" ng-if=\"feedbackStyle === 4\"><header><span class=\"left\">{{questionOptions[0].optionValue}}</span><span class=\"right\">{{questionOptions[questionOptions.length - 1].optionValue}}</span></header><div class=\"md-satisfied\" ng-if=\"questionOptions.length <= 10\" ng-init=\"(questionType===5 ? iconFaces: iconFaces.reverse());\"><div style=\"display:inline;\" ng-repeat=\"option in questionOptions track by $index\"><input type=\"radio\" id=\"raId-{{raId}}-questionId-{{questionId}}-{{option.optionNumber}}\" name=\"raId-{{raId}}-questionId-{{questionId}}\" ng-model=\"questionModel.optionNumber\" ng-value=\"option.optionNumber\"> <label class=\"satisfied ctms-icons icon-face-{{iconFaces[$index]}}\" for=\"raId-{{raId}}-questionId-{{questionId}}-{{option.optionNumber}}\"></label></div></div></div></div><div class=\"exam-options\" ng-switch-when=\"6\"><md-radio-group ng-model=\"$parent.questionModel.optionNumber\"><div ng-repeat=\"option in questionOptions track by $index\" class=\"row\"><div layout=\"row\"><div flex=\"\" style=\"max-width:30px;\" ng-if=\"isAllowViewCorrectAns\"><i class=\"fa fa-check-circle\" ng-if=\"option.isRightOption === 1\"></i></div><div layout=\"row\"><div><md-radio-button flex=\"\" class=\"md-primary\" value=\"{{option.optionNumber}}\" ng-disabled=\"isOnlyReviewQuestion\"><span ng-bind-html=\"option.optionValue\"></span></md-radio-button></div><div><a ng-href=\"{{option.href}}\" target=\"_blank\" ng-if=\"option.hasImage===0 && option.href.length > 0\">&nbsp; &nbsp; ({{ \'FIELD.VIEW_FILES\' | translate}})</a></div></div></div><img ng-src=\"{{option.href}}\" ng-style=\"option.imgDisplayType==0 && {\'cursor\': \'default\'} || option.imgDisplayType==1 && {\'cursor\': \'default\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==2 && option.imgWidth != 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==2 && option.imgWidth == 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (option.imgDisplayType==2 && option.imgWidth != 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth} || (option.imgDisplayType==2 && option.imgWidth == 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':option.imgHeight} || (option.imgDisplayType==3 && option.imgWidth != 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth, \'height\':option.imgHeight} || (option.imgDisplayType==3 && option.imgWidth == 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (option.imgDisplayType==3 && option.imgWidth != 0 && option.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':option.imgWidth} || (option.imgDisplayType==3 && option.imgWidth == 0 && option.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':option.imgHeight}\" style=\"display:block;margin-left: 20px;margin-bottom: 20px;\" ng-if=\"option.hasImage===1 && option.href.length > 0\" ng-click=\"(option.imgDisplayType==2 || option.imgDisplayType==3) && openImage(option.viewHref)\"></div></md-radio-group></div><div class=\"exam-options\" ng-switch-when=\"7\"><md-input-container md-no-float=\"\" class=\"md-block\" ng-repeat=\"option in questionOptions track by $index\"><input ng-model=\"$parent.questionModel.optionNumber\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-disabled=\"isOnlyReviewQuestion\" placeholder=\"{{ \'PLACEHOLDERS.QUESTION_FILLING\' | translate}}\"></md-input-container></div></ng-switch>");
$templateCache.put("app/modules/course-resource/views/test-questionnaire/test-questionnaire-component.html","<div class=\"play-main\"><div class=\"wp-play\"><header></header><div ng-if=\"$ctrl.loadView\" class=\"page-spinner-loader\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div><test-questionnaire-start exam=\"$ctrl.exam\" start-fn=\"$ctrl.startExam()\" button-disabled=\"$ctrl.buttonDisabled\" ng-if=\"$ctrl.pageView===\'start\'\"></test-questionnaire-start><test-questionnaire-form exam=\"$ctrl.exam\" session-id=\"$ctrl.sessionId\" item-id=\"$ctrl.itemId\" exam-history-id=\"$ctrl.examHistoryId\" question-model=\"$ctrl.questionModel\" questionnaire-data=\"$ctrl.questionnaireData\" questions-pagination=\"$ctrl.questionsPagination\" page-view=\"$ctrl.pageView\" exam-result=\"$ctrl.examResult\" ng-if=\"$ctrl.pageView===\'form\'\" button-disabled-fn=\"$ctrl.buttonDisabledFn()\"></test-questionnaire-form><test-questionnaire-status exam=\"$ctrl.exam\" exam-result=\"$ctrl.examResult\" ng-if=\"$ctrl.pageView===\'status\'\"></test-questionnaire-status><test-questionnaire-result session-id=\"$ctrl.sessionId\" exam=\"$ctrl.exam\" params=\"$ctrl.params\" exam-result=\"$ctrl.examResult\" test-again=\"$ctrl.testAgain()\" ng-if=\"$ctrl.pageView===\'result\'\"></test-questionnaire-result></div></div>");
$templateCache.put("app/modules/course-resource/views/test-questionnaire/test-questionnaire-form-component.html","<div class=\"th-test\"><header><h1>{{$ctrl.exam.name}}</h1></header><div class=\"md-test\"><header style=\"min-height: 30px;\"><div class=\"th-time\" ng-if=\"$ctrl.exam.isTimeLimit === 1\"><div class=\"clock\"><i class=\"material-icons\">alarm</i></div><p class=\"md-time\"><strong>{{ \'FIELD.TIME_LEFT\' | translate}}</strong> <span><timer countdown=\"$ctrl.timer\" max-time-unit=\"\'hour\'\" interval=\"1000\" finish-callback=\"$ctrl.timerFinished()\" ng-model=\"$ctrl.hourTime\">{{hhours}}:{{mminutes}}:{{sseconds}}</timer></span></p></div><timer ng-init=\"$ctrl.sessionTime={seconds: 0}\" max-time-unit=\"\'second\'\" interval=\"1000\" ng-model=\"$ctrl.sessionTime\" ng-hide=\"true\">{{sseconds}}</timer><md-button class=\"md-raised md-primary md-btn\" ng-click=\"$ctrl.selectQuestionPanel()\">{{ \'ACTIONS.SELECT_QUESTION_NUMBER\' | translate}}</md-button><div class=\"th-prompt\" ng-style=\"($ctrl.questionPanelSelected?\'\':{\'display\':\'none\'})\" ng-init=\"$ctrl.questionTitle = \'\'\"><header><span ng-bind-html=\"$ctrl.questionTitle\"></span></header><div class=\"md-prompt\"><div ng-repeat=\"questionsGroup in $ctrl.questions | groupBy: \'surveyGroupName\' track by $index\"><span ng-if=\"questionsGroup[0].surveyGroupId <= 4\">{{\"FIELD.\" + questionsGroup[0].surveyGroupName |uppercase | translate}}</span> <span ng-if=\"questionsGroup[0].surveyGroupId > 4\">{{questionsGroup[0].surveyGroupName}}</span><ul><li ng-repeat=\"(key, question) in questionsGroup\" ng-mouseleave=\"$ctrl.questionTitle =\'\'\" ng-mouseover=\"$ctrl.questionTitle = (key + 1) +\'.&nbsp;\' + question.subject\" ng-class=\"{\'must\':question.isRequired, \'already\': $ctrl.questionModel[question.questionId].completed}\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.paginationChanged({}, \'index\', question.index); $ctrl.questionPanelSelected = (!$ctrl.questionPanelSelected);\"><span ng-if=\"questionsGroup[0].surveyGroupName.length > 0\">{{key + 1}}</span> <span ng-if=\"questionsGroup[0].surveyGroupName.length === 0\">{{question.index}}</span></a></li></ul></div></div><footer><p><i class=\"material-icons\">lens</i>{{ \'FIELD.QUESTION_ANSWERED\' | translate}}</p><p><i class=\"material-icons\">panorama_fish_eye</i>{{ \'FIELD.QUESTION_NOT_ANSWERED\' | translate}}</p><p ng-if=\"$ctrl.exam.feedbackType === 1\"><span class=\"must\">*</span>{{ \'FIELD.QUESTION_REQUIRED\' | translate}}</p></footer></div></header><div class=\"pt-test\"><div class=\"row\"><form novalidate=\"\" ui-paginate=\"questionsGroup in $ctrl.questions | itemsPerPage:$ctrl.questionsPagination.perPage | groupBy: \'surveyGroupName\'\" current-page=\"$ctrl.questionCurrentPage\" pagination-id=\"question\"><div class=\"title\" ng-if=\"questionsGroup[0].surveyGroupName.length > 0\"><span ng-if=\"questionsGroup[0].surveyGroupId <= 4\">{{\"FIELD.\" + questionsGroup[0].surveyGroupName | uppercase | translate}}</span> <span ng-if=\"questionsGroup[0].surveyGroupId > 4\">{{questionsGroup[0].surveyGroupName}}</span></div><div class=\"col-md12\" ng-repeat=\"(key, question) in questionsGroup\" id=\"question-{{question.index}}\"><h6 ng-if=\"questionsGroup[0].surveyGroupName.length > 0\"><span class=\"must\" ng-if=\"question.isRequired === 1\">*</span> {{key + 1}}.<br><span ng-bind-html=\"question.subject\"></span> <a ng-href=\"{{question.href}}\" target=\"_blank\" ng-if=\"question.hasImage===0 && question.href.length > 0\">&nbsp; &nbsp; ({{ \'FIELD.VIEW_FILES\' | translate}})</a></h6><h6 ng-if=\"questionsGroup[0].surveyGroupName.length === 0\"><span class=\"must\" ng-if=\"question.isRequired === 1\">*</span> {{question.index}}.<br><span ng-bind-html=\"question.subject |replaceAll:\'\\n\':\'<br>\'\"></span> <a ng-href=\"{{question.href}}\" target=\"_blank\" ng-if=\"question.hasImage===0 && question.href.length > 0\">&nbsp; &nbsp; ({{ \'FIELD.VIEW_FILES\' | translate}})</a></h6><img ng-src=\"{{question.href}}\" alt=\"\" ng-style=\"question.imgDisplayType==0 && {\'cursor\': \'default\'} || question.imgDisplayType==1 && {\'cursor\': \'default\', \'width\':question.imgWidth, \'height\':question.imgHeight} || (question.imgDisplayType==2 && question.imgWidth != 0 && question.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':question.imgWidth, \'height\':question.imgHeight} || (question.imgDisplayType==2 && question.imgWidth == 0 && question.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (question.imgDisplayType==2 && question.imgWidth != 0 && question.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':question.imgWidth} || (question.imgDisplayType==2 && question.imgWidth == 0 && question.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':question.imgHeight} || (question.imgDisplayType==3 && question.imgWidth != 0 && question.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':question.imgWidth, \'height\':question.imgHeight} || (question.imgDisplayType==3 && question.imgWidth == 0 && question.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\'} || (question.imgDisplayType==3 && question.imgWidth != 0 && question.imgHeight == 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'width\':question.imgWidth} || (question.imgDisplayType==3 && question.imgWidth == 0 && question.imgHeight != 0) && {\'max-width\':\'500px\', \'max-height\':\'500px\', \'height\':question.imgHeight}\" style=\"display:block;margin-left: 20px;margin-bottom: 20px;\" ng-if=\"question.hasImage===1 && question.href.length > 0\" ng-click=\"(question.imgDisplayType==2 || question.imgDisplayType==3) && $ctrl.openImage(question.viewHref)\"><options-tpl ra-id=\"question.raId\" question-id=\"question.questionId\" question-type=\"question.questionType\" question-options=\"question.questionOptions\" feedback-style=\"$ctrl.exam.feedbackStyle\" feedback-type=\"$ctrl.exam.feedbackType\" student-response=\"question.studentResponse\" other-answer=\"question.otherAnswer\" select-option-type=\"question.selectOptionType\" selected-option-count=\"question.selectedOptionCount\" ng-model=\"$ctrl.questionModel[question.questionId]\" on-change=\"$ctrl.questionsChanged(question.questionId)\"></options-tpl><div ng-repeat=\"instructor in question.instructorQuestions\"><h5><span class=\"must break-line-text\" ng-if=\"question.isRequired === 1\">*</span> {{ instructor.subject }}</h5><options-tpl ra-id=\"instructor.raId\" question-id=\"instructor.questionId\" question-type=\"instructor.questionType\" question-options=\"instructor.questionOptions\" feedback-style=\"$ctrl.exam.feedbackStyle\" feedback-type=\"$ctrl.exam.feedbackType\" student-response=\"instructor.studentResponse\" other-answer=\"instructor.otherAnswer\" select-option-type=\"question.selectOptionType\" selected-option-count=\"question.selectedOptionCount\" ng-model=\"$ctrl.questionModel[question.questionId].instructor[instructor.raId]\" on-change=\"$ctrl.questionsChanged(instructor.questionId)\" ng-if=\"question.surveyGroupId === 2\"></options-tpl></div></div></form></div></div></div></div><footer id=\"end\"><div class=\"linkBox test-footer\"><script type=\"text/ng-template\" id=\"questionnaire.pagination.html\"><div layout=\"row\"> <div flex=\"40\" layout-align=\"start center\"> <div ng-if=\"1 < pages.length || !autoHide\"> <md-button class=\"md-primary md-button md-raised btn-wide right\" ng-if=\"directionLinks && (pagination.current !== 1)\" ng-click=\"setCurrent(pagination.current - 1)\"> <md-icon style=\"color:rgb(255,255,255)\">navigate_before</md-icon> {{ \'ACTIONS.PREVIOUS_PAGE\' | translate}} </md-button> </div> </div> <div flex=\"20\" layout=\"row\" layout-align=\"center center\"> <div ng-if=\"1 < pages.length || !autoHide\"> <span>{{pagination.current}}/{{pages.length}}</span> </div> <div ng-if=\"!(1 < pages.length || !autoHide)\"> <span>{{pagination.current}}/{{pages.length}}</span> </div> </div> <div flex=\"40\" layout=\"row\" layout-align=\"end center\"> <div ng-if=\"1 < pages.length || !autoHide\"> <md-button class=\"md-primary md-button md-raised btn-wide right\" ng-if=\"directionLinks && (pagination.current !== pagination.last)\" ng-click=\"setCurrent(pagination.current + 1)\"> {{ \'ACTIONS.NEXT_PAGE\' | translate}} <md-icon style=\"color:rgb(255,255,255)\">navigate_next</md-icon> </md-button> </div> <md-button class=\"md-raised md-primary md-raised btn\" ng-if=\"directionLinks && (pagination.current === pagination.last)\" ng-click=\"btnFinishFn()\" ng-disabled=\"buttonSubmmitDisabled\" > {{ \'ACTIONS.FINISH\' | translate}} </md-button> </div> </div></script><ui-pagination-controls on-page-change=\"$ctrl.paginationChanged(params, \'pagination\')\" pagination-id=\"question\" can-select-option=\"false\" template-url=\"questionnaire.pagination.html\" btn-finish-fn=\"$ctrl.finishedExam()\" max-size=\"$ctrl.questionsPagination.total\" ng-if=\"$ctrl.isPageFooter\" button-submmit-disabled=\"$ctrl.buttonSubmmitDisabled\"></ui-pagination-controls></div></footer>");
$templateCache.put("app/modules/course-resource/views/test-questionnaire/test-questionnaire-result-component.html","<div class=\"th-test\"><header><h1>{{$ctrl.exam.name}}</h1></header><div class=\"md-test\"><div class=\"row th-result\"><div class=\"col-sm-6\"><div class=\"md-result\" ng-class=\"{\'pass\': $ctrl.examResult.isPass > 0}\"><i class=\"fa\" ng-class=\"{\'fa-trophy\': $ctrl.examResult.isPass > 0, \'fa-coffee\':$ctrl.examResult.isPass === 0}\"></i><div class=\"pt-result\"><div class=\"result\"><h6 ng-if=\"$ctrl.examResult.isPass > 0 && $ctrl.examResult.waitGradeQue === 0 && $ctrl.examResult.isAllowViewScore===1\">{{ \'FIELD.SCORE_PASSING\' | translate}}</h6><h6 ng-if=\"$ctrl.examResult.isPass === 0 && $ctrl.examResult.waitGradeQue === 0 && $ctrl.examResult.isAllowViewScore===1\">{{ \'FIELD.SCORE_FAILED\' | translate}}</h6><p ng-if=\"$ctrl.examResult.isAllowViewScore===1\">{{ \'FIELD.SCORE\' | translate}} : <span ng-if=\"$ctrl.examResult.waitGradeQue > 0\">{{ \'FIELD.LECTURER_RATING_REQUIRED\' | translate}}</span> <strong ng-if=\"$ctrl.examResult.waitGradeQue === 0\">{{$ctrl.examResult.totalScore}}</strong></p><p><span ng-bind-html=\"\'PLACEHOLDERS.TOTAL_OF_QUESTIONS\' | translate: {\'value\': $ctrl.examResult.totalQuestion}\"></span>, <span ng-bind-html=\"\'PLACEHOLDERS.TOTAL_OF_GRADE_QUESTIONS\' | translate: {\'value\': $ctrl.examResult.scored}\"></span>, <span ng-bind-html=\"\'PLACEHOLDERS.TOTAL_OF_WRONG_QUESTIONS\' | translate: {\'value\': $ctrl.examResult.wrong}\"></span> <span ng-if=\"$ctrl.examResult.waitGradeQue > 0\">,</span> <span ng-if=\"$ctrl.examResult.waitGradeQue <= 0\">.</span> <span ng-if=\"$ctrl.examResult.waitGradeQue > 0\">{{ \'PLACEHOLDERS.MANUAL_GRADE_QUESTTIONS\' | translate}} {{$ctrl.examResult.waitGradeQue}}</span> <span ng-if=\"$ctrl.examResult.waitGradeQue > 0\">.</span></p></div></div></div></div><div class=\"col-sm-6\"><div class=\"pie\" style=\"width:100px; height:100px; margin:auto; text-align: center; text-align: -moz-center;\"><canvas id=\"pie\" class=\"chart chart-pie\" width=\"100\" height=\"100\" chart-options=\"$ctrl.examResultPieChartOptions\" chart-data=\"$ctrl.examResultPieChartData\" chart-labels=\"$ctrl.examResultPieChartLabels\"></canvas></div></div></div><md-button class=\"md-raised md-primary btn\" ng-click=\"$ctrl.testAgain()\" ng-if=\"($ctrl.exam.remNumForTest > 0 || $ctrl.exam.maximunForTest === -1) && $ctrl.isFunction===1\">{{ \'ACTIONS.RE_TEST_ONCE\' | translate}}</md-button><div class=\"th-tab\" ng-if=\"$ctrl.examResult.isAllowViewAns > 0\"><header><span ng-if=\"$ctrl.examResult.isValidAnnounce === 0\">{{ \'PLACEHOLDERS.THE_PAPER_WILL_BE_PUBLISHED\' | translate: {\'value\': $ctrl.examResult.announceDate} }}</span> <span ng-if=\"$ctrl.examResult.isValidAnnounce > 0\">{{ \'FIELD.VIEW_MY_ANSWERED\' | translate}} :</span><ul class=\"nav-tab\" ng-if=\"$ctrl.examResult.isValidAnnounce > 0\"><li ng-class=\"{\'active\': $ctrl.showInCorrect === 0}\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.getExamQuestionsReview($ctrl.params, 0)\">{{ \'FIELD.ALL\' | translate}}</a></li><li ng-class=\"{\'active\':$ctrl.showInCorrect === 1}\"><a href=\"javascript:void(0);\" ng-click=\"$ctrl.getExamQuestionsReview($ctrl.params, 1)\">{{ \'FIELD.WRONG_QUESTIONS\' | translate}}</a></li></ul></header><div class=\"tab-content\"><div class=\"pt-test\"><div class=\"row\"><div class=\"col-md12\" ng-repeat=\"examReviewQuestionsData in $ctrl.examReviewQuestionsDatas\" ng-class=\"{\'wrong\': examReviewQuestionsData.isCorrect === 0}\"><h6><span class=\"must\" ng-if=\"examReviewQuestionsData.isRequired === 1\">*</span> {{examReviewQuestionsData.index}}.<br><span ng-bind-html=\"examReviewQuestionsData.subject\"></span></h6><options-tpl ra-id=\"examReviewQuestionsData.raId\" question-id=\"examReviewQuestionsData.questionId\" question-type=\"examReviewQuestionsData.questionType\" question-options=\"examReviewQuestionsData.questionOptions\" feedback-style=\"$ctrl.exam.feedbackStyle\" feedback-type=\"$ctrl.exam.feedbackType\" student-response=\"examReviewQuestionsData.studentResponse\" other-answer=\"examReviewQuestionsData.otherAnswer\" ng-model=\"$ctrl.questionModel[examReviewQuestionsData.questionId]\" is-allow-view-score=\"(($ctrl.examResult.isAllowViewScore===1)?true:false)\" is-allow-view-correct-ans=\"(($ctrl.examResult.isAllowViewCorrectAns===1)?true:false)\" is-only-review-question=\"true\"></options-tpl><p class=\"answer\" ng-if=\"examReviewQuestionsData.questionType===3 && $ctrl.examResult.isAllowViewCorrectAns===1\"><span ng-bind=\"\'FIELD.REFERENCE_ANSWER\' | translate\"></span> <span>:</span><br><span ng-bind-html=\"examReviewQuestionsData.questionOptions[0].openEndValue\"></span><br></p><p class=\"answer\" ng-if=\"examReviewQuestionsData.questionType===7 && $ctrl.examResult.isAllowViewCorrectAns===1\"><span ng-bind=\"\'FIELD.CORRECT_ANSWER\' | translate\"></span> <span>:</span><br><span ng-bind-html=\"examReviewQuestionsData.questionOptions[0].openEndValue\"></span><br></p><p class=\"answer\" ng-if=\"$ctrl.examResult.isAllowViewCorrectAns===1\"><span ng-bind=\"\'FIELD.QUESTION_ANALYSIS\' | translate\"></span> <span>:</span><br><span ng-bind-html=\"examReviewQuestionsData.analyze\"></span><br></p><p class=\"fraction\" ng-if=\"$ctrl.examResult.isAllowViewScore===1\"><span ng-if=\"examReviewQuestionsData.questionType!==3\">{{examReviewQuestionsData.score}}{{ \'FIELD.POINT\' | translate}}</span> <span ng-if=\"examReviewQuestionsData.questionType===3\">{{ \'FIELD.NOT_YET_RATED\' | translate}}</span></p></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/course-resource/views/test-questionnaire/test-questionnaire-start-component.html","<div class=\"th-test\"><div class=\"complete\" ng-if=\"$ctrl.exam.isEnrollEffective === 0\"><i class=\"icon icons-food-17\"></i><p>{{ \'MESSAGE.MSG_YOU_DO_NOT_HAVE_PERMISSION_TO_VIEW_THIS_LEARNING_ACTIVITY\' | translate}}</p></div><div ng-if=\"$ctrl.exam.isEnrollEffective !== 0\"><header><h1>{{$ctrl.exam.name}}</h1><p>{{$ctrl.exam.description}}</p><p ng-if=\"$ctrl.questionnaireType===\'evaluationSurvey\'\">{{ \'FIELD.EVALUATION_STAFF\' | translate}} : {{$ctrl.exam.targetName}}</p></header><div class=\"th-caption\" ng-if=\"$ctrl.exam.feedbackType === 2\"><div class=\"left\"><ul class=\"md-caption\"><li><span class=\"li-title\">{{ \'FIELD.CAN_TEST_NUMBER_OF_TIMES\' | translate}}：</span> <span class=\"text\" ng-if=\"$ctrl.exam.maximunForTest > 0\">{{$ctrl.exam.maximunForTest}} {{ \'FIELD.NUMBER_OF_TIMES\' | translate}}</span> <span class=\"text\" ng-if=\"$ctrl.exam.maximunForTest === -1\">{{ \'FIELD.UNLIMITED\' | translate}}</span></li><li ng-if=\"$ctrl.exam.remNumForTest > 0\"><span class=\"li-title\">{{ \'FIELD.LAST_TEST_NUMBER_OF_TIMES\' | translate}}：</span> <span class=\"text\">{{$ctrl.exam.remNumForTest | number}} {{ \'FIELD.NUMBER_OF_TIMES\' | translate}}</span></li><li><span class=\"li-title\">{{ \'FIELD.EXAM_SCORE_ADOPTION\' | translate}}：</span> <span ng-if=\"$ctrl.exam.scoreType===1\" class=\"text\">{{ \'FIELD.SELECT_THE_HIGHEST_SCORE_ONCE\' | translate}}</span> <span ng-if=\"$ctrl.exam.scoreType===2\" class=\"text\">{{ \'FIELD.SELECT_THE_LATEST_ONE\' | translate}}</span></li></ul></div><div class=\"right\" ng-if=\"$ctrl.exam.isTimeLimit === 1\"><div class=\"th-time\"><div class=\"clock\"><i class=\"material-icons\">alarm</i></div><p class=\"md-time\">{{ \'FIELD.TEST_TIME\' | translate}} <span><timer autostart=\"false\" countdown=\"$ctrl.exam.limitMins * 60\" ng-model=\"$ctrl.time\">{{hhours}} :{{mminutes}} : {{sseconds}}</timer></span></p></div></div></div><div class=\"md-test\"><md-button class=\"md-raised md-primary btn\" ng-disabled=\"$ctrl.buttonDisabled\" ng-if=\"$ctrl.exam.feedbackType === 1\" ng-click=\"$ctrl.startFn()\">{{ \'ACTIONS.START_SURVEY\' | translate}}</md-button><md-button class=\"md-raised md-primary btn\" ng-disabled=\"$ctrl.buttonDisabled\" ng-if=\"$ctrl.exam.feedbackType === 2\" ng-click=\"$ctrl.startFn()\">{{ \'ACTIONS.START_TEST\' | translate}}</md-button></div></div></div><footer></footer>");
$templateCache.put("app/modules/course-resource/views/test-questionnaire/test-questionnaire-status-component.html","<div class=\"th-test\"><header><h1>{{$ctrl.exam.name}}</h1><p>{{$ctrl.exam.footer}}</p></header><div class=\"md-test\"><div class=\"complete\" ng-if=\"$ctrl.exam.canPlay === 0\"><i class=\"icon icons-food-17\"></i><p>{{ \'MESSAGE.MSG_ERROR_PLAY_BLOCKING\' | translate}}</p></div><div class=\"complete\" ng-if=\"($ctrl.exam.isNotAccessPeriod === 1 || $ctrl.exam.isNotValidReTest === 1) && ($ctrl.exam.canPlay !== 0)\"><i class=\"icon icons-food-17\"></i><p>{{ \'MESSAGE.MSG_CURRENTLY_NON_VIEWING_TIME\' | translate}} <span ng-if=\"$ctrl.exam.isNotValidReTest === 1\">，{{ \'MESSAGE.MSG_NEXT_TEST_DATETIME\' | translate}}：{{$ctrl.exam.reTestDate}}</span></p></div><div class=\"complete\" ng-if=\"($ctrl.exam.isNotAccessPeriod !== 1 && $ctrl.exam.isNotValidReTest !== 1) && ($ctrl.exam.isNotFitAttedDance === 1) && ($ctrl.exam.canPlay !== 0)\"><i class=\"icon icons-food-17\"></i><p>{{ \'MESSAGE.MSG_YOUR_ATTENDANCE_RATE_IS_TOO_LOW_TO_FILL_OUT\' | translate}}</p></div><div class=\"complete\" ng-if=\"($ctrl.exam.isNotAccessPeriod !== 1 && $ctrl.exam.isNotValidReTest !== 1) && ($ctrl.exam.isOverMaxViewTimes === 1 || $ctrl.examResult.isFeedbackAllowViewResult === 0) && ($ctrl.exam.isNotFitAttedDance === 0) && ($ctrl.exam.canPlay !== 0)\" ng-switch=\"$ctrl.exam.feedbackType\"><i class=\"icon icons-food-17\"></i><p ng-switch-when=\"1\">{{ \'MESSAGE.MSG_YOU_HAVE_COMPLETED_THIS_QUESTIONNAIRE\' | translate}}</p><p ng-switch-when=\"2\">{{ \'MESSAGE.MSG_YOU_HAVE_COMPLETED_THIS_TEST\' | translate}}</p></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/accumulation-block.html","<div permission=\"\" permission-only=\"[\'Modules.course.online\', \'Modules.course\']\"><div class=\"th-accumu\"><div class=\"row\"><div ui-sref=\"{{($ctrl.isManager)?\'.\':\'learningPassport.trainingRecords\'}}\" permission=\"\" permission-only=\"[\'Modules.course.online\']\" ng-class=\"{\'col-xs-12\': true, \'el-cursor\': (!$ctrl.isManager)}\"><total-block block-background=\"pt-blueG\" icon=\"icon-globe\" is-material-icon=\"false\" count=\"$ctrl.onlineCourseHours.hours\" block-title=\"FIELD.TOTAL_OF_ONLINE_COURSE_LEARNING_HOURS\"></total-block></div><div ui-sref=\"{{($ctrl.isManager)?\'.\':\'learningPassport.trainingRecords\'}}\" permission=\"\" permission-only=\"[\'Modules.course\']\" ng-class=\"{\'col-xs-12\': true, \'el-cursor\': (!$ctrl.isManager)}\"><total-block block-background=\"pt-blue\" icon=\"fa fa-trophy\" is-material-icon=\"false\" count=\"$ctrl.coursePassCount.num\" block-title=\"FIELD.CUMULATIVE_OF_PASSED_COURSES\"></total-block></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/certification-progress.html","<div><div class=\"th-trend\"><div flex=\"\" layout=\"row\" ng-class=\"{\'href\':(!$ctrl.isManager)}\" ui-sref=\"{{($ctrl.isManager)?\'.\':\'certZone.certRecordsSearch\'}}\"><span class=\"li-title li-title-override\"><i class=\"material-icons\">assignment_ind</i>{{\'FIELD.CERTIFICATE_LIST\' |translate}}</span><div class=\"li-legend\" ng-if=\"$ctrl.certProgress.certs.length !== 0\"><square-text permission=\"\" permission-only=\"[\'Modules.certification.inner\']\" class=\"m-l-30\" width=\"24\" height=\"24\" font-size=\"14\" text=\"FIELD.IN\" color=\"rgba(49, 157, 181, 0.7)\"></square-text><span permission=\"\" permission-only=\"[\'Modules.certification.inner\']\" class=\"value\">{{$ctrl.certProgress.innercertCount}}</span><square-text permission=\"\" permission-only=\"[\'Modules.certification.ext\']\" class=\"m-l-30\" width=\"24\" height=\"24\" font-size=\"14\" text=\"FIELD.OUT\"></square-text><span permission=\"\" permission-only=\"[\'Modules.certification.ext\']\" class=\"value\">{{$ctrl.certProgress.extcertCount}}</span></div></div><div class=\"md-content\" ng-if=\"$ctrl.certProgress.certs.length !== 0\"><div class=\"license\" flex=\"\" layout=\"row\" ng-repeat=\"cert in $ctrl.certProgress.certs\" ng-if=\"($ctrl.hasCertificationInnerPermission && cert.certType===1) || ($ctrl.hasCertificationExtPermission && cert.certType===2)\"><square-text ng-if=\"cert.certType===1\" text=\"FIELD.IN\" color=\"rgba(49, 157, 181, 0.7)\"></square-text><square-text ng-if=\"cert.certType===2\" text=\"FIELD.OUT\"></square-text><div flex=\"\" layout=\"column\"><span class=\"title\">{{cert.certName}}</span> <span ng-if=\"cert.progress===100 && cert.isForever===0\">{{\'FIELD.VALIDITY_PERIOD\' |translate}} : {{cert.validDate}}</span> <span ng-if=\"cert.progress===100 && cert.isForever===1\">{{\'FIELD.PERMANENT\' |translate}}</span><div ng-if=\"cert.progress!==100\" class=\"progress th-line m-t-5\" ng-class=\"{1:\'pt-blue\', 2:\'pt-orange\'}[cert.certType]\"><div class=\"progress-bar\" ng-style=\"{ \'width\' : cert.progress + \'%\'}\"><div class=\"progress-value li-progress-value\" ng-style=\"{\'color\': (cert.certType===1)?\'rgba(49, 157, 181, 0.7)\':\'#F08917\'}\">{{cert.progress}}%</div></div></div></div><div ng-if=\"cert.progress===100\" layout-align=\"center end\" class=\"m-r-10\"><i class=\"material-icons li-check\">done</i></div></div></div><div class=\"pt-noData\" ng-if=\"$ctrl.certProgress.certs.length === 0\"><i class=\"ctms-icons icon-sun\"></i><p>{{ \'FIELD.THERE_IS_NO_CERTIFICATE_DATA\' | translate}}</p></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/classroom-course-incomplete.html","<div permission=\"\" permission-only=\"[\'Modules.course.classroom\']\"><div class=\"th-item\"><header class=\"pt-blueG\"><h4>{{ \'FIELD.CLASS_ROOM_COURSE\' | translate}}/{{ \'FIELD.CLASS_ROOM_TEST\' | translate}}{{ \'FIELD.INCOMPLETE_ITEM\' | translate}}</h4></header><div class=\"md-content\" ng-scrollbars=\"\"><ul ng-if=\"$ctrl.inCompleteItems.length > 0\"><li ng-repeat=\"inCompleteItem in $ctrl.inCompleteItems\"><div class=\"pt-class\"><a ng-if=\"!$ctrl.isManager\" ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:inCompleteItem.enrollmentId})\">{{inCompleteItem.courseName}} - {{inCompleteItem.sessionName}}</a> <span ng-if=\"$ctrl.isManager\">{{inCompleteItem.courseName}} - {{inCompleteItem.sessionName}}</span></div><div class=\"pt-item\"><p><span ng-if=\"inCompleteItem.courseType!=3\"><i class=\"fa fa-pencil pt-green\" title=\"{{ \'FIELD.TEST\' | translate}}\"></i> <span ng-if=\"inCompleteItem.testProgress!==\'0\' && (!$ctrl.isManager)\"><a href=\"javascript:void(0)\" course-info-player=\"\" play-item-id=\"inCompleteItem.testItemId\" session-id=\"inCompleteItem.sessionId\" reload-fn=\"$ctrl.reloadFn()\">{{inCompleteItem.testProgress}}</a></span> <span ng-if=\"inCompleteItem.testProgress===\'0\' || $ctrl.isManager\">{{inCompleteItem.testProgress}}</span></span> <span ng-if=\"inCompleteItem.courseType==3\"></span></p><p><span ng-if=\"inCompleteItem.courseType!=3\"><i class=\"material-icons pt-yellow\" title=\"{{ \'FIELD.QUESTIONNAIRE\' | translate}}\">description</i> <span ng-if=\"inCompleteItem.surveyProgress!==\'0\' && (!$ctrl.isManager)\"><a href=\"javascript:void(0)\" course-info-player=\"\" play-item-id=\"inCompleteItem.surveyItemId\" session-id=\"inCompleteItem.sessionId\" reload-fn=\"$ctrl.reloadFn()\">{{inCompleteItem.surveyProgress}}</a></span> <span ng-if=\"inCompleteItem.surveyProgress===\'0\' || $ctrl.isManager\">{{inCompleteItem.surveyProgress}}</span></span> <span ng-if=\"inCompleteItem.courseType==3\"></span></p><p><i class=\"material-icons pt-purple\" title=\"{{ \'FIELD.REPORT\' | translate}}\">assessment</i> <span ng-if=\"inCompleteItem.reportProgress!==\'0\' && (!$ctrl.isManager)\"><a ui-sref=\"learningPassport.incompleteCourses.courseInfo({tabSelect:\'submitReport\', enrollmentId:inCompleteItem.enrollmentId})\">{{inCompleteItem.reportProgress}}</a></span> <span ng-if=\"inCompleteItem.reportProgress===\'0\' || $ctrl.isManager\">{{inCompleteItem.reportProgress}}</span></p></div></li></ul><div class=\"pt-noData\" ng-if=\"$ctrl.inCompleteItems.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/classroom-course-schedule.html","<div permission=\"\" permission-only=\"[\'Modules.course.classroom\']\" ui-sref=\"{{($ctrl.isManager)?\'.\':\'myCalendar\'}}\"><div class=\"th-timeTable\" ng-class=\"{0: \'noData\'}[$ctrl.calendar.length]\"><header class=\"pt-blue\"><div class=\"pt-day\"><ds-widget-clock show-digital=\"\" only-text=\"true\" digital-format=\"\'d\'\">></ds-widget-clock></div><div class=\"pt-month\"><p><ds-widget-clock show-digital=\"\" only-text=\"true\" digital-format=\"\'MMMM\'\">></ds-widget-clock><span>&bull;</span><ds-widget-clock show-digital=\"\" only-text=\"true\" digital-format=\"\'yyyy\'\">></ds-widget-clock></p><p><ds-widget-clock show-digital=\"\" only-text=\"true\" digital-format=\"\'EEEE\'\">></ds-widget-clock></p></div><div class=\"pt-clock\"><ds-widget-clock data-show-digital=\"\" only-text=\"true\"></ds-widget-clock></div></header><div class=\"md-content\" ng-if=\"$ctrl.calendar.length>0\" ng-scrollbars=\"\"><ul><li ng-repeat=\"calendar in $ctrl.calendar\"><div class=\"pt-time\"><span>{{calendar.startTime}}</span> <span>{{calendar.endTime}}</span></div><div class=\"pt-class\"><p class=\"location\"><i class=\"material-icons\">room</i>{{calendar.place}}</p><p>{{calendar.eventName}}</p></div></li></ul></div><div class=\"pt-noData\" ng-if=\"$ctrl.calendar.length===0\"><i class=\"icon icons-food-17\"></i><p>{{ \'FIELD.TODAY_IS_NOT_ANY_SCHEDULE\' |translate }}</p><p>Have a nice day!</p></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/distribution-map.html","<div permission=\"\" permission-only=\"[\'Modules.course\']\"><div class=\"pieChart\"><header><h5>{{ \'FIELD.DISTRIBUTION_MAP_OF_COURSES_IN_EACH_CATEGORY\' | translate}}</h5></header><c3chart bindto-id=\"pie-plot1-chart\" transition-duration=\"1000\" ng-if=\"$ctrl.distribution.length >0\"><chart-legend show-legend=\"false\"><chart-size chart-height=\"220\"><chart-colors color-function=\"$ctrl.colorOpacity\"><chart-column ng-repeat=\"distributionMap in $ctrl.distribution\" column-id=\"{{distributionMap.categoryName}}\" column-values=\"{{distributionMap.sum}}\" column-type=\"pie\"><chart-pie expand=\"true\"></chart-pie></chart-column></chart-colors></chart-size></chart-legend></c3chart><div class=\"pt-noData\" ng-if=\"$ctrl.distribution.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/learning-detail.html","<div ng-if=\"$ctrl.chartFinish\"><div class=\"th-team\"><span class=\"li-title li-title-override\"><i class=\"material-icons el-grey\">school</i>{{\'FIELD.LEARNING_DETAIL_OF_THE_YEAR\' |translate}}</span><hr><div class=\"md-content\"><highchart id=\"chart\" config=\"$ctrl.chartConfig\" ng-if=\"!$ctrl.isNoData\"></highchart><div class=\"pt-noData\" ng-if=\"$ctrl.isNoData\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.THERE_IS_NO_COURSE_DATA\' | translate}}</p></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/learning-resume.html","<div permission=\"\" permission-only=\"[\'Modules.course.online\',\'Modules.course.classroom\',\'Modules.course.external\']\"><div class=\"th-history\"><header class=\"pt-purple\"><h4>{{ \'FIELD.MY_LEARNING_RESUME\' | translate}}</h4><a ui-sref=\"learningPassport.trainingRecords\" class=\"more\" ng-if=\"!$ctrl.isManager\"><i class=\"material-icons\">more_horiz</i></a></header><div class=\"md-content\" ng-scrollbars=\"\"><ul ng-if=\"$ctrl.myLearningHistoryItems.length > 0\"><li class=\"pt-blueG\" ng-repeat=\"myLearningHistoryItem in $ctrl.myLearningHistoryItems\" ng-class=\"{1:\'pt-blueG\',2:\'pt-green\',3:\'pt-green\',4:\'pt-blueG\',5:\'pt-yellow\',6:\'pt-blueG\',7:\'pt-yellow\'}[myLearningHistoryItem.itemType]\"><i class=\"material-icons\" nf-if=\"myLearningHistoryItem.itemType === 1 || myLearningHistoryItem.itemType === 4\">school</i> <i class=\"fa fa-pencil\" aria-hidden=\"true\" ng-if=\"myLearningHistoryItem.itemType === 2 || myLearningHistoryItem.itemType === 3\"></i> <i class=\"icon-globe\" ng-if=\"myLearningHistoryItem.itemType === 6\"></i><div class=\"pt-time\">{{myLearningHistoryItem.dateTime}}</div><div class=\"pt-class\" ng-if=\"!$ctrl.isManager\"><a ng-if=\"myLearningHistoryItem.itemType === 1 || myLearningHistoryItem.itemType === 2 || myLearningHistoryItem.itemType === 3 || myLearningHistoryItem.itemType === 5\" ui-sref=\"learningPassport.incompleteCourses.courseInfo({enrollmentId:myLearningHistoryItem.enrollmentId, tabSelect: (myLearningHistoryItem.itemType===5) ? \'submitReport\' : null})\"><span ng-if=\"myLearningHistoryItem.itemType === 1\">{{ \'FIELD.LEARNING_COURSE\' | translate}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 2\">{{ \'FIELD.FILE_IN_QUESTIONNAIRE\' | translate}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 3\">{{ \'FIELD.FILE_IN_TEST\' | translate}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 5\">{{ \'FIELD.SUBMIT_REPORT\' | translate}}</span> -&nbsp;{{myLearningHistoryItem.itemTitle}}</a> <a ng-if=\"myLearningHistoryItem.itemType === 4\" ui-sref=\"knowledgeDocumentCatalog({cid:myLearningHistoryItem.resourceFolderId})\"><span>{{ \'FIELD.VIEW_DOCUMENT_CENTER\' | translate}}</span>-&nbsp;{{myLearningHistoryItem.itemTitle}}</a> <a ng-if=\"(myLearningHistoryItem.itemType === 6 || myLearningHistoryItem.itemType === 7) && myLearningHistoryItem.courseType === 1\" ui-sref=\"courseResourceCatalog.CourseInfo({cid: 0, courseId:myLearningHistoryItem.courseId, backState: \'courseResourceCatalog\'})\"><span ng-if=\"myLearningHistoryItem.itemType === 6\">{{ \'FIELD.ENROLLMENT_COURSE\' | translate}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 7\">{{ \'FIELD.CANCEL_COURSE\' | translate}}</span> -&nbsp;{{myLearningHistoryItem.itemTitle}}</a> <a ng-if=\"(myLearningHistoryItem.itemType === 6 || myLearningHistoryItem.itemType === 7) && myLearningHistoryItem.courseType === 2\" ui-sref=\"courseResourceCatalog.ProgramInfo({cid: 0, programId:myLearningHistoryItem.courseId, backState: \'courseResourceCatalog\'})\"><span ng-if=\"myLearningHistoryItem.itemType === 6\">{{ \'FIELD.ENROLLMENT_COURSE\' | translate}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 7\">{{ \'FIELD.CANCEL_COURSE\' | translate}}</span> -&nbsp;{{myLearningHistoryItem.itemTitle}}</a></div><div class=\"pt-class\" ng-if=\"$ctrl.isManager\"><span ng-if=\"myLearningHistoryItem.itemType === 1\">{{ \'FIELD.LEARNING_COURSE\' | translate}}-&nbsp;{{myLearningHistoryItem.itemTitle}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 2\">{{ \'FIELD.FILE_IN_QUESTIONNAIRE\' | translate}}-&nbsp;{{myLearningHistoryItem.itemTitle}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 3\">{{ \'FIELD.FILE_IN_TEST\' | translate}}-&nbsp;{{myLearningHistoryItem.itemTitle}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 4\">{{ \'FIELD.VIEW_DOCUMENT_CENTER\' | translate}}-&nbsp;{{myLearningHistoryItem.itemTitle}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 5\">{{ \'FIELD.SUBMIT_REPORT\' | translate}}-&nbsp;{{myLearningHistoryItem.itemTitle}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 6\">{{ \'FIELD.ENROLLMENT_COURSE\' | translate}}-&nbsp;{{myLearningHistoryItem.itemTitle}}</span> <span ng-if=\"myLearningHistoryItem.itemType === 7\">{{ \'FIELD.CANCEL_COURSE\' | translate}}-&nbsp;{{myLearningHistoryItem.itemTitle}}</span></div></li></ul><div class=\"pt-noData\" ng-if=\"$ctrl.myLearningHistoryItems.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/online-course-curve.html","<div permission=\"\" permission-only=\"[\'Modules.course.online\']\" ng-if=\"$ctrl.chartFinish\"><div class=\"Graph\"><header><h5>{{ \'FIELD.ONLINE_COURSE_LEARNING_TIME_CURVE\' | translate}}({{ \'FIELD.SIX_MONTH\' | translate}})</h5></header><div class=\"md-content\"><highchart id=\"chart1\" config=\"$ctrl.lineChartConfig\" ng-if=\"$ctrl.learningGraphDatas.length > 0\"></highchart><div class=\"pt-noData\" ng-if=\"$ctrl.learningGraphDatas.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/platform-latest-news.html","<div><div class=\"th-trend\"><header class=\"pt-blue\"><h4>{{ \'FIELD.PERFORM_LATEST_NEWS\' | translate}}</h4></header><div class=\"md-content\" ng-scrollbars=\"\"><ul ng-if=\"$ctrl.platformNews.length > 0\"><li ng-repeat=\"platformNews in $ctrl.platformNews\"><div class=\"el-person\"><avatar avatar-url=\"::platformNews.avatarUrl\" first-name=\"::platformNews.firstName\"></avatar><span>{{platformNews.userName}}</span><ng-switch on=\"platformNews.type\"><p ng-switch-when=\"1\">{{ \'FIELD.LOGIN_PLATFORM\' | translate}}</p><p ng-switch-when=\"2\">{{ \'FIELD.LEARNING_COURSE\' | translate}}</p><p ng-switch-when=\"3\">{{ \'FIELD.FILE_IN_ONLINE_TEST\' | translate}}</p><p ng-switch-when=\"4\">{{ \'FIELD.FILE_IN_ONLINE_QUESTIONNAIRE\' | translate}}</p><p ng-switch-when=\"5\">{{ \'FIELD.VIEW_DOCUMENT_CENTER\' | translate}}</p><p ng-switch-when=\"6\">{{ \'FIELD.FORUM_PUBLISHED_ARTICLE\' | translate}}</p><p ng-switch-when=\"7\">{{ \'FIELD.ENROLLMENT_COURSE\' | translate}}</p></ng-switch></div><div class=\"pt-time\">{{platformNews.actionDate}}</div></li></ul><div class=\"pt-noData\" ng-if=\"$ctrl.platformNews.length === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/total-block.html","<div class=\"md-accumu\" ng-class=\"$ctrl.blockBackground\"><i ng-class=\"($ctrl.isMaterialIcon)?\'material-icons\':$ctrl.icon\">{{($ctrl.isMaterialIcon)?$ctrl.icon:\'\'}}</i><div class=\"el-value\"><p ng-bind-html=\"$ctrl.count |costFormat\"></p></div><div class=\"word\" ng-bind-html=\"$ctrl.blockTitle | translate\"></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/training-road-map-progress.html","<div permission=\"\" permission-only=\"[\'Modules.training_roadmap\']\"><div class=\"th-licenses\" ng-class=\"{0: \'noData\'}[$ctrl.roadmapProgress.length]\"><header class=\"pt-purple\"><i class=\"icon icons-faces-users-03\" ng-if=\"$ctrl.roadmapProgress.length===0\"></i><h4>{{ \'FIELD.TRAINING_BLUEPRINT_PROGRESS\' | translate}}</h4><a href=\"javascript:void(0);\" class=\"more\" ng-if=\"$ctrl.roadmapProgress.length>0 && (!$ctrl.isManager) && (!$ctrl.trainingRoadButtonClose)\" ui-sref=\"learningPassport.trainingRoadMap\"><i class=\"material-icons\">more_horiz</i></a></header><div class=\"md-content\" ng-if=\"$ctrl.roadmapProgress.length>0\" ng-scrollbars=\"\"><ul><li ng-repeat=\"roadmapProgress in $ctrl.roadmapProgress\" ng-class=\"{0:\'pt-blue\', 1:\'pt-orange\', 2:\'pt-purple\'}[$index%3]\"><i class=\"icon icons-faces-users-03\"></i><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"auto\"><div class=\"pt-class\">{{roadmapProgress.roadMapName}}</div></div><div flex=\"20\"></div></div><div class=\"progress\"><div class=\"progress-bar\" ng-style=\"{ \'width\' : (roadmapProgress.progressRate.slice(0,-1) |numberFormat:\'floor\') + \'%\'}\"><div class=\"progress-value\">{{roadmapProgress.progressRate.slice(0,-1) |numberFormat:\'floor\'}} %</div></div></div></li></ul></div><div class=\"pt-noData\" ng-if=\"$ctrl.roadmapProgress.length===0\"><i class=\"ctms-icons icon-sun\"></i><p>{{ \'FIELD.THERE_IS_NO_ROADMAP_DATA\' | translate}}</p></div></div></div>");
$templateCache.put("app/modules/dashboard/views/learning/year-accumulated-training-costs.html","<div permission=\"\" permission-only=\"[\'Modules.course\']\"><div class=\"pieChart\"><span class=\"li-title li-title-override\"><i class=\"material-icons el-grey\">attach_money</i>{{\'FIELD.CUMULATIVE_TRAINING_COSTS_FOR_THE_YEAR\' |translate}} : <b ng-bind-html=\"($ctrl.distributionMaps.sumCost.toString() |costFormat)\"></b><b>{{\'FIELD.DOLLARS\' |translate}}</b></span><hr><c3chart bindto-id=\"year-accumulated-training-costs\" transition-duration=\"1000\" ng-if=\"$ctrl.pies.length >0 && $ctrl.distributionMaps.sumCost !== 0\"><chart-legend show-legend=\"false\"><chart-size chart-height=\"220\"><chart-colors color-function=\"$ctrl.colorOpacity\"><chart-column ng-repeat=\"pie in $ctrl.pies\" column-id=\"{{pie.categoryName}}\" column-values=\"{{pie.sum}}\" column-type=\"pie\"><chart-pie expand=\"true\"></chart-pie></chart-column></chart-colors></chart-size></chart-legend></c3chart><div class=\"pt-noData\" ng-if=\"$ctrl.distributionMaps.sumCost === 0\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.THERE_IS_NO_COST_DATA\' | translate}}</p></div></div></div>");
$templateCache.put("app/modules/dashboard/views/manager/average-training-cost-dialog.html","<md-dialog flex=\"80\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{$ctrl.groupName }}-{{ \'FIELD.CUMULATIVE_TRAINING_COSTS_OF_DEPARTMENT_GROUPS\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><div layout=\"row\" layout-padding=\"5\"><div class=\"th-arc th-cost th-arc-override\" flex=\"15\"><div class=\"top\"><i class=\"fa fa-dollar\"></i></div><div class=\"md-arc\"><div class=\"pt-arc\"></div></div></div><div flex=\"\"><ul class=\"avg-ul\"><li class=\"company\">{{\'FIELD.CUMULATIVE_TRAINING_COSTS\' |translate}}-{{\'FIELD.COMPANY\' | translate}} <span class=\"count\">{{$ctrl.groupTrainingCost.companyTotalCost |number}} {{\'FIELD.DOLLARS\' |translate}}</span></li><li class=\"department\"><span ng-show=\"$ctrl.isShowGroupUserTrainingCostDetail\">{{\'FIELD.CUMULATIVE_TRAINING_COSTS\' |translate}}-{{\'FIELD.IN_EACH_DEPARTMENT\' |translate}}</span> <span ng-show=\"!$ctrl.isShowGroupUserTrainingCostDetail\">{{\'FIELD.CUMULATIVE_TRAINING_COSTS\' |translate}}-{{\'FIELD.DEPARTMENT_MEMBERS\' |translate}}</span> <span class=\"count\">{{$ctrl.groupTrainingCost.groupTotalCost |number}}<span class=\"unit\">{{\'FIELD.DOLLARS\' |translate}}</span></span></li></ul></div></div><div class=\"th-board\"><div class=\"col-xs-12\"><div class=\"th-team height-auto\"><header class=\"m-b-10\"><h5 ng-show=\"$ctrl.isShowGroupUserTrainingCostDetail\">{{$ctrl.groupName }}-{{\'FIELD.CUMULATIVE_TRAINING_COSTS_IN_EACH_DEPARTMENT\' | translate}}</h5><h5 ng-show=\"!$ctrl.isShowGroupUserTrainingCostDetail\">{{$ctrl.groupName }}{{\'FIELD.EMPLOYEE_CUMULATIVE_TRAINING_COSTS\' |translate}}</h5><span class=\"pt-mark pt-mark-override\" ng-show=\"$ctrl.isShowGroupUserTrainingCostDetail\">{{\'FIELD.CLICK_THE_PATH_AND_EXPAND_THE_DATA\' |translate}}</span></header><div><drill-bar-chart chart-id=\"groupTrainingCost\" drill-fn=\"$ctrl.drillFn(id)\" drill-id=\"$ctrl.drillId\" colors=\"$ctrl.chartColors\" stack-labels-format=\"{total:,.0f}\" y-axis-text=\"\'FIELD.DOLLARS_NT\' |translate\"></drill-bar-chart></div></div></div></div><div class=\"th-board\" ng-show=\"$ctrl.isShowGroupUserTrainingCostDetail\"><div class=\"col-xs-12\"><div class=\"th-team height-auto\"><header><h5>{{$ctrl.groupName }}{{\'FIELD.EMPLOYEE_CUMULATIVE_TRAINING_COSTS\' |translate}}</h5></header><div><drill-bar-chart chart-id=\"groupUserTrainingCost\" drill-id=\"$ctrl.drillId\" params=\"$ctrl.groupUserTrainingCostParams\" is-watch=\"true\" colors=\"$ctrl.chartColors\" stack-labels-format=\"{total:,.0f}\" y-axis-text=\"\'FIELD.DOLLARS_NT\' |translate\"></drill-bar-chart></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/dashboard/views/manager/average-training-hours-dialog.html","<md-dialog flex=\"80\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{$ctrl.groupName }}-{{ \'FIELD.DEPARTMENT\' | translate}}{{ \'FIELD.AVERAGE_TRAINING_HOURS\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout-padding=\"\"><div layout=\"row\" layout-padding=\"5\"><div class=\"th-arc th-arc-override\" flex=\"15\"><div class=\"top\"><i class=\"material-icons\">school</i></div><div class=\"md-arc\"><div class=\"pt-arc\"></div></div></div><div flex=\"\"><ul class=\"avg-ul\"><li class=\"company\">{{\'FIELD.AVERAGE_TRAINING_HOURS\' | translate}}-{{\'FIELD.COMPANY\' | translate}} <span class=\"count\">{{$ctrl.groupTrainingHours.allAvgHours}} hr</span></li><li class=\"department\"><span ng-show=\"$ctrl.isShowGroupUserTrainingHoursDetail\">{{\'FIELD.AVERAGE_TRAINING_HOURS\' |translate}}-{{\'FIELD.IN_EACH_DEPARTMENT\' |translate}}</span> <span ng-show=\"!$ctrl.isShowGroupUserTrainingHoursDetail\">{{\'FIELD.AVERAGE_TRAINING_HOURS\' |translate}}-{{\'FIELD.DEPARTMENT_MEMBERS\' |translate}}</span> <span class=\"count\">{{$ctrl.groupTrainingHours.groupAvgHours}}<span class=\"unit\">hr</span></span></li></ul></div></div><div class=\"th-board\"><div class=\"col-xs-12\"><div class=\"th-team height-auto\"><header class=\"m-b-10\"><h5 ng-show=\"$ctrl.isShowGroupUserTrainingHoursDetail\">{{$ctrl.groupName }}-{{\'FIELD.AVERAGE_TRAINING_HOURS_IN_EACH_DEPARTMENT\' | translate}}</h5><h5 ng-show=\"!$ctrl.isShowGroupUserTrainingHoursDetail\">{{$ctrl.groupName }}{{\'FIELD.EMPLOYEE_TRAINING_HOURS\' |translate}}</h5><span class=\"pt-mark pt-mark-override\" ng-show=\"$ctrl.isShowGroupUserTrainingHoursDetail\">{{\'FIELD.CLICK_THE_PATH_AND_EXPAND_THE_DATA\' |translate}}</span></header><div><drill-bar-chart chart-id=\"groupTrainingHours\" drill-fn=\"$ctrl.drillFn(id)\" drill-id=\"$ctrl.drillId\" colors=\"$ctrl.chartColors\" stack-labels-format=\"{total} hr\" y-axis-text=\"\'(\'+(\'FIELD.HOURS\' |translate)+\')\'\"></drill-bar-chart></div></div></div></div><div class=\"th-board\" ng-show=\"$ctrl.isShowGroupUserTrainingHoursDetail\"><div class=\"col-xs-12\"><div class=\"th-team height-auto\"><header><h5>{{$ctrl.groupName }}{{\'FIELD.HOURS\' |translate}}</h5></header><div><drill-bar-chart chart-id=\"groupUserTrainingHours\" drill-id=\"$ctrl.drillId\" params=\"$ctrl.groupUserTrainingHoursParams\" is-watch=\"true\" colors=\"$ctrl.chartColors\" stack-labels-format=\"{total} hr\" y-axis-text=\"\'FIELD.HOURS\' |translate\"></drill-bar-chart></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/dashboard/views/manager/average-training-hours.html","<div class=\"href\"><div class=\"th-team\"><header><h5><span>{{ \'FIELD.DEPARTMENT_MEMBERS_FOR_THE_YEAR\' | translate}}</span> <strong>{{ \'FIELD.AVERAGE_TRAINING_HOURS\' | translate}}</strong></h5></header><div class=\"md-content\"><div class=\"th-arc\"><div class=\"top\"><i class=\"material-icons\">school</i><p><span>{{$ctrl.groupTrainingHours.groupAvgHours}}</span>hr</p></div><div class=\"md-arc\"><div class=\"pt-arc\"></div></div><p class=\"average\">{{ \'FIELD.COMPANY_AVERAGE\' | translate}}:<span>{{$ctrl.groupTrainingHours.allAvgHours}}</span>{{ \'FIELD.HOUR\' | translate}}</p></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/manager/cumulative-training-costs.html","<div><div class=\"th-team\"><header><h5><span>{{ \'FIELD.DEPARTMENT_MEMBERS_FOR_THE_YEAR\' | translate}}</span> <strong>{{ \'FIELD.CUMULATIVE_TRAINING_COSTS\' | translate}}</strong></h5></header><div class=\"md-content\"><div class=\"th-arc th-cost\"><div class=\"top\"><i class=\"fa fa-dollar\"></i><p><span ng-bind-html=\"$ctrl.groupCost.groupTotalCost.toString() |costFormat\"></span></p></div><div class=\"md-arc\"><div class=\"pt-arc\"></div></div><p class=\"average\">{{ \'FIELD.COMPANY_TOTAL_COSTS\' | translate}}:<span>{{$ctrl.groupCost.companyTotalCost |number}}</span></p></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/manager/drill-bar-chart.html","<div ng-if=\"$ctrl.isNoData===0\"><highchart id=\"{{$ctrl.chartId}}\" config=\"$ctrl.chartConfig\"></highchart></div>");
$templateCache.put("app/modules/dashboard/views/manager/group-incompleted-course.html","<div><div class=\"th-team height-auto\"><header class=\"pt-blue\"><h4>{{\'FIELD.LIST_OF_UNEXPIRED_COURSE_TO_BE_EXPIRED\' |translate}}</h4></header><div class=\"content\"><div class=\"th-tab p-20 p-t-0\"><table class=\"BoxTable\"><thead><tr><th class=\"appear\">{{ \'FIELD.COURSE\' | translate}}</th><th>{{ \'FIELD.SESSION\' | translate}}</th><th>{{ \'FIELD.IS_WILL_EXPIRE\' | translate}}{{ \'FIELD.DATE\' | translate}}</th><th class=\"appear\">{{ \'FIELD.FULL_NAME\' | translate}}</th><th>{{ \'FIELD.EMPLOYEE_NUMBER\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"groupIncompletedCourse in $ctrl.groupIncompletedCourse | limitTo: $ctrl.incompletedCourseCount\"><td class=\"appear\" data-th=\"\'FIELD.COURSE\' | translate\"><div class=\"pt-title\">{{groupIncompletedCourse.courseName}}</div></td><td><div class=\"pt-title\">{{groupIncompletedCourse.sessionName}}</div></td><td><div class=\"text\">{{groupIncompletedCourse.expireEnd}}</div></td><td class=\"appear\" data-th=\"\'FIELD.FULL_NAME\' | translate\"><div class=\"text\">{{groupIncompletedCourse.userName}}</div></td><td><div class=\"text\">{{groupIncompletedCourse.EmployeeNumber}}</div></td></tr></tbody></table><footer class=\"text-center m-t-20\" ng-if=\"$ctrl.groupIncompletedCourse.length > 7\"><a href=\"javascript:void(0)\" class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.incompletedCourseMore($ctrl.isMore)\"><span ng-if=\"$ctrl.isMore===1\">{{ \'ACTIONS.EXPAND_MORE\' | translate}}</span> <span ng-if=\"$ctrl.isMore===0\">{{ \'ACTIONS.COLLAPSE_MORE\' | translate}}</span> <i class=\"mdi-hardware-keyboard-arrow-right\"></i></a></footer></div></div></div></div>");
$templateCache.put("app/modules/dashboard/views/manager/group-user-info.html","<div><div class=\"th-team subordinate\"><header class=\"pt-purple\"><h4>{{ \'FIELD.DEPARTMENT_MEMBERS\' | translate}}</h4></header><div class=\"md-content\"><ul><li ng-repeat=\"groupUserInfo in $ctrl.groupUserInfo\"><avatar avatar-url=\"::groupUserInfo.avatarUrl\" first-name=\"::groupUserInfo.firstName\" ng-click=\"$ctrl.learningDashboardDialog($event, groupUserInfo)\"></avatar><div class=\"md-team\"><div class=\"pt-title\"><h6 ng-click=\"$ctrl.learningDashboardDialog($event, groupUserInfo)\">{{groupUserInfo.fullName}}</h6></div><div class=\"pt-team\"><p><i class=\"icon-graduation cir-grey\" title=\"{{\'FIELD.NUMBER_OF_COURSES_DUE_WITHIN_THIS_WEEK\' |translate}}\"></i><span>{{groupUserInfo.courseWillExpireCount}}</span>{{\'FIELD.WILL_BE_EXPIRED_COURSES\' |translate}}</p><p><i class=\"fa fa-dollar cir-grey\" title=\"{{\'FIELD.CUMULATIVE_TRAINING_COSTS_FOR_THE_YEAR\' |translate}}\"></i> <span>NT${{groupUserInfo.annualCost |number}}</span></p><p ng-if=\"groupUserInfo.isInstructor===1\" lecturer-info-dialog=\"\" lecturer-id=\"groupUserInfo.instructorId\" class=\"href\"><i class=\"fa fa-microphone cir-red-override\" title=\"{{\'FIELD.INSTRUCTOR\' |translate}}\"></i> <span ng-if=\"groupUserInfo.instructorScore>0\">{{groupUserInfo.instructorScore |number:2}}</span> <span ng-if=\"groupUserInfo.instructorScore<=0\">-</span></p></div></div></li></ul></div></div></div>");
$templateCache.put("app/modules/dashboard/views/manager/lecturer-info-dialog.html","<md-dialog flex=\"50\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{$ctrl.instructorInfo.instructorName}} {{ \'FIELD.LECTURER_TEACHING_DATA\' | translate}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-set=\"md\" aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-content-padding\"><section id=\"timeline\" class=\"th-contentList\"><div layout=\"row\" class=\"icon-header\"><i class=\"fa fa-microphone mic\"></i><div flex=\"\" flex-offset=\"5\"><ul class=\"avg-ul\"><li>{{\'FIELD.LECTURER_TEACHING_SATISFACTION\' | translate}} : <span ng-if=\"$ctrl.learnerTotlaScore<=0\">-</span> <span class=\"count\" ng-if=\"$ctrl.learnerTotlaScore>0\">{{$ctrl.learnerTotlaScore |number:2}}</span></li><li class=\"department\" permission=\"\" permission-only=\"[\'Modules.course.classroom\']\">{{\'FIELD.CLASS_ROOM_COURSE\' | translate}}{{\'FIELD.CUMULATIVE_TEACHING_HOURS\' | translate}} <span ng-if=\"$ctrl.classroomTotalHour<=0\">N/A</span> <span class=\"count\" ng-if=\"$ctrl.classroomTotalHour>0\">{{($ctrl.classroomTotalHour/60).toFixed(1) |replaceAll:\'\\\\.?0+$\':\'\'}}<span class=\"unit\">hrs</span></span></li></ul></div></div><div class=\"th-board row\"><div class=\"col-xs-12\"><div class=\"th-team height-auto\"><header layout=\"row\"><h5>{{\'FIELD.LECTURER_TEACHING_INFORMATION\' | translate}}</h5><span flex=\"\" class=\"header-span\" layout=\"row\" layout-align=\"end center\" layout-padding=\"\">{{\'FIELD.NUMBER_OF_TEACHING_SESSIONS\' |translate}}: {{$ctrl.teachingTimes}}</span></header><div class=\"time-line\"><ul><li class=\"pt-blueG\" ui-paginate=\"lecturer in $ctrl.lecturerInfo | itemsPerPage:$ctrl.lecturerPagination.perPage\" total-items=\"$ctrl.lecturerPagination.total\" current-page=\"$ctrl.lecturerPagination.currentPage\" pagination-id=\"lecturer\"><i class=\"dot\"></i><div class=\"time-text\" layout=\"row\"><span>{{lecturer.publishedDate}}&nbsp;&nbsp;&nbsp;&nbsp;{{\'FIELD.SESSION\' |translate}}:{{lecturer.sessionName}}</span></div><div class=\"time-text\" layout=\"row\"><a flex=\"70\" href=\"javascript:void(0);\" ng-click=\"$ctrl.close()\" ui-sref=\"courseResourceCatalog.CourseInfo({cid: 0, courseId:lecturer.courseId})\">{{lecturer.courseName}}</a><div flex=\"25\" layout=\"row\" layout-align=\"end start\"><i class=\"material-icons\">star_rate</i> <span class=\"unit\" ng-if=\"lecturer.learnerScore<=0\">-</span> <span class=\"unit\" ng-if=\"lecturer.learnerScore>0\">{{lecturer.learnerScore.toFixed(2) |replaceAll:\'\\\\.?0+$\':\'\'}}</span> <i class=\"material-icons m-l-20\">schedule</i> <span class=\"unit\" ng-if=\"lecturer.teachingHour<=0\">N/A</span> <span class=\"unit\" ng-if=\"lecturer.teachingHour>0\">{{(lecturer.teachingHour/60).toFixed(1) |replaceAll:\'\\\\.?0+$\':\'\'}} hrs</span></div></div></li></ul></div></div></div></div><footer><ui-pagination-controls on-page-change=\"$ctrl.getData(params)\" pagination-id=\"lecturer\"></ui-pagination-controls></footer></section></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/dashboard/views/manager/month-cumulative-training-costs.html","<div><div class=\"th-team\"><header><h5>{{ \'FIELD.MONTHLY_ACCUMULATED_TRAINING_COSTS\' | translate}}</h5></header><div class=\"md-content\" style=\"width:90%\" ng-if=\"$ctrl.isGroupMonthCostNoData === 0\"><highchart id=\"chart1\" config=\"$ctrl.trainingCosts\"></highchart></div><div class=\"pt-noData\" ng-if=\"$ctrl.isGroupMonthCostNoData === 1\"><i class=\"ctms-icons icon-smile\"></i><p>{{ \'FIELD.NO_INFORMATION\' | translate}}</p></div></div></div>");
$templateCache.put("app/modules/dashboard/views/manager/rate-progress-bars.html","<div><div class=\"th-team height-auto\"><header><h5>{{$ctrl.progressTitle |translate}}</h5></header><div class=\"th-progress\"><div class=\"el-person\" ng-repeat=\"progress in $ctrl.progresses\"><h6>{{progress.name}}</h6><div class=\"progress th-line\" ng-class=\"{0: \'nopass\'}[progress.isPass]\"><div class=\"progress-bar\" ng-style=\"{ \'width\' : progress[$ctrl.valueKey] + \'%\'}\"><div class=\"progress-value\"><span>{{progress[$ctrl.valueKey]}}%</span></div></div></div></div></div></div></div>");}]);